/*!
 * Font Awesome Pro 5.15.4 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license (Commercial License)
 */

export const faAbacus = {
  prefix: "far",
  iconName: "abacus",
  icon: [
    576,
    512,
    [],
    "f640",
    "M552 0c-13.25 0-24 10.74-24 24v48h-48V48c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v24H240V48c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v24h-48V48c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v24H48V24C48 10.74 37.25 0 24 0S0 10.74 0 24v476c0 6.63 5.37 12 12 12h24c6.63 0 12-5.37 12-12v-60h48v24c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-24h48v24c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-24h192v24c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-24h48v60c0 6.63 5.37 12 12 12h24c6.63 0 12-5.37 12-12V24c0-13.26-10.75-24-24-24zM96 120v24c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-24h48v24c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-24h192v24c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-24h48v112H336v-24c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v24h-48v-24c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v24h-48v-24c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v24H48V120h48zm384 272v-24c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v24H240v-24c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v24h-48v-24c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v24H48V280h48v24c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-24h48v24c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-24h48v24c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-24h192v112h-48z"
  ]
};
export const faAcorn = {
  prefix: "far",
  iconName: "acorn",
  icon: [
    448,
    512,
    [],
    "f6ae",
    "M352 64H251.5c3.4-9.4 8.47-18.18 15.16-26.04 5.56-6.52 5.31-15.91-.62-21.86L254.69 4.78c-3.12-3.16-7.72-5.14-11.97-4.72-4.38.14-8.5 2.08-11.31 5.3-14.75 16.8-24.55 37.06-29.39 58.65H96c-53.02 0-96 42.98-96 96v32c0 17.67 14.33 32 32 32v32c0 98.06 55.4 187.7 143.11 231.55L224 512l48.89-24.45C360.6 443.7 416 354.06 416 256v-32c17.67 0 32-14.33 32-32v-32c0-53.02-42.98-96-96-96zM48 160c0-26.47 21.53-48 48-48h256c26.47 0 48 21.53 48 48v16H48v-16zm320 96c0 80.39-44.67 152.67-116.57 188.62L224 458.33l-27.43-13.71C124.67 408.67 80 336.39 80 256v-32h288v32z"
  ]
};
export const faAd = {
  prefix: "far",
  iconName: "ad",
  icon: [
    512,
    512,
    [],
    "f641",
    "M101.42 352h16.94c6.81 0 12.88-4.32 15.12-10.75l7.38-21.25h70.29l7.38 21.25A16 16 0 0 0 233.65 352h16.94c11.01 0 18.73-10.85 15.12-21.25L212 176.13A24.004 24.004 0 0 0 189.33 160h-26.66c-10.22 0-19.32 6.47-22.67 16.12L86.31 330.75C82.7 341.15 90.42 352 101.42 352zM176 218.78L194.48 272h-36.96L176 218.78zM352 352c9.93 0 19.4-2.02 28.02-5.68 2.94 3.41 7.13 5.68 11.98 5.68h16c8.84 0 16-7.16 16-16V176c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v36.42c-7.54-2.69-15.54-4.42-24-4.42-39.7 0-72 32.3-72 72s32.3 72 72 72zm0-96c13.23 0 24 10.77 24 24s-10.77 24-24 24-24-10.77-24-24 10.77-24 24-24zM464 64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zm0 336H48V112h416v288z"
  ]
};
export const faAddressBook = {
  prefix: "far",
  iconName: "address-book",
  icon: [
    448,
    512,
    [],
    "f2b9",
    "M436 160c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h320c26.5 0 48-21.5 48-48v-48h20c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20v-64h20c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20v-64h20zm-68 304H48V48h320v416zM208 256c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm-89.6 128h179.2c12.4 0 22.4-8.6 22.4-19.2v-19.2c0-31.8-30.1-57.6-67.2-57.6-10.8 0-18.7 8-44.8 8-26.9 0-33.4-8-44.8-8-37.1 0-67.2 25.8-67.2 57.6v19.2c0 10.6 10 19.2 22.4 19.2z"
  ]
};
export const faAddressCard = {
  prefix: "far",
  iconName: "address-card",
  icon: [
    576,
    512,
    [],
    "f2bb",
    "M528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm0 400H48V80h480v352zM208 256c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm-89.6 128h179.2c12.4 0 22.4-8.6 22.4-19.2v-19.2c0-31.8-30.1-57.6-67.2-57.6-10.8 0-18.7 8-44.8 8-26.9 0-33.4-8-44.8-8-37.1 0-67.2 25.8-67.2 57.6v19.2c0 10.6 10 19.2 22.4 19.2zM360 320h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm0-64h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm0-64h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8z"
  ]
};
export const faAdjust = {
  prefix: "far",
  iconName: "adjust",
  icon: [
    512,
    512,
    [],
    "f042",
    "M256 56c110.549 0 200 89.468 200 200 0 110.549-89.468 200-200 200-110.549 0-200-89.468-200-200 0-110.549 89.468-200 200-200m0-48C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 96c-83.947 0-152 68.053-152 152s68.053 152 152 152V104z"
  ]
};
export const faAirConditioner = {
  prefix: "far",
  iconName: "air-conditioner",
  icon: [
    576,
    512,
    [],
    "f8f4",
    "M437.42,309.5A16.1,16.1,0,0,0,416,324.67v17.62c0,6.38,3.93,11.85,9.66,14.63,14.92,7.25,24.72,23.06,21.84,41.47C444.4,418.12,426.2,432,406.22,432H400a40,40,0,0,1-40-40V288H312V392a88,88,0,0,0,88,88h4.53c44.92,0,85.21-32.18,90.77-76.76A87.55,87.55,0,0,0,437.42,309.5ZM216,424a40,40,0,0,1-40,40h-6.22c-20,0-38.18-13.88-41.28-33.61-2.88-18.41,6.92-34.22,21.84-41.47,5.73-2.78,9.66-8.25,9.66-14.63V356.67a16.1,16.1,0,0,0-21.42-15.17A87.55,87.55,0,0,0,80.7,435.24C86.26,479.82,126.55,512,171.47,512H176a88,88,0,0,0,88-88V288H216ZM544,0H32A32,32,0,0,0,0,32V224a32,32,0,0,0,32,32H544a32,32,0,0,0,32-32V32A32,32,0,0,0,544,0ZM528,208H48V48H528ZM112,176H464a16,16,0,0,0,16-16V144a16,16,0,0,0-16-16H112a16,16,0,0,0-16,16v16A16,16,0,0,0,112,176Z"
  ]
};
export const faAirFreshener = {
  prefix: "far",
  iconName: "air-freshener",
  icon: [
    512,
    512,
    [],
    "f5d0",
    "M448 64L460.406 93.781C461.031 95 462.625 96 464 96S466.969 95 467.562 93.781L480 64L509.781 51.578C511 50.969 512 49.359 512 48C512 46.625 511 45.031 509.781 44.422L480 32L467.562 2.219C466.969 1 465.375 0 464 0S461.031 1 460.406 2.219L448 32L418.219 44.422C417 45.031 416 46.625 416 48C416 49.359 417 50.969 418.219 51.578L448 64ZM480 224L467.562 194.219C466.969 193 465.375 192 464 192S461.031 193 460.406 194.219L448 224L418.219 236.422C417 237.031 416 238.625 416 240C416 241.359 417 242.969 418.219 243.578L448 256L460.406 285.781C461.031 287 462.625 288 464 288S466.969 287 467.562 285.781L480 256L509.781 243.578C511 242.969 512 241.359 512 240C512 238.625 511 237.031 509.781 236.422L480 224ZM381.781 51.578C383 50.969 384 49.359 384 48C384 46.625 383 45.031 381.781 44.422L352 32L339.562 2.219C338.969 1 337.375 0 336 0S333.031 1 332.406 2.219L320 32L290.219 44.422C289 45.031 288 46.625 288 48C288 49.359 289 50.969 290.219 51.578L320 64L332.406 93.781C333.031 95 334.625 96 336 96S338.969 95 339.562 93.781L352 64L381.781 51.578ZM445.781 147.578C447 146.969 448 145.359 448 144C448 142.625 447 141.031 445.781 140.422L416 128L403.562 98.219C402.969 97 401.375 96 400 96S397.031 97 396.406 98.219L384 128L354.219 140.422C353 141.031 352 142.625 352 144C352 145.359 353 146.969 354.219 147.578L384 160L396.406 189.781C397.031 191 398.625 192 400 192S402.969 191 403.562 189.781L416 160L445.781 147.578ZM224 32C224 14.406 209.594 0 192 0H128C110.406 0 96 14.406 96 32V128H224V32ZM160 272C124.625 272 96 300.625 96 336S124.625 400 160 400S224 371.375 224 336S195.375 272 160 272ZM224 160H96C43 160 0 203 0 256V448C0 483.203 28.812 512 64 512H256C291.188 512 320 483.203 320 448V256C320 203 277 160 224 160ZM272 432C272 449.672 257.688 464 240 464H80C62.312 464 48 449.672 48 432V256C48 229.484 69.5 208 96 208H224C250.5 208 272 229.484 272 256V432Z"
  ]
};
export const faAlarmClock = {
  prefix: "far",
  iconName: "alarm-clock",
  icon: [
    512,
    512,
    [],
    "f34e",
    "M256 64C132.26 64 32 164.29 32 288a222.69 222.69 0 0 0 44.75 134l-40.1 40.09a16 16 0 0 0 0 22.63l22.63 22.62a16 16 0 0 0 22.62 0l40.1-40.12a222.82 222.82 0 0 0 268 0l40.1 40.09a16 16 0 0 0 22.63 0l22.62-22.62a16 16 0 0 0 0-22.63L435.21 422A222.7 222.7 0 0 0 480 288c0-123.71-100.3-224-224-224zm0 400a176 176 0 1 1 176-176 176 176 0 0 1-176 176zM96 0A96 96 0 0 0 0 96a94.81 94.81 0 0 0 15.3 51.26L161.2 25.68A95.63 95.63 0 0 0 96 0zm184 292.47V168a8 8 0 0 0-8-8h-32a8 8 0 0 0-8 8v132.16a32 32 0 0 0 12 25l64.54 51.57a8.58 8.58 0 0 0 5.87 1.72 8 8 0 0 0 5.35-2.95l20-25a8 8 0 0 0-1.25-11.27zM416 0a95.66 95.66 0 0 0-65.18 25.66l145.89 121.57A94.85 94.85 0 0 0 512 96a96 96 0 0 0-96-96z"
  ]
};
export const faAlarmExclamation = {
  prefix: "far",
  iconName: "alarm-exclamation",
  icon: [
    512,
    512,
    [],
    "f843",
    "M256 64C132.3 64 32 164.29 32 288a222.7 222.7 0 0 0 44.79 134l-40.1 40.09a16 16 0 0 0 0 22.63l22.62 22.62a16 16 0 0 0 22.63 0L122 467.22a222.82 222.82 0 0 0 268 0l40.1 40.09a16 16 0 0 0 22.62 0l22.63-22.62a16 16 0 0 0 0-22.63L435.25 422A222.69 222.69 0 0 0 480 288c0-123.71-100.26-224-224-224zm0 400a176 176 0 1 1 176-176 176 176 0 0 1-176 176zM96 0A96 96 0 0 0 0 96a94.81 94.81 0 0 0 15.3 51.26L161.2 25.68A95.63 95.63 0 0 0 96 0zm320 0a95.66 95.66 0 0 0-65.18 25.66l145.89 121.57A94.85 94.85 0 0 0 512 96a96 96 0 0 0-96-96zM256 352a32 32 0 1 0 32 32 32 32 0 0 0-32-32zm22.3-192h-44.6a16.06 16.06 0 0 0-15.9 17.6l12.8 128a16 16 0 0 0 15.9 14.4h19a16 16 0 0 0 15.9-14.4l12.8-128a16 16 0 0 0-15.89-17.6z"
  ]
};
export const faAlarmPlus = {
  prefix: "far",
  iconName: "alarm-plus",
  icon: [
    512,
    512,
    [],
    "f844",
    "M256 64C132.3 64 32 164.29 32 288a222.7 222.7 0 0 0 44.79 134l-40.1 40.09a16 16 0 0 0 0 22.63l22.62 22.62a16 16 0 0 0 22.63 0L122 467.22a222.82 222.82 0 0 0 268 0l40.1 40.09a16 16 0 0 0 22.62 0l22.63-22.62a16 16 0 0 0 0-22.63L435.25 422A222.69 222.69 0 0 0 480 288c0-123.71-100.26-224-224-224zm0 400a176 176 0 1 1 176-176 176 176 0 0 1-176 176zm96-200h-72v-72a16 16 0 0 0-16-16h-16a16 16 0 0 0-16 16v72h-72a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h72v72a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-72h72a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zM96 0A96 96 0 0 0 0 96a94.81 94.81 0 0 0 15.3 51.26L161.2 25.68A95.63 95.63 0 0 0 96 0zm320 0a95.66 95.66 0 0 0-65.18 25.66l145.89 121.57A94.85 94.85 0 0 0 512 96a96 96 0 0 0-96-96z"
  ]
};
export const faAlarmSnooze = {
  prefix: "far",
  iconName: "alarm-snooze",
  icon: [
    512,
    512,
    [],
    "f845",
    "M256 64C132.3 64 32 164.29 32 288a222.7 222.7 0 0 0 44.79 134l-40.1 40.09a16 16 0 0 0 0 22.63l22.62 22.62a16 16 0 0 0 22.63 0L122 467.22a222.82 222.82 0 0 0 268 0l40.1 40.09a16 16 0 0 0 22.62 0l22.63-22.62a16 16 0 0 0 0-22.63L435.25 422A222.69 222.69 0 0 0 480 288c0-123.71-100.26-224-224-224zm0 400a176 176 0 1 1 176-176 176 176 0 0 1-176 176zm64-280H192a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h78.07l-96.83 121A24 24 0 0 0 192 392h128a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16h-78.08l96.8-121A24 24 0 0 0 320 184zM96 0A96 96 0 0 0 0 96a94.81 94.81 0 0 0 15.3 51.26L161.2 25.68A95.63 95.63 0 0 0 96 0zm320 0a95.66 95.66 0 0 0-65.18 25.66l145.89 121.57A94.85 94.85 0 0 0 512 96a96 96 0 0 0-96-96z"
  ]
};
export const faAlbum = {
  prefix: "far",
  iconName: "album",
  icon: [
    448,
    512,
    [],
    "f89f",
    "M416 32H32A32 32 0 0 0 0 64v384a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32V64a32 32 0 0 0-32-32zm-16 400H48V80h352zm-176-32A144 144 0 1 0 80 256a144 144 0 0 0 144 144zm0-168a24 24 0 1 1-24 24 24 24 0 0 1 24-24z"
  ]
};
export const faAlbumCollection = {
  prefix: "far",
  iconName: "album-collection",
  icon: [
    512,
    512,
    [],
    "f8a0",
    "M496 104a24 24 0 0 0-24-24H40a24 24 0 0 0-24 24v24h480zm-16-80a24 24 0 0 0-24-24H56a24 24 0 0 0-24 24v24h448zm0 136H32A32 32 0 0 0 .13 194.9l26.19 288A32 32 0 0 0 58.18 512h395.64a32 32 0 0 0 31.86-29.1l26.19-288A32 32 0 0 0 480 160zm-40.8 304H72.8L49.52 208h413zM256 448c80.13 0 148.25-45.29 152.34-104 4.32-62-63.78-114.89-152.35-114.89S99.33 282.05 103.66 344c4.1 58.71 72.21 104 152.34 104zm0-120.41c14.56 0 26.26 8.69 26.14 19.32s-11.82 19-26.14 19-26-8.47-26.13-19 11.58-19.32 26.13-19.32z"
  ]
};
export const faAlicorn = {
  prefix: "far",
  iconName: "alicorn",
  icon: [
    640,
    512,
    [],
    "f6b0",
    "M448 96c0-8.84-7.16-16-16-16s-16 7.16-16 16 7.16 16 16 16 16-7.16 16-16zm183.98-32H526.61l-15.28-18.57c16.37-5.23 29.03-18.72 32.51-35.79C544.85 4.68 540.96 0 535.9 0H399.95c-68.22 0-125.48 47.71-140.26 111.5-36.9-1.23-73.89-13.34-98.32-40.94-4.02-4.54-9.17-6.56-14.21-6.56-9.78 0-19.16 7.6-19.16 19.06 0 86.09 59.76 162.72 140.01 183.21 10.11 2.58 19.99-5.19 19.99-15.63v-16.36c0-6.96-4.44-13.34-11.15-15.21-37.34-10.46-68.92-37.67-86.32-73.34 23.38 9.37 48.83 14.27 75.24 14.27h38.18v-16c0-53.02 42.98-96 96-96h51.33l44.67 54.28.05 65.35c0 4.77-3.03 9.01-7.54 10.55l-31.02 10.59c-1.51.52-9.71 2.95-16.48-3.83L416 160h-32v80c0 26.09-12.68 49.03-32 63.64V464h-48V320l-107.91-30.83-28.65 79.78L191.53 464H150l-21.13-87.86a31.698 31.698 0 0 1 .37-16.18l22.7-76.72C128.54 273.72 112 250.83 112 224c0-14.93 5.32-28.49 13.9-39.38-9.05-14.37-15.81-30.08-20.87-46.54-7.91 6.56-15.17 13.86-21.04 22.32C37.36 162.55 0 200.84 0 248v56c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-56c0-13.22 6.87-24.39 16.78-31.68-.18 2.59-.78 5.05-.78 7.68 0 30.13 11.9 58.09 32.16 78.58l-12.95 43.76a78.913 78.913 0 0 0-1.05 40.84l24.12 100.29c3.46 14.38 16.32 24.52 31.11 24.52h74.7c20.86 0 36.14-19.64 31.02-39.86l-25.53-100.76 8.51-23.71L256 356.2V480c0 17.67 14.33 32 32 32h80c17.67 0 32-14.33 32-32V324.35c20.57-23.15 32-52.8 32-84.35v-5.62c20.95 6.97 38.32.72 40.93-.17l31.03-10.59c23.96-8.18 40.05-30.7 40.04-56.01l-.04-52.28 92.46-36.67c6.59-4.39 3.48-14.66-4.44-14.66z"
  ]
};
export const faAlien = {
  prefix: "far",
  iconName: "alien",
  icon: [
    448,
    512,
    [],
    "f8f5",
    "M224,0C100.28125,0,0,88.0293,0,232.45117,0,344.22852,134.21484,457.04883,194.86328,502.32422a48.70766,48.70766,0,0,0,58.27344,0C313.78516,457.04883,448,344.22852,448,232.45117,448,88.0293,347.71875,0,224,0Zm-.42188,463.85938C113.63672,381.78711,48,295.2793,48,232.45117,48,122.125,118.72852,48,224,48s176,74.125,176,184.45117C400,295.2793,334.36328,381.78711,223.57812,463.85938ZM129.8125,224h-32a15.99954,15.99954,0,0,0-16,16,80.00021,80.00021,0,0,0,80,80h32a16.00079,16.00079,0,0,0,16-16A79.999,79.999,0,0,0,129.8125,224Zm224,0h-32a79.999,79.999,0,0,0-80,80,16.00079,16.00079,0,0,0,16,16h32a80.00021,80.00021,0,0,0,80-80A15.99954,15.99954,0,0,0,353.8125,224Z"
  ]
};
export const faAlienMonster = {
  prefix: "far",
  iconName: "alien-monster",
  icon: [
    576,
    512,
    [],
    "f8f6",
    "M560,128H544a15.99954,15.99954,0,0,0-16,16v96H480V176a15.99954,15.99954,0,0,0-16-16H432V96h32a16.00079,16.00079,0,0,0,16-16V48a15.99954,15.99954,0,0,0-16-16H448a15.99954,15.99954,0,0,0-16,16V64H400a15.99954,15.99954,0,0,0-16,16v48H192V80a15.99954,15.99954,0,0,0-16-16H144V48a15.99954,15.99954,0,0,0-16-16H112A15.99954,15.99954,0,0,0,96,48V80a16.00079,16.00079,0,0,0,16,16h32v64H112a15.99954,15.99954,0,0,0-16,16v64H48V144a15.99954,15.99954,0,0,0-16-16H16A15.99954,15.99954,0,0,0,0,144V272a16.00079,16.00079,0,0,0,16,16H64v80a16.00079,16.00079,0,0,0,16,16h48v80a16.00079,16.00079,0,0,0,16,16h96a16.00079,16.00079,0,0,0,16-16V448a15.99954,15.99954,0,0,0-16-16H176V384H400v48H336a15.99954,15.99954,0,0,0-16,16v16a16.00079,16.00079,0,0,0,16,16h96a16.00079,16.00079,0,0,0,16-16V384h48a16.00079,16.00079,0,0,0,16-16V288h48a16.00079,16.00079,0,0,0,16-16V144A15.99954,15.99954,0,0,0,560,128ZM464,336H112V288h32V208h48V176H384v32h48v80h32ZM240,224H208a15.99954,15.99954,0,0,0-16,16v48a16.00079,16.00079,0,0,0,16,16h32a16.00079,16.00079,0,0,0,16-16V240A15.99954,15.99954,0,0,0,240,224Zm128,0H336a15.99954,15.99954,0,0,0-16,16v48a16.00079,16.00079,0,0,0,16,16h32a16.00079,16.00079,0,0,0,16-16V240A15.99954,15.99954,0,0,0,368,224Z"
  ]
};
export const faAlignCenter = {
  prefix: "far",
  iconName: "align-center",
  icon: [
    448,
    512,
    [],
    "f037",
    "M108.1 88h231.81A12.09 12.09 0 0 0 352 75.9V52.09A12.09 12.09 0 0 0 339.91 40H108.1A12.09 12.09 0 0 0 96 52.09V75.9A12.1 12.1 0 0 0 108.1 88zM432 424H16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm0-256H16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm-92.09 176A12.09 12.09 0 0 0 352 331.9v-23.81A12.09 12.09 0 0 0 339.91 296H108.1A12.09 12.09 0 0 0 96 308.09v23.81a12.1 12.1 0 0 0 12.1 12.1z"
  ]
};
export const faAlignJustify = {
  prefix: "far",
  iconName: "align-justify",
  icon: [
    448,
    512,
    [],
    "f039",
    "M432 424H16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm0-128H16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm0-128H16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm0-128H16A16 16 0 0 0 0 56v16a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V56a16 16 0 0 0-16-16z"
  ]
};
export const faAlignLeft = {
  prefix: "far",
  iconName: "align-left",
  icon: [
    448,
    512,
    [],
    "f036",
    "M12.83 344h262.34A12.82 12.82 0 0 0 288 331.17v-22.34A12.82 12.82 0 0 0 275.17 296H12.83A12.82 12.82 0 0 0 0 308.83v22.34A12.82 12.82 0 0 0 12.83 344zm0-256h262.34A12.82 12.82 0 0 0 288 75.17V52.83A12.82 12.82 0 0 0 275.17 40H12.83A12.82 12.82 0 0 0 0 52.83v22.34A12.82 12.82 0 0 0 12.83 88zM432 168H16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm0 256H16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16z"
  ]
};
export const faAlignRight = {
  prefix: "far",
  iconName: "align-right",
  icon: [
    448,
    512,
    [],
    "f038",
    "M16 216h416a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16zm416 208H16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm3.17-384H172.83A12.82 12.82 0 0 0 160 52.83v22.34A12.82 12.82 0 0 0 172.83 88h262.34A12.82 12.82 0 0 0 448 75.17V52.83A12.82 12.82 0 0 0 435.17 40zm0 256H172.83A12.82 12.82 0 0 0 160 308.83v22.34A12.82 12.82 0 0 0 172.83 344h262.34A12.82 12.82 0 0 0 448 331.17v-22.34A12.82 12.82 0 0 0 435.17 296z"
  ]
};
export const faAlignSlash = {
  prefix: "far",
  iconName: "align-slash",
  icon: [
    640,
    512,
    [],
    "f846",
    "M634 471L36 3.5A16 16 0 0 0 13.49 6l-10 12.5A16 16 0 0 0 6 41l598 467.5a16 16 0 0 0 22.5-2.5l10-12.5A16 16 0 0 0 634 471zM528 296h-39.94l52.69 41.19A15.6 15.6 0 0 0 544 328v-16a16 16 0 0 0-16-16zm16-112a16 16 0 0 0-16-16H324.34l61.39 48H528a16 16 0 0 0 16-16zm-16-96a16 16 0 0 0 16-16V56a16 16 0 0 0-16-16H160.61L222 88zM112 424a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h367.37L418 424zm0-80h203.65l-61.39-48H112a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16z"
  ]
};
export const faAllergies = {
  prefix: "far",
  iconName: "allergies",
  icon: [
    480,
    512,
    [],
    "f461",
    "M256 304c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm-64-16c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm64 112c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm152-288c-2.7 0-5.4.2-8 .4V104c0-39.7-32.3-72-72-72-6.4 0-12.7.8-18.6 2.4C296.7 13.8 273.9 0 248 0s-48.7 13.8-61.4 34.4c-5.9-1.6-12.2-2.4-18.6-2.4-39.7 0-72 32.3-72 72v92.1c-10.5-3.7-38.1-10.2-65.3 8.9C-1.8 227.8-9.8 272.8 13 305.3l113.5 171c14.9 22.4 39.8 35.7 66.6 35.7h180.6c38 0 71-27 78.5-64.3l20.6-103.2c4.7-23.7 7.1-48 7.1-72.2V184c.1-39.7-32.2-72-71.9-72zm24 160.3c0 21.1-2.1 42.1-6.2 62.8l-20.6 103.2c-3 15-16.1 25.7-31.4 25.7H193.1c-10.7 0-20.7-5.4-26.7-14.3L52.3 277.8c-18-25.7 20.7-54.1 39.3-27.5l37.8 54.4c4.5 6.5 14.6 3.2 14.6-4.6V104c0-31.8 48-31.7 48 0v144c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V72c0-31.8 48-31.7 48 0v176c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V104c0-31.8 48-31.7 48 0v144c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-64c0-31.8 48-31.7 48 0v88.3zM192 368c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm192-80c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm-32 112c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm-32-64c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16z"
  ]
};
export const faAmbulance = {
  prefix: "far",
  iconName: "ambulance",
  icon: [
    640,
    512,
    [],
    "f0f9",
    "M296 160h-56v-56c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v56h-56c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h56v56c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-56h56c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm328 208h-16V251.9c0-19-7.7-37.5-21.1-50.9L503 117.1C489.6 103.7 471 96 452.1 96H416V56c0-30.9-25.1-56-56-56H56C25.1 0 0 25.1 0 56v304c0 30.9 25.1 56 56 56h8c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zm-464 96c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm208-96H242.7c-16.6-28.6-47.2-48-82.7-48s-66.1 19.4-82.7 48H56c-4.4 0-8-3.6-8-8V56c0-4.4 3.6-8 8-8h304c4.4 0 8 3.6 8 8v312zm48-224h36.1c6.3 0 12.5 2.6 17 7l73 73H416v-80zm64 320c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-100.9c-17.2-25.9-46.6-43.1-80-43.1-24.7 0-47 9.6-64 24.9V272h144v91.1z"
  ]
};
export const faAmericanSignLanguageInterpreting = {
  prefix: "far",
  iconName: "american-sign-language-interpreting",
  icon: [
    640,
    512,
    [],
    "f2a3",
    "M635.1 210.8c-.1-.1-40.2-80.4-40.2-80.4-11.4-22.7-39.9-33.6-64.4-21.3L478.9 135s-76.4-7-77.4-7c-18.7 0-36.6 4.3-52.7 12.5-6.6-8.8-14.3-14.1-23.5-18.3 11.4-35.6-14.8-73.5-53.5-73.2-3.2-26.4-25.9-49-55.5-49-13 0-25.6 4.5-35.7 12.8-45.4 37.3-74.4 89.6-82.4 146.6l-29.7 53.5s-44.7 25.4-44.8 25.5C2.1 251.1-6.1 278.5 4.9 301.2c.1.1 40.2 80.4 40.2 80.4 11.5 22.9 40.1 33.5 64.4 21.3l51.6-25.9c76.9 7 76.9 7 78.8 7 18.1 0 35.6-4.5 51.2-12.5 6.6 8.8 14.3 14.1 23.5 18.3-11.8 37 17.1 73.8 53.5 73.4 3.4 27.1 26.7 48.9 55.6 48.9 13 0 25.7-4.5 35.6-12.8 45.4-37.3 74.4-89.6 82.4-146.6l29.7-53.5s44.7-25.4 44.8-25.5c21.7-12.8 29.9-40.1 18.9-62.9zM297 188.6c-19.9-9.9-43.4-11.3-64.5-3.9-8.4 3-6.3 15.5 2.7 15.5 32.4 0 57.2 14.5 69.8 41 9 18.8-19.8 32.9-28.8 13.6l-.1-.1c-6.9-14-20.7-22.7-36.2-22.7-22.1 0-40 17.9-40 40 0 24.7 20.8 40 40 40 15.5 0 29.3-8.7 36.2-22.7l.1-.1c9.1-19.2 37.8-5.2 28.8 13.6-11.9 24.9-37.3 41.1-64.7 41.2-4.6-.4-62.2-5.7-84.6-7.7-1.5-.1-3 .1-4.3.8l-59.8 30c-4.5 2.2-9.1 0-10.8-3.4l-40-79.9c-1.9-3.9-.5-8.7 3.1-10.8l52.2-29.7c1.3-.7 2.3-1.8 3-3.1l37-66.7c.5-.9.8-1.9 1-3 5.6-49.8 30-94.8 68.9-126.7 6.7-5.6 16.9-4.8 22.4 2.1 6 7.5 4.4 17.2-2.2 22.6-12.1 10.2-22.4 21.5-30.6 33.5-4.9 7.3 3.8 16.1 11.1 11.1C226 100 247.3 92 270 89.2c8.2-1.1 16.4 4.1 17.8 13.9 1.1 8.7-4.8 16.7-13.8 17.8-15 1.8-29.4 6.8-42.9 14.8-7.8 4.6-3 16.6 5.8 14.7 23.6-5.2 51.3-1.7 74 9.3 19.2 9.5 5.1 38.1-13.9 28.9zm299.1 50.5l-52.2 29.7c-1.3.7-2.3 1.8-3 3.1l-37 66.7c-.5.9-.8 1.9-1 3-5.6 49.8-30 94.8-68.9 126.7-16 13.4-36.8-11-20.2-24.7 12.2-10.3 22.5-21.6 30.7-33.6 5-7.4-4-16-11.1-11.1-19.3 13.1-40.6 21.2-63.2 23.9-21.2 2.6-24.9-29.3-4.1-31.6 15-1.8 29.4-6.8 42.9-14.8 7.8-4.6 3-16.6-5.8-14.7-23.6 5.2-51.3 1.7-74-9.3-19.2-9.6-5-38.2 13.9-28.9 19.9 9.9 43.4 11.4 64.5 3.9 8.4-3 6.3-15.5-2.7-15.5-32.4 0-57.2-14.5-69.8-41-9-18.8 19.8-32.9 28.8-13.6l.1.1c6.9 14 20.7 22.7 36.2 22.7 22.1 0 40-17.9 40-40 0-24.7-20.8-40-40-40-15.5 0-29.3 8.7-36.2 22.7l-.1.1c-9.1 19.2-37.8 5.2-28.8-13.6 12.1-25.3 37.4-41.1 66.2-41.2l83.1 7.7c1.5.1 3-.1 4.3-.8l59.8-30c4.5-2.2 9.1 0 10.8 3.4l40 79.9c1.7 3.9.4 8.6-3.2 10.8z"
  ]
};
export const faAmpGuitar = {
  prefix: "far",
  iconName: "amp-guitar",
  icon: [
    512,
    512,
    [],
    "f8a1",
    "M464 80h-61.5C377.75 52.71 321.51 0 256 0S134.25 52.71 109.5 80H48a48 48 0 0 0-48 48v336a48 48 0 0 0 48 48h416a48 48 0 0 0 48-48V128a48 48 0 0 0-48-48zM256 48c26.9 0 54 14.79 76.25 32h-152.5C202 62.77 229.1 48 256 48zm208 416H48V272h416zm0-240H48v-96h416zM128 400a16 16 0 1 0 16 16 16 16 0 0 0-16-16zm64-64a16 16 0 1 0-16-16 16 16 0 0 0 16 16zm-96 48a16 16 0 1 0-16-16 16 16 0 0 0 16 16zm32-48a16 16 0 1 0-16-16 16 16 0 0 0 16 16zm128 0a16 16 0 1 0-16-16 16 16 0 0 0 16 16zm128 0a16 16 0 1 0-16-16 16 16 0 0 0 16 16zm-64 0a16 16 0 1 0-16-16 16 16 0 0 0 16 16zm-160 48a16 16 0 1 0-16-16 16 16 0 0 0 16 16zm192 0a16 16 0 1 0-16-16 16 16 0 0 0 16 16zm32 16a16 16 0 1 0 16 16 16 16 0 0 0-16-16zm-64 0a16 16 0 1 0 16 16 16 16 0 0 0-16-16zm-128 0a16 16 0 1 0 16 16 16 16 0 0 0-16-16zm224-16a16 16 0 1 0-16-16 16 16 0 0 0 16 16zm-192 0a16 16 0 1 0-16-16 16 16 0 0 0 16 16zm32 16a16 16 0 1 0 16 16 16 16 0 0 0-16-16zm32-16a16 16 0 1 0-16-16 16 16 0 0 0 16 16zM112 200a24 24 0 1 0-24-24 24 24 0 0 0 24 24zm80 0a24 24 0 1 0-24-24 24 24 0 0 0 24 24z"
  ]
};
export const faAnalytics = {
  prefix: "far",
  iconName: "analytics",
  icon: [
    608,
    512,
    [],
    "f643",
    "M416 320h-64c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32zm-16 144h-32v-96h32v96zm176-272h-64c-17.67 0-32 14.33-32 32v256c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V224c0-17.67-14.33-32-32-32zm-16 272h-32V240h32v224zM256 192h-64c-17.67 0-32 14.33-32 32v256c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V224c0-17.67-14.33-32-32-32zm-16 272h-32V240h32v224zM96 352H32c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32zM80 464H48v-64h32v64zM64 256c26.51 0 48-21.49 48-48 0-4.27-.74-8.34-1.78-12.28l101.5-101.5C215.66 95.26 219.73 96 224 96c6.15 0 11.97-1.26 17.38-3.37l95.34 76.27c-.35 2.33-.71 4.67-.71 7.1 0 26.51 21.49 48 48 48s48-21.49 48-48c0-2.43-.37-4.76-.71-7.09l95.34-76.27C532.03 94.74 537.85 96 544 96c26.51 0 48-21.49 48-48S570.51 0 544 0s-48 21.49-48 48c0 2.43.37 4.76.71 7.09l-95.34 76.27c-5.4-2.11-11.23-3.37-17.38-3.37s-11.97 1.26-17.38 3.37L271.29 55.1c.35-2.33.71-4.67.71-7.1 0-26.51-21.49-48-48-48s-48 21.49-48 48c0 4.27.74 8.34 1.78 12.28l-101.5 101.5C72.34 160.74 68.27 160 64 160c-26.51 0-48 21.49-48 48s21.49 48 48 48z"
  ]
};
export const faAnchor = {
  prefix: "far",
  iconName: "anchor",
  icon: [
    576,
    512,
    [],
    "f13d",
    "M571.515 331.515l-67.029-67.029c-4.686-4.686-12.284-4.686-16.971 0l-67.029 67.029c-7.56 7.56-2.206 20.485 8.485 20.485h44.268C453.531 417.326 380.693 456.315 312 462.865V216h60c6.627 0 12-5.373 12-12v-24c0-6.627-5.373-12-12-12h-60v-11.668c32.456-10.195 56-40.512 56-76.332 0-44.183-35.817-80-80-80s-80 35.817-80 80c0 35.82 23.544 66.138 56 76.332V168h-60c-6.627 0-12 5.373-12 12v24c0 6.627 5.373 12 12 12h60v246.865C195.192 456.304 122.424 417.176 102.762 352h44.268c10.691 0 16.045-12.926 8.485-20.485l-67.029-67.029c-4.686-4.686-12.284-4.686-16.971 0l-67.03 67.029C-3.074 339.074 2.28 352 12.971 352h40.284C73.657 451.556 181.238 512 288 512c113.135 0 215.338-65.3 234.745-160h40.284c10.691 0 16.045-12.926 8.486-20.485zM288 48c17.645 0 32 14.355 32 32s-14.355 32-32 32-32-14.355-32-32 14.355-32 32-32z"
  ]
};
export const faAngel = {
  prefix: "far",
  iconName: "angel",
  icon: [
    576,
    512,
    [],
    "f779",
    "M571.7 453.1l-38.2-78.6c-6.6-13.5-6.6-29.6 0-43.1 16.2-33.4 26.4-37.5 26.4-75.3 0-51.1-46.9-96-100.4-96-25.1 0-48.7 10-66.3 28.1l-72.7 73.4c-10.3-3.4-21.2-5.4-32.5-5.4-11.2 0-22.1 2-32.4 5.4l-72.7-73.3c-17.6-18-41.2-28.1-66.3-28.1-53.5 0-100.4 44.9-100.4 96 0 37.9 10.2 42 26.4 75.3 6.6 13.5 6.6 29.6 0 43.1L4.4 453.1c-14.5 29.8 9.3 58.9 36.3 58.9h494.7c27.6 0 50.4-29.9 36.3-58.9zM52.4 464l33.4-68.6c12.9-26.6 12.9-58.5 0-85.1-5.4-11.2-9.9-18.9-13.5-25.1-7.2-12.4-8.1-14-8.1-29.2 0-24.7 25.5-48 52.4-48 12.1 0 23.5 4.9 32.1 13.7l65.2 65.8c-7.3 7.5-13.6 16.1-18.4 25.7L120.1 464H52.4zm121.4 0l64.6-129.3c9.5-18.9 28.5-30.7 49.7-30.7 21.2 0 40.2 11.8 49.7 30.7L402.3 464H173.8zm282.1 0l-75.3-150.8c-4.8-9.7-11.1-18.2-18.4-25.7l65.2-65.8c8.6-8.9 20-13.7 32.1-13.7 27 0 52.4 23.3 52.4 48 0 15.2-.9 16.8-8.1 29.2-3.6 6.2-8.1 13.9-13.5 25.1-12.9 26.6-12.9 58.5 0 85.1l33.4 68.6h-67.8zM208 144c0 44.2 35.8 80 80 80s80-35.8 80-80-35.8-80-80-80-80 35.8-80 80zm112 0c0 17.6-14.4 32-32 32s-32-14.4-32-32 14.4-32 32-32 32 14.4 32 32zm-143.3-6.7l.2-.1c.8-13 3.9-25.2 8.8-36.6-11-6-17.6-13-17.6-20.6 0-22.1 53.7-40 120-40s120 17.9 120 40c0 7.6-6.7 14.6-17.6 20.6 4.9 11.4 8 23.6 8.8 36.6l.2.1C429.3 122.8 448 102.5 448 80c0-44.2-71.6-80-160-80S128 35.8 128 80c0 22.5 18.7 42.8 48.7 57.3z"
  ]
};
export const faAngleDoubleDown = {
  prefix: "far",
  iconName: "angle-double-down",
  icon: [
    320,
    512,
    [],
    "f103",
    "M151.5 427.8L3.5 281c-4.7-4.7-4.7-12.3 0-17l19.8-19.8c4.7-4.7 12.3-4.7 17 0L160 362.7l119.7-118.5c4.7-4.7 12.3-4.7 17 0l19.8 19.8c4.7 4.7 4.7 12.3 0 17l-148 146.8c-4.7 4.7-12.3 4.7-17 0zm17-160l148-146.8c4.7-4.7 4.7-12.3 0-17l-19.8-19.8c-4.7-4.7-12.3-4.7-17 0L160 202.7 40.3 84.2c-4.7-4.7-12.3-4.7-17 0L3.5 104c-4.7 4.7-4.7 12.3 0 17l148 146.8c4.7 4.7 12.3 4.7 17 0z"
  ]
};
export const faAngleDoubleLeft = {
  prefix: "far",
  iconName: "angle-double-left",
  icon: [
    384,
    512,
    [],
    "f100",
    "M20.2 247.5L167 99.5c4.7-4.7 12.3-4.7 17 0l19.8 19.8c4.7 4.7 4.7 12.3 0 17L85.3 256l118.5 119.7c4.7 4.7 4.7 12.3 0 17L184 412.5c-4.7 4.7-12.3 4.7-17 0l-146.8-148c-4.7-4.7-4.7-12.3 0-17zm160 17l146.8 148c4.7 4.7 12.3 4.7 17 0l19.8-19.8c4.7-4.7 4.7-12.3 0-17L245.3 256l118.5-119.7c4.7-4.7 4.7-12.3 0-17L344 99.5c-4.7-4.7-12.3-4.7-17 0l-146.8 148c-4.7 4.7-4.7 12.3 0 17z"
  ]
};
export const faAngleDoubleRight = {
  prefix: "far",
  iconName: "angle-double-right",
  icon: [
    384,
    512,
    [],
    "f101",
    "M363.8 264.5L217 412.5c-4.7 4.7-12.3 4.7-17 0l-19.8-19.8c-4.7-4.7-4.7-12.3 0-17L298.7 256 180.2 136.3c-4.7-4.7-4.7-12.3 0-17L200 99.5c4.7-4.7 12.3-4.7 17 0l146.8 148c4.7 4.7 4.7 12.3 0 17zm-160-17L57 99.5c-4.7-4.7-12.3-4.7-17 0l-19.8 19.8c-4.7 4.7-4.7 12.3 0 17L138.7 256 20.2 375.7c-4.7 4.7-4.7 12.3 0 17L40 412.5c4.7 4.7 12.3 4.7 17 0l146.8-148c4.7-4.7 4.7-12.3 0-17z"
  ]
};
export const faAngleDoubleUp = {
  prefix: "far",
  iconName: "angle-double-up",
  icon: [
    320,
    512,
    [],
    "f102",
    "M168.5 84.2l148 146.8c4.7 4.7 4.7 12.3 0 17l-19.8 19.8c-4.7 4.7-12.3 4.7-17 0L160 149.3 40.3 267.8c-4.7 4.7-12.3 4.7-17 0L3.5 248c-4.7-4.7-4.7-12.3 0-17l148-146.8c4.7-4.7 12.3-4.7 17 0zm-17 160L3.5 391c-4.7 4.7-4.7 12.3 0 17l19.8 19.8c4.7 4.7 12.3 4.7 17 0L160 309.3l119.7 118.5c4.7 4.7 12.3 4.7 17 0l19.8-19.8c4.7-4.7 4.7-12.3 0-17l-148-146.8c-4.7-4.7-12.3-4.7-17 0z"
  ]
};
export const faAngleDown = {
  prefix: "far",
  iconName: "angle-down",
  icon: [
    320,
    512,
    [],
    "f107",
    "M151.5 347.8L3.5 201c-4.7-4.7-4.7-12.3 0-17l19.8-19.8c4.7-4.7 12.3-4.7 17 0L160 282.7l119.7-118.5c4.7-4.7 12.3-4.7 17 0l19.8 19.8c4.7 4.7 4.7 12.3 0 17l-148 146.8c-4.7 4.7-12.3 4.7-17 0z"
  ]
};
export const faAngleLeft = {
  prefix: "far",
  iconName: "angle-left",
  icon: [
    192,
    512,
    [],
    "f104",
    "M4.2 247.5L151 99.5c4.7-4.7 12.3-4.7 17 0l19.8 19.8c4.7 4.7 4.7 12.3 0 17L69.3 256l118.5 119.7c4.7 4.7 4.7 12.3 0 17L168 412.5c-4.7 4.7-12.3 4.7-17 0L4.2 264.5c-4.7-4.7-4.7-12.3 0-17z"
  ]
};
export const faAngleRight = {
  prefix: "far",
  iconName: "angle-right",
  icon: [
    192,
    512,
    [],
    "f105",
    "M187.8 264.5L41 412.5c-4.7 4.7-12.3 4.7-17 0L4.2 392.7c-4.7-4.7-4.7-12.3 0-17L122.7 256 4.2 136.3c-4.7-4.7-4.7-12.3 0-17L24 99.5c4.7-4.7 12.3-4.7 17 0l146.8 148c4.7 4.7 4.7 12.3 0 17z"
  ]
};
export const faAngleUp = {
  prefix: "far",
  iconName: "angle-up",
  icon: [
    320,
    512,
    [],
    "f106",
    "M168.5 164.2l148 146.8c4.7 4.7 4.7 12.3 0 17l-19.8 19.8c-4.7 4.7-12.3 4.7-17 0L160 229.3 40.3 347.8c-4.7 4.7-12.3 4.7-17 0L3.5 328c-4.7-4.7-4.7-12.3 0-17l148-146.8c4.7-4.7 12.3-4.7 17 0z"
  ]
};
export const faAngry = {
  prefix: "far",
  iconName: "angry",
  icon: [
    496,
    512,
    [],
    "f556",
    "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm0-144c-33.6 0-65.2 14.8-86.8 40.6-8.5 10.2-7.1 25.3 3.1 33.8s25.3 7.2 33.8-3c24.8-29.7 75-29.7 99.8 0 8.1 9.7 23.2 11.9 33.8 3 10.2-8.5 11.5-23.6 3.1-33.8-21.6-25.8-53.2-40.6-86.8-40.6zm-48-72c10.3 0 19.9-6.7 23-17.1 3.8-12.7-3.4-26.1-16.1-29.9l-80-24c-12.8-3.9-26.1 3.4-29.9 16.1-3.8 12.7 3.4 26.1 16.1 29.9l28.2 8.5c-3.1 4.9-5.3 10.4-5.3 16.6 0 17.7 14.3 32 32 32s32-14.4 32-32.1zm199-54.9c-3.8-12.7-17.1-19.9-29.9-16.1l-80 24c-12.7 3.8-19.9 17.2-16.1 29.9 3.1 10.4 12.7 17.1 23 17.1 0 17.7 14.3 32 32 32s32-14.3 32-32c0-6.2-2.2-11.7-5.3-16.6l28.2-8.5c12.7-3.7 19.9-17.1 16.1-29.8z"
  ]
};
export const faAnkh = {
  prefix: "far",
  iconName: "ankh",
  icon: [
    320,
    512,
    [],
    "f644",
    "M304 272h-76.92c29.46-36.35 54.82-87.85 54.82-134.86C281.9 52.98 227.33 0 160 0S38.1 52.98 38.1 137.14c0 47 25.36 98.51 54.82 134.86H16c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h120v176c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V320h120c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16zM160 48c44.21 0 73.9 35.82 73.9 89.14 0 53.83-49.69 119.49-73.9 133.35-24.21-13.85-73.9-79.52-73.9-133.35C86.1 83.82 115.8 48 160 48z"
  ]
};
export const faAppleAlt = {
  prefix: "far",
  iconName: "apple-alt",
  icon: [
    448,
    512,
    [],
    "f5d1",
    "M415.22 177.62c-18.53-26.47-43.99-43.17-73.58-48.28h-.03c-34.49-5.98-86.14 9.16-117.6 23.77-31.46-14.61-82.95-29.77-117.64-23.77-29.59 5.11-55.05 21.81-73.58 48.28C4.85 217.5-6.55 280.12 3.73 337.17 18.97 421.69 69.96 512 167.23 512c13.44 0 27.62-4.03 42.21-11.97 9-4.88 20.12-4.88 29.12 0 14.59 7.94 28.78 11.97 42.21 11.97 97.26 0 148.25-90.31 163.5-174.84 10.28-57.04-1.12-119.66-29.05-159.54zm-18.19 151.02C392.97 351.25 368.19 464 280.77 464c-5.25 0-11.9-2.12-19.28-6.12-11.56-6.3-24.53-9.45-37.49-9.45s-25.93 3.16-37.49 9.45c-7.37 4-14.03 6.12-19.28 6.12-87.42 0-112.2-112.75-116.26-135.34-8-44.39.5-94.03 21.12-123.5 11.19-15.98 25.46-25.58 42.43-28.5 12.55-2.16 53.83-.07 109.48 30.75 55.68-30.84 97-32.94 109.48-30.75 16.97 2.92 31.24 12.52 42.43 28.5 20.62 29.46 29.12 79.11 21.12 123.48zM222.41 112c18.66 0 52.09-3.26 73.2-24.38C326.17 57.06 319.32.65 319.32.65S313.93 0 305.57 0c-18.66 0-52.09 3.27-73.19 24.38-30.56 30.57-23.71 86.97-23.71 86.97s5.39.65 13.74.65z"
  ]
};
export const faAppleCrate = {
  prefix: "far",
  iconName: "apple-crate",
  icon: [
    576,
    512,
    [],
    "f6b1",
    "M434.22 50.47c11.29-12.19 14.43-32.03 13.22-50.22-12.88-.86-35.67-.12-50.02 13.28-16.53 16.6-13.77 46.36-13.22 50.22 18.47 1.23 37.77-1.85 50.02-13.28zm-191.69 0c11.29-12.19 14.43-32.03 13.22-50.22-12.88-.86-35.67-.12-50.02 13.28-16.53 16.6-13.77 46.36-13.22 50.22 18.47 1.23 37.77-1.85 50.02-13.28zM560 192h-49.71c3.97-26.97.44-63.55-17.22-89.06-11.25-16.31-27.09-26.7-45.78-30.06l-.29-.05c-18.22-3.02-43.56 3.02-63 11.41-19.5-8.39-44.91-14.39-63.28-11.36-12.35 2.23-23.3 7.82-32.68 15.9-9.39-8.09-20.36-13.67-32.76-15.9l-.28-.05c-18.22-3.02-43.56 3.02-63 11.41-19.47-8.41-45-14.36-63.28-11.36-18.62 3.36-34.44 13.73-45.69 30.03-17.76 25.71-21.32 62.47-17.34 89.09H16c-8.84 0-16 7.16-16 16v288c0 8.84 7.16 16 16 16h544c8.84 0 16-7.16 16-16V208c0-8.84-7.16-16-16-16zm-245.5-61.8c5.25-7.61 10.91-9.41 14.44-10.03 6.78-1.17 28.5 3.37 43.38 11.69l11.69 6.55 11.72-6.56c14.78-8.27 36.19-12.81 43.25-11.69 3.81.7 9.44 2.56 14.62 10.06 10.12 14.66 12.22 40.64 9 58.03-.23 1.37-.76 2.42-1.02 3.75H318.29c2.64-17.95 1.48-40.01-4.47-60.38.27-.42.4-1.01.68-1.42zm-191.97 0c5.25-7.61 10.91-9.41 14.38-10.03 7.03-.95 28.5 3.36 43.38 11.67l11.72 6.56 11.72-6.56c14.78-8.27 36.16-12.81 43.25-11.69 6 1.12 10.69 4.33 14.66 10.09 10.12 14.64 12.19 40.61 8.97 58-.23 1.37-.76 2.42-1.02 3.75h-155.1c-.29-1.47-.87-2.62-1.12-4.14-3.18-16.94-1.03-42.93 9.16-57.65zM528 464H48v-88h480v88zm0-136H48v-88h480v88zM96 304c8.84 0 16-7.16 16-16s-7.16-16-16-16-16 7.16-16 16 7.16 16 16 16zm384 128c8.84 0 16-7.16 16-16s-7.16-16-16-16-16 7.16-16 16 7.16 16 16 16zm-384 0c8.84 0 16-7.16 16-16s-7.16-16-16-16-16 7.16-16 16 7.16 16 16 16zm384-128c8.84 0 16-7.16 16-16s-7.16-16-16-16-16 7.16-16 16 7.16 16 16 16z"
  ]
};
export const faArchive = {
  prefix: "far",
  iconName: "archive",
  icon: [
    512,
    512,
    [],
    "f187",
    "M464 32H48C21.5 32 0 53.5 0 80v80c0 8.8 7.2 16 16 16h16v272c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32V176h16c8.8 0 16-7.2 16-16V80c0-26.5-21.5-48-48-48zm-32 400H80V176h352v256zm32-304H48V80h416v48zM204 272h104c6.6 0 12-5.4 12-12v-24c0-6.6-5.4-12-12-12H204c-6.6 0-12 5.4-12 12v24c0 6.6 5.4 12 12 12z"
  ]
};
export const faArchway = {
  prefix: "far",
  iconName: "archway",
  icon: [
    576,
    512,
    [],
    "f557",
    "M560 48c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16H16C7.16 0 0 7.16 0 16v16c0 8.84 7.16 16 16 16h16v416H16.02c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16H176c8.84 0 16-7.16 16-16V320c0-53.02 42.98-96 96-96s96 42.98 96 96v160h.02v16c0 8.84 7.16 16 16 16H560c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16h-16V48h16zm-64 0v40H80V48h416zm-64 416V320c0-79.4-64.6-144-144-144s-144 64.6-144 144v144H80V136h416v328h-64z"
  ]
};
export const faArrowAltCircleDown = {
  prefix: "far",
  iconName: "arrow-alt-circle-down",
  icon: [
    512,
    512,
    [],
    "f358",
    "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm-32-316v116h-67c-10.7 0-16 12.9-8.5 20.5l99 99c4.7 4.7 12.3 4.7 17 0l99-99c7.6-7.6 2.2-20.5-8.5-20.5h-67V140c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12z"
  ]
};
export const faArrowAltCircleLeft = {
  prefix: "far",
  iconName: "arrow-alt-circle-left",
  icon: [
    512,
    512,
    [],
    "f359",
    "M8 256c0 137 111 248 248 248s248-111 248-248S393 8 256 8 8 119 8 256zm448 0c0 110.5-89.5 200-200 200S56 366.5 56 256 145.5 56 256 56s200 89.5 200 200zm-72-20v40c0 6.6-5.4 12-12 12H256v67c0 10.7-12.9 16-20.5 8.5l-99-99c-4.7-4.7-4.7-12.3 0-17l99-99c7.6-7.6 20.5-2.2 20.5 8.5v67h116c6.6 0 12 5.4 12 12z"
  ]
};
export const faArrowAltCircleRight = {
  prefix: "far",
  iconName: "arrow-alt-circle-right",
  icon: [
    512,
    512,
    [],
    "f35a",
    "M504 256C504 119 393 8 256 8S8 119 8 256s111 248 248 248 248-111 248-248zm-448 0c0-110.5 89.5-200 200-200s200 89.5 200 200-89.5 200-200 200S56 366.5 56 256zm72 20v-40c0-6.6 5.4-12 12-12h116v-67c0-10.7 12.9-16 20.5-8.5l99 99c4.7 4.7 4.7 12.3 0 17l-99 99c-7.6 7.6-20.5 2.2-20.5-8.5v-67H140c-6.6 0-12-5.4-12-12z"
  ]
};
export const faArrowAltCircleUp = {
  prefix: "far",
  iconName: "arrow-alt-circle-up",
  icon: [
    512,
    512,
    [],
    "f35b",
    "M256 504c137 0 248-111 248-248S393 8 256 8 8 119 8 256s111 248 248 248zm0-448c110.5 0 200 89.5 200 200s-89.5 200-200 200S56 366.5 56 256 145.5 56 256 56zm20 328h-40c-6.6 0-12-5.4-12-12V256h-67c-10.7 0-16-12.9-8.5-20.5l99-99c4.7-4.7 12.3-4.7 17 0l99 99c7.6 7.6 2.2 20.5-8.5 20.5h-67v116c0 6.6-5.4 12-12 12z"
  ]
};
export const faArrowAltDown = {
  prefix: "far",
  iconName: "arrow-alt-down",
  icon: [
    448,
    512,
    [],
    "f354",
    "M400 208h-73.8V80c0-26.5-21.5-48-48-48H169.8c-26.5 0-48 21.5-48 48v128H48.1c-42.6 0-64.2 51.7-33.9 81.9l175.9 176c18.7 18.7 49.1 18.7 67.9 0l176-176c30-30.1 8.7-81.9-34-81.9zM224 432L48 256h121.8V80h108.3v176H400L224 432z"
  ]
};
export const faArrowAltFromBottom = {
  prefix: "far",
  iconName: "arrow-alt-from-bottom",
  icon: [
    384,
    512,
    [],
    "f346",
    "M384 444v24c0 6.6-5.4 12-12 12H12c-6.6 0-12-5.4-12-12v-24c0-6.6 5.4-12 12-12h360c6.6 0 12 5.4 12 12zM14.1 190.1l144-144c18.7-18.7 49.1-18.7 67.9 0l143.9 144c30.2 30.2 8.7 81.9-33.9 81.9h-51.6v80c0 26.5-21.5 48-48 48h-88.6c-26.5 0-48-21.5-48-48v-80H48c-42.7 0-64-51.8-33.9-81.9zM48 224h99.7v128h88.6V224H336L192 80 48 224z"
  ]
};
export const faArrowAltFromLeft = {
  prefix: "far",
  iconName: "arrow-alt-from-left",
  icon: [
    448,
    512,
    [],
    "f347",
    "M36 448H12c-6.6 0-12-5.4-12-12V76c0-6.6 5.4-12 12-12h24c6.6 0 12 5.4 12 12v360c0 6.6-5.4 12-12 12zM289.9 78.1l144 144c18.7 18.7 18.7 49.1 0 67.9l-144 143.9c-30.2 30.2-81.9 8.7-81.9-33.9v-51.6h-80c-26.5 0-48-21.5-48-48v-88.6c0-26.5 21.5-48 48-48h80V112c0-42.7 51.8-64 81.9-33.9zM256 112v99.7H128v88.6h128V400l144-144-144-144z"
  ]
};
export const faArrowAltFromRight = {
  prefix: "far",
  iconName: "arrow-alt-from-right",
  icon: [
    448,
    512,
    [],
    "f348",
    "M412 64h24c6.6 0 12 5.4 12 12v360c0 6.6-5.4 12-12 12h-24c-6.6 0-12-5.4-12-12V76c0-6.6 5.4-12 12-12zM158.1 433.9l-144-144c-18.7-18.7-18.7-49.1 0-67.9l144-143.9C188.3 47.9 240 69.4 240 112v51.6h80c26.5 0 48 21.5 48 48v88.6c0 26.5-21.5 48-48 48h-80V400c0 42.7-51.8 64-81.9 33.9zM192 400v-99.7h128v-88.6H192V112L48 256l144 144z"
  ]
};
export const faArrowAltFromTop = {
  prefix: "far",
  iconName: "arrow-alt-from-top",
  icon: [
    384,
    512,
    [],
    "f349",
    "M0 68V44c0-6.6 5.4-12 12-12h360c6.6 0 12 5.4 12 12v24c0 6.6-5.4 12-12 12H12C5.4 80 0 74.6 0 68zm369.9 253.9l-144 144c-18.7 18.7-49.1 18.7-67.9 0l-143.9-144c-30.2-30.2-8.7-81.9 34-81.9h51.6v-80c0-26.5 21.5-48 48-48h88.6c26.5 0 48 21.5 48 48v80H336c42.7 0 64 51.8 33.9 81.9zM336 288h-99.7V160h-88.6v128H48l144 144 144-144z"
  ]
};
export const faArrowAltLeft = {
  prefix: "far",
  iconName: "arrow-alt-left",
  icon: [
    448,
    512,
    [],
    "f355",
    "M272 431.952v-73.798h128c26.51 0 48-21.49 48-48V201.846c0-26.51-21.49-48-48-48H272V80.057c0-42.638-51.731-64.15-81.941-33.941l-176 175.943c-18.745 18.745-18.746 49.137 0 67.882l176 175.952C220.208 496.042 272 474.675 272 431.952zM48 256L224 80v121.846h176v108.308H224V432L48 256z"
  ]
};
export const faArrowAltRight = {
  prefix: "far",
  iconName: "arrow-alt-right",
  icon: [
    448,
    512,
    [],
    "f356",
    "M176 80.048v73.798H48c-26.51 0-48 21.49-48 48v108.308c0 26.51 21.49 48 48 48h128v73.789c0 42.638 51.731 64.151 81.941 33.941l176-175.943c18.745-18.745 18.746-49.137 0-67.882l-176-175.952C227.792 15.958 176 37.325 176 80.048zM400 256L224 432V310.154H48V201.846h176V80l176 176z"
  ]
};
export const faArrowAltSquareDown = {
  prefix: "far",
  iconName: "arrow-alt-square-down",
  icon: [
    448,
    512,
    [],
    "f350",
    "M204 128h40c6.6 0 12 5.4 12 12v116h67c10.7 0 16 12.9 8.5 20.5l-99 99c-4.7 4.7-12.3 4.7-17 0l-99-99c-7.6-7.6-2.2-20.5 8.5-20.5h67V140c0-6.6 5.4-12 12-12zm244-48v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
  ]
};
export const faArrowAltSquareLeft = {
  prefix: "far",
  iconName: "arrow-alt-square-left",
  icon: [
    448,
    512,
    [],
    "f351",
    "M352 236v40c0 6.6-5.4 12-12 12H224v67c0 10.7-12.9 16-20.5 8.5l-99-99c-4.7-4.7-4.7-12.3 0-17l99-99c7.6-7.6 20.5-2.2 20.5 8.5v67h116c6.6 0 12 5.4 12 12zm96-156v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
  ]
};
export const faArrowAltSquareRight = {
  prefix: "far",
  iconName: "arrow-alt-square-right",
  icon: [
    448,
    512,
    [],
    "f352",
    "M96 276v-40c0-6.6 5.4-12 12-12h116v-67c0-10.7 12.9-16 20.5-8.5l99 99c4.7 4.7 4.7 12.3 0 17l-99 99c-7.6 7.6-20.5 2.2-20.5-8.5v-67H108c-6.6 0-12-5.4-12-12zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
  ]
};
export const faArrowAltSquareUp = {
  prefix: "far",
  iconName: "arrow-alt-square-up",
  icon: [
    448,
    512,
    [],
    "f353",
    "M244 384h-40c-6.6 0-12-5.4-12-12V256h-67c-10.7 0-16-12.9-8.5-20.5l99-99c4.7-4.7 12.3-4.7 17 0l99 99c7.6 7.6 2.2 20.5-8.5 20.5h-67v116c0 6.6-5.4 12-12 12zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
  ]
};
export const faArrowAltToBottom = {
  prefix: "far",
  iconName: "arrow-alt-to-bottom",
  icon: [
    384,
    512,
    [],
    "f34a",
    "M336 176h-51.6V80c0-26.5-21.5-48-48-48h-88.6c-26.5 0-48 21.5-48 48v96H48.1c-42.6 0-64.2 51.7-33.9 81.9l143.9 144c18.7 18.7 49.1 18.7 67.9 0l144-144c30-30.1 8.7-81.9-34-81.9zM192 368L48 224h99.7V80h88.6v144H336L192 368zm192 76v24c0 6.6-5.4 12-12 12H12c-6.6 0-12-5.4-12-12v-24c0-6.6 5.4-12 12-12h360c6.6 0 12 5.4 12 12z"
  ]
};
export const faArrowAltToLeft = {
  prefix: "far",
  iconName: "arrow-alt-to-left",
  icon: [
    448,
    512,
    [],
    "f34b",
    "M304 400v-51.6h96c26.5 0 48-21.5 48-48v-88.6c0-26.5-21.5-48-48-48h-96v-51.6c0-42.6-51.7-64.2-81.9-33.9l-144 143.9c-18.7 18.7-18.7 49.1 0 67.9l144 144C252.2 464 304 442.7 304 400zM112 256l144-144v99.7h144v88.6H256V400L112 256zM36 448H12c-6.6 0-12-5.4-12-12V76c0-6.6 5.4-12 12-12h24c6.6 0 12 5.4 12 12v360c0 6.6-5.4 12-12 12z"
  ]
};
export const faArrowAltToRight = {
  prefix: "far",
  iconName: "arrow-alt-to-right",
  icon: [
    448,
    512,
    [],
    "f34c",
    "M144 112v51.6H48c-26.5 0-48 21.5-48 48v88.6c0 26.5 21.5 48 48 48h96v51.6c0 42.6 51.7 64.2 81.9 33.9l144-143.9c18.7-18.7 18.7-49.1 0-67.9l-144-144C195.8 48 144 69.3 144 112zm192 144L192 400v-99.7H48v-88.6h144V112l144 144zm76-192h24c6.6 0 12 5.4 12 12v360c0 6.6-5.4 12-12 12h-24c-6.6 0-12-5.4-12-12V76c0-6.6 5.4-12 12-12z"
  ]
};
export const faArrowAltToTop = {
  prefix: "far",
  iconName: "arrow-alt-to-top",
  icon: [
    384,
    512,
    [],
    "f34d",
    "M48 336h51.6v96c0 26.5 21.5 48 48 48h88.6c26.5 0 48-21.5 48-48v-96h51.6c42.6 0 64.2-51.7 33.9-81.9l-143.9-144c-18.7-18.7-49.1-18.7-67.9 0l-144 144C-16 284.2 5.3 336 48 336zm144-192l144 144h-99.7v144h-88.6V288H48l144-144zM0 68V44c0-6.6 5.4-12 12-12h360c6.6 0 12 5.4 12 12v24c0 6.6-5.4 12-12 12H12C5.4 80 0 74.6 0 68z"
  ]
};
export const faArrowAltUp = {
  prefix: "far",
  iconName: "arrow-alt-up",
  icon: [
    448,
    512,
    [],
    "f357",
    "M48.048 304h73.798v128c0 26.51 21.49 48 48 48h108.308c26.51 0 48-21.49 48-48V304h73.789c42.638 0 64.151-51.731 33.941-81.941l-175.943-176c-18.745-18.745-49.137-18.746-67.882 0l-175.952 176C-16.042 252.208 5.325 304 48.048 304zM224 80l176 176H278.154v176H169.846V256H48L224 80z"
  ]
};
export const faArrowCircleDown = {
  prefix: "far",
  iconName: "arrow-circle-down",
  icon: [
    512,
    512,
    [],
    "f0ab",
    "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm129.9-206.1l-19.6-19.6c-4.8-4.8-12.5-4.7-17.2.2L282 300.8V140c0-6.6-5.4-12-12-12h-28c-6.6 0-12 5.4-12 12v160.8l-67.1-70.3c-4.7-4.9-12.4-5-17.2-.2l-19.6 19.6c-4.7 4.7-4.7 12.3 0 17l121.4 121.4c4.7 4.7 12.3 4.7 17 0l121.4-121.4c4.7-4.7 4.7-12.3 0-17z"
  ]
};
export const faArrowCircleLeft = {
  prefix: "far",
  iconName: "arrow-circle-left",
  icon: [
    512,
    512,
    [],
    "f0a8",
    "M504 256C504 119 393 8 256 8S8 119 8 256s111 248 248 248 248-111 248-248zm-448 0c0-110.5 89.5-200 200-200s200 89.5 200 200-89.5 200-200 200S56 366.5 56 256zm189.1 129.9L123.7 264.5c-4.7-4.7-4.7-12.3 0-17l121.4-121.4c4.7-4.7 12.3-4.7 17 0l19.6 19.6c4.8 4.8 4.7 12.5-.2 17.2L211.2 230H372c6.6 0 12 5.4 12 12v28c0 6.6-5.4 12-12 12H211.2l70.3 67.1c4.9 4.7 5 12.4.2 17.2l-19.6 19.6c-4.7 4.7-12.3 4.7-17 0z"
  ]
};
export const faArrowCircleRight = {
  prefix: "far",
  iconName: "arrow-circle-right",
  icon: [
    512,
    512,
    [],
    "f0a9",
    "M8 256c0 137 111 248 248 248s248-111 248-248S393 8 256 8 8 119 8 256zm448 0c0 110.5-89.5 200-200 200S56 366.5 56 256 145.5 56 256 56s200 89.5 200 200zM266.9 126.1l121.4 121.4c4.7 4.7 4.7 12.3 0 17L266.9 385.9c-4.7 4.7-12.3 4.7-17 0l-19.6-19.6c-4.8-4.8-4.7-12.5.2-17.2l70.3-67.1H140c-6.6 0-12-5.4-12-12v-28c0-6.6 5.4-12 12-12h160.8l-70.3-67.1c-4.9-4.7-5-12.4-.2-17.2l19.6-19.6c4.7-4.7 12.3-4.7 17 0z"
  ]
};
export const faArrowCircleUp = {
  prefix: "far",
  iconName: "arrow-circle-up",
  icon: [
    512,
    512,
    [],
    "f0aa",
    "M256 504c137 0 248-111 248-248S393 8 256 8 8 119 8 256s111 248 248 248zm0-448c110.5 0 200 89.5 200 200s-89.5 200-200 200S56 366.5 56 256 145.5 56 256 56zM126.1 245.1l121.4-121.4c4.7-4.7 12.3-4.7 17 0l121.4 121.4c4.7 4.7 4.7 12.3 0 17l-19.6 19.6c-4.8 4.8-12.5 4.7-17.2-.2L282 211.2V372c0 6.6-5.4 12-12 12h-28c-6.6 0-12-5.4-12-12V211.2l-67.1 70.3c-4.7 4.9-12.4 5-17.2.2l-19.6-19.6c-4.7-4.7-4.7-12.3 0-17z"
  ]
};
export const faArrowDown = {
  prefix: "far",
  iconName: "arrow-down",
  icon: [
    448,
    512,
    [],
    "f063",
    "M441.9 250.1l-19.8-19.8c-4.7-4.7-12.3-4.7-17 0L250 385.4V44c0-6.6-5.4-12-12-12h-28c-6.6 0-12 5.4-12 12v341.4L42.9 230.3c-4.7-4.7-12.3-4.7-17 0L6.1 250.1c-4.7 4.7-4.7 12.3 0 17l209.4 209.4c4.7 4.7 12.3 4.7 17 0l209.4-209.4c4.7-4.7 4.7-12.3 0-17z"
  ]
};
export const faArrowFromBottom = {
  prefix: "far",
  iconName: "arrow-from-bottom",
  icon: [
    384,
    512,
    [],
    "f342",
    "M35.5 183.9l148-148.4c4.7-4.7 12.3-4.7 17 0l148 148.4c4.7 4.7 4.7 12.3 0 17l-19.6 19.6c-4.8 4.8-12.5 4.7-17.1-.2L218 123.2V372c0 6.6-5.4 12-12 12h-28c-6.6 0-12-5.4-12-12V123.2l-93.7 97.1c-4.7 4.8-12.4 4.9-17.1.2l-19.6-19.6c-4.8-4.7-4.8-12.3-.1-17zM372 428H12c-6.6 0-12 5.4-12 12v28c0 6.6 5.4 12 12 12h360c6.6 0 12-5.4 12-12v-28c0-6.6-5.4-12-12-12z"
  ]
};
export const faArrowFromLeft = {
  prefix: "far",
  iconName: "arrow-from-left",
  icon: [
    448,
    512,
    [],
    "f343",
    "M296.1 99.5l148.4 148c4.7 4.7 4.7 12.3 0 17l-148.4 148c-4.7 4.7-12.3 4.7-17 0l-19.6-19.6c-4.8-4.8-4.7-12.5.2-17.1l97.1-93.7H108c-6.6 0-12-5.4-12-12v-28c0-6.6 5.4-12 12-12h248.8l-97.1-93.7c-4.8-4.7-4.9-12.4-.2-17.1l19.6-19.6c4.7-4.9 12.3-4.9 17-.2zM52 436V76c0-6.6-5.4-12-12-12H12C5.4 64 0 69.4 0 76v360c0 6.6 5.4 12 12 12h28c6.6 0 12-5.4 12-12z"
  ]
};
export const faArrowFromRight = {
  prefix: "far",
  iconName: "arrow-from-right",
  icon: [
    448,
    512,
    [],
    "f344",
    "M151.9 412.5L3.5 264.5c-4.7-4.7-4.7-12.3 0-17l148.4-148c4.7-4.7 12.3-4.7 17 0l19.6 19.6c4.8 4.8 4.7 12.5-.2 17.1L91.2 230H340c6.6 0 12 5.4 12 12v28c0 6.6-5.4 12-12 12H91.2l97.1 93.7c4.8 4.7 4.9 12.4.2 17.1l-19.6 19.6c-4.7 4.8-12.3 4.8-17 .1zM396 76v360c0 6.6 5.4 12 12 12h28c6.6 0 12-5.4 12-12V76c0-6.6-5.4-12-12-12h-28c-6.6 0-12 5.4-12 12z"
  ]
};
export const faArrowFromTop = {
  prefix: "far",
  iconName: "arrow-from-top",
  icon: [
    384,
    512,
    [],
    "f345",
    "M348.5 328.1l-148 148.4c-4.7 4.7-12.3 4.7-17 0l-148-148.4c-4.7-4.7-4.7-12.3 0-17l19.6-19.6c4.8-4.8 12.5-4.7 17.1.2l93.7 97.1V140c0-6.6 5.4-12 12-12h28c6.6 0 12 5.4 12 12v248.8l93.7-97.1c4.7-4.8 12.4-4.9 17.1-.2l19.6 19.6c4.9 4.7 4.9 12.3.2 17zM12 84h360c6.6 0 12-5.4 12-12V44c0-6.6-5.4-12-12-12H12C5.4 32 0 37.4 0 44v28c0 6.6 5.4 12 12 12z"
  ]
};
export const faArrowLeft = {
  prefix: "far",
  iconName: "arrow-left",
  icon: [
    448,
    512,
    [],
    "f060",
    "M229.9 473.899l19.799-19.799c4.686-4.686 4.686-12.284 0-16.971L94.569 282H436c6.627 0 12-5.373 12-12v-28c0-6.627-5.373-12-12-12H94.569l155.13-155.13c4.686-4.686 4.686-12.284 0-16.971L229.9 38.101c-4.686-4.686-12.284-4.686-16.971 0L3.515 247.515c-4.686 4.686-4.686 12.284 0 16.971L212.929 473.9c4.686 4.686 12.284 4.686 16.971-.001z"
  ]
};
export const faArrowRight = {
  prefix: "far",
  iconName: "arrow-right",
  icon: [
    448,
    512,
    [],
    "f061",
    "M218.101 38.101L198.302 57.9c-4.686 4.686-4.686 12.284 0 16.971L353.432 230H12c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h341.432l-155.13 155.13c-4.686 4.686-4.686 12.284 0 16.971l19.799 19.799c4.686 4.686 12.284 4.686 16.971 0l209.414-209.414c4.686-4.686 4.686-12.284 0-16.971L235.071 38.101c-4.686-4.687-12.284-4.687-16.97 0z"
  ]
};
export const faArrowSquareDown = {
  prefix: "far",
  iconName: "arrow-square-down",
  icon: [
    448,
    512,
    [],
    "f339",
    "M353.9 266.9L232.5 388.3c-4.7 4.7-12.3 4.7-17 0L94.1 266.9c-4.7-4.7-4.7-12.3 0-17l19.6-19.6c4.8-4.8 12.5-4.7 17.2.2l67.1 70.3V140c0-6.6 5.4-12 12-12h28c6.6 0 12 5.4 12 12v160.8l67.1-70.3c4.7-4.9 12.4-5 17.2-.2l19.6 19.6c4.7 4.7 4.7 12.3 0 17zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
  ]
};
export const faArrowSquareLeft = {
  prefix: "far",
  iconName: "arrow-square-left",
  icon: [
    448,
    512,
    [],
    "f33a",
    "M213.1 385.9L91.7 264.5c-4.7-4.7-4.7-12.3 0-17l121.4-121.4c4.7-4.7 12.3-4.7 17 0l19.6 19.6c4.8 4.8 4.7 12.5-.2 17.2L179.2 230H340c6.6 0 12 5.4 12 12v28c0 6.6-5.4 12-12 12H179.2l70.3 67.1c4.9 4.7 5 12.4.2 17.2l-19.6 19.6c-4.7 4.7-12.3 4.7-17 0zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
  ]
};
export const faArrowSquareRight = {
  prefix: "far",
  iconName: "arrow-square-right",
  icon: [
    448,
    512,
    [],
    "f33b",
    "M234.9 126.1l121.4 121.4c4.7 4.7 4.7 12.3 0 17L234.9 385.9c-4.7 4.7-12.3 4.7-17 0l-19.6-19.6c-4.8-4.8-4.7-12.5.2-17.2l70.3-67.1H108c-6.6 0-12-5.4-12-12v-28c0-6.6 5.4-12 12-12h160.8l-70.3-67.1c-4.9-4.7-5-12.4-.2-17.2l19.6-19.6c4.7-4.7 12.3-4.7 17 0zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
  ]
};
export const faArrowSquareUp = {
  prefix: "far",
  iconName: "arrow-square-up",
  icon: [
    448,
    512,
    [],
    "f33c",
    "M94.1 245.1l121.4-121.4c4.7-4.7 12.3-4.7 17 0l121.4 121.4c4.7 4.7 4.7 12.3 0 17l-19.6 19.6c-4.8 4.8-12.5 4.7-17.2-.2L250 211.2V372c0 6.6-5.4 12-12 12h-28c-6.6 0-12-5.4-12-12V211.2l-67.1 70.3c-4.7 4.9-12.4 5-17.2.2l-19.6-19.6c-4.7-4.7-4.7-12.3 0-17zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
  ]
};
export const faArrowToBottom = {
  prefix: "far",
  iconName: "arrow-to-bottom",
  icon: [
    384,
    512,
    [],
    "f33d",
    "M348.5 232.1l-148 148.4c-4.7 4.7-12.3 4.7-17 0l-148-148.4c-4.7-4.7-4.7-12.3 0-17l19.6-19.6c4.8-4.8 12.5-4.7 17.1.2l93.7 97.1V44c0-6.6 5.4-12 12-12h28c6.6 0 12 5.4 12 12v248.8l93.7-97.1c4.7-4.8 12.4-4.9 17.1-.2l19.6 19.6c4.9 4.7 4.9 12.3.2 17zM372 428H12c-6.6 0-12 5.4-12 12v28c0 6.6 5.4 12 12 12h360c6.6 0 12-5.4 12-12v-28c0-6.6-5.4-12-12-12z"
  ]
};
export const faArrowToLeft = {
  prefix: "far",
  iconName: "arrow-to-left",
  icon: [
    448,
    512,
    [],
    "f33e",
    "M247.9 412.5l-148.4-148c-4.7-4.7-4.7-12.3 0-17l148.4-148c4.7-4.7 12.3-4.7 17 0l19.6 19.6c4.8 4.8 4.7 12.5-.2 17.1L187.2 230H436c6.6 0 12 5.4 12 12v28c0 6.6-5.4 12-12 12H187.2l97.1 93.7c4.8 4.7 4.9 12.4.2 17.1l-19.6 19.6c-4.7 4.8-12.3 4.8-17 .1zM52 436V76c0-6.6-5.4-12-12-12H12C5.4 64 0 69.4 0 76v360c0 6.6 5.4 12 12 12h28c6.6 0 12-5.4 12-12z"
  ]
};
export const faArrowToRight = {
  prefix: "far",
  iconName: "arrow-to-right",
  icon: [
    448,
    512,
    [],
    "f340",
    "M200.1 99.5l148.4 148c4.7 4.7 4.7 12.3 0 17l-148.4 148c-4.7 4.7-12.3 4.7-17 0l-19.6-19.6c-4.8-4.8-4.7-12.5.2-17.1l97.1-93.7H12c-6.6 0-12-5.4-12-12v-28c0-6.6 5.4-12 12-12h248.8l-97.1-93.7c-4.8-4.7-4.9-12.4-.2-17.1l19.6-19.6c4.7-4.9 12.3-4.9 17-.2zM396 76v360c0 6.6 5.4 12 12 12h28c6.6 0 12-5.4 12-12V76c0-6.6-5.4-12-12-12h-28c-6.6 0-12 5.4-12 12z"
  ]
};
export const faArrowToTop = {
  prefix: "far",
  iconName: "arrow-to-top",
  icon: [
    384,
    512,
    [],
    "f341",
    "M35.5 279.9l148-148.4c4.7-4.7 12.3-4.7 17 0l148 148.4c4.7 4.7 4.7 12.3 0 17l-19.6 19.6c-4.8 4.8-12.5 4.7-17.1-.2L218 219.2V468c0 6.6-5.4 12-12 12h-28c-6.6 0-12-5.4-12-12V219.2l-93.7 97.1c-4.7 4.8-12.4 4.9-17.1.2l-19.6-19.6c-4.8-4.7-4.8-12.3-.1-17zM12 84h360c6.6 0 12-5.4 12-12V44c0-6.6-5.4-12-12-12H12C5.4 32 0 37.4 0 44v28c0 6.6 5.4 12 12 12z"
  ]
};
export const faArrowUp = {
  prefix: "far",
  iconName: "arrow-up",
  icon: [
    448,
    512,
    [],
    "f062",
    "M6.101 261.899L25.9 281.698c4.686 4.686 12.284 4.686 16.971 0L198 126.568V468c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12V126.568l155.13 155.13c4.686 4.686 12.284 4.686 16.971 0l19.799-19.799c4.686-4.686 4.686-12.284 0-16.971L232.485 35.515c-4.686-4.686-12.284-4.686-16.971 0L6.101 244.929c-4.687 4.686-4.687 12.284 0 16.97z"
  ]
};
export const faArrows = {
  prefix: "far",
  iconName: "arrows",
  icon: [
    512,
    512,
    [],
    "f047",
    "M360.549 412.216l-96.064 96.269c-4.686 4.686-12.284 4.686-16.971 0l-96.064-96.269c-4.686-4.686-4.686-12.284 0-16.971l19.626-19.626c4.753-4.753 12.484-4.675 17.14.173L230 420.78h2V280H91.22v2l44.986 41.783c4.849 4.656 4.927 12.387.173 17.14l-19.626 19.626c-4.686 4.686-12.284 4.686-16.971 0L3.515 264.485c-4.686-4.686-4.686-12.284 0-16.971l96.269-96.064c4.686-4.686 12.284-4.686 16.97 0l19.626 19.626c4.753 4.753 4.675 12.484-.173 17.14L91.22 230v2H232V91.22h-2l-41.783 44.986c-4.656 4.849-12.387 4.927-17.14.173l-19.626-19.626c-4.686-4.686-4.686-12.284 0-16.971l96.064-96.269c4.686-4.686 12.284-4.686 16.971 0l96.064 96.269c4.686 4.686 4.686 12.284 0 16.971l-19.626 19.626c-4.753 4.753-12.484 4.675-17.14-.173L282 91.22h-2V232h140.78v-2l-44.986-41.783c-4.849-4.656-4.927-12.387-.173-17.14l19.626-19.626c4.686-4.686 12.284-4.686 16.971 0l96.269 96.064c4.686 4.686 4.686 12.284 0 16.971l-96.269 96.064c-4.686 4.686-12.284 4.686-16.971 0l-19.626-19.626c-4.753-4.753-4.675-12.484.173-17.14L420.78 282v-2H280v140.78h2l41.783-44.986c4.656-4.849 12.387-4.927 17.14-.173l19.626 19.626c4.687 4.685 4.687 12.283 0 16.969z"
  ]
};
export const faArrowsAlt = {
  prefix: "far",
  iconName: "arrows-alt",
  icon: [
    512,
    512,
    [],
    "f0b2",
    "M276 236.075h115.85v-76.15c0-10.691 12.926-16.045 20.485-8.485l96.149 96.149c4.686 4.686 4.686 12.284 0 16.971l-96.149 96.149c-7.56 7.56-20.485 2.206-20.485-8.485v-76.149H275.999v115.776h76.15c10.691 0 16.045 12.926 8.485 20.485l-96.149 96.15c-4.686 4.686-12.284 4.686-16.971 0l-96.149-96.149c-7.56-7.56-2.206-20.485 8.485-20.485H236V276.075H120.149v76.149c0 10.691-12.926 16.045-20.485 8.485L3.515 264.56c-4.686-4.686-4.686-12.284 0-16.971l96.149-96.149c7.56-7.56 20.485-2.206 20.485 8.485v76.15H236V120.15h-76.149c-10.691 0-16.045-12.926-8.485-20.485l96.149-96.149c4.686-4.686 12.284-4.686 16.971 0l96.149 96.149c7.56 7.56 2.206 20.485-8.485 20.485H276v115.925z"
  ]
};
export const faArrowsAltH = {
  prefix: "far",
  iconName: "arrows-alt-h",
  icon: [
    512,
    512,
    [],
    "f337",
    "M508.485 247.515l-99.03-99.029c-7.56-7.56-20.485-2.206-20.485 8.485V228H123.03v-71.03c0-10.691-12.926-16.045-20.485-8.485l-99.03 99.029c-4.686 4.686-4.686 12.284 0 16.971l99.03 99.029c7.56 7.56 20.485 2.206 20.485-8.485V284h265.941v71.03c0 10.691 12.926 16.045 20.485 8.485l99.03-99.029c4.686-4.687 4.686-12.285-.001-16.971z"
  ]
};
export const faArrowsAltV = {
  prefix: "far",
  iconName: "arrows-alt-v",
  icon: [
    256,
    512,
    [],
    "f338",
    "M227.03 388.97H156V123.03h71.03c10.691 0 16.045-12.926 8.485-20.485l-99.029-99.03c-4.686-4.686-12.284-4.686-16.971 0l-99.029 99.03c-7.56 7.56-2.206 20.485 8.485 20.485H100v265.94H28.97c-10.691 0-16.045 12.926-8.485 20.485l99.029 99.03c4.686 4.686 12.284 4.686 16.971 0l99.029-99.03c7.56-7.559 2.206-20.485-8.484-20.485z"
  ]
};
export const faArrowsH = {
  prefix: "far",
  iconName: "arrows-h",
  icon: [
    512,
    512,
    [],
    "f07e",
    "M347.404 142.86c-4.753 4.753-4.675 12.484.173 17.14l73.203 70H91.22l73.203-70c4.849-4.656 4.927-12.387.173-17.14l-19.626-19.626c-4.686-4.686-12.284-4.686-16.971 0L3.515 247.515c-4.686 4.686-4.686 12.284 0 16.971L128 388.766c4.686 4.686 12.284 4.686 16.971 0l19.626-19.626c4.753-4.753 4.675-12.484-.173-17.14L91.22 282h329.56l-73.203 70c-4.849 4.656-4.927 12.387-.173 17.14l19.626 19.626c4.686 4.686 12.284 4.686 16.971 0l124.485-124.281c4.686-4.686 4.686-12.284 0-16.971L384 123.234c-4.686-4.686-12.284-4.686-16.971 0l-19.625 19.626z"
  ]
};
export const faArrowsV = {
  prefix: "far",
  iconName: "arrows-v",
  icon: [
    320,
    512,
    [],
    "f07d",
    "M273.1 347.4c-4.8-4.8-12.5-4.7-17.1.2l-70 73.2V91.2l70 73.2c4.7 4.8 12.4 4.9 17.1.2l19.6-19.6c4.7-4.7 4.7-12.3 0-17L168.5 3.5c-4.7-4.7-12.3-4.7-17 0L27.2 128c-4.7 4.7-4.7 12.3 0 17l19.6 19.6c4.8 4.8 12.5 4.7 17.1-.2l70-73.2v329.6l-70-73.2c-4.7-4.8-12.4-4.9-17.1-.2L27.2 367c-4.7 4.7-4.7 12.3 0 17l124.3 124.5c4.7 4.7 12.3 4.7 17 0L292.8 384c4.7-4.7 4.7-12.3 0-17l-19.7-19.6z"
  ]
};
export const faAssistiveListeningSystems = {
  prefix: "far",
  iconName: "assistive-listening-systems",
  icon: [
    512,
    512,
    [],
    "f2a2",
    "M189.149 512c-13.255 0-24-10.745-24-24s10.745-24 24-24c36.393 0 66-30.016 66-66.909l.002-.334C256.157 324.62 328 312.824 328 264c0-66.918-53.497-120-120-120-66.38 0-120 52.95-120 120 0 13.255-10.745 24-24 24s-24-10.745-24-24c0-93.338 74.866-168 168-168 92.97 0 168 74.484 168 168 0 74.659-72.099 87.835-72.851 133.282-.106 63.272-51.205 114.718-114 114.718zM296 264c0-48.523-39.477-88-88-88s-88 39.477-88 88c0 13.255 10.745 24 24 24s24-10.745 24-24c0-22.056 17.944-40 40-40s40 17.944 40 40c0 13.255 10.745 24 24 24s24-10.745 24-24zm130.99-71c11.94-5.755 16.955-20.1 11.2-32.04-17.206-35.699-42.929-67.404-74.385-91.688-10.495-8.099-25.564-6.16-33.664 4.333s-6.16 25.563 4.332 33.664c25.581 19.748 46.493 45.521 60.477 74.532 5.759 11.946 20.109 16.951 32.04 11.199zm71.404-35.37c11.945-5.744 16.974-20.083 11.23-32.029-23.882-49.678-55.813-90.241-94.916-120.565-10.475-8.122-25.549-6.218-33.674 4.258-8.122 10.474-6.216 25.55 4.258 33.673 33.17 25.723 60.443 60.522 81.073 103.432 5.744 11.949 20.084 16.972 32.029 11.231zM208 280c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm-64 64c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zM24 464c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm104.971-16.971l-64-64L31.03 416.97l64 64 33.941-33.941z"
  ]
};
export const faAsterisk = {
  prefix: "far",
  iconName: "asterisk",
  icon: [
    512,
    512,
    [],
    "f069",
    "M479.31 357.216L303.999 256l175.31-101.215c5.74-3.314 7.706-10.653 4.392-16.392l-12-20.785c-3.314-5.74-10.653-7.706-16.392-4.392L280 214.431V12c0-6.627-5.373-12-12-12h-24c-6.627 0-12 5.373-12 12v202.431L56.69 113.215c-5.74-3.314-13.079-1.347-16.392 4.392l-12 20.785c-3.314 5.74-1.347 13.079 4.392 16.392L208 256 32.69 357.216c-5.74 3.314-7.706 10.653-4.392 16.392l12 20.784c3.314 5.739 10.653 7.706 16.392 4.392L232 297.569V500c0 6.627 5.373 12 12 12h24c6.627 0 12-5.373 12-12V297.569l175.31 101.215c5.74 3.314 13.078 1.347 16.392-4.392l12-20.784c3.314-5.739 1.347-13.079-4.392-16.392z"
  ]
};
export const faAt = {
  prefix: "far",
  iconName: "at",
  icon: [
    512,
    512,
    [],
    "f1fa",
    "M504 232C504 95.751 394.053 8 256 8 118.94 8 8 118.919 8 256c0 137.059 110.919 248 248 248 52.926 0 104.681-17.079 147.096-48.321 5.501-4.052 6.423-11.924 2.095-17.211l-15.224-18.597c-4.055-4.954-11.249-5.803-16.428-2.041C339.547 442.517 298.238 456 256 456c-110.28 0-200-89.72-200-200S145.72 56 256 56c109.469 0 200 65.02 200 176 0 63.106-42.478 98.29-83.02 98.29-19.505 0-20.133-12.62-16.366-31.463l28.621-148.557c1.426-7.402-4.245-14.27-11.783-14.27h-39.175a12.005 12.005 0 0 0-11.784 9.735c-1.102 5.723-1.661 8.336-2.28 13.993-11.923-19.548-35.878-31.068-65.202-31.068C183.412 128.66 120 191.149 120 281.53c0 61.159 32.877 102.11 93.18 102.11 29.803 0 61.344-16.833 79.749-42.239 4.145 30.846 28.497 38.01 59.372 38.01C451.467 379.41 504 315.786 504 232zm-273.9 97.35c-28.472 0-45.47-19.458-45.47-52.05 0-57.514 39.56-93.41 74.61-93.41 30.12 0 45.471 21.532 45.471 51.58 0 46.864-33.177 93.88-74.611 93.88z"
  ]
};
export const faAtlas = {
  prefix: "far",
  iconName: "atlas",
  icon: [
    448,
    512,
    [],
    "f558",
    "M224 320c66.28 0 120-53.73 120-120 0-66.28-53.72-120-120-120-66.27 0-120 53.72-120 120 0 66.27 53.73 120 120 120zm86.38-136h-34.59c-1.39-23.68-5.75-44.99-12.27-62.19 24.05 12.21 41.81 34.87 46.86 62.19zm-34.59 32h34.59c-5.05 27.32-22.82 49.98-46.86 62.19 6.53-17.21 10.88-38.51 12.27-62.19zM224 114.24c6.91 8.37 17.51 32.39 19.96 69.76h-39.93c2.46-37.37 13.06-61.39 19.97-69.76zM243.96 216c-2.45 37.37-13.05 61.39-19.96 69.76-6.91-8.37-17.51-32.39-19.96-69.76h39.92zm-59.49-94.19c-6.52 17.2-10.87 38.51-12.27 62.19h-34.59c5.06-27.32 22.82-49.98 46.86-62.19zM172.21 216c1.4 23.68 5.75 44.98 12.27 62.19-24.04-12.21-41.8-34.87-46.86-62.19h34.59zM448 384V16c0-8.8-7.2-16-16-16H80C35.8 0 0 35.8 0 80v352c0 44.2 35.8 80 80 80h352c8.8 0 16-7.2 16-16v-16c0-7.8-5.6-14.3-12.9-15.7-4.2-13-4.2-51.6 0-64.6 7.4-1.5 12.9-7.9 12.9-15.7zm-54 80H80c-17.7 0-32-14.3-32-32 0-17.6 14.4-32 32-32h314c-2.7 17.3-2.7 46.7 0 64zm6-112H80c-11.4 0-22.2 2.4-32 6.7V80c0-17.7 14.3-32 32-32h320v304z"
  ]
};
export const faAtom = {
  prefix: "far",
  iconName: "atom",
  icon: [
    448,
    512,
    [],
    "f5d2",
    "M223.96093,224a32,32,0,1,0,32.01344,32A32.06712,32.06712,0,0,0,223.96093,224ZM439.1941,128c-15.5457-27.73828-49.52629-41.332-93.10817-41.33008a243.233,243.233,0,0,0-28.21981,1.94336C295.08477,34.42578,261.52418,0,224,0s-71.08477,34.42383-93.86612,88.61133a243.21832,243.21832,0,0,0-28.21981-1.94141C58.34,86.67188,24.3477,100.26562,8.8059,128c-18.75525,33.4668-6.61444,80.59766,27.51656,127.99805C2.19146,303.39844-9.94935,350.5332,8.8059,384c15.5457,27.73633,49.52629,41.33008,93.10817,41.33008a243.233,243.233,0,0,0,28.21981-1.94336C152.91523,477.57422,186.47582,512,224,512s71.08477-34.42578,93.86612-88.61328a243.233,243.233,0,0,0,28.21981,1.94336c43.57407,0,77.56637-13.59766,93.10817-41.33008,18.75525-33.4668,6.61444-80.60156-27.51656-128.00195C445.80854,208.59766,457.94935,161.4668,439.1941,128ZM224,48c14.38534,0,32.158,18.14844,47.09227,49.95508A406.60211,406.60211,0,0,0,224,114.166a406.74553,406.74553,0,0,0-47.09031-16.21485C191.844,66.14648,209.61466,48,224,48ZM101.91407,377.33008c-26.55349,0-46.76994-6.64063-52.75927-17.33008-7.15361-12.76367-.47274-37.64453,18.54623-66.66211a421.10486,421.10486,0,0,0,36.99674,33.623,441.83594,441.83594,0,0,0,9.61888,49.20312C110.24757,376.42773,105.823,377.33008,101.91407,377.33008Zm2.7837-192.291a421.13793,421.13793,0,0,0-36.9987,33.62305C48.6801,189.64453,42.00119,164.76367,49.15284,152c5.99129-10.6875,26.21164-17.33008,52.773-17.332,3.90693,0,8.32763.90234,12.3928,1.166A441.86723,441.86723,0,0,0,104.69777,185.03906ZM224,464c-14.38534,0-32.158-18.14844-47.09227-49.95508A406.60211,406.60211,0,0,0,224,397.834a406.72488,406.72488,0,0,0,47.09031,16.2129C256.15605,445.85352,238.38534,464,224,464Zm-.03907-112a96,96,0,1,1,96.01689-96A96.0082,96.0082,0,0,1,223.96093,352Zm174.88623,8c-5.99129,10.68945-26.20774,17.33008-52.76123,17.33008-3.9089,0-8.3335-.90235-12.40258-1.166a441.83594,441.83594,0,0,0,9.61888-49.20312,421.13793,421.13793,0,0,0,36.9987-33.623C399.3199,322.35547,405.99881,347.23633,398.84716,360ZM380.299,218.66211a421.10486,421.10486,0,0,0-36.99674-33.62305,441.30414,441.30414,0,0,0-9.61888-49.20312c4.071-.26367,8.49759-1.168,12.40844-1.168,26.54959,0,46.76408,6.64258,52.75341,17.332C405.99881,164.76367,399.31794,189.64453,380.299,218.66211Z"
  ]
};
export const faAtomAlt = {
  prefix: "far",
  iconName: "atom-alt",
  icon: [
    448,
    512,
    [],
    "f5d3",
    "M397.88114,255.83232c53.65542,83.42019,66.68647,161.24674,27.09333,200.80844-61.06155,60.95189-182.77841-15.32781-200.96563-26.99945C205.88412,441.26607,84.04227,517.6239,23.012,456.64076c-39.56188-39.5617-26.53083-117.40388,27.09333-200.80844C-3.55012,172.41213-16.54992,94.57,23.012,55.02388,62.6676,15.4778,140.54139,28.50879,224.00884,82.07021c83.43621-53.59267,161.3725-66.63928,200.96563-27.04633C464.56761,94.57,451.53656,172.41213,397.88114,255.83232ZM80.69857,213.2863A619.57734,619.57734,0,0,1,181.447,112.61646C139.6664,88.617,79.32359,66.69552,56.98019,88.96069,40.23045,105.69473,46.41785,153.61564,80.69857,213.2863ZM181.5095,398.92318A610.36594,610.36594,0,0,1,80.69857,298.34709C46.41785,358.03338,40.23045,405.93866,56.98019,422.6727,73.79243,439.39111,121.79168,433.20373,181.5095,398.92318ZM338.94456,255.83232a552.289,552.289,0,0,0-114.967-115.357,551.74859,551.74859,0,0,0-114.93571,115.357c33.96822,45.71783,69.90516,81.42023,114.93571,114.84143C269.41439,337.00255,305.25758,301.17515,338.94456,255.83232Zm-82.905-.01563a32.04639,32.04639,0,1,1-32.03075-32.015A32.021,32.021,0,0,1,256.03959,255.81669Zm111.24828,42.5304A610.3659,610.3659,0,0,1,266.47693,398.92318c59.71782,34.29618,107.71708,40.48355,124.52932,23.74952C407.756,405.93866,401.59983,358.03338,367.28787,298.34709ZM266.53943,112.61646A619.36058,619.36058,0,0,1,367.28787,213.2863c34.312-59.67066,40.46812-107.59157,23.71838-124.32561C368.75659,66.78927,308.63253,88.44508,266.53943,112.61646Z"
  ]
};
export const faAudioDescription = {
  prefix: "far",
  iconName: "audio-description",
  icon: [
    512,
    512,
    [],
    "f29e",
    "M464 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm-6 336H54a6 6 0 0 1-6-6V118a6 6 0 0 1 6-6h404a6 6 0 0 1 6 6v276a6 6 0 0 1-6 6zm-212.541-63.861l-57.097-168A12.001 12.001 0 0 0 177 160h-35.894a12.001 12.001 0 0 0-11.362 8.139l-57.097 168C70.003 343.922 75.789 352 84.009 352h29.133a12 12 0 0 0 11.535-8.693l8.574-29.906h51.367l8.793 29.977A12 12 0 0 0 204.926 352h29.172c8.22 0 14.006-8.078 11.361-15.861zm-82.534-97.43l8.822 30.655h-25.606l9.041-30.652c1.277-4.421 2.651-9.994 3.872-15.245 1.22 5.251 2.594 10.823 3.871 15.242zM331.2 160h-57.366c-6.627 0-12 5.373-12 12v168c0 6.627 5.373 12 12 12H331.2c61.041 0 98.96-36.933 98.96-96.386 0-58.977-37.919-95.614-98.96-95.614zm-1.801 145.39h-14.523v-98.78h14.523c28.685 0 46.175 16.767 46.175 49.005 0 32.098-16.399 49.775-46.175 49.775z"
  ]
};
export const faAward = {
  prefix: "far",
  iconName: "award",
  icon: [
    448,
    512,
    [],
    "f559",
    "M446.34 433.21l-62.35-137.6c4.44-11.43 8.32-14.17 22.34-28.19a44.715 44.715 0 0 0 11.57-43.18c-8.29-30.95-8.3-26.65 0-57.62a44.721 44.721 0 0 0-11.57-43.18c-22.68-22.7-20.52-18.94-28.82-49.92a44.68 44.68 0 0 0-31.61-31.61c-30.96-8.29-27.22-6.13-49.9-28.81a44.714 44.714 0 0 0-43.19-11.58c-30.87 8.27-26.69 8.29-57.62 0A44.72 44.72 0 0 0 152 13.1c-22.66 22.66-18.93 20.51-49.9 28.81a44.68 44.68 0 0 0-31.61 31.61c-8.29 30.96-6.13 27.22-28.81 49.9-11.29 11.29-15.71 27.76-11.57 43.18 8.29 30.95 8.3 26.65 0 57.62a44.715 44.715 0 0 0 11.57 43.18c15.1 15.11 18.02 17.06 22.34 28.19L1.66 433.21c-5.96 13.15 4.85 27.44 20.45 27.44.29 0 .59-.01.88-.02l72.86-2.51 50.13 47.65C150.45 510 156.26 512 162 512c8.53 0 16.92-4.39 20.55-12.4L224 408.13l41.45 91.47c3.63 8.01 12.02 12.4 20.55 12.4 5.75 0 11.56-2 16.01-6.23l50.13-47.65 72.86 2.51c.3.01.59.02.88.02 15.6-.01 26.42-14.29 20.46-27.44zM153.73 446.9l-39.4-37.44-49.99 1.72 29.72-65.59c2.59 1.28 5.18 2.57 8.04 3.34 25.14 6.74 26.79 5.7 43.06 21.97 8.63 8.63 20.07 13.1 31.63 13.1 1.95 0 3.87-.55 5.81-.8l-28.87 63.7zm23.55-111.76c-22.02-22.08-33.74-24.8-60.92-32.09-11.34-42.3-17.04-45.88-39.4-68.24 11.51-42.93 7.89-49.38 0-78.79 30.96-30.96 31.22-37.69 39.41-68.24 29.09-7.78 37.07-8.22 68.25-39.4 42.62 11.42 49.19 7.94 78.79 0 21.29 21.29 25.65 27.98 68.24 39.4 11.34 42.3 17.04 45.88 39.4 68.25-11.33 42.3-8.19 48.26 0 78.81-21.29 21.29-27.98 25.66-39.4 68.25-26.27 7.04-38.28 9.44-60.93 32.09-31.14-18.18-67.02-15.45-93.44-.04zm176.51 75.01l-20.12-.69-39.4 37.44-28.87-63.7c1.94.26 3.86.8 5.81.8 11.55 0 23-4.47 31.63-13.1 16.41-16.41 17.81-15.2 43.06-21.97 2.85-.76 5.44-2.06 8.04-3.34l29.72 65.58-29.87-1.02zM320 192c0-53.02-42.98-96-96-96s-96 42.98-96 96 42.98 96 96 96 96-42.98 96-96zm-96 48c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48z"
  ]
};
export const faAxe = {
  prefix: "far",
  iconName: "axe",
  icon: [
    640,
    512,
    [],
    "f6b2",
    "M525.74 160l-58.59-58.59 39.92-39.92c6.25-6.25 6.25-16.38 0-22.63L473.13 4.93c-6.25-6.25-16.38-6.25-22.63 0l-39.92 39.92-35.46-35.48C368.87 3.12 360.68 0 352.49 0s-16.38 3.12-22.63 9.37l-96.49 96.49c-12.5 12.5-12.5 32.76 0 45.25l35.47 35.47L4.69 450.74c-6.25 6.25-6.25 16.38 0 22.63l33.94 33.94c6.25 6.25 16.38 6.25 22.63 0l264.16-264.16L384 301.74V416h32c123.71 0 224-100.29 224-224v-32H525.74zM432 367.28v-85.42l-4.69-4.69-148.68-148.68 73.85-73.87 148.7 148.7 4.69 4.69h85.42c-7.64 84.3-74.98 151.64-159.29 159.27z"
  ]
};
export const faAxeBattle = {
  prefix: "far",
  iconName: "axe-battle",
  icon: [
    512,
    512,
    [],
    "f6b3",
    "M512 176.38c-3.73-68.04-31.19-128.82-73.55-171.67-3.19-3.23-7.04-4.7-10.83-4.7-7.08 0-13.96 5.14-16.01 13.66-4.69 19.52-30.54 106.3-131.61 106.3V80c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v39.96c-100.01 0-126.17-86.81-130.85-106.3C99.1 5.15 92.21 0 85.13 0c-3.79 0-7.64 1.48-10.83 4.7C28.71 50.83 0 117.62 0 192c0 74.38 28.71 141.17 74.31 187.3 3.19 3.22 7.04 4.7 10.83 4.7 7.08 0 13.96-5.14 16.01-13.66 4.69-19.5 30.84-106.3 130.85-106.3V496c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V264.03c101.07 0 126.91 86.78 131.61 106.3 2.05 8.52 8.93 13.66 16.01 13.66 3.79 0 7.64-1.48 10.83-4.7 42.36-42.85 69.82-103.63 73.55-171.67L496.73 192 512 176.38zM76.88 303.53C58.27 270.65 48.07 231.96 48.07 192c0-39.97 10.2-78.65 28.81-111.53 31.76 53.46 84.2 87.5 155.12 87.5v48.07c-70.69-.01-123.23 33.82-155.12 87.49zm385.16-78.3c-3.96 28.21-12.87 54.77-26.17 78.31-31.48-53.01-83.46-87.51-155.87-87.51v-48.07c71.15 0 123.69-33.33 155.87-87.5 13.29 23.54 22.21 50.1 26.17 78.31L429.56 192l32.48 33.23z"
  ]
};
export const faBaby = {
  prefix: "far",
  iconName: "baby",
  icon: [
    384,
    512,
    [],
    "f77c",
    "M192 160c44.2 0 80-35.8 80-80S236.2 0 192 0s-80 35.8-80 80 35.8 80 80 80zm135.6 56.2l42.8-30c14.5-10.1 18-30.1 7.8-44.6-10.1-14.5-30.1-18-44.6-7.8l-42.8 30c-58.9 41.3-138.9 41.3-197.8 0l-42.8-30c-14.5-10.2-34.5-6.6-44.6 7.8-10.2 14.5-6.7 34.4 7.8 44.6l42.8 30c17.4 12.2 36.2 21.4 55.6 28.5v40.2c-9.4 5.6-16 15.4-16 27.1v18.7c0 6.2 2.3 11.9 5.6 17L63 396c-9.1 11.4-9.3 27.5-.6 39.2l48 64c6.3 8.4 15.9 12.8 25.6 12.8 6.7 0 13.4-2.1 19.2-6.4 14.2-10.6 17-30.7 6.4-44.8l-33.1-44.2 18.3-22.9c11.3 9 25.2 14.2 39.8 14.2h11c14.6 0 28.5-5.2 39.8-14.2l18.3 22.9-33.1 44.2c-10.6 14.1-7.8 34.2 6.4 44.8 5.8 4.3 12.5 6.4 19.2 6.4 9.8 0 19.3-4.4 25.6-12.8l48-64c8.8-11.7 8.5-27.8-.6-39.2l-38.6-48.3c3.3-5.1 5.6-10.8 5.6-17V312c0-11.7-6.6-21.5-16-27.1v-40.2c19.3-7.1 38-16.3 55.4-28.5zM256 330.7l-35.9 35.9c-6 6-14.1 9.4-22.6 9.4h-11c-8.5 0-16.6-3.3-22.6-9.4L128 330.7V312h128v18.7z"
  ]
};
export const faBabyCarriage = {
  prefix: "far",
  iconName: "baby-carriage",
  icon: [
    512,
    512,
    [],
    "f77d",
    "M496 96h-40c-30.9 0-56 25.1-56 56v40H293.2L189.1 28.2C179.9 13.7 164.7 3.8 147.3.9c-17.2-2.8-34.4 1.6-47.5 12C41.1 59.8-.3 138.8 0 216c.2 50.1 17.6 99.5 60.3 138.7C25.7 363.6 0 394.7 0 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-8.9-1.8-17.2-4.4-25.2 21.6 5.9 44.6 9.2 68.4 9.2s46.9-3.3 68.4-9.2c-2.7 8-4.4 16.3-4.4 25.2 0 44.2 35.8 80 80 80s80-35.8 80-80c0-37.3-25.7-68.4-60.3-77.3C425 320.4 448 274.6 448 224v-72c0-4.4 3.6-8 8-8h40c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zM129.8 50.4c3.5-2.7 7.5-2.5 9.7-2.2 3.8.6 7.3 2.8 9.2 5.7L236.3 192H49.4c6.5-54.7 35-105.4 80.4-141.6zM80 464c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm320-32c0 17.6-14.4 32-32 32s-32-14.4-32-32 14.4-32 32-32 32 14.4 32 32zm-176-64c-90.4 0-165.2-56.1-174.9-128h349.8c-9.7 71.9-84.5 128-174.9 128z"
  ]
};
export const faBackpack = {
  prefix: "far",
  iconName: "backpack",
  icon: [
    448,
    512,
    [],
    "f5d4",
    "M320 80h-8V56c0-30.88-25.12-56-56-56h-64c-30.88 0-56 25.12-56 56v24h-8C57.31 80 0 137.31 0 208v240c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V208c0-70.69-57.31-128-128-128zM184 56c0-4.41 3.59-8 8-8h64c4.41 0 8 3.59 8 8v24h-80V56zm136 408H128v-64h192v64zm0-112H128v-32c0-17.67 14.33-32 32-32h128c17.67 0 32 14.33 32 32v32zm80 96c0 8.82-7.18 16-16 16h-16V320c0-44.11-35.89-80-80-80H160c-44.11 0-80 35.89-80 80v144H64c-8.82 0-16-7.18-16-16V208c0-44.11 35.89-80 80-80h192c44.11 0 80 35.89 80 80v240zm-96-288H144c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16z"
  ]
};
export const faBackspace = {
  prefix: "far",
  iconName: "backspace",
  icon: [
    640,
    512,
    [],
    "f55a",
    "M469.65 181.65l-11.31-11.31c-6.25-6.25-16.38-6.25-22.63 0L384 222.06l-51.72-51.72c-6.25-6.25-16.38-6.25-22.63 0l-11.31 11.31c-6.25 6.25-6.25 16.38 0 22.63L350.06 256l-51.72 51.72c-6.25 6.25-6.25 16.38 0 22.63l11.31 11.31c6.25 6.25 16.38 6.25 22.63 0L384 289.94l51.72 51.72c6.25 6.25 16.38 6.25 22.63 0l11.31-11.31c6.25-6.25 6.25-16.38 0-22.63L417.94 256l51.72-51.72c6.24-6.25 6.24-16.38-.01-22.63zM576 64H205.26C188.28 64 172 70.74 160 82.74L9.37 233.37c-12.5 12.5-12.5 32.76 0 45.25L160 429.25c12 12 28.28 18.75 45.25 18.75H576c35.35 0 64-28.65 64-64V128c0-35.35-28.65-64-64-64zm16 320c0 8.82-7.18 16-16 16H205.26c-4.27 0-8.29-1.66-11.31-4.69L54.63 256l139.31-139.31c3.02-3.02 7.04-4.69 11.31-4.69H576c8.82 0 16 7.18 16 16v256z"
  ]
};
export const faBackward = {
  prefix: "far",
  iconName: "backward",
  icon: [
    512,
    512,
    [],
    "f04a",
    "M267.5 281.2l192 159.4c20.6 17.2 52.5 2.8 52.5-24.6V96c0-27.4-31.9-41.8-52.5-24.6L267.5 232c-15.3 12.8-15.3 36.4 0 49.2zM464 130.3V382L313 256.6l151-126.3zM11.5 281.2l192 159.4c20.6 17.2 52.5 2.8 52.5-24.6V96c0-27.4-31.9-41.8-52.5-24.6L11.5 232c-15.3 12.8-15.3 36.4 0 49.2zM208 130.3V382L57 256.6l151-126.3z"
  ]
};
export const faBacon = {
  prefix: "far",
  iconName: "bacon",
  icon: [
    576,
    512,
    [],
    "f7e5",
    "M566.93 104.4L470.81 8.91a31 31 0 0 0-40.18-2.83c-13.64 10.1-25.15 14.39-41 20.3C247 79.52 209.26 191.29 200.65 214.11c-29.75 78.82-89.55 94.67-98.72 98.08-24.86 9.26-54.73 20.38-91.07 50.36C-3 374-3.63 395 9.07 407.61l96.14 95.49a30.73 30.73 0 0 0 21.71 8.9 31.05 31.05 0 0 0 18.47-6.08c13.6-10.06 25.09-14.34 40.94-20.24 142.2-53 180-164.1 188.94-187.69C405 219.18 464.8 203.3 474 199.86c24.87-9.26 54.74-20.4 91.11-50.41 13.89-11.4 14.52-32.45 1.82-45.05zM83.14 413.53l-26.06-25.89c23.06-16.11 42.75-23.44 62.56-30.79 74.36-25.31 109.53-82.38 125.91-125.79l1-2.57c28-75.17 81.75-128 159.85-157.13 13.55-5 26.5-9.87 40.61-18.47l22.41 22.27c-13.09 7.23-25.26 11.84-37.73 16.55-28.28 10.6-57.57 21.59-97.35 61.37s-50.78 69.06-61.34 97.36c-9.88 26.27-19.16 51.06-54 85.95s-59.66 44.16-85.91 54c-15.82 5.9-31.95 12.1-49.95 23.14zm373.17-258.32C381.87 180.56 346.73 237.64 330.36 281l-.91 2.42c-28.06 75.28-81.86 128.18-159.9 157.25-13.51 5-26.43 9.84-40.51 18.41l-22.41-22.27c13-7.21 25.17-11.83 37.62-16.5 28.28-10.6 57.53-21.57 97.31-61.33s50.75-69 61.35-97.35c9.87-26.26 19.15-51.06 54.06-86s59.69-44.19 86-54c15.76-5.91 31.9-12.13 49.92-23.19l26.07 25.9c-23.12 16.18-42.82 23.51-62.65 30.87z"
  ]
};
export const faBacteria = {
  prefix: "far",
  iconName: "bacteria",
  icon: [
    640,
    512,
    [],
    "e059",
    "M272.35,226.4A17.71,17.71,0,0,0,281.46,203l-4.1-9.27c3.79-1,7.52-2.19,11.45-2.84a82.48,82.48,0,0,0,34.29-14.38L333.56,186a17.76,17.76,0,1,0,23.92-26.27L347,150.21a81.46,81.46,0,0,0,10.67-46.93l13.63-4a17.73,17.73,0,1,0-10.15-34l-13.58,4a82.85,82.85,0,0,0-34.85-33.52l3.55-13.56a17.8,17.8,0,0,0-34.47-8.93l-3.48,13.31a83.77,83.77,0,0,0-16.79,1.09,288.11,288.11,0,0,0-31.8,7.38l-4-11.12a17.8,17.8,0,0,0-33.56,11.89l3.9,10.94a284.78,284.78,0,0,0-43.61,23.42l-7.06-9.42a17.9,17.9,0,0,0-24.94-3.6A17.69,17.69,0,0,0,116.84,82l7,9.32A285.14,285.14,0,0,0,89,126.42l-9.5-6.92a17.84,17.84,0,0,0-24.89,3.86,17.66,17.66,0,0,0,3.88,24.77L68,155a283,283,0,0,0-23,43.68l-11.07-3.79a17.73,17.73,0,1,0-11.59,33.52l11.18,3.83a282,282,0,0,0-6.6,28.91,81.66,81.66,0,0,0-.71,19.51l-13.46,4a17.73,17.73,0,1,0,10.13,34l13.6-4a82.5,82.5,0,0,0,34.75,33.48l-3.57,13.7a17.81,17.81,0,0,0,34.48,8.92l3.52-13.48c1.11.05,2.24.28,3.35.28A82.81,82.81,0,0,0,152.62,345l9.73,10a17.77,17.77,0,0,0,25.56-24.7l-9.82-10.07a81.61,81.61,0,0,0,12.8-31.79,118.24,118.24,0,0,1,3.56-14.22l9.3,4.35a17.74,17.74,0,1,0,15.15-32.09l-9.27-4.33a118.71,118.71,0,0,1,35.11-34l4.11,9.28a17.86,17.86,0,0,0,16.32,10.58A18.14,18.14,0,0,0,272.35,226.4ZM143.5,281.92A35.81,35.81,0,0,1,108.11,312a36.45,36.45,0,0,1-6-.51A36,36,0,0,1,72.5,270.08,240.4,240.4,0,0,1,270.16,72.48a35.83,35.83,0,0,1,41.34,29.61,36,36,0,0,1-29.59,41.42A168.43,168.43,0,0,0,143.5,281.92Zm470.29-50.61,13.46-4a17.73,17.73,0,1,0-10.13-34l-13.6,4a82.39,82.39,0,0,0-34.76-33.47l3.58-13.71a17.81,17.81,0,0,0-34.48-8.91l-3.52,13.47c-1.11-.05-2.24-.28-3.35-.28a82.9,82.9,0,0,0-43.61,12.58l-9.73-10a17.77,17.77,0,0,0-25.56,24.7l9.82,10.07a81.67,81.67,0,0,0-12.8,31.79,118.24,118.24,0,0,1-3.56,14.22l-9.3-4.35a17.74,17.74,0,1,0-15.15,32.09l9.27,4.33a118.7,118.7,0,0,1-35.11,34l-4.11-9.28a17.86,17.86,0,0,0-16.32-10.58,18.14,18.14,0,0,0-7.18,1.5A17.71,17.71,0,0,0,358.54,309l4.1,9.27c-3.79,1-7.52,2.19-11.45,2.84a82.43,82.43,0,0,0-34.29,14.38L306.44,326a17.77,17.77,0,1,0-23.92,26.28L293,361.79a81.46,81.46,0,0,0-10.67,46.93l-13.64,4a17.73,17.73,0,1,0,10.16,34l13.58-4a82.85,82.85,0,0,0,34.85,33.52l-3.55,13.56a17.8,17.8,0,0,0,34.47,8.93l3.48-13.31a83.77,83.77,0,0,0,16.79-1.09,285.86,285.86,0,0,0,31.8-7.38l4,11.12a17.8,17.8,0,0,0,33.56-11.89l-3.9-10.94a284.78,284.78,0,0,0,43.61-23.42l7.06,9.42a17.89,17.89,0,0,0,24.94,3.6A17.68,17.68,0,0,0,523.16,430l-7-9.33A285.14,285.14,0,0,0,551,385.58l9.5,6.92a17.76,17.76,0,1,0,21-28.63L572,357a283,283,0,0,0,23-43.68l11.07,3.79a17.73,17.73,0,1,0,11.59-33.52l-11.18-3.83a282,282,0,0,0,6.6-28.91A81.64,81.64,0,0,0,613.79,231.31ZM369.84,439.52a35.85,35.85,0,0,1-41.35-29.61,36,36,0,0,1,29.6-41.41A168.45,168.45,0,0,0,496.5,230.08,35.82,35.82,0,0,1,531.89,200a36.45,36.45,0,0,1,6,.51,36,36,0,0,1,29.58,41.42A240.39,240.39,0,0,1,369.84,439.52ZM112,224a16,16,0,1,0,16,16A16,16,0,0,0,112,224Zm96-96a16,16,0,1,0,16,16A16,16,0,0,0,208,128ZM400,384a16,16,0,1,0,16,16A16,16,0,0,0,400,384Z"
  ]
};
export const faBacterium = {
  prefix: "far",
  iconName: "bacterium",
  icon: [
    512,
    512,
    [],
    "e05a",
    "M511,102.93A23.76,23.76,0,0,0,481.47,87l-18.09,5.36a110.58,110.58,0,0,0-46.47-44.69l4.73-18.08a23.74,23.74,0,0,0-46-11.91L371,35.44a110.9,110.9,0,0,0-22.38,1.46,380.94,380.94,0,0,0-42.41,9.83L301,31.91a23.74,23.74,0,0,0-44.75,15.85l5.21,14.59a380,380,0,0,0-58.15,31.22L193.85,81a23.85,23.85,0,0,0-33.24-4.8,23.57,23.57,0,0,0-4.83,33.09l9.33,12.43a380.18,380.18,0,0,0-46.41,46.83L106,159.34a23.68,23.68,0,1,0-28,38.17l12.64,9.2A376.32,376.32,0,0,0,60,265l-14.76-5.06a23.65,23.65,0,1,0-15.47,44.69l14.91,5.12a377.91,377.91,0,0,0-8.8,38.53,109.1,109.1,0,0,0-.94,26l-18,5.31a23.64,23.64,0,0,0,13.51,45.31l18.12-5.36A110,110,0,0,0,95,464.14l-4.77,18.28a23.66,23.66,0,0,0,17,28.83,24.7,24.7,0,0,0,6,.75,23.73,23.73,0,0,0,23-17.7l4.69-18c1.48.05,3,.37,4.47.37a110.4,110.4,0,0,0,58.14-16.78l13,13.31a23.7,23.7,0,0,0,34.08-32.93l-13.09-13.43a109.15,109.15,0,0,0,17.06-42.38,155.49,155.49,0,0,1,4.75-19l12.4,5.8a23.66,23.66,0,1,0,20.19-42.79l-12.35-5.78a158.12,158.12,0,0,1,46.81-45.38l5.48,12.37a23.74,23.74,0,0,0,43.48-19.08l-5.47-12.36c5.05-1.36,10-2.92,15.27-3.79a109.9,109.9,0,0,0,45.72-19.17L444.75,248a23.69,23.69,0,1,0,31.88-35l-14-12.63a108.75,108.75,0,0,0,14.23-62.57L495,132.32A23.61,23.61,0,0,0,511,102.93ZM420.07,181.2a63.54,63.54,0,0,1-41.56,25.92,208.58,208.58,0,0,0-171.39,171.4,64,64,0,1,1-126.24-21A336.53,336.53,0,0,1,357.56,80.87,63.14,63.14,0,0,1,368.17,80c30.8,0,57.87,23,62.95,53.51A63.53,63.53,0,0,1,420.07,181.2ZM160,288a32,32,0,1,0,32,32A32,32,0,0,0,160,288Zm80-104a24,24,0,1,0,24,24A24,24,0,0,0,240,184Z"
  ]
};
export const faBadge = {
  prefix: "far",
  iconName: "badge",
  icon: [
    512,
    512,
    [],
    "f335",
    "M256 512c-36.2 0-68.2-18.6-86.7-46.7-33.1 6.8-68.7-2.6-94.3-28.3-25.6-25.6-35.1-61.4-28.3-94.3C18.7 324.3 0 292.3 0 256c0-36.2 18.6-68.2 46.7-86.7-6.8-32.8 2.6-68.7 28.3-94.3 25.6-25.6 61.4-35.1 94.3-28.3C187.7 18.7 219.7 0 256 0c36.3 0 68.2 18.7 86.7 46.7 32.8-6.8 68.7 2.6 94.3 28.3 25.6 25.6 35.1 61.4 28.3 94.3 27.9 18.3 46.7 50.2 46.7 86.7 0 36.2-18.6 68.2-46.7 86.7 6.8 32.8-2.6 68.7-28.3 94.3-25.6 25.6-61.2 35.1-94.3 28.3-18.4 27.9-50.3 46.7-86.7 46.7zm-61.2-108.2c6.5 17.4 15.9 60.2 61.2 60.2 43.9 0 53.5-39.6 61.2-60.2 30.5 13.8 57.8 27.3 85.8-.7 31-31 9.8-65.9.7-85.8 17.4-6.5 60.2-15.9 60.2-61.2 0-43.9-39.6-53.5-60.2-61.2 7.7-16.9 31.3-53.8-.7-85.8-31-31-65.9-9.8-85.8-.7C310.7 90.8 301.3 48 256 48c-43.9 0-53.5 39.6-61.2 60.2-16.9-7.7-53.8-31.3-85.8.7-31 31-9.8 65.9-.7 85.8-17.5 6.6-60.3 16-60.3 61.3 0 43.9 39.6 53.5 60.2 61.2-7.7 16.9-31.3 53.8.7 85.8 31 31 64.8 10.4 85.9.8z"
  ]
};
export const faBadgeCheck = {
  prefix: "far",
  iconName: "badge-check",
  icon: [
    512,
    512,
    [],
    "f336",
    "M332.73 178.37c-3.85-3.88-10.11-3.9-13.98-.06l-87.36 86.66-37.88-38.19c-3.84-3.88-10.11-3.9-13.98-.06l-23.4 23.21c-3.88 3.85-3.9 10.11-.06 13.98l68.05 68.6c3.85 3.88 10.11 3.9 13.98.06l117.78-116.83c3.88-3.85 3.9-10.11.06-13.98l-23.21-23.39zM512 256c0-36.5-18.8-68.4-46.7-86.7 6.8-32.9-2.7-68.7-28.3-94.3-25.6-25.7-61.5-35.1-94.3-28.3C324.2 18.7 292.3 0 256 0s-68.3 18.7-86.7 46.7C136.4 39.9 100.6 49.4 75 75c-25.7 25.6-35.1 61.5-28.3 94.3C18.6 187.8 0 219.8 0 256c0 36.3 18.7 68.3 46.7 86.7-6.8 32.9 2.7 68.7 28.3 94.3 25.6 25.7 61.2 35.1 94.3 28.3 18.5 28.1 50.5 46.7 86.7 46.7 36.4 0 68.3-18.8 86.7-46.7 33.1 6.8 68.7-2.7 94.3-28.3 25.7-25.6 35.1-61.5 28.3-94.3 28.1-18.5 46.7-50.5 46.7-86.7zm-108.3 61.3c9.1 19.9 30.3 54.8-.7 85.8-28 28-55.3 14.5-85.8.7-7.7 20.6-17.3 60.2-61.2 60.2-45.3 0-54.7-42.8-61.2-60.2-21.1 9.6-54.9 30.2-85.9-.8-32-32-8.4-68.9-.7-85.8C87.6 309.5 48 299.9 48 256c0-45.3 42.8-54.7 60.3-61.3-9.1-19.9-30.3-54.8.7-85.8 32-32 68.9-8.4 85.8-.7C202.5 87.6 212.1 48 256 48c45.3 0 54.7 42.8 61.2 60.4 19.9-9.1 54.8-30.3 85.8.7 32 32 8.4 68.9.7 85.8 20.6 7.7 60.2 17.3 60.2 61.2 0 45.3-42.8 54.7-60.2 61.2z"
  ]
};
export const faBadgeDollar = {
  prefix: "far",
  iconName: "badge-dollar",
  icon: [
    512,
    512,
    [],
    "f645",
    "M286.41 239.72l-50.07-14.3a8.46 8.46 0 0 1-6.12-8.11c0-4.64 3.78-8.42 8.44-8.42h32.78c3.6 0 7.08.77 10.26 2.22 4.8 2.21 10.37 1.71 14.11-2.03l17.52-17.52c5.27-5.27 4.67-14.28-1.55-18.38-9.5-6.27-20.35-10.11-31.78-11.46V144c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v17.56c-30.29 3.62-53.37 30.98-49.32 63.05 2.9 22.95 20.66 41.31 42.91 47.67l50.07 14.3a8.46 8.46 0 0 1 6.12 8.11c0 4.64-3.78 8.42-8.44 8.42h-32.78c-3.6 0-7.08-.77-10.26-2.22-4.8-2.21-10.37-1.71-14.11 2.03l-17.52 17.52c-5.27 5.27-4.67 14.28 1.55 18.38 9.5 6.27 20.35 10.11 31.78 11.46V368c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-17.56c30.29-3.62 53.37-30.98 49.32-63.05-2.9-22.95-20.66-41.31-42.91-47.67zM512 256c0-36.5-18.8-68.4-46.7-86.7 6.8-32.9-2.7-68.7-28.3-94.3-25.6-25.7-61.5-35.1-94.3-28.3C324.2 18.7 292.3 0 256 0s-68.3 18.7-86.7 46.7C136.4 39.9 100.6 49.4 75 75c-25.7 25.6-35.1 61.5-28.3 94.3C18.6 187.8 0 219.8 0 256c0 36.3 18.7 68.3 46.7 86.7-6.8 32.9 2.7 68.7 28.3 94.3 25.6 25.7 61.2 35.1 94.3 28.3 18.5 28.1 50.5 46.7 86.7 46.7 36.4 0 68.3-18.8 86.7-46.7 33.1 6.8 68.7-2.7 94.3-28.3 25.7-25.6 35.1-61.5 28.3-94.3 28.1-18.5 46.7-50.5 46.7-86.7zm-108.3 61.3c9.1 19.9 30.3 54.8-.7 85.8-28 28-55.3 14.5-85.8.7-7.7 20.6-17.3 60.2-61.2 60.2-45.3 0-54.7-42.8-61.2-60.2-21.1 9.6-54.9 30.2-85.9-.8-32-32-8.4-68.9-.7-85.8C87.6 309.5 48 299.9 48 256c0-45.3 42.8-54.7 60.3-61.3-9.1-19.9-30.3-54.8.7-85.8 32-32 68.9-8.4 85.8-.7C202.5 87.6 212.1 48 256 48c45.3 0 54.7 42.8 61.2 60.4 19.9-9.1 54.8-30.3 85.8.7 32 32 8.4 68.9.7 85.8 20.6 7.7 60.2 17.3 60.2 61.2 0 45.3-42.8 54.7-60.2 61.2z"
  ]
};
export const faBadgePercent = {
  prefix: "far",
  iconName: "badge-percent",
  icon: [
    512,
    512,
    [],
    "f646",
    "M341.65 181.65l-11.31-11.31c-6.25-6.25-16.38-6.25-22.63 0L170.35 307.72c-6.25 6.25-6.25 16.38 0 22.63l11.31 11.31c6.25 6.25 16.38 6.25 22.63 0l137.37-137.37c6.24-6.26 6.24-16.39-.01-22.64zM192 224c17.67 0 32-14.33 32-32s-14.33-32-32-32-32 14.33-32 32 14.33 32 32 32zm128 64c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm192-32c0-36.5-18.8-68.4-46.7-86.7 6.8-32.9-2.7-68.7-28.3-94.3-25.6-25.7-61.5-35.1-94.3-28.3C324.2 18.7 292.3 0 256 0s-68.3 18.7-86.7 46.7C136.4 39.9 100.6 49.4 75 75c-25.7 25.6-35.1 61.5-28.3 94.3C18.6 187.8 0 219.8 0 256c0 36.3 18.7 68.3 46.7 86.7-6.8 32.9 2.7 68.7 28.3 94.3 25.6 25.7 61.2 35.1 94.3 28.3 18.5 28.1 50.5 46.7 86.7 46.7 36.4 0 68.3-18.8 86.7-46.7 33.1 6.8 68.7-2.7 94.3-28.3 25.7-25.6 35.1-61.5 28.3-94.3 28.1-18.5 46.7-50.5 46.7-86.7zm-108.3 61.3c9.1 19.9 30.3 54.8-.7 85.8-28 28-55.3 14.5-85.8.7-7.7 20.6-17.3 60.2-61.2 60.2-45.3 0-54.7-42.8-61.2-60.2-21.1 9.6-54.9 30.2-85.9-.8-32-32-8.4-68.9-.7-85.8C87.6 309.5 48 299.9 48 256c0-45.3 42.8-54.7 60.3-61.3-9.1-19.9-30.3-54.8.7-85.8 32-32 68.9-8.4 85.8-.7C202.5 87.6 212.1 48 256 48c45.3 0 54.7 42.8 61.2 60.4 19.9-9.1 54.8-30.3 85.8.7 32 32 8.4 68.9.7 85.8 20.6 7.7 60.2 17.3 60.2 61.2 0 45.3-42.8 54.7-60.2 61.2z"
  ]
};
export const faBadgeSheriff = {
  prefix: "far",
  iconName: "badge-sheriff",
  icon: [
    512,
    512,
    [],
    "f8a2",
    "M440 320c-1.16 0-2.14.56-3.28.66L398.22 256l38.49-64.61c1.14.09 2.12.66 3.29.66a40 40 0 1 0-36.57-56h-76.55L285.5 66.48A39.55 39.55 0 0 0 296 40a40 40 0 0 0-80 0 39.55 39.55 0 0 0 10.59 26.62L185.28 136h-76.71A40 40 0 1 0 72 192c1.16 0 2.14-.56 3.28-.66l38.5 64.71-38.49 64.61c-1.14-.09-2.12-.66-3.29-.66a40 40 0 1 0 36.57 56h76.55l41.38 69.52A39.55 39.55 0 0 0 216 472a40 40 0 0 0 80 0 39.55 39.55 0 0 0-10.59-26.62L326.72 376h76.71A40 40 0 1 0 440 320zm-126.94 8a24 24 0 0 0-20.62 11.72l-36.53 61.36-36.5-61.35A24 24 0 0 0 198.78 328h-72l35.53-59.66a24 24 0 0 0 0-24.54L126.78 184h72.16a24 24 0 0 0 20.62-11.72l36.53-61.36 36.5 61.35A24 24 0 0 0 313.22 184h72l-35.53 59.66a24 24 0 0 0 0 24.54l35.53 59.8zM256 208a48 48 0 1 0 48 48 48 48 0 0 0-48-48z"
  ]
};
export const faBadgerHoney = {
  prefix: "far",
  iconName: "badger-honey",
  icon: [
    640,
    512,
    [],
    "f6b4",
    "M622.25 142.46c-25.64-14.52-42.75-26.42-70.68-45.37-14.21-9.64-29.74-18.01-44.88-24.55C493.37 66.79 479.4 64 465.45 64c-19.05 0-38.09 5.21-55.47 15.21C392.89 89.04 374.06 96 354.96 96H128C57.31 96 0 153.31 0 224v16c0 8.84 7.16 16 16 16h20.03c7.09 30.4 23.81 55.89 45.93 73.08l-12.39 33.03c-6.25 16.83-7.28 34.88-1.97 55.23l13.66 34.23c5.06 16.83 20.53 28.42 38.28 28.42h63.1c12.25 0 24.04-5.28 31.74-14.8 7.99-9.87 10.78-22.65 7.72-34.92l-12.72-34.14L231.14 352h55.08l19.18 95.86c3.75 18.62 20.22 32.14 39.22 32.14h62.66c11.73 0 23.07-4.82 30.79-13.65 8.23-9.42 11.56-21.95 9.14-34.19L421.77 304.9c52.93-31.81 91.06-46.85 119.35-54.67L560 288l23.06-46.11c22.4-2.82 32.95-2.82 40.79-19 7.32-15.11 16.16-35.79 16.16-47.62-.01-13.93-6.89-26.65-17.76-32.81zM128 144h226.96c25.67 0 52.24-7.8 78.97-23.19 10.02-5.77 20.92-8.81 31.53-8.81 7.65 0 15.12 1.55 22.22 4.62 24.46 10.56 33.51 18.62 48.47 27.38H460c-31.69 0-61.5 13.05-93.12 28.33l-100.62 61.02c-9.22 4.42-18.91 6.66-28.75 6.66H192c-36.94 0-71.81-43.97-78.58-94.63 4.73-.89 9.6-1.38 14.58-1.38zm456.67 49.32c-98.73 12.31-162.93 55.59-216.6 87.84 8.85 44.28 4.93 24.65 30.16 150.83h-47.05c-22.36-111.76-15.68-78.35-25.61-128H201.29c-30.77 62.39-23.89 48.44-44.13 89.49 7.88 21.15 5.08 13.63 14.35 38.51h-46.39l-11.69-29.3c-2.54-11.53-.77-18.78 1.07-23.73 14.89-39.67 8.33-22.19 24.81-66.12l-27.91-21.68c-14.08-10.94-24.25-27.3-28.63-46.08L74.12 208H49.61c4.22-20.73 16.66-38.34 33.55-49.88C94.18 216.67 135.67 272 192 272h45.5c14.69 0 29-3.3 43.94-10.55l100.66-61.02C408.91 187.56 435.03 176 460 176h16.81c1.91 9.06 9.56 16 19.19 16s17.29-6.94 19.19-16h80.45c-3.4 5.19-8.99 12.91-10.97 17.32z"
  ]
};
export const faBagsShopping = {
  prefix: "far",
  iconName: "bags-shopping",
  icon: [
    576,
    512,
    [],
    "f847",
    "M272 240a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-32h80v48h48v-64a32 32 0 0 0-32-32h-96V96a96 96 0 0 0-192 0v64H32a32 32 0 0 0-32 32v256a32 32 0 0 0 32 32h128v-48H48V208h80v32a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-32h96zm-96-80V96a48 48 0 0 1 96 0v64zm368 128H224a32 32 0 0 0-32 32v160a32 32 0 0 0 32 32h320a32 32 0 0 0 32-32V320a32 32 0 0 0-32-32zm-112 48a48 48 0 0 1-96 0zm96 128H240V336h48.3c1.57 47.4 35.8 89.12 83.07 95.19A96.12 96.12 0 0 0 480 336h48z"
  ]
};
export const faBahai = {
  prefix: "far",
  iconName: "bahai",
  icon: [
    512,
    512,
    [],
    "f666",
    "M496.25 202.52l-110-15.44 41.82-104.34c5.26-13.11-4.98-25.55-16.89-25.55-3.2 0-6.52.9-9.69 2.92L307.45 120l-34.1-107.18C270.64 4.27 263.32 0 256 0c-7.32 0-14.64 4.27-17.35 12.82l-34.09 107.19-94.04-59.89c-3.18-2.02-6.5-2.92-9.69-2.92-11.91 0-22.15 12.43-16.89 25.55l41.82 104.34-110 15.44c-17.53 2.46-21.67 26.27-6.03 34.67l98.16 52.66-74.49 83.53c-10.92 12.25-1.72 30.93 13.28 30.93 1.32 0 2.67-.14 4.07-.45l108.57-23.65-4.11 112.55c-.43 11.65 8.87 19.22 18.41 19.22 5.16 0 10.39-2.21 14.2-7.18l68.18-88.9 68.18 88.9c3.81 4.97 9.04 7.18 14.2 7.18 9.55 0 18.84-7.57 18.41-19.22l-4.11-112.55 108.57 23.65c1.39.3 2.75.45 4.07.45 15.01 0 24.2-18.69 13.28-30.93l-74.48-83.54 98.16-52.66c15.65-8.4 11.51-32.21-6.03-34.67zM369.02 322.05l13.99 15.69-20.39-4.44-59.48-12.96 2.25 61.67.77 21.14-12.81-16.7L256 337.74l-37.35 48.71-12.81 16.7.77-21.14 2.25-61.67-59.48 12.96-20.39 4.44 13.99-15.69 40.81-45.77-53.78-28.85-18.44-9.89 20.66-2.9 60.27-8.46-22.91-57.17-7.86-19.6 17.67 11.25 51.52 32.81 18.68-58.73 6.4-20.14 6.4 20.14 18.68 58.73 51.52-32.81 17.67-11.25-7.86 19.6-22.91 57.17 60.27 8.46 20.66 2.9-18.44 9.89-53.78 28.85 40.81 45.77z"
  ]
};
export const faBalanceScale = {
  prefix: "far",
  iconName: "balance-scale",
  icon: [
    640,
    512,
    [],
    "f24e",
    "M256 336h-.02c0-16.18 1.34-8.73-85.05-181.51-8.83-17.65-25.89-26.49-42.95-26.49-17.04 0-34.08 8.82-42.92 26.49C-2.06 328.75.02 320.33.02 336H0c0 44.18 57.31 80 128 80s128-35.82 128-80zM83.24 265.13c11.4-22.65 26.02-51.69 44.46-89.1.03-.01.13-.03.29-.03l.02-.04c19.82 39.64 35.03 69.81 46.7 92.96 11.28 22.38 19.7 39.12 25.55 51.08H55.83c6.2-12.68 15.24-30.69 27.41-54.87zM528 464H344V155.93c27.42-8.67 48.59-31.36 54.39-59.93H528c8.84 0 16-7.16 16-16V64c0-8.84-7.16-16-16-16H393.25C380.89 19.77 352.79 0 320 0s-60.89 19.77-73.25 48H112c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h129.61c5.8 28.57 26.97 51.26 54.39 59.93V464H112c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16zM320 112c-17.64 0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32zm319.98 224c0-16.18 1.34-8.73-85.05-181.51-8.83-17.65-25.89-26.49-42.95-26.49-17.04 0-34.08 8.82-42.92 26.49-87.12 174.26-85.04 165.84-85.04 181.51H384c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02zm-200.15-16c6.19-12.68 15.23-30.69 27.4-54.87 11.4-22.65 26.02-51.69 44.46-89.1.03-.01.13-.03.29-.03l.02-.04c19.82 39.64 35.03 69.81 46.7 92.96 11.28 22.38 19.7 39.12 25.55 51.08H439.83z"
  ]
};
export const faBalanceScaleLeft = {
  prefix: "far",
  iconName: "balance-scale-left",
  icon: [
    640,
    512,
    [],
    "f515",
    "M512 384c70.69 0 128-35.82 128-80h-.02c0-16.18 1.34-8.73-85.05-181.51C546.11 104.84 529.04 96 511.99 96c-17.04 0-34.08 8.82-42.92 26.49-87.13 174.26-85.05 165.84-85.05 181.51H384c0 44.18 57.31 80 128 80zm72.25-96H439.83c6.19-12.68 72-144 72.15-144l.02-.04c19.82 39.64 66.4 132.08 72.25 144.04zM130.36 178.35l131.29-43.93c9.28 9.95 21.06 17.31 34.34 21.51V496c0 8.84 7.16 16 16 16h216c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16H344V155.93c29.77-9.42 51.76-35.54 55.15-67.52l125.71-42.06c8.38-2.8 12.9-11.87 10.1-20.25l-5.08-15.17c-2.8-8.38-11.87-12.9-20.25-10.1L389.47 41.04C375.76 16.66 349.96 0 320 0c-44.18 0-80 35.82-80 80 0 3.66.6 7.16 1.08 10.69l-125.95 42.14c-8.38 2.8-12.9 11.87-10.1 20.25l5.08 15.17c2.81 8.38 11.87 12.9 20.25 10.1zM288 80c0-17.64 14.36-32 32-32s32 14.36 32 32-14.36 32-32 32-32-14.35-32-32zM0 432c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02c0-16.18 1.34-8.73-85.05-181.51-8.83-17.65-25.89-26.49-42.95-26.49-17.04 0-34.08 8.82-42.92 26.49C-2.06 424.75.02 416.33.02 432H0zm55.83-16c6.19-12.68 53.43-106.56 71.87-143.97.03-.01.13-.03.29-.03l.02-.04c19.82 39.64 66.4 132.08 72.25 144.04H55.83z"
  ]
};
export const faBalanceScaleRight = {
  prefix: "far",
  iconName: "balance-scale-right",
  icon: [
    640,
    512,
    [],
    "f516",
    "M256 304h-.02c0-15.67 2.08-7.25-85.05-181.51C162.1 104.82 145.05 96 128.01 96c-17.06 0-34.12 8.84-42.95 26.49C-1.32 295.27.02 287.82.02 304H0c0 44.18 57.31 80 128 80s128-35.82 128-80zM128 143.96l.02.04c.15 0 65.96 131.32 72.15 144H55.75c5.85-11.96 52.43-104.4 72.25-144.04zm401.89 24.29l5.08-15.17c2.8-8.38-1.72-17.45-10.1-20.25L398.92 90.69C399.4 87.16 400 83.66 400 80c0-44.18-35.82-80-80-80-29.96 0-55.76 16.66-69.47 41.04L130.36.83c-8.38-2.8-17.45 1.72-20.25 10.1l-5.08 15.17c-2.8 8.38 1.72 17.45 10.1 20.25l125.71 42.06c3.39 31.98 25.38 58.1 55.15 67.52V464H112c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h216c8.84 0 16-7.16 16-16V155.93c13.29-4.2 25.06-11.57 34.34-21.51l131.29 43.93c8.39 2.8 17.45-1.72 20.26-10.1zM320 112c-17.64 0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32zm319.98 320c0-15.67 2.08-7.25-85.05-181.51-8.84-17.67-25.88-26.5-42.92-26.49-17.06 0-34.12 8.84-42.95 26.49-86.38 172.78-85.04 165.33-85.04 181.51H384c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02zm-200.23-16c5.85-11.96 52.43-104.4 72.25-144.04l.02.04c.15 0 .26.03.29.03 18.44 37.41 65.67 131.29 71.87 143.97H439.75z"
  ]
};
export const faBallPile = {
  prefix: "far",
  iconName: "ball-pile",
  icon: [
    576,
    512,
    [],
    "f77e",
    "M480 320c-10.4 0-20.3 2.1-29.7 5.2 18.2-17.5 29.7-41.9 29.7-69.2 0-53-43-96-96-96-10.4 0-20.3 2.1-29.7 5.2 18.3-17.5 29.7-42 29.7-69.2 0-53-43-96-96-96s-96 43-96 96c0 27.2 11.4 51.7 29.7 69.2-9.4-3.1-19.2-5.2-29.7-5.2-53 0-96 43-96 96 0 27.2 11.4 51.7 29.7 69.2-9.4-3.1-19.2-5.2-29.7-5.2-53 0-96 43-96 96s43 96 96 96 96-43 96-96c0-27.2-11.4-51.7-29.7-69.2 9.4 3.1 19.2 5.2 29.7 5.2s20.3-2.1 29.7-5.2c-18.3 17.5-29.7 42-29.7 69.2 0 53 43 96 96 96s96-43 96-96c0-27.2-11.4-51.7-29.7-69.2 9.4 3.1 19.2 5.2 29.7 5.2s20.3-2.1 29.7-5.2c-18.3 17.5-29.7 42-29.7 69.2 0 53 43 96 96 96s96-43 96-96-43-96-96-96zM288 48c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zm29.7 277.2c-9.4-3.1-19.2-5.2-29.7-5.2s-20.3 2.1-29.7 5.2c18.2-17.5 29.7-41.9 29.7-69.2s-11.4-51.7-29.7-69.2c9.4 3.1 19.2 5.2 29.7 5.2s20.3-2.1 29.7-5.2c-18.3 17.5-29.7 42-29.7 69.2s11.4 51.7 29.7 69.2zM96 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm96-160c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm96 160c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm96-160c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm96 160c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"
  ]
};
export const faBallot = {
  prefix: "far",
  iconName: "ballot",
  icon: [
    448,
    512,
    [],
    "f732",
    "M200 408h144c4.4 0 8-3.6 8-8v-32c0-4.4-3.6-8-8-8H200c-4.4 0-8 3.6-8 8v32c0 4.4 3.6 8 8 8zm-88 8h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16zm0-128h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16zm88-8h144c4.4 0 8-3.6 8-8v-32c0-4.4-3.6-8-8-8H200c-4.4 0-8 3.6-8 8v32c0 4.4 3.6 8 8 8zm-88-120h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16zm88-8h144c4.4 0 8-3.6 8-8v-32c0-4.4-3.6-8-8-8H200c-4.4 0-8 3.6-8 8v32c0 4.4 3.6 8 8 8zM416 0H32C14.3 0 0 14.3 0 32v448c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32zm-16 464H48V48h352v416z"
  ]
};
export const faBallotCheck = {
  prefix: "far",
  iconName: "ballot-check",
  icon: [
    448,
    512,
    [],
    "f733",
    "M344 360H200c-4.4 0-8 3.6-8 8v32c0 4.4 3.6 8 8 8h144c4.4 0 8-3.6 8-8v-32c0-4.4-3.6-8-8-8zm-232 56h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16zm0-256h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16zm88-8h144c4.4 0 8-3.6 8-8v-32c0-4.4-3.6-8-8-8H200c-4.4 0-8 3.6-8 8v32c0 4.4 3.6 8 8 8zM416 0H32C14.3 0 0 14.3 0 32v448c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32zm-16 464H48V48h352v416zM134.6 286.4c2.1 2.1 5.5 2.1 7.6 0l64.2-63.6c2.1-2.1 2.1-5.5 0-7.6l-12.6-12.7c-2.1-2.1-5.5-2.1-7.6 0l-47.6 47.2-20.6-20.9c-2.1-2.1-5.5-2.1-7.6 0l-12.7 12.6c-2.1 2.1-2.1 5.5 0 7.6l36.9 37.4zM344 232H237.4c-1.9 5-4.6 9.7-8.5 13.5L194.2 280H344c4.4 0 8-3.6 8-8v-32c0-4.4-3.6-8-8-8z"
  ]
};
export const faBan = {
  prefix: "far",
  iconName: "ban",
  icon: [
    512,
    512,
    [],
    "f05e",
    "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm141.421 106.579c73.176 73.175 77.05 187.301 15.964 264.865L132.556 98.615c77.588-61.105 191.709-57.193 264.865 15.964zM114.579 397.421c-73.176-73.175-77.05-187.301-15.964-264.865l280.829 280.829c-77.588 61.105-191.709 57.193-264.865-15.964z"
  ]
};
export const faBandAid = {
  prefix: "far",
  iconName: "band-aid",
  icon: [
    640,
    512,
    [],
    "f462",
    "M552 96H88c-48.5 0-88 39.5-88 88v144c0 48.5 39.5 88 88 88h464c48.5 0 88-39.5 88-88V184c0-48.5-39.5-88-88-88zM88 368c-22.1 0-40-17.9-40-40V184c0-22.1 17.9-40 40-40h104v224H88zm184-88c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm-24-72c0-13.3 10.7-24 24-24s24 10.7 24 24-10.7 24-24 24-24-10.7-24-24zm96 96c0-13.3 10.7-24 24-24s24 10.7 24 24-10.7 24-24 24-24-10.7-24-24zm24-72c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm224 96c0 22.1-17.9 40-40 40H448V144h104c22.1 0 40 17.9 40 40v144z"
  ]
};
export const faBanjo = {
  prefix: "far",
  iconName: "banjo",
  icon: [
    512,
    512,
    [],
    "f8a3",
    "M502.63 39L473.05 9.37a32 32 0 0 0-45.26 0l-46.31 46.32A35.26 35.26 0 0 0 373 69.48L355.11 123l-62.88 62.87a166.32 166.32 0 0 0-73.54-31.2l-.51-.51a26.18 26.18 0 0 0-52.36 0v.46a166.32 166.32 0 0 0-72.32 29.84l-.23-.23a26.18 26.18 0 0 0-37 37l.23.22a166.31 166.31 0 0 0-29.84 72.34h-.46a26.18 26.18 0 0 0 0 52.36h.46a166.31 166.31 0 0 0 29.84 72.34l-.23.22a26.18 26.18 0 1 0 37 37l.23-.23a166.32 166.32 0 0 0 72.32 29.82v.46a26.18 26.18 0 0 0 52.36 0v-.46a166.32 166.32 0 0 0 72.32-29.82l.23.23a26.18 26.18 0 1 0 37-37l-.23-.22a166.31 166.31 0 0 0 29.84-72.34h.46a26.18 26.18 0 0 0 0-52.36l-.47-.07a166.12 166.12 0 0 0-31.19-73.91l63-63 53.35-17.78a35.26 35.26 0 0 0 13.79-8.53l46.32-46.31a32 32 0 0 0 .03-45.19zM192 440a120 120 0 1 1 120-120 120.13 120.13 0 0 1-120 120zm-41.38-131.31a16 16 0 0 0-22.63 0L116.68 320a16 16 0 0 0 0 22.63l52.69 52.68a16 16 0 0 0 22.63 0L203.31 384a16 16 0 0 0 0-22.63z"
  ]
};
export const faBarcode = {
  prefix: "far",
  iconName: "barcode",
  icon: [
    512,
    512,
    [],
    "f02a",
    "M0 448V64h18v384H0zm26.857-.273V64H36v383.727h-9.143zm27.143 0V64h8.857v383.727H54zm44.857 0V64h8.857v383.727h-8.857zm36 0V64h17.714v383.727h-17.714zm44.857 0V64h8.857v383.727h-8.857zm18 0V64h8.857v383.727h-8.857zm18 0V64h8.857v383.727h-8.857zm35.715 0V64h18v383.727h-18zm44.857 0V64h18v383.727h-18zm35.999 0V64h18.001v383.727h-18.001zm36.001 0V64h18.001v383.727h-18.001zm26.857 0V64h18v383.727h-18zm45.143 0V64h26.857v383.727h-26.857zm35.714 0V64h9.143v383.727H476zm18 .273V64h18v384h-18z"
  ]
};
export const faBarcodeAlt = {
  prefix: "far",
  iconName: "barcode-alt",
  icon: [
    640,
    512,
    [],
    "f463",
    "M360 384h48c4.4 0 8-3.6 8-8V136c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v240c0 4.4 3.6 8 8 8zm96 0h48c4.4 0 8-3.6 8-8V136c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v240c0 4.4 3.6 8 8 8zm-160 0h16c4.4 0 8-3.6 8-8V136c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v240c0 4.4 3.6 8 8 8zM592 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h544c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zm0 464H48V48h544v416zm-456-80h48c4.4 0 8-3.6 8-8V136c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v240c0 4.4 3.6 8 8 8zm96 0h16c4.4 0 8-3.6 8-8V136c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v240c0 4.4 3.6 8 8 8z"
  ]
};
export const faBarcodeRead = {
  prefix: "far",
  iconName: "barcode-read",
  icon: [
    640,
    512,
    [],
    "f464",
    "M248 128h-16c-4.4 0-8 3.6-8 8v240c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V136c0-4.4-3.6-8-8-8zm-64 0h-48c-4.4 0-8 3.6-8 8v240c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V136c0-4.4-3.6-8-8-8zm-40 336H48v-96c0-8.8-7.2-16-16-16H16c-8.8 0-16 7.2-16 16v128c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zM16 160h16c8.8 0 16-7.2 16-16V48h96c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16H16C7.2 0 0 7.2 0 16v128c0 8.8 7.2 16 16 16zm496 216V136c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v240c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8zM312 128h-16c-4.4 0-8 3.6-8 8v240c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V136c0-4.4-3.6-8-8-8zm312 224h-16c-8.8 0-16 7.2-16 16v96h-96c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16zm0-352H496c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h96v96c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16zM408 128h-48c-4.4 0-8 3.6-8 8v240c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V136c0-4.4-3.6-8-8-8z"
  ]
};
export const faBarcodeScan = {
  prefix: "far",
  iconName: "barcode-scan",
  icon: [
    640,
    512,
    [],
    "f465",
    "M632 232H8c-4.4 0-8 2.7-8 6v36c0 3.3 3.6 6 8 6h624c4.4 0 8-2.7 8-6v-36c0-3.3-3.6-6-8-6zM288 8c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152h64V8zm96 0c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v152h32V8zm96 0c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152h64V8zM160 8c0-4.4-3.6-8-8-8H72c-4.4 0-8 3.6-8 8v152h96V8zm416 0c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152h64V8zm-64 496c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V352h-64v152zm-160 0c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V352h-32v152zm64 0c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V352h-64v152zm-192 0c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V352h-64v152zm-160 0c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8V352H64v152z"
  ]
};
export const faBars = {
  prefix: "far",
  iconName: "bars",
  icon: [
    448,
    512,
    [],
    "f0c9",
    "M436 124H12c-6.627 0-12-5.373-12-12V80c0-6.627 5.373-12 12-12h424c6.627 0 12 5.373 12 12v32c0 6.627-5.373 12-12 12zm0 160H12c-6.627 0-12-5.373-12-12v-32c0-6.627 5.373-12 12-12h424c6.627 0 12 5.373 12 12v32c0 6.627-5.373 12-12 12zm0 160H12c-6.627 0-12-5.373-12-12v-32c0-6.627 5.373-12 12-12h424c6.627 0 12 5.373 12 12v32c0 6.627-5.373 12-12 12z"
  ]
};
export const faBaseball = {
  prefix: "far",
  iconName: "baseball",
  icon: [
    640,
    512,
    [],
    "f432",
    "M625.6 54.5l-16.7-22c-27.1-37-77.6-41.9-112.3-16.9L308.8 152.2c-48.1 34.7-92 73.3-131 117.8-54.8 62.6-106 101.2-135.6 122.5-8.4-9.8-23-11.3-33.2-3.3-10.3 8.3-12 23.4-3.7 33.7l64 80c7.8 9.8 22.9 12.4 33.8 3.7 9.3-7.5 11.2-20.4 5.4-30.4 29.1-21 81.9-56.6 156-87.9 54.7-23.1 106.5-52.2 154.6-86.9L605 166c35.9-25.9 46.7-75.9 20.6-111.5zm-547 383.4l-7.1-8.9c35.9-27 77.4-61.6 111.6-95.1l21.6 29.5c-42.8 21.5-89.1 49.1-126.1 74.5zM576 128.4L390.9 264c-75 52.8-136.4 76-161.7 87.6l-27.1-37.1c18.9-20.2 59.8-69.3 134.8-123.4L524.7 54.9c13.6-9.8 34.3-8.9 45.5 6.3l13 21.5c10.3 14.3 7.2 34-7.2 45.7zM512 320c-52.9 0-96 43.1-96 96s43.1 96 96 96 96-43.1 96-96-43.1-96-96-96zm0 144c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"
  ]
};
export const faBaseballBall = {
  prefix: "far",
  iconName: "baseball-ball",
  icon: [
    496,
    512,
    [],
    "f433",
    "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM114 404c12-14.4 22.5-30 30.8-47.1l-26.8-13c-6.8 13.9-15.3 26.5-24.9 38.4-55.4-67.7-64.8-173.4 0-252.7 9.6 11.8 18.1 24.4 24.8 38.2l26.8-13.1c-8.3-17-18.7-32.5-30.7-46.8 73.3-66.4 188.4-72 268 0-12 14.3-22.4 29.9-30.7 47l26.8 13c6.8-13.9 15.3-26.5 24.8-38.3 55.8 68.3 64.4 173.9.1 252.7-9.6-11.8-18.1-24.4-24.9-38.3l-26.8 13.1c8.3 17 18.7 32.6 30.8 46.9-73.6 66.7-188.8 71.9-268.1 0zm42.7-76.5l-28.3-9.2c12.2-37.5 14-81.5-.1-124.7l28.3-9.2c16.3 50 14 100.4.1 143.1zm211-9.2l-28.3 9.2c-16.3-50-14-100.5-.1-143.1l28.3 9.2c-12.2 37.4-14 81.5.1 124.7z"
  ]
};
export const faBasketballBall = {
  prefix: "far",
  iconName: "basketball-ball",
  icon: [
    496,
    512,
    [],
    "f434",
    "M248 8C111 8 0 118.9 0 256c0 137.9 111.6 248 248 248 136.2 0 248-110 248-248C496 119 385.2 8 248 8zm-13.9 447.3c-38.9-2.7-77.1-16.7-109.4-42L248 290l43 43c-29.2 35.1-48.9 77.4-56.9 122.3zm91.5-87.7l45.7 45.7c-26.1 20.5-56.1 33.6-87.2 39.3 7.3-31.1 21.6-59.9 41.5-85zm34-33.9c25-20 53.9-34.2 85.1-41.5-5.8 31.9-19.2 61.7-39.4 87.3l-45.7-45.8zm87.7-91.6c-45 8.1-87.2 27.8-122.4 57l-43-43 123.3-123.4c24.8 31.4 39.4 69.2 42.1 109.4zM139 181c-25.8 20.6-55.8 35-88.1 42.1 5.5-33 19-63.9 39.8-90.4L139 181zm-14.3-82.3C151.1 77.9 182 64.4 215 58.9c-7.1 32.3-21.5 62.3-42.1 88.1l-48.2-48.3zm140.2-41.9c39.1 3.3 75.8 17.8 106.4 41.9L248 222.1l-40.4-40.4c29.7-35.8 49.6-78.9 57.3-124.9zM48.8 273c46-7.8 89.1-27.6 124.8-57.3l40.4 40.4L90.7 379.4C66.6 348.7 52.1 312 48.8 273z"
  ]
};
export const faBasketballHoop = {
  prefix: "far",
  iconName: "basketball-hoop",
  icon: [
    640,
    512,
    [],
    "f435",
    "M639.9 336.9c0 22.8-13.6 43.2-34.7 51.8l-103.5 42.5 3.8-53.4 81.4-33.5c3-1.2 5-4.2 5-7.4V218.6C509.1 1.6 133.4.7 48 218.7V337c0 3.3 2 6.2 5 7.4l81.4 33.5 3.8 53.4-103.5-42.5C13.6 380.1 0 359.8 0 336.9L1.2 207C1.8 205 68.7 8 320 8s318.1 197 318.8 199c1.6 10.2 1.1-8.5 1.1 129.9zM461.2 512l-75.4-71.6L320 512l-65.8-71.6-75.4 71.6-18.2-224H136c-4.4 0-8-3.6-8-8v-32c0-4.4 3.6-8 8-8h368c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8h-24.6l-18.2 224zM206.7 352.4l46.7 43.6 44-44-42.1-42.1-48.6 42.5zm113.3-23l41.4-41.4h-82.8l41.4 41.4zm22.6 22.6l44 44 46.7-43.6-48.6-42.5-42.1 42.1zm104.7-64h-39l36.5 31.9 2.5-31.9zm-254.6 0l2.6 31.9 36.5-31.9h-39.1zm38.1 130.6l-29.9-27.9 4.3 53.5 25.6-25.6zm132.4-.8L320 374.6l-43.2 43.2 43.2 40.3 43.2-40.3zm71.6 26.4l4.3-53.5-29.9 27.9 25.6 25.6zM464 208v-80H176v80h32v-48h224v48h32z"
  ]
};
export const faBat = {
  prefix: "far",
  iconName: "bat",
  icon: [
    640,
    512,
    [],
    "f6b5",
    "M638.61 287.25L568.3 129.7c-5.47-12.27-17.85-19.4-30.67-19.4-5.81 0-11.71 1.46-17.1 4.57l-104.9 60.44L384 64l-58.12 48h-11.77L256 64l-31.62 111.3-104.9-60.44a34.122 34.122 0 0 0-17.1-4.57c-12.83 0-25.2 7.13-30.67 19.4L1.39 287.25c-4.91 10.99 3.9 22.34 15.21 22.34 1.75 0 3.55-.27 5.38-.85l16.48-5.28a69.085 69.085 0 0 1 21.07-3.29c21.83 0 42.85 10.33 55.46 28.51l38.4 55.32 12.31-11.82c13.11-12.59 30.14-18.75 47.08-18.75 20.13 0 40.15 8.69 53.36 25.6L320 448l53.86-68.97c13.21-16.91 33.23-25.6 53.36-25.6 16.95 0 33.98 6.16 47.09 18.75l12.3 11.82 38.41-55.33c12.61-18.17 33.63-28.51 55.46-28.51 7.02 0 14.13 1.07 21.07 3.29l16.48 5.28c1.82.58 3.63.85 5.38.85 11.3.01 20.11-11.34 15.2-22.33zM485.59 301.3l-10.08 14.51c-14.95-6.8-31.36-10.38-48.3-10.38-36.08 0-69.32 16.06-91.19 44.06L320 370.02l-16.03-20.53c-21.87-28-55.1-44.06-91.19-44.06-16.94 0-33.35 3.58-48.3 10.38l-10.07-14.51c-19.49-28.08-50.74-45.83-84.98-48.72l39.46-88.42 91.53 52.74 53.32 30.72 16.82-59.2 11.54-40.62 1.46 1.2 13.29 11h46.29l13.31-10.99 1.46-1.2 11.54 40.62 16.82 59.2 53.32-30.72 91.53-52.74 39.46 88.43c-34.25 2.87-65.49 20.62-84.99 48.7z"
  ]
};
export const faBath = {
  prefix: "far",
  iconName: "bath",
  icon: [
    512,
    512,
    [],
    "f2cd",
    "M496,256H80V69.25a21.26,21.26,0,0,1,36.28-15l12,12a74,74,0,0,0,15.18,88A15.9,15.9,0,0,0,144,176l11.31,11.31a16,16,0,0,0,22.63,0L283.31,81.94a16,16,0,0,0,0-22.63L272,48a15.89,15.89,0,0,0-21.78-.56,74,74,0,0,0-88-15.18l-12-12A69.25,69.25,0,0,0,32,69.25V256H16A16,16,0,0,0,0,272v16a16,16,0,0,0,16,16H32v80a95.4,95.4,0,0,0,32,71.09V496a16,16,0,0,0,16,16H96a16,16,0,0,0,16-16V478.39A95.87,95.87,0,0,0,128,480H384a95.87,95.87,0,0,0,16-1.61V496a16,16,0,0,0,16,16h16a16,16,0,0,0,16-16V455.09A95.4,95.4,0,0,0,480,384V304h16a16,16,0,0,0,16-16V272A16,16,0,0,0,496,256ZM178,120.51c-5.93-5-10-12.1-10-20.51a28,28,0,0,1,28-28c8.46,0,15.58,4.08,20.58,10.07C205.07,93.75,192.62,106.2,178,120.51ZM432,384a48.05,48.05,0,0,1-48,48H128a48.05,48.05,0,0,1-48-48V304H432Z"
  ]
};
export const faBatteryBolt = {
  prefix: "far",
  iconName: "battery-bolt",
  icon: [
    640,
    512,
    [],
    "f376",
    "M445.394 223.522L304.616 469.519c-3.522 6.654-9.943 10.481-16.623 10.481-12.266 0-21.553-12.557-18.677-25.843l36.847-166.382h-94.961c-11.6 0-20.566-11.186-19.031-23.775l25.597-213.775C219.04 39.792 227.177 32 236.8 32h108.8c12.604 0 21.8 13.087 18.552 26.411L336.458 192h92.321c14.785 0 24.011 17.55 16.615 31.522zM48 144h110.197l5.747-48H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h180.604l10.63-48H48V144zm568 16h-8v-16c0-26.51-21.49-48-48-48H405.38l-9.951 48H560v64h32v96h-32v64H418.017l-27.469 48H560c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24z"
  ]
};
export const faBatteryEmpty = {
  prefix: "far",
  iconName: "battery-empty",
  icon: [
    640,
    512,
    [],
    "f244",
    "M560 144v64h32v96h-32v64H48V144h512m0-48H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48z"
  ]
};
export const faBatteryFull = {
  prefix: "far",
  iconName: "battery-full",
  icon: [
    640,
    512,
    [],
    "f240",
    "M560 144v64h32v96h-32v64H48V144h512m0-48H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48zm-48 96H96v128h416V192z"
  ]
};
export const faBatteryHalf = {
  prefix: "far",
  iconName: "battery-half",
  icon: [
    640,
    512,
    [],
    "f242",
    "M320 320H96V192h224v128zm240-176H48v224h512v-64h32v-96h-32v-64m0-48c26.51 0 48 21.49 48 48v16h8c13.255 0 24 10.745 24 24v144c0 13.255-10.745 24-24 24h-8v16c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V144c0-26.51 21.49-48 48-48h512z"
  ]
};
export const faBatteryQuarter = {
  prefix: "far",
  iconName: "battery-quarter",
  icon: [
    640,
    512,
    [],
    "f243",
    "M224 320H96V192h128v128zm336-176H48v224h512v-64h32v-96h-32v-64m0-48c26.51 0 48 21.49 48 48v16h8c13.255 0 24 10.745 24 24v144c0 13.255-10.745 24-24 24h-8v16c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V144c0-26.51 21.49-48 48-48h512z"
  ]
};
export const faBatterySlash = {
  prefix: "far",
  iconName: "battery-slash",
  icon: [
    640,
    512,
    [],
    "f377",
    "M36 3.51A16 16 0 0 0 13.51 6l-10 12.49A16 16 0 0 0 6 41l598 467.49a16 16 0 0 0 22.49-2.49l10-12.49A16 16 0 0 0 634 471zM616 160h-8v-16a48 48 0 0 0-48-48H232.24l61.39 48H560v64h32v96h-32v48.25l44.18 34.53A47.74 47.74 0 0 0 608 368v-16h8a24 24 0 0 0 24-24V184a24 24 0 0 0-24-24zM48 368V134.74l-32.79-25.63A47.74 47.74 0 0 0 0 144v224a48 48 0 0 0 48 48h359.76l-61.39-48z"
  ]
};
export const faBatteryThreeQuarters = {
  prefix: "far",
  iconName: "battery-three-quarters",
  icon: [
    640,
    512,
    [],
    "f241",
    "M416 320H96V192h320v128zm144-176H48v224h512v-64h32v-96h-32v-64m0-48c26.51 0 48 21.49 48 48v16h8c13.255 0 24 10.745 24 24v144c0 13.255-10.745 24-24 24h-8v16c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V144c0-26.51 21.49-48 48-48h512z"
  ]
};
export const faBed = {
  prefix: "far",
  iconName: "bed",
  icon: [
    640,
    512,
    [],
    "f236",
    "M168 304c48.52 0 88-39.48 88-88s-39.48-88-88-88-88 39.48-88 88 39.48 88 88 88zm0-128c22.06 0 40 17.94 40 40s-17.94 40-40 40-40-17.94-40-40 17.94-40 40-40zm360-48H304c-8.84 0-16 7.16-16 16v192H48V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v352c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-48h544v48c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V240c0-61.86-50.14-112-112-112zm64 208H336V176h192c35.29 0 64 28.71 64 64v96z"
  ]
};
export const faBedAlt = {
  prefix: "far",
  iconName: "bed-alt",
  icon: [
    512,
    512,
    [],
    "f8f7",
    "M80,160a32,32,0,0,1,32-32h96a32,32,0,0,1,32,32v32h32V160a32,32,0,0,1,32-32h96a32,32,0,0,1,32,32v32h48V64a32,32,0,0,0-32-32H64A32,32,0,0,0,32,64V192H80Zm368,64H64A64,64,0,0,0,0,288V464a16,16,0,0,0,16,16H32a16,16,0,0,0,16-16V416H464v48a16,16,0,0,0,16,16h16a16,16,0,0,0,16-16V288A64,64,0,0,0,448,224Zm16,144H48V288a16,16,0,0,1,16-16H448a16,16,0,0,1,16,16Z"
  ]
};
export const faBedBunk = {
  prefix: "far",
  iconName: "bed-bunk",
  icon: [
    576,
    512,
    [],
    "f8f8",
    "M152,144A72,72,0,1,0,80,72,72,72,0,0,0,152,144Zm0-96a24,24,0,1,1-24,24A24,24,0,0,1,152,48ZM464,0H272a16,16,0,0,0-16,16V160H48V16A16,16,0,0,0,32,0H16A16,16,0,0,0,0,16V496a16,16,0,0,0,16,16H32a16,16,0,0,0,16-16V464H528v32a16,16,0,0,0,16,16h16a16,16,0,0,0,16-16V128C576,50.14,525.88,0,464,0Zm64,416H304V304H464a64.07,64.07,0,0,1,64,64Zm0-139.74A111.31,111.31,0,0,0,464,256H272a16,16,0,0,0-16,16V416H48V208H528ZM528,160H304V48H464a64.07,64.07,0,0,1,64,64ZM152,400a72,72,0,1,0-72-72A72,72,0,0,0,152,400Zm0-96a24,24,0,1,1-24,24A24,24,0,0,1,152,304Z"
  ]
};
export const faBedEmpty = {
  prefix: "far",
  iconName: "bed-empty",
  icon: [
    640,
    512,
    [],
    "f8f9",
    "M528,128H48V80A16,16,0,0,0,32,64H16A16,16,0,0,0,0,80V432a16,16,0,0,0,16,16H32a16,16,0,0,0,16-16V384H592v48a16,16,0,0,0,16,16h16a16,16,0,0,0,16-16V240A112,112,0,0,0,528,128ZM160,336H48V176H160Zm432,0H208V176H528a64.07,64.07,0,0,1,64,64Z"
  ]
};
export const faBeer = {
  prefix: "far",
  iconName: "beer",
  icon: [
    448,
    512,
    [],
    "f0fc",
    "M152 152v208c0 13.255-10.745 24-24 24s-24-10.745-24-24V152c0-13.255 10.745-24 24-24s24 10.745 24 24zm72-24c-13.255 0-24 10.745-24 24v208c0 13.255 10.745 24 24 24s24-10.745 24-24V152c0-13.255-10.745-24-24-24zm224 40v145.288c0 27.985-16.418 53.646-41.827 65.373L352 403.664V432c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h256c26.51 0 48 21.49 48 48v16h24c39.701 0 72 32.299 72 72zM298 80H54c-3.314 0-6 2.678-6 5.992v340.016A5.993 5.993 0 0 0 54 432h244a6 6 0 0 0 6-6V86a6 6 0 0 0-6-6zm102 88c0-13.233-10.767-24-24-24h-24v206.798l34.058-15.719c8.47-3.909 13.942-12.463 13.942-21.791V168z"
  ]
};
export const faBell = {
  prefix: "far",
  iconName: "bell",
  icon: [
    448,
    512,
    [],
    "f0f3",
    "M439.39 362.29c-19.32-20.76-55.47-51.99-55.47-154.29 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84C118.56 68.1 64.08 130.3 64.08 208c0 102.3-36.15 133.53-55.47 154.29-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h383.8c19.12 0 32-15.6 32.1-32 .05-7.55-2.61-15.27-8.61-21.71zM67.53 368c21.22-27.97 44.42-74.33 44.53-159.42 0-.2-.06-.38-.06-.58 0-61.86 50.14-112 112-112s112 50.14 112 112c0 .2-.06.38-.06.58.11 85.1 23.31 131.46 44.53 159.42H67.53zM224 512c35.32 0 63.97-28.65 63.97-64H160.03c0 35.35 28.65 64 63.97 64z"
  ]
};
export const faBellExclamation = {
  prefix: "far",
  iconName: "bell-exclamation",
  icon: [
    448,
    512,
    [],
    "f848",
    "M236.46 290.51a31.94 31.94 0 1 0 17 17 31.92 31.92 0 0 0-17-17zM246.29 128h-44.6a16.06 16.06 0 0 0-15.9 17.6l12.8 96a16 16 0 0 0 15.9 14.4h19a16 16 0 0 0 15.9-14.4l12.8-96a16 16 0 0 0-15.9-17.6zM224 512a64 64 0 0 0 64-64H160a64 64 0 0 0 64 64zm215.37-149.7c-19.31-20.77-55.46-52-55.46-154.3 0-77.7-54.47-139.91-127.94-155.16V32A32 32 0 1 0 192 32v20.84C118.56 68.09 64.09 130.3 64.09 208c0 102.3-36.15 133.53-55.46 154.3A31.17 31.17 0 0 0 0 384c.13 16.41 13 32 32.09 32h383.82c19.12 0 32-15.59 32.09-32a31.17 31.17 0 0 0-8.63-21.7zM67.53 368c21.22-28 44.41-74.33 44.53-159.42 0-.2-.06-.38-.06-.58a112 112 0 0 1 224 0c0 .2-.06.38-.06.58.12 85.11 23.31 131.47 44.53 159.42z"
  ]
};
export const faBellOn = {
  prefix: "far",
  iconName: "bell-on",
  icon: [
    640,
    512,
    [],
    "f8fa",
    "M520.94,100a23.8,23.8,0,0,0,12-3.22l55.42-32a24,24,0,0,0-24-41.56l-55.42,32a24,24,0,0,0,12,44.78ZM112,192a24,24,0,0,0-24-24H24a24,24,0,0,0,0,48H88A24,24,0,0,0,112,192ZM51.66,64.78l55.42,32a24,24,0,1,0,24-41.56l-55.42-32a24,24,0,1,0-24,41.56ZM616,168H552a24,24,0,0,0,0,48h64a24,24,0,0,0,0-48ZM479.9,208c0-77.7-54.46-139.91-127.93-155.16V32A32,32,0,1,0,288,32V52.84C214.56,68.09,160.09,130.3,160.09,208c0,102.3-36.15,133.53-55.47,154.3A31.15,31.15,0,0,0,96,384c.12,16.41,13,32,32.09,32H511.9c19.13,0,32-15.59,32.1-32a31.17,31.17,0,0,0-8.63-21.7C516.06,341.53,479.9,310.3,479.9,208ZM163.53,368c21.22-28,44.41-74.33,44.53-159.42,0-.2-.06-.38-.06-.58a112,112,0,0,1,224,0c0,.2-.06.38-.06.58.12,85.11,23.31,131.47,44.53,159.42ZM320,512a64,64,0,0,0,64-64H256A64,64,0,0,0,320,512Z"
  ]
};
export const faBellPlus = {
  prefix: "far",
  iconName: "bell-plus",
  icon: [
    448,
    512,
    [],
    "f849",
    "M224 512a64 64 0 0 0 64-64H160a64 64 0 0 0 64 64zm215.37-149.7c-19.31-20.77-55.46-52-55.46-154.3 0-77.7-54.47-139.91-127.94-155.16V32A32 32 0 1 0 192 32v20.84C118.56 68.09 64.09 130.3 64.09 208c0 102.3-36.15 133.53-55.46 154.3A31.17 31.17 0 0 0 0 384c.13 16.41 13 32 32.09 32h383.82c19.12 0 32-15.59 32.09-32a31.17 31.17 0 0 0-8.63-21.7zM67.53 368c21.22-28 44.41-74.33 44.53-159.42 0-.2-.06-.38-.06-.58a112 112 0 0 1 224 0c0 .2-.06.38-.06.58.12 85.11 23.31 131.47 44.53 159.42zM288 216h-40v-40a16 16 0 0 0-16-16h-16a16 16 0 0 0-16 16v40h-40a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h40v40a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-40h40a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16z"
  ]
};
export const faBellSchool = {
  prefix: "far",
  iconName: "bell-school",
  icon: [
    512,
    512,
    [],
    "f5d5",
    "M208 112c-52.94 0-96 43.06-96 96s43.06 96 96 96 96-43.06 96-96-43.06-96-96-96zm0 144c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48zm256 32c-26.51 0-48 21.49-48 48 0 16.43 8.27 30.89 20.86 39.55C430.78 389.9 416.55 400 400 400h-48v-42.26c39.36-37.87 64-90.94 64-149.74C416 93.31 322.69 0 208 0S0 93.31 0 208c0 58.8 24.64 111.88 64 149.74V480c0 17.67 14.33 32 32 32h224c17.67 0 32-14.33 32-32v-32h48c42.2 0 77.48-29.87 85.98-69.56 15.39-8 26.02-23.9 26.02-42.44 0-26.51-21.49-48-48-48zM304 464H112v-71.67c28.75 15.04 61.37 23.67 96 23.67s67.25-8.63 96-23.67V464zm-96-96c-88.22 0-160-71.78-160-160S119.78 48 208 48s160 71.78 160 160-71.78 160-160 160z"
  ]
};
export const faBellSchoolSlash = {
  prefix: "far",
  iconName: "bell-school-slash",
  icon: [
    640,
    512,
    [],
    "f5d6",
    "M633.99 471.02L36 3.51C29.1-2.01 19.03-.9 13.51 6l-10 12.49C-2.02 25.39-.9 35.46 6 40.98l598 467.51c6.9 5.52 16.96 4.4 22.49-2.49l10-12.49c5.52-6.9 4.41-16.97-2.5-22.49zM576 336c0-26.51-21.49-48-48-48-12.86 0-24.47 5.12-33.09 13.36l74.54 58.28c4.05-6.98 6.55-14.97 6.55-23.64zm-304 32c-88.22 0-160-71.78-160-160 0-7.37 1.21-14.42 2.18-21.53l-42.6-33.31C66.78 170.67 64 189 64 208c0 58.8 24.64 111.87 64 149.74V480c0 17.67 14.33 32 32 32h224c17.67 0 32-14.33 32-32v-57.56l-84.61-66.15C312.99 363.69 293.01 368 272 368zm96 96H176v-71.67c28.75 15.04 61.37 23.67 96 23.67s67.25-8.63 96-23.67V464zM272 48c88.22 0 160 71.78 160 160 0 13.81-2.31 26.99-5.61 39.78L467 279.53c8.25-22.33 13-46.35 13-71.53C480 93.31 386.69 0 272 0c-43.2 0-83.35 13.26-116.64 35.89l40.96 32.02C218.95 55.62 244.48 48 272 48zm-17.08 65.73l112.44 87.91C364.01 151.71 322.76 112 272 112c-5.85 0-11.52.72-17.08 1.73z"
  ]
};
export const faBellSlash = {
  prefix: "far",
  iconName: "bell-slash",
  icon: [
    640,
    512,
    [],
    "f1f6",
    "M633.99 471.02L36 3.51C29.1-2.01 19.03-.9 13.51 6l-10 12.49C-2.02 25.39-.9 35.46 6 40.98l598 467.51c6.9 5.52 16.96 4.4 22.49-2.49l10-12.49c5.52-6.9 4.41-16.97-2.5-22.49zM163.53 368c16.71-22.03 34.48-55.8 41.4-110.58l-45.47-35.55c-3.27 90.73-36.47 120.68-54.84 140.42-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h279.66l-61.4-48H163.53zM320 96c61.86 0 112 50.14 112 112 0 .2-.06.38-.06.58.02 16.84 1.16 31.77 2.79 45.73l59.53 46.54c-8.31-22.13-14.34-51.49-14.34-92.85 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84c-26.02 5.41-49.45 16.94-69.13 32.72l38.17 29.84C275 103.18 296.65 96 320 96zm0 416c35.32 0 63.97-28.65 63.97-64H256.03c0 35.35 28.65 64 63.97 64z"
  ]
};
export const faBells = {
  prefix: "far",
  iconName: "bells",
  icon: [
    640,
    512,
    [],
    "f77f",
    "M638.4 313.9c-2.1-5.9-6.4-11.2-12.9-14.5-21-10.8-58.3-24.9-87.4-105-.8-2.2-14.7-40.5-15.4-42.6C503 97.6 451.8 64 397.4 64c-15.1 0-30.5 2.6-45.6 8.1-3.6 1.3-6.6 3.3-10 4.8-14.2-16-32.1-29-53.5-36.8-15-5.5-30.5-8.1-45.6-8.1-54.5 0-105.6 33.6-125.3 87.8-.8 2.1-14.6 40.4-15.4 42.6-29.2 80.1-66.4 94.3-87.4 105-6.5 3.3-10.8 8.6-12.9 14.5-4.6 12.9 1 28.8 16 34.2L99.5 346c-2.1 7-3.5 14.3-3.5 22 0 44.2 35.8 80 80 80 32.6 0 60.5-19.6 72.9-47.6l42.1 15.3c-2.8 6.5-7.5 14.8-3.4 26 4.9 13.1 19.6 21.3 34.3 15.9l76.3-27.8C410 459.1 438.4 480 472 480c44.2 0 80-35.8 80-80 0-8.7-1.9-16.8-4.5-24.6l75-27.3c14.9-5.4 20.5-21.3 15.9-34.2zM176 400c-17.6 0-32-14.4-32-32 0-1.9.6-3.7.9-5.5l58.4 21.2c-5.6 9.6-15.5 16.3-27.3 16.3zM76.1 286.4c23.2-18.2 49.7-49.3 70.9-107.5 9.1-25 5.6-15.6 15.4-42.6 12.2-33.6 44.5-56.2 80.2-56.2 21.5 0 42.5 7.8 59.4 24.8-34.4 35.5-48 88.6-30 138.2.8 2.1 14.8 40.4 15.6 42.6 13.1 36.1 16.2 62.6 15 83.3L76.1 286.4zM504 400c0 17.6-14.4 32-32 32-12.8 0-23.5-7.8-28.4-18.7l58.9-21.5c.8 2.6 1.5 5.3 1.5 8.2zm-156.5-2.9c6-28.8 6.4-69.7-14.8-128-8.6-23.5-5.5-15-15.6-42.6-16.1-44.2 6.8-93.3 51-109.4 44.6-16.2 93.4 7.1 109.4 51 9.7 26.7 5 13.8 15.4 42.6 21.2 58.3 47.8 89.3 70.9 107.6l-216.3 78.8z"
  ]
};
export const faBetamax = {
  prefix: "far",
  iconName: "betamax",
  icon: [
    512,
    512,
    [],
    "f8a4",
    "M464 400H48V192H0v208a48 48 0 0 0 48 48h416a48 48 0 0 0 48-48V192h-48zM240 288a80 80 0 1 0-80 80 80 80 0 0 0 80-80zm-112 0a32 32 0 1 1 32 32 32 32 0 0 1-32-32zM496 64H16A16 16 0 0 0 0 80v80h512V80a16 16 0 0 0-16-16zm-96 304a32 32 0 0 0 32-32v-96a32 32 0 0 0-32-32h-96a32 32 0 0 0-32 32v96a32 32 0 0 0 32 32zm-80-112h64v64h-64z"
  ]
};
export const faBezierCurve = {
  prefix: "far",
  iconName: "bezier-curve",
  icon: [
    640,
    512,
    [],
    "f55b",
    "M576 176c35.35 0 64-28.65 64-64s-28.65-64-64-64c-26.8 0-49.45 16.61-58.95 40H400V64c0-17.67-14.33-32-32-32h-96c-17.67 0-32 14.33-32 32v24H122.95C113.45 64.61 90.8 48 64 48 28.65 48 0 76.65 0 112s28.65 64 64 64c26.8 0 49.45-16.61 58.95-40H203C138.68 173.78 94.2 241.52 88.81 320H64c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32h-23.19c5.79-66.78 47.39-123.33 105.47-150.54C246.33 182.38 257.73 192 272 192h96c14.27 0 25.67-9.62 29.72-22.54C455.8 196.67 497.4 253.22 503.19 320H480c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32h-24.81c-5.39-78.48-49.87-146.22-114.18-184h80.05c9.49 23.39 32.14 40 58.94 40zm-16-65.59l.62-2.4C562.45 100.94 568.78 96 576 96c8.82 0 16 7.18 16 16s-7.18 16-16 16c-7.22 0-13.55-4.94-15.38-12.01l-.62-2.4v-3.18zm-480 3.18l-.62 2.4C77.55 123.06 71.22 128 64 128c-8.82 0-16-7.18-16-16s7.18-16 16-16c7.22 0 13.55 4.94 15.38 12.01l.62 2.39v3.19zM144 368v64H80v-64h64zm208-224h-64V80h64v64zm208 224v64h-64v-64h64z"
  ]
};
export const faBible = {
  prefix: "far",
  iconName: "bible",
  icon: [
    448,
    512,
    [],
    "f647",
    "M160 208h48v96c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-96h48c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16h-48V96c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v48h-48c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16zm288 176V16c0-8.8-7.2-16-16-16H80C35.8 0 0 35.8 0 80v352c0 44.2 35.8 80 80 80h352c8.8 0 16-7.2 16-16v-16c0-7.8-5.6-14.3-12.9-15.7-4.2-13-4.2-51.6 0-64.6 7.4-1.5 12.9-7.9 12.9-15.7zm-54 80H80c-17.7 0-32-14.3-32-32 0-17.6 14.4-32 32-32h314c-2.7 17.3-2.7 46.7 0 64zm6-112H80c-11.4 0-22.2 2.4-32 6.7V80c0-17.7 14.3-32 32-32h320v304z"
  ]
};
export const faBicycle = {
  prefix: "far",
  iconName: "bicycle",
  icon: [
    640,
    512,
    [],
    "f206",
    "M514.115 192.017c-17.637-.285-34.469 3.005-49.832 9.181l-79.29-127.746A20 20 0 0 0 368 64h-68c-6.627 0-12 5.373-12 12v16c0 6.627 5.373 12 12 12h56.874l32.276 52H256v-16c0-6.627-5.373-12-12-12h-96c-11.046 0-20 8.954-20 20s8.954 20 20 20h61.187l-25.65 36.644c-16.797-8.102-35.634-12.643-55.532-12.644C57.375 191.998-.443 250.196.003 320.824.446 391.137 57.583 448 128 448c58.192 0 107.306-38.835 122.859-92H284a20.005 20.005 0 0 0 16.385-8.53l110.038-157.197 19.539 31.48c-28.136 23.519-46.021 58.892-45.962 98.445.104 68.88 57.908 127.158 126.785 127.797 71.601.664 129.787-57.467 129.21-129.048-.556-69.152-56.736-125.812-125.88-126.93zM128 408c-48.523 0-88-39.477-88-88s39.477-88 88-88a87.552 87.552 0 0 1 32.134 6.075L99.615 324.53C90.342 337.781 99.857 356 116 356h92.294c-13.785 30.625-44.589 52-80.294 52zm26.413-92l38.641-55.201c13.409 14.722 21.898 33.997 22.852 55.201h-61.493zm119.174 0h-17.655c-1.069-34.805-16.026-66.113-39.524-88.563L238.413 196h119.174l-84 120zm234.284 91.905c-45.514-2.092-82.216-39.219-83.815-84.752-.924-26.302 9.764-50.177 27.328-66.888l47.843 77.08c3.495 5.631 10.894 7.362 16.524 3.867l13.594-8.438c5.631-3.495 7.362-10.893 3.867-16.524l-47.351-76.287c9.012-2.809 18.641-4.205 28.626-3.928 45.797 1.27 83.314 38.07 85.418 83.837 2.379 51.775-40.258 94.413-92.034 92.033z"
  ]
};
export const faBiking = {
  prefix: "far",
  iconName: "biking",
  icon: [
    640,
    512,
    [],
    "f84a",
    "M400 96a48 48 0 1 0-48-48 48 48 0 0 0 48 48zM128 256a128 128 0 1 0 128 128 128 128 0 0 0-128-128zm0 208a80 80 0 1 1 80-80 80.09 80.09 0 0 1-80 80zm384-208a128 128 0 1 0 128 128 128 128 0 0 0-128-128zm0 208a80 80 0 1 1 80-80 80.09 80.09 0 0 1-80 80zM401 210.73a24 24 0 0 0 15 5.27h64a24 24 0 0 0 0-48h-55.59L351 109.27a24 24 0 0 0-30.62.51l-104 89.11a32 32 0 0 0 3.06 50.94l76.53 51V416a24 24 0 0 0 48 0V288a24 24 0 0 0-10.69-20l-50.11-33.4 71.29-61.1z"
  ]
};
export const faBikingMountain = {
  prefix: "far",
  iconName: "biking-mountain",
  icon: [
    640,
    512,
    [],
    "f84b",
    "M400 96a48 48 0 1 0-48-48 48 48 0 0 0 48 48zm224 256h-5.2a110.19 110.19 0 0 0-8.65-20.89l3.67-3.67a16 16 0 0 0 0-22.63l-22.63-22.63a16 16 0 0 0-22.63 0l-3.66 3.67a110.72 110.72 0 0 0-20.9-8.65V272a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v5.2a110.19 110.19 0 0 0-20.89 8.65l-3.67-3.67a16 16 0 0 0-22.63 0l-22.62 22.63a16 16 0 0 0 0 22.63l3.67 3.67A110.45 110.45 0 0 0 405.2 352H400a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h5.2a110.19 110.19 0 0 0 8.65 20.89l-3.67 3.67a16 16 0 0 0 0 22.63l22.62 22.63a16 16 0 0 0 22.63 0l3.67-3.67a110.94 110.94 0 0 0 20.9 8.65v5.2a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-5.2a110.56 110.56 0 0 0 20.9-8.65l3.67 3.67a16 16 0 0 0 22.62 0l22.63-22.63a16 16 0 0 0 0-22.63l-3.67-3.67A110.45 110.45 0 0 0 618.8 416h5.2a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-112 96a64 64 0 1 1 64-64 64 64 0 0 1-64 64zm-272-96h-5.2a110.19 110.19 0 0 0-8.65-20.89l3.67-3.67a16 16 0 0 0 0-22.63l-22.63-22.63a16 16 0 0 0-22.63 0l-3.66 3.67a110.72 110.72 0 0 0-20.9-8.65V272a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v5.2a110.19 110.19 0 0 0-20.89 8.65l-3.67-3.67a16 16 0 0 0-22.63 0l-22.63 22.63a16 16 0 0 0 0 22.63l3.67 3.67A110.45 110.45 0 0 0 21.2 352H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h5.2a110.19 110.19 0 0 0 8.65 20.89l-3.67 3.67a16 16 0 0 0 0 22.63l22.62 22.63a16 16 0 0 0 22.63 0l3.67-3.67A110.94 110.94 0 0 0 96 490.8v5.2a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-5.2a110.56 110.56 0 0 0 20.9-8.65l3.67 3.67a16 16 0 0 0 22.62 0l22.63-22.63a16 16 0 0 0 0-22.63l-3.67-3.67A110.45 110.45 0 0 0 234.8 416h5.2a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-112 96a64 64 0 1 1 64-64 64 64 0 0 1-64 64zm273-237.27a24 24 0 0 0 15 5.27h64a24 24 0 0 0 0-48h-55.59L351 109.27a24 24 0 0 0-30.62.51l-112 96a24 24 0 0 0 2.31 38.22L296 300.84V416a24 24 0 0 0 48 0V288a24 24 0 0 0-10.69-20l-43.23-28.82 70.73-60.63zM159.19 172a35.53 35.53 0 0 0 49.45 3.77l87.3-74.45c16.82-14.24 14.56-37 3.27-49.84C270 18.45 219 13.88 185.93 42L132.2 87.91a34.9 34.9 0 0 0-3.26 49.85zm57.88-93.5c9.92-8.42 24-9.35 35.65-3.43l-65.64 56-13.54-15.31z"
  ]
};
export const faBinoculars = {
  prefix: "far",
  iconName: "binoculars",
  icon: [
    512,
    512,
    [],
    "f1e5",
    "M511.67 388c-3.46-129.77-61.06-150.16-63.58-243.98-.48-17.65-14.28-32.02-31.93-32.02H416V64c0-17.67-14.33-32-32-32h-80c-17.67 0-32 14.33-32 32v48h-32V64c0-17.67-14.33-32-32-32h-80c-17.67 0-32 14.33-32 32v48h-.16c-17.65 0-31.45 14.38-31.93 32.02C61.39 237.84 3.79 258.23.33 388L0 432c0 26.51 21.49 48 48 48h128c26.51 0 48-21.49 48-48V288h64v144c0 26.51 21.49 48 48 48h128c26.51 0 48-21.49 48-48l-.33-44zM320 80h48v32h-48V80zm-176 0h48v32h-48V80zm32 352l-128 .36.31-43.08c1.61-60.24 16.07-91.47 31.39-124.54 13.05-28.17 27.67-59.73 31.4-104.74H176v272zm48-192v-80h64v80h-64zm112 192V160h64.9c3.73 45.01 18.35 76.58 31.4 104.74 15.32 33.07 29.78 64.3 31.37 123.61L464 432H336z"
  ]
};
export const faBiohazard = {
  prefix: "far",
  iconName: "biohazard",
  icon: [
    576,
    512,
    [],
    "f780",
    "M287.9 112c18.6 0 36.2 3.8 52.8 9.6 13.3-10.3 23.6-24.3 29.5-40.7-25.2-10.9-53-17-82.2-17-29.1 0-56.9 6-82.1 16.9 5.9 16.4 16.2 30.4 29.5 40.7 16.5-5.7 34-9.5 52.5-9.5zM163.6 438.7c12-11.8 20.4-26.4 24.5-42.4-32.9-26.4-54.8-65.3-58.9-109.6-8.5-2.8-17.2-4.6-26.4-4.6-7.6 0-15.2 1-22.5 3.1 4.1 62.8 35.8 118 83.3 153.5zm224.2-42.6c4.1 16 12.5 30.7 24.5 42.5 47.4-35.5 79.1-90.7 83-153.5-7.2-2-14.7-3-22.2-3-9.2 0-18 1.9-26.6 4.7-4.1 44.2-26 82.9-58.7 109.3zm113.5-205c-17.6-10.4-36.3-16.6-55.3-19.9 6-17.7 10-36.4 10-56.2 0-41-14.5-80.8-41-112.2-2.5-3-6.6-3.7-10-1.8-3.3 1.9-4.8 6-3.6 9.7 4.5 13.8 6.6 26.3 6.6 38.5 0 67.8-53.8 122.9-120 122.9S168 117 168 49.2c0-12.1 2.2-24.7 6.6-38.5 1.2-3.7-.3-7.8-3.6-9.7-3.4-1.9-7.5-1.2-10 1.8C134.6 34.2 120 74 120 115c0 19.8 3.9 38.5 10 56.2-18.9 3.3-37.7 9.5-55.3 19.9-34.6 20.5-61 53.3-74.3 92.4-1.3 3.7.2 7.7 3.5 9.8 3.3 2 7.5 1.3 10-1.6 9.4-10.8 19-19.1 29.2-25.1 57.3-33.9 130.8-13.7 163.9 45 33.1 58.7 13.4 134-43.9 167.9-10.2 6.1-22 10.4-35.8 13.4-3.7.8-6.4 4.2-6.4 8.1.1 4 2.7 7.3 6.5 8 39.7 7.8 80.6.8 115.2-19.7 18-10.6 32.9-24.5 45.3-40.1 12.4 15.6 27.3 29.5 45.3 40.1 34.6 20.5 75.5 27.5 115.2 19.7 3.8-.7 6.4-4 6.5-8 0-3.9-2.6-7.3-6.4-8.1-13.9-2.9-25.6-7.3-35.8-13.4-57.3-33.9-77-109.2-43.9-167.9s106.6-78.9 163.9-45c10.2 6.1 19.8 14.3 29.2 25.1 2.5 2.9 6.7 3.6 10 1.6s4.8-6.1 3.5-9.8c-13.1-39.1-39.5-72-74.1-92.4zm-213.4 129c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"
  ]
};
export const faBirthdayCake = {
  prefix: "far",
  iconName: "birthday-cake",
  icon: [
    448,
    512,
    [],
    "f1fd",
    "M192 64c0-31 32-23 32-64 12 0 32 29.5 32 56s-14.25 40-32 40-32-14.25-32-32zm160 32c17.75 0 32-13.5 32-40S364 0 352 0c0 41-32 33-32 64 0 17.75 14.25 32 32 32zm96 176v240H0V272c0-26.5 21.5-48 48-48h24V112h48v112h80V112h48v112h80V112h48v112h24c26.5 0 48 21.5 48 48zm-400 6v56.831c8.352 7 15.27 13.169 26.75 13.169 25.378 0 30.13-32 74.75-32 43.974 0 49.754 32 74.5 32 25.588 0 30.061-32 74.75-32 44.473 0 49.329 32 74.75 32 11.258 0 18.135-6.18 26.5-13.187v-56.805a6 6 0 0 0-6-6L54 272a6 6 0 0 0-6 6zm352 186v-80.87c-7.001 2.914-15.54 4.87-26.5 4.87-44.544 0-49.389-32-74.75-32-25.144 0-30.329 32-74.75 32-43.974 0-49.755-32-74.5-32-25.587 0-30.062 32-74.75 32-11.084 0-19.698-1.974-26.75-4.911V464h352zM96 96c17.75 0 32-13.5 32-40S108 0 96 0c0 41-32 33-32 64 0 17.75 14.25 32 32 32z"
  ]
};
export const faBlanket = {
  prefix: "far",
  iconName: "blanket",
  icon: [
    512,
    512,
    [],
    "f498",
    "M440 368H112c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h328c39.8 0 71.7-32.5 71.6-72.4l.4.4V88c0-48.5-39.5-88-88-88H88C39.5 0 0 39.5 0 88v304l.3-.5c0 8.4.5 17 2.3 25.7C14.1 473.3 66.2 512 123.4 512H496c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16H120c-42.2 0-76-36.5-71.6-79.5C52.2 347 86.6 320 124.3 320H440c13.2 0 24 10.8 24 24s-10.8 24-24 24zm-4.3-96H120c-27 0-51.9 9.2-72 24.3V88c0-22.1 17.9-40 40-40h336c22.1 0 40 17.9 40 40v189.3c-8.9-3.4-18.4-5.3-28.3-5.3z"
  ]
};
export const faBlender = {
  prefix: "far",
  iconName: "blender",
  icon: [
    512,
    512,
    [],
    "f517",
    "M425.91 330.01L512 0H48C21.49 0 0 21.49 0 48v160c0 26.51 21.49 48 48 48h102.26l6.17 70.99C121.06 341.14 96 375.57 96 416v64c0 17.67 14.33 32 32 32h320c17.67 0 32-14.33 32-32v-64c0-37.92-22.17-70.39-54.09-85.99zM48 208V48h84.17l13.91 160H48zM449.87 48l-12.52 48H296c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h133l-16.7 64H296c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h107.96l-25.04 96H204.01L180.36 48h269.51zM432 464H144v-48c0-26.47 21.53-48 48-48h192c26.47 0 48 21.53 48 48v48zm-144-72c-13.26 0-24 10.74-24 24 0 13.25 10.74 24 24 24s24-10.75 24-24c0-13.26-10.74-24-24-24z"
  ]
};
export const faBlenderPhone = {
  prefix: "far",
  iconName: "blender-phone",
  icon: [
    576,
    512,
    [],
    "f6b6",
    "M352 392c-13.26 0-24 10.74-24 24 0 13.25 10.74 24 24 24s24-10.75 24-24c0-13.26-10.74-24-24-24zm137.91-61.99L576 0H192l28.43 326.99C185.06 341.14 160 375.57 160 416v64c0 17.67 14.33 32 32 32h320c17.67 0 32-14.33 32-32v-64c0-37.92-22.17-70.39-54.09-85.99zM513.87 48l-12.52 48H360c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h133l-16.7 64H360c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h107.96l-25.04 96H268.01L244.36 48h269.51zM496 464H208v-48c0-26.47 21.53-48 48-48h192c26.47 0 48 21.53 48 48v48zM115.78 122.61c7.43.73 14.46-3.46 17.24-10.26l25.78-63.26c3.02-7.39.2-15.85-6.68-20.07l-39.28-24.1C98.51-3.87 80.09-.5 68.95 11.97c-92.57 103.6-92 259.55 2.1 362.49 9.87 10.8 29.12 12.48 41.65 4.8l39.41-24.18c6.88-4.22 9.7-12.67 6.68-20.07l-25.78-63.26c-2.78-6.81-9.8-10.99-17.24-10.26l-45.03 4.42c-17.28-46.94-17.65-99.78 0-147.72l45.04 4.42z"
  ]
};
export const faBlind = {
  prefix: "far",
  iconName: "blind",
  icon: [
    384,
    512,
    [],
    "f29d",
    "M192.913 510.276c-12.325 4.929-26.281-1.079-31.196-13.37l-50.539-126.341 22.976-71.801 72.129 180.316c4.923 12.307-1.063 26.274-13.37 31.196zM96 0C71.699 0 52 19.699 52 44s19.699 44 44 44 44-19.699 44-44S120.301 0 96 0zm12.53 140.603a4.002 4.002 0 0 1 5.605.802L219.2 281.6c5.429 7.239 15.514 8.364 22.399 3.2 7.051-5.288 8.472-15.373 3.2-22.399l-120-160c-3.14-4.188-7.939-6.385-12.8-6.386L80 96v.009c-4.69.003-9.336 2.049-12.494 5.996L0 186.388v85.161c0 8.616 6.621 16.029 15.227 16.433C24.416 288.414 32 281.093 32 272v-74.388l32-40v176.64L17.142 480.679c-4.039 12.624 2.92 26.133 15.544 30.173 12.63 4.041 26.134-2.924 30.173-15.544L128 291.746V173.333l-20.275-27.132a4.003 4.003 0 0 1 .805-5.598zm274.307 359.245L252.28 284.813a24.013 24.013 0 0 1-12.67 9.96L369.161 508.15a8 8 0 0 0 10.989 2.687 7.998 7.998 0 0 0 2.687-10.989z"
  ]
};
export const faBlinds = {
  prefix: "far",
  iconName: "blinds",
  icon: [
    512,
    512,
    [],
    "f8fb",
    "M512,32V16A16,16,0,0,0,496,0H16A16,16,0,0,0,0,16V32A15.94,15.94,0,0,0,10.28,46.85L.07,158.55a16,16,0,0,0,9.65,16.09L.08,270.41a15.94,15.94,0,0,0,9.64,16.22L.08,382.41a15.94,15.94,0,0,0,9.64,16.22L.08,494.41a16,16,0,0,0,16,17.59H495.89a16,16,0,0,0,16-17.59l-9.64-95.78a15.93,15.93,0,0,0,9.64-16.22l-9.64-95.78a15.93,15.93,0,0,0,9.64-16.22l-9.64-95.77a16,16,0,0,0,9.65-16.09L501.72,46.85A15.94,15.94,0,0,0,512,32ZM58.38,48H120v80H51.06Zm-7,416,6.45-64H454.17l6.44,64ZM454.17,176l6.44,64H217.22a79.22,79.22,0,0,1,5.16,48H454.17l6.44,64H51.38l6.45-64h7.79a79.25,79.25,0,0,1,5.16-48H51.38l6.45-64H120v54.66a48,48,0,1,0,48,0V48H453.62l7.32,80H200v48Z"
  ]
};
export const faBlindsOpen = {
  prefix: "far",
  iconName: "blinds-open",
  icon: [
    512,
    512,
    [],
    "f8fc",
    "M16,352h64.4A79.24,79.24,0,0,1,64,304H21.35A16,16,0,0,0,6.17,314.94l-5.34,16A16,16,0,0,0,16,352Zm489.82-37.06A16,16,0,0,0,490.65,304H224a79.24,79.24,0,0,1-16.41,48H496a16,16,0,0,0,15.18-21.06Zm0,160A16,16,0,0,0,490.65,464H21.35A16,16,0,0,0,6.17,474.94l-5.34,16A16,16,0,0,0,16,512H496a16,16,0,0,0,15.18-21.06Zm0-320A16,16,0,0,0,490.65,144H200v48H496a16,16,0,0,0,15.18-21.06ZM496,0H16A16,16,0,0,0,0,16V32A16,16,0,0,0,16,48H120v96H21.35A16,16,0,0,0,6.17,154.94l-5.34,16A16,16,0,0,0,16,192H120v70.66a48,48,0,1,0,48,0V48H496a16,16,0,0,0,16-16V16A16,16,0,0,0,496,0Z"
  ]
};
export const faBlindsRaised = {
  prefix: "far",
  iconName: "blinds-raised",
  icon: [
    512,
    512,
    [],
    "f8fd",
    "M512,32V16A16,16,0,0,0,496,0H16A16,16,0,0,0,0,16V32A15.94,15.94,0,0,0,10.28,46.85L.07,158.55a16,16,0,0,0,9.65,16.09L.08,270.41a16,16,0,0,0,16,17.59H120V422.66a48,48,0,1,0,48,0V48H453.62l7.32,80H200v48H454.17l6.45,64H200v48H495.89a16,16,0,0,0,16-17.59l-9.64-95.77a16,16,0,0,0,9.65-16.09L501.72,46.85A15.94,15.94,0,0,0,512,32ZM51.38,240l6.45-64H120v64ZM120,128H51.06l7.32-80H120Z"
  ]
};
export const faBlog = {
  prefix: "far",
  iconName: "blog",
  icon: [
    512,
    512,
    [],
    "f781",
    "M208.8 96c-9.1-.7-16.8 7-16.8 16.2v16c0 8.6 6.8 15.3 15.4 15.8 85.3 5.9 153.2 75.3 160.4 160.7.7 8.5 7.3 15.2 15.8 15.2h16.2c9.1 0 16.8-7.7 16.2-16.8-8.3-110.4-96.7-198.9-207.2-207.1zm-.1-96C199.6-.4 192 7.2 192 16.3v16c0 8.6 6.8 15.3 15.4 15.8C345.6 55.8 457.2 166.4 464 304.5c.4 8.6 7.2 15.5 15.8 15.5h16c9.1 0 16.7-7.6 16.3-16.7C503.5 139.9 372.1 8.5 208.7 0zM137 224h-9c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h10.9c47 0 88 38.4 84.9 85.3-2.6 39.9-34.6 71.8-74.4 74.5C102.4 451 64 410 64 362.9V112c0-8.8-7.2-16-16-16H16c-8.8 0-16 7.2-16 16v249c0 82.6 66.5 153.7 149 150.9 75.4-2.6 136.3-63.5 138.9-138.9 2.9-82.5-68.3-149-150.9-149z"
  ]
};
export const faBold = {
  prefix: "far",
  iconName: "bold",
  icon: [
    384,
    512,
    [],
    "f032",
    "M314.52 238.78A119.76 119.76 0 0 0 232 32H48a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16v352H48a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h208a128 128 0 0 0 128-128c0-49.49-28.38-91.92-69.48-113.22zM128 80h88a72 72 0 0 1 0 144h-88zm112 352H128V272h112a80 80 0 0 1 0 160z"
  ]
};
export const faBolt = {
  prefix: "far",
  iconName: "bolt",
  icon: [
    384,
    512,
    [],
    "f0e7",
    "M377.8 167.9c-8.2-14.3-23.1-22.9-39.6-22.9h-94.4l28.7-87.5c3.7-13.8.8-28.3-7.9-39.7C255.8 6.5 242.5 0 228.2 0H97.7C74.9 0 55.4 17.1 52.9 37.1L.5 249.3c-1.9 13.8 2.2 27.7 11.3 38.2C20.9 298 34.1 304 48 304h98.1l-34.9 151.7c-3.2 13.7-.1 27.9 8.6 38.9 8.7 11.1 21.8 17.4 35.9 17.4 16.3 0 31.5-8.8 38.8-21.6l183.2-276.7c8.4-14.3 8.4-31.5.1-45.8zM160.1 457.4L206.4 256H47.5L97.7 48l127.6-.9L177.5 193H334L160.1 457.4z"
  ]
};
export const faBomb = {
  prefix: "far",
  iconName: "bomb",
  icon: [
    512,
    512,
    [],
    "f1e2",
    "M384.5 144.5l56-56-17-17-56 56-52.2-52.2c-6.2-6.2-16.4-6.2-22.6 0l-28.4 28.4c-17.9-5-36.8-7.7-56.3-7.7C93.1 96 0 189.1 0 304s93.1 208 208 208 208-93.1 208-208c0-19.5-2.7-38.4-7.7-56.3l28.4-28.4c6.2-6.2 6.2-16.4 0-22.6l-52.2-52.2zm-30 89.1c7.9 28.2 13.5 43.9 13.5 70.4 0 88.4-71.6 160-160 160S48 392.4 48 304s71.6-160 160-160c26.3 0 41.4 5.4 70.4 13.5l25.6-25.6 76.1 76.1-25.6 25.6zM512 72c0 6.6-5.4 12-12 12h-24c-6.6 0-12-5.4-12-12s5.4-12 12-12h24c6.6 0 12 5.4 12 12zm-60-60v24c0 6.6-5.4 12-12 12s-12-5.4-12-12V12c0-6.6 5.4-12 12-12s12 5.4 12 12zm5 43c-4.7-4.7-4.7-12.3 0-17l17-17c4.7-4.7 12.3-4.7 17 0 4.7 4.7 4.7 12.3 0 17l-17 17c-4.7 4.7-12.3 4.7-17 0zm-67.9-16.9c-4.7-4.7-4.7-12.3 0-17 4.7-4.7 12.3-4.7 17 0l17 17c4.7 4.7 4.7 12.3 0 17-4.7 4.7-12.3 4.7-17 0l-17-17zm101.8 67.8c4.7 4.7 4.7 12.3 0 17-4.7 4.7-12.3 4.7-17 0l-17-17c-4.7-4.7-4.7-12.3 0-17 4.7-4.7 12.3-4.7 17 0l17 17zM216 208c0 13.3-10.7 24-24 24-30.9 0-56 25.1-56 56 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-57.3 46.7-104 104-104 13.3 0 24 10.7 24 24z"
  ]
};
export const faBone = {
  prefix: "far",
  iconName: "bone",
  icon: [
    640,
    512,
    [],
    "f5d7",
    "M640 183.23C640 135.14 598.38 96 547.19 96c-39.72 0-75 23.73-87.84 59.06C458.23 158.3 452.72 176 448 176H192c-4.72 0-10.23-17.7-11.34-20.94C167.81 119.73 132.53 96 92.81 96 41.62 96 0 135.14 0 183.23c0 29.45 8.09 53.34 32.34 72.77C7.93 275.57 0 299.54 0 328.77 0 376.86 41.62 416 92.81 416c39.72 0 75-23.73 87.84-59.05 1.09-3.23 6.89-20.95 11.34-20.95h256c4.45 0 10.25 17.73 11.34 20.95 12.84 35.31 48.12 59.05 87.84 59.05 51.19 0 92.81-39.14 92.81-87.23 0-29.23-7.93-53.19-32.34-72.77 24.27-19.43 32.36-43.31 32.36-72.77zm-72.06 104.3c19.34 8.88 24.06 23.12 24.06 41.23 0 21.64-20.09 39.23-44.81 39.23-19.59 0-36.75-11.02-42.72-27.41C494.42 310.66 483.78 288 448 288H192c-35.78 0-46.42 22.66-56.47 52.59-5.97 16.39-23.12 27.41-42.72 27.41C68.09 368 48 350.41 48 328.77c0-18.12 4.72-32.36 24.06-41.23 12.62-5.81 20.5-17.89 20.5-31.53s-7.84-25.7-20.5-31.53C52.28 215.39 48 200.72 48 183.23 48 161.59 68.09 144 92.81 144c19.59 0 36.75 11.02 42.72 27.42C154.17 225.19 176.64 224 192 224h256c15.36 0 37.83 1.19 56.47-52.58 5.97-16.41 23.12-27.42 42.72-27.42 24.72 0 44.81 17.59 44.81 39.23 0 17.48-4.28 32.16-24.06 41.23-12.66 5.83-20.5 17.89-20.5 31.53s7.87 25.73 20.5 31.54z"
  ]
};
export const faBoneBreak = {
  prefix: "far",
  iconName: "bone-break",
  icon: [
    640,
    512,
    [],
    "f5d8",
    "M640 87.23C640 39.14 598.37 0 547.19 0c-39.72 0-75 23.73-87.84 59.06C458.23 62.3 452.72 80 448 80h-80c-26.51 0-48 21.49-48 48h128c15.36 0 37.83 1.19 56.47-52.58C510.44 59.02 527.59 48 547.19 48 571.91 48 592 65.59 592 87.23c0 17.48-4.28 32.16-24.06 41.23-12.66 5.83-20.5 17.89-20.5 31.53s7.88 25.72 20.5 31.53c19.34 8.88 24.06 23.12 24.06 41.23 0 21.64-20.09 39.23-44.81 39.23-19.59 0-36.75-11.02-42.72-27.41C494.42 214.66 483.78 192 448 192h-16c-26.51 0-48 21.49-48 48h64c4.45 0 10.25 17.73 11.34 20.95 12.84 35.31 48.12 59.05 87.84 59.05 51.19 0 92.81-39.14 92.81-87.23 0-29.23-7.93-53.19-32.34-72.77C631.91 140.57 640 116.69 640 87.23zM234.24 323.01c-10.86 10.86-27.6 25.91-2.75 77.11 7.38 15.82 3.04 35.74-10.82 49.6-17.48 17.48-44.13 19.25-59.43 3.95-12.36-12.36-19.71-25.77-12.14-46.17 4.83-13.07 1.85-27.15-7.8-36.79s-23.76-12.62-36.79-7.8c-19.95 7.4-33.36.67-46.17-12.14-15.3-15.3-13.53-41.95 3.95-59.43 13.85-13.85 33.78-18.2 49.59-10.83 28.27 14.06 51.82 22.56 77.12-2.74l58.45-58.45c18.74-18.74 18.74-49.14 0-67.88l-92.38 92.38c-3.15 3.15-19.79-5.28-22.84-6.79-34.05-15.89-75.78-7.72-103.87 20.36-36.2 36.19-37.95 93.3-3.95 127.31 20.67 20.67 43.22 32 74.32 28.58-3.41 30.89 7.76 53.5 28.58 74.32 34.01 34.01 91.12 32.25 127.31-3.94 28.09-28.09 36.25-69.82 20.35-103.88-1.5-3.07-10.12-19.49-6.78-22.83l26.44-26.44c18.75-18.75 18.75-49.14 0-67.88l-60.39 60.38z"
  ]
};
export const faBong = {
  prefix: "far",
  iconName: "bong",
  icon: [
    448,
    512,
    [],
    "f55c",
    "M443.31 217.37l-52.69-52.69c-6.25-6.25-16.38-6.25-22.63 0l-11.31 11.31c-6.25 6.25-6.25 16.38 0 22.63l9.38 9.38-39.41 39.41c-11.56-11.37-24.53-21.33-38.65-29.51V47.74l15.97-.02c8.82-.01 15.97-7.16 15.98-15.98l.04-15.72C320 7.17 312.82-.01 303.97 0L80.03.26c-8.82.01-15.97 7.16-15.98 15.98l-.04 15.73c-.01 8.85 7.17 16.02 16.02 16.01L96 47.96v169.93C38.67 251.1 0 312.97 0 384c0 43.81 14.8 84.07 39.52 116.35C45.34 507.96 54.73 512 64.31 512h255.37c9.58 0 18.97-4.04 24.79-11.65C369.21 468.07 384 427.8 384 384c0-36.12-10.08-69.81-27.44-98.62L400 241.94l9.38 9.38c6.25 6.25 16.38 6.25 22.63 0l11.3-11.32c6.25-6.25 6.25-16.38 0-22.63zm-323.25 42.06L144 245.56V47.99h96v197.57l23.94 13.87c24.81 14.37 44.12 35.73 56.56 60.57h-257c12.45-24.84 31.75-46.2 56.56-60.57zM311.53 464H72.47C56.43 440.25 48 412.77 48 384c0-5.39.47-10.71 1.07-16h285.85c.6 5.29 1.07 10.61 1.07 16 .01 28.77-8.42 56.25-24.46 80z"
  ]
};
export const faBook = {
  prefix: "far",
  iconName: "book",
  icon: [
    448,
    512,
    [],
    "f02d",
    "M128 152v-32c0-4.4 3.6-8 8-8h208c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H136c-4.4 0-8-3.6-8-8zm8 88h208c4.4 0 8-3.6 8-8v-32c0-4.4-3.6-8-8-8H136c-4.4 0-8 3.6-8 8v32c0 4.4 3.6 8 8 8zm299.1 159.7c-4.2 13-4.2 51.6 0 64.6 7.3 1.4 12.9 7.9 12.9 15.7v16c0 8.8-7.2 16-16 16H80c-44.2 0-80-35.8-80-80V80C0 35.8 35.8 0 80 0h352c8.8 0 16 7.2 16 16v368c0 7.8-5.5 14.2-12.9 15.7zm-41.1.3H80c-17.6 0-32 14.4-32 32 0 17.7 14.3 32 32 32h314c-2.7-17.3-2.7-46.7 0-64zm6-352H80c-17.7 0-32 14.3-32 32v278.7c9.8-4.3 20.6-6.7 32-6.7h320V48z"
  ]
};
export const faBookAlt = {
  prefix: "far",
  iconName: "book-alt",
  icon: [
    448,
    512,
    [],
    "f5d9",
    "M435.1 399.7c-4.2 13-4.2 51.6 0 64.6 7.3 1.4 12.9 7.9 12.9 15.7v16c0 8.8-7.2 16-16 16H80c-44.2 0-80-35.8-80-80V80C0 35.8 35.8 0 80 0h352c8.8 0 16 7.2 16 16v368c0 7.8-5.5 14.2-12.9 15.7zm-41.1.3H80c-17.6 0-32 14.4-32 32 0 17.7 14.3 32 32 32h314c-2.7-17.3-2.7-46.7 0-64zm6-352H80c-17.7 0-32 14.3-32 32v278.7c9.8-4.3 20.6-6.7 32-6.7h320V48z"
  ]
};
export const faBookDead = {
  prefix: "far",
  iconName: "book-dead",
  icon: [
    448,
    512,
    [],
    "f6b7",
    "M128.3 297.64l4.31 16.24c1.19 4.48 5.52 7.07 9.67 5.79L240 289.56l97.71 30.11c4.15 1.28 8.48-1.31 9.67-5.79l4.31-16.24c1.19-4.48-1.21-9.16-5.37-10.44L296.99 272l49.33-15.2c4.16-1.28 6.56-5.95 5.37-10.44l-4.31-16.24c-1.19-4.48-5.52-7.07-9.67-5.79L240 254.44l-97.71-30.11c-4.15-1.28-8.48 1.31-9.67 5.79l-4.31 16.24c-1.19 4.48 1.21 9.16 5.37 10.44l49.33 15.2-49.33 15.2c-4.16 1.28-6.57 5.95-5.38 10.44zM192 194.91V208c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16v-13.09c19.32-11.68 32-30.04 32-50.91 0-35.35-35.82-64-80-64s-80 28.65-80 64c0 20.87 12.68 39.23 32 50.91zM272 128c8.84 0 16 7.16 16 16s-7.16 16-16 16-16-7.16-16-16 7.16-16 16-16zm-64 0c8.84 0 16 7.16 16 16s-7.16 16-16 16-16-7.16-16-16 7.16-16 16-16zm240 256V16c0-8.8-7.2-16-16-16H80C35.8 0 0 35.8 0 80v352c0 44.2 35.8 80 80 80h352c8.8 0 16-7.2 16-16v-16c0-7.8-5.6-14.3-12.9-15.7-4.2-13-4.2-51.6 0-64.6 7.4-1.5 12.9-7.9 12.9-15.7zm-54 80H80c-17.7 0-32-14.3-32-32 0-17.6 14.4-32 32-32h314c-2.7 17.3-2.7 46.7 0 64zm6-112H80c-11.4 0-22.2 2.4-32 6.7V80c0-17.7 14.3-32 32-32h320v304z"
  ]
};
export const faBookHeart = {
  prefix: "far",
  iconName: "book-heart",
  icon: [
    448,
    512,
    [],
    "f499",
    "M448 384V16c0-8.8-7.2-16-16-16H80C35.8 0 0 35.8 0 80v352c0 44.2 35.8 80 80 80h352c8.8 0 16-7.2 16-16v-16c0-7.8-5.6-14.3-12.9-15.7-4.2-13-4.2-51.6 0-64.6 7.4-1.5 12.9-7.9 12.9-15.7zm-54 80H80c-17.7 0-32-14.3-32-32 0-17.6 14.4-32 32-32h314c-2.7 17.3-2.7 46.7 0 64zm6-112H80c-11.4 0-22.2 2.4-32 6.7V80c0-17.7 14.3-32 32-32h320v304zm-184.5-67.5c4.7 4.6 12.3 4.6 17 0l72.6-71.3c21.1-20.7 19.8-55.1-3.7-74.2s-54.3-10.6-70 4.8l-7.4 7.3-7.4-7.3c-15.3-15.1-46.2-24.1-70-4.8-23.6 19.1-24.8 53.5-3.7 74.2l72.6 71.3z"
  ]
};
export const faBookMedical = {
  prefix: "far",
  iconName: "book-medical",
  icon: [
    448,
    512,
    [],
    "f7e6",
    "M448 384V16a16 16 0 0 0-16-16H80A80 80 0 0 0 0 80v352a80 80 0 0 0 80 80h352a16 16 0 0 0 16-16v-16a16 16 0 0 0-12.9-15.7c-4.2-13-4.2-51.6 0-64.6A16 16 0 0 0 448 384zm-54 80H80a32 32 0 0 1 0-64h314c-2.7 17.3-2.7 46.7 0 64zm6-112H80a79.37 79.37 0 0 0-32 6.7V80a32 32 0 0 1 32-32h320zM136 224h56v56a8 8 0 0 0 8 8h48a8 8 0 0 0 8-8v-56h56a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8h-56v-56a8 8 0 0 0-8-8h-48a8 8 0 0 0-8 8v56h-56a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8z"
  ]
};
export const faBookOpen = {
  prefix: "far",
  iconName: "book-open",
  icon: [
    640,
    512,
    [],
    "f518",
    "M561.91 0C549.44 0 406.51 6.49 320 56.89 233.49 6.49 90.56 0 78.09 0 35.03 0 0 34.34 0 76.55v313.72c0 40.73 32.47 74.3 73.92 76.41 36.78 1.91 128.81 9.5 187.73 38.69 8.19 4.05 17.25 6.29 26.34 6.58v.05h64.02v-.05c9.09-.29 18.15-2.53 26.34-6.58 58.92-29.19 150.95-36.78 187.73-38.69C607.53 464.57 640 431 640 390.27V76.55C640 34.34 604.97 0 561.91 0zM296 438.15c0 11.09-10.96 18.91-21.33 14.96-64.53-24.54-153.96-32.07-198.31-34.38-15.9-.8-28.36-13.3-28.36-28.46V76.55C48 60.81 61.5 48 78.06 48c19.93.1 126.55 7.81 198.53 40.49 11.63 5.28 19.27 16.66 19.28 29.44L296 224v214.15zm296-47.88c0 15.16-12.46 27.66-28.36 28.47-44.35 2.3-133.78 9.83-198.31 34.38-10.37 3.94-21.33-3.87-21.33-14.96V224l.14-106.08c.02-12.78 7.65-24.15 19.28-29.44C435.4 55.81 542.02 48.1 561.94 48 578.5 48 592 60.81 592 76.55v313.72z"
  ]
};
export const faBookReader = {
  prefix: "far",
  iconName: "book-reader",
  icon: [
    512,
    512,
    [],
    "f5da",
    "M459.91 192.02c-.7 0-1.39.02-2.06.05-49.8 2.84-140.51 13-201.84 47.57-61.33-34.57-152.05-44.73-201.84-47.57-.67-.04-1.36-.05-2.06-.05C31.71 192.01 0 206.36 0 242.22v178.05c0 26.69 21.25 48.7 48.34 50.12 34.41 1.81 120.56 9.08 177 37.47 5.47 2.77 11.34 4.14 17.19 4.14h26.94c5.84 0 11.72-1.37 17.19-4.14 56.44-28.39 142.59-35.65 177-37.47 27.09-1.42 48.34-23.44 48.34-50.12V242.22c0-35.86-31.71-50.2-52.09-50.2zM232 458.43c-60.63-25.8-138.17-33.71-181.14-35.97-1.71-.09-2.86-1.21-2.86-2.19l-.46-178.45c.76-.76 3.29-1.74 3.88-1.84 35.86 2.04 125.09 10.18 180.58 41.26v177.19zm232-38.16c0 .98-1.15 2.1-2.87 2.19-42.94 2.26-120.43 10.16-181.13 35.98v-177.2c55.32-30.98 144.17-39.16 179.93-41.22 1.4.13 3.78 1.09 4.07 2.2v178.05zM256 191.99c53.02 0 96-42.98 96-95.99S309.02 0 256 0s-96 42.98-96 95.99 42.98 96 96 96zM256 48c26.47 0 48 21.53 48 48s-21.53 48-48 48-48-21.53-48-48 21.53-48 48-48z"
  ]
};
export const faBookSpells = {
  prefix: "far",
  iconName: "book-spells",
  icon: [
    448,
    512,
    [],
    "f6b8",
    "M448 384V16c0-8.8-7.2-16-16-16H80C35.8 0 0 35.8 0 80v352c0 44.2 35.8 80 80 80h352c8.8 0 16-7.2 16-16v-16c0-7.8-5.6-14.3-12.9-15.7-4.2-13-4.2-51.6 0-64.6 7.4-1.5 12.9-7.9 12.9-15.7zm-54 80H80c-17.7 0-32-14.3-32-32 0-17.6 14.4-32 32-32h314c-2.7 17.3-2.7 46.7 0 64zm6-112H80c-11.4 0-22.2 2.4-32 6.7V80c0-17.7 14.3-32 32-32h320v304zm-154.66-85.33L272 320l26.66-53.33L352 240l-53.34-26.67L272 160l-26.66 53.33L192 240l53.34 26.67zM160 200l18.66-37.33L216 144l-37.34-18.67L160 88l-18.67 37.33L104 144l37.33 18.67L160 200z"
  ]
};
export const faBookUser = {
  prefix: "far",
  iconName: "book-user",
  icon: [
    448,
    512,
    [],
    "f7e7",
    "M240 208a64 64 0 1 0-64-64 64 64 0 0 0 64 64zm208 176V16a16 16 0 0 0-16-16H80A80 80 0 0 0 0 80v352a80 80 0 0 0 80 80h352a16 16 0 0 0 16-16v-16a16 16 0 0 0-12.9-15.7c-4.2-13-4.2-51.6 0-64.6A16 16 0 0 0 448 384zm-54 80H80a32 32 0 0 1 0-64h314c-2.7 17.3-2.7 46.7 0 64zm6-112H80a79.37 79.37 0 0 0-32 6.7V80a32 32 0 0 1 32-32h320zm-256-32h192a16 16 0 0 0 16-16v-22.4c0-31.81-30.09-57.6-67.2-57.6h-4.95a103.25 103.25 0 0 1-79.7 0h-5c-37.11 0-67.2 25.79-67.2 57.6V304A16 16 0 0 0 144 320z"
  ]
};
export const faBookmark = {
  prefix: "far",
  iconName: "bookmark",
  icon: [
    384,
    512,
    [],
    "f02e",
    "M336 0H48C21.49 0 0 21.49 0 48v464l192-112 192 112V48c0-26.51-21.49-48-48-48zm0 428.43l-144-84-144 84V54a6 6 0 0 1 6-6h276c3.314 0 6 2.683 6 5.996V428.43z"
  ]
};
export const faBooks = {
  prefix: "far",
  iconName: "books",
  icon: [
    576,
    512,
    [],
    "f5db",
    "M575.46 454.59L458.55 11.86c-2.28-8.5-11.1-13.59-19.6-11.31L423.5 4.68c-7.54 2.02-12.37 9.11-11.83 16.53-11.47 7.42-64.22 21.55-77.85 20.86-3.24-6.69-10.97-10.42-18.5-8.4L304 36.7V32c0-17.67-14.33-32-40-32H24C14.33 0 0 14.33 0 32v448c0 17.67 14.33 32 24 32h240c25.67 0 40-14.33 40-32V115.94l101.45 384.2c2.28 8.5 11.1 13.59 19.6 11.31l15.46-4.14c7.54-2.02 12.37-9.11 11.83-16.52 11.47-7.42 64.21-21.55 77.85-20.86 3.24 6.69 10.97 10.42 18.5 8.4l15.46-4.14c8.49-2.28 13.58-11.1 11.31-19.6zM128 464H48v-48h80v48zm0-96H48V144h80v224zm0-272H48V48h80v48zm128 368h-80v-48h80v48zm0-96h-80V144h80v224zm0-272h-80V48h80v48zm185.98 355.01L344.74 81.69c16.76-1.8 60.74-13.39 77.28-20.71l97.24 369.32c-16.76 1.81-60.74 13.4-77.28 20.71z"
  ]
};
export const faBooksMedical = {
  prefix: "far",
  iconName: "books-medical",
  icon: [
    640,
    512,
    [],
    "f7e8",
    "M256 256a128 128 0 1 0-128 128 128 128 0 0 0 128-128zm-149.33 58.67v-37.34H69.33A5.33 5.33 0 0 1 64 272v-32a5.33 5.33 0 0 1 5.33-5.33h37.34v-37.34A5.33 5.33 0 0 1 112 192h32a5.33 5.33 0 0 1 5.33 5.33v37.34h37.34A5.33 5.33 0 0 1 192 240v32a5.33 5.33 0 0 1-5.33 5.33h-37.34v37.34A5.33 5.33 0 0 1 144 320h-32a5.33 5.33 0 0 1-5.33-5.33zm532.79 139.92L522.55 11.86A16 16 0 0 0 503 .55l-15.5 4.13a16 16 0 0 0-11.83 16.53c-11.47 7.42-64.22 21.55-77.85 20.86a16 16 0 0 0-18.5-8.4L368 36.7V32c0-17.67-14.33-32-40-32H88c-9.67 0-24 14.33-24 32v77.56c14.91-6.56 31.14-10.24 48-11.94V48h80v61.56A160.44 160.44 0 0 1 242 144h78v224h-78a160.44 160.44 0 0 1-50 34.44V464h-80v-49.62c-16.86-1.7-33.09-5.4-48-11.94V480c0 17.67 14.33 32 24 32h240c25.67 0 40-14.33 40-32V115.94l101.45 384.2a16 16 0 0 0 19.6 11.31l15.46-4.14a16 16 0 0 0 11.83-16.52c11.47-7.42 64.21-21.55 77.85-20.86a16 16 0 0 0 18.5 8.4l15.46-4.14a16.06 16.06 0 0 0 11.31-19.6zM320 464h-80v-48h80zm0-368h-80V48h80zm186 355L408.74 81.69C425.5 79.89 469.48 68.3 486 61l97.26 369.3c-16.76 1.81-60.74 13.4-77.26 20.7z"
  ]
};
export const faBoombox = {
  prefix: "far",
  iconName: "boombox",
  icon: [
    640,
    512,
    [],
    "f8a5",
    "M448 432a96 96 0 1 0-96-96 96 96 0 0 0 96 96zm144-272V56a56.06 56.06 0 0 0-56-56H104a56.07 56.07 0 0 0-56 56v104a48 48 0 0 0-48 48v256a48 48 0 0 0 48 48h544a48 48 0 0 0 48-48V208a48 48 0 0 0-48-48zM96 56a8 8 0 0 1 8-8h432a8 8 0 0 1 8 8v104h-96v-16a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v16h-32v-16a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v16h-32v-16a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v16H96zm496 408H48V208h544zm-400-32a96 96 0 1 0-96-96 96 96 0 0 0 96 96z"
  ]
};
export const faBoot = {
  prefix: "far",
  iconName: "boot",
  icon: [
    512,
    512,
    [],
    "f782",
    "M415 263.8L352 248V144c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H32C14.3 0 0 14.3 0 32v434.7c0 8.5 3.4 16.6 9.4 22.6L32 512h64l32-32 32 32h64l32-32 32 32h64l32-32 32 32h64l22.6-22.6c6-6 9.4-14.1 9.4-22.6V388c0-58.8-40-110-97-124.2zM48 48h288v48H48V48zm416 368H48V144h256v48h-72c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h72v32h-72c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h82.1l89.3 22.3c35.7 8.9 60.6 40.8 60.6 77.6V416z"
  ]
};
export const faBoothCurtain = {
  prefix: "far",
  iconName: "booth-curtain",
  icon: [
    512,
    512,
    [],
    "f734",
    "M0 32v464c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V48h56v328c0 39.7 32.3 72 72 72 16.3 0 31.7-5.5 44-15 24.7 19.1 63.3 19.1 88 0 24.7 19.1 63.3 19.1 88 0 12.3 9.5 27.7 15 44 15 8.5 0 16.5-1.7 24-4.4V496c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V24c0-13.2-10.8-24-24-24H32C14.3 0 0 14.3 0 32zm152 16h312v328c0 13.2-10.8 24-24 24-9.5 0-18.2-5.7-22-14.5-7.6-17.5-36.4-17.5-44 0-7.6 17.6-36.4 17.6-44 0-7.6-17.5-36.4-17.5-44 0-7.6 17.6-36.4 17.6-44 0-3.8-8.8-12.4-14.4-22-14.4s-18.2 5.7-22 14.4c-3.8 8.8-12.5 14.5-22 14.5-13.2 0-24-10.8-24-24V48z"
  ]
};
export const faBorderAll = {
  prefix: "far",
  iconName: "border-all",
  icon: [
    448,
    512,
    [],
    "f84c",
    "M416 32H32A32 32 0 0 0 0 64v384a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32V64a32 32 0 0 0-32-32zm-16 48v152H248V80zm-200 0v152H48V80zM48 432V280h152v152zm200 0V280h152v152z"
  ]
};
export const faBorderBottom = {
  prefix: "far",
  iconName: "border-bottom",
  icon: [
    448,
    512,
    [],
    "f84d",
    "M432 432H16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zM112 88h24a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16zm0 196h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16zm100 0h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16zm100 0h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16zM212 184h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16zm100-96h24a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16zm-100 0h24a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16zm0 296h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16zm220-156h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16zm0 100h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16zm0-200h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16zm0-96h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM16 384h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16zm0-200h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16zm0-96h24a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16H16A16 16 0 0 0 0 48v24a16 16 0 0 0 16 16zm0 196h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16z"
  ]
};
export const faBorderCenterH = {
  prefix: "far",
  iconName: "border-center-h",
  icon: [
    448,
    512,
    [],
    "f89c",
    "M432 232H16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zM112 88h24a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16zm0 392h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16zm100 0h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16zm100 0h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16zM212 184h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16zm100-96h24a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16zm-100 0h24a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16zm0 296h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16zm220 40h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16zm0-96h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16zm0-200h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16zm0-96h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM16 384h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16zm0-200h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16zm0-96h24a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16H16A16 16 0 0 0 0 48v24a16 16 0 0 0 16 16zm0 392h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16z"
  ]
};
export const faBorderCenterV = {
  prefix: "far",
  iconName: "border-center-v",
  icon: [
    448,
    512,
    [],
    "f89d",
    "M248 464V48a16 16 0 0 0-16-16h-16a16 16 0 0 0-16 16v416a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16zm144-320v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16h-24a16 16 0 0 0-16 16zM0 144v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16zm0 100v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16zm0 100v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16zm296-100v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16h-24a16 16 0 0 0-16 16zm96 100v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16h-24a16 16 0 0 0-16 16zm0-100v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16h-24a16 16 0 0 0-16 16zm-296 0v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16h-24a16 16 0 0 0-16 16zM56 464v-24a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16zm96 0v-24a16 16 0 0 0-16-16h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16zm200 0v-24a16 16 0 0 0-16-16h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16zm96 0v-24a16 16 0 0 0-16-16h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16zM96 48v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-24a16 16 0 0 0-16 16zm200 0v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-24a16 16 0 0 0-16 16zm96 0v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-24a16 16 0 0 0-16 16zM0 48v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16H16A16 16 0 0 0 0 48z"
  ]
};
export const faBorderInner = {
  prefix: "far",
  iconName: "border-inner",
  icon: [
    448,
    512,
    [],
    "f84e",
    "M432 232H248V48a16 16 0 0 0-16-16h-16a16 16 0 0 0-16 16v184H16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h184v184a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16V280h184a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zM40 424H16a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16zM16 184h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16zm24 144H16a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16zm72-240h24a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16zm-96 0h24a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16H16A16 16 0 0 0 0 48v24a16 16 0 0 0 16 16zm296 0h24a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16zm120 240h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16zm-296 96h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16zM432 32h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm0 96h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16zm-96 296h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16zm96 0h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16z"
  ]
};
export const faBorderLeft = {
  prefix: "far",
  iconName: "border-left",
  icon: [
    448,
    512,
    [],
    "f84f",
    "M32 32H16A16 16 0 0 0 0 48v416a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm204 392h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16zm0-96h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16zm0-200h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16zM136 32h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm100 0h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM136 424h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16zm0-196h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16zm100 0h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16zm196-100h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16zm0 100h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16zm0-196h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm-96 392h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16zm96-96h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16zm-96-100h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16zm96 196h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16zM336 32h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
  ]
};
export const faBorderNone = {
  prefix: "far",
  iconName: "border-none",
  icon: [
    448,
    512,
    [],
    "f850",
    "M336 228h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16zm96 0h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16zm-296 0h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16zm200 196h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16zm96 0h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16zm0-96h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16zm0-200h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16zM136 424h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16zm100-196h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16zm0 196h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16zm0-96h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16zm0-200h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16zm0-96h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm100 0h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm96 0h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM40 228H16a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16zm0 196H16a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16zm0-96H16a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16zm0-200H16a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16zm0-96H16A16 16 0 0 0 0 48v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm96 0h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
  ]
};
export const faBorderOuter = {
  prefix: "far",
  iconName: "border-outer",
  icon: [
    448,
    512,
    [],
    "f851",
    "M416 32H32A32 32 0 0 0 0 64v384a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32V64a32 32 0 0 0-32-32zm-16 400H48V80h352zM212 184h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16zm100 100h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16zm-200 0h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16zm100 0h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16zm0 100h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16z"
  ]
};
export const faBorderRight = {
  prefix: "far",
  iconName: "border-right",
  icon: [
    448,
    512,
    [],
    "f852",
    "M432 32h-16a16 16 0 0 0-16 16v416a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM40 32H16A16 16 0 0 0 0 48v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm96 0h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm0 392h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16zm0-196h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16zM40 128H16a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16zm0 296H16a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16zm0-196H16a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16zm0 100H16a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16zm296 96h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16zm-100 0h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16zm100-196h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16zm0-196h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm-100 0h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm0 96h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16zm0 200h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16zm0-100h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16z"
  ]
};
export const faBorderStyle = {
  prefix: "far",
  iconName: "border-style",
  icon: [
    448,
    512,
    [],
    "f853",
    "M432 32H32A32 32 0 0 0 0 64v400a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16V80h384a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM236 424h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16zm-100 0h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16zm200 0h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16zm96-196h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16zm0 100h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16zm0-200h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16zm0 296h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16z"
  ]
};
export const faBorderStyleAlt = {
  prefix: "far",
  iconName: "border-style-alt",
  icon: [
    448,
    512,
    [],
    "f854",
    "M432 32h-16a16 16 0 0 0-16 16v384H16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h400a32 32 0 0 0 32-32V48a16 16 0 0 0-16-16zM312 88h24a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16zm-100 0h24a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16zM16 384h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16zm0-100h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16zm96-196h24a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16zm-96 96h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16zm0-96h24a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16H16A16 16 0 0 0 0 48v24a16 16 0 0 0 16 16z"
  ]
};
export const faBorderTop = {
  prefix: "far",
  iconName: "border-top",
  icon: [
    448,
    512,
    [],
    "f855",
    "M432 32H16A16 16 0 0 0 0 48v16a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM136 424h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16zm0-196h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16zm100 196h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16zM40 228H16a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16zm0 196H16a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16zm0-96H16a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16zm0-200H16a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16zm196 200h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16zm100 96h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16zm96-196h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16zm0-100h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16zM236 228h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16zm196 100h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16zM236 128h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16zm196 296h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16zm-96-196h-24a16 16 0 0 0-16 16v24a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-24a16 16 0 0 0-16-16z"
  ]
};
export const faBowArrow = {
  prefix: "far",
  iconName: "bow-arrow",
  icon: [
    512,
    512,
    [],
    "f6b9",
    "M145.78 286.65l33.94-33.9-99.54-99.42c33.83-24.46 74.26-37.85 116.85-37.85 34.01 0 66.7 8.5 95.73 24.37l34.96-34.91c-38.88-24.21-83.72-37.4-130.69-37.4-55.44 0-107.96 18.26-151.12 51.56l-7.28-7.27c-6.25-6.24-16.38-6.24-22.63 0l-11.31 11.3c-6.25 6.24-6.25 16.36 0 22.6l141.09 140.92zM493.2.3L364.62 25.98c-12.29 2.45-16.88 17.6-8.02 26.45l34.47 34.42-250.63 250.33-49.7-16.55c-1.93-.64-12.39-3.68-21.03 4.96l-63.68 63.6c-10.8 10.79-6.46 29.17 8.04 33.99l55.65 18.53 18.55 55.58c2.99 8.97 11.19 14.05 19.57 14.05 5.14 0 10.36-1.92 14.47-6.02l63.67-63.59a20.51 20.51 0 0 0 4.97-21.01l-16.57-49.64L425 120.75l34.46 34.42c8.92 8.91 24.04 4.2 26.48-8.01l25.72-128.43C514.02 7 503.46-1.74 493.2.3zM116.27 454.85l-14.93-44.72-44.78-14.91 32.92-32.88 44.78 14.91 14.93 44.72-32.92 32.88zM455.64 94.86L417 56.26l48.3-9.65-9.66 48.25zm-48.57 89l-34.96 34.91c16.19 29.21 24.9 62.14 24.9 96.45 0 42.53-13.42 82.9-37.91 116.69L258.9 331.83l-33.94 33.9 141.75 141.58c6.25 6.24 16.38 6.24 22.62 0l11.31-11.3c6.25-6.24 6.25-16.36 0-22.6l-7.28-7.27c33.35-43.1 51.64-95.55 51.64-150.92.01-47.23-13.36-92.33-37.93-131.36z"
  ]
};
export const faBowlingBall = {
  prefix: "far",
  iconName: "bowling-ball",
  icon: [
    496,
    512,
    [],
    "f436",
    "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-96-296c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm112-32c0-17.7-14.3-32-32-32s-32 14.3-32 32 14.3 32 32 32 32-14.3 32-32zm-16 64c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"
  ]
};
export const faBowlingPins = {
  prefix: "far",
  iconName: "bowling-pins",
  icon: [
    496,
    512,
    [],
    "f437",
    "M491 308.2c-13.4-54-49.4-87.4-53.8-132-3-30.5 21.4-53.1 18.8-95.8C453.1 34 419.5.1 376 0c-43.4.1-77 34-79.9 80.5-2.8 42.7 21.7 65.3 18.7 95.8-4.4 44.5-40.5 78.1-53.7 131.9-13 52.5.3 140.1 29.1 191.5l6.9 12.3h158.1l6.9-12.3c28.6-51.4 41.9-139.1 28.9-191.5zM408.1 83.5c1.5 24.2-14.9 43.4-18.4 76.6h-27.4c-3.5-33.4-19.9-52.2-18.4-76.6 3-47.5 61.2-47.5 64.2 0zm18.1 380.4H325.9c-18.8-42.2-27.4-107-18.2-144.2 10.7-43.1 43.5-75 52.9-127.7h31c9.4 52.7 42.2 84.6 52.9 127.7 9.1 37.2.4 102-18.3 144.2zm-245-287.6c-3-30.5 21.4-53.1 18.7-95.8C197 34 163.4.2 119.9.1 76.5.2 42.9 34 40 80.5c-2.7 42.8 21.8 65.2 18.7 95.8C54.3 221 18.4 254.2 5 308.2c-13 52.5.3 140.2 29 191.5l6.9 12.3H199l6.9-12.3c28.7-51.3 42-139 29-191.5-13.3-54-49.3-87.2-53.7-131.9zM152 83.5c1.5 24.3-14.9 43.2-18.4 76.5h-27.4c-3.5-33.5-19.9-52-18.4-76.5 3.1-47.4 61.3-47.4 64.2 0zM170.1 464H69.8C51 421.7 42.4 356.9 51.6 319.7c10.6-43 43.4-74.8 52.9-127.7h30.9c9.5 53 42.3 84.7 52.9 127.8 9.2 37.2.6 101.9-18.2 144.2z"
  ]
};
export const faBox = {
  prefix: "far",
  iconName: "box",
  icon: [
    512,
    512,
    [],
    "f466",
    "M509.5 184.6L458.9 32.8C452.4 13.2 434.1 0 413.4 0H98.6c-20.7 0-39 13.2-45.5 32.8L2.5 184.6c-1.6 4.9-2.5 10-2.5 15.2V464c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V199.8c0-5.2-.8-10.3-2.5-15.2zm-48.1 7.4H280V48h133.4l48 144zM98.6 48H232v144H50.6l48-144zM48 464V240h416v224H48z"
  ]
};
export const faBoxAlt = {
  prefix: "far",
  iconName: "box-alt",
  icon: [
    448,
    512,
    [],
    "f49a",
    "M447.9 176c0-10.6-2.6-21-7.6-30.3l-49.1-91.9c-4.3-13-16.5-21.8-30.3-21.8H87.1c-13.8 0-26 8.8-30.4 21.9L7.6 145.8c-5 9.3-7.6 19.7-7.6 30.3C.1 236.6 0 448 0 448c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32 0 0-.1-211.4-.1-272zm-97.1-96l42.8 80H278.4l-24-80h96.4zM97.2 80h96.4l-24 80H54.4l42.8-80zM48 432c0-42.3.1-157.9.1-224H160v64c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16v-64h111.9c0 66.1 0 181.8.1 224H48z"
  ]
};
export const faBoxBallot = {
  prefix: "far",
  iconName: "box-ballot",
  icon: [
    576,
    512,
    [],
    "f735",
    "M573.8 282.5L520 148.3c-4.8-12.3-16.6-20.3-29.8-20.3H448V32c0-17.7-14.3-32-32-32H160c-17.7 0-32 14.3-32 32v96H85.8c-13.2 0-25 8.1-29.8 20.3L2.2 282.4C.8 286.1 0 290 0 294l.2 185.9c-.1 17.7 14.3 32.2 32 32.2h511.6c17.7 0 32.1-14.4 32-32.2L576 294c0-4-.8-7.9-2.2-11.5zM176 48h224v144H176V48zM96.7 176H128v64h320v-64h31.3L520 280H55.9l40.8-104zM48.3 464l.7-136h478l.8 136H48.3z"
  ]
};
export const faBoxCheck = {
  prefix: "far",
  iconName: "box-check",
  icon: [
    640,
    512,
    [],
    "f467",
    "M492.5 133.4L458.9 32.8C452.4 13.2 434.1 0 413.4 0H98.6c-20.7 0-39 13.2-45.5 32.8L2.5 184.6c-1.6 4.9-2.5 10-2.5 15.2V464c0 26.5 21.5 48 48 48h400c106 0 192-86 192-192 0-90.7-63-166.5-147.5-186.6zM280 48h133.4l26.8 80.4c-49.8 2-94.7 22.7-127.7 55.6H280V48zM98.6 48H232v136H53.3L98.6 48zM48 464V232h229.5c-13.6 26.4-21.5 56.3-21.5 88 0 57.4 25.3 108.8 65.3 144H48zm400 0c-79.4 0-144-64.6-144-144s64.6-144 144-144 144 64.6 144 144-64.6 144-144 144zm64.6-205.7c-3.1-3.1-8.1-3.1-11.2 0l-69.9 69.3-30.3-30.6c-3.1-3.1-8.1-3.1-11.2 0l-18.7 18.6c-3.1 3.1-3.1 8.1 0 11.2l54.4 54.9c3.1 3.1 8.1 3.1 11.2 0l94.2-93.5c3.1-3.1 3.1-8.1 0-11.2l-18.5-18.7z"
  ]
};
export const faBoxFragile = {
  prefix: "far",
  iconName: "box-fragile",
  icon: [
    512,
    512,
    [],
    "f49b",
    "M448 0H64C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zm16 448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h384c8.8 0 16 7.2 16 16v384zM336 96h-43.9l22.9 36.4-64 32 37 59.6-91-68.4 64-32L236.4 96H176c-8.8 0-16 7.2-16 16v97.6c0 44.7 30.7 81.6 72 92.3V368h-24c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16h-24v-66.1c41.3-10.7 72-47.6 72-92.3V112c0-8.8-7.2-16-16-16z"
  ]
};
export const faBoxFull = {
  prefix: "far",
  iconName: "box-full",
  icon: [
    640,
    512,
    [],
    "f49c",
    "M638.3 239.8L586.8 137c-4-8.1-12.1-9.5-16.7-8.9l-50.7 6.5L541.5 74c3.7-10 3.2-20.9-1.3-30.6-4.5-9.7-12.5-17-22.6-20.7L462.1 2.4c-20.7-7.6-43.7 3.2-51.3 23.9l-30.9 84.9C365 47.5 308.2 0 240 0 164.7 0 103.6 58 97.2 131.6l-27.4-3.5c-4.6-.6-12.6.9-16.7 8.9L1.7 239.8c-4.6 9.2.3 20.2 10.1 23L64 277.7V425c0 14.7 10 27.5 24.2 31l216.2 54.1c13.6 3.4 25 1.5 31 0L551.8 456c14.2-3.6 24.2-16.4 24.2-31V277.7l52.1-14.9c9.9-2.8 14.7-13.8 10.2-23zM453.2 50.3L493.7 65l-27.8 76.4-48.2 6.1 35.5-97.2zM61.7 227.2L86 178.6l154.8 19.7-41.2 68.3-137.9-39.4zM296 458.5l-184-46V291.4l97.8 27.9c8 2.3 15.2-1.8 18.5-7.3L296 199.8v258.7zm38.6-300.4L320 160l-175.4-22.3C148 87.7 189.2 48 240 48c52.9 0 96 43.1 96 96 0 4.8-.7 9.5-1.4 14.1zM528 412.5l-184 46V199.8l67.7 112.3c3.3 5.5 10.6 9.6 18.5 7.3l97.8-27.9v121zm-87.7-145.9l-41.2-68.3L554 178.6l24.3 48.6-138 39.4z"
  ]
};
export const faBoxHeart = {
  prefix: "far",
  iconName: "box-heart",
  icon: [
    448,
    512,
    [],
    "f49d",
    "M301.3 243c-23.5-19.1-54.3-10.6-70 4.8l-7.4 7.3-7.4-7.3c-15.3-15.1-46.2-24.1-70-4.8-23.6 19.1-24.8 53.5-3.7 74.2l72.6 71.3c4.7 4.6 12.3 4.6 17 0l72.6-71.3c21.1-20.7 19.9-55.1-3.7-74.2zm146.6-67c0-10.6-2.6-21-7.6-30.3l-49.1-91.9c-4.3-13-16.5-21.8-30.3-21.8H87.1c-13.8 0-26 8.8-30.4 21.9L7.6 145.8c-5 9.3-7.6 19.7-7.6 30.3C.1 236.6 0 448 0 448c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32 0 0-.1-211.4-.1-272zM248 80h102.8l34.2 64H248V80zM97.2 80H200v64H63l34.2-64zM48 432c0-36.5.1-163.5.1-240h351.8c0 76.5.1 203.5.1 240H48z"
  ]
};
export const faBoxOpen = {
  prefix: "far",
  iconName: "box-open",
  icon: [
    640,
    512,
    [],
    "f49e",
    "M638.3 143.8L586.8 41c-4-8-12.1-9.5-16.7-8.9L320 64 69.8 32.1c-4.6-.6-12.6.9-16.6 8.9L1.7 143.8c-4.6 9.2.3 20.2 10.1 23L64 181.7V393c0 14.7 10 27.5 24.2 31l216.2 54.1c6 1.5 17.4 3.4 31 0L551.8 424c14.2-3.6 24.2-16.4 24.2-31V181.7l52.1-14.9c9.9-2.8 14.7-13.8 10.2-23zM86 82.6l154.8 19.7-41.2 68.3-138-39.4L86 82.6zm26 112.8l97.8 27.9c8 2.3 15.2-1.8 18.5-7.3L296 103.8v322.7l-184-46V195.4zm416 185.1l-184 46V103.8l67.7 112.3c3.3 5.5 10.6 9.6 18.5 7.3l97.8-27.9v185zm-87.7-209.9l-41.2-68.3L554 82.6l24.3 48.6-138 39.4z"
  ]
};
export const faBoxTissue = {
  prefix: "far",
  iconName: "box-tissue",
  icon: [
    512,
    512,
    [],
    "e05b",
    "M480,208H410.67L448,96H338.6A70.2,70.2,0,0,1,272,48,70.19,70.19,0,0,0,205.4,0H64l46.22,208H32A32,32,0,0,0,0,240V480a32,32,0,0,0,32,32H480a32,32,0,0,0,32-32V240A32,32,0,0,0,480,208ZM205.4,48a22.16,22.16,0,0,1,21.06,15.18A118.06,118.06,0,0,0,338.6,144h42.8l-48,144H177.17L123.84,48ZM48,256h72.89L128,288H112a16,16,0,0,0-16,16v16a16,16,0,0,0,16,16H400a16,16,0,0,0,16-16V304a16,16,0,0,0-16-16H384l10.67-32H464V368H48ZM464,464H48V416H464Z"
  ]
};
export const faBoxUp = {
  prefix: "far",
  iconName: "box-up",
  icon: [
    512,
    512,
    [],
    "f49f",
    "M400 368H112c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h288c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zM448 0H64C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zm16 448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h384c8.8 0 16 7.2 16 16v384zM358.2 99c-3.1-3.8-9.4-3.8-12.5 0l-64 80c-4.2 5.3-.4 13 6.2 13h32v112c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V192h32c6.7 0 10.4-7.7 6.2-13l-63.9-80zM128 192v112c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V192h32c6.7 0 10.4-7.7 6.2-13l-64-80c-3.1-3.8-9.4-3.8-12.5 0l-64 80c-4.2 5.3-.4 13 6.2 13H128z"
  ]
};
export const faBoxUsd = {
  prefix: "far",
  iconName: "box-usd",
  icon: [
    448,
    512,
    [],
    "f4a0",
    "M447.9 176c0-10.6-2.6-21-7.6-30.3l-49.1-91.9c-4.3-13-16.5-21.8-30.3-21.8H87.1c-13.8 0-26 8.8-30.4 21.9L7.6 145.8c-5 9.3-7.6 19.7-7.6 30.3C.1 236.6 0 448 0 448c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32 0 0-.1-211.4-.1-272zM248 80h102.8l34.2 64H248V80zM97.2 80H200v64H63l34.2-64zM48 432c0-36.5.1-163.5.1-240h351.8c0 76.5.1 203.5.1 240H48zm201.3-129.7l-42.2-11.4c-4.2-1.1-7.1-4.5-7.1-8.3 0-4.8 4.5-8.7 10.1-8.7h26.3c4.1 0 8.2 1 11.8 3 3.1 1.7 6.8 1.4 9.2-1.2l12.1-12.7c3.1-3.3 2.6-8.6-1.1-11.2-8.3-5.7-18.1-8.9-28.3-9.5V232c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v10.2c-22.2 1.1-40 18.6-40 40.3 0 18.2 12.6 34.3 30.7 39.2l42.2 11.4c4.2 1.1 7.1 4.5 7.1 8.3 0 4.8-4.5 8.7-10.1 8.7h-26.3c-4.1 0-8.2-1-11.8-3-3.1-1.7-6.8-1.4-9.2 1.2L178.6 361c-3.1 3.3-2.6 8.6 1.1 11.2 8.3 5.7 18.1 8.9 28.3 9.5V392c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-10.2c22.2-1.1 40-18.6 40-40.3 0-18.2-12.6-34.3-30.7-39.2z"
  ]
};
export const faBoxes = {
  prefix: "far",
  iconName: "boxes",
  icon: [
    640,
    512,
    [],
    "f468",
    "M592 224H480V48c0-26.5-21.5-48-48-48H208c-26.5 0-48 21.5-48 48v176H48c-26.5 0-48 21.5-48 48v192c0 26.5 21.5 48 48 48h544c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48zM208 48h64v90.7l48-21.3 48 21.3V48h64v176H208V48zm88 416H48V272h80v90.7l48-21.3 48 21.3V272h72v192zm296 0H344V272h72v90.7l48-21.3 48 21.3V272h80v192z"
  ]
};
export const faBoxesAlt = {
  prefix: "far",
  iconName: "boxes-alt",
  icon: [
    640,
    512,
    [],
    "f4a1",
    "M592 224H480V48c0-26.5-21.5-48-48-48H208c-26.5 0-48 21.5-48 48v176H48c-26.5 0-48 21.5-48 48v192c0 26.5 21.5 48 48 48h544c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48zM208 48h80v72c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V48h80v176H208V48zm88 416H48V272h96v72c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-72h88v192zm296 0H344V272h88v72c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-72h96v192z"
  ]
};
export const faBoxingGlove = {
  prefix: "far",
  iconName: "boxing-glove",
  icon: [
    448,
    512,
    [],
    "f438",
    "M252.4 360.8l7.2 14.3c2 4 .4 8.8-3.6 10.7L227.8 400l28.2 14.1c4 2 5.6 6.8 3.6 10.7l-7.2 14.3c-2 4-6.8 5.6-10.7 3.6L192 417.9l-49.7 24.8c-4 2-8.8.4-10.7-3.6l-7.2-14.3c-2-4-.4-8.8 3.6-10.7l28.2-14.1-28.2-14.1c-4-2-5.6-6.8-3.6-10.7l7.2-14.3c2-4 6.8-5.6 10.7-3.6l49.7 24.8 49.7-24.8c3.9-2 8.7-.4 10.7 3.5zM448 229.5c0 55.7-23.3 110.2-63.9 149.6L368 394.7v77.9c0 21.8-17.9 39.5-40 39.5H72c-22.1 0-40-17.7-40-39.5v-82.8l-17-102C5 229.5 0 170 0 111 0 49.8 50.8 0 113.2 0H288c61.8 0 112 49.8 112 111v33.2c28.8 18.1 48 49.5 48 85.3zm-48 0c0-29.5-25.1-53.5-56-53.5h-31.3c-21.5 0-40.2 17.6-40.7 39.1-.5 20.2 14.2 37.2 33.4 40.4 3.8.6 6.6 4 6.6 7.9v32.3c0 4.7-4.1 8.4-8.8 8-44.4-4.4-79.2-42-79.2-87.6 0-8.4 1.6-16.3 3.7-24h-70.5c-30.6 0-59.5-10.9-82.3-30.8-3.5-3.1-3.7-8.4-.4-11.7l11.3-11.3c3-3 7.7-3.1 10.9-.4 16.9 14.4 38.1 22.3 60.5 22.3h87.4c16.2-19.4 40.2-32 67.3-32h32c10.2 0 8 6 8-17 0-35.3-28.1-63-64-63H113.2C77.2 48 48 76.2 48 111c0 95.9 11.4 151 31.4 273H104c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H80v48h240v-48h-24c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h24c0-6.2 2.5-12.1 6.9-16.4l23.8-23.1c31.8-30.7 49.3-71.6 49.3-115z"
  ]
};
export const faBrackets = {
  prefix: "far",
  iconName: "brackets",
  icon: [
    448,
    512,
    [],
    "f7e9",
    "M128 32H32A32 32 0 0 0 0 64v384a32 32 0 0 0 32 32h96a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16H48V80h80a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm288 0h-96a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h80v352h-80a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h96a32 32 0 0 0 32-32V64a32 32 0 0 0-32-32z"
  ]
};
export const faBracketsCurly = {
  prefix: "far",
  iconName: "brackets-curly",
  icon: [
    576,
    512,
    [],
    "f7ea",
    "M208 32h-88a56 56 0 0 0-56 56v77.49a40 40 0 0 1-11.72 28.29L7 239a24 24 0 0 0 0 34l45.24 45.24A40 40 0 0 1 64 346.52V424a56 56 0 0 0 56 56h88a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16h-88a8 8 0 0 1-8-8v-77.48a88.06 88.06 0 0 0-25.78-62.24L57.93 256l28.29-28.28A88.06 88.06 0 0 0 112 165.48V88a8 8 0 0 1 8-8h88a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm361 207l-45.25-45.24A40.07 40.07 0 0 1 512 165.48V88a56 56 0 0 0-56-56h-88a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h88a8 8 0 0 1 8 8v77.48a88 88 0 0 0 25.78 62.24L518.06 256l-28.28 28.28A88 88 0 0 0 464 346.52V424a8 8 0 0 1-8 8h-88a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h88a56 56 0 0 0 56-56v-77.49a40 40 0 0 1 11.72-28.29L569 273a24 24 0 0 0 0-34z"
  ]
};
export const faBraille = {
  prefix: "far",
  iconName: "braille",
  icon: [
    640,
    512,
    [],
    "f2a1",
    "M112 256c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zM64 392c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm0-344c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm160 184c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm0 160c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm0-344c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm224 184c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm0 160c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm0-344c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm160 184c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm0 160c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm0-320c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24z"
  ]
};
export const faBrain = {
  prefix: "far",
  iconName: "brain",
  icon: [
    544,
    512,
    [],
    "f5dc",
    "M511.9 228.2c1.9-7.5 2.9-15.2 2.9-23 0-33-16.7-63-43.7-80.6-.4-39.7-29.4-72.8-67.5-79.8C389.9 17.8 361.8 0 330.3 0c-22.8 0-43.4 9.2-58.3 24.1A82.316 82.316 0 0 0 213.7 0c-31.4 0-59.6 17.8-73.3 44.9-38.1 7-67.1 40.1-67.5 79.8-27.1 17.6-43.7 47.6-43.7 80.6 0 7.7 1 15.4 2.9 23C11.9 246.3 0 272.2 0 299.5c0 33 16.7 63 43.7 80.6.5 47.5 38.5 86.2 85.8 88.3 15.9 26.7 44.9 43.6 76.8 43.6 26 0 49.2-11.2 65.6-28.8 16.4 17.6 39.6 28.8 65.6 28.8 31.9 0 60.9-16.9 76.8-43.6 47.4-2 85.4-40.8 85.9-88.3 27-17.6 43.7-47.7 43.7-80.6.1-27.3-11.8-53.2-32-71.3zm-264 194.6c0 22.8-18.6 41.2-41.5 41.2-32.9 0-39.5-29.5-45.6-47.6l-20.3 3.4c-24 4-48.5-15.3-48.5-40.5 0-2.8 4.7-27.4 4.7-27.4l-18.2-7.5c-36.9-15.2-41.3-66.1-5.5-86.6l19.5-11.2-9.9-20.1C65 190.7 94 166 107.7 160.4l18.9-7.7c-5-21.9-5.5-22.8-5.5-27.2 0-18.8 15.3-34 31.9-34.1l22.9 1.2 4.8-18.9c3.9-15.1 17.4-25.6 32.9-25.6 18.9 0 34.2 15.2 34.2 34l.1 340.7zm217.7-78.5l-18.3 7.5s4.6 24.6 4.6 27.4c0 25.2-24.5 44.4-48.5 40.5l-20.3-3.4c-6.1 18.2-12.7 47.6-45.6 47.6-22.9 0-41.5-18.5-41.5-41.2V82c0-18.8 15.3-34 34.2-34 15.5 0 29.1 10.5 32.9 25.6l4.8 18.9 22.9-1.2c16.5.1 31.9 15.4 31.9 34.1 0 4.4-.4 5.3-5.5 27.2l18.9 7.7c13.7 5.6 42.7 30.2 25.1 65.9l-9.9 20.1 19.5 11.2c36.1 20.7 31.7 71.6-5.2 86.8z"
  ]
};
export const faBreadLoaf = {
  prefix: "far",
  iconName: "bread-loaf",
  icon: [
    640,
    512,
    [],
    "f7eb",
    "M400 32H240C107.45 32 0 103.63 0 192c0 35.35 26.86 64 60 64h4v192a32 32 0 0 0 32 32h448a32 32 0 0 0 32-32V256h4c33.14 0 60-28.65 60-64 0-88.37-107.45-160-240-160zm20 176h-52v224H112V208H60c-5.79 0-12-6.43-12-16 0-59.66 89.72-112 192-112s192 52.34 192 112c0 9.57-6.21 16-12 16z"
  ]
};
export const faBreadSlice = {
  prefix: "far",
  iconName: "bread-slice",
  icon: [
    576,
    512,
    [],
    "f7ec",
    "M288 0C110.12 0 0 93.77 0 180.66c0 37.74 26 66.42 64 73.54V480a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32V254.41c39.71-6.85 64-35.73 64-73.75C576 93.77 465.88 0 288 0zm215.84 207.11L464 208v256H112V208l-39.16-1C65.37 205.62 48 200.25 48 180.66 48 126.44 133.46 48 288 48s240 78.44 240 132.66c0 14.99-7.9 23.64-24.16 26.45z"
  ]
};
export const faBriefcase = {
  prefix: "far",
  iconName: "briefcase",
  icon: [
    512,
    512,
    [],
    "f0b1",
    "M464 128h-80V80c0-26.51-21.49-48-48-48H176c-26.51 0-48 21.49-48 48v48H48c-26.51 0-48 21.49-48 48v256c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V176c0-26.51-21.49-48-48-48zM176 80h160v48H176V80zM54 176h404c3.31 0 6 2.69 6 6v74H48v-74c0-3.31 2.69-6 6-6zm404 256H54c-3.31 0-6-2.69-6-6V304h144v24c0 13.25 10.75 24 24 24h80c13.25 0 24-10.75 24-24v-24h144v122c0 3.31-2.69 6-6 6z"
  ]
};
export const faBriefcaseMedical = {
  prefix: "far",
  iconName: "briefcase-medical",
  icon: [
    512,
    512,
    [],
    "f469",
    "M344 288h-56v-56c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v56h-56c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h56v56c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-56h56c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm120-160H352V80c0-26.5-21.5-48-48-48h-96c-26.5 0-48 21.5-48 48v48H48c-26.5 0-48 21.5-48 48v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48zM208 80h96v48h-96V80zm256 378c0 3.3-2.7 6-6 6H54c-3.3 0-6-2.7-6-6V182c0-3.3 2.7-6 6-6h404c3.3 0 6 2.7 6 6v276z"
  ]
};
export const faBringForward = {
  prefix: "far",
  iconName: "bring-forward",
  icon: [
    512,
    512,
    [],
    "f856",
    "M352 304V48a48 48 0 0 0-48-48H48A48 48 0 0 0 0 48v256a48 48 0 0 0 48 48h256a48 48 0 0 0 48-48zM48 48h256v256H48zm416 112h-80v48h80v256H208v-80h-48v80a48 48 0 0 0 48 48h256a48 48 0 0 0 48-48V208a48 48 0 0 0-48-48zM240 416a16 16 0 0 0 16 16h160a16 16 0 0 0 16-16V256a16 16 0 0 0-16-16h-32v144H240z"
  ]
};
export const faBringFront = {
  prefix: "far",
  iconName: "bring-front",
  icon: [
    640,
    512,
    [],
    "f857",
    "M480 368V144a48 48 0 0 0-48-48H208a48 48 0 0 0-48 48v224a48 48 0 0 0 48 48h224a48 48 0 0 0 48-48zM208 144h224v224H208zM48 48h160v16h48V48a48 48 0 0 0-48-48H48A48 48 0 0 0 0 48v160a48 48 0 0 0 48 48h80v-48H48zm544 208h-80v48h80v160H432v-16h-48v16a48 48 0 0 0 48 48h160a48 48 0 0 0 48-48V304a48 48 0 0 0-48-48zM96 160h32v-16a79.24 79.24 0 0 1 16.41-48H96zm448 192h-32v16a79.24 79.24 0 0 1-16.41 48H544z"
  ]
};
export const faBroadcastTower = {
  prefix: "far",
  iconName: "broadcast-tower",
  icon: [
    640,
    512,
    [],
    "f519",
    "M168.67 192c11 0 18.61-10.83 14.85-21.18-4.93-13.58-7.55-27.98-7.55-42.82s2.62-29.24 7.55-42.82C187.29 74.83 179.68 64 168.67 64h-17.73c-7.01 0-13.46 4.49-15.41 11.23C130.64 92.21 128 109.88 128 128c0 18.12 2.64 35.79 7.54 52.76 1.94 6.74 8.39 11.24 15.4 11.24h17.73zm-120.8-64c0-37.81 9.46-73.41 26.05-104.66C79.56 12.72 71.97 0 59.97 0H40.61c-6.27 0-12.13 3.59-14.73 9.31C8.22 48.13-1.31 91.41.15 137.12c1.24 38.89 10.78 75.94 26.53 109.73 2.62 5.63 8.41 9.14 14.61 9.14h18.87c12.02 0 19.6-12.74 13.94-23.37C57.43 201.39 47.87 165.84 47.87 128zM614.07 9.29C611.46 3.58 605.61 0 599.34 0h-19.43c-11.98 0-19.66 12.66-14.02 23.25 23.26 43.67 32.56 95.83 21.53 150.66-4.16 20.72-11.49 40.35-21.26 58.57-5.72 10.68 1.8 23.52 13.91 23.52h19.24c6.27 0 12.13-3.58 14.73-9.29C630.57 210.48 640 170.36 640 128s-9.42-82.48-25.93-118.71zM489.06 64h-17.73c-11.01 0-18.61 10.83-14.86 21.18 4.93 13.58 7.55 27.98 7.55 42.82s-2.62 29.24-7.55 42.82c-3.76 10.35 3.85 21.18 14.86 21.18h17.73c7.01 0 13.46-4.49 15.41-11.24 4.9-16.97 7.53-34.64 7.53-52.76 0-18.12-2.64-35.79-7.54-52.76-1.94-6.75-8.39-11.24-15.4-11.24zM372.7 187.76C389.31 173.1 400 151.89 400 128c0-44.18-35.82-80-80.01-80-5.52 0-10.92.56-16.12 1.62a79.525 79.525 0 0 0-28.61 12.04c-21.28 14.38-35.27 38.72-35.27 66.34 0 23.86 10.83 44.86 27.4 59.52L143.98 483.68c-3.4 8.16.46 17.52 8.62 20.92l14.78 6.16c8.16 3.4 17.53-.46 20.93-8.62L245.26 368h149.47l56.96 134.15c3.4 8.16 12.77 12.02 20.93 8.62l14.78-6.16c8.16-3.4 12.01-12.77 8.62-20.92L372.7 187.76zM320 96c17.65 0 32 14.36 32 32s-14.36 32-32 32-32-14.36-32-32 14.35-32 32-32zm-54.35 224l47.84-112.66c2.19.18 4.28.66 6.51.66 2.23 0 4.33-.48 6.52-.66L374.35 320h-108.7z"
  ]
};
export const faBroom = {
  prefix: "far",
  iconName: "broom",
  icon: [
    640,
    512,
    [],
    "f51a",
    "M636.52 31.02l-19.92-25c-5.5-6.9-15.57-8.05-22.49-2.56L363.38 181.38l-34.72-43.56c-4.82-6.05-14.03-6.02-18.81.06l-57.61 73.18c-31.09.74-103.98 6.65-151.87 44.66C38.28 304.99 0 511.31 0 511.31c15.1.66 212.37 7.35 272.15-40.1 47.71-37.87 70-107.39 77.79-137.63l84.34-39.52c7.02-3.29 9.13-12.28 4.29-18.35l-35.34-44.34 230.73-177.9c6.92-5.5 8.06-15.54 2.56-22.45zM242.27 433.73c-16.64 13.21-74.29 28.51-182.8 30.21 4.76-19.1 10.1-38.18 15.8-56.35l45.29-35.95c4.96-3.94 1.23-11.88-4.97-10.57l-26.06 5.5c13.43-35.28 27.73-63.05 40.72-73.36 27.04-21.46 71.32-31.04 109.74-33.53l59.81 75.03c-9.44 30.94-28.14 75.69-57.53 99.02zm88.06-143.88l-39.78-49.91 24.22-30.77c2.39-3.04 7-3.05 9.41-.03l43.77 54.91c2.42 3.03 1.37 7.53-2.15 9.17l-35.47 16.63z"
  ]
};
export const faBrowser = {
  prefix: "far",
  iconName: "browser",
  icon: [
    512,
    512,
    [],
    "f37e",
    "M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM48 92c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v24c0 6.6-5.4 12-12 12H60c-6.6 0-12-5.4-12-12V92zm416 334c0 3.3-2.7 6-6 6H54c-3.3 0-6-2.7-6-6V168h416v258zm0-310c0 6.6-5.4 12-12 12H172c-6.6 0-12-5.4-12-12V92c0-6.6 5.4-12 12-12h280c6.6 0 12 5.4 12 12v24z"
  ]
};
export const faBrush = {
  prefix: "far",
  iconName: "brush",
  icon: [
    384,
    512,
    [],
    "f55d",
    "M352 0H32C14.33 0 0 14.33 0 32v288c0 35.35 28.65 64 64 64h48v48c0 44.18 35.82 80 80 80s80-35.82 80-80v-48h48c35.35 0 64-28.65 64-64V32c0-17.67-14.33-32-32-32zm-16 48v176H48V48h288zm-16 288h-96v96c0 17.64-14.36 32-32 32s-32-14.36-32-32v-96H64c-8.82 0-16-7.18-16-16v-48h288v48c0 8.82-7.18 16-16 16z"
  ]
};
export const faBug = {
  prefix: "far",
  iconName: "bug",
  icon: [
    576,
    512,
    [],
    "f188",
    "M536 264h-64v-94.059l40.971-40.971c9.372-9.373 9.372-24.569 0-33.941-9.373-9.372-24.568-9.372-33.941 0L438.059 136H425C425 60.87 364.091 0 289 0c-75.13 0-136 60.909-136 136h-15.059l-40.97-40.971c-9.373-9.372-24.568-9.372-33.941 0-9.373 9.373-9.373 24.569 0 33.941L104 169.941V264H40c-13.255 0-24 10.745-24 24s10.745 24 24 24h64v24c0 29.275 7.91 56.733 21.694 80.365L71.029 471.03c-9.373 9.373-9.373 24.568 0 33.941 9.371 9.372 24.568 9.373 33.941 0l51.029-51.029C184.482 480.046 222.411 496 264 496h48c41.589 0 79.518-15.954 108.001-42.058l51.029 51.029c9.372 9.372 24.568 9.373 33.941 0 9.372-9.373 9.372-24.568 0-33.941l-54.665-54.665C464.09 392.734 472 365.275 472 336v-24h64c13.255 0 24-10.745 24-24s-10.745-24-24-24zM289 48c48.601 0 88 39.399 88 88H201c0-48.601 39.399-88 88-88zm23 400V260c0-6.627-5.373-12-12-12h-24c-6.627 0-12 5.373-12 12v188c-61.757 0-112-50.243-112-112V184h272v152c0 61.757-50.243 112-112 112z"
  ]
};
export const faBuilding = {
  prefix: "far",
  iconName: "building",
  icon: [
    448,
    512,
    [],
    "f1ad",
    "M128 148v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12zm140 12h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12zm-128 96h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12zm128 0h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12zm-76 84v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm76 12h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12zm180 124v36H0v-36c0-6.6 5.4-12 12-12h19.5V24c0-13.3 10.7-24 24-24h337c13.3 0 24 10.7 24 24v440H436c6.6 0 12 5.4 12 12zM79.5 463H192v-67c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v67h112.5V49L80 48l-.5 415z"
  ]
};
export const faBullhorn = {
  prefix: "far",
  iconName: "bullhorn",
  icon: [
    576,
    512,
    [],
    "f0a1",
    "M544 184.88V32.01C544 23.26 537.02 0 512.01 0H512c-7.12 0-14.19 2.38-19.98 7.02l-85.03 68.03C364.28 109.19 310.66 128 256 128H64c-35.35 0-64 28.65-64 64v96c0 35.35 28.65 64 64 64l-.48 32c0 39.77 9.26 77.35 25.56 110.94 5.19 10.69 16.52 17.06 28.4 17.06h106.28c26.05 0 41.69-29.84 25.9-50.56-16.4-21.52-26.15-48.36-26.15-77.44 0-11.11 1.62-21.79 4.41-32H256c54.66 0 108.28 18.81 150.98 52.95l85.03 68.03a32.023 32.023 0 0 0 19.98 7.02c24.92 0 32-22.78 32-32V295.13c19.05-11.09 32-31.49 32-55.12.01-23.64-12.94-44.04-31.99-55.13zM127.73 464c-10.76-25.45-16.21-52.31-16.21-80 0-14.22 1.72-25.34 2.6-32h64.91c-2.09 10.7-3.52 21.41-3.52 32 0 28.22 6.58 55.4 19.21 80h-66.99zM240 304H64c-8.82 0-16-7.18-16-16v-96c0-8.82 7.18-16 16-16h176v128zm256 110.7l-59.04-47.24c-42.8-34.22-94.79-55.37-148.96-61.45V173.99c54.17-6.08 106.16-27.23 148.97-61.46L496 65.3v349.4z"
  ]
};
export const faBullseye = {
  prefix: "far",
  iconName: "bullseye",
  icon: [
    496,
    512,
    [],
    "f140",
    "M248 104c-84.02 0-152 68-152 152 0 84.02 68 152 152 152 84.02 0 152-68 152-152 0-84.02-68-152-152-152zm0 256c-57.35 0-104-46.65-104-104s46.65-104 104-104 104 46.65 104 104-46.65 104-104 104zm0-352C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 448c-110.28 0-200-89.72-200-200S137.72 56 248 56s200 89.72 200 200-89.72 200-200 200zm0-256c-30.88 0-56 25.12-56 56s25.12 56 56 56 56-25.12 56-56-25.12-56-56-56z"
  ]
};
export const faBullseyeArrow = {
  prefix: "far",
  iconName: "bullseye-arrow",
  icon: [
    496,
    512,
    [],
    "f648",
    "M305.05 98.74l16.57 49.7-90.59 90.59c-9.38 9.38-9.38 24.56 0 33.94 9.37 9.37 24.56 9.38 33.94 0l90.59-90.59 49.7 16.57c7.39 2.46 15.53.54 21.04-4.96l63.67-63.67c10.8-10.8 6.46-29.2-8.04-34.04l-55.66-18.55-18.55-55.65c-4.83-14.5-23.23-18.84-34.04-8.04L310.02 77.7a20.582 20.582 0 0 0-4.97 21.04zM248 152c7.66 0 15.08.96 22.27 2.54l14.74-14.74-10.32-30.95c-.24-.73-.2-1.47-.41-2.21-8.57-1.5-17.28-2.65-26.29-2.65-84.02 0-152 68-152 152 0 84.02 68 152 152 152 84.02 0 152-68 152-152 0-9.03-1.15-17.75-2.65-26.34-.72-.21-1.49-.12-2.2-.36l-30.94-10.31-14.74 14.74c1.58 7.19 2.53 14.61 2.53 22.27 0 57.35-46.65 104-104 104s-104-46.65-104-104S190.65 152 248 152zm236.43 29.1l-35.5 35.5c-1.34 1.34-2.87 2.38-4.32 3.55 2.12 11.65 3.39 23.59 3.39 35.84 0 110.28-89.72 200-200 200s-200-89.72-200-200 89.72-200 200-200c12.34 0 24.37 1.28 36.1 3.43 1.16-1.42 1.98-3.04 3.3-4.36l35.5-35.5A248.155 248.155 0 0 0 248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248c0-26.11-4.09-51.26-11.57-74.9z"
  ]
};
export const faBullseyePointer = {
  prefix: "far",
  iconName: "bullseye-pointer",
  icon: [
    496,
    512,
    [],
    "f649",
    "M242.16 240.67L27.98 301.55c-15.17 4.31-16.95 25.1-2.73 31.92l68.47 32.89-89.17 89.17c-6.07 6.06-6.07 15.9 0 21.96l21.96 21.96c6.07 6.06 15.9 6.06 21.96 0l89.17-89.17 32.89 68.47c6.83 14.22 27.61 12.44 31.92-2.73l60.87-214.18c3.68-12.91-8.25-24.83-21.16-21.17zm27.36 117.03l-14.08 49.55C335.92 403.3 400 337.46 400 256c0-84.02-68-152-152-152-81.47 0-147.3 64.1-151.25 144.57l49.55-14.08C156.25 187.44 198.04 152 248 152c57.35 0 104 46.65 104 104 0 49.96-35.44 91.75-82.48 101.7zM248 8C111.03 8 0 119.03 0 256c0 7.3.47 14.49 1.09 21.63 3.46-1.97 7-3.87 10.99-5l36.24-10.3c-.07-2.12-.32-4.19-.32-6.33 0-110.28 89.72-200 200-200s200 89.72 200 200-89.72 200-200 200c-2.14 0-4.21-.25-6.33-.32l-10.3 36.24c-1.14 4.02-3.15 7.5-5.14 10.98 7.19.63 14.42 1.1 21.77 1.1 136.97 0 248-111.03 248-248S384.97 8 248 8z"
  ]
};
export const faBurgerSoda = {
  prefix: "far",
  iconName: "burger-soda",
  icon: [
    640,
    512,
    [],
    "f858",
    "M110.47 464L81.72 176H336a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16H206.74l20-80H272a16 16 0 0 0 16-16V16a16 16 0 0 0-16-16h-51.5a40 40 0 0 0-38.81 30.3L157.26 128H16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h17.48l30.57 306.29A31.88 31.88 0 0 0 96 512h160a31.56 31.56 0 0 0 10.11-1.94A115.79 115.79 0 0 1 238.3 464zM528 312a16 16 0 1 0-16-16 16 16 0 0 0 16 16zm-80-16a16 16 0 1 0-16-16 16 16 0 0 0 16 16zm192 80c0-12.92-6.53-23.88-16-31.19a71.86 71.86 0 0 0-5.11-74.32C585.46 222.87 518.41 192.06 448 192c-70.36.06-137.41 30.87-170.82 78.49a71.83 71.83 0 0 0-5.18 74.32c-9.51 7.31-16 18.27-16 31.19a39.64 39.64 0 0 0 12.65 28.91A59.64 59.64 0 0 0 264 428a84.09 84.09 0 0 0 84 84h200a84.09 84.09 0 0 0 84-84 59.64 59.64 0 0 0-4.65-23.09A39.64 39.64 0 0 0 640 376zm-323.56-77.95c22.77-32.45 72.89-58 131.56-58.05s108.8 25.6 131.57 58.06A24.07 24.07 0 0 1 559.84 336H336.17a24.07 24.07 0 0 1-19.73-37.95zM548 464H348a36 36 0 0 1-36-36 12 12 0 0 1 12-12h248a12 12 0 0 1 12 12 36 36 0 0 1-36 36zM368 312a16 16 0 1 0-16-16 16 16 0 0 0 16 16z"
  ]
};
export const faBurn = {
  prefix: "far",
  iconName: "burn",
  icon: [
    384,
    512,
    [],
    "f46a",
    "M192 0C86.2 93.5 0 214.4 0 298.1 0 424 79 512 192 512s192-88 192-213.9c0-84-87.3-205.6-192-298.1zm0 65.2c51.4 51.1 144 158.5 144 232.9 0 29.5-5.6 55.6-15.1 78.4-3.5-74.7-83.7-157.9-128.9-208.8-45.8 51.5-125.4 133.8-128.9 208.8-9.4-22.8-15.1-49-15.1-78.4 0-74.2 92.6-181.7 144-232.9zm-18.1 397c-38.1-7.5-63.4-38.7-63.4-81.1 0-20.6 13.5-64.6 81.5-141.1 68 76.5 81.5 120.5 81.5 141.1 0 42.4-25.3 73.7-63.4 81.1-20.9 2.4-15.4 2.4-36.2 0z"
  ]
};
export const faBurrito = {
  prefix: "far",
  iconName: "burrito",
  icon: [
    512,
    512,
    [],
    "f7ed",
    "M512 123a74.13 74.13 0 0 0-52.26-70.74A74.05 74.05 0 0 0 358.12 6.73a80.49 80.49 0 0 0-106 41.57L34 266.45a116 116 0 0 0 0 164.05L81.5 478a116 116 0 0 0 164.05 0L463.7 259.87a80.49 80.49 0 0 0 41.57-106A73.46 73.46 0 0 0 512 123zM163.52 464a67.54 67.54 0 0 1-48.08-19.92l-47.52-47.52a67.27 67.27 0 0 1-17.1-29.71A216.16 216.16 0 0 0 112 376c92.14 0 170.78-58.11 201.75-139.52a171.27 171.27 0 0 1 98.57 6.9l-200.7 200.7a67.55 67.55 0 0 1-48.1 19.92zM268.43 99.88A167.07 167.07 0 0 1 280 160c0 92.64-75.38 168-168 168a168 168 0 0 1-56.44-10.07 67.89 67.89 0 0 1 12.37-17.54z"
  ]
};
export const faBus = {
  prefix: "far",
  iconName: "bus",
  icon: [
    512,
    512,
    [],
    "f207",
    "M368 368c17.67 0 32-14.33 32-32s-14.33-32-32-32-32 14.33-32 32 14.33 32 32 32zm-224 0c17.67 0 32-14.33 32-32s-14.33-32-32-32-32 14.33-32 32 14.33 32 32 32zm344-240h-8V80c0-44.8-99.2-80-224-80S32 35.2 32 80v48h-8c-13.25 0-24 10.74-24 24v80c0 13.25 10.75 24 24 24h8v160c0 17.67 14.33 32 32 32v32c0 17.67 14.33 32 32 32h16c17.67 0 32-14.33 32-32v-32h224v32c0 17.67 14.33 32 32 32h16c17.67 0 32-14.33 32-32v-32c17.67 0 32-14.33 32-32V256h8c13.25 0 24-10.75 24-24v-80c0-13.26-10.75-24-24-24zm-56 272H80V272h352v128zm0-176H80v-64h352v64zm0-112H80V85.43C94.18 71.6 156.69 48 256 48s161.82 23.6 176 37.43V112z"
  ]
};
export const faBusAlt = {
  prefix: "far",
  iconName: "bus-alt",
  icon: [
    512,
    512,
    [],
    "f55e",
    "M144 304c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm344-176h-8V80c0-44.8-99.2-80-224-80S32 35.2 32 80v48h-8c-13.25 0-24 10.74-24 24v80c0 13.25 10.75 24 24 24h8v160c0 17.67 14.33 32 32 32v32c0 17.67 14.33 32 32 32h16c17.67 0 32-14.33 32-32v-32h224v32c0 17.67 14.33 32 32 32h16c17.67 0 32-14.33 32-32v-32c17.67 0 32-14.33 32-32V256h8c13.25 0 24-10.75 24-24v-80c0-13.26-10.75-24-24-24zM80 160h152v64H80v-64zm352 240H80V272h352v128zm0-176H280v-64h152v64zm0-112h-96c0-17.67-14.33-32-32-32h-96c-17.67 0-32 14.33-32 32H80V85.43C94.18 71.6 156.69 48 256 48s161.82 23.6 176 37.43V112zm-64 256c17.67 0 32-14.33 32-32s-14.33-32-32-32-32 14.33-32 32 14.33 32 32 32z"
  ]
};
export const faBusSchool = {
  prefix: "far",
  iconName: "bus-school",
  icon: [
    512,
    512,
    [],
    "f5dd",
    "M488 128h-24V80c0-44.8-92.11-80-208-80S48 35.2 48 80v48H24c-13.25 0-24 10.74-24 24v80c0 13.25 10.75 24 24 24h16.91C25.59 273.01 16 295.3 16 320v64c0 29.95 20.65 54.88 48.43 61.87-.05.74-.43 1.37-.43 2.13v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h192v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32c0-.76-.38-1.39-.43-2.13C475.35 438.88 496 413.95 496 384v-64c0-24.7-9.59-46.99-24.91-64H488c13.25 0 24-10.75 24-24v-80c0-13.26-10.75-24-24-24zM96 84.4C108.24 71.08 164.99 48 256 48s147.76 23.08 160 36.4V112h-80c0-17.67-14.33-32-32-32h-96c-17.67 0-32 14.33-32 32H96V84.4zM416 160v64H272v-64h144zm-320 0h144v64H96v-64zm352 224c0 8.82-7.18 16-16 16H80c-8.82 0-16-7.18-16-16v-64c0-26.47 21.53-48 48-48h288c26.47 0 48 21.53 48 48v64zm-80-80c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm-224 0c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32z"
  ]
};
export const faBusinessTime = {
  prefix: "far",
  iconName: "business-time",
  icon: [
    640,
    512,
    [],
    "f64a",
    "M496 224c-79.59 0-144 64.41-144 144s64.41 144 144 144 144-64.41 144-144-64.41-144-144-144zm64 150.29c0 5.34-4.37 9.71-9.71 9.71h-60.57c-5.34 0-9.71-4.37-9.71-9.71v-76.57c0-5.34 4.37-9.71 9.71-9.71h12.57c5.34 0 9.71 4.37 9.71 9.71V352h38.29c5.34 0 9.71 4.37 9.71 9.71v12.58zM216 320h80c13.25 0 24-10.75 24-24v-24h28.68a177.277 177.277 0 0 1 46.45-48H48v-74c0-3.31 2.69-6 6-6h404c3.31 0 6 2.69 6 6v45.06c10.39-1.92 21.06-3.06 32-3.06 5.4 0 10.72.33 16 .81V144c0-26.51-21.49-48-48-48h-80V48c0-26.51-21.49-48-48-48H176c-26.51 0-48 21.49-48 48v48H48c-26.51 0-48 21.49-48 48v256c0 26.51 21.49 48 48 48h291.43a174.578 174.578 0 0 1-16.37-48H54c-3.31 0-6-2.69-6-6V272h144v24c0 13.25 10.75 24 24 24zM176 48h160v48H176V48z"
  ]
};
export const faCabinetFiling = {
  prefix: "far",
  iconName: "cabinet-filing",
  icon: [
    512,
    512,
    [],
    "f64b",
    "M464 0H48C21.49 0 0 21.49 0 48v416c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V48c0-26.51-21.49-48-48-48zm0 464H48V280h416v184zm0-232H48V48h416v184zm-304-56h16c8.84 0 16-7.16 16-16v-8h128v8c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-24c0-17.67-14.33-32-32-32H176c-17.67 0-32 14.33-32 32v24c0 8.84 7.16 16 16 16zm0 232h16c8.84 0 16-7.16 16-16v-8h128v8c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-24c0-17.67-14.33-32-32-32H176c-17.67 0-32 14.33-32 32v24c0 8.84 7.16 16 16 16z"
  ]
};
export const faCactus = {
  prefix: "far",
  iconName: "cactus",
  icon: [
    512,
    512,
    [],
    "f8a7",
    "M240 129.94a16 16 0 1 0 16 16 16 16 0 0 0-16-16zm32 224a16 16 0 1 0 16 16 16 16 0 0 0-16-16zM464 224a48 48 0 0 0-48 48v64a16 16 0 0 1-16 16h-48V101.43c0-52-38.93-98.58-90.84-101.3C259.43 0 257.71 0 256 0a96 96 0 0 0-96 96v128h-48a16 16 0 0 1-16-16v-64a48 48 0 0 0-96 0v64a112 112 0 0 0 112 112h48v160a32 32 0 0 0 32 32h128a32 32 0 0 0 32-32v-32h48a112 112 0 0 0 112-112v-64a48 48 0 0 0-48-48zM304 464h-96V96a48 48 0 0 1 48-48l2.65.07c25 1.31 45.35 25.25 45.35 53.36z"
  ]
};
export const faCalculator = {
  prefix: "far",
  iconName: "calculator",
  icon: [
    448,
    512,
    [],
    "f1ec",
    "M400 0H48C22.4 0 0 22.4 0 48v416c0 25.6 22.4 48 48 48h352c25.6 0 48-22.4 48-48V48c0-25.6-22.4-48-48-48zm0 464H48V208h352v256zm0-304H48V48h352v112zM108.8 320h38.4c6.4 0 12.8-6.4 12.8-12.8v-38.4c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v38.4c0 6.4 6.4 12.8 12.8 12.8zm192 96h38.4c6.4 0 12.8-6.4 12.8-12.8V268.8c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v134.4c0 6.4 6.4 12.8 12.8 12.8zm-192 0h38.4c6.4 0 12.8-6.4 12.8-12.8v-38.4c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v38.4c0 6.4 6.4 12.8 12.8 12.8zm96-96h38.4c6.4 0 12.8-6.4 12.8-12.8v-38.4c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v38.4c0 6.4 6.4 12.8 12.8 12.8zm0 96h38.4c6.4 0 12.8-6.4 12.8-12.8v-38.4c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v38.4c0 6.4 6.4 12.8 12.8 12.8z"
  ]
};
export const faCalculatorAlt = {
  prefix: "far",
  iconName: "calculator-alt",
  icon: [
    512,
    512,
    [],
    "f64c",
    "M477.71 0H34.29C15.35 0 0 15.35 0 34.29v443.43C0 496.65 15.35 512 34.29 512h443.43c18.94 0 34.29-15.35 34.29-34.29V34.29C512 15.35 496.65 0 477.71 0zM232 464H48V280h184v184zm0-232H48V48h184v184zm232 232H280V280h184v184zm0-232H280V48h184v184zm-360-72h80c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8h-80c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8zm224 248h80c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8h-80c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8zm0-48h80c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8h-80c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8zm0-200h24v24c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-24h24c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8h-24v-24c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v24h-24c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8zM104.4 396.28l11.31 11.31c3.12 3.12 8.19 3.12 11.31 0L144 390.63l16.97 16.97c3.12 3.12 8.19 3.12 11.31 0l11.31-11.31c3.12-3.12 3.12-8.19 0-11.31L166.63 368l16.97-16.97c3.12-3.12 3.12-8.19 0-11.31l-11.31-11.31c-3.12-3.12-8.19-3.12-11.31 0L144 345.37l-16.97-16.97c-3.12-3.12-8.19-3.12-11.31 0l-11.31 11.31c-3.12 3.12-3.12 8.19 0 11.31L121.37 368l-16.97 16.97c-3.12 3.12-3.12 8.19 0 11.31z"
  ]
};
export const faCalendar = {
  prefix: "far",
  iconName: "calendar",
  icon: [
    448,
    512,
    [],
    "f133",
    "M400 64h-48V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H160V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zm-6 400H54c-3.3 0-6-2.7-6-6V160h352v298c0 3.3-2.7 6-6 6z"
  ]
};
export const faCalendarAlt = {
  prefix: "far",
  iconName: "calendar-alt",
  icon: [
    448,
    512,
    [],
    "f073",
    "M148 288h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm108-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm96 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm-96 96v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm-96 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm192 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm96-260v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48zm-48 346V160H48v298c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
  ]
};
export const faCalendarCheck = {
  prefix: "far",
  iconName: "calendar-check",
  icon: [
    448,
    512,
    [],
    "f274",
    "M400 64h-48V12c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v52H160V12c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v52H48C21.49 64 0 85.49 0 112v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm-6 400H54a6 6 0 0 1-6-6V160h352v298a6 6 0 0 1-6 6zm-52.849-200.65L198.842 404.519c-4.705 4.667-12.303 4.637-16.971-.068l-75.091-75.699c-4.667-4.705-4.637-12.303.068-16.971l22.719-22.536c4.705-4.667 12.303-4.637 16.97.069l44.104 44.461 111.072-110.181c4.705-4.667 12.303-4.637 16.971.068l22.536 22.718c4.667 4.705 4.636 12.303-.069 16.97z"
  ]
};
export const faCalendarDay = {
  prefix: "far",
  iconName: "calendar-day",
  icon: [
    448,
    512,
    [],
    "f783",
    "M112 368h96c8.8 0 16-7.2 16-16v-96c0-8.8-7.2-16-16-16h-96c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16zM400 64h-48V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H160V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zm0 394c0 3.3-2.7 6-6 6H54c-3.3 0-6-2.7-6-6V160h352v298z"
  ]
};
export const faCalendarEdit = {
  prefix: "far",
  iconName: "calendar-edit",
  icon: [
    448,
    512,
    [],
    "f333",
    "M243.1 234.1l46.8 46.8c2 2 2 5.2 0 7.2L175.4 402.6l-48.2 5.4c-6.4.7-11.9-4.7-11.2-11.2l5.4-48.2 114.5-114.5c2-2 5.2-2 7.2 0zm83-10.8l-25.4-25.4c-7.9-7.9-20.7-7.9-28.6 0l-19.5 19.5c-2 2-2 5.2 0 7.2l46.8 46.8c2 2 5.2 2 7.2 0l19.5-19.5c7.9-7.9 7.9-20.7 0-28.6zM448 112v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48zm-48 346V160H48v298c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
  ]
};
export const faCalendarExclamation = {
  prefix: "far",
  iconName: "calendar-exclamation",
  icon: [
    448,
    512,
    [],
    "f334",
    "M188.6 212.7l6.5 104c.4 6.3 5.6 11.3 12 11.3h33.8c6.3 0 11.6-4.9 12-11.3l6.5-104c.4-6.9-5.1-12.7-12-12.7h-46.8c-6.9 0-12.4 5.8-12 12.7zM264 384c0 22.1-17.9 40-40 40s-40-17.9-40-40 17.9-40 40-40 40 17.9 40 40zM400 64h-48V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H160V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zm-6 400H54c-3.3 0-6-2.7-6-6V160h352v298c0 3.3-2.7 6-6 6z"
  ]
};
export const faCalendarMinus = {
  prefix: "far",
  iconName: "calendar-minus",
  icon: [
    448,
    512,
    [],
    "f272",
    "M124 328c-6.6 0-12-5.4-12-12v-24c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v24c0 6.6-5.4 12-12 12H124zm324-216v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48zm-48 346V160H48v298c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
  ]
};
export const faCalendarPlus = {
  prefix: "far",
  iconName: "calendar-plus",
  icon: [
    448,
    512,
    [],
    "f271",
    "M336 292v24c0 6.6-5.4 12-12 12h-76v76c0 6.6-5.4 12-12 12h-24c-6.6 0-12-5.4-12-12v-76h-76c-6.6 0-12-5.4-12-12v-24c0-6.6 5.4-12 12-12h76v-76c0-6.6 5.4-12 12-12h24c6.6 0 12 5.4 12 12v76h76c6.6 0 12 5.4 12 12zm112-180v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48zm-48 346V160H48v298c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
  ]
};
export const faCalendarStar = {
  prefix: "far",
  iconName: "calendar-star",
  icon: [
    448,
    512,
    [],
    "f736",
    "M167 331.4l-9.4 54.6c-1.7 9.9 8.7 17.2 17.4 12.6l48.9-25.8 48.9 25.8c8.7 4.6 19.1-2.8 17.4-12.6l-9.4-54.6 39.6-38.6c7.1-6.9 3.2-19-6.6-20.5l-54.7-8-24.5-49.6c-4.4-8.8-17.1-9-21.5 0l-24.5 49.6-54.7 8c-9.8 1.4-13.7 13.5-6.6 20.5l39.7 38.6zM400 64h-48V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H160V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zm0 394c0 3.3-2.7 6-6 6H54c-3.3 0-6-2.7-6-6V160h352v298z"
  ]
};
export const faCalendarTimes = {
  prefix: "far",
  iconName: "calendar-times",
  icon: [
    448,
    512,
    [],
    "f273",
    "M311.7 374.7l-17 17c-4.7 4.7-12.3 4.7-17 0L224 337.9l-53.7 53.7c-4.7 4.7-12.3 4.7-17 0l-17-17c-4.7-4.7-4.7-12.3 0-17l53.7-53.7-53.7-53.7c-4.7-4.7-4.7-12.3 0-17l17-17c4.7-4.7 12.3-4.7 17 0l53.7 53.7 53.7-53.7c4.7-4.7 12.3-4.7 17 0l17 17c4.7 4.7 4.7 12.3 0 17L257.9 304l53.7 53.7c4.8 4.7 4.8 12.3.1 17zM448 112v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48zm-48 346V160H48v298c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
  ]
};
export const faCalendarWeek = {
  prefix: "far",
  iconName: "calendar-week",
  icon: [
    448,
    512,
    [],
    "f784",
    "M112 304h224c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16H112c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16zM400 64h-48V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H160V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zm0 394c0 3.3-2.7 6-6 6H54c-3.3 0-6-2.7-6-6V160h352v298z"
  ]
};
export const faCamcorder = {
  prefix: "far",
  iconName: "camcorder",
  icon: [
    576,
    512,
    [],
    "f8a8",
    "M543.86 160a32.13 32.13 0 0 0-18.27 5.73l-109.59 75V224a64 64 0 0 0-64-64H96v-40a40 40 0 0 1 40-40h168a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16H136a88 88 0 0 0-88 88v42.26A63.85 63.85 0 0 0 0 224v192a64 64 0 0 0 64 64h288a64 64 0 0 0 64-64v-16.8l109.59 75a32 32 0 0 0 18.26 5.8c16.63 0 32.15-13 32.15-31.59V191.5c0-18.5-15.49-31.5-32.14-31.5zM368 416a16 16 0 0 1-16 16H64a16 16 0 0 1-16-16V224a16 16 0 0 1 16-16h288a16 16 0 0 1 16 16zm160 1.69L416 341v-42.09l112-76.68zM304 256H112a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16z"
  ]
};
export const faCamera = {
  prefix: "far",
  iconName: "camera",
  icon: [
    512,
    512,
    [],
    "f030",
    "M342.7 144H464v288H48V144h121.3l24-64h125.5l23.9 64zM324.3 32h-131c-20 0-37.9 12.4-44.9 31.1L136 96H48c-26.5 0-48 21.5-48 48v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V144c0-26.5-21.5-48-48-48h-88l-14.3-38c-5.8-15.7-20.7-26-37.4-26zM256 408c-66.2 0-120-53.8-120-120s53.8-120 120-120 120 53.8 120 120-53.8 120-120 120zm0-192c-39.7 0-72 32.3-72 72s32.3 72 72 72 72-32.3 72-72-32.3-72-72-72z"
  ]
};
export const faCameraAlt = {
  prefix: "far",
  iconName: "camera-alt",
  icon: [
    512,
    512,
    [],
    "f332",
    "M256 408c-66.2 0-120-53.8-120-120s53.8-120 120-120 120 53.8 120 120-53.8 120-120 120zm0-192c-39.7 0-72 32.3-72 72s32.3 72 72 72 72-32.3 72-72-32.3-72-72-72zm-24 72c0-13.2 10.8-24 24-24 8.8 0 16-7.2 16-16s-7.2-16-16-16c-30.9 0-56 25.1-56 56 0 8.8 7.2 16 16 16s16-7.2 16-16zm110.7-145H464v288H48V143h121.3l24-64h125.5l23.9 64zM324.3 31h-131c-20 0-37.9 12.4-44.9 31.1L136 95H48c-26.5 0-48 21.5-48 48v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V143c0-26.5-21.5-48-48-48h-88l-14.3-38c-5.8-15.7-20.7-26-37.4-26z"
  ]
};
export const faCameraHome = {
  prefix: "far",
  iconName: "camera-home",
  icon: [
    448,
    512,
    [],
    "f8fe",
    "M224,160a64.12,64.12,0,0,0-64,64,16,16,0,0,0,32,0,32,32,0,0,1,32-32,16,16,0,0,0,0-32Zm0-80C144.59,80,80,144.59,80,224s64.59,144,144,144,144-64.59,144-144S303.41,80,224,80Zm0,240a96,96,0,1,1,96-96A96,96,0,0,1,224,320ZM384,0H64A64,64,0,0,0,0,64V384a64,64,0,0,0,64,64H81.42l-4.89,2.83c-6.9,4.33-12.5,14.45-12.5,22.6v11.9A26.68,26.68,0,0,0,90.7,512H357.37A26.68,26.68,0,0,0,384,485.33V473.45c0-8.17-5.65-18.3-12.58-22.62L366.57,448H384a64,64,0,0,0,64-64V64A64,64,0,0,0,384,0Zm16,384a16,16,0,0,1-16,16H64a16,16,0,0,1-16-16V64A16,16,0,0,1,64,48H384a16,16,0,0,1,16,16Z"
  ]
};
export const faCameraMovie = {
  prefix: "far",
  iconName: "camera-movie",
  icon: [
    576,
    512,
    [],
    "f8a9",
    "M176 96a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm192 0a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm182.29 144a25.69 25.69 0 0 0-14.61 4.59L448 303.22v.78a63.5 63.5 0 0 0-10.37-34.74C481.75 244.62 512 198 512 144 512 64.6 447.4 0 368 0c-35.15 0-69.24 13.27-96 37.37C245.24 13.27 211.15 0 176 0 96.6 0 32 64.6 32 144c0 37 14.43 70.46 37.46 96H32a32 32 0 0 0-32 32v64a32 32 0 0 0 32 32h48v80a64 64 0 0 0 64 64h240a64 64 0 0 0 64-64v.73l87.68 58.62a25.56 25.56 0 0 0 14.61 4.6c13.3 0 25.71-10.36 25.71-25.23v-221.5c0-14.82-12.39-25.22-25.71-25.22zM400 448a16 16 0 0 1-16 16H144a16 16 0 0 1-16-16V320H48v-32h336a16 16 0 0 1 16 16zm-32-208H176a96 96 0 0 1 0-192c23.27 0 45.95 8.89 63.88 25L272 102l32.13-29c17.92-16.14 40.6-25 63.87-25a96 96 0 0 1 0 192zm160 204.48L448 391v-30l80-53.5z"
  ]
};
export const faCameraPolaroid = {
  prefix: "far",
  iconName: "camera-polaroid",
  icon: [
    576,
    512,
    [],
    "f8aa",
    "M288 128a80 80 0 1 0 80 80 80.12 80.12 0 0 0-80-80zm0 112a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm282.63 103.94L512 256V80a48 48 0 0 0-48-48H112a48 48 0 0 0-48 48v176L5.38 343.94A32 32 0 0 0 0 361.69V448a32 32 0 0 0 32 32h512a32 32 0 0 0 32-32v-86.31a32 32 0 0 0-5.37-17.75zM112 270.53V80h352v190.53L507.64 336H68.36zM528 432H48v-48h480zM424 112h-32a8 8 0 0 0-8 8v32a8 8 0 0 0 8 8h32a8 8 0 0 0 8-8v-32a8 8 0 0 0-8-8z"
  ]
};
export const faCameraRetro = {
  prefix: "far",
  iconName: "camera-retro",
  icon: [
    512,
    512,
    [],
    "f083",
    "M154 80H38c-3.3 0-6-2.7-6-6V38c0-3.3 2.7-6 6-6h116c3.3 0 6 2.7 6 6v36c0 3.3-2.7 6-6 6zm358 0v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48h136l33.6-44.8C226.7 39.1 240.9 32 256 32h208c26.5 0 48 21.5 48 48zm-48 64H48v288h416V144zm0-64H256l-12 16h220V80zm-88 208c0-66.2-53.8-120-120-120s-120 53.8-120 120 53.8 120 120 120 120-53.8 120-120zm-48 0c0 39.7-32.3 72-72 72s-72-32.3-72-72 32.3-72 72-72 72 32.3 72 72zm-96 0c0-13.2 10.8-24 24-24 8.8 0 16-7.2 16-16s-7.2-16-16-16c-30.9 0-56 25.1-56 56 0 8.8 7.2 16 16 16s16-7.2 16-16z"
  ]
};
export const faCampfire = {
  prefix: "far",
  iconName: "campfire",
  icon: [
    512,
    512,
    [],
    "f6ba",
    "M256 320c79.53 0 144-64.47 144-144 0-33.29-33.42-101.96-80-144-13.37 12.06-25.45 24.75-36.14 37.48C266.34 46.01 244.61 22.21 220 0c-63.17 56.98-108 131.22-108 176 0 79.53 64.47 144 144 144zM220.26 67.87c9.13 10.02 17.58 20.21 25.14 30.33l36.26 48.56 36.85-43.89C339.82 133.29 352 165.07 352 176c0 52.93-43.06 96-96 96-52.93 0-96-43.07-96-96 0-19.32 20.77-63.38 60.26-108.13zM500.9 465.46l-165.41-52.32 165.41-52.32c8.33-2.64 12.98-11.61 10.38-20.04l-4.71-15.27c-2.6-8.43-11.47-13.14-19.8-10.5L256 387.99 25.24 315c-8.33-2.64-17.2 2.07-19.8 10.5L.73 340.77c-2.6 8.43 2.04 17.41 10.37 20.04l165.41 52.32L11.1 465.46C2.77 468.09-1.88 477.07.73 485.5l4.71 15.27c2.6 8.44 11.47 13.14 19.8 10.5L256 438.28l230.76 72.99c8.33 2.63 17.2-2.07 19.8-10.5l4.71-15.27c2.61-8.44-2.03-17.41-10.37-20.04z"
  ]
};
export const faCampground = {
  prefix: "far",
  iconName: "campground",
  icon: [
    640,
    512,
    [],
    "f6bb",
    "M624 464h-28.53l-245.9-341.21 63.33-87.88c5.22-7.12 3.68-17.14-3.44-22.36L396.58 3.1c-7.13-5.23-17.14-3.69-22.37 3.44L320 81.76 265.79 6.54c-5.22-7.13-15.24-8.67-22.37-3.44l-12.88 9.45c-7.12 5.22-8.67 15.24-3.44 22.36l63.33 87.88L44.53 464H16c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16zM320 163.82L536.33 464h-99.97L320 304 203.64 464h-99.97L320 163.82z"
  ]
};
export const faCandleHolder = {
  prefix: "far",
  iconName: "candle-holder",
  icon: [
    448,
    512,
    [],
    "f6bc",
    "M160 192c45.93 0 78-32.61 78-79.29C238 82.72 205.41 37.82 160 0c-45.62 38-78 82.84-78 112.71 0 46.68 32.07 79.29 78 79.29zm0-125.83c20.01 22.07 29.44 39.99 30 46.53 0 11.69-3.9 31.29-30 31.29s-30-19.61-30.01-31c.56-6.74 10-24.73 30.01-46.82zM376 368c-39.7 0-72 32.3-72 72 0 8.46 1.73 16.46 4.42 24H272V256c0-17.67-14.33-32-32-32H80c-17.67 0-32 14.33-32 32v208H16c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h360c39.7 0 72-32.3 72-72s-32.3-72-72-72zm-152 96H96V272h32v56c0 13.25 10.75 24 24 24s24-10.75 24-24v-56h48v192zm152 0c-13.23 0-24-10.77-24-24s10.77-24 24-24 24 10.77 24 24-10.77 24-24 24z"
  ]
};
export const faCandyCane = {
  prefix: "far",
  iconName: "candy-cane",
  icon: [
    512,
    512,
    [],
    "f786",
    "M497.1 95.4C469.2 36.6 411.5 0 346.5 0c-29.9 0-59.2 8.1-85 23.5l-25.8 15.4c-21.8 13-28.9 41.3-15.9 63.1l30.8 51.5c12.1 20.2 39.9 29.7 63.1 15.9l25.8-15.4c16-9.6 30.1 14.6 14.4 24L22.5 375c-10.6 6.3-18 16.4-21 28.3s-1.2 24.3 5.1 34.8l30.8 51.5c8.3 13.8 23.4 22.4 39.5 22.4 8.3 0 16.4-2.3 23.6-6.5l325.7-193.6c75.7-45.3 106.9-140.4 70.9-216.5zM212.4 383.3L156 351.5l64.2-38.2 56.4 31.8-64.2 38.2zm111.8-66.5L267.8 285l59.4-35.3 56.3 31.7-59.3 35.4zM395.1 128c-3.2-4.1-6.8-7.7-10.9-10.8V54.3c30.1 10 55.3 31.6 69.5 61.7 1.9 3.9 2.9 8 4.3 12.1h-62.9zm-59-79.3v56.7c-15.9 2.8-19.3 6.2-45.1 22l-28.9-48.3c27.6-16.5 42.6-27.6 74-30.4zM108.4 379.8l56.5 31.8-87.2 51.9-28.9-48.3 59.6-35.4zm318.2-129.2l-51.8-29.2c17.9-10.6 29.2-23.2 32.9-45.4h55.4c-3.1 27.5-15.9 53.9-36.5 74.6z"
  ]
};
export const faCandyCorn = {
  prefix: "far",
  iconName: "candy-corn",
  icon: [
    640,
    512,
    [],
    "f6bd",
    "M480 0C314.19 1.62 315.52 39.54 322.11 72.47 352.45 224.02 416.18 416 479.91 416h.09c63.77-.18 127.53-191.9 157.89-343.53C644.48 39.54 645.81 1.62 480 0zm-.07 365.62c-12.06-10.3-29.27-39.56-47.6-84.11 31.25-1.83 64.03-1.83 95.28 0-18.35 44.56-35.59 73.82-47.68 84.11zM591 63c-3.27 16.31-6.73 31.93-10.29 47.16-63.77-8.07-137.65-8.07-201.42 0C375.73 94.93 372.26 79.31 369 63c-.12-.62-.23-1.19-.33-1.72 10.2-4.34 38.91-12.52 111.34-13.26 72.42.74 101.13 8.92 111.34 13.26-.11.53-.22 1.1-.35 1.72zM84.94 205.81c-116.1 118.4-88.35 144.26-60.4 162.89 128.62 85.71 309.43 176.4 354.49 131.34l.06-.06c44.96-45.22-45.52-225.87-131.27-354.56-18.62-27.96-44.48-55.71-162.88 60.39zm6.69 149.12c-13.29-8.26-26.78-16.85-40.62-26.07-.53-.35-1.01-.68-1.45-.98 4.14-10.28 18.66-36.37 69.35-88.1 51.74-50.69 77.82-65.21 88.1-69.35.3.44.63.93.98 1.45 9.23 13.84 17.81 27.34 26.07 40.63-50.81 39.37-103.05 91.61-142.43 142.42zm226.04 16.27c18.53 44.49 27.03 77.37 25.76 93.2-15.81 1.24-48.68-7.28-93.13-25.82 20.81-23.39 43.98-46.57 67.37-67.38z"
  ]
};
export const faCannabis = {
  prefix: "far",
  iconName: "cannabis",
  icon: [
    544,
    512,
    [],
    "f55f",
    "M516.88 312.08c-2.16-1.05-11.9-5.64-27.19-10.96 39.01-57.61 52.25-110.92 52.98-113.95 3.85-15.95-.78-32.74-12.27-44.54-9.21-9.45-21.8-14.64-34.78-14.64-3.21 0-6.45.32-9.66.97-3.1.63-55.54 11.56-114.37 43.47-14.48-85.81-57.6-148.6-59.79-151.74C302.76 7.74 287.89 0 272 0s-30.76 7.74-39.79 20.7c-2.19 3.14-45.31 65.92-59.79 151.74-58.83-31.91-111.27-42.85-114.37-43.47a48.7 48.7 0 0 0-9.66-.97c-12.98 0-25.57 5.19-34.78 14.64-11.5 11.79-16.13 28.58-12.28 44.53.73 3.03 13.98 56.34 52.98 113.95-15.29 5.32-25.03 9.91-27.19 10.96C10.54 320.13.01 336.85 0 355.17c-.01 18.32 10.49 35.05 27.06 43.12 2.17 1.05 46.28 22.24 105.46 28.67a47.751 47.751 0 0 0 13.09 38.15c9.26 9.65 21.98 14.89 35.03 14.89 4.47 0 8.97-.62 13.4-1.88 3.67-1.05 25.83-7.77 53.96-22.27V496c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-40.15c28.13 14.5 50.29 21.22 53.96 22.27 4.42 1.27 8.93 1.88 13.4 1.88 13.05 0 25.77-5.24 35.03-14.89 9.91-10.32 14.56-24.32 13.09-38.15 59.18-6.44 103.29-27.62 105.46-28.67 16.57-8.07 27.07-24.8 27.06-43.12-.01-18.32-10.54-35.04-27.12-43.09zM378.22 380.8c-17.3 0-31.13-.86-42.42-2.33-.22.11-.4.15-.62.27 19.77 28.81 28.18 53.26 28.18 53.26s-48-13.73-91.36-48.48C228.63 418.27 180.64 432 180.64 432s8.42-24.45 28.18-53.26c-.22-.11-.4-.15-.62-.27-11.29 1.46-25.12 2.33-42.42 2.33-64.84 0-117.4-25.6-117.4-25.6s40.88-19.84 94.97-24.56c-.85-.77-1.57-1.3-2.43-2.09C69.37 263.02 48.38 176 48.38 176s95.02 19.22 166.57 84.75c.93.85 1.57 1.57 2.48 2.41-.85-10.83-1.33-22.72-1.33-35.96C216.1 128.23 272 48 272 48s55.9 80.23 55.9 179.2c0 13.23-.48 25.13-1.33 35.96.91-.84 1.54-1.56 2.48-2.41C400.6 195.22 495.62 176 495.62 176s-20.99 87.02-92.54 152.55c-.86.79-1.58 1.32-2.43 2.09 54.09 4.71 94.97 24.56 94.97 24.56s-52.56 25.6-117.4 25.6z"
  ]
};
export const faCapsules = {
  prefix: "far",
  iconName: "capsules",
  icon: [
    544,
    512,
    [],
    "f46b",
    "M529 296.8l-111.5-193C386.8 50.4 318.6 32.2 265.3 63c-21.2 12.3-36.6 30.5-45.8 51.3C206.4 67 163.5 32 112 32 50.1 32 0 82.1 0 144v224c0 61.9 50.1 112 112 112s112-50.1 112-112V214c.2.4.3.8.5 1.2l111.5 193c30.8 53.3 98.9 71.6 152.3 40.8s71.5-98.9 40.7-152.2zM176 256H48V144c0-84.7 128-84.7 128 0v112zm89.9-64.7c-42.1-73 68.2-136.7 110.3-63.7l43.8 75.8-110.3 63.7-43.8-75.8z"
  ]
};
export const faCar = {
  prefix: "far",
  iconName: "car",
  icon: [
    512,
    512,
    [],
    "f1b9",
    "M499.99 192.01h-52.21l-31.36-77.88C404.24 83.84 374.86 64 342.22 64H169.78c-32.64 0-62.02 19.84-74.21 50.12L64.21 192h-52.2C4.2 192-1.53 199.34.37 206.91l6 24A12.01 12.01 0 0 0 18.01 240h11.31C21.04 254.16 16 270.41 16 287.99V424c0 13.25 10.75 24 24 24h16c13.25 0 24-10.75 24-24v-24h352v24c0 13.25 10.75 24 24 24h16c13.25 0 24-10.75 24-24V288c0-17.59-5.04-33.84-13.31-47.99H494c5.51 0 10.31-3.75 11.64-9.09l6-24c1.89-7.58-3.84-14.91-11.65-14.91zM140.1 132.05C145 119.87 156.65 112 169.78 112h172.44c13.13 0 24.78 7.87 29.68 20.05l24.13 59.94H115.97l24.13-59.94zM448 336c0 8.82-7.18 16-16 16H80c-8.82 0-16-7.18-16-16v-48c0-26.47 21.53-48 48-48h288c26.47 0 48 21.53 48 48v48zm-320-72.01c-19.2 0-32 12.76-32 31.91s12.8 31.91 32 31.91 48 3.19 48-15.96c0-19.14-28.8-47.86-48-47.86zm256 0c-19.2 0-48 28.72-48 47.86 0 19.15 28.8 15.96 48 15.96s32-12.76 32-31.91c0-19.14-12.8-31.91-32-31.91z"
  ]
};
export const faCarAlt = {
  prefix: "far",
  iconName: "car-alt",
  icon: [
    480,
    512,
    [],
    "f5de",
    "M438.73 209.26l-38.3-95.14C388.24 83.84 358.87 64 326.22 64H153.78c-32.64 0-62.02 19.84-74.21 50.12l-38.31 95.14C16.37 226.6 0 255.35 0 287.99V424c0 13.25 10.75 24 24 24h16c13.25 0 24-10.75 24-24v-24h352v24c0 13.25 10.75 24 24 24h16c13.25 0 24-10.75 24-24V288c0-32.65-16.37-61.4-41.27-78.74zM124.1 132.05C129 119.87 140.65 112 153.78 112h172.44c13.13 0 24.78 7.87 29.68 20.05l24.13 59.94H99.97l24.13-59.94zM432 336c0 8.82-7.18 16-16 16H64c-8.82 0-16-7.18-16-16v-48c0-26.47 21.53-48 48-48h288c26.47 0 48 21.53 48 48v48zm-320-72.01c-19.2 0-32 12.76-32 31.91s12.8 31.91 32 31.91 48 3.19 48-15.96c0-19.14-28.8-47.86-48-47.86zm256 0c-19.2 0-48 28.72-48 47.86 0 19.15 28.8 15.96 48 15.96s32-12.76 32-31.91c0-19.14-12.8-31.91-32-31.91z"
  ]
};
export const faCarBattery = {
  prefix: "far",
  iconName: "car-battery",
  icon: [
    512,
    512,
    [],
    "f5df",
    "M480 96h-48V80c0-8.84-7.16-16-16-16h-96c-8.84 0-16 7.16-16 16v15.98L208 96V80c0-8.84-7.16-16-16-16H96c-8.84 0-16 7.16-16 16v16H32c-17.67 0-32 14.33-32 32v288c0 17.67 14.33 32 32 32h448c17.67 0 32-14.33 32-32V128c0-17.67-14.33-32-32-32zm-16 304H48V144h416v256zM200 232H88c-4.42 0-8 3.58-8 8v32c0 4.42 3.58 8 8 8h112c4.42 0 8-3.58 8-8v-32c0-4.42-3.58-8-8-8zm224 0h-32v-32c0-4.42-3.58-8-8-8h-32c-4.42 0-8 3.58-8 8v32h-32c-4.42 0-8 3.58-8 8v32c0 4.42 3.58 8 8 8h32v32c0 4.42 3.58 8 8 8h32c4.42 0 8-3.58 8-8v-32h32c4.42 0 8-3.58 8-8v-32c0-4.42-3.58-8-8-8z"
  ]
};
export const faCarBuilding = {
  prefix: "far",
  iconName: "car-building",
  icon: [
    640,
    512,
    [],
    "f859",
    "M148 192h-40a12 12 0 0 0-12 12v40a12 12 0 0 0 12 12h40a12 12 0 0 0 12-12v-40a12 12 0 0 0-12-12zm0 96h-40a12 12 0 0 0-12 12v40a12 12 0 0 0 12 12h40a12 12 0 0 0 12-12v-40a12 12 0 0 0-12-12zm0-192h-40a12 12 0 0 0-12 12v40a12 12 0 0 0 12 12h40a12 12 0 0 0 12-12v-40a12 12 0 0 0-12-12zm156 80.14a143.45 143.45 0 0 1 48-25.81V32a32 32 0 0 0-32-32H32A32 32 0 0 0 0 32v400a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16V48h256zM204 96a12 12 0 0 0-12 12v40a12 12 0 0 0 12 12h40a12 12 0 0 0 12-12v-40a12 12 0 0 0-12-12zm324 248a24 24 0 1 0 24 24 24 24 0 0 0-24-24zm58.77-67.4l-14-32.72A111.86 111.86 0 0 0 469.8 176h-75.6a111.86 111.86 0 0 0-102.94 67.88l-14 32.72A80.15 80.15 0 0 0 224 352v32a79.67 79.67 0 0 0 32.07 63.65c0 .12-.07.23-.07.35v32a32 32 0 0 0 32 32h16a32 32 0 0 0 32-32v-16h192v16a32 32 0 0 0 32 32h16a32 32 0 0 0 32-32v-32c0-.12-.07-.23-.07-.35A79.67 79.67 0 0 0 640 384v-32a80.16 80.16 0 0 0-53.23-75.4zM592 384a32 32 0 0 1-32 32H304a32 32 0 0 1-32-32v-32a32 32 0 0 1 32-32h6.86l24.52-57.21A64 64 0 0 1 394.2 224h75.6a64 64 0 0 1 58.82 38.79L553.14 320H560a32 32 0 0 1 32 32zM256 244v-40a12 12 0 0 0-12-12h-40a12 12 0 0 0-12 12v40a12 12 0 0 0 12 12h40a12 12 0 0 0 12-12zm80 100a24 24 0 1 0 24 24 24 24 0 0 0-24-24zm163.32-68.35A32.06 32.06 0 0 0 469.8 256h-75.6a32 32 0 0 0-29.41 19.4L345.2 320h173.6z"
  ]
};
export const faCarBump = {
  prefix: "far",
  iconName: "car-bump",
  icon: [
    576,
    512,
    [],
    "f5e0",
    "M101.98 308.12c-17.69 8.02-23.99 24.81-15.77 41.96 8.22 17.15 25.5 23.24 43.18 15.22 17.69-8.02 45.59-17.2 37.37-34.35-8.22-17.16-47.09-30.86-64.78-22.83zm235.83-106.97c-17.69 8.02-31.88 45.79-23.66 62.94 8.22 17.15 33.38 2.26 51.07-5.76 17.69-8.02 23.99-24.81 15.77-41.96-8.22-17.15-25.5-23.24-43.18-15.22zM116.19 450.03l324.26-147.08 10.31 21.51c5.69 11.88 20.21 17.01 32.42 11.48l14.74-6.69c12.21-5.54 17.49-19.66 11.8-31.53l-44.67-93.19-13.75-28.67c-14.02-29.25-41.45-48.16-71.83-53.3l-76.15-69.24c-24.24-22.04-59.82-27.54-89.89-13.9L54.57 111.46C24.5 125.1 5.96 155.15 7.73 187.38l5.58 101.25c-15.48 25.94-18.22 58.54-4.19 87.79l58.42 121.86c5.69 11.88 20.21 17.02 32.42 11.48l14.74-6.69c12.21-5.54 17.49-19.66 11.8-31.53l-10.31-21.51zm-41-295.56l158.85-72.05c12.09-5.49 26.21-3.3 35.96 5.56l47.98 43.62-122.81 55.71-135.2 61.32-3.52-63.79c-.71-12.96 6.64-24.88 18.74-30.37zm20.38 252.55c-8.13 3.69-17.82.25-21.61-7.65l-20.62-43.01c-11.37-23.72-.78-52.01 23.6-63.07l265.3-120.33c24.38-11.06 53.47-.76 64.83 22.95l20.62 43.01c3.79 7.91.26 17.34-7.87 21.02L95.57 407.02zM464 384c-61.75 0-112 46.65-112 104 0 13.25 10.75 24 24 24s24-10.75 24-24c0-30.87 28.72-56 64-56s64 25.12 64 56c0 13.25 10.75 24 24 24s24-10.75 24-24c0-57.34-50.25-104-112-104z"
  ]
};
export const faCarBus = {
  prefix: "far",
  iconName: "car-bus",
  icon: [
    640,
    512,
    [],
    "f85a",
    "M336 344.48a23.93 23.93 0 1 0 24 23.93 24 24 0 0 0-24-23.93zm163.32-68.16a32.06 32.06 0 0 0-29.52-19.59h-75.6a32 32 0 0 0-29.41 19.34l-19.59 44.47h173.6zM528 344.48a23.93 23.93 0 1 0 24 23.93 24 24 0 0 0-24-23.93zm58.77-67.21l-14-32.63A111.88 111.88 0 0 0 469.8 177h-75.6a111.88 111.88 0 0 0-102.94 67.69l-14 32.63A79.93 79.93 0 0 0 224 352.45v31.91c0 26 12.72 48.9 32.07 63.47 0 .13-.07.23-.07.35v31.91A32 32 0 0 0 288 512h16a32 32 0 0 0 32-31.91v-15.95h192v15.95A32 32 0 0 0 560 512h16a32 32 0 0 0 32-31.91v-31.91c0-.12-.07-.22-.07-.35 19.35-14.57 32.07-37.48 32.07-63.47v-31.91a79.93 79.93 0 0 0-53.23-75.18zM592 384.36a32 32 0 0 1-32 31.91H304a32 32 0 0 1-32-31.91v-31.91a32 32 0 0 1 32-31.91h6.86l24.52-57a64 64 0 0 1 58.82-38.68h75.6a64 64 0 0 1 58.82 38.68l24.52 57H560a32 32 0 0 1 32 31.91zM176 97.18H96a16 16 0 0 0-16 15.95v111.69a16 16 0 0 0 16 16h80zM48 328.52V99.15c0-28.72 63.77-51.29 144-51.29s144 22.57 144 51.29v58.33a144.12 144.12 0 0 1 48-11.69V99.15C384 26 280.57 0 192 0S0 26 0 99.15v229.37a56 56 0 0 0 56 55.84h8v31.91a32 32 0 0 0 32 31.91h16a32 32 0 0 0 32-31.91v-31.91h48v-31.91a110.91 110.91 0 0 1 1.18-15.95H56a8 8 0 0 1-8-7.98zm32-39.89a24 24 0 1 0 24-23.93 24 24 0 0 0-24 23.93zm181.84-56.56a143.19 143.19 0 0 1 42.16-55v-64a16 16 0 0 0-16-15.95h-80v143.65h50.11z"
  ]
};
export const faCarCrash = {
  prefix: "far",
  iconName: "car-crash",
  icon: [
    640,
    512,
    [],
    "f5e1",
    "M136.89 123.07a31.77 31.77 0 0 0 12.66-22.45l2.16-21.95 12.19 18.36a31.944 31.944 0 0 0 21.75 13.86c9 1.28 17.94-1.17 24.97-6.89l52.16-42.94c10.25-8.42 11.72-23.55 3.28-33.78-8.47-10.23-23.56-11.66-33.78-3.28l-38.31 31.55-27.47-41.31C159.09 3.02 145.28-2.32 132.25.97c-13.06 3.28-22.66 14.47-23.91 27.78l-4.81 49.41-48.66-9.81c-13.09-2.56-26.66 3.3-33.56 14.84-6.94 11.53-5.81 26.23 2.72 36.56l31.53 38.31-41.34 27.48C2.88 193.1-2.31 206.52 1 219.74c3.28 13.22 14.19 22.62 27.78 23.97l49.41 4.78-9.81 48.66c-2.62 12.98 5.78 25.64 18.78 28.27 1.62.31 3.22.47 4.78.47 11.19 0 21.19-7.86 23.5-19.27l13.34-66.27c1.75-8.8-.31-17.97-5.62-25.17-5.34-7.2-13.53-11.84-22.5-12.73l-21.94-2.12 18.31-12.17c7.5-4.95 12.56-12.89 13.91-21.78a32.07 32.07 0 0 0-6.91-24.97l-14-17.02 21.62 4.36c8.68 1.76 17.99-.32 25.24-5.68zm397.86 187.6c-18.54-4.97-53.8 15.31-58.75 33.81s23.69 22.87 42.23 27.83c18.54 4.97 34.21-4.04 39.17-22.54s-4.11-34.13-22.65-39.1zm82.49-34.56L604.86 174.3c-3.94-32.41-27.18-59.17-58.71-67.62L379.59 62.06c-31.53-8.45-65.04 3.11-84.65 29.21l-61.62 81.98c-28.54 10.31-51.79 33.84-60.24 65.37l-35.2 131.37c-3.43 12.8 4.17 25.96 16.97 29.39l15.45 4.14c12.8 3.43 25.96-4.17 29.39-16.97l6.21-23.18 340.01 91.11-6.21 23.18c-3.43 12.8 4.17 25.96 16.97 29.39l15.46 4.14c12.8 3.43 25.96-4.17 29.39-16.97l26.92-100.46 8.28-30.91c8.45-31.54.08-63.54-19.48-86.74zM333.31 120.1c7.89-10.5 21.18-15.08 33.86-11.68l166.56 44.63c12.68 3.4 21.9 14.01 23.48 27.04l7.8 64.14-270.53-72.49 38.83-51.64zm257.05 230.32l-12.42 46.37c-2.28 8.52-11.07 13.6-19.6 11.31L218.33 317c-8.52-2.28-13.6-11.07-11.31-19.6l12.42-46.37c6.85-25.56 33.22-40.79 58.79-33.94l278.19 74.54c25.56 6.85 40.79 33.22 33.94 58.79zM287.47 244.41c-18.54-4.97-34.21 4.05-39.17 22.54s4.11 34.13 22.65 39.1c18.55 4.97 45.54 15.5 50.49-2.99 4.96-18.49-15.42-53.68-33.97-58.65z"
  ]
};
export const faCarGarage = {
  prefix: "far",
  iconName: "car-garage",
  icon: [
    640,
    512,
    [],
    "f5e2",
    "M631.76 168.24L331.67 3.02a24.06 24.06 0 0 0-23.35 0L8.24 168.24c-7.74 4.3-10.52 14.05-6.23 21.79l7.78 14.01c4.3 7.74 14.05 10.52 21.79 6.23L320 51.53l288.41 158.73c7.74 4.3 17.49 1.51 21.79-6.23l7.78-14.01c4.3-7.73 1.51-17.49-6.22-21.78zM192 328c-19.2 0-32 12.76-32 31.91 0 19.14 12.8 31.91 32 31.91s48 3.19 48-15.96c0-19.14-28.8-47.86-48-47.86zm256 0c-19.2 0-48 28.72-48 47.86s28.8 15.96 48 15.96 32-12.76 32-31.91S467.2 328 448 328zm58.21-61.83l-25.79-64.04c-12.19-30.28-41.56-50.12-74.21-50.12H233.78c-32.65 0-62.02 19.84-74.21 50.12l-25.79 64.04C102.04 281.83 80 314.2 80 352v136c0 13.25 10.75 24 24 24h16c13.25 0 24-10.75 24-24v-24h352v24c0 13.25 10.75 24 24 24h16c13.25 0 24-10.75 24-24V352c0-37.8-22.04-70.17-53.79-85.83zM204.1 220.06c4.9-12.18 16.56-20.05 29.69-20.05h172.44c13.13 0 24.78 7.87 29.69 20.05L450.37 256H189.63l14.47-35.94zM512 400c0 8.82-7.18 16-16 16H144c-8.82 0-16-7.18-16-16v-48c0-26.47 21.53-48 48-48h288c26.47 0 48 21.53 48 48v48z"
  ]
};
export const faCarMechanic = {
  prefix: "far",
  iconName: "car-mechanic",
  icon: [
    512,
    512,
    [],
    "f5e3",
    "M503.91 104h-55.98l-24-24 24-24h55.97c5.95 0 9.9-6.31 7.25-11.64-15.19-30.52-49.01-50.04-86.84-42.88-25.65 4.87-46.72 22.99-57.05 46.52H145.01c-12.38-28.17-40.2-48-72.94-48C40.75 0 13.9 18.12.84 44.37-1.81 49.7 2.15 56 8.09 56h55.98l24 24-24 24H8.09c-5.95 0-9.9 6.31-7.25 11.64 15.19 30.52 49.01 50.04 86.84 42.88 25.65-4.86 46.73-22.99 57.05-46.52h222.25c12.38 28.17 40.2 48 72.94 48 31.32 0 58.17-18.12 71.23-44.38 2.66-5.31-1.3-11.62-7.24-11.62zm-69.7 162.17l-25.79-64.04c-12.18-30.29-41.55-50.13-74.2-50.13H161.78c-32.65 0-62.02 19.84-74.21 50.12l-25.79 64.04C30.04 281.83 8 314.2 8 352v136c0 13.25 10.75 24 24 24h16c13.25 0 24-10.75 24-24v-24h352v24c0 13.25 10.75 24 24 24h16c13.25 0 24-10.75 24-24V352c0-37.8-22.04-70.17-53.79-85.83zM132.1 220.05C137 207.87 148.66 200 161.79 200h172.44c13.13 0 24.78 7.87 29.69 20.05l14.47 35.94H117.63l14.47-35.94zM440 400c0 8.82-7.18 16-16 16H72c-8.82 0-16-7.18-16-16v-48c0-26.47 21.53-48 48-48h288c26.47 0 48 21.53 48 48v48zm-320-72.01c-19.2 0-32 12.76-32 31.91s12.8 31.91 32 31.91 48 3.19 48-15.96-28.8-47.86-48-47.86zm256 0c-19.2 0-48 28.72-48 47.86s28.8 15.96 48 15.96 32-12.76 32-31.91-12.8-31.91-32-31.91z"
  ]
};
export const faCarSide = {
  prefix: "far",
  iconName: "car-side",
  icon: [
    640,
    512,
    [],
    "f5e4",
    "M544 192h-16L419.21 56.02A63.99 63.99 0 0 0 369.24 32H155.33c-26.17 0-49.7 15.93-59.42 40.23L48 192v2.26C20.44 201.4 0 226.21 0 256v112c0 8.84 7.16 16 16 16h48c0 53.02 42.98 96 96 96s96-42.98 96-96h128c0 53.02 42.98 96 96 96s96-42.98 96-96h48c8.84 0 16-7.16 16-16v-80c0-53.02-42.98-96-96-96zM280 80h89.24c4.89 0 9.44 2.19 12.49 6l84.8 106H280V80zM140.47 90.06c2.45-6.11 8.28-10.06 14.86-10.06H232v112H99.7l40.77-101.94zM160 432c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm320 0c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm112-96h-29.31c-16.63-28.57-47.24-48-82.69-48s-66.05 19.43-82.69 48H242.69c-16.63-28.57-47.24-48-82.69-48s-66.05 19.43-82.69 48H48v-80c0-8.82 7.18-16 16-16h480c26.47 0 48 21.53 48 48v48z"
  ]
};
export const faCarTilt = {
  prefix: "far",
  iconName: "car-tilt",
  icon: [
    640,
    512,
    [],
    "f5e5",
    "M198.33 314.05c-13.48 13.48-13.51 31.43-.06 44.87 13.44 13.44 31.39 13.42 44.87-.06 13.48-13.48 35.94-31.46 22.5-44.9-13.45-13.45-53.83-13.39-67.31.09zm179.73-179.72c-13.48 13.48-13.54 53.86-.1 67.3 13.44 13.44 31.42-9.02 44.9-22.5 13.48-13.48 13.51-31.42.06-44.87-13.43-13.43-31.38-13.41-44.86.07zM624 464H280.38l-20.26-20.77 247.12-247.12 16.85 16.85c9.3 9.3 24.39 9.3 33.7 0l11.23-11.23c9.3-9.3 9.3-24.39 0-33.7l-95.48-95.48c-22.92-22.92-54.59-31.6-84.24-26.3l-93.68-39.9C265.8-6.35 231.25.34 208.33 23.26L87.27 144.32c-22.92 22.92-29.61 57.46-16.91 87.28l39.9 93.68c-5.3 29.65 3.38 61.32 26.3 84.24L191.03 464H16c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16zM114.2 212.94c-5.11-11.99-2.45-25.7 6.76-34.91L242.03 56.96c9.22-9.22 22.92-11.87 34.91-6.77l59.02 25.14-196.62 196.62-25.14-59.01zm89.75 196.59l-33.7-33.7c-18.58-18.58-18.58-48.81 0-67.39l202.19-202.19c18.58-18.58 48.82-18.58 67.4 0l33.7 33.7c6.19 6.19 6.19 16.27 0 22.46L226.42 409.53c-6.2 6.19-16.28 6.19-22.47 0z"
  ]
};
export const faCarWash = {
  prefix: "far",
  iconName: "car-wash",
  icon: [
    480,
    512,
    [],
    "f5e6",
    "M80 128c23.56 0 42.67-19.1 42.67-42.67S80 0 80 0 37.33 61.77 37.33 85.33 56.44 128 80 128zm160 0c23.56 0 42.67-19.1 42.67-42.67S240 0 240 0s-42.67 61.77-42.67 85.33S216.44 128 240 128zm160 0c23.56 0 42.67-19.1 42.67-42.67S400 0 400 0s-42.67 61.77-42.67 85.33S376.44 128 400 128zm26.21 138.17l-25.79-64.04c-12.18-30.29-41.55-50.13-74.2-50.13H153.78c-32.65 0-62.02 19.84-74.21 50.12l-25.79 64.04C22.04 281.83 0 314.2 0 352v136c0 13.25 10.75 24 24 24h16c13.25 0 24-10.75 24-24v-24h352v24c0 13.25 10.75 24 24 24h16c13.25 0 24-10.75 24-24V352c0-37.8-22.04-70.17-53.79-85.83zM124.1 220.05C129 207.87 140.66 200 153.79 200h172.44c13.13 0 24.78 7.87 29.69 20.05l14.47 35.94H109.63l14.47-35.94zM432 400c0 8.82-7.18 16-16 16H64c-8.82 0-16-7.18-16-16v-48c0-26.47 21.53-48 48-48h288c26.47 0 48 21.53 48 48v48zm-64-72.01c-19.2 0-48 28.72-48 47.86s28.8 15.96 48 15.96 32-12.76 32-31.91-12.8-31.91-32-31.91zm-256 0c-19.2 0-32 12.76-32 31.91s12.8 31.91 32 31.91 48 3.19 48-15.96-28.8-47.86-48-47.86z"
  ]
};
export const faCaravan = {
  prefix: "far",
  iconName: "caravan",
  icon: [
    640,
    512,
    [],
    "f8ff",
    "M624,336H576V160A160,160,0,0,0,416,0H96A96,96,0,0,0,0,96V288a96,96,0,0,0,96,96,96,96,0,0,0,192,0H624a16,16,0,0,0,16-16V352A16,16,0,0,0,624,336ZM192,432a48,48,0,1,1,48-48A48.05,48.05,0,0,1,192,432ZM432,208a16,16,0,0,0,0,32v96H368V144h64Zm96,128H480V136a40,40,0,0,0-40-40H360a40,40,0,0,0-40,40V336H274.69c-16.64-28.57-47.25-48-82.69-48s-66,19.43-82.69,48H96a48.05,48.05,0,0,1-48-48V96A48.05,48.05,0,0,1,96,48H416A112.12,112.12,0,0,1,528,160ZM256,96H128a32,32,0,0,0-32,32v64a32,32,0,0,0,32,32H256a32,32,0,0,0,32-32V128A32,32,0,0,0,256,96Z"
  ]
};
export const faCaravanAlt = {
  prefix: "far",
  iconName: "caravan-alt",
  icon: [
    640,
    512,
    [],
    "e000",
    "M416,96H352a32,32,0,0,0-32,32v64a32,32,0,0,0,32,32h64a32,32,0,0,0,32-32V128A32,32,0,0,0,416,96ZM624,336H576V160A160,160,0,0,0,416,0H96A96,96,0,0,0,0,96V288a96,96,0,0,0,96,96,96,96,0,0,0,192,0H624a16,16,0,0,0,16-16V352A16,16,0,0,0,624,336ZM192,432a48,48,0,1,1,48-48A48.05,48.05,0,0,1,192,432Zm336-96H274.69c-16.64-28.57-47.25-48-82.69-48s-66,19.43-82.69,48H96a48.05,48.05,0,0,1-48-48V96A48.05,48.05,0,0,1,96,48H416A112.12,112.12,0,0,1,528,160ZM256,96H128a32,32,0,0,0-32,32v64a32,32,0,0,0,32,32H256a32,32,0,0,0,32-32V128A32,32,0,0,0,256,96Z"
  ]
};
export const faCaretCircleDown = {
  prefix: "far",
  iconName: "caret-circle-down",
  icon: [
    512,
    512,
    [],
    "f32d",
    "M157.1 216h197.8c10.7 0 16.1 13 8.5 20.5l-98.9 98.3c-4.7 4.7-12.2 4.7-16.9 0l-98.9-98.3c-7.7-7.5-2.3-20.5 8.4-20.5zM504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-48 0c0-110.5-89.5-200-200-200S56 145.5 56 256s89.5 200 200 200 200-89.5 200-200z"
  ]
};
export const faCaretCircleLeft = {
  prefix: "far",
  iconName: "caret-circle-left",
  icon: [
    512,
    512,
    [],
    "f32e",
    "M296 157.1v197.8c0 10.7-13 16.1-20.5 8.5l-98.3-98.9c-4.7-4.7-4.7-12.2 0-16.9l98.3-98.9c7.5-7.7 20.5-2.3 20.5 8.4zM256 504C119 504 8 393 8 256S119 8 256 8s248 111 248 248-111 248-248 248zm0-48c110.5 0 200-89.5 200-200S366.5 56 256 56 56 145.5 56 256s89.5 200 200 200z"
  ]
};
export const faCaretCircleRight = {
  prefix: "far",
  iconName: "caret-circle-right",
  icon: [
    512,
    512,
    [],
    "f330",
    "M216 354.9V157.1c0-10.7 13-16.1 20.5-8.5l98.3 98.9c4.7 4.7 4.7 12.2 0 16.9l-98.3 98.9c-7.5 7.7-20.5 2.3-20.5-8.4zM256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zm0 48C145.5 56 56 145.5 56 256s89.5 200 200 200 200-89.5 200-200S366.5 56 256 56z"
  ]
};
export const faCaretCircleUp = {
  prefix: "far",
  iconName: "caret-circle-up",
  icon: [
    512,
    512,
    [],
    "f331",
    "M354.9 296H157.1c-10.7 0-16.1-13-8.5-20.5l98.9-98.3c4.7-4.7 12.2-4.7 16.9 0l98.9 98.3c7.7 7.5 2.3 20.5-8.4 20.5zM8 256C8 119 119 8 256 8s248 111 248 248-111 248-248 248S8 393 8 256zm48 0c0 110.5 89.5 200 200 200s200-89.5 200-200S366.5 56 256 56 56 145.5 56 256z"
  ]
};
export const faCaretDown = {
  prefix: "far",
  iconName: "caret-down",
  icon: [
    320,
    512,
    [],
    "f0d7",
    "M272 160H48.1c-42.6 0-64.2 51.7-33.9 81.9l111.9 112c18.7 18.7 49.1 18.7 67.9 0l112-112c30-30.1 8.7-81.9-34-81.9zM160 320L48 208h224L160 320z"
  ]
};
export const faCaretLeft = {
  prefix: "far",
  iconName: "caret-left",
  icon: [
    224,
    512,
    [],
    "f0d9",
    "M224 367.952V144.057c0-42.638-51.731-64.151-81.941-33.941l-112 111.943c-18.745 18.745-18.746 49.137 0 67.882l112 111.952C172.208 432.042 224 410.675 224 367.952zM64 256l112-112v224L64 256z"
  ]
};
export const faCaretRight = {
  prefix: "far",
  iconName: "caret-right",
  icon: [
    224,
    512,
    [],
    "f0da",
    "M0 144.048v223.895c0 42.638 51.731 64.151 81.941 33.941l112-111.943c18.745-18.745 18.746-49.137 0-67.882l-112-111.952C51.792 79.958 0 101.325 0 144.048zM160 256L48 368V144l112 112z"
  ]
};
export const faCaretSquareDown = {
  prefix: "far",
  iconName: "caret-square-down",
  icon: [
    448,
    512,
    [],
    "f150",
    "M125.1 208h197.8c10.7 0 16.1 13 8.5 20.5l-98.9 98.3c-4.7 4.7-12.2 4.7-16.9 0l-98.9-98.3c-7.7-7.5-2.3-20.5 8.4-20.5zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
  ]
};
export const faCaretSquareLeft = {
  prefix: "far",
  iconName: "caret-square-left",
  icon: [
    448,
    512,
    [],
    "f191",
    "M272 157.1v197.8c0 10.7-13 16.1-20.5 8.5l-98.3-98.9c-4.7-4.7-4.7-12.2 0-16.9l98.3-98.9c7.5-7.7 20.5-2.3 20.5 8.4zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
  ]
};
export const faCaretSquareRight = {
  prefix: "far",
  iconName: "caret-square-right",
  icon: [
    448,
    512,
    [],
    "f152",
    "M176 354.9V157.1c0-10.7 13-16.1 20.5-8.5l98.3 98.9c4.7 4.7 4.7 12.2 0 16.9l-98.3 98.9c-7.5 7.7-20.5 2.3-20.5-8.4zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
  ]
};
export const faCaretSquareUp = {
  prefix: "far",
  iconName: "caret-square-up",
  icon: [
    448,
    512,
    [],
    "f151",
    "M322.9 304H125.1c-10.7 0-16.1-13-8.5-20.5l98.9-98.3c4.7-4.7 12.2-4.7 16.9 0l98.9 98.3c7.7 7.5 2.3 20.5-8.4 20.5zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
  ]
};
export const faCaretUp = {
  prefix: "far",
  iconName: "caret-up",
  icon: [
    320,
    512,
    [],
    "f0d8",
    "M48.048 352h223.895c42.638 0 64.151-51.731 33.941-81.941l-111.943-112c-18.745-18.745-49.137-18.746-67.882 0l-111.952 112C-16.042 300.208 5.325 352 48.048 352zM160 192l112 112H48l112-112z"
  ]
};
export const faCarrot = {
  prefix: "far",
  iconName: "carrot",
  icon: [
    512,
    512,
    [],
    "f787",
    "M369.8 142.2c22.7-47.5 11-103.8-35.4-142.2-44.5 36.9-56.7 90-37.4 136.1-14-4.9-28.3-8.1-42.5-8.1-48 0-94.1 26.8-116.6 72.8L2.4 478.3c-3 6.2-3.3 13.8 0 20.5 4.1 8.3 12.4 13.1 21 13.1 3.4 0 6.9-.8 10.3-2.4L311.3 374c25-12.2 46.4-32.6 59.6-59.6 15.7-32.1 16.9-67.6 6.1-98.9 45.9 18.7 98.4 6.3 135.1-37.9-38.6-46.4-94.8-58.1-142.3-35.4zm-42.1 151.2c-8.1 16.5-21 29.5-37.5 37.5l-57.3 28L209 335c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l12.2 12.2-110.4 54L173 238.3l34 34.7c4.7 4.7 10.8 7 17 7s12.3-2.3 17-7c9.4-9.4 9.4-24.6 0-33.9l-41.6-40.9c14.8-13.7 34-22.1 55.1-22.1 12.4 0 24.4 2.8 35.7 8.3 19.6 9.6 34.3 26.2 41.4 46.8 7 20.5 5.7 42.7-3.9 62.2z"
  ]
};
export const faCars = {
  prefix: "far",
  iconName: "cars",
  icon: [
    640,
    512,
    [],
    "f85b",
    "M499.32 275.65A32.06 32.06 0 0 0 469.8 256h-75.6a32 32 0 0 0-29.41 19.4L345.2 320h173.6zM336 344a24 24 0 1 0 24 24 24 24 0 0 0-24-24zm250.77-67.4l-14-32.72A111.86 111.86 0 0 0 469.8 176h-75.6a111.86 111.86 0 0 0-102.94 67.88l-14 32.72A80.16 80.16 0 0 0 224 352v32a79.67 79.67 0 0 0 32.07 63.65c0 .12-.07.23-.07.35v32a32 32 0 0 0 32 32h16a32 32 0 0 0 32-32v-16h192v16a32 32 0 0 0 32 32h16a32 32 0 0 0 32-32v-32c0-.12-.07-.23-.07-.35A79.67 79.67 0 0 0 640 384v-32a80.16 80.16 0 0 0-53.23-75.4zM592 384a32 32 0 0 1-32 32H304a32 32 0 0 1-32-32v-32a32 32 0 0 1 32-32h6.86l24.52-57.21A64 64 0 0 1 394.2 224h75.6a64 64 0 0 1 58.82 38.79L553.14 320H560a32 32 0 0 1 32 32zm-64-40a24 24 0 1 0 24 24 24 24 0 0 0-24-24zM275.32 99.65A32.06 32.06 0 0 0 245.8 80h-75.6a32 32 0 0 0-29.41 19.4L121.2 144h173.6zM252.79 252.4l5.32-12.4H80a32 32 0 0 1-32-32v-32a32 32 0 0 1 32-32h6.86l24.52-57.21A64 64 0 0 1 170.2 48h75.6a64 64 0 0 1 58.82 38.79L329.14 144H336c6.62 0 12.41 2.49 17.52 5.93A143.81 143.81 0 0 1 394.2 144h14.88a80.3 80.3 0 0 0-46.31-43.4l-14-32.72A111.86 111.86 0 0 0 245.8 0h-75.6A111.86 111.86 0 0 0 67.26 67.88l-14 32.72A80.16 80.16 0 0 0 0 176v32a79.67 79.67 0 0 0 32.07 63.65c0 .12-.07.23-.07.35v32a32 32 0 0 0 32 32h16a32 32 0 0 0 32-32v-16h100.46a112 112 0 0 1 40.33-35.6zM88 192a24 24 0 1 0 24-24 24 24 0 0 0-24 24z"
  ]
};
export const faCartArrowDown = {
  prefix: "far",
  iconName: "cart-arrow-down",
  icon: [
    576,
    512,
    [],
    "f218",
    "M551.991 64H144.28l-8.726-44.608C133.35 8.128 123.478 0 112 0H12C5.373 0 0 5.373 0 12v24c0 6.627 5.373 12 12 12h80.24l69.594 355.701C150.796 415.201 144 430.802 144 448c0 35.346 28.654 64 64 64s64-28.654 64-64a63.681 63.681 0 0 0-8.583-32h145.167a63.681 63.681 0 0 0-8.583 32c0 35.346 28.654 64 64 64 35.346 0 64-28.654 64-64 0-18.136-7.556-34.496-19.676-46.142l1.035-4.757c3.254-14.96-8.142-29.101-23.452-29.101H203.76l-9.39-48h312.405c11.29 0 21.054-7.869 23.452-18.902l45.216-208C578.695 78.139 567.299 64 551.991 64zM208 472c-13.234 0-24-10.766-24-24s10.766-24 24-24 24 10.766 24 24-10.766 24-24 24zm256 0c-13.234 0-24-10.766-24-24s10.766-24 24-24 24 10.766 24 24-10.766 24-24 24zm23.438-200H184.98l-31.31-160h368.548l-34.78 160zm-91.923-59.515l-51.029 51.029c-4.686 4.686-12.284 4.686-16.971 0l-51.029-51.029c-7.56-7.56-2.206-20.485 8.485-20.485H312v-52c0-6.627 5.373-12 12-12h24c6.627 0 12 5.373 12 12v52h27.029c10.691 0 16.045 12.926 8.486 20.485z"
  ]
};
export const faCartPlus = {
  prefix: "far",
  iconName: "cart-plus",
  icon: [
    576,
    512,
    [],
    "f217",
    "M551.991 64H144.28l-8.726-44.608C133.35 8.128 123.478 0 112 0H12C5.373 0 0 5.373 0 12v24c0 6.627 5.373 12 12 12h80.24l69.594 355.701C150.796 415.201 144 430.802 144 448c0 35.346 28.654 64 64 64s64-28.654 64-64a63.681 63.681 0 0 0-8.583-32h145.167a63.681 63.681 0 0 0-8.583 32c0 35.346 28.654 64 64 64s64-28.654 64-64c0-18.136-7.556-34.496-19.676-46.142l1.035-4.757c3.254-14.96-8.142-29.101-23.452-29.101H203.76l-9.39-48h312.405c11.29 0 21.054-7.869 23.452-18.902l45.216-208C578.695 78.139 567.299 64 551.991 64zM464 424c13.234 0 24 10.766 24 24s-10.766 24-24 24-24-10.766-24-24 10.766-24 24-24zm-256 0c13.234 0 24 10.766 24 24s-10.766 24-24 24-24-10.766-24-24 10.766-24 24-24zm279.438-152H184.98l-31.31-160h368.548l-34.78 160zM272 200v-16c0-6.627 5.373-12 12-12h32v-32c0-6.627 5.373-12 12-12h16c6.627 0 12 5.373 12 12v32h32c6.627 0 12 5.373 12 12v16c0 6.627-5.373 12-12 12h-32v32c0 6.627-5.373 12-12 12h-16c-6.627 0-12-5.373-12-12v-32h-32c-6.627 0-12-5.373-12-12z"
  ]
};
export const faCashRegister = {
  prefix: "far",
  iconName: "cash-register",
  icon: [
    512,
    512,
    [],
    "f788",
    "M168 296h-16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zm-32-48c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-16zm96 0c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-16zm128 48h-16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zm48-64h-16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zm103.4 147.5l-25.5-178.3c-3.4-23.6-23.6-41.2-47.5-41.2H208v-32h96c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h96v32H73.6c-23.9 0-44.1 17.6-47.5 41.2L.6 379.5c-.4 3-.6 6-.6 9.1V464c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48v-75.5c0-3-.2-6-.6-9zM80 80V48h192v32H80zm-6.4 128h364.7l22.9 160H50.8l22.8-160zM464 464H48v-48h416v48zM328 248c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-16zm-64 48h-16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16z"
  ]
};
export const faCassetteTape = {
  prefix: "far",
  iconName: "cassette-tape",
  icon: [
    512,
    512,
    [],
    "f8ab",
    "M144 288h224a64 64 0 0 0 0-128H144a64 64 0 0 0 0 128zm224-80a16 16 0 1 1-16 16 16 16 0 0 1 16-16zm-162.27 0h100.54a57.52 57.52 0 0 0 0 32H205.73a57.52 57.52 0 0 0 0-32zM144 208a16 16 0 1 1-16 16 16 16 0 0 1 16-16zM464 64H48a48 48 0 0 0-48 48v288a48 48 0 0 0 48 48h416a48 48 0 0 0 48-48V112a48 48 0 0 0-48-48zM141.67 400l16-32h196.66l16 32zM464 400h-40l-40-80H128l-40 80H48V112h416z"
  ]
};
export const faCat = {
  prefix: "far",
  iconName: "cat",
  icon: [
    576,
    512,
    [],
    "f6be",
    "M416 128c-8.84 0-16 7.16-16 16s7.16 16 16 16 16-7.16 16-16-7.16-16-16-16zM547.53 4.15A47.971 47.971 0 0 0 528.01 0c-11.64 0-23.13 4.23-32.12 12.32L456.25 48h-16.49l-39.64-35.68a48.032 48.032 0 0 0-51.65-8.17C331.16 11.87 320 29.04 320 48v112c0 4.24.85 8.24 1.25 12.38l-47 7.12c-67.48 10.23-124.62 46.4-162.25 97.52V184c0-48.53-39.47-88-88-88-13.25 0-24 10.75-24 24 0 13.47 11.12 24.37 24.68 23.99C47.02 143.37 64 164.57 64 186.92V399.3c0 73.41 39.4 112.7 88 112.7h184c8.84 0 16-7.16 16-16 0-17.67-14.33-32-32-32h-16.14c-.11-7.37-.78-14.63-1.85-21.81L384 393.95V480c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V270.2c38.07-22.2 64-63.03 64-110.19V48c0-18.95-11.16-36.13-28.47-43.85zM464 464h-32v-98.02c0-11.45-6.16-22.09-16.09-27.77-9.91-5.69-22.22-5.62-32.12.19l-96.35 56.68c-12.08-24.98-30.23-46.88-53.45-63.11-7.52-5.26-18.07-2.21-22.53 5.81l-7.44 13.39c-3.97 7.15-2.55 16.49 4.07 21.29 29.22 21.17 46.87 55.04 47.63 91.54H152c-22.06 0-40-17.94-40-40 0-99.28 71.25-182.16 169.44-197.03l53.57-8.12C356.4 259.74 398.75 288 448 288c5.48 0 10.7-.95 16-1.62V464zm64-304c0 44.18-35.82 80-80 80s-80-35.82-80-80V48l53.33 48h53.33L528 48v112zm-64-16c0 8.84 7.16 16 16 16s16-7.16 16-16-7.16-16-16-16-16 7.16-16 16z"
  ]
};
export const faCatSpace = {
  prefix: "far",
  iconName: "cat-space",
  icon: [
    640,
    512,
    [],
    "e001",
    "M448,0A176,176,0,0,0,272,176c0,1.32227.168,2.60156.19727,3.916C205.63672,190.57422,149.23633,226.43555,112,277.01562V184A88.08953,88.08953,0,0,0,24,96a23.99716,23.99716,0,1,0,.6875,47.98438C47.03125,143.375,64,164.5625,64,186.92188v212.375C64,472.70312,103.40625,512,152,512H336a15.9908,15.9908,0,0,0,16-16,32.01159,32.01159,0,0,0-32-32H303.875A163.00191,163.00191,0,0,0,302,442.1875l82-48.23438V480a32.01159,32.01159,0,0,0,32,32h64a32.01159,32.01159,0,0,0,32-32V339.81836C577.51953,314.19727,624,250.59375,624,176A175.99871,175.99871,0,0,0,448,0Zm0,48a127.06647,127.06647,0,0,1,72.9375,23.0625L480,112H416L375.0625,71.0625A127.06647,127.06647,0,0,1,448,48Zm56,128a16,16,0,1,1-16-16A15.9908,15.9908,0,0,1,504,176Zm-80,0a16,16,0,1,1-16-16A15.9908,15.9908,0,0,1,424,176ZM287.4375,395.07812A163.5365,163.5365,0,0,0,234,331.96875c-7.53125-5.26563-18.09375-2.20313-22.53125,5.8125l-7.4375,13.39063c-3.96875,7.14062-2.5625,16.48437,4.0625,21.28124A115.85626,115.85626,0,0,1,255.71875,464H152a40.037,40.037,0,0,1-40-40c0-98.66406,70.42969-180.97852,167.67188-196.59961A176.345,176.345,0,0,0,382.38672,339.22656ZM464,464H432V365.98438a31.91955,31.91955,0,0,0-3.96094-15.19336A162.0303,162.0303,0,0,0,464,351.19336ZM448,304A128.1454,128.1454,0,0,1,320,176c0-32.16992,12.334-61.25391,32-83.76367V176a96,96,0,0,0,192,0V92.23633C563.666,114.74609,576,143.83008,576,176A128.14414,128.14414,0,0,1,448,304ZM146.94531,68.76953l39.71094,16.56055,16.5625,39.71094a5.32345,5.32345,0,0,0,9.53906,0l16.5586-39.71094,39.71484-16.56055a5.336,5.336,0,0,0,0-9.541l-39.71484-16.5586L212.75781,2.957a5.325,5.325,0,0,0-9.53906,0l-16.5625,39.71289-39.71094,16.5586a5.336,5.336,0,0,0,0,9.541Z"
  ]
};
export const faCauldron = {
  prefix: "far",
  iconName: "cauldron",
  icon: [
    448,
    512,
    [],
    "f6bf",
    "M448 196v-24c0-6.63-6.27-12-14-12H14c-7.73 0-14 5.37-14 12v24c0 6.63 6.27 12 14 12h29.63C16.35 250.46 0 299.55 0 345.6c0 39.08 11.82 70.65 32 95.53V488c0 13.25 10.75 24 24 24s24-10.75 24-24v-7.49c38.95 21.3 89.14 31.49 144 31.49s105.05-10.19 144-31.49V488c0 13.25 10.75 24 24 24s24-10.75 24-24v-46.87c20.18-24.88 32-56.45 32-95.53 0-46.04-16.35-95.13-43.63-137.6H434c7.73 0 14-5.37 14-12zm-54.51 188H392c.49 0 .89.25 1.37.28C367.36 455.26 269.65 464 224 464s-143.36-8.74-169.37-79.72c.48-.03.88-.28 1.37-.28h-1.49C50.44 372.78 48 360.14 48 345.6c0-45.61 21.15-97.83 54.92-137.6h242.17C378.85 247.77 400 299.99 400 345.6c0 14.54-2.44 27.18-6.51 38.4zM160 64c17.67 0 32-14.33 32-32S177.67 0 160 0s-32 14.33-32 32 14.33 32 32 32zm112 64c26.51 0 48-21.49 48-48s-21.49-48-48-48-48 21.49-48 48 21.49 48 48 48z"
  ]
};
export const faCctv = {
  prefix: "far",
  iconName: "cctv",
  icon: [
    576,
    512,
    [],
    "f8ac",
    "M573.86 256.4a30.75 30.75 0 0 0-16.38-17.09l-33.8-14.86c20.74-14.36 17.57-46.33-6.25-55.86L139.24 2.32C119.9-5.41 104.23 8 99.57 16.15L4.23 183a32 32 0 0 0 16.85 45.94l164 67.92L143.37 408H48v-40a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v128a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-40h112a24 24 0 0 0 22.47-15.56l46.95-125.21 75.92 31.45c12.8 4.65 25-1.14 27.89-2.94l20.79-13 136.82 60.16.09.06a31.15 31.15 0 0 0 40.75-16l41.65-94.83a30.62 30.62 0 0 0 .53-23.73zM314.8 298.65L54.93 191l79.16-138.51 337.3 148.29z"
  ]
};
export const faCertificate = {
  prefix: "far",
  iconName: "certificate",
  icon: [
    512,
    512,
    [],
    "f0a3",
    "M489.199 255.927c41.041-40.173 24.263-102.49-31.145-116.634C473.43 85.289 427.935 38 372.589 53.775 358.41-1.828 295.346-17.915 256 22.621 242.445 8.655 226.954.019 205.706.018c-29.388-.001-57.144 17.868-66.295 53.757-54.95-15.663-100.976 31.042-85.465 85.518-55.295 14.115-72.274 76.374-31.145 116.634-40.946 40.08-24.367 102.464 31.145 116.634-15.512 54.481 30.59 101.158 85.465 85.518C153.747 514.3 216.434 529.714 256 489.25c39.511 40.408 102.326 24.759 116.589-31.171 55.007 15.678 100.937-31.177 85.465-85.518 55.295-14.115 72.274-76.374 31.145-116.634zm-31.205 36.574c11.133 10.539 5.95 29.28-8.665 32.775l-50.903 12.992 14.349 50.387c4.055 14.491-9.607 28.165-24.099 24.108l-50.37-14.354-12.987 50.92c-3.525 14.75-22.608 19.626-32.764 8.668L256 420.621l-36.554 37.376c-10.263 10.849-29.158 6.421-32.764-8.668l-12.987-50.92-50.37 14.354c-14.489 4.056-28.154-9.615-24.099-24.108l14.349-50.387-50.903-12.992c-14.609-3.494-19.803-22.231-8.665-32.775l37.363-36.566-37.363-36.566c-11.133-10.539-5.95-29.28 8.665-32.775l50.903-12.992-14.349-50.387c-4.054-14.49 9.605-28.166 24.099-24.108l50.37 14.354 12.987-50.92c3.476-14.546 22.503-19.514 32.764-8.668L256 91.525l36.554-37.652c10.382-10.974 29.328-5.71 32.764 8.668l12.987 50.92 50.37-14.354c14.488-4.056 28.154 9.615 24.099 24.108l-14.349 50.387 50.903 12.992c14.609 3.494 19.802 22.231 8.665 32.775l-37.363 36.566 37.364 36.566z"
  ]
};
export const faChair = {
  prefix: "far",
  iconName: "chair",
  icon: [
    448,
    512,
    [],
    "f6c0",
    "M445.13 326.27l-10.66-31.97c-7.33-22.02-27.44-36.74-50.44-37.87L384 128C384 57.31 326.69 0 256 0h-64C121.31 0 64 57.31 64 128l-.03 128.43c-23 1.13-43.11 15.85-50.41 37.84L2.85 326.3c-5.66 17.03-2.78 35.89 7.72 50.44 5.57 7.73 13.02 13.65 21.41 17.65L32 496c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-96h288.04l-.04 96c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16l.04-101.61c8.39-4 15.84-9.92 21.41-17.65 10.49-14.55 13.37-33.41 7.68-50.47zM296 59.13c23.8 13.88 40 39.39 40 68.87v128h-40V59.13zM200 48h48v208h-48V48zm-48 11.13V256h-40V128c0-29.48 16.2-54.99 40-68.87zM48.38 341.48l10.72-32.03c1.06-3.27 4.12-5.45 7.56-5.45h314.69c3.44 0 6.5 2.19 7.59 5.48l10.66 31.97c1.77 5.33-2.24 10.55-7.59 10.55H56c-5.42 0-9.33-5.28-7.62-10.52z"
  ]
};
export const faChairOffice = {
  prefix: "far",
  iconName: "chair-office",
  icon: [
    448,
    512,
    [],
    "f6c1",
    "M64 224v-64c0-17.67-14.33-32-32-32S0 142.33 0 160v64c0 17.67 14.33 32 32 32s32-14.33 32-32zm352-96c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32s32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm-13.53 166.3c-7.34-22.03-27.46-36.75-50.47-37.88V64c0-35.35-28.65-64-64-64H160c-35.35 0-64 28.65-64 64v192.42c-23.01 1.12-43.13 15.84-50.43 37.84L34.85 326.3c-5.66 17.03-2.78 35.89 7.72 50.44C53.07 391.31 70.04 400 88.01 400H200v50.01c-31.93 4.97-57.99 19.43-69.85 38.56-6.41 10.34 2.41 23.43 15.02 23.43h157.66c12.61 0 21.44-13.09 15.02-23.43-11.86-19.13-37.92-33.59-69.85-38.56V400h112c17.97 0 34.94-8.69 45.45-23.27 10.5-14.55 13.38-33.41 7.69-50.47l-10.67-31.96zM144 64c0-8.82 7.18-16 16-16h128c8.82 0 16 7.18 16 16v192H144V64zm216 288H88.01c-5.42 0-9.33-5.28-7.62-10.52l10.72-32.03c1.06-3.27 4.12-5.45 7.56-5.45h250.67c3.44 0 6.5 2.19 7.6 5.48l10.66 31.97c1.77 5.35-2.26 10.55-7.6 10.55z"
  ]
};
export const faChalkboard = {
  prefix: "far",
  iconName: "chalkboard",
  icon: [
    640,
    512,
    [],
    "f51b",
    "M80 48h480v368h48V40c0-22.06-17.94-40-40-40H72C49.94 0 32 17.94 32 40v376h48V48zm544 416H512v-80c0-17.67-14.33-32-32-32H288c-17.67 0-32 14.33-32 32v80H16c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16zm-160 0H304v-64h160v64z"
  ]
};
export const faChalkboardTeacher = {
  prefix: "far",
  iconName: "chalkboard-teacher",
  icon: [
    640,
    512,
    [],
    "f51c",
    "M226.79 342.02C199 342.02 192.02 352 160 352c-31.97 0-38.95-9.98-66.79-9.98C21.12 342.02 0 403 0 434.67V472c0 22.09 17.91 40 40 40h240c22.09 0 40-17.91 40-40v-37.33c0-42.72-30.58-92.65-93.21-92.65zM272 464H48v-29.33c0-14.01 8.15-44.65 45.21-44.65 17.24 0 29.56 9.98 66.79 9.98 37.37 0 49.49-9.98 66.79-9.98 37.02 0 45.21 30.58 45.21 44.65V464zM160 320c53.02 0 96-42.98 96-96s-42.98-96-96-96-96 42.98-96 96 42.98 96 96 96zm0-144c26.47 0 48 21.53 48 48s-21.53 48-48 48-48-21.53-48-48 21.53-48 48-48zM592 0H208c-26.47 0-48 22.25-48 49.59V96c9.69 0 32.27 3.13 48 9.52V48h384v320h-48v-48c0-17.67-14.33-32-32-32H384c-17.67 0-32 14.33-32 32v96h240c26.47 0 48-22.25 48-49.59V49.59C640 22.25 618.47 0 592 0zm-96 368h-96v-32h96v32z"
  ]
};
export const faChargingStation = {
  prefix: "far",
  iconName: "charging-station",
  icon: [
    576,
    512,
    [],
    "f5e7",
    "M120.57 224h42.39l-8.78 54.77c-1.28 4.74 2.86 9.23 8.34 9.23 2.98 0 5.85-1.37 7.42-3.74l66.93-99.28c3.3-4.99-.82-11.26-7.42-11.26h-41.22l8.28-36.28c1.45-4.76-2.66-9.43-8.28-9.43h-48.57c-4.3 0-7.93 2.78-8.5 6.51l-19.1 81c-.67 4.49 3.33 8.48 8.51 8.48zM560 128h-16V80c0-8.84-7.16-16-16-16s-16 7.16-16 16v48h-32V80c0-8.84-7.16-16-16-16s-16 7.16-16 16v48h-16c-8.84 0-16 7.16-16 16v48c0 35.76 23.62 65.69 56 75.93V372c0 15.44-12.56 28-28 28s-28-12.56-28-28v-28c0-48.53-39.47-88-88-88h-8V48c0-26.51-21.49-48-48-48H80C53.49 0 32 21.49 32 48v416H8c-4.42 0-8 3.58-8 8v32c0 4.42 3.58 8 8 8h336c4.42 0 8-3.58 8-8v-32c0-4.42-3.58-8-8-8h-24V304h8c22.06 0 40 17.94 40 40v28c0 41.91 34.09 76 76 76s76-34.09 76-76V267.93c32.38-10.24 56-40.17 56-75.93v-48c0-8.84-7.16-16-16-16zM272 464H80V48h192v416zm256-272c0 17.64-14.36 32-32 32s-32-14.36-32-32v-16h64v16z"
  ]
};
export const faChartArea = {
  prefix: "far",
  iconName: "chart-area",
  icon: [
    512,
    512,
    [],
    "f1fe",
    "M500 400c6.6 0 12 5.4 12 12v24c0 6.6-5.4 12-12 12H12c-6.6 0-12-5.4-12-12V76c0-6.6 5.4-12 12-12h24c6.6 0 12 5.4 12 12v324h452zM372 128.7l-84 56-85.1-85.1c-5.5-5.5-14.8-4.4-18.8 2.3L96 256v96h384l-90.3-218.1c-3-6.9-11.5-9.4-17.7-5.2zM144 269.3l57.5-103.2 80.4 80.4c71.8-47.9 8.2-5.4 80.7-53.8L407.2 304H144v-34.7z"
  ]
};
export const faChartBar = {
  prefix: "far",
  iconName: "chart-bar",
  icon: [
    512,
    512,
    [],
    "f080",
    "M396.8 352h22.4c6.4 0 12.8-6.4 12.8-12.8V108.8c0-6.4-6.4-12.8-12.8-12.8h-22.4c-6.4 0-12.8 6.4-12.8 12.8v230.4c0 6.4 6.4 12.8 12.8 12.8zm-192 0h22.4c6.4 0 12.8-6.4 12.8-12.8V140.8c0-6.4-6.4-12.8-12.8-12.8h-22.4c-6.4 0-12.8 6.4-12.8 12.8v198.4c0 6.4 6.4 12.8 12.8 12.8zm96 0h22.4c6.4 0 12.8-6.4 12.8-12.8V204.8c0-6.4-6.4-12.8-12.8-12.8h-22.4c-6.4 0-12.8 6.4-12.8 12.8v134.4c0 6.4 6.4 12.8 12.8 12.8zM496 400H48V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v336c0 17.67 14.33 32 32 32h464c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16zm-387.2-48h22.4c6.4 0 12.8-6.4 12.8-12.8v-70.4c0-6.4-6.4-12.8-12.8-12.8h-22.4c-6.4 0-12.8 6.4-12.8 12.8v70.4c0 6.4 6.4 12.8 12.8 12.8z"
  ]
};
export const faChartLine = {
  prefix: "far",
  iconName: "chart-line",
  icon: [
    512,
    512,
    [],
    "f201",
    "M117.65 277.65c6.25 6.25 16.38 6.25 22.63 0L192 225.94l84.69 84.69c6.25 6.25 16.38 6.25 22.63 0L409.54 200.4l29.49 29.5c15.12 15.12 40.97 4.41 40.97-16.97V112c0-8.84-7.16-16-16-16H363.07c-21.38 0-32.09 25.85-16.97 40.97l29.5 29.49-87.6 87.6-84.69-84.69c-6.25-6.25-16.38-6.25-22.63 0l-74.34 74.34c-6.25 6.25-6.25 16.38 0 22.63l11.31 11.31zM496 400H48V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v336c0 17.67 14.33 32 32 32h464c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16z"
  ]
};
export const faChartLineDown = {
  prefix: "far",
  iconName: "chart-line-down",
  icon: [
    512,
    512,
    [],
    "f64d",
    "M180.69 246.62c6.25 6.25 16.38 6.25 22.63 0L288 161.94l87.6 87.6-29.5 29.49c-15.12 15.12-4.41 40.97 16.97 40.97H464c8.84 0 16-7.16 16-16V203.07c0-21.38-25.85-32.09-40.97-16.97l-29.49 29.5-110.23-110.22c-6.25-6.25-16.38-6.25-22.63 0L192 190.06l-51.72-51.72c-6.25-6.25-16.38-6.25-22.63 0l-11.31 11.31c-6.25 6.25-6.25 16.38 0 22.63l74.35 74.34zM496 400H48V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v336c0 17.67 14.33 32 32 32h464c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16z"
  ]
};
export const faChartNetwork = {
  prefix: "far",
  iconName: "chart-network",
  icon: [
    640,
    512,
    [],
    "f78a",
    "M568 368c-19.1 0-36.3 7.6-49.2 19.7L440.6 343c4.5-12.2 7.4-25.2 7.4-39 0-61.9-50.1-112-112-112-8.4 0-16.6 1.1-24.4 2.9l-32.2-69c15-13.2 24.6-32.3 24.6-53.8 0-39.8-32.2-72-72-72s-72 32.2-72 72 32.2 72 72 72c.9 0 1.8-.2 2.7-.3l33.5 71.7C241.5 235.9 224 267.8 224 304c0 61.9 50.1 112 112 112 30.7 0 58.6-12.4 78.8-32.5l82.2 47c-.4 3.1-1 6.3-1 9.5 0 39.8 32.2 72 72 72s72-32.2 72-72-32.2-72-72-72zM232 96c-13.2 0-24-10.8-24-24s10.8-24 24-24 24 10.8 24 24-10.8 24-24 24zm104 272c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm232 96c-13.2 0-24-10.8-24-24s10.8-24 24-24 24 10.8 24 24-10.8 24-24 24zm-54.4-261.2l-19.2-25.6-48 36 19.2 25.6 48-36zM576 192c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zM152 320h48v-32h-48v32zm-88-80c-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64-28.7-64-64-64z"
  ]
};
export const faChartPie = {
  prefix: "far",
  iconName: "chart-pie",
  icon: [
    544,
    512,
    [],
    "f200",
    "M511.96 223.2C503.72 103.74 408.26 8.28 288.8.04c-.35-.03-.7-.04-1.04-.04C279.11 0 272 7.44 272 16.23V240h223.77c9.14 0 16.82-7.68 16.19-16.8zM320 192V53.51C387.56 70.95 441.05 124.44 458.49 192H320zm-96 96V50.72c0-8.83-7.18-16.21-15.74-16.21-.7 0-1.4.05-2.11.15C86.99 51.49-4.1 155.6.14 280.37 4.47 407.53 113.18 512 240.12 512c.98 0 1.93-.01 2.91-.02 50.4-.63 96.97-16.87 135.26-44.03 7.9-5.6 8.42-17.23 1.57-24.08L224 288zm18.44 175.99l-2.31.01c-100.66 0-188.59-84.84-192.01-185.26-2.91-85.4 50.15-160.37 127.88-187.6v216.74l14.06 14.06 126.22 126.22c-23.16 10.1-48.16 15.5-73.84 15.83zM527.79 288H290.5l158.03 158.03c3.17 3.17 7.41 4.81 11.62 4.81 3.82 0 7.62-1.35 10.57-4.13 38.7-36.46 65.32-85.61 73.13-140.86 1.34-9.46-6.51-17.85-16.06-17.85z"
  ]
};
export const faChartPieAlt = {
  prefix: "far",
  iconName: "chart-pie-alt",
  icon: [
    512,
    512,
    [],
    "f64e",
    "M461.29 288H224V50.71c0-8.83-7.18-16.21-15.74-16.21-.7 0-1.4.05-2.11.15C87.08 51.47-3.96 155.43.13 280.07 4.2 404.1 107.91 507.8 231.93 511.87c2.69.09 5.39.13 8.07.13 121.04 0 220.89-89.66 237.35-206.16 1.33-9.45-6.52-17.84-16.06-17.84zM240 464c-2.15 0-4.33-.04-6.5-.11-98.98-3.25-182.15-86.42-185.4-185.4C45.31 193.22 98.36 118.35 176 91.14V336h244.78C394.15 411.06 322.06 464 240 464zM288.8.04c-.35-.03-.7-.04-1.04-.04C279.1 0 272 7.44 272 16.23V240h223.77c9.14 0 16.82-7.69 16.2-16.8C503.72 103.74 408.26 8.28 288.8.04z"
  ]
};
export const faChartScatter = {
  prefix: "far",
  iconName: "chart-scatter",
  icon: [
    512,
    512,
    [],
    "f7ee",
    "M496 400H48V80a16 16 0 0 0-16-16H16A16 16 0 0 0 0 80v336a32 32 0 0 0 32 32h464a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm-336-80a32 32 0 1 0-32-32 32 32 0 0 0 32 32zm256-160a32 32 0 1 0-32-32 32 32 0 0 0 32 32zm-224 0a32 32 0 1 0-32-32 32 32 0 0 0 32 32zm192 160a32 32 0 1 0-32-32 32 32 0 0 0 32 32zm-96-64a32 32 0 1 0-32-32 32 32 0 0 0 32 32z"
  ]
};
export const faCheck = {
  prefix: "far",
  iconName: "check",
  icon: [
    512,
    512,
    [],
    "f00c",
    "M435.848 83.466L172.804 346.51l-96.652-96.652c-4.686-4.686-12.284-4.686-16.971 0l-28.284 28.284c-4.686 4.686-4.686 12.284 0 16.971l133.421 133.421c4.686 4.686 12.284 4.686 16.971 0l299.813-299.813c4.686-4.686 4.686-12.284 0-16.971l-28.284-28.284c-4.686-4.686-12.284-4.686-16.97 0z"
  ]
};
export const faCheckCircle = {
  prefix: "far",
  iconName: "check-circle",
  icon: [
    512,
    512,
    [],
    "f058",
    "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 48c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532 89.451-200 200-200m140.204 130.267l-22.536-22.718c-4.667-4.705-12.265-4.736-16.97-.068L215.346 303.697l-59.792-60.277c-4.667-4.705-12.265-4.736-16.97-.069l-22.719 22.536c-4.705 4.667-4.736 12.265-.068 16.971l90.781 91.516c4.667 4.705 12.265 4.736 16.97.068l172.589-171.204c4.704-4.668 4.734-12.266.067-16.971z"
  ]
};
export const faCheckDouble = {
  prefix: "far",
  iconName: "check-double",
  icon: [
    448,
    512,
    [],
    "f560",
    "M444.09 166.99l-27.39-28.37c-2.6-1.96-5.53-2.93-8.8-2.93-3.27 0-5.87.98-7.82 2.93L142.81 396.86l-94.88-94.88c-1.96-2.61-4.55-3.91-7.82-3.91-3.27 0-6.21 1.3-8.8 3.91l-27.4 27.38c-2.6 2.61-3.91 5.55-3.91 8.8s1.31 5.87 3.91 7.82l130.1 131.07c2.6 1.96 5.53 2.94 8.8 2.94 3.27 0 5.87-.98 7.82-2.94L444.08 183.6c2.6-2.61 3.91-5.55 3.91-8.8.01-3.24-1.3-5.86-3.9-7.81zM131.88 285.04c2.62 1.97 5.58 2.96 8.88 2.96s5.92-.99 7.89-2.96L353.34 80.35c2.62-2.64 3.95-5.6 3.95-8.88 0-3.28-1.33-5.92-3.95-7.89l-27.63-28.62c-2.62-1.97-5.58-2.96-8.88-2.96s-5.92.99-7.89 2.96L140.76 204.12l-60.41-60.41c-1.97-2.64-4.59-3.95-7.89-3.95s-6.26 1.31-8.88 3.95l-27.63 27.63c-2.62 2.64-3.95 5.6-3.95 8.88 0 3.29 1.33 5.92 3.95 7.89l95.93 96.93z"
  ]
};
export const faCheckSquare = {
  prefix: "far",
  iconName: "check-square",
  icon: [
    448,
    512,
    [],
    "f14a",
    "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zm0 400H48V80h352v352zm-35.864-241.724L191.547 361.48c-4.705 4.667-12.303 4.637-16.97-.068l-90.781-91.516c-4.667-4.705-4.637-12.303.069-16.971l22.719-22.536c4.705-4.667 12.303-4.637 16.97.069l59.792 60.277 141.352-140.216c4.705-4.667 12.303-4.637 16.97.068l22.536 22.718c4.667 4.706 4.637 12.304-.068 16.971z"
  ]
};
export const faCheese = {
  prefix: "far",
  iconName: "cheese",
  icon: [
    512,
    512,
    [],
    "f7ef",
    "M299.83 32h-1.49a32.27 32.27 0 0 0-19.64 7L0 255.87V448a32 32 0 0 0 32 32h448a32 32 0 0 0 32-32V255.87C512 136.05 418 38.2 299.83 32zm3.77 48.4c87.74 7.67 155.63 79.47 159.64 167.42H88.47zM464 432H48V295.89h416z"
  ]
};
export const faCheeseSwiss = {
  prefix: "far",
  iconName: "cheese-swiss",
  icon: [
    512,
    512,
    [],
    "f7f0",
    "M176 319.9a48 48 0 1 0 48 48 48 48 0 0 0-48-48zM299.83 32h-1.49a32.27 32.27 0 0 0-19.64 7L0 255.87V448a32 32 0 0 0 32 32h448a32 32 0 0 0 32-32V255.87C512 136.05 418 38.2 299.83 32zM196.48 163.8A47.9 47.9 0 1 0 270 106.59l33.6-26.15c87.74 7.67 155.63 79.47 159.64 167.42h-53.9a47.59 47.59 0 0 0-82.68 0H88.47zM464 432H48V295.89h278.66a47.59 47.59 0 0 0 82.68 0H464z"
  ]
};
export const faCheeseburger = {
  prefix: "far",
  iconName: "cheeseburger",
  icon: [
    512,
    512,
    [],
    "f7f1",
    "M352 176a16 16 0 1 0-16-16 16 16 0 0 0 16 16zm-96-32a16 16 0 1 0-16-16 16 16 0 0 0 16 16zm-96 32a16 16 0 1 0-16-16 16 16 0 0 0 16 16zm352 112a79.33 79.33 0 0 0-28.1-60.4 8.78 8.78 0 0 0 1.2-1.5 72.49 72.49 0 0 0 .6-75.4C442.3 78.7 352.19 32.1 256 32c-96.1.1-186.31 46.7-229.71 118.7a72.45 72.45 0 0 0 .6 75.4 15.76 15.76 0 0 0 1.2 1.5 79.35 79.35 0 0 0-9.3 111.8 78.09 78.09 0 0 0 15 13.7c-.7 2.8-1.7 5.5-1.7 8.5v34.7a83.73 83.73 0 0 0 83.7 83.7h280.6a83.8 83.8 0 0 0 83.71-83.7v-34.7c0-3-1.1-5.7-1.7-8.5A80 80 0 0 0 512 288zM67.37 175.5c34.9-57.9 109-95.4 188.61-95.5 79.71.1 153.81 37.6 188.72 95.5a24.51 24.51 0 0 1-.2 25.2c-2.9 4.7-7.41 7.4-12.21 7.4H79.67c-4.8 0-9.3-2.7-12.2-7.4a24.73 24.73 0 0 1-.1-25.2zM432 396.3a35.72 35.72 0 0 1-35.7 35.7H115.67A35.72 35.72 0 0 1 80 396.3v-25.6h352zm0-76.3H80a32 32 0 0 1 0-64h144l96 48 96-48h16a32 32 0 1 1 0 64z"
  ]
};
export const faChess = {
  prefix: "far",
  iconName: "chess",
  icon: [
    512,
    512,
    [],
    "f439",
    "M497.59 279.17A31.92 31.92 0 0 0 512 252.44V192a32 32 0 0 0-32-32H288a32 32 0 0 0-32 32v60.5c0 10.92 5.47 21 12.75 25.52L296 299.61v74.77a23.69 23.69 0 0 0-8 17.62v24l-25.6 19.2A16 16 0 0 0 256 448a16 16 0 0 0-6.4-12.8L224 416v-24a23.73 23.73 0 0 0-16.83-22.55c-3.84-25-6.41-50.14-6.41-75.42V256H208a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16h-3.1l26.91-80.41A24 24 0 0 0 209 96h-64.24V64h24a8 8 0 0 0 8-8V40a8 8 0 0 0-8-8h-24V8a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v24h-24a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h24v32H48.5a24 24 0 0 0-22.78 31.59l27 80.41H48a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h8.76v38c0 25.17-2.56 50.23-6.36 75.1C39.93 371.71 32 380.73 32 392v24L6.4 435.2A16 16 0 0 0 0 448v48a16 16 0 0 0 16 16h224a16 16 0 0 0 16-16 16 16 0 0 0 16 16h224a16 16 0 0 0 16-16v-48a16 16 0 0 0-6.4-12.8L480 416v-24a23.69 23.69 0 0 0-8-17.62v-74.82zM175.71 144l-16.33 48.76-5.1 15.24h-50.92l-5.14-15.28L81.87 144zm-17 224H98.82c3.55-25.22 5.94-50.12 5.94-74v-38h48v38c0 23.92 2.4 48.81 5.94 74zM48 464l12.8-9.6L80 440v-24h96v24l19.2 14.4L208 464zm256 0l12.8-9.6L336 440v-24h96v24l19.2 14.4L464 464zm160-219.33l-40 31.74V368h-80v-91.61l-40-31.56V208h32v24h32v-24h32v24h32v-24h32zM384 288a16 16 0 0 0-16 16v32h32v-32a16 16 0 0 0-16-16z"
  ]
};
export const faChessBishop = {
  prefix: "far",
  iconName: "chess-bishop",
  icon: [
    320,
    512,
    [],
    "f43a",
    "M304 464H16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zM0 304c0 51.64 30.14 85.24 64 96v32h48v-67.11l-33.46-10.64C63.78 349.56 48 333.9 48 304c0-74.57 66.13-165.78 101.33-201.84a15.81 15.81 0 0 1 22.27-.24c12.64 11.8 34 35.52 59.22 81.33l-66.13 66.13a16 16 0 0 0 0 22.62L176 283.31a16 16 0 0 0 22.62 0L252.94 229c11.43 27.7 19.06 54.54 19.06 75 0 29.9-15.78 45.56-30.54 50.25L208 364.89V432h48v-32c33.86-10.76 64-44.36 64-96 0-73.38-67.81-197.2-120.6-241.49C213.4 59.09 224 47.05 224 32a32 32 0 0 0-32-32h-64a32 32 0 0 0-32 32c0 15 10.6 27.09 24.6 30.51C67.81 106.8 0 230.62 0 304z"
  ]
};
export const faChessBishopAlt = {
  prefix: "far",
  iconName: "chess-bishop-alt",
  icon: [
    256,
    512,
    [],
    "f43b",
    "M249.6 435.2L224 416v-24c0-12.1-9.1-21.68-20.74-23.34a460.24 460.24 0 0 1-3.2-48.66H208a16 16 0 0 0 16-16v-16a15.8 15.8 0 0 0-13.62-15.52C224 261.59 232 243.33 232 211.37c0-41.66-25.85-100.61-57.95-132.6C184.27 76 192 67.06 192 56a24.07 24.07 0 0 0-24-24H88a24.07 24.07 0 0 0-24 24c0 11.06 7.73 20 18 22.77-32.15 31.99-58 90.94-58 132.6 0 32 8 50.22 21.62 61.11A15.8 15.8 0 0 0 32 288v16a16 16 0 0 0 16 16h7.94a460.24 460.24 0 0 1-3.2 48.66C41.1 370.31 32 379.9 32 392v24L6.4 435.2A16 16 0 0 0 0 448v48a16 16 0 0 0 16 16h224a16 16 0 0 0 16-16v-48a16 16 0 0 0-6.4-12.8zM115.21 110.39a16.3 16.3 0 0 1 25.58 0 220.39 220.39 0 0 1 17.78 26.27L121 174.28a8 8 0 0 0 0 11.32l13.45 13.45a8 8 0 0 0 11.32 0l28.66-28.67c5.8 15.3 9.62 29.88 9.62 41v.55A49.85 49.85 0 0 1 169 247l-9 9v16H96v-16l-9-9a49.83 49.83 0 0 1-15-35.1v-.59c0-25.71 17.81-68.97 43.21-100.92zM154.9 368h-53.8c1.58-16 2.78-31.95 2.84-48h48.12c.06 16.05 1.26 32 2.84 48zM48 464l32-24v-24h96v24l32 24z"
  ]
};
export const faChessBoard = {
  prefix: "far",
  iconName: "chess-board",
  icon: [
    512,
    512,
    [],
    "f43c",
    "M448 384v-64h-64v64zm0-127.93v-64h-64v64zM320.07 448h64v-64h-64zm-127.94 0h64v-64h-64zM64.2 256.1v64h64v-64zM448 64.2h-64v64h64zm-255.87 0h-64v64h64zm-127.93 64v64h64v-64zm255.87-64h-64v64h64zm-64 255.87v64h64v-64zm-64 0h-64v64h64zM384 192.13v-64h-64v64zm-64 127.94h64v-64h-64zm-64-127.94v-64h-64v64zm64 64v-64h-64v64zm-64 0h-64v64h64zm-64-64h-64v64h64zm-64 191.9H64v64h64zM480 0H32A32 32 0 0 0 0 32v448a32 32 0 0 0 32 32h448a32 32 0 0 0 32-32V32a32 32 0 0 0-32-32zm-16 464H48V48h416z"
  ]
};
export const faChessClock = {
  prefix: "far",
  iconName: "chess-clock",
  icon: [
    640,
    512,
    [],
    "f43d",
    "M448.22 416.06a112 112 0 1 0-112-111.95 112 112 0 0 0 112 111.95zm-12.67-122.19L486.46 243a12 12 0 0 1 17 0l5.66 5.65a12 12 0 0 1 0 17l-50.91 50.9a12 12 0 0 1-17 0l-5.65-5.66a12 12 0 0 1-.01-17.02zM600 96h-55.79V80a16 16 0 0 0-16-16h-128a16 16 0 0 0-16 16v16H200.08V48h40a16 16 0 0 0 16-16V16a16 16 0 0 0-16-16H112a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h40v48H40a40 40 0 0 0-40 40v336a40 40 0 0 0 40 40h560a40 40 0 0 0 40-40V136a40 40 0 0 0-40-40zm-8 368H48V144h544zm-399.88-48.09a112 112 0 1 0-112-112 112 112 0 0 0 112 112zm-16-179.91a12 12 0 0 1 12-12h8a12 12 0 0 1 12 12v72a12 12 0 0 1-12 12h-8a12 12 0 0 1-12-12z"
  ]
};
export const faChessClockAlt = {
  prefix: "far",
  iconName: "chess-clock-alt",
  icon: [
    640,
    512,
    [],
    "f43e",
    "M600 96H487.94V48h40a16 16 0 0 0 16-16V16A16 16 0 0 0 528 0H400a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h40v48H256V80a16 16 0 0 0-16-16H112a16 16 0 0 0-16 16v16H40a40 40 0 0 0-40 40v336a40 40 0 0 0 40 40h560a40 40 0 0 0 40-40V136a40 40 0 0 0-40-40zm-8 368H48V144h544zm-400-47.94A112 112 0 1 0 80 304.11a112 112 0 0 0 112 111.95zm-12.67-122.19L230.24 243a12 12 0 0 1 17 0l5.65 5.65a12 12 0 0 1 0 17L202 316.49a12 12 0 0 1-17 0l-5.66-5.66a12 12 0 0 1-.01-16.96zM448 415.91A112 112 0 1 0 336 304a112 112 0 0 0 112 111.91zM432 236a12 12 0 0 1 12-12h8a12 12 0 0 1 12 12v72a12 12 0 0 1-12 12h-8a12 12 0 0 1-12-12z"
  ]
};
export const faChessKing = {
  prefix: "far",
  iconName: "chess-king",
  icon: [
    448,
    512,
    [],
    "f43f",
    "M400 464H48a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h352a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm37.05-281.16A55.37 55.37 0 0 0 391.93 160H248v-56h48a8 8 0 0 0 8-8V64a8 8 0 0 0-8-8h-48V8a8 8 0 0 0-8-8h-32a8 8 0 0 0-8 8v48h-48a8 8 0 0 0-8 8v32a8 8 0 0 0 8 8h48v56H56a55.95 55.95 0 0 0-53.31 73.06L68.51 432h50.54L48.38 218.38A8 8 0 0 1 56 208h335.93a8 8 0 0 1 7.78 10l-70.82 214h50.55l66-199.31a55.35 55.35 0 0 0-8.39-49.85z"
  ]
};
export const faChessKingAlt = {
  prefix: "far",
  iconName: "chess-king-alt",
  icon: [
    320,
    512,
    [],
    "f440",
    "M281.6 435.2L256 416v-24a23.73 23.73 0 0 0-16.83-22.55c-3.83-25-6.41-50.14-6.41-75.42V256H240a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16h-3.1l26.92-80.41A24 24 0 0 0 241 96h-64.24V64h24a8 8 0 0 0 8-8V40a8 8 0 0 0-8-8h-24V8a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v24h-24a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h24v32H80.5a24 24 0 0 0-22.78 31.59l27 80.41H80a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h8.76v38c0 25.17-2.56 50.23-6.36 75.1C71.93 371.71 64 380.73 64 392v24l-25.6 19.2A16 16 0 0 0 32 448v48a16 16 0 0 0 16 16h224a16 16 0 0 0 16-16v-48a16 16 0 0 0-6.4-12.8zM207.72 144l-21.52 64h-50.88l-21.5-64zm-17.29 224H131.1c3.37-24.53 5.66-49.2 5.66-74v-38h48v38c0 24.8 2.29 49.47 5.67 74zM80 464l32-24v-24h96v24l32 24z"
  ]
};
export const faChessKnight = {
  prefix: "far",
  iconName: "chess-knight",
  icon: [
    384,
    512,
    [],
    "f441",
    "M44.05 320.68l14.41 6.41A113 113 0 0 0 32.07 400v32h48v-32a65.49 65.49 0 0 1 36.18-58.57L154.36 318a39.31 39.31 0 0 0 21.71-35.15v-58.78l-15.27 9.06a19.64 19.64 0 0 0-10.26 12.8L143 271a26.2 26.2 0 0 1-15.35 16.78L117.17 292a26.12 26.12 0 0 1-20.36-.38l-33.26-14.8A26.21 26.21 0 0 1 48 252.88V140.53a19.67 19.67 0 0 1 5.75-13.9l7.34-7.34L49.46 96A14 14 0 0 1 48 89.82 9.82 9.82 0 0 1 57.82 80h105.09c86.76 0 157 70.37 157 157.17V432h48V237.17C367.93 124 276 32 162.91 32H57.82A57.89 57.89 0 0 0 0 89.82a62.22 62.22 0 0 0 5.15 24.72 67.51 67.51 0 0 0-5.15 26v112.34a74.26 74.26 0 0 0 44.05 67.8zM80.07 164a20 20 0 1 0 20-20 20 20 0 0 0-20 20zM368 464H16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h352a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16z"
  ]
};
export const faChessKnightAlt = {
  prefix: "far",
  iconName: "chess-knight-alt",
  icon: [
    320,
    512,
    [],
    "f442",
    "M89.69 195.2a13.87 13.87 0 1 0-13.81-13.87 13.84 13.84 0 0 0 13.81 13.87zm223.91 240L288 416v-30.13a78.67 78.67 0 0 0 16-47.13V232.61C304 139.64 228.38 64 135.42 64h-80a55.65 55.65 0 0 0-52.31 74.15 62.19 62.19 0 0 0-3.06 19.56v84.84a67.88 67.88 0 0 0 37 60.43q-15.76 22.09-20.2 51.52A75.61 75.61 0 0 0 32 411.57V416L6.4 435.2A16 16 0 0 0 0 448v48a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-48a16 16 0 0 0-6.4-12.8zM55.43 112h80C201.74 112 256 166.27 256 232.61v106.13a32 32 0 0 1-9.37 22.63L240 368H64.8c-.19-2.14-.78-4.23-.45-6.4 4.34-29 21.48-45.89 46.18-57l34.85-10.86A24.76 24.76 0 0 0 160 271.19v-48.26l-27.12 4.7a14.88 14.88 0 0 0-7.72 9.68l-5.68 18.95A19.76 19.76 0 0 1 108 268.93c-5.54 2.22-10.22 4.61-15.48 4.61a18.67 18.67 0 0 1-7.71-1.74l-25-11.15A19.83 19.83 0 0 1 48 242.55v-84.84c0-7.37 4.39-10.55 9.85-16l-8.71-17.61c-3.3-6.63 1.14-12.1 6.29-12.1zM48 464l32-24v-24h160v24l32 24z"
  ]
};
export const faChessPawn = {
  prefix: "far",
  iconName: "chess-pawn",
  icon: [
    320,
    512,
    [],
    "f443",
    "M304 464H16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zM48 288h32v29.5c0 40.29-3.51 81.23-23.43 114.5h53.57c15-37 17.86-77.35 17.86-114.5V288h64v29.5c0 37.15 2.91 77.49 17.86 114.5h53.57C243.51 398.73 240 357.79 240 317.5V288h32a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16h-31c23.8-21.93 39-53.08 39-88a120 120 0 0 0-240 0c0 34.92 15.16 66.07 39 88H48a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16zM160 80a72 72 0 1 1-72 72 72.08 72.08 0 0 1 72-72z"
  ]
};
export const faChessPawnAlt = {
  prefix: "far",
  iconName: "chess-pawn-alt",
  icon: [
    256,
    512,
    [],
    "f444",
    "M249.6 435.2L224 416v-24a24 24 0 0 0-24-24h2.61c-1.54-16-2.61-32-2.61-48v-32h8a16 16 0 0 0 16-16v-16a15.76 15.76 0 0 0-13.61-15.46A95 95 0 0 0 224 192a96 96 0 1 0-178.42 48.49A15.79 15.79 0 0 0 32 256v16a16 16 0 0 0 16 16h8v32c0 16-1.07 32-2.61 48H56a24 24 0 0 0-24 24v24L6.4 435.2A16 16 0 0 0 0 448v48a16 16 0 0 0 16 16h224a16 16 0 0 0 16-16v-48a16 16 0 0 0-6.4-12.8zM152 288v30c0 16.69 1 33.35 2.54 50h-53.08c1.54-16.62 2.54-33.28 2.54-50v-30zm-24-144a48 48 0 1 1-48 48 48.05 48.05 0 0 1 48-48zM48 464l32-24v-24h96v24l32 24z"
  ]
};
export const faChessQueen = {
  prefix: "far",
  iconName: "chess-queen",
  icon: [
    512,
    512,
    [],
    "f445",
    "M256 112a56 56 0 1 0-56-56 56 56 0 0 0 56 56zm248.87 72.16l-28.51-15.92a15.09 15.09 0 0 0-8.45-2.59 17.59 17.59 0 0 0-13.84 7.27A47.48 47.48 0 0 1 416 192a50.79 50.79 0 0 1-9.16-.85C383.7 186.86 368 164.93 368 141.4a13.4 13.4 0 0 0-13.4-13.4h-38.77c-6 0-11.61 4-12.86 9.91a48 48 0 0 1-93.94 0c-1.25-5.92-6.82-9.91-12.86-9.91H157.4a13.4 13.4 0 0 0-13.4 13.4c0 25.69-19 48.75-44.67 50.49-1.12.07-2.23.11-3.33.11a47.47 47.47 0 0 1-38.21-19.26 17.17 17.17 0 0 0-13.61-7.13 15.16 15.16 0 0 0-8.48 2.59l-28.57 16a16 16 0 0 0-5.44 20.47L109.84 432H163L69.91 236.32A94.78 94.78 0 0 0 96 240c2.17 0 4.37-.07 6.57-.22 34.06-2.31 63.1-23 78.23-52.22a95.81 95.81 0 0 0 150.29.14c13.29 26 37.51 45.18 67 50.64A98.41 98.41 0 0 0 416 240a96.13 96.13 0 0 0 26-3.55L349 432h53.16l108.15-227.37a16 16 0 0 0-5.44-20.47zM432 464H80a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h352a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16z"
  ]
};
export const faChessQueenAlt = {
  prefix: "far",
  iconName: "chess-queen-alt",
  icon: [
    256,
    512,
    [],
    "f446",
    "M223.67 416v-24c0-11.22-7.86-20.21-18.25-22.84-3.12-22.26-5.34-44.64-5.34-67.13V256h24a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16h-7.5l38.59-105a8.16 8.16 0 0 0-2.76-10.42l-12.15-8.11c-3.8-2.53-8.61-1.24-11.33 2.39-14 18.65-43.76 9-43.76-16.06a6.82 6.82 0 0 0-6.85-6.8h-19.71a6.6 6.6 0 0 0-6.54 5 24.4 24.4 0 0 1-47.76 0 6.59 6.59 0 0 0-6.54-5H78.06a6.82 6.82 0 0 0-6.82 6.82c0 25.32-30 34.55-43.83 16-2.44-3.28-7.21-5-11.23-2.31L4 92.6A8.16 8.16 0 0 0 1.24 103l38.59 105h-7.5a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h24v46c0 22.44-2.21 44.76-5.33 67-10.78 2.35-19 11.5-19 23v24L6.39 435.2A16 16 0 0 0 0 448v48a16 16 0 0 0 16 16h223.64a16 16 0 0 0 16-16v-48a16 16 0 0 0-6.39-12.8zM93.26 127.36a71.71 71.71 0 0 0 69.71.08 70.83 70.83 0 0 0 26.82 14.43L166.92 208H89.46l-22.89-66.19a71.44 71.44 0 0 0 26.69-14.45zM156.92 368H99.46c2.78-21.9 4.77-43.89 4.77-66v-46h47.92v46c0 22.11 1.99 44.1 4.77 66zm-109 96l31.95-24v-24h95.86v24l31.95 24zm80.27-408a28 28 0 1 0-28-28 28 28 0 0 0 28 28z"
  ]
};
export const faChessRook = {
  prefix: "far",
  iconName: "chess-rook",
  icon: [
    384,
    512,
    [],
    "f447",
    "M368 464H16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h352a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zM346 32H38A38 38 0 0 0 0 70v139.43a32 32 0 0 0 11 24.14l37 32.21c0 48.49 1.54 93-11.85 166.22h49C98 356.41 96 309.53 96 238.22l-48-41.78V80h64v48h48V80h64v48h48V80h64v116.44l-48 41.78C288 309 286 356.6 298.86 432h49C334.47 358.81 336 314 336 265.78l37-32.21a32 32 0 0 0 11-24.14V70a38 38 0 0 0-38-38zM192 224a32 32 0 0 0-32 32v64h64v-64a32 32 0 0 0-32-32z"
  ]
};
export const faChessRookAlt = {
  prefix: "far",
  iconName: "chess-rook-alt",
  icon: [
    320,
    512,
    [],
    "f448",
    "M313.6 435.2L288 416v-24c0-11.17-7.79-20.14-18.13-22.81l-5.34-117.63 26.73-20.15A32 32 0 0 0 304 205.86V96a32 32 0 0 0-32-32H48a32 32 0 0 0-32 32v110a32 32 0 0 0 12.78 25.58l26.69 20.05-5.34 117.6C39.79 371.86 32 380.83 32 392v24L6.4 435.2A16 16 0 0 0 0 448v48a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-48a16 16 0 0 0-6.4-12.8zM64 112h40v32h32v-32h48v32h32v-32h40v85.88l-40.53 30.56L221.55 368H98.45l6.08-139.59L64 197.94zM48 464l32-24v-24h160v24l32 24zm136-216.41a23.59 23.59 0 0 0-47.18 0V288H184z"
  ]
};
export const faChevronCircleDown = {
  prefix: "far",
  iconName: "chevron-circle-down",
  icon: [
    512,
    512,
    [],
    "f13a",
    "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm8.5-107.5l122.8-122.8c4.7-4.7 4.7-12.3 0-17l-22.6-22.6c-4.7-4.7-12.3-4.7-17 0L256 277.8l-91.7-91.7c-4.7-4.7-12.3-4.7-17 0l-22.6 22.6c-4.7 4.7-4.7 12.3 0 17l122.8 122.8c4.7 4.7 12.3 4.7 17 0z"
  ]
};
export const faChevronCircleLeft = {
  prefix: "far",
  iconName: "chevron-circle-left",
  icon: [
    512,
    512,
    [],
    "f137",
    "M504 256C504 119 393 8 256 8S8 119 8 256s111 248 248 248 248-111 248-248zm-448 0c0-110.5 89.5-200 200-200s200 89.5 200 200-89.5 200-200 200S56 366.5 56 256zm107.5-8.5l122.8-122.8c4.7-4.7 12.3-4.7 17 0l22.6 22.6c4.7 4.7 4.7 12.3 0 17L234.2 256l91.7 91.7c4.7 4.7 4.7 12.3 0 17l-22.6 22.6c-4.7 4.7-12.3 4.7-17 0L163.5 264.5c-4.7-4.7-4.7-12.3 0-17z"
  ]
};
export const faChevronCircleRight = {
  prefix: "far",
  iconName: "chevron-circle-right",
  icon: [
    512,
    512,
    [],
    "f138",
    "M8 256c0 137 111 248 248 248s248-111 248-248S393 8 256 8 8 119 8 256zm448 0c0 110.5-89.5 200-200 200S56 366.5 56 256 145.5 56 256 56s200 89.5 200 200zm-107.5 8.5L225.7 387.3c-4.7 4.7-12.3 4.7-17 0l-22.6-22.6c-4.7-4.7-4.7-12.3 0-17l91.7-91.7-91.7-91.7c-4.7-4.7-4.7-12.3 0-17l22.6-22.6c4.7-4.7 12.3-4.7 17 0l122.8 122.8c4.7 4.7 4.7 12.3 0 17z"
  ]
};
export const faChevronCircleUp = {
  prefix: "far",
  iconName: "chevron-circle-up",
  icon: [
    512,
    512,
    [],
    "f139",
    "M264.5 163.5l122.8 122.8c4.7 4.7 4.7 12.3 0 17l-22.6 22.6c-4.7 4.7-12.3 4.7-17 0L256 234.2l-91.7 91.7c-4.7 4.7-12.3 4.7-17 0l-22.6-22.6c-4.7-4.7-4.7-12.3 0-17l122.8-122.8c4.7-4.7 12.3-4.7 17 0zM504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-48 0c0-110.5-89.5-200-200-200S56 145.5 56 256s89.5 200 200 200 200-89.5 200-200z"
  ]
};
export const faChevronDoubleDown = {
  prefix: "far",
  iconName: "chevron-double-down",
  icon: [
    448,
    512,
    [],
    "f322",
    "M441.9 89.7L232.5 299.1c-4.7 4.7-12.3 4.7-17 0L6.1 89.7c-4.7-4.7-4.7-12.3 0-17l19.8-19.8c4.7-4.7 12.3-4.7 17 0L224 233.6 405.1 52.9c4.7-4.7 12.3-4.7 17 0l19.8 19.8c4.7 4.7 4.7 12.3 0 17zm0 143l-19.8-19.8c-4.7-4.7-12.3-4.7-17 0L224 393.6 42.9 212.9c-4.7-4.7-12.3-4.7-17 0L6.1 232.7c-4.7 4.7-4.7 12.3 0 17l209.4 209.4c4.7 4.7 12.3 4.7 17 0l209.4-209.4c4.7-4.7 4.7-12.3 0-17z"
  ]
};
export const faChevronDoubleLeft = {
  prefix: "far",
  iconName: "chevron-double-left",
  icon: [
    448,
    512,
    [],
    "f323",
    "M390.3 473.9L180.9 264.5c-4.7-4.7-4.7-12.3 0-17L390.3 38.1c4.7-4.7 12.3-4.7 17 0l19.8 19.8c4.7 4.7 4.7 12.3 0 17L246.4 256l180.7 181.1c4.7 4.7 4.7 12.3 0 17l-19.8 19.8c-4.7 4.7-12.3 4.7-17 0zm-143 0l19.8-19.8c4.7-4.7 4.7-12.3 0-17L86.4 256 267.1 74.9c4.7-4.7 4.7-12.3 0-17l-19.8-19.8c-4.7-4.7-12.3-4.7-17 0L20.9 247.5c-4.7 4.7-4.7 12.3 0 17l209.4 209.4c4.7 4.7 12.3 4.7 17 0z"
  ]
};
export const faChevronDoubleRight = {
  prefix: "far",
  iconName: "chevron-double-right",
  icon: [
    448,
    512,
    [],
    "f324",
    "M57.7 38.1l209.4 209.4c4.7 4.7 4.7 12.3 0 17L57.7 473.9c-4.7 4.7-12.3 4.7-17 0l-19.8-19.8c-4.7-4.7-4.7-12.3 0-17L201.6 256 20.9 74.9c-4.7-4.7-4.7-12.3 0-17l19.8-19.8c4.7-4.7 12.3-4.7 17 0zm143 0l-19.8 19.8c-4.7 4.7-4.7 12.3 0 17L361.6 256 180.9 437.1c-4.7 4.7-4.7 12.3 0 17l19.8 19.8c4.7 4.7 12.3 4.7 17 0l209.4-209.4c4.7-4.7 4.7-12.3 0-17L217.7 38.1c-4.7-4.7-12.3-4.7-17 0z"
  ]
};
export const faChevronDoubleUp = {
  prefix: "far",
  iconName: "chevron-double-up",
  icon: [
    448,
    512,
    [],
    "f325",
    "M6.1 422.3l209.4-209.4c4.7-4.7 12.3-4.7 17 0l209.4 209.4c4.7 4.7 4.7 12.3 0 17l-19.8 19.8c-4.7 4.7-12.3 4.7-17 0L224 278.4 42.9 459.1c-4.7 4.7-12.3 4.7-17 0L6.1 439.3c-4.7-4.7-4.7-12.3 0-17zm0-143l19.8 19.8c4.7 4.7 12.3 4.7 17 0L224 118.4l181.1 180.7c4.7 4.7 12.3 4.7 17 0l19.8-19.8c4.7-4.7 4.7-12.3 0-17L232.5 52.9c-4.7-4.7-12.3-4.7-17 0L6.1 262.3c-4.7 4.7-4.7 12.3 0 17z"
  ]
};
export const faChevronDown = {
  prefix: "far",
  iconName: "chevron-down",
  icon: [
    448,
    512,
    [],
    "f078",
    "M441.9 167.3l-19.8-19.8c-4.7-4.7-12.3-4.7-17 0L224 328.2 42.9 147.5c-4.7-4.7-12.3-4.7-17 0L6.1 167.3c-4.7 4.7-4.7 12.3 0 17l209.4 209.4c4.7 4.7 12.3 4.7 17 0l209.4-209.4c4.7-4.7 4.7-12.3 0-17z"
  ]
};
export const faChevronLeft = {
  prefix: "far",
  iconName: "chevron-left",
  icon: [
    256,
    512,
    [],
    "f053",
    "M231.293 473.899l19.799-19.799c4.686-4.686 4.686-12.284 0-16.971L70.393 256 251.092 74.87c4.686-4.686 4.686-12.284 0-16.971L231.293 38.1c-4.686-4.686-12.284-4.686-16.971 0L4.908 247.515c-4.686 4.686-4.686 12.284 0 16.971L214.322 473.9c4.687 4.686 12.285 4.686 16.971-.001z"
  ]
};
export const faChevronRight = {
  prefix: "far",
  iconName: "chevron-right",
  icon: [
    256,
    512,
    [],
    "f054",
    "M24.707 38.101L4.908 57.899c-4.686 4.686-4.686 12.284 0 16.971L185.607 256 4.908 437.13c-4.686 4.686-4.686 12.284 0 16.971L24.707 473.9c4.686 4.686 12.284 4.686 16.971 0l209.414-209.414c4.686-4.686 4.686-12.284 0-16.971L41.678 38.101c-4.687-4.687-12.285-4.687-16.971 0z"
  ]
};
export const faChevronSquareDown = {
  prefix: "far",
  iconName: "chevron-square-down",
  icon: [
    448,
    512,
    [],
    "f329",
    "M215.5 348.5L92.7 225.7c-4.7-4.7-4.7-12.3 0-17l22.6-22.6c4.7-4.7 12.3-4.7 17 0l91.7 91.7 91.7-91.7c4.7-4.7 12.3-4.7 17 0l22.6 22.6c4.7 4.7 4.7 12.3 0 17L232.5 348.5c-4.7 4.7-12.3 4.7-17 0zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
  ]
};
export const faChevronSquareLeft = {
  prefix: "far",
  iconName: "chevron-square-left",
  icon: [
    448,
    512,
    [],
    "f32a",
    "M131.5 247.5l122.8-122.8c4.7-4.7 12.3-4.7 17 0l22.6 22.6c4.7 4.7 4.7 12.3 0 17L202.2 256l91.7 91.7c4.7 4.7 4.7 12.3 0 17l-22.6 22.6c-4.7 4.7-12.3 4.7-17 0L131.5 264.5c-4.7-4.7-4.7-12.3 0-17zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
  ]
};
export const faChevronSquareRight = {
  prefix: "far",
  iconName: "chevron-square-right",
  icon: [
    448,
    512,
    [],
    "f32b",
    "M316.5 264.5L193.7 387.3c-4.7 4.7-12.3 4.7-17 0l-22.6-22.6c-4.7-4.7-4.7-12.3 0-17l91.7-91.7-91.7-91.7c-4.7-4.7-4.7-12.3 0-17l22.6-22.6c4.7-4.7 12.3-4.7 17 0l122.8 122.8c4.7 4.7 4.7 12.3 0 17zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
  ]
};
export const faChevronSquareUp = {
  prefix: "far",
  iconName: "chevron-square-up",
  icon: [
    448,
    512,
    [],
    "f32c",
    "M232.5 163.5l122.8 122.8c4.7 4.7 4.7 12.3 0 17l-22.6 22.6c-4.7 4.7-12.3 4.7-17 0L224 234.2l-91.7 91.7c-4.7 4.7-12.3 4.7-17 0l-22.6-22.6c-4.7-4.7-4.7-12.3 0-17l122.8-122.8c4.7-4.7 12.3-4.7 17 0zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
  ]
};
export const faChevronUp = {
  prefix: "far",
  iconName: "chevron-up",
  icon: [
    448,
    512,
    [],
    "f077",
    "M6.101 359.293L25.9 379.092c4.686 4.686 12.284 4.686 16.971 0L224 198.393l181.13 180.698c4.686 4.686 12.284 4.686 16.971 0l19.799-19.799c4.686-4.686 4.686-12.284 0-16.971L232.485 132.908c-4.686-4.686-12.284-4.686-16.971 0L6.101 342.322c-4.687 4.687-4.687 12.285 0 16.971z"
  ]
};
export const faChild = {
  prefix: "far",
  iconName: "child",
  icon: [
    448,
    512,
    [],
    "f1ae",
    "M410.947 101.089c-22.433-22.431-55.179-26.458-81.062-14.53C320.167 38.057 277.177 0 224 0c-53.179 0-96.168 38.06-105.885 86.559-25.929-11.95-58.664-7.866-81.06 14.527-28.074 28.075-28.074 73.752-.003 101.825L96 261.823V440c0 39.701 32.299 72 72 72h8c18.423 0 35.253-6.955 48-18.378C236.747 505.045 253.577 512 272 512h8c39.701 0 72-32.299 72-72V261.823l58.946-58.912c28.072-28.073 28.072-73.75.001-101.822zM224 48c33.137 0 60 26.863 60 60s-26.863 60-60 60-60-26.863-60-60 26.863-60 60-60zm152.971 120.971L304 241.941V440c0 13.255-10.745 24-24 24h-8c-13.255 0-24-10.745-24-24v-96h-48v96c0 13.255-10.745 24-24 24h-8c-13.255 0-24-10.745-24-24V241.941L71.029 168.97c-9.372-9.373-9.372-24.569 0-33.942 9.373-9.372 24.568-9.372 33.941 0L177.941 208h92.117l72.971-72.971c9.373-9.372 24.568-9.372 33.941 0 9.373 9.373 9.373 24.569.001 33.942z"
  ]
};
export const faChimney = {
  prefix: "far",
  iconName: "chimney",
  icon: [
    512,
    512,
    [],
    "f78b",
    "M480 0H32C14.3 0 0 14.3 0 32v160c0 17.7 14.3 32 32 32v256c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32V224c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32zM304 464H80v-80h224v80zM80 336V224h80v112H80zm352 128h-80v-80h80v80zm0-128H208V224h224v112zm32-160H48V48h416v128z"
  ]
};
export const faChurch = {
  prefix: "far",
  iconName: "church",
  icon: [
    576,
    512,
    [],
    "f51d",
    "M281.71 320.3c-33.27 3.17-57.71 33.02-57.71 66.45V496c0 8.84 7.16 16 16 16h96c8.84 0 16-7.16 16-16V384c0-37.42-32.12-67.34-70.29-63.7zm276.86 19.69L448 292.58v-34.46c0-11.24-5.9-21.66-15.54-27.44L312 158.4V112h60c6.63 0 12-5.37 12-12V76c0-6.63-5.37-12-12-12h-60V12c0-6.63-5.37-12-12-12h-24c-6.63 0-12 5.37-12 12v52h-60c-6.63 0-12 5.37-12 12v24c0 6.63 5.37 12 12 12h60v46.4l-120.46 72.28A31.997 31.997 0 0 0 128 258.12v34.47l-110.57 47.4C6.96 344.99 0 357.89 0 372.32v122.44C0 504.28 5.97 512 13.33 512H32c8.84 0 16-7.16 16-16V379.11l80-34.3V496c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V267.17l112-67.2 112 67.2V496c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V344.81l80 34.3V496c0 8.84 7.16 16 16 16h18.67c7.37 0 13.33-7.71 13.33-17.23V372.32c0-14.43-6.96-27.33-17.43-32.33z"
  ]
};
export const faCircle = {
  prefix: "far",
  iconName: "circle",
  icon: [
    512,
    512,
    [],
    "f111",
    "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200z"
  ]
};
export const faCircleNotch = {
  prefix: "far",
  iconName: "circle-notch",
  icon: [
    512,
    512,
    [],
    "f1ce",
    "M288 28.977v16.391c0 7.477 5.182 13.945 12.474 15.598C389.568 81.162 456 160.742 456 256c0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-95.244 66.422-174.837 155.526-195.034C218.818 59.313 224 52.845 224 45.368V28.981c0-10.141-9.322-17.76-19.246-15.675C91.959 37.004 7.373 137.345 8.004 257.332c.72 137.052 111.477 246.956 248.531 246.667C393.255 503.711 504 392.788 504 256c0-119.349-84.308-219.003-196.617-242.665C297.403 11.232 288 18.779 288 28.977z"
  ]
};
export const faCity = {
  prefix: "far",
  iconName: "city",
  icon: [
    640,
    512,
    [],
    "f64f",
    "M244 384h-40c-6.63 0-12 5.37-12 12v40c0 6.63 5.37 12 12 12h40c6.63 0 12-5.37 12-12v-40c0-6.63-5.37-12-12-12zm0-192h-40c-6.63 0-12 5.37-12 12v40c0 6.63 5.37 12 12 12h40c6.63 0 12-5.37 12-12v-40c0-6.63-5.37-12-12-12zm-96 0h-40c-6.63 0-12 5.37-12 12v40c0 6.63 5.37 12 12 12h40c6.63 0 12-5.37 12-12v-40c0-6.63-5.37-12-12-12zm0 192h-40c-6.63 0-12 5.37-12 12v40c0 6.63 5.37 12 12 12h40c6.63 0 12-5.37 12-12v-40c0-6.63-5.37-12-12-12zm0-96h-40c-6.63 0-12 5.37-12 12v40c0 6.63 5.37 12 12 12h40c6.63 0 12-5.37 12-12v-40c0-6.63-5.37-12-12-12zm96 0h-40c-6.63 0-12 5.37-12 12v40c0 6.63 5.37 12 12 12h40c6.63 0 12-5.37 12-12v-40c0-6.63-5.37-12-12-12zm288 96h-40c-6.63 0-12 5.37-12 12v40c0 6.63 5.37 12 12 12h40c6.63 0 12-5.37 12-12v-40c0-6.63-5.37-12-12-12zm0-96h-40c-6.63 0-12 5.37-12 12v40c0 6.63 5.37 12 12 12h40c6.63 0 12-5.37 12-12v-40c0-6.63-5.37-12-12-12zm84-96H512V24c0-13.26-10.74-24-24-24H280c-13.26 0-24 10.74-24 24v72h-32V16c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v80h-64V16c0-8.84-7.16-16-16-16H80c-8.84 0-16 7.16-16 16v80H24c-13.26 0-24 10.74-24 24v376c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V144h256V48h160v192h128v256c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V216c0-13.26-10.75-24-24-24zM404 96h-40c-6.63 0-12 5.37-12 12v40c0 6.63 5.37 12 12 12h40c6.63 0 12-5.37 12-12v-40c0-6.63-5.37-12-12-12zm0 192h-40c-6.63 0-12 5.37-12 12v40c0 6.63 5.37 12 12 12h40c6.63 0 12-5.37 12-12v-40c0-6.63-5.37-12-12-12zm0-96h-40c-6.63 0-12 5.37-12 12v40c0 6.63 5.37 12 12 12h40c6.63 0 12-5.37 12-12v-40c0-6.63-5.37-12-12-12z"
  ]
};
export const faClarinet = {
  prefix: "far",
  iconName: "clarinet",
  icon: [
    640,
    512,
    [],
    "f8ad",
    "M616 112a23.7 23.7 0 0 0-13.28 4l-66 44H480v-32h24a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8H232a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h24v32H101.2a31.92 31.92 0 0 0-10.12 1.64l-69.2 23.07A32 32 0 0 0 0 215.06v81.88a32 32 0 0 0 21.88 30.35l69.2 23.07A31.92 31.92 0 0 0 101.2 352h435.53l66 44A24 24 0 0 0 640 376V136a24 24 0 0 0-24-24zm-232 16h64v32h-64zm-96 0h64v32h-64zm304 203.15L551.27 304H103.79L48 285.4v-58.8l55.79-18.6h447.48L592 180.84zM464 232a24 24 0 1 0 24 24 24 24 0 0 0-24-24zm-96 0a24 24 0 1 0 24 24 24 24 0 0 0-24-24zm-96 0a24 24 0 1 0 24 24 24 24 0 0 0-24-24z"
  ]
};
export const faClawMarks = {
  prefix: "far",
  iconName: "claw-marks",
  icon: [
    512,
    512,
    [],
    "f6c2",
    "M7.11 224.51c-4.99-2.37-9.39 4.09-5.49 8l85.11 85.13c6 6 9.37 14.14 9.37 22.63V384h43.73c8.49 0 16.62 3.37 22.62 9.37l117.13 117.16c3.86 3.86 10.31-.56 7.98-5.49C206.47 333.11 63.46 251.26 7.11 224.51zM246.69 29.63c6 6 9.37 14.14 9.37 22.63V96h43.73c8.49 0 16.62 3.37 22.62 9.37l52.25 52.26c6 6 9.37 14.14 9.37 22.63V224h43.72c8.49 0 16.62 3.37 22.62 9.37l53.14 53.16c3.86 3.86 10.31-.56 7.98-5.49C430.42 109.11 287.41 27.26 231.05.51c-4.99-2.37-9.39 4.09-5.49 8l21.13 21.12zm262.25 436.9l-1.44-3.03C453.42 347.77 321.51 134.06 45.64 3.14 31.74-3.47 15.02.89 6.06 13.53-2.97 26.3-1.51 43.59 7.8 52.74l144.28 179.7V296h62.05l65.92 65.94V424h64.42l114.97 80.47a31.741 31.741 0 0 0 20.5 7.48c6.44 0 12.87-1.92 18.46-5.86 12.69-8.93 17.13-25.56 10.54-39.56zM359.6 376h-31.56v-33.94L234 248h-33.93v-32.44L92.85 82.16C277.03 188.93 382.78 335.35 435.9 429.43L359.6 376z"
  ]
};
export const faClinicMedical = {
  prefix: "far",
  iconName: "clinic-medical",
  icon: [
    576,
    512,
    [],
    "f7f2",
    "M256 200v56h-56a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8h56v56a8 8 0 0 0 8 8h48a8 8 0 0 0 8-8v-56h56a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8h-56v-56a8 8 0 0 0-8-8h-48a8 8 0 0 0-8 8zm314.24 15.44L323.87 13a56 56 0 0 0-71.74 0L5.76 215.42a16 16 0 0 0-2 22.54L14 250.26a16 16 0 0 0 22.53 2L64 229.71V288h-.31v208a16.13 16.13 0 0 0 16.1 16H496a16 16 0 0 0 16-16V229.71l27.5 22.59a16 16 0 0 0 22.53-2l10.26-12.3a16 16 0 0 0-2.05-22.58zM464 224h-.21v240h-352.1V194.48l.31-.25v-4L288 45.65l176 144.62z"
  ]
};
export const faClipboard = {
  prefix: "far",
  iconName: "clipboard",
  icon: [
    384,
    512,
    [],
    "f328",
    "M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM192 40c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm144 418c0 3.3-2.7 6-6 6H54c-3.3 0-6-2.7-6-6V118c0-3.3 2.7-6 6-6h42v36c0 6.6 5.4 12 12 12h168c6.6 0 12-5.4 12-12v-36h42c3.3 0 6 2.7 6 6z"
  ]
};
export const faClipboardCheck = {
  prefix: "far",
  iconName: "clipboard-check",
  icon: [
    384,
    512,
    [],
    "f46c",
    "M269.3 225.8c-3.9-3.9-10.2-3.9-14.1-.1l-88 87.3-38.1-38.5c-3.9-3.9-10.2-3.9-14.1-.1l-23.6 23.4c-3.9 3.9-3.9 10.2-.1 14.1l68.5 69.1c3.9 3.9 10.2 3.9 14.1.1l118.6-117.6c3.9-3.9 3.9-10.2.1-14.1l-23.3-23.6zM336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM192 48c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16 7.2-16 16-16zm144 408c0 4.4-3.6 8-8 8H56c-4.4 0-8-3.6-8-8V120c0-4.4 3.6-8 8-8h40v32c0 8.8 7.2 16 16 16h160c8.8 0 16-7.2 16-16v-32h40c4.4 0 8 3.6 8 8v336z"
  ]
};
export const faClipboardList = {
  prefix: "far",
  iconName: "clipboard-list",
  icon: [
    384,
    512,
    [],
    "f46d",
    "M280 240H168c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zm0 96H168c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zM112 232c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zM336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM192 48c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16 7.2-16 16-16zm144 408c0 4.4-3.6 8-8 8H56c-4.4 0-8-3.6-8-8V120c0-4.4 3.6-8 8-8h40v32c0 8.8 7.2 16 16 16h160c8.8 0 16-7.2 16-16v-32h40c4.4 0 8 3.6 8 8v336z"
  ]
};
export const faClipboardListCheck = {
  prefix: "far",
  iconName: "clipboard-list-check",
  icon: [
    384,
    512,
    [],
    "f737",
    "M126.2 286.4l64.2-63.6c2.1-2.1 2.1-5.5 0-7.6l-12.6-12.7c-2.1-2.1-5.5-2.1-7.6 0l-47.6 47.2-20.6-20.9c-2.1-2.1-5.5-2.1-7.6 0l-12.7 12.6c-2.1 2.1-2.1 5.5 0 7.6l37.1 37.4c1.9 2.1 5.3 2.1 7.4 0zM336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM192 48c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16 7.2-16 16-16zm144 408c0 4.4-3.6 8-8 8H56c-4.4 0-8-3.6-8-8V120c0-4.4 3.6-8 8-8h40v32c0 8.8 7.2 16 16 16h160c8.8 0 16-7.2 16-16v-32h40c4.4 0 8 3.6 8 8v336zM112 328c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm168-88h-63.3c-1.3 1.8-2.1 3.9-3.7 5.5L186.2 272H280c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zm0 96H168c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8z"
  ]
};
export const faClipboardPrescription = {
  prefix: "far",
  iconName: "clipboard-prescription",
  icon: [
    384,
    512,
    [],
    "f5e8",
    "M336 64h-80c0-35.35-28.65-64-64-64s-64 28.65-64 64H48C21.49 64 0 85.49 0 112v352c0 26.51 21.49 48 48 48h288c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zM192 48c8.82 0 16 7.18 16 16s-7.18 16-16 16-16-7.18-16-16 7.18-16 16-16zm144 408c0 4.42-3.58 8-8 8H56c-4.42 0-8-3.58-8-8V120c0-4.42 3.58-8 8-8h40v32c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-32h40c4.42 0 8 3.58 8 8v336zm-50.34-127.03c3.12-3.12 3.12-8.19 0-11.31l-11.31-11.31c-3.12-3.12-8.19-3.12-11.31 0l-36.69 36.69c-.91.91-.99 2.16-1.37 3.31l-32.3-32.3C211.17 304.9 224 286.03 224 264c0-30.93-25.07-56-56-56h-64c-4.42 0-8 3.58-8 8v144c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-40h25.37l48.97 48.97c-1.15.38-2.4.46-3.31 1.37l-36.69 36.69c-3.12 3.12-3.12 8.19 0 11.31l11.31 11.31c3.12 3.12 8.19 3.12 11.31 0l36.69-36.69c.92-.92.99-2.16 1.37-3.31l40 40c3.12 3.12 8.19 3.12 11.31 0l11.31-11.31c3.12-3.12 3.12-8.19 0-11.31l-40-40c1.15-.38 2.4-.46 3.31-1.37l36.71-36.69zM168 288h-40v-48h40c13.23 0 24 10.77 24 24s-10.77 24-24 24z"
  ]
};
export const faClipboardUser = {
  prefix: "far",
  iconName: "clipboard-user",
  icon: [
    384,
    512,
    [],
    "f7f3",
    "M336 64h-80a64 64 0 0 0-128 0H48a48 48 0 0 0-48 48v352a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V112a48 48 0 0 0-48-48zM192 40a24 24 0 1 1-24 24 24 24 0 0 1 24-24zm144 418a6 6 0 0 1-6 6H54a6 6 0 0 1-6-6V118a6 6 0 0 1 6-6h42v36a12 12 0 0 0 12 12h168a12 12 0 0 0 12-12v-36h42a6 6 0 0 1 6 6zm-99.2-106h-5a103.25 103.25 0 0 1-79.7 0h-5c-37.01 0-67.1 25.79-67.1 57.6v6.4a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16v-6.4c0-31.81-30.09-57.6-67.2-57.6zM192 336a64 64 0 1 0-64-64 64 64 0 0 0 64 64z"
  ]
};
export const faClock = {
  prefix: "far",
  iconName: "clock",
  icon: [
    512,
    512,
    [],
    "f017",
    "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm61.8-104.4l-84.9-61.7c-3.1-2.3-4.9-5.9-4.9-9.7V116c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v141.7l66.8 48.6c5.4 3.9 6.5 11.4 2.6 16.8L334.6 349c-3.9 5.3-11.4 6.5-16.8 2.6z"
  ]
};
export const faClone = {
  prefix: "far",
  iconName: "clone",
  icon: [
    512,
    512,
    [],
    "f24d",
    "M464 0H144c-26.51 0-48 21.49-48 48v48H48c-26.51 0-48 21.49-48 48v320c0 26.51 21.49 48 48 48h320c26.51 0 48-21.49 48-48v-48h48c26.51 0 48-21.49 48-48V48c0-26.51-21.49-48-48-48zM362 464H54a6 6 0 0 1-6-6V150a6 6 0 0 1 6-6h42v224c0 26.51 21.49 48 48 48h224v42a6 6 0 0 1-6 6zm96-96H150a6 6 0 0 1-6-6V54a6 6 0 0 1 6-6h308a6 6 0 0 1 6 6v308a6 6 0 0 1-6 6z"
  ]
};
export const faClosedCaptioning = {
  prefix: "far",
  iconName: "closed-captioning",
  icon: [
    512,
    512,
    [],
    "f20a",
    "M464 64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zm-6 336H54c-3.3 0-6-2.7-6-6V118c0-3.3 2.7-6 6-6h404c3.3 0 6 2.7 6 6v276c0 3.3-2.7 6-6 6zm-211.1-85.7c1.7 2.4 1.5 5.6-.5 7.7-53.6 56.8-172.8 32.1-172.8-67.9 0-97.3 121.7-119.5 172.5-70.1 2.1 2 2.5 3.2 1 5.7l-17.5 30.5c-1.9 3.1-6.2 4-9.1 1.7-40.8-32-94.6-14.9-94.6 31.2 0 48 51 70.5 92.2 32.6 2.8-2.5 7.1-2.1 9.2.9l19.6 27.7zm190.4 0c1.7 2.4 1.5 5.6-.5 7.7-53.6 56.9-172.8 32.1-172.8-67.9 0-97.3 121.7-119.5 172.5-70.1 2.1 2 2.5 3.2 1 5.7L420 220.2c-1.9 3.1-6.2 4-9.1 1.7-40.8-32-94.6-14.9-94.6 31.2 0 48 51 70.5 92.2 32.6 2.8-2.5 7.1-2.1 9.2.9l19.6 27.7z"
  ]
};
export const faCloud = {
  prefix: "far",
  iconName: "cloud",
  icon: [
    640,
    512,
    [],
    "f0c2",
    "M543.7 200.1C539.7 142.1 491.4 96 432 96c-7.6 0-15.1.8-22.4 2.3C377.7 58.3 328.1 32 272 32c-84.6 0-155.5 59.7-172.3 139.8C39.9 196.1 0 254.4 0 320c0 88.4 71.6 160 160 160h336c79.5 0 144-64.5 144-144 0-61.8-39.2-115.8-96.3-135.9zM496 432H160c-61.9 0-112-50.1-112-112 0-56.4 41.7-103.1 96-110.9V208c0-70.7 57.3-128 128-128 53.5 0 99.3 32.8 118.4 79.4 11.2-9.6 25.7-15.4 41.6-15.4 35.3 0 64 28.7 64 64 0 11.8-3.2 22.9-8.8 32.4 2.9-.3 5.9-.4 8.8-.4 53 0 96 43 96 96s-43 96-96 96z"
  ]
};
export const faCloudDownload = {
  prefix: "far",
  iconName: "cloud-download",
  icon: [
    640,
    512,
    [],
    "f0ed",
    "M543.7 200.1C539.7 142.1 491.4 96 432 96c-7.6 0-15.1.8-22.4 2.3C377.7 58.3 328.1 32 272 32c-84.6 0-155.5 59.7-172.3 139.8C39.9 196.1 0 254.4 0 320c0 88.4 71.6 160 160 160h336c79.5 0 144-64.5 144-144 0-61.8-39.2-115.8-96.3-135.9zM496 432H160c-61.9 0-112-50.1-112-112 0-56.4 41.7-103.1 96-110.9V208c0-70.7 57.3-128 128-128 53.5 0 99.3 32.8 118.4 79.4 11.2-9.6 25.7-15.4 41.6-15.4 35.3 0 64 28.7 64 64 0 11.8-3.2 22.9-8.8 32.4 2.9-.3 5.9-.4 8.8-.4 53 0 96 43 96 96s-43 96-96 96zM383.6 255.6c-4.7-4.7-12.4-4.7-17.1.1L312 311.5V172c0-6.6-5.4-12-12-12h-24c-6.6 0-12 5.4-12 12v139.5l-54.5-55.8c-4.7-4.8-12.3-4.8-17.1-.1l-16.9 16.9c-4.7 4.7-4.7 12.3 0 17l104 104c4.7 4.7 12.3 4.7 17 0l104-104c4.7-4.7 4.7-12.3 0-17l-16.9-16.9z"
  ]
};
export const faCloudDownloadAlt = {
  prefix: "far",
  iconName: "cloud-download-alt",
  icon: [
    640,
    512,
    [],
    "f381",
    "M543.7 200.1C539.7 142.1 491.4 96 432 96c-7.6 0-15.1.8-22.4 2.3C377.7 58.3 328.1 32 272 32c-84.6 0-155.5 59.7-172.3 139.8C39.9 196.1 0 254.4 0 320c0 88.4 71.6 160 160 160h336c79.5 0 144-64.5 144-144 0-61.8-39.2-115.8-96.3-135.9zM496 432H160c-61.9 0-112-50.1-112-112 0-56.4 41.7-103.1 96-110.9V208c0-70.7 57.3-128 128-128 53.5 0 99.3 32.8 118.4 79.4 11.2-9.6 25.7-15.4 41.6-15.4 35.3 0 64 28.7 64 64 0 11.8-3.2 22.9-8.8 32.4 2.9-.3 5.9-.4 8.8-.4 53 0 96 43 96 96s-43 96-96 96zM387 256h-67v-84c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v84h-67c-10.7 0-16 12.9-8.5 20.5l99 99c4.7 4.7 12.3 4.7 17 0l99-99c7.6-7.6 2.2-20.5-8.5-20.5z"
  ]
};
export const faCloudDrizzle = {
  prefix: "far",
  iconName: "cloud-drizzle",
  icon: [
    512,
    512,
    [],
    "f738",
    "M48 360c-8.8 0-16 7.2-16 16v40c0 8.8 7.2 16 16 16s16-7.2 16-16v-40c0-8.8-7.2-16-16-16zm96 80c-8.8 0-16 7.2-16 16v40c0 8.8 7.2 16 16 16s16-7.2 16-16v-40c0-8.8-7.2-16-16-16zm96-80c-8.8 0-16 7.2-16 16v40c0 8.8 7.2 16 16 16s16-7.2 16-16v-40c0-8.8-7.2-16-16-16zm96 80c-8.8 0-16 7.2-16 16v40c0 8.8 7.2 16 16 16s16-7.2 16-16v-40c0-8.8-7.2-16-16-16zm96-80c-8.8 0-16 7.2-16 16v40c0 8.8 7.2 16 16 16s16-7.2 16-16v-40c0-8.8-7.2-16-16-16zm-21.3-255.8C397.2 61.8 358 32 312 32c-13.5 0-26.8 2.6-39.2 7.7C250.3 14.5 218.4 0 184 0 120 0 67.6 50.3 64.2 113.4 25.6 130.4 0 168.5 0 212c0 59.5 48.4 108 108 108h296c59.6 0 108-48.5 108-108 0-57.3-44.9-104.3-101.3-107.8zM404 272H108c-33.1 0-60-26.9-60-60 0-28 19.1-52 46.4-58.3l20.8-4.8-2.8-24.9c-.2-1.3-.4-2.6-.4-4 0-39.7 32.3-72 72-72 25.2 0 48.2 13.1 61.4 35.1l13.3 22.1 21.1-14.9C289.4 83.6 300.5 80 312 80c28.6 0 52.4 21.7 55.3 50.4l2.2 21.6H404c33.1 0 60 26.9 60 60s-26.9 60-60 60z"
  ]
};
export const faCloudHail = {
  prefix: "far",
  iconName: "cloud-hail",
  icon: [
    512,
    512,
    [],
    "f739",
    "M384 352c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm-192 96c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm128 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm-64-96c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zM64 448c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm64-96c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm282.7-247.8C397.2 61.8 358 32 312 32c-13.5 0-26.8 2.6-39.2 7.7C250.3 14.5 218.4 0 184 0 120 0 67.6 50.3 64.2 113.4 25.6 130.4 0 168.5 0 212c0 59.5 48.4 108 108 108h296c59.6 0 108-48.5 108-108 0-57.3-44.9-104.3-101.3-107.8zM404 272H108c-33.1 0-60-26.9-60-60 0-28 19.1-52 46.4-58.3l20.8-4.8-2.8-24.9c-.2-1.3-.4-2.6-.4-4 0-39.7 32.3-72 72-72 25.2 0 48.2 13.1 61.4 35.1l13.3 22.1 21.1-14.9C289.4 83.6 300.5 80 312 80c28.6 0 52.4 21.7 55.3 50.4l2.2 21.6H404c33.1 0 60 26.9 60 60s-26.9 60-60 60z"
  ]
};
export const faCloudHailMixed = {
  prefix: "far",
  iconName: "cloud-hail-mixed",
  icon: [
    512,
    512,
    [],
    "f73a",
    "M410.7 104.2C397.2 61.8 358 32 312 32c-13.5 0-26.8 2.6-39.2 7.7C250.3 14.5 218.4 0 184 0 120 0 67.6 50.3 64.2 113.4 25.6 130.4 0 168.5 0 212c0 59.5 48.4 108 108 108h296c59.6 0 108-48.5 108-108 0-57.3-44.9-104.3-101.3-107.8zM404 272H108c-33.1 0-60-26.9-60-60 0-28 19.1-52 46.4-58.3l20.8-4.8-2.8-24.9c-.2-1.3-.4-2.6-.4-4 0-39.7 32.3-72 72-72 25.2 0 48.2 13.1 61.4 35.1l13.3 22.1 21.1-14.9C289.4 83.6 300.5 80 312 80c28.6 0 52.4 21.7 55.3 50.4l2.2 21.6H404c33.1 0 60 26.9 60 60s-26.9 60-60 60zM87.2 369.7c-7.9-3.9-17.5-.8-21.5 7.2l-16 32c-3.9 7.9-.8 17.5 7.2 21.5 2.3 1.1 4.8 1.7 7.2 1.7 5.8 0 11.5-3.2 14.3-8.8l16-32c3.8-8.1.7-17.7-7.2-21.6zm384 0c-7.9-3.9-17.5-.8-21.5 7.2l-16 32c-3.9 7.9-.8 17.5 7.2 21.5 2.3 1.1 4.8 1.7 7.2 1.7 5.8 0 11.5-3.2 14.3-8.8l16-32c3.8-8.1.7-17.7-7.2-21.6zm-95.3.4c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zm-96.7-.4c-7.9-3.9-17.5-.8-21.5 7.2l-16 32c-3.9 7.9-.8 17.5 7.2 21.5 2.3 1.1 4.8 1.7 7.2 1.7 5.8 0 11.5-3.2 14.3-8.8l16-32c3.8-8.1.7-17.7-7.2-21.6zm-95.3.4c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zM32 448c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm192 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm192 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"
  ]
};
export const faCloudMeatball = {
  prefix: "far",
  iconName: "cloud-meatball",
  icon: [
    576,
    512,
    [],
    "f73b",
    "M384.5 375.6l-16.7-8.7 5.7-18c6.1-19.2-7.5-35.9-25.3-35.9-6 0-8.5 1.2-27.1 7.1l-8.7-16.7c-10.8-20.7-38.1-20.6-48.8 0l-8.7 16.7c-17.7-5.6-20.8-7.1-27.1-7.1-17.8 0-31.4 16.7-25.3 35.9l5.7 18-16.7 8.7c-20.5 10.7-20.8 38 0 48.8l16.7 8.7-5.7 18c-6.3 19.9 8.6 36.4 26.1 36.4 3.7 0 12.5-3.2 26.3-7.6l8.7 16.7c10.8 20.7 38.1 20.6 48.8 0l8.7-16.7c13.9 4.4 22.6 7.6 26.3 7.6 17.6 0 32.4-16.4 26.1-36.4l-5.7-18 16.7-8.7c20.7-10.8 20.6-38.1 0-48.8zM576 256c0-59.2-41.5-110.1-97.6-123.8C468.9 75.4 419.4 32 360 32c-12.8 0-25.6 2.2-38 6.5C293.6 13.5 258 0 220 0 137.7 0 70.1 64.1 64.4 145 24.8 167.6 0 209.6 0 256c0 70.6 57.4 128 128 128h18.5c3.8-13.1 12-24.8 23.7-32.8-1-5.1-1.1-10.2-.8-15.2H128c-44.1 0-80-35.9-80-80 0-32.5 19.4-61.5 49.6-73.9l15.6-6.4-.8-16.9c-.1-1.4-.2-2.8-.4-2.8 0-59.5 48.4-108 108-108 30.1 0 58.2 12.4 79.1 35l12.3 13.3 16.2-8.2c49-24.9 103.5 12.6 104.4 62.5l-2.8 24.1 24.9 1.9c41.5 3.2 73.9 38 73.9 79.3 0 44.1-35.9 80-80 80h-41.4c.3 5 .2 10.1-.7 15.2 11.7 8 19.9 19.7 23.7 32.8H448c70.6.1 128-57.3 128-127.9zM64 416c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm448 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"
  ]
};
export const faCloudMoon = {
  prefix: "far",
  iconName: "cloud-moon",
  icon: [
    640,
    512,
    [],
    "f6c3",
    "M390.8 296.4C383.3 246.4 340 208 288 208c-5.1 0-10.2.4-15.2 1.1C248.5 188 217.2 176 184 176c-64 0-118.3 45.2-132.4 105.3C19.6 305.1 0 343 0 384c0 70.6 57.4 128 128 128h204c64 0 116-52 116-116 0-41.8-22.8-79.3-57.2-99.6zM332 464H128c-44.2 0-80-35.8-80-80 0-32.8 19.8-61 48.1-73.3.7-48 39.7-86.7 87.9-86.7 31.2 0 58.4 16.3 74.1 40.8 8.7-5.5 18.9-8.8 29.9-8.8 30.9 0 56 25.1 56 56 0 5.9-1.2 11.5-2.9 16.9 33.2 4.5 58.9 32.6 58.9 67.1 0 37.6-30.5 68-68 68zm305.6-176.8c-4.1-8.6-12.4-13.9-21.8-13.9-1.5 0-3 .1-4.6.4-7.7 1.5-15.5 2.2-23.2 2.2-67 0-121.5-54.7-121.5-121.9 0-43.7 23.6-84.3 61.6-106 8.9-5.1 13.6-15 11.9-25.1-1.7-10.2-9.4-17.9-19.5-19.8-11.5-2-23.2-3.1-35-3.1-100.5 0-183.1 77.9-191 176.6 16.8.8 32.8 4.8 47.6 11.3 1.9-66.3 48.5-121.6 110.8-136.1-21.9 29.1-34.4 64.9-34.4 102.4 0 81.1 57 149.1 132.9 165.9-20.1 10.4-42.6 16-65.9 16-6.7 0-13.1-1.1-19.6-2 7.3 15.5 11.8 32.3 13.3 49.7 2.1.1 4.2.3 6.3.3 58.1 0 112.4-25.9 149-71.1 6-7.4 7.2-17.3 3.1-25.8z"
  ]
};
export const faCloudMoonRain = {
  prefix: "far",
  iconName: "cloud-moon-rain",
  icon: [
    640,
    512,
    [],
    "f73c",
    "M268.5 418.1c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm288 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-1.1-234.7c-12-36.8-46.7-63.4-87.4-63.4-3.1 0-6.1.2-9.1.5C245.3 104.7 219.2 96 192 96c-52.4 0-97.6 31.3-117.2 77.2C31.4 187.3 0 228 0 276c0 59.6 48.4 108 108 108h200c59.6 0 108-48.4 108-108 0-38.8-20.8-73.6-52.6-92.6zM308 336H108c-33.1 0-60-26.9-60-60s26.9-60 60-60c1.6 0 3.2.4 4.8.5 3.8-40.6 37.6-72.5 79.2-72.5 25.2 0 47.4 11.9 62.1 30.1 6.5-3.8 13.9-6.1 21.9-6.1 24.3 0 44 19.7 44 44 0 1.8-.3 3.4-.5 5.2 27.6 5.4 48.5 29.6 48.5 58.8 0 33.1-26.9 60-60 60zm329.8-99.3c-3.8-7.9-11.8-13-20.5-13h-1.5l-2.8.4c-6.1 1.2-12.3 1.8-18.4 1.8-53.2 0-96.5-43.4-96.5-96.8 0-34.7 18.8-67 49-84.2 8.4-4.8 12.8-14 11.2-23.6-1.6-9.5-8.8-16.8-18.3-18.6C530.3.9 520.5 0 510.7 0c-73.6 0-135.1 50.3-153.6 118.2 13.8 11.9 25 26.8 32.6 44.1.6.4 1 .9 1.6 1.3 0-1.2-.4-2.4-.4-3.6 0-58.9 42.6-108 98.6-118.1-19.9 24.2-31.3 54.9-31.3 87.1 0 67.4 48.8 123.5 112.9 134.8-18 10.5-38.7 16.2-60.2 16.2-23.4 0-45.1-7-63.6-18.7.5 4.9.9 9.8.9 14.7 0 10.1-1.3 19.8-3.3 29.3 20.2 9.2 42.4 14.7 66.1 14.7 48.4 0 93.6-21.6 124.2-59.2 5.3-6.9 6.4-16.1 2.6-24.1z"
  ]
};
export const faCloudMusic = {
  prefix: "far",
  iconName: "cloud-music",
  icon: [
    640,
    512,
    [],
    "f8ae",
    "M543.69 200.09A111.8 111.8 0 0 0 409.59 98.3a176 176 0 0 0-309.9 73.5A160 160 0 0 0 160 480h336a144 144 0 0 0 47.69-279.91zM496 432H160a112 112 0 0 1-16-222.91V208a128 128 0 0 1 246.41-48.59 64 64 0 0 1 96.78 81A81.06 81.06 0 0 1 496 240a96 96 0 0 1 0 192zM363.19 176.75l-128 47.25A16 16 0 0 0 224 239.25V338a69.27 69.27 0 0 0-16-2c-26.5 0-48 14.33-48 32s21.5 32 48 32 48-14.33 48-32v-84.84l96-37.52V306a69.27 69.27 0 0 0-16-2c-26.5 0-48 14.33-48 32s21.5 32 48 32 48-14.33 48-32V192a16 16 0 0 0-20.81-15.25z"
  ]
};
export const faCloudRain = {
  prefix: "far",
  iconName: "cloud-rain",
  icon: [
    512,
    512,
    [],
    "f73d",
    "M88 374.2c-12.8 44.4-40 56.4-40 87.7 0 27.7 21.5 50.1 48 50.1s48-22.4 48-50.1c0-31.4-27.2-43.1-40-87.7-2.2-8.1-13.5-8.5-16 0zm160 0c-12.8 44.4-40 56.4-40 87.7 0 27.7 21.5 50.1 48 50.1s48-22.4 48-50.1c0-31.4-27.2-43.1-40-87.7-2.2-8.1-13.5-8.5-16 0zm160 0c-12.8 44.4-40 56.4-40 87.7 0 27.7 21.5 50.1 48 50.1s48-22.4 48-50.1c0-31.4-27.2-43.1-40-87.7-2.2-8.1-13.5-8.5-16 0zm2.7-270C397.2 61.8 358 32 312 32c-13.5 0-26.8 2.6-39.2 7.7C250.3 14.5 218.4 0 184 0 120 0 67.6 50.3 64.2 113.4 25.6 130.4 0 168.5 0 212c0 59.5 48.4 108 108 108h296c59.6 0 108-48.5 108-108 0-57.3-44.9-104.3-101.3-107.8zM404 272H108c-33.1 0-60-26.9-60-60 0-28 19.1-52 46.4-58.3l20.8-4.8-2.8-24.9c-.2-1.3-.4-2.6-.4-4 0-39.7 32.3-72 72-72 25.2 0 48.2 13.1 61.4 35.1l13.3 22.1 21.1-14.9C289.4 83.6 300.5 80 312 80c28.6 0 52.4 21.7 55.3 50.4l2.2 21.6H404c33.1 0 60 26.9 60 60s-26.9 60-60 60z"
  ]
};
export const faCloudRainbow = {
  prefix: "far",
  iconName: "cloud-rainbow",
  icon: [
    576,
    512,
    [],
    "f73e",
    "M560.6 48c8.6-.4 15.4-7.1 15.4-15.7V16.2c0-9-7.6-16.6-16.6-16.2-140.2 6-260.9 87.3-323.5 204.2C220 196.4 202.4 192 184 192c-64 0-116.4 50.3-119.8 113.4C25.6 322.4 0 360.5 0 404c0 59.5 48.4 108 108 108h296c59.6 0 108-48.5 108-108 0-38.5-20.4-71.9-50.8-91.1 23.7-30.7 59.1-52 99.7-56.2 8.4-.9 15.1-7.4 15.1-15.9v-16.1c0-9.2-7.7-16.9-16.8-16.1-61 5.3-113.8 39.2-145.5 87.9-1-.1-1.9-.4-3-.5-5.6-17.8-16-33.1-29.3-45.2 41.2-56 105.7-93.9 179.3-98.5 8.5-.5 15.3-7.2 15.3-15.8v-16c0-9.1-7.6-16.7-16.7-16.2-91.1 5.2-170.7 53-220.1 123.4-8.7-2.4-17.8-3.9-27.2-3.9-12 0-23.8 2.4-35 6.5C331.2 126.5 436.9 53.6 560.6 48zM312 272c28.6 0 52.4 21.7 55.3 50.4l2.2 21.6H404c33.1 0 60 26.9 60 60s-26.9 60-60 60H108c-33.1 0-60-26.9-60-60 0-28 19.1-52 46.4-58.3l20.8-4.8-2.8-24.9c-.2-1.3-.4-2.6-.4-4 0-39.7 32.3-72 72-72 25.2 0 48.2 13.1 61.4 35.1l13.3 22.1 21.1-14.9c9.6-6.7 20.7-10.3 32.2-10.3z"
  ]
};
export const faCloudShowers = {
  prefix: "far",
  iconName: "cloud-showers",
  icon: [
    512,
    512,
    [],
    "f73f",
    "M48 368c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16v-80c0-8.8-7.2-16-16-16zm96 32c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16v-80c0-8.8-7.2-16-16-16zm96-32c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16v-80c0-8.8-7.2-16-16-16zm96 32c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16v-80c0-8.8-7.2-16-16-16zm96-32c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16v-80c0-8.8-7.2-16-16-16zm-21.3-263.8C397.2 61.8 358 32 312 32c-13.5 0-26.8 2.6-39.2 7.7C250.3 14.5 218.4 0 184 0 120 0 67.6 50.3 64.2 113.4 25.6 130.4 0 168.5 0 212c0 59.5 48.4 108 108 108h296c59.6 0 108-48.5 108-108 0-57.3-44.9-104.3-101.3-107.8zM404 272H108c-33.1 0-60-26.9-60-60 0-28 19.1-52 46.4-58.3l20.8-4.8-2.8-24.9c-.2-1.3-.4-2.6-.4-4 0-39.7 32.3-72 72-72 25.2 0 48.2 13.1 61.4 35.1l13.3 22.1 21.1-14.9C289.4 83.6 300.5 80 312 80c28.6 0 52.4 21.7 55.3 50.4l2.2 21.6H404c33.1 0 60 26.9 60 60s-26.9 60-60 60z"
  ]
};
export const faCloudShowersHeavy = {
  prefix: "far",
  iconName: "cloud-showers-heavy",
  icon: [
    512,
    512,
    [],
    "f740",
    "M87.9 370.1c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zm384 0c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zm-96 0c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zm-96 0c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zm-96 0c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zm226.8-265.9C397.2 61.8 358 32 312 32c-13.5 0-26.8 2.6-39.2 7.7C250.3 14.5 218.4 0 184 0 120 0 67.6 50.3 64.2 113.4 25.6 130.4 0 168.5 0 212c0 59.5 48.4 108 108 108h296c59.6 0 108-48.5 108-108 0-57.3-44.9-104.3-101.3-107.8zM404 272H108c-33.1 0-60-26.9-60-60 0-28 19.1-52 46.4-58.3l20.7-4.8-2.7-24.9c-.2-1.3-.4-2.6-.4-4 0-39.7 32.3-72 72-72 25.2 0 48.2 13.1 61.4 35.1l13.3 22.1 21.1-14.9C289.4 83.6 300.5 80 312 80c28.6 0 52.4 21.7 55.3 50.4l2.2 21.6H404c33.1 0 60 26.9 60 60s-26.9 60-60 60z"
  ]
};
export const faCloudSleet = {
  prefix: "far",
  iconName: "cloud-sleet",
  icon: [
    512,
    512,
    [],
    "f741",
    "M87.2 353.7c-7.9-3.9-17.5-.7-21.5 7.2l-64 128c-3.9 7.9-.8 17.5 7.2 21.5 2.3 1.1 4.8 1.7 7.2 1.7 5.8 0 11.5-3.2 14.3-8.8l64-128c3.8-8.1.7-17.7-7.2-21.6zm256 0c-7.9-3.9-17.5-.7-21.5 7.2l-64 128c-3.9 7.9-.8 17.5 7.2 21.5 2.3 1.1 4.8 1.7 7.2 1.7 5.8 0 11.5-3.2 14.3-8.8l64-128c3.8-8.1.7-17.7-7.2-21.6zm151.7 35.4l-8-13.9c-2.2-3.8-7.1-5.1-10.9-2.9l-28 16.1V360c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v28.4l-28-16.1c-3.8-2.2-8.7-.9-10.9 2.9l-8 13.9c-2.2 3.8-.9 8.7 2.9 10.9l27.9 16-27.9 16c-3.8 2.2-5.1 7.1-2.9 10.9l8 13.9c2.2 3.8 7.1 5.1 10.9 2.9l28-16.1V472c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-28.4l28 16.1c3.8 2.2 8.7.9 10.9-2.9l8-13.9c2.2-3.8.9-8.7-2.9-10.9l-27.9-16 27.9-16c3.8-2.2 5.1-7.1 2.9-10.9zm-256 0l-8-13.9c-2.2-3.8-7.1-5.1-10.9-2.9l-28 16.1V360c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v28.4l-28-16.1c-3.8-2.2-8.7-.9-10.9 2.9l-8 13.9c-2.2 3.8-.9 8.7 2.9 10.9l27.9 16-27.9 16c-3.8 2.2-5.1 7.1-2.9 10.9l8 13.9c2.2 3.8 7.1 5.1 10.9 2.9l28-16.1V472c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-28.4l28 16.1c3.8 2.2 8.7.9 10.9-2.9l8-13.9c2.2-3.8.9-8.7-2.9-10.9l-27.9-16 27.9-16c3.8-2.2 5.1-7.1 2.9-10.9zM512 212c0-57.3-44.9-104.3-101.3-107.8C397.2 61.8 358 32 312 32c-13.5 0-26.8 2.6-39.2 7.7C250.3 14.5 218.4 0 184 0 120 0 67.6 50.3 64.2 113.4 25.6 130.4 0 168.5 0 212c0 59.5 48.4 108 108 108h296c59.6 0 108-48.5 108-108zm-464 0c0-28 19.1-52 46.4-58.3l20.8-4.8-2.8-24.9c-.2-1.3-.4-2.6-.4-4 0-39.7 32.3-72 72-72 25.2 0 48.2 13.1 61.4 35.1l13.3 22.1 21.1-14.9C289.4 83.6 300.5 80 312 80c28.6 0 52.4 21.7 55.3 50.4l2.2 21.6H404c33.1 0 60 26.9 60 60s-26.9 60-60 60H108c-33.1 0-60-26.9-60-60z"
  ]
};
export const faCloudSnow = {
  prefix: "far",
  iconName: "cloud-snow",
  icon: [
    512,
    512,
    [],
    "f742",
    "M510.9 389.1l-8-13.9c-2.2-3.8-7.1-5.1-10.9-2.9l-28 16.1V360c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v28.4l-28-16.1c-3.8-2.2-8.7-.9-10.9 2.9l-8 13.9c-2.2 3.8-.9 8.7 2.9 10.9l27.9 16-27.9 16c-3.8 2.2-5.1 7.1-2.9 10.9l8 13.9c2.2 3.8 7.1 5.1 10.9 2.9l28-16.1V472c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-28.4l28 16.1c3.8 2.2 8.7.9 10.9-2.9l8-13.9c2.2-3.8.9-8.7-2.9-10.9l-27.9-16 27.9-16c3.8-2.2 5.1-7.1 2.9-10.9zm-384 0l-8-13.9c-2.2-3.8-7.1-5.1-10.9-2.9l-28 16.1V360c0-4.4-3.6-8-8-8H56c-4.4 0-8 3.6-8 8v28.4l-28-16.1c-3.8-2.2-8.7-.9-10.9 2.9l-8 13.9c-2.2 3.8-.9 8.7 2.9 10.9l27.9 16L4 432c-3.8 2.2-5.1 7.1-2.9 10.9l8 13.9c2.2 3.8 7.1 5.1 10.9 2.9l28-16.1V472c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-28.4l28 16.1c3.8 2.2 8.7.9 10.9-2.9l8-13.9c2.2-3.8.9-8.7-2.9-10.9l-27.9-16 27.9-16c3.8-2.2 5.1-7.1 2.9-10.9zm192 32l-8-13.9c-2.2-3.8-7.1-5.1-10.9-2.9l-28 16.1V392c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v28.4l-28-16.1c-3.8-2.2-8.7-.9-10.9 2.9l-8 13.9c-2.2 3.8-.9 8.7 2.9 10.9l27.9 16-27.9 16c-3.8 2.2-5.1 7.1-2.9 10.9l8 13.9c2.2 3.8 7.1 5.1 10.9 2.9l28-16.1V504c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-28.4l28 16.1c3.8 2.2 8.7.9 10.9-2.9l8-13.9c2.2-3.8.9-8.7-2.9-10.9l-27.9-16 27.9-16c3.8-2.2 5.1-7.1 2.9-10.9zM108 320h296c59.6 0 108-48.5 108-108 0-57.3-44.9-104.3-101.3-107.8C397.2 61.8 358 32 312 32c-13.5 0-26.8 2.6-39.2 7.7C250.3 14.5 218.4 0 184 0 120 0 67.6 50.3 64.2 113.4 25.6 130.4 0 168.5 0 212c0 59.5 48.4 108 108 108zM94.4 153.7l20.7-4.8-2.7-24.9c-.2-1.3-.4-2.6-.4-4 0-39.7 32.3-72 72-72 25.2 0 48.2 13.1 61.4 35.1l13.3 22.1 21.1-14.9C289.4 83.6 300.5 80 312 80c28.6 0 52.4 21.7 55.3 50.4l2.2 21.6H404c33.1 0 60 26.9 60 60s-26.9 60-60 60H108c-33.1 0-60-26.9-60-60 0-28 19.1-52 46.4-58.3z"
  ]
};
export const faCloudSun = {
  prefix: "far",
  iconName: "cloud-sun",
  icon: [
    640,
    512,
    [],
    "f6c4",
    "M582.8 296.4C575.3 246.4 532 208 480 208c-5.1 0-10.2.4-15.2 1.1C440.5 188 409.2 176 376 176c-64 0-118.3 45.2-132.4 105.3C211.6 305.1 192 343 192 384c0 70.6 57.4 128 128 128h204c64 0 116-52 116-116 0-41.8-22.8-79.3-57.2-99.6zM524 464H320c-44.2 0-80-35.8-80-80 0-32.8 19.8-61 48.1-73.3.7-48 39.7-86.7 87.9-86.7 31.2 0 58.4 16.3 74.1 40.8 8.7-5.5 18.9-8.8 29.9-8.8 30.9 0 56 25.1 56 56 0 5.9-1.2 11.5-2.9 16.9 33.2 4.5 58.9 32.6 58.9 67.1 0 37.6-30.4 68-68 68zM106.5 341.3l8.5-43.9 6-31.1-26.2-17.8-37-25.1 37-25.1 26.2-17.8-6-31.1-8.5-43.9 43.7 8.5 31.2 6 17.8-26.3L224 57v1l24.9 36.9 17.8 26.3 31.2-6 43.6-8.5-8.4 43.6c13.9-3.8 28.2-6.3 42.9-6.3 2.4 0 4.7.5 7 .6l9.1-47c2.2-11.6-1.4-23.5-9.7-31.8-6.7-6.7-15.6-10.4-25-10.4-2.2 0-4.5.2-6.8.6l-62 12-35.4-52.4C246.7 5.8 235.8 0 224 0c-11.4 0-22.7 4.9-29.3 14.7l-35.4 52.4-62-12c-2.3-.4-4.5-.7-6.8-.7-9.3 0-18.3 3.7-25 10.4-8.3 8.4-11.9 20.2-9.7 31.8l12 62.1-52.3 35.5C5.8 200.8 0 211.8 0 223.5c0 11.8 5.8 22.7 15.6 29.3l52.3 35.4-12 62.1c-2.2 11.6 1.4 23.5 9.7 31.8 6.7 6.7 15.6 10.4 25 10.4 2.2 0 4.5-.2 6.8-.6l62-12 .8 1.3c.3-18 3.8-35.6 9.9-52.2l-19.8 3.8-43.8 8.5zm109.2-79c-18-3.9-31.7-19.2-31.7-38.3 0-22.1 17.9-40 40-40 12 0 22.4 5.5 29.7 13.9 11-11.8 23.7-21.7 37.5-29.9-16.1-19.4-40.1-32-67.2-32-48.5 0-88 39.5-88 88 0 33.7 19.2 62.7 47.1 77.5 8.7-14.4 19.5-27.4 32.4-38.5.1-.3.2-.5.2-.7z"
  ]
};
export const faCloudSunRain = {
  prefix: "far",
  iconName: "cloud-sun-rain",
  icon: [
    640,
    512,
    [],
    "f743",
    "M588.5 418.1c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm286.9-234.7c-12-36.8-46.7-63.4-87.4-63.4-3.1 0-6.1.2-9.1.5C469.3 104.7 443.2 96 416 96c-52.4 0-97.6 31.3-117.2 77.2C255.4 187.3 224 228 224 276c0 59.6 48.4 108 108 108h200c59.6 0 108-48.4 108-108 0-38.8-20.8-73.6-52.6-92.6zM532 336H332c-33.1 0-60-26.9-60-60s26.9-60 60-60c1.6 0 3.2.4 4.8.5 3.8-40.6 37.6-72.5 79.2-72.5 25.2 0 47.4 11.9 62.1 30.1 6.5-3.8 13.9-6.1 21.9-6.1 24.3 0 44 19.7 44 44 0 1.8-.3 3.4-.5 5.2 27.6 5.4 48.5 29.6 48.5 58.8 0 33.1-26.9 60-60 60zm-339.1-72.3l-5.9 8.7-10.8 16-11.2-16.7-17.8-26.3-31.2 6-19.4 3.8 3.8-19.6 6-31.1-26.2-17.8-16.5-11.2 16.5-11.2 26.2-17.8-6-31.1-3.8-19.5 19.4 3.8 31.2 6L165 79.5l10.8-16L187 80.3l17.8 26.3 31.2-6 19.4-3.7-3.8 19.6-6 31.1 13.5 9.2c5.3-3.2 10.7-6.2 16.4-8.7 7-13 15.7-24.8 25.7-35.2l7-36.1c1.8-9.1-1.1-18.4-7.6-25-5.2-5.3-12.3-8.2-19.6-8.2-1.8 0-3.6.2-5.3.5L227 53.5l-28-41.3C193.9 4.6 185.2 0 176 0c-8.9 0-17.9 3.8-23 11.5l-27.8 41.2-48.7-9.4c-1.8-.3-3.6-.5-5.3-.5-7.3 0-14.3 2.9-19.6 8.2-6.5 6.6-9.4 15.9-7.6 25l9.4 48.8-41.1 27.9C4.6 157.8 0 166.4 0 175.6s4.6 17.9 12.2 23.1l41.1 27.8-9.4 48.8c-1.8 9.1 1.1 18.4 7.6 25 5.2 5.3 12.3 8.2 19.6 8.2 1.8 0 3.6-.2 5.3-.5l48.7-9.4 27.8 41.2c5.2 7.7 13.8 12.3 23 12.3 8.9 0 17.9-3.8 23-11.5l5.2-7.8c-7.8-17.4-12.3-36.5-12.3-56.7.2-4.3.7-8.3 1.1-12.4zM176 136c-22.1 0-40 17.9-40 40s17.9 40 40 40 40-17.9 40-40-17.9-40-40-40z"
  ]
};
export const faCloudUpload = {
  prefix: "far",
  iconName: "cloud-upload",
  icon: [
    640,
    512,
    [],
    "f0ee",
    "M543.7 200.1C539.7 142.1 491.4 96 432 96c-7.6 0-15.1.8-22.4 2.3C377.7 58.3 328.1 32 272 32c-84.6 0-155.5 59.7-172.3 139.8C39.9 196.1 0 254.4 0 320c0 88.4 71.6 160 160 160h336c79.5 0 144-64.5 144-144 0-61.8-39.2-115.8-96.3-135.9zM496 432H160c-61.9 0-112-50.1-112-112 0-56.4 41.7-103.1 96-110.9V208c0-70.7 57.3-128 128-128 53.5 0 99.3 32.8 118.4 79.4 11.2-9.6 25.7-15.4 41.6-15.4 35.3 0 64 28.7 64 64 0 11.8-3.2 22.9-8.8 32.4 2.9-.3 5.9-.4 8.8-.4 53 0 96 43 96 96s-43 96-96 96zM296.5 150.5c-4.7-4.7-12.3-4.7-17 0l-104 104c-4.7 4.7-4.7 12.3 0 17l16.9 16.9c4.7 4.7 12.4 4.7 17.1-.1l54.5-55.8V372c0 6.6 5.4 12 12 12h24c6.6 0 12-5.4 12-12V232.5l54.5 55.8c4.7 4.8 12.3 4.8 17.1.1l16.9-16.9c4.7-4.7 4.7-12.3 0-17l-104-104z"
  ]
};
export const faCloudUploadAlt = {
  prefix: "far",
  iconName: "cloud-upload-alt",
  icon: [
    640,
    512,
    [],
    "f382",
    "M395.5 267.5l-99-99c-4.7-4.7-12.3-4.7-17 0l-99 99c-7.6 7.6-2.2 20.5 8.5 20.5h67v84c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-84h67c10.7 0 16.1-12.9 8.5-20.5zm148.2-67.4C539.7 142.1 491.4 96 432 96c-7.6 0-15.1.8-22.4 2.3C377.7 58.3 328.1 32 272 32c-84.6 0-155.5 59.7-172.3 139.8C39.9 196.1 0 254.4 0 320c0 88.4 71.6 160 160 160h336c79.5 0 144-64.5 144-144 0-61.8-39.2-115.8-96.3-135.9zM496 432H160c-61.9 0-112-50.1-112-112 0-56.4 41.7-103.1 96-110.9V208c0-70.7 57.3-128 128-128 53.5 0 99.3 32.8 118.4 79.4 11.2-9.6 25.7-15.4 41.6-15.4 35.3 0 64 28.7 64 64 0 11.8-3.2 22.9-8.8 32.4 2.9-.3 5.9-.4 8.8-.4 53 0 96 43 96 96s-43 96-96 96z"
  ]
};
export const faClouds = {
  prefix: "far",
  iconName: "clouds",
  icon: [
    640,
    512,
    [],
    "f744",
    "M538.7 296.2C525.2 253.8 486 224 440 224c-13.5 0-26.8 2.6-39.2 7.7-1.8-2.1-4.1-3.6-6-5.5 17-19 26.5-43.6 26.5-68.9 0-57.3-46.7-104-104-104-7 0-13.9.7-20.7 2.1C275.5 21.6 238 0 197.3 0c-51.2 0-96 33.9-111.3 81.6C37.2 90.1 0 132.8 0 184c0 57.3 46.7 104 104 104h90.8c-1.2 5.7-2.3 11.4-2.7 17.4-38.6 17-64.2 55.1-64.2 98.6 0 59.5 48.4 108 108 108h296c59.6 0 108-48.5 108-108 .1-57.3-44.8-104.3-101.2-107.8zM104 240c-30.9 0-56-25.1-56-56 0-30.4 24.4-55.3 54.7-56l23.4.8 3-21.3c4.8-33.9 34.2-59.5 68.2-59.5 29 0 54.3 17.7 64.6 45l9 24 23.3-10.6c7.5-3.4 15.2-5.1 23-5.1 30.9 0 56 25.1 56 56 0 15.8-6.7 30.5-18.8 41.4l-1.3 1.2c-13-4.8-26.8-7.9-41.3-7.9-39.1 0-73.8 18.9-95.7 48H104zm428 224H236c-33.1 0-60-26.9-60-60 0-28 19.1-52 46.4-58.3l20.8-4.8-2.8-24.9c-.2-1.3-.4-2.6-.4-4 0-39.7 32.3-72 72-72 25.2 0 48.2 13.1 61.4 35.1l13.3 22.1 21.1-14.9c9.6-6.8 20.7-10.3 32.2-10.3 28.6 0 52.4 21.7 55.3 50.4l2.2 21.6H532c33.1 0 60 26.9 60 60s-26.9 60-60 60z"
  ]
};
export const faCloudsMoon = {
  prefix: "far",
  iconName: "clouds-moon",
  icon: [
    640,
    512,
    [],
    "f745",
    "M382.8 273.9c-3.8-5.8-8.5-10.7-13.2-15.6 7.4-14.1 11.9-29.9 11.9-47 0-56.1-44.4-102-99.7-103.9-23.7-29.7-60-48.1-99-48.1-40.1 0-77.2 19-100.9 50.3C35.1 119.5 0 161.4 0 211.3c0 37 19.5 69.1 48.6 87.5C21.4 320.7 4.2 354.3 4.2 392c0 66.2 53.5 120 119.2 120h238.4c65.7 0 119.2-53.8 119.2-120 0-59-42.4-108.2-98.2-118.1zM47.7 211.3c0-30.9 24.9-56 55.6-56h6.7c12.3-28.2 40.2-48 72.8-48 34.2 0 63 21.8 74.3 52.2 6.5-2.7 13.6-4.2 21.1-4.2 30.7 0 55.6 25.1 55.6 56 0 7.4-1.8 14.2-4.4 20.7-12.3-4.7-25.2-8-39-8-9.6 0-19 1.2-28.1 3.6-20-12.7-43.3-19.6-67.2-19.6-43.5 0-82.8 22.4-105.8 57.2-24-6.3-41.6-27.9-41.6-53.9zM361.8 464H123.4c-39.5 0-71.5-32.2-71.5-72 0-37.6 28.7-68 65.1-71.3 7.1-36.8 39.3-64.7 77.9-64.7 23.7 0 44.8 10.7 59.4 27.3 10.2-7.1 22.6-11.3 36-11.3 30 0 54.9 20.9 61.6 49 3.3-.5 6.5-1 9.9-1 39.5 0 71.5 32.2 71.5 72 .1 39.8-32 72-71.5 72zm275.9-202c-3.9-8.2-12.1-13.4-21-13.4h-1.5l-2.9.4c-6.9 1.3-13.8 2-20.7 2-59.7 0-108.3-49.1-108.3-109.4 0-39.2 21-75.7 54.9-95.1 8.6-4.9 13.1-14.5 11.4-24.3-1.7-9.8-9-17.4-18.8-19.2-10.3-2-21.1-3-31.7-3-66.6 0-124.6 37.8-154 93.1 14.6 8.3 27.3 19.4 37.8 32.4 14.8-34.4 43.7-61.2 79.8-72.1-17.2 25.6-26.9 56.3-26.9 88.2 0 72.3 48.5 133.3 114.4 151.7-15.9 7-33.2 10.7-51 10.7-5.4 0-10.4-1.1-15.6-1.8 10.7 14.7 18.5 31.4 23.5 49.3 49.9-2.2 96.1-25.4 127.8-64.7 5.6-7.1 6.7-16.6 2.8-24.8z"
  ]
};
export const faCloudsSun = {
  prefix: "far",
  iconName: "clouds-sun",
  icon: [
    640,
    512,
    [],
    "f746",
    "M640 236.8c0-50.8-38.5-92.9-87.8-98.6C532 103.4 494.4 80 452 80c-46 0-85.9 26.4-104.5 66-31.7 13.8-54.4 43.6-58.6 79-22.3 12.7-40.7 31.8-52.1 55.3C191.4 297.6 160 341.1 160 392c0 66.2 53.8 120 120 120h240c66.2 0 120-53.8 120-120 0-32-12.8-60.8-33.3-82.3 20.1-18.1 33.3-43.7 33.3-72.9zM520 464H280c-39.8 0-72-32.2-72-72 0-37.6 28.9-68 65.5-71.3C280.7 283.9 313 256 352 256c23.9 0 45.1 10.7 59.8 27.3 10.3-7.1 22.8-11.3 36.2-11.3 30.2 0 55.3 20.9 62 49 3.3-.5 6.5-1 10-1 39.8 0 72 32.2 72 72s-32.2 72-72 72zm45.6-182.7c-7.8-3.2-15.9-6-24.5-7.5-20.3-30.5-54.7-49.8-93.1-49.8-9.6 0-19.2 1.2-28.3 3.6-20.2-12.7-43.6-19.6-67.7-19.6-2.2 0-4.2.4-6.4.5 8.8-12.9 22.8-21.9 39.4-22.6 4.9-32.7 32.9-57.8 67-57.8 35.8 0 64.8 27.8 67.5 62.9 6.5-3.1 13.6-5.3 21.3-5.3 28.3 0 51.2 22.9 51.2 51.2 0 19.1-10.7 35.7-26.4 44.4zM115 297.4l6-31.1-26.2-17.8-37-25.1 37-25.1 26.2-17.8-6-31.1-8.5-43.9 43.7 8.5 31.2 6 17.8-26.3L224 57v1l24.9 36.9 17.8 26.3 31.2-6 35.1-6.8c13.1-18 29.9-32.5 49.2-42.8-6.6-6.5-15.4-10.2-24.6-10.2-2.2 0-4.5.2-6.8.6l-62 12-35.4-52.4C246.7 5.8 235.8 0 224 0c-11.4 0-22.7 4.9-29.3 14.7l-35.4 52.4-62-12c-2.3-.4-4.5-.7-6.8-.7-9.3 0-18.3 3.7-25 10.4-8.3 8.4-11.9 20.2-9.7 31.8l12 62.1-52.3 35.5C5.8 200.8 0 211.8 0 223.5c0 11.8 5.8 22.7 15.6 29.3l52.3 35.4-12 62.1c-2.2 11.6 1.4 23.5 9.7 31.8 6.7 6.7 15.6 10.4 25 10.4 2.2 0 4.5-.2 6.8-.6l31.1-6c.7-17.9 4.4-35.1 10.8-51l-32.7 6.3 8.4-43.8zM224 184c15.5 0 28.7 9.1 35.3 22.1.3-.2.6-.4.8-.6 4.2-17.1 11.6-33.1 22-47.1-15.5-13.7-35.7-22.4-58.1-22.4-48.5 0-88 39.5-88 88 0 26.7 12.2 50.3 31 66.5 11.1-12.3 24.4-22.7 39.5-31C193.3 253 184 239.7 184 224c0-22.1 17.9-40 40-40z"
  ]
};
export const faClub = {
  prefix: "far",
  iconName: "club",
  icon: [
    512,
    512,
    [],
    "f327",
    "M256 48c60.3 0 101.3 60.9 79.6 116.5L321 201.9c-1.6 4 1.4 8.2 5.6 8.2.3 0 .5 0 .8-.1l39.8-5.3c3.9-.5 7.7-.8 11.5-.8 46.8 0 85.5 38.2 85.3 85.8-.2 47.3-39.4 85.1-86.6 85.1h-.8c-38.1-.3-48.9-6-78.4-36.2-1.2-1.3-2.7-1.8-4.2-1.8-3.1 0-6 2.4-6 6V360c0 37.7-2.3 48.8 24.7 82.9 6.8 8.5.7 21.1-10.2 21.1h-93.1c-10.9 0-16.9-12.6-10.2-21.1 27-34 24.7-45.2 24.7-82.9v-17.1c0-3.6-3-6-6-6-1.5 0-3 .6-4.2 1.8-29.2 29.9-40.1 35.8-78.3 36.2h-.8c-47.2 0-86.5-37.9-86.6-85.2-.1-47.5 38.6-85.6 85.3-85.6 3.8 0 7.6.2 11.5.8l39.8 5.3c.3 0 .5.1.8.1 4.1 0 7.1-4.2 5.6-8.2l-14.6-37.4C154.6 108.8 195.8 48 256 48m0-48c-22.4 0-44.5 5.6-63.9 16.2-18.3 10-34.3 24.6-46.2 42-11.9 17.4-19.6 37.6-22.3 58.4-1.7 13.2-1.4 26.6.9 39.7-14.8 1-29.3 4.4-43.1 10.3-15.9 6.8-30.2 16.4-42.4 28.7-25.2 25.3-39.1 58.8-39 94.5.2 73.4 60.5 133.1 134.6 133.1h1.2c6.9-.1 13.5-.3 19.9-.8-3.9 7.2-6.3 15.2-7.1 23.5-1 11 1 22.1 5.9 32 4.8 10 12.2 18.4 21.4 24.5 9.9 6.5 21.5 10 33.5 10h93.1c12 0 23.6-3.5 33.5-10 9.2-6.1 16.6-14.5 21.4-24.5 4.8-10 6.8-21 5.9-32-.7-8.3-3.2-16.2-7.1-23.5 6.4.5 13 .8 20 .8h1.2c73.9 0 134.3-59.6 134.6-132.9.1-35.7-13.7-69.3-38.9-94.6-12.3-12.3-26.5-22-42.5-28.7-13.8-5.9-28.3-9.3-43.1-10.3 2.3-13.1 2.6-26.5.9-39.7-2.7-20.8-10.4-41-22.3-58.4s-27.9-31.9-46.2-41.9C300.5 5.6 278.4 0 256 0z"
  ]
};
export const faCocktail = {
  prefix: "far",
  iconName: "cocktail",
  icon: [
    576,
    512,
    [],
    "f561",
    "M296 464h-64V346.78l176.74-176.73c15.52-15.52 4.53-42.05-17.42-42.05H24.68c-21.95 0-32.94 26.53-17.42 42.05L184 346.78V464h-64c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h240c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40zM81.1 176h253.8L208 302.9 81.1 176zM432 0c-62.61 0-115.35 40.2-135.18 96h52.54c16.65-28.55 47.27-48 82.64-48 52.93 0 96 43.06 96 96s-43.07 96-96 96c-14.04 0-27.29-3.2-39.32-8.64l-35.26 35.26C379.23 279.92 404.59 288 432 288c79.53 0 144-64.47 144-144S511.53 0 432 0z"
  ]
};
export const faCode = {
  prefix: "far",
  iconName: "code",
  icon: [
    576,
    512,
    [],
    "f121",
    "M234.8 511.7L196 500.4c-4.2-1.2-6.7-5.7-5.5-9.9L331.3 5.8c1.2-4.2 5.7-6.7 9.9-5.5L380 11.6c4.2 1.2 6.7 5.7 5.5 9.9L244.7 506.2c-1.2 4.3-5.6 6.7-9.9 5.5zm-83.2-121.1l27.2-29c3.1-3.3 2.8-8.5-.5-11.5L72.2 256l106.1-94.1c3.4-3 3.6-8.2.5-11.5l-27.2-29c-3-3.2-8.1-3.4-11.3-.4L2.5 250.2c-3.4 3.2-3.4 8.5 0 11.7L140.3 391c3.2 3 8.2 2.8 11.3-.4zm284.1.4l137.7-129.1c3.4-3.2 3.4-8.5 0-11.7L435.7 121c-3.2-3-8.3-2.9-11.3.4l-27.2 29c-3.1 3.3-2.8 8.5.5 11.5L503.8 256l-106.1 94.1c-3.4 3-3.6 8.2-.5 11.5l27.2 29c3.1 3.2 8.1 3.4 11.3.4z"
  ]
};
export const faCodeBranch = {
  prefix: "far",
  iconName: "code-branch",
  icon: [
    384,
    512,
    [],
    "f126",
    "M384 144c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 36.4 24.3 67.1 57.5 76.8-.6 16.1-4.2 28.5-11 36.9-15.4 19.2-49.3 22.4-85.2 25.7-28.2 2.6-57.4 5.4-81.3 16.9v-144c32.5-10.2 56-40.5 56-76.3 0-44.2-35.8-80-80-80S0 35.8 0 80c0 35.8 23.5 66.1 56 76.3v199.3C23.5 365.9 0 396.2 0 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-34-21.2-63.1-51.2-74.6 3.1-5.2 7.8-9.8 14.9-13.4 16.2-8.2 40.4-10.4 66.1-12.8 42.2-3.9 90-8.4 118.2-43.5 14-17.4 21.1-39.8 21.6-67.9 31.6-10.7 54.4-40.6 54.4-75.8zM80 48c17.6 0 32 14.4 32 32s-14.4 32-32 32-32-14.4-32-32 14.4-32 32-32zm0 416c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm224-288c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32z"
  ]
};
export const faCodeCommit = {
  prefix: "far",
  iconName: "code-commit",
  icon: [
    640,
    512,
    [],
    "f386",
    "M128 256c0 10.8.9 21.5 2.6 32H12c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h118.6c-1.7 10.5-2.6 21.2-2.6 32zm500-32H509.4c1.8 10.5 2.6 21.2 2.6 32s-.9 21.5-2.6 32H628c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12zm-308-80c-29.9 0-58 11.7-79.2 32.8C219.6 198 208 226.1 208 256s11.6 58 32.8 79.2C262 356.3 290.1 368 320 368s58-11.7 79.2-32.8C420.4 314 432 285.9 432 256s-11.6-58-32.8-79.2C378 155.7 349.9 144 320 144m0-48c88.4 0 160 71.6 160 160s-71.6 160-160 160-160-71.6-160-160S231.6 96 320 96z"
  ]
};
export const faCodeMerge = {
  prefix: "far",
  iconName: "code-merge",
  icon: [
    384,
    512,
    [],
    "f387",
    "M304 192c-38 0-69.8 26.5-77.9 62-23.9-3.5-58-12.9-83.9-37.6-16.6-15.9-27.9-36.5-33.7-61.6C138.6 143.3 160 114.1 160 80c0-44.2-35.8-80-80-80S0 35.8 0 80c0 35.8 23.5 66.1 56 76.3v199.3C23.5 365.9 0 396.2 0 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-35.8-23.5-66.1-56-76.3V246.1c1.6 1.7 3.3 3.4 5 5 39.3 37.5 90.4 48.6 121.2 51.8 12.1 28.9 40.6 49.2 73.8 49.2 44.2 0 80-35.8 80-80S348.2 192 304 192zM80 48c17.6 0 32 14.4 32 32s-14.4 32-32 32-32-14.4-32-32 14.4-32 32-32zm0 416c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm224-160c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32z"
  ]
};
export const faCoffee = {
  prefix: "far",
  iconName: "coffee",
  icon: [
    640,
    512,
    [],
    "f0f4",
    "M512 32H112c-8.8 0-16 7.2-16 16v256c0 44.2 35.8 80 80 80h224c44.2 0 80-35.8 80-80v-16h32c70.6 0 128-57.4 128-128S582.6 32 512 32zm-80 272c0 17.6-14.4 32-32 32H176c-17.6 0-32-14.4-32-32V80h288v224zm80-64h-32V80h32c44.1 0 80 35.9 80 80s-35.9 80-80 80zm55.8 240H40.2c-37.3 0-50.2-48-32-48h591.7c18.1 0 5.2 48-32.1 48z"
  ]
};
export const faCoffeePot = {
  prefix: "far",
  iconName: "coffee-pot",
  icon: [
    512,
    512,
    [],
    "e002",
    "M428,175,480,32H88A88,88,0,0,0,0,120v88a16,16,0,0,0,16,16H32a16,16,0,0,0,16-16V120A40,40,0,0,1,88,80h25.46l34.73,95.53C96.92,215.22,64,276.16,64,344.62c0,51.47,18.62,84.77,49.64,117.71A57.18,57.18,0,0,0,155.17,480H420.84a57.08,57.08,0,0,0,41.45-17.6c31-32.95,49.69-66.24,49.71-117.72C512,276.86,480,215.07,428,175ZM411.47,80l-29.09,80H193.62L164.53,80ZM114.09,320c7.11-46.22,34.2-85.91,72.12-112H392.07c37.25,26.13,63,66.23,69.84,112Z"
  ]
};
export const faCoffeeTogo = {
  prefix: "far",
  iconName: "coffee-togo",
  icon: [
    448,
    512,
    [],
    "f6c5",
    "M432 96h-16l-24.71-74.12C386.94 8.81 374.71 0 360.94 0h-274C73.16 0 61.07 8.81 56.71 21.88L32 96H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h19.84l25.8 322.55C62.97 499.18 76.86 512 93.54 512h260.92c16.68 0 30.57-12.82 31.9-29.45L412.16 160H432c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM98.6 48h250.8l21.33 64H77.26L98.6 48zm9.71 416l-7.68-96h246.73l-7.68 96H108.31zm250.58-240H89.11l-5.12-64H364l-5.11 64z"
  ]
};
export const faCoffin = {
  prefix: "far",
  iconName: "coffin",
  icon: [
    384,
    512,
    [],
    "f6c6",
    "M374.44,115.19,266.7,9.37a32.89,32.89,0,0,0-23-9.37H140.32a32.89,32.89,0,0,0-23,9.37L9.54,115.19A31.61,31.61,0,0,0,1,145.58L88.08,487.76A32.47,32.47,0,0,0,119.69,512H264.31a32.48,32.48,0,0,0,31.61-24.24L383,145.58a31.65,31.65,0,0,0-8.59-30.39ZM252.43,464H131.55L49.81,142.91,146.45,48h91.08l96.64,94.91Z"
  ]
};
export const faCoffinCross = {
  prefix: "far",
  iconName: "coffin-cross",
  icon: [
    384,
    512,
    [],
    "e051",
    "M374.45 115.19L266.71 9.37c-6.11-6-14.4-9.37-23.04-9.37H140.33c-8.64 0-16.93 3.37-23.04 9.37L9.55 115.19C1.46 123.14-1.8 134.67.98 145.58l87.11 342.18C91.71 502.01 104.75 512 119.7 512h144.62c14.95 0 27.98-9.99 31.61-24.24l87.11-342.18c2.76-10.91-.49-22.44-8.59-30.39zM252.44 464H131.56L49.82 142.91 146.46 48h91.08l96.64 94.91L252.44 464zM216 112c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v48h-56c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h56v128c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V208h56c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16h-56v-48z"
  ]
};
export const faCog = {
  prefix: "far",
  iconName: "cog",
  icon: [
    512,
    512,
    [],
    "f013",
    "M452.515 237l31.843-18.382c9.426-5.441 13.996-16.542 11.177-27.054-11.404-42.531-33.842-80.547-64.058-110.797-7.68-7.688-19.575-9.246-28.985-3.811l-31.785 18.358a196.276 196.276 0 0 0-32.899-19.02V39.541a24.016 24.016 0 0 0-17.842-23.206c-41.761-11.107-86.117-11.121-127.93-.001-10.519 2.798-17.844 12.321-17.844 23.206v36.753a196.276 196.276 0 0 0-32.899 19.02l-31.785-18.358c-9.41-5.435-21.305-3.877-28.985 3.811-30.216 30.25-52.654 68.265-64.058 110.797-2.819 10.512 1.751 21.613 11.177 27.054L59.485 237a197.715 197.715 0 0 0 0 37.999l-31.843 18.382c-9.426 5.441-13.996 16.542-11.177 27.054 11.404 42.531 33.842 80.547 64.058 110.797 7.68 7.688 19.575 9.246 28.985 3.811l31.785-18.358a196.202 196.202 0 0 0 32.899 19.019v36.753a24.016 24.016 0 0 0 17.842 23.206c41.761 11.107 86.117 11.122 127.93.001 10.519-2.798 17.844-12.321 17.844-23.206v-36.753a196.34 196.34 0 0 0 32.899-19.019l31.785 18.358c9.41 5.435 21.305 3.877 28.985-3.811 30.216-30.25 52.654-68.266 64.058-110.797 2.819-10.512-1.751-21.613-11.177-27.054L452.515 275c1.22-12.65 1.22-25.35 0-38zm-52.679 63.019l43.819 25.289a200.138 200.138 0 0 1-33.849 58.528l-43.829-25.309c-31.984 27.397-36.659 30.077-76.168 44.029v50.599a200.917 200.917 0 0 1-67.618 0v-50.599c-39.504-13.95-44.196-16.642-76.168-44.029l-43.829 25.309a200.15 200.15 0 0 1-33.849-58.528l43.819-25.289c-7.63-41.299-7.634-46.719 0-88.038l-43.819-25.289c7.85-21.229 19.31-41.049 33.849-58.529l43.829 25.309c31.984-27.397 36.66-30.078 76.168-44.029V58.845a200.917 200.917 0 0 1 67.618 0v50.599c39.504 13.95 44.196 16.642 76.168 44.029l43.829-25.309a200.143 200.143 0 0 1 33.849 58.529l-43.819 25.289c7.631 41.3 7.634 46.718 0 88.037zM256 160c-52.935 0-96 43.065-96 96s43.065 96 96 96 96-43.065 96-96-43.065-96-96-96zm0 144c-26.468 0-48-21.532-48-48 0-26.467 21.532-48 48-48s48 21.533 48 48c0 26.468-21.532 48-48 48z"
  ]
};
export const faCogs = {
  prefix: "far",
  iconName: "cogs",
  icon: [
    640,
    512,
    [],
    "f085",
    "M217.1 478.1c-23.8 0-41.6-3.5-57.5-7.5-10.6-2.7-18.1-12.3-18.1-23.3v-31.7c-9.4-4.4-18.4-9.6-26.9-15.6l-26.7 15.4c-9.6 5.6-21.9 3.8-29.5-4.3-35.4-37.6-44.2-58.6-57.2-98.5-3.6-10.9 1.1-22.7 11-28.4l26.8-15c-.9-10.3-.9-20.7 0-31.1L12.2 223c-10-5.6-14.6-17.5-11-28.4 13.1-40 21.9-60.9 57.2-98.5 7.6-8.1 19.8-9.9 29.5-4.3l26.7 15.4c8.5-6 17.5-11.2 26.9-15.6V61.4c0-11.1 7.6-20.8 18.4-23.3 44.2-10.5 70-10.5 114.3 0 10.8 2.6 18.4 12.2 18.4 23.3v30.4c9.4 4.4 18.4 9.6 26.9 15.6L346.2 92c9.7-5.6 21.9-3.7 29.6 4.4 26.1 27.9 48.4 58.5 56.8 100.3 2 9.8-2.4 19.8-10.9 25.1l-26.6 16.5c.9 10.3.9 20.7 0 31.1l26.6 16.5c8.4 5.2 12.9 15.2 10.9 24.9-8.1 40.5-29.6 71.3-56.9 100.6-7.6 8.1-19.8 9.9-29.5 4.3l-26.7-15.4c-8.5 6-17.5 11.2-26.9 15.6v31.7c0 11-7.4 20.6-18.1 23.3-15.8 3.8-33.6 7.2-57.4 7.2zm-27.6-50.7c18.3 2.9 36.9 2.9 55.1 0v-44.8l16-5.7c15.2-5.4 29.1-13.4 41.3-23.9l12.9-11 38.8 22.4c11.7-14.4 21-30.5 27.6-47.7l-38.8-22.4 3.1-16.7c2.9-15.9 2.9-32 0-47.9l-3.1-16.7 38.8-22.4c-6.6-17.2-15.9-33.3-27.6-47.7l-38.8 22.4-12.9-11c-12.3-10.5-26.2-18.6-41.3-23.9l-16-5.7V80c-18.3-2.9-36.9-2.9-55.1 0v44.8l-16 5.7c-15.2 5.4-29.1 13.4-41.3 23.9l-12.9 11L80.5 143c-11.7 14.4-21 30.5-27.6 47.7l38.8 22.4-3.1 16.7c-2.9 15.9-2.9 32 0 47.9l3.1 16.7-38.8 22.4c6.6 17.2 15.9 33.4 27.6 47.7l38.8-22.4 12.9 11c12.3 10.5 26.2 18.6 41.3 23.9l16 5.7v44.7zm27.1-85.1c-22.6 0-45.2-8.6-62.4-25.8-34.4-34.4-34.4-90.4 0-124.8 34.4-34.4 90.4-34.4 124.8 0 34.4 34.4 34.4 90.4 0 124.8-17.3 17.2-39.9 25.8-62.4 25.8zm0-128.4c-10.3 0-20.6 3.9-28.5 11.8-15.7 15.7-15.7 41.2 0 56.9 15.7 15.7 41.2 15.7 56.9 0 15.7-15.7 15.7-41.2 0-56.9-7.8-7.9-18.1-11.8-28.4-11.8zM638.5 85c-1-5.8-6-10-11.9-10h-16.1c-3.5-9.9-8.8-19-15.5-26.8l8-13.9c2.9-5.1 1.8-11.6-2.7-15.3C591 11.3 580.5 5.1 569 .8c-5.5-2.1-11.8.1-14.7 5.3l-8 13.9c-10.2-1.9-20.7-1.9-30.9 0l-8-13.9c-3-5.1-9.2-7.3-14.7-5.3-11.5 4.3-22.1 10.5-31.4 18.2-4.5 3.7-5.7 10.2-2.7 15.3l8 13.9c-6.7 7.8-12 16.9-15.5 26.8H435c-5.9 0-11 4.3-11.9 10.2-2 12.2-1.9 24.5 0 36.2 1 5.8 6 10 11.9 10h16.1c3.5 9.9 8.8 19 15.5 26.8l-8 13.9c-2.9 5.1-1.8 11.6 2.7 15.3 9.3 7.7 19.9 13.9 31.4 18.2 5.5 2.1 11.8-.1 14.7-5.3l8-13.9c10.2 1.9 20.7 1.9 30.9 0l8 13.9c3 5.1 9.2 7.3 14.7 5.3 11.5-4.3 22.1-10.5 31.4-18.2 4.5-3.7 5.7-10.2 2.7-15.3l-8-13.9c6.7-7.8 12-16.9 15.5-26.8h16.1c5.9 0 11-4.3 11.9-10.2 1.9-12.2 1.9-24.4-.1-36.2zm-107.8 50.2c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm107.8 255.4c-1-5.8-6-10-11.9-10h-16.1c-3.5-9.9-8.8-19-15.5-26.8l8-13.9c2.9-5.1 1.8-11.6-2.7-15.3-9.3-7.7-19.9-13.9-31.4-18.2-5.5-2.1-11.8.1-14.7 5.3l-8 13.9c-10.2-1.9-20.7-1.9-30.9 0l-8-13.9c-3-5.1-9.2-7.3-14.7-5.3-11.5 4.3-22.1 10.5-31.4 18.2-4.5 3.7-5.7 10.2-2.7 15.3l8 13.9c-6.7 7.8-12 16.9-15.5 26.8h-16.1c-5.9 0-11 4.3-11.9 10.2-2 12.2-1.9 24.5 0 36.2 1 5.8 6 10 11.9 10H451c3.5 9.9 8.8 19 15.5 26.8l-8 13.9c-2.9 5.1-1.8 11.6 2.7 15.3 9.3 7.7 19.9 13.9 31.4 18.2 5.5 2.1 11.8-.1 14.7-5.3l8-13.9c10.2 1.9 20.7 1.9 30.9 0l8 13.9c3 5.1 9.2 7.3 14.7 5.3 11.5-4.3 22.1-10.5 31.4-18.2 4.5-3.7 5.7-10.2 2.7-15.3l-8-13.9c6.7-7.8 12-16.9 15.5-26.8h16.1c5.9 0 11-4.3 11.9-10.2 2-12.1 2-24.4 0-36.2zm-107.8 50.2c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
  ]
};
export const faCoin = {
  prefix: "far",
  iconName: "coin",
  icon: [
    512,
    512,
    [],
    "f85c",
    "M256 64C114.67 64 0 128.44 0 208v112c0 70.72 114.67 128 256 128s256-57.28 256-128V208c0-79.56-114.67-144-256-144zM88 363.37C62.42 349.16 48 333.2 48 320v-28.27a226 226 0 0 0 40 24.75zm96 30.88a348.83 348.83 0 0 1-64-16.32v-48.09a373.73 373.73 0 0 0 64 16.28zm112 4c-12.81 1.1-26.1 1.78-40 1.78s-27.19-.68-40-1.78v-48.18c13.07 1.16 26.36 1.93 40 1.93s26.93-.77 40-1.93zm96-20.29a348.83 348.83 0 0 1-64 16.32v-48.16a373.73 373.73 0 0 0 64-16.28zM464 320c0 13.2-14.42 29.16-40 43.37v-46.89a226 226 0 0 0 40-24.75zm-208-16c-119 0-208-50.68-208-96s89-96 208-96 208 50.68 208 96-88.95 96-208 96z"
  ]
};
export const faCoins = {
  prefix: "far",
  iconName: "coins",
  icon: [
    512,
    512,
    [],
    "f51e",
    "M320 0C214 0 128 35.8 128 80v52.6C53.5 143.6 0 173.2 0 208v224c0 44.2 86 80 192 80s192-35.8 192-80v-52.7c74.5-11 128-40.5 128-75.3V80c0-44.2-86-80-192-80zm16 428.3C326 440 275.6 464 192 464S58 440 48 428.3v-39.5c35.2 16.6 86.6 27.2 144 27.2s108.8-10.6 144-27.2v39.5zm0-96C326 344 275.6 368 192 368S58 344 48 332.3v-44.9c35.2 20 86.6 32.6 144 32.6s108.8-12.7 144-32.6v44.9zM192 272c-79.5 0-144-21.5-144-48s64.5-48 144-48 144 21.5 144 48-64.5 48-144 48zm272 28.3c-7.1 8.3-34.9 22.6-80 30.4V283c31-4.6 58.7-12.1 80-22.2v39.5zm0-96c-7.1 8.3-34.9 22.6-80 30.4V208c0-7.2-2.5-14.2-6.8-20.9 33.8-5.3 64-14.8 86.8-27.8v45zM320 144c-5 0-9.8-.3-14.7-.5-26-7.9-56.8-13.2-90.4-14.9C191 120 176 108.6 176 96c0-26.5 64.5-48 144-48s144 21.5 144 48-64.5 48-144 48z"
  ]
};
export const faColumns = {
  prefix: "far",
  iconName: "columns",
  icon: [
    512,
    512,
    [],
    "f0db",
    "M464 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM232 432H54a6 6 0 0 1-6-6V112h184v320zm226 0H280V112h184v314a6 6 0 0 1-6 6z"
  ]
};
export const faComet = {
  prefix: "far",
  iconName: "comet",
  icon: [
    512,
    512,
    [],
    "e003",
    "M308.422,263.93781l-61.1094-8.92187L219.961,199.48281a13.37629,13.37629,0,0,0-24.01563,0l-27.35353,55.53313-61.10939,8.92187a13.40072,13.40072,0,0,0-7.40625,22.86911l44.26173,43.166-10.4961,61.01164a13.38,13.38,0,0,0,19.416,14.11913l54.69533-28.81051,54.69533,28.81051a13.386,13.386,0,0,0,19.416-14.11913L271.631,329.97288l44.25392-43.166A13.4298,13.4298,0,0,0,308.422,263.93781ZM502.34978,9.75648a32.86732,32.86732,0,0,0-33.0879-8.29687c-28.4004,8.5-94.98245,29.18356-153.252,52.291a38.60717,38.60717,0,0,0-53.8965-20.29489c-42.21095,21.998-146.28325,79.17959-203.461,136.283-78.20315,78.19522-78.20315,205.36889,0,283.56411a200.55452,200.55452,0,0,0,283.53916,0c57.084-56.99407,114.38481-161.28105,136.38091-203.36889a38.52636,38.52636,0,0,0-20.40235-53.90033c23.1836-58.49407,43.8047-124.89438,52.30275-153.18731A32.66975,32.66975,0,0,0,502.34978,9.75648Zm-71.5801,227.97433c-23.90235,44.79291-73.98635,133.18929-122.47661,181.57594a152.39983,152.39983,0,0,1-215.64655,0c-59.39456-59.49406-59.39456-156.1873,0-215.68137,49.084-49.08783,141.754-101.08191,181.6524-122.3768,2.446,8.03684,4.29138,14.41977,10.998,37.38667l24.90236-10.68749c47.584-20.40427,107.3848-40.19917,146.28325-52.40032-12.2168,38.79292-31.9004,98.39636-52.3965,146.28107l-10.7168,24.90426C421.60232,235.09874,424.78362,236.06512,430.76968,237.73081Z"
  ]
};
export const faComment = {
  prefix: "far",
  iconName: "comment",
  icon: [
    512,
    512,
    [],
    "f075",
    "M256 32C114.6 32 0 125.1 0 240c0 47.6 19.9 91.2 52.9 126.3C38 405.7 7 439.1 6.5 439.5c-6.6 7-8.4 17.2-4.6 26S14.4 480 24 480c61.5 0 110-25.7 139.1-46.3C192 442.8 223.2 448 256 448c141.4 0 256-93.1 256-208S397.4 32 256 32zm0 368c-26.7 0-53.1-4.1-78.4-12.1l-22.7-7.2-19.5 13.8c-14.3 10.1-33.9 21.4-57.5 29 7.3-12.1 14.4-25.7 19.9-40.2l10.6-28.1-20.6-21.8C69.7 314.1 48 282.2 48 240c0-88.2 93.3-160 208-160s208 71.8 208 160-93.3 160-208 160z"
  ]
};
export const faCommentAlt = {
  prefix: "far",
  iconName: "comment-alt",
  icon: [
    512,
    512,
    [],
    "f27a",
    "M448 0H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v84c0 7.1 5.8 12 12 12 2.4 0 4.9-.7 7.1-2.4L304 416h144c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zm16 352c0 8.8-7.2 16-16 16H288l-12.8 9.6L208 428v-60H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h384c8.8 0 16 7.2 16 16v288z"
  ]
};
export const faCommentAltCheck = {
  prefix: "far",
  iconName: "comment-alt-check",
  icon: [
    512,
    512,
    [],
    "f4a2",
    "M448 0H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v84c0 7.1 5.8 12 12 12 2.4 0 4.9-.7 7.1-2.4L304 416h144c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zm16 352c0 8.8-7.2 16-16 16H288l-12.8 9.6L208 428v-60H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h384c8.8 0 16 7.2 16 16v288zM332.7 130.4c-3.8-3.9-10.1-3.9-14-.1L231.4 217l-37.9-38.2c-3.8-3.9-10.1-3.9-14-.1l-23.4 23.2c-3.9 3.8-3.9 10.1-.1 14l68.1 68.6c3.8 3.9 10.1 3.9 14 .1l117.8-116.8c3.9-3.8 3.9-10.1.1-14l-23.3-23.4z"
  ]
};
export const faCommentAltDollar = {
  prefix: "far",
  iconName: "comment-alt-dollar",
  icon: [
    512,
    512,
    [],
    "f650",
    "M448 0H64C28.65 0 0 28.65 0 64v288c0 35.35 28.65 64 64 64h96v83.98c0 7.1 5.83 12.02 12.05 12.02 2.41 0 4.88-.74 7.08-2.37L304 416h144c35.35 0 64-28.65 64-64V64c0-35.35-28.65-64-64-64zm16 352c0 8.82-7.18 16-16 16H288l-12.8 9.6-67.2 50.39V368H64c-8.82 0-16-7.18-16-16V64c0-8.82 7.18-16 16-16h384c8.82 0 16 7.18 16 16v288zM286.41 191.72l-50.07-14.3a8.46 8.46 0 0 1-6.12-8.11c0-4.64 3.78-8.42 8.44-8.42h32.78c3.6 0 7.08.77 10.26 2.22 4.8 2.21 10.37 1.71 14.11-2.03l17.52-17.52c5.27-5.27 4.67-14.28-1.55-18.38-9.5-6.27-20.35-10.11-31.78-11.46V96c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v17.56c-30.29 3.62-53.37 30.98-49.32 63.05 2.9 22.95 20.66 41.31 42.91 47.67l50.07 14.3a8.46 8.46 0 0 1 6.12 8.11c0 4.64-3.78 8.42-8.44 8.42h-32.78c-3.6 0-7.08-.77-10.26-2.22-4.8-2.21-10.37-1.71-14.11 2.03l-17.52 17.52c-5.27 5.27-4.68 14.28 1.55 18.38 9.5 6.27 20.35 10.11 31.78 11.46V320c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-17.56c30.29-3.62 53.37-30.98 49.32-63.05-2.9-22.95-20.66-41.31-42.91-47.67z"
  ]
};
export const faCommentAltDots = {
  prefix: "far",
  iconName: "comment-alt-dots",
  icon: [
    512,
    512,
    [],
    "f4a3",
    "M448 0H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v84c0 7.1 5.8 12 12 12 2.4 0 4.9-.7 7.1-2.4L304 416h144c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zm16 352c0 8.8-7.2 16-16 16H288l-12.8 9.6L208 428v-60H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h384c8.8 0 16 7.2 16 16v288zM128 176c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm128 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm128 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"
  ]
};
export const faCommentAltEdit = {
  prefix: "far",
  iconName: "comment-alt-edit",
  icon: [
    512,
    512,
    [],
    "f4a4",
    "M448 0H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v84c0 7.1 5.8 12 12 12 2.4 0 4.9-.7 7.1-2.4L304 416h144c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zm16 352c0 8.8-7.2 16-16 16H288l-12.8 9.6L208 428v-60H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h384c8.8 0 16 7.2 16 16v288zM164.9 243.2l-4.8 42.8c-.6 5.7 4.2 10.6 10 10l42.8-4.8 85.5-85.5-48-48-85.5 85.5zm159.3-133.9c-7-7-18.4-7-25.4 0l-28.3 28.3 48 48 28.3-28.3c7-7 7-18.4 0-25.4l-22.6-22.6z"
  ]
};
export const faCommentAltExclamation = {
  prefix: "far",
  iconName: "comment-alt-exclamation",
  icon: [
    512,
    512,
    [],
    "f4a5",
    "M256 256c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zM448 0H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v84c0 7.1 5.8 12 12 12 2.4 0 4.9-.7 7.1-2.4L304 416h144c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zm16 352c0 8.8-7.2 16-16 16H288l-12.8 9.6L208 428v-60H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h384c8.8 0 16 7.2 16 16v288zM284.7 96h-57.4c-10 0-17.6 9.1-15.7 18.9l18 96c1.4 7.6 8 13.1 15.7 13.1h21.4c7.7 0 14.3-5.5 15.7-13.1l18-96c1.9-9.8-5.7-18.9-15.7-18.9z"
  ]
};
export const faCommentAltLines = {
  prefix: "far",
  iconName: "comment-alt-lines",
  icon: [
    512,
    512,
    [],
    "f4a6",
    "M448 0H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v84c0 7.1 5.8 12 12 12 2.4 0 4.9-.7 7.1-2.4L304 416h144c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zm16 352c0 8.8-7.2 16-16 16H288l-12.8 9.6L208 428v-60H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h384c8.8 0 16 7.2 16 16v288zm-96-216H144c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zm-96 96H144c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16z"
  ]
};
export const faCommentAltMedical = {
  prefix: "far",
  iconName: "comment-alt-medical",
  icon: [
    512,
    512,
    [],
    "f7f4",
    "M448 0H64A64 64 0 0 0 0 64v288a64 64 0 0 0 64 64h96v84a12 12 0 0 0 12.05 12 11.84 11.84 0 0 0 7.08-2.37L304 416h144a64 64 0 0 0 64-64V64a64 64 0 0 0-64-64zm16 352a16 16 0 0 1-16 16H288l-12.79 9.6L208 428v-60H64a16 16 0 0 1-16-16V64a16 16 0 0 1 16-16h384a16 16 0 0 1 16 16zM344 176h-56v-56a8 8 0 0 0-8-8h-48a8 8 0 0 0-8 8v56h-56a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8h56v56a8 8 0 0 0 8 8h48a8 8 0 0 0 8-8v-56h56a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8z"
  ]
};
export const faCommentAltMinus = {
  prefix: "far",
  iconName: "comment-alt-minus",
  icon: [
    512,
    512,
    [],
    "f4a7",
    "M448 0H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v84c0 7.1 5.8 12 12 12 2.4 0 4.9-.7 7.1-2.4L304 416h144c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zm16 352c0 8.8-7.2 16-16 16H288l-12.8 9.6L208 428v-60H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h384c8.8 0 16 7.2 16 16v288zM336 184H176c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h160c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16z"
  ]
};
export const faCommentAltMusic = {
  prefix: "far",
  iconName: "comment-alt-music",
  icon: [
    512,
    512,
    [],
    "f8af",
    "M331.19 96.75l-128 47.25A16 16 0 0 0 192 159.25V258a69.82 69.82 0 0 0-16-2c-26.5 0-48 14.33-48 32s21.5 32 48 32 48-14.33 48-32v-84.84l96-37.52V226a69.82 69.82 0 0 0-16-2c-26.5 0-48 14.33-48 32s21.5 32 48 32 48-14.33 48-32V112a16 16 0 0 0-20.81-15.25zM448 0H64A64.05 64.05 0 0 0 0 64v288a64.05 64.05 0 0 0 64 64h96v84a12 12 0 0 0 12 12 11.35 11.35 0 0 0 7.09-2.41L304 416h144a64.05 64.05 0 0 0 64-64V64a64.05 64.05 0 0 0-64-64zm16 352a16 16 0 0 1-16 16H288l-12.81 9.59L208 428v-60H64a16 16 0 0 1-16-16V64a16 16 0 0 1 16-16h384a16 16 0 0 1 16 16z"
  ]
};
export const faCommentAltPlus = {
  prefix: "far",
  iconName: "comment-alt-plus",
  icon: [
    512,
    512,
    [],
    "f4a8",
    "M448 0H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v84c0 7.1 5.8 12 12 12 2.4 0 4.9-.7 7.1-2.4L304 416h144c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zm16 352c0 8.8-7.2 16-16 16H288l-12.8 9.6L208 428v-60H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h384c8.8 0 16 7.2 16 16v288zM336 184h-56v-56c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16v56h-56c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h56v56c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-56h56c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16z"
  ]
};
export const faCommentAltSlash = {
  prefix: "far",
  iconName: "comment-alt-slash",
  icon: [
    640,
    512,
    [],
    "f4a9",
    "M634 471L36 3.5C29.1-2 19-.9 13.5 6l-10 12.5C-2 25.4-.9 35.5 6 41l58 45.3 41.6 32.5L604 508.5c6.9 5.5 17 4.4 22.5-2.5l10-12.5c5.5-6.9 4.4-17-2.5-22.5zM512 48c8.8 0 16 7.2 16 16v263.2l46.8 36.6c.7-3.8 1.2-7.8 1.2-11.8V64c0-35.3-28.7-64-64-64H128c-5.5 0-10.7.9-15.8 2.2L170.8 48H512zM339.2 377.6L272 428v-60H128c-8.8 0-16-7.2-16-16V184.8l-48-37.5V352c0 35.3 28.7 64 64 64h96v84c0 7.1 5.8 12 12 12 2.4 0 4.9-.7 7.1-2.4L368 416h39.8l-58.6-45.8-10 7.4z"
  ]
};
export const faCommentAltSmile = {
  prefix: "far",
  iconName: "comment-alt-smile",
  icon: [
    512,
    512,
    [],
    "f4aa",
    "M448 0H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v84c0 7.1 5.8 12 12 12 2.4 0 4.9-.7 7.1-2.4L304 416h144c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zm16 352c0 8.8-7.2 16-16 16H288l-12.8 9.6L208 428v-60H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h384c8.8 0 16 7.2 16 16v288zM325.8 240.2C308.5 260.4 283.1 272 256 272s-52.5-11.6-69.8-31.8c-8.6-10.1-23.8-11.3-33.8-2.7s-11.2 23.8-2.7 33.8c26.5 31 65.2 48.7 106.3 48.7s79.8-17.8 106.2-48.7c8.6-10.1 7.4-25.2-2.7-33.8-10-8.6-25.1-7.4-33.7 2.7zM192 192c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm128 0c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32z"
  ]
};
export const faCommentAltTimes = {
  prefix: "far",
  iconName: "comment-alt-times",
  icon: [
    512,
    512,
    [],
    "f4ab",
    "M448 0H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v84c0 7.1 5.8 12 12 12 2.4 0 4.9-.7 7.1-2.4L304 416h144c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zm16 352c0 8.8-7.2 16-16 16H288l-12.8 9.6L208 428v-60H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h384c8.8 0 16 7.2 16 16v288zM329.5 145.8l-11.3-11.3c-6.2-6.2-16.4-6.2-22.6 0L256 174.1l-39.6-39.6c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-6.2 6.2-6.2 16.4 0 22.6l39.6 39.6-39.6 39.6c-6.2 6.2-6.2 16.4 0 22.6l11.3 11.3c6.2 6.2 16.4 6.2 22.6 0l39.6-39.6 39.6 39.6c6.2 6.2 16.4 6.2 22.6 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6L289.9 208l39.6-39.6c6.3-6.2 6.3-16.4 0-22.6z"
  ]
};
export const faCommentCheck = {
  prefix: "far",
  iconName: "comment-check",
  icon: [
    512,
    512,
    [],
    "f4ac",
    "M332.7 162.4c-3.8-3.9-10.1-3.9-14-.1L231.4 249l-37.9-38.2c-3.8-3.9-10.1-3.9-14-.1l-23.4 23.2c-3.9 3.8-3.9 10.1-.1 14l68.1 68.6c3.8 3.9 10.1 3.9 14 .1l117.8-116.8c3.9-3.8 3.9-10.1.1-14l-23.3-23.4zM256 32C114.6 32 0 125.1 0 240c0 47.6 19.9 91.2 52.9 126.3C38 405.7 7 439.1 6.5 439.5c-6.6 7-8.4 17.2-4.6 26S14.4 480 24 480c61.5 0 110-25.7 139.1-46.3C192 442.8 223.2 448 256 448c141.4 0 256-93.1 256-208S397.4 32 256 32zm0 368c-26.7 0-53.1-4.1-78.4-12.1l-22.7-7.2-19.5 13.8c-14.3 10.1-33.9 21.4-57.5 29 7.3-12.1 14.4-25.7 19.9-40.2l10.6-28.1-20.6-21.8C69.7 314.1 48 282.2 48 240c0-88.2 93.3-160 208-160s208 71.8 208 160-93.3 160-208 160z"
  ]
};
export const faCommentDollar = {
  prefix: "far",
  iconName: "comment-dollar",
  icon: [
    512,
    512,
    [],
    "f651",
    "M256 32C114.62 32 0 125.13 0 240c0 47.55 19.86 91.23 52.9 126.27C38 405.72 6.97 439.06 6.54 439.5c-6.56 6.95-8.38 17.19-4.59 25.98S14.39 480 23.98 480c61.51 0 110.02-25.72 139.15-46.33C191.95 442.8 223.2 448 256 448c141.38 0 256-93.12 256-208S397.38 32 256 32zm0 368c-26.69 0-53.05-4.07-78.37-12.09l-22.74-7.21-19.48 13.78c-14.34 10.15-33.88 21.45-57.47 28.97 7.29-12.06 14.38-25.7 19.86-40.22l10.61-28.07-20.59-21.83C69.65 314.07 48 282.25 48 240c0-88.22 93.31-160 208-160s208 71.78 208 160-93.31 160-208 160zm30.41-176.28l-50.07-14.3a8.46 8.46 0 0 1-6.12-8.11c0-4.64 3.78-8.42 8.44-8.42h32.78c3.6 0 7.08.77 10.26 2.22 4.8 2.21 10.37 1.71 14.11-2.03l17.52-17.52c5.27-5.27 4.67-14.28-1.55-18.38-9.5-6.27-20.35-10.11-31.78-11.46V128c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v17.56c-30.29 3.62-53.37 30.98-49.32 63.05 2.9 22.95 20.66 41.31 42.91 47.67l50.07 14.3a8.46 8.46 0 0 1 6.12 8.11c0 4.64-3.78 8.42-8.44 8.42h-32.78c-3.6 0-7.08-.77-10.26-2.22-4.8-2.21-10.37-1.71-14.11 2.03l-17.52 17.52c-5.27 5.27-4.68 14.28 1.55 18.38 9.5 6.27 20.35 10.11 31.78 11.46V352c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-17.56c30.29-3.62 53.37-30.98 49.32-63.05-2.9-22.95-20.66-41.31-42.91-47.67z"
  ]
};
export const faCommentDots = {
  prefix: "far",
  iconName: "comment-dots",
  icon: [
    512,
    512,
    [],
    "f4ad",
    "M144 208c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm112 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm112 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zM256 32C114.6 32 0 125.1 0 240c0 47.6 19.9 91.2 52.9 126.3C38 405.7 7 439.1 6.5 439.5c-6.6 7-8.4 17.2-4.6 26S14.4 480 24 480c61.5 0 110-25.7 139.1-46.3C192 442.8 223.2 448 256 448c141.4 0 256-93.1 256-208S397.4 32 256 32zm0 368c-26.7 0-53.1-4.1-78.4-12.1l-22.7-7.2-19.5 13.8c-14.3 10.1-33.9 21.4-57.5 29 7.3-12.1 14.4-25.7 19.9-40.2l10.6-28.1-20.6-21.8C69.7 314.1 48 282.2 48 240c0-88.2 93.3-160 208-160s208 71.8 208 160-93.3 160-208 160z"
  ]
};
export const faCommentEdit = {
  prefix: "far",
  iconName: "comment-edit",
  icon: [
    512,
    512,
    [],
    "f4ae",
    "M164.9 275.2l-4.8 42.8c-.6 5.7 4.2 10.6 10 10l42.8-4.8 85.5-85.5-48-48-85.5 85.5zm159.3-133.9c-7-7-18.4-7-25.4 0l-28.3 28.3 48 48 28.3-28.3c7-7 7-18.4 0-25.4l-22.6-22.6zM256 32C114.6 32 0 125.1 0 240c0 47.6 19.9 91.2 52.9 126.3C38 405.7 7 439.1 6.5 439.5c-6.6 7-8.4 17.2-4.6 26S14.4 480 24 480c61.5 0 110-25.7 139.1-46.3C192 442.8 223.2 448 256 448c141.4 0 256-93.1 256-208S397.4 32 256 32zm0 368c-26.7 0-53.1-4.1-78.4-12.1l-22.7-7.2-19.5 13.8c-14.3 10.1-33.9 21.4-57.5 29 7.3-12.1 14.4-25.7 19.9-40.2l10.6-28.1-20.6-21.8C69.7 314.1 48 282.2 48 240c0-88.2 93.3-160 208-160s208 71.8 208 160-93.3 160-208 160z"
  ]
};
export const faCommentExclamation = {
  prefix: "far",
  iconName: "comment-exclamation",
  icon: [
    512,
    512,
    [],
    "f4af",
    "M256 288c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm28.7-160h-57.4c-10 0-17.6 9.1-15.7 18.9l18 96c1.4 7.6 8 13.1 15.7 13.1h21.4c7.7 0 14.3-5.5 15.7-13.1l18-96c1.9-9.8-5.7-18.9-15.7-18.9zM256 32C114.6 32 0 125.1 0 240c0 47.6 19.9 91.2 52.9 126.3C38 405.7 7 439.1 6.5 439.5c-6.6 7-8.4 17.2-4.6 26S14.4 480 24 480c61.5 0 110-25.7 139.1-46.3C192 442.8 223.2 448 256 448c141.4 0 256-93.1 256-208S397.4 32 256 32zm0 368c-26.7 0-53.1-4.1-78.4-12.1l-22.7-7.2-19.5 13.8c-14.3 10.1-33.9 21.4-57.5 29 7.3-12.1 14.4-25.7 19.9-40.2l10.6-28.1-20.6-21.8C69.7 314.1 48 282.2 48 240c0-88.2 93.3-160 208-160s208 71.8 208 160-93.3 160-208 160z"
  ]
};
export const faCommentLines = {
  prefix: "far",
  iconName: "comment-lines",
  icon: [
    512,
    512,
    [],
    "f4b0",
    "M368 168H144c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zm-96 96H144c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zM256 32C114.6 32 0 125.1 0 240c0 47.6 19.9 91.2 52.9 126.3C38 405.7 7 439.1 6.5 439.5c-6.6 7-8.4 17.2-4.6 26S14.4 480 24 480c61.5 0 110-25.7 139.1-46.3C192 442.8 223.2 448 256 448c141.4 0 256-93.1 256-208S397.4 32 256 32zm0 368c-26.7 0-53.1-4.1-78.4-12.1l-22.7-7.2-19.5 13.8c-14.3 10.1-33.9 21.4-57.5 29 7.3-12.1 14.4-25.7 19.9-40.2l10.6-28.1-20.6-21.8C69.7 314.1 48 282.2 48 240c0-88.2 93.3-160 208-160s208 71.8 208 160-93.3 160-208 160z"
  ]
};
export const faCommentMedical = {
  prefix: "far",
  iconName: "comment-medical",
  icon: [
    512,
    512,
    [],
    "f7f5",
    "M344 208h-56v-56a8 8 0 0 0-8-8h-48a8 8 0 0 0-8 8v56h-56a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8h56v56a8 8 0 0 0 8 8h48a8 8 0 0 0 8-8v-56h56a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8zM256 32C114.62 32 0 125.12 0 240c0 47.55 19.86 91.23 52.9 126.27C38 405.72 7 439.06 6.54 439.5A24 24 0 0 0 24 480c61.51 0 110-25.72 139.15-46.33A307.33 307.33 0 0 0 256 448c141.38 0 256-93.13 256-208S397.38 32 256 32zm0 368a259.17 259.17 0 0 1-78.37-12.09l-22.75-7.21-19.47 13.78a212 212 0 0 1-57.47 29 247.26 247.26 0 0 0 19.86-40.25l10.61-28.07-20.59-21.83C69.65 314.07 48 282.25 48 240c0-88.22 93.31-160 208-160s208 71.78 208 160-93.31 160-208 160z"
  ]
};
export const faCommentMinus = {
  prefix: "far",
  iconName: "comment-minus",
  icon: [
    512,
    512,
    [],
    "f4b1",
    "M336 216H176c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h160c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zM256 32C114.6 32 0 125.1 0 240c0 47.6 19.9 91.2 52.9 126.3C38 405.7 7 439.1 6.5 439.5c-6.6 7-8.4 17.2-4.6 26S14.4 480 24 480c61.5 0 110-25.7 139.1-46.3C192 442.8 223.2 448 256 448c141.4 0 256-93.1 256-208S397.4 32 256 32zm0 368c-26.7 0-53.1-4.1-78.4-12.1l-22.7-7.2-19.5 13.8c-14.3 10.1-33.9 21.4-57.5 29 7.3-12.1 14.4-25.7 19.9-40.2l10.6-28.1-20.6-21.8C69.7 314.1 48 282.2 48 240c0-88.2 93.3-160 208-160s208 71.8 208 160-93.3 160-208 160z"
  ]
};
export const faCommentMusic = {
  prefix: "far",
  iconName: "comment-music",
  icon: [
    512,
    512,
    [],
    "f8b0",
    "M256 32C114.64 32 .07 125.09.07 240 .07 287.59 20 331.2 53 366.3c-14.91 39.4-45.9 72.79-46.4 73.2A24 24 0 0 0 24.06 480c61.49 0 110-25.7 139.08-46.3A308.73 308.73 0 0 0 256 448c141.39 0 256-93.09 256-208S397.42 32 256 32zm0 368a259.93 259.93 0 0 1-78.39-12.09L155 380.7l-19.5 13.8a215.27 215.27 0 0 1-57.5 29 252.11 252.11 0 0 0 19.91-40.2l10.59-28.1-20.63-21.79C69.74 314.09 48.06 282.2 48.06 240c0-88.2 93.3-160 208-160s208 71.8 208 160S370.71 400 256 400zm75.18-271.25L203.23 176A16 16 0 0 0 192 191.25V290a69.82 69.82 0 0 0-16-2c-26.49 0-48 14.33-48 32s21.5 32 48 32 48-14.33 48-32v-84.84l96-37.52V258a69.8 69.8 0 0 0-16-2c-26.5 0-48 14.33-48 32s21.5 32 48 32 48-14.33 48-32V144a16 16 0 0 0-20.79-15.25z"
  ]
};
export const faCommentPlus = {
  prefix: "far",
  iconName: "comment-plus",
  icon: [
    512,
    512,
    [],
    "f4b2",
    "M336 216h-56v-56c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16v56h-56c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h56v56c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-56h56c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zM256 32C114.6 32 0 125.1 0 240c0 47.6 19.9 91.2 52.9 126.3C38 405.7 7 439.1 6.5 439.5c-6.6 7-8.4 17.2-4.6 26S14.4 480 24 480c61.5 0 110-25.7 139.1-46.3C192 442.8 223.2 448 256 448c141.4 0 256-93.1 256-208S397.4 32 256 32zm0 368c-26.7 0-53.1-4.1-78.4-12.1l-22.7-7.2-19.5 13.8c-14.3 10.1-33.9 21.4-57.5 29 7.3-12.1 14.4-25.7 19.9-40.2l10.6-28.1-20.6-21.8C69.7 314.1 48 282.2 48 240c0-88.2 93.3-160 208-160s208 71.8 208 160-93.3 160-208 160z"
  ]
};
export const faCommentSlash = {
  prefix: "far",
  iconName: "comment-slash",
  icon: [
    640,
    512,
    [],
    "f4b3",
    "M320 80c114.7 0 208 71.8 208 160 0 25.3-7.9 49.1-21.5 70.4l37.9 29.6c20.1-29.6 31.6-63.7 31.6-100 0-114.9-114.6-208-256-208-48.2 0-93 11-131.5 29.8l43 33.6C258.4 85.6 288.3 80 320 80zm0 320c-26.7 0-53.1-4.1-78.4-12.1l-22.7-7.2-19.5 13.8c-14.3 10.1-33.9 21.4-57.5 29 7.3-12.1 14.4-25.7 19.9-40.2l10.6-28.1-20.6-21.8C133.7 314.1 112 282.2 112 240c0-16.6 3.3-32.7 9.5-47.8L82.8 162c-12 24.1-18.8 50.4-18.8 78 0 47.6 19.9 91.2 52.9 126.3-14.9 39.4-45.9 72.8-46.4 73.2-6.6 7-8.4 17.2-4.6 26S78.4 480 88 480c61.5 0 110-25.7 139.1-46.3C256 442.8 287.2 448 320 448c37.5 0 73-6.7 105.1-18.5l-46.2-36.2c-18.7 4.3-38.5 6.7-58.9 6.7zm314 71L481.6 351.8l-6.8-5.3L36 3.5C29.1-2 19-.9 13.5 6l-10 12.5C-2 25.4-.9 35.5 6 41l598 467.5c6.9 5.5 17 4.4 22.5-2.5l10-12.5c5.5-6.9 4.4-17-2.5-22.5z"
  ]
};
export const faCommentSmile = {
  prefix: "far",
  iconName: "comment-smile",
  icon: [
    512,
    512,
    [],
    "f4b4",
    "M325.8 272.2C308.5 292.4 283.1 304 256 304s-52.5-11.6-69.8-31.8c-8.6-10.1-23.8-11.2-33.8-2.7-10.1 8.6-11.2 23.8-2.7 33.8 26.5 31 65.2 48.7 106.3 48.7s79.8-17.8 106.2-48.7c8.6-10.1 7.4-25.2-2.7-33.8-10-8.6-25.1-7.4-33.7 2.7zM192 224c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm128 0c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zM256 32C114.6 32 0 125.1 0 240c0 47.6 19.9 91.2 52.9 126.3C38 405.7 7 439.1 6.5 439.5c-6.6 7-8.4 17.2-4.6 26S14.4 480 24 480c61.5 0 110-25.7 139.1-46.3C192 442.8 223.2 448 256 448c141.4 0 256-93.1 256-208S397.4 32 256 32zm0 368c-26.7 0-53.1-4.1-78.4-12.1l-22.7-7.2-19.5 13.8c-14.3 10.1-33.9 21.4-57.5 29 7.3-12.1 14.4-25.7 19.9-40.2l10.6-28.1-20.6-21.8C69.7 314.1 48 282.2 48 240c0-88.2 93.3-160 208-160s208 71.8 208 160-93.3 160-208 160z"
  ]
};
export const faCommentTimes = {
  prefix: "far",
  iconName: "comment-times",
  icon: [
    512,
    512,
    [],
    "f4b5",
    "M329.5 177.8l-11.3-11.3c-6.2-6.2-16.4-6.2-22.6 0L256 206.1l-39.6-39.6c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-6.2 6.2-6.2 16.4 0 22.6l39.6 39.6-39.6 39.6c-6.2 6.2-6.2 16.4 0 22.6l11.3 11.3c6.2 6.2 16.4 6.2 22.6 0l39.6-39.6 39.6 39.6c6.2 6.2 16.4 6.2 22.6 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6L289.9 240l39.6-39.6c6.3-6.2 6.3-16.4 0-22.6zM256 32C114.6 32 0 125.1 0 240c0 47.6 19.9 91.2 52.9 126.3C38 405.7 7 439.1 6.5 439.5c-6.6 7-8.4 17.2-4.6 26S14.4 480 24 480c61.5 0 110-25.7 139.1-46.3C192 442.8 223.2 448 256 448c141.4 0 256-93.1 256-208S397.4 32 256 32zm0 368c-26.7 0-53.1-4.1-78.4-12.1l-22.7-7.2-19.5 13.8c-14.3 10.1-33.9 21.4-57.5 29 7.3-12.1 14.4-25.7 19.9-40.2l10.6-28.1-20.6-21.8C69.7 314.1 48 282.2 48 240c0-88.2 93.3-160 208-160s208 71.8 208 160-93.3 160-208 160z"
  ]
};
export const faComments = {
  prefix: "far",
  iconName: "comments",
  icon: [
    576,
    512,
    [],
    "f086",
    "M532 386.2c27.5-27.1 44-61.1 44-98.2 0-80-76.5-146.1-176.2-157.9C368.3 72.5 294.3 32 208 32 93.1 32 0 103.6 0 192c0 37 16.5 71 44 98.2-15.3 30.7-37.3 54.5-37.7 54.9-6.3 6.7-8.1 16.5-4.4 25 3.6 8.5 12 14 21.2 14 53.5 0 96.7-20.2 125.2-38.8 9.2 2.1 18.7 3.7 28.4 4.9C208.1 407.6 281.8 448 368 448c20.8 0 40.8-2.4 59.8-6.8C456.3 459.7 499.4 480 553 480c9.2 0 17.5-5.5 21.2-14 3.6-8.5 1.9-18.3-4.4-25-.4-.3-22.5-24.1-37.8-54.8zm-392.8-92.3L122.1 305c-14.1 9.1-28.5 16.3-43.1 21.4 2.7-4.7 5.4-9.7 8-14.8l15.5-31.1L77.7 256C64.2 242.6 48 220.7 48 192c0-60.7 73.3-112 160-112s160 51.3 160 112-73.3 112-160 112c-16.5 0-33-1.9-49-5.6l-19.8-4.5zM498.3 352l-24.7 24.4 15.5 31.1c2.6 5.1 5.3 10.1 8 14.8-14.6-5.1-29-12.3-43.1-21.4l-17.1-11.1-19.9 4.6c-16 3.7-32.5 5.6-49 5.6-54 0-102.2-20.1-131.3-49.7C338 339.5 416 272.9 416 192c0-3.4-.4-6.7-.7-10C479.7 196.5 528 238.8 528 288c0 28.7-16.2 50.6-29.7 64z"
  ]
};
export const faCommentsAlt = {
  prefix: "far",
  iconName: "comments-alt",
  icon: [
    576,
    512,
    [],
    "f4b6",
    "M512 160h-96V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v160c0 35.3 28.7 64 64 64h32v52c0 7.1 5.8 12 12 12 2.4 0 4.9-.7 7.1-2.4l76.9-43.5V384c0 35.3 28.7 64 64 64h96l108.9 61.6c2.2 1.6 4.7 2.4 7.1 2.4 6.2 0 12-4.9 12-12v-52h32c35.3 0 64-28.7 64-64V224c0-35.3-28.7-64-64-64zM96 240H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h288c8.8 0 16 7.2 16 16v160c0 8.8-7.2 16-16 16H211.4l-11 6.2-56.4 31.9V240H96zm432 144c0 8.8-7.2 16-16 16h-80v38.1l-56.4-31.9-11-6.2H256c-8.8 0-16-7.2-16-16v-96h112c35.3 0 64-28.7 64-64v-16h96c8.8 0 16 7.2 16 16v160z"
  ]
};
export const faCommentsAltDollar = {
  prefix: "far",
  iconName: "comments-alt-dollar",
  icon: [
    576,
    512,
    [],
    "f652",
    "M512 160h-96V64c0-35.35-28.65-64-64-64H64C28.65 0 0 28.65 0 64v208c0 35.35 28.65 64 64 64h32v51.98c0 7.1 5.83 12.02 12.05 12.02 2.41 0 4.87-.74 7.08-2.37L192 354.12V384c0 35.35 28.65 64 64 64h96l108.87 61.63c2.21 1.63 4.68 2.37 7.08 2.37 6.22 0 12.05-4.92 12.05-12.02V448h32c35.35 0 64-28.65 64-64V224c0-35.35-28.65-64-64-64zM200.35 294.23L144 326.13V288H64c-8.82 0-16-7.18-16-16V64c0-8.82 7.18-16 16-16h288c8.82 0 16 7.18 16 16v208c0 8.82-7.18 16-16 16H211.36l-11.01 6.23zM528 384c0 8.82-7.18 16-16 16h-80v38.13l-56.35-31.9-11-6.23H256c-8.82 0-16-7.18-16-16v-48h112c35.35 0 64-28.65 64-64v-64h96c8.82 0 16 7.18 16 16v160zM233.28 158.28l-42.19-11.44c-4.19-1.14-7.09-4.55-7.09-8.3 0-4.8 4.5-8.7 10.06-8.7h26.34c4.15 0 8.23 1.04 11.77 2.95 3.08 1.66 6.84 1.37 9.24-1.18l12.07-12.73c3.11-3.28 2.6-8.64-1.13-11.19-8.3-5.65-18.06-8.88-28.35-9.52V88c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v10.25c-22.18 1.1-40 18.57-40 40.3 0 18.17 12.62 34.28 30.72 39.17l42.19 11.44c4.19 1.14 7.09 4.55 7.09 8.3 0 4.8-4.5 8.7-10.06 8.7H195.6c-4.15 0-8.23-1.04-11.77-2.95-3.08-1.67-6.84-1.37-9.24 1.18l-12.07 12.73c-3.11 3.28-2.6 8.64 1.13 11.19 8.3 5.65 18.06 8.88 28.35 9.52V248c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-10.25c22.18-1.1 40-18.57 40-40.3 0-18.17-12.62-34.28-30.72-39.17z"
  ]
};
export const faCommentsDollar = {
  prefix: "far",
  iconName: "comments-dollar",
  icon: [
    576,
    512,
    [],
    "f653",
    "M532.01 386.17C559.48 359.05 576 325.04 576 288c0-80.02-76.45-146.13-176.18-157.94C368.35 72.46 294.32 32 208 32 93.12 32 0 103.64 0 192c0 37.04 16.52 71.05 43.99 98.17-15.3 30.74-37.34 54.53-37.7 54.89-6.31 6.69-8.05 16.53-4.42 24.99A23.085 23.085 0 0 0 23.06 384c53.54 0 96.67-20.24 125.17-38.78 9.21 2.12 18.69 3.74 28.37 4.89C208.11 407.58 281.8 448 368 448c20.79 0 40.83-2.41 59.77-6.78C456.27 459.76 499.4 480 552.94 480c9.22 0 17.55-5.5 21.18-13.96 3.64-8.46 1.89-18.3-4.42-24.99-.35-.36-22.39-24.14-37.69-54.88zm-372.99-87.72l-19.87-4.58-17.09 11.12c-14.07 9.15-28.46 16.29-43.1 21.41a258.5 258.5 0 0 0 8-14.84l15.49-31.12-24.74-24.42C64.16 242.63 48 220.66 48 192c0-60.71 73.27-112 160-112s160 51.29 160 112-73.27 112-160 112c-16.52 0-33-1.87-48.98-5.55zm339.27 53.56l-24.74 24.42 15.49 31.12c2.56 5.15 5.26 10.11 8 14.84-14.64-5.11-29.03-12.26-43.1-21.4l-17.09-11.12-19.87 4.58A218.576 218.576 0 0 1 368 400c-53.96 0-102.22-20.06-131.3-49.7C337.96 339.53 416 272.86 416 192c0-3.37-.39-6.66-.65-9.97C479.7 196.49 528 238.85 528 288c0 28.66-16.16 50.63-29.71 64.01zM233.28 182.28l-42.19-11.44c-4.19-1.14-7.09-4.55-7.09-8.3 0-4.8 4.5-8.7 10.06-8.7h26.34c4.15 0 8.23 1.04 11.77 2.95 3.08 1.66 6.84 1.37 9.24-1.18l12.07-12.73c3.11-3.28 2.6-8.64-1.13-11.19-8.3-5.65-18.06-8.88-28.35-9.52V112c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v10.25c-22.18 1.1-40 18.57-40 40.3 0 18.17 12.62 34.28 30.72 39.17l42.19 11.44c4.19 1.14 7.09 4.55 7.09 8.3 0 4.8-4.5 8.7-10.06 8.7H195.6c-4.15 0-8.23-1.04-11.77-2.95-3.08-1.67-6.84-1.37-9.24 1.18l-12.07 12.73c-3.11 3.28-2.6 8.64 1.13 11.19 8.3 5.65 18.06 8.88 28.35 9.52V272c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-10.25c22.18-1.1 40-18.57 40-40.3 0-18.17-12.62-34.28-30.72-39.17z"
  ]
};
export const faCompactDisc = {
  prefix: "far",
  iconName: "compact-disc",
  icon: [
    496,
    512,
    [],
    "f51f",
    "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm0-360c-88.2 0-160 71.8-160 160h32c0-70.6 57.4-128 128-128V96zm0 72c-48.6 0-88 39.4-88 88s39.4 88 88 88 88-39.4 88-88-39.4-88-88-88zm0 120c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
  ]
};
export const faCompass = {
  prefix: "far",
  iconName: "compass",
  icon: [
    496,
    512,
    [],
    "f14e",
    "M347.94 129.86L203.6 195.83a31.938 31.938 0 0 0-15.77 15.77l-65.97 144.34c-7.61 16.65 9.54 33.81 26.2 26.2l144.34-65.97a31.938 31.938 0 0 0 15.77-15.77l65.97-144.34c7.61-16.66-9.54-33.81-26.2-26.2zm-77.36 148.72c-12.47 12.47-32.69 12.47-45.16 0-12.47-12.47-12.47-32.69 0-45.16 12.47-12.47 32.69-12.47 45.16 0 12.47 12.47 12.47 32.69 0 45.16zM248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 448c-110.28 0-200-89.72-200-200S137.72 56 248 56s200 89.72 200 200-89.72 200-200 200z"
  ]
};
export const faCompassSlash = {
  prefix: "far",
  iconName: "compass-slash",
  icon: [
    640,
    512,
    [],
    "f5e9",
    "M633.99 471.02L36 3.51C29.1-2.01 19.03-.9 13.51 6l-10 12.49C-2.02 25.39-.9 35.46 6 40.98l598 467.51c6.9 5.52 16.96 4.4 22.49-2.49l10-12.49c5.52-6.9 4.41-16.97-2.5-22.49zM320 56c110.28 0 200 89.72 200 200 0 20.23-3.07 39.75-8.69 58.18l39.84 31.15C561.88 317.58 568 287.53 568 256 568 119.03 456.97 8 320 8c-53.08 0-102.15 16.82-142.49 45.21l40.06 31.32C247.58 66.54 282.54 56 320 56zm99.94 73.86l-91.12 41.65 81.23 63.51 36.09-78.96c7.61-16.66-9.54-33.81-26.2-26.2zM220.06 382.14l91.13-41.65-81.23-63.51-36.09 78.96c-7.62 16.65 9.53 33.81 26.19 26.2zM320 456c-110.28 0-200-89.72-200-200 0-20.24 3.08-39.76 8.69-58.18l-39.84-31.15C78.12 194.42 72 224.47 72 256c0 136.97 111.03 248 248 248 53.08 0 102.15-16.82 142.49-45.22l-40.06-31.32C392.42 445.46 357.46 456 320 456z"
  ]
};
export const faCompress = {
  prefix: "far",
  iconName: "compress",
  icon: [
    448,
    512,
    [],
    "f066",
    "M436 192H312c-13.3 0-24-10.7-24-24V44c0-6.6 5.4-12 12-12h24c6.6 0 12 5.4 12 12v100h100c6.6 0 12 5.4 12 12v24c0 6.6-5.4 12-12 12zm-276-24V44c0-6.6-5.4-12-12-12h-24c-6.6 0-12 5.4-12 12v100H12c-6.6 0-12 5.4-12 12v24c0 6.6 5.4 12 12 12h124c13.3 0 24-10.7 24-24zm0 300V344c0-13.3-10.7-24-24-24H12c-6.6 0-12 5.4-12 12v24c0 6.6 5.4 12 12 12h100v100c0 6.6 5.4 12 12 12h24c6.6 0 12-5.4 12-12zm176 0V368h100c6.6 0 12-5.4 12-12v-24c0-6.6-5.4-12-12-12H312c-13.3 0-24 10.7-24 24v124c0 6.6 5.4 12 12 12h24c6.6 0 12-5.4 12-12z"
  ]
};
export const faCompressAlt = {
  prefix: "far",
  iconName: "compress-alt",
  icon: [
    448,
    512,
    [],
    "f422",
    "M224 232v-95.005c0-21.382 25.851-32.09 40.971-16.971l27.704 27.704L404.888 35.515c4.686-4.686 12.284-4.686 16.971 0l22.627 22.627c4.686 4.686 4.686 12.284 0 16.971L332.272 187.326l27.704 27.704c15.119 15.119 4.411 40.97-16.971 40.97H248c-13.255 0-24-10.745-24-24zM43.112 476.485l112.213-112.213 27.704 27.704c15.12 15.119 40.971 4.411 40.971-16.971V280c0-13.255-10.745-24-24-24h-95.005c-21.382 0-32.09 25.851-16.971 40.971l27.704 27.704L3.515 436.888c-4.686 4.686-4.686 12.284 0 16.971l22.627 22.627c4.686 4.686 12.284 4.686 16.97-.001z"
  ]
};
export const faCompressArrowsAlt = {
  prefix: "far",
  iconName: "compress-arrows-alt",
  icon: [
    512,
    512,
    [],
    "f78c",
    "M300 224h136c10.7 0 16-12.9 8.4-20.5l-50.9-51L507.3 38.6c6.2-6.2 6.2-16.4 0-22.6L496 4.7c-6.2-6.2-16.4-6.2-22.6 0L359.5 118.6l-51-51C300.9 60 288 65.3 288 76v136c0 6.6 5.4 12 12 12zm93.4 135.5l51-51c7.5-7.6 2.2-20.5-8.5-20.5H300c-6.6 0-12 5.4-12 12v136c0 10.7 12.9 16 20.5 8.4l51-50.9 113.9 113.9c6.2 6.2 16.4 6.2 22.6 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6l-113.9-114zM212 288H76c-10.7 0-16 12.9-8.4 20.5l50.9 51L4.7 473.4c-6.2 6.2-6.2 16.4 0 22.6L16 507.3c6.2 6.2 16.4 6.2 22.6 0l113.9-113.9 51 51c7.6 7.5 20.5 2.2 20.5-8.5V300c0-6.6-5.4-12-12-12zm-93.4-135.5l-51 51C60 211.1 65.3 224 76 224h136c6.6 0 12-5.4 12-12V76c0-10.7-12.9-16-20.5-8.4l-51 50.9L38.6 4.7c-6.2-6.2-16.4-6.2-22.6 0L4.7 16c-6.2 6.2-6.2 16.4 0 22.6l113.9 113.9z"
  ]
};
export const faCompressWide = {
  prefix: "far",
  iconName: "compress-wide",
  icon: [
    512,
    512,
    [],
    "f326",
    "M500 224H376c-13.3 0-24-10.7-24-24V76c0-6.6 5.4-12 12-12h24c6.6 0 12 5.4 12 12v100h100c6.6 0 12 5.4 12 12v24c0 6.6-5.4 12-12 12zm-340-24V76c0-6.6-5.4-12-12-12h-24c-6.6 0-12 5.4-12 12v100H12c-6.6 0-12 5.4-12 12v24c0 6.6 5.4 12 12 12h124c13.3 0 24-10.7 24-24zm0 236V312c0-13.3-10.7-24-24-24H12c-6.6 0-12 5.4-12 12v24c0 6.6 5.4 12 12 12h100v100c0 6.6 5.4 12 12 12h24c6.6 0 12-5.4 12-12zm240 0V336h100c6.6 0 12-5.4 12-12v-24c0-6.6-5.4-12-12-12H376c-13.3 0-24 10.7-24 24v124c0 6.6 5.4 12 12 12h24c6.6 0 12-5.4 12-12z"
  ]
};
export const faComputerClassic = {
  prefix: "far",
  iconName: "computer-classic",
  icon: [
    448,
    512,
    [],
    "f8b1",
    "M360 304H216a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h144a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8zM96 340a20 20 0 1 0-20-20 20 20 0 0 0 20 20zm16-84h224a32 32 0 0 0 32-32V112a32 32 0 0 0-32-32H112a32 32 0 0 0-32 32v112a32 32 0 0 0 32 32zM416 0H32A32 32 0 0 0 0 32v352a32 32 0 0 0 32 32v64a32 32 0 0 0 32 32h320a32 32 0 0 0 32-32v-64a32 32 0 0 0 32-32V32a32 32 0 0 0-32-32zm-48 464H80v-48h288zm32-96H48V48h352z"
  ]
};
export const faComputerSpeaker = {
  prefix: "far",
  iconName: "computer-speaker",
  icon: [
    640,
    512,
    [],
    "f8b2",
    "M592 32H368a48 48 0 0 0-48 48v352a48 48 0 0 0 48 48h224a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48zm0 400H368V80h224zm-480 0a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h192.41A79.24 79.24 0 0 1 288 432zM0 80v256a48 48 0 0 0 48 48h240v-48H48V80h240a79.24 79.24 0 0 1 16.41-48H48A48 48 0 0 0 0 80zm480 112a32 32 0 1 0-32-32 32 32 0 0 0 32 32zm0 208a80 80 0 1 0-80-80 80 80 0 0 0 80 80zm0-112a32 32 0 1 1-32 32 32 32 0 0 1 32-32z"
  ]
};
export const faConciergeBell = {
  prefix: "far",
  iconName: "concierge-bell",
  icon: [
    512,
    512,
    [],
    "f562",
    "M496 400h-16v-48c0-112.82-83.49-205.89-192-221.46V112h48c8.84 0 16-7.16 16-16V80c0-8.84-7.16-16-16-16H176c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h48v18.54C115.49 146.11 32 239.18 32 352v48H16c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16zm-64 0H80v-48c0-97.05 78.95-176 176-176s176 78.95 176 176v48z"
  ]
};
export const faConstruction = {
  prefix: "far",
  iconName: "construction",
  icon: [
    640,
    512,
    [],
    "f85d",
    "M324 216a28 28 0 1 0-28-28 28 28 0 0 0 28 28zm-18.62 140.36l-83-53.67-29.8 109.11a16 16 0 0 0 11.22 19.64 15.8 15.8 0 0 0 4.2.56 16 16 0 0 0 15.43-11.8l18.25-66.89L288 383.23V416a16 16 0 0 0 32 0v-32.77a31.92 31.92 0 0 0-14.62-26.87zm135-9.26l-14 20.86L358.31 326l-10.53-52.75c-3.75-18.61-18.13-33.3-35.56-37.12l-24.59-7.3a48 48 0 0 0-48.78 18l-11.62 15.48a16 16 0 0 0 4.41 23.23l103.92 64 .09.07 70.67 43.48H385a19.13 19.13 0 0 0-18.21 12.51l-9.2 26.4h163.89l-54.32-84.64a16 16 0 0 0-26.75-.26zm190.67 80.78L367.37 25.3a57 57 0 0 0-94.71 0L8.89 427.89a52.87 52.87 0 0 0-2.31 54.88A56.23 56.23 0 0 0 56.29 512h527.45a56.23 56.23 0 0 0 49.71-29.27 52.82 52.82 0 0 0-2.37-54.85zm-39.84 32c-.66 1.24-2.72 4.08-7.5 4.08H56.29c-4.78 0-6.84-2.84-7.5-4.06a5.25 5.25 0 0 1 .25-5.75l263.77-402.6a9.06 9.06 0 0 1 14.41 0L591 454.19a5.27 5.27 0 0 1 .24 5.73z"
  ]
};
export const faContainerStorage = {
  prefix: "far",
  iconName: "container-storage",
  icon: [
    640,
    512,
    [],
    "f4b7",
    "M640 64V48c0-8.8-7.2-16-16-16H16C7.2 32 0 39.2 0 48v16c0 8.8 7.2 16 16 16v352c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16V80c8.8 0 16-7.2 16-16zm-64 368H64V80h512v352zm-440-48h32c4.4 0 8-3.6 8-8V136c0-4.4-3.6-8-8-8h-32c-4.4 0-8 3.6-8 8v240c0 4.4 3.6 8 8 8zm224 0h32c4.4 0 8-3.6 8-8V136c0-4.4-3.6-8-8-8h-32c-4.4 0-8 3.6-8 8v240c0 4.4 3.6 8 8 8zm112 0h32c4.4 0 8-3.6 8-8V136c0-4.4-3.6-8-8-8h-32c-4.4 0-8 3.6-8 8v240c0 4.4 3.6 8 8 8zm-224 0h32c4.4 0 8-3.6 8-8V136c0-4.4-3.6-8-8-8h-32c-4.4 0-8 3.6-8 8v240c0 4.4 3.6 8 8 8z"
  ]
};
export const faConveyorBelt = {
  prefix: "far",
  iconName: "conveyor-belt",
  icon: [
    640,
    512,
    [],
    "f46e",
    "M544 320H96c-53 0-96 43-96 96s43 96 96 96h448c53 0 96-43 96-96s-43-96-96-96zm0 144H96c-26.5 0-48-21.5-48-48s21.5-48 48-48h448c26.5 0 48 21.5 48 48s-21.5 48-48 48zm-416-80c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm384 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm-192 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm-176-96h352c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16H144c-8.8 0-16 7.2-16 16v256c0 8.8 7.2 16 16 16zm32-240h80v112l64-32 64 32V48h80v192H176V48z"
  ]
};
export const faConveyorBeltAlt = {
  prefix: "far",
  iconName: "conveyor-belt-alt",
  icon: [
    640,
    512,
    [],
    "f46f",
    "M544 320H96c-53 0-96 43-96 96s43 96 96 96h448c53 0 96-43 96-96s-43-96-96-96zm0 144H96c-26.5 0-48-21.5-48-48s21.5-48 48-48h448c26.5 0 48 21.5 48 48s-21.5 48-48 48zm-416-80c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm384 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm-192 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm-208-96h416c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H384V16c0-8.8-7.2-16-16-16H112c-8.8 0-16 7.2-16 16v256c0 8.8 7.2 16 16 16zm272-176h112v128H384V112zM144 48h192v192H144V48z"
  ]
};
export const faCookie = {
  prefix: "far",
  iconName: "cookie",
  icon: [
    512,
    512,
    [],
    "f563",
    "M352 320c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm-32-160c17.67 0 32-14.33 32-32s-14.33-32-32-32-32 14.33-32 32 14.33 32 32 32zm-128 32c0-17.67-14.33-32-32-32s-32 14.33-32 32 14.33 32 32 32 32-14.33 32-32zm0 128c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm96-96c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm222.37 30.79l-12.08-76.26a132.493 132.493 0 0 0-37.16-72.95l-54.76-54.75c-19.73-19.72-45.18-32.7-72.71-37.05l-76.7-12.15A131.26 131.26 0 0 0 236.34 0c-20.72 0-41.25 4.88-59.89 14.38l-69.12 35.21a132.25 132.25 0 0 0-57.79 57.8l-35.1 68.87A132.602 132.602 0 0 0 1.62 257.2l12.08 76.27a132.493 132.493 0 0 0 37.16 72.95l54.76 54.75a132.087 132.087 0 0 0 72.71 37.05l76.7 12.14c6.86 1.09 13.75 1.62 20.63 1.62 20.72 0 41.25-4.88 59.88-14.38l69.12-35.21a132.302 132.302 0 0 0 57.79-57.8l35.1-68.87a132.56 132.56 0 0 0 12.82-80.93zm-55.59 59.15l-35.1 68.88c-8.13 15.97-20.86 28.7-36.81 36.82l-69.12 35.21C302 460.83 288.83 464 275.66 464a84.8 84.8 0 0 1-13.12-1.03l-76.69-12.14c-17.63-2.79-33.64-10.95-46.28-23.59l-54.76-54.76c-12.69-12.68-20.88-28.77-23.69-46.51L49.04 249.7c-2.81-17.76.01-35.62 8.18-51.64l35.1-68.88c8.13-15.97 20.86-28.7 36.81-36.82l69.12-35.21C210 51.17 223.17 48 236.35 48c4.38 0 8.79.35 13.12 1.03l76.7 12.15c17.63 2.79 33.63 10.95 46.27 23.59l54.76 54.75c12.69 12.69 20.88 28.77 23.69 46.52l12.08 76.26c2.8 17.76-.02 35.62-8.19 51.64z"
  ]
};
export const faCookieBite = {
  prefix: "far",
  iconName: "cookie-bite",
  icon: [
    512,
    512,
    [],
    "f564",
    "M352 320c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zM192 192c0-17.67-14.33-32-32-32s-32 14.33-32 32 14.33 32 32 32 32-14.33 32-32zm0 128c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm96-96c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm222.52 31.82c-69.97-.85-126.47-57.69-126.47-127.86-70.17 0-127-56.49-127.86-126.45C249.57.5 242.9 0 236.26 0c-20.68 0-41.18 4.85-59.79 14.33l-69.13 35.22a132.221 132.221 0 0 0-57.79 57.81l-35.1 68.88a132.645 132.645 0 0 0-12.82 80.95l12.08 76.28a132.555 132.555 0 0 0 37.16 72.96l54.77 54.76a132.036 132.036 0 0 0 72.71 37.06l76.71 12.14c6.86 1.09 13.76 1.62 20.64 1.62 20.72 0 41.25-4.88 59.89-14.38l69.13-35.22a132.221 132.221 0 0 0 57.79-57.81l35.1-68.88c12.56-24.63 17.01-52.57 12.91-79.9zm-55.68 58.1l-35.1 68.88c-8.14 15.97-20.87 28.7-36.81 36.83l-69.13 35.22c-11.74 5.98-24.92 9.15-38.1 9.15-4.38 0-8.8-.35-13.13-1.03l-76.71-12.14c-17.64-2.79-33.64-10.95-46.28-23.59l-54.77-54.76c-12.69-12.69-20.88-28.77-23.69-46.52l-12.08-76.27c-2.81-17.77.01-35.62 8.18-51.64l35.1-68.88c8.14-15.97 20.87-28.71 36.81-36.83l69.13-35.22c5.52-2.81 11.36-5 17.38-6.52 17.83 58.88 65.85 104.96 125.69 120.09 15.12 59.85 61.22 107.87 120.11 125.69a83.485 83.485 0 0 1-6.6 17.54z"
  ]
};
export const faCopy = {
  prefix: "far",
  iconName: "copy",
  icon: [
    448,
    512,
    [],
    "f0c5",
    "M433.941 65.941l-51.882-51.882A48 48 0 0 0 348.118 0H176c-26.51 0-48 21.49-48 48v48H48c-26.51 0-48 21.49-48 48v320c0 26.51 21.49 48 48 48h224c26.51 0 48-21.49 48-48v-48h80c26.51 0 48-21.49 48-48V99.882a48 48 0 0 0-14.059-33.941zM266 464H54a6 6 0 0 1-6-6V150a6 6 0 0 1 6-6h74v224c0 26.51 21.49 48 48 48h96v42a6 6 0 0 1-6 6zm128-96H182a6 6 0 0 1-6-6V54a6 6 0 0 1 6-6h106v88c0 13.255 10.745 24 24 24h88v202a6 6 0 0 1-6 6zm6-256h-64V48h9.632c1.591 0 3.117.632 4.243 1.757l48.368 48.368a6 6 0 0 1 1.757 4.243V112z"
  ]
};
export const faCopyright = {
  prefix: "far",
  iconName: "copyright",
  icon: [
    512,
    512,
    [],
    "f1f9",
    "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 448c-110.532 0-200-89.451-200-200 0-110.531 89.451-200 200-200 110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200zm107.351-101.064c-9.614 9.712-45.53 41.396-104.065 41.396-82.43 0-140.484-61.425-140.484-141.567 0-79.152 60.275-139.401 139.762-139.401 55.531 0 88.738 26.62 97.593 34.779a11.965 11.965 0 0 1 1.936 15.322l-18.155 28.113c-3.841 5.95-11.966 7.282-17.499 2.921-8.595-6.776-31.814-22.538-61.708-22.538-48.303 0-77.916 35.33-77.916 80.082 0 41.589 26.888 83.692 78.277 83.692 32.657 0 56.843-19.039 65.726-27.225 5.27-4.857 13.596-4.039 17.82 1.738l19.865 27.17a11.947 11.947 0 0 1-1.152 15.518z"
  ]
};
export const faCorn = {
  prefix: "far",
  iconName: "corn",
  icon: [
    512,
    512,
    [],
    "f6c7",
    "M441.79.32c-2.07-.2-4.57-.32-7.04-.32-12.1 0-23.73 2.82-34.13 8.01-3.53-.5-7.11-.75-10.72-.75-7.27 0-14.52 1.05-21.53 3.12a76.524 76.524 0 0 0-25.45 12.79c-9.17.42-18.11 2.45-26.63 6.07-8.9 4.01-16.77 9.4-23.38 15.86a76.438 76.438 0 0 0-26.06 9.58c-7.6 4.3-14.32 9.96-19.91 16.61-8.69 2.35-16.93 6.25-24.4 11.58-5.01 3.53-8.85 8.24-12.81 12.8-4.79-5.68-9.5-11.39-14.94-16.82L152.63 36.7c-9.01-9.01-24.43-4.34-26.93 8.15L98.51 180.72l-61.48 61.46c-47.25 47.23-49.15 122.14-6.51 171.46l60.7 61.97c27.39 27.38 65.59 40.41 105.41 35.3 29.25-3.75 55.89-18.9 76.75-39.75l57.83-57.81 135.93-27.18c12.5-2.5 17.17-17.91 8.15-26.92l-42.16-42.15c-5.32-5.32-10.89-10.28-16.62-14.96 3.61-3.4 7.61-6.35 10.55-10.46 5.29-7.4 9.13-15.55 11.49-24.04a76.011 76.011 0 0 0 17.39-20.81c4.6-7.74 7.69-16.19 9.24-24.91a76.238 76.238 0 0 0 15.55-22.55c3.97-8.82 6.19-18.12 6.68-27.45a77.528 77.528 0 0 0 12.88-24.7 78.082 78.082 0 0 0 2.61-31.7 77.244 77.244 0 0 0 8.93-32.94l.04-1v-1c2.4-41.1-28.34-76.61-70.08-80.26zM64.38 379.79c-24.07-30.62-21.7-75.58 6.5-103.78l71.73-71.7 18.33-91.64c45.96 45.94 62.27 102.09 48.95 155.23-33.79 12.01-65.48 31.89-92.77 59.17l-52.74 52.72zm243.24-10.53l-71.73 71.7c-30.38 30.37-80.44 31.18-110.82.81l-27.5-27.49 53.39-53.37c37.92-37.91 86.06-58.39 133.48-58.39 41.21 0 81.88 15.47 114.84 48.42l-91.66 18.32zM447.95 105.4c6.45 7.13 9.43 17.47 6.45 27.58-3 9.65-10.59 16.78-19.55 19.53 5.05 7.82 6.21 17.93 2.07 27.12-4.14 9.19-12.42 14.94-21.61 16.55 4.14 8.27 3.91 18.38-1.14 26.89-4.84 8.51-13.57 13.56-22.77 14.25 3.22 8.5 2.3 18.38-3.44 26.43-4.12 5.77-10.05 8.77-16.29 10.44-27.19-12.65-56.74-19.53-87.22-19.53-7.91 0-15.79.47-23.62 1.32 4.84-38.96-2.36-78.56-21.29-115.62 1.36-7.19 4.66-13.99 10.93-18.41 9.49-6.78 20.02-5.96 26.66-3.46.69-8.96 5.75-17.7 14.26-22.53 13.58-8.05 26.54-1.31 26.9-1.14 1.61-8.97 7.59-17.24 16.78-21.38 11.56-4.9 21.83-1.13 27.13 2.3 2.76-9.19 10.11-16.54 19.77-19.3 2.58-.76 16.01-4.31 27.59 6.89 23.37-44.68 85.4 17.95 38.39 42.07z"
  ]
};
export const faCouch = {
  prefix: "far",
  iconName: "couch",
  icon: [
    640,
    512,
    [],
    "f4b8",
    "M576 196.6V128c0-53-43-96-96-96H160c-53 0-96 43-96 96v68.6C29.4 207.3 3.1 236.9.3 273-2 302 9.9 329.5 32 347.6V440c0 22.1 17.9 40 40 40h88c4 0 30.2-.9 31.9-32h256.2c1.4 30.8 28 32 31.9 32h88c22.1 0 40-17.9 40-40v-92.4c22-18.1 34-45.5 31.7-74.6-2.8-36.1-29.1-65.7-63.7-76.4zM144 432H80V321.3l-11.9-7C54.6 306.5 47 292 48.2 276.7 49.7 256.5 69.4 240 92 240h12c22.1 0 40 17.9 40 40v152zm304-128v96H192v-96h256zm3.7-48H188.2c-9.8-34.3-39.7-59.8-76.2-63.2V128c0-26.5 21.5-48 48-48h320c26.5 0 48 21.5 48 48v64.8c-36.6 3.4-66.5 28.9-76.3 63.2zm120.2 58.4l-11.9 7V432h-64V280c0-22.1 17.9-40 40-40h12c22.6 0 42.3 16.5 43.9 36.8 1.1 15.3-6.5 29.7-20 37.6z"
  ]
};
export const faCow = {
  prefix: "far",
  iconName: "cow",
  icon: [
    640,
    512,
    [],
    "f6c8",
    "M624.48 237.99l-16.51-19.15v-42.82c0-11.89-12.52-19.63-23.15-14.31-6.08 3.04-11.32 7.1-16.1 11.58l-59.99-69.6A96.044 96.044 0 0 0 430.96 64H111.99c-48.6 0-88 39.4-88 88v86.41C9.48 250.14 0 267.88 0 288v32c39.76 0 72-32.24 72-72v-96c0-16.88 10.57-31.18 25.38-37.04-.87 4.21-1.35 8.57-1.35 13.04v288c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-39.98c2.55.87 5.4 1.3 8.04 2.05V392c0 8.84 7.16 16 16 16s16-7.16 16-16v-8.68c2.68.15 13.27.14 16-.01V392c0 8.84 7.16 16 16 16s16-7.16 16-16v-13.98c2.62-.74 5.44-1.17 7.96-2.03V416c0 17.67 14.33 32 32 32h63.96c17.67 0 31.99-14.32 32-31.99l.04-143.97L463.97 288v41.98c0 12.32 3.56 24.38 10.24 34.73l35.46 54.89a62.08 62.08 0 0 0 52.14 28.4H576c35.34 0 64-28.65 64-64V279.78c0-15.34-5.51-30.17-15.52-41.79zm-414.37 82.58c6.95-27.82 31.97-48.57 61.9-48.57 29.92 0 54.92 20.73 61.89 48.53-61.3 20.93-62.19 21.03-123.79.04zM592 384c0 8.82-7.18 16-16 16h-14.19c-4.8 0-9.22-2.41-11.83-6.44l-35.46-54.9c-.87-2.95-1.69-5.72-2.56-8.68v-61.87l-75.77-75.77c-13.35-13.35-36.17-3.9-36.17 14.98L399.98 400h-31.97v-64c0-45.59-38.14-96-95.99-96-58.15 0-95.99 50.69-95.99 96v64h-32V128c0-8.82 7.18-16 16-16h4.32c.8 1.5 25.36 34.82 25.36 34.82C211.52 175.75 241.1 192 271.94 192h.17c30.84 0 60.42-16.25 82.23-45.18 0 0 24.56-33.32 25.36-34.82h51.27c15.34 0 29.87 7.42 38.87 19.85l118.28 137.49c2.5 2.91 3.88 6.62 3.88 10.46V384zm-32-80c-8.84 0-16 7.16-16 16s7.16 16 16 16 16-7.16 16-16-7.16-16-16-16z"
  ]
};
export const faCowbell = {
  prefix: "far",
  iconName: "cowbell",
  icon: [
    448,
    512,
    [],
    "f8b3",
    "M384.19 122.35A32 32 0 0 0 352.64 96h-16V48a48.1 48.1 0 0 0-48.12-48H160.29a48.1 48.1 0 0 0-48.09 48v48H95.36a32 32 0 0 0-31.55 26.35l-63.3 352A32 32 0 0 0 32.07 512h383.86a32 32 0 0 0 31.56-37.65zM160 48h128v48H160zM51.14 464l57.54-320h230.64l57.54 320z"
  ]
};
export const faCowbellMore = {
  prefix: "far",
  iconName: "cowbell-more",
  icon: [
    640,
    512,
    [],
    "f8b4",
    "M464 160c-97 0-176 79-176 176s79 176 176 176 176-78.95 176-176-78.95-176-176-176zm0 304a128 128 0 1 1 128-128 128 128 0 0 1-128 128zm80-152h-56v-56a16 16 0 0 0-16-16h-16a16 16 0 0 0-16 16v56h-56a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h56v56a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-56h56a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zM300.39 464H51.14l57.54-320h230.64l4.1 22.84a207.09 207.09 0 0 1 44.42-24.2l-3.65-20.29A32 32 0 0 0 352.64 96h-16V48a48.1 48.1 0 0 0-48.12-48H160.29a48.1 48.1 0 0 0-48.09 48v48H95.36a32 32 0 0 0-31.55 26.35l-63.3 352A32 32 0 0 0 32.07 512h321.59a209.26 209.26 0 0 1-53.27-48zM160 48h128v48H160z"
  ]
};
export const faCreditCard = {
  prefix: "far",
  iconName: "credit-card",
  icon: [
    576,
    512,
    [],
    "f09d",
    "M527.9 32H48.1C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48.1 48h479.8c26.6 0 48.1-21.5 48.1-48V80c0-26.5-21.5-48-48.1-48zM54.1 80h467.8c3.3 0 6 2.7 6 6v42H48.1V86c0-3.3 2.7-6 6-6zm467.8 352H54.1c-3.3 0-6-2.7-6-6V256h479.8v170c0 3.3-2.7 6-6 6zM192 332v40c0 6.6-5.4 12-12 12h-72c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h72c6.6 0 12 5.4 12 12zm192 0v40c0 6.6-5.4 12-12 12H236c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h136c6.6 0 12 5.4 12 12z"
  ]
};
export const faCreditCardBlank = {
  prefix: "far",
  iconName: "credit-card-blank",
  icon: [
    576,
    512,
    [],
    "f389",
    "M527.9 32H48.1C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48.1 48h479.8c26.6 0 48.1-21.5 48.1-48V80c0-26.5-21.5-48-48.1-48zm-6 400H54.1c-3.3 0-6-2.7-6-6V86c0-3.3 2.7-6 6-6h467.8c3.3 0 6 2.7 6 6v340c0 3.3-2.7 6-6 6zM192 364v8c0 6.6-5.4 12-12 12h-72c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h72c6.6 0 12 5.4 12 12zm192 0v8c0 6.6-5.4 12-12 12H236c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h136c6.6 0 12 5.4 12 12z"
  ]
};
export const faCreditCardFront = {
  prefix: "far",
  iconName: "credit-card-front",
  icon: [
    576,
    512,
    [],
    "f38a",
    "M527.9 32H48.1C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48.1 48h479.8c26.6 0 48.1-21.5 48.1-48V80c0-26.5-21.5-48-48.1-48zm-6 400H54.1c-3.3 0-6-2.7-6-6V86c0-3.3 2.7-6 6-6h467.8c3.3 0 6 2.7 6 6v340c0 3.3-2.7 6-6 6zM192 364v8c0 6.6-5.4 12-12 12h-72c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h72c6.6 0 12 5.4 12 12zm192 0v8c0 6.6-5.4 12-12 12H236c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h136c6.6 0 12 5.4 12 12zm-124-44h-56c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm28-12v-40c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12zm-192 0v-40c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12zm384-40v40c0 6.6-5.4 12-12 12h-72c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h72c6.6 0 12 5.4 12 12zm0-132v48c0 13.3-10.7 24-24 24h-80c-13.3 0-24-10.7-24-24v-48c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24z"
  ]
};
export const faCricket = {
  prefix: "far",
  iconName: "cricket",
  icon: [
    640,
    512,
    [],
    "f449",
    "M635.7 31.9l-15.2-21.6c-7.6-10.8-22.6-13.5-33.4-5.9L442.6 105.9c-14.5 10.1-34.4 6.6-44.5-7.8L385.4 80c-9.9-14-29.7-18.2-44.5-7.8L13.8 300.7C4.9 306.9-.7 317.2.1 328c5.6 79.3 54.7 149.2 127.4 181.6 15.4 6.9 28.9-2.5 30.4-3.5L485 277.6c14.5-10.1 18-30 7.9-44.4l-15.3-21.8c-10.1-14.4-6.6-34.3 7.9-44.4L629.8 65.2c10.8-7.6 13.5-22.5 5.9-33.3zM138 461.5c-48.8-25.3-82-72.6-89.1-126.9l224.8-157.1-19.1 107.9 108.2 19L138 461.5zM437.8 252l-37.9 26.5-108.2-19 19.1-107.9 37.9-26.5c3.6-2.5 8.6-1.6 11.1 2L439.7 241c2.6 3.5 1.7 8.5-1.9 11zm73.8 68.5c-52.9 0-95.9 42.9-95.9 95.7s43 95.7 95.9 95.7 95.9-42.9 95.9-95.7-43-95.7-95.9-95.7zm0 143.6c-26.4 0-48-21.5-48-47.9s21.5-47.9 48-47.9c26.4 0 48 21.5 48 47.9 0 26.5-21.5 47.9-48 47.9z"
  ]
};
export const faCroissant = {
  prefix: "far",
  iconName: "croissant",
  icon: [
    512,
    512,
    [],
    "f7f6",
    "M507.72 168a161 161 0 0 0-73.48-84 71.07 71.07 0 0 0-26.18-42.49A203.31 203.31 0 0 0 285.49 0a199 199 0 0 0-46.12 5.77 72.23 72.23 0 0 0-46-3.57A262.32 262.32 0 0 0 2.13 193.38a73 73 0 0 0 3.5 45.5 201.29 201.29 0 0 0 35.73 168.36 71 71 0 0 0 41.5 25.95 161.71 161.71 0 0 0 85.06 74.52c46.79 17.71 95.34-22 87.11-71.4l-15.85-95.07a69.94 69.94 0 0 0 4.32-5.7 72.79 72.79 0 0 0 48.24-21.17l22.64-22.62c12.94-12.94 19.78-29.95 20.85-47.58a69.1 69.1 0 0 0 6.62-4.83l94.45 15.74c49.82 8.3 89.02-40.72 71.42-87.08zM111.81 382.26c-11.51 9-25.79 4.39-32.28-4.12-21.85-28.64-31.86-63.25-30.84-97.94 1.1.39 2.06 1 3.18 1.33l135.28 41.61zm73.13 80.58a113.44 113.44 0 0 1-50.43-38.27 70.28 70.28 0 0 0 6.94-4.56l55-43.16 11.23 67.35a17 17 0 0 1-22.74 18.64zm95.49-205l-22.62 22.62a25.57 25.57 0 0 1-25.6 6.36L66 235.66A25.58 25.58 0 0 1 48.7 205 214.41 214.41 0 0 1 205 48.76 25.57 25.57 0 0 1 235.64 66l51.15 166.18a25.56 25.56 0 0 1-6.36 25.63zm42.95-69.89l-41.85-136c-.39-1.24-1-2.36-1.42-3.56 1.79-.08 3.58-.38 5.37-.38a154 154 0 0 1 93.46 31.63c8.58 6.54 13.08 20.85 4.12 32.27zm120.82 19.79l-66.64-11.1 43.26-55.12a69.1 69.1 0 0 0 4.31-6.55 113.54 113.54 0 0 1 37.71 50 17 17 0 0 1-18.64 22.77z"
  ]
};
export const faCrop = {
  prefix: "far",
  iconName: "crop",
  icon: [
    512,
    512,
    [],
    "f125",
    "M496 352h-80V141.25l91.31-91.31c6.25-6.25 6.25-16.38 0-22.63L484.69 4.69c-6.25-6.25-16.38-6.25-22.63 0L370.75 96H192v64h114.75L160 306.75V16c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v80H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h80v224c0 17.67 14.33 32 32 32h192v-64H205.25L352 205.25V496c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-80h80c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
  ]
};
export const faCropAlt = {
  prefix: "far",
  iconName: "crop-alt",
  icon: [
    512,
    512,
    [],
    "f565",
    "M160 16c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v80H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h80v224c0 17.67 14.33 32 32 32h192v-64H160V16zm336 336h-80V128c0-17.67-14.33-32-32-32H192v64h160v336c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-80h80c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
  ]
};
export const faCross = {
  prefix: "far",
  iconName: "cross",
  icon: [
    384,
    512,
    [],
    "f654",
    "M344 104h-64V40c0-22.06-17.94-40-40-40h-96c-22.06 0-40 17.94-40 40v64H40c-22.06 0-40 17.94-40 40v96c0 22.06 17.94 40 40 40h64v192c0 22.06 17.94 40 40 40h96c22.06 0 40-17.94 40-40V280h64c22.06 0 40-17.94 40-40v-96c0-22.06-17.94-40-40-40zm-8 128H232v232h-80V232H48v-80h104V48h80v104h104v80z"
  ]
};
export const faCrosshairs = {
  prefix: "far",
  iconName: "crosshairs",
  icon: [
    512,
    512,
    [],
    "f05b",
    "M500 232h-29.334C459.597 131.885 380.115 52.403 280 41.334V12c0-6.627-5.373-12-12-12h-24c-6.627 0-12 5.373-12 12v29.334C131.885 52.403 52.403 131.885 41.334 232H12c-6.627 0-12 5.373-12 12v24c0 6.627 5.373 12 12 12h29.334C52.403 380.115 131.885 459.597 232 470.666V500c0 6.627 5.373 12 12 12h24c6.627 0 12-5.373 12-12v-29.334C380.115 459.597 459.597 380.115 470.666 280H500c6.627 0 12-5.373 12-12v-24c0-6.627-5.373-12-12-12zM280 422.301V380c0-6.627-5.373-12-12-12h-24c-6.627 0-12 5.373-12 12v42.301C158.427 411.84 100.154 353.532 89.699 280H132c6.627 0 12-5.373 12-12v-24c0-6.627-5.373-12-12-12H89.699C100.16 158.427 158.468 100.154 232 89.699V132c0 6.627 5.373 12 12 12h24c6.627 0 12-5.373 12-12V89.699C353.573 100.16 411.846 158.468 422.301 232H380c-6.627 0-12 5.373-12 12v24c0 6.627 5.373 12 12 12h42.301C411.84 353.573 353.532 411.846 280 422.301zM288 256c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z"
  ]
};
export const faCrow = {
  prefix: "far",
  iconName: "crow",
  icon: [
    640,
    512,
    [],
    "f520",
    "M448 72c-13.25 0-24 10.74-24 24 0 13.25 10.75 24 24 24s24-10.75 24-24c0-13.26-10.75-24-24-24zm96-40h-24.91C501.51 12.49 476.32 0 448 0c-53.02 0-96 42.98-96 96v30.16L12.09 393.57A30.216 30.216 0 0 0 0 417.74C0 435.26 14.37 448 30.23 448c4.48 0 9.08-1.02 13.5-3.23L165.27 384h96.49l44.41 120.1c2.27 6.23 9.15 9.44 15.38 7.17l22.55-8.21c6.23-2.27 9.44-9.15 7.17-15.38L312.94 384H352c1.91 0 3.76-.23 5.66-.29l44.51 120.38c2.27 6.23 9.15 9.44 15.38 7.17l22.55-8.21c6.23-2.27 9.44-9.15 7.17-15.38l-41.24-111.53C485.74 352.8 544 279.26 544 192v-80l96-16c0-35.35-42.98-64-96-64zm-48 160c0 79.4-64.6 144-144 144h-77.74l45.33-12.95c48.03-13.73 88.41-47.23 110.72-91.89 3.94-7.91.75-17.52-7.16-21.47-7.91-3.91-17.5-.73-21.47 7.16-18.31 36.66-51.44 64.16-90.91 75.42l-144.93 41.41 215.83-169.8L400 149.47V96c0-26.47 21.53-48 48-48s48 21.53 48 48v96z"
  ]
};
export const faCrown = {
  prefix: "far",
  iconName: "crown",
  icon: [
    640,
    512,
    [],
    "f521",
    "M528 464H112c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h416c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zm64-336c-26.5 0-48 21.5-48 48 0 7.1 1.6 13.7 4.4 19.8L476 239.2c-5.2 3.1-10.8 4.6-16.4 4.6-11.1 0-21.9-5.8-27.8-16.1L350.3 85C361 76.2 368 63 368 48c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 15 7 28.2 17.7 37l-81.5 142.6c-5.9 10.4-16.7 16.1-27.8 16.1-5.6 0-11.3-1.5-16.4-4.6l-72.3-43.4c2.7-6 4.4-12.7 4.4-19.8 0-26.5-21.5-48-48-48S0 149.5 0 176s21.5 48 48 48c2.6 0 5.2-.4 7.7-.8L128 416h384l72.3-192.8c2.5.4 5.1.8 7.7.8 26.5 0 48-21.5 48-48s-21.5-48-48-48zM478.7 368H161.3l-36-96.1 14 8.4c12.4 7.5 26.7 11.4 41.1 11.4 28.7 0 55.3-15.4 69.5-40.3L320 128.7l70.1 122.7c14.2 24.9 40.8 40.3 69.5 40.3 14.5 0 28.7-3.9 41.1-11.4l14-8.4-36 96.1z"
  ]
};
export const faCrutch = {
  prefix: "far",
  iconName: "crutch",
  icon: [
    512,
    512,
    [],
    "f7f7",
    "M507.31 185.59L326.29 4.68a16 16 0 0 0-22.62 0L292.35 16a16 16 0 0 0 0 22.61l181 180.9a16 16 0 0 0 22.63 0l11.31-11.3a16 16 0 0 0 .02-22.62zm-178.75 77.2l-79.19-79.15 71.43-71.38-33.94-33.92-121.14 121a87.62 87.62 0 0 0-23.5 42.43l-28.31 122.47L5.27 472.81a18 18 0 0 0 0 25.44l8.49 8.48a18 18 0 0 0 25.45 0l108.66-108.59 122.5-28.24a87.85 87.85 0 0 0 42.41-23.51l121.16-121.06L400 191.41zm-49.75 49.7a39.75 39.75 0 0 1-19.25 10.66l-91.78 21.18L189 252.59a39.74 39.74 0 0 1 10.69-19.27l15.77-15.76 79.19 79.14z"
  ]
};
export const faCrutches = {
  prefix: "far",
  iconName: "crutches",
  icon: [
    640,
    512,
    [],
    "f7f8",
    "M635.31 185.59L454.29 4.68a16 16 0 0 0-22.62 0L420.35 16a16 16 0 0 0 0 22.61l181 180.9a16 16 0 0 0 22.63 0l11.31-11.3a16 16 0 0 0 .02-22.62zm-178.75 77.2l-79.19-79.15 71.43-71.38-33.94-33.92-121.14 121a87.62 87.62 0 0 0-23.5 42.43l-28.31 122.47-108.64 108.57a18 18 0 0 0 0 25.44l8.49 8.48a18 18 0 0 0 25.45 0l108.67-108.59 122.49-28.24a87.85 87.85 0 0 0 42.41-23.51l121.16-121.06L528 191.41zm-49.75 49.7a39.75 39.75 0 0 1-19.25 10.66l-91.78 21.18L317 252.59a39.74 39.74 0 0 1 10.69-19.27l15.77-15.76 79.19 79.14zM207.93 353l4.87-4.86 10.51-45.47L89.38 168.79l79.2-79.15L264 185c2.33-2.79 4.57-5.64 7.15-8.22l26.27-26.25-94.9-94.81 17.13-17.12a16 16 0 0 0 0-22.61L208.33 4.68a16 16 0 0 0-22.62 0L4.69 185.59a16 16 0 0 0 0 22.61L16 219.5a16 16 0 0 0 22.63 0l16.81-16.79 143.78 143.68c2.59 2.61 5.83 4.33 8.71 6.61zm219.43 40.53a120.22 120.22 0 0 1-21.8 7.6l-31.27 7.21 98.5 98.43a18 18 0 0 0 25.45 0l8.49-8.48a18 18 0 0 0 0-25.44z"
  ]
};
export const faCube = {
  prefix: "far",
  iconName: "cube",
  icon: [
    512,
    512,
    [],
    "f1b2",
    "M239.1 7.5l-208 78c-18.7 7-31.1 25-31.1 45v225.1c0 18.2 10.3 34.8 26.5 42.9l208 104c13.5 6.8 29.4 6.8 42.9 0l208-104c16.3-8.1 26.5-24.8 26.5-42.9V130.5c0-20-12.4-37.9-31.1-44.9l-208-78C262 3.4 250 3.4 239.1 7.5zm16.9 45l208 78v.3l-208 84.5-208-84.5v-.3l208-78zM48 182.6l184 74.8v190.2l-184-92v-173zm232 264.9V257.4l184-74.8v172.9l-184 92z"
  ]
};
export const faCubes = {
  prefix: "far",
  iconName: "cubes",
  icon: [
    512,
    512,
    [],
    "f1b3",
    "M384 215.1V102.5c0-15-9.3-28.4-23.4-33.7l-92-34.5c-8.1-3.1-17.1-3.1-25.3 0l-92 34.5c-14.1 5.3-23.4 18.7-23.4 33.7v112.6L23.4 254.4C9.3 259.6 0 273.1 0 288.1v106.6c0 13.6 7.7 26.1 19.9 32.2l98.6 49.3c10.1 5.1 22.1 5.1 32.2 0L256 423.6l105.3 52.6c10.1 5.1 22.1 5.1 32.2 0l98.6-49.3c12.2-6.1 19.9-18.6 19.9-32.2V288.1c0-15-9.3-28.4-23.4-33.7L384 215.1zm-116 34.8V152l92-31.7v97.6l-92 32zM152 94.2l104-39 104 39v.2L256 131 152 94.3v-.1zm0 26.1l92 31.7v97.9l-92-32v-97.6zm-30 329.4l-96.8-48.4V308l96.8 39.3v102.4zM25.2 280.8v-.2l109.4-41 108.1 40.5v1.2l-108.1 43.9-109.4-44.4zm122 66.5l95.5-38.8V402l-95.5 47.8V347.3zm217.6 102.4L269.3 402v-93.4l95.5 38.8v102.3zm122-48.4L390 449.7V347.3l96.8-39.3v93.3zm0-120.5l-109.4 44.4-108.1-43.9v-1.2l108.1-40.5 109.4 41v.2z"
  ]
};
export const faCurling = {
  prefix: "far",
  iconName: "curling",
  icon: [
    640,
    512,
    [],
    "f44a",
    "M540.5 199.7C529.7 158.5 492.6 128 448 128H288v-16c0-26.5 21.5-48 48-48h128c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16H336c-61.9 0-112 50.1-112 112v16h-32c-44.6 0-81.7 30.5-92.5 71.7C41.9 218.6 0 272.1 0 336v32c0 79.5 64.5 144 144 144h352c79.5 0 144-64.5 144-144v-32c0-63.9-41.9-117.4-99.5-136.3zM144 240h352c52.9 0 96 43.1 96 96H48c0-52.9 43.1-96 96-96zm352 224H144c-52.9 0-96-43.1-96-96h544c0 52.9-43.1 96-96 96z"
  ]
};
export const faCut = {
  prefix: "far",
  iconName: "cut",
  icon: [
    448,
    512,
    [],
    "f0c4",
    "M263.39 256L445.66 73.37c3.12-3.12 3.12-8.19 0-11.31-18.74-18.74-49.14-18.74-67.88 0L223.82 216.35l-43.1-43.18C187.92 159.71 192 144.33 192 128c0-53.02-42.98-96-96-96S0 74.98 0 128s42.98 96 96 96c16.31 0 31.66-4.07 45.11-11.24L184.26 256l-43.15 43.24C127.66 292.07 112.31 288 96 288c-53.02 0-96 42.98-96 96s42.98 96 96 96 96-42.98 96-96c0-16.33-4.08-31.71-11.28-45.17l43.1-43.18 153.95 154.29c18.74 18.74 49.14 18.74 67.88 0 3.12-3.12 3.12-8.19 0-11.31L263.39 256zM96 176c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48zm0 256c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48z"
  ]
};
export const faDagger = {
  prefix: "far",
  iconName: "dagger",
  icon: [
    384,
    512,
    [],
    "f6cb",
    "M344 96H216V16c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v80H40c-22.09 0-40 17.91-40 40s17.91 40 40 40c19.25 0 34.57-13.88 38.38-32H112v264.05l63.36 95.04c3.96 5.94 10.3 8.91 16.64 8.91s12.68-2.97 16.64-8.91L272 408.05V144h33.62c3.81 18.12 19.13 32 38.38 32 22.09 0 40-17.91 40-40s-17.91-40-40-40zM224 393.52l-32 48-32-48V144h64v249.52z"
  ]
};
export const faDatabase = {
  prefix: "far",
  iconName: "database",
  icon: [
    448,
    512,
    [],
    "f1c0",
    "M224 48c97.167 0 176 27.723 176 61.714v4.571C400 148.277 321.167 176 224 176S48 148.277 48 114.286v-4.571C48 75.723 126.833 48 224 48m176 135.018v26.399c0 33.991-78.833 61.714-176 61.714S48 243.408 48 209.417v-26.399C85.813 210.982 155.021 224 224 224s138.187-13.018 176-40.982m0 96v26.834c0 33.991-78.833 61.714-176 61.714S48 339.842 48 305.851v-26.834C85.813 306.982 155.021 320 224 320s138.187-13.018 176-40.982m0 96v27.268C400 436.277 321.167 464 224 464S48 436.277 48 402.286v-27.268C85.813 402.982 155.021 416 224 416s138.187-13.018 176-40.982M224 0C137.052 0 0 23.26 0 109.714v292.571C0 488.758 137.03 512 224 512c86.948 0 224-23.26 224-109.714V109.714C448 23.242 310.97 0 224 0z"
  ]
};
export const faDeaf = {
  prefix: "far",
  iconName: "deaf",
  icon: [
    512,
    512,
    [],
    "f2a4",
    "M404.486 124.485l-16.971-16.971c-4.686-4.686-4.686-12.284 0-16.971l87.029-87.029c4.686-4.686 12.284-4.686 16.971 0l16.971 16.971c4.686 4.686 4.686 12.284 0 16.971l-87.029 87.029c-4.687 4.687-12.285 4.687-16.971 0zm-367.03 384l151.029-151.029c4.686-4.686 4.686-12.284 0-16.971l-16.971-16.971c-4.686-4.686-12.284-4.686-16.971 0L3.515 474.544c-4.686 4.686-4.686 12.284 0 16.971l16.971 16.971c4.686 4.686 12.284 4.686 16.97-.001zM351.15 397.282C351.901 351.835 424 338.659 424 264c0-93.516-75.03-168-168-168-93.134 0-168 74.662-168 168 0 13.255 10.745 24 24 24s24-10.745 24-24c0-67.05 53.62-120 120-120 66.503 0 120 53.082 120 120 0 48.824-71.843 60.62-72.849 132.757l-.002.334c0 36.894-29.607 66.909-66 66.909-13.255 0-24 10.745-24 24s10.745 24 24 24c62.796 0 113.894-51.446 114.001-114.718zM320 288c-13.255 0-24-10.745-24-24 0-22.056-17.944-40-40-40s-40 17.944-40 40c0 13.255-10.745 24-24 24s-24-10.745-24-24c0-48.523 39.477-88 88-88s88 39.477 88 88c0 13.255-10.745 24-24 24z"
  ]
};
export const faDebug = {
  prefix: "far",
  iconName: "debug",
  icon: [
    512,
    512,
    [],
    "f7f9",
    "M117.75 271a16 16 0 1 0 4.5 31.68l42.75-6.09a90.21 90.21 0 0 0 10.81 39l-35.51 23.69a16 16 0 1 0 17.7 26.61l37.64-25.1a87.82 87.82 0 0 0 83.24 19.94L162.77 264.58zM256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.28 0-200-89.72-200-200a198.86 198.86 0 0 1 42.81-123.25l280.44 280.44A198.86 198.86 0 0 1 256 456zm157.19-76.75L345 311.08a89.64 89.64 0 0 0 2-14.49l42.73 6.11a16 16 0 1 0 4.5-31.68l-46.82-6.69v-24.65l46.82-6.7a16 16 0 1 0-4.5-31.68l-43.52 6.22a90.15 90.15 0 0 0-10-31.1l35.51-23.69A16 16 0 1 0 354 126.11l-37.64 25.1a90.27 90.27 0 0 0-126.08 5.1l-57.5-57.5A198.86 198.86 0 0 1 256 56c110.28 0 200 89.72 200 200a198.86 198.86 0 0 1-42.81 123.25z"
  ]
};
export const faDeer = {
  prefix: "far",
  iconName: "deer",
  icon: [
    512,
    512,
    [],
    "f78e",
    "M384 160c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm81.4-51.5l-68.7-19.4c3-3.3 6.2-6.3 8.7-10L423.5 52c4.9-7.3 2.9-17.3-4.4-22.2l-13.3-8.9c-7.4-4.9-17.3-2.9-22.2 4.4l-18.1 27.2c-3.9 5.8-9.2 10.5-15.4 13.6l-48.8 24.4-9.5-2.8c7.9-9.9 12.3-22.3 12.3-35V16c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16v36.8c0 1.8-.6 3.6-1.7 5L241 74.6l-11-3.1c-3.4-1-5.8-4.1-5.8-7.7V16c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16v47.8c0 25 16.8 47.2 40.9 53.9l63.8 17.9-14.6 24.4H88c-48.5 0-88 39.5-88 88v64h48v7.2L37.6 347c-6.2 16.8-7.3 34.9-2.6 53.3l24.5 81.5c4.5 17.8 20.4 30.3 38.8 30.3h63.8c12.4 0 23.9-5.6 31.5-15.3 7.6-9.8 10.3-22.3 7-35.4l-24-80.7 10.7-28.6H240v120c0 22.1 17.9 40 40 40h64c22.1 0 40-17.9 40-40V295.3l20.8-31.3H448c35.3 0 64-28.7 64-64v-29.9c0-28.5-19.2-53.8-46.6-61.6zM464 200c0 8.8-7.2 16-16 16h-68.8L336 280.7V464h-48V304H154l-28.1 74.8 25.4 85.2h-47.1l-23.1-76.5c-2-7.9-1.5-16.1 1.3-23.7L96.5 332l-.5-68H48v-16c0-22.1 17.9-40 40-40h205.7l34.5-58.8c7.5-15 24.6-22.5 40.8-18l83.3 23.5c6.9 1.9 11.7 8.3 11.7 15.4V200z"
  ]
};
export const faDeerRudolph = {
  prefix: "far",
  iconName: "deer-rudolph",
  icon: [
    576,
    512,
    [],
    "f78f",
    "M400 160c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm136-64c-15.5 0-28.5 9.1-35.2 22-5.8-4.1-12.3-7.4-19.4-9.4l-68.7-19.4c3-3.3 6.2-6.3 8.7-10L439.5 52c4.9-7.4 2.9-17.3-4.4-22.2l-13.3-8.9c-7.4-4.9-17.3-2.9-22.2 4.4l-18.1 27.2c-3.9 5.8-9.2 10.5-15.4 13.6l-48.8 24.4-1.3.6-9-2.5.7-.9c7.9-9.9 12.3-22.3 12.3-35V16c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16v36.8c0 1.8-.6 3.6-1.7 5l-13.4 16.8-11-3.1c-3.4-1-5.8-4.1-5.8-7.7V16c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16v47.8c0 25 16.8 47.2 40.9 53.9l63.8 17.9-14.5 24.4H88c-48.5 0-88 39.5-88 88v64h48v7.2L37.6 347c-6.2 16.8-7.3 34.9-2.6 53.3l24.5 81.5c4.5 17.8 20.4 30.3 38.8 30.3h63.8c12.4 0 23.9-5.6 31.5-15.3 7.6-9.8 10.3-22.3 7-35.4l-24-80.7 10.7-28.6H256v120c0 22.1 17.9 40 40 40h64c22.1 0 40-17.9 40-40V302.4l21.9-38.4H464c35.3 0 64-28.7 64-64v-25.6c2.7.6 5.2 1.6 8 1.6 22.1 0 40-17.9 40-40s-17.9-40-40-40zm-56 104c0 8.8-7.2 16-16 16h-69.9L352 289.6V464h-48V304H154l-28.1 74.8 25.4 85.2h-47.1l-23.1-76.5c-2-7.9-1.5-16.1 1.3-23.7L96.5 332l-.5-68H48v-16c0-22.1 17.9-40 40-40h221.7l34.5-58.8c7.5-15 24.6-22.5 40.8-18l83.3 23.5c6.9 1.9 11.7 8.3 11.7 15.4V200z"
  ]
};
export const faDemocrat = {
  prefix: "far",
  iconName: "democrat",
  icon: [
    640,
    512,
    [],
    "f747",
    "M638.7 221.2L619 191.7c-25.2-37.8-66.5-61.2-111.6-63.7h-219l-73.6-61.2c11.3-19.2 11.5-43.1-.9-61.9-3.4-5.2-10.8-5.9-15.2-1.5l-40.9 40.8-41.9-41.8c-3.6-3.6-9.6-3-12.4 1.2-11.4 17.2-9.9 39.7 3.1 56l-93 108.7C-1.1 185.4-4 209.6 6.1 229.7l13.7 27.4c9.6 19.1 28.8 30.9 50.1 30.9h31c14.8 0 29.2-6 38.2-15.1l10.3-8.7 26.3 68.3V472c0 22.1 18 40 40 40h72.1c22.1 0 40-17.9 40-40v-40h96.1v40c0 22.1 18 40 40 40H536c22.1 0 40-17.9 40-40V216c0-.5-.1-1-.2-1.5 1 1.4 2.3 2.4 3.3 3.9l19.6 29.4c1.2 1.8 3 3 5.1 3.4 2.2.5 4.2 0 6-1.2l26.7-17.7c3.6-2.5 4.6-7.5 2.2-11.1zM527.9 464h-56.1v-64c0-8.8-7.2-16-16-16H295.7c-8.8 0-16 7.2-16 16v64h-56.1V352h304.3v112zm0-160H214.7l-36.9-98.8c-3.9-10.4-16.9-13.8-25.4-6.6l-46 39.1c-1.5 1.5-3.6 2.3-5.7 2.3h-31c-3.1 0-5.8-1.7-7.2-4.4l-13.7-27.3c-1.4-2.9-1-6.3 1.1-8.8L138.6 96h36.3l96.1 80h216.9c22.1 0 40 17.9 40 40v88zm-244.2-77.2l-8.2-16.5c-1.5-3-5.7-3-7.2 0l-8.2 16.5-18.3 2.7c-3.3.5-4.6 4.5-2.2 6.8l13.2 12.9-3.1 18.2c-.6 3.3 2.9 5.8 5.8 4.2l16.3-8.6 16.3 8.6c2.9 1.5 6.4-.9 5.8-4.2l-3.1-18.2 13.2-12.9c2.4-2.3 1.1-6.3-2.2-6.8l-18.1-2.7zm95.8 0l-8.2-16.5c-1.5-3-5.7-3-7.2 0l-8.2 16.5-18.3 2.7c-3.3.5-4.6 4.5-2.2 6.8l13.2 12.9-3.1 18.2c-.6 3.3 2.9 5.8 5.8 4.2l16.3-8.6 16.3 8.6c2.9 1.5 6.4-.9 5.8-4.2l-3.1-18.2 13.2-12.9c2.4-2.3 1.1-6.3-2.2-6.8l-18.1-2.7zm96.2 0l-8.2-16.5c-1.5-3-5.7-3-7.2 0l-8.2 16.5-18.3 2.7c-3.3.5-4.6 4.5-2.2 6.8l13.2 12.9-3.1 18.2c-.6 3.3 2.9 5.8 5.8 4.2l16.3-8.6 16.3 8.6c2.9 1.5 6.4-.9 5.8-4.2l-3.1-18.2 13.2-12.9c2.4-2.3 1.1-6.3-2.2-6.8l-18.1-2.7z"
  ]
};
export const faDesktop = {
  prefix: "far",
  iconName: "desktop",
  icon: [
    576,
    512,
    [],
    "f108",
    "M528 0H48C21.5 0 0 21.5 0 48v288c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zm-6 336H54c-3.3 0-6-2.7-6-6V54c0-3.3 2.7-6 6-6h468c3.3 0 6 2.7 6 6v276c0 3.3-2.7 6-6 6zm-42 152c0 13.3-10.7 24-24 24H120c-13.3 0-24-10.7-24-24s10.7-24 24-24h98.7l18.6-55.8c1.6-4.9 6.2-8.2 11.4-8.2h78.7c5.2 0 9.8 3.3 11.4 8.2l18.6 55.8H456c13.3 0 24 10.7 24 24z"
  ]
};
export const faDesktopAlt = {
  prefix: "far",
  iconName: "desktop-alt",
  icon: [
    576,
    512,
    [],
    "f390",
    "M528 0H48C21.5 0 0 21.5 0 48v288c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM48 54c0-3.3 2.7-6 6-6h468c3.3 0 6 2.7 6 6v234H48V54zm432 434c0 13.3-10.7 24-24 24H120c-13.3 0-24-10.7-24-24s10.7-24 24-24h98.7l18.6-55.8c1.6-4.9 6.2-8.2 11.4-8.2h78.7c5.2 0 9.8 3.3 11.4 8.2l18.6 55.8H456c13.3 0 24 10.7 24 24z"
  ]
};
export const faDewpoint = {
  prefix: "far",
  iconName: "dewpoint",
  icon: [
    448,
    512,
    [],
    "f748",
    "M176 0c-12.4 0-24.7 6.8-29.2 20.7C100 168.6 0 240.8 0 345c0 92.3 78.7 167 176 167s176-74.7 176-167c0-104.8-99.8-175.8-146.8-324.3C201.2 7.1 188.6 0 176 0zm128 345c0 65.6-57.4 119-128 119S48 410.6 48 345c0-42.9 25.1-82.9 56.8-133.5 23.7-37.8 49.9-79.6 71.2-131 21.4 51.7 47.6 93.4 71.4 131.2C279 262.1 304 301.9 304 345zM368 0c-44.1 0-80 35.9-80 80s35.9 80 80 80 80-35.9 80-80-35.9-80-80-80zm0 112c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
  ]
};
export const faDharmachakra = {
  prefix: "far",
  iconName: "dharmachakra",
  icon: [
    512,
    512,
    [],
    "f655",
    "M499.23 232.01l-20.46.62c-4.6-44.33-22.16-84.78-48.78-117.59l14.96-14.07c5.13-4.72 5.3-12.76.37-17.69l-16.6-16.6c-4.93-4.93-12.97-4.76-17.69.37l-14.07 14.96c-32.81-26.62-73.26-44.18-117.59-48.78l.62-20.46C280.28 5.8 274.71 0 267.74 0h-23.48c-6.97 0-12.54 5.8-12.25 12.77l.62 20.46c-44.33 4.6-84.77 22.16-117.59 48.78l-14.07-14.96c-4.72-5.13-12.76-5.3-17.69-.37l-16.6 16.6c-4.93 4.93-4.76 12.97.37 17.69l14.96 14.07c-26.62 32.81-44.18 73.26-48.78 117.59l-20.46-.62C5.8 231.72 0 237.29 0 244.26v23.48c0 6.97 5.8 12.54 12.77 12.25l20.46-.62c4.6 44.33 22.16 84.77 48.78 117.59l-14.96 14.07c-5.13 4.72-5.3 12.76-.37 17.69l16.6 16.6c4.93 4.93 12.97 4.76 17.69-.37l14.07-14.96c32.81 26.62 73.26 44.18 117.59 48.78l-.62 20.46c-.29 6.96 5.28 12.77 12.25 12.77h23.48c6.97 0 12.54-5.81 12.25-12.77l-.62-20.46c44.33-4.6 84.77-22.16 117.59-48.78l14.07 14.96c4.72 5.13 12.76 5.3 17.69.37l16.6-16.6c4.93-4.93 4.76-12.97-.37-17.69l-14.96-14.07c26.62-32.81 44.18-73.26 48.78-117.59l20.46.62c6.97.29 12.77-5.28 12.77-12.25v-23.48c0-6.97-5.8-12.54-12.77-12.25zm-68.74 2.1l-80.48 2.46c-2.49-12.06-7.33-23.25-13.89-33.2l58.67-55.2c18.98 24.37 31.68 53.79 35.7 85.94zM256 304c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm107.84-186.79l-55.2 58.67c-9.95-6.56-21.14-11.4-33.2-13.89l2.46-80.48c32.14 4.01 61.56 16.72 85.94 35.7zm-129.73-35.7l2.46 80.48c-12.06 2.49-23.25 7.33-33.2 13.89l-55.2-58.67c24.37-18.98 53.79-31.69 85.94-35.7zm-116.9 66.65l58.67 55.2c-6.56 9.95-11.4 21.14-13.89 33.2l-80.48-2.46c4.02-32.14 16.72-61.56 35.7-85.94zm-35.7 129.73l80.48-2.46c2.49 12.06 7.33 23.25 13.89 33.2l-58.67 55.2c-18.98-24.37-31.69-53.79-35.7-85.94zm66.65 116.9l55.2-58.67c9.95 6.56 21.14 11.4 33.2 13.89l-2.46 80.48c-32.14-4.01-61.56-16.72-85.94-35.7zm129.73 35.7l-2.46-80.48c12.06-2.49 23.25-7.33 33.2-13.89l55.2 58.67c-24.37 18.98-53.79 31.69-85.94 35.7zm116.9-66.65l-58.67-55.2c6.56-9.95 11.4-21.14 13.89-33.2l80.48 2.46c-4.01 32.14-16.72 61.56-35.7 85.94z"
  ]
};
export const faDiagnoses = {
  prefix: "far",
  iconName: "diagnoses",
  icon: [
    640,
    512,
    [],
    "f470",
    "M632 464H8c-4.4 0-8 3.6-8 8v32c0 4.4 3.6 8 8 8h624c4.4 0 8-3.6 8-8v-32c0-4.4-3.6-8-8-8zM256 304c0 8.8 7.2 16 16 16s16-7.2 16-16-7.2-16-16-16-16 7.2-16 16zm240-48c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zM96 272c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zm488.6 56.4l-17.8 26.7c-3.1 4.6-8.1 7.2-13.3 7.2-9.8 0-55.6-34.9-137.5-58.9V416h48v-43.8c26.3 11.7 46.7 23.1 57 29.2 9.9 5.8 21.1 8.9 32.5 8.9 21.4 0 41.3-10.7 53.2-28.6l17.8-26.7c9.7-14.6 13.1-32.7 9.2-49.7-3.8-16.9-14.5-31.7-29.4-40.6-13.8-8.3-35.3-20.1-61.2-32.3 4.2 26.5-13.3 41.5-17.4 44.9 23.2 11.1 42.2 21.6 53.9 28.6 8 4.7 10.1 14.9 5 22.5zM33.2 381.7c11.9 17.9 31.8 28.6 53.2 28.6 11.4 0 22.7-3.1 32.5-8.9 10.3-6.1 30.7-17.5 57-29.2V416h48V303.4C142.8 327.2 96 362.3 86.4 362.3c-5.2 0-10.2-2.5-13.3-7.2l-17.8-26.7c-5.1-7.6-2.9-17.8 4.9-22.5 3.6-2.2 8.5-4.9 13.4-7.7-14.7-7.8-24.9-23-25.5-40.7-4.4 2.5-9.1 5.1-12.6 7.2-14.9 8.9-25.6 23.7-29.4 40.6-3.8 17-.5 35.1 9.2 49.7l17.9 26.7zm110-117.3C192.7 243.5 255.7 224 320 224c44.9 0 89 9.6 128.6 22.4-3.6-26.6 14.1-41.1 18.3-44.4-19.9-6.6-41.1-12.3-63-16.8 17.2-19.7 28-45.1 28-73.3C432 50.2 381.8 0 320 0c-61.8 0-112 50.2-112 112 0 28 10.7 53.4 27.8 73.1-39.8 8.1-77.1 20.8-109.3 34.2 15.3 12.7 19.3 30.2 16.7 45.1zM320 48c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm32 336c0 8.8 7.2 16 16 16s16-7.2 16-16-7.2-16-16-16-16 7.2-16 16z"
  ]
};
export const faDiamond = {
  prefix: "far",
  iconName: "diamond",
  icon: [
    448,
    512,
    [],
    "f219",
    "M189.5 496L11 285.7c-14.6-17.2-14.6-42.2 0-59.5L189.5 16c18.1-21.4 50.9-21.3 69 0L437 226.3c14.6 17.2 14.6 42.2 0 59.5L258.5 496c-18.1 21.4-50.9 21.3-69 0zM48 256l176 206.5L400 256 224 49.5 48 256z"
  ]
};
export const faDice = {
  prefix: "far",
  iconName: "dice",
  icon: [
    640,
    512,
    [],
    "f522",
    "M480 328c-13.25 0-24 10.74-24 24 0 13.25 10.75 24 24 24s24-10.75 24-24c0-13.26-10.75-24-24-24zm96-136H439.38v.01c-2.89-5.17-6.26-10.15-10.66-14.55L270.54 19.28C257.69 6.42 240.84 0 224 0s-33.69 6.42-46.54 19.28L19.28 177.46c-25.7 25.7-25.7 67.38 0 93.08l158.18 158.18C190.31 441.57 207.16 448 224 448s33.69-6.43 46.54-19.28L320 379.26V448c0 35.35 28.65 64 64 64h192c35.35 0 64-28.65 64-64V256c0-35.35-28.65-64-64-64zM235.63 393.82c-4.19 4.19-9.09 4.82-11.63 4.82s-7.44-.63-11.63-4.82L54.18 235.63c-6.42-6.42-6.42-16.86 0-23.27L212.37 54.18c4.19-4.19 9.09-4.82 11.63-4.82s7.44.63 11.63 4.82l158.19 158.18c6.42 6.41 6.42 16.85 0 23.27L235.63 393.82zM592 448c0 8.82-7.18 16-16 16H384c-8.82 0-16-7.18-16-16V331.26l60.72-60.72c8.73-8.73 14.26-19.37 17.05-30.54H576c8.82 0 16 7.18 16 16v192zM224 200c-13.25 0-24 10.74-24 24 0 13.25 10.75 24 24 24s24-10.75 24-24c0-13.26-10.75-24-24-24zm96 0c-13.25 0-24 10.74-24 24 0 13.25 10.75 24 24 24s24-10.75 24-24c0-13.26-10.75-24-24-24zm-192 0c-13.25 0-24 10.74-24 24 0 13.25 10.75 24 24 24s24-10.75 24-24c0-13.26-10.75-24-24-24zm96 96c-13.25 0-24 10.74-24 24 0 13.25 10.75 24 24 24s24-10.75 24-24c0-13.26-10.75-24-24-24zm0-192c-13.25 0-24 10.74-24 24 0 13.25 10.75 24 24 24s24-10.75 24-24c0-13.26-10.75-24-24-24z"
  ]
};
export const faDiceD10 = {
  prefix: "far",
  iconName: "dice-d10",
  icon: [
    512,
    512,
    [],
    "f6cd",
    "M503.88 261.29L279.8 10.64C273.45 3.55 264.73 0 256 0s-17.45 3.55-23.8 10.64L8.12 261.29c-11.81 13.21-10.6 33.5 2.69 45.22l224.08 197.52c6.03 5.32 13.57 7.97 21.11 7.97s15.08-2.66 21.11-7.97L501.19 306.5c13.29-11.71 14.49-32.01 2.69-45.21zM256 287.83l-66.08-44.05L256 89.6l66.08 154.18L256 287.83zm-113.37-55.56l-56.9 14.23 97.58-109.15-40.68 94.92zm12.9 46.26L232 329.51v107.97L74.61 298.76l80.92-20.23zM280 329.51l76.47-50.98 80.92 20.22L280 437.49V329.51zm89.37-97.24l-40.68-94.92 97.58 109.15-56.9-14.23z"
  ]
};
export const faDiceD12 = {
  prefix: "far",
  iconName: "dice-d12",
  icon: [
    512,
    512,
    [],
    "f6ce",
    "M508.62 185.24l-55.85-111.7a32.06 32.06 0 0 0-14.31-14.31L326.76 3.38A32.066 32.066 0 0 0 312.45 0h-112.9c-4.97 0-9.87 1.16-14.31 3.38L73.54 59.23a32.06 32.06 0 0 0-14.31 14.31L3.38 185.24A32.066 32.066 0 0 0 0 199.55v112.89c0 4.97 1.16 9.87 3.38 14.31l55.85 111.7a32.06 32.06 0 0 0 14.31 14.31l111.7 55.85c4.44 2.22 9.34 3.38 14.31 3.38h112.89c4.97 0 9.87-1.16 14.31-3.38l111.7-55.85a32.06 32.06 0 0 0 14.31-14.31l55.85-111.7c2.22-4.44 3.38-9.34 3.38-14.31V199.55c.01-4.96-1.15-9.86-3.37-14.31zm-53.62.1l-78.18 104.24L280 241.17v-93.5l140.72-28.14-.93-4.61L455 185.34zM300.56 464h-89.11l-52.96-132.41L256 282.83l97.52 48.76L300.56 464zM203.33 48h105.34l64.28 32.14L256 103.53 139.06 80.14 203.33 48zM92.21 114.92l-.93 4.61L232 147.68v93.5l-96.82 48.41L57 185.34l35.21-70.42zM48 308.67v-55.35l58.9 78.53 41.96 104.91-49.08-24.54L48 308.67zm364.22 103.55l-49.08 24.54 41.96-104.91 58.9-78.53v55.35l-51.78 103.55z"
  ]
};
export const faDiceD20 = {
  prefix: "far",
  iconName: "dice-d20",
  icon: [
    448,
    512,
    [],
    "f6cf",
    "M431.88 116.13L239.88 4.3a31.478 31.478 0 0 0-31.76 0l-192 111.84C6.15 121.94 0 132.75 0 144.45v223.09c0 11.71 6.15 22.51 16.12 28.32l192 111.84a31.478 31.478 0 0 0 31.76 0l192-111.84c9.97-5.81 16.12-16.62 16.12-28.32V144.45c0-11.7-6.15-22.51-16.12-28.32zM224 87.87L296.47 184H151.53L224 87.87zm0 251.42L155.72 232h136.56L224 339.29zm-110.88-84.82l63.37 99.58-83.42-19.37 20.05-80.21zm221.76 0l20.05 80.21-83.42 19.37 63.37-99.58zm16.6-77.22l-70.41-93.41 106.02 61.76-35.61 31.65zm-254.96 0L60.91 145.6l106.02-61.76-70.41 93.41zm-24.24 42.66L48 317.05V198.33l24.28 21.58zM200 408.78v38.64L89.71 383.18 200 408.78zm48 0l110.29-25.61L248 447.42v-38.64zm152-91.73l-24.28-97.13L400 198.33v118.72z"
  ]
};
export const faDiceD4 = {
  prefix: "far",
  iconName: "dice-d4",
  icon: [
    512,
    512,
    [],
    "f6d0",
    "M504.9 289.03L280.85 11.86C274.45 3.96 265.23 0 256 0s-18.45 3.96-24.85 11.86L7.1 289.03c-11.31 14-8.84 34.57 5.47 45.49l224.05 170.94a31.87 31.87 0 0 0 19.38 6.55c6.83 0 13.66-2.18 19.38-6.55l224.05-170.94c14.31-10.92 16.78-31.5 5.47-45.49zM232 87.17v354.38L54.81 306.37 232 87.17zm48 354.38V87.17l177.19 219.2L280 441.55z"
  ]
};
export const faDiceD6 = {
  prefix: "far",
  iconName: "dice-d6",
  icon: [
    448,
    512,
    [],
    "f6d1",
    "M431.88 116.13L239.88 4.3a31.478 31.478 0 0 0-31.76 0l-192 111.84C6.15 121.94 0 132.75 0 144.45v223.09c0 11.71 6.15 22.51 16.12 28.32l192 111.84a31.478 31.478 0 0 0 31.76 0l192-111.84c9.97-5.81 16.12-16.62 16.12-28.32V144.45c0-11.7-6.15-22.51-16.12-28.32zM224 50.6l152.35 88.74L224 228.22 71.65 139.34 224 50.6zM48 181.12l152 88.66v177.64L48 358.88V181.12zm200 266.3V269.78l152-88.66v177.76l-152 88.54z"
  ]
};
export const faDiceD8 = {
  prefix: "far",
  iconName: "dice-d8",
  icon: [
    512,
    512,
    [],
    "f6d2",
    "M502.12 232.14L279.86 9.88C273.27 3.29 264.64 0 256 0s-17.27 3.29-23.86 9.88L9.88 232.14c-13.18 13.18-13.18 34.55 0 47.73l222.25 222.25c6.59 6.59 15.23 9.88 23.86 9.88s17.27-3.29 23.86-9.88L502.1 279.87c13.19-13.19 13.19-34.55.02-47.73zM280 77.9l166.38 166.38L280 315.6V77.9zm-48 237.7L65.62 244.29 232 77.9v237.7zm0 52.22v66.27L116.04 318.13 232 367.82zm48 0l115.97-49.69L280 434.1v-66.28z"
  ]
};
export const faDiceFive = {
  prefix: "far",
  iconName: "dice-five",
  icon: [
    448,
    512,
    [],
    "f523",
    "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zm16 384c0 8.82-7.18 16-16 16H64c-8.82 0-16-7.18-16-16V96c0-8.82 7.18-16 16-16h320c8.82 0 16 7.18 16 16v320zM128 128c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm96 96c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm-96 96c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm192-192c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm0 192c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32z"
  ]
};
export const faDiceFour = {
  prefix: "far",
  iconName: "dice-four",
  icon: [
    448,
    512,
    [],
    "f524",
    "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zm16 384c0 8.82-7.18 16-16 16H64c-8.82 0-16-7.18-16-16V96c0-8.82 7.18-16 16-16h320c8.82 0 16 7.18 16 16v320zM128 128c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm0 192c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm192-192c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm0 192c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32z"
  ]
};
export const faDiceOne = {
  prefix: "far",
  iconName: "dice-one",
  icon: [
    448,
    512,
    [],
    "f525",
    "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zm16 384c0 8.82-7.18 16-16 16H64c-8.82 0-16-7.18-16-16V96c0-8.82 7.18-16 16-16h320c8.82 0 16 7.18 16 16v320zM224 224c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32z"
  ]
};
export const faDiceSix = {
  prefix: "far",
  iconName: "dice-six",
  icon: [
    448,
    512,
    [],
    "f526",
    "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zm16 384c0 8.82-7.18 16-16 16H64c-8.82 0-16-7.18-16-16V96c0-8.82 7.18-16 16-16h320c8.82 0 16 7.18 16 16v320zM128 128c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm0 96c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm192 0c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm-192 96c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm192-192c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm0 192c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32z"
  ]
};
export const faDiceThree = {
  prefix: "far",
  iconName: "dice-three",
  icon: [
    448,
    512,
    [],
    "f527",
    "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zm16 384c0 8.82-7.18 16-16 16H64c-8.82 0-16-7.18-16-16V96c0-8.82 7.18-16 16-16h320c8.82 0 16 7.18 16 16v320zM128 128c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm96 96c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm96 96c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32z"
  ]
};
export const faDiceTwo = {
  prefix: "far",
  iconName: "dice-two",
  icon: [
    448,
    512,
    [],
    "f528",
    "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zm16 384c0 8.82-7.18 16-16 16H64c-8.82 0-16-7.18-16-16V96c0-8.82 7.18-16 16-16h320c8.82 0 16 7.18 16 16v320zM128 128c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm192 192c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32z"
  ]
};
export const faDigging = {
  prefix: "far",
  iconName: "digging",
  icon: [
    576,
    512,
    [],
    "f85e",
    "M272 96a48 48 0 1 0-48-48 48 48 0 0 0 48 48zm39.06 320a32 32 0 0 0-30.35 21.88L256 512h320L474.07 305.69a32 32 0 0 0-56.07-2.15l-31.52 53.69-75-40.52L289 194.56a121.81 121.81 0 0 0-65.47-85.62A123 123 0 0 0 168.72 96H96a24 24 0 0 0-17.94 8.06L21.2 170.38a32 32 0 0 0 9 49l331.6 179.9L352 416zM107.84 206L70 185.38 106.78 144h55.33zm82.51 45l49.18-54.63 18 91.15zm203 189.26l50.84-86.63L498.75 464H379.48zM195.5 346.94L65.33 273.88l-64.24 207a24 24 0 1 0 45.81 14.23l46.35-149.27L160 382.25V488a24 24 0 0 0 48 0V368a24 24 0 0 0-12.5-21.06z"
  ]
};
export const faDigitalTachograph = {
  prefix: "far",
  iconName: "digital-tachograph",
  icon: [
    640,
    512,
    [],
    "f566",
    "M608 96H32c-17.67 0-32 14.33-32 32v256c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V128c0-17.67-14.33-32-32-32zm-16 272H48V144h544v224zM96 240h192c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16H96c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16zm-8 104h208c4.42 0 8-3.58 8-8v-8c0-4.42-3.58-8-8-8H88c-4.42 0-8 3.58-8 8v8c0 4.42 3.58 8 8 8zm256 0h208c4.42 0 8-3.58 8-8v-8c0-4.42-3.58-8-8-8H344c-4.42 0-8 3.58-8 8v8c0 4.42 3.58 8 8 8zM96 264c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8H96zm58.67 0c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8h-16zm58.66 0c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8h-16zm58.67 0c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8h-16z"
  ]
};
export const faDiploma = {
  prefix: "far",
  iconName: "diploma",
  icon: [
    640,
    512,
    [],
    "f5ea",
    "M608.64 79.58c-5.62-9.54-17.06-15.56-29.38-15.56-7.35 0 1.98-2.46-134.62 43.56a390.517 390.517 0 0 1-124.65 20.44c-42.38 0-84.48-6.9-124.65-20.44C58.15 61.36 68.05 64.03 60.74 64.03c-12.31 0-23.75 6.01-29.38 15.56-41.81 70.93-41.81 217.94 0 288.87 5.63 9.54 17.06 15.56 29.38 15.56 7.35 0-1.98 2.46 134.62-43.56 7.54-2.54 15.21-4.61 22.88-6.69l-57.4 98.91c-3.05 7.49 2.65 15.63 10.73 15.32l36.64.01 25.21 28.52c5.56 5.87 15.33 4.04 18.39-3.45L320 352.01l68.2 121.06c3.05 7.49 12.83 9.32 18.39 3.45l25.2-28.52 36.64-.01c8.08.31 13.78-7.83 10.73-15.32l-57.4-98.92c7.67 2.07 15.34 4.15 22.89 6.69C581.85 386.67 571.95 384 579.27 384c12.31 0 23.75-6.01 29.38-15.56 41.8-70.92 41.8-217.92-.01-288.86zM180.02 294.96l-113 38.07c-25.49-56.48-25.49-161.56 0-218.04l113 38.07c24.81 8.36 50.23 14.23 75.98 18.03v97.58l-5.15 8.88c-23.99 3.84-47.66 9.61-70.83 17.41zm392.96 38.08l-113-38.07c-23.16-7.8-46.84-13.57-70.82-17.4l-5.15-8.88V171.1c25.74-3.8 51.16-9.67 75.98-18.03l113-38.07c25.47 56.48 25.47 161.56-.01 218.04z"
  ]
};
export const faDirections = {
  prefix: "far",
  iconName: "directions",
  icon: [
    512,
    512,
    [],
    "f5eb",
    "M502.61 233.32L278.68 9.39C272.42 3.13 264.21 0 256 0s-16.42 3.13-22.68 9.39L9.39 233.32c-12.52 12.53-12.52 32.83 0 45.36l223.93 223.93c6.26 6.26 14.47 9.39 22.68 9.39s16.42-3.13 22.68-9.39l223.93-223.93c12.52-12.53 12.52-32.83 0-45.36zM256 457.4L54.6 256 256 54.6 457.4 256 256 457.4zM160 248v80c0 4.42 3.58 8 8 8h32c4.42 0 8-3.58 8-8v-64h80v53.73c0 4.8 3.93 8.02 8.05 8.02 1.87 0 3.78-.66 5.38-2.14l84.21-77.73c3.43-3.17 3.43-8.59 0-11.76l-84.21-77.73c-1.6-1.47-3.51-2.14-5.38-2.14-4.12 0-8.05 3.22-8.05 8.02V216h-96c-17.67 0-32 14.33-32 32z"
  ]
};
export const faDiscDrive = {
  prefix: "far",
  iconName: "disc-drive",
  icon: [
    512,
    512,
    [],
    "f8b5",
    "M256 112a144 144 0 1 0 144 144 144 144 0 0 0-144-144zm0 176a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm240 144h-16V96a64 64 0 0 0-64-64H96a64 64 0 0 0-64 64v336H16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h480a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm-64 0H80V96a16 16 0 0 1 16-16h320a16 16 0 0 1 16 16z"
  ]
};
export const faDisease = {
  prefix: "far",
  iconName: "disease",
  icon: [
    512,
    512,
    [],
    "f7fa",
    "M459.68 179.63l-60.78-20.49c-9.81-3.32-16.94-9.95-19-17.7L365.37 87.5c-6.81-25.46-27.65-45-55.71-52.44-30.88-8.1-63.12.15-84.25 21.62L183.6 99.25c-7 7.16-18.59 11-30.15 10.14l-65.12-5c-33.75-2.54-65.06 13.19-79.93 40.19-12.85 23.38-10.88 50.32 5.37 72.06l34.9 46.8c4.63 6.17 5.32 13.16 2 19.67L25 334c-11.85 23.36-9.25 49.83 6.93 70.85 19.21 24.91 52.9 36.44 86.07 29.35l63.4-13.64c11.32-2.49 23.82-.05 32.38 6.28L263 463.3a87.24 87.24 0 0 0 51.87 16.7 89.76 89.76 0 0 0 37.25-8c25.41-11.6 41.75-33.77 43.75-59.35l4.25-55.24c.56-7.44 6-14.47 14.62-18.8L471 310.25c27.21-13.73 42.87-39.6 40.87-67.54-2.07-28.71-22.07-52.92-52.19-63.08zm-10.35 87.74l-56.21 28.35c-23.72 12-39 33.64-40.87 58L348 408.93c-.88 11.38-11.35 17.33-15.78 19.36-10.25 4.69-27 6.52-40.66-3.56l-49.21-36.47c-14.69-10.85-33.22-16.64-52-16.64a90.73 90.73 0 0 0-19 2l-63.4 13.64c-17 3.73-31.41-3.25-38-11.77-4.87-6.33-5.59-13-2.12-19.83l25.74-50.88c11.44-22.59 9-49.44-6.37-70.07L52.21 187.9c-4.91-6.58-5.5-13.38-1.75-20.18 4.4-8 16.43-16.87 34.18-15.5l65.12 5c25.25 2 51.12-7.1 68.09-24.36l41.81-42.55c8.87-9.08 23.78-12.54 37.78-8.85 11.22 2.94 19.25 9.83 21.56 18.46l14.5 54c6.28 23.29 25 42.24 50.09 50.7l60.77 20.5C456 229 463.3 236.9 464 246.12c.58 8.52-4.76 16.27-14.67 21.25zM160 192a32 32 0 1 0 32 32 32 32 0 0 0-32-32zm128 96a32 32 0 1 0 32 32 32 32 0 0 0-32-31.95zm16-96a16 16 0 1 0 16 16 16 16 0 0 0-16-16z"
  ]
};
export const faDivide = {
  prefix: "far",
  iconName: "divide",
  icon: [
    384,
    512,
    [],
    "f529",
    "M192 160c26.51 0 48-21.49 48-48s-21.49-48-48-48-48 21.49-48 48 21.49 48 48 48zm176 64H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h352c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM192 352c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48z"
  ]
};
export const faDizzy = {
  prefix: "far",
  iconName: "dizzy",
  icon: [
    496,
    512,
    [],
    "f567",
    "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-33.8-217.9c7.8-7.8 7.8-20.5 0-28.3L196.3 192l17.9-17.9c7.8-7.8 7.8-20.5 0-28.3-7.8-7.8-20.5-7.8-28.3 0L168 163.7l-17.8-17.8c-7.8-7.8-20.5-7.8-28.3 0-7.8 7.8-7.8 20.5 0 28.3l17.9 17.9-17.9 17.9c-7.8 7.8-7.8 20.5 0 28.3 7.8 7.8 20.5 7.8 28.3 0l17.8-17.8 17.8 17.8c7.9 7.7 20.5 7.7 28.4-.2zm160-92.2c-7.8-7.8-20.5-7.8-28.3 0L328 163.7l-17.8-17.8c-7.8-7.8-20.5-7.8-28.3 0-7.8 7.8-7.8 20.5 0 28.3l17.9 17.9-17.9 17.9c-7.8 7.8-7.8 20.5 0 28.3 7.8 7.8 20.5 7.8 28.3 0l17.8-17.8 17.8 17.8c7.8 7.8 20.5 7.8 28.3 0 7.8-7.8 7.8-20.5 0-28.3l-17.8-18 17.9-17.9c7.7-7.8 7.7-20.4 0-28.2zM248 272c-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64-28.7-64-64-64z"
  ]
};
export const faDna = {
  prefix: "far",
  iconName: "dna",
  icon: [
    384,
    512,
    [],
    "f471",
    "M0 495.1C-.5 503 5.2 512 15.4 512h15.4c8.1 0 14.7-6.2 15.3-14.4.3-4.5 1-10.5 2.2-17.6h287c1.2 7.1 2.1 13.4 2.5 17.7.7 8.1 7.3 14.3 15.3 14.3h15.5c11.5 0 15.8-10.7 15.3-16.8-2.1-29.5-16.3-126.8-108.5-208.8-12.6 9.3-26.2 18.2-40.9 26.7 9.1 7.5 17 15.2 24.6 23H123.6c20.6-20.9 46.4-41.3 79.3-59.3C359.8 190.5 381.2 56 384 16.9 384.5 9 378.8 0 368.6 0h-15.4c-8.1 0-14.7 6.2-15.3 14.4-.3 4.5-1 10.5-2.2 17.6H48.6c-1.3-7.1-2-13.2-2.4-17.7C45.5 6.2 38.9 0 30.9 0H15.4C5.2 0-.5 9.1 0 16.9c2.6 35.7 21.2 153 147.9 238.9C21.3 341.4 2.6 458.9 0 495.1zM322.4 80c-5.7 15-13.6 31.3-24.2 48H86.3C75.7 111.3 67.8 95 62 80h260.4zM192 228.8c-27.4-16.3-49.4-34.3-67.5-52.8h135.4c-18.2 18.4-40.3 36.4-67.9 52.8zM61.4 432c5.7-14.9 13.5-31.2 24.1-48h211.7c10.6 16.8 18.6 33 24.4 48H61.4z"
  ]
};
export const faDoNotEnter = {
  prefix: "far",
  iconName: "do-not-enter",
  icon: [
    496,
    512,
    [],
    "f5ec",
    "M394.67 192H101.33C93.97 192 88 199.16 88 208v96c0 8.84 5.97 16 13.33 16h293.33c7.36 0 13.33-7.16 13.33-16v-96c.01-8.84-5.96-16-13.32-16zM360 272H136v-32h224v32zM248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 448c-110.28 0-200-89.72-200-200S137.72 56 248 56s200 89.72 200 200-89.72 200-200 200z"
  ]
};
export const faDog = {
  prefix: "far",
  iconName: "dog",
  icon: [
    576,
    512,
    [],
    "f6d3",
    "M576,104v48a88.09,88.09,0,0,1-88,88h-8V480a32,32,0,0,1-32,32H368a32,32,0,0,1-32-32V384H208v96a32,32,0,0,1-32,32H96a32,32,0,0,1-32-32V312a118.82,118.82,0,0,1,7.88-41.63A88,88,0,0,1,0,184a24,24,0,0,1,48,0,40,40,0,0,0,40,40h15.06c21.38-19.69,49.66-32,80.94-32H304V16c0-14.25,17.22-21.39,27.31-11.31L358.59,32l-.12.15c.53,0,1-.15,1.53-.15h76.22a55.65,55.65,0,0,1,50.09,31l.53,1H536A40,40,0,0,1,576,104ZM432,268.73,317.06,240H184a72.09,72.09,0,0,0-72,72V464h48V336H384V464h48ZM528,112H457.16L443.38,84.42A8,8,0,0,0,436.22,80H360a8,8,0,0,0-8,8V199.26l80,20V192h56a40,40,0,0,0,40-40Zm-96,0a16,16,0,1,1-16-16A16,16,0,0,1,432,112Z"
  ]
};
export const faDogLeashed = {
  prefix: "far",
  iconName: "dog-leashed",
  icon: [
    576,
    512,
    [],
    "f6d4",
    "M576,104v48a88.09,88.09,0,0,1-88,88h-8V480a32,32,0,0,1-32,32H368a32,32,0,0,1-32-32V384H208v96a32,32,0,0,1-32,32H96a32,32,0,0,1-32-32V312a118.82,118.82,0,0,1,7.88-41.63A88,88,0,0,1,0,184a24,24,0,0,1,48,0,40,40,0,0,0,40,40h15c21.39-19.68,49.67-32,81-32h55.59L38.42,41.63a16,16,0,0,1-3.23-22.4L44.77,6.42A16,16,0,0,1,67.16,3.19L304,180.22V16c0-14.25,17.23-21.39,27.31-11.31L358.6,32l-.14.16c.53,0,1-.16,1.54-.16h76.22a55.67,55.67,0,0,1,50.09,31l.53,1H536A40,40,0,0,1,576,104ZM280,240H184a72.09,72.09,0,0,0-72,72V464h48V336H280Zm152,28.73-104-26V336h56V464h48ZM528,112H457.16L443.38,84.42A8,8,0,0,0,436.22,80H360a8,8,0,0,0-8,8V199.27l80,20V192h56a40,40,0,0,0,40-40Zm-96,0a16,16,0,1,1-16-16A16,16,0,0,1,432,112Z"
  ]
};
export const faDollarSign = {
  prefix: "far",
  iconName: "dollar-sign",
  icon: [
    288,
    512,
    [],
    "f155",
    "M211.9 242.1L95.6 208.9c-15.8-4.5-28.6-17.2-31.1-33.5C60.6 150 80.3 128 105 128h73.8c15.9 0 31.5 5 44.4 14.1 6.4 4.5 15 3.8 20.5-1.7l22.9-22.9c6.8-6.8 6.1-18.2-1.5-24.1C240.4 74.3 210.4 64 178.8 64H176V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48h-2.5C60.3 64 14.9 95.8 3.1 143.6c-13.9 56.2 20.2 111.2 73 126.3l116.3 33.2c15.8 4.5 28.6 17.2 31.1 33.5C227.4 362 207.7 384 183 384h-73.8c-15.9 0-31.5-5-44.4-14.1-6.4-4.5-15-3.8-20.5 1.7l-22.9 22.9c-6.8 6.8-6.1 18.2 1.5 24.1 24.6 19.1 54.6 29.4 86.3 29.4h2.8v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-48h2.5c49.2 0 94.6-31.8 106.4-79.6 13.9-56.2-20.2-111.2-73-126.3z"
  ]
};
export const faDolly = {
  prefix: "far",
  iconName: "dolly",
  icon: [
    576,
    512,
    [],
    "f472",
    "M575.2 309.9l-5.1-15.2c-2.8-8.4-11.9-12.9-20.2-10.1L531 291 459.1 75.3C455.7 65.2 448.6 57 439 52.2c-9.5-4.7-20.4-5.5-30.5-2.2l-221.9 74L158 38.3C150.4 15.4 129 0 105 0H16C7.2 0 0 7.2 0 16v16c0 8.8 7.2 16 16 16h88.9c3.4 0 6.5 2.2 7.6 5.5l93.6 280.8c-27.6 16.9-46.2 47-46.2 81.7 0 53 43 96 96 96s96-43 96-96c0-4.9-.7-9.5-1.4-14.2L565 330.2c8.4-2.8 13-11.9 10.2-20.3zM256 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm75.6-106.5C314 334.8 286.9 320 256 320c-1.3 0-2.6.3-3.9.4l-50.3-150.8 86.5-28.8 19.9 59.7c2.8 8.4 11.9 12.9 20.2 10.1l15.2-5.1c8.4-2.8 12.9-11.9 10.1-20.2l-19.9-59.7 82.3-27.4 69.4 208.1-153.9 51.2z"
  ]
};
export const faDollyEmpty = {
  prefix: "far",
  iconName: "dolly-empty",
  icon: [
    576,
    512,
    [],
    "f473",
    "M575.2 309.9l-5.1-15.2c-2.8-8.4-11.9-12.9-20.2-10.1l-218.3 72.9C314 334.8 286.9 320 256 320c-1.3 0-2.6.3-3.9.4l-94-282.1C150.4 15.4 129 0 105 0H16C7.2 0 0 7.2 0 16v16c0 8.8 7.2 16 16 16h88.9c3.4 0 6.5 2.2 7.6 5.5l93.6 280.8c-27.6 16.9-46.2 47-46.2 81.7 0 53 43 96 96 96s96-43 96-96c0-4.9-.7-9.5-1.4-14.2L565 330.2c8.4-2.8 13-11.9 10.2-20.3zM256 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"
  ]
};
export const faDollyFlatbed = {
  prefix: "far",
  iconName: "dolly-flatbed",
  icon: [
    640,
    512,
    [],
    "f474",
    "M208 352h384c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16v256c0 8.8 7.2 16 16 16zm32-240h112v112l48-32 48 32V112h112v192H240V112zm384 288H144V16c0-8.8-7.2-16-16-16H16C7.2 0 0 7.2 0 16v16c0 8.8 7.2 16 16 16h80v384c0 8.8 7.2 16 16 16h50.9c-1.8 5-2.9 10.4-2.9 16 0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1.2-11-2.9-16H451c-1.8 5-2.9 10.4-2.9 16 0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1.2-11-2.9-16H624c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16z"
  ]
};
export const faDollyFlatbedAlt = {
  prefix: "far",
  iconName: "dolly-flatbed-alt",
  icon: [
    640,
    512,
    [],
    "f475",
    "M208 352h384c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16h-48V80c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16v256c0 8.8 7.2 16 16 16zm208-240h80v80h-80v-80zm0 128h144v64H416v-64zM240 112h128v192H240V112zm384 288H144V16c0-8.8-7.2-16-16-16H16C7.2 0 0 7.2 0 16v16c0 8.8 7.2 16 16 16h80v384c0 8.8 7.2 16 16 16h50.9c-1.8 5-2.9 10.4-2.9 16 0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1.2-11-2.9-16H451c-1.8 5-2.9 10.4-2.9 16 0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1.2-11-2.9-16H624c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16z"
  ]
};
export const faDollyFlatbedEmpty = {
  prefix: "far",
  iconName: "dolly-flatbed-empty",
  icon: [
    640,
    512,
    [],
    "f476",
    "M624 400H144V16c0-8.8-7.2-16-16-16H16C7.2 0 0 7.2 0 16v16c0 8.8 7.2 16 16 16h80v384c0 8.8 7.2 16 16 16h50.9c-1.8 5-2.9 10.4-2.9 16 0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1.2-11-2.9-16H451c-1.8 5-2.9 10.4-2.9 16 0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1.2-11-2.9-16H624c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16z"
  ]
};
export const faDonate = {
  prefix: "far",
  iconName: "donate",
  icon: [
    512,
    512,
    [],
    "f4b9",
    "M225.6 232.3l50.1 14.3c3.6 1 6.1 4.4 6.1 8.1 0 4.6-3.8 8.4-8.4 8.4h-32.8c-3.6 0-7.1-.8-10.3-2.2-4.8-2.2-10.4-1.7-14.1 2l-17.5 17.5c-5.3 5.3-4.7 14.3 1.5 18.4 9.5 6.3 20.4 10.1 31.8 11.5V328c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-17.6c30.3-3.6 53.4-31 49.3-63-2.9-23-20.7-41.3-42.9-47.7l-50.1-14.3c-3.6-1-6.1-4.4-6.1-8.1 0-4.6 3.8-8.4 8.4-8.4h32.8c3.6 0 7.1.8 10.3 2.2 4.8 2.2 10.4 1.7 14.1-2l17.5-17.5c5.3-5.3 4.7-14.3-1.5-18.4-9.5-6.3-20.4-10.1-31.8-11.5V104c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16v17.6c-30.3 3.6-53.4 31-49.3 63 2.9 23 20.6 41.3 42.9 47.7zM480 320h-34.7c17-30.9 26.7-66.3 26.7-104C472 96.7 375.3 0 256 0S40 96.7 40 216c0 37.7 9.7 73.1 26.7 104H32c-17.7 0-32 17.2-32 38.4v115.2C0 494.8 14.3 512 32 512h448c17.7 0 32-17.2 32-38.4V358.4c0-21.2-14.3-38.4-32-38.4zM256 48c92.6 0 168 75.4 168 168s-75.4 168-168 168S88 308.6 88 216 163.4 48 256 48zm208 416H48v-96h54.6c12.2 12.3 25.9 22.9 40.7 32H104c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h304c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8h-39.3c14.8-9.1 28.5-19.7 40.7-32H464v96z"
  ]
};
export const faDoorClosed = {
  prefix: "far",
  iconName: "door-closed",
  icon: [
    640,
    512,
    [],
    "f52a",
    "M624 464H512V32c0-17.67-14.33-32-32-32H160c-17.67 0-32 14.33-32 32v432H16c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16zm-160 0H176V48h288v416zm-64-176c17.67 0 32-14.33 32-32s-14.33-32-32-32-32 14.33-32 32 14.33 32 32 32z"
  ]
};
export const faDoorOpen = {
  prefix: "far",
  iconName: "door-open",
  icon: [
    640,
    512,
    [],
    "f52b",
    "M288 288c13.25 0 24-14.33 24-32s-10.75-32-24-32-24 14.33-24 32 10.75 32 24 32zm336 176H512V113.45C512 86.19 490.47 64 464 64h-80V33.18C384 14.42 369.21 0 352.06 0c-2.57 0-5.19.32-7.83 1.01l-192 49.74C137.99 54.44 128 67.7 128 82.92V464H16c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16zm-288 0H176V94.18l160-41.45V464zm128 0h-80V112h80v352z"
  ]
};
export const faDotCircle = {
  prefix: "far",
  iconName: "dot-circle",
  icon: [
    512,
    512,
    [],
    "f192",
    "M256 56c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532 89.451-200 200-200m0-48C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 168c-44.183 0-80 35.817-80 80s35.817 80 80 80 80-35.817 80-80-35.817-80-80-80z"
  ]
};
export const faDove = {
  prefix: "far",
  iconName: "dove",
  icon: [
    512,
    512,
    [],
    "f4ba",
    "M368 160.2c0 8.8 7.2 16 16 16s16-7.2 16-16-7.2-16-16-16c-8.9 0-16 7.2-16 16zM384 64c-46.2 0-84.8 32.8-93.9 76.4-29-36.6-49-79.8-56.2-126.5C231.8.6 215-5.1 206 5.5c-25.1 29.6-44.3 65.1-55 105.1-1.6 5.8-2.4 11.7-3.4 17.5-25.4-24.4-46.3-53.5-60.6-86.3-5.5-12.6-23.3-13.1-29.1-.7-16.1 34.1-25.3 72-25.9 112-1.3 96.1 54.8 163.1 95.9 199.4L13.8 391C1.6 394.3-3.9 409.2 3 420.3c19.8 32.3 68.9 87 174.8 91.6 13.5.6 17.6-4.6 25.2-9.4l76.4-54.1H320c88.4 0 160-71.7 160-160.1V159.9L512 64H384zm-186.6 59c2.6-9.7 5.8-19.1 9.6-28.2 15.9 38.4 39.9 72.9 69.3 102.4-30.2-6.8-58.6-18.2-84.1-34.1.4-13.7 1.8-27.2 5.2-40.1zM432 152.1v136.1c0 61.8-50.2 111.7-112 111.7h-55.9l-89.4 63.7c-52.3-3.3-85.9-21.4-107-40.2l154-52C165.9 324.9 78.6 261.1 80 153.7c.1-9 .8-17 1.9-25.7C174.6 249.1 320 256 336 256v-95.8c0-26.6 21.5-48.1 48-48.1h61.4l-13.4 40z"
  ]
};
export const faDownload = {
  prefix: "far",
  iconName: "download",
  icon: [
    576,
    512,
    [],
    "f019",
    "M528 288h-92.1l46.1-46.1c30.1-30.1 8.8-81.9-33.9-81.9h-64V48c0-26.5-21.5-48-48-48h-96c-26.5 0-48 21.5-48 48v112h-64c-42.6 0-64.2 51.7-33.9 81.9l46.1 46.1H48c-26.5 0-48 21.5-48 48v128c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V336c0-26.5-21.5-48-48-48zm-400-80h112V48h96v160h112L288 368 128 208zm400 256H48V336h140.1l65.9 65.9c18.8 18.8 49.1 18.7 67.9 0l65.9-65.9H528v128zm-88-64c0-13.3 10.7-24 24-24s24 10.7 24 24-10.7 24-24 24-24-10.7-24-24z"
  ]
};
export const faDraftingCompass = {
  prefix: "far",
  iconName: "drafting-compass",
  icon: [
    512,
    512,
    [],
    "f568",
    "M450.33 296.36c14.32-13.92 27.51-29.15 38.7-46.11 5.02-7.6 2.23-18.06-5.64-22.62l-13.79-8c-7.39-4.28-16.54-1.77-21.29 5.34-6.52 9.75-13.92 18.7-21.73 27.24l-76.3-141.76c.72-4.75 1.45-9.51 1.45-14.46C351.72 42.98 308.86 0 256 0s-95.72 42.98-95.72 95.99c0 4.95.73 9.71 1.45 14.46L85.46 252.16c-7.85-8.49-15.24-17.44-21.76-27.19-4.75-7.11-13.9-9.63-21.29-5.34l-13.79 8c-7.87 4.56-10.66 15.02-5.64 22.62 11.17 16.92 24.68 31.66 39.06 45.44L0 410.94l7.91 65.75c1.5 12.62 8.63 23.51 19.6 29.89 6.2 3.59 13.06 5.42 19.94 5.42 5.3 0 10.66-1.08 15.74-3.27l61.44-26.33 62.2-115.57c22.37 5.83 45.54 9.13 69.17 9.13 23.65 0 46.91-3.07 69.31-8.87l62.05 115.3 61.48 26.34c5.08 2.17 10.41 3.25 15.7 3.25 6.89 0 13.74-1.83 19.94-5.42 10.97-6.37 18.1-17.26 19.57-29.83l7.95-65.81-61.67-114.56zM256 48c26.43 0 47.86 21.49 47.86 48s-21.43 48-47.86 48-47.86-21.49-47.86-48S229.57 48 256 48zM90.48 444.85l-36.3 15.56-4.83-40.09 138.38-257.15c11.16 11.41 25.27 19.66 40.93 24.37l.15.28L90.48 444.85zM256 327.98c-15.5 0-30.71-1.85-45.58-4.97L256 238.32l45.56 84.65c-14.89 3.03-30.07 5.01-45.56 5.01zm27.18-140.17l.15-.28c15.67-4.71 29.77-12.96 40.93-24.37l65.57 121.85c-13.04 9.27-27.14 16.89-41.8 23.3l-64.85-120.5zm174.64 272.6l-36.3-15.56-50.76-94.31c14.56-6.61 28.6-14.25 41.83-23.24l50.06 93.03-4.83 40.08z"
  ]
};
export const faDragon = {
  prefix: "far",
  iconName: "dragon",
  icon: [
    640,
    512,
    [],
    "f6d5",
    "M481.12 119.98c14.92.85 27.36-9.89 30.88-24.59l-58.43-15.37c-6.5 27.13 15.51 39.27 27.55 39.96zm82.55 136.9l-94.19-44.21a9.876 9.876 0 0 1-4.6-4.69h18.68c4.9 3.12 8.91 5.72 12.25 7.89 16.52 10.73 24.81 16.12 42.65 16.12h27.87c23.03 0 43.8-12.59 54.22-32.85l12.88-25.04c10.49-20.39 8.19-45.32-5.84-63.51L560.5 23.65C549.07 8.84 530.99 0 512.12 0h-213.7c-37.28 0-52.93 46.77-24.99 69.01l12.52 9.94c-4.44 1.8-3.56 1.43-4.75 2.01-29.37 14.28-29.24 55.87.01 70.08L320 166.01v12.95l-167.69-41.84c-22.03-5.48-45.5 3.28-58.53 21.77L5.03 285.13c-14.39 22.6 4.05 52.39 33.06 48.25l91.52-17.21c-14.71 23.28 5.27 52.03 31.82 48.36l180.76-24.23c4.91 10.23 10.58 19.99 17.01 29.17-147.08 10.08-247.2 32.47-321.46 48.52C15.88 422.71 0 442.24 0 464.42c0 26.21 21.52 47.54 47.98 47.54l449.17.04c76.07.01 138.73-55.84 142.65-127.15 2.96-53.81-26.93-104.04-76.13-127.97zM68.03 278.95l65-92.44c1.66-2.38 4.59-3.66 7.69-2.81l69.82 17.33-41.4 58.87-101.11 19.05zm123.03 33.18l69.38-98.67L320 228.47c0 21.25.13 36.77 6.72 65.48l-135.66 18.18zM497.15 464l-449.26.9c92.02-19.88 196.84-43.56 383.18-51.02 16.58-.67 23.38-21.76 9.29-31.79C367.78 330.38 368 258.74 368 239.03V132.98l-45.11-17.22 57.34-23.24L324.16 48h188.22c3.96 0 7.7 1.84 10.12 4.97l67.13 87.01c2.7 3.5 3.13 8.23 1.11 12.16l-12.88 25.04c-2.12 4.13-6.65 6.79-11.53 6.79h-27.87c-3.61 0-3.61 0-16.5-8.37-5.12-3.33-24.56-15.64-24.56-15.64H416v44.11c0 22.19 12.6 42.09 33.08 52.04l93.59 43.92c32.27 15.69 51.12 47.18 49.2 82.16-2.48 45.13-44.97 81.82-94.72 81.81z"
  ]
};
export const faDrawCircle = {
  prefix: "far",
  iconName: "draw-circle",
  icon: [
    512,
    512,
    [],
    "f5ed",
    "M512 256c0-30.3-21.11-55.54-49.39-62.17-20.85-69.11-75.33-123.6-144.44-144.45C311.54 21.11 286.3 0 256 0s-55.54 21.11-62.17 49.39c-69.11 20.85-123.6 75.33-144.44 144.45C21.12 200.46 0 225.7 0 256c0 30.3 21.12 55.54 49.39 62.17 20.85 69.11 75.33 123.6 144.44 144.45C200.46 490.89 225.7 512 256 512s55.54-21.11 62.17-49.39c69.11-20.85 123.6-75.33 144.44-144.45C490.89 311.54 512 286.3 512 256zm-64 16c-8.82 0-16-7.18-16-16s7.18-16 16-16 16 7.18 16 16-7.18 16-16 16zM256 48c8.82 0 16 7.18 16 16s-7.18 16-16 16-16-7.18-16-16 7.18-16 16-16zM64 240c8.82 0 16 7.18 16 16s-7.18 16-16 16-16-7.18-16-16 7.18-16 16-16zm192 224c-8.82 0-16-7.18-16-16s7.18-16 16-16 16 7.18 16 16-7.18 16-16 16zm53.89-50.28C298.53 395.9 278.71 384 256 384c-22.7 0-42.53 11.9-53.89 29.72A166.552 166.552 0 0 1 98.28 309.89C116.1 298.53 128 278.7 128 256c0-22.71-11.9-42.53-29.72-53.89A166.567 166.567 0 0 1 202.12 98.28C213.47 116.1 233.3 128 256 128c22.71 0 42.53-11.9 53.89-29.72a166.614 166.614 0 0 1 103.84 103.83C395.9 213.47 384 233.29 384 256c0 22.7 11.9 42.53 29.72 53.89a166.529 166.529 0 0 1-103.83 103.83z"
  ]
};
export const faDrawPolygon = {
  prefix: "far",
  iconName: "draw-polygon",
  icon: [
    448,
    512,
    [],
    "f5ee",
    "M384 352c-3.36 0-6.59.49-9.81.99l-35.21-58.68C347.05 283.6 352 270.43 352 256s-4.95-27.6-13.01-38.31l35.21-58.68c3.22.5 6.45.99 9.81.99 35.35 0 64-28.65 64-64s-28.65-64-64-64c-26.84 0-49.75 16.56-59.25 40H123.25c-9.5-23.44-32.4-40-59.25-40C28.65 32 0 60.65 0 96c0 26.84 16.56 49.75 40 59.25v201.49C16.56 366.25 0 389.15 0 416c0 35.35 28.65 64 64 64 26.85 0 49.75-16.56 59.25-40h201.49c9.5 23.44 32.41 40 59.25 40 35.35 0 64-28.65 64-64 .01-35.35-28.64-64-63.99-64zm-296 4.75v-201.5A64.053 64.053 0 0 0 123.25 120h201.49c2.1 5.19 4.96 9.92 8.28 14.32l-35.21 58.67c-3.22-.5-6.45-.99-9.82-.99-35.35 0-64 28.65-64 64s28.65 64 64 64c3.36 0 6.59-.49 9.82-.99l35.21 58.67c-3.32 4.4-6.18 9.14-8.28 14.32H123.25A64.053 64.053 0 0 0 88 356.75zM288 240c8.82 0 16 7.18 16 16s-7.18 16-16 16-16-7.18-16-16 7.18-16 16-16zm96-160c8.82 0 16 7.18 16 16s-7.18 16-16 16-16-7.18-16-16 7.18-16 16-16zM64 80c8.82 0 16 7.18 16 16s-7.18 16-16 16-16-7.18-16-16 7.18-16 16-16zm0 352c-8.82 0-16-7.18-16-16s7.18-16 16-16 16 7.18 16 16-7.18 16-16 16zm320 0c-8.82 0-16-7.18-16-16s7.18-16 16-16 16 7.18 16 16-7.18 16-16 16z"
  ]
};
export const faDrawSquare = {
  prefix: "far",
  iconName: "draw-square",
  icon: [
    448,
    512,
    [],
    "f5ef",
    "M408 356.75v-201.5c23.44-9.5 40-32.41 40-59.25 0-35.35-28.65-64-64-64-26.84 0-49.75 16.56-59.25 40h-201.5c-9.5-23.44-32.4-40-59.25-40C28.65 32 0 60.65 0 96c0 26.84 16.56 49.75 40 59.25v201.49C16.56 366.25 0 389.15 0 416c0 35.35 28.65 64 64 64 26.85 0 49.75-16.56 59.25-40h201.49c9.5 23.44 32.41 40 59.25 40 35.35 0 64-28.65 64-64 .01-26.85-16.55-49.75-39.99-59.25zm-320 0v-201.5A64.053 64.053 0 0 0 123.25 120h201.49a64.053 64.053 0 0 0 35.25 35.25v201.49a64.053 64.053 0 0 0-35.25 35.25H123.25A64.066 64.066 0 0 0 88 356.75zM384 80c8.82 0 16 7.18 16 16s-7.18 16-16 16-16-7.18-16-16 7.18-16 16-16zM64 80c8.82 0 16 7.18 16 16s-7.18 16-16 16-16-7.18-16-16 7.18-16 16-16zm0 352c-8.82 0-16-7.18-16-16s7.18-16 16-16 16 7.18 16 16-7.18 16-16 16zm320 0c-8.82 0-16-7.18-16-16s7.18-16 16-16 16 7.18 16 16-7.18 16-16 16z"
  ]
};
export const faDreidel = {
  prefix: "far",
  iconName: "dreidel",
  icon: [
    448,
    512,
    [],
    "f792",
    "M443.3 48L432 36.7c-6.2-6.2-16.4-6.2-22.6 0L294.7 151.4l-77.6-77.6c-6.5-6.5-15.1-9.8-23.6-9.8-8.6 0-17.1 3.3-23.6 9.8L19.6 224C7 236.5 0 253.5 0 271.3v141.8c0 37 29.9 66.9 66.9 66.9h141.8c17.7 0 34.7-7 47.3-19.6l150.2-150.2c13.1-13.1 13.1-34.2 0-47.3l-77.6-77.6L443.3 70.6c6.3-6.2 6.3-16.4 0-22.6zM222.1 426.5c-3.6 3.6-8.3 5.5-13.3 5.5H66.9c-10.4 0-18.9-8.5-18.9-18.9V271.3c0-5 2-9.8 5.5-13.3l53.2-53.2 168.5 168.5-53.1 53.2zm87.1-87.2L140.7 170.8l52.7-52.7L362 286.6l-52.8 52.7z"
  ]
};
export const faDrone = {
  prefix: "far",
  iconName: "drone",
  icon: [
    512,
    512,
    [],
    "f85f",
    "M339.41 92.33a63.82 63.82 0 1 1 80.26 80.26l-35.93 49.77A110.32 110.32 0 0 0 400 224a112 112 0 1 0-112-112 110.32 110.32 0 0 0 1.64 16.26zM111 368.2a31.91 31.91 0 1 0 32.8 32.8l67.86-49h88.68l67.86 49a31.91 31.91 0 1 0 32.8-32.8l-49-67.86v-88.68l49-67.86a31.91 31.91 0 1 0-32.8-32.8l-67.86 49h-88.68l-67.86-49a31.91 31.91 0 1 0-32.8 32.8l49 67.86v88.68zM208 208h96v96h-96zm192 80a110.45 110.45 0 0 0-16.26 1.64l35.93 49.77a63.82 63.82 0 1 1-80.26 80.25l-49.77-35.92A110.32 110.32 0 0 0 288 400a112 112 0 1 0 112-112zm-288-64a110.32 110.32 0 0 0 16.26-1.64l-35.92-49.77a63.82 63.82 0 1 1 80.25-80.26l49.77 35.93A110.45 110.45 0 0 0 224 112a112 112 0 1 0-112 112zm60.59 195.67a63.82 63.82 0 1 1-80.26-80.26l35.93-49.77A110.32 110.32 0 0 0 112 288a112 112 0 1 0 112 112 110.32 110.32 0 0 0-1.64-16.26z"
  ]
};
export const faDroneAlt = {
  prefix: "far",
  iconName: "drone-alt",
  icon: [
    640,
    512,
    [],
    "f860",
    "M287.94 136a24 24 0 0 0-24-24h-97.6a23.65 23.65 0 0 0-44.76 0H24a24 24 0 0 0 0 48h240a24 24 0 0 0 23.94-24zm184 101.65l-96.85-29.05a191.87 191.87 0 0 0-110.32 0L168 237.65V192h-48v64.05a32 32 0 0 0 32 32h45.44a178.39 178.39 0 0 0-53.36 110.24 16.13 16.13 0 0 0 16 17.71h16.25c8.34 0 14.76-6.58 15.68-14.87a130.07 130.07 0 0 1 41.87-81.89L251 336.38A53.34 53.34 0 0 0 288.7 352h62.47a53.32 53.32 0 0 0 37.7-15.62L406 319.24a130.07 130.07 0 0 1 41.87 81.89c.92 8.29 7.34 14.85 15.67 14.87h16.26a16.14 16.14 0 0 0 16-17.71 178.49 178.49 0 0 0-53.36-110.24h45.46a32 32 0 0 0 32-32V192h-48zm-117 64.79a5.38 5.38 0 0 1-3.77 1.56H288.7a5.36 5.36 0 0 1-3.77-1.56l-38.28-38.29 31.91-9.57a143.9 143.9 0 0 1 82.74 0l31.92 9.58zm261.45-190.37l-97.9.31a23.57 23.57 0 0 0-44.94.15l-98 .31a23.55 23.55 0 0 0 .15 47.09l240.86-.77a23.55 23.55 0 0 0-.15-47.09z"
  ]
};
export const faDrum = {
  prefix: "far",
  iconName: "drum",
  icon: [
    512,
    512,
    [],
    "f569",
    "M431.67 121.83l73.2-47.2a16 16 0 0 0 4.44-22.19l-8.87-13.31a16 16 0 0 0-22.19-4.44l-109.8 70.81C319.94 97 273.56 96 256 96 213.25 96 0 101.4 0 208v160c0 61.86 114.62 112 256 112s256-50.14 256-112V208c0-43.4-35.52-69.85-80.33-86.17zM88 400.21C62 387.88 48 375.08 48 368v-88.56A216.21 216.21 0 0 0 88 297zM232 431c-37.53-1.64-69.81-6.57-96-13.54V309.2c36.05 6.87 71.63 9.43 96 10.33zm144-13.54c-26.19 7-58.47 11.9-96 13.54V319.53c24.37-.9 59.95-3.46 96-10.33zM464 368c0 7.08-14 19.88-40 32.21V297a216.21 216.21 0 0 0 40-17.54zm-208-96c-114.88 0-208-28.65-208-64s93.12-64 208-64c17.19 0 33.8.71 49.78 1.92l-72.91 47a16 16 0 0 0-4.43 22.19l8.87 13.31a16 16 0 0 0 22.19 4.44l118.74-76.56C430.13 167.93 464 186.73 464 208c0 35.35-93.13 64-208 64z"
  ]
};
export const faDrumSteelpan = {
  prefix: "far",
  iconName: "drum-steelpan",
  icon: [
    576,
    512,
    [],
    "f56a",
    "M288 32C128.94 32 0 89.31 0 160v192c0 70.69 128.94 128 288 128s288-57.31 288-128V160c0-70.69-128.94-128-288-128zm0 48c24.31 0 47.75 1.23 69.87 3.47l-11.5 44.71C341.86 145.73 315.67 160 288 160c-27.67 0-53.86-14.27-58.37-31.82l-11.5-44.71C240.25 81.23 263.69 80 288 80zm-58.38 95.55C245.95 185.92 266.66 192 288 192c21.02 0 41.47-5.87 57.68-15.95 2.82 21.76 11.49 41.94 24.64 59.01C344.61 238.2 316.97 240 288 240c-29.32 0-57.28-1.84-83.25-5.05 13.11-17.29 21.97-37.61 24.87-59.4zm-55.11-86.04l13.02 46.08c9.82 34.77-3.37 70.58-30.33 91.44C91.51 212.75 48 188.09 48 160c0-30.5 51.21-56.99 126.51-70.49zM528 352c0 27.47-93.46 80-240 80-146.54 0-240-52.53-240-80V230.7C99.59 265.22 187.77 288 288 288s188.41-22.78 240-57.3V352zM418.16 227.15c-8.38-6.16-15.65-13.85-21.32-22.94-11.73-18.82-15.42-41.09-10.4-62.7l12.19-52.46C475.46 102.39 528 129.13 528 160c0 28.18-43.8 52.9-109.84 67.15z"
  ]
};
export const faDrumstick = {
  prefix: "far",
  iconName: "drumstick",
  icon: [
    512,
    512,
    [],
    "f6d6",
    "M471.06 57.65A169.92 169.92 0 0 0 348.12.07a172.16 172.16 0 0 0-126.19 49.72C195.34 76.21 160 119.46 160 189.81v60.42L116.3 294c-1.93 1.88-5.75 1-7.75.17A79.19 79.19 0 0 0 23.22 423.7a76.41 76.41 0 0 0 43.57 21.59 76.39 76.39 0 0 0 21.57 43.55 79.19 79.19 0 0 0 129.58-85.33c-1-2.5-1.56-6 .16-7.75L261.84 352H323c38.72 0 72.75-10.17 104-31.08 46.22-30.88 76.69-79.36 83.56-133 6.22-48.32-7.81-94.58-39.5-130.27zM173.37 421.34A31.07 31.07 0 0 1 144.43 464c-12 0-27.64-7.82-30.11-25.39l-5-35.8-35.81-5.05C56 395.28 48 379.69 48 367.65a31.13 31.13 0 0 1 42.5-29 60.4 60.4 0 0 0 22.5 4.42 52.8 52.8 0 0 0 37.27-15.17l20.43-20.45a84.92 84.92 0 0 0 34 33.87l-20.49 20.5c-15.3 15.24-19.43 38.05-10.84 59.52zM400.31 281c-23.13 15.47-48.44 23-77.34 23h-77.81A37 37 0 0 1 208 267.2v-77.39c0-41 14.28-72.7 47.78-106 57.69-57.39 139.86-38.82 179.4 5.7 61.93 69.83 14.31 158.66-34.87 191.49z"
  ]
};
export const faDrumstickBite = {
  prefix: "far",
  iconName: "drumstick-bite",
  icon: [
    512,
    512,
    [],
    "f6d7",
    "M471.15 57.65A170 170 0 0 0 348.19.07 172.2 172.2 0 0 0 222 49.79c-26.62 26.42-62 69.67-62 140.01v60.42L116.3 294c-1.93 1.88-5.75 1-7.75.17A79.19 79.19 0 0 0 23.22 423.7a76.41 76.41 0 0 0 43.57 21.59 76.39 76.39 0 0 0 21.57 43.55 79.19 79.19 0 0 0 129.58-85.33c-1-2.5-1.56-6 .16-7.75L261.89 352H323a189.07 189.07 0 0 0 50.76-6.94A24 24 0 0 0 388.29 310c-19.38-33.91-14.6-75.9 11.63-102.15 21-21 51.48-28.58 81.7-20.23A24 24 0 0 0 512 164.24c-.38-40.09-14.5-76.95-40.85-106.59zM173.37 421.34A31.07 31.07 0 0 1 144.43 464c-12 0-27.64-7.82-30.11-25.38l-5-35.81-35.81-5.05C56 395.28 48 379.7 48 367.65a31.13 31.13 0 0 1 42.5-29 60.4 60.4 0 0 0 22.5 4.42 52.77 52.77 0 0 0 37.28-15.17l20.46-20.47a85 85 0 0 0 34 33.87c-21.21 21.15-18.74 18.7-20.59 20.52-15.23 15.24-19.36 38.05-10.78 59.52zM366 173.92c-33.85 33.86-45.38 83.82-32.16 129.66-3.59.27-7.16.41-10.78.41H245.2A37 37 0 0 1 208 267.2v-77.4c0-41 14.29-72.7 47.79-106 57.7-57.39 139.9-38.81 179.44 5.7a112.62 112.62 0 0 1 25.07 46.91 128.69 128.69 0 0 0-94.3 37.51z"
  ]
};
export const faDryer = {
  prefix: "far",
  iconName: "dryer",
  icon: [
    448,
    512,
    [],
    "f861",
    "M384 0H64A64 64 0 0 0 0 64v416a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32V64a64 64 0 0 0-64-64zm16 464H48V64a16 16 0 0 1 16-16h320a16 16 0 0 1 16 16zM128 104a24 24 0 1 0-24 24 24 24 0 0 0 24-24zm56 24a24 24 0 1 0-24-24 24 24 0 0 0 24 24zm40 32a136 136 0 1 0 136 136 136 136 0 0 0-136-136zm-25.5 179.93c6.59 6.17 15.25 14.28 17.71 28.13a6.94 6.94 0 0 1-7.07 7.94h-14.5a7.05 7.05 0 0 1-6.83-5.06c-1.21-4.29-4.25-7.3-9.42-12.15-7.77-7.27-18.39-17.23-18.39-36.07s10.62-28.83 18.39-36.11c7-6.54 10.06-9.75 10.06-17.25s-3.09-10.72-10.06-17.25c-6.6-6.19-15.26-14.3-17.71-28.17a6.94 6.94 0 0 1 7.06-7.94h14.51a7 7 0 0 1 6.82 5.07c1.22 4.3 4.25 7.33 9.43 12.18 7.76 7.28 18.39 17.24 18.39 36.11s-10.63 28.83-18.39 36.1c-7 6.54-10.05 9.76-10.05 17.26s3.08 10.67 10.05 17.21zm71.11 0c6.59 6.17 15.25 14.28 17.71 28.13a6.94 6.94 0 0 1-7.06 7.94h-14.51a7 7 0 0 1-6.82-5.06c-1.22-4.29-4.26-7.3-9.43-12.15-7.76-7.27-18.39-17.23-18.39-36.07s10.63-28.83 18.39-36.11c7-6.54 10.05-9.75 10.05-17.25s-3.08-10.72-10.05-17.25c-6.59-6.19-15.25-14.3-17.71-28.17a6.94 6.94 0 0 1 7.06-7.94h14.51a7 7 0 0 1 6.82 5.07c1.22 4.3 4.25 7.33 9.43 12.18 7.77 7.28 18.39 17.24 18.39 36.11s-10.62 28.83-18.39 36.1c-7 6.54-10.06 9.76-10.06 17.26s3.09 10.67 10.06 17.21z"
  ]
};
export const faDryerAlt = {
  prefix: "far",
  iconName: "dryer-alt",
  icon: [
    448,
    512,
    [],
    "f862",
    "M224 160a136 136 0 1 0 136 136 136 136 0 0 0-136-136zm0 224c-40.15 0-73.73-27.18-84.25-64H176a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16h-36.25c10.52-36.82 44.1-64 84.25-64a88 88 0 0 1 0 176zm-96-280a24 24 0 1 0-24 24 24 24 0 0 0 24-24zm56 24a24 24 0 1 0-24-24 24 24 0 0 0 24 24zM384 0H64A64 64 0 0 0 0 64v416a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32V64a64 64 0 0 0-64-64zm16 464H48V64a16 16 0 0 1 16-16h320a16 16 0 0 1 16 16z"
  ]
};
export const faDuck = {
  prefix: "far",
  iconName: "duck",
  icon: [
    576,
    512,
    [],
    "f6d8",
    "M416 144c0-8.84-7.16-16-16-16s-16 7.16-16 16 7.16 16 16 16 16-7.16 16-16zm48 96c61.86 0 112-50.14 112-112h-65.57c-.46-3.32-.6-6.58-1.36-9.95-9.15-40.61-41.97-73.7-82.54-83-9-2.07-17.88-3.05-26.53-3.05-61.86 0-112 50.14-112 112v80h-54.23c-39 0-78.18-13.76-104.79-42.28-3.96-4.25-8.94-6.14-13.82-6.14-9.78 0-19.16 7.59-19.16 19.06 0 94.71 72.21 178.39 164.58 188.02 9.47.99 17.77-6.49 17.77-16.01v-16.09c0-8.02-5.94-14.86-13.9-15.77-45.77-5.2-85.53-35.7-105.91-77.49 23.38 9.37 48.83 14.27 75.24 14.27L336 272V144c0-35.29 28.71-64 64-64 5.19 0 10.5.62 15.79 1.83 22.66 5.2 41.32 23.99 46.46 46.77 7.9 35.06-11.85 61.87-34.92 72.89L400 214.54v71.63l11.86 13.57c8.89 10.18 19.61 27.21 20.12 50.54.43 19.57-7.61 38.82-22.64 54.19-17.12 17.5-40.59 27.54-64.39 27.54h-91.17c-6.03 0-12.1-.31-18.66-.97-88.83-7.9-163.37-73.51-183.76-159.04h29.28a190.546 190.546 0 0 1-14.15-48H32.25C12.96 224-2.39 241.03.31 260.13 16.82 376.94 112.22 468.3 230.87 478.84c7.53.77 15.18 1.16 22.91 1.16h91.17c71.96 0 136.61-58.84 135.02-130.78-.69-31.13-12.86-59.21-31.97-81.07V240h16z"
  ]
};
export const faDumbbell = {
  prefix: "far",
  iconName: "dumbbell",
  icon: [
    640,
    512,
    [],
    "f44b",
    "M632 224h-24v-72c0-30.9-25.1-56-56-56h-32c-2.7 0-5.4.4-8 .8V88c0-30.9-25.1-56-56-56h-32c-30.9 0-56 25.1-56 56v136h-96V88c0-30.9-25.1-56-56-56h-32c-30.9 0-56 25.1-56 56v8.8c-2.6-.4-5.3-.8-8-.8H88c-30.9 0-56 25.1-56 56v72H8c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h24v72c0 30.9 25.1 56 56 56h32c2.7 0 5.4-.4 8-.8v8.8c0 30.9 25.1 56 56 56h32c30.9 0 56-25.1 56-56V288h96v136c0 30.9 25.1 56 56 56h32c30.9 0 56-25.1 56-56v-8.8c2.6.4 5.3.8 8 .8h32c30.9 0 56-25.1 56-56v-72h24c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM120 368H88c-4.4 0-8-3.6-8-8V152c0-4.4 3.6-8 8-8h32c4.4 0 8 3.6 8 8v208c0 4.4-3.6 8-8 8zm104 56c0 4.4-3.6 8-8 8h-32c-4.4 0-8-3.6-8-8V88c0-4.4 3.6-8 8-8h32c4.4 0 8 3.6 8 8v336zm240 0c0 4.4-3.6 8-8 8h-32c-4.4 0-8-3.6-8-8V88c0-4.4 3.6-8 8-8h32c4.4 0 8 3.6 8 8v336zm96-64c0 4.4-3.6 8-8 8h-32c-4.4 0-8-3.6-8-8V152c0-4.4 3.6-8 8-8h32c4.4 0 8 3.6 8 8v208z"
  ]
};
export const faDumpster = {
  prefix: "far",
  iconName: "dumpster",
  icon: [
    576,
    512,
    [],
    "f793",
    "M560 160c10.4 0 18-9.8 15.5-19.9l-24-96C549.7 37 543.3 32 536 32h-98.9l25.6 128H560zM404.5 32H304v128h126.1L404.5 32zM560 224h-20l4-32H32l4 32H16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h26l22 176v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h320v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16l22-176h26c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zm-90.4 176H106.4l-20-160h403.3l-20.1 160zM16 160h97.3l25.6-128H40c-7.3 0-13.7 5-15.5 12.1l-24 96C-2 150.2 5.6 160 16 160zM272 32H171.5l-25.6 128H272V32z"
  ]
};
export const faDumpsterFire = {
  prefix: "far",
  iconName: "dumpster-fire",
  icon: [
    640,
    512,
    [],
    "f794",
    "M418.7 104.1l.2-.2-14.4-72H304v128h60.8c16.2-19.3 34.2-38.2 53.9-55.8zm42.6 0c18.2 16.3 35.5 33.7 51.1 51.5 5.7-5.6 11.4-11.1 17.3-16.3l21.3-19 21.3 19c1.1.9 2.1 2.1 3.1 3.1-.1-.8.2-1.5 0-2.3l-24-96C549.7 37 543.3 32 536 32h-98.9l12.3 61.5 11.9 10.6zM272 32H171.5l-25.6 128H272V32zM106.4 400l-20-160h225.3c7.9-15.7 17.6-31.9 28.9-48H32l4 32H16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h26l22 176v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h208.8c-12.8-14.3-23.5-30.4-31.6-48H106.4zM16 160h97.3l25.6-128H40c-7.3 0-13.7 5-15.5 12.1l-24 96C-2 150.2 5.6 160 16 160zm535.1 3.2c-14.9 13.3-28.3 27.2-40.2 41.2-19.5-25.8-43.6-52-71-76.4-70.2 62.7-120 144.3-120 193.6 0 87.5 71.6 158.4 160 158.4s160-70.9 160-158.4c.1-36.6-37-112.2-88.8-158.4zM480 432c-61.8 0-112-49.5-112-110.4 0-22.6 24.9-74.7 72.2-126.4 22.4 23.7 30.5 35.7 68.5 86.1 40.6-47.8 39.1-46.1 41.1-48.4 26.4 35.3 42.2 74 42.2 88.8 0 60.8-50.2 110.3-112 110.3z"
  ]
};
export const faDungeon = {
  prefix: "far",
  iconName: "dungeon",
  icon: [
    512,
    512,
    [],
    "f6d9",
    "M512 295.43c0-8.47-1.91-16.51-5.33-23.7 3.66-7.9 5.48-16.63 5.14-25.42-1.32-35.2-9.77-69.19-25.09-101-4.32-8.97-10.97-16.45-19.02-21.85-1.4-9.57-5.29-18.7-11.41-26.4-21.33-26.84-47.35-48.81-77.33-65.3a55.498 55.498 0 0 0-26.64-6.84c-.44 0-.88 0-1.31.02-6.72-7.04-15.24-12.27-24.74-15C303.32 3.35 279.67 0 256 0s-47.32 3.35-70.29 9.95c-9.49 2.72-18 7.95-24.72 14.99-.44-.01-.88-.02-1.31-.02-9.29 0-18.49 2.36-26.62 6.83-29.99 16.5-56.01 38.47-77.35 65.32a55.208 55.208 0 0 0-11.41 26.39c-8.05 5.39-14.7 12.87-19.02 21.84C9.95 177.12 1.51 211.1.18 246.32c-.33 8.77 1.48 17.5 5.14 25.4A55.223 55.223 0 0 0 0 295.43v57.14c0 8.37 1.86 16.31 5.2 23.43-3.34 7.12-5.2 15.06-5.2 23.43v57.14C0 487.13 24.87 512 55.43 512h401.14c30.56 0 55.43-24.87 55.43-55.43v-57.14c0-8.37-1.86-16.31-5.2-23.43 3.33-7.12 5.2-15.06 5.2-23.43v-57.14zM112 456.57c0 4.1-3.33 7.43-7.43 7.43H55.43c-4.1 0-7.43-3.33-7.43-7.43v-57.14c0-4.1 3.33-7.43 7.43-7.43h49.14c4.1 0 7.43 3.33 7.43 7.43v57.14zm0-104c0 4.1-3.33 7.43-7.43 7.43H55.43c-4.1 0-7.43-3.33-7.43-7.43v-57.14c0-4.1 3.33-7.43 7.43-7.43h49.14c4.1 0 7.43 3.33 7.43 7.43v57.14zm21.22-148.4c-5.98 13.92-9.85 28.93-10.74 44.79-.22 3.92-3.26 7.04-7.19 7.04H55.81c-4.25 0-7.82-3.62-7.66-7.86 1.1-29.28 8.33-57 20.37-81.99 1.29-2.67 4.01-4.17 6.8-4.17 1.39 0 2.8.37 4.05 1.15l51.11 31.94c3.09 1.93 4.18 5.75 2.74 9.1zm16.94-33.11c-1.3 0-2.6-.35-3.79-1.09L95.3 138.05c-3.78-2.36-4.79-7.62-2.02-11.11 17.19-21.62 38.54-39.72 62.89-53.12a7.23 7.23 0 0 1 3.5-.89c3.03 0 5.99 1.85 7.17 4.86l22.1 56.24c1.31 3.33-.03 7-3.07 8.89a133.5 133.5 0 0 0-30.09 25.55c-1.47 1.68-3.53 2.59-5.62 2.59zM208 456c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8V203.13c8.16-12.3 19.22-22.32 32-29.78V456zm64 0c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8V161.62c5.23-.89 10.52-1.62 16-1.62s10.77.73 16 1.62V456zm16.88-329.27c-.64 0-1.3-.08-1.94-.24-10.99-2.81-20.99-4.2-30.95-4.2-10.02 0-20 1.41-30.92 4.2-.65.17-1.3.25-1.95.25-2.98 0-5.79-1.7-6.91-4.56l-22.04-56.09c-1.6-4.08.59-8.79 4.8-10C217.1 50.87 236.21 48 256 48s38.9 2.87 57.03 8.08c4.21 1.21 6.4 5.92 4.8 10l-22.04 56.1c-1.12 2.86-3.93 4.55-6.91 4.55zM336 456c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8V173.36c12.78 7.46 23.84 17.47 32 29.78V456zm25.84-284.94c-2.08 0-4.14-.91-5.62-2.6a133.758 133.758 0 0 0-30.09-25.55c-3.04-1.89-4.38-5.56-3.07-8.89l22.1-56.24c1.18-3.01 4.13-4.86 7.17-4.86 1.19 0 2.39.28 3.5.89a208.882 208.882 0 0 1 62.89 53.12c2.77 3.49 1.76 8.75-2.02 11.11l-51.07 31.92c-1.19.75-2.5 1.1-3.79 1.1zm27.68 77.9c-.89-15.85-4.76-30.87-10.74-44.79-1.44-3.35-.35-7.17 2.74-9.1l51.11-31.94a7.639 7.639 0 0 1 4.05-1.15c2.79 0 5.51 1.5 6.8 4.17 12.04 24.99 19.27 52.71 20.37 81.99.16 4.24-3.41 7.86-7.66 7.86H396.7c-3.92 0-6.96-3.12-7.18-7.04zM464 456.57c0 4.1-3.33 7.43-7.43 7.43h-49.14c-4.1 0-7.43-3.33-7.43-7.43v-57.14c0-4.1 3.33-7.43 7.43-7.43h49.14c4.1 0 7.43 3.33 7.43 7.43v57.14zm0-104c0 4.1-3.33 7.43-7.43 7.43h-49.14c-4.1 0-7.43-3.33-7.43-7.43v-57.14c0-4.1 3.33-7.43 7.43-7.43h49.14c4.1 0 7.43 3.33 7.43 7.43v57.14z"
  ]
};
export const faEar = {
  prefix: "far",
  iconName: "ear",
  icon: [
    384,
    512,
    [],
    "f5f0",
    "M192 92c-55.12 0-100 44.86-100 100 0 37.5 30.5 68 68 68 15.44 0 28 12.56 28 28s-12.56 28-28 28h-20c-6.62 0-12 5.39-12 12v16c0 6.61 5.38 12 12 12h20c37.5 0 68-30.5 68-68s-30.5-68-68-68c-15.44 0-28-12.56-28-28 0-33.08 26.91-60 60-60s60 26.92 60 60v20c0 6.61 5.38 12 12 12h16c6.62 0 12-5.39 12-12v-20c0-55.14-44.88-100-100-100zm0-92C85.96 0 0 85.96 0 192v176c0 79.53 64.47 144 144 144s144-64.47 144-144v-9.9c57.33-33.21 96-95.08 96-166.1C384 85.96 298.04 0 192 0zm71.94 316.57L240 330.44v37.57c0 52.93-43.06 96-96 96s-96-43.07-96-96V192c0-79.4 64.6-144 144-144s144 64.6 144 144c0 51.09-27.61 98.82-72.06 124.57z"
  ]
};
export const faEarMuffs = {
  prefix: "far",
  iconName: "ear-muffs",
  icon: [
    640,
    512,
    [],
    "f795",
    "M621.4 305.2c-6.3-39.7-43.5-50-44.4-50.2-13.8-18.4-32.2-22.3-33.1-22.6V224C544 100.5 443.5.1 320 0 196.5.1 96 100.5 96 224v8.4c-.9.3-19.2 4.2-33.1 22.6-.9.3-38 10.5-44.4 50.2-15 15-23.5 38.8-15.3 63.2-7.8 24.2.5 48 15.7 63 5.2 30.3 28.2 45 44.9 50.1.5.7 23.7 32.6 66 23.9 8.9 4.3 18.7 6.6 29 6.6 36 0 65.3-28.3 65.3-63.1 0-6.9-1.2-13.7-3.6-20.2 6.4-17.6 2.8-32.9.2-40.5 6.1-17.6 2.6-32.7 0-40.3 2.7-7.6 6.2-22.8-.2-40.5 2.4-6.5 3.6-13.3 3.6-20.2 0-34.8-29.3-63.1-65.3-63.1h-14.7c0-97 78.9-176 176-176 97 0 176 79 176 176h-14.7c-36 0-65.3 28.3-65.3 63.1 0 6.9 1.2 13.7 3.6 20.2-6.4 17.6-2.8 32.9-.2 40.5-2.6 7.6-6.1 22.7 0 40.3-2.6 7.6-6.2 22.8.2 40.5-2.4 6.5-3.6 13.3-3.6 20.2 0 34.8 29.3 63.1 65.3 63.1 10.2 0 20.1-2.3 29-6.6 42.3 8.7 65.5-23.2 66-23.9 16.7-5.1 39.7-19.8 44.9-50.1 15.2-15 23.5-38.7 15.7-63 8-24.4-.5-48.2-15.6-63.2zM167.5 314c11.7 10.1 11.1 26.5 0 36 11.7 10.1 11.1 26.5 0 36 11.7 10.1 11.1 26.5 0 36 24.5 21-7.7 57.1-31.4 35.6-16 14.5-41.3 2.5-39.7-19.3-20.5 7.7-38.2-13-30.5-31.6-16.9-4.5-24.1-24.8-11.5-38.7-12.6-13.9-5.4-34.2 11.5-38.8-7.7-18.5 9.7-39.3 30.5-31.6-1.6-21.8 23.6-33.9 39.7-19.3 23.7-21.5 55.8 14.7 31.4 35.7zm406.6 92.8c7.8 18.6-9.9 39.2-30.5 31.6 1.6 21.8-23.6 33.9-39.7 19.3-23.7 21.4-55.9-14.7-31.4-35.7-11.1-9.5-11.7-25.9 0-36-11.1-9.5-11.7-25.9 0-36-11.1-9.5-11.7-25.9 0-36-24.4-21 7.7-57.2 31.4-35.6 16-14.5 41.3-2.5 39.7 19.3 20.7-7.8 38.2 13.1 30.5 31.6 16.9 4.6 24.1 24.9 11.5 38.8 12.6 13.8 5.4 34.1-11.5 38.7z"
  ]
};
export const faEclipse = {
  prefix: "far",
  iconName: "eclipse",
  icon: [
    640,
    512,
    [],
    "f749",
    "M448 64c-106 0-192 86-192 192s86 192 192 192 192-86 192-192S554 64 448 64zm0 336c-79.4 0-144-64.6-144-144s64.6-144 144-144 144 64.6 144 144-64.6 144-144 144zm-192 58l-51.9-77-90.9 17.6 17.6-91.2-76.8-52 76.8-52-17.6-91.2 91 17.6L256 53l31.7 46.9c11.2-11.5 23.7-21.9 37.2-30.8l-35.3-52.4c-15.1-22.3-51.9-22.3-67 0l-40.4 59.9-70.8-13.7C98 60.4 84.5 64.5 75 74.1s-13.7 23.1-11.1 36.3l13.7 71-59.8 40.5C6.6 229.5 0 242 0 255.5s6.7 26 17.8 33.5l59.8 40.5-13.7 71c-2.6 13.2 1.6 26.8 11.1 36.3 9.5 9.5 22.9 13.7 36.3 11.1l70.8-13.7 40.4 59.9C230 505.3 242.6 512 256 512s26-6.7 33.5-17.8l34.8-51.6c-13.5-9-25.8-19.4-37.1-30.9L256 458zm-26.4-251.1c4.3-19.1 11-37.3 19.9-54.3-54.3 3.5-97.5 48.3-97.5 103.4s43.2 99.9 97.5 103.3c-8.9-16.9-15.6-35.1-19.9-54.3-17.5-9.5-29.6-27.8-29.6-49.1s12.1-39.5 29.6-49z"
  ]
};
export const faEclipseAlt = {
  prefix: "far",
  iconName: "eclipse-alt",
  icon: [
    512,
    512,
    [],
    "f74a",
    "M326.1 309.2c-46.5 8.9-89.3-26.8-89.3-73.9 0-27.1 14.5-52 38-65.4 3.6-2.1 2.7-7.6-1.4-8.3-5.8-1.1-11.6-1.6-17.5-1.6-52.9 0-95.9 42.9-95.9 96 0 53 42.9 96 95.9 96 29.6 0 56.6-13.5 74.5-35.5 2.7-3.3-.2-8.1-4.3-7.3zm168.1-87.3l-59.8-40.5 13.7-71c2.6-13.2-1.6-26.8-11.1-36.4-9.6-9.5-23.2-13.7-36.2-11.1l-70.9 13.7-40.4-59.9c-15.1-22.3-51.9-22.3-67 0l-40.4 59.9-70.8-13.7C98 60.4 84.5 64.5 75 74.1c-9.5 9.6-13.7 23.1-11.1 36.3l13.7 71-59.8 40.5C6.6 229.5 0 242 0 255.5s6.7 26 17.8 33.5l59.8 40.5-13.7 71c-2.6 13.2 1.6 26.8 11.1 36.3 9.5 9.5 22.9 13.7 36.3 11.1l70.8-13.7 40.4 59.9C230 505.3 242.6 512 256 512s26-6.7 33.5-17.8l40.4-59.9 70.9 13.7c13.4 2.7 26.8-1.6 36.3-11.1 9.5-9.5 13.6-23.1 11.1-36.3l-13.7-71 59.8-40.5c11.1-7.5 17.8-20.1 17.8-33.5-.1-13.6-6.7-26.1-17.9-33.7zm-112.9 85.6l17.6 91.2-91-17.6L256 458l-51.9-77-90.9 17.6 17.6-91.2-76.8-52 76.8-52-17.6-91.2 91 17.6L256 53l51.9 76.9 91-17.6-17.6 91.1 76.8 52-76.8 52.1z"
  ]
};
export const faEdit = {
  prefix: "far",
  iconName: "edit",
  icon: [
    576,
    512,
    [],
    "f044",
    "M402.3 344.9l32-32c5-5 13.7-1.5 13.7 5.7V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h273.5c7.1 0 10.7 8.6 5.7 13.7l-32 32c-1.5 1.5-3.5 2.3-5.7 2.3H48v352h352V350.5c0-2.1.8-4.1 2.3-5.6zm156.6-201.8L296.3 405.7l-90.4 10c-26.2 2.9-48.5-19.2-45.6-45.6l10-90.4L432.9 17.1c22.9-22.9 59.9-22.9 82.7 0l43.2 43.2c22.9 22.9 22.9 60 .1 82.8zM460.1 174L402 115.9 216.2 301.8l-7.3 65.3 65.3-7.3L460.1 174zm64.8-79.7l-43.2-43.2c-4.1-4.1-10.8-4.1-14.8 0L436 82l58.1 58.1 30.9-30.9c4-4.2 4-10.8-.1-14.9z"
  ]
};
export const faEgg = {
  prefix: "far",
  iconName: "egg",
  icon: [
    384,
    512,
    [],
    "f7fb",
    "M192 0C86 0 0 214 0 320s86 192 192 192 192-86 192-192S298 0 192 0zm0 464c-79.4 0-144-64.6-144-144 0-117.41 90.58-272 144-272s144 154.59 144 272c0 79.4-64.6 144-144 144z"
  ]
};
export const faEggFried = {
  prefix: "far",
  iconName: "egg-fried",
  icon: [
    512,
    512,
    [],
    "f7fc",
    "M478.32 150.45c-39.5-40.71-100.73-46.29-144.39-82.24S255.63 0 200.54 0a157.74 157.74 0 0 0-25.15 2.1c-86.78 14-111.71 80-125 157.13-11.1 64.34-54.41 127-50 192.91s52.83 128.45 114.97 150.75c17.64 6.32 33.83 9.11 48.92 9.11 64.66 0 108.94-51.18 155.72-95.56 43.68-41.44 93.4-37.72 140.93-73.89 56.28-42.82 71.71-140.55 17.39-192.1zm-46.43 153.84C415.7 316.61 398.22 323 378 330.39c-28.26 10.33-60.29 22-91 51.18-5.51 5.23-11 10.55-16.48 15.88C233.77 433.13 202.05 464 164.28 464c-10.22 0-20.92-2.06-32.72-6.29C87.09 441.7 51.26 395 48.2 349c-1.92-29 10.31-61.4 23.26-95.69 10.3-27.28 21-55.49 26.19-85.85C111.48 87.34 133 57.6 183 49.54a110.62 110.62 0 0 1 17.52-1.49c32.33 0 54.3 17 93.51 49.5l9.39 7.77c25.45 21 54.09 33.12 79.36 43.85 25 10.6 46.52 19.75 61.08 34.76l.69.71.72.68c17.78 16.88 19.27 40.81 18.57 53.57-1.39 26.03-13.95 51.7-31.95 65.4zM224 128.14c-61.72 0-112 50.3-112 112.13s50.24 112.11 112 112.11 112-50.3 112-112.11-50.21-112.13-112-112.13zm0 72.07a40.08 40.08 0 0 0-40 40.06 16 16 0 1 1-32 0 72.13 72.13 0 0 1 72-72.09 16 16 0 0 1 0 32z"
  ]
};
export const faEject = {
  prefix: "far",
  iconName: "eject",
  icon: [
    448,
    512,
    [],
    "f052",
    "M400 320H48c-26.51 0-48 21.49-48 48v64c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48v-64c0-26.51-21.49-48-48-48zm0 112H48v-64h352v64zM48.048 304h351.895c42.637 0 64.151-51.731 33.941-81.941l-175.943-176c-18.745-18.745-49.137-18.746-67.882 0l-175.952 176C-16.042 252.208 5.325 304 48.048 304zM224 80l176 176H48L224 80z"
  ]
};
export const faElephant = {
  prefix: "far",
  iconName: "elephant",
  icon: [
    640,
    512,
    [],
    "f6da",
    "M528 127.97c-8.84 0-16 7.16-16 16s7.16 16 16 16 16-7.16 16-16-7.16-16-16-16zm-16-96h-61.16c-3.64-3.77-7.46-7.4-11.71-10.66-25.97-19.88-59.44-26.22-91.82-17.46-18.04 4.9-33.88 14.96-46.49 28.11H192C85.96 31.97 0 117.93 0 223.98v112.01c0 8.84 7.16 16 16 16h16V480c0 17.67 14.33 32 32 32h80c17.67 0 32-14.33 32-32v-72.84c18.48 5.11 66.55 16.98 128 0V480c0 17.67 14.33 32 32 32h80c17.67 0 32-14.33 32-32V287.98h144v88.01c0 13.24-10.78 24-24 24s-24-10.77-24-24v-8c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v4.78c0 37.58 27.38 71.2 64.78 74.87 42.91 4.21 79.22-29.56 79.22-71.65V159.97c0-70.69-57.31-128-128-128zM400 464h-48V344.09c-120.67 33.34-111.08 31.2-224 0V464H80V303.98H48v-80.01c0-79.54 64.47-144.01 144-144.01h83.24c-6.11 26.93-2.43 54.18 11.54 77.47 11.53 19.19 28.91 34.05 49.22 42.53 0 40.15 27.18 73.73 64 84.26V464zm192-256.02c0 17.67-14.33 32-32 32H424c-22.06 0-40-17.94-40-40v-37.24c-22.65-4.59-41.89-6.4-56.06-30-16.43-27.46-7.38-71.86 31.94-82.57 29.16-7.91 55.52 6.33 66.66 29.8H512c44.11 0 80 35.89 80 80.01v48z"
  ]
};
export const faEllipsisH = {
  prefix: "far",
  iconName: "ellipsis-h",
  icon: [
    512,
    512,
    [],
    "f141",
    "M304 256c0 26.5-21.5 48-48 48s-48-21.5-48-48 21.5-48 48-48 48 21.5 48 48zm120-48c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48zm-336 0c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48z"
  ]
};
export const faEllipsisHAlt = {
  prefix: "far",
  iconName: "ellipsis-h-alt",
  icon: [
    512,
    512,
    [],
    "f39b",
    "M256 184c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72zm0 96c-13.2 0-24-10.8-24-24s10.8-24 24-24 24 10.8 24 24-10.8 24-24 24zm176-96c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72zm0 96c-13.2 0-24-10.8-24-24s10.8-24 24-24 24 10.8 24 24-10.8 24-24 24zM80 184c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72zm0 96c-13.2 0-24-10.8-24-24s10.8-24 24-24 24 10.8 24 24-10.8 24-24 24z"
  ]
};
export const faEllipsisV = {
  prefix: "far",
  iconName: "ellipsis-v",
  icon: [
    128,
    512,
    [],
    "f142",
    "M64 208c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zM16 104c0 26.5 21.5 48 48 48s48-21.5 48-48-21.5-48-48-48-48 21.5-48 48zm0 304c0 26.5 21.5 48 48 48s48-21.5 48-48-21.5-48-48-48-48 21.5-48 48z"
  ]
};
export const faEllipsisVAlt = {
  prefix: "far",
  iconName: "ellipsis-v-alt",
  icon: [
    192,
    512,
    [],
    "f39c",
    "M96 184c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72zm0 96c-13.2 0-24-10.8-24-24s10.8-24 24-24 24 10.8 24 24-10.8 24-24 24zm0 80c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72zm0 96c-13.2 0-24-10.8-24-24s10.8-24 24-24 24 10.8 24 24-10.8 24-24 24zm0-304c39.8 0 72-32.2 72-72S135.8 8 96 8 24 40.2 24 80s32.2 72 72 72zm0-96c13.2 0 24 10.8 24 24s-10.8 24-24 24-24-10.8-24-24 10.8-24 24-24z"
  ]
};
export const faEmptySet = {
  prefix: "far",
  iconName: "empty-set",
  icon: [
    448,
    512,
    [],
    "f656",
    "M443.31 48L432 36.69c-6.25-6.25-16.38-6.25-22.63 0l-67.77 67.77C309.09 79.19 268.36 64 224 64 117.96 64 32 149.96 32 256c0 44.36 15.19 85.09 40.46 117.6L4.69 441.38c-6.25 6.25-6.25 16.38 0 22.63L16 475.31c6.25 6.25 16.38 6.25 22.63 0l67.77-67.77C138.9 432.81 179.64 448 224 448c106.04 0 192-85.96 192-192 0-44.36-15.19-85.09-40.46-117.6l67.77-67.77c6.25-6.25 6.25-16.39 0-22.63zM80 256c0-79.4 64.6-144 144-144 31.04 0 59.64 10.11 83.18 26.88l-200.31 200.3C90.1 315.64 80 287.05 80 256zm288 0c0 79.4-64.6 144-144 144-31.05 0-59.64-10.1-83.19-26.88l200.31-200.3C357.9 196.36 368 224.96 368 256z"
  ]
};
export const faEngineWarning = {
  prefix: "far",
  iconName: "engine-warning",
  icon: [
    640,
    512,
    [],
    "f5f2",
    "M320 32C196.3 32 96 132.3 96 256c0 123.76 100.3 224 224 224s224-100.24 224-224c0-123.7-100.3-224-224-224zm0 400c-97.05 0-176-78.95-176-176S222.95 80 320 80s176 78.95 176 176-78.95 176-176 176zm0-112c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm22.32-192h-44.64c-9.47 0-16.86 8.17-15.92 17.59l12.8 128c.82 8.18 7.7 14.41 15.92 14.41h19.04c8.22 0 15.1-6.23 15.92-14.41l12.8-128c.94-9.42-6.45-17.59-15.92-17.59zM48 256c0-59.53 19.55-117.38 55.36-164.51 5.18-6.81 4.48-16.31-2.03-21.86l-12.2-10.41c-6.91-5.9-17.62-5.06-23.15 2.15C23.32 117.02 0 185.5 0 256c0 70.47 23.32 138.96 65.96 194.62 5.53 7.21 16.23 8.05 23.15 2.16l12.19-10.4c6.51-5.55 7.21-15.04 2.04-21.86C67.55 373.37 48 315.53 48 256zM572.73 59.71c-5.58-7.18-16.29-7.95-23.17-2l-12.15 10.51c-6.47 5.6-7.1 15.09-1.88 21.87C572.04 137.47 592 195.81 592 256c0 60.23-19.96 118.57-56.46 165.95-5.22 6.78-4.59 16.27 1.88 21.87l12.15 10.5c6.87 5.95 17.59 5.18 23.17-2C616.21 396.38 640 327.31 640 256c0-71.27-23.79-140.34-67.27-196.29z"
  ]
};
export const faEnvelope = {
  prefix: "far",
  iconName: "envelope",
  icon: [
    512,
    512,
    [],
    "f0e0",
    "M464 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm0 48v40.805c-22.422 18.259-58.168 46.651-134.587 106.49-16.841 13.247-50.201 45.072-73.413 44.701-23.208.375-56.579-31.459-73.413-44.701C106.18 199.465 70.425 171.067 48 152.805V112h416zM48 400V214.398c22.914 18.251 55.409 43.862 104.938 82.646 21.857 17.205 60.134 55.186 103.062 54.955 42.717.231 80.509-37.199 103.053-54.947 49.528-38.783 82.032-64.401 104.947-82.653V400H48z"
  ]
};
export const faEnvelopeOpen = {
  prefix: "far",
  iconName: "envelope-open",
  icon: [
    512,
    512,
    [],
    "f2b6",
    "M494.586 164.516c-4.697-3.883-111.723-89.95-135.251-108.657C337.231 38.191 299.437 0 256 0c-43.205 0-80.636 37.717-103.335 55.859-24.463 19.45-131.07 105.195-135.15 108.549A48.004 48.004 0 0 0 0 201.485V464c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V201.509a48 48 0 0 0-17.414-36.993zM464 458a6 6 0 0 1-6 6H54a6 6 0 0 1-6-6V204.347c0-1.813.816-3.526 2.226-4.665 15.87-12.814 108.793-87.554 132.364-106.293C200.755 78.88 232.398 48 256 48c23.693 0 55.857 31.369 73.41 45.389 23.573 18.741 116.503 93.493 132.366 106.316a5.99 5.99 0 0 1 2.224 4.663V458zm-31.991-187.704c4.249 5.159 3.465 12.795-1.745 16.981-28.975 23.283-59.274 47.597-70.929 56.863C336.636 362.283 299.205 400 256 400c-43.452 0-81.287-38.237-103.335-55.86-11.279-8.967-41.744-33.413-70.927-56.865-5.21-4.187-5.993-11.822-1.745-16.981l15.258-18.528c4.178-5.073 11.657-5.843 16.779-1.726 28.618 23.001 58.566 47.035 70.56 56.571C200.143 320.631 232.307 352 256 352c23.602 0 55.246-30.88 73.41-45.389 11.994-9.535 41.944-33.57 70.563-56.568 5.122-4.116 12.601-3.346 16.778 1.727l15.258 18.526z"
  ]
};
export const faEnvelopeOpenDollar = {
  prefix: "far",
  iconName: "envelope-open-dollar",
  icon: [
    512,
    512,
    [],
    "f657",
    "M230.72 233.72l42.19 11.44c4.19 1.14 7.09 4.55 7.09 8.3 0 4.8-4.5 8.7-10.06 8.7H243.6c-4.15 0-8.23-1.04-11.77-2.95-3.08-1.67-6.84-1.37-9.24 1.18l-12.07 12.73c-3.11 3.28-2.6 8.64 1.13 11.19 8.3 5.65 18.06 8.88 28.35 9.52V304c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-10.25c22.18-1.1 40-18.57 40-40.3 0-18.17-12.62-34.28-30.72-39.17l-42.19-11.44c-4.19-1.14-7.09-4.55-7.09-8.3 0-4.8 4.5-8.7 10.06-8.7h26.34c4.15 0 8.23 1.04 11.77 2.95 3.08 1.66 6.84 1.37 9.24-1.18l12.07-12.73c3.11-3.28 2.6-8.64-1.13-11.19-8.3-5.65-18.06-8.88-28.35-9.52V144c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v10.25c-22.18 1.1-40 18.57-40 40.3 0 18.17 12.62 34.28 30.72 39.17zm263.87-69.2c-1.52-1.26-13.86-11.2-30.59-24.66V96c0-26.51-21.49-48-48-48h-66.13C327.24 28.85 293.77 0 256 0c-37.65 0-70.9 28.63-93.85 48H96c-26.51 0-48 21.49-48 48v43.85c-16.81 13.52-29.15 23.46-30.48 24.56A48.002 48.002 0 0 0 0 201.48V464c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V201.51c0-14.31-6.38-27.88-17.41-36.99zM96 96h320v156.66c-36.26 29.32-78.69 63.67-86.59 69.95C311.25 337.12 279.6 368 256 368c-23.69 0-55.86-31.37-73.41-45.39-7.9-6.28-50.33-40.64-86.59-69.97V96zm368 362c0 3.31-2.69 6-6 6H54c-3.31 0-6-2.69-6-6V275.56c38.96 31.48 95.95 77.65 104.66 84.58C174.71 377.76 212.55 416 256 416c43.21 0 80.64-37.72 103.34-55.86 9-7.15 65.84-53.19 104.66-84.56V458z"
  ]
};
export const faEnvelopeOpenText = {
  prefix: "far",
  iconName: "envelope-open-text",
  icon: [
    512,
    512,
    [],
    "f658",
    "M494.59 164.52c-1.52-1.26-13.86-11.2-30.59-24.66V96c0-26.51-21.49-48-48-48h-66.13C327.24 28.85 293.77 0 256 0c-37.65 0-70.9 28.63-93.85 48H96c-26.51 0-48 21.49-48 48v43.85c-16.81 13.52-29.15 23.46-30.48 24.56A48.002 48.002 0 0 0 0 201.48V464c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V201.51c0-14.31-6.38-27.88-17.41-36.99zM96 96h320v156.66c-36.26 29.32-78.69 63.67-86.59 69.95C311.25 337.12 279.6 368 256 368c-23.69 0-55.86-31.37-73.41-45.39-7.9-6.28-50.33-40.64-86.59-69.97V96zm368 362c0 3.31-2.69 6-6 6H54c-3.31 0-6-2.69-6-6V275.56c38.96 31.48 95.95 77.65 104.66 84.58C174.71 377.76 212.55 416 256 416c43.21 0 80.64-37.72 103.34-55.86 9-7.15 65.84-53.19 104.66-84.56V458zM176 192h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16H176c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16zm176 64v-16c0-8.84-7.16-16-16-16H176c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16z"
  ]
};
export const faEnvelopeSquare = {
  prefix: "far",
  iconName: "envelope-square",
  icon: [
    448,
    512,
    [],
    "f199",
    "M187.293 260.374C114.743 210.491 115.482 210.366 96 196v-12c0-13.255 10.745-24 24-24h208c13.255 0 24 10.745 24 24v12c-19.497 14.376-18.747 14.494-91.293 64.374-8.414 5.812-25.104 19.79-36.707 19.625-11.6.166-28.296-13.816-36.707-19.625zm91.563 26.355C267.519 294.575 247.377 312.105 224 312c-23.241.104-43.082-17.118-54.849-25.266-45.054-30.977-62.02-42.883-73.151-50.958V328c0 13.255 10.745 24 24 24h208c13.255 0 24-10.745 24-24v-92.224c-11.13 8.074-28.094 19.978-73.144 50.953zM448 80v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48zm-48 346V86a6 6 0 0 0-6-6H54a6 6 0 0 0-6 6v340a6 6 0 0 0 6 6h340a6 6 0 0 0 6-6z"
  ]
};
export const faEquals = {
  prefix: "far",
  iconName: "equals",
  icon: [
    384,
    512,
    [],
    "f52c",
    "M368 304H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h352c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm0-160H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h352c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
  ]
};
export const faEraser = {
  prefix: "far",
  iconName: "eraser",
  icon: [
    512,
    512,
    [],
    "f12d",
    "M497.94 273.94a48 48 0 0 0 0-67.88l-160-160a48 48 0 0 0-67.88 0l-256 256a48 48 0 0 0 0 67.88l96 96A48 48 0 0 0 144 480h356a12 12 0 0 0 12-12v-24a12 12 0 0 0-12-12H339.88l158.06-158.06zM304 80l160 160-103 103-160-160zM144 432l-96-96 119-119 160 160-55 55z"
  ]
};
export const faEthernet = {
  prefix: "far",
  iconName: "ethernet",
  icon: [
    512,
    512,
    [],
    "f796",
    "M496 192h-48v-48c0-8.8-7.2-16-16-16h-48V80c0-8.8-7.2-16-16-16H144c-8.8 0-16 7.2-16 16v48H80c-8.8 0-16 7.2-16 16v48H16c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16zm-32 208h-48V288h-32v112h-64V288h-32v112h-64V288h-32v112h-64V288H96v112H48V240h64v-64h64v-64h160v64h64v64h64v160z"
  ]
};
export const faEuroSign = {
  prefix: "far",
  iconName: "euro-sign",
  icon: [
    320,
    512,
    [],
    "f153",
    "M315.6 458.6l-6.5-29.4c-1.4-6.5-8-10.6-14.5-9.1-10.3 2.4-26.5 5.4-44.7 5.4-65.5 0-117-39.5-138.2-97.4h129.5c5.7 0 10.6-4 11.7-9.6l5-24c1.5-7.5-4.1-14.4-11.7-14.4h-148c-1.5-16.1-2.1-32.3-.6-48h162.5c5.7 0 10.6-4 11.7-9.5l5.1-24c1.6-7.5-4.1-14.5-11.7-14.5H108.1c21-58.4 72.5-98 140-98 14.7 0 28.9 2.1 38.2 3.8 6.2 1.1 12.2-2.6 13.8-8.7l7.9-29.6c1.8-6.8-2.5-13.6-9.4-14.9-11.4-2.1-29.4-4.7-49.3-4.7-100 0-179.7 64.1-205.9 152H12c-6.6 0-12 5.4-12 12v24c0 6.6 5.4 12 12 12h23.1c-1.2 15.8-1 35.5.4 48H12c-6.6 0-12 5.4-12 12v24c0 6.6 5.4 12 12 12h32.2c26 88.7 103.4 152 205 152 24.4 0 45.4-4.2 57.5-7.2 6.4-1.6 10.3-7.9 8.9-14.2z"
  ]
};
export const faExchange = {
  prefix: "far",
  iconName: "exchange",
  icon: [
    512,
    512,
    [],
    "f0ec",
    "M508.485 168.485l-100.375 100c-4.686 4.686-12.284 4.686-16.97 0l-19.626-19.626c-4.753-4.753-4.675-12.484.173-17.14L422.916 184H12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h410.916l-51.228-47.719c-4.849-4.656-4.927-12.387-.173-17.14l19.626-19.626c4.686-4.686 12.284-4.686 16.97 0l100.375 100c4.685 4.686 4.685 12.284-.001 16.97zm-504.97 192l100.375 100c4.686 4.686 12.284 4.686 16.97 0l19.626-19.626c4.753-4.753 4.675-12.484-.173-17.14L89.084 376H500c6.627 0 12-5.373 12-12v-24c0-6.627-5.373-12-12-12H89.084l51.228-47.719c4.849-4.656 4.927-12.387.173-17.14l-19.626-19.626c-4.686-4.686-12.284-4.686-16.97 0l-100.375 100c-4.686 4.686-4.686 12.284.001 16.97z"
  ]
};
export const faExchangeAlt = {
  prefix: "far",
  iconName: "exchange-alt",
  icon: [
    512,
    512,
    [],
    "f362",
    "M508.485 168.48l-96.16 96.16c-7.58 7.58-20.485 2.14-20.485-8.485L391.833 184H12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h379.833l.01-72.162c.001-10.683 12.949-16.022 20.485-8.485l96.156 96.156c4.687 4.686 4.688 12.285.001 16.971zM3.515 360.491l96.156 96.156c7.536 7.536 20.484 2.198 20.485-8.485l.01-72.162H500c6.627 0 12-5.373 12-12v-24c0-6.628-5.373-12-12-12H120.167l-.007-72.154c0-10.625-12.905-16.066-20.485-8.485l-96.16 96.16c-4.687 4.685-4.686 12.284 0 16.97z"
  ]
};
export const faExclamation = {
  prefix: "far",
  iconName: "exclamation",
  icon: [
    256,
    512,
    [],
    "f12a",
    "M173.854 48c6.874 0 12.343 5.763 11.984 12.628l-11.742 224c-.334 6.375-5.6 11.372-11.984 11.372H93.888c-6.383 0-11.65-4.997-11.984-11.372l-11.742-224C69.802 53.763 75.271 48 82.146 48h91.708M128 336c35.29 0 64 28.71 64 64s-28.71 64-64 64-64-28.71-64-64 28.71-64 64-64M173.854 0H82.146C47.881 0 20.427 28.783 22.228 63.141l11.742 224c.698 13.309 5.689 25.414 13.592 35.001C28.035 342.31 16 369.777 16 400c0 61.757 50.243 112 112 112s112-50.243 112-112c0-30.223-12.035-57.69-31.561-77.858a59.78 59.78 0 0 0 13.592-35.001l11.742-224C235.566 28.922 208.259 0 173.854 0z"
  ]
};
export const faExclamationCircle = {
  prefix: "far",
  iconName: "exclamation-circle",
  icon: [
    512,
    512,
    [],
    "f06a",
    "M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 448c-110.532 0-200-89.431-200-200 0-110.495 89.472-200 200-200 110.491 0 200 89.471 200 200 0 110.53-89.431 200-200 200zm42-104c0 23.159-18.841 42-42 42s-42-18.841-42-42 18.841-42 42-42 42 18.841 42 42zm-81.37-211.401l6.8 136c.319 6.387 5.591 11.401 11.985 11.401h41.17c6.394 0 11.666-5.014 11.985-11.401l6.8-136c.343-6.854-5.122-12.599-11.985-12.599h-54.77c-6.863 0-12.328 5.745-11.985 12.599z"
  ]
};
export const faExclamationSquare = {
  prefix: "far",
  iconName: "exclamation-square",
  icon: [
    448,
    512,
    [],
    "f321",
    "M448 80v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48zm-48 346V86a6 6 0 0 0-6-6H54a6 6 0 0 0-6 6v340a6 6 0 0 0 6 6h340a6 6 0 0 0 6-6zm-134-74c0 23.159-18.841 42-42 42s-42-18.841-42-42 18.841-42 42-42 42 18.841 42 42zm-81.37-211.401l6.8 136c.319 6.387 5.591 11.401 11.985 11.401h41.17c6.394 0 11.666-5.014 11.985-11.401l6.8-136c.343-6.854-5.122-12.599-11.985-12.599h-54.77c-6.863 0-12.328 5.745-11.985 12.599z"
  ]
};
export const faExclamationTriangle = {
  prefix: "far",
  iconName: "exclamation-triangle",
  icon: [
    576,
    512,
    [],
    "f071",
    "M248.747 204.705l6.588 112c.373 6.343 5.626 11.295 11.979 11.295h41.37a12 12 0 0 0 11.979-11.295l6.588-112c.405-6.893-5.075-12.705-11.979-12.705h-54.547c-6.903 0-12.383 5.812-11.978 12.705zM330 384c0 23.196-18.804 42-42 42s-42-18.804-42-42 18.804-42 42-42 42 18.804 42 42zm-.423-360.015c-18.433-31.951-64.687-32.009-83.154 0L6.477 440.013C-11.945 471.946 11.118 512 48.054 512H527.94c36.865 0 60.035-39.993 41.577-71.987L329.577 23.985zM53.191 455.002L282.803 57.008c2.309-4.002 8.085-4.002 10.394 0l229.612 397.993c2.308 4-.579 8.998-5.197 8.998H58.388c-4.617.001-7.504-4.997-5.197-8.997z"
  ]
};
export const faExpand = {
  prefix: "far",
  iconName: "expand",
  icon: [
    448,
    512,
    [],
    "f065",
    "M0 180V56c0-13.3 10.7-24 24-24h124c6.6 0 12 5.4 12 12v24c0 6.6-5.4 12-12 12H48v100c0 6.6-5.4 12-12 12H12c-6.6 0-12-5.4-12-12zM288 44v24c0 6.6 5.4 12 12 12h100v100c0 6.6 5.4 12 12 12h24c6.6 0 12-5.4 12-12V56c0-13.3-10.7-24-24-24H300c-6.6 0-12 5.4-12 12zm148 276h-24c-6.6 0-12 5.4-12 12v100H300c-6.6 0-12 5.4-12 12v24c0 6.6 5.4 12 12 12h124c13.3 0 24-10.7 24-24V332c0-6.6-5.4-12-12-12zM160 468v-24c0-6.6-5.4-12-12-12H48V332c0-6.6-5.4-12-12-12H12c-6.6 0-12 5.4-12 12v124c0 13.3 10.7 24 24 24h124c6.6 0 12-5.4 12-12z"
  ]
};
export const faExpandAlt = {
  prefix: "far",
  iconName: "expand-alt",
  icon: [
    448,
    512,
    [],
    "f424",
    "M448 56v95.005c0 21.382-25.851 32.09-40.971 16.971l-27.704-27.704-107.242 107.243c-4.686 4.686-12.284 4.686-16.971 0l-22.627-22.627c-4.686-4.686-4.686-12.284 0-16.971l107.243-107.243-27.704-27.704C296.905 57.851 307.613 32 328.995 32H424c13.255 0 24 10.745 24 24zM175.917 264.485L68.674 371.728 40.97 344.024C25.851 328.905 0 339.613 0 360.995V456c0 13.255 10.745 24 24 24h95.005c21.382 0 32.09-25.851 16.971-40.971l-27.704-27.704 107.243-107.243c4.686-4.686 4.686-12.284 0-16.971l-22.627-22.627c-4.687-4.685-12.285-4.685-16.971.001z"
  ]
};
export const faExpandArrows = {
  prefix: "far",
  iconName: "expand-arrows",
  icon: [
    448,
    512,
    [],
    "f31d",
    "M447.9 332l.1 136c0 6.6-5.4 12-12 12l-136-.1c-6.6 0-12-5.4-12-12v-27.8c0-6.7 5.5-12.1 12.2-12l61.4 2.3 1.4-1.4-139-139L85 429l1.4 1.4 61.4-2.3c6.7-.1 12.2 5.3 12.2 12v27.8c0 6.6-5.4 12-12 12L12 480c-6.6 0-12-5.4-12-12l.1-136c0-6.6 5.4-12 12-12h27.8c6.7 0 12.1 5.5 12 12.2l-2.3 61.4L51 395l139-139L51 117l-1.4 1.4 2.3 61.4c.1 6.7-5.3 12.2-12 12.2H12.1c-6.6 0-12-5.4-12-12L0 44c0-6.6 5.4-12 12-12l136 .1c6.6 0 12 5.4 12 12v27.8c0 6.7-5.5 12.1-12.2 12l-61.4-2.3L85 83l139 139L363 83l-1.4-1.4-61.4 2.3c-6.7.1-12.2-5.3-12.2-12V44.1c0-6.6 5.4-12 12-12l136-.1c6.6 0 12 5.4 12 12l-.1 136c0 6.6-5.4 12-12 12h-27.8c-6.7 0-12.1-5.5-12-12.2l2.3-61.4-1.4-1.4-139 139 139 139 1.4-1.4-2.3-61.4c-.1-6.7 5.3-12.2 12-12.2h27.8c6.6 0 12 5.4 12 12z"
  ]
};
export const faExpandArrowsAlt = {
  prefix: "far",
  iconName: "expand-arrows-alt",
  icon: [
    448,
    512,
    [],
    "f31e",
    "M252.3 256l121.4 121.4 53.8-53.8c7.6-7.6 20.5-2.2 20.5 8.5v136c0 6.6-5.4 12-12 12H300c-10.7 0-16-12.9-8.5-20.5l53.8-53.8L224 284.3 102.6 405.7l53.8 53.8c7.6 7.6 2.2 20.5-8.5 20.5h-136c-6.6 0-12-5.4-12-12V332c0-10.7 12.9-16 20.5-8.5l53.8 53.8L195.7 256 74.3 134.6l-53.8 53.8C12.9 196 0 190.7 0 180V44c0-6.6 5.4-12 12-12h136c10.7 0 16 12.9 8.5 20.5l-53.8 53.8L224 227.7l121.4-121.4-53.8-53.8C284 44.9 289.3 32 300 32h136c6.6 0 12 5.4 12 12v136c0 10.7-12.9 16-20.5 8.5l-53.8-53.8L252.3 256z"
  ]
};
export const faExpandWide = {
  prefix: "far",
  iconName: "expand-wide",
  icon: [
    512,
    512,
    [],
    "f320",
    "M0 212V88c0-13.3 10.7-24 24-24h124c6.6 0 12 5.4 12 12v24c0 6.6-5.4 12-12 12H48v100c0 6.6-5.4 12-12 12H12c-6.6 0-12-5.4-12-12zM352 76v24c0 6.6 5.4 12 12 12h100v100c0 6.6 5.4 12 12 12h24c6.6 0 12-5.4 12-12V88c0-13.3-10.7-24-24-24H364c-6.6 0-12 5.4-12 12zm148 212h-24c-6.6 0-12 5.4-12 12v100H364c-6.6 0-12 5.4-12 12v24c0 6.6 5.4 12 12 12h124c13.3 0 24-10.7 24-24V300c0-6.6-5.4-12-12-12zM160 436v-24c0-6.6-5.4-12-12-12H48V300c0-6.6-5.4-12-12-12H12c-6.6 0-12 5.4-12 12v124c0 13.3 10.7 24 24 24h124c6.6 0 12-5.4 12-12z"
  ]
};
export const faExternalLink = {
  prefix: "far",
  iconName: "external-link",
  icon: [
    512,
    512,
    [],
    "f08e",
    "M497.6,0,334.4.17A14.4,14.4,0,0,0,320,14.57V47.88a14.4,14.4,0,0,0,14.69,14.4l73.63-2.72,2.06,2.06L131.52,340.49a12,12,0,0,0,0,17l23,23a12,12,0,0,0,17,0L450.38,101.62l2.06,2.06-2.72,73.63A14.4,14.4,0,0,0,464.12,192h33.31a14.4,14.4,0,0,0,14.4-14.4L512,14.4A14.4,14.4,0,0,0,497.6,0ZM432,288H416a16,16,0,0,0-16,16V458a6,6,0,0,1-6,6H54a6,6,0,0,1-6-6V118a6,6,0,0,1,6-6H208a16,16,0,0,0,16-16V80a16,16,0,0,0-16-16H48A48,48,0,0,0,0,112V464a48,48,0,0,0,48,48H400a48,48,0,0,0,48-48V304A16,16,0,0,0,432,288Z"
  ]
};
export const faExternalLinkAlt = {
  prefix: "far",
  iconName: "external-link-alt",
  icon: [
    512,
    512,
    [],
    "f35d",
    "M432,288H416a16,16,0,0,0-16,16V458a6,6,0,0,1-6,6H54a6,6,0,0,1-6-6V118a6,6,0,0,1,6-6H208a16,16,0,0,0,16-16V80a16,16,0,0,0-16-16H48A48,48,0,0,0,0,112V464a48,48,0,0,0,48,48H400a48,48,0,0,0,48-48V304A16,16,0,0,0,432,288ZM500,0H364a12,12,0,0,0-8.48,20.48l48.19,48.21L131.51,340.89a12,12,0,0,0,0,17l22.63,22.63a12,12,0,0,0,17,0l272.2-272.21,48.21,48.2A12,12,0,0,0,512,148V12A12,12,0,0,0,500,0Z"
  ]
};
export const faExternalLinkSquare = {
  prefix: "far",
  iconName: "external-link-square",
  icon: [
    448,
    512,
    [],
    "f14c",
    "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zm-6 400H54a6 6 0 0 1-6-6V86a6 6 0 0 1 6-6h340a6 6 0 0 1 6 6v340a6 6 0 0 1-6 6zm-54-304l-136 .145c-6.627 0-12 5.373-12 12V167.9c0 6.722 5.522 12.133 12.243 11.998l58.001-2.141L99.515 340.485c-4.686 4.686-4.686 12.284 0 16.971l23.03 23.029c4.686 4.686 12.284 4.686 16.97 0l162.729-162.729-2.141 58.001c-.136 6.721 5.275 12.242 11.998 12.242h27.755c6.628 0 12-5.373 12-12L352 140c0-6.627-5.373-12-12-12z"
  ]
};
export const faExternalLinkSquareAlt = {
  prefix: "far",
  iconName: "external-link-square-alt",
  icon: [
    448,
    512,
    [],
    "f360",
    "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zm-6 400H54a6 6 0 0 1-6-6V86a6 6 0 0 1 6-6h340a6 6 0 0 1 6 6v340a6 6 0 0 1-6 6zm-54-304H204.015c-10.658 0-16.039 12.93-8.485 20.485l48.187 48.201L99.515 340.888c-4.686 4.686-4.686 12.284 0 16.971l22.627 22.627c4.687 4.686 12.285 4.686 16.971 0l144.201-144.201 48.201 48.192c7.513 7.513 20.485 2.235 20.485-8.485V140c0-6.627-5.373-12-12-12z"
  ]
};
export const faEye = {
  prefix: "far",
  iconName: "eye",
  icon: [
    576,
    512,
    [],
    "f06e",
    "M288 144a110.94 110.94 0 0 0-31.24 5 55.4 55.4 0 0 1 7.24 27 56 56 0 0 1-56 56 55.4 55.4 0 0 1-27-7.24A111.71 111.71 0 1 0 288 144zm284.52 97.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 400c-98.65 0-189.09-55-237.93-144C98.91 167 189.34 112 288 112s189.09 55 237.93 144C477.1 345 386.66 400 288 400z"
  ]
};
export const faEyeDropper = {
  prefix: "far",
  iconName: "eye-dropper",
  icon: [
    512,
    512,
    [],
    "f1fb",
    "M483.89 28.14l-.02-.02-.03-.03c-37.47-37.47-98.26-37.46-135.72.03l-77.09 77.09-13.1-13.1c-9.44-9.44-24.65-9.31-33.94 0l-63.6 63.6c-9.37 9.37-9.37 24.57 0 33.94l16.98 16.98L50.75 333.25c-12 12-18.75 28.28-18.75 45.26V424L0 480l32 32 56-32h45.49c16.97 0 33.25-6.74 45.25-18.74l126.64-126.62 16.96 16.96c9.44 9.44 24.65 9.31 33.94 0l63.6-63.6c9.37-9.37 9.37-24.57 0-33.94l-13.1-13.1 77.09-77.09c37.5-37.47 37.5-98.25.02-135.73zM144.8 427.32a15.892 15.892 0 0 1-11.31 4.68H80v-53.49c0-4.27 1.66-8.29 4.69-11.31l126.63-126.62 60.12 60.12L144.8 427.32zm305.14-297.38l-77.09 77.09-33.94 33.94 30.07 30.06-29.66 29.66-128-128 29.66-29.65 30.06 30.07L382.08 62.05c9.05-9.06 21.1-14.05 33.91-14.05 12.82 0 24.86 4.98 33.91 14.04l.04.04C459.01 71.14 464 83.19 464 96.01c0 12.81-5 24.86-14.06 33.93z"
  ]
};
export const faEyeEvil = {
  prefix: "far",
  iconName: "eye-evil",
  icon: [
    640,
    512,
    [],
    "f6db",
    "M610.12 217.47l-94.53-25.09c14.97-23.36 41.28-64.52 41.31-64.56 9.09-14.31 8.16-32.16-2.44-45.44-11-13.81-29.66-19.02-46.62-13.09l-101.62 36.06c-3.97-1.7-8.03-3.31-12.19-4.81l-36.75-77.16C350.41 8.95 336.12 0 320 0s-30.41 8.95-37.28 23.39l-36.75 77.14c-4.16 1.5-8.22 3.11-12.19 4.81L132.16 69.3c-16.94-6.02-35.62-.7-46.62 13.08-10.6 13.28-11.54 31.12-2.42 45.5 0 0 26.31 41.14 41.28 64.5l-94.53 25.09C12 222.2 0 237.69 0 256s12 33.8 29.84 38.53l94.5 25.08c-14.91 23.33-41.22 64.55-41.25 64.58-9.09 14.31-8.16 32.16 2.44 45.44 11 13.83 29.72 19.08 46.62 13.09l101.62-36.06c3.97 1.7 8.03 3.31 12.19 4.81l36.75 77.12C289.59 503.03 303.88 512 320 512s30.41-8.97 37.28-23.41l36.75-77.12c4.16-1.5 8.22-3.11 12.19-4.81l101.62 36.05c16.97 6.05 35.66.73 46.62-13.08 10.59-13.28 11.53-31.12 2.41-45.48 0 0-26.31-41.2-41.22-64.53l94.47-25.08C628 289.8 640 274.31 640 256s-12-33.8-29.88-38.53zm-123.81 60.26l-5 6.67a298.45 298.45 0 0 1-13.78 17.12l-11.81 13.73 9.88 15.17c1.34 2.08 23.72 37.08 38.31 59.95l-100.28-35.58-9.06 4.41c-7.72 3.78-16.12 7.09-24.94 9.83l-10.03 3.12-39.6 83.12-39.59-83.09-10.03-3.12c-8.81-2.73-17.22-6.05-24.94-9.83l-9.06-4.41L136.1 390.4c14.59-22.88 36.94-57.86 38.28-59.89l10.03-15.2-11.94-13.77c-5.12-5.91-9.69-11.64-13.78-17.12l-5-6.67L71.81 256l81.88-21.75 5-6.67c4.12-5.5 8.69-11.23 13.81-17.16l11.91-13.8-10-15.22c-1.5-2.31-23.75-37.05-38.28-59.78l100.25 35.56 9.06-4.41c7.72-3.78 16.12-7.09 24.94-9.83l10.03-3.12L320 56.72l39.59 83.11 10.03 3.12c8.81 2.73 17.22 6.05 24.94 9.83l9.06 4.41 100.25-35.56c-14.53 22.75-36.75 57.44-38.19 59.66l-10.28 15.27 12.09 13.88c5.12 5.92 9.69 11.66 13.81 17.16l5 6.67L568.19 256l-81.88 21.73zm-142.1-55.71c4.41 9.25 7.79 20.41 7.79 33.98 0 42.67-32 64-32 64s-32-21.33-32-64c0-13.57 3.37-24.73 7.79-33.98-20.82-3-39.68-9.76-55.59-19.33C229.99 217.94 224 236.27 224 256c0 53.02 42.98 96 96 96s96-42.98 96-96c0-19.73-5.99-38.06-16.2-53.31-15.9 9.57-34.77 16.33-55.59 19.33z"
  ]
};
export const faEyeSlash = {
  prefix: "far",
  iconName: "eye-slash",
  icon: [
    640,
    512,
    [],
    "f070",
    "M634 471L36 3.51A16 16 0 0 0 13.51 6l-10 12.49A16 16 0 0 0 6 41l598 467.49a16 16 0 0 0 22.49-2.49l10-12.49A16 16 0 0 0 634 471zM296.79 146.47l134.79 105.38C429.36 191.91 380.48 144 320 144a112.26 112.26 0 0 0-23.21 2.47zm46.42 219.07L208.42 260.16C210.65 320.09 259.53 368 320 368a113 113 0 0 0 23.21-2.46zM320 112c98.65 0 189.09 55 237.93 144a285.53 285.53 0 0 1-44 60.2l37.74 29.5a333.7 333.7 0 0 0 52.9-75.11 32.35 32.35 0 0 0 0-29.19C550.29 135.59 442.93 64 320 64c-36.7 0-71.71 7-104.63 18.81l46.41 36.29c18.94-4.3 38.34-7.1 58.22-7.1zm0 288c-98.65 0-189.08-55-237.93-144a285.47 285.47 0 0 1 44.05-60.19l-37.74-29.5a333.6 333.6 0 0 0-52.89 75.1 32.35 32.35 0 0 0 0 29.19C89.72 376.41 197.08 448 320 448c36.7 0 71.71-7.05 104.63-18.81l-46.41-36.28C359.28 397.2 339.89 400 320 400z"
  ]
};
export const faFan = {
  prefix: "far",
  iconName: "fan",
  icon: [
    512,
    512,
    [],
    "f863",
    "M256 224a32 32 0 1 0 32 32 32 32 0 0 0-32-32zm255.69 41.06C501 180.11 428.72 116 343.53 116a244.34 244.34 0 0 0-42.5 3.63l7.78-77.15A38.8 38.8 0 0 0 265.09.34C180.09 11 116 83.31 116 168.49a244.42 244.42 0 0 0 3.63 42.5l-77.16-7.78a38.4 38.4 0 0 0-31.38 11.43A39.06 39.06 0 0 0 .31 246.92C11 331.92 83.28 396 168.47 396a244.34 244.34 0 0 0 42.5-3.63l-7.78 77.15a38.25 38.25 0 0 0 11.44 31.35A39 39 0 0 0 242 512a38.44 38.44 0 0 0 5-.31c84.91-10.69 149-82.97 149-168.15a244.42 244.42 0 0 0-3.63-42.5l77.16 7.78a38.5 38.5 0 0 0 31.34-11.43 39 39 0 0 0 10.82-32.31zM324.75 246l13 35.91c6.78 18.65 10.22 39.4 10.22 61.65 0 57.25-40.47 106.4-95.84 118.59L266 324.76l-35.9 13c-18.63 6.81-39.38 10.24-61.63 10.24-57.25 0-106.38-40.47-118.59-95.84l137.37 13.88-13-35.91c-6.78-18.65-10.22-39.4-10.22-61.65 0-57.25 40.47-106.37 95.84-118.59L246 187.27l35.9-13c18.66-6.78 39.41-10.22 61.66-10.22 57.25 0 106.41 40.47 118.59 95.84z"
  ]
};
export const faFanTable = {
  prefix: "far",
  iconName: "fan-table",
  icon: [
    448,
    512,
    [],
    "e004",
    "M448,224C448,100.29,347.71,0,224,0S0,100.29,0,224C0,339.6,87.58,434.69,200,446.68V464H112c-21.32,0-41.21,13.89-47.48,33.12C62.11,504.53,68.41,512,76.2,512H371.81c7.78,0,14.08-7.47,11.67-14.88C377.22,477.89,357.32,464,336,464H248V446.68C360.42,434.69,448,339.6,448,224ZM224,400c-97,0-176-78.95-176-176S127,48,224,48s176,79,176,176S321.05,400,224,400ZM354.06,266.31a17.49,17.49,0,0,0,20.34-17.25,87.62,87.62,0,0,0-144.35-66.88L195.62,90.24c-2.57-6.85-13-15.9-25.1-9l0,0a87.06,87.06,0,0,0-40.87,53.25c-8.85,33.12,2.3,86.06,55.38,104.9l-62.65,76.1c-8.76,10.6-1.81,22.47,4.77,26.26a87.71,87.71,0,0,0,119.77-32.11,86.67,86.67,0,0,0,9.95-59.52ZM224,240a16,16,0,1,1,16-16A16,16,0,0,1,224,240Z"
  ]
};
export const faFarm = {
  prefix: "far",
  iconName: "farm",
  icon: [
    576,
    512,
    [],
    "f864",
    "M112 48a64.07 64.07 0 0 1 64 64v37.43l14.25-28.49a64.12 64.12 0 0 1 31.24-29.86l.38-.17A111.93 111.93 0 0 0 0 112v384a16 16 0 0 0 16 16h112v-48H48V112a64.07 64.07 0 0 1 64-64zm288 176h-64a16 16 0 0 0-16 16v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-64a16 16 0 0 0-16-16zm172.62 22.22l-55.49-111a32 32 0 0 0-15.62-14.93L381 66.76a32 32 0 0 0-26 0l-120.51 53.56c-5.17 2.3-11 8-10.49 8a31.56 31.56 0 0 0-5.13 6.95l-55.49 111a32.08 32.08 0 0 0-3.38 14.27V512h400a16 16 0 0 0 16-16V260.54a32.08 32.08 0 0 0-3.38-14.32zM528 464H416v-64a16 16 0 0 0-16-16h-64a16 16 0 0 0-16 16v64H208V264.31l51.23-102.46L368 113.51l108.77 48.34L528 264.31z"
  ]
};
export const faFastBackward = {
  prefix: "far",
  iconName: "fast-backward",
  icon: [
    512,
    512,
    [],
    "f049",
    "M12 448h24c6.6 0 12-5.4 12-12V277.7c1.1 1.2 2.2 2.4 3.5 3.4l184 159.5c20.6 17.2 52.5 2.8 52.5-24.6V292l171.5 148.6c20.6 17.2 52.5 2.8 52.5-24.6V96c0-27.4-31.9-41.8-52.5-24.6L288 221.1v-125c0-27.4-31.9-41.8-52.5-24.6L51.5 232c-1.3 1.1-2.4 2.2-3.5 3.4V76c0-6.6-5.4-12-12-12H12C5.4 64 0 69.4 0 76v360c0 6.6 5.4 12 12 12zm452-316.8V381L320.4 256.5 464 131.2zm-224 0V381L96.4 256.5 240 131.2z"
  ]
};
export const faFastForward = {
  prefix: "far",
  iconName: "fast-forward",
  icon: [
    512,
    512,
    [],
    "f050",
    "M500 64h-24c-6.6 0-12 5.4-12 12v158.3c-1.1-1.2-2.2-2.4-3.5-3.4l-184-159.5C255.9 54.3 224 68.6 224 96v124L52.5 71.4C31.9 54.3 0 68.6 0 96v320c0 27.4 31.9 41.8 52.5 24.6L224 291v125c0 27.4 31.9 41.8 52.5 24.6l184-160.5c1.3-1.1 2.4-2.2 3.5-3.4V436c0 6.6 5.4 12 12 12h24c6.6 0 12-5.4 12-12V76c0-6.6-5.4-12-12-12zM48 380.8V131.1l143.6 124.4L48 380.8zm224 0V131.1l143.6 124.4L272 380.8z"
  ]
};
export const faFaucet = {
  prefix: "far",
  iconName: "faucet",
  icon: [
    512,
    512,
    [],
    "e005",
    "M368,224H323.18c-18.67-23.11-44.83-39.81-75.18-45.58V147.6S366.6,160,368,160c8.71,0,16-7.48,16-16.89V112.89c0-9.42-7.26-16.89-16-16.89-1.4,0,6.12-.79-120,13.32V80a16,16,0,0,0-16-16H216a16,16,0,0,0-16,16v29.32C73.88,95.21,81.38,96,80,96c-8.72,0-16,7.47-16,16.89v30.22C64,152.52,71.26,160,80,160c1.43,0,120-12.4,120-12.4v30.82c-30.35,5.77-56.51,22.47-75.18,45.58H16A16,16,0,0,0,0,240v16a16,16,0,0,0,16,16H150.75a79.89,79.89,0,0,1,146.5,0H368a96.1,96.1,0,0,1,96,96v32H400V368a32,32,0,0,0-32-32H297.25a79.89,79.89,0,0,1-146.5,0H16A16,16,0,0,0,0,352v16a16,16,0,0,0,16,16H124.82c23.46,29.05,58.93,48,99.18,48s75.72-18.95,99.18-48H352v16a48,48,0,0,0,48,48h64a48,48,0,0,0,48-48V368C512,288.6,447.4,224,368,224Z"
  ]
};
export const faFaucetDrip = {
  prefix: "far",
  iconName: "faucet-drip",
  icon: [
    512,
    512,
    [],
    "e006",
    "M416,480a32,32,0,0,0,64,0c0-17.67-32-64-32-64S416,462.33,416,480ZM368,160H323.18c-18.67-23.11-44.83-39.81-75.18-45.58V83.6S366.6,96,368,96c8.71,0,16-7.48,16-16.89V48.89C384,39.47,376.74,32,368,32c-1.4,0,6.12-.79-120,13.32V16A16,16,0,0,0,232,0H216a16,16,0,0,0-16,16V45.32C73.88,31.21,81.38,32,80,32c-8.72,0-16,7.47-16,16.89V79.11C64,88.52,71.26,96,80,96c1.43,0,120-12.4,120-12.4v30.82c-30.35,5.77-56.51,22.47-75.18,45.58H16A16,16,0,0,0,0,176v16a16,16,0,0,0,16,16H150.75a79.89,79.89,0,0,1,146.5,0H368a96.1,96.1,0,0,1,96,96v32H400V304a32,32,0,0,0-32-32H297.25a79.89,79.89,0,0,1-146.5,0H16A16,16,0,0,0,0,288v16a16,16,0,0,0,16,16H124.82c23.46,29.05,58.93,48,99.18,48s75.72-18.95,99.18-48H352v16a48,48,0,0,0,48,48h64a48,48,0,0,0,48-48V304C512,224.6,447.4,160,368,160Z"
  ]
};
export const faFax = {
  prefix: "far",
  iconName: "fax",
  icon: [
    512,
    512,
    [],
    "f1ac",
    "M288 368h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm192-167.12V77.25a32 32 0 0 0-9.38-22.63L425.38 9.38A32 32 0 0 0 402.75 0H176a32 32 0 0 0-32 32v104.88a63.33 63.33 0 0 0-32-8.88H64a64 64 0 0 0-64 64v256a64 64 0 0 0 64 64h48a63.44 63.44 0 0 0 40-14.41A63.44 63.44 0 0 0 192 512h256a64 64 0 0 0 64-64V256a63.71 63.71 0 0 0-32-55.12zM128 448a16 16 0 0 1-16 16H64a16 16 0 0 1-16-16V192a16 16 0 0 1 16-16h48a16 16 0 0 1 16 16zm64-400h192v32a16 16 0 0 0 16 16h32v96H192zm272 400a16 16 0 0 1-16 16H192a16 16 0 0 1-16-16V240h272a16 16 0 0 1 16 16zM288 272h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 96h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
  ]
};
export const faFeather = {
  prefix: "far",
  iconName: "feather",
  icon: [
    512,
    512,
    [],
    "f52d",
    "M467.1 44.9C438.24 16.04 401.59 0 361.59 0c-46.7 0-97.98 21.85-146.78 70.66l-85.75 85.76C54 231.47 56.69 352.92 72.69 405.37L7.03 471.03c-9.37 9.37-9.37 24.57 0 33.94 9.37 9.37 24.57 9.37 33.94 0l65.6-65.6c17.44 5.3 42.43 9.15 70.88 9.15 57.19 0 128.04-15.48 178.13-65.57l85.76-85.75c90.61-90.62 88.32-189.75 25.76-252.3zM147.37 398.57L193.94 352h124.12c-44.62 41.83-106.87 48.46-140.61 48.46-11.41.01-21.29-.81-30.08-1.89zM350.58 320H225.94l64-64h123.81c-2.23 2.4-4.01 4.83-6.39 7.21L350.58 320zm88.31-96H321.94l22.51-22.51c9.37-9.37 9.37-24.57 0-33.94-9.37-9.37-24.57-9.37-33.94 0l-197 197c-5.27-45.97-.29-124.34 49.52-174.15 0 0 18.71-18.71 85.75-85.76 37.02-37.02 76.03-56.58 112.8-56.58 26.63 0 51.37 10.66 71.53 30.82 39.17 39.16 40.02 92.25 5.78 145.12z"
  ]
};
export const faFeatherAlt = {
  prefix: "far",
  iconName: "feather-alt",
  icon: [
    512,
    512,
    [],
    "f56b",
    "M71.46 287.61c-4.85 41.95-7.25 84.14-7.38 126.37L7.03 471.03c-9.37 9.37-9.37 24.57 0 33.94 9.37 9.37 24.57 9.37 33.94 0l57.05-57.05c42.23-.12 84.42-2.53 126.37-7.38C473.8 415.14 508.44 51.72 512 0 460.28 3.56 96.87 38.2 71.46 287.61zm147.42 105.25c-23.41 2.71-47.3 4.36-71.31 5.51L193.94 352h125.37c-27.89 21.72-60.89 36.83-100.43 40.86zM352.81 320H225.94l64-64h106.12c-12.11 23.11-26.54 44.76-43.25 64zm-30.87-96l13.54-13.54c9.37-9.37 9.37-24.57 0-33.94-9.37-9.37-24.57-9.37-33.94 0l-187.9 187.9c1.16-24.09 2.83-48.13 5.58-71.96C136.33 124.4 349.77 70.87 457.48 54.51c-6.89 45.3-20.53 109.25-46.37 169.49h-89.17z"
  ]
};
export const faFemale = {
  prefix: "far",
  iconName: "female",
  icon: [
    320,
    512,
    [],
    "f182",
    "M300.6 331.5l-48-139c-3.5-10.2-9.4-19.4-17.4-26.6 15.4-17.6 24.8-40.6 24.8-65.8C260 44.9 215.1 0 160 0S60 44.9 60 100c0 25.2 9.4 48.2 24.8 65.8-7.9 7.3-13.9 16.4-17.4 26.6L19.5 331.2C5.2 374 36.9 416 80 416v32c0 35.3 28.7 64 64 64h32c35.3 0 64-28.7 64-64v-32c44-.2 74.5-42.9 60.6-84.5zM160 48c28.7 0 52 23.3 52 52s-23.3 52-52 52-52-23.3-52-52 23.3-52 52-52zm79.6 320H192v80c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-80H80c-10.5 0-18.8-10.2-15.1-21.4L112.8 208c2.2-6.5 8.3-10.9 15.2-10.9h7.9c15.8 3.9 32.4 3.9 48.2 0h7.9c6.9 0 13 4.4 15.2 10.9l48 138.9c3.3 10-3.8 21.1-15.6 21.1z"
  ]
};
export const faFieldHockey = {
  prefix: "far",
  iconName: "field-hockey",
  icon: [
    640,
    512,
    [],
    "f44c",
    "M619.5 96.3L558.8 157l-45.2-45.2 91.2-91.2C612.4 12.9 607 0 596.3 0h-33.9c-3.2 0-6.2 1.3-8.5 3.5L214.7 342.7c-29.4 29.5-75.6-14.8-45.3-45.2 31.2-31.2 31.2-81.9 0-113.1-31.2-31.2-81.8-31.3-113.1 0C20 220.6 0 268.8 0 320.1 0 426.7 86.3 512 192 512c86.5 0 131.8-52.2 153.3-73.7 18.2 43.3 61 73.7 110.7 73.7 66.2 0 120-53.8 120-120 0-49.8-30.5-92.5-73.7-110.7l134.2-134.2c2.3-2.3 3.5-5.3 3.5-8.5v-33.9c0-10.6-12.9-16-20.5-8.4zM192 464c-38.5 0-74.7-14.9-101.8-42C63 394.8 48 358.6 48 320.1c0-38.5 15-74.7 42.2-101.8 29.5-29.6 75.6 14.9 45.2 45.3-31.1 31.2-31.1 81.9.2 113.2 31.1 30.8 81.7 31.3 113-.2l231.1-231.1 45.2 45.2-82.5 82.5c-55.2 6.3-98.7 49.8-105 105C293.3 422.5 262.2 464 192 464zm336-72c0 39.7-32.3 72-72 72s-72-32.3-72-72 32.3-72 72-72 72 32.3 72 72z"
  ]
};
export const faFighterJet = {
  prefix: "far",
  iconName: "fighter-jet",
  icon: [
    640,
    512,
    [],
    "f0fb",
    "M520 181.4l-108-12.34L370.22 152h-11.15L288.5 63.79C310.73 62.56 328 56.09 328 48c0-9-21.38-16-47.19-16H128v32h16v63.53L119.48 96h-74.3L8 133.18v62.12l-8 1v119.42l8 1v62.12L45.18 416h74.3L144 384.47V448h-16v32h152.81c25.81 0 47.19-7 47.19-16 0-8.09-17.27-14.56-39.5-15.79L359.07 360h11.15L412 342.94l108-12.34c61-13.55 120.35-22 120-74.6.3-52.76-59.54-61.15-120-74.6zm-8 101.8L400 296l-39.2 16H336l-96 120h-48V296h-40l-56 72H65.07L56 358.93V304h8v-16h40v-8l-56-6.8v-34.4l56-6.8v-8H64v-16h-8v-54.93l9.07-9.07H96l56 72h40V80h48l96 120h24.8l39.2 16 112 12.8c81.6 18.13 80 22.6 80 27.2s1.6 9.07-80 27.2z"
  ]
};
export const faFile = {
  prefix: "far",
  iconName: "file",
  icon: [
    384,
    512,
    [],
    "f15b",
    "M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48z"
  ]
};
export const faFileAlt = {
  prefix: "far",
  iconName: "file-alt",
  icon: [
    384,
    512,
    [],
    "f15c",
    "M288 248v28c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-28c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm-12 72H108c-6.6 0-12 5.4-12 12v28c0 6.6 5.4 12 12 12h168c6.6 0 12-5.4 12-12v-28c0-6.6-5.4-12-12-12zm108-188.1V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V48C0 21.5 21.5 0 48 0h204.1C264.8 0 277 5.1 286 14.1L369.9 98c9 8.9 14.1 21.2 14.1 33.9zm-128-80V128h76.1L256 51.9zM336 464V176H232c-13.3 0-24-10.7-24-24V48H48v416h288z"
  ]
};
export const faFileArchive = {
  prefix: "far",
  iconName: "file-archive",
  icon: [
    384,
    512,
    [],
    "f1c6",
    "M128.3 160v32h32v-32zm64-96h-32v32h32zm-64 32v32h32V96zm64 32h-32v32h32zm177.6-30.1L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM256 51.9l76.1 76.1H256zM336 464H48V48h79.7v16h32V48H208v104c0 13.3 10.7 24 24 24h104zM194.2 265.7c-1.1-5.6-6-9.7-11.8-9.7h-22.1v-32h-32v32l-19.7 97.1C102 385.6 126.8 416 160 416c33.1 0 57.9-30.2 51.5-62.6zm-33.9 124.4c-17.9 0-32.4-12.1-32.4-27s14.5-27 32.4-27 32.4 12.1 32.4 27-14.5 27-32.4 27zm32-198.1h-32v32h32z"
  ]
};
export const faFileAudio = {
  prefix: "far",
  iconName: "file-audio",
  icon: [
    384,
    512,
    [],
    "f1c7",
    "M369.941 97.941l-83.882-83.882A48 48 0 0 0 252.118 0H48C21.49 0 0 21.49 0 48v416c0 26.51 21.49 48 48 48h288c26.51 0 48-21.49 48-48V131.882a48 48 0 0 0-14.059-33.941zM332.118 128H256V51.882L332.118 128zM48 464V48h160v104c0 13.255 10.745 24 24 24h104v288H48zm144-76.024c0 10.691-12.926 16.045-20.485 8.485L136 360.486h-28c-6.627 0-12-5.373-12-12v-56c0-6.627 5.373-12 12-12h28l35.515-36.947c7.56-7.56 20.485-2.206 20.485 8.485v135.952zm41.201-47.13c9.051-9.297 9.06-24.133.001-33.439-22.149-22.752 12.235-56.246 34.395-33.481 27.198 27.94 27.212 72.444.001 100.401-21.793 22.386-56.947-10.315-34.397-33.481z"
  ]
};
export const faFileCertificate = {
  prefix: "far",
  iconName: "file-certificate",
  icon: [
    512,
    512,
    [],
    "f5f3",
    "M497.83 97.98L413.94 14.1c-9-9-21.2-14.1-33.89-14.1H175.99C149.5.1 128 21.6 128 48.09V128h47.99V48.09h159.97v103.98c0 13.3 10.7 23.99 24 23.99H464v287.95H224V512h239.93c26.5 0 48.07-21.5 48.07-47.99V131.97c0-12.69-5.17-24.99-14.17-33.99zm-113.88 30.09V51.99l76.09 76.08h-76.09zM247.42 338.28c7.4-7.53 10.29-18.5 7.58-28.79-5.43-20.65-5.44-17.74 0-38.42 2.71-10.29-.18-21.26-7.58-28.79-14.86-15.12-13.43-12.61-18.87-33.27-2.71-10.29-10.6-18.32-20.71-21.07-20.28-5.53-17.84-4.1-32.69-19.21-7.4-7.53-18.18-10.47-28.29-7.71-20.32 5.54-17.46 5.53-37.75 0-10.1-2.76-20.88.19-28.28 7.71-14.91 15.18-12.5 13.7-32.69 19.21-10.11 2.76-18 10.79-20.71 21.07-5.46 20.74-4 18.13-18.87 33.27-7.4 7.53-10.29 18.5-7.58 28.79 5.45 20.71 5.42 17.79 0 38.42-2.71 10.29.18 21.26 7.58 28.79 14.85 15.11 13.43 12.61 18.87 33.27 2.71 10.29 10.6 18.32 20.71 21.07 14.31 3.9 11.52 2.97 15.84 5V512l64-32 64 32V397.62c4.31-2.02 1.52-1.1 15.84-5 10.11-2.76 18-10.79 20.71-21.07 5.48-20.75 4.02-18.14 18.89-33.27zM128 352c-35.34 0-64-28.65-64-64s28.66-64 64-64 64 28.65 64 64-28.66 64-64 64z"
  ]
};
export const faFileChartLine = {
  prefix: "far",
  iconName: "file-chart-line",
  icon: [
    384,
    512,
    [],
    "f659",
    "M131.2 320h-22.4c-6.4 0-12.8 6.4-12.8 12.8v70.4c0 6.4 6.4 12.8 12.8 12.8h22.4c6.4 0 12.8-6.4 12.8-12.8v-70.4c0-6.4-6.4-12.8-12.8-12.8zm72-64h-22.4c-6.4 0-12.8 6.4-12.8 12.8v134.4c0 6.4 6.4 12.8 12.8 12.8h22.4c6.4 0 12.8-6.4 12.8-12.8V268.8c0-6.4-6.4-12.8-12.8-12.8zm49.6 160h22.4c6.4 0 12.8-6.4 12.8-12.8V300.8c0-6.4-6.4-12.8-12.8-12.8h-22.4c-6.4 0-12.8 6.4-12.8 12.8v102.4c0 6.4 6.4 12.8 12.8 12.8zM369.83 97.98L285.94 14.1c-9-9-21.2-14.1-33.89-14.1H47.99C21.5.1 0 21.6 0 48.09v415.92C0 490.5 21.5 512 47.99 512h287.94c26.5 0 48.07-21.5 48.07-47.99V131.97c0-12.69-5.17-24.99-14.17-33.99zM255.95 51.99l76.09 76.08h-76.09V51.99zM336 464.01H47.99V48.09h159.97v103.98c0 13.3 10.7 23.99 24 23.99H336v287.95z"
  ]
};
export const faFileChartPie = {
  prefix: "far",
  iconName: "file-chart-pie",
  icon: [
    384,
    512,
    [],
    "f65a",
    "M369.83 97.98L285.94 14.1c-9-9-21.2-14.1-33.89-14.1H47.99C21.5.1 0 21.6 0 48.09v415.92C0 490.5 21.5 512 47.99 512h287.94c26.5 0 48.07-21.5 48.07-47.99V131.97c0-12.69-5.17-24.99-14.17-33.99zM255.95 51.99l76.09 76.08h-76.09V51.99zM336 464.01H47.99V48.09h159.97v103.98c0 13.3 10.7 23.99 24 23.99H336v287.95zm-176-206.4c-36.52 7.41-64 39.68-64 78.39 0 44.18 35.82 80 80 80 38.7 0 70.97-27.49 78.39-64H160v-94.39zm32-32V320h94.39a80.321 80.321 0 0 0 1.61-16c0-44.18-35.82-80-80-80-5.48 0-10.83.56-16 1.61z"
  ]
};
export const faFileCheck = {
  prefix: "far",
  iconName: "file-check",
  icon: [
    384,
    512,
    [],
    "f316",
    "M369.941 97.941l-83.882-83.882A48 48 0 0 0 252.118 0H48C21.49 0 0 21.49 0 48v416c0 26.51 21.49 48 48 48h288c26.51 0 48-21.49 48-48V131.882a48 48 0 0 0-14.059-33.941zM332.118 128H256V51.882L332.118 128zM48 464V48h160v104c0 13.255 10.745 24 24 24h104v288H48zm261.151-192.661L166.842 412.508c-4.705 4.667-12.303 4.637-16.971-.068l-75.091-75.7c-4.667-4.705-4.637-12.303.068-16.971l22.719-22.536c4.705-4.667 12.303-4.637 16.97.069l44.104 44.461 111.072-110.181c4.705-4.667 12.303-4.637 16.971.068l22.536 22.718c4.667 4.706 4.636 12.303-.069 16.971z"
  ]
};
export const faFileCode = {
  prefix: "far",
  iconName: "file-code",
  icon: [
    384,
    512,
    [],
    "f1c9",
    "M149.9 349.1l-.2-.2-32.8-28.9 32.8-28.9c3.6-3.2 4-8.8.8-12.4l-.2-.2-17.4-18.6c-3.4-3.6-9-3.7-12.4-.4l-57.7 54.1c-3.7 3.5-3.7 9.4 0 12.8l57.7 54.1c1.6 1.5 3.8 2.4 6 2.4 2.4 0 4.8-1 6.4-2.8l17.4-18.6c3.3-3.5 3.1-9.1-.4-12.4zm220-251.2L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM256 51.9l76.1 76.1H256zM336 464H48V48h160v104c0 13.3 10.7 24 24 24h104zM209.6 214c-4.7-1.4-9.5 1.3-10.9 6L144 408.1c-1.4 4.7 1.3 9.6 6 10.9l24.4 7.1c4.7 1.4 9.6-1.4 10.9-6L240 231.9c1.4-4.7-1.3-9.6-6-10.9zm24.5 76.9l.2.2 32.8 28.9-32.8 28.9c-3.6 3.2-4 8.8-.8 12.4l.2.2 17.4 18.6c3.3 3.5 8.9 3.7 12.4.4l57.7-54.1c3.7-3.5 3.7-9.4 0-12.8l-57.7-54.1c-3.5-3.3-9.1-3.2-12.4.4l-17.4 18.6c-3.3 3.5-3.1 9.1.4 12.4z"
  ]
};
export const faFileContract = {
  prefix: "far",
  iconName: "file-contract",
  icon: [
    384,
    512,
    [],
    "f56c",
    "M196.66 363.33l-13.88-41.62c-3.28-9.81-12.44-16.41-22.78-16.41s-19.5 6.59-22.78 16.41L119 376.36c-1.5 4.58-5.78 7.64-10.59 7.64H96c-8.84 0-16 7.16-16 16s7.16 16 16 16h12.41c18.62 0 35.09-11.88 40.97-29.53L160 354.58l16.81 50.48a15.994 15.994 0 0 0 14.06 10.89c.38.03.75.05 1.12.05 6.03 0 11.59-3.41 14.31-8.86l7.66-15.33c2.78-5.59 7.94-6.19 10.03-6.19s7.25.59 10.19 6.53c7.38 14.7 22.19 23.84 38.62 23.84H288c8.84 0 16-7.16 16-16s-7.16-16-16-16h-15.19c-4.28 0-8.12-2.38-10.16-6.5-11.93-23.85-46.24-30.33-65.99-14.16zM369.83 97.98L285.94 14.1c-9-9-21.2-14.1-33.89-14.1H47.99C21.5.1 0 21.6 0 48.09v415.92C0 490.5 21.5 512 47.99 512h287.94c26.5 0 48.07-21.5 48.07-47.99V131.97c0-12.69-5.17-24.99-14.17-33.99zM255.95 51.99l76.09 76.08h-76.09V51.99zM336 464.01H47.99V48.09h159.97v103.98c0 13.3 10.7 23.99 24 23.99H336v287.95zM88 112h80c4.42 0 8-3.58 8-8V88c0-4.42-3.58-8-8-8H88c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8zm0 64h80c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8H88c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8z"
  ]
};
export const faFileCsv = {
  prefix: "far",
  iconName: "file-csv",
  icon: [
    384,
    512,
    [],
    "f6dd",
    "M369.83 97.98L285.94 14.1c-9-9-21.2-14.1-33.89-14.1H47.99C21.5.1 0 21.6 0 48.09v415.92C0 490.5 21.5 512 47.99 512h287.94c26.5 0 48.07-21.5 48.07-47.99V131.97c0-12.69-5.17-24.99-14.17-33.99zM255.95 51.99l76.09 76.08h-76.09V51.99zM336 464.01H47.99V48.09h159.97v103.98c0 13.3 10.7 23.99 24 23.99H336v287.95zM224 264v20.8c0 35.48 12.88 68.89 36.28 94.09 3.02 3.25 7.27 5.11 11.72 5.11s8.7-1.86 11.72-5.11c23.41-25.2 36.28-58.61 36.28-94.09V264c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v20.8c0 20.27-5.7 40.17-16 56.88-10.3-16.7-16-36.61-16-56.88V264c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8zm-104-8h-8c-26.51 0-48 21.49-48 48v32c0 26.51 21.49 48 48 48h8c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8h-8c-8.84 0-16-7.16-16-16v-32c0-8.84 7.16-16 16-16h8c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8zm59.45 42.47c-1.38-1.19-2.12-2.55-2.12-3.84 0-3.12 4.45-6.62 10.41-6.62H200c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8h-12.27c-23.39 0-42.41 17.33-42.41 38.62 0 10.66 4.86 20.92 13.33 28.14l21.89 18.77c1.38 1.19 2.12 2.55 2.12 3.84 0 3.12-4.45 6.62-10.41 6.62H160c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h12.27c23.39 0 42.41-17.33 42.41-38.62 0-10.66-4.86-20.92-13.33-28.14l-21.9-18.77z"
  ]
};
export const faFileDownload = {
  prefix: "far",
  iconName: "file-download",
  icon: [
    384,
    512,
    [],
    "f56d",
    "M216 236.07c0-6.63-5.37-12-12-12h-24c-6.63 0-12 5.37-12 12v84.01h-48.88c-10.71 0-16.05 12.97-8.45 20.52l72.31 71.77c4.99 4.95 13.04 4.95 18.03 0l72.31-71.77c7.6-7.54 2.26-20.52-8.45-20.52H216v-84.01zM369.83 97.98L285.94 14.1c-9-9-21.2-14.1-33.89-14.1H47.99C21.5.1 0 21.6 0 48.09v415.92C0 490.5 21.5 512 47.99 512h287.94c26.5 0 48.07-21.5 48.07-47.99V131.97c0-12.69-5.17-24.99-14.17-33.99zM255.95 51.99l76.09 76.08h-76.09V51.99zM336 464.01H47.99V48.09h159.97v103.98c0 13.3 10.7 23.99 24 23.99H336v287.95z"
  ]
};
export const faFileEdit = {
  prefix: "far",
  iconName: "file-edit",
  icon: [
    384,
    512,
    [],
    "f31c",
    "M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm163.1-229.9l46.8 46.8c2 2 2 5.2 0 7.2L143.4 402.6 95.2 408c-6.4.7-11.9-4.7-11.2-11.2l5.4-48.2 114.5-114.5c2-2 5.2-2 7.2 0zm83 17.8l-19.5 19.5c-2 2-5.2 2-7.2 0l-46.8-46.8c-2-2-2-5.2 0-7.2l19.5-19.5c7.9-7.9 20.7-7.9 28.6 0l25.4 25.4c7.9 7.9 7.9 20.7 0 28.6z"
  ]
};
export const faFileExcel = {
  prefix: "far",
  iconName: "file-excel",
  icon: [
    384,
    512,
    [],
    "f1c3",
    "M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm212-240h-28.8c-4.4 0-8.4 2.4-10.5 6.3-18 33.1-22.2 42.4-28.6 57.7-13.9-29.1-6.9-17.3-28.6-57.7-2.1-3.9-6.2-6.3-10.6-6.3H124c-9.3 0-15 10-10.4 18l46.3 78-46.3 78c-4.7 8 1.1 18 10.4 18h28.9c4.4 0 8.4-2.4 10.5-6.3 21.7-40 23-45 28.6-57.7 14.9 30.2 5.9 15.9 28.6 57.7 2.1 3.9 6.2 6.3 10.6 6.3H260c9.3 0 15-10 10.4-18L224 320c.7-1.1 30.3-50.5 46.3-78 4.7-8-1.1-18-10.3-18z"
  ]
};
export const faFileExclamation = {
  prefix: "far",
  iconName: "file-exclamation",
  icon: [
    384,
    512,
    [],
    "f31a",
    "M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm108.6-251.3l6.5 104c.4 6.3 5.6 11.3 12 11.3h33.8c6.3 0 11.6-4.9 12-11.3l6.5-104c.4-6.9-5.1-12.7-12-12.7h-46.8c-6.9 0-12.4 5.8-12 12.7zM232 384c0 22.1-17.9 40-40 40s-40-17.9-40-40 17.9-40 40-40 40 17.9 40 40z"
  ]
};
export const faFileExport = {
  prefix: "far",
  iconName: "file-export",
  icon: [
    576,
    512,
    [],
    "f56e",
    "M572.29 279.06l-71.77-72.31c-7.55-7.6-20.52-2.26-20.52 8.45v48.88h-96v-132.1c0-12.7-5.17-25-14.17-33.99L285.94 14.1c-9-9-21.2-14.1-33.89-14.1H47.99C21.5.1 0 21.6 0 48.09v415.92C0 490.5 21.5 512 47.99 512h287.94c26.5 0 48.07-21.5 48.07-47.99V360.07h-48v103.94H47.99V48.09h159.97v103.98c0 13.3 10.7 23.99 24 23.99H336v88.01H172c-6.63 0-12 5.37-12 12v24c0 6.63 5.37 12 12 12h308v48.88c0 10.71 12.97 16.05 20.52 8.45l71.77-72.31c4.95-4.99 4.95-13.04 0-18.03zM255.95 128.07V51.99l76.09 76.08h-76.09z"
  ]
};
export const faFileImage = {
  prefix: "far",
  iconName: "file-image",
  icon: [
    384,
    512,
    [],
    "f1c5",
    "M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm32-48h224V288l-23.5-23.5c-4.7-4.7-12.3-4.7-17 0L176 352l-39.5-39.5c-4.7-4.7-12.3-4.7-17 0L80 352v64zm48-240c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48z"
  ]
};
export const faFileImport = {
  prefix: "far",
  iconName: "file-import",
  icon: [
    512,
    512,
    [],
    "f56f",
    "M497.83 97.98L413.94 14.1c-9-9-21.2-14.1-33.89-14.1H175.99C149.5.1 128 21.6 128 48.09v215.98H12c-6.63 0-12 5.37-12 12v24c0 6.63 5.37 12 12 12h276v48.88c0 10.71 12.97 16.05 20.52 8.45l71.77-72.31c4.95-4.99 4.95-13.04 0-18.03l-71.77-72.31c-7.55-7.6-20.52-2.26-20.52 8.45v48.88H175.99V48.09h159.97v103.98c0 13.3 10.7 23.99 24 23.99H464v287.95H175.99V360.07H128v103.94c0 26.49 21.5 47.99 47.99 47.99h287.94c26.5 0 48.07-21.5 48.07-47.99V131.97c0-12.69-5.17-24.99-14.17-33.99zm-113.88 30.09V51.99l76.09 76.08h-76.09z"
  ]
};
export const faFileInvoice = {
  prefix: "far",
  iconName: "file-invoice",
  icon: [
    384,
    512,
    [],
    "f570",
    "M296 400h-80c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h80c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8zM80 240v96c0 8.84 7.16 16 16 16h192c8.84 0 16-7.16 16-16v-96c0-8.84-7.16-16-16-16H96c-8.84 0-16 7.16-16 16zm32 16h160v64H112v-64zM369.83 97.98L285.94 14.1c-9-9-21.2-14.1-33.89-14.1H47.99C21.5.1 0 21.6 0 48.09v415.92C0 490.5 21.5 512 47.99 512h287.94c26.5 0 48.07-21.5 48.07-47.99V131.97c0-12.69-5.17-24.99-14.17-33.99zM255.95 51.99l76.09 76.08h-76.09V51.99zM336 464.01H47.99V48.09h159.97v103.98c0 13.3 10.7 23.99 24 23.99H336v287.95zM88 112h80c4.42 0 8-3.58 8-8V88c0-4.42-3.58-8-8-8H88c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8zm0 64h80c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8H88c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8z"
  ]
};
export const faFileInvoiceDollar = {
  prefix: "far",
  iconName: "file-invoice-dollar",
  icon: [
    384,
    512,
    [],
    "f571",
    "M369.83 97.98L285.94 14.1c-9-9-21.2-14.1-33.89-14.1H47.99C21.5.1 0 21.6 0 48.09v415.92C0 490.5 21.5 512 47.99 512h287.94c26.5 0 48.07-21.5 48.07-47.99V131.97c0-12.69-5.17-24.99-14.17-33.99zM255.95 51.99l76.09 76.08h-76.09V51.99zM336 464.01H47.99V48.09h159.97v103.98c0 13.3 10.7 23.99 24 23.99H336v287.95zM208 216c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v24.12c-23.62.63-42.67 20.55-42.67 45.07 0 19.97 12.98 37.81 31.58 43.39l45 13.5c5.16 1.55 8.77 6.78 8.77 12.73 0 7.27-5.3 13.19-11.8 13.19h-28.11c-4.56 0-8.96-1.29-12.82-3.72-3.24-2.03-7.36-1.91-10.13.73l-11.75 11.21c-3.53 3.37-3.33 9.21.57 12.14 9.1 6.83 20.08 10.77 31.37 11.35V424c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-24.12c23.62-.63 42.67-20.54 42.67-45.07 0-19.97-12.98-37.81-31.58-43.39l-45-13.5c-5.16-1.55-8.77-6.78-8.77-12.73 0-7.27 5.3-13.19 11.8-13.19h28.11c4.56 0 8.96 1.29 12.82 3.72 3.24 2.03 7.36 1.91 10.13-.73l11.75-11.21c3.53-3.37 3.33-9.21-.57-12.14-9.1-6.83-20.08-10.77-31.37-11.35V216zM88 112h80c4.42 0 8-3.58 8-8V88c0-4.42-3.58-8-8-8H88c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8zm88 56v-16c0-4.42-3.58-8-8-8H88c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h80c4.42 0 8-3.58 8-8z"
  ]
};
export const faFileMedical = {
  prefix: "far",
  iconName: "file-medical",
  icon: [
    384,
    512,
    [],
    "f477",
    "M224 232c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v56h-56c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h56v56c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-56h56c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8h-56v-56zM369.8 98l-83.9-83.9C276.9 5.1 264.7 0 252 0H48C21.5.1 0 21.6 0 48.1V464c0 26.5 21.5 48 48 48h287.9c26.5 0 48.1-21.5 48.1-48V132c0-12.7-5.2-25-14.2-34zM255.9 52l76.1 76.1h-76.1V52zM336 464H48V48.1h160v104c0 13.3 10.7 24 24 24h104V464z"
  ]
};
export const faFileMedicalAlt = {
  prefix: "far",
  iconName: "file-medical-alt",
  icon: [
    448,
    512,
    [],
    "f478",
    "M433.9 98l-84-84c-9-9-21.1-14-33.8-14h-204C85.6.1 64 21.6 64 48.1V272H16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h113.2l32.5 65.1c5.9 11.8 22.7 11.8 28.6 0l49.7-99.4 17.2 34.3H344c13.2 0 24-10.8 24-24s-10.8-24-24-24h-57.2l-32.5-65.1c-5.9-11.8-22.7-11.8-28.6 0L176 306.3 158.9 272H112V48.1h160v104c0 13.3 10.7 24 24 24h104V464H112.1v-96H64v96c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V132c0-12.8-5.1-25-14.1-34zM320 128.1V52l76.1 76.1H320z"
  ]
};
export const faFileMinus = {
  prefix: "far",
  iconName: "file-minus",
  icon: [
    384,
    512,
    [],
    "f318",
    "M369.9,98,286,14.1A48,48,0,0,0,252.1,0H48A48.16,48.16,0,0,0,0,48.1v416a48,48,0,0,0,48,48H336a48,48,0,0,0,48-48V132A48.23,48.23,0,0,0,369.9,98ZM256,52l76.1,76.1H256Zm80,412.1H48V48.1H208v104a23.94,23.94,0,0,0,24,24H336ZM111.48,280.35a16,16,0,0,0-16,16v16a16,16,0,0,0,16,16h160a16,16,0,0,0,16-16v-16a16,16,0,0,0-16-16Z"
  ]
};
export const faFileMusic = {
  prefix: "far",
  iconName: "file-music",
  icon: [
    384,
    512,
    [],
    "f8b6",
    "M144 271.29V370a69.27 69.27 0 0 0-16-2c-26.5 0-48 14.32-48 32s21.5 32 48 32 48-14.32 48-32v-84.81l96-37.51V338a69.82 69.82 0 0 0-16-2c-26.5 0-48 14.33-48 32s21.5 32 48 32 48-14.32 48-32V224a16 16 0 0 0-20.81-15.24l-128 47.24A16 16 0 0 0 144 271.29zM369.91 98L286 14.09A48 48 0 0 0 252.09 0H48A48.15 48.15 0 0 0 0 48.08V464a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V132a48.22 48.22 0 0 0-14.09-34zM256 52l76.09 76.08H256zm80 412H48V48.08h160v104a23.93 23.93 0 0 0 24 24h104z"
  ]
};
export const faFilePdf = {
  prefix: "far",
  iconName: "file-pdf",
  icon: [
    384,
    512,
    [],
    "f1c1",
    "M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm250.2-143.7c-12.2-12-47-8.7-64.4-6.5-17.2-10.5-28.7-25-36.8-46.3 3.9-16.1 10.1-40.6 5.4-56-4.2-26.2-37.8-23.6-42.6-5.9-4.4 16.1-.4 38.5 7 67.1-10 23.9-24.9 56-35.4 74.4-20 10.3-47 26.2-51 46.2-3.3 15.8 26 55.2 76.1-31.2 22.4-7.4 46.8-16.5 68.4-20.1 18.9 10.2 41 17 55.8 17 25.5 0 28-28.2 17.5-38.7zm-198.1 77.8c5.1-13.7 24.5-29.5 30.4-35-19 30.3-30.4 35.7-30.4 35zm81.6-190.6c7.4 0 6.7 32.1 1.8 40.8-4.4-13.9-4.3-40.8-1.8-40.8zm-24.4 136.6c9.7-16.9 18-37 24.7-54.7 8.3 15.1 18.9 27.2 30.1 35.5-20.8 4.3-38.9 13.1-54.8 19.2zm131.6-5s-5 6-37.3-7.8c35.1-2.6 40.9 5.4 37.3 7.8z"
  ]
};
export const faFilePlus = {
  prefix: "far",
  iconName: "file-plus",
  icon: [
    384,
    512,
    [],
    "f319",
    "M369.9,97.9,286,14A48,48,0,0,0,252.1-.1H48A48.16,48.16,0,0,0,0,48V464a48,48,0,0,0,48,48H336a48,48,0,0,0,48-48V131.9A48.23,48.23,0,0,0,369.9,97.9ZM256,51.9,332.1,128H256ZM336,464H48V48H208V152a23.94,23.94,0,0,0,24,24H336ZM215,223.75a16,16,0,0,0-16-16H183a16,16,0,0,0-16,16v56.5h-55.5a16,16,0,0,0-16,16v16a16,16,0,0,0,16,16H167v56a16,16,0,0,0,16,16h16a16,16,0,0,0,16-16v-56h56.5a16,16,0,0,0,16-16v-16a16,16,0,0,0-16-16H215Z"
  ]
};
export const faFilePowerpoint = {
  prefix: "far",
  iconName: "file-powerpoint",
  icon: [
    384,
    512,
    [],
    "f1c4",
    "M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm72-60V236c0-6.6 5.4-12 12-12h69.2c36.7 0 62.8 27 62.8 66.3 0 74.3-68.7 66.5-95.5 66.5V404c0 6.6-5.4 12-12 12H132c-6.6 0-12-5.4-12-12zm48.5-87.4h23c7.9 0 13.9-2.4 18.1-7.2 8.5-9.8 8.4-28.5.1-37.8-4.1-4.6-9.9-7-17.4-7h-23.9v52z"
  ]
};
export const faFilePrescription = {
  prefix: "far",
  iconName: "file-prescription",
  icon: [
    384,
    512,
    [],
    "f572",
    "M369.83 97.98L285.94 14.1c-9-9-21.2-14.1-33.89-14.1H47.99C21.5.1 0 21.6 0 48.09v415.92C0 490.5 21.5 512 47.99 512h287.94c26.5 0 48.07-21.5 48.07-47.99V131.97c0-12.69-5.17-24.99-14.17-33.99zM255.95 51.99l76.09 76.08h-76.09V51.99zM336 464.01H47.99V48.09h159.97v103.98c0 13.3 10.7 23.99 24 23.99H336v287.95zM224.97 330.34l-32.3-32.3C211.17 288.9 224 270.03 224 248c0-30.93-25.07-56-56-56h-64c-4.42 0-8 3.58-8 8v144c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-40h25.37l48.97 48.97c-1.15.38-2.4.46-3.31 1.37l-36.69 36.69c-3.12 3.12-3.12 8.19 0 11.31l11.31 11.31c3.12 3.12 8.19 3.12 11.31 0l36.69-36.69c.92-.92.99-2.16 1.37-3.31l40 40c3.12 3.12 8.19 3.12 11.31 0l11.31-11.31c3.12-3.12 3.12-8.19 0-11.31l-40-40c1.15-.38 2.4-.46 3.31-1.37l36.69-36.69c3.12-3.12 3.12-8.19 0-11.31l-11.31-11.31c-3.12-3.12-8.19-3.12-11.31 0l-36.69 36.69c-.9.9-.98 2.15-1.36 3.3zM168 272h-40v-48h40c13.23 0 24 10.77 24 24s-10.77 24-24 24z"
  ]
};
export const faFileSearch = {
  prefix: "far",
  iconName: "file-search",
  icon: [
    640,
    512,
    [],
    "f865",
    "M603.32 473.39l-81.48-81.46a128 128 0 1 0-33.93 33.93l81.48 81.46a16 16 0 0 0 22.62 0L603.32 496a16 16 0 0 0 0-22.61zM416 400a80 80 0 1 1 80-80 80.09 80.09 0 0 1-80 80zM80 464V48.09h160v104a23.93 23.93 0 0 0 24 24h83.29c20.89-10 44-16.06 68.71-16.06V132a48.23 48.23 0 0 0-14.1-34L318 14.1A48 48 0 0 0 284.1 0H80a48.16 48.16 0 0 0-48 48.09V464a48 48 0 0 0 48 48h288a47.86 47.86 0 0 0 45.15-32.29A158.48 158.48 0 0 1 347.43 464zM288 52l76.1 76.08H288z"
  ]
};
export const faFileSignature = {
  prefix: "far",
  iconName: "file-signature",
  icon: [
    576,
    512,
    [],
    "f573",
    "M568.54 167.33l-31.87-31.87c-9.94-9.94-26.07-9.94-36.01 0l-27.25 27.25 67.88 67.88 27.25-27.25c9.95-9.94 9.95-26.07 0-36.01zM329.06 306a63.974 63.974 0 0 0-16.26 27.11L297.57 384h-24.76c-4.28 0-8.12-2.38-10.16-6.5-11.97-23.86-46.28-30.34-66-14.17l-13.88-41.62c-3.28-9.81-12.44-16.41-22.78-16.41s-19.5 6.59-22.78 16.41L119 376.36c-1.5 4.58-5.78 7.64-10.59 7.64H96c-8.84 0-16 7.16-16 16s7.16 16 16 16h12.41c18.62 0 35.09-11.88 40.97-29.53L160 354.58l16.81 50.48a15.994 15.994 0 0 0 14.06 10.89c.38.03.75.05 1.12.05 6.03 0 11.59-3.41 14.31-8.86l7.66-15.33c2.78-5.59 7.94-6.19 10.03-6.19s7.25.59 10.19 6.53c7.38 14.7 22.19 23.84 38.62 23.84H336V464H47.99V48.09h159.97v103.98c0 13.3 10.7 23.99 24 23.99H336v78l48-47.58v-74.5c0-12.7-5.17-25-14.17-33.99L285.94 14.1c-9-9-21.2-14.1-33.89-14.1H47.99C21.5.1 0 21.6 0 48.09v415.92C0 490.5 21.5 512 47.99 512h287.94c26.5 0 48.07-21.5 48.07-47.99V388.8l134.66-135.58-67.88-67.88L329.06 306zM255.95 51.99l76.09 76.08h-76.09V51.99z"
  ]
};
export const faFileSpreadsheet = {
  prefix: "far",
  iconName: "file-spreadsheet",
  icon: [
    384,
    512,
    [],
    "f65b",
    "M80 240v176c0 8.84 7.16 16 16 16h192c8.84 0 16-7.16 16-16V240c0-8.84-7.16-16-16-16H96c-8.84 0-16 7.16-16 16zm128 32h64v48h-64v-48zm0 80h64v48h-64v-48zm-96-80h64v48h-64v-48zm0 80h64v48h-64v-48zM369.83 97.98L285.94 14.1c-9-9-21.2-14.1-33.89-14.1H47.99C21.5.1 0 21.6 0 48.09v415.92C0 490.5 21.5 512 47.99 512h287.94c26.5 0 48.07-21.5 48.07-47.99V131.97c0-12.69-5.17-24.99-14.17-33.99zM255.95 51.99l76.09 76.08h-76.09V51.99zM336 464.01H47.99V48.09h159.97v103.98c0 13.3 10.7 23.99 24 23.99H336v287.95z"
  ]
};
export const faFileTimes = {
  prefix: "far",
  iconName: "file-times",
  icon: [
    384,
    512,
    [],
    "f317",
    "M369.9,98,286,14.1A48,48,0,0,0,252.1,0H48A48.16,48.16,0,0,0,0,48.1v416a48,48,0,0,0,48,48H336a48,48,0,0,0,48-48V132A48.23,48.23,0,0,0,369.9,98ZM256,52l76.1,76.1H256Zm80,412.1H48V48.1H208v104a23.94,23.94,0,0,0,24,24H336ZM264.85,264a16,16,0,0,0,0-22.63L253.53,230a16,16,0,0,0-22.63,0l-40,40-39.24-39.24a16,16,0,0,0-22.63,0l-11.31,11.31a16,16,0,0,0,0,22.63L157,303.92l-39.6,39.6a16,16,0,0,0,0,22.63l11.32,11.31a16,16,0,0,0,22.63,0L191,337.86l40,40a16,16,0,0,0,22.63,0l11.32-11.32a16,16,0,0,0,0-22.63l-40-39.95Z"
  ]
};
export const faFileUpload = {
  prefix: "far",
  iconName: "file-upload",
  icon: [
    384,
    512,
    [],
    "f574",
    "M369.83 97.98L285.94 14.1c-9-9-21.2-14.1-33.89-14.1H47.99C21.5.1 0 21.6 0 48.09v415.92C0 490.5 21.5 512 47.99 512h287.94c26.5 0 48.07-21.5 48.07-47.99V131.97c0-12.69-5.17-24.99-14.17-33.99zM255.95 51.99l76.09 76.08h-76.09V51.99zM336 464.01H47.99V48.09h159.97v103.98c0 13.3 10.7 23.99 24 23.99H336v287.95zM182.98 227.79l-72.31 71.77c-7.6 7.54-2.26 20.52 8.45 20.52H168v84c0 6.63 5.37 12 12 12h24c6.63 0 12-5.37 12-12v-84h48.88c10.71 0 16.05-12.97 8.45-20.52l-72.31-71.77c-4.99-4.95-13.05-4.95-18.04 0z"
  ]
};
export const faFileUser = {
  prefix: "far",
  iconName: "file-user",
  icon: [
    384,
    512,
    [],
    "f65c",
    "M369.83 97.98L285.94 14.1c-9-9-21.2-14.1-33.89-14.1H47.99C21.5.1 0 21.6 0 48.09v415.92C0 490.5 21.5 512 47.99 512h287.94c26.5 0 48.07-21.5 48.07-47.99V131.97c0-12.69-5.17-24.99-14.17-33.99zM255.95 51.99l76.09 76.08h-76.09V51.99zM336 464.01H47.99V48.09h159.97v103.98c0 13.3 10.7 23.99 24 23.99H336v287.95zM128 272c0 35.35 28.65 64 64 64s64-28.65 64-64-28.65-64-64-64-64 28.65-64 64zm103.85 80c-12.29 5.12-25.73 8-39.85 8s-27.56-2.88-39.85-8h-4.95c-37.11 0-67.2 25.79-67.2 57.6v6.4c0 8.84 7.16 16 16 16h192c8.84 0 16-7.16 16-16v-6.4c0-31.81-30.09-57.6-67.2-57.6h-4.95z"
  ]
};
export const faFileVideo = {
  prefix: "far",
  iconName: "file-video",
  icon: [
    384,
    512,
    [],
    "f1c8",
    "M369.941 97.941l-83.882-83.882A48 48 0 0 0 252.118 0H48C21.49 0 0 21.49 0 48v416c0 26.51 21.49 48 48 48h288c26.51 0 48-21.49 48-48V131.882a48 48 0 0 0-14.059-33.941zM332.118 128H256V51.882L332.118 128zM48 464V48h160v104c0 13.255 10.745 24 24 24h104v288H48zm228.687-211.303L224 305.374V268c0-11.046-8.954-20-20-20H100c-11.046 0-20 8.954-20 20v104c0 11.046 8.954 20 20 20h104c11.046 0 20-8.954 20-20v-37.374l52.687 52.674C286.704 397.318 304 390.28 304 375.986V264.011c0-14.311-17.309-21.319-27.313-11.314z"
  ]
};
export const faFileWord = {
  prefix: "far",
  iconName: "file-word",
  icon: [
    384,
    512,
    [],
    "f1c2",
    "M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm220.1-208c-5.7 0-10.6 4-11.7 9.5-20.6 97.7-20.4 95.4-21 103.5-.2-1.2-.4-2.6-.7-4.3-.8-5.1.3.2-23.6-99.5-1.3-5.4-6.1-9.2-11.7-9.2h-13.3c-5.5 0-10.3 3.8-11.7 9.1-24.4 99-24 96.2-24.8 103.7-.1-1.1-.2-2.5-.5-4.2-.7-5.2-14.1-73.3-19.1-99-1.1-5.6-6-9.7-11.8-9.7h-16.8c-7.8 0-13.5 7.3-11.7 14.8 8 32.6 26.7 109.5 33.2 136 1.3 5.4 6.1 9.1 11.7 9.1h25.2c5.5 0 10.3-3.7 11.6-9.1l17.9-71.4c1.5-6.2 2.5-12 3-17.3l2.9 17.3c.1.4 12.6 50.5 17.9 71.4 1.3 5.3 6.1 9.1 11.6 9.1h24.7c5.5 0 10.3-3.7 11.6-9.1 20.8-81.9 30.2-119 34.5-136 1.9-7.6-3.8-14.9-11.6-14.9h-15.8z"
  ]
};
export const faFilesMedical = {
  prefix: "far",
  iconName: "files-medical",
  icon: [
    448,
    512,
    [],
    "f7fd",
    "M433.94 65.94l-51.88-51.88A48 48 0 0 0 348.12 0H176a48 48 0 0 0-48 48v48H48a48 48 0 0 0-48 48v320a48 48 0 0 0 48 48h224a48 48 0 0 0 48-48v-48h80a48 48 0 0 0 48-48V99.88a48 48 0 0 0-14.06-33.94zM352 51.88L396.12 96H352zM272 458a6 6 0 0 1-6 6H54a6 6 0 0 1-6-6V150a6 6 0 0 1 6-6h74v224a48 48 0 0 0 48 48h96zm128-96a6 6 0 0 1-6 6H182a6 6 0 0 1-6-6V54a6 6 0 0 1 6-6h122v64a32 32 0 0 0 32 32h64zm-85.33-179.34A6.67 6.67 0 0 0 308 176h-40a6.67 6.67 0 0 0-6.67 6.66v46.67h-46.66A6.67 6.67 0 0 0 208 236v40a6.67 6.67 0 0 0 6.67 6.66h46.66v46.67A6.67 6.67 0 0 0 268 336h40a6.67 6.67 0 0 0 6.67-6.67v-46.67h46.66A6.67 6.67 0 0 0 368 276v-40a6.67 6.67 0 0 0-6.67-6.67h-46.66z"
  ]
};
export const faFill = {
  prefix: "far",
  iconName: "fill",
  icon: [
    512,
    512,
    [],
    "f575",
    "M502.63 217.06L294.94 9.37A31.94 31.94 0 0 0 272.31 0c-8.19 0-16.38 3.12-22.62 9.37L162.5 96.56 70.62 4.69c-6.25-6.25-16.38-6.25-22.63 0L36.69 16c-6.25 6.25-6.25 16.38 0 22.63l91.88 91.88L28.11 230.95c-37.49 37.48-37.49 98.26 0 135.75L145.3 483.89c18.74 18.74 43.31 28.12 67.87 28.12 24.57 0 49.13-9.37 67.87-28.12l221.57-221.57c12.51-12.51 12.51-32.76.02-45.26zM247.11 449.95C238.05 459.01 226 464 213.18 464s-24.87-4.99-33.93-14.05L65.3 336h295.75L247.11 449.95zM409.06 288H49.34c2-8.67 6.27-16.67 12.71-23.11L162.5 164.44l69.9 69.9c9.37 9.37 24.56 9.37 33.94 0 9.37-9.37 9.37-24.57 0-33.94l-69.9-69.9 75.87-75.87 185.06 185.06L409.06 288z"
  ]
};
export const faFillDrip = {
  prefix: "far",
  iconName: "fill-drip",
  icon: [
    576,
    512,
    [],
    "f576",
    "M512 320s-64 92.65-64 128c0 35.35 28.66 64 64 64s64-28.65 64-64-64-128-64-128zm-9.37-102.94L294.94 9.37A31.94 31.94 0 0 0 272.31 0c-8.19 0-16.38 3.12-22.62 9.37L162.5 96.56 70.62 4.69c-6.25-6.25-16.38-6.25-22.63 0L36.69 16c-6.25 6.25-6.25 16.38 0 22.63l91.88 91.88L28.11 230.95c-37.49 37.48-37.49 98.26 0 135.75L145.3 483.89c18.74 18.74 43.31 28.12 67.87 28.12 24.57 0 49.13-9.37 67.87-28.12l221.57-221.57c12.51-12.51 12.51-32.76.02-45.26zM247.11 449.95C238.05 459.01 226 464 213.18 464s-24.87-4.99-33.93-14.05L65.3 336h295.75L247.11 449.95zM409.06 288H49.34c2-8.67 6.27-16.67 12.71-23.11L162.5 164.44l69.9 69.9c9.37 9.37 24.56 9.37 33.94 0 9.37-9.37 9.37-24.57 0-33.94l-69.9-69.9 75.87-75.87 185.05 185.06-48.3 48.31z"
  ]
};
export const faFilm = {
  prefix: "far",
  iconName: "film",
  icon: [
    512,
    512,
    [],
    "f008",
    "M488 64h-8v20c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12V64H96v20c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12V64h-8C10.7 64 0 74.7 0 88v336c0 13.3 10.7 24 24 24h8v-20c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v20h320v-20c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v20h8c13.3 0 24-10.7 24-24V88c0-13.3-10.7-24-24-24zM96 372c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm288 208c0 6.6-5.4 12-12 12H140c-6.6 0-12-5.4-12-12v-96c0-6.6 5.4-12 12-12h232c6.6 0 12 5.4 12 12v96zm0-168c0 6.6-5.4 12-12 12H140c-6.6 0-12-5.4-12-12v-96c0-6.6 5.4-12 12-12h232c6.6 0 12 5.4 12 12v96zm96 152c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40z"
  ]
};
export const faFilmAlt = {
  prefix: "far",
  iconName: "film-alt",
  icon: [
    512,
    512,
    [],
    "f3a0",
    "M488 64h-8v20c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12V64H96v20c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12V64h-8C10.7 64 0 74.7 0 88v336c0 13.3 10.7 24 24 24h8v-20c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v20h320v-20c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v20h8c13.3 0 24-10.7 24-24V88c0-13.3-10.7-24-24-24zM96 372c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm280 208c0 6.6-5.4 12-12 12H148c-6.6 0-12-5.4-12-12V124c0-6.6 5.4-12 12-12h216c6.6 0 12 5.4 12 12v264zm104-16c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40z"
  ]
};
export const faFilmCanister = {
  prefix: "far",
  iconName: "film-canister",
  icon: [
    576,
    512,
    [],
    "f8b7",
    "M544 112H320V80h16a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-80V16a16 16 0 0 0-16-16H112a16 16 0 0 0-16 16v16H16A16 16 0 0 0 0 48v16a16 16 0 0 0 16 16h16v384H16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16h-16v-32h160a32 32 0 0 0 32-32v-48a32 32 0 0 1 32-32 32 32 0 0 0 32-32V144a32 32 0 0 0-32-32zM80 464V80h192v384zm344-104a16 16 0 0 1-16 16h-16a16 16 0 0 1-16-16v-16a16 16 0 0 1 16-16h16a16 16 0 0 1 16 16zm0-160a16 16 0 0 1-16 16h-16a16 16 0 0 1-16-16v-16a16 16 0 0 1 16-16h16a16 16 0 0 1 16 16zm96 0a16 16 0 0 1-16 16h-16a16 16 0 0 1-16-16v-16a16 16 0 0 1 16-16h16a16 16 0 0 1 16 16z"
  ]
};
export const faFilter = {
  prefix: "far",
  iconName: "filter",
  icon: [
    512,
    512,
    [],
    "f0b0",
    "M463.952 0H48.057C5.419 0-16.094 51.731 14.116 81.941L176 243.882V416c0 15.108 7.113 29.335 19.2 40l64 47.066c31.273 21.855 76.8 1.538 76.8-38.4V243.882L497.893 81.941C528.042 51.792 506.675 0 463.952 0zM288 224v240l-64-48V224L48 48h416L288 224z"
  ]
};
export const faFingerprint = {
  prefix: "far",
  iconName: "fingerprint",
  icon: [
    512,
    512,
    [],
    "f577",
    "M256.12 245.96c-13.25 0-24 10.74-24 24 1.14 72.25-8.14 141.9-27.7 211.55-2.73 9.72 2.15 30.49 23.12 30.49 10.48 0 20.11-6.92 23.09-17.52 13.53-47.91 31.04-125.41 29.48-224.52.01-13.25-10.73-24-23.99-24zm-.86-81.73C194 164.16 151.25 211.3 152.1 265.32c.75 47.94-3.75 95.91-13.37 142.55-2.69 12.98 5.67 25.69 18.64 28.36 13.05 2.67 25.67-5.66 28.36-18.64 10.34-50.09 15.17-101.58 14.37-153.02-.41-25.95 19.92-52.49 54.45-52.34 31.31.47 57.15 25.34 57.62 55.47.77 48.05-2.81 96.33-10.61 143.55-2.17 13.06 6.69 25.42 19.76 27.58 19.97 3.33 26.81-15.1 27.58-19.77 8.28-50.03 12.06-101.21 11.27-152.11-.88-55.8-47.94-101.88-104.91-102.72zm-110.69-19.78c-10.3-8.34-25.37-6.8-33.76 3.48-25.62 31.5-39.39 71.28-38.75 112 .59 37.58-2.47 75.27-9.11 112.05-2.34 13.05 6.31 25.53 19.36 27.89 20.11 3.5 27.07-14.81 27.89-19.36 7.19-39.84 10.5-80.66 9.86-121.33-.47-29.88 9.2-57.88 28-80.97 8.35-10.28 6.79-25.39-3.49-33.76zm109.47-62.33c-15.41-.41-30.87 1.44-45.78 4.97-12.89 3.06-20.87 15.98-17.83 28.89 3.06 12.89 16 20.83 28.89 17.83 11.05-2.61 22.47-3.77 34-3.69 75.43 1.13 137.73 61.5 138.88 134.58.59 37.88-1.28 76.11-5.58 113.63-1.5 13.17 7.95 25.08 21.11 26.58 16.72 1.95 25.51-11.88 26.58-21.11a929.06 929.06 0 0 0 5.89-119.85c-1.56-98.75-85.07-180.33-186.16-181.83zm252.07 121.45c-2.86-12.92-15.51-21.2-28.61-18.27-12.94 2.86-21.12 15.66-18.26 28.61 4.71 21.41 4.91 37.41 4.7 61.6-.11 13.27 10.55 24.09 23.8 24.2h.2c13.17 0 23.89-10.61 24-23.8.18-22.18.4-44.11-5.83-72.34zm-40.12-90.72C417.29 43.46 337.6 1.29 252.81.02 183.02-.82 118.47 24.91 70.46 72.94 24.09 119.37-.9 181.04.14 246.65l-.12 21.47c-.39 13.25 10.03 24.31 23.28 24.69.23.02.48.02.72.02 12.92 0 23.59-10.3 23.97-23.3l.16-23.64c-.83-52.5 19.16-101.86 56.28-139 38.76-38.8 91.34-59.67 147.68-58.86 69.45 1.03 134.73 35.56 174.62 92.39 7.61 10.86 22.56 13.45 33.42 5.86 10.84-7.62 13.46-22.59 5.84-33.43z"
  ]
};
export const faFire = {
  prefix: "far",
  iconName: "fire",
  icon: [
    384,
    512,
    [],
    "f06d",
    "M216 24.01c0-23.8-31.16-33.11-44.15-13.04C76.55 158.25 200 238.73 200 288c0 22.06-17.94 40-40 40s-40-17.94-40-40V182.13c0-19.39-21.86-30.76-37.73-19.68C30.75 198.38 0 257.28 0 320c0 105.87 86.13 192 192 192s192-86.13 192-192c0-170.29-168-192.85-168-295.99zM192 464c-79.4 0-144-64.6-144-144 0-28.66 8.56-64.71 24-88v56c0 48.52 39.48 88 88 88s88-39.48 88-88c0-64.27-88-120-64-208 40 88 152 121.77 152 240 0 79.4-64.6 144-144 144z"
  ]
};
export const faFireAlt = {
  prefix: "far",
  iconName: "fire-alt",
  icon: [
    448,
    512,
    [],
    "f7e4",
    "M323.56 51.2c-20.8 19.3-39.58 39.59-56.22 59.97C240.08 73.62 206.28 35.53 168 0 69.74 91.17 0 209.96 0 281.6 0 408.85 100.29 512 224 512s224-103.15 224-230.4c0-53.27-51.98-163.14-124.44-230.4zM224 464c-97.05 0-176-81.83-176-182.4 0-45.37 44.3-133.21 120.16-214.09 22.34 23.36 42.82 47.72 60.34 71.86l36.62 50.44 39.41-48.29c5.83-7.15 11.85-14.15 18.01-20.97C368.89 177.96 400 250.42 400 281.6 400 382.17 321.05 464 224 464zm89.47-220.84l-51.3 58.52S181.75 198.98 175.69 192C133.27 242.86 112 272.62 112 306.41 112 374.23 163.37 416 226.5 416c25.26 0 48.62-7.87 67.58-21.13 43.08-30.14 53.18-88.58 29.26-134.24-2.95-5.62-6.24-11.48-9.87-17.47z"
  ]
};
export const faFireExtinguisher = {
  prefix: "far",
  iconName: "fire-extinguisher",
  icon: [
    448,
    512,
    [],
    "f134",
    "M420.054 20.658l-144 24C264.919 46.514 256 54.906 256 72h-58.332C208.353 36.108 181.446 0 144 0c-39.435 0-66.368 39.676-52.228 76.203-52.039 13.051-75.381 54.213-90.049 90.884-4.923 12.307 1.063 26.274 13.37 31.197 12.317 4.926 26.279-1.075 31.196-13.37C75.058 112.99 106.964 120 168 120v27.076c-41.543 10.862-72 49.235-72 94.129V488c0 13.255 10.745 24 24 24h144c13.255 0 24-10.745 24-24V240c0-44.731-30.596-82.318-72-92.975V120h40c0 16.871 8.727 25.454 20.054 27.342l144 24C434.681 173.78 448 162.501 448 147.669V44.331c0-14.829-13.316-26.112-27.946-23.673zM144 72c-8.822 0-16-7.178-16-16s7.178-16 16-16 16 7.178 16 16-7.178 16-16 16zm96 168v224h-96V241.205c0-26.936 21.366-49.009 47.632-49.204L192 192c26.467 0 48 21.533 48 48zm168-111.218l-112-18.667v-28.23l112-18.667v65.564z"
  ]
};
export const faFireSmoke = {
  prefix: "far",
  iconName: "fire-smoke",
  icon: [
    576,
    512,
    [],
    "f74b",
    "M456 272c-27.3 0-53.1 9.2-74 25.8-23.9-26.3-57.8-41.8-94-41.8s-70.1 15.5-94 41.8c-20.9-16.6-46.6-25.8-74-25.8C53.8 272 0 325.8 0 392s53.8 120 120 120h336c66.2 0 120-53.8 120-120s-53.8-120-120-120zm0 192H120c-39.7 0-72-32.3-72-72s32.3-72 72-72c22.7 0 43.7 10.7 57.6 29.3l22.5 30.2 17.9-33.1c14-26.2 40.9-42.4 70-42.4s56 16.2 70.1 42.3l17.9 33.1 22.5-30.2c13.8-18.6 34.8-29.3 57.6-29.3 39.7 0 72 32.3 72 72S495.7 464 456 464zM320 200s-70.2-71.7-75.4-77.9c-36.2 44.9-54.4 71.2-54.4 101.1 0 11.4 2 21.6 5 31.3C222.1 235 254.5 224 288 224c32.4 0 63.7 10.5 90.1 28.7 5.9-22.8 3.7-48-7.4-69.9-2.5-5-5.3-10.1-8.4-15.4L320 200zm-200 40c15.7 0 30.9 2.6 45.4 7.2-3.2-10.9-5.4-22.3-5.4-34.2 0-29.8 31.5-89.7 84.2-146.1 14.5 15.1 27.9 30.7 39.5 46.1l36.1 47.9 38.8-45.8c2.1-2.5 4.2-4.9 6.4-7.3 31.9 40.9 51 87.8 51 105.2 0 11.9-2.2 23.3-5.4 34.2 14.5-4.6 29.7-7.2 45.4-7.2 1.9 0 3.7.5 5.6.6 1.5-9 2.4-18.2 2.4-27.6 0-40.3-40.8-123.4-97.8-174.2-16.3 14.6-31.1 29.9-44.2 45.4-21.4-28.5-47.9-57.3-78-84.2-77.2 68.9-132 158.8-132 213 0 9.4 1 18.6 2.4 27.6 1.9-.1 3.7-.6 5.6-.6z"
  ]
};
export const faFireplace = {
  prefix: "far",
  iconName: "fireplace",
  icon: [
    640,
    512,
    [],
    "f79a",
    "M342.3 311.6c-14-18.8-31.4-37.8-51.1-55.6-50.5 45.6-86.4 105-86.4 140.8 0 63.6 51.6 115.2 115.2 115.2s115.2-51.6 115.2-115.2c0-26.6-26.7-81.6-64-115.2-10.7 9.6-20.4 19.8-28.9 30zm15.5 136.9c-10.6 7.7-23.7 12.3-37.8 12.3-35.3 0-64-24.4-64-64 0-19.7 11.9-37.1 35.6-66.8 3.4 4.1 48.3 64.1 48.3 64.1l28.7-34.2c2 3.5 3.9 6.9 5.5 10.2 13.4 26.6 7.8 60.8-16.3 78.4zM624 0H16C7.2 0 0 7.2 0 16v112c0 8.8 7.2 16 16 16h16v344c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24v-96.6c0-83.7 60.9-158.7 144.2-166.7 5.3-.5 10.6-.8 15.8-.8 88.4 0 160 71.6 160 160v104c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V144h16c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16zm-64 464h-32v-80c0-114.7-93.3-208-208-208-6.7 0-13.5.3-20.3 1C194.5 187 112 281 112 390.9V464H80V144h480v320zm32-368H48V48h544v48z"
  ]
};
export const faFirstAid = {
  prefix: "far",
  iconName: "first-aid",
  icon: [
    576,
    512,
    [],
    "f479",
    "M200 288h56v56c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-56h56c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8h-56v-56c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v56h-56c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zM528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM96 432H54c-3.3 0-6-2.7-6-6V86c0-3.3 2.7-6 6-6h42v352zm336 0H144V80h288v352zm96-6c0 3.3-2.7 6-6 6h-42V80h42c3.3 0 6 2.7 6 6v340z"
  ]
};
export const faFish = {
  prefix: "far",
  iconName: "fish",
  icon: [
    640,
    512,
    [],
    "f578",
    "M360.18 64c-103.38 0-183.5 63.14-220.38 98.67l-72.88-56.3c-13.91-10.75-33.25-11.66-48.22-2.23C4.39 113.17-2.61 129.53.89 145.81L24.64 256 .89 366.19c-3.5 16.28 3.5 32.64 17.81 41.67 14.97 9.42 34.31 8.5 48.22-2.22l72.88-56.31c36.88 35.53 117 98.67 220.38 98.67C514.09 448 640 303.05 640 256S514.09 64 360.18 64zm0 336c-81.19 0-156.79-51.09-200.44-98.91l-14.91-16.31-92.72 71.63L73.77 256 52.11 155.59l92.72 71.63 14.91-16.31C203.4 163.09 278.99 112 360.18 112c125.22 0 227.97 119.88 231.85 143.2C588.15 280.13 485.4 400 360.18 400zM448 224c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32z"
  ]
};
export const faFishCooked = {
  prefix: "far",
  iconName: "fish-cooked",
  icon: [
    640,
    512,
    [],
    "f7fe",
    "M360.18 64C257 64 176.93 126.92 140 162.48l-73-57.73a42.27 42.27 0 0 0-48.22-2.19C4.39 111.59-2.61 128 .89 144.14L24.67 256 .89 367.8a39.15 39.15 0 0 0 17.82 41.65 42.33 42.33 0 0 0 48.4-2.37L140 349.5c37 35.56 117 98.5 220.22 98.5C514.09 448 640 303.05 640 256S514.09 64 360.18 64zm0 336c-18 0-107.64 2.59-215.57-115.39l-92.5 73.16L73.74 256 52.11 154.2l92.57 73.19C252.75 109 341.55 112 360.18 112c125.22 0 228 119.88 231.85 143.2C588.16 280.12 485.4 400 360.18 400zm-12.87-240L336 148.69a16 16 0 0 0-22.62 0l-84.69 84.69a16 16 0 0 0 0 22.62L240 267.31a16 16 0 0 0 22.63 0l84.69-84.69a16 16 0 0 0-.01-22.62zm112 16L448 164.69a16 16 0 0 0-22.63 0L276.68 313.38a16 16 0 0 0 0 22.62L288 347.31a16 16 0 0 0 22.63 0l148.68-148.69a16 16 0 0 0 0-22.62zM496 244.69a16 16 0 0 0-22.63 0l-84.69 84.69a16 16 0 0 0 0 22.62L400 363.31a16 16 0 0 0 22.63 0l84.69-84.69a16 16 0 0 0 0-22.62z"
  ]
};
export const faFistRaised = {
  prefix: "far",
  iconName: "fist-raised",
  icon: [
    448,
    512,
    [],
    "f6de",
    "M400 180.33V88c0-30.93-25.07-56-56-56h-24c-4.4 0-8.64.63-12.75 1.6C298.59 13.86 278.9 0 256 0h-24c-22.9 0-42.59 13.86-51.25 33.6-4.11-.97-8.35-1.6-12.75-1.6h-24c-22.9 0-42.59 13.86-51.25 33.6C88.64 64.63 84.4 64 80 64H56C25.07 64 0 89.07 0 120v210.98c0 40.29 16 78.94 44.49 107.43L64 457.93V496c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-57.94l-33.53-33.54C59.09 385.16 48 358.34 48 330.98v-59.79c2.63.38 5.26.81 8 .81h24c11.91 0 22.91-3.8 32-10.17 9.09 6.37 20.09 10.17 32 10.17h24c11.78 0 22.69-3.7 31.72-9.94 4.72 11.09 11.44 21.25 20.16 29.98 3.85 3.86 8.04 7.23 12.39 10.33-18.28 15.61-33.47 36.18-49.5 60.2-5.94 8.91-3.53 20.94 5.38 26.87l7.69 5.12c8.91 5.94 20.94 3.53 26.87-5.37 29.28-43.91 46.74-64.58 83.3-68.49 8-.86 13.98-7.8 13.98-15.85V288c0-8.84-7.16-16-16-16h-16.68c-26.16 0-47.36-21.2-47.36-47.36v-.74c0-8.78 7.12-15.9 15.9-15.9H336c35.35 0 64 28.65 64 64v48c0 25.46-10.11 49.88-28.12 67.88L320 439.76V496c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-36.35l37.83-37.83A144 144 0 0 0 448 320v-48c0-37.94-19.06-71.4-48-91.67zM80 224H56c-4.41 0-8-3.59-8-8v-96c0-4.41 3.59-8 8-8h24c4.41 0 8 3.59 8 8v96c0 4.41-3.59 8-8 8zm96-8c0 4.41-3.59 8-8 8h-24c-4.41 0-8-3.59-8-8V88c0-4.41 3.59-8 8-8h24c4.41 0 8 3.59 8 8v128zm48-47.13V56c0-4.41 3.59-8 8-8h24c4.41 0 8 3.59 8 8v104h-8.03c-11.7 0-22.53 3.38-31.97 8.87zm88-8.87V88c0-4.41 3.59-8 8-8h24c4.41 0 8 3.59 8 8v73.62c-5.27-.76-10.52-1.62-16-1.62h-24z"
  ]
};
export const faFlag = {
  prefix: "far",
  iconName: "flag",
  icon: [
    512,
    512,
    [],
    "f024",
    "M336.174 80c-49.132 0-93.305-32-161.913-32-31.301 0-58.303 6.482-80.721 15.168a48.04 48.04 0 0 0 2.142-20.727C93.067 19.575 74.167 1.594 51.201.104 23.242-1.71 0 20.431 0 48c0 17.764 9.657 33.262 24 41.562V496c0 8.837 7.163 16 16 16h16c8.837 0 16-7.163 16-16v-83.443C109.869 395.28 143.259 384 199.826 384c49.132 0 93.305 32 161.913 32 58.479 0 101.972-22.617 128.548-39.981C503.846 367.161 512 352.051 512 335.855V95.937c0-34.459-35.264-57.768-66.904-44.117C409.193 67.309 371.641 80 336.174 80zM464 336c-21.783 15.412-60.824 32-102.261 32-59.945 0-102.002-32-161.913-32-43.361 0-96.379 9.403-127.826 24V128c21.784-15.412 60.824-32 102.261-32 59.945 0 102.002 32 161.913 32 43.271 0 96.32-17.366 127.826-32v240z"
  ]
};
export const faFlagAlt = {
  prefix: "far",
  iconName: "flag-alt",
  icon: [
    512,
    512,
    [],
    "f74c",
    "M472.5 0c-7 0-14.3 1.5-21.2 4.6-50.5 22.7-87.8 30.3-119.1 30.3C266.1 34.9 227.7.4 151.4.4c-28.4 0-62.2 4.9-104.5 18C44.3 7.9 35.3 0 24 0 10.7 0 0 10.7 0 24v476c0 6.6 5.4 12 12 12h24c6.6 0 12-5.4 12-12V398.1c37.3-11.8 69.6-16.5 98.5-16.5 81.2 0 137.8 34.4 219.1 34.4 35.3 0 75.1-6.5 123.7-25 14-5.4 22.8-17.9 22.8-31.2V33.4C512 13 493.4 0 472.5 0zM464 349.1c-35.3 12.7-67.6 18.9-98.5 18.9-75.5 0-128.5-34.4-219.1-34.4-31.9 0-64.5 4.7-98.5 14.2V68.5C87.7 55 121.7 48.4 151.4 48.4c66.3 0 105.2 34.5 180.8 34.5 40.3 0 82.3-10 131.8-31.5v297.7z"
  ]
};
export const faFlagCheckered = {
  prefix: "far",
  iconName: "flag-checkered",
  icon: [
    512,
    512,
    [],
    "f11e",
    "M448 327.4V258c-15.5 9.4-44 19-72 22.9v70.4c28.7-2.8 54.8-13.5 72-23.9zm0-207.3c-21.2 8.1-46.7 15.8-72 20.2v70.6c25-4 48.6-12.5 72-21.4zM88 336.8c21.7-7 47.2-11.9 72-14.5v-70.1c-24.3 2.4-48 7.6-72 15.3zm357.1-285C409.2 67.3 371.6 80 336.2 80c-49.1 0-93.3-32-161.9-32-31.3 0-58.3 6.5-80.8 15.2 2.2-6.7 3-13.7 2.1-20.7C93.1 19.6 74.2 1.6 51.2.1 23.2-1.7 0 20.4 0 48c0 17.8 9.7 33.3 24 41.6V496c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-83.4c37.9-17.3 71.3-28.6 127.8-28.6 49.1 0 93.3 32 161.9 32 58.5 0 102-22.6 128.5-40 13.6-8.9 21.7-24 21.7-40.2V95.9c.1-34.4-35.2-57.7-66.8-44.1zM464 336c-21.8 15.4-60.8 32-102.3 32-59.9 0-102-32-161.9-32-43.4 0-96.4 9.4-127.8 24V128c21.8-15.4 60.8-32 102.3-32 59.9 0 102 32 161.9 32 43.3 0 96.3-17.4 127.8-32zM88 136.6V206c15.5-9.4 44-19 72-22.9v-70.4c-28.7 2.8-54.8 13.4-72 23.9zm72 46.5v69.1c30.5-3 51.4-1.3 72 3.1v-67c-28.5-7.6-48.7-8.4-72-5.2zm144 92.7c-23.7-6.2-46.5-15.2-72-20.5v67.5c25.9 4.3 48.9 12.9 72 19.6v-66.6c28.5 7.5 48.7 8.3 72 5.2v-70c-23.8 3.8-46.5 3.3-72-2.1zm0-134.5c-25.9-4.3-48.8-12.9-72-19.7v66.6c23.8 6.3 46.5 15.2 72 20.5z"
  ]
};
export const faFlagUsa = {
  prefix: "far",
  iconName: "flag-usa",
  icon: [
    512,
    512,
    [],
    "f74d",
    "M472.5 0c-7 0-14.3 1.5-21.2 4.6-50.5 22.7-87.8 30.3-119.1 30.3C266.1 34.9 227.7.4 151.4.4c-28.4 0-62.2 4.9-104.5 18C44.3 7.9 35.3 0 24 0 10.7 0 0 10.7 0 24v476c0 6.6 5.4 12 12 12h24c6.6 0 12-5.4 12-12V398.1c37.3-11.8 69.6-16.5 98.5-16.5 81.2 0 137.8 34.4 219.1 34.4 35.3 0 75.1-6.5 123.7-25 14-5.4 22.8-17.9 22.8-31.2V33.4C512 13 493.4 0 472.5 0zM176 40c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16 7.2-16 16-16zm0 56c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16 7.2-16 16-16zm-72-56c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16 7.2-16 16-16zm0 56c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16 7.2-16 16-16zm360 253.1c-79 28.4-125.8 20.7-196.4 3.1-73-18.2-132.2-28.8-219.6-4.4v-55.3c92.6-32.5 146-19.4 202.2-5.2C304.4 301 363.8 317.4 464 286v63.1zm0-113.6c-92.5 32.4-146 19.4-202.1 5.2-57.5-14.5-117.4-29-213.9 1.3v-61.6c92.6-32.5 146-19.4 202.2-5.2C304.4 189 363.8 205.4 464 174v61.5zm0-112c-96.5 33.8-150.9 18.1-208 3.7V71c22.2 6.4 46.9 11.9 76.2 11.9 40.3 0 82.3-10 131.8-31.5v72.1z"
  ]
};
export const faFlame = {
  prefix: "far",
  iconName: "flame",
  icon: [
    384,
    512,
    [],
    "f6df",
    "M192 0C79.7 101.33 0 220.92 0 300.55 0 425.05 78.95 512 192 512s192-86.95 192-211.45C384 220.6 303.78 100.86 192 0zm0 464c-86.13 0-144-65.69-144-163.45 0-46.27 45.31-136.62 143.96-234.47C278.21 151.97 336 244.82 336 300.55 336 398.31 278.13 464 192 464zm45.07-224.32c-19.89-17-38.67-33.06-38.67-58.22 0-3.4-2.82-4.69-4.04-5.08-2.32-.74-5.77-.57-7.94 2.38C131.52 253.42 216 248 216 302c0 23.2-18.8 42-42 42-23.19 0-42-18.8-42-42v-30a6 6 0 0 0-10.24-4.24C115.38 273.95 96 294.48 96 327.58c0 48.75 43.06 88.42 96 88.42s96-39.67 96-88.42c0-44.37-25.89-66.5-50.93-87.9z"
  ]
};
export const faFlashlight = {
  prefix: "far",
  iconName: "flashlight",
  icon: [
    640,
    512,
    [],
    "f8b8",
    "M608 96h-32a317 317 0 0 0-175.89 53.26L384 160H48a48 48 0 0 0-48 48v96a48 48 0 0 0 48 48h336l16.13 10.75A317.07 317.07 0 0 0 576 416h32a32 32 0 0 0 32-32V128a32 32 0 0 0-32-32zm-64 269.65a267.55 267.55 0 0 1-117.24-42.84L398.53 304H48v-96h350.54l28.19-18.8A267.73 267.73 0 0 1 544 146.35zM284 232h-24a24 24 0 0 0 0 48h24a24 24 0 0 0 0-48z"
  ]
};
export const faFlask = {
  prefix: "far",
  iconName: "flask",
  icon: [
    448,
    512,
    [],
    "f0c3",
    "M437.2 403.5L320 215V48h20c6.6 0 12-5.4 12-12V12c0-6.6-5.4-12-12-12H108c-6.6 0-12 5.4-12 12v24c0 6.6 5.4 12 12 12h20v167L10.8 403.5C-18.5 450.6 15.3 512 70.9 512h306.2c55.7 0 89.4-61.5 60.1-108.5zM377.1 464H70.9c-18.1 0-28.7-20.1-19.3-35.2l117.2-188.5c4.7-7.6 7.2-16.4 7.2-25.3V48h96v167c0 9 2.5 17.7 7.2 25.3l117.2 188.5c9.4 15.1-1.1 35.2-19.3 35.2z"
  ]
};
export const faFlaskPoison = {
  prefix: "far",
  iconName: "flask-poison",
  icon: [
    416,
    512,
    [],
    "f6e0",
    "M304 169.05V48h16c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16H96c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h16v120.12C45.61 202.85 0 271.88 0 352c0 53.79 20.43 102.79 53.94 139.7 11.95 13.17 29.22 20.3 47 20.3h214.05c18.06 0 35.49-7.44 47.58-20.85 32.24-35.78 52.25-82.79 53.39-134.48 1.75-79.95-44.77-151.49-111.96-187.62zm22.91 289.96c-2.81 3.12-7.27 4.99-11.92 4.99H100.94c-4.58 0-8.86-1.71-11.45-4.56C62.73 429.97 48 391.81 48 352c0-59.36 33.05-113.52 86.25-141.35L160 197.17V48h96v149.74l25.27 13.59c53.96 29.02 87.99 85.65 86.7 144.29-.85 38.23-15.43 74.95-41.06 103.39zM208 256c-49.09 0-88.89 31.84-88.89 71.11 0 23.19 14.09 43.59 35.55 56.57v14.54c0 9.82 7.96 17.78 17.78 17.78h71.11c9.82 0 17.78-7.96 17.78-17.78v-14.54c21.47-12.98 35.55-33.38 35.55-56.57C296.89 287.84 257.1 256 208 256zm-35.55 88.89c-9.82 0-17.78-7.96-17.78-17.78s7.96-17.78 17.78-17.78 17.78 7.96 17.78 17.78c-.01 9.82-7.97 17.78-17.78 17.78zm71.11 0c-9.82 0-17.78-7.96-17.78-17.78s7.96-17.78 17.78-17.78 17.78 7.96 17.78 17.78-7.97 17.78-17.78 17.78z"
  ]
};
export const faFlaskPotion = {
  prefix: "far",
  iconName: "flask-potion",
  icon: [
    416,
    512,
    [],
    "f6e1",
    "M304 169.05V48h16c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16H96c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h16v120.12C45.61 202.85 0 271.88 0 352c0 53.79 20.43 102.79 53.94 139.7 11.95 13.17 29.22 20.3 47 20.3h214.05c18.06 0 35.49-7.44 47.58-20.85 32.24-35.78 52.25-82.79 53.39-134.48 1.75-79.95-44.77-151.49-111.96-187.62zm-144 28.12V48h96v149.74c16.81 9.04 94.76 40.59 109.67 130.26h-31.76c-26.41 0-52.88-6.08-76.47-17.58-61-29.75-133.88-29.75-194.88 0l-9.93 4.84C72.41 232.48 142.66 206.25 160 197.17zm166.91 261.84c-2.81 3.12-7.27 4.99-11.92 4.99H100.94c-4.58 0-8.86-1.71-11.45-4.56-22.64-24.94-36.04-56.23-39.81-89.35l33.92-16.51c47.81-23.34 104.97-23.34 152.84 0 30.09 14.67 63.81 22.42 97.47 22.42h31.77c-4.68 30.72-17.76 59.7-38.77 83.01z"
  ]
};
export const faFlower = {
  prefix: "far",
  iconName: "flower",
  icon: [
    512,
    512,
    [],
    "f7ff",
    "M461.55 256C492.22 229.19 512 190.23 512 146.29A146.28 146.28 0 0 0 365.71 0C321.77 0 282.81 19.78 256 50.45 229.19 19.78 190.23 0 146.29 0A146.28 146.28 0 0 0 0 146.29c0 43.94 19.78 82.9 50.45 109.71C19.78 282.81 0 321.77 0 365.71A146.29 146.29 0 0 0 146.29 512c43.94 0 82.9-19.78 109.71-50.45C282.81 492.22 321.77 512 365.71 512A146.29 146.29 0 0 0 512 365.71c0-43.94-19.78-82.9-50.45-109.71zm-95.84 208c-28.25 0-54.38-12.09-73.57-34L256 388.62 219.86 430c-19.19 22-45.32 34-73.57 34A98.4 98.4 0 0 1 48 365.71c0-28.25 12.09-54.38 34-73.57L123.38 256 82 219.86c-22-19.19-34-45.32-34-73.57A98.4 98.4 0 0 1 146.29 48c28.25 0 54.38 12.09 73.57 34L256 123.38 292.14 82c19.19-22 45.32-34 73.57-34A98.4 98.4 0 0 1 464 146.29c0 28.25-12.09 54.38-34 73.57L388.62 256 430 292.14c22 19.19 34 45.32 34 73.57A98.4 98.4 0 0 1 365.71 464zM256 176a80 80 0 1 0 80 80 80 80 0 0 0-80-80z"
  ]
};
export const faFlowerDaffodil = {
  prefix: "far",
  iconName: "flower-daffodil",
  icon: [
    512,
    512,
    [],
    "f800",
    "M495.87 288h-47.26c-67.45 0-127.49 30-168.61 77v-82a90.52 90.52 0 0 0 102.53-139A89.43 89.43 0 0 0 400 90.67 90.76 90.76 0 0 0 309.34 0 89.39 89.39 0 0 0 256 17.47 89.4 89.4 0 0 0 202.65 0 90.75 90.75 0 0 0 112 90.67 89.43 89.43 0 0 0 129.47 144 89.43 89.43 0 0 0 112 197.33a90.48 90.48 0 0 0 120 85.72v82c-41.12-47-101.16-77-168.6-77H16.13c-9.19 0-17 9-16.06 19.65C10.06 422.15 106.43 512 223.83 512h64.34c117.4 0 213.77-89.85 223.76-204.35.92-10.65-6.87-19.65-16.06-19.65zm-272 176c-79.54 0-148.7-54.09-169.91-128 75.25 0 128.67 32.21 160.93 85.92L240.13 464zm12.92-241.37a42.48 42.48 0 1 1-59.38-59.38L203.19 144l-25.82-19.25A42.27 42.27 0 0 1 160 90.67 42.7 42.7 0 0 1 202.65 48a42.26 42.26 0 0 1 34.1 17.38L256 91.2l19.25-25.82A42.24 42.24 0 0 1 309.34 48 42.71 42.71 0 0 1 352 90.67a42.28 42.28 0 0 1-17.38 34.08L308.81 144l25.81 19.25A42.28 42.28 0 0 1 352 197.33 42.71 42.71 0 0 1 309.34 240a42.26 42.26 0 0 1-34.09-17.37L256 196.8zM288 464h-16.13l25.28-42.08c32.07-53.4 85.3-85.92 160.93-85.92-21.22 73.91-90.39 128-170.08 128zm0-320a32 32 0 1 0-32 32 32 32 0 0 0 32-32z"
  ]
};
export const faFlowerTulip = {
  prefix: "far",
  iconName: "flower-tulip",
  icon: [
    512,
    512,
    [],
    "f801",
    "M495.87 288H448.6c-67.44 0-127.48 30-168.6 77v-77.16c75.24-.88 136-62 136-137.44V16a16 16 0 0 0-25.45-12.88l-73.91 53.64-48.35-51a16 16 0 0 0-24.58 0l-48.35 51-73.91-53.64A16 16 0 0 0 96 16v134.4c0 75.45 60.76 136.6 136 137.44V365c-41.12-47-101.16-77-168.6-77H16.13c-9.19 0-17 9-16.06 19.65C10.06 422.15 106.43 512 223.83 512h64.34c117.4 0 213.77-89.85 223.76-204.35.92-10.65-6.87-19.65-16.06-19.65zM144 150.4v-72l56 41.6 56-56 56 56 56-41.6v72a89.6 89.6 0 0 1-89.6 89.6h-44.8a89.61 89.61 0 0 1-89.6-89.6zM223.83 464c-79.54 0-148.7-54.09-169.91-128 75.25 0 128.67 32.21 160.93 85.92L240.13 464zm64.17 0h-16.13l25.28-42.08c32-53.34 85.23-85.92 160.93-85.92-21.22 73.91-90.39 128-170.08 128z"
  ]
};
export const faFlushed = {
  prefix: "far",
  iconName: "flushed",
  icon: [
    496,
    512,
    [],
    "f579",
    "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm96-312c-44.2 0-80 35.8-80 80s35.8 80 80 80 80-35.8 80-80-35.8-80-80-80zm0 128c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm0-72c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm-112 24c0-44.2-35.8-80-80-80s-80 35.8-80 80 35.8 80 80 80 80-35.8 80-80zm-80 48c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm0-72c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm160 144H184c-13.2 0-24 10.8-24 24s10.8 24 24 24h128c13.2 0 24-10.8 24-24s-10.8-24-24-24z"
  ]
};
export const faFlute = {
  prefix: "far",
  iconName: "flute",
  icon: [
    640,
    512,
    [],
    "f8b9",
    "M592 160H48a48 48 0 0 0-48 48v96a48 48 0 0 0 48 48h544a48 48 0 0 0 48-48v-96a48 48 0 0 0-48-48zM96 304H48v-96h48zm496 0H144v-96h448zm-80-24a24 24 0 1 0-24-24 24 24 0 0 0 24 24zm-96 0a24 24 0 1 0-24-24 24 24 0 0 0 24 24zm-96 0a24 24 0 1 0-24-24 24 24 0 0 0 24 24z"
  ]
};
export const faFluxCapacitor = {
  prefix: "far",
  iconName: "flux-capacitor",
  icon: [
    448,
    512,
    [],
    "f8ba",
    "M448,120V392a88.1599,88.1599,0,0,1-88,88H88A88.15989,88.15989,0,0,1,0,392V120A88.15989,88.15989,0,0,1,88,32H360A88.1599,88.1599,0,0,1,448,120Zm-48,0a40.027,40.027,0,0,0-40-40H88a40.027,40.027,0,0,0-40,40V392a40.027,40.027,0,0,0,40,40H360a40.027,40.027,0,0,0,40-40Zm-16,56a80.034,80.034,0,0,1-80,80,91.97421,91.97421,0,0,1-20.43751-3l48.71876-48.71875C339,197.76562,344.5,184.875,344.5,175.51562a40.017,40.017,0,0,0-40-40c-9.375,0-22.25,5.46876-28.78125,12.20313L224,199.4375l-51.71875-51.73438C165.75,140.96875,152.875,135.5,143.5,135.5a40.027,40.027,0,0,0-40,40c0,9.375,5.5,22.26562,12.21875,28.76562L164.4375,253A91.97413,91.97413,0,0,1,144,256a80,80,0,1,1,80-80,80,80,0,0,1,160,0ZM208,336V262.625l-75.3125-75.3125a18.38329,18.38329,0,0,1-4.375-11.01562,15.97086,15.97086,0,0,1,16-16,18.49292,18.49292,0,0,1,11,4.39062L224,233.375l68.68749-68.6875a18.49294,18.49294,0,0,1,11-4.39062,15.97086,15.97086,0,0,1,16,16,18.38323,18.38323,0,0,1-4.375,11.01562L240,262.625V336a16,16,0,0,1-32,0Zm96,.10938a80,80,0,0,1-160,0C144,312.125,160.3125,282.0625,180.43749,269L184,272.5625V336a40,40,0,0,0,80,0V272.5625L267.56249,269C287.68749,282.0625,304,312.125,304,336.10938Z"
  ]
};
export const faFog = {
  prefix: "far",
  iconName: "fog",
  icon: [
    640,
    512,
    [],
    "f74e",
    "M208 464H80c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zm416 0H288c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h336c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zm-48-56v-16c0-8.8-7.2-16-16-16H16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h544c8.8 0 16-7.2 16-16zm-404-88h296c59.6 0 108-48.5 108-108 0-57.3-44.9-104.3-101.3-107.8C461.2 61.8 422 32 376 32c-13.5 0-26.8 2.6-39.2 7.7C314.3 14.5 282.4 0 248 0c-64 0-116.4 50.3-119.8 113.4C89.6 130.4 64 168.5 64 212c0 59.5 48.4 108 108 108zm-13.6-166.3l20.8-4.8-2.8-24.9c-.2-1.3-.4-2.6-.4-4 0-39.7 32.3-72 72-72 25.2 0 48.2 13.1 61.4 35.1l13.3 22.1 21.1-14.9C353.4 83.6 364.5 80 376 80c28.6 0 52.4 21.7 55.3 50.4l2.2 21.6H468c33.1 0 60 26.9 60 60s-26.9 60-60 60H172c-33.1 0-60-26.9-60-60 0-28 19.1-52 46.4-58.3z"
  ]
};
export const faFolder = {
  prefix: "far",
  iconName: "folder",
  icon: [
    512,
    512,
    [],
    "f07b",
    "M464 128H272l-54.63-54.63c-6-6-14.14-9.37-22.63-9.37H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V176c0-26.51-21.49-48-48-48zm0 272H48V112h140.12l54.63 54.63c6 6 14.14 9.37 22.63 9.37H464v224z"
  ]
};
export const faFolderDownload = {
  prefix: "far",
  iconName: "folder-download",
  icon: [
    512,
    512,
    [],
    "e053",
    "M464,128H272L217.37,73.37A32,32,0,0,0,194.74,64H48A48,48,0,0,0,0,112V400a48,48,0,0,0,48,48H464a48,48,0,0,0,48-48V176A48,48,0,0,0,464,128Zm0,272H48V112H188.12L232,155.88V256H183.12a12,12,0,0,0-8.45,20.52L247,348.29a12.81,12.81,0,0,0,18,0h0l72.31-71.77A12,12,0,0,0,328.88,256H280V176H464Z"
  ]
};
export const faFolderMinus = {
  prefix: "far",
  iconName: "folder-minus",
  icon: [
    512,
    512,
    [],
    "f65d",
    "M464 128H272l-54.63-54.63c-6-6-14.14-9.37-22.63-9.37H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V176c0-26.51-21.49-48-48-48zm0 272H48V112h140.12l54.63 54.63c6 6 14.14 9.37 22.63 9.37H464v224zM176 280v16c0 8.84 7.16 16 16 16h128c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16H192c-8.84 0-16 7.16-16 16z"
  ]
};
export const faFolderOpen = {
  prefix: "far",
  iconName: "folder-open",
  icon: [
    576,
    512,
    [],
    "f07c",
    "M527.9 224H480v-48c0-26.5-21.5-48-48-48H272l-64-64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h400c16.5 0 31.9-8.5 40.7-22.6l79.9-128c20-31.9-3-73.4-40.7-73.4zM48 118c0-3.3 2.7-6 6-6h134.1l64 64H426c3.3 0 6 2.7 6 6v42H152c-16.8 0-32.4 8.8-41.1 23.2L48 351.4zm400 282H72l77.2-128H528z"
  ]
};
export const faFolderPlus = {
  prefix: "far",
  iconName: "folder-plus",
  icon: [
    512,
    512,
    [],
    "f65e",
    "M464,128H272L217.37,73.37A32,32,0,0,0,194.74,64H48A48,48,0,0,0,0,112V400a48,48,0,0,0,48,48H464a48,48,0,0,0,48-48V176A48,48,0,0,0,464,128Zm0,272H48V112H188.12l54.63,54.63A32,32,0,0,0,265.38,176H464ZM247.5,208a16,16,0,0,0-16,16v40H192a16,16,0,0,0-16,16v16a16,16,0,0,0,16,16h39.5v40a16,16,0,0,0,16,16h16a16,16,0,0,0,16-16V312H320a16,16,0,0,0,16-16V280a16,16,0,0,0-16-16H279.5V224a16,16,0,0,0-16-16Z"
  ]
};
export const faFolderTimes = {
  prefix: "far",
  iconName: "folder-times",
  icon: [
    512,
    512,
    [],
    "f65f",
    "M464 128H272l-54.63-54.63c-6-6-14.14-9.37-22.63-9.37H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V176c0-26.51-21.49-48-48-48zm0 272H48V112h140.12l54.63 54.63c6 6 14.14 9.37 22.63 9.37H464v224zM227.71 225.77a15.964 15.964 0 0 0-11.31-4.69c-4.09 0-8.19 1.56-11.31 4.69l-11.31 11.31c-6.25 6.25-6.25 16.38 0 22.63L222.06 288l-28.28 28.28c-6.25 6.25-6.25 16.38 0 22.63l11.31 11.31c3.12 3.12 7.22 4.69 11.31 4.69s8.19-1.56 11.31-4.69L256 321.94l28.29 28.28c3.12 3.12 7.22 4.69 11.31 4.69s8.19-1.56 11.31-4.69l11.31-11.31c6.25-6.25 6.25-16.38 0-22.63L289.94 288l28.28-28.29c6.25-6.25 6.25-16.38 0-22.63l-11.31-11.31a15.964 15.964 0 0 0-11.31-4.69c-4.09 0-8.19 1.56-11.31 4.69L256 254.06l-28.29-28.29z"
  ]
};
export const faFolderTree = {
  prefix: "far",
  iconName: "folder-tree",
  icon: [
    576,
    512,
    [],
    "f802",
    "M288 224h224a32 32 0 0 0 32-32V64a32 32 0 0 0-32-32H400L368 0h-80a32 32 0 0 0-32 32v72H80V16A16 16 0 0 0 64 0H48a16 16 0 0 0-16 16v392a32 32 0 0 0 32 32h192v40a32 32 0 0 0 32 32h224a32 32 0 0 0 32-32V352a32 32 0 0 0-32-32H400l-32-32h-80a32 32 0 0 0-32 32v72H80V152h176v40a32 32 0 0 0 32 32zm16-176h44.12l32 32H496v96H304zm0 288h44.12l32 32H496v96H304z"
  ]
};
export const faFolderUpload = {
  prefix: "far",
  iconName: "folder-upload",
  icon: [
    512,
    512,
    [],
    "e054",
    "M464,128H272L217.37,73.37A32,32,0,0,0,194.74,64H48A48,48,0,0,0,0,112V400a48,48,0,0,0,48,48H464a48,48,0,0,0,48-48V176A48,48,0,0,0,464,128Zm0,272H280V320h48.88a12,12,0,0,0,8.45-20.52L265,227.71a12.81,12.81,0,0,0-18,0h0l-72.31,71.77A12,12,0,0,0,183.12,320H232v80H48V112H188.12l54.63,54.63A32,32,0,0,0,265.38,176H464Z"
  ]
};
export const faFolders = {
  prefix: "far",
  iconName: "folders",
  icon: [
    640,
    512,
    [],
    "f660",
    "M592 64H400L345.37 9.37c-6-6-14.14-9.37-22.63-9.37H176c-26.51 0-48 21.49-48 48v80H48c-26.51 0-48 21.49-48 48v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48v-80h80c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zM464 464H48V176h80v160c0 26.51 21.49 48 48 48h288v80zm128-128H176V48h140.12l54.63 54.63c6 6 14.14 9.37 22.63 9.37H592v224z"
  ]
};
export const faFont = {
  prefix: "far",
  iconName: "font",
  icon: [
    448,
    512,
    [],
    "f031",
    "M432 432h-33.32l-135-389.24A16 16 0 0 0 248.55 32h-49.1a16 16 0 0 0-15.12 10.76L49.32 432H16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16h-35.44l33.31-96h164.26l33.31 96H304a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zM158.53 288L224 99.31 289.47 288z"
  ]
};
export const faFontAwesomeLogoFull = {
  prefix: "far",
  iconName: "font-awesome-logo-full",
  icon: [
    3992,
    512,
    ["Font Awesome"],
    "f4e6",
    "M454.6 0H57.4C25.9 0 0 25.9 0 57.4v397.3C0 486.1 25.9 512 57.4 512h397.3c31.4 0 57.4-25.9 57.4-57.4V57.4C512 25.9 486.1 0 454.6 0zm-58.9 324.9c0 4.8-4.1 6.9-8.9 8.9-19.2 8.1-39.7 15.7-61.5 15.7-40.5 0-68.7-44.8-163.2 2.5v51.8c0 30.3-45.7 30.2-45.7 0v-250c-9-7-15-17.9-15-30.3 0-21 17.1-38.2 38.2-38.2 21 0 38.2 17.1 38.2 38.2 0 12.2-5.8 23.2-14.9 30.2v21c37.1-12 65.5-34.4 146.1-3.4 26.6 11.4 68.7-15.7 76.5-15.7 5.5 0 10.3 4.1 10.3 8.9v160.4zm432.9-174.2h-137v70.1H825c39.8 0 40.4 62.2 0 62.2H691.6v105.6c0 45.5-70.7 46.4-70.7 0V128.3c0-22 18-39.8 39.8-39.8h167.8c39.6 0 40.5 62.2.1 62.2zm191.1 23.4c-169.3 0-169.1 252.4 0 252.4 169.9 0 169.9-252.4 0-252.4zm0 196.1c-81.6 0-82.1-139.8 0-139.8 82.5 0 82.4 139.8 0 139.8zm372.4 53.4c-17.5 0-31.4-13.9-31.4-31.4v-117c0-62.4-72.6-52.5-99.1-16.4v133.4c0 41.5-63.3 41.8-63.3 0V208c0-40 63.1-41.6 63.1 0v3.4c43.3-51.6 162.4-60.4 162.4 39.3v141.5c.3 30.4-31.5 31.4-31.7 31.4zm179.7 2.9c-44.3 0-68.3-22.9-68.3-65.8V235.2H1488c-35.6 0-36.7-55.3 0-55.3h15.5v-37.3c0-41.3 63.8-42.1 63.8 0v37.5h24.9c35.4 0 35.7 55.3 0 55.3h-24.9v108.5c0 29.6 26.1 26.3 27.4 26.3 31.4 0 52.6 56.3-22.9 56.3zM1992 123c-19.5-50.2-95.5-50-114.5 0-107.3 275.7-99.5 252.7-99.5 262.8 0 42.8 58.3 51.2 72.1 14.4l13.5-35.9H2006l13 35.9c14.2 37.7 72.1 27.2 72.1-14.4 0-10.1 5.3 6.8-99.1-262.8zm-108.9 179.1l51.7-142.9 51.8 142.9h-103.5zm591.3-85.6l-53.7 176.3c-12.4 41.2-72 41-84 0l-42.3-135.9-42.3 135.9c-12.4 40.9-72 41.2-84.5 0l-54.2-176.3c-12.5-39.4 49.8-56.1 60.2-16.9L2213 342l45.3-139.5c10.9-32.7 59.6-34.7 71.2 0l45.3 139.5 39.3-142.4c10.3-38.3 72.6-23.8 60.3 16.9zm275.4 75.1c0-42.4-33.9-117.5-119.5-117.5-73.2 0-124.4 56.3-124.4 126 0 77.2 55.3 126.4 128.5 126.4 31.7 0 93-11.5 93-39.8 0-18.3-21.1-31.5-39.3-22.4-49.4 26.2-109 8.4-115.9-43.8h148.3c16.3 0 29.3-13.4 29.3-28.9zM2571 277.7c9.5-73.4 113.9-68.6 118.6 0H2571zm316.7 148.8c-31.4 0-81.6-10.5-96.6-31.9-12.4-17 2.5-39.8 21.8-39.8 16.3 0 36.8 22.9 77.7 22.9 27.4 0 40.4-11 40.4-25.8 0-39.8-142.9-7.4-142.9-102 0-40.4 35.3-75.7 98.6-75.7 31.4 0 74.1 9.9 87.6 29.4 10.8 14.8-1.4 36.2-20.9 36.2-15.1 0-26.7-17.3-66.2-17.3-22.9 0-37.8 10.5-37.8 23.8 0 35.9 142.4 6 142.4 103.1-.1 43.7-37.4 77.1-104.1 77.1zm266.8-252.4c-169.3 0-169.1 252.4 0 252.4 170.1 0 169.6-252.4 0-252.4zm0 196.1c-81.8 0-82-139.8 0-139.8 82.5 0 82.4 139.8 0 139.8zm476.9 22V268.7c0-53.8-61.4-45.8-85.7-10.5v134c0 41.3-63.8 42.1-63.8 0V268.7c0-52.1-59.5-47.4-85.7-10.1v133.6c0 41.5-63.3 41.8-63.3 0V208c0-40 63.1-41.6 63.1 0v3.4c9.9-14.4 41.8-37.3 78.6-37.3 35.3 0 57.7 16.4 66.7 43.8 13.9-21.8 45.8-43.8 82.6-43.8 44.3 0 70.7 23.4 70.7 72.7v145.3c.5 17.3-13.5 31.4-31.9 31.4 3.5.1-31.3 1.1-31.3-31.3zM3992 291.6c0-42.4-32.4-117.5-117.9-117.5-73.2 0-127.5 56.3-127.5 126 0 77.2 58.3 126.4 131.6 126.4 31.7 0 91.5-11.5 91.5-39.8 0-18.3-21.1-31.5-39.3-22.4-49.4 26.2-110.5 8.4-117.5-43.8h149.8c16.3 0 29.1-13.4 29.3-28.9zm-180.5-13.9c9.7-74.4 115.9-68.3 120.1 0h-120.1z"
  ]
};
export const faFontCase = {
  prefix: "far",
  iconName: "font-case",
  icon: [
    640,
    512,
    [],
    "f866",
    "M624 160h-16a16 16 0 0 0-16 16v12.82C570 171.07 542.44 160 512 160a128 128 0 0 0-128 128v32a128 128 0 0 0 128 128c30.44 0 58-11.07 80-28.82V432a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16V176a16 16 0 0 0-16-16zm-32 160a80 80 0 0 1-160 0v-32a80 80 0 0 1 160 0zM212.5 74.35a16 16 0 0 0-15-10.35h-43.03a16 16 0 0 0-15 10.35L1 426.35A16 16 0 0 0 16 448h17.14a16 16 0 0 0 15-10.35L88.22 336h175.56l40.11 101.65a16 16 0 0 0 15 10.35H336a16 16 0 0 0 15-21.65zM107.16 288L176 113.58 244.84 288z"
  ]
};
export const faFootballBall = {
  prefix: "far",
  iconName: "football-ball",
  icon: [
    496,
    512,
    [],
    "f44e",
    "M481.4 60.9c-4.8-18.2-19.1-32.5-37.2-37.4-23.8-6.4-211.8-59.9-349.7 78.2C-28.2 224.6-2.4 386.9 14.6 451.6c4.8 18.2 19.1 31.6 37.2 36.5 23.8 6.4 211.7 60.9 349.7-77.3 122.7-122.9 96.9-285.3 79.9-349.9zM64.3 442.6c-1.6-.4-2.8-1.7-3.2-3.3-5.4-20.3-11.7-51.9-12.8-88.9l105.1 105.1c-36.8-1.2-68.5-7.4-89.1-12.9zm303.3-66.7c-41.2 41.3-91.6 66.6-150.1 75.9L52.3 286.6c8.2-50.2 29.6-103.9 76.1-150.5 41.2-41.3 91.6-66.6 150.1-75.9l165.1 165.1c-8.1 50.3-29.5 104-76 150.6zm-25-319.4c36.8 1.2 68.5 7.4 89.1 12.9 1.6.4 2.8 1.7 3.2 3.3 5.4 20.3 11.7 51.9 12.8 88.9L342.6 56.5zm-88.9 103.3l-11.3 11.3c-3.1 3.1-3.1 8.2 0 11.3l28.3 28.3-22.7 22.7-28.3-28.3c-3.1-3.1-8.2-3.1-11.3 0l-11.3 11.3c-3.1 3.1-3.1 8.2 0 11.3l28.3 28.3-22.6 22.6-28.3-28.3c-3.1-3.1-8.2-3.1-11.3 0l-11.3 11.3c-3.1 3.1-3.1 8.2 0 11.3l28.3 28.3-28.3 28.3c-3.1 3.1-3.1 8.2 0 11.3l11.3 11.3c3.1 3.1 8.2 3.1 11.3 0l28.3-28.3 28.3 28.3c3.1 3.1 8.2 3.1 11.3 0l11.3-11.3c3.1-3.1 3.1-8.2 0-11.3l-28.3-28.3 22.6-22.6 28.3 28.3c3.1 3.1 8.2 3.1 11.3 0l11.3-11.3c3.1-3.1 3.1-8.2 0-11.3L270.6 256l22.6-22.6 28.3 28.3c3.1 3.1 8.2 3.1 11.3 0l11.3-11.3c3.1-3.1 3.1-8.2 0-11.3l-28.3-28.3 28.3-28.3c3.1-3.1 3.1-8.2 0-11.3l-11.3-11.3c-3.1-3.1-8.2-3.1-11.3 0l-28.3 28.3-28.2-28.4c-3.2-3.1-8.2-3.1-11.3 0z"
  ]
};
export const faFootballHelmet = {
  prefix: "far",
  iconName: "football-helmet",
  icon: [
    512,
    512,
    [],
    "f44f",
    "M479.6 320H355.5l-15.2-76 136.5-17.8c9-1.2 15.6-9.8 13.9-18.7C468.1 93.8 368.3 8 248 8 114.9 8 18.2 109.5 2.6 219.9-7.6 292 13.3 359 53.7 409.9c3.1 3.9 7.8 6.1 12.8 6.1H120c92.7 46.4 95 49.8 115 49.8 17 0 33.8-6.6 46.4-19.2 36.2-36.2 10.9-79.7 5-94.6h42.9l9.5 49.5c9.5 47.4 47.6 83.2 95.6 89.2 42.2 5.3 52.6 9.6 66.5-2.6 14.3-12.6 10.8-18.4 10.8-136.1-.1-17.7-14.4-32-32.1-32zm-206 0l-10.3-25.7c-7.8-19.4 4.9-40.9 25.6-43.6l19.6-2.6 14.4 71.9h-49.3zm9.1-116.9c-51.8 6.7-83.4 60.5-64 109l32.6 81.6c4.6 11.5-3.9 24.1-16.3 24.1-5.9 0 .2 2.1-103.7-49.8H82.4c-28-41.2-39.5-90.9-32.3-141.4C62.3 140.1 139.6 56 248 56c83.2 0 156.4 51.9 185.8 127.4l-151.1 19.7zm196.9 261l-41.3-5.2c-25.9-3.2-47.6-18.7-59.7-40.7h101.1l-.1 45.9zm0-80.1H368.3l-6.4-32h117.7v32zM176 312c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24z"
  ]
};
export const faForklift = {
  prefix: "far",
  iconName: "forklift",
  icon: [
    640,
    512,
    [],
    "f47a",
    "M416 344.9V237.1c0-8.7-1.8-17.2-5.2-25.2L332.5 29.1C324.9 11.4 307.6 0 288.3 0H144c-26.5 0-48 21.5-48 48v112H48c-26.5 0-48 21.5-48 48v208c0 53 43 96 96 96s96-43 96-96h64c0 53 43 96 96 96s96-43 96-96c0-28.3-12.5-53.5-32-71.1zM144 48h144.3l78.4 182.8c.9 2 1.3 4.1 1.3 6.3v2.9H246.1c-8.9 0-17.7-3-24.7-8.5L144 170.6V48zM96 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm173.3-96h-90.6c-16.6-28.6-47.2-48-82.7-48-17.6 0-33.8 5.1-48 13.3V208h65.9l77.9 61.2c15.4 12.1 34.8 18.8 54.4 18.8H368v33.6c-5.2-.9-10.5-1.6-16-1.6-35.4 0-66.1 19.4-82.7 48zm82.7 96c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm272-64h-96V16c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16v416c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16z"
  ]
};
export const faForward = {
  prefix: "far",
  iconName: "forward",
  icon: [
    512,
    512,
    [],
    "f04e",
    "M244.5 230.8L52.5 71.4C31.9 54.3 0 68.6 0 96v320c0 27.4 31.9 41.8 52.5 24.6l192-160.6c15.3-12.8 15.3-36.4 0-49.2zM48 381.7V130.1l151 125.4L48 381.7zm452.5-150.9l-192-159.4C287.9 54.3 256 68.6 256 96v320c0 27.4 31.9 41.8 52.5 24.6l192-160.6c15.3-12.8 15.3-36.4 0-49.2zM304 381.7V130.1l151 125.4-151 126.2z"
  ]
};
export const faFragile = {
  prefix: "far",
  iconName: "fragile",
  icon: [
    288,
    512,
    [],
    "f4bb",
    "M200 464h-32V349.4c72.7-12.4 126.3-79.5 119.4-156.7l-16-178.1C270.7 6.3 263.9 0 255.7 0H32.3c-8.2 0-15 6.3-15.7 14.6L.6 192.7C-6.3 269.9 47.3 337 120 349.4V464H88.1c-37.2 0-50 48-32 48h175.8c18.1 0 5.2-48-31.9-48zM72.6 272c-18.5-20.6-27.4-47.3-24.9-75L61.1 48h61.7l26.6 38L80 130l98.7 94-40.1-82L208 98l-24.8-50H227l13.3 149c2.5 27.8-6.4 54.4-24.9 75s-43.9 32-71.4 32-52.9-11.3-71.4-32z"
  ]
};
export const faFrenchFries = {
  prefix: "far",
  iconName: "french-fries",
  icon: [
    512,
    512,
    [],
    "f803",
    "M351.54 228.14c.4-1.78 1.46-3.22 2.06-4.91l30.15-172.46a16 16 0 0 0-20.34-18.08l-34.28 10.25c-4.24 1.27-7.17 4.51-9.13 8.33v207.27c17.55-8.38 29.15-19.54 31.54-30.4zM288 268.78V32a16 16 0 0 0-8.84-14.31l-32-16A16 16 0 0 0 224 16v252.78a160.62 160.62 0 0 0 64 0zM431.45 192l16.3-93.23a16 16 0 0 0-20.34-18.08l-17.31 5.17-18.75 107.26c2.24-.32 4.33-1.12 6.63-1.12zm-350.9 0H114c3.6 0 7 1 10.35 1.75l-20-107.16-19.74-5.9a16 16 0 0 0-20.36 18.08zm84.62 45.79c5.3 7.58 14.49 14.86 26.83 20.75V33.17l-3.76-20.1a16 16 0 0 0-25.39-9.81l-28.51 21.62a16 16 0 0 0-6.07 15.69zM432 224h-34c-6.92 0-13.7 4.27-15.19 11-8.6 39-62.09 69-126.79 69s-118.19-30-126.79-69c-1.49-6.76-8.27-11-15.19-11H80a16 16 0 0 0-15.62 19.47l54.1 243.47A32 32 0 0 0 149.73 512h212.54a32 32 0 0 0 31.24-25.06l54.1-243.47A16 16 0 0 0 432 224zm-82.56 240H162.56l-33.3-149.86C161.08 337.86 205.8 352 256 352s94.92-14.14 126.74-37.86z"
  ]
};
export const faFrog = {
  prefix: "far",
  iconName: "frog",
  icon: [
    576,
    512,
    [],
    "f52e",
    "M576 189.94c0-21.4-11.72-40.95-30.48-51.23-28.68-15.71-65.94-29.69-85.51-36.62C448.64 61.74 411.98 32 368 32c-42.97 0-78.91 28.42-91.16 67.35C120.27 120.52-.49 254.49 0 416.98.11 451.89 29.08 480 64 480h304c8.84 0 16-7.16 16-16 0-17.67-14.33-32-32-32h-29.74l18.87-25.48c9.29-13.93 14.7-29.24 17.15-44.82L469.62 480H560c8.84 0 16-7.16 16-16 0-17.67-14.33-32-32-32h-53.63l-98.52-104.68 154.44-86.65A58.183 58.183 0 0 0 576 189.94zm-53.19 8.87l-174.79 96.05c-7.56-15.39-18.32-29.45-32.92-40.4-39.66-29.72-95-29.75-134.72 0l-34.78 26.09c-10.59 7.95-12.75 23-4.78 33.61 7.97 10.59 23 12.77 33.59 4.8l34.78-26.09c22.72-17.08 54.44-17.02 77.09 0 27.28 20.45 33.81 58.67 15.59 86.06L262.56 432H64c-8.65 0-15.97-6.95-16-15.17-.41-135.69 100.74-251.73 235.27-269.92l30.21-4.08 9.15-29.08C328.98 93.56 347.21 80 368 80c21.15 0 39.99 14.43 45.81 35.1l6.74 23.93 23.44 8.3c18.33 6.49 52.91 19.47 78.47 33.47 3.47 1.9 5.54 5.32 5.54 9.14 0 3.67-1.99 7.07-5.19 8.87zM368 120c-13.25 0-24 10.74-24 24 0 13.25 10.75 24 24 24s24-10.75 24-24c0-13.26-10.75-24-24-24z"
  ]
};
export const faFrostyHead = {
  prefix: "far",
  iconName: "frosty-head",
  icon: [
    384,
    512,
    [],
    "f79b",
    "M368 240h-32V32c0-17.7-14.3-32-32-32H80C62.3 0 48 14.3 48 32v208H16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h13.1C20.9 308.4 16 330.4 16 353.7c0 62.8 32.8 117.5 82 148.8 10.7 6.8 23.6 9.5 36.2 9.5h41c-8.6-12.5-19.8-28.1-31.1-48h-9.9c-5.4 0-8.9-1-10.4-2C86.3 438.2 64 397.7 64 353.7c0-24.3 7.4-46.4 19.2-65.7H302c7.6 12.7 13.1 26.6 15.8 41.3 9.2 50.8-11.2 100.6-53.1 129.8-4.7 3.3-10.1 5-15.7 5h-9.2c-11.3 20-22.4 35.5-31.1 48H249c15.4 0 30.5-4.8 43.1-13.6 53.9-37.6 86.1-104.1 72.8-177.7-2-11.4-5.6-22.2-9.8-32.7H368c8.8 0 16-7.2 16-16v-16c0-8.9-7.2-16.1-16-16.1zm-80 0H96v-64h192v64zm0-112H96V48h192v80zm-96 240c-20.6 0-37.3 16.7-37.3 37.3C154.7 426 192 480 192 480s37.3-54 37.3-74.7c0-20.6-16.7-37.3-37.3-37.3zm-82.7-26.7c0 11.8 9.6 21.3 21.3 21.3 11.8 0 21.3-9.6 21.3-21.3 0-11.8-9.6-21.3-21.3-21.3-11.7 0-21.3 9.6-21.3 21.3zm165.4 0c0-11.8-9.6-21.3-21.3-21.3-11.8 0-21.3 9.6-21.3 21.3 0 11.8 9.6 21.3 21.3 21.3 11.7.1 21.3-9.5 21.3-21.3z"
  ]
};
export const faFrown = {
  prefix: "far",
  iconName: "frown",
  icon: [
    496,
    512,
    [],
    "f119",
    "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-80-216c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160-64c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm-80 128c-40.2 0-78 17.7-103.8 48.6-8.5 10.2-7.1 25.3 3.1 33.8 10.2 8.4 25.3 7.1 33.8-3.1 16.6-19.9 41-31.4 66.9-31.4s50.3 11.4 66.9 31.4c8.1 9.7 23.1 11.9 33.8 3.1 10.2-8.5 11.5-23.6 3.1-33.8C326 321.7 288.2 304 248 304z"
  ]
};
export const faFrownOpen = {
  prefix: "far",
  iconName: "frown-open",
  icon: [
    496,
    512,
    [],
    "f57a",
    "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-48-248c0-17.7-14.3-32-32-32s-32 14.3-32 32 14.3 32 32 32 32-14.3 32-32zm128-32c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm-80 112c-35.6 0-88.8 21.3-95.8 61.2-2 11.8 9 21.5 20.5 18.1 31.2-9.6 59.4-15.3 75.3-15.3s44.1 5.7 75.3 15.3c11.4 3.5 22.5-6.3 20.5-18.1-7-39.9-60.2-61.2-95.8-61.2z"
  ]
};
export const faFunction = {
  prefix: "far",
  iconName: "function",
  icon: [
    640,
    512,
    [],
    "f661",
    "M224 48c0-8.84-7.16-16-16-16h-48c-48.6 0-88 39.4-88 88v48H16c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h56v144c0 22.09-17.91 40-40 40H16c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h16c48.6 0 88-39.4 88-88V216h56c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16h-56v-48c0-22.09 17.91-40 40-40h48c8.84 0 16-7.16 16-16V48zm93.43 60.92l-12.8-9.63c-7.22-5.44-17.81-4.01-22.92 3.41C244.39 157 224 222.17 224 288c0 65.85 20.39 131.02 57.71 185.3 5.11 7.43 15.7 8.85 22.92 3.41l12.8-9.63c6.84-5.14 8.09-14.54 3.28-21.59C289.2 399.27 272 343.92 272 288c0-55.91 17.2-111.26 48.71-157.5 4.8-7.05 3.55-16.44-3.28-21.58zm264.86-6.22c-5.11-7.43-15.7-8.85-22.92-3.41l-12.8 9.63c-6.84 5.14-8.09 14.54-3.28 21.59C574.8 176.73 592 232.08 592 288c0 55.91-17.2 111.26-48.71 157.5-4.8 7.05-3.55 16.44 3.28 21.59l12.8 9.63c7.22 5.44 17.81 4.02 22.92-3.41C619.61 419 640 353.83 640 288c0-65.85-20.39-131.02-57.71-185.3zm-74.84 120.84l-10.99-10.99c-6.07-6.07-15.91-6.07-21.98 0L432 255.03l-42.47-42.47c-6.07-6.07-15.91-6.07-21.98 0l-10.99 10.99c-6.07 6.07-6.07 15.91 0 21.98L399.03 288l-42.47 42.47c-6.07 6.07-6.07 15.91 0 21.98l10.99 10.99c6.07 6.07 15.91 6.07 21.98 0L432 320.97l42.47 42.47c6.07 6.07 15.91 6.07 21.98 0l10.99-10.99c6.07-6.07 6.07-15.91 0-21.98L464.97 288l42.47-42.47c6.08-6.07 6.08-15.92.01-21.99z"
  ]
};
export const faFunnelDollar = {
  prefix: "far",
  iconName: "funnel-dollar",
  icon: [
    640,
    512,
    [],
    "f662",
    "M471.61 160.38l94.5-103.14C587.24 36.12 572.27 0 542.4 0H33.6C3.73 0-11.24 36.12 9.89 57.25L192 256v135.91c0 15.11 7.11 29.33 19.2 38.4l95.99 72c8.91 6.68 18.89 9.7 28.63 9.7 16.62 0 32.46-8.82 41.17-23.14C402.66 503.51 432.31 512 464 512c97.2 0 176-78.8 176-176 0-94.63-74.74-171.6-168.39-175.62zM335.99 463.91l-95.99-72V237.33L66.52 48h442.96L393.15 174.96C331.26 202.23 288 264.02 288 336c0 46.7 18.31 89.03 47.99 120.53v7.38zM464 464c-70.58 0-128-57.42-128-128s57.42-128 128-128 128 57.42 128 128-57.42 128-128 128zm27.09-136.58l-45-13.5c-5.16-1.55-8.77-6.78-8.77-12.73 0-7.27 5.3-13.19 11.8-13.19h28.11c4.56 0 8.96 1.29 12.82 3.72 3.24 2.03 7.36 1.91 10.13-.73l11.75-11.21c3.53-3.37 3.33-9.21-.57-12.14-9.1-6.83-20.08-10.77-31.37-11.35V240c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v16.12c-23.62.63-42.67 20.55-42.67 45.07 0 19.97 12.98 37.81 31.58 43.39l45 13.5c5.16 1.55 8.77 6.78 8.77 12.73 0 7.27-5.3 13.19-11.8 13.19h-28.11c-4.56 0-8.96-1.29-12.82-3.72-3.24-2.03-7.36-1.91-10.13.73l-11.75 11.21c-3.53 3.37-3.33 9.21.57 12.14 9.1 6.83 20.08 10.77 31.37 11.35V432c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-16.12c23.62-.63 42.67-20.54 42.67-45.07 0-19.97-12.98-37.81-31.58-43.39z"
  ]
};
export const faFutbol = {
  prefix: "far",
  iconName: "futbol",
  icon: [
    496,
    512,
    [],
    "f1e3",
    "M483.8 179.4C449.8 74.6 352.6 8 248.1 8c-25.4 0-51.2 3.9-76.7 12.2C41.2 62.5-30.1 202.4 12.2 332.6 46.2 437.4 143.4 504 247.9 504c25.4 0 51.2-3.9 76.7-12.2 130.2-42.3 201.5-182.2 159.2-312.4zm-74.5 193.7l-52.2 6.4-43.7-60.9 24.4-75.2 71.1-22.1 38.9 36.4c-.2 30.7-7.4 61.1-21.7 89.2-4.7 9.3-10.7 17.8-16.8 26.2zm0-235.4l-10.4 53.1-70.7 22-64.2-46.5V92.5l47.4-26.2c39.2 13 73.4 38 97.9 71.4zM184.9 66.4L232 92.5v73.8l-64.2 46.5-70.6-22-10.1-52.5c24.3-33.4 57.9-58.6 97.8-71.9zM139 379.5L85.9 373c-14.4-20.1-37.3-59.6-37.8-115.3l39-36.4 71.1 22.2 24.3 74.3-43.5 61.7zm48.2 67l-22.4-48.1 43.6-61.7H287l44.3 61.7-22.4 48.1c-6.2 1.8-57.6 20.4-121.7 0z"
  ]
};
export const faGalaxy = {
  prefix: "far",
  iconName: "galaxy",
  icon: [
    512,
    512,
    [],
    "e008",
    "M506.46308,266.91212l-.03125-.01563C489.18219,193.742,428.121,134.7434,354.59127,120.07188a202.37262,202.37262,0,0,0-60.84248-2.953,106.7548,106.7548,0,0,1,50.81144-45.827,36.20633,36.20633,0,0,0,21.84329-39.31156,36.23237,36.23237,0,0,0-32.59307-30.968A201.526,201.526,0,0,0,266.87436,5.559C193.75089,22.85546,134.75213,83.88525,120.06494,157.43036a202.4291,202.4291,0,0,0-2.84369,60.87354A106.56522,106.56522,0,0,1,71.28471,167.477,36.44256,36.44256,0,0,0,31.973,145.60252a36.21769,36.21769,0,0,0-30.9681,32.593,201.27673,201.27673,0,0,0,4.5624,66.92027C22.817,318.27026,83.8782,377.26885,157.4079,391.94037a201.36172,201.36172,0,0,0,60.84248,2.95306,106.75481,106.75481,0,0,1-50.81144,45.827A36.7142,36.7142,0,0,0,178.18872,511a194.69683,194.69683,0,0,0,19.81156,1,205.81064,205.81064,0,0,0,47.12453-5.54674C318.24828,489.1568,377.247,428.127,391.93423,354.58189a202.42908,202.42908,0,0,0,2.84369-60.87354,106.5652,106.5652,0,0,1,45.93654,50.82691,36.70618,36.70618,0,0,0,70.27978-10.7185A201.96376,201.96376,0,0,0,506.46308,266.91212ZM365.966,233.89728a24.011,24.011,0,0,0-26.24945,31.5305,151.14812,151.14812,0,0,1,5.15614,79.74809c-11.34546,56.73887-58.29565,105.98574-120.96621,116.62221a155.27325,155.27325,0,0,0,54.21761-95.81021,24.02479,24.02479,0,0,0-31.53059-26.265A152.37383,152.37383,0,0,1,166.814,344.879C109.87179,333.50623,60.59548,286.17728,50.22265,223.94439A155.24373,155.24373,0,0,0,146.03314,278.115a24.01235,24.01235,0,0,0,26.24945-31.53049,151.14813,151.14813,0,0,1-5.15614-79.74809C178.47192,110.09751,225.4221,60.85064,288.09266,50.21418a155.27325,155.27325,0,0,0-54.21761,95.8102,24.02987,24.02987,0,0,0,31.53059,26.265,151.21288,151.21288,0,0,1,79.77958-5.15613c56.83669,11.3513,106.19894,58.58454,116.5913,120.93461A155.24378,155.24378,0,0,0,365.966,233.89728Zm-109.96644-17.8902a39.999,39.999,0,1,0,39.99916,39.999A39.99858,39.99858,0,0,0,255.99959,216.00708Z"
  ]
};
export const faGameBoard = {
  prefix: "far",
  iconName: "game-board",
  icon: [
    512,
    512,
    [],
    "f867",
    "M480 0H32A32 32 0 0 0 0 32v448a32 32 0 0 0 32 32h448a32 32 0 0 0 32-32V32a32 32 0 0 0-32-32zm-16 464H48V48h416zm-32-32v-88h-88v88zm0-176v-88h-88v88zM80 80v88h88V80zm264 0h-88v88h88zM168 432h88v-88h-88zm88-264h-88v88h88zm0 176h88v-88h-88zm-88-88H80v88h88z"
  ]
};
export const faGameBoardAlt = {
  prefix: "far",
  iconName: "game-board-alt",
  icon: [
    512,
    512,
    [],
    "f868",
    "M480 0H32A32 32 0 0 0 0 32v448a32 32 0 0 0 32 32h448a32 32 0 0 0 32-32V32a32 32 0 0 0-32-32zm-16 464H48V48h416zm-48-48V256H256v160zM256 96H96v160h160z"
  ]
};
export const faGameConsoleHandheld = {
  prefix: "far",
  iconName: "game-console-handheld",
  icon: [
    384,
    512,
    [],
    "f8bb",
    "M352 0H32A32 32 0 0 0 0 32v448a32 32 0 0 0 32 32h256a96 96 0 0 0 96-96V32a32 32 0 0 0-32-32zm-16 416a48.05 48.05 0 0 1-48 48H48V48h288zM112 240h144a32 32 0 0 0 32-32V96a16 16 0 0 0-16-16H112a16 16 0 0 0-16 16v128a16 16 0 0 0 16 16zM88 352h24v24a8 8 0 0 0 8 8h16a8 8 0 0 0 8-8v-24h24a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8h-24v-24a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v24H88a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8zm144-16a24 24 0 1 0 24 24 24 24 0 0 0-24-24zm24-24a24 24 0 1 0 24-24 24 24 0 0 0-24 24z"
  ]
};
export const faGamepad = {
  prefix: "far",
  iconName: "gamepad",
  icon: [
    640,
    512,
    [],
    "f11b",
    "M432 240a32 32 0 1 0 32 32 32 32 0 0 0-32-32zm-184-24h-48v-48a8 8 0 0 0-8-8h-32a8 8 0 0 0-8 8v48h-48a8 8 0 0 0-8 8v32a8 8 0 0 0 8 8h48v48a8 8 0 0 0 8 8h32a8 8 0 0 0 8-8v-48h48a8 8 0 0 0 8-8v-32a8 8 0 0 0-8-8zm248-40a32 32 0 1 0 32 32 32 32 0 0 0-32-32zM464 64H176a176 176 0 1 0 120.81 304h46.38A176 176 0 1 0 464 64zm0 304c-55.81 0-85.5-32.69-101.69-48h-84.62c-15.6 14.69-45.5 48-101.69 48a128 128 0 0 1 0-256h288a128 128 0 0 1 0 256z"
  ]
};
export const faGamepadAlt = {
  prefix: "far",
  iconName: "gamepad-alt",
  icon: [
    640,
    512,
    [],
    "f8bc",
    "M400 224a32 32 0 1 0 32 32 32 32 0 0 0-32-32zm238.57 114.4l-27.5-181.25C603.32 106 565.45 65 515.68 53.79a889.52 889.52 0 0 0-391.36 0C74.55 65 36.68 106 28.93 157.15L1.44 338.4C-9.86 412.85 46.94 480 121.21 480h.25a121 121 0 0 0 108.38-67.94L243.67 384h152.66l13.83 28.06A121 121 0 0 0 518.55 480h.25c74.27 0 131.06-67.15 119.77-141.6zm-64.85 68.19A71.66 71.66 0 0 1 518.55 432c-27.79 0-52.82-15.77-65.34-41.17l-13.83-28.05-13.2-26.78H213.82l-13.2 26.78-13.83 28.05c-12.52 25.4-37.55 41.17-65.58 41.17a71.55 71.55 0 0 1-54.93-25.41 76 76 0 0 1-17.39-61l27.49-181.24c4.83-31.8 27.79-56.82 58.5-63.74a841.73 841.73 0 0 1 370.25 0c30.71 6.92 53.66 31.94 58.49 63.74l27.49 181.25a76 76 0 0 1-17.39 60.99zM496 160a32 32 0 1 0 32 32 32 32 0 0 0-32-32zm-232 40h-48v-48a8 8 0 0 0-8-8h-32a8 8 0 0 0-8 8v48h-48a8 8 0 0 0-8 8v32a8 8 0 0 0 8 8h48v48a8 8 0 0 0 8 8h32a8 8 0 0 0 8-8v-48h48a8 8 0 0 0 8-8v-32a8 8 0 0 0-8-8z"
  ]
};
export const faGarage = {
  prefix: "far",
  iconName: "garage",
  icon: [
    640,
    512,
    [],
    "e009",
    "M597.91,110.08,346.31,5.29a68.1,68.1,0,0,0-52.62,0L42.09,110.08A68.11,68.11,0,0,0,0,173.2V496a16,16,0,0,0,16,16H32a16,16,0,0,0,16-16V173.2a20.18,20.18,0,0,1,12.5-18.8L312.19,49.58a20.49,20.49,0,0,1,15.72,0L579.5,154.4A20.38,20.38,0,0,1,592,173.2V496a16,16,0,0,0,16,16h16a16,16,0,0,0,16-16V173.2A68.11,68.11,0,0,0,597.91,110.08ZM504,192H136a40,40,0,0,0-40,40V496a16,16,0,0,0,16,16h16a16,16,0,0,0,16-16V352H496V496a16,16,0,0,0,16,16h16a16,16,0,0,0,16-16V232A40,40,0,0,0,504,192Zm-8,128H144V240H496ZM368,416H272a16,16,0,0,0,0,32h96a16,16,0,0,0,0-32Z"
  ]
};
export const faGarageCar = {
  prefix: "far",
  iconName: "garage-car",
  icon: [
    640,
    512,
    [],
    "e00a",
    "M504,192H136a40,40,0,0,0-40,40V496a16,16,0,0,0,16,16h16a16,16,0,0,0,16-16V240H496V496a16,16,0,0,0,16,16h16a16,16,0,0,0,16-16V232A40,40,0,0,0,504,192Zm93.91-81.91L346.31,5.29a68.1,68.1,0,0,0-52.62,0L42.09,110.08A68.1,68.1,0,0,0,0,173.19V496a16,16,0,0,0,16,16H32a16,16,0,0,0,16-16V173.19a20.19,20.19,0,0,1,12.5-18.8L312.19,49.58a20.49,20.49,0,0,1,15.72,0L579.5,154.39a20.39,20.39,0,0,1,12.5,18.8V496a16,16,0,0,0,16,16h16a16,16,0,0,0,16-16V173.19A68.1,68.1,0,0,0,597.91,110.08ZM430.19,370.38l-11.61-46.45a69.07,69.07,0,0,0-67.12-52.4h-64A69.07,69.07,0,0,0,220.35,324l-11.7,46.79A47.83,47.83,0,0,0,176,416v24a23.79,23.79,0,0,0,16,22.38V496a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16V464H384v32a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16V462.38A23.79,23.79,0,0,0,464,440V416A47.83,47.83,0,0,0,430.19,370.38ZM232,436.56c-9.6,0-16-6.64-16-16.61s6.4-16.62,16-16.62,24,14.95,24,24.92S241.6,436.56,232,436.56ZM258.81,368l8.11-32.42a21.14,21.14,0,0,1,20.54-16.05h64A21.14,21.14,0,0,1,372,335.58L380.12,368ZM408,436.56c-9.6,0-24,1.66-24-8.31s14.4-24.92,24-24.92S424,410,424,420,417.6,436.56,408,436.56Z"
  ]
};
export const faGarageOpen = {
  prefix: "far",
  iconName: "garage-open",
  icon: [
    640,
    512,
    [],
    "e00b",
    "M597.91,110.08,346.31,5.29a68.1,68.1,0,0,0-52.62,0L42.09,110.08A68.1,68.1,0,0,0,0,173.19V496a16,16,0,0,0,16,16H32a16,16,0,0,0,16-16V173.19a20.19,20.19,0,0,1,12.5-18.8L312.19,49.58a20.49,20.49,0,0,1,15.72,0L579.5,154.39a20.39,20.39,0,0,1,12.5,18.8V496a16,16,0,0,0,16,16h16a16,16,0,0,0,16-16V173.19A68.1,68.1,0,0,0,597.91,110.08ZM504,192H136a40,40,0,0,0-40,40V496a16,16,0,0,0,16,16h16a16,16,0,0,0,16-16V320H496V496a16,16,0,0,0,16,16h16a16,16,0,0,0,16-16V232A40,40,0,0,0,504,192Zm-8,48v48H144V240H496ZM430.19,370.38,425.6,352H376.12l4,16H258.81l4-16H213.33l-4.68,18.74A47.83,47.83,0,0,0,176,416v24a23.79,23.79,0,0,0,16,22.38V496a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16V464H384v32a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16V462.38A23.79,23.79,0,0,0,464,440V416A47.83,47.83,0,0,0,430.19,370.38ZM232,436.56c-9.6,0-16-6.64-16-16.61s6.4-16.62,16-16.62,24,14.95,24,24.92S241.6,436.56,232,436.56Zm176,0c-9.6,0-24,1.66-24-8.31s14.4-24.92,24-24.92S424,410,424,420,417.6,436.56,408,436.56Z"
  ]
};
export const faGasPump = {
  prefix: "far",
  iconName: "gas-pump",
  icon: [
    512,
    512,
    [],
    "f52f",
    "M493.3 107.3l-86.6-86.6c-3.1-3.1-8.2-3.1-11.3 0l-22.6 22.6c-3.1 3.1-3.1 8.2 0 11.3L416 97.9V160c0 28.1 20.9 51.3 48 55.2V376c0 13.2-10.8 24-24 24s-24-10.8-24-24v-32c0-48.6-39.4-88-88-88h-8V48c0-26.5-21.5-48-48-48H80C53.5 0 32 21.5 32 48v416H8c-4.4 0-8 3.6-8 8v32c0 4.4 3.6 8 8 8h336c4.4 0 8-3.6 8-8v-32c0-4.4-3.6-8-8-8h-24V304h8c22.1 0 40 17.9 40 40v27.8c0 37.7 27 72 64.5 75.9 43 4.3 79.5-29.5 79.5-71.7V152.6c0-17-6.7-33.3-18.7-45.3zM272 464H80V240h192v224zm0-272H80V48h192v144z"
  ]
};
export const faGasPumpSlash = {
  prefix: "far",
  iconName: "gas-pump-slash",
  icon: [
    640,
    512,
    [],
    "f5f4",
    "M633.99 471.02L36 3.51C29.1-2.01 19.03-.9 13.51 6l-10 12.49C-2.02 25.39-.9 35.46 6 40.98l598 467.51c6.9 5.52 16.96 4.4 22.49-2.49l10-12.49c5.52-6.9 4.41-16.97-2.5-22.49zM480 97.94V160c0 28.14 20.93 51.27 48 55.19v112.04l48 37.53V152.57c0-16.97-6.74-33.25-18.75-45.26l-86.63-86.63c-3.12-3.12-8.19-3.12-11.31 0L436.68 43.3c-3.12 3.12-3.12 8.19 0 11.31L480 97.94zM336 48v129.12l48 37.53V48c0-26.51-21.49-48-48-48H144c-9.28 0-17.86 2.75-25.21 7.31L170.84 48H336zm72 416h-24v-66.58l-48-37.53V464H144V209.79l-48-37.53V464H72c-4.42 0-8 3.58-8 8v32c0 4.42 3.58 8 8 8h336c4.42 0 8-3.58 8-8v-32c0-4.42-3.58-8-8-8z"
  ]
};
export const faGavel = {
  prefix: "far",
  iconName: "gavel",
  icon: [
    512,
    512,
    [],
    "f0e3",
    "M497.965 176.618l-23.185-23.185c-13.611-13.61-33.433-17.321-50.434-11.133l-54.624-54.624c6.189-16.998 2.479-36.821-11.133-50.433l-23.185-23.174c-18.757-18.757-49.122-18.76-67.882 0L163.914 117.667c-18.715 18.715-18.715 49.167 0 67.883l23.184 23.184c13.613 13.613 33.433 17.326 50.434 11.133l10.342 10.342-56.543 56.52c-22.021-22.02-51.866-19.249-69.498-1.616L14.069 392.908c-18.757 18.757-18.76 49.122 0 67.882l37.163 37.174c18.714 18.714 49.165 18.715 67.882 0l107.773-107.796c17.412-17.41 20.652-47.231-1.616-69.499l56.543-56.519 10.341 10.341c-6.189 16.998-2.479 36.821 11.134 50.434l25.417 25.417c17.484 17.484 45.932 17.485 63.417 0L497.965 244.5c18.713-18.715 18.713-49.167 0-67.882zM85.195 464.043l-.021-.021L48 426.849l107.773-107.795 37.173 37.173L85.195 464.043zm275.219-149.875l-23.184-23.184 14.793-14.793L235.832 160l-14.792 14.792-23.184-23.184L301.465 48l23.184 23.184L307.832 88l116.191 116.191 16.816-16.816 23.184 23.184-103.609 103.609z"
  ]
};
export const faGem = {
  prefix: "far",
  iconName: "gem",
  icon: [
    576,
    512,
    [],
    "f3a5",
    "M464 0H112c-4 0-7.8 2-10 5.4L2 152.6c-2.9 4.4-2.6 10.2.7 14.2l276 340.8c4.8 5.9 13.8 5.9 18.6 0l276-340.8c3.3-4.1 3.6-9.8.7-14.2L474.1 5.4C471.8 2 468.1 0 464 0zm-19.3 48l63.3 96h-68.4l-51.7-96h56.8zm-202.1 0h90.7l51.7 96H191l51.6-96zm-111.3 0h56.8l-51.7 96H68l63.3-96zm-43 144h51.4L208 352 88.3 192zm102.9 0h193.6L288 435.3 191.2 192zM368 352l68.2-160h51.4L368 352z"
  ]
};
export const faGenderless = {
  prefix: "far",
  iconName: "genderless",
  icon: [
    288,
    512,
    [],
    "f22d",
    "M144 160c52.9 0 96 43.1 96 96s-43.1 96-96 96-96-43.1-96-96 43.1-96 96-96m0-48C64.5 112 0 176.5 0 256s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144z"
  ]
};
export const faGhost = {
  prefix: "far",
  iconName: "ghost",
  icon: [
    384,
    512,
    [],
    "f6e2",
    "M192 0c-1.96 0-3.93.03-5.91.09C81.01 3.24 0 94.92 0 200.05v263.92C0 473.61 7.89 480 16.12 480c3.93 0 7.94-1.46 11.2-4.72l24.92-18.53c2.86-2.12 6.21-3.16 9.54-3.16 4.43 0 8.82 1.83 11.97 5.38l42.95 48.35c3.12 3.12 7.22 4.69 11.31 4.69s8.19-1.56 11.31-4.69l40.72-45.85c3.18-3.58 7.57-5.38 11.96-5.38s8.78 1.79 11.96 5.38l40.72 45.85c3.12 3.12 7.22 4.69 11.31 4.69s8.19-1.56 11.31-4.69l42.95-48.35a15.994 15.994 0 0 1 21.51-2.22l24.92 18.53c3.26 3.26 7.27 4.72 11.2 4.72 8.22 0 16.12-6.39 16.12-16.03V192C384 85.96 298.04 0 192 0zm144 407.07c-4.48-.98-9.09-1.48-13.77-1.48-18.28 0-35.72 7.83-47.86 21.5L256 447.77l-16.15-18.18c-12.13-13.66-29.58-21.5-47.85-21.5s-35.71 7.84-47.85 21.5L128 447.77l-18.38-20.69a64.069 64.069 0 0 0-47.86-21.49c-4.68 0-9.29.5-13.77 1.48V200.05c0-81.49 62.6-149.67 139.53-151.98L192 48c79.4 0 144 64.6 144 144v215.07zM128 160c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm128 0c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32z"
  ]
};
export const faGift = {
  prefix: "far",
  iconName: "gift",
  icon: [
    512,
    512,
    [],
    "f06b",
    "M464 144h-26.1c6.2-12.1 10.1-25.5 10.1-40 0-48.5-39.5-88-88-88-41.6 0-68.5 21.3-103 68.3-34.5-47-61.4-68.3-103-68.3-48.5 0-88 39.5-88 88 0 14.5 3.8 27.9 10.1 40H48c-26.5 0-48 21.5-48 48v128c0 8.8 7.2 16 16 16h16v107.4c0 29 23.6 52.6 52.6 52.6h342.8c29 0 52.6-23.6 52.6-52.6V336h16c8.8 0 16-7.2 16-16V192c0-26.5-21.5-48-48-48zM232 448H84.6c-2.5 0-4.6-2-4.6-4.6V336h112v-48H48v-96h184v256zm-78.1-304c-22.1 0-40-17.9-40-40s17.9-40 40-40c22 0 37.5 7.6 84.1 77l2 3h-86.1zm122-3C322.5 71.6 338 64 360 64c22.1 0 40 17.9 40 40s-17.9 40-40 40h-86.1l2-3zM464 288H320v48h112v107.4c0 2.5-2 4.6-4.6 4.6H280V192h184v96z"
  ]
};
export const faGiftCard = {
  prefix: "far",
  iconName: "gift-card",
  icon: [
    576,
    512,
    [],
    "f663",
    "M528 128h-58.07c6.22-12.06 10.07-25.52 10.07-40 0-48.52-39.48-88-88-88-41.6 0-68.51 21.34-103.04 68.33C254.44 21.33 227.53 0 185.93 0c-48.52 0-88 39.48-88 88 0 14.48 3.85 27.94 10.07 40H48c-26.51 0-48 21.49-48 48v288c0 26.51 21.49 48 48 48h480c26.51 0 48-21.49 48-48V176c0-26.51-21.49-48-48-48zM392 48c22.06 0 40 17.94 40 40 0 22.05-17.94 40-40 40h-86.07c51.36-76.47 65.72-80 86.07-80zM145.93 88c0-22.06 17.94-40 40-40 19.94 0 34.58 3.27 86.07 80h-86.07c-22.06 0-40-17.95-40-40zm76.13 88l-51.72 51.72c-6.25 6.25-6.25 16.38 0 22.63l11.31 11.31c6.25 6.25 16.38 6.25 22.63 0L288 177.94l83.72 83.72c6.25 6.25 16.38 6.25 22.63 0l11.31-11.31c6.25-6.25 6.25-16.38 0-22.63L353.94 176H528v144H48V176h174.06zM48 464v-80h480v80H48z"
  ]
};
export const faGifts = {
  prefix: "far",
  iconName: "gifts",
  icon: [
    640,
    512,
    [],
    "f79c",
    "M608 224h-20.4c2.6-7.6 4.4-15.5 4.4-23.8 0-35.5-27-72.2-72.1-72.2-48.1 0-75.9 47.7-87.9 75.3-11.4-26-36.9-69.4-80-74.3v-1c0-17.7-14.3-32-32-32h-61.4l30.7-22c7.2-5.1 8.9-15.1 3.7-22.3l-9.3-13c-5.1-7.2-15.1-8.9-22.3-3.7l-32 22.9 11.5-30.6c3.1-8.3-1.1-17.5-9.4-20.6l-15-5.6c-8.3-3.1-17.5 1.1-20.6 9.4l-19.9 53-19.9-53.1C153 2.1 143.8-2.1 135.5 1l-15 5.6c-8.3 3.1-12.5 12.3-9.4 20.6l11.5 30.6-32-22.8c-7.2-5.1-17.2-3.5-22.3 3.7l-9.3 13c-5.1 7.2-3.5 17.2 3.7 22.3l30.7 22H32c-17.7 0-32 14.3-32 32v352c0 17.7 14.3 32 32 32h576c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32zm-88.1-48c17.7 0 24.1 14.5 24.1 24.2 0 5.1-1.5 12.6-8.8 19-2.1 1.8-4.5 3.4-7.2 4.8h-52.6c8.8-20.3 25.9-48 44.5-48zm-175.8 0c18.7 0 35.6 27.4 44.5 48H336c-2.7-1.4-5.1-3-7.2-4.8-7.3-6.4-8.8-13.8-8.8-19 0-9.7 6.4-24.2 24.1-24.2zM224 256v208H48V144h250.7c-17 14-26.7 35.2-26.7 56.2 0 8.3 1.7 16.2 4.4 23.8H256c-17.7 0-32 14.3-32 32zm184 208H272v-72h136v72zm0-120H272v-72h136v72zm23.3-120l.7-.2.7.2h-1.4zM592 464H456v-72h136v72zm0-120H456v-72h136v72z"
  ]
};
export const faGingerbreadMan = {
  prefix: "far",
  iconName: "gingerbread-man",
  icon: [
    448,
    512,
    [],
    "f79d",
    "M192 96c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm32 240c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm222.7-109.4c-7.6-46.7-48.5-81-98-82.5.9-5.9 1.3-12 1.3-18.1 0-33.7-13.1-65.3-36.9-89.1C289.3 13.1 257.7 0 224 0s-65.3 13.1-89.1 36.9C111.1 60.7 98 92.3 98 126c0 6.1.4 12.1 1.3 18.1-49.4 1.5-90.4 35.8-98 82.5-4.8 29.2 3.4 58.8 22.5 81.2 11.3 13.3 25.7 23.2 41.7 29.1l-7 8.5c-18 21.6-26.6 50.2-23.6 78.5 2.9 27 15.9 50.9 36.7 67.1 17.4 13.5 39.2 21 61.4 21 29.8 0 57.8-13.1 76.8-36l14.2-17 14.2 17c19.1 22.9 47.1 36 76.8 36 22.2 0 44-7.5 61.5-21.1 20.8-16.2 33.8-40 36.7-67.1 3-28.3-5.6-56.9-23.6-78.5l-7-8.5c16-5.9 30.3-15.8 41.7-29.1 18.9-22.3 27.1-51.9 22.4-81.1zM348 295h-31.2c-8.2 0-14.8 6.6-14.8 14.8 0 3.5 1.2 6.8 3.4 9.5l47.3 56.7c18.9 22.7 17.5 58.8-5.8 77-25.5 19.9-56.9 10.3-71.9-7.7L244 408c-5.2-6.2-12.6-9.4-20-9.4s-14.8 3.1-20 9.4l-31.1 37.3c-15 18.1-46.4 27.6-71.9 7.7-23.3-18.2-24.7-54.3-5.8-77l47.3-56.7c2.2-2.7 3.4-6 3.4-9.5 0-8.2-6.6-14.8-14.8-14.8H100c-66.9 0-72-103 2.8-103h60.4c5.8 0 8.5-7.9 4.5-12.1-13.4-14-21.7-33-21.7-53.9 0-43.1 34.9-78 78-78s78 34.9 78 78c0 20.9-8.3 39.9-21.7 53.9-4 4.2-1.4 12.1 4.5 12.1h60.4c74.8 0 69.8 103 2.8 103zm-124-23c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm32-176c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm-32 112c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16z"
  ]
};
export const faGlass = {
  prefix: "far",
  iconName: "glass",
  icon: [
    384,
    512,
    [],
    "f804",
    "M352 0H32A32 32 0 0 0 .06 34l32 448A32 32 0 0 0 64 512h256a32 32 0 0 0 31.94-30l32-448A32 32 0 0 0 352 0zm-17.19 48l-8 112H57.18l-8-112zM305.1 464H78.9L60.61 208h262.77z"
  ]
};
export const faGlassChampagne = {
  prefix: "far",
  iconName: "glass-champagne",
  icon: [
    256,
    512,
    [],
    "f79e",
    "M200 464h-48V349.5c65-12 111.6-71 103-137.1l-27-185C225.7 11.7 212.2 0 196.3 0H59.7C43.8 0 30.3 11.7 28 27.4L1 212.3c-8.7 66.2 38 125.2 103 137.1V464H56c-22.1 0-40 17.9-40 40 0 4.4 3.6 8 8 8h208c4.4 0 8-3.6 8-8 0-22.1-17.9-40-40-40zM73.5 48h109l11.7 80H61.8l11.7-80zm-6.9 228.6c-14.3-16.3-20.7-37-18-57.4l6.3-43.3h146.3l6.2 42.6c2.8 21.1-3.6 41.7-17.9 58.1C174.2 294 151.8 304 128 304s-46.2-10-61.4-27.4z"
  ]
};
export const faGlassCheers = {
  prefix: "far",
  iconName: "glass-cheers",
  icon: [
    640,
    512,
    [],
    "f79f",
    "M587.6 414.1l-29.8 11.7-40.5-103c50.9-33.5 70.1-100.2 40.2-154.3l-84.1-152C467.6 6.1 456.8 0 445.4 0c-3.9 0-7.9.7-11.7 2.2L320 46.9 206.3 2.2C202.5.7 198.5 0 194.6 0c-11.3 0-22.2 6.1-28 16.5l-84.1 152c-29.9 54.1-10.7 120.8 40.2 154.3l-40.5 103-29.8-11.7c-20.6-8.1-43.8 2-51.9 22.6-1.6 4.1.4 8.8 4.5 10.4l163.8 64.4c4.1 1.6 8.8-.4 10.4-4.5 8.1-20.6-2-43.8-22.6-51.9l-29.8-11.7L167.1 341c8 1.6 16 2.5 23.8 2.5 52.6 0 100.9-34.2 114.2-87.4l14.8-59.6 14.8 59.6c13.2 53.2 61.5 87.4 114.2 87.4 7.9 0 15.9-.9 23.8-2.5l40.2 102.3-29.8 11.7c-20.6 8.1-30.7 31.3-22.6 51.9 1.6 4.1 6.3 6.1 10.4 4.5l164-64.4c4.1-1.6 6.1-6.3 4.5-10.4-8-20.5-31.3-30.6-51.8-22.5zm-329-169.6c-7.5 30-35.3 51-67.6 51-9.4 0-18.7-1.8-27.8-5.3-20.1-7.9-35.7-23.8-42.8-43.5-6.7-18.5-5.2-38 4.1-54.8l25.1-45.3 121.5 47.8-12.5 50.1zm24.2-97.2L173 104.1 201.8 52l95.4 37.5-14.4 57.8zm74.4 0l-14.4-57.7L438.2 52l28.8 52.1-109.8 43.2zm119.6 142.8c-9 3.5-18.3 5.3-27.8 5.3-32.3 0-60.1-21-67.6-51l-12.5-50.3 121.5-47.8 25.1 45.3c9.3 16.8 10.8 36.3 4.1 54.8-7.1 19.9-22.7 35.8-42.8 43.7z"
  ]
};
export const faGlassCitrus = {
  prefix: "far",
  iconName: "glass-citrus",
  icon: [
    512,
    512,
    [],
    "f869",
    "M368 0c-62.61 0-115.35 40.2-135.18 96h52.54C302 67.45 332.63 48 368 48a96.11 96.11 0 0 1 96 96c0 50.07-38.67 90.84-87.63 95.15l-4.84 48.49C449.39 285.73 512 222.32 512 144A144 144 0 0 0 368 0zm-48 128H32A32 32 0 0 0 .16 163.18l32 320A32 32 0 0 0 64 512h224a32 32 0 0 0 31.84-28.82l32-320A32 32 0 0 0 320 128zm-46.48 336h-195l-16-160h227zm20.8-208H57.68l-8-80h252.64z"
  ]
};
export const faGlassMartini = {
  prefix: "far",
  iconName: "glass-martini",
  icon: [
    512,
    512,
    [],
    "f000",
    "M502.05 57.6C523.3 36.34 508.25 0 478.2 0H33.8C3.75 0-11.3 36.34 9.95 57.6L232 279.64V463h-64c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h240c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40h-64V279.64L502.05 57.6zM256 235.76L68.23 48h375.53L256 235.76z"
  ]
};
export const faGlassMartiniAlt = {
  prefix: "far",
  iconName: "glass-martini-alt",
  icon: [
    512,
    512,
    [],
    "f57b",
    "M502.05 57.6C523.3 36.34 508.25 0 478.2 0H33.8C3.75 0-11.3 36.34 9.95 57.6L232 279.64V464h-64c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h240c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40h-64V279.64L502.05 57.6zM256 235.76L164.24 144h183.53L256 235.76zM443.77 48l-48 48H116.24l-48-48h375.53z"
  ]
};
export const faGlassWhiskey = {
  prefix: "far",
  iconName: "glass-whiskey",
  icon: [
    512,
    512,
    [],
    "f7a0",
    "M480 32H32C12.5 32-2.4 49.2.3 68.5l56 356.5c4.5 31.5 31.5 54.9 63.4 54.9h273c31.8 0 58.9-23.4 63.4-54.9l55.6-356.5C514.4 49.2 499.5 32 480 32zm-87.3 400h-273c-7.9 0-14.7-5.9-15.9-14.4L85.9 304h340.4l-17.8 114.3c-1.1 7.8-7.9 13.7-15.8 13.7zm41.1-176H78.4L50.7 80h410.6l-27.5 176z"
  ]
};
export const faGlassWhiskeyRocks = {
  prefix: "far",
  iconName: "glass-whiskey-rocks",
  icon: [
    512,
    512,
    [],
    "f7a1",
    "M480 32H32C12.5 32-2.4 49.2.3 68.5l56 356.5c4.5 31.5 31.5 54.9 63.4 54.9h273c31.8 0 58.9-23.4 63.4-54.9l55.6-356.5C514.4 49.2 499.5 32 480 32zm-87.3 400h-273c-7.9 0-14.7-5.9-15.9-14.4l-13.3-84.7c11.6 11.8 27.7 19.1 45.5 19.1h64c21.7 0 40.9-10.9 52.5-27.6 2.5 4.1 5.4 8 9 11.6l45.3 45.3c12.1 12.1 28.2 18.7 45.3 18.7 17.1 0 33.2-6.7 45.3-18.7l20.2-20.2-8.9 57.2c-1.3 7.8-8.1 13.7-16 13.7zM120 288v-64c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16zm175.4-8.6l45.3-45.3c3-3 7-4.7 11.3-4.7s8.3 1.7 11.3 4.7l45.3 45.3c6.2 6.2 6.2 16.4 0 22.6l-45.3 45.3c-3 3-7 4.7-11.3 4.7s-8.3-1.7-11.3-4.7L295.4 302c-6.2-6.2-6.2-16.3 0-22.6zm141-40l-39.2-39.2c-12.1-12.1-28.2-18.7-45.3-18.7-17.1 0-33.2 6.7-45.3 18.7L264 243v-19c0-35.3-28.7-64-64-64h-64c-33.5 0-60.8 26-63.5 58.8L50.7 80h410.6l-24.9 159.4z"
  ]
};
export const faGlasses = {
  prefix: "far",
  iconName: "glasses",
  icon: [
    576,
    512,
    [],
    "f530",
    "M574.1 280.37L528.75 98.66c-5.91-23.7-21.59-44.05-43-55.81-21.44-11.73-46.97-14.11-70.19-6.33l-15.25 5.08c-8.39 2.79-12.92 11.86-10.12 20.24l5.06 15.18c2.79 8.38 11.85 12.91 20.23 10.12l13.18-4.39c10.87-3.62 23-3.57 33.16 1.73 10.29 5.37 17.57 14.56 20.37 25.82l38.46 153.82c-22.19-6.81-49.79-12.46-81.2-12.46-39.9 0-85.63 9.2-133.04 36.34H269.6c-47.41-27.15-93.13-36.35-133.04-36.35-31.42 0-59.02 5.65-81.21 12.46l38.46-153.83c2.79-11.25 10.09-20.45 20.38-25.81 10.16-5.3 22.28-5.35 33.15-1.73l13.17 4.39c8.38 2.79 17.44-1.74 20.23-10.12l5.06-15.18c2.8-8.38-1.73-17.45-10.12-20.24l-15.25-5.08c-23.22-7.78-48.75-5.41-70.19 6.33-21.41 11.77-37.09 32.11-43 55.8L1.9 280.37A64.218 64.218 0 0 0 0 295.86v70.25C0 429.01 51.58 480 115.2 480h37.12c60.28 0 110.37-45.94 114.88-105.37l2.93-38.63h35.75l2.93 38.63C313.31 434.06 363.4 480 423.68 480h37.12c63.62 0 115.2-50.99 115.2-113.88v-70.25c0-5.23-.64-10.43-1.9-15.5zM219.33 371c-2.6 34.2-32.03 61-67.02 61H115.2C78.15 432 48 402.44 48 366.11v-48.47c19.77-8.19 51.23-17.99 88.58-18 29.78 0 58.86 6.22 86.76 18.53L219.33 371zM528 366.12c0 36.33-30.15 65.88-67.2 65.88h-37.12c-34.98 0-64.42-26.79-67.01-61l-4.01-52.82c27.91-12.31 57-18.53 86.79-18.53 37.37 0 68.84 9.82 88.55 17.98v48.49z"
  ]
};
export const faGlassesAlt = {
  prefix: "far",
  iconName: "glasses-alt",
  icon: [
    576,
    512,
    [],
    "f5f5",
    "M560.51 225.9L528.75 98.64C522.05 71.78 495.01 32 443.33 32c-15.63 0-23.03 2.94-43.02 9.6-8.39 2.79-12.92 11.86-10.12 20.24l5.06 15.18c2.24 6.7 8.48 10.94 15.18 10.94 3.54 0 4.82-.74 18.23-5.21 26.07-8.68 48.2 6.13 53.53 27.54l29.67 118.68C490.97 215.88 466.47 208 440 208c-55.09 0-102.27 32.91-123.65 80h-56.7c-21.38-47.09-68.56-80-123.65-80-26.47 0-50.97 7.88-71.86 20.96l29.67-118.68c5.32-21.41 27.46-36.22 53.53-27.54 13.42 4.47 14.7 5.21 18.23 5.21 6.7 0 12.94-4.24 15.18-10.94l5.06-15.18c2.8-8.38-1.73-17.45-10.12-20.24C155.7 34.94 148.3 32 132.67 32 81 32 53.95 71.78 47.25 98.64L15.49 225.9C2.16 279.34 0 300.12 0 344c0 75.11 60.89 136 136 136 72.37 0 130.97-56.69 135.19-128h33.61c4.22 71.31 62.82 128 135.19 128 75.11 0 136-60.89 136-136 .01-43.88-2.15-64.66-15.48-118.1zM136 432c-48.52 0-88-39.48-88-88s39.48-88 88-88 88 39.48 88 88-39.48 88-88 88zm304 0c-48.52 0-88-39.48-88-88s39.48-88 88-88 88 39.48 88 88-39.48 88-88 88z"
  ]
};
export const faGlobe = {
  prefix: "far",
  iconName: "globe",
  icon: [
    496,
    512,
    [],
    "f0ac",
    "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm179.3 160h-67.2c-6.7-36.5-17.5-68.8-31.2-94.7 42.9 19 77.7 52.7 98.4 94.7zM248 56c18.6 0 48.6 41.2 63.2 112H184.8C199.4 97.2 229.4 56 248 56zM48 256c0-13.7 1.4-27.1 4-40h77.7c-1 13.1-1.7 26.3-1.7 40s.7 26.9 1.7 40H52c-2.6-12.9-4-26.3-4-40zm20.7 88h67.2c6.7 36.5 17.5 68.8 31.2 94.7-42.9-19-77.7-52.7-98.4-94.7zm67.2-176H68.7c20.7-42 55.5-75.7 98.4-94.7-13.7 25.9-24.5 58.2-31.2 94.7zM248 456c-18.6 0-48.6-41.2-63.2-112h126.5c-14.7 70.8-44.7 112-63.3 112zm70.1-160H177.9c-1.1-12.8-1.9-26-1.9-40s.8-27.2 1.9-40h140.3c1.1 12.8 1.9 26 1.9 40s-.9 27.2-2 40zm10.8 142.7c13.7-25.9 24.4-58.2 31.2-94.7h67.2c-20.7 42-55.5 75.7-98.4 94.7zM366.3 296c1-13.1 1.7-26.3 1.7-40s-.7-26.9-1.7-40H444c2.6 12.9 4 26.3 4 40s-1.4 27.1-4 40h-77.7z"
  ]
};
export const faGlobeAfrica = {
  prefix: "far",
  iconName: "globe-africa",
  icon: [
    496,
    512,
    [],
    "f57c",
    "M248 8C111.04 8 0 119.03 0 256s111.04 248 248 248 248-111.03 248-248S384.96 8 248 8zm0 448c-110.28 0-200-89.72-200-200S137.72 56 248 56c10.92 0 21.55 1.12 32 2.81v21.7c0 8.56-6.94 15.5-15.5 15.5h-24.21c-5.18 0-10.02 2.59-12.89 6.9l-8.08 12.11c-2.14 3.21-5.4 5.5-9.14 6.44l-14.45 3.61a15.492 15.492 0 0 0-11.74 15.04v4.4c0 8.56 6.94 15.5 15.5 15.5h90.09c4.11 0 8.05 1.63 10.96 4.54l6.92 6.92c2.91 2.91 6.85 4.54 10.96 4.54h10.09c8.56 0 15.5 6.94 15.5 15.5 0 6.67-4.27 12.59-10.6 14.7l-47.31 15.77c-3.9 1.3-8.15 1-11.83-.84l-14.72-7.36a54.682 54.682 0 0 0-24.43-5.77h-.89c-11.82 0-23.32 3.83-32.78 10.93l-27.58 20.69A54.545 54.545 0 0 0 152 283.31v14.06c0 14.49 5.76 28.38 16 38.63a54.641 54.641 0 0 0 38.63 16h25.88c8.56 0 15.5 6.94 15.5 15.5v29.88c0 12.25 2.85 24.33 8.33 35.29 4.7 9.4 14.31 15.34 24.82 15.34 9.28 0 17.94-4.64 23.09-12.36l13.03-19.55a159.608 159.608 0 0 1 25-29.16c2.47-2.26 4.14-5.26 4.76-8.56l4.3-22.83c.44-2.33 1.41-4.53 2.83-6.43l18.74-24.98c2.01-2.68 3.1-5.95 3.1-9.3V303.5c0-8.56-6.94-15.5-15.5-15.5h-8.21c-5.18 0-10.02-2.59-12.89-6.9l-13.24-19.86c-5.67-8.5-1.7-20.07 7.99-23.3l2.65-.88c4.54-1.51 9.52-.85 13.5 1.81l18.21 12.14a15.532 15.532 0 0 0 15.53.97l15.39-7.7c5.25-2.62 8.57-7.99 8.57-13.86v-6.93c0-8.56 6.94-15.5 15.5-15.5h18.44c3.82 15.41 6.07 31.43 6.07 48C448 366.28 358.28 456 248 456z"
  ]
};
export const faGlobeAmericas = {
  prefix: "far",
  iconName: "globe-americas",
  icon: [
    496,
    512,
    [],
    "f57d",
    "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-32 50.8v11.3c0 11.9-12.5 19.6-23.2 14.3l-24-12c14.9-6.4 30.7-10.9 47.2-13.6zm32 369.8V456c-110.3 0-200-89.7-200-200 0-29.1 6.4-56.7 17.6-81.7 9.9 14.7 25.2 37.4 34.6 51.1 5.2 7.6 11.2 14.6 18.1 20.7l.8.7c9.5 8.6 20.2 16 31.6 21.8 14 7 34.4 18.2 48.8 26.1 10.2 5.6 16.5 16.3 16.5 28v32c0 8.5 3.4 16.6 9.4 22.6 15 15.1 24.3 38.7 22.6 51.3zm42.7 22.7l17.4-46.9c2-5.5 3.3-11.2 4.8-16.9 1.1-4 3.2-7.7 6.2-10.7l11.3-11.3c8.8-8.7 13.7-20.6 13.7-33 0-8.1-3.2-15.9-8.9-21.6l-13.7-13.7c-6-6-14.1-9.4-22.6-9.4H232c-9.4-4.7-21.5-32-32-32s-20.9-2.5-30.3-7.2l-11.1-5.5c-4-2-6.6-6.2-6.6-10.7 0-5.1 3.3-9.7 8.2-11.3l31.2-10.4c5.4-1.8 11.3-.6 15.5 3.1l9.3 8.1c1.5 1.3 3.3 2 5.2 2h5.6c6 0 9.8-6.3 7.2-11.6l-15.6-31.2c-1.6-3.1-.9-6.9 1.6-9.3l9.9-9.6c1.5-1.5 3.5-2.3 5.6-2.3h9c2.1 0 4.2-.8 5.7-2.3l8-8c3.1-3.1 3.1-8.2 0-11.3l-4.7-4.7c-3.1-3.1-3.1-8.2 0-11.3L264 112l4.7-4.7c6.2-6.2 6.2-16.4 0-22.6l-28.3-28.3c2.5-.1 5-.4 7.6-.4 78.2 0 145.8 45.2 178.7 110.7l-13 6.5c-3.7 1.9-6.9 4.7-9.2 8.1l-19.6 29.4c-5.4 8.1-5.4 18.6 0 26.6l18 27c3.3 5 8.4 8.5 14.1 10l29.2 7.3c-10.8 84-73.9 151.9-155.5 169.7z"
  ]
};
export const faGlobeAsia = {
  prefix: "far",
  iconName: "globe-asia",
  icon: [
    496,
    512,
    [],
    "f57e",
    "M403.31 322.49l-11.91-11.91a8.008 8.008 0 0 1-2.34-5.66V292c0-2.21-1.79-4-4-4H379c-1.78 0-3.35 1.18-3.84 2.88l-4.2 14.47a3.996 3.996 0 0 1-3.84 2.88h-3.8a3.99 3.99 0 0 1-3.69-2.46l-5.35-12.85a8.003 8.003 0 0 0-7.39-4.93H334.8c-1.66 0-3.29.52-4.64 1.48l-23.71 16.89a26.355 26.355 0 0 1-5.59 3.05l-39.34 15.74a7.996 7.996 0 0 0-5.03 7.43v10.21c0 2.12.84 4.16 2.34 5.66l11.91 11.91c3 3 7.07 4.69 11.31 4.69h10.34c1.31 0 2.61-.16 3.88-.48l21.27-5.32c9.12-2.28 18.77.39 25.42 7.04l13.01 13.01c3 3 7.07 4.69 11.31 4.69h15.16c4.24 0 8.31-1.69 11.31-4.69l9.57-9.57c3-3 4.69-7.07 4.69-11.31V333.8c-.01-4.24-1.7-8.31-4.7-11.31zM248 8C111.04 8 0 119.03 0 256s111.04 248 248 248 248-111.03 248-248S384.96 8 248 8zm0 448c-99.37 0-181.8-72.91-197.19-168h62.57c4.24 0 8.31-1.69 11.31-4.69l19.47-19.46c3.86-3.86 10.37-2.8 12.81 2.08l22.62 45.23c2.71 5.42 8.25 8.85 14.31 8.85h6.1c8.84 0 16-7.16 16-16v-9.37c0-4.24-1.69-8.31-4.69-11.31l-5.66-5.66c-3.12-3.12-3.12-8.19 0-11.31l5.66-5.66c3-3 7.07-4.69 11.31-4.69h.31c5.62 0 10.83-2.95 13.72-7.77l17.37-28.95c1.8-3 6.2-2.83 7.76.3a7.996 7.996 0 0 0 7.15 4.42H272c4.42 0 8-3.58 8-8V137.9c0-6.06-3.42-11.6-8.84-14.31l-10.83-5.41c-5.49-2.75-5.97-10.4-.86-13.81l50.16-38.53C389.83 91.88 448 167.23 448 256c0 110.28-89.72 200-200 200z"
  ]
};
export const faGlobeEurope = {
  prefix: "far",
  iconName: "globe-europe",
  icon: [
    496,
    512,
    [],
    "f7a2",
    "M178.1 123.7c0-6.2-5.1-11.3-11.3-11.3-3 0-5.9 1.2-8 3.3l-25.4 25.4c-2.1 2.1-3.3 5-3.3 8 0 6.2 5.1 11.3 11.3 11.3h16c3 0 5.9-1.2 8-3.3l9.4-9.4c2.1-2.1 3.3-5 3.3-8v-16zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm175.1 344.4h-13.4c-4.8 0-9.5-1.9-12.9-5.3l-17.3-17.3c-6-6-14.1-9.4-22.6-9.4h-18.3l-43.2-37.1c-8.2-7.1-18.7-10.9-29.6-10.9h-31.2c-8.2 0-16.3 2.2-23.4 6.5l-42.9 25.7c-13.7 8.2-22.1 23-22.1 39v23.9c0 14.3 6.7 27.8 18.2 36.4l22.2 16.7c8.6 6.5 24.6 11.8 35.4 11.8h20.2c8.8 0 16 7.2 16 16v7.1c-3.4.2-6.7.5-10.1.5-110.3 0-200-89.7-200-200 0-108.3 86.7-196.6 194.3-199.7L213.3 78c-2 1.5-3.2 3.9-3.2 6.4v20c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-8l16-16h20.7c6.2 0 11.3 5 11.3 11.3 0 3-1.2 5.9-3.3 8L260 126.5c-1.2 1.2-2.7 2.2-4.4 2.7l-40 13.3c-3.3 1.1-5.5 4.1-5.5 7.6 0 6.6-2.6 12.8-7.2 17.5l-20.1 20.1c-3 3-4.7 7.1-4.7 11.3v25.4c0 8.8 7.2 16 16 16h22.1c6.1 0 11.6-3.4 14.3-8.8l9.4-18.7c1.4-2.7 4.1-4.4 7.2-4.4h3.1c4.4 0 8 3.6 8 8s3.6 8 8 8h16c4.4 0 8-3.6 8-8v-2.2c0-3.4 2.2-6.5 5.5-7.6l31.6-10.5c6.5-2.2 10.9-8.3 10.9-15.2v-4.5c0-8.8 7.2-16 16-16h36.7c6.2 0 11.3 5.1 11.3 11.3v9.4c0 6.2-5.1 11.3-11.3 11.3h-32c-3 0-5.9 1.2-8 3.3l-9.4 9.4c-2.1 2.1-3.3 5-3.3 8 0 6.2 5.1 11.3 11.3 11.3h16c3 0 5.9 1.2 8 3.3l9.4 9.4c2.1 2.1 3.3 5 3.3 8v8.7l-12.5 12.5c-4.6 4.6-4.6 12-.1 16.7l31.9 32.6c3 3.1 7.1 4.8 11.4 4.8h20.3c-3.8 11-8.5 21.7-14.1 31.9z"
  ]
};
export const faGlobeSnow = {
  prefix: "far",
  iconName: "globe-snow",
  icon: [
    448,
    512,
    [],
    "f7a3",
    "M232 80c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm-128 80c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm224-16c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm35.3 255c51.5-41 84.7-104 84.7-175C448 100.3 347.7 0 224 0S0 100.3 0 224c0 71 33.2 134 84.7 175l-46.3 61.8C22.6 481.9 37.6 512 64 512h320c26.4 0 41.4-30.1 25.6-51.2L363.3 399zM96 464l24-32h208l24 32H96zm200.9-80H256v-48h57.9c14.2 0 22-15 12.9-24.9L276 256h15.4c10.7 0 16.5-11.2 9.7-18.7l-67.4-73.2c-5-5.5-14.3-5.5-19.3 0L147 237.3c-6.8 7.4-1 18.7 9.7 18.7H172l-50.7 55.1c-9.1 9.9-1.3 24.9 12.9 24.9H192v48h-40.9C90.4 356.2 48 295 48 224c0-97 79-176 176-176s176 79 176 176c0 71-42.4 132.2-103.1 160z"
  ]
};
export const faGlobeStand = {
  prefix: "far",
  iconName: "globe-stand",
  icon: [
    448,
    512,
    [],
    "f5f6",
    "M208.07 352c88.4 0 160.06-71.63 160.06-160 0-88.32-71.61-160-160.06-160-88.4 0-160.06 71.63-160.06 160 .01 88.31 71.61 160 160.06 160zm0-272c61.88 0 112.04 50.14 112.04 112s-50.16 112-112.04 112S96.03 253.86 96.03 192 146.19 80 208.07 80zm140.05 384H248.09v-35.53c47.5-7.92 93.08-30.1 129.75-66.77 85.25-85.22 92.73-218.44 22.91-312.38l10.7-10.7c6.25-6.25 6.25-16.38 0-22.63l-11.31-11.3c-6.25-6.25-16.38-6.25-22.64 0L334.47 47.7c3.17 2.79 6.39 5.52 9.41 8.53 36.28 36.26 56.26 84.48 56.26 135.77s-19.98 99.5-56.26 135.76S259.37 384 208.07 384s-99.53-19.97-135.81-56.24c-3.02-3.02-5.75-6.23-8.53-9.41L4.69 377.38c-6.25 6.25-6.25 16.38 0 22.63L16 411.31c6.25 6.25 16.38 6.25 22.64 0l26.71-26.7c40.03 29.72 87.18 45.3 134.72 46.95V464H100.03c-19.89 0-36.01 16.12-36.01 36 0 6.63 5.37 12 12 12h296.1c6.63 0 12-5.37 12-12 .01-19.88-16.11-36-36-36z"
  ]
};
export const faGolfBall = {
  prefix: "far",
  iconName: "golf-ball",
  icon: [
    416,
    512,
    [],
    "f450",
    "M416 208C416 94.2 324.7 1.8 211.3 0 97.3-1.8 2.5 89.4.1 203.4c-1.3 60.7 23.6 115.3 64 154.1V416c0 30.9 25.1 56 56 56h16c4.4 0 8 3.6 8 8v20c0 6.6 5.4 12 12 12h24c6.6 0 12-5.4 12-12v-20c0-30.9-25.1-56-56-56-12.8 0-24 2.1-24-8v-32h192v32c0 10.1-11.2 8-24 8-30.9 0-56 25.1-56 56v20c0 6.6 5.4 12 12 12h24c6.6 0 12-5.4 12-12v-20c0-4.4 3.6-8 8-8h16c30.9 0 56-25.1 56-56v-58.5C391.3 319.7 416 266.8 416 208zM208 48c88.2 0 160 71.8 160 160 0 52.7-25.9 99-65.5 128h-189C73.9 307 48 260.7 48 208c0-88.2 71.8-160 160-160zm48 142.9c0 18.3-14.8 33.1-33.1 33.1-14.4 0-26.3-9.3-30.9-22.1 26.3 9.4 51.5-15.2 41.9-41.9 12.8 4.6 22.1 16.5 22.1 30.9zm80 16c0 18.3-14.8 33.1-33.1 33.1-14.4 0-26.3-9.3-30.9-22.1 26.3 9.4 51.5-15.2 41.9-41.9 12.8 4.6 22.1 16.5 22.1 30.9zm-64 64c0 18.3-14.8 33.1-33.1 33.1-14.4 0-26.3-9.3-30.9-22.1 26.3 9.4 51.5-15.2 41.9-41.9 12.8 4.6 22.1 16.5 22.1 30.9z"
  ]
};
export const faGolfClub = {
  prefix: "far",
  iconName: "golf-club",
  icon: [
    640,
    512,
    [],
    "f451",
    "M631 8.6l-14.4-6.9c-8-3.9-17.5-.5-21.4 7.4L465.5 279.3 75.8 206.2C36 198.7 0 229.5 0 269.1V448c0 35.3 28.6 64 64 64h302.7c24.6 0 47-14.1 57.7-36.3l214-445.8c3.8-7.9.5-17.5-7.4-21.3zM434.9 342.9l-53.8 112c-2.7 5.5-8.3 9.1-14.4 9.1H64c-19.1 0-16-23-16-24h72c4.4 0 8-3.6 8-8v-32c0-4.4-3.6-8-8-8H48v-48h72c4.4 0 8-3.6 8-8v-32c0-4.4-3.6-8-8-8H48v-26.9c0-9.6 8.6-17.7 18.9-15.7l356.5 66.9c10.4 1.9 16 13.1 11.5 22.6z"
  ]
};
export const faGopuram = {
  prefix: "far",
  iconName: "gopuram",
  icon: [
    512,
    512,
    [],
    "f664",
    "M496 352h-16V240c0-8.84-7.16-16-16-16h-16v-80c0-8.84-7.16-16-16-16h-16V24c0-13.26-10.75-24-24-24s-24 10.74-24 24v8h-48v-8c0-13.26-10.75-24-24-24s-24 10.74-24 24v8h-32v-8c0-13.26-10.75-24-24-24s-24 10.74-24 24v8h-48v-8c0-13.26-10.75-24-24-24S96 10.74 96 24v104H80c-8.84 0-16 7.16-16 16v80H48c-8.84 0-16 7.16-16 16v112H16c-8.84 0-16 7.16-16 16v128c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-96h48v104c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V400h256v104c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V400h48v96c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V368c0-8.84-7.16-16-16-16zM144 80h224v48H144V80zm120 120h-16c-8.84 0-16 7.16-16 16v8h-40v-48h128v48h-40v-8c0-8.84-7.16-16-16-16zm-152-24h48v48h-48v-48zm16 176H80v-80h48v80zm224 0h-64v-32c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v32h-64v-80h192v80zm0-128v-48h48v48h-48zm80 128h-48v-80h48v80zm-144 80h-64c-8.84 0-16 7.16-16 16v64h96v-64c0-8.84-7.16-16-16-16z"
  ]
};
export const faGraduationCap = {
  prefix: "far",
  iconName: "graduation-cap",
  icon: [
    640,
    512,
    [],
    "f19d",
    "M606.72 147.91l-258-79.57c-18.81-5.78-38.62-5.78-57.44 0l-258 79.57C13.38 154.05 0 171.77 0 192.02s13.38 37.97 33.28 44.11l22.64 6.98c-2.46 5.19-4.4 10.62-5.7 16.31C39.53 264.6 32 275.33 32 288.01c0 10.78 5.68 19.85 13.86 25.65L20.33 428.53C18.11 438.52 25.71 448 35.95 448h56.11c10.24 0 17.84-9.48 15.62-19.47L82.14 313.66c8.17-5.8 13.86-14.87 13.86-25.65 0-10.6-5.49-19.54-13.43-25.36 1.13-3.55 2.96-6.67 4.85-9.83l54.87 16.92L128 384c0 35.34 85.96 64 192 64s192-28.65 192-64l-14.28-114.26 109-33.62c19.91-6.14 33.28-23.86 33.28-44.11s-13.38-37.96-33.28-44.1zM462.44 374.47c-59.7 34.2-225.9 33.78-284.87 0l11.3-90.36 102.42 31.59c11.15 3.43 32.24 7.77 57.44 0l102.42-31.59 11.29 90.36zM334.59 269.82c-9.44 2.91-19.75 2.91-29.19 0L154.62 223.3l168.31-31.56c8.69-1.62 14.41-9.98 12.78-18.67-1.62-8.72-10.09-14.36-18.66-12.76l-203.78 38.2c-6.64 1.24-12.8 3.54-18.71 6.27L53.19 192l252.22-77.79c9.44-2.91 19.75-2.91 29.19 0l252.22 77.82-252.23 77.79z"
  ]
};
export const faGramophone = {
  prefix: "far",
  iconName: "gramophone",
  icon: [
    384,
    512,
    [],
    "f8bd",
    "M56 320a24 24 0 0 0 13.56-4.2c40.13-27.48 125-77.19 201.19-77.19a144.32 144.32 0 0 1 37.41 4.67A26.79 26.79 0 0 1 328 269.15a34.81 34.81 0 0 1-34.78 34.77H184a24 24 0 0 0-24 24v24h133.22A82.87 82.87 0 0 0 376 269.15a74.88 74.88 0 0 0-55.41-72.26C236.91 174.46 175.43 65 150.84 13.63A24 24 0 0 0 106 17.79l-73.19 272A24 24 0 0 0 56 320zm80.7-231.24c21.79 36.43 50.58 76 86 106.73-46.25 9-91.24 29.2-127.8 49.52zM368 464h-16v-48a32 32 0 0 0-32-32H64a32 32 0 0 0-32 32v48H16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h352a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm-64 0H80v-32h224z"
  ]
};
export const faGreaterThan = {
  prefix: "far",
  iconName: "greater-than",
  icon: [
    320,
    512,
    [],
    "f531",
    "M311.16 218.53L37.47 81.69c-7.9-3.95-17.52-.75-21.47 7.16L1.69 117.48c-3.95 7.9-.75 17.51 7.16 21.46L242.96 256 8.85 373.06c-7.9 3.95-11.11 13.56-7.16 21.46L16 423.15c3.95 7.9 13.56 11.11 21.47 7.16l273.68-136.84c5.42-2.71 8.84-8.25 8.84-14.31v-46.31c.01-6.07-3.41-11.61-8.83-14.32z"
  ]
};
export const faGreaterThanEqual = {
  prefix: "far",
  iconName: "greater-than-equal",
  icon: [
    384,
    512,
    [],
    "f532",
    "M368 416H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h352c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM33.15 310.37l11.88 31.1c3.28 8.59 12.59 12.77 20.8 9.33l276.12-115.56c6.08-2.54 10.06-8.7 10.06-15.54v-55.4c0-6.84-3.98-13-10.06-15.54L65.82 33.2c-8.21-3.43-17.52.74-20.8 9.33l-11.88 31.1c-3.28 8.58.71 18.32 8.92 21.76L272.91 192 42.06 288.61c-8.2 3.44-12.19 13.18-8.91 21.76z"
  ]
};
export const faGrimace = {
  prefix: "far",
  iconName: "grimace",
  icon: [
    496,
    512,
    [],
    "f57f",
    "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-80-216c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm16 16H152c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48h192c26.5 0 48-21.5 48-48v-32c0-26.5-21.5-48-48-48zm-168 96h-24c-8.8 0-16-7.2-16-16v-8h40v24zm0-40h-40v-8c0-8.8 7.2-16 16-16h24v24zm64 40h-48v-24h48v24zm0-40h-48v-24h48v24zm64 40h-48v-24h48v24zm0-40h-48v-24h48v24zm56 24c0 8.8-7.2 16-16 16h-24v-24h40v8zm0-24h-40v-24h24c8.8 0 16 7.2 16 16v8z"
  ]
};
export const faGrin = {
  prefix: "far",
  iconName: "grin",
  icon: [
    496,
    512,
    [],
    "f580",
    "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm105.6-151.4c-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.9-3.1-19.4 5.4-17.7 15.3 7.9 47.1 71.3 80 123.3 80s115.3-32.9 123.3-80c1.6-9.8-7.7-18.4-17.7-15.3zM168 240c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32z"
  ]
};
export const faGrinAlt = {
  prefix: "far",
  iconName: "grin-alt",
  icon: [
    496,
    512,
    [],
    "f581",
    "M200.3 248c12.4-18.7 15.1-37.3 15.7-56-.5-18.7-3.3-37.3-15.7-56-8-12-25.1-11.4-32.7 0-12.4 18.7-15.1 37.3-15.7 56 .5 18.7 3.3 37.3 15.7 56 8.1 12 25.2 11.4 32.7 0zm128 0c12.4-18.7 15.1-37.3 15.7-56-.5-18.7-3.3-37.3-15.7-56-8-12-25.1-11.4-32.7 0-12.4 18.7-15.1 37.3-15.7 56 .5 18.7 3.3 37.3 15.7 56 8.1 12 25.2 11.4 32.7 0zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm105.6-151.4c-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.9-3.1-19.4 5.3-17.7 15.3 7.9 47.2 71.3 80 123.3 80s115.3-32.9 123.3-80c1.6-9.8-7.7-18.4-17.7-15.3z"
  ]
};
export const faGrinBeam = {
  prefix: "far",
  iconName: "grin-beam",
  icon: [
    496,
    512,
    [],
    "f582",
    "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm105.6-151.4c-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.8-3.1-19.4 5.3-17.7 15.3 7.9 47.1 71.3 80 123.3 80s115.3-32.9 123.3-80c1.6-9.8-7.7-18.4-17.7-15.3zm-235.9-72.9c3.5 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3zm160 0c3.5 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3z"
  ]
};
export const faGrinBeamSweat = {
  prefix: "far",
  iconName: "grin-beam-sweat",
  icon: [
    496,
    512,
    [],
    "f583",
    "M440 160c29.5 0 53.3-26.3 53.3-58.7 0-25-31.7-75.5-46.2-97.3-3.6-5.3-10.7-5.3-14.2 0-14.5 21.8-46.2 72.3-46.2 97.3 0 32.4 23.8 58.7 53.3 58.7zM248 400c51.9 0 115.3-32.9 123.3-80 1.7-9.9-7.7-18.5-17.7-15.3-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.8-3.1-19.4 5.3-17.7 15.3 8 47.1 71.4 80 123.3 80zm130.3-168.3c3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3 3.5 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.6 6.2 4.6 9.3 3.7zm105.3-52.9c-24.6 15.7-46 12.9-46.4 12.9 6.9 20.2 10.8 41.8 10.8 64.3 0 110.3-89.7 200-200 200S48 366.3 48 256 137.7 56 248 56c39.8 0 76.8 11.8 108 31.9 1.7-9.5 6.3-24.1 17.2-45.7C336.4 20.6 293.7 8 248 8 111 8 0 119 0 256s111 248 248 248 248-111 248-248c0-27-4.4-52.9-12.4-77.2zM168 189.4c12.3 0 23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3 3.5 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.8 19.2-21.6 31.5-21.6z"
  ]
};
export const faGrinHearts = {
  prefix: "far",
  iconName: "grin-hearts",
  icon: [
    496,
    512,
    [],
    "f584",
    "M353.6 304.6c-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.8-3.1-19.4 5.3-17.7 15.3 7.9 47.2 71.3 80 123.3 80s115.3-32.9 123.3-80c1.6-9.8-7.7-18.4-17.7-15.3zm-152.8-48.9c4.5 1.2 9.2-1.5 10.5-6l19.4-69.9c5.6-20.3-7.4-41.1-28.8-44.5-18.6-3-36.4 9.8-41.5 27.9l-2 7.1-7.1-1.9c-18.2-4.7-38.2 4.3-44.9 22-7.7 20.2 3.8 41.9 24.2 47.2l70.2 18.1zm188.8-65.3c-6.7-17.6-26.7-26.7-44.9-22l-7.1 1.9-2-7.1c-5-18.1-22.8-30.9-41.5-27.9-21.4 3.4-34.4 24.2-28.8 44.5l19.4 69.9c1.2 4.5 5.9 7.2 10.5 6l70.2-18.2c20.4-5.3 31.9-26.9 24.2-47.1zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200z"
  ]
};
export const faGrinSquint = {
  prefix: "far",
  iconName: "grin-squint",
  icon: [
    496,
    512,
    [],
    "f585",
    "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm105.6-151.4c-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.9-3.1-19.4 5.4-17.7 15.3 7.9 47.1 71.3 80 123.3 80s115.3-32.9 123.3-80c1.6-9.8-7.7-18.4-17.7-15.3zm-234.7-40.8c3.6 4.2 9.9 5.7 15.3 2.5l80-48c3.6-2.2 5.8-6.1 5.8-10.3s-2.2-8.1-5.8-10.3l-80-48c-5.1-3-11.4-1.9-15.3 2.5-3.8 4.5-3.8 11-.1 15.5l33.6 40.3-33.6 40.3c-3.8 4.5-3.7 11.1.1 15.5zm242.9 2.5c5.4 3.2 11.7 1.7 15.3-2.5 3.8-4.5 3.8-11 .1-15.5L343.6 208l33.6-40.3c3.8-4.5 3.7-11-.1-15.5-3.8-4.4-10.2-5.4-15.3-2.5l-80 48c-3.6 2.2-5.8 6.1-5.8 10.3s2.2 8.1 5.8 10.3l80 48z"
  ]
};
export const faGrinSquintTears = {
  prefix: "far",
  iconName: "grin-squint-tears",
  icon: [
    512,
    512,
    [],
    "f586",
    "M117.1 384.1c-25.8 3.7-84 13.7-100.9 30.6-21.9 21.9-21.5 57.9.9 80.3s58.3 22.8 80.3.9C114.3 479 124.3 420.8 128 395c.8-6.4-4.6-11.8-10.9-10.9zm-41.2-41.7C40.3 268 53 176.1 114.6 114.6 152.4 76.8 202.6 56 256 56c36.2 0 70.8 9.8 101.2 27.7 3.8-20.3 8-36.1 12-48.3C333.8 17.2 294.9 8 256 8 192.5 8 129.1 32.2 80.6 80.6c-74.1 74.1-91.3 183.4-52 274 12.2-4.1 27.7-8.3 47.3-12.2zm352.3-187.6c45 76.6 34.9 176.9-30.8 242.6-37.8 37.8-88 58.6-141.4 58.6-30.5 0-59.8-7-86.4-19.8-3.9 19.5-8 35-12.2 47.2 31.4 13.6 65 20.6 98.7 20.6 63.5 0 126.9-24.2 175.4-72.6 78.1-78.1 93.1-195.4 45.2-288.6-12.3 4-28.2 8.1-48.5 12zm-33.3-26.9c25.8-3.7 84-13.7 100.9-30.6 21.9-21.9 21.5-57.9-.9-80.3s-58.3-22.8-80.3-.9C397.7 33 387.7 91.2 384 117c-.8 6.4 4.6 11.8 10.9 10.9zm-187 108.3c-3-3-7.2-4.2-11.4-3.2L106 255.7c-5.7 1.4-9.5 6.7-9.1 12.6.5 5.8 5.1 10.5 10.9 11l52.3 4.8 4.8 52.3c.5 5.8 5.2 10.4 11 10.9h.9c5.5 0 10.3-3.7 11.7-9.1l22.6-90.5c1-4.2-.2-8.5-3.2-11.5zm39.7-25.1l90.5-22.6c5.7-1.4 9.5-6.7 9.1-12.6-.5-5.8-5.1-10.5-10.9-11l-52.3-4.8-4.8-52.3c-.5-5.8-5.2-10.4-11-10.9-5.6-.1-11.2 3.4-12.6 9.1L233 196.5c-1 4.1.2 8.4 3.2 11.4 5 5 11.3 3.2 11.4 3.2zm52 88.5c-29.1 29.1-59.7 52.9-83.9 65.4-9.2 4.8-10 17.5-1.7 23.4 38.9 27.7 107 6.2 143.7-30.6S416 253 388.3 214.1c-5.8-8.2-18.5-7.6-23.4 1.7-12.3 24.2-36.2 54.7-65.3 83.8z"
  ]
};
export const faGrinStars = {
  prefix: "far",
  iconName: "grin-stars",
  icon: [
    496,
    512,
    [],
    "f587",
    "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm105.6-151.4c-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.8-3.1-19.4 5.3-17.7 15.3 7.9 47.2 71.3 80 123.3 80s115.3-32.9 123.3-80c1.6-9.8-7.7-18.4-17.7-15.3zm-227.9-57.5c-1 6.2 5.4 11 11 7.9l31.3-16.3 31.3 16.3c5.6 3.1 12-1.7 11-7.9l-6-34.9 25.4-24.6c4.5-4.5 1.9-12.2-4.3-13.2l-34.9-5-15.5-31.6c-2.9-5.8-11-5.8-13.9 0l-15.5 31.6-34.9 5c-6.2.9-8.9 8.6-4.3 13.2l25.4 24.6-6.1 34.9zm259.7-72.7l-34.9-5-15.5-31.6c-2.9-5.8-11-5.8-13.9 0l-15.5 31.6-34.9 5c-6.2.9-8.9 8.6-4.3 13.2l25.4 24.6-6 34.9c-1 6.2 5.4 11 11 7.9l31.3-16.3 31.3 16.3c5.6 3.1 12-1.7 11-7.9l-6-34.9 25.4-24.6c4.5-4.6 1.8-12.2-4.4-13.2z"
  ]
};
export const faGrinTears = {
  prefix: "far",
  iconName: "grin-tears",
  icon: [
    640,
    512,
    [],
    "f588",
    "M117.1 256.1c-25.8 3.7-84 13.7-100.9 30.6-21.9 21.9-21.5 57.9.9 80.3s58.3 22.8 80.3.9C114.3 351 124.3 292.8 128 267c.8-6.4-4.6-11.8-10.9-10.9zm506.7 30.6c-16.9-16.9-75.1-26.9-100.9-30.6-6.3-.9-11.7 4.5-10.8 10.8 3.7 25.8 13.7 84 30.6 100.9 21.9 21.9 57.9 21.5 80.3-.9 22.3-22.3 22.7-58.3.8-80.2zm-126.6 61.7C463.8 412.3 396.9 456 320 456c-76.9 0-143.8-43.7-177.2-107.6-12.5 37.4-25.2 43.9-28.3 46.5C159.1 460.7 234.5 504 320 504s160.9-43.3 205.5-109.1c-3.2-2.7-15.9-9.2-28.3-46.5zM122.7 224.5C137.9 129.2 220.5 56 320 56c99.5 0 182.1 73.2 197.3 168.5 2.1-.2 5.2-2.4 49.5 7C554.4 106 448.7 8 320 8S85.6 106 73.2 231.4c44.5-9.4 47.1-7.2 49.5-6.9zM320 400c51.9 0 115.3-32.9 123.3-80 1.7-9.9-7.7-18.5-17.7-15.3-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.8-3.1-19.4 5.3-17.7 15.3 8 47.1 71.4 80 123.3 80zm130.3-168.3c3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3 3.5 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.6 6.2 4.6 9.3 3.7zM240 189.4c12.3 0 23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3 3.5 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.8 19.2-21.6 31.5-21.6z"
  ]
};
export const faGrinTongue = {
  prefix: "far",
  iconName: "grin-tongue",
  icon: [
    496,
    512,
    [],
    "f589",
    "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm64 400c0 35.6-29.1 64.5-64.9 64-35.1-.5-63.1-29.8-63.1-65v-42.8l17.7-8.8c15-7.5 31.5 1.7 34.9 16.5l2.8 12.1c2.1 9.2 15.2 9.2 17.3 0l2.8-12.1c3.4-14.8 19.8-24.1 34.9-16.5l17.7 8.8V408zm28.2 25.3c2.2-8.1 3.8-16.5 3.8-25.3v-43.5c14.2-12.4 24.4-27.5 27.3-44.5 1.7-9.9-7.7-18.5-17.7-15.3-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.9-3.1-19.4 5.3-17.7 15.3 2.9 17 13.1 32.1 27.3 44.5V408c0 8.8 1.6 17.2 3.8 25.3C91.8 399.9 48 333 48 256c0-110.3 89.7-200 200-200s200 89.7 200 200c0 77-43.8 143.9-107.8 177.3zM168 176c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm160 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"
  ]
};
export const faGrinTongueSquint = {
  prefix: "far",
  iconName: "grin-tongue-squint",
  icon: [
    496,
    512,
    [],
    "f58a",
    "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm64 400c0 35.6-29.1 64.5-64.9 64-35.1-.5-63.1-29.8-63.1-65v-42.8l17.7-8.8c15-7.5 31.5 1.7 34.9 16.5l2.8 12.1c2.1 9.2 15.2 9.2 17.3 0l2.8-12.1c3.4-14.8 19.8-24.1 34.9-16.5l17.7 8.8V408zm28.2 25.3c2.2-8.1 3.8-16.5 3.8-25.3v-43.5c14.2-12.4 24.4-27.5 27.3-44.5 1.7-9.9-7.7-18.5-17.7-15.3-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.9-3.1-19.4 5.3-17.7 15.3 2.9 17 13.1 32.1 27.3 44.5V408c0 8.8 1.6 17.2 3.8 25.3C91.8 399.9 48 333 48 256c0-110.3 89.7-200 200-200s200 89.7 200 200c0 77-43.8 143.9-107.8 177.3zm36.9-281.1c-3.8-4.4-10.3-5.5-15.3-2.5l-80 48c-3.6 2.2-5.8 6.1-5.8 10.3s2.2 8.1 5.8 10.3l80 48c5.4 3.2 11.7 1.7 15.3-2.5 3.8-4.5 3.8-11 .1-15.5L343.6 208l33.6-40.3c3.8-4.5 3.7-11.1-.1-15.5zm-162.9 45.5l-80-48c-5-3-11.4-2-15.3 2.5-3.8 4.5-3.8 11-.1 15.5l33.6 40.3-33.6 40.3c-3.8 4.5-3.7 11 .1 15.5 3.6 4.2 9.9 5.7 15.3 2.5l80-48c3.6-2.2 5.8-6.1 5.8-10.3s-2.2-8.1-5.8-10.3z"
  ]
};
export const faGrinTongueWink = {
  prefix: "far",
  iconName: "grin-tongue-wink",
  icon: [
    496,
    512,
    [],
    "f58b",
    "M152 180c-25.7 0-55.9 16.9-59.8 42.1-.8 5 1.7 10 6.1 12.4 4.4 2.4 9.9 1.8 13.7-1.6l9.5-8.5c14.8-13.2 46.2-13.2 61 0l9.5 8.5c2.5 2.2 8 4.7 13.7 1.6 4.4-2.4 6.9-7.4 6.1-12.4-3.9-25.2-34.1-42.1-59.8-42.1zm176-52c-44.2 0-80 35.8-80 80s35.8 80 80 80 80-35.8 80-80-35.8-80-80-80zm0 128c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm0-72c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm64 400c0 35.6-29.1 64.5-64.9 64-35.1-.5-63.1-29.8-63.1-65v-42.8l17.7-8.8c15-7.5 31.5 1.7 34.9 16.5l2.8 12.1c2.1 9.2 15.2 9.2 17.3 0l2.8-12.1c3.4-14.8 19.8-24.1 34.9-16.5l17.7 8.8V408zm28.2 25.3c2.2-8.1 3.8-16.5 3.8-25.3v-43.5c14.2-12.4 24.4-27.5 27.3-44.5 1.7-9.9-7.7-18.5-17.7-15.3-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.9-3.1-19.4 5.3-17.7 15.3 2.9 17 13.1 32.1 27.3 44.5V408c0 8.8 1.6 17.2 3.8 25.3C91.8 399.9 48 333 48 256c0-110.3 89.7-200 200-200s200 89.7 200 200c0 77-43.8 143.9-107.8 177.3z"
  ]
};
export const faGrinWink = {
  prefix: "far",
  iconName: "grin-wink",
  icon: [
    496,
    512,
    [],
    "f58c",
    "M328 180c-25.69 0-55.88 16.92-59.86 42.12-1.75 11.22 11.5 18.24 19.83 10.84l9.55-8.48c14.81-13.19 46.16-13.19 60.97 0l9.55 8.48c8.48 7.43 21.56.25 19.83-10.84C383.88 196.92 353.69 180 328 180zm-160 60c17.67 0 32-14.33 32-32s-14.33-32-32-32-32 14.33-32 32 14.33 32 32 32zm185.55 64.64c-25.93 8.3-64.4 13.06-105.55 13.06s-79.62-4.75-105.55-13.06c-9.94-3.13-19.4 5.37-17.71 15.34C132.67 367.13 196.06 400 248 400s115.33-32.87 123.26-80.02c1.68-9.89-7.67-18.48-17.71-15.34zM248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 448c-110.28 0-200-89.72-200-200S137.72 56 248 56s200 89.72 200 200-89.72 200-200 200z"
  ]
};
export const faGripHorizontal = {
  prefix: "far",
  iconName: "grip-horizontal",
  icon: [
    512,
    512,
    [],
    "f58d",
    "M488 96h-96c-13.25 0-24 10.74-24 24v96c0 13.25 10.75 24 24 24h96c13.25 0 24-10.75 24-24v-96c0-13.26-10.75-24-24-24zm-24 96h-48v-48h48v48zm24 80h-96c-13.25 0-24 10.74-24 24v96c0 13.25 10.75 24 24 24h96c13.25 0 24-10.75 24-24v-96c0-13.26-10.75-24-24-24zm-24 96h-48v-48h48v48zM120 96H24c-13.25 0-24 10.74-24 24v96c0 13.25 10.75 24 24 24h96c13.25 0 24-10.75 24-24v-96c0-13.26-10.75-24-24-24zm-24 96H48v-48h48v48zm24 80H24c-13.25 0-24 10.74-24 24v96c0 13.25 10.75 24 24 24h96c13.25 0 24-10.75 24-24v-96c0-13.26-10.75-24-24-24zm-24 96H48v-48h48v48zM304 96h-96c-13.25 0-24 10.74-24 24v96c0 13.25 10.75 24 24 24h96c13.25 0 24-10.75 24-24v-96c0-13.26-10.75-24-24-24zm-24 96h-48v-48h48v48zm24 80h-96c-13.25 0-24 10.74-24 24v96c0 13.25 10.75 24 24 24h96c13.25 0 24-10.75 24-24v-96c0-13.26-10.75-24-24-24zm-24 96h-48v-48h48v48z"
  ]
};
export const faGripLines = {
  prefix: "far",
  iconName: "grip-lines",
  icon: [
    448,
    512,
    [],
    "f7a4",
    "M432 288H16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h416c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zm0-112H16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h416c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16z"
  ]
};
export const faGripLinesVertical = {
  prefix: "far",
  iconName: "grip-lines-vertical",
  icon: [
    256,
    512,
    [],
    "f7a5",
    "M96 464V48c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16v416c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16zm112 0V48c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16v416c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16z"
  ]
};
export const faGripVertical = {
  prefix: "far",
  iconName: "grip-vertical",
  icon: [
    320,
    512,
    [],
    "f58e",
    "M120 0H24C10.75 0 0 10.74 0 24v96c0 13.25 10.75 24 24 24h96c13.26 0 24-10.75 24-24V24c0-13.26-10.74-24-24-24zM96 96H48V48h48v48zM296 0h-96c-13.25 0-24 10.74-24 24v96c0 13.25 10.75 24 24 24h96c13.26 0 24-10.75 24-24V24c0-13.26-10.74-24-24-24zm-24 96h-48V48h48v48zM120 368H24c-13.25 0-24 10.74-24 24v96c0 13.25 10.75 24 24 24h96c13.26 0 24-10.75 24-24v-96c0-13.26-10.74-24-24-24zm-24 96H48v-48h48v48zm200-96h-96c-13.25 0-24 10.74-24 24v96c0 13.25 10.75 24 24 24h96c13.26 0 24-10.75 24-24v-96c0-13.26-10.74-24-24-24zm-24 96h-48v-48h48v48zM120 184H24c-13.25 0-24 10.74-24 24v96c0 13.25 10.75 24 24 24h96c13.26 0 24-10.75 24-24v-96c0-13.26-10.74-24-24-24zm-24 96H48v-48h48v48zm200-96h-96c-13.25 0-24 10.74-24 24v96c0 13.25 10.75 24 24 24h96c13.26 0 24-10.75 24-24v-96c0-13.26-10.74-24-24-24zm-24 96h-48v-48h48v48z"
  ]
};
export const faGuitar = {
  prefix: "far",
  iconName: "guitar",
  icon: [
    512,
    512,
    [],
    "f7a6",
    "M502.63 39L473.05 9.37a32 32 0 0 0-45.26 0L381.48 55.7A35.14 35.14 0 0 0 373 69.49l-17.81 53.45-36 36c-15.44-12.85-33.06-23-52.59-27.54a125.39 125.39 0 0 0-28.48-3.4c-26.37 0-51.12 9-69.57 27.4a90 90 0 0 0-22.07 36.51c-6.57 20.24-25.31 35.66-46 37.6C74.65 232 50.62 242 32.21 260.53-17.57 310.18-8.61 399.58 51.9 460.12 86.08 494.3 129.45 512 169.67 512c31 0 60.19-10.53 81.81-32.17 18.52-18.41 28.54-42.43 31-68.4 1.92-20.57 17.34-39.42 37.57-46a90.34 90.34 0 0 0 36.52-22.08c24.94-25 32.43-61.48 24-97.92-4.52-19.54-14.63-37.17-27.47-52.62l35.94-36L442.48 139a35.26 35.26 0 0 0 13.79-8.53l46.32-46.32a32 32 0 0 0 .04-45.15zM305.26 319.79c-38.49 12.49-66.84 47.53-70.52 87.06-4.83 50.32-48.2 57.14-65.07 57.14-29.24 0-59.8-13.78-83.82-37.81S48 371.51 48 342.25c0-16.78 7-60.17 57-64.94 39.64-3.72 74.67-32.08 87.18-70.68 10.82-33.74 56.12-41.8 92.82-13.54l-64.72 64.72a48.8 48.8 0 1 0 33.92 34L319 227c26.49 34.56 22.06 81.22-13.74 92.79z"
  ]
};
export const faGuitarElectric = {
  prefix: "far",
  iconName: "guitar-electric",
  icon: [
    512,
    512,
    [],
    "f8be",
    "M511.21 39.58a48.13 48.13 0 0 0-37.8-38.27C450.48-3 450.66.79 366.74 54.94a32.15 32.15 0 0 0-14.74 27v44.59l-83.23 83.17a12.45 12.45 0 0 1-1.77-12.77l15.9-34.18a41.31 41.31 0 0 0-66.67-46.65L181 151.34a95.94 95.94 0 0 0-22.42 35.47 47.67 47.67 0 0 1-24.74 27.11l-70.29 32.57c-31 12.38-54.45 40.37-61.43 74.36a102.65 102.65 0 0 0 28 93.48l67.51 67.5A102.9 102.9 0 0 0 266 447.28l32.05-69.15a47.69 47.69 0 0 1 27.12-24.74A96 96 0 0 0 360.65 331l19.84-19.83a42.28 42.28 0 0 0 0-59.82c-17.58-17.58-38.86-11.62-42.76-10.38l-21.8 6.95c-7 2.23-11.51-1.82-13.58-3.89l149.37-149.4A47.44 47.44 0 0 0 464 96.42a48 48 0 0 0 47.21-56.84zM312.08 288.49a52.57 52.57 0 0 0 16-2.49l24.14-6.39-19.84 23.08a55.75 55.75 0 0 1-20.59 13 87.92 87.92 0 0 0-50 45.62l-32.9 71.1A62.9 62.9 0 0 1 126 453.54L58.45 386a61.92 61.92 0 0 1-17.15-57.1c4.33-21.1 18.28-37.78 39.05-46.12l70.32-32.56a87.89 87.89 0 0 0 45.62-50 55.77 55.77 0 0 1 13-20.59L245.48 144l-14.71 36.05a52.86 52.86 0 0 0 10.51 59.46l33.56 33.56a52.36 52.36 0 0 0 37.24 15.42zm-177.46 36.2a16 16 0 0 0-22.63 0L100.68 336a16 16 0 0 0 0 22.63l52.69 52.68a16 16 0 0 0 22.63 0L187.31 400a16 16 0 0 0 0-22.63zm64-64a16 16 0 0 0-22.63 0L164.68 272a16 16 0 0 0 0 22.63l52.69 52.68a16 16 0 0 0 22.63 0L251.31 336a16 16 0 0 0 0-22.63z"
  ]
};
export const faGuitars = {
  prefix: "far",
  iconName: "guitars",
  icon: [
    512,
    512,
    [],
    "f8bf",
    "M188.1 444.13C172.69 456.75 150.78 464 128 464s-44.7-7.25-60.1-19.87C60.46 438 48 425.1 48 406.83c0-9.38 3.6-18.55 10.72-27.18 23.07-27.85 27.37-68.53 10.64-101.31-12.86-25.09 17-42.53 17.43-42.8 4.29-2.68 10.34-4.66 17.21-6V312a24 24 0 0 0 48 0v-82.5c6.89 1.38 12.94 3.38 17.21 6 16 10 26 26.11 17.39 42.88-16.69 32.7-12.39 73.38 10.62 101.16 2 2.36 3 4.84 4.4 7.28l23.15-63a45.72 45.72 0 0 1 4.58-23.59c.11-.22.15-.45.26-.67a39.93 39.93 0 0 0-3.52-14.19A104.73 104.73 0 0 1 216 240.71V212.9c-1-1.12-1.82-2.37-2.89-3.44a104 104 0 0 0-18.58-14.67c-12.84-8-27.55-12-42.58-13.83v-54.22l16.62-33.23a29.12 29.12 0 0 0 3.07-13v-54.1A26.4 26.4 0 0 0 145.28 0h-34.56A26.41 26.41 0 0 0 84.3 26.41v54.08a29.12 29.12 0 0 0 3.07 13L104 126.74V181c-15 1.84-29.74 5.84-42.58 13.83a103.66 103.66 0 0 0-18.58 14.67c-15.39 15.39-24.62 35-24.62 56.58a74.37 74.37 0 0 0 8.42 34.2c8 15.65 6 35.59-4.88 48.78C8.11 365.55-.07 385.43 0 407c-.07 58 57.34 105 128 105a144.89 144.89 0 0 0 79.87-23.54 111 111 0 0 1-15.26-48.54c-1.61 1.54-3.17 3.08-4.51 4.21zM400 384h-64a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm105.48 16.82l-26.93-73.45a72.1 72.1 0 0 1 2.58-55.79 72.13 72.13 0 0 0 7-30.94v-28.32a18.45 18.45 0 0 0-18.45-18.47 18.49 18.49 0 0 0-16.42 10l-10.64 20.55c-5.36 10.37-15.35 17-26.62 19l-24-.1V73.38a34.2 34.2 0 0 0 5.09-3.8A40.75 40.75 0 0 0 368.25 0a40.2 40.2 0 0 0-22.6 6.83c-16.39 11.15-14 13.35-31.84 96.24a27.27 27.27 0 0 0 7.32 25L344 151v91.66l-24-.11c-11.31-3.11-20.83-11-25-22.37l-13-35.76a17.46 17.46 0 0 0-16.41-11.49 17.51 17.51 0 0 0-17.5 17.5v50.33a72.22 72.22 0 0 0 7 30.93 72.07 72.07 0 0 1 2.53 55.78l-27 73.48C208 453.51 246.53 512 303.73 512h128.41c57.26-.06 95.86-58.59 73.34-111.18zM432.15 464H303.73c-28.89 0-35.44-29.3-29.07-44.16.35-.83-3.08 8.57 27.93-75.84a126.27 126.27 0 0 0 6.58-56s116.79.18 117.67 0c-1.86 18.06.33 38.67 6.64 55.89 30.95 84.4 27.53 75 27.88 75.83C472.74 446.3 448.33 464 432.15 464z"
  ]
};
export const faHSquare = {
  prefix: "far",
  iconName: "h-square",
  icon: [
    448,
    512,
    [],
    "f0fd",
    "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zm-6 400H54a6 6 0 0 1-6-6V86a6 6 0 0 1 6-6h340a6 6 0 0 1 6 6v340a6 6 0 0 1-6 6zm-50-292v232c0 6.627-5.373 12-12 12h-24c-6.627 0-12-5.373-12-12v-92H152v92c0 6.627-5.373 12-12 12h-24c-6.627 0-12-5.373-12-12V140c0-6.627 5.373-12 12-12h24c6.627 0 12 5.373 12 12v92h144v-92c0-6.627 5.373-12 12-12h24c6.627 0 12 5.373 12 12z"
  ]
};
export const faH1 = {
  prefix: "far",
  iconName: "h1",
  icon: [
    576,
    512,
    [],
    "f313",
    "M304 96h-98.94A13.06 13.06 0 0 0 192 109.06v21.88A13.06 13.06 0 0 0 205.06 144H232v88H88v-88h26.94A13.06 13.06 0 0 0 128 130.94V112a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v18.94A13.06 13.06 0 0 0 13.06 144H40v224H13.06A13.06 13.06 0 0 0 0 381.06V400a16 16 0 0 0 16 16h98.94A13.06 13.06 0 0 0 128 402.94v-21.88A13.06 13.06 0 0 0 114.94 368H88v-88h144v88h-26.94A13.06 13.06 0 0 0 192 381.06V400a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-18.94A13.06 13.06 0 0 0 306.94 368H280V144h26.94A13.06 13.06 0 0 0 320 130.94V112a16 16 0 0 0-16-16zm256 272h-56V120a24 24 0 0 0-24-24h-24a24 24 0 0 0-21.44 13.26l-24 48A24 24 0 0 0 432 192h24v176h-56a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h160a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16z"
  ]
};
export const faH2 = {
  prefix: "far",
  iconName: "h2",
  icon: [
    576,
    512,
    [],
    "f314",
    "M304 96h-98.94A13.06 13.06 0 0 0 192 109.06v21.88A13.06 13.06 0 0 0 205.06 144H232v88H88v-88h26.94A13.06 13.06 0 0 0 128 130.94V112a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v18.94A13.06 13.06 0 0 0 13.06 144H40v224H13.06A13.06 13.06 0 0 0 0 381.06V400a16 16 0 0 0 16 16h98.94A13.06 13.06 0 0 0 128 402.94v-21.88A13.06 13.06 0 0 0 114.94 368H88v-88h144v88h-26.94A13.06 13.06 0 0 0 192 381.06V400a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-18.94A13.06 13.06 0 0 0 306.94 368H280V144h26.94A13.06 13.06 0 0 0 320 130.94V112a16 16 0 0 0-16-16zm244.14 272.13H410.82c8.52-60.35 146-79.28 146-179.31C556.8 134.17 515 96 455.05 96a114.71 114.71 0 0 0-97.92 55.05 11.81 11.81 0 0 0 3.58 15.95L382 181.23a11.89 11.89 0 0 0 16.27-3c13-18.23 31.58-31.35 53.72-31.35 29.57 0 49.43 18.08 49.43 45 0 67-149.45 84-149.45 195.49a137.14 137.14 0 0 0 1.39 18.42 12.18 12.18 0 0 0 11.8 10.21h183A11.85 11.85 0 0 0 560 404.18V380a11.85 11.85 0 0 0-11.86-11.87z"
  ]
};
export const faH3 = {
  prefix: "far",
  iconName: "h3",
  icon: [
    576,
    512,
    [],
    "f315",
    "M480.07 219.78l75.39-85.88a11.82 11.82 0 0 0 2.93-7.76v-18.32A11.89 11.89 0 0 0 546.44 96H379.87a11.88 11.88 0 0 0-11.94 11.82V132a11.88 11.88 0 0 0 11.94 11.83s102.44-.11 106-.25c-2.77 2.88-74.12 85.58-74.12 85.58a11.67 11.67 0 0 0-1.86 12.38l6.71 15.3a12.94 12.94 0 0 0 10.93 7.16h17.08c48.61 0 65.85 27.23 65.85 50.56 0 28.57-24.58 50.13-57.17 50.13-24 0-46.88-10.46-65.29-26.89a12 12 0 0 0-17.76 1.81l-16 22a11.73 11.73 0 0 0 1.4 15.41c24.6 23.34 60.62 39 99.38 39 64.2 0 109.86-46.22 109.86-103.17.01-51.1-36.73-84.17-84.81-93.07zM304 96h-98.94A13.06 13.06 0 0 0 192 109.06v21.88A13.06 13.06 0 0 0 205.06 144H232v88H88v-88h26.94A13.06 13.06 0 0 0 128 130.94V112a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v18.94A13.06 13.06 0 0 0 13.06 144H40v224H13.06A13.06 13.06 0 0 0 0 381.06V400a16 16 0 0 0 16 16h98.94A13.06 13.06 0 0 0 128 402.94v-21.88A13.06 13.06 0 0 0 114.94 368H88v-88h144v88h-26.94A13.06 13.06 0 0 0 192 381.06V400a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-18.94A13.06 13.06 0 0 0 306.94 368H280V144h26.94A13.06 13.06 0 0 0 320 130.94V112a16 16 0 0 0-16-16z"
  ]
};
export const faH4 = {
  prefix: "far",
  iconName: "h4",
  icon: [
    576,
    512,
    [],
    "f86a",
    "M304 96h-98.94A13.06 13.06 0 0 0 192 109.06v21.88A13.06 13.06 0 0 0 205.06 144H232v88H88v-88h26.94A13.06 13.06 0 0 0 128 130.94V112a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v18.94A13.06 13.06 0 0 0 13.06 144H40v224H13.06A13.06 13.06 0 0 0 0 381.06V400a16 16 0 0 0 16 16h98.94A13.06 13.06 0 0 0 128 402.94v-21.88A13.06 13.06 0 0 0 114.94 368H88v-88h144v88h-26.94A13.06 13.06 0 0 0 192 381.06V400a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-18.94A13.06 13.06 0 0 0 306.94 368H280V144h26.94A13.06 13.06 0 0 0 320 130.94V112a16 16 0 0 0-16-16zm256 136h-16V112a16 16 0 0 0-16-16h-16a16 16 0 0 0-16 16v120h-96V112a16 16 0 0 0-16-16h-16a16 16 0 0 0-16 16v136a32 32 0 0 0 32 32h112v120a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16V280h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16z"
  ]
};
export const faHamburger = {
  prefix: "far",
  iconName: "hamburger",
  icon: [
    512,
    512,
    [],
    "f805",
    "M352 176a16 16 0 1 0-16-16 16 16 0 0 0 16 16zm-96-32a16 16 0 1 0-16-16 16 16 0 0 0 16 16zm-96 32a16 16 0 1 0-16-16 16 16 0 0 0 16 16zm352 112a79.45 79.45 0 0 0-28.07-60.4c.36-.54.85-.92 1.2-1.48a72.63 72.63 0 0 0 .63-75.43C442.33 78.69 352.18 32.09 256 32c-96.11.09-186.26 46.67-229.7 118.67a72.65 72.65 0 0 0 .6 75.44c.35.55.85.94 1.21 1.49a79.32 79.32 0 0 0 5.65 125.46c-.66 2.83-1.73 5.51-1.73 8.53v34.68A83.82 83.82 0 0 0 115.72 480h280.56A83.82 83.82 0 0 0 480 396.27v-34.68c0-3-1.07-5.7-1.73-8.53A79.75 79.75 0 0 0 512 288zM67.37 175.46C102.3 117.56 176.32 80.09 256 80c79.69.09 153.75 37.57 188.69 95.47a24.59 24.59 0 0 1-.21 25.17c-2.93 4.68-7.38 7.36-12.2 7.36H79.75c-4.82 0-9.26-2.69-12.2-7.37a24.56 24.56 0 0 1-.18-25.17zM432 396.27A35.77 35.77 0 0 1 396.28 432H115.72A35.77 35.77 0 0 1 80 396.27v-25.6h352zm0-76.27H80a32 32 0 0 1 0-64h352a32 32 0 0 1 0 64z"
  ]
};
export const faHammer = {
  prefix: "far",
  iconName: "hammer",
  icon: [
    576,
    512,
    [],
    "f6e3",
    "M571.31 193.94l-22.63-22.63c-6.25-6.24-16.38-6.25-22.63 0l-11.31 11.31-28.91-28.9c5.63-21.31.36-44.9-16.35-61.61l-45.25-45.25C392.99 15.62 352.05 0 311.1 0c-40.95 0-81.9 15.62-113.14 46.86l67.88 67.88v18.75c0 8.05 1.62 15.91 4.5 23.27L22.77 387.89C-6.88 415.57-7.68 462.32 21 491c14.03 14.03 32.37 21 50.69 21 19.15 0 38.27-7.62 52.42-22.77l230.92-247.34c7.56 3 15.58 4.52 23.61 4.52 5.61 0 11.23-.73 16.7-2.17l28.91 28.9-11.31 11.31c-6.25 6.25-6.25 16.38 0 22.63l22.62 22.63c6.25 6.24 16.37 6.25 22.63 0l113.14-113.14c6.23-6.25 6.23-16.38-.02-22.63zM89.02 456.47c-9.86 10.56-25.36 9.31-34.08.59-10.21-10.22-8.44-25.66.59-34.08L300.3 194.46l17.24 17.24L89.02 456.47zm380.47-205.96l-59.74-59.73-26.68 7.05c-9.5 2.52-15.12-3.61-15.4-3.88l-49.14-49.14c-2.98-2.98-4.69-7.1-4.69-11.31V94.86l-40.4-40.4C285.37 50.21 298.06 48 311.1 48c29.92 0 58.04 11.65 79.2 32.8l45.25 45.25c5.84 5.84 4.45 13.26 3.89 15.4l-7.05 26.69 59.74 59.73-22.64 22.64z"
  ]
};
export const faHammerWar = {
  prefix: "far",
  iconName: "hammer-war",
  icon: [
    384,
    512,
    [],
    "f6e4",
    "M352.07 32c-3.83 0 5.08-1.29-136.07 22.23V12c0-6.63-5.37-12-12-12h-24c-6.63 0-12 5.37-12 12v42.23C26.22 30.6 35.77 32 31.93 32 14.64 32 0 46.05 0 64.01v191.98C0 273.95 14.64 288 31.94 288c3.86 0-5.08 1.29 136.06-22.23V500c0 6.63 5.37 12 12 12h24c6.63 0 12-5.37 12-12V265.77C357.77 289.4 348.23 288 352.06 288c17.3 0 31.94-14.05 31.94-32.01V64.01C384 46.05 369.36 32 352.07 32zM336 237.11l-144-24-144 24V82.89l144 24 144-24v154.22z"
  ]
};
export const faHamsa = {
  prefix: "far",
  iconName: "hamsa",
  icon: [
    512,
    512,
    [],
    "f665",
    "M256.01 288c-53.01 0-95.98 64-95.98 64s42.97 64 95.98 64 95.98-64 95.98-64-42.98-64-95.98-64zm0 96c-17.67 0-31.99-14.33-31.99-32s14.33-32 31.99-32S288 334.33 288 352s-14.33 32-31.99 32zm249.54-100.6c-11.79-26.32-38.34-43.4-67.59-43.4h-6V113.71c0-39.77-28.77-74.45-66.91-80.65-4.42-.72-8.79-1.06-13.07-1.06-10.18 0-19.93 1.91-28.89 5.4-11.97-18.9-31.34-32.65-54.01-36.34A81.3 81.3 0 0 0 256 0c-28.39 0-53.38 14.88-67.58 37.24a75.764 75.764 0 0 0-15.33-4.18c-4.42-.72-8.79-1.06-13.07-1.06-44.1 0-79.98 35.89-79.98 80v128h-5.99c-29.25 0-55.8 17.08-67.63 43.5-12.21 27.09-6.7 58.57 14.08 80.12l83.42 86.46C141.91 489.43 197.34 512 256.01 512s114.1-22.57 152.08-61.91l83.42-86.46c20.79-21.55 26.3-53.04 14.04-80.23zm-48.57 46.89l-83.42 86.45C344.58 446.78 301.75 464 256.01 464s-88.57-17.22-117.56-47.25L55.03 330.3c-7.06-7.32-8.96-17.99-4.82-27.17C54.32 293.94 63.69 288 74.05 288h53.98V112c0-17.67 14.32-32 31.99-32 1.76 0 3.56.14 5.37.44 15.73 2.56 26.62 17.33 26.62 33.27V216c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V80c0-17.67 14.32-32 31.99-32 1.76 0 3.56.14 5.37.44 15.73 2.56 26.62 17.33 26.62 33.27V216c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V112c0-17.67 14.32-32 31.99-32 1.76 0 3.56.14 5.37.44 15.73 2.56 26.62 17.33 26.62 33.27V288h53.99c10.36 0 19.72 5.94 23.84 15.12 4.14 9.19 2.24 19.86-4.82 27.17z"
  ]
};
export const faHandHeart = {
  prefix: "far",
  iconName: "hand-heart",
  icon: [
    480,
    512,
    [],
    "f4bc",
    "M408 112c-2.7 0-5.4.2-8 .4V104c0-39.7-32.3-72-72-72-6.4 0-12.7.8-18.6 2.4C296.7 13.8 273.9 0 248 0s-48.7 13.8-61.4 34.4c-5.9-1.6-12.2-2.4-18.6-2.4-39.7 0-72 32.3-72 72v92.1c-10.5-3.7-38.1-10.2-65.3 8.9C-1.8 227.8-9.8 272.8 13 305.3l113.5 171c14.9 22.4 39.8 35.7 66.6 35.7h180.6c38 0 71-27 78.5-64.3l20.6-103.2c4.7-23.7 7.1-48 7.1-72.2V184c.1-39.7-32.2-72-71.9-72zm24 160.3c0 21.1-2.1 42.1-6.2 62.8l-20.6 103.2c-3 15-16.1 25.7-31.4 25.7H193.1c-10.7 0-20.7-5.4-26.7-14.3L52.3 277.8c-18-25.7 20.7-54.1 39.3-27.5l37.8 54.4c4.5 6.5 14.6 3.2 14.6-4.6V104c0-31.8 48-31.7 48 0v144c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V72c0-31.8 48-31.7 48 0v176c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V104c0-31.8 48-31.7 48 0v144c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-64c0-31.8 48-31.7 48 0v88.3zm-95.5 24.5c-19.6-15.3-45.2-8.5-58.3 3.9l-6.2 5.8-6.2-5.8c-12.8-12-38.5-19.3-58.3-3.9-19.6 15.3-20.7 42.8-3.1 59.4l60.5 57.1c3.9 3.7 10.2 3.7 14.1 0l60.5-57.1c17.6-16.6 16.6-44.1-3-59.4z"
  ]
};
export const faHandHolding = {
  prefix: "far",
  iconName: "hand-holding",
  icon: [
    576,
    512,
    [],
    "f4bd",
    "M551.9 312c-31.1-26.4-69.3-16.1-88.4-1.8l-60.4 45.5h-3.3c-.2-38-30.5-67.8-69.2-67.8h-144c-28.4 0-56.3 9.4-78.5 26.3L79.8 336H16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h80l41.3-31.5c14-10.7 31.4-16.5 49.4-16.5h144c27.9 0 29.1 40.2-1.1 40.2h-59.8c-7.6 0-13.8 6.2-13.8 13.8v.1c0 7.6 6.2 13.8 13.8 13.8h134.5c9.7 0 19.2-3.2 26.9-9l61.3-46.1c8.3-6.2 20.5-6.7 28.4 0 10.1 8.5 9.3 23.1-.9 30.7L419.4 455c-7.8 5.8-17.2 9-26.9 9H16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h376.8c19.9 0 39.3-6.5 55.2-18.5l100.8-75.9c16.6-12.5 26.5-31.5 27.1-52 .7-20.5-8.1-40.1-24-53.6z"
  ]
};
export const faHandHoldingBox = {
  prefix: "far",
  iconName: "hand-holding-box",
  icon: [
    576,
    512,
    [],
    "f47b",
    "M551.9 312c-31.1-26.4-69.3-16.1-88.4-1.8l-60.4 45.5h-3.3c-.2-38-30.5-67.8-69.2-67.8h-144c-28.4 0-56.3 9.4-78.5 26.3L79.8 336H16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h80l41.3-31.5c14-10.7 31.4-16.5 49.4-16.5h144c27.9 0 29.1 40.2-1.1 40.2h-59.8c-7.6 0-13.8 6.2-13.8 13.8v.1c0 7.6 6.2 13.8 13.8 13.8h134.5c9.7 0 19.2-3.2 26.9-9l61.3-46.1c8.3-6.2 20.5-6.7 28.4 0 10.1 8.5 9.3 23.1-.9 30.7L419.4 455c-7.8 5.8-17.2 9-26.9 9H16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h376.8c19.9 0 39.3-6.5 55.2-18.5l100.8-75.9c16.6-12.5 26.5-31.5 27.1-52 .7-20.5-8.1-40.1-24-53.6zm-439.4-56h352c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16h-352c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16zm32-208h80v112l64-32 64 32V48h80v160h-288V48z"
  ]
};
export const faHandHoldingHeart = {
  prefix: "far",
  iconName: "hand-holding-heart",
  icon: [
    576,
    512,
    [],
    "f4be",
    "M266.8 247.1c13 13.4 32.5 10.2 42.4 0l98.7-102c30.1-31.1 36.4-90.1-6-126.3C363.5-14 312.8 1 288 26.6 263.2 1 212.5-14 174.2 18.8c-42.4 36.2-36.1 95.2-6 126.3l98.6 102zM204.5 55.6c14.1-12 36.1-9 49.3 4.7L288 95.6l34.1-35.4c13.2-13.7 35.3-16.7 49.3-4.7 18.9 16.1 15.7 42.4 2.7 55.9L288 200.5l-86.1-89.1c-13.1-13.4-16.2-39.7 2.6-55.8zM551.9 312c-31.1-26.4-69.3-16.1-88.4-1.8l-60.4 45.5h-3.3c-.2-38-30.5-67.8-69.2-67.8h-144c-28.4 0-56.3 9.4-78.5 26.3L79.8 336H16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h80l41.3-31.5c14-10.7 31.4-16.5 49.4-16.5h144c27.9 0 29.1 40.2-1.1 40.2h-59.8c-7.6 0-13.8 6.2-13.8 13.8v.1c0 7.6 6.2 13.8 13.8 13.8h134.5c9.7 0 19.2-3.2 26.9-9l61.3-46.1c8.3-6.2 20.5-6.7 28.4 0 10.1 8.5 9.3 23.1-.9 30.7L419.4 455c-7.8 5.8-17.2 9-26.9 9H16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h376.8c19.9 0 39.3-6.5 55.2-18.5l100.8-75.9c16.6-12.5 26.5-31.5 27.1-52 .7-20.5-8.1-40.1-24-53.6z"
  ]
};
export const faHandHoldingMagic = {
  prefix: "far",
  iconName: "hand-holding-magic",
  icon: [
    576,
    512,
    [],
    "f6e5",
    "M551.94 312.03c-31.11-26.43-69.35-16.09-88.37-1.77l-60.43 45.5h-3.27c-.17-38.03-30.51-67.76-69.2-67.76h-144c-28.38 0-56.26 9.35-78.5 26.33L79.79 336H16c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h80.02l41.27-31.52c13.96-10.66 31.39-16.48 49.37-16.48h144c27.86 0 29.07 40.16-1.14 40.16h-59.76c-7.6 0-13.76 6.16-13.76 13.76v.08c0 7.6 6.16 13.76 13.76 13.76h134.46c9.71 0 19.17-3.16 26.93-9l61.29-46.15c8.27-6.22 20.49-6.73 28.42 0 10.05 8.54 9.26 23.06-.87 30.68L419.43 455c-7.76 5.84-17.2 9-26.92 9H16c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h376.83c19.92 0 39.3-6.48 55.21-18.46l100.81-75.91c16.6-12.48 26.49-31.45 27.11-52.03.62-20.54-8.13-40.06-24.02-53.57zM224 192h41.69c42.62 0 78.28-30.48 86.31-70.8-16.09 9.98-44.81 22.8-86.31 22.8H224c-22.53 0-40-21.5-40-40V88c0-22.06 17.94-40 40-40h144c22.06 0 40 17.94 40 40v33.22c0 33.94-15.78 68.22-44.47 96.5L324.72 256c73.34-5.77 130.75-63.72 131.28-133.28V88c0-48.53-39.47-88-88-88H224c-48.53 0-88 39.47-88 88v16c0 46.88 41.12 88 88 88z"
  ]
};
export const faHandHoldingMedical = {
  prefix: "far",
  iconName: "hand-holding-medical",
  icon: [
    576,
    512,
    [],
    "e05c",
    "M160,176h64v64a16,16,0,0,0,16,16h64a16,16,0,0,0,16-16V176h64a16,16,0,0,0,16-16V96a16,16,0,0,0-16-16H320V16A16,16,0,0,0,304,0H240a16,16,0,0,0-16,16V80H160a16,16,0,0,0-16,16v64A16,16,0,0,0,160,176ZM552,312c-31.11-26.4-69.32-16.09-88.41-1.8l-60.42,45.49h-3.29c-.21-38-30.51-67.78-69.21-67.78h-144a130.4,130.4,0,0,0-78.51,26.29L79.8,336H16A16,16,0,0,0,0,352v16a16,16,0,0,0,16,16H96l41.3-31.49A81.37,81.37,0,0,1,186.72,336h144c27.89,0,29.09,40.2-1.11,40.2H269.82A13.82,13.82,0,0,0,256,390v.1a13.83,13.83,0,0,0,13.79,13.81H404.34a45,45,0,0,0,26.91-9l61.3-46.1c8.3-6.21,20.5-6.71,28.41,0a19.28,19.28,0,0,1-.91,30.69L419.45,455a45.16,45.16,0,0,1-26.91,9H16A16,16,0,0,0,0,480v16a16,16,0,0,0,16,16H392.84A91.69,91.69,0,0,0,448,493.5l100.81-75.89A67.32,67.32,0,0,0,552,312Z"
  ]
};
export const faHandHoldingSeedling = {
  prefix: "far",
  iconName: "hand-holding-seedling",
  icon: [
    576,
    512,
    [],
    "f4bf",
    "M250.7 192H264v48c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-48h13.3C410.6 192 480 116.6 480 24V0h-61.3C363.5 0 315.4 31.7 288 79 260.6 31.7 212.5 0 157.3 0H96v24c0 92.6 69.4 168 154.7 168zm168-144h11.2c-9.9 54.7-53 96-104.5 96h-11.2c9.9-54.7 53-96 104.5-96zm-261.4 0c51.5 0 94.6 41.3 104.5 96h-11.2c-51.5 0-94.6-41.3-104.5-96h11.2zm394.6 264c-31.1-26.4-69.3-16.1-88.4-1.8l-60.4 45.5h-3.3c-.2-38-30.5-67.8-69.2-67.8h-144c-28.4 0-56.3 9.4-78.5 26.3L79.8 336H16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h80l41.3-31.5c14-10.7 31.4-16.5 49.4-16.5h144c27.9 0 29.1 40.2-1.1 40.2h-59.8c-7.6 0-13.8 6.2-13.8 13.8v.1c0 7.6 6.2 13.8 13.8 13.8h134.5c9.7 0 19.2-3.2 26.9-9l61.3-46.1c8.3-6.2 20.5-6.7 28.4 0 10.1 8.5 9.3 23.1-.9 30.7L419.4 455c-7.8 5.8-17.2 9-26.9 9H16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h376.8c19.9 0 39.3-6.5 55.2-18.5l100.8-75.9c16.6-12.5 26.5-31.5 27.1-52 .7-20.5-8.1-40.1-24-53.6z"
  ]
};
export const faHandHoldingUsd = {
  prefix: "far",
  iconName: "hand-holding-usd",
  icon: [
    576,
    512,
    [],
    "f4c0",
    "M551.9 312c-31.1-26.4-69.3-16.1-88.4-1.8l-60.4 45.5h-3.3c-.2-38-30.5-67.8-69.2-67.8h-144c-28.4 0-56.3 9.4-78.5 26.3L79.8 336H16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h80l41.3-31.5c14-10.7 31.4-16.5 49.4-16.5h144c27.9 0 29.1 40.2-1.1 40.2h-59.8c-7.6 0-13.8 6.2-13.8 13.8v.1c0 7.6 6.2 13.8 13.8 13.8h134.5c9.7 0 19.2-3.2 26.9-9l61.3-46.1c8.3-6.2 20.5-6.7 28.4 0 10.1 8.5 9.3 23.1-.9 30.7L419.4 455c-7.8 5.8-17.2 9-26.9 9H16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h376.8c19.9 0 39.3-6.5 55.2-18.5l100.8-75.9c16.6-12.5 26.5-31.5 27.1-52 .7-20.5-8.1-40.1-24-53.6zM257.6 144.3l50.1 14.3c3.6 1 6.1 4.4 6.1 8.1 0 4.6-3.8 8.4-8.4 8.4h-32.8c-3.6 0-7.1-.8-10.3-2.2-4.8-2.2-10.4-1.7-14.1 2l-17.5 17.5c-5.3 5.3-4.7 14.3 1.5 18.4 9.5 6.3 20.4 10.1 31.8 11.5V240c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-17.6c30.3-3.6 53.4-31 49.3-63-2.9-23-20.7-41.3-42.9-47.7l-50.1-14.3c-3.6-1-6.1-4.4-6.1-8.1 0-4.6 3.8-8.4 8.4-8.4h32.8c3.6 0 7.1.8 10.3 2.2 4.8 2.2 10.4 1.7 14.1-2l17.5-17.5c5.3-5.3 4.7-14.3-1.5-18.4-9.5-6.3-20.4-10.1-31.8-11.5V16c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16v17.6c-30.3 3.6-53.4 31-49.3 63 2.9 23 20.6 41.3 42.9 47.7z"
  ]
};
export const faHandHoldingWater = {
  prefix: "far",
  iconName: "hand-holding-water",
  icon: [
    576,
    512,
    [],
    "f4c1",
    "M551.9 312c-31.1-26.4-69.3-16.1-88.4-1.8l-60.4 45.5h-3.3c-.2-38-30.5-67.8-69.2-67.8h-144c-28.4 0-56.3 9.4-78.5 26.3L79.8 336H16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h80l41.3-31.5c14-10.7 31.4-16.5 49.4-16.5h144c27.9 0 29.1 40.2-1.1 40.2h-59.8c-7.6 0-13.8 6.2-13.8 13.8v.1c0 7.6 6.2 13.8 13.8 13.8h134.5c9.7 0 19.2-3.2 26.9-9l61.3-46.1c8.3-6.2 20.5-6.7 28.4 0 10.1 8.5 9.3 23.1-.9 30.7L419.4 455c-7.8 5.8-17.2 9-26.9 9H16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h376.8c19.9 0 39.3-6.5 55.2-18.5l100.8-75.9c16.6-12.5 26.5-31.5 27.1-52 .7-20.5-8.1-40.1-24-53.6zM288 256c53 0 96-42.1 96-94 0-40-57.1-120.7-83.2-155.6-3.2-4.3-8-6.4-12.8-6.4s-9.6 2.1-12.8 6.4C249.1 41.3 192 122 192 162c0 51.9 43 94 96 94zm0-185.1c34 49.8 47.5 81.1 48 91.1 0 25.4-21.5 46-48 46s-48-20.6-48-45.8c.5-10.1 14-41.5 48-91.3z"
  ]
};
export const faHandLizard = {
  prefix: "far",
  iconName: "hand-lizard",
  icon: [
    576,
    512,
    [],
    "f258",
    "M556.686 290.542L410.328 64.829C397.001 44.272 374.417 32 349.917 32H56C25.121 32 0 57.122 0 88v8c0 44.112 35.888 80 80 80h196.042l-18.333 48H144c-48.523 0-88 39.477-88 88 0 30.879 25.121 56 56 56h131.552c2.987 0 5.914.549 8.697 1.631L352 408.418V480h224V355.829c0-23.225-6.679-45.801-19.314-65.287zM528 432H400v-23.582c0-19.948-12.014-37.508-30.604-44.736l-99.751-38.788A71.733 71.733 0 0 0 243.552 320H112c-4.411 0-8-3.589-8-8 0-22.056 17.944-40 40-40h113.709c19.767 0 37.786-12.407 44.84-30.873l24.552-64.281c8.996-23.553-8.428-48.846-33.63-48.846H80c-17.645 0-32-14.355-32-32v-8c0-4.411 3.589-8 8-8h293.917c8.166 0 15.693 4.09 20.137 10.942l146.358 225.715A71.84 71.84 0 0 1 528 355.829V432z"
  ]
};
export const faHandMiddleFinger = {
  prefix: "far",
  iconName: "hand-middle-finger",
  icon: [
    512,
    512,
    [],
    "f806",
    "M479.94 312.91c-.01-12.53-4.34-63.48-64.95-78.63-4.52-25.94-24.73-46.96-51.36-51.91-30.66-5.7-42.63-6.36-43.67-6.31l.04-96.07c0-44.18-35.82-80-80-80-44.11 0-79.85 35.7-79.98 79.78l-.05 96.29c-10.39-.49-23.46 2.65-36.82 5.33-11.88 2.38-59.16 16.77-59.16 76.94l-19.77 9.89C16.94 281.86 0 309.28 0 339.78v46.97c0 21.37 8.32 41.46 23.43 56.57l26.5 26.5c27.2 27.2 63.36 42.18 101.82 42.18h184.29c79.59 0 144.02-64.44 143.96-144.09l-.06-55zM336.04 464H151.75a95.942 95.942 0 0 1-67.87-28.12l-26.51-26.51c-6-6-9.37-14.14-9.37-22.63v-46.97a32 32 0 0 1 17.69-28.62L80 304v32c0 8.84 7.16 16 16 16s16-7.16 16-16l-.01-82.43c0-12.2 8.66-22.72 20.62-25.11 19.46-3.89 21.11-4.46 24.21-4.46 10.34 0 19.16 8.4 19.16 19.21 0 7.07 5.73 12.79 12.79 12.79h6.41c7.07 0 12.79-5.73 12.79-12.79L208 81.37c0-16.71 12.22-31.63 28.86-33.22C255.94 46.33 272 61.29 272 80l-.04 163.2c0 7.07 5.73 12.8 12.79 12.8h6.4c7.07 0 12.79-5.73 12.79-12.79 0-10.81 8.82-19.21 19.15-19.21 2.89 0 3.31.29 31.69 5.56 7.58 1.41 13.14 8.03 13.14 15.75V272l39.77 9.94c14.23 3.56 24.22 16.34 24.23 31.01l.06 55c.06 53.03-42.91 96.05-95.94 96.05z"
  ]
};
export const faHandPaper = {
  prefix: "far",
  iconName: "hand-paper",
  icon: [
    448,
    512,
    [],
    "f256",
    "M372.57 112.641v-10.825c0-43.612-40.52-76.691-83.039-65.546-25.629-49.5-94.09-47.45-117.982.747C130.269 26.456 89.144 57.945 89.144 102v126.13c-19.953-7.427-43.308-5.068-62.083 8.871-29.355 21.796-35.794 63.333-14.55 93.153L132.48 498.569a32 32 0 0 0 26.062 13.432h222.897c14.904 0 27.835-10.289 31.182-24.813l30.184-130.958A203.637 203.637 0 0 0 448 310.564V179c0-40.62-35.523-71.992-75.43-66.359zm27.427 197.922c0 11.731-1.334 23.469-3.965 34.886L368.707 464h-201.92L51.591 302.303c-14.439-20.27 15.023-42.776 29.394-22.605l27.128 38.079c8.995 12.626 29.031 6.287 29.031-9.283V102c0-25.645 36.571-24.81 36.571.691V256c0 8.837 7.163 16 16 16h6.856c8.837 0 16-7.163 16-16V67c0-25.663 36.571-24.81 36.571.691V256c0 8.837 7.163 16 16 16h6.856c8.837 0 16-7.163 16-16V101.125c0-25.672 36.57-24.81 36.57.691V256c0 8.837 7.163 16 16 16h6.857c8.837 0 16-7.163 16-16v-76.309c0-26.242 36.57-25.64 36.57-.691v131.563z"
  ]
};
export const faHandPeace = {
  prefix: "far",
  iconName: "hand-peace",
  icon: [
    448,
    512,
    [],
    "f25b",
    "M362.146 191.976c-13.71-21.649-38.761-34.016-65.006-30.341V74c0-40.804-32.811-74-73.141-74-40.33 0-73.14 33.196-73.14 74L160 168l-18.679-78.85C126.578 50.843 83.85 32.11 46.209 47.208 8.735 62.238-9.571 104.963 5.008 142.85l55.757 144.927c-30.557 24.956-43.994 57.809-24.733 92.218l54.853 97.999C102.625 498.97 124.73 512 148.575 512h205.702c30.744 0 57.558-21.44 64.555-51.797l27.427-118.999a67.801 67.801 0 0 0 1.729-15.203L448 256c0-44.956-43.263-77.343-85.854-64.024zM399.987 326c0 1.488-.169 2.977-.502 4.423l-27.427 119.001c-1.978 8.582-9.29 14.576-17.782 14.576H148.575c-6.486 0-12.542-3.621-15.805-9.449l-54.854-98c-4.557-8.141-2.619-18.668 4.508-24.488l26.647-21.764a16 16 0 0 0 4.812-18.139l-64.09-166.549C37.226 92.956 84.37 74.837 96.51 106.389l59.784 155.357A16 16 0 0 0 171.227 272h11.632c8.837 0 16-7.163 16-16V74c0-34.375 50.281-34.43 50.281 0v182c0 8.837 7.163 16 16 16h6.856c8.837 0 16-7.163 16-16v-28c0-25.122 36.567-25.159 36.567 0v28c0 8.837 7.163 16 16 16h6.856c8.837 0 16-7.163 16-16 0-25.12 36.567-25.16 36.567 0v70z"
  ]
};
export const faHandPointDown = {
  prefix: "far",
  iconName: "hand-point-down",
  icon: [
    448,
    512,
    [],
    "f0a7",
    "M188.8 512c45.616 0 83.2-37.765 83.2-83.2v-35.647a93.148 93.148 0 0 0 22.064-7.929c22.006 2.507 44.978-3.503 62.791-15.985C409.342 368.1 448 331.841 448 269.299V248c0-60.063-40-98.512-40-127.2v-2.679c4.952-5.747 8-13.536 8-22.12V32c0-17.673-12.894-32-28.8-32H156.8C140.894 0 128 14.327 128 32v64c0 8.584 3.048 16.373 8 22.12v2.679c0 6.964-6.193 14.862-23.668 30.183l-.148.129-.146.131c-9.937 8.856-20.841 18.116-33.253 25.851C48.537 195.798 0 207.486 0 252.8c0 56.928 35.286 92 83.2 92 8.026 0 15.489-.814 22.4-2.176V428.8c0 45.099 38.101 83.2 83.2 83.2zm0-48c-18.7 0-35.2-16.775-35.2-35.2V270.4c-17.325 0-35.2 26.4-70.4 26.4-26.4 0-35.2-20.625-35.2-44 0-8.794 32.712-20.445 56.1-34.926 14.575-9.074 27.225-19.524 39.875-30.799 18.374-16.109 36.633-33.836 39.596-59.075h176.752C364.087 170.79 400 202.509 400 248v21.299c0 40.524-22.197 57.124-61.325 50.601-8.001 14.612-33.979 24.151-53.625 12.925-18.225 19.365-46.381 17.787-61.05 4.95V428.8c0 18.975-16.225 35.2-35.2 35.2zM328 64c0-13.255 10.745-24 24-24s24 10.745 24 24-10.745 24-24 24-24-10.745-24-24z"
  ]
};
export const faHandPointLeft = {
  prefix: "far",
  iconName: "hand-point-left",
  icon: [
    512,
    512,
    [],
    "f0a5",
    "M0 220.8C0 266.416 37.765 304 83.2 304h35.647a93.148 93.148 0 0 0 7.929 22.064c-2.507 22.006 3.503 44.978 15.985 62.791C143.9 441.342 180.159 480 242.701 480H264c60.063 0 98.512-40 127.2-40h2.679c5.747 4.952 13.536 8 22.12 8h64c17.673 0 32-12.894 32-28.8V188.8c0-15.906-14.327-28.8-32-28.8h-64c-8.584 0-16.373 3.048-22.12 8H391.2c-6.964 0-14.862-6.193-30.183-23.668l-.129-.148-.131-.146c-8.856-9.937-18.116-20.841-25.851-33.253C316.202 80.537 304.514 32 259.2 32c-56.928 0-92 35.286-92 83.2 0 8.026.814 15.489 2.176 22.4H83.2C38.101 137.6 0 175.701 0 220.8zm48 0c0-18.7 16.775-35.2 35.2-35.2h158.4c0-17.325-26.4-35.2-26.4-70.4 0-26.4 20.625-35.2 44-35.2 8.794 0 20.445 32.712 34.926 56.1 9.074 14.575 19.524 27.225 30.799 39.875 16.109 18.374 33.836 36.633 59.075 39.596v176.752C341.21 396.087 309.491 432 264 432h-21.299c-40.524 0-57.124-22.197-50.601-61.325-14.612-8.001-24.151-33.979-12.925-53.625-19.365-18.225-17.787-46.381-4.95-61.05H83.2C64.225 256 48 239.775 48 220.8zM448 360c13.255 0 24 10.745 24 24s-10.745 24-24 24-24-10.745-24-24 10.745-24 24-24z"
  ]
};
export const faHandPointRight = {
  prefix: "far",
  iconName: "hand-point-right",
  icon: [
    512,
    512,
    [],
    "f0a4",
    "M428.8 137.6h-86.177a115.52 115.52 0 0 0 2.176-22.4c0-47.914-35.072-83.2-92-83.2-45.314 0-57.002 48.537-75.707 78.784-7.735 12.413-16.994 23.317-25.851 33.253l-.131.146-.129.148C135.662 161.807 127.764 168 120.8 168h-2.679c-5.747-4.952-13.536-8-22.12-8H32c-17.673 0-32 12.894-32 28.8v230.4C0 435.106 14.327 448 32 448h64c8.584 0 16.373-3.048 22.12-8h2.679c28.688 0 67.137 40 127.2 40h21.299c62.542 0 98.8-38.658 99.94-91.145 12.482-17.813 18.491-40.785 15.985-62.791A93.148 93.148 0 0 0 393.152 304H428.8c45.435 0 83.2-37.584 83.2-83.2 0-45.099-38.101-83.2-83.2-83.2zm0 118.4h-91.026c12.837 14.669 14.415 42.825-4.95 61.05 11.227 19.646 1.687 45.624-12.925 53.625 6.524 39.128-10.076 61.325-50.6 61.325H248c-45.491 0-77.21-35.913-120-39.676V215.571c25.239-2.964 42.966-21.222 59.075-39.596 11.275-12.65 21.725-25.3 30.799-39.875C232.355 112.712 244.006 80 252.8 80c23.375 0 44 8.8 44 35.2 0 35.2-26.4 53.075-26.4 70.4h158.4c18.425 0 35.2 16.5 35.2 35.2 0 18.975-16.225 35.2-35.2 35.2zM88 384c0 13.255-10.745 24-24 24s-24-10.745-24-24 10.745-24 24-24 24 10.745 24 24z"
  ]
};
export const faHandPointUp = {
  prefix: "far",
  iconName: "hand-point-up",
  icon: [
    448,
    512,
    [],
    "f0a6",
    "M105.6 83.2v86.177a115.52 115.52 0 0 0-22.4-2.176c-47.914 0-83.2 35.072-83.2 92 0 45.314 48.537 57.002 78.784 75.707 12.413 7.735 23.317 16.994 33.253 25.851l.146.131.148.129C129.807 376.338 136 384.236 136 391.2v2.679c-4.952 5.747-8 13.536-8 22.12v64c0 17.673 12.894 32 28.8 32h230.4c15.906 0 28.8-14.327 28.8-32v-64c0-8.584-3.048-16.373-8-22.12V391.2c0-28.688 40-67.137 40-127.2v-21.299c0-62.542-38.658-98.8-91.145-99.94-17.813-12.482-40.785-18.491-62.791-15.985A93.148 93.148 0 0 0 272 118.847V83.2C272 37.765 234.416 0 188.8 0c-45.099 0-83.2 38.101-83.2 83.2zm118.4 0v91.026c14.669-12.837 42.825-14.415 61.05 4.95 19.646-11.227 45.624-1.687 53.625 12.925 39.128-6.524 61.325 10.076 61.325 50.6V264c0 45.491-35.913 77.21-39.676 120H183.571c-2.964-25.239-21.222-42.966-39.596-59.075-12.65-11.275-25.3-21.725-39.875-30.799C80.712 279.645 48 267.994 48 259.2c0-23.375 8.8-44 35.2-44 35.2 0 53.075 26.4 70.4 26.4V83.2c0-18.425 16.5-35.2 35.2-35.2 18.975 0 35.2 16.225 35.2 35.2zM352 424c13.255 0 24 10.745 24 24s-10.745 24-24 24-24-10.745-24-24 10.745-24 24-24z"
  ]
};
export const faHandPointer = {
  prefix: "far",
  iconName: "hand-pointer",
  icon: [
    448,
    512,
    [],
    "f25a",
    "M358.182 179.361c-19.493-24.768-52.679-31.945-79.872-19.098-15.127-15.687-36.182-22.487-56.595-19.629V67c0-36.944-29.736-67-66.286-67S89.143 30.056 89.143 67v161.129c-19.909-7.41-43.272-5.094-62.083 8.872-29.355 21.795-35.793 63.333-14.55 93.152l109.699 154.001C134.632 501.59 154.741 512 176 512h178.286c30.802 0 57.574-21.5 64.557-51.797l27.429-118.999A67.873 67.873 0 0 0 448 326v-84c0-46.844-46.625-79.273-89.818-62.639zM80.985 279.697l27.126 38.079c8.995 12.626 29.031 6.287 29.031-9.283V67c0-25.12 36.571-25.16 36.571 0v175c0 8.836 7.163 16 16 16h6.857c8.837 0 16-7.164 16-16v-35c0-25.12 36.571-25.16 36.571 0v35c0 8.836 7.163 16 16 16H272c8.837 0 16-7.164 16-16v-21c0-25.12 36.571-25.16 36.571 0v21c0 8.836 7.163 16 16 16h6.857c8.837 0 16-7.164 16-16 0-25.121 36.571-25.16 36.571 0v84c0 1.488-.169 2.977-.502 4.423l-27.43 119.001c-1.978 8.582-9.29 14.576-17.782 14.576H176c-5.769 0-11.263-2.878-14.697-7.697l-109.712-154c-14.406-20.223 14.994-42.818 29.394-22.606zM176.143 400v-96c0-8.837 6.268-16 14-16h6c7.732 0 14 7.163 14 16v96c0 8.837-6.268 16-14 16h-6c-7.733 0-14-7.163-14-16zm75.428 0v-96c0-8.837 6.268-16 14-16h6c7.732 0 14 7.163 14 16v96c0 8.837-6.268 16-14 16h-6c-7.732 0-14-7.163-14-16zM327 400v-96c0-8.837 6.268-16 14-16h6c7.732 0 14 7.163 14 16v96c0 8.837-6.268 16-14 16h-6c-7.732 0-14-7.163-14-16z"
  ]
};
export const faHandReceiving = {
  prefix: "far",
  iconName: "hand-receiving",
  icon: [
    640,
    512,
    [],
    "f47c",
    "M297.6 246.7c6.2 6.2 14.3 9.3 22.4 9.3s16.2-3.1 22.4-9.3l96.4-96.4c12.4-12.3 12.4-32.4 0-44.7L342.4 9.3C336.2 3.1 328.1 0 320 0s-16.2 3.1-22.4 9.3l-96.4 96.4c-12.4 12.3-12.4 32.4 0 44.7l96.4 96.3zM320 54l74 74-74 74-74-74 74-74zm252.9 42.2C531 93.4 496 126.7 496 168c0 0-.1 39-.2 76-11.7-7.8-25.7-12-39.8-12-22.5 0-43.3 10.2-57 28l-71.8 93.3c-2.7 3.5-5 7.4-7.2 11.2-2.3-3.8-4.5-7.7-7.2-11.2L241 260c-13.8-17.8-34.6-28-57-28-14.1 0-28.1 4.3-39.8 12-.1-37.1-.2-76-.2-76 0-41.3-35-74.6-76.9-71.8C28.8 98.7 0 132.2 0 170.5V362c0 25.3 8.7 50.2 24.5 70l58.7 74c3 3.8 7.7 6.1 12.5 6.1H112c8.8 0 16-7.2 16-16v-11.6L62 402c-9.1-11.3-14-25.4-14-40V168.9c0-11.6 7.8-22.3 19.2-24.4 15.3-3 28.8 8.7 28.8 23.5 0 0 .2 101 .3 132.6 0 7.6 2.8 14.8 7.8 20.6l76.5 92.6c4.4 5.3 10.7 8 17 8 5.8 0 11.7-2.3 16.1-7 7.5-7.9 7.3-20.4.8-29.2l-49.5-67c-8.1-10.5-6.1-25.6 4.4-33.7 4.4-3.4 9.5-5 14.6-5 7.2 0 14.3 3.2 19.1 9.4l71.7 93.2c8.6 11.2 13.3 24.9 13.3 39V496c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-74.4c0-14.1 4.7-27.8 13.3-39l71.7-93.2c4.7-6.1 11.9-9.4 19.1-9.4 5.1 0 10.2 1.6 14.6 5 10.5 8.1 12.5 23.1 4.4 33.7l-49.5 67c-6.5 8.8-6.6 21.3.8 29.2 4.4 4.7 10.2 7 16.1 7 6.3 0 12.6-2.7 17-8l76.5-92.6c5-5.8 7.7-13 7.8-20.6-.1-31.7.1-132.7.1-132.7 0-14.8 13.4-26.5 28.8-23.5 11.4 2.2 19.2 12.8 19.2 24.4V362c0 14.5-4.9 28.6-14 39.9l-66 82.5V496c0 8.8 7.2 16 16 16h16.3c4.9 0 9.5-2.2 12.5-6.1l58.7-74c15.8-19.8 24.5-44.6 24.5-70V170.5c0-38.3-28.8-71.8-67.1-74.3z"
  ]
};
export const faHandRock = {
  prefix: "far",
  iconName: "hand-rock",
  icon: [
    512,
    512,
    [],
    "f255",
    "M408.864 79.052c-22.401-33.898-66.108-42.273-98.813-23.588-29.474-31.469-79.145-31.093-108.334-.022-47.16-27.02-108.71 5.055-110.671 60.806C44.846 105.407 0 140.001 0 187.429v56.953c0 32.741 14.28 63.954 39.18 85.634l97.71 85.081c4.252 3.702 3.11 5.573 3.11 32.903 0 17.673 14.327 32 32 32h252c17.673 0 32-14.327 32-32 0-23.513-1.015-30.745 3.982-42.37l42.835-99.656c6.094-14.177 9.183-29.172 9.183-44.568V146.963c0-52.839-54.314-88.662-103.136-67.911zM464 261.406a64.505 64.505 0 0 1-5.282 25.613l-42.835 99.655c-5.23 12.171-7.883 25.04-7.883 38.25V432H188v-10.286c0-16.37-7.14-31.977-19.59-42.817l-97.71-85.08C56.274 281.255 48 263.236 48 244.381v-56.953c0-33.208 52-33.537 52 .677v41.228a16 16 0 0 0 5.493 12.067l7 6.095A16 16 0 0 0 139 235.429V118.857c0-33.097 52-33.725 52 .677v26.751c0 8.836 7.164 16 16 16h7c8.836 0 16-7.164 16-16v-41.143c0-33.134 52-33.675 52 .677v40.466c0 8.836 7.163 16 16 16h7c8.837 0 16-7.164 16-16v-27.429c0-33.03 52-33.78 52 .677v26.751c0 8.836 7.163 16 16 16h7c8.837 0 16-7.164 16-16 0-33.146 52-33.613 52 .677v114.445z"
  ]
};
export const faHandScissors = {
  prefix: "far",
  iconName: "hand-scissors",
  icon: [
    512,
    512,
    [],
    "f257",
    "M256 480l70-.013c5.114 0 10.231-.583 15.203-1.729l118.999-27.427C490.56 443.835 512 417.02 512 386.277V180.575c0-23.845-13.03-45.951-34.005-57.69l-97.999-54.853c-34.409-19.261-67.263-5.824-92.218 24.733L142.85 37.008c-37.887-14.579-80.612 3.727-95.642 41.201-15.098 37.642 3.635 80.37 41.942 95.112L168 192l-94-9.141c-40.804 0-74 32.811-74 73.14 0 40.33 33.196 73.141 74 73.141h87.635c-3.675 26.245 8.692 51.297 30.341 65.006C178.657 436.737 211.044 480 256 480zm0-48.013c-25.16 0-25.12-36.567 0-36.567 8.837 0 16-7.163 16-16v-6.856c0-8.837-7.163-16-16-16h-28c-25.159 0-25.122-36.567 0-36.567h28c8.837 0 16-7.163 16-16v-6.856c0-8.837-7.163-16-16-16H74c-34.43 0-34.375-50.281 0-50.281h182c8.837 0 16-7.163 16-16v-11.632a16 16 0 0 0-10.254-14.933L106.389 128.51c-31.552-12.14-13.432-59.283 19.222-46.717l166.549 64.091a16.001 16.001 0 0 0 18.139-4.812l21.764-26.647c5.82-7.127 16.348-9.064 24.488-4.508l98 54.854c5.828 3.263 9.449 9.318 9.449 15.805v205.701c0 8.491-5.994 15.804-14.576 17.782l-119.001 27.427a19.743 19.743 0 0 1-4.423.502h-70z"
  ]
};
export const faHandSparkles = {
  prefix: "far",
  iconName: "hand-sparkles",
  icon: [
    640,
    512,
    [],
    "e05d",
    "M471.38,467.5l-1-.43-1-.49a37.63,37.63,0,0,1-6.06-4.23,31.74,31.74,0,0,1-9.47,1.65H273.14a32.29,32.29,0,0,1-26.69-14.3L132.34,277.8c-18-25.71,20.7-54.1,39.3-27.5l37.81,54.4c4.5,6.5,14.59,3.21,14.59-4.61V104c0-31.8,48-31.7,48,0V248a8,8,0,0,0,8,8h16a8,8,0,0,0,8-8V72c0-31.8,48-31.7,48,0V248a8,8,0,0,0,8,8h16a8,8,0,0,0,8-8V104c0-31.8,48-31.7,48,0V248a8,8,0,0,0,8,8h16a8,8,0,0,0,8-8V184c0-31.8,48-31.7,48,0v88.3a321.9,321.9,0,0,1-6.2,62.79L495.6,386.4l13.27-5.53,15.63-37.49.41-1,.47-.95c5.83-11.74,18-19.6,31-20.92A371.21,371.21,0,0,0,560,272.3V184A71.94,71.94,0,0,0,488,112c-2.7,0-5.4.2-8,.41V104a72.08,72.08,0,0,0-72-72,70.77,70.77,0,0,0-18.59,2.41,72,72,0,0,0-122.81,0A70.79,70.79,0,0,0,248,32a72.08,72.08,0,0,0-72,72v92.09c-10.5-3.68-38.09-10.18-65.29,8.91A72.13,72.13,0,0,0,93,305.3l113.5,171a79.81,79.81,0,0,0,66.6,35.7H453.75a79.85,79.85,0,0,0,57-24.3l-1.9-4.57ZM86,156.3l20.69-49.63h0l.09,0L156.3,86A7.29,7.29,0,0,0,160,80h0A7.28,7.28,0,0,0,156.3,74L106.73,53.37l-.07,0L86,3.7A6.65,6.65,0,0,0,74,3.7L53.34,53.33l-.05,0L3.7,74A7.28,7.28,0,0,0,0,80H0A7.29,7.29,0,0,0,3.7,86l49.57,20.67.07,0L74,156.3a6.65,6.65,0,0,0,11.92,0ZM307.58,288a4,4,0,0,0-7.15,0L288,317.79l-29.79,12.42a4,4,0,0,0,0,7.15L288,349.78l12.42,29.78a4,4,0,0,0,7.15,0L320,349.78l29.79-12.42a4,4,0,0,0,0-7.15L320,317.79ZM640,432A7.28,7.28,0,0,0,636.3,426l-49.57-20.67-.07,0L566,355.7a6.65,6.65,0,0,0-11.92,0l-20.7,49.63-.05,0L483.7,426A7.28,7.28,0,0,0,480,432h0A7.29,7.29,0,0,0,483.7,438l49.57,20.67.07,0L554,508.3a6.65,6.65,0,0,0,11.92,0l20.69-49.63h0l.09-.05L636.3,438A7.29,7.29,0,0,0,640,432h0Z"
  ]
};
export const faHandSpock = {
  prefix: "far",
  iconName: "hand-spock",
  icon: [
    512,
    512,
    [],
    "f259",
    "M501.03053,116.17605c-19.39059-31.50779-51.24406-35.72849-66.31044-35.01756-14.11325-50.81051-62.0038-54.08-70.73816-54.08a74.03091,74.03091,0,0,0-72.23816,58.916l-4.64648,22.66014-13.68357-53.207c-9.09569-35.37107-46.412-64.05074-89.66-53.07223a73.89749,73.89749,0,0,0-55.121,78.94722,73.68273,73.68273,0,0,0-64.8495,94.42181l24.35933,82.19721c-38.24017-7.54492-62.79677,16.18358-68.11512,21.84764a73.6791,73.6791,0,0,0,3.19921,104.19329l91.36509,85.9765A154.164,154.164,0,0,0,220.62279,512h107.4549A127.30079,127.30079,0,0,0,452.3392,413.86139l57.623-241.96272A73.20274,73.20274,0,0,0,501.03053,116.17605Zm-37.7597,44.60544L405.64788,402.74812a79.46616,79.46616,0,0,1-77.57019,61.25972H220.62279a106.34052,106.34052,0,0,1-73.1366-28.998l-91.369-85.98041C31.34381,325.72669,66.61133,288.131,91.39644,311.5392l51.123,48.10739c5.42577,5.10937,13.48239.71679,13.48239-5.82617a246.79914,246.79914,0,0,0-10.17771-70.1523l-36.01362-121.539c-9.7324-32.88279,39.69916-47.27145,49.38664-14.625l31.3437,105.77923c5.59374,18.90428,33.78119,10.71288,28.9648-8.00781L177.06427,80.23662c-8.50389-33.1035,41.43157-45.64646,49.86515-12.83593l47.32609,184.035c4.42773,17.24218,29.16207,16.5039,32.71089-.80468l31.791-154.9706c6.81054-33.1074,57.51748-24.10741,50.11906,11.96288L360.32764,246.78924c-3.72265,18.10936,23.66793,24.63084,28.05659,6.21679L413.185,148.85962C421.1498,115.512,471.14,127.79713,463.27083,160.78149Z"
  ]
};
export const faHands = {
  prefix: "far",
  iconName: "hands",
  icon: [
    640,
    512,
    [],
    "f4c2",
    "M572.9 96.2C531 93.4 496 126.7 496 168c0 0-.1 39-.2 76-11.7-7.8-25.7-12-39.8-12-22.5 0-43.3 10.2-57 28l-71.8 93.3c-2.7 3.5-5 7.4-7.2 11.2-2.3-3.8-4.5-7.7-7.2-11.2L241 260c-13.8-17.8-34.6-28-57-28-14.1 0-28.1 4.3-39.8 12-.1-37.1-.2-76-.2-76 0-41.3-35-74.6-76.9-71.8C28.8 98.7 0 132.2 0 170.5V362c0 25.3 8.7 50.2 24.5 70l58.7 74c3 3.8 7.7 6.1 12.5 6.1H112c8.8 0 16-7.2 16-16v-11.6L62 402c-9.1-11.3-14-25.4-14-40V168.9c0-11.6 7.8-22.3 19.2-24.4 15.3-3 28.8 8.7 28.8 23.5 0 0 .2 101 .3 132.6 0 7.6 2.8 14.8 7.8 20.6l76.5 92.6c4.4 5.3 10.7 8 17 8 5.8 0 11.7-2.3 16.1-7 7.5-7.9 7.3-20.4.8-29.2l-49.5-67c-8.1-10.5-6.1-25.6 4.4-33.7 4.4-3.4 9.5-5 14.6-5 7.2 0 14.3 3.2 19.1 9.4l71.7 93.2c8.6 11.2 13.3 24.9 13.3 39V496c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-74.4c0-14.1 4.7-27.8 13.3-39l71.7-93.2c4.7-6.1 11.9-9.4 19.1-9.4 5.1 0 10.2 1.6 14.6 5 10.5 8.1 12.5 23.1 4.4 33.7l-49.5 67c-6.5 8.8-6.6 21.3.8 29.2 4.4 4.7 10.2 7 16.1 7 6.3 0 12.6-2.7 17-8l76.5-92.6c5-5.8 7.7-13 7.8-20.6-.1-31.7.1-132.7.1-132.7 0-14.8 13.4-26.5 28.8-23.5 11.4 2.2 19.2 12.8 19.2 24.4V362c0 14.5-4.9 28.6-14 39.9l-66 82.5V496c0 8.8 7.2 16 16 16h16.3c4.9 0 9.5-2.2 12.5-6.1l58.7-74c15.8-19.8 24.5-44.6 24.5-70V170.5c0-38.3-28.8-71.8-67.1-74.3z"
  ]
};
export const faHandsHeart = {
  prefix: "far",
  iconName: "hands-heart",
  icon: [
    640,
    512,
    [],
    "f4c3",
    "M298.8 247.1c6.3 6.5 13.8 8.9 21.2 8.9 7.3.1 14.9-2.4 21.2-8.9l98.7-102c30.1-31.1 36.4-90.1-6-126.3C395.5-14 344.8 1 320 26.6 295.2 1 244.5-14 206.2 18.8c-42.4 36.2-36.1 95.2-6 126.3l98.6 102zM236.5 55.6c14.1-12 36.1-9 49.3 4.7L320 95.6l34.1-35.4c13.2-13.7 35.3-16.7 49.3-4.7 18.9 16.1 15.7 42.4 2.7 55.9L320 200.5l-86.1-89.1c-13.1-13.4-16.2-39.7 2.6-55.8zm336.4 40.6C531 93.4 496 126.7 496 168c0 0-.1 39-.2 76-29.8-19.8-72.5-15.5-96.8 16l-71.8 93.3c-2.7 3.5-5 7.4-7.2 11.2-2.3-3.8-4.5-7.7-7.2-11.2L241 260c-24.6-31.9-67.4-35.5-96.8-16-.1-37.1-.2-76-.2-76 0-41.3-35-74.6-76.9-71.8C28.8 98.7 0 132.2 0 170.5V362c0 25.3 8.7 50.2 24.5 70l58.7 74c3 3.8 7.7 6.1 12.5 6.1H112c8.8 0 16-7.2 16-16 0-7.5-2.6-14.8-7.2-20.6L62 402c-9.1-11.3-14-25.4-14-40V168.9c0-11.6 7.8-22.3 19.2-24.4 15.3-3 28.8 8.7 28.8 23.5 0 0 .2 101 .3 132.6 0 7.6 2.8 14.8 7.8 20.6l76.5 92.6c17.7 21.4 52.2-3.3 33.9-28.2l-49.5-67c-8.1-10.5-6.1-25.6 4.4-33.7 10.8-8.4 25.8-5.8 33.7 4.4l71.7 93.2c8.6 11.2 13.3 24.9 13.3 39V496c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-74.4c0-14.1 4.7-27.8 13.3-39l71.7-93.2c7.9-10.2 22.9-12.7 33.7-4.4 10.5 8.1 12.5 23.1 4.4 33.7l-49.5 67c-18.4 24.9 16.2 49.6 33.9 28.2l76.5-92.6c5-5.8 7.7-13 7.8-20.6-.1-31.7.1-132.7.1-132.7 0-14.8 13.4-26.5 28.8-23.5 11.4 2.2 19.2 12.8 19.2 24.4V362c0 14.5-4.9 28.6-14 39.9l-58.7 73.4c-4.7 5.9-7.2 13.1-7.2 20.6 0 8.8 7.2 16 16 16h16.3c4.9 0 9.5-2.2 12.5-6.1l58.7-74c15.8-19.8 24.5-44.6 24.5-70V170.5c-.1-38.3-28.9-71.8-67.2-74.3z"
  ]
};
export const faHandsHelping = {
  prefix: "far",
  iconName: "hands-helping",
  icon: [
    640,
    512,
    [],
    "f4c4",
    "M637.9 203.9l-8-13.9c-4.4-7.7-14.2-10.3-21.9-5.9l-96.7 56.4c-3.7-27.4-26.9-48.6-55.3-48.6H304v64c0 17.6-14.3 32-32 32s-32-14.4-32-32v-86.3c0-11 5.7-21.3 15-27.1l33.4-20.9c10.2-6.4 21.9-9.7 33.9-9.7h105.3l119.8-68.2c7.7-4.4 10.4-14.1 6-21.8L545.5 8c-4.4-7.7-14.1-10.4-21.8-6L415 64h-92.7c-21 0-41.5 5.9-59.3 17l-33.5 20.9c-18.3 11.4-30.6 29.4-35.2 49.8l-59.4 35.6C110.8 201.8 96 227.9 96 256.1v34.1L8 341c-7.7 4.4-10.3 14.2-5.9 21.9l8 13.9c4.4 7.7 14.2 10.3 21.9 5.9L144 318v-61.8c0-11.3 5.9-21.8 15.6-27.6L192 209v42.2c0 41.8 30 80.1 71.7 84.3 47.9 4.9 88.3-32.7 88.3-79.6v-16h104c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8h-32v60c0 15.4-12.5 27.8-27.8 27.8h-24.1v24c0 17.8-14.4 32.2-32.2 32.2H211.3l-62.8 36.3c-7.7 4.4-10.3 14.2-5.9 21.9l8 13.9c4.4 7.7 14.2 10.3 21.9 5.9l51.6-29.9h115.8c36.9 0 68.1-25.1 77.4-59.2 31.5-9.2 54.7-38.4 54.7-72.8v-14.3c17.6-5.3 31.5-19 37.1-36.4L632 225.8c7.7-4.5 10.3-14.2 5.9-21.9z"
  ]
};
export const faHandsUsd = {
  prefix: "far",
  iconName: "hands-usd",
  icon: [
    640,
    512,
    [],
    "f4c5",
    "M289.6 144.3l50.1 14.3c3.6 1 6.1 4.4 6.1 8.1 0 4.6-3.8 8.4-8.4 8.4h-32.8c-3.6 0-7.1-.8-10.3-2.2-4.8-2.2-10.4-1.7-14.1 2l-17.5 17.5c-5.3 5.3-4.7 14.3 1.5 18.4 9.5 6.3 20.4 10.1 31.8 11.5V240c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-17.6c30.3-3.6 53.4-31 49.3-63-2.9-23-20.7-41.3-42.9-47.7l-50.1-14.3c-3.6-1-6.1-4.4-6.1-8.1 0-4.6 3.8-8.4 8.4-8.4h32.8c3.6 0 7.1.8 10.3 2.2 4.8 2.2 10.4 1.7 14.1-2l17.5-17.5c5.3-5.3 4.7-14.3-1.5-18.4-9.5-6.3-20.4-10.1-31.8-11.5V16c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16v17.6c-30.3 3.6-53.4 31-49.3 63 2.9 23 20.6 41.3 42.9 47.7zm283.3-48.1C531 93.4 496 126.7 496 168c0 0-.1 39-.2 76-11.7-7.8-25.7-12-39.8-12-22.5 0-43.3 10.2-57 28l-71.8 93.3c-2.7 3.5-5 7.4-7.2 11.2-2.3-3.8-4.5-7.7-7.2-11.2L241 260c-13.8-17.8-34.6-28-57-28-14.1 0-28.1 4.3-39.8 12-.1-37.1-.2-76-.2-76 0-41.3-35-74.6-76.9-71.8C28.8 98.7 0 132.2 0 170.5V362c0 25.3 8.7 50.2 24.5 70l58.7 74c3 3.8 7.7 6.1 12.5 6.1H112c8.8 0 16-7.2 16-16 0-7.5-2.6-14.8-7.2-20.6L62 402c-9.1-11.3-14-25.4-14-40V168.9c0-11.6 7.8-22.3 19.2-24.4 15.3-3 28.8 8.7 28.8 23.5 0 0 .2 101 .3 132.6 0 7.6 2.8 14.8 7.8 20.6l76.5 92.6c8.1 9.8 23.6 11.1 33.1 1 7.5-7.9 7.3-20.4.8-29.2l-49.5-67c-8.1-10.5-6.1-25.6 4.4-33.7 4.4-3.4 9.5-5 14.6-5 7.2 0 14.3 3.2 19.1 9.4l71.7 93.2c8.6 11.2 13.3 24.9 13.3 39V496c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-74.4c0-14.1 4.7-27.8 13.3-39l71.7-93.2c4.7-6.1 11.9-9.4 19.1-9.4 5.1 0 10.2 1.6 14.6 5 10.5 8.1 12.5 23.1 4.4 33.7l-49.5 67c-6.5 8.8-6.6 21.3.8 29.2 10.2 10.9 25.7 7.9 33.1-1l76.5-92.6c5-5.8 7.7-13 7.8-20.6-.1-31.7.1-132.7.1-132.7 0-14.8 13.4-26.5 28.8-23.5 11.4 2.2 19.2 12.8 19.2 24.4V362c0 14.5-4.9 28.6-14 39.9l-58.7 73.4c-4.7 5.9-7.2 13.1-7.2 20.6 0 8.8 7.2 16 16 16h16.3c4.9 0 9.5-2.2 12.5-6.1l58.7-74c15.8-19.8 24.5-44.6 24.5-70V170.5c-.1-38.3-28.9-71.8-67.2-74.3z"
  ]
};
export const faHandsWash = {
  prefix: "far",
  iconName: "hands-wash",
  icon: [
    576,
    512,
    [],
    "e05e",
    "M576,192a80.09,80.09,0,0,0-80-80c-2.39,0-4.64.5-7,.71A63.65,63.65,0,1,0,448,128c.19,0,.37,0,.56-.06A78.77,78.77,0,0,0,421.64,221H386.21a67.83,67.83,0,0,0-4.49-12.92l12.42-39.3a67.5,67.5,0,0,0-42.83-84.32,68.3,68.3,0,0,0-6.63-13.17A67.28,67.28,0,0,0,309.56,44,67.66,67.66,0,0,0,253.9.45,66,66,0,0,0,246.24,0,66.87,66.87,0,0,0,208,11.94a68.38,68.38,0,0,0-11.55-2.37,66.08,66.08,0,0,0-7.66-.44c-29.57,0-55.51,19.24-64.56,47.89l-19.15,60.61c-1.5-.11-3-.17-4.54-.18-37.52,0-68.09,29.94-68.57,66.75v92.23A150.26,150.26,0,0,0,56.43,356C23.87,366.09,0,396.15,0,432a80.09,80.09,0,0,0,80,80c31.25,0,58.09-18.19,71.25-44.38A144.84,144.84,0,0,0,255.5,512h169A67.5,67.5,0,0,0,492,445.76a67.47,67.47,0,0,0,26-52,67.61,67.61,0,0,0,24.77-66.19A66.67,66.67,0,0,0,518,287.42a53.17,53.17,0,0,0-3-17.95C549.93,260.88,576,229.53,576,192ZM448,80a16,16,0,1,1,16-16A16,16,0,0,1,448,80ZM311,143.26c8.13-25.71,45.21-13.61,37.41,11.05l-5.83,18.48a65.19,65.19,0,0,0-40.58-1Zm-4.34-29.4-19.7,62.36L241.29,190.3c.21-.38.6-.6.74-1l27.18-86.46C277.34,77.09,314.41,89.19,306.62,113.86ZM80,184.83c.14-10.79,9.44-19.39,20.16-19.39h.07a19.52,19.52,0,0,1,19.39,19.63l1.69,40.66L170,71.48c8.12-25.72,45.2-13.62,37.41,11L176.12,181.7a6.5,6.5,0,1,0,12.4,3.91L227.46,62.35c8.12-25.72,45.2-13.62,37.41,11.05l-35.24,112a6.33,6.33,0,0,0,3.44,7.48l-20,6.17C151,219.7,110,276.41,110,340.47v5.66a99.83,99.83,0,0,1-30-69.7ZM80,464a32,32,0,1,1,32-32A32,32,0,0,1,80,464ZM476.5,360h-130a6.5,6.5,0,0,0,0,13H449.77c9.43,0,18.08,6.37,19.86,15.63A19.53,19.53,0,0,1,450.5,412h-104a6.5,6.5,0,0,0,0,13h77.27c9.43,0,18.08,6.37,19.86,15.63A19.53,19.53,0,0,1,424.5,464h-169A97.5,97.5,0,0,1,158,366.5v-26a100.65,100.65,0,0,1,69.22-95.59l87.52-27a20,20,0,0,1,5.73-.85,19.5,19.5,0,0,1,5.79,38.13L288,269H449.77c9.43,0,18.08,6.37,19.86,15.63A19.53,19.53,0,0,1,450.5,308h-104a6.5,6.5,0,0,0,0,13H475.77c9.43,0,18.08,6.37,19.86,15.63A19.53,19.53,0,0,1,476.5,360ZM496,224a32,32,0,1,1,32-32A32,32,0,0,1,496,224Z"
  ]
};
export const faHandshake = {
  prefix: "far",
  iconName: "handshake",
  icon: [
    640,
    512,
    [],
    "f2b5",
    "M519.2 127.9l-47.6-47.6A56.252 56.252 0 0 0 432 64H205.2c-14.8 0-29.1 5.9-39.6 16.3L118 127.9H0v255.7h64c17.6 0 31.8-14.2 31.9-31.7h9.1l84.6 76.4c30.9 25.1 73.8 25.7 105.6 3.8 12.5 10.8 26 15.9 41.1 15.9 18.2 0 35.3-7.4 48.8-24 22.1 8.7 48.2 2.6 64-16.8l26.2-32.3c5.6-6.9 9.1-14.8 10.9-23h57.9c.1 17.5 14.4 31.7 31.9 31.7h64V127.9H519.2zM48 351.6c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16c0 8.9-7.2 16-16 16zm390-6.9l-26.1 32.2c-2.8 3.4-7.8 4-11.3 1.2l-23.9-19.4-30 36.5c-6 7.3-15 4.8-18 2.4l-36.8-31.5-15.6 19.2c-13.9 17.1-39.2 19.7-55.3 6.6l-97.3-88H96V175.8h41.9l61.7-61.6c2-.8 3.7-1.5 5.7-2.3H262l-38.7 35.5c-29.4 26.9-31.1 72.3-4.4 101.3 14.8 16.2 61.2 41.2 101.5 4.4l8.2-7.5 108.2 87.8c3.4 2.8 3.9 7.9 1.2 11.3zm106-40.8h-69.2c-2.3-2.8-4.9-5.4-7.7-7.7l-102.7-83.4 12.5-11.4c6.5-6 7-16.1 1-22.6L367 167.1c-6-6.5-16.1-6.9-22.6-1l-55.2 50.6c-9.5 8.7-25.7 9.4-34.6 0-9.3-9.9-8.5-25.1 1.2-33.9l65.6-60.1c7.4-6.8 17-10.5 27-10.5l83.7-.2c2.1 0 4.1.8 5.5 2.3l61.7 61.6H544v128zm48 47.7c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16c0 8.9-7.2 16-16 16z"
  ]
};
export const faHandshakeAlt = {
  prefix: "far",
  iconName: "handshake-alt",
  icon: [
    640,
    512,
    [],
    "f4c6",
    "M255.7 182.7l65.6-60.1c7.4-6.8 17-10.5 27-10.5l83.7-.2c2.1 0 4.1.8 5.5 2.3l61.7 61.6H624c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16H519.2l-47.6-47.6C461.1 69.9 446.9 64 432 64H205.2c-14.8 0-29.1 5.9-39.6 16.3L118 127.9H16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h121.9l61.7-61.6c2-.8 3.7-1.5 5.7-2.3H262l-38.7 35.5c-29.4 26.9-31.1 72.3-4.4 101.3 14.8 16.2 61.2 41.2 101.5 4.4l8.2-7.5 108.2 87.8c3.4 2.8 4 7.8 1.2 11.3L411.9 377c-2.8 3.4-7.8 4-11.3 1.2l-23.9-19.4-30 36.5c-2.2 2.7-5.4 4.4-8.9 4.8-3.5.4-7-.7-9.1-2.4l-36.8-31.5-15.6 19.2c-13.9 17.1-39.2 19.7-55.3 6.6l-97.3-88H16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h89l84.6 76.4c30.9 25.1 73.8 25.7 105.6 3.8 12.5 10.8 26 15.9 41.1 15.9 18.2 0 35.3-7.4 48.8-24 22.1 8.7 48.2 2.6 64-16.8l26.2-32.3c5.6-6.9 9.1-14.8 10.9-23H624c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16H474.8c-2.3-2.8-4.9-5.4-7.7-7.7l-102.7-83.4 12.5-11.4c6.5-6 7-16.1 1-22.6L367 167.1c-6-6.5-16.1-6.9-22.6-1l-55.2 50.6c-9.5 8.7-25.7 9.4-34.6 0-9.4-9.9-8.5-25.2 1.1-34z"
  ]
};
export const faHandshakeAltSlash = {
  prefix: "far",
  iconName: "handshake-alt-slash",
  icon: [
    640,
    512,
    [],
    "e05f",
    "M16,175.91h84.67l-61.4-48H16a16,16,0,0,0-16,16v16A16,16,0,0,0,16,175.91ZM346.7,395.3a13.36,13.36,0,0,1-8.9,4.8,12.76,12.76,0,0,1-9.1-2.39l-36.79-31.5-15.61,19.2C262.41,402.5,237.09,405.1,221,392l-97.3-88H16A16.05,16.05,0,0,0,0,320v16a16,16,0,0,0,16,16h89l84.59,76.41c30.91,25.09,73.82,25.69,105.61,3.79,12.5,10.8,26,15.9,41.1,15.9,18.2,0,35.29-7.4,48.79-24a56.09,56.09,0,0,0,35.28,1.75l-60.14-47Zm31.21-216.39L367,167.1a16.07,16.07,0,0,0-22.59-1l-10.36,9.5,38.37,30,4.49-4.1A16,16,0,0,0,377.91,178.91ZM624,304H498.3l61.4,48H624a16,16,0,0,0,16-16V320A16.05,16.05,0,0,0,624,304Zm0-176.2H519.2L471.59,80.21A56.54,56.54,0,0,0,432,64H205.2a56.09,56.09,0,0,0-12.07,1.42L296,145.82,321.3,122.6a39.79,39.79,0,0,1,27-10.5l83.7-.19a7.5,7.5,0,0,1,5.5,2.3l61.7,61.59H624a16,16,0,0,0,16-16v-16A16.05,16.05,0,0,0,624,127.8ZM36,3.52A16,16,0,0,0,13.51,6l-10,12.49A16,16,0,0,0,6,41L604,508.48A16,16,0,0,0,626.48,506l10-12.49A16,16,0,0,0,634,471Z"
  ]
};
export const faHandshakeSlash = {
  prefix: "far",
  iconName: "handshake-slash",
  icon: [
    640,
    512,
    [],
    "e060",
    "M346.7,395.21c-6,7.29-15,4.79-18,2.39l-36.79-31.5L276.3,385.3c-13.89,17.11-39.21,19.7-55.3,6.61l-97.3-88H96V175.8h4.53L39.27,127.91H0V383.6H64a31.89,31.89,0,0,0,31.91-31.69H105l84.59,76.39c30.91,25.11,73.82,25.7,105.61,3.8,12.5,10.81,26,15.9,41.1,15.9,18.2,0,35.29-7.4,48.79-24a56,56,0,0,0,35.2,1.78l-60.1-47ZM48,351.6a16,16,0,1,1,16-16A16,16,0,0,1,48,351.6ZM377.91,178.8,367,167.1a16.07,16.07,0,0,0-22.59-1L334,175.6l38.32,30,4.55-4.14A16,16,0,0,0,377.91,178.8ZM519.2,127.91,471.59,80.3C462.52,71.3,444.78,64,432,64H205.2a56.09,56.09,0,0,0-12.07,1.42l102.94,80.48,25.34-23.2a39.77,39.77,0,0,1,27-10.5l83.68-.2a7.43,7.43,0,0,1,5.5,2.29l61.71,61.61H544v128H498.18L600.11,383.6H640V127.91ZM592,351.6a16,16,0,1,1,16-16A16,16,0,0,1,592,351.6ZM36,3.52A16,16,0,0,0,13.51,6l-10,12.49A16,16,0,0,0,6,41L604,508.48A16,16,0,0,0,626.48,506l10-12.49A16,16,0,0,0,634,471Z"
  ]
};
export const faHanukiah = {
  prefix: "far",
  iconName: "hanukiah",
  icon: [
    640,
    512,
    [],
    "f6e6",
    "M456 160c-4.42 0-8 3.58-8 8v128h32V168c0-4.42-3.58-8-8-8h-16zM320 80c13.25 0 24-11.94 24-26.67S320 0 320 0s-24 38.61-24 53.33S306.75 80 320 80zm224 88c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v128h32V168zm72-40c13.25 0 24-11.94 24-26.67C640 86.61 616 48 616 48s-24 38.61-24 53.33c0 14.73 10.75 26.67 24 26.67zm-224 32c-4.42 0-8 3.58-8 8v128h32V168c0-4.42-3.58-8-8-8h-16zm-288 0c-4.42 0-8 3.58-8 8v128h32V168c0-4.42-3.58-8-8-8h-16zm-80-32c13.25 0 24-11.94 24-26.67C48 86.61 24 48 24 48S0 86.61 0 101.33C0 116.06 10.75 128 24 128zm600 32h-16c-8.84 0-16 7.16-16 16v118.22c0 23.07-18.71 41.78-41.78 41.78H344V128c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v208H89.78C66.71 336 48 317.29 48 294.22V176c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v118.22C0 343.8 40.2 384 89.78 384H296v80H112c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16H344v-80h206.22c49.59 0 89.78-40.2 89.78-89.78V176c0-8.84-7.16-16-16-16zm-456 0c-4.42 0-8 3.58-8 8v128h32V168c0-4.42-3.58-8-8-8h-16zm64 0c-4.42 0-8 3.58-8 8v128h32V168c0-4.42-3.58-8-8-8h-16zm-120-32c13.25 0 24-11.94 24-26.67S112 48 112 48s-24 38.61-24 53.33S98.75 128 112 128zm64 0c13.25 0 24-11.94 24-26.67S176 48 176 48s-24 38.61-24 53.33S162.75 128 176 128zm64 0c13.25 0 24-11.94 24-26.67S240 48 240 48s-24 38.61-24 53.33S226.75 128 240 128zm160 0c13.25 0 24-11.94 24-26.67S400 48 400 48s-24 38.61-24 53.33S386.75 128 400 128zm64 0c13.25 0 24-11.94 24-26.67S464 48 464 48s-24 38.61-24 53.33S450.75 128 464 128zm64 0c13.25 0 24-11.94 24-26.67S528 48 528 48s-24 38.61-24 53.33S514.75 128 528 128z"
  ]
};
export const faHardHat = {
  prefix: "far",
  iconName: "hard-hat",
  icon: [
    512,
    512,
    [],
    "f807",
    "M480 320c0-101.46-67.5-187-160-214.6V80a16 16 0 0 0-16-16h-96a16 16 0 0 0-16 16v25.4C99.49 133 32 218.54 32 320a32 32 0 0 0-32 32v64a32 32 0 0 0 32 32h448a32 32 0 0 0 32-32v-64a32 32 0 0 0-32-32zM172.16 165.29l17.78 81.27a12 12 0 0 0 11.72 9.44H212a12 12 0 0 0 12-12V112h64v132a12 12 0 0 0 12 12h10.34a12 12 0 0 0 11.72-9.44l17.78-81.27A176.14 176.14 0 0 1 432 320H80a176.14 176.14 0 0 1 92.16-154.71zM464 400H48v-32h416z"
  ]
};
export const faHashtag = {
  prefix: "far",
  iconName: "hashtag",
  icon: [
    448,
    512,
    [],
    "f292",
    "M443.524 190.109l4.286-24c1.313-7.355-4.342-14.109-11.813-14.109h-89.045l18.909-105.89c1.313-7.355-4.342-14.11-11.813-14.11h-24.38a12 12 0 0 0-11.813 9.89L298.192 152h-111.24l18.909-105.89c1.313-7.355-4.342-14.11-11.813-14.11h-24.38a12 12 0 0 0-11.813 9.89L138.192 152H44.86a12 12 0 0 0-11.813 9.891l-4.286 24C27.448 193.246 33.103 200 40.575 200h89.045l-20 112H16.289a12 12 0 0 0-11.813 9.891l-4.286 24C-1.123 353.246 4.532 360 12.003 360h89.045L82.139 465.891C80.826 473.246 86.481 480 93.953 480h24.38a12 12 0 0 0 11.813-9.891L149.808 360h111.24l-18.909 105.891c-1.313 7.355 4.342 14.109 11.813 14.109h24.38a12 12 0 0 0 11.813-9.891L309.808 360h93.331a12 12 0 0 0 11.813-9.891l4.286-24c1.313-7.355-4.342-14.109-11.813-14.109H318.38l20-112h93.331a12 12 0 0 0 11.813-9.891zM269.62 312H158.38l20-112h111.24l-20 112z"
  ]
};
export const faHatChef = {
  prefix: "far",
  iconName: "hat-chef",
  icon: [
    512,
    512,
    [],
    "f86b",
    "M416 32a95.17 95.17 0 0 0-57.73 19.74C334.93 20.5 298 0 256 0s-78.93 20.5-102.27 51.74A95.56 95.56 0 0 0 0 128c0 41.74 64 224 64 224v128a32 32 0 0 0 32 32h320a32 32 0 0 0 32-32V352s64-182.26 64-224a96 96 0 0 0-96-96zM112 464v-80h288v80zm290.74-128h-29.55L384 201.25a8 8 0 0 0-7.33-8.61l-16-1.28h-.65a8 8 0 0 0-8 7.37l-11 137.3h-69.68V200a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v136h-68.42l-11-137.3a8 8 0 0 0-8-7.37h-.65l-16 1.28a8 8 0 0 0-7.33 8.61L138.81 336h-29.55C80 252.78 48.46 149.34 48 128a47.57 47.57 0 0 1 76.72-38l38.52 29.22 28.94-38.73C207.6 59.84 230.86 48 256 48s48.4 11.84 63.82 32.47l28.94 38.73L387.28 90A47.57 47.57 0 0 1 464 127.92c-.46 21.42-32 124.86-61.26 208.08z"
  ]
};
export const faHatCowboy = {
  prefix: "far",
  iconName: "hat-cowboy",
  icon: [
    640,
    512,
    [],
    "f8c0",
    "M617.78 239.05c-24.06-11.08-43.34 4.24-49.07 11.62-1.64 2.45-17.73 25.85-57.17 48.4C495.86 198.05 462 64 392.32 64c-18.35 0-36.06 7.23-52.66 21.52-11.75 10.09-27.5 10.09-39.25 0C283.81 71.23 266.1 64 247.75 64 178.1 64 144.2 198.09 128.53 299.12c-36.85-21.06-53.26-42.81-56.4-47.35a40.82 40.82 0 0 0-49.53-13c-18.21 8.1-27 27.85-20.42 45.93C5.28 292.87 79.16 480 320 480s314.79-187.13 317.82-195.1c6.55-17.99-2.09-37.61-20.04-45.85zm-370-127c6.53 0 13.72 3.33 21.35 9.89 30 25.83 71.9 25.81 101.87 0 7.63-6.58 14.82-9.91 21.35-9.91 18.19 0 44.6 57.37 63.46 148.85-78.15 35.67-186.45 38.81-271.49 0C203.15 169.37 229.56 112 247.75 112zM320 432c-135.81 0-209.67-67.5-245.16-115.87 41.5 27 117.19 58.27 245.16 58.27s204-31.73 245.31-58.54C529.85 364.36 456 432 320 432z"
  ]
};
export const faHatCowboySide = {
  prefix: "far",
  iconName: "hat-cowboy-side",
  icon: [
    640,
    512,
    [],
    "f8c1",
    "M483.88 230l-18.54-101a78.2 78.2 0 0 0-93.25-63.26l-161.78 34.33a77.94 77.94 0 0 0-61.47 68L142 228.25C74.23 243.76 19.9 303.83 1.86 387.88c-4.65 21.7-.5 44.39 11.44 62.28C26 469.12 45.4 480 66.58 480h492.7A80.83 80.83 0 0 0 640 399.27c0-40.81-38.51-143.56-156.12-169.27zM66.58 432c-10.86 0-21.7-15.95-17.78-34 16.2-75.38 67.54-126 127.85-126 26.47 0 52.22 9.44 73.87 26.73l91 78.46c24.59 21.19 46.81 39.62 69.37 54.81zm245-144l-30.37-26.17a167.25 167.25 0 0 0-90.55-36.61l5.93-51.9A30.07 30.07 0 0 1 220.27 147L382 112.71a30.13 30.13 0 0 1 36.06 24.67L445.71 288zm250.25 143.48a269.19 269.19 0 0 1-41.77-4.26l-26.52-144.53C572.85 309.9 592 382.34 592 399.27c0 17.14-13.39 30.84-30.17 32.21z"
  ]
};
export const faHatSanta = {
  prefix: "far",
  iconName: "hat-santa",
  icon: [
    640,
    512,
    [],
    "f7a7",
    "M627 178.3c-1.5-13.2-7.4-25.9-17.4-35.9-9.7-9.7-22.2-15.8-35.8-17.3-10.5-8.3-23.6-13.1-37.8-13.1s-27.3 4.8-37.8 13.1c-.1 0-.2.1-.4.1C426.3 59 379.8 32 305.4 32h-.2c-72.8.1-138.4 45-167.4 114.4L58.8 336H32c-17.7 0-32 16.1-32 36v72c0 19.9 14.3 36 32 36h448c17.7 0 32-16.1 32-36v-72c0-19.9-14.3-36-32-36h-29.6l-62.8-112.8 51.8 20.3c1.8 3.5 3.2 7.1 5.6 10.2 1.5 13.2 7.4 25.9 17.4 35.9 9.8 9.8 22.4 15.9 36 17.5 10.4 8.2 23.5 12.9 37.5 12.9s27.1-4.7 37.5-12.9c13.6-1.6 26.2-7.7 36-17.5 10-10 15.9-22.6 17.4-35.8 8.3-10.4 13-23.6 13-37.7s-4.6-27.3-12.8-37.8zM464 384v48H48v-48h416zM335.4 227.9L395.5 336H110.8l71.3-171.2C203.5 113.3 251.8 80 305.2 80h.1c54.4 0 89.5 17.1 150.3 72-5.5 8.1-9.6 16.9-10.7 26.4-3.1 3.9-5.1 8.5-7.2 13l-52.5-20.6c-4.8-1.9-9.8-2.8-14.8-2.8-14.2 0-27.5 7.7-34.8 20-7.1 12.3-7.3 27.3-.2 39.9zm246.9.6l-9.5 2.8 4.7 8.7c2.9 5.3 2.1 11.6-2 15.6-2.5 2.5-5.9 3.9-9.4 3.9-1.8 0-3.8-.6-6.2-1.9l-8.7-4.7-2.8 9.5c-1.7 5.8-6.7 9.7-12.5 9.7s-10.8-3.9-12.5-9.7l-2.8-9.5-8.7 4.7c-2.4 1.3-4.4 1.9-6.2 1.9-3.6 0-6.9-1.4-9.4-3.9-4.1-4.1-4.9-10.3-2-15.6l4.7-8.7-9.5-2.8c-5.8-1.7-9.7-6.7-9.7-12.5s3.9-10.8 9.7-12.5l9.5-2.8-4.7-8.7c-2.9-5.3-2.1-11.6 2-15.6 2.4-2.4 5.6-3.7 9-3.7 2.3 0 4.6.6 6.7 1.7l8.7 4.7 2.8-9.5c1.7-5.8 6.7-9.7 12.5-9.7s10.8 3.9 12.5 9.7l2.8 9.5 8.7-4.7c2.1-1.1 4.4-1.7 6.7-1.7 3.4 0 6.6 1.3 9 3.7 4.1 4.1 4.9 10.3 2 15.6l-4.7 8.7 9.5 2.8c5.8 1.7 9.7 6.7 9.7 12.5s-4.1 10.8-9.9 12.5z"
  ]
};
export const faHatWinter = {
  prefix: "far",
  iconName: "hat-winter",
  icon: [
    512,
    512,
    [],
    "f7a8",
    "M480 416H32c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32v-32c0-17.7-14.3-32-32-32zM195.2 105.2c-5.5 10.1-4.4 22.8 4.2 31.4 5.2 5.2 12 7.8 18.9 7.8 4.4 0 8.6-1.5 12.5-3.6 3.3 11 13.1 19.2 25.2 19.2s21.9-8.2 25.2-19.2c4 2.1 8.2 3.6 12.5 3.6 6.8 0 13.6-2.6 18.9-7.8 8.6-8.6 9.7-21.3 4.2-31.4 11-3.3 19.2-13.1 19.2-25.2s-8.2-21.9-19.2-25.2c5.5-10.1 4.4-22.8-4.2-31.4s-21.3-9.7-31.4-4.2C277.9 8.2 268.1 0 256 0s-21.9 8.2-25.2 19.2c-10.1-5.5-22.8-4.4-31.4 4.2s-9.7 21.3-4.2 31.4C184.2 58.1 176 67.9 176 80s8.2 21.9 19.2 25.2zM85.9 335.9l42.1-21.1 64 32 64-32 64 32 64-32 42.1 21.1c5.5 26.4 5.9 45.6 5.9 48.1h48c0-2-2.3-165.5-131.9-244.9-2.8 7.3-7.1 14.2-13 20.1-6.6 6.6-14.6 11.2-23.2 14 46.8 24.6 75.2 61.8 92.6 98.2L384 261.2l-64 32-64-32-64 32-64-32-20.6 10.3c17.4-36.4 45.8-73.6 92.6-98.2-8.6-2.8-16.6-7.4-23.2-14-5.9-5.9-10.1-12.7-12.9-20.1C34.3 218.5 32 382 32 384h48c0-2.5.4-21.7 5.9-48.1z"
  ]
};
export const faHatWitch = {
  prefix: "far",
  iconName: "hat-witch",
  icon: [
    576,
    512,
    [],
    "f6e7",
    "M572 433.06l-10.47-11.86c-5.57-6.31-14.94-6.85-21.65-1.76-10.95 8.32-22.75 15.26-34.96 21.38L408.2 223.85c-4.54-10.61-5.05-22.71-1.33-33.87l6.35-19.04A15.982 15.982 0 0 1 428.4 160h39.2c6.9 0 13 4.4 15.18 10.94l14.04 42.12 13.94 41.82 16.13-41.03 30.36-77.24c6.07-18.15 1.63-36.97-11.31-49.91l-69.08-72.38C467.53 4.99 455.47 0 442.64 0c-8.33 0-16.56 2.19-23.8 6.32L252.01 109.58c-26.33 15.03-47.13 38.04-59.67 66.26L71.48 441c-12.35-6.16-24.29-13.15-35.37-21.56-6.71-5.1-16.07-4.55-21.65 1.76L4 433.06c-5.92 6.71-5.25 17.25 1.85 22.71C53.08 492.14 111.35 512 171.63 512h232.75c60.28 0 118.54-19.86 165.77-56.23 7.09-5.47 7.77-16 1.85-22.71zm-364 31.82h-36.37c-18.73 0-37.01-3.02-54.85-7.51L135.63 416H208v48.88zm112-.88h-64v-64h64v64zm10-112h-84c-12.59 0-23.22 6.55-30.14 16h-58.35l78.7-172.67c8.36-18.81 22.23-34.15 41.07-44.94L442.65 48.01l69.32 72.6-2.68 6.81A63.876 63.876 0 0 0 467.6 112h-39.2a63.913 63.913 0 0 0-60.71 43.76l-6.35 19.04c-7.44 22.33-6.44 46.54 3.02 68.6L419.91 368h-59.77c-6.92-9.45-17.55-16-30.14-16zm74.37 112.88H368V416h73.3l18.39 41.25c-17.99 4.57-36.42 7.63-55.32 7.63z"
  ]
};
export const faHatWizard = {
  prefix: "far",
  iconName: "hat-wizard",
  icon: [
    512,
    512,
    [],
    "f6e8",
    "M496 464h-35.5l-81.32-200.17c-7.21-17.73-7.99-37.64-2.21-55.94L442.67 0 223.83 131.92c-27.61 16.64-49.46 42.15-62.37 72.8L52.22 464H16c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16zm-256 0l10.67-21.33L304 416l-53.33-26.67L224 336l-26.67 53.33L144 416l53.33 26.67L208 464H104.31l101.38-240.64c.99-2.36 2.34-4.5 3.49-6.77L224 224l16 32 16-32 32-16-32-16-8.93-17.86c.53-.34 1-.79 1.54-1.11l110-66.31-27.4 86.71c-9.15 28.96-7.91 60.38 3.51 88.47l6.86 16.89L320 288l-16-32-16 32-32 16 32 16 16 32 16-32 25.09-12.55L408.69 464H240z"
  ]
};
export const faHdd = {
  prefix: "far",
  iconName: "hdd",
  icon: [
    576,
    512,
    [],
    "f0a0",
    "M567.403 235.642L462.323 84.589A48 48 0 0 0 422.919 64H153.081a48 48 0 0 0-39.404 20.589L8.597 235.642A48.001 48.001 0 0 0 0 263.054V400c0 26.51 21.49 48 48 48h480c26.51 0 48-21.49 48-48V263.054c0-9.801-3-19.366-8.597-27.412zM153.081 112h269.838l77.913 112H75.168l77.913-112zM528 400H48V272h480v128zm-32-64c0 17.673-14.327 32-32 32s-32-14.327-32-32 14.327-32 32-32 32 14.327 32 32zm-96 0c0 17.673-14.327 32-32 32s-32-14.327-32-32 14.327-32 32-32 32 14.327 32 32z"
  ]
};
export const faHeadSide = {
  prefix: "far",
  iconName: "head-side",
  icon: [
    512,
    512,
    [],
    "f6e9",
    "M352 192c0-17.67-14.33-32-32-32s-32 14.33-32 32 14.33 32 32 32 32-14.33 32-32zm157.21 83c-20.94-47.12-48.44-151.73-73.08-186.75C397.68 33.6 334.56 0 266.09 0h-66.08C95.47 0 4.12 80.08.14 184.55-2.13 244.33 23.1 298.14 64 334.82V496c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V313.39l-15.95-14.31c-46.94-42.1-63.11-111.72-32.19-172.5C89.2 76.78 143.11 48 198.99 48h67.1c51.99 0 100.88 25.37 130.78 67.87 11.2 15.91 28.06 65.67 40.38 102 6.55 19.32 12.86 37.92 18.97 54.13H400v112c0 8.84-7.16 16-16 16h-80v96c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-48h32c35.35 0 64-28.65 64-64v-64h31.96c23.16 0 38.65-23.84 29.25-45z"
  ]
};
export const faHeadSideBrain = {
  prefix: "far",
  iconName: "head-side-brain",
  icon: [
    512,
    512,
    [],
    "f808",
    "M509.21 275c-20.94-47.12-48.44-151.73-73.08-186.75A207.94 207.94 0 0 0 266.09 0H200C95.47 0 4.12 80.08.14 184.55A191.3 191.3 0 0 0 64 334.82V496a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16V313.39l-16-14.31C49.11 257 32.94 187.36 63.86 126.58 89.2 76.78 143.11 48 199 48h67.1a160.06 160.06 0 0 1 130.78 67.87c11.2 15.91 28.06 65.67 40.38 102 6.55 19.32 12.86 37.92 19 54.13H400v112a16 16 0 0 1-16 16h-80v96a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-48h32a64 64 0 0 0 64-64v-64h32a32 32 0 0 0 29.21-45zM313.6 192c21.21 0 38.4-16.48 38.4-36.8s-17.19-36.8-38.4-36.8H311a38.09 38.09 0 0 0-35.8-25.6c-7.1 0-13.38 2.45-19.08 5.81C249.35 87.68 237.8 80 224 80s-25.34 7.68-32.11 18.61c-5.71-3.36-12-5.81-19.09-5.81a38.4 38.4 0 0 0-38.4 38.4A38.4 38.4 0 0 0 96 169.6c0 16.84 11 30.74 26.11 35.92-.06.86-.51 1.6-.51 2.48a38.4 38.4 0 0 0 38.4 38.4 37.91 37.91 0 0 0 12.8-2.58V288H224v-44.18a37.91 37.91 0 0 0 12.8 2.58 38.4 38.4 0 0 0 38.4-38.4 37.84 37.84 0 0 0-3.73-16z"
  ]
};
export const faHeadSideCough = {
  prefix: "far",
  iconName: "head-side-cough",
  icon: [
    640,
    512,
    [],
    "e061",
    "M320,224a32,32,0,1,0-32-32A32,32,0,0,0,320,224Zm189.2,51c-20.93-47.13-48.43-151.73-73.07-186.75A207.9,207.9,0,0,0,266.09,0H198.17C93.66,0,3.67,80.86.11,185.3A191.31,191.31,0,0,0,64,334.81V496a16,16,0,0,0,16,16H96a16,16,0,0,0,16-16V313.39l-16-14.31c-46.6-41.79-62.88-110.71-32.86-171.17C88.2,77.53,142.07,48,198.32,48h67.77a160.1,160.1,0,0,1,130.79,67.87c11.18,15.91,28.06,65.68,40.37,102,6.55,19.32,12.86,37.93,19,54.13H400v48H347.17c-30.32,0-57.5,22.71-59.09,53A56,56,0,0,0,344,432h56v16a16,16,0,0,1-16,16H304v48h80a64,64,0,0,0,64-64V408a16,16,0,0,0-16-16H344a16,16,0,0,1,0-32h88a16,16,0,0,0,16-16V320H480A32,32,0,0,0,509.2,275ZM616,360a24,24,0,1,0,24,24A24,24,0,0,0,616,360Zm0,104a24,24,0,1,0,24,24A24,24,0,0,0,616,464Zm0-160a24,24,0,1,0-24-24A24,24,0,0,0,616,304Zm-64,16a24,24,0,1,0,24,24A24,24,0,0,0,552,320Zm0,96a24,24,0,1,0,24,24A24,24,0,0,0,552,416Zm-64-56a24,24,0,1,0,24,24A24,24,0,0,0,488,360Z"
  ]
};
export const faHeadSideCoughSlash = {
  prefix: "far",
  iconName: "head-side-cough-slash",
  icon: [
    640,
    512,
    [],
    "e062",
    "M448,325.61V320H480a32,32,0,0,0,29.25-45c-20.93-47.12-48.43-151.73-73.07-186.75A207.9,207.9,0,0,0,266.09,0H198.17A201.1,201.1,0,0,0,80.5,38.31L36,3.52A16,16,0,0,0,13.51,6l-10,12.49A16,16,0,0,0,6,41L531.61,451.9l13.77,10.76-10.52-8.22,63.65,49.76,1.41,1.1,1.52,1.18,1,.77h0l1.58,1.24a15.58,15.58,0,0,0,3.14,1.62,14,14,0,0,1-2.07-1.07h0a14.19,14.19,0,0,0,2.29,1.18A15.73,15.73,0,0,0,626.48,506l10-12.48A16,16,0,0,0,634,471Zm-48-37.52-82.66-64.63c.92.08,1.72.54,2.66.54a32,32,0,1,0-32-32,31.13,31.13,0,0,0,2.05,10.13L120,69.2A156.89,156.89,0,0,1,198.32,48h67.77a160.11,160.11,0,0,1,130.79,67.88c11.18,15.9,28.06,65.67,40.37,102,6.55,19.31,12.86,37.92,19,54.12H400ZM552,368a24,24,0,1,0-24-24A24,24,0,0,0,552,368Zm64-64a24,24,0,1,0-24-24A24,24,0,0,0,616,304ZM344,392a16,16,0,0,1,0-32h18.11l-42.46-33.2c-17.57,8.86-30.5,25.69-31.57,46.19A56,56,0,0,0,344,432h56v16a16,16,0,0,1-16,16H304v48h80a64,64,0,0,0,64-64V427.15L403,392ZM63.19,127.91c.19-.39.46-.71.65-1.09L26,97.2A184.69,184.69,0,0,0,.11,185.3,191.29,191.29,0,0,0,64,334.81V496a16,16,0,0,0,16,16H96a16,16,0,0,0,16-16V313.39l-16-14.31C49.45,257.29,33.17,188.37,63.19,127.91ZM616,360a24,24,0,1,0,24,24A24,24,0,0,0,616,360Z"
  ]
};
export const faHeadSideHeadphones = {
  prefix: "far",
  iconName: "head-side-headphones",
  icon: [
    512,
    512,
    [],
    "f8c2",
    "M509.21 275c-20.94-47.12-48.44-151.73-73.09-186.75A207.88 207.88 0 0 0 266.09 0H200C95.48 0 4.14 80.08.14 184.55A191.34 191.34 0 0 0 64 334.81V496a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16V313.39l-15.93-14.31C49.14 257 33 187.36 63.89 126.58 88.13 78.88 138.68 50.76 192 48.45v52.75c-46.15 13.8-80 56.14-80 106.8a112 112 0 1 0 224 0c0-50.66-33.85-93-80-106.8V48h10.09a160.07 160.07 0 0 1 130.78 67.88c11.19 15.9 28.06 65.67 40.37 102 6.56 19.31 12.88 37.92 19 54.12H400v112a16 16 0 0 1-16 16h-80v96a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-48h32a64 64 0 0 0 64-64v-64h32a32 32 0 0 0 29.21-45zM288 208a64 64 0 1 1-64-64 64.07 64.07 0 0 1 64 64zm-96 0a32 32 0 1 0 32-32 32 32 0 0 0-32 32z"
  ]
};
export const faHeadSideMask = {
  prefix: "far",
  iconName: "head-side-mask",
  icon: [
    512,
    512,
    [],
    "e063",
    "M320.06,160a32,32,0,1,0,32,32A32,32,0,0,0,320.06,160ZM509.29,275c-20.94-47.12-48.44-151.73-73.09-186.75A207.93,207.93,0,0,0,266.14,0H198.2C93.68,0,3.67,80.86.11,185.31A191.26,191.26,0,0,0,64,334.81V496a16,16,0,0,0,16,16H96a16,16,0,0,0,16-16V313.39l-16-14.31a144.19,144.19,0,0,1-47.64-98.94L224,319.29V480a32,32,0,0,0,32,32h115a88.21,88.21,0,0,0,82.81-58.2l54.6-151.63A31.4,31.4,0,0,0,509.29,275Zm-69.76,77H336.06a16,16,0,1,0,0,32H428l-11.52,32H336.06a16,16,0,1,0,0,32H403a40.09,40.09,0,0,1-31.92,16h-99V320h179Zm-199.7-80L55.62,147a146.1,146.1,0,0,1,7.58-19.12C88.22,77.53,142.1,48,198.36,48h67.78a160.12,160.12,0,0,1,130.8,67.88c11.19,15.9,28.07,65.67,40.39,102,6.54,19.31,12.86,37.92,19,54.12Z"
  ]
};
export const faHeadSideMedical = {
  prefix: "far",
  iconName: "head-side-medical",
  icon: [
    512,
    512,
    [],
    "f809",
    "M336 216v-48a8 8 0 0 0-8-8h-56v-56a8 8 0 0 0-8-8h-48a8 8 0 0 0-8 8v56h-56a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8h56v56a8 8 0 0 0 8 8h48a8 8 0 0 0 8-8v-56h56a8 8 0 0 0 8-8zm173.21 59c-20.94-47.12-48.44-151.73-73.08-186.75A207.94 207.94 0 0 0 266.09 0H200C95.47 0 4.12 80.08.14 184.55A191.3 191.3 0 0 0 64 334.82V496a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16V313.39l-16-14.31C49.11 257 32.94 187.36 63.86 126.58 89.2 76.78 143.11 48 199 48h67.1a160.06 160.06 0 0 1 130.78 67.87c11.2 15.91 28.06 65.67 40.38 102 6.55 19.32 12.86 37.92 19 54.13H400v112a16 16 0 0 1-16 16h-80v96a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-48h32a64 64 0 0 0 64-64v-64h32a32 32 0 0 0 29.21-45z"
  ]
};
export const faHeadSideVirus = {
  prefix: "far",
  iconName: "head-side-virus",
  icon: [
    512,
    512,
    [],
    "e064",
    "M126.2,238.2H137c25.3,0,38,30.6,20.1,48.6l-7.6,7.6c-5.6,5.5-5.6,14.5-0.1,20.1c5.5,5.6,14.6,5.5,20.2,0l7.6-7.6 c17.9-17.9,48.6-5.2,48.6,20.1v10.8c0,7.9,6.4,14.2,14.2,14.2s14.2-6.4,14.2-14.2V327c0-25.3,30.6-38,48.6-20.1l7.6,7.6 c2.7,2.7,6.3,4.2,10.1,4.2c7.9,0,14.2-6.4,14.2-14.3c0-3.8-1.5-7.4-4.2-10l-7.6-7.6c-17.9-17.9-5.2-48.6,20.1-48.6h10.8 c7.9,0,14.2-6.4,14.2-14.2s-6.4-14.2-14.2-14.2H343c-25.3,0-38-30.6-20.1-48.6l7.6-7.6c5.6-5.6,5.6-14.6,0-20.1s-14.6-5.6-20.1,0 l-7.6,7.6c-17.9,17.9-48.6,5.2-48.6-20.1v-10.8c0-7.9-6.4-14.2-14.2-14.2s-14.2,6.4-14.2,14.2V121c0,25.3-30.6,38-48.6,20.1 l-7.6-7.6c-5.6-5.6-14.6-5.6-20.1,0c-5.6,5.6-5.6,14.6,0,20.1l7.6,7.6c17.9,17.9,5.2,48.6-20.1,48.6h-10.8 c-7.9,0-14.2,6.4-14.2,14.2S118.4,238.2,126.2,238.2z M208,224c-8.8,0-16-7.2-16-16s7.2-16,16-16s16,7.2,16,16S216.8,224,208,224z M272,256c-8.8,0-16-7.2-16-16s7.2-16,16-16s16,7.2,16,16S280.8,256,272,256z M509.2,275c-20.9-47.1-48.4-151.7-73.1-186.8 C397.2,32.9,333.8,0,266.1,0H200C95.5,0,4.1,80.1,0.1,184.6C-2.1,241.7,21.3,296.8,64,334.8V496c0,8.8,7.2,16,16,16h16 c8.8,0,16-7.2,16-16V313.4l-16-14.3C49.1,257,32.9,187.4,63.9,126.6C89.2,76.8,143.1,48,199,48h67.1c52,0,100.8,25.3,130.8,67.9 c11.2,15.9,28.1,65.7,40.4,102c6.5,19.3,12.9,37.9,19,54.1H400v112c0,8.8-7.2,16-16,16h-80v96c0,8.8,7.2,16,16,16h16 c8.8,0,16-7.2,16-16v-48h32c35.3,0,64-28.7,64-64v-64h32c17.7,0,32-14.4,32-32C512,283.5,511,279.1,509.2,275z"
  ]
};
export const faHeadVr = {
  prefix: "far",
  iconName: "head-vr",
  icon: [
    512,
    512,
    [],
    "f6ea",
    "M398.34 48C361.82 17.72 315.46 0 266.09 0h-66.08C134.87 0 75.11 31.29 38.16 80H32C14.33 80 0 94.33 0 112v64c0 17.67 14.33 32 32 32h184c.27 0 .42-.26.68-.28C234.26 227.38 259.55 240 288 240h192c17.67 0 32-14.33 32-32V80c0-17.67-14.33-32-32-32h-81.66zM193.61 160H48v-32h145.61c-.88 5.23-1.61 10.52-1.61 16s.73 10.77 1.61 16zM216 80H104.07c26.77-20.36 60.23-32 94.92-32h67.1c4.66 0 9.26.4 13.86.81-25.14 2.12-47.39 13.71-63.27 31.47-.26-.02-.41-.28-.68-.28zm168 112h-96c-26.47 0-48-21.53-48-48s21.53-48 48-48h96v96zm80 0h-32V96h32v96zM56.5 240H6.39c9.64 37.12 29.89 69.96 57.61 94.82V496c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V313.39l-15.95-14.31C77.91 282.82 64.51 262.39 56.5 240zm451.49 32H400v112c0 8.84-7.16 16-16 16h-80v96c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-48h32c35.35 0 64-28.65 64-64v-64h31.96c23.16 0 38.65-23.84 29.24-45-.39-.88-.82-2.08-1.21-3z"
  ]
};
export const faHeading = {
  prefix: "far",
  iconName: "heading",
  icon: [
    512,
    512,
    [],
    "f1dc",
    "M432 80v352h32a16 16 0 0 1 16 16v16a16 16 0 0 1-16 16H336a16 16 0 0 1-16-16v-16a16 16 0 0 1 16-16h32V280H144v152h32a16 16 0 0 1 16 16v16a16 16 0 0 1-16 16H48a16 16 0 0 1-16-16v-16a16 16 0 0 1 16-16h32V80H48a16 16 0 0 1-16-16V48a16 16 0 0 1 16-16h128a16 16 0 0 1 16 16v16a16 16 0 0 1-16 16h-32v152h224V80h-32a16 16 0 0 1-16-16V48a16 16 0 0 1 16-16h128a16 16 0 0 1 16 16v16a16 16 0 0 1-16 16z"
  ]
};
export const faHeadphones = {
  prefix: "far",
  iconName: "headphones",
  icon: [
    512,
    512,
    [],
    "f025",
    "M256 32C114.52 32 0 146.497 0 288v49.714a24.001 24.001 0 0 0 12.319 20.966l19.702 10.977C32.908 430.748 82.698 480 144 480h24c13.255 0 24-10.745 24-24V280c0-13.255-10.745-24-24-24h-24c-40.744 0-76.402 21.758-96 54.287V288c0-114.691 93.309-208 208-208s208 93.309 208 208v22.287C444.402 277.758 408.744 256 368 256h-24c-13.255 0-24 10.745-24 24v176c0 13.255 10.745 24 24 24h24c61.302 0 111.092-49.252 111.979-110.344l19.702-10.977A24.001 24.001 0 0 0 512 337.713V288c0-141.48-114.497-256-256-256zM144 304v128c-35.29 0-64-28.71-64-64s28.71-64 64-64zm224 128V304c35.29 0 64 28.71 64 64s-28.71 64-64 64z"
  ]
};
export const faHeadphonesAlt = {
  prefix: "far",
  iconName: "headphones-alt",
  icon: [
    512,
    512,
    [],
    "f58f",
    "M192 288h-48c-35.35 0-64 28.7-64 64.12v63.76c0 35.41 28.65 64.12 64 64.12h48c17.67 0 32-14.36 32-32.06V320.06c0-17.71-14.33-32.06-32-32.06zm-16 143.91h-32c-8.82 0-16-7.19-16-16.03v-63.76c0-8.84 7.18-16.03 16-16.03h32v95.82zM256 32C112.91 32 4.57 151.13 0 288v112c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V288c0-114.67 93.33-207.8 208-207.82 114.67.02 208 93.15 208 207.82v112c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V288C507.43 151.13 399.09 32 256 32zm112 256h-48c-17.67 0-32 14.35-32 32.06v127.88c0 17.7 14.33 32.06 32 32.06h48c35.35 0 64-28.71 64-64.12v-63.76c0-35.41-28.65-64.12-64-64.12zm16 127.88c0 8.84-7.18 16.03-16 16.03h-32v-95.82h32c8.82 0 16 7.19 16 16.03v63.76z"
  ]
};
export const faHeadset = {
  prefix: "far",
  iconName: "headset",
  icon: [
    512,
    512,
    [],
    "f590",
    "M224 336V192.36c0-17.67-14.33-32-32-32h-48c-35.35 0-64 28.65-64 64V304c0 35.35 28.65 64 64 64h48c17.67 0 32-14.33 32-32zm-48-16h-32c-8.82 0-16-7.18-16-16v-79.64c0-8.82 7.18-16 16-16h32V320zM256 0C113.18 0 4.58 118.83 0 256v16c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-16c0-114.69 93.31-208 208-208s208 93.31 208 208h-.12c.08 2.43.12 165.72.12 165.72 0 23.35-18.93 42.28-42.28 42.28H320c0-26.51-21.49-48-48-48h-32c-26.51 0-48 21.49-48 48s21.49 48 48 48h181.72c49.86 0 90.28-40.42 90.28-90.28V256C507.42 118.83 398.82 0 256 0zm112 368c35.35 0 64-28.65 64-64v-79.64c0-35.35-28.65-64-64-64h-48c-17.67 0-32 14.33-32 32V336c0 17.67 14.33 32 32 32h48zm-32-159.64h32c8.82 0 16 7.18 16 16V304c0 8.82-7.18 16-16 16h-32V208.36z"
  ]
};
export const faHeart = {
  prefix: "far",
  iconName: "heart",
  icon: [
    512,
    512,
    [],
    "f004",
    "M458.4 64.3C400.6 15.7 311.3 23 256 79.3 200.7 23 111.4 15.6 53.6 64.3-21.6 127.6-10.6 230.8 43 285.5l175.4 178.7c10 10.2 23.4 15.9 37.6 15.9 14.3 0 27.6-5.6 37.6-15.8L469 285.6c53.5-54.7 64.7-157.9-10.6-221.3zm-23.6 187.5L259.4 430.5c-2.4 2.4-4.4 2.4-6.8 0L77.2 251.8c-36.5-37.2-43.9-107.6 7.3-150.7 38.9-32.7 98.9-27.8 136.5 10.5l35 35.7 35-35.7c37.8-38.5 97.8-43.2 136.5-10.6 51.1 43.1 43.5 113.9 7.3 150.8z"
  ]
};
export const faHeartBroken = {
  prefix: "far",
  iconName: "heart-broken",
  icon: [
    512,
    512,
    [],
    "f7a9",
    "M473.7 73.9l-2.4-2.5C445.5 45.1 411.6 32 377.6 32s-67.9 13.1-93.7 39.4L256 100l-27.9-28.5C202.4 45.2 168.4 32 134.4 32S66.5 45.2 40.7 71.5l-2.4 2.4C-10.4 123.7-12.5 203 31 256l212.1 218.5c3.5 3.6 8.2 5.5 12.8 5.5 4.7 0 9.3-1.8 12.8-5.5L481 256c43.5-53 41.4-132.3-7.3-182.1zM445 224.2L256 418.9 67 224.2c-27.2-34.6-24.9-85.5 5.2-116.3l2.8-2.8C90.8 88.9 111.9 80 134.4 80s43.6 8.9 59.4 25.1l26 26.6L240 192l-75.6 35.2c-4.8 2.4-5.9 8.7-2.3 12.6l86.8 88.6c5.9 6 15.8.1 13.4-7.9L240 248l76.6-52.4c3-2.1 4.2-6 2.9-9.4l-23.6-58.3 22.3-22.8C334 88.9 355.1 80 377.6 80s43.6 8.9 59 24.7l2.7 2.8c30.6 31.2 32.9 82.1 5.7 116.7z"
  ]
};
export const faHeartCircle = {
  prefix: "far",
  iconName: "heart-circle",
  icon: [
    496,
    512,
    [],
    "f4c7",
    "M361.8 162.8c-38.3-32.8-89-17.8-113.8 7.8-24.8-25.6-75.5-40.6-113.8-7.8-42.4 36.2-36.1 95.2-6 126.3l98.7 102c13 13.4 32.5 10.2 42.4 0l98.7-102c29.9-31.1 36.2-90.1-6.2-126.3zm-27.7 92.7l-86.1 89-86.1-89.1c-13-13.5-16.2-39.7 2.7-55.9 14.1-12 36.1-9 49.3 4.7l34.1 35.4 34.1-35.4c13.2-13.7 35.3-16.7 49.3-4.7 18.9 16.2 15.8 42.5 2.7 56zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200z"
  ]
};
export const faHeartRate = {
  prefix: "far",
  iconName: "heart-rate",
  icon: [
    640,
    512,
    [],
    "f5f8",
    "M624 232H480c-9.3 0-17.76 5.37-21.72 13.79l-35.78 76.04-79.28-303.89C340.47 7.36 330.91 0 320 0c-.19 0-.41 0-.62.02-11.12.28-20.62 8.2-22.88 19.12l-75.84 366.52-37.53-136.03c-2.87-10.41-12.35-17.62-23.15-17.62H16c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h125.72l59.16 214.38A23.974 23.974 0 0 0 224 512c.25 0 .53 0 .78-.02 11.09-.36 20.47-8.27 22.72-19.12l75.19-363.44 70.09 268.64c2.53 9.77 10.94 16.91 21 17.83 10.5 1.14 19.62-4.53 23.94-13.67L495.22 280H624c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16z"
  ]
};
export const faHeartSquare = {
  prefix: "far",
  iconName: "heart-square",
  icon: [
    448,
    512,
    [],
    "f4c8",
    "M325.2 160.4c-13.9-11.7-29.6-16.4-44.9-16.4-22.1 0-43.3 10-56.3 23.3-13-13.3-34.2-23.3-56.3-23.3-15.3 0-31 4.7-44.9 16.4-37.6 31.7-32.1 83.3-5.3 110.5l87.7 89.3c5.5 5.6 12.1 7.8 18.5 7.8h.6c6.4 0 13-2.2 18.5-7.8l87.7-89.3c26.7-27.2 32.3-78.8-5.3-110.5zm-28.9 76.9L224 310.9l-72.3-73.6c-4-4.1-16.4-24.7 2-40.2 13.6-11.4 31.3-1.1 36.1 3.7l34.2 34.8 34.2-34.8c4.7-4.8 22.4-15.2 36.1-3.7 18.3 15.5 5.9 36.2 2 40.2zM392 32H56C25.1 32 0 57.1 0 88v336c0 30.9 25.1 56 56 56h336c30.9 0 56-25.1 56-56V88c0-30.9-25.1-56-56-56zm8 392c0 4.4-3.6 8-8 8H56c-4.4 0-8-3.6-8-8V88c0-4.4 3.6-8 8-8h336c4.4 0 8 3.6 8 8v336z"
  ]
};
export const faHeartbeat = {
  prefix: "far",
  iconName: "heartbeat",
  icon: [
    512,
    512,
    [],
    "f21e",
    "M266.4 427.7c-5.8 5.7-15.1 5.7-20.9 0L136.7 320H68.5l143.3 141.8c24.5 24.2 63.9 24.3 88.4 0L443.5 320h-68.2L266.4 427.7zM354.7 32c-36.5 0-71 12.3-98.7 34.9C228.3 44.3 193.8 32 157.3 32 86.2 32 0 88.9 0 188c0 37.3 13.7 72.1 37.8 100h116.8l29.9-71.7 56.9 126.3c5.5 12.3 22.9 12.7 28.9.6l49.7-99.4 22.1 44.2h132c24.1-27.9 37.8-62.7 37.8-100 .1-99.1-86.1-156-157.2-156zm83.9 224h-76.7l-27.6-55.2c-5.9-11.8-22.7-11.8-28.6 0l-48.9 97.9-58.2-129.3c-5.7-12.8-24-12.5-29.4.4L133.3 256H73.4c-58.8-69.5-7-176 83.9-176 31 0 51 6.2 98.7 53.4C307.1 82.9 325.1 80 354.7 80c91.2 0 142.7 106.5 83.9 176z"
  ]
};
export const faHeat = {
  prefix: "far",
  iconName: "heat",
  icon: [
    448,
    512,
    [],
    "e00c",
    "M48,156.12V112A16,16,0,0,0,32,96H16A16,16,0,0,0,0,112v44.12A186.57,186.57,0,0,0,54.67,288.6,140.87,140.87,0,0,1,96,387.88V464a16,16,0,0,0,16,16h16a16,16,0,0,0,16-16V387.88A186.61,186.61,0,0,0,89.33,255.39,140.83,140.83,0,0,1,48,156.12Zm152,0V48a16,16,0,0,0-16-16H168a16,16,0,0,0-16,16V156.12A186.57,186.57,0,0,0,206.67,288.6,140.87,140.87,0,0,1,248,387.88V464a16,16,0,0,0,16,16h16a16,16,0,0,0,16-16V387.88a186.61,186.61,0,0,0-54.67-132.49A140.83,140.83,0,0,1,200,156.12Zm193.33,99.27A140.83,140.83,0,0,1,352,156.12V112a16,16,0,0,0-16-16H320a16,16,0,0,0-16,16v44.12A186.57,186.57,0,0,0,358.67,288.6,140.87,140.87,0,0,1,400,387.88V464a16,16,0,0,0,16,16h16a16,16,0,0,0,16-16V387.88A186.61,186.61,0,0,0,393.33,255.39Z"
  ]
};
export const faHelicopter = {
  prefix: "far",
  iconName: "helicopter",
  icon: [
    640,
    512,
    [],
    "f533",
    "M316.5 416.02h235.22c15.69 0 30.81-6.63 41.51-18.16 10.55-11.41 15.9-26.75 14.68-42.13-9.94-122.54-110.45-219.35-231.95-226.98V48h184.03c8.84 0 16-7.16 16-16V16c0-8.84-7.17-16-16-16H143.93c-8.84 0-16 7.16-16 16v16c0 8.84 7.17 16 16 16h184.03v80H148.19l-36.07-48.02C104.58 69.97 92.58 64 80.06 64H39.99C27.56 64 16.04 69.61 8.4 79.39c-7.64 9.78-10.3 22.28-7.01 35.2L36.2 233.95l164.93 65.85 70.47 93.82c10.55 14.03 27.33 22.4 44.9 22.4zm91.47-234.03c81.63 20.18 144.96 90.87 151.98 177.57.22 2.66-1 4.58-2.07 5.72-.94 1.02-3 2.73-6.17 2.73H407.97V181.99zM75.84 198.07L50.7 112h25.36l48.09 64h235.82v192.01H316.5c-2.51 0-4.92-1.19-6.42-3.2L231.5 260.23 75.84 198.07zm561.88 274.49l-22.16-22.14c-3.09-3.09-8.06-3.09-11.22-.07-7.39 7.06-16.14 13.65-30.41 13.65H239.95c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h333.98c13.41 0 31.79 0 63.16-27.47a8.564 8.564 0 0 0 2.91-6.09c.06-2.24-.75-4.33-2.28-5.88z"
  ]
};
export const faHelmetBattle = {
  prefix: "far",
  iconName: "helmet-battle",
  icon: [
    576,
    512,
    [],
    "f6eb",
    "M32.01 256C49.68 256 64 243.44 64 227.94V0L.97 221.13C-4.08 238.84 11.2 256 32.01 256zm543.02-34.87L512 0v227.94c0 15.5 14.32 28.06 31.99 28.06 20.81 0 36.09-17.16 31.04-34.87zM480 210.82C480 90.35 288 0 288 0S96 90.35 96 210.82c0 82.76-22.86 145.9-31.13 180.71-3.43 14.43 3.59 29.37 16.32 35.24l161.54 78.76a64.01 64.01 0 0 0 28.05 6.47h34.46c9.72 0 19.31-2.21 28.05-6.47l161.54-78.76c12.73-5.87 19.75-20.81 16.32-35.24-8.29-34.81-31.15-97.95-31.15-180.71zM312 462.5V288l88-32v-32H176v32l88 32v174.5l-149.12-72.69c.77-2.82 1.58-5.77 2.43-8.86 10.63-38.59 26.69-96.9 26.69-170.13 0-63.44 91.88-127.71 144-156.76 52.12 29.05 144 93.32 144 156.76 0 73.23 16.06 131.54 26.69 170.12.85 3.08 1.66 6.04 2.43 8.85L312 462.5z"
  ]
};
export const faHexagon = {
  prefix: "far",
  iconName: "hexagon",
  icon: [
    576,
    512,
    [],
    "f312",
    "M441.5 39.8C432.9 25.1 417.1 16 400 16H176c-17.1 0-32.9 9.1-41.5 23.8l-112 192c-8.7 14.9-8.7 33.4 0 48.4l112 192c8.6 14.7 24.4 23.8 41.5 23.8h224c17.1 0 32.9-9.1 41.5-23.8l112-192c8.7-14.9 8.7-33.4 0-48.4l-112-192zM400 448H176L64 256 176 64h224l112 192-112 192z"
  ]
};
export const faHighlighter = {
  prefix: "far",
  iconName: "highlighter",
  icon: [
    544,
    512,
    [],
    "f591",
    "M0 479.98L99.88 512l35.56-35.58-67.01-67.04L0 479.98zM527.93 79.27l-63.17-63.2C454.09 5.39 440.04 0 425.97 0c-12.93 0-25.88 4.55-36.28 13.73L124.8 239.96a36.598 36.598 0 0 0-10.79 38.1l13.05 42.83-33.95 33.97c-9.37 9.37-9.37 24.56 0 33.93l62.26 62.29c9.37 9.38 24.58 9.38 33.95 0l33.86-33.88 42.72 13.08a36.54 36.54 0 0 0 10.7 1.61 36.57 36.57 0 0 0 27.43-12.38l226.25-265.13c19.16-21.72 18.14-54.61-2.35-75.11zM272.78 382.18l-35.55-10.89-27.59-8.45-20.4 20.41-16.89 16.9-28.31-28.32 16.97-16.98 20.37-20.38-8.4-27.57-10.86-35.66 38.23-32.65 105.18 105.23-32.75 38.36zm220.99-258.97L326.36 319.39l-101.6-101.65 196.68-168c1.29-1.14 2.82-1.72 4.53-1.72 1.3 0 3.2.35 4.86 2.01l63.17 63.2c2.54 2.56 2.67 6.68-.23 9.98z"
  ]
};
export const faHiking = {
  prefix: "far",
  iconName: "hiking",
  icon: [
    384,
    512,
    [],
    "f6ec",
    "M114.13 252.08L142.88 141c5.59-21.31-9.34-38.69-25.94-42.69-42.84-10.25-87.22 15.28-98.19 57.28L1.13 224.05c-4.9 18.7 6.53 38.01 25.94 42.69l44.41 10.64c20.2 4.76 38.24-8.23 42.65-25.3zm-43.31-24.22l-19.87-4.77 14.28-55.47c3.28-12.59 14.31-21.45 27.22-23.28l-21.63 83.52zM368 160h-16c-8.84 0-16 7.16-16 16v24h-37.12l-50.09-57.16c-9.59-9.58-22.34-14.84-35.87-14.84-23.37 0-43.62 15.83-49.25 38.47l-22.53 90.08c-4.78 18.97.84 39.34 14.72 53.23l73.81 73.81c1.5 1.5 2.34 3.55 2.34 5.66V488c0 13.25 10.75 24 24 24s24-10.75 24-24v-98.75c0-14.95-5.81-29.02-16.41-39.59l-50.37-50.38 24.55-96.21 32.16 36.75c4.56 5.2 11.16 8.19 18.06 8.19h48v248c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V176c0-8.84-7.16-16-16-16zM121.87 317.6L80.73 482.17c-3.22 12.86 4.59 25.89 17.47 29.11 1.94.48 3.91.72 5.84.72 10.75 0 20.53-7.28 23.25-18.17l33.47-133.88-27.55-27.55c-4.46-4.46-8-9.59-11.34-14.8zM239.99 96c26.51 0 48-21.49 48-48s-21.49-48-48-48-48 21.49-48 48 21.49 48 48 48z"
  ]
};
export const faHippo = {
  prefix: "far",
  iconName: "hippo",
  icon: [
    640,
    512,
    [],
    "f6ed",
    "M559.21 91.45c-18.74 1.41-34.99 8.97-49.36 15.86-18.82-25.75-48.45-42.44-80.98-43.51-6.67-18.5-24.2-31.8-44.98-31.8H351.9c-26.5 0-47.99 21.49-47.99 48v4.23C275.19 71.45 242.66 64 207.94 64 99.48 64 0 128 0 224v224c0 17.67 14.32 32 31.99 32h79.98c17.67 0 31.99-14.33 31.99-32v-40.58c55.92 15.3 103.01 6.82 127.96 0V448c0 17.67 14.32 32 31.99 32h79.98c17.67 0 31.99-14.33 31.99-32V303.75l95.97-.07V336c0 8.84 7.16 16 16 16h31.99c8.83 0 16-7.16 16-16v-32.37l12.78-.01c28.34 0 51.39-23.08 51.39-51.44v-82.55c-.01-43.7-35.95-81.28-80.8-78.18zM367.89 432H319.9v-87.47c-122.94 33.63-114.46 29.95-223.93 0V432H47.99V235.51C56.43 156.2 132.07 112 207.94 112c35.88 0 69.1 10.02 95.97 26.58l.19 58.89c0 43.64 26.27 80.96 63.79 97.35V432zm224.12-176.38l-181.63.13h-.03c-32.18 0-58.26-26.09-58.26-58.28L351.9 88c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v31.52c22.43-6.57 33.96-8.29 44.57-7.53 21.76 1.55 40.8 15.33 49.31 35.42l8.97 21.17c54.94-20.54 59.67-28.03 76.04-29.25 18.26-1.58 29.24 16.98 29.24 30.31v85.98zM431.87 160c-8.83 0-16 7.16-16 16s7.16 16 16 16 16-7.16 16-16-7.16-16-16-16z"
  ]
};
export const faHistory = {
  prefix: "far",
  iconName: "history",
  icon: [
    512,
    512,
    [],
    "f1da",
    "M504 255.532c.252 136.64-111.182 248.372-247.822 248.468-64.014.045-122.373-24.163-166.394-63.942-5.097-4.606-5.3-12.543-.443-17.4l16.96-16.96c4.529-4.529 11.776-4.659 16.555-.395C158.208 436.843 204.848 456 256 456c110.549 0 200-89.468 200-200 0-110.549-89.468-200-200-200-55.52 0-105.708 22.574-141.923 59.043l49.091 48.413c7.641 7.535 2.305 20.544-8.426 20.544H26.412c-6.627 0-12-5.373-12-12V45.443c0-10.651 12.843-16.023 20.426-8.544l45.097 44.474C124.866 36.067 187.15 8 256 8c136.811 0 247.747 110.781 248 247.532zm-167.058 90.173l14.116-19.409c3.898-5.36 2.713-12.865-2.647-16.763L280 259.778V116c0-6.627-5.373-12-12-12h-24c-6.627 0-12 5.373-12 12v168.222l88.179 64.13c5.36 3.897 12.865 2.712 16.763-2.647z"
  ]
};
export const faHockeyMask = {
  prefix: "far",
  iconName: "hockey-mask",
  icon: [
    448,
    512,
    [],
    "f6ee",
    "M192 416c-8.84 0-16 7.16-16 16s7.16 16 16 16 16-7.16 16-16-7.16-16-16-16zm0-64c-8.84 0-16 7.16-16 16s7.16 16 16 16 16-7.16 16-16-7.16-16-16-16zm80-240c8.84 0 16-7.16 16-16s-7.16-16-16-16-16 7.16-16 16 7.17 16 16 16zm-96 0c8.84 0 16-7.16 16-16s-7.16-16-16-16-16 7.16-16 16 7.16 16 16 16zm16 176c-8.84 0-16 7.16-16 16s7.16 16 16 16 16-7.16 16-16-7.16-16-16-16zm64 128c-8.84 0-16 7.16-16 16s7.16 16 16 16 16-7.16 16-16-7.16-16-16-16zm0-128c-8.84 0-16 7.16-16 16s7.16 16 16 16 16-7.16 16-16-7.16-16-16-16zm0 64c-8.84 0-16 7.16-16 16s7.16 16 16 16 16-7.16 16-16-7.16-16-16-16zm-32-224c-8.84 0-16 7.16-16 16s7.16 16 16 16 16-7.16 16-16-7.16-16-16-16zm152.61-73.54C335.13 18.15 279.56 0 224 0 168.43 0 112.87 18.15 71.39 54.46 7.36 110.5-31.01 224.44 32.63 416 64.53 512 224 512 224 512s159.47 0 191.37-96c63.64-191.56 25.27-305.5-38.76-361.54zm-6.8 346.41C352.86 451.91 256.36 463.84 224 464c-26.37 0-128.4-10.71-145.81-63.13-47.21-142.08-38.16-255.17 24.82-310.3C133.92 63.52 178.02 48 224 48c45.98 0 90.08 15.52 120.99 42.57 62.98 55.13 72.03 168.22 24.82 310.3zM200 208c0-17.67-14.33-32-32-32h-64c-17.67 0-32 14.33-32 32 0 35.35 28.65 64 64 64s64-28.65 64-64zm80-32c-17.67 0-32 14.33-32 32 0 35.35 28.65 64 64 64s64-28.65 64-64c0-17.67-14.33-32-32-32h-64z"
  ]
};
export const faHockeyPuck = {
  prefix: "far",
  iconName: "hockey-puck",
  icon: [
    544,
    512,
    [],
    "f453",
    "M272 48C136.6 48 0 87.6 0 176v144c0 94.5 136.8 144 272 144s272-49.5 272-144V176c0-88.4-136.6-128-272-128zm224 272c0 53-100.3 96-224 96S48 373 48 320v-66.3c101.2 67.2 346.8 67.2 448 0V320zm-224-64c-123.7 0-224-35.8-224-80s100.3-80 224-80 224 35.8 224 80-100.3 80-224 80z"
  ]
};
export const faHockeySticks = {
  prefix: "far",
  iconName: "hockey-sticks",
  icon: [
    640,
    512,
    [],
    "f454",
    "M600 304H407.3L520 86.5c9.9-19.7 1.8-43.7-17.9-53.6L444.8 4.2c-19.7-9.9-43.7-1.9-53.6 17.7L320 158.2 248.8 21.9c-9.9-19.6-33.9-27.6-53.6-17.7l-57.3 28.6c-19.7 9.9-27.8 34-17.9 53.6L232.7 304H40c-22.1 0-40 18-40 40v128c0 22.1 17.9 40 40 40h186.5c37.2 0 71.2-17 93.6-45.1 22.4 28.1 56.3 45.1 93.5 45.1H600c22.1 0 40-17.9 40-40V344c0-22-17.9-40-40-40zM166.6 72.2l43-21.5 83.3 159.4-27.5 52.7-98.8-190.6zM79.6 464H48V352h31.6v112zm211.3-39.8c-12.3 24.6-37 39.8-64.5 39.8H111.6V352h141.9c12.3 0 23.3-6.8 28.5-17.3l148.4-284 43 21.5-182.5 352zm237 39.8H413.5c-6.6 0-43.4.8-66.5-43.7l35.7-68.9c7.2.9-21.4.6 145.2.6v112zm64.1 0h-32V352h32v112z"
  ]
};
export const faHollyBerry = {
  prefix: "far",
  iconName: "holly-berry",
  icon: [
    448,
    512,
    [],
    "f7aa",
    "M224 96c26.5 0 48-21.5 48-48S250.5 0 224 0s-48 21.5-48 48 21.5 48 48 48zm31.9 48c0 26.5 21.5 48 48 48s48-21.5 48-48-21.5-48-48-48-48 21.5-48 48zM144 191.9c26.5 0 48-21.5 48-48s-21.5-48-48-48-48 21.5-48 48 21.5 48 48 48zm276 144.3c-14.4-1.4-29.2-4.2-43.9-8.4-7.1-2-11.4-8.7-9.8-15.2 3.5-14.2 8.3-27.7 14.1-40 8.8-18.7-3.9-40.8-25-42.6-77.4-6.9-94.9-37.9-131.4-37.9-37.6 0-52.9 30.9-131.4 37.9-21.3 1.9-33.8 24.1-25 42.6 5.9 12.4 10.6 25.9 14.1 40.1 1.6 6.5-2.7 13.2-9.8 15.2-14.8 4.2-29.6 7-43.9 8.4C8.7 338.2-6.7 358.9 3 379c14.4 29.8 22 64.1 22.2 99 .1 24.3 21.5 34.1 34.9 34.1 5.9 0 11.8-1.5 17.3-4.5 32.2-17.5 67.5-28.4 102.1-31.5 21.2-1.9 33.9-24 25-42.6-5.9-12.4-10.6-25.9-14.1-40-6.6-26.3 73.7-26.3 67.1 0-3.5 14.2-8.3 27.6-14.1 40-8.8 18.7 3.9 40.8 25 42.6 34.6 3.1 69.9 14 102.1 31.5 5.5 3 11.4 4.5 17.3 4.5 13.2 0 34.8-9.7 34.9-34.1.2-34.9 7.8-69.2 22.2-99 10.2-21.1-6.5-41-24.9-42.8zm-232.9-4.1c-32.2 9.1-51.2 41.2-43.2 73 2.3 9 4.9 17.8 8 26.3-27.1 4.6-53.7 13-79.5 25-2-26.4-7.5-51.7-16.5-75.7 9.7-1.8 19.4-4 29.1-6.8 32.2-9.1 51.2-41.2 43.2-73-2.3-9-4.9-17.8-8-26.3 27-4.6 53.9-13.1 79.5-25.1 2 26.2 7.6 51.8 16.5 75.7-9.7 1.8-19.4 4.1-29.1 6.9zm188.5 124.3c-25.7-12-52.3-20.4-79.5-25 3.1-8.5 5.7-17.3 8-26.3 7.1-28.3-7.3-56.7-33.2-69.1-1.9-14-17.9-35.3-22.9-85 0-.5.1-1 .2-1.5 25.6 11.9 52.5 20.4 79.5 25.1-3.1 8.5-5.7 17.3-8 26.3-8 31.8 11 63.9 43.2 73 9.7 2.8 19.4 5 29.1 6.8-8.9 24-14.4 49.3-16.4 75.7z"
  ]
};
export const faHome = {
  prefix: "far",
  iconName: "home",
  icon: [
    576,
    512,
    [],
    "f015",
    "M570.24 247.41L512 199.52V104a8 8 0 0 0-8-8h-32a8 8 0 0 0-7.95 7.88v56.22L323.87 45a56.06 56.06 0 0 0-71.74 0L5.76 247.41a16 16 0 0 0-2 22.54L14 282.25a16 16 0 0 0 22.53 2L64 261.69V448a32.09 32.09 0 0 0 32 32h128a32.09 32.09 0 0 0 32-32V344h64v104a32.09 32.09 0 0 0 32 32h128a32.07 32.07 0 0 0 32-31.76V261.67l27.53 22.62a16 16 0 0 0 22.53-2L572.29 270a16 16 0 0 0-2.05-22.59zM463.85 432H368V328a32.09 32.09 0 0 0-32-32h-96a32.09 32.09 0 0 0-32 32v104h-96V222.27L288 77.65l176 144.56z"
  ]
};
export const faHomeAlt = {
  prefix: "far",
  iconName: "home-alt",
  icon: [
    576,
    512,
    [],
    "f80a",
    "M570.24 247.41L323.87 45a56.06 56.06 0 0 0-71.74 0L5.76 247.41a16 16 0 0 0-2 22.54L14 282.25a16 16 0 0 0 22.53 2L64 261.69V448a32.09 32.09 0 0 0 32 32h128a32.09 32.09 0 0 0 32-32V344h64v104a32.09 32.09 0 0 0 32 32h128a32.07 32.07 0 0 0 32-31.76V261.67l27.53 22.62a16 16 0 0 0 22.53-2L572.29 270a16 16 0 0 0-2.05-22.59zM463.85 432H368V328a32.09 32.09 0 0 0-32-32h-96a32.09 32.09 0 0 0-32 32v104h-96V222.27L288 77.65l176 144.56z"
  ]
};
export const faHomeHeart = {
  prefix: "far",
  iconName: "home-heart",
  icon: [
    576,
    512,
    [],
    "f4c9",
    "M231.3 191.8c-15.3 0-31 4.8-44.9 16.5-37.7 31.7-32.1 83.3-5.3 110.6l87.8 89.4c12.7 12.9 30.3 7.5 37.7 0l87.8-89.4c26.8-27.3 32.4-78.9-5.3-110.6-13.9-11.7-29.7-16.5-44.9-16.5-22.2 0-43.3 10-56.4 23.3-13.2-13.3-34.3-23.3-56.5-23.3zM358.1 245c18.3 15.4 5.9 36.1 2 40.2l-72.4 73.6-72.3-73.6c-4-4.1-16.4-24.8 2-40.2 13.6-11.5 31.3-1.1 36.1 3.8l34.3 34.9 34.3-34.9c4.6-4.9 22.3-15.3 36-3.8zM573 224l-61.1-52.2V72c0-4.4-3.6-8-8-8h-32c-4.4 0-8 3.6-8 8v60.5L313.2 9.1c-14.7-12.1-36-12.1-50.7 0L2.9 224.3c-3.4 2.8-3.9 7.8-1.1 11.3l20.3 24.8c2.8 3.4 7.8 3.9 11.3 1.1l30.3-27.7V496c0 8.8 7.3 16 16.1 16H496c8.8 0 16-7.2 16-16V233.8l30.8 27.3c3.4 2.8 8.5 2.3 11.3-1.1l20.3-24.8c2.6-3.4 2-8.4-1.4-11.2zM463.8 464H111.7V194.5l171-140c2.9-2.4 7.2-2.4 10.1 0l171 140V464z"
  ]
};
export const faHomeLg = {
  prefix: "far",
  iconName: "home-lg",
  icon: [
    576,
    512,
    [],
    "f80b",
    "M570.24 215.42l-58.35-47.95V72a8 8 0 0 0-8-8h-32a8 8 0 0 0-7.89 7.71v56.41L323.87 13a56 56 0 0 0-71.74 0L5.76 215.42a16 16 0 0 0-2 22.54L14 250.26a16 16 0 0 0 22.53 2L64 229.71V288h-.31v208a16.13 16.13 0 0 0 16.1 16H496a16 16 0 0 0 16-16V229.71l27.5 22.59a16 16 0 0 0 22.53-2l10.26-12.3a16 16 0 0 0-2.05-22.58zM464 224h-.21v240H352V320a32 32 0 0 0-32-32h-64a32 32 0 0 0-32 32v144H111.69V194.48l.31-.25v-4L288 45.65l176 144.62z"
  ]
};
export const faHomeLgAlt = {
  prefix: "far",
  iconName: "home-lg-alt",
  icon: [
    576,
    512,
    [],
    "f80c",
    "M570.24 215.42L323.87 13a56 56 0 0 0-71.75 0L5.76 215.42a16 16 0 0 0-2 22.54L14 250.26a16 16 0 0 0 22.53 2L64 229.71V288h-.31v208a16.13 16.13 0 0 0 16.1 16H496a16 16 0 0 0 16-16V229.71l27.5 22.59a16 16 0 0 0 22.53-2l10.26-12.3a16 16 0 0 0-2.05-22.58zM464 224h-.21v240H352V320a32 32 0 0 0-32-32h-64a32 32 0 0 0-32 32v144H111.69V194.48l.31-.25v-4L288 45.65l176 144.62z"
  ]
};
export const faHoodCloak = {
  prefix: "far",
  iconName: "hood-cloak",
  icon: [
    576,
    512,
    [],
    "f6ef",
    "M569.6 460.8C512 383.9 512 320 512 320v-64c0-84-46.4-123-101.2-182.7l39.8-39.8C462.9 21.2 454.2 0 436.7 0H287.6C192 0 64 109.5 64 256v64s0 63.9-57.7 140.8c-15.8 21-.3 51.2 26 51.2h511.3c26.4 0 41.8-30.1 26-51.2zM368.3 464h-160V328c0-44.1 35.9-80 80-80s80 35.9 80 80zm48 0V328c0-70.6-57.4-128-128-128s-128 57.4-128 128v136H62.5c48-75.8 49.5-136.6 49.5-144v-64c0-118.7 106.5-208 175.5-208h80.7l-23.9 23.9c36.5 39.7 34.4 37.5 49.2 53.2C441.1 175.8 464 202.6 464 256v64c0 7.4 1.5 68.2 49.5 144z"
  ]
};
export const faHorizontalRule = {
  prefix: "far",
  iconName: "horizontal-rule",
  icon: [
    640,
    512,
    [],
    "f86c",
    "M640 247.5v17a16 16 0 0 1-16 16H16a16 16 0 0 1-16-16v-17a16 16 0 0 1 16-16h608a16 16 0 0 1 16 16z"
  ]
};
export const faHorse = {
  prefix: "far",
  iconName: "horse",
  icon: [
    576,
    512,
    [],
    "f6f0",
    "M464 80c-8.84 0-16 7.16-16 16s7.16 16 16 16 16-7.16 16-16-7.16-16-16-16zm111.95 22.25a48.011 48.011 0 0 0-10.94-30.47L543.28 45.3c16.02-5.4 29.13-18.84 32.56-35.66C576.85 4.68 572.96 0 567.9 0H432c-68.4 0-125.82 47.95-140.42 112H176c-38.12 0-71.77 19.22-92.01 48.4C37.36 162.55 0 200.84 0 248v56c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-56c0-13.22 6.87-24.39 16.78-31.68-.18 2.59-.78 5.05-.78 7.68 0 30.13 11.91 58.09 32.16 78.58l-12.94 43.76a78.948 78.948 0 0 0-1.05 40.85l24.11 100.29c3.46 14.38 16.32 24.52 31.11 24.52h74.7c20.86 0 36.14-19.64 31.02-39.86l-25.53-100.76 9.48-26.41L288 358.5V480c0 17.67 14.33 32 32 32h80c17.67 0 32-14.33 32-32V324.35c19.96-22.47 31.31-51.04 31.97-81.55.05-.93.08-8.43.08-8.43 20.95 6.97 38.32.72 40.94-.17l31.02-10.59c23.96-8.18 40.01-30.7 39.99-56.02l-.05-65.34zm-55.44 75.94l-31.02 10.59c-1.51.52-9.71 2.95-16.48-3.83L448.05 160h-32v80H416c0 26.09-12.68 49.03-32 63.64V464h-48V320l-139.82-31.07-28.73 80.02L191.53 464H150l-21.13-87.86a31.698 31.698 0 0 1 .37-16.18l22.7-76.72C128.54 273.72 112 250.83 112 224c0-35.35 28.65-64 64-64h160v-16c0-53.02 42.98-96 96-96h51.33L528 102.28l.05 65.35c0 4.77-3.03 9.02-7.54 10.56z"
  ]
};
export const faHorseHead = {
  prefix: "far",
  iconName: "horse-head",
  icon: [
    512,
    512,
    [],
    "f7ab",
    "M506.9 268.6c-.8-1.9-71.4-140.4-103.9-166 6.1-18.9 6.7-39.9 1-61.3-8.2-31.5-42-48.9-72.4-38L166.8 65.1C19 118.2 0 257 0 372v76c0 35.3 28.7 64 64 64h232c19.9 0 38.5-10.7 48.4-27.9 10-17.2 10.1-38.6.2-55.9l-.5-.9-.5-.9-39.1-62.2c2.3-1 .3-.5 3.9-1.6l5.5 7.4c14.1 18.8 36.6 30 60 30h27.3c18.8 0 36.5-7 50.3-19.7 42.8-35.4 36.8-30.3 38.8-32.3 20.8-20.8 27.3-52 16.6-79.4zM456.4 314l-36.8 30.3c-4.9 4.9-11.5 7.6-18.4 7.6h-27.3c-8.5 0-16.6-4-21.7-10.8l-33.7-45.5C299.9 314.2 281 328 250.8 328c-34.6 0-66-20.6-80.1-52.6-2.5-5.8-8.3-9.5-14.6-9.5-4.2 0-8.2 1.7-11.3 4.7l-12.1 12.1c-5 5-6.2 12.4-3.1 18.6C153 347.4 199.4 376 250.7 376c1.4 0 2.7-.3 4-.4l48.1 76.4c3 5.3-.8 12-6.9 12H64c-8.8 0-16-7.2-16-16v-76c0-129.9 29.2-223.7 135.6-262l164.3-61.6c5.5-2 9.1 2.6 9.7 5 9.9 37.7-13.1 58.3-27.7 66.9 34.6 6.7 60.5 35.9 75.5 64.4l56.8 101.5c3.8 9.6 1.5 20.5-5.8 27.8zM296 176c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24c0-13.2-10.7-24-24-24z"
  ]
};
export const faHorseSaddle = {
  prefix: "far",
  iconName: "horse-saddle",
  icon: [
    576,
    512,
    [],
    "f8c3",
    "M464 80a16 16 0 1 0 16 16 16 16 0 0 0-16-16zm111.94 22.25c0-9.48-4.91-23.14-10.94-30.47L543.28 45.3c16-5.39 29.12-18.85 32.56-35.66A8.11 8.11 0 0 0 567.9 0H432c-68.41 0-125.81 48-140.41 112H176a111.81 111.81 0 0 0-92 48.41C37.37 162.55 0 200.84 0 248v56a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-56c0-13.22 6.87-24.39 16.78-31.69-.16 2.17-6.73 47.72 31.38 86.27l-12.94 43.76a82.4 82.4 0 0 0-1.06 40.85l24.12 100.29A32 32 0 0 0 137.37 512h74.72a32 32 0 0 0 31-39.86l-25.5-100.76 9.47-26.38L288 358.5V480a32 32 0 0 0 32 32h80a32 32 0 0 0 32-32V324.34a126.17 126.17 0 0 0 32-81.54c.06-.92.09-8.42.09-8.42a64.41 64.41 0 0 0 40.91-.18l31-10.59a59.07 59.07 0 0 0 40-56zM224 295.12l-27.81-6.18-28.75 80L191.53 464H150l-21.13-87.86a33 33 0 0 1 .38-16.19l22.69-76.72a63.79 63.79 0 0 1 8.06-121V176c0 40.16 27.18 73.73 64 84.25zM208 176v-16h80v16a40 40 0 0 1-80 0zm312.5 2.19l-31 10.59A16 16 0 0 1 473 185l-24.94-25h-32v80H416a79.66 79.66 0 0 1-32 63.64V464h-48V320l-64-14.22v-45.53c36.82-10.52 64-44.09 64-84.25v-32a96 96 0 0 1 96-96h51.34L528 102.28l.06 65.34a11.13 11.13 0 0 1-7.56 10.57z"
  ]
};
export const faHospital = {
  prefix: "far",
  iconName: "hospital",
  icon: [
    448,
    512,
    [],
    "f0f8",
    "M128 244v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12zm140 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12zm-76 84v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm76 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12zm180 124v36H0v-36c0-6.627 5.373-12 12-12h19.5V85.035C31.5 73.418 42.245 64 55.5 64H144V24c0-13.255 10.745-24 24-24h112c13.255 0 24 10.745 24 24v40h88.5c13.255 0 24 9.418 24 21.035V464H436c6.627 0 12 5.373 12 12zM79.5 463H192v-67c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v67h112.5V112H304v24c0 13.255-10.745 24-24 24H168c-13.255 0-24-10.745-24-24v-24H79.5v351zM266 64h-26V38a6 6 0 0 0-6-6h-20a6 6 0 0 0-6 6v26h-26a6 6 0 0 0-6 6v20a6 6 0 0 0 6 6h26v26a6 6 0 0 0 6 6h20a6 6 0 0 0 6-6V96h26a6 6 0 0 0 6-6V70a6 6 0 0 0-6-6z"
  ]
};
export const faHospitalAlt = {
  prefix: "far",
  iconName: "hospital-alt",
  icon: [
    640,
    512,
    [],
    "f47d",
    "M500 416h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12zm0-160h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12zM340 416h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12zm0-160h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12zM180 416h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12zm0-160h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12zm182-144h-26V86c0-3.3-2.7-6-6-6h-20c-3.3 0-6 2.7-6 6v26h-26c-3.3 0-6 2.7-6 6v20c0 3.3 2.7 6 6 6h26v26c0 3.3 2.7 6 6 6h20c3.3 0 6-2.7 6-6v-26h26c3.3 0 6-2.7 6-6v-20c0-3.3-2.7-6-6-6zm222-16H464V53.7C464 24.1 439.9 0 410.3 0H229.7C200.1 0 176 24.1 176 53.7V96H56c-30.9 0-56 25.1-56 56v352c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V152c0-4.4 3.6-8 8-8h168V53.7c0-3.2 2.6-5.7 5.7-5.7h180.6c3.2 0 5.7 2.6 5.7 5.7V144h168c4.4 0 8 3.6 8 8v352c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V152c0-30.9-25.1-56-56-56z"
  ]
};
export const faHospitalSymbol = {
  prefix: "far",
  iconName: "hospital-symbol",
  icon: [
    512,
    512,
    [],
    "f47e",
    "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256 256-114.6 256-256S397.4 0 256 0zm0 464c-114.7 0-208-93.3-208-208S141.3 48 256 48s208 93.3 208 208-93.3 208-208 208zm88-320h-32c-4.4 0-8 3.6-8 8v80h-96v-80c0-4.4-3.6-8-8-8h-32c-4.4 0-8 3.6-8 8v208c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8v-80h96v80c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V152c0-4.4-3.6-8-8-8z"
  ]
};
export const faHospitalUser = {
  prefix: "far",
  iconName: "hospital-user",
  icon: [
    640,
    512,
    [],
    "f80d",
    "M480 320a96 96 0 1 0-96-96 96 96 0 0 0 96 96zm0-144a48 48 0 1 1-48 48 48.05 48.05 0 0 1 48-48zm143.69 205.13C606.44 355.5 577 342 546.79 342a102 102 0 0 0-29.58 4.39 126.42 126.42 0 0 1-74.42 0 101.87 101.87 0 0 0-29.58-4.39c-30.23 0-59.65 13.48-76.9 39.11A95.5 95.5 0 0 0 320 434.67V472a40 40 0 0 0 40 40h240a40 40 0 0 0 40-40v-37.33a95.5 95.5 0 0 0-16.31-53.54zM592 464H368v-29.33a47.74 47.74 0 0 1 8.12-26.74c7.55-11.21 21.41-17.93 37.08-17.93a54 54 0 0 1 15.63 2.31 174.49 174.49 0 0 0 102.33 0 53.4 53.4 0 0 1 15.63-2.31c15.67 0 29.53 6.7 37.08 17.91a47.74 47.74 0 0 1 8.13 26.76zM148 224h-40a12 12 0 0 0-12 12v40a12 12 0 0 0 12 12h40a12 12 0 0 0 12-12v-40a12 12 0 0 0-12-12zm0 96h-40a12 12 0 0 0-12 12v40a12 12 0 0 0 12 12h40a12 12 0 0 0 12-12v-40a12 12 0 0 0-12-12zm0 96h-40a12 12 0 0 0-12 12v40a12 12 0 0 0 12 12h40a12 12 0 0 0 12-12v-40a12 12 0 0 0-12-12zm96-96h-40a12 12 0 0 0-12 12v40a12 12 0 0 0 12 12h40a12 12 0 0 0 12-12v-40a12 12 0 0 0-12-12zm0-96h-40a12 12 0 0 0-12 12v40a12 12 0 0 0 12 12h40a12 12 0 0 0 12-12v-40a12 12 0 0 0-12-12zm108 101.83V128a32 32 0 0 0-32-32h-16V32a32 32 0 0 0-32-32H80a32 32 0 0 0-32 32v64H32a32 32 0 0 0-32 32v368a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16V144h48V48h160v96h48v229.36c1.86-3.4 3.58-6.86 5.76-10.1 10.73-15.94 25.46-28.33 42.24-37.43zM244 416h-40a12 12 0 0 0-12 12v40a12 12 0 0 0 12 12h40a12 12 0 0 0 12-12v-40a12 12 0 0 0-12-12zm-52-272h26a6 6 0 0 0 6-6v-20a6 6 0 0 0-6-6h-26V86a6 6 0 0 0-6-6h-20a6 6 0 0 0-6 6v26h-26a6 6 0 0 0-6 6v20a6 6 0 0 0 6 6h26v26a6 6 0 0 0 6 6h20a6 6 0 0 0 6-6z"
  ]
};
export const faHospitals = {
  prefix: "far",
  iconName: "hospitals",
  icon: [
    640,
    512,
    [],
    "f80e",
    "M192 144h26a6 6 0 0 0 6-6v-20a6 6 0 0 0-6-6h-26V86a6 6 0 0 0-6-6h-20a6 6 0 0 0-6 6v26h-26a6 6 0 0 0-6 6v20a6 6 0 0 0 6 6h26v26a6 6 0 0 0 6 6h20a6 6 0 0 0 6-6zm244 272h-40a12 12 0 0 0-12 12v40a12 12 0 0 0 12 12h40a12 12 0 0 0 12-12v-40a12 12 0 0 0-12-12zm-192-96h-40a12 12 0 0 0-12 12v40a12 12 0 0 0 12 12h40a12 12 0 0 0 12-12v-40a12 12 0 0 0-12-12zm0-96h-40a12 12 0 0 0-12 12v40a12 12 0 0 0 12 12h40a12 12 0 0 0 12-12v-40a12 12 0 0 0-12-12zm-96 192h-40a12 12 0 0 0-12 12v40a12 12 0 0 0 12 12h40a12 12 0 0 0 12-12v-40a12 12 0 0 0-12-12zm0-192h-40a12 12 0 0 0-12 12v40a12 12 0 0 0 12 12h40a12 12 0 0 0 12-12v-40a12 12 0 0 0-12-12zm0 96h-40a12 12 0 0 0-12 12v40a12 12 0 0 0 12 12h40a12 12 0 0 0 12-12v-40a12 12 0 0 0-12-12zm96 96h-40a12 12 0 0 0-12 12v40a12 12 0 0 0 12 12h40a12 12 0 0 0 12-12v-40a12 12 0 0 0-12-12zm288-192h-40a12 12 0 0 0-12 12v40a12 12 0 0 0 12 12h40a12 12 0 0 0 12-12v-40a12 12 0 0 0-12-12zm0 96h-40a12 12 0 0 0-12 12v40a12 12 0 0 0 12 12h40a12 12 0 0 0 12-12v-40a12 12 0 0 0-12-12zm76-224h-16V32a32 32 0 0 0-32-32H368a32 32 0 0 0-32 32v64h-32V32a32 32 0 0 0-32-32H80a32 32 0 0 0-32 32v64H32a32 32 0 0 0-32 32v368a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16V144h48V48h160v96h40v352a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16V144h40V48h160v96h48v352a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16V128a32 32 0 0 0-32-32zm-76 320h-40a12 12 0 0 0-12 12v40a12 12 0 0 0 12 12h40a12 12 0 0 0 12-12v-40a12 12 0 0 0-12-12zm-96-96h-40a12 12 0 0 0-12 12v40a12 12 0 0 0 12 12h40a12 12 0 0 0 12-12v-40a12 12 0 0 0-12-12zm0-96h-40a12 12 0 0 0-12 12v40a12 12 0 0 0 12 12h40a12 12 0 0 0 12-12v-40a12 12 0 0 0-12-12zm44-80h26a6 6 0 0 0 6-6v-20a6 6 0 0 0-6-6h-26V86a6 6 0 0 0-6-6h-20a6 6 0 0 0-6 6v26h-26a6 6 0 0 0-6 6v20a6 6 0 0 0 6 6h26v26a6 6 0 0 0 6 6h20a6 6 0 0 0 6-6z"
  ]
};
export const faHotTub = {
  prefix: "far",
  iconName: "hot-tub",
  icon: [
    512,
    512,
    [],
    "f593",
    "M432.83 209.65c1 8.21 7.62 14.35 15.48 14.35h15.85c9.35 0 16.8-8.57 15.73-18.35-4.26-39.11-22.02-74.53-49.29-97.16-17.07-14.17-28.34-36.75-31.44-62.15-1-8.21-7.62-14.35-15.48-14.35h-15.85c-9.35 0-16.8 8.57-15.73 18.35 4.27 39.11 22.02 74.53 49.29 97.16 17.08 14.18 28.34 36.76 31.44 62.15zm-96 0c1 8.21 7.62 14.35 15.48 14.35h15.85c9.35 0 16.8-8.57 15.73-18.35-4.26-39.11-22.02-74.53-49.29-97.16-17.07-14.17-28.34-36.75-31.44-62.15-1-8.21-7.62-14.35-15.48-14.35h-15.85c-9.35 0-16.8 8.57-15.73 18.35 4.27 39.11 22.02 74.53 49.29 97.16 17.08 14.18 28.34 36.76 31.44 62.15zM480 288H288l-110.93-83.2a63.99 63.99 0 0 0-38.4-12.8H64c-35.35 0-64 28.65-64 64v192c0 35.35 28.65 64 64 64h384c35.35 0 64-28.65 64-64V320c0-17.67-14.33-32-32-32zM48 256c0-8.82 7.18-16 16-16h74.67c3.44 0 6.85 1.14 9.6 3.2L208 288H48v-32zm64 208H64c-8.82 0-16-7.18-16-16V336h64v128zm120 0h-72V336h72v128zm120 0h-72V336h72v128zm112-16c0 8.82-7.18 16-16 16h-48V336h64v112zM96 160c44.18 0 80-35.82 80-80 0-44.19-35.82-80-80-80S16 35.81 16 80c0 44.18 35.82 80 80 80zm0-112c17.64 0 32 14.36 32 32s-14.36 32-32 32-32-14.36-32-32 14.36-32 32-32z"
  ]
};
export const faHotdog = {
  prefix: "far",
  iconName: "hotdog",
  icon: [
    512,
    512,
    [],
    "f80f",
    "M484.05 186.63C501.86 166.11 512 140.44 512 113A113 113 0 0 0 399 0c-27.45 0-53.12 10.15-73.65 28l-2.88-2.88C306.56 9.14 284.94 0 263.12 0a74.51 74.51 0 0 0-53.18 21.69L21.69 209.89c-30.1 30.11-28.6 80.64 3.37 112.59l2.94 2.89C10.14 345.89 0 371.56 0 399a113 113 0 0 0 113 113c27.46 0 53.13-10.15 73.65-28l2.88 2.88c15.91 15.98 37.53 25.12 59.35 25.12a74.51 74.51 0 0 0 53.18-21.69l188.22-188.2c30.1-30.13 28.6-80.64-3.37-112.59zm-428.43 57.2L243.84 55.62c10.18-10.21 29.32-12 47 5.72L61.33 290.88c-17.72-17.72-15.85-36.88-5.71-47.05zm400.76 24.34L268.16 456.38c-10.18 10.2-29.32 12-47-5.72l229.51-229.54c17.72 17.72 15.85 36.88 5.71 47.05zM445 159L159 445a65 65 0 0 1-92-92L353 67a65 65 0 1 1 92 92zm-45-47c-10.5 10.52-19 11.53-30.75 13-5.61.68-63.52 3.28-71.66 71.67-5.1 41.72-35.25 42.67-43.68 43.68-5.63.67-63.51 3.23-71.5 71.53-1 8.32-1.92 38.53-43.53 43.51-13.91 1.66-31.19 3.72-49.5 22A16 16 0 0 0 112 400c10.47-10.47 18.94-11.48 30.69-12.89 5.68-.68 63.48-3.22 71.47-71.5 1-8.15 1.86-38.53 43.56-43.53 5.72-.69 63.49-3.27 71.62-71.63 5.11-41.74 35.35-42.7 43.72-43.72 13.94-1.68 31.22-3.78 49.56-22.11A16 16 0 0 0 400 112z"
  ]
};
export const faHotel = {
  prefix: "far",
  iconName: "hotel",
  icon: [
    576,
    512,
    [],
    "f594",
    "M560 48c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16H16C7.16 0 0 7.16 0 16v16c0 8.84 7.16 16 16 16h15.98v416H16c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h544c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16h-16V48h16zm-64 416H320v-80h64c0-53.02-42.98-96-96-96s-96 42.98-96 96h64v80H79.98V48H496v416zM268.8 160h38.4c6.4 0 12.8-6.4 12.8-12.8v-38.4c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v38.4c0 6.4 6.4 12.8 12.8 12.8zm0 96h38.4c6.4 0 12.8-6.4 12.8-12.8v-38.4c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v38.4c0 6.4 6.4 12.8 12.8 12.8zm128 0h38.4c6.4 0 12.8-6.4 12.8-12.8v-38.4c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v38.4c0 6.4 6.4 12.8 12.8 12.8zm0-96h38.4c6.4 0 12.8-6.4 12.8-12.8v-38.4c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v38.4c0 6.4 6.4 12.8 12.8 12.8zm-256 96h38.4c6.4 0 12.8-6.4 12.8-12.8v-38.4c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v38.4c0 6.4 6.4 12.8 12.8 12.8zm0-96h38.4c6.4 0 12.8-6.4 12.8-12.8v-38.4c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v38.4c0 6.4 6.4 12.8 12.8 12.8z"
  ]
};
export const faHourglass = {
  prefix: "far",
  iconName: "hourglass",
  icon: [
    384,
    512,
    [],
    "f254",
    "M368 48h4c6.627 0 12-5.373 12-12V12c0-6.627-5.373-12-12-12H12C5.373 0 0 5.373 0 12v24c0 6.627 5.373 12 12 12h4c0 80.564 32.188 165.807 97.18 208C47.899 298.381 16 383.9 16 464h-4c-6.627 0-12 5.373-12 12v24c0 6.627 5.373 12 12 12h360c6.627 0 12-5.373 12-12v-24c0-6.627-5.373-12-12-12h-4c0-80.564-32.188-165.807-97.18-208C336.102 213.619 368 128.1 368 48zM64 48h256c0 101.62-57.307 184-128 184S64 149.621 64 48zm256 416H64c0-101.62 57.308-184 128-184s128 82.38 128 184z"
  ]
};
export const faHourglassEnd = {
  prefix: "far",
  iconName: "hourglass-end",
  icon: [
    384,
    512,
    [],
    "f253",
    "M372 0H12C5.373 0 0 5.373 0 12v24c0 6.627 5.373 12 12 12h4c0 80.564 32.188 165.807 97.18 208C47.898 298.381 16 383.9 16 464h-4c-6.627 0-12 5.373-12 12v24c0 6.627 5.373 12 12 12h360c6.627 0 12-5.373 12-12v-24c0-6.627-5.373-12-12-12h-4c0-80.564-32.188-165.807-97.18-208C336.102 213.619 368 128.1 368 48h4c6.627 0 12-5.373 12-12V12c0-6.627-5.373-12-12-12zM192 232c-70.692 0-128-82.379-128-184h256c0 101.621-57.308 184-128 184z"
  ]
};
export const faHourglassHalf = {
  prefix: "far",
  iconName: "hourglass-half",
  icon: [
    384,
    512,
    [],
    "f252",
    "M368 48h4c6.627 0 12-5.373 12-12V12c0-6.627-5.373-12-12-12H12C5.373 0 0 5.373 0 12v24c0 6.627 5.373 12 12 12h4c0 80.564 32.188 165.807 97.18 208C47.898 298.381 16 383.9 16 464h-4c-6.627 0-12 5.373-12 12v24c0 6.627 5.373 12 12 12h360c6.627 0 12-5.373 12-12v-24c0-6.627-5.373-12-12-12h-4c0-80.564-32.188-165.807-97.18-208C336.102 213.619 368 128.1 368 48zm-48 0c0 28.672-4.564 55.81-12.701 80H76.701C68.564 103.81 64 76.672 64 48h256zm-12.701 336H76.701C97.405 322.453 141.253 280 192 280s94.595 42.453 115.299 104z"
  ]
};
export const faHourglassStart = {
  prefix: "far",
  iconName: "hourglass-start",
  icon: [
    384,
    512,
    [],
    "f251",
    "M372 0H12C5.373 0 0 5.373 0 12v24c0 6.627 5.373 12 12 12h4c0 80.564 32.188 165.807 97.18 208C47.898 298.381 16 383.9 16 464h-4c-6.627 0-12 5.373-12 12v24c0 6.627 5.373 12 12 12h360c6.627 0 12-5.373 12-12v-24c0-6.627-5.373-12-12-12h-4c0-80.564-32.188-165.807-97.18-208C336.102 213.619 368 128.1 368 48h4c6.627 0 12-5.373 12-12V12c0-6.627-5.373-12-12-12zm-52 464H64c0-101.62 57.308-184 128-184s128 82.38 128 184z"
  ]
};
export const faHouse = {
  prefix: "far",
  iconName: "house",
  icon: [
    576,
    512,
    [],
    "e00d",
    "M570.63,240,512,187.36V56a24,24,0,0,0-24-24H392a24,24,0,0,0-24,24v2.08l-53.44-48a40,40,0,0,0-53.12,0L5.37,240A16,16,0,0,0,4,262.58l10.62,11.95a16,16,0,0,0,22.59,1.34l26.75-24V472a40,40,0,0,0,40,40H472a40,40,0,0,0,40-40V251.85l26.75,24a16,16,0,0,0,22.59-1.34L572,262.58A16,16,0,0,0,570.63,240ZM464,464H112V208.75l176-158,176,158Zm0-319.74-48-43.09V80h48ZM224,208v96a16,16,0,0,0,16,16h96a16,16,0,0,0,16-16V208a16,16,0,0,0-16-16H240A16,16,0,0,0,224,208Z"
  ]
};
export const faHouseDamage = {
  prefix: "far",
  iconName: "house-damage",
  icon: [
    576,
    512,
    [],
    "f6f1",
    "M573.05 224l-61.13-52.23v-99.8c0-4.4-3.6-8-8-8H471.9c-4.4 0-8 3.6-8 8v60.5L313.23 9.07c-14.71-12.1-36.01-12.1-50.72 0L2.92 224.33c-3.4 2.8-3.9 7.8-1.1 11.3l20.31 24.8c2.8 3.4 7.8 3.9 11.3 1.1l30.28-27.67V496c0 8.8 7.31 16 16.11 16H253.2l-47.55-118.83 79.83-53.2A23.963 23.963 0 0 0 296.17 320v-59.58l68.95 86.12-74.26 49.48c-10.07 6.72-13.57 19.87-8.16 30.7L325.34 512h170.67c8.8 0 15.95-7.2 15.95-16V233.77l30.77 27.33c3.4 2.8 8.5 2.3 11.3-1.1l20.31-24.8c2.61-3.4 2.11-8.4-1.29-11.2zM463.8 464H355.04l-19.91-39.78 78.42-52.25a23.99 23.99 0 0 0 10.41-16.28c1.03-6.66-.78-13.42-4.97-18.69L290.92 177c-6.38-7.94-17.13-11.05-26.7-7.64-9.63 3.38-16.07 12.45-16.07 22.64v115.16l-85.36 56.87c-9.44 6.3-13.2 18.34-8.97 28.87l28.45 71.1h-70.53V194.47l170.97-140c2.9-2.4 7.21-2.4 10.1 0l170.99 140V464z"
  ]
};
export const faHouseDay = {
  prefix: "far",
  iconName: "house-day",
  icon: [
    640,
    512,
    [],
    "e00e",
    "M352,304v64a16,16,0,0,0,16,16h64a16,16,0,0,0,16-16V304a16.05,16.05,0,0,0-16-16H368A16.05,16.05,0,0,0,352,304Zm282.63-8L576,242.85V144a16,16,0,0,0-16-16H544a16,16,0,0,0-16,16v55.34L424.06,105.12a36.35,36.35,0,0,0-48.15,0L165.37,296A16,16,0,0,0,164,318.58l10.62,12a16,16,0,0,0,22.59,1.33L224,307.61V472a40,40,0,0,0,40,40H536a40,40,0,0,0,40-40V307.61l26.75,24.26a16,16,0,0,0,22.59-1.33l10.62-12A16,16,0,0,0,634.63,296ZM528,464H272V264.06L400,148,528,264.06ZM104,176a72.08,72.08,0,0,1,72-72c38.61,0,70,30.61,71.68,68.8l40-36.28-7.39-3.69,23-69a11.89,11.89,0,0,0-15.06-15l-69,23L186.66,6.6a11.9,11.9,0,0,0-21.31,0L132.83,71.71l-69.09-23a11.89,11.89,0,0,0-15.06,15l23,69L6.6,165.35a11.9,11.9,0,0,0,0,21.31l65.11,32.51-23,69.1a11.89,11.89,0,0,0,15.06,15.06L127,282.23,166,246.81C131.1,241.89,104,212.27,104,176Zm32,0a40,40,0,1,0,40-40A40.07,40.07,0,0,0,136,176Z"
  ]
};
export const faHouseFlood = {
  prefix: "far",
  iconName: "house-flood",
  icon: [
    576,
    512,
    [],
    "f74f",
    "M38.1 244.8c2.8 3.4 7.8 3.9 11.3 1.1l14.7-12v177.5c9.3-6.6 20.3-10.6 31.9-10.6 5.5 0 10.8 1.2 16 2.7v-209l170.9-140c2.9-2.4 7.2-2.4 10.1 0l170.9 140V224h.1v179.5c5.2-1.5 10.5-2.8 16-2.8 11.6 0 22.8 4 32.1 10.7V233.8l14.7 12c3.4 2.8 8.5 2.3 11.3-1.1l20.3-24.8c2.6-3.4 2.1-8.4-1.3-11.2L512 171.8V72c0-4.4-3.6-8-8-8h-32c-4.4 0-8 3.6-8 8v60.5L313.4 9.1c-14.7-12.1-36-12.1-50.7 0L18.9 208.7c-3.4 2.8-3.9 7.8-1.1 11.3l20.3 24.8zm523.4 219.1c-25.1-2.6-49.2-11.9-66.4-25.9-8.7-7.1-21.6-7-30.3.1-20.5 16.9-50 26.6-80.8 26.6-30.1 0-60.3-10-80.9-26.7-8.7-7.1-21.6-7-30.3.1-20.5 16.9-50 26.6-80.8 26.6-30.1 0-60.3-10-80.9-26.7-8.7-7.1-21.6-7-30.3.1-17.2 14.2-40.7 23.3-66.1 25.8-8.2.9-14.7 7.3-14.7 15.5v16.5c0 9.1 7.6 16.8 16.7 16 28.9-2.5 56.5-11.5 79.3-25.8 54.9 34.2 137.9 33.9 192 0 54.9 34.2 137.9 33.9 192 0 22.9 14.3 50.5 23.3 79.2 25.8 9.1.8 16.7-6.9 16.7-16v-16.7c.1-8.1-6.3-14.4-14.4-15.3zM240 192c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16v-96c0-8.8-7.2-16-16-16h-96z"
  ]
};
export const faHouseLeave = {
  prefix: "far",
  iconName: "house-leave",
  icon: [
    640,
    512,
    [],
    "e00f",
    "M363.25,389a7.4,7.4,0,0,0,1.62-2.64L372.46,368H112.05V168L240.1,51.93l104.81,95A123.2,123.2,0,0,1,381,124.32l7.13-2.89L264.17,9.1a36.4,36.4,0,0,0-48.18,0L5.37,200A16,16,0,0,0,4,222.55l10.63,12a16,16,0,0,0,22.6,1.33L64,211.57V376a40,40,0,0,0,40,40H336.36ZM528,96A48,48,0,1,0,480.1,48,47.91,47.91,0,0,0,528,96Zm111,185.52a21.92,21.92,0,0,0-.8-2.54,25.55,25.55,0,0,0-5.49-8.08L603.43,242a8.75,8.75,0,0,1-2-3.2L588.55,200a105.09,105.09,0,0,0-99.85-72c-34.83,0-53,8.79-95.73,26a92.15,92.15,0,0,0-48.24,44.8L330.32,229.9a25,25,0,0,0-2.23,9.22c0,.71-.08,1.41-.06,2.09a21.6,21.6,0,0,0,1.59,7.93c.06.14.17.25.23.39a23.39,23.39,0,0,0,4.31,6.17c.43.45.86.91,1.32,1.34a26.84,26.84,0,0,0,6.46,4.45c.23.11.48.16.72.26a26.44,26.44,0,0,0,7,1.92c.62.09,1.23.18,1.85.22a23.15,23.15,0,0,0,7.86-.71c.26-.08.5-.25.76-.34a23.62,23.62,0,0,0,8.13-5,25.45,25.45,0,0,0,5.61-7.73l14-30.38a43.71,43.71,0,0,1,22.82-21c21.69-8.71,33.1-13.5,44.33-17.11l-19.82,79.2c-4.69,18.9.31,38.79,14.91,54.61l79,73a39.65,39.65,0,0,1,11.79,20.39l19.51,84.8a23.62,23.62,0,0,0,3.36,7.61,24.53,24.53,0,0,0,1.77,2.05,24.25,24.25,0,0,0,4.05,4.05,23.65,23.65,0,0,0,2.8,1.65,23.34,23.34,0,0,0,5,2.12,22.79,22.79,0,0,0,3.54.64,23.67,23.67,0,0,0,8.21-.12,24,24,0,0,0,17.91-28.8l-19.51-84.7a88.16,88.16,0,0,0-26-44.89l-53.83-49.61,26.2-104.79c7.4,9.7,7.5,12.61,21.82,55.4a57.41,57.41,0,0,0,13.82,22.21l29.29,29a24.91,24.91,0,0,0,8.44,5.38,20.4,20.4,0,0,0,3,.59,22.16,22.16,0,0,0,5.82.79,23.39,23.39,0,0,0,2.35-.36,24.52,24.52,0,0,0,5.65-1.55c.81-.34,1.61-.7,2.39-1.12a27.36,27.36,0,0,0,5-3.56c.51-.45,1.08-.82,1.55-1.3a26.48,26.48,0,0,0,4.7-6.55c.25-.5.34-1.06.56-1.57a23,23,0,0,0,1.63-6.13,20.79,20.79,0,0,0,.09-2.62A21.18,21.18,0,0,0,639.05,281.52ZM176.1,192a16.05,16.05,0,0,0-16,16v64a16,16,0,0,0,16,16h64a16,16,0,0,0,16-16V208a16.05,16.05,0,0,0-16-16ZM427.43,338l-.87-.93c-1.69-1.83-2.85-3.91-4.38-5.82l-27.71,67.3A38.74,38.74,0,0,1,385.56,412l-58.43,58.49A23.95,23.95,0,1,0,361,504.39l58.4-58.5a87.66,87.66,0,0,0,19.41-29.5l19.44-49.93L428.36,338.9Z"
  ]
};
export const faHouseNight = {
  prefix: "far",
  iconName: "house-night",
  icon: [
    640,
    512,
    [],
    "e010",
    "M112,224a111.77,111.77,0,0,0,87-41.47,5.25,5.25,0,0,0-5.05-8.47A87.74,87.74,0,0,1,134.11,11.6a5.26,5.26,0,0,0-1.65-9.73A136.16,136.16,0,0,0,112,0a112,112,0,0,0,0,224ZM195,68.78l39.72,16.56,16.56,39.72a5.32,5.32,0,0,0,9.54,0l16.56-39.72,39.72-16.56a5.33,5.33,0,0,0,0-9.54L277.33,42.68,260.77,3a5.32,5.32,0,0,0-9.54,0L234.67,42.68,195,59.24a5.33,5.33,0,0,0,0,9.54Zm-37.9,310.46-39.72-16.56L100.77,323a5.32,5.32,0,0,0-9.54,0L74.67,362.68,35,379.24a5.33,5.33,0,0,0,0,9.54l39.72,16.56,16.56,39.72a5.32,5.32,0,0,0,9.54,0l16.56-39.72,39.72-16.56a5.33,5.33,0,0,0,0-9.54ZM634.63,296,576,242.85V144a16,16,0,0,0-16-16H544a16,16,0,0,0-16,16v55.34L424.06,105.12a36.35,36.35,0,0,0-48.15,0L165.37,296A16,16,0,0,0,164,318.58l10.62,12a16,16,0,0,0,22.59,1.33L224,307.61V472a40,40,0,0,0,40,40H536a40,40,0,0,0,40-40V307.61l26.75,24.26a16,16,0,0,0,22.59-1.33l10.62-12A16,16,0,0,0,634.63,296ZM528,464H272V264.06L400,148,528,264.06ZM352,304v64a16,16,0,0,0,16,16h64a16,16,0,0,0,16-16V304a16.05,16.05,0,0,0-16-16H368A16.05,16.05,0,0,0,352,304Z"
  ]
};
export const faHouseReturn = {
  prefix: "far",
  iconName: "house-return",
  icon: [
    640,
    512,
    [],
    "e011",
    "M176.08,192a16.06,16.06,0,0,0-16,16v64a16.05,16.05,0,0,0,16,16h64a16,16,0,0,0,16-16V208a16.05,16.05,0,0,0-16-16Zm-64-23.91L240.08,52,357.34,157.72a136.72,136.72,0,0,1,32.27-34.21L264.15,9.12a36.37,36.37,0,0,0-48.17,0L5.37,200A16,16,0,0,0,4,222.58l10.62,11.95a16,16,0,0,0,22.6,1.33L64,211.6V376a40,40,0,0,0,40,40H335.58l5.78-25.12A119.54,119.54,0,0,1,349.67,368H112ZM432.07,96a48,48,0,1,0-47.9-48A47.94,47.94,0,0,0,432.07,96Zm92.84,164.79-19.82-79.2c11.22,3.61,22.63,8.4,44.33,17.11a43.74,43.74,0,0,1,22.82,21l14,30.38a25.45,25.45,0,0,0,5.61,7.73,23.62,23.62,0,0,0,8.13,5c.26.09.5.26.76.34a23.15,23.15,0,0,0,7.86.71c.62,0,1.23-.13,1.84-.22a26.51,26.51,0,0,0,7-1.92c.23-.1.49-.15.72-.26a26.59,26.59,0,0,0,6.45-4.45c.47-.43.9-.89,1.33-1.34a23.39,23.39,0,0,0,4.31-6.17c.06-.14.17-.25.23-.39a21.6,21.6,0,0,0,1.58-7.93c0-.68,0-1.38,0-2.09a25.19,25.19,0,0,0-2.24-9.22l-14.41-31.11A92.09,92.09,0,0,0,567.11,154c-42.7-17.2-60.9-26-95.72-26a105.08,105.08,0,0,0-99.84,72l-12.88,38.8a8.75,8.75,0,0,1-2,3.2L327.34,270.9a25.35,25.35,0,0,0-5.48,8.08,20.21,20.21,0,0,0-.81,2.54,22.73,22.73,0,0,0-.86,8.5,23,23,0,0,0,1.64,6.13c.21.51.3,1.07.55,1.57a26.48,26.48,0,0,0,4.7,6.55c.47.48,1.05.85,1.55,1.3a27.1,27.1,0,0,0,5,3.56,24.81,24.81,0,0,0,2.39,1.12,24.44,24.44,0,0,0,5.64,1.55,23.39,23.39,0,0,0,2.35.36,22,22,0,0,0,5.82-.79,20.4,20.4,0,0,0,3-.59,24.91,24.91,0,0,0,8.44-5.38l29.29-29a57.41,57.41,0,0,0,13.82-22.21c14.32-42.79,14.41-45.7,21.82-55.4l26.19,104.79-53.83,49.61a88.21,88.21,0,0,0-26,44.89L353,482.78A24,24,0,0,0,371,511.58a23.67,23.67,0,0,0,8.21.12,22.79,22.79,0,0,0,3.54-.64,23.34,23.34,0,0,0,5-2.12,23.65,23.65,0,0,0,2.8-1.65,24.19,24.19,0,0,0,4-4.05,22.92,22.92,0,0,0,1.78-2.05,23.84,23.84,0,0,0,3.36-7.61l19.51-84.8A39.63,39.63,0,0,1,431,388.39l79-73C524.6,299.58,529.6,279.69,524.91,260.79Zm108,209.69L574.52,412a38.74,38.74,0,0,1-8.91-13.41l-27.71-67.3c-1.52,1.91-2.69,4-4.38,5.82l-.86.93-.94.87-29.84,27.56,19.43,49.93a87.54,87.54,0,0,0,19.42,29.5l58.39,58.5a23.95,23.95,0,0,0,33.82-33.91Z"
  ]
};
export const faHouseSignal = {
  prefix: "far",
  iconName: "house-signal",
  icon: [
    640,
    512,
    [],
    "e012",
    "M0,224H0v48c132.55,0,240,107.45,240,240h48C288,352.94,159.06,224,0,224ZM0,416v48a48,48,0,0,1,48,48H96A96,96,0,0,0,0,416Zm0-96v48A144,144,0,0,1,144,512h48C192,406,106,320,0,320ZM634.63,200,576,146.84V48a16,16,0,0,0-16-16H544a16,16,0,0,0-16,16v55.34L424.06,9.1a36.36,36.36,0,0,0-48.15,0L165.37,200A16,16,0,0,0,164,222.57l10.62,12a16,16,0,0,0,22.59,1.33L224,211.59V262.5a339.26,339.26,0,0,1,48,53.35V168.05L400,51.93,528,168.05V368H303.41a332.68,332.68,0,0,1,18.07,48H536a40,40,0,0,0,40-40V211.59l26.75,24.27a16,16,0,0,0,22.59-1.33l10.62-12A16,16,0,0,0,634.63,200ZM432,288a16.05,16.05,0,0,0,16-16V208a16,16,0,0,0-16-16H368a16,16,0,0,0-16,16v64a16.05,16.05,0,0,0,16,16Z"
  ]
};
export const faHouseUser = {
  prefix: "far",
  iconName: "house-user",
  icon: [
    576,
    512,
    [],
    "e065",
    "M570.61,240,512,187.37V56a24,24,0,0,0-24-24H392a24,24,0,0,0-24,24v2.08l-53.44-48C308.28,4.53,296.39,0,288,0s-20.28,4.53-26.56,10.09L5.39,240A18.21,18.21,0,0,0,0,252a18.47,18.47,0,0,0,4,10.61l10.62,12a18.15,18.15,0,0,0,12,5.37,18.54,18.54,0,0,0,10.63-4l26.75-24V472a40,40,0,0,0,40,40H472a40,40,0,0,0,40-40V251.85l26.75,24a16,16,0,0,0,22.59-1.33L572,262.59A18.47,18.47,0,0,0,576,252,18.21,18.21,0,0,0,570.61,240ZM464,464H416V448a96,96,0,0,0-96-96H256a96,96,0,0,0-96,96v16H112V208.76l176-158,176,158Zm0-319.72-48-43.1V80h48ZM224,256a64,64,0,1,0,64-64A64,64,0,0,0,224,256Z"
  ]
};
export const faHryvnia = {
  prefix: "far",
  iconName: "hryvnia",
  icon: [
    384,
    512,
    [],
    "f6f2",
    "M368 240c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16h-71.22C311.4 174.48 320 151.63 320 127.86 320 75 280.3 32 231.5 32h-73.88c-23.84 0-46.83 8.87-64.49 24.89L70.35 77.55c-6.54 5.94-7.04 16.05-1.1 22.6l21.5 23.7c5.94 6.54 16.06 7.04 22.6 1.1l22.76-20.64c5.9-5.35 13.58-8.31 21.54-8.31h73.85c13.28 0 24.5 14.59 24.5 31.86 0 9.59-3.39 18.64-9.28 24.8L209.01 192H16c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h147.01l-30.67 32H16c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h71.22C72.6 337.52 64 360.37 64 384.14 64 437 103.7 480 152.5 480h73.88c23.85 0 46.84-8.88 64.51-24.9l22.77-20.65c6.54-5.94 7.04-16.06 1.1-22.6l-21.5-23.71c-5.94-6.54-16.06-7.04-22.6-1.1l-22.77 20.66a32.006 32.006 0 0 1-21.5 8.3H152.5c-13.28 0-24.5-14.59-24.5-31.86 0-9.59 3.39-18.64 9.28-24.8L174.99 320H368c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16H220.99l30.67-32H368z"
  ]
};
export const faHumidity = {
  prefix: "far",
  iconName: "humidity",
  icon: [
    384,
    512,
    [],
    "f750",
    "M160 292c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm92 60c-15.5 0-28 12.5-28 28s12.5 28 28 28 28-12.5 28-28-12.5-28-28-28zM223.9 22.1C219.5 7.5 205.8 0 192 0c-13.5 0-27 7.2-31.8 22.1C109.1 179.8 0 222.7 0 333.9 0 432.3 85.9 512 192 512s192-79.7 192-178.1c0-111.7-108.9-153.3-160.1-311.8zM192 464c-79.4 0-144-58.4-144-130.1 0-40.3 19.3-67.6 56.3-116.2 28-36.8 61.8-81.2 87.7-143.5 26 62.6 59.8 106.9 87.9 143.6 36.9 48.3 56.1 75.4 56.1 116 0 71.8-64.6 130.2-144 130.2zm61-196.2l-12.5-10c-3.5-2.8-8.5-2.2-11.2 1.2l-99.5 134c-2.8 3.5-2.2 8.5 1.2 11.2l12.5 10c3.5 2.8 8.5 2.2 11.2-1.2l99.5-134c2.8-3.4 2.2-8.5-1.2-11.2z"
  ]
};
export const faHurricane = {
  prefix: "far",
  iconName: "hurricane",
  icon: [
    384,
    512,
    [],
    "f751",
    "M209.9 89.6l12.3-39c4.1-12.7 1.5-26.5-7-36.7C206.8 3.8 194-1.4 181.3.3 77.9 13.1 0 104.3 0 212.5c0 106 75.6 194.1 174.1 209.9l-12.3 39c-4.1 12.7-1.5 26.4 7 36.7 7.3 8.9 18.1 13.9 29.3 13.9 1.5 0 3.1-.1 4.7-.3C306.1 498.9 384 407.7 384 299.5c0-106-75.6-194-174.1-209.9zm2.2 371.8l26.7-84.4H206c-87.1 0-158-73.8-158-164.5C48 134 100.3 67 171.9 50.6L145.2 135H178c87.1 0 158 73.8 158 164.5 0 78.5-52.3 145.5-123.9 161.9zM192 184c-39.7 0-72 32.3-72 72s32.3 72 72 72 72-32.3 72-72-32.3-72-72-72zm0 96c-13.2 0-24-10.8-24-24s10.8-24 24-24 24 10.8 24 24-10.8 24-24 24z"
  ]
};
export const faICursor = {
  prefix: "far",
  iconName: "i-cursor",
  icon: [
    256,
    512,
    [],
    "f246",
    "M128 41.522C91.867.049 43.399-.377 11.818.076 5.26.17 0 5.516 0 12.075v23.609c0 6.641 5.393 12.037 12.034 12C39.464 47.528 104 52.257 104 104v128H68c-6.627 0-12 5.373-12 12v24c0 6.627 5.373 12 12 12h36v128c0 51.494-62.335 55.801-92.092 55.985C5.314 464.026 0 469.39 0 475.984v23.943c0 6.558 5.258 11.903 11.815 11.999 31.535.46 80.027.054 116.185-41.448 36.132 41.473 84.601 41.899 116.182 41.446 6.558-.094 11.818-5.44 11.818-11.999v-23.608c0-6.641-5.393-12.037-12.034-12C216.538 464.47 152 459.731 152 408V280h36c6.627 0 12-5.373 12-12v-24c0-6.627-5.373-12-12-12h-36V104c0-51.514 62.301-55.805 92.092-55.985C250.686 47.975 256 42.61 256 36.016V12.073C256 5.515 250.742.17 244.185.074 212.65-.386 164.157.02 128 41.522z"
  ]
};
export const faIceCream = {
  prefix: "far",
  iconName: "ice-cream",
  icon: [
    448,
    512,
    [],
    "f810",
    "M380.91 129.3C366.57 55.65 301.85 0 224 0S81.43 55.65 67.09 129.3A79.87 79.87 0 0 0 80 288h.94l92.81 192.13A55.56 55.56 0 0 0 224 512c21.47 0 40.72-12.2 50.25-31.86L367.06 288h.94a79.87 79.87 0 0 0 12.91-158.7zM231 459.25c-3.81 7.87-10.25 7.87-14.06 0L134.25 288h179.5zM368 240H80a32 32 0 0 1-32-32 31.72 31.72 0 0 1 26.83-31.33l33-5.39 6.39-32.82a111.85 111.85 0 0 1 219.58 0l6.39 32.82 33 5.39A31.72 31.72 0 0 1 400 208a32 32 0 0 1-32 32z"
  ]
};
export const faIceSkate = {
  prefix: "far",
  iconName: "ice-skate",
  icon: [
    576,
    512,
    [],
    "f7ac",
    "M568 416h-32c-4.4 0-8 3.6-8 8v16c0 13.3-10.7 24-24 24h-72v-48h16c35.3 0 64-28.7 64-64v-53c0-44.1-30-82.4-72.7-93.1L352 184V8c0-4.4-3.6-8-8-8h-32c-4.4 0-8 3.6-8 8v24h-99.7c-8.1 0-16.2 1.6-23.8 4.6L52.1 88C40 92.8 32 104.6 32 117.7V352c0 35.3 28.7 64 64 64v48H8c-4.4 0-8 3.6-8 8v32c0 4.4 3.6 8 8 8h504c35.3 0 64-28.7 64-64v-24c0-4.4-3.6-8-8-8zM80 352V128.5l118.4-47.4c1.9-.8 3.9-1.1 5.9-1.1H304v48h-72c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h72v32h-72c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h82.1l113.5 28.4C449 257.7 464 276.9 464 299v53c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16zm64 64h240v48H144v-48z"
  ]
};
export const faIcicles = {
  prefix: "far",
  iconName: "icicles",
  icon: [
    512,
    512,
    [],
    "f7ad",
    "M480 0H32C10.6 0-4.8 20.7 1.4 41.2l79.5 235.9c2.5 7.2 8.8 10.9 15.1 10.9 6.3 0 12.7-3.6 15.1-10.9l28.8-86.6 36.4 181.1c1.9 8.3 8.7 12.4 15.6 12.4 6.8 0 13.7-4.1 15.6-12.4l38.7-190.7 26.4 95.7c2.3 7.6 8.8 11.4 15.3 11.4s13-3.8 15.3-11.4l38.1-134.8 58.8 357.4C402 507.7 409 512 416 512s14-4.3 15.7-12.8l79.8-461.3C515.1 18.2 500 0 480 0zM95.8 171.2L54.3 48h82.5l-41 123.2zm103.4.1l-7.1 35L187 181 160.3 48h64l-25.1 123.3zm96.1-42.6l-6.9 24.4-29-105.1h58.7l-22.8 80.7zm121.5 175l-28-169.7-14.2-86H461l-44.2 255.7z"
  ]
};
export const faIcons = {
  prefix: "far",
  iconName: "icons",
  icon: [
    512,
    512,
    [],
    "f86d",
    "M144 343.78a48 48 0 1 0 48 48 48 48 0 0 0-48-48zM101.74 213a37 37 0 0 0 52.36 0l78.56-78.44A79.06 79.06 0 0 0 227 17.49c-28.08-23.13-69.54-22.82-99-.86-29.45-22-71-22.3-99.05.89a79.11 79.11 0 0 0-5.77 117.08zM59.42 54.53A29.54 29.54 0 0 1 78.35 48 35.08 35.08 0 0 1 103 58.32l25 24.89 24.93-24.89c12.25-12.15 31.43-13.83 43.58-3.82a31.09 31.09 0 0 1 2.31 46.15l-70.85 70.71-70.87-70.69a31.13 31.13 0 0 1 2.32-46.14zm337.93 305.24l32.27-69.89a24 24 0 1 0-43.54-20.12l-63.7 138h109.27l-36.92 68.58A24 24 0 1 0 437 499.05l75-139.28zm-141.44-72h-27.42l-7.09-14.17a27.36 27.36 0 0 0-25.64-17.76H92.08a27.39 27.39 0 0 0-25.65 17.76l-7 14.21H32a32 32 0 0 0-32 32V480a32 32 0 0 0 32 32h223.91a32 32 0 0 0 32-32V319.79a32 32 0 0 0-32-31.98zm-16 176.23H48V335.79h41.22l13.21-26.73 2.57-5.26h77.83l2.69 5.4 13.24 26.59h41.13zm112-256V68.24L463.83 51v78.58a84 84 0 0 0-16-1.69c-35.34 0-64 21.47-64 48s28.64 48 64 48 64-21.48 64-48V32c0-17.9-13.54-32-29.64-32a28.08 28.08 0 0 0-4.26.33L329.39 23.17c-14.63 2.25-25.5 15.74-25.5 31.66V161.6a83.25 83.25 0 0 0-16-1.7c-35.33 0-64 21.55-64 48.13s28.64 48.13 64 48.13 63.98-21.55 63.98-48.16z"
  ]
};
export const faIconsAlt = {
  prefix: "far",
  iconName: "icons-alt",
  icon: [
    512,
    512,
    [],
    "f86e",
    "M16 128.33h72v80a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-80h72a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16zm480 164.36a16 16 0 0 0-22.62 0L292.7 473.38a16 16 0 0 0 0 22.62l11.3 11.31a16 16 0 0 0 22.62 0l180.69-180.69a16 16 0 0 0 0-22.62zM16 48h192a16 16 0 0 0 16-16V16a16 16 0 0 0-16-16H16A16 16 0 0 0 0 16v16a16 16 0 0 0 16 16zM482.34 0a28 28 0 0 0-4.25.33L329.52 23.18C314.88 25.44 304 38.94 304 54.86V161.7a83.25 83.25 0 0 0-16-1.7c-35.34 0-64 21.56-64 48.16s28.65 48.17 64 48.17 64-21.57 64-48.17V68.29l112-17.23v78.64a83.25 83.25 0 0 0-16-1.7c-35.34 0-64 21.49-64 48s28.65 48 64 48 64-21.49 64-48V32c0-17.91-13.55-32-29.66-32zM328 368a40 40 0 1 0-40-40 40 40 0 0 0 40 40zm143.67 64a40 40 0 1 0 40 40 40 40 0 0 0-39.99-40zm-266.51 11.21l27.33-16.06a16 16 0 0 0 5.09-22l-8.48-13.57a16 16 0 0 0-22-5.1l-37 21.71-23.32-23.32c21.25-11.72 35.84-34.08 35.84-60A68.79 68.79 0 1 0 45 324.8a68.08 68.08 0 0 0 15.76 43.27l-26 15.66a71.33 71.33 0 0 0-32.33 42.55 67.57 67.57 0 0 0 7.22 52.85c12.72 21.12 35.35 32.78 58.94 32.78A72.6 72.6 0 0 0 106 501.44l56.38-33.12 39 39a16 16 0 0 0 22.63 0L235.33 496a16 16 0 0 0 0-22.62zM80.93 460.52c-10.66 6.43-24.22 3.68-30.16-6.14-5.18-8.66-3.21-22.33 8.72-29.52l37.12-22.32 30.73 30.72zm32.9-114.93a20.8 20.8 0 1 1 20.78-20.79 20.83 20.83 0 0 1-20.78 20.79z"
  ]
};
export const faIdBadge = {
  prefix: "far",
  iconName: "id-badge",
  icon: [
    384,
    512,
    [],
    "f2c1",
    "M336 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zm0 464H48V48h288v416zM144 112h96c8.8 0 16-7.2 16-16s-7.2-16-16-16h-96c-8.8 0-16 7.2-16 16s7.2 16 16 16zm48 176c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm-89.6 128h179.2c12.4 0 22.4-8.6 22.4-19.2v-19.2c0-31.8-30.1-57.6-67.2-57.6-10.8 0-18.7 8-44.8 8-26.9 0-33.4-8-44.8-8-37.1 0-67.2 25.8-67.2 57.6v19.2c0 10.6 10 19.2 22.4 19.2z"
  ]
};
export const faIdCard = {
  prefix: "far",
  iconName: "id-card",
  icon: [
    576,
    512,
    [],
    "f2c2",
    "M528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm0 400H303.2c.9-4.5.8 3.6.8-22.4 0-31.8-30.1-57.6-67.2-57.6-10.8 0-18.7 8-44.8 8-26.9 0-33.4-8-44.8-8-37.1 0-67.2 25.8-67.2 57.6 0 26-.2 17.9.8 22.4H48V144h480v288zm-168-80h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm0-64h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm0-64h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm-168 96c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64z"
  ]
};
export const faIdCardAlt = {
  prefix: "far",
  iconName: "id-card-alt",
  icon: [
    576,
    512,
    [],
    "f47f",
    "M512 64H368V32c0-17.7-14.3-32-32-32h-96c-17.7 0-32 14.3-32 32v32H64C28.7 64 0 92.7 0 128v320c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zM256 48h64v64h-64V48zm272 400c0 8.8-7.2 16-16 16H399.2c.2-1.1.8-2.1.8-3.2v-19.2c0-31.8-30.1-57.6-67.2-57.6-10.8 0-18.7 8-44.8 8-26.9 0-33.4-8-44.8-8-37.1 0-67.2 25.8-67.2 57.6v19.2c0 1.1.5 2.1.8 3.2H64c-8.8 0-16-7.2-16-16V128c0-8.8 7.2-16 16-16h144v48h160v-48h144c8.8 0 16 7.2 16 16v320zM288 224c-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64-28.7-64-64-64z"
  ]
};
export const faIgloo = {
  prefix: "far",
  iconName: "igloo",
  icon: [
    640,
    512,
    [],
    "f7ae",
    "M320 0C146.3 0 4.7 139.3.4 312H0v136c0 35.3 28.7 64 64 64h512c35.3 0 64-28.7 64-64V312h-.4C635.3 139.3 493.7 0 320 0zm243.7 200c16.8 34 26.7 71.9 27.9 112H520V200h43.7zM392 58c56.7 15.6 106 49 141.5 94H392V58zm-72-10c8.1 0 16.1.5 24 1.2V152H106.5C156.4 88.8 233.4 48 320 48zM76.3 200H120v112H48.4c1.2-40.1 11.1-78 27.9-112zM192 384v80H64c-8.8 0-16-7.2-16-16v-88h146.4c-1.5 7.8-2.4 15.8-2.4 24zm208 80H240v-80c0-44.1 35.9-80 80-80s80 35.9 80 80v80zm-80-208c-43.9 0-82.6 22.2-105.7 56H168V200h304v112h-46.3c-23.1-33.8-61.8-56-105.7-56zm272 192c0 8.8-7.2 16-16 16H448v-80c0-8.2-.9-16.2-2.4-24H592v88z"
  ]
};
export const faImage = {
  prefix: "far",
  iconName: "image",
  icon: [
    512,
    512,
    [],
    "f03e",
    "M464 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm-6 336H54a6 6 0 0 1-6-6V118a6 6 0 0 1 6-6h404a6 6 0 0 1 6 6v276a6 6 0 0 1-6 6zM128 152c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zM96 352h320v-80l-87.515-87.515c-4.686-4.686-12.284-4.686-16.971 0L192 304l-39.515-39.515c-4.686-4.686-12.284-4.686-16.971 0L96 304v48z"
  ]
};
export const faImagePolaroid = {
  prefix: "far",
  iconName: "image-polaroid",
  icon: [
    448,
    512,
    [],
    "f8c4",
    "M416 32H32A32 32 0 0 0 0 64v384a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32V64a32 32 0 0 0-32-32zm-16 400H48v-64h352zm0-112h-16l-97.07-121c-7.46-9.31-22.4-9.31-29.86 0l-63.38 79-33.05-45.78c-7.92-11-25.36-11-33.28 0L64 320H48V80h352zM144 176a32 32 0 1 0-32-32 32 32 0 0 0 32 32z"
  ]
};
export const faImages = {
  prefix: "far",
  iconName: "images",
  icon: [
    576,
    512,
    [],
    "f302",
    "M480 416v16c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V176c0-26.51 21.49-48 48-48h16v48H54a6 6 0 0 0-6 6v244a6 6 0 0 0 6 6h372a6 6 0 0 0 6-6v-10h48zm42-336H150a6 6 0 0 0-6 6v244a6 6 0 0 0 6 6h372a6 6 0 0 0 6-6V86a6 6 0 0 0-6-6zm6-48c26.51 0 48 21.49 48 48v256c0 26.51-21.49 48-48 48H144c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h384zM264 144c0 22.091-17.909 40-40 40s-40-17.909-40-40 17.909-40 40-40 40 17.909 40 40zm-72 96l39.515-39.515c4.686-4.686 12.284-4.686 16.971 0L288 240l103.515-103.515c4.686-4.686 12.284-4.686 16.971 0L480 208v80H192v-48z"
  ]
};
export const faInbox = {
  prefix: "far",
  iconName: "inbox",
  icon: [
    576,
    512,
    [],
    "f01c",
    "M567.403 235.642L462.323 84.589A48 48 0 0 0 422.919 64H153.081a48 48 0 0 0-39.404 20.589L8.597 235.642A48.001 48.001 0 0 0 0 263.054V400c0 26.51 21.49 48 48 48h480c26.51 0 48-21.49 48-48V263.054c0-9.801-3-19.366-8.597-27.412zM153.081 112h269.838l77.913 112H378.334l-32 64H229.666l-32-64H75.168l77.913-112zM528 400H48V272h120l32 64h176l32-64h120v128z"
  ]
};
export const faInboxIn = {
  prefix: "far",
  iconName: "inbox-in",
  icon: [
    576,
    512,
    [],
    "f310",
    "M395.5 185.5l-99 99c-4.7 4.7-12.3 4.7-17 0l-99-99c-7.6-7.6-2.2-20.5 8.5-20.5h67V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v153h67c10.7 0 16.1 12.9 8.5 20.5zM528 352H408l-32 64H200l-32-64H48v112h480V352zm48 2.2V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V354.2c0-11.8 4.3-23.1 12.1-31.9l101.6-114.2c2.3-2.6 4.9-4.9 7.7-7 2.4-1.7 5.6-1.4 7.7.7l24.8 24.9c2.2 2.2 2.3 5.9.2 8.2L92.7 304h105l32 64h116.7l32-64h105L422 234.9c-2.1-2.4-2-5.9.2-8.2l24.6-25c2-2.1 5.3-2.4 7.7-.7 2.9 2.1 5.5 4.4 7.9 7.1L564 322.3c7.7 8.8 12 20.2 12 31.9z"
  ]
};
export const faInboxOut = {
  prefix: "far",
  iconName: "inbox-out",
  icon: [
    576,
    512,
    [],
    "f311",
    "M180.5 102.5l99-99c4.7-4.7 12.3-4.7 17 0l99 99c7.6 7.6 2.2 20.5-8.5 20.5h-67v153c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12V123h-67c-10.7 0-16.1-12.9-8.5-20.5zM576 354.2V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V354.2c0-11.8 4.3-23.1 12.1-31.9l101.6-114.2c9.1-10.2 22.2-16.1 35.9-16.1H202c3.3 0 6 2.7 6 6v36c0 3.3-2.7 6-6 6h-52.4l-56.9 64h105l32 64h116.7l32-64h105l-56.9-64H374c-3.3 0-6-2.7-6-6v-36c0-3.3 2.7-6 6-6h52.4c13.7 0 26.8 5.9 35.9 16.1l101.6 114.2c7.8 8.8 12.1 20.2 12.1 31.9zm-48-2.2H408l-32 64H200l-32-64H48v112h480V352z"
  ]
};
export const faIndent = {
  prefix: "far",
  iconName: "indent",
  icon: [
    448,
    512,
    [],
    "f03c",
    "M432 424H16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zM27.31 363.3l96-96a16 16 0 0 0 0-22.62l-96-96C17.27 138.66 0 145.78 0 160v192c0 14.31 17.33 21.3 27.31 11.3zM435.17 168H204.83A12.82 12.82 0 0 0 192 180.83v22.34A12.82 12.82 0 0 0 204.83 216h230.34A12.82 12.82 0 0 0 448 203.17v-22.34A12.82 12.82 0 0 0 435.17 168zM432 48H16A16 16 0 0 0 0 64v16a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V64a16 16 0 0 0-16-16zm3.17 248H204.83A12.82 12.82 0 0 0 192 308.83v22.34A12.82 12.82 0 0 0 204.83 344h230.34A12.82 12.82 0 0 0 448 331.17v-22.34A12.82 12.82 0 0 0 435.17 296z"
  ]
};
export const faIndustry = {
  prefix: "far",
  iconName: "industry",
  icon: [
    512,
    512,
    [],
    "f275",
    "M475.115 163.723L336 252.251v-68.28c0-18.916-20.931-30.399-36.885-20.248L160 252.251V56c0-13.255-10.745-24-24-24H24C10.745 32 0 42.745 0 56v400c0 13.255 10.745 24 24 24h464c13.255 0 24-10.745 24-24V183.971c0-18.917-20.931-30.399-36.885-20.248zM464 432H48V80h64v215.971c0 18.916 20.931 30.399 36.885 20.248L288 227.691v68.28c0 18.915 20.931 30.399 36.885 20.248L464 227.691V432z"
  ]
};
export const faIndustryAlt = {
  prefix: "far",
  iconName: "industry-alt",
  icon: [
    512,
    512,
    [],
    "f3b3",
    "M475.115 131.752L336 220.28V152c0-18.916-20.931-30.399-36.885-20.248L160 220.28V56c0-13.255-10.745-24-24-24H24C10.745 32 0 42.745 0 56v400c0 13.255 10.745 24 24 24h464c13.255 0 24-10.745 24-24V152c0-18.917-20.931-30.399-36.885-20.248zM464 432H48V80h64v184c0 18.916 20.931 30.399 36.885 20.248L288 195.72V264c0 18.915 20.931 30.399 36.885 20.248L464 195.72V432zm-60-48h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12zm-128 0h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12zm-128 0h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12z"
  ]
};
export const faInfinity = {
  prefix: "far",
  iconName: "infinity",
  icon: [
    640,
    512,
    [],
    "f534",
    "M484.4 96C407 96 349.3 164.1 320 208.5 290.7 164.1 233 96 155.6 96 69.8 96 0 167.8 0 256s69.8 160 155.6 160c77.5 0 135.1-68.1 164.4-112.5C349.3 347.9 407 416 484.4 416c85.8 0 155.6-71.8 155.6-160S570.2 96 484.4 96zM155.6 368C96.2 368 48 317.8 48 256s48.2-112 107.6-112c67.8 0 120.5 82.3 137.2 112-16.8 29.7-69.4 112-137.2 112zm328.8 0c-67.8 0-120.5-82.3-137.2-112 16.8-29.7 69.4-112 137.2-112 59.3 0 107.6 50.2 107.6 112s-48.2 112-107.6 112z"
  ]
};
export const faInfo = {
  prefix: "far",
  iconName: "info",
  icon: [
    256,
    512,
    [],
    "f129",
    "M224 352.589V224c0-16.475-6.258-31.517-16.521-42.872C225.905 161.14 236 135.346 236 108 236 48.313 187.697 0 128 0 68.313 0 20 48.303 20 108c0 20.882 5.886 40.859 16.874 58.037C15.107 176.264 0 198.401 0 224v39.314c0 23.641 12.884 44.329 32 55.411v33.864C12.884 363.671 0 384.359 0 408v40c0 35.29 28.71 64 64 64h128c35.29 0 64-28.71 64-64v-40c0-23.641-12.884-44.329-32-55.411zM128 48c33.137 0 60 26.863 60 60s-26.863 60-60 60-60-26.863-60-60 26.863-60 60-60zm80 400c0 8.836-7.164 16-16 16H64c-8.836 0-16-7.164-16-16v-40c0-8.836 7.164-16 16-16h16V279.314H64c-8.836 0-16-7.164-16-16V224c0-8.836 7.164-16 16-16h96c8.836 0 16 7.164 16 16v168h16c8.836 0 16 7.164 16 16v40z"
  ]
};
export const faInfoCircle = {
  prefix: "far",
  iconName: "info-circle",
  icon: [
    512,
    512,
    [],
    "f05a",
    "M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 448c-110.532 0-200-89.431-200-200 0-110.495 89.472-200 200-200 110.491 0 200 89.471 200 200 0 110.53-89.431 200-200 200zm0-338c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z"
  ]
};
export const faInfoSquare = {
  prefix: "far",
  iconName: "info-square",
  icon: [
    448,
    512,
    [],
    "f30f",
    "M448 80v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48zm-48 346V86a6 6 0 0 0-6-6H54a6 6 0 0 0-6 6v340a6 6 0 0 0 6 6h340a6 6 0 0 0 6-6zM224 118c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z"
  ]
};
export const faInhaler = {
  prefix: "far",
  iconName: "inhaler",
  icon: [
    640,
    512,
    [],
    "f5f9",
    "M128 400c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm-96 48c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm0-96c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm0-96c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm96 48c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm281.19-192.18c-3.21-3.21-7.26-4.7-11.25-4.7-6.87 0-13.56 4.39-15.54 11.95L346.49 256H224c-17.67 0-32 14.33-32 32v192c0 17.67 14.33 32 32 32h270.62c29.09 0 54.53-19.62 61.91-47.76l37.96-144.71c2.88-11-.28-22.71-8.32-30.75L409.19 111.82zM510.1 452.06c-1.84 7.03-8.21 11.94-15.48 11.94H240V304h143.53l9.39-35.82 21.77-82.99 131.04 131.04-35.63 135.83zM616.27 38.02L478.47 1.1c-2.77-.74-5.56-1.1-8.3-1.1-14.13 0-27.06 9.43-30.89 23.72l-15.41 57.52 39.19 39.19 18.45-68.83L588.4 80.24l-34.98 130.55 39.19 39.19L638.9 77.21c4.58-17.07-5.55-34.61-22.63-39.19z"
  ]
};
export const faIntegral = {
  prefix: "far",
  iconName: "integral",
  icon: [
    384,
    512,
    [],
    "f667",
    "M340.18 58.73C325.55 41.75 303.85 32 280.67 32c-35.78 0-66.49 22.94-74.62 55.78l-80.66 325.25C122.67 424.02 111.57 432 99 432c-8.3 0-16.31-3.53-21.41-9.44l-35.66-41.45c-5.84-6.79-16.27-7.71-23.29-2.06l-12.7 10.24c-7.01 5.65-7.96 15.74-2.13 22.53l35.67 41.47C54.12 470.27 75.82 480 99 480c35.78 0 66.49-22.94 74.62-55.78l80.66-325.25C257 87.98 268.11 80 280.67 80c8.3 0 16.31 3.53 21.41 9.44l39.99 46.53c5.84 6.79 16.27 7.72 23.29 2.07l12.69-10.22c7.02-5.65 7.97-15.74 2.14-22.53l-40.01-46.56z"
  ]
};
export const faIntersection = {
  prefix: "far",
  iconName: "intersection",
  icon: [
    320,
    512,
    [],
    "f668",
    "M48 432V227.22c0-53.45 36.12-102.08 88.48-112.81C208.46 99.67 272 154.56 272 224v208c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V231.14c0-83.51-60.89-158.24-144.01-166.35C80.62 55.47 0 130.5 0 224v208c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16z"
  ]
};
export const faInventory = {
  prefix: "far",
  iconName: "inventory",
  icon: [
    640,
    512,
    [],
    "f480",
    "M624 0h-16c-8.8 0-16 7.2-16 16v144h-48V16c0-8.8-7.2-16-16-16H336c-8.8 0-16 7.2-16 16v144H48V16c0-8.8-7.2-16-16-16H16C7.2 0 0 7.2 0 16v496h48v-32h544v32h48V16c0-8.8-7.2-16-16-16zM368 48h128v112H368V48zM144 432V304h120v128H144zm168 0V304h120v128H312zm168 0V272c0-8.8-7.2-16-16-16H112c-8.8 0-16 7.2-16 16v160H48V208h544v224H480z"
  ]
};
export const faIslandTropical = {
  prefix: "far",
  iconName: "island-tropical",
  icon: [
    448,
    512,
    [],
    "f811",
    "M336.53 32a125.17 125.17 0 0 0-65 17.87C249.61 20.28 207.89 0 159.39 0 94.9 0 41.49 35.43 32.21 81.64 30.71 89.09 37.4 96 46.4 96H80l16-32 19 37.91c-6.27 9.6-11.45 19.63-14.53 30.14-8.18 27.9-4.92 59.59 21.76 89.32a8.26 8.26 0 0 0 11.74.35l66.65-68.67c-5.77 76.67-32.31 153.22-51 199H128A128 128 0 0 0 0 482.08C.28 498.93 15.14 512 32 512h320c16.84 0 31.71-13 32-29.88 1-60.75-40.53-111.58-96.62-125.79C308.51 248 297.19 139.47 295.9 128H368l16-32 16 32h35.4a12.38 12.38 0 0 0 12.42-14.36C439.69 67.43 393 32 336.53 32zm-87.47 118.16l.66.11c2.7 35.85 5.82 120.48-10.87 201.73h-37.68c19.52-51 43.18-126.26 47.89-201.84zM334.39 464H49.61A80.14 80.14 0 0 1 128 400h128a80.14 80.14 0 0 1 78.39 64z"
  ]
};
export const faItalic = {
  prefix: "far",
  iconName: "italic",
  icon: [
    320,
    512,
    [],
    "f033",
    "M320 48v16a16 16 0 0 1-16 16h-67l-88 352h59a16 16 0 0 1 16 16v16a16 16 0 0 1-16 16H16a16 16 0 0 1-16-16v-16a16 16 0 0 1 16-16h67l88-352h-59a16 16 0 0 1-16-16V48a16 16 0 0 1 16-16h192a16 16 0 0 1 16 16z"
  ]
};
export const faJackOLantern = {
  prefix: "far",
  iconName: "jack-o-lantern",
  icon: [
    576,
    512,
    [],
    "f30e",
    "M494.59 104.28C455.6 67.15 396.8 62.07 352 89V35.81c0-6.06-3.42-11.6-8.84-14.31l-39.6-19.8c-8.37-4.19-18.54-.32-22.01 8.37l-26.7 66.74c-10.24 2.99-20.02 7.37-28.85 13.23-45.03-28.27-105.03-23.42-144.59 14.25C28.91 154.28 0 220.94 0 292s28.91 137.72 81.41 187.73c37.66 35.8 95.62 42.53 141.09 16.3 2.16-1.23 4.91-1.08 7.41.39C247.06 506.75 266.62 512 288 512s40.94-5.25 58.09-15.58c2.53-1.47 5.28-1.62 7.41-.39 45.44 26.23 103.41 19.52 141.09-16.31C547.09 429.72 576 363.06 576 292s-28.91-137.72-81.41-187.72zm-33.12 340.67c-22.28 21.27-56.88 25.16-83.97 9.52-17.28-10-38.81-9.59-56.16.83-19.44 11.72-47.25 11.72-66.69 0-17.41-10.48-38.94-10.81-56.16-.83-27.16 15.64-61.69 11.75-83.97-9.5C71.62 404.11 48 349.8 48 292s23.62-112.11 66.53-152.97c13.19-12.56 30.72-18.87 48.28-18.87 17.12 0 34.25 5.98 47.44 17.97l16.59 15.09 16.19-15.53c24.75-23.81 65.19-23.81 89.94 0l16.19 15.53 16.59-15.09c26.72-24.25 69.69-23.89 95.72.91C504.38 179.89 528 234.2 528 292s-23.62 112.11-66.53 152.95zM249.15 272c2.85 0 4.86-1.11 6-3.33s1.14-4.44 0-6.67L214 195.33c-1.71-2.23-3.86-3.33-6.43-3.33s-4.43 1.11-5.57 3.33L160.85 262c-1.14 2.23-1.14 4.44 0 6.67s3.15 3.33 6 3.33h82.3zm160 0c2.85 0 4.86-1.11 6-3.33s1.14-4.44 0-6.67L374 195.33c-1.71-2.23-3.86-3.33-6.43-3.33s-4.43 1.11-5.57 3.33L320.85 262c-1.14 2.23-1.14 4.44 0 6.67s3.15 3.33 6 3.33h82.3zm37.4 18.27c-45.82 27.05-100.16 42.79-158.54 42.79h-.02v14.26c0 8.84-7.16 16-16 16h-16c-8.84 0-16-7.16-16-16v-18.18c-40.08-6.1-77.53-19.4-110.47-38.84-12.68-7.48-28.11 4.78-23.24 18.67 6.02 17.15 12.92 28.87 19.04 37.46 9.21 12.72 21.04 23.43 34.75 32.51.21-8.65 7.22-15.63 15.92-15.63h16c8.84 0 16 7.16 16 16v21.49c23.45 6.86 50.17 10.51 80.02 10.51 29.83 0 56.52-3.64 79.98-10.52v-21.48c0-8.84 7.16-16 16-16h16c8.68 0 15.66 6.93 15.91 15.55 13.85-9.19 25.81-20.04 35.19-32.99 5.95-8.35 12.75-19.93 18.7-36.96 4.86-13.88-10.57-26.12-23.24-18.64z"
  ]
};
export const faJedi = {
  prefix: "far",
  iconName: "jedi",
  icon: [
    576,
    512,
    [],
    "f669",
    "M560,241.23438C560,390.53125,437.94015,512,287.91215,512q-6.37486,0-12.84347-.29688C136.22793,505.34375,22.4804,392.125,16.10554,253.95312c-.28125-6.29687.18749-12.48437.31249-18.71874a15.86953,15.86953,0,0,1,.125-7.75,269.32041,269.32041,0,0,1,113.90378-207,23.736,23.736,0,0,1,13.7497-4.42188,24.13055,24.13055,0,0,1,19.93707,10.64062A23.88407,23.88407,0,0,1,166.53978,49a126.06575,126.06575,0,0,0-8.96856,46.65625c0,41.10937,19.18709,78.90625,52.62386,103.67187a24.03259,24.03259,0,0,1,1.81246,37.375c-23.99948,21.67188-37.21794,51.03126-37.21794,82.6875,0,51.90626,35.718,95.26563,83.87318,108.17188l2.2187-57.26562-20.6558,14.03124a12.34237,12.34237,0,0,1-14.99967-1.17187,12.00668,12.00668,0,0,1-2.06246-14.875l17.28088-28.9375-36.593-7.57813a12.00026,12.00026,0,0,1,0-23.5l36.593-7.59374L223.16355,271.75a11.99745,11.99745,0,0,1,17.06213-16.0625l24.46822,16.60938L275.91241,11.51562a12.00927,12.00927,0,0,1,23.99948.03126l11.2185,260.71874,24.46822-16.60937a12.08736,12.08736,0,0,1,14.99968,1.1875,13.74639,13.74639,0,0,1,3.74992,8.70313,14.18111,14.18111,0,0,1-1.68747,6.15624l-17.24962,28.9375,36.56171,7.59376a12.00026,12.00026,0,0,1,0,23.5l-36.56171,7.57812,17.24962,28.92188a12.001,12.001,0,0,1-2.06245,14.875,12.28459,12.28459,0,0,1-14.99968,1.1875l-20.6558-14.03126,2.2187,57.57813c40.74912-10.51563,73.15467-43.89063,81.52949-85.375A111.53351,111.53351,0,0,0,363.81675,236.6875a24.04957,24.04957,0,0,1,1.81246-37.39062C399.066,174.53125,418.22182,136.75,418.22182,95.64062a126.30747,126.30747,0,0,0-8.96855-46.70312,23.934,23.934,0,0,1,36.03047-28.53125A270.72551,270.72551,0,0,1,559.125,226.84375a15.84287,15.84287,0,0,1,.46874,7.64063C559.65626,236.75,560,238.95312,560,241.23438Zm-452.1152,57.3125a15.98428,15.98428,0,0,1-22.562,1.51562L68.6044,285.4375c12.781,62.125,51.90513,115.4375,105.279,147.20312a158.932,158.932,0,0,1-12.406-212.03124,174.82519,174.82519,0,0,1-51.62388-114.625c-14.156,18.39062-24.812,39.0625-32.59305,60.82812l29.9056,29.875a15.99812,15.99812,0,1,1-22.62451,22.625L67.85442,202.65625a220.57569,220.57569,0,0,0-3.24993,36.75l41.78034,36.54687A15.992,15.992,0,0,1,107.8848,298.54688ZM507.00115,285.625l-16.49964,14.4375a16.00682,16.00682,0,0,1-21.062-24.10938l42.34284-37.03124a219.80562,219.80562,0,0,0-3.46868-36.625L491.28274,219.3125a15.9926,15.9926,0,0,1-22.62451-22.60938l30.06185-30.0625A223.23012,223.23012,0,0,0,465.93954,106.125a174.70091,174.70091,0,0,1-51.59263,114.45312c29.24936,36.70313,40.90536,84.14063,31.40557,131.375a159.13826,159.13826,0,0,1-43.87405,81.03126A223.24987,223.24987,0,0,0,507.00115,285.625Z"
  ]
};
export const faJoint = {
  prefix: "far",
  iconName: "joint",
  icon: [
    640,
    512,
    [],
    "f595",
    "M476.34 181.1c22.38 15.68 35.66 41.16 35.66 68.59V280c0 4.42 3.58 8 8 8h32c4.42 0 8-3.58 8-8v-30.31c0-43.24-21.01-83.41-56.34-108.06C479.85 125.02 464 99.34 464 70.31V8c0-4.42-3.58-8-8-8h-32c-4.42 0-8 3.58-8 8v66.4c0 43.69 24.56 81.63 60.34 106.7zm76.94-94.01c-5.67-3.8-9.28-9.96-9.28-16.78V8c0-4.42-3.58-8-8-8h-32c-4.42 0-8 3.58-8 8v62.31c0 22.02 10.17 43.41 28.64 55.39C566.79 153.04 592 199.54 592 249.69V280c0 4.42 3.58 8 8 8h32c4.42 0 8-3.58 8-8v-30.31c0-65.44-32.41-126.19-86.72-162.6zM616 352H278.94C180.3 352 83.65 379.72 0 432c83.65 52.28 180.3 80 278.94 80H616c13.25 0 24-10.75 24-24V376c0-13.26-10.75-24-24-24zM278.94 464c-59.16 0-117.42-10.93-172.06-32 49.28-19.01 101.56-29.28 154.74-31.2l54.19 63.2h-36.87zm100.11 0l-54.88-64h96.77l54.88 64h-96.77zM592 464h-52.95l-54.88-64H592v64z"
  ]
};
export const faJournalWhills = {
  prefix: "far",
  iconName: "journal-whills",
  icon: [
    448,
    512,
    [],
    "f66a",
    "M435.09375,399.70312c-4.1875,13-4.1875,51.59376,0,64.59376A16.0064,16.0064,0,0,1,448,480v16a16.0612,16.0612,0,0,1-16,16H80A79.964,79.964,0,0,1,0,432V80A79.964,79.964,0,0,1,80,0H432a16.0612,16.0612,0,0,1,16,16V384A15.9909,15.9909,0,0,1,435.09375,399.70312ZM400,48H80A31.9517,31.9517,0,0,0,48,80V358.70312A79.33472,79.33472,0,0,1,80,352H400Zm-6,352H80a32,32,0,0,0,0,64H394C391.28125,446.70312,391.28125,417.29688,394,400ZM116.125,201.46875c0-.34375-.125-.6875-.125-1.04687a113.9228,113.9228,0,0,1,4.65625-31.9375l17.6875,17.6875a7.99915,7.99915,0,0,0,11.3125-11.3125L126.9375,152.15625a122.208,122.208,0,0,1,52.875-55.6875,4.02047,4.02047,0,0,1,4.84376.79687,4.06586,4.06586,0,0,1,.4375,4.89063,60.044,60.044,0,0,0-9.65626,32.25c0,14.28125,5.18751,27.79687,15,39.10937a4.01624,4.01624,0,0,1,.25,4.92188A59.86683,59.86683,0,0,0,227.375,271.125H228V243.3125l-6.34375,6.34375a7.99915,7.99915,0,0,1-11.3125-11.3125L220.68749,228H208a8,8,0,0,1,0-16h12.68749l-10.34374-10.34375a7.99915,7.99915,0,0,1,11.3125-11.3125L228,196.6875V100a12,12,0,0,1,24,0v96.6875l6.34375-6.34375a7.99915,7.99915,0,0,1,11.3125,11.3125L259.31249,212H272a8,8,0,0,1,0,16H259.31249l10.34376,10.35938a7.99915,7.99915,0,1,1-11.3125,11.3125L252,243.32812v27.82813h.65625a59.88671,59.88671,0,0,0,36.65624-92.70313,3.99355,3.99355,0,0,1,.25-4.90624c9.81251-11.3125,15-24.84376,15-39.125a60.044,60.044,0,0,0-9.65624-32.25,4.78239,4.78239,0,0,1-.625-2.15626,4.60792,4.60792,0,0,1,1.0625-2.71874,3.98087,3.98087,0,0,1,4.84374-.8125,122.44378,122.44378,0,0,1,52.875,55.6875L330.34375,174.875a7.99915,7.99915,0,0,0,11.3125,11.3125L359.34375,168.5A112.796,112.796,0,0,1,364,200.4375c0,.35938-.125.6875-.125,1.04688l-33.15625,29.03124A9.11316,9.11316,0,0,0,328,236.53125a9.24745,9.24745,0,0,0,1.96875,5.26563,8.03814,8.03814,0,0,0,11.3125.75l20.03124-17.53126C349.5,279.1875,299.625,320,240,320s-109.53125-40.8125-121.3125-94.96875l20.03125,17.51563a8.005,8.005,0,1,0,10.5625-12.03126Z"
  ]
};
export const faJoystick = {
  prefix: "far",
  iconName: "joystick",
  icon: [
    448,
    512,
    [],
    "f8c5",
    "M416 352H248V221.28a112 112 0 1 0-48 0V352h-72v-16a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v16H32a32 32 0 0 0-32 32v96a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32v-96a32 32 0 0 0-32-32zM160 112a64 64 0 1 1 64 64 64.07 64.07 0 0 1-64-64zm240 352H48v-64h352z"
  ]
};
export const faJug = {
  prefix: "far",
  iconName: "jug",
  icon: [
    448,
    512,
    [],
    "f8c6",
    "M304 288H144a32 32 0 0 0-32 32v64a32 32 0 0 0 32 32h160a32 32 0 0 0 32-32v-64a32 32 0 0 0-32-32zm144-120a72 72 0 0 0-72-72 70.93 70.93 0 0 0-54.58 25.77l-10.41-13a32 32 0 0 1-7-20V48a16 16 0 0 0 16-16V16A16 16 0 0 0 304 0H144a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16v40.78a32 32 0 0 1-7 20l-76.95 96.16a128 128 0 0 0-28 80V448a64 64 0 0 0 64 64H352a64 64 0 0 0 64-64V284.9a127.59 127.59 0 0 0-11.1-51A72 72 0 0 0 448 168zm-80 280a16 16 0 0 1-16 16H96a16 16 0 0 1-16-16V284.9a80.32 80.32 0 0 1 17.53-50l76.94-96.17a80.31 80.31 0 0 0 17.53-50V48h64v40.78a80.31 80.31 0 0 0 17.53 50l76.94 96.17a80.34 80.34 0 0 1 17.53 50zm9.38-256.28l-24.09-30.1C356.14 151.54 365 144 376 144a23.88 23.88 0 0 1 1.38 47.72z"
  ]
};
export const faKaaba = {
  prefix: "far",
  iconName: "kaaba",
  icon: [
    576,
    512,
    [],
    "f66b",
    "M554.12 83.51L318.36 4.93C308.51 1.64 298.25 0 288 0s-20.51 1.64-30.36 4.93L21.88 83.51A32.006 32.006 0 0 0 0 113.87v310.8c0 15 10.42 27.98 25.06 31.24l242.12 53.8c6.86 1.53 13.84 2.29 20.83 2.29s13.97-.76 20.83-2.29l242.12-53.8c14.64-3.25 25.06-16.24 25.06-31.24v-310.8c-.02-13.77-8.83-26-21.9-30.36zM528 248.87l-69.89-19.06c-5.09-1.39-10.11 2.44-10.11 7.72v16.58c0 3.61 2.41 6.77 5.89 7.72L528 282.04v129.8l-229.59 51.02c-4.1.91-11.66 2.03-20.83 0L48 411.84v-129.8l74.11-20.21a7.997 7.997 0 0 0 5.89-7.72v-16.58c0-5.28-5.02-9.11-10.11-7.72L48 248.87v-34.63l228.56-68.55c7.41-2.28 15.38-2.25 22.91 0L528 214.24v34.63zm0-84.74L313.31 99.72c-16.56-4.97-34.03-5-50.59 0L48 164.13V125.4l224.82-74.94c5.68-1.9 17.04-4.44 30.36 0L528 125.4v38.73zm-266.11 26.41l-96 26.18a7.997 7.997 0 0 0-5.89 7.72v16.58c0 5.28 5.02 9.11 10.11 7.72l96-26.18a7.997 7.997 0 0 0 5.89-7.72v-16.57c0-5.29-5.02-9.12-10.11-7.73zm48 32.01l96 26.18c5.09 1.39 10.11-2.44 10.11-7.72v-16.58c0-3.61-2.41-6.77-5.89-7.72l-96-26.18c-5.09-1.39-10.11 2.44-10.11 7.72v16.57a8 8 0 0 0 5.89 7.73z"
  ]
};
export const faKazoo = {
  prefix: "far",
  iconName: "kazoo",
  icon: [
    640,
    512,
    [],
    "f8c7",
    "M608 128H480.68c-19.53-9.89-41.29-16-64.68-16s-45.15 6.11-64.68 16H241.93a128.3 128.3 0 0 0-35.17 4.92L23.21 185.37A32 32 0 0 0 0 216.14v79.72a32 32 0 0 0 23.21 30.77l183.55 52.44a127.93 127.93 0 0 0 35.17 4.93h109.39c19.53 9.89 41.29 16 64.68 16s45.15-6.11 64.68-16H608a32 32 0 0 0 32-32V160a32 32 0 0 0-32-32zM296.32 336h-54.39a80.08 80.08 0 0 1-22-3.08L48 283.79v-55.58l172-49.13a80.08 80.08 0 0 1 22-3.08h54.39a143.74 143.74 0 0 0 0 160zM416 352a96 96 0 1 1 96-96 96.1 96.1 0 0 1-96 96zm176-16h-56.32a143.74 143.74 0 0 0 0-160H592zM466.91 216.4l-11.31-11.31a8 8 0 0 0-11.32 0L416 233.37l-28.28-28.28a8 8 0 0 0-11.32 0l-11.31 11.31a8 8 0 0 0 0 11.31L393.37 256l-28.28 28.28a8 8 0 0 0 0 11.32l11.31 11.31a8 8 0 0 0 11.32 0L416 278.63l28.28 28.28a8 8 0 0 0 11.32 0l11.31-11.31a8 8 0 0 0 0-11.32L438.63 256l28.28-28.29a8 8 0 0 0 0-11.31z"
  ]
};
export const faKerning = {
  prefix: "far",
  iconName: "kerning",
  icon: [
    640,
    512,
    [],
    "f86f",
    "M416.54 0h-17A8 8 0 0 0 392 5.32l-176.28 496a8 8 0 0 0 7.55 10.68h17a8 8 0 0 0 7.54-5.32l176.29-496A8 8 0 0 0 416.54 0zm206.25 393.94l-103.91-288A16 16 0 0 0 504.07 96h-48.14a16 16 0 0 0-14.81 9.94l-103.91 288A16 16 0 0 0 352 416h25.92a16 16 0 0 0 14.81-9.94l19.1-54.06h136.34l19.08 54.06a16 16 0 0 0 14.81 9.94H608a16 16 0 0 0 14.79-22.06zM434.42 288L480 158.84 525.59 288zM288 96h-25.94a16 16 0 0 0-14.81 9.94L160 353.16 72.75 105.94A16 16 0 0 0 57.94 96H32a16 16 0 0 0-14.81 22.06l103.91 288a16 16 0 0 0 14.83 9.94h48.14a16 16 0 0 0 14.81-9.94l103.91-288A16 16 0 0 0 288 96z"
  ]
};
export const faKey = {
  prefix: "far",
  iconName: "key",
  icon: [
    512,
    512,
    [],
    "f084",
    "M320 48c79.529 0 144 64.471 144 144s-64.471 144-144 144c-18.968 0-37.076-3.675-53.66-10.339L224 368h-32v48h-48v48H48v-96l134.177-134.177A143.96 143.96 0 0 1 176 192c0-79.529 64.471-144 144-144m0-48C213.965 0 128 85.954 128 192c0 8.832.602 17.623 1.799 26.318L7.029 341.088A24.005 24.005 0 0 0 0 358.059V488c0 13.255 10.745 24 24 24h144c13.255 0 24-10.745 24-24v-24h24c13.255 0 24-10.745 24-24v-20l40.049-40.167C293.106 382.604 306.461 384 320 384c106.035 0 192-85.954 192-192C512 85.965 426.046 0 320 0zm0 144c0 26.51 21.49 48 48 48s48-21.49 48-48-21.49-48-48-48-48 21.49-48 48z"
  ]
};
export const faKeySkeleton = {
  prefix: "far",
  iconName: "key-skeleton",
  icon: [
    512,
    512,
    [],
    "f6f3",
    "M313.5 153.27c-12.49 12.49-12.49 32.74 0 45.23 12.49 12.49 32.74 12.49 45.23 0 12.49-12.49 12.49-32.74 0-45.23-12.49-12.49-32.74-12.49-45.23 0zm63.96-63.96c-12.49 12.49-12.49 32.74 0 45.23 12.49 12.49 32.74 12.49 45.23 0 12.49-12.49 12.49-32.74 0-45.23-12.49-12.49-32.74-12.49-45.23 0zM448.04 0H288.15c-35.32 0-63.96 28.64-63.96 63.96v159.89c0 8.86 1.81 17.3 5.07 24.97L4.68 473.4c-6.24 6.24-6.24 16.37 0 22.61l11.3 11.3c6.24 6.24 16.37 6.24 22.61 0l38.79-38.79 38.31 38.31c6.24 6.24 16.37 6.24 22.61 0l43.13-43.13c6.24-6.24 6.24-16.37 0-22.61l-38.31-38.31 30.86-30.86 39.12 39.12c6.24 6.25 16.37 6.25 22.61 0l15.76-15.76c6.24-6.24 6.24-16.37 0-22.61l-39.12-39.12 50.81-50.81a63.69 63.69 0 0 0 24.97 5.07h159.89c35.32 0 63.96-28.64 63.96-63.96V63.96C512 28.64 483.37 0 448.04 0zm15.99 223.85c0 8.82-7.17 15.99-15.99 15.99H288.15c-8.82 0-15.99-7.17-15.99-15.99V63.96c0-8.82 7.17-15.99 15.99-15.99h159.89c8.82 0 15.99 7.17 15.99 15.99v159.89z"
  ]
};
export const faKeyboard = {
  prefix: "far",
  iconName: "keyboard",
  icon: [
    576,
    512,
    [],
    "f11c",
    "M528 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h480c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm8 336c0 4.411-3.589 8-8 8H48c-4.411 0-8-3.589-8-8V112c0-4.411 3.589-8 8-8h480c4.411 0 8 3.589 8 8v288zM170 270v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm96 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm96 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm96 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm-336 82v-28c0-6.627-5.373-12-12-12H82c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm384 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zM122 188v-28c0-6.627-5.373-12-12-12H82c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm96 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm96 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm96 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm96 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm-98 158v-16c0-6.627-5.373-12-12-12H180c-6.627 0-12 5.373-12 12v16c0 6.627 5.373 12 12 12h216c6.627 0 12-5.373 12-12z"
  ]
};
export const faKeynote = {
  prefix: "far",
  iconName: "keynote",
  icon: [
    512,
    512,
    [],
    "f66c",
    "M505.24 274.49l-48.4-96.8A32 32 0 0 0 428.22 160H144c0-33.85 21.22-62.7 52.02-74.36C204.92 110.28 228.29 128 256 128h32c35.35 0 64-28.65 64-64S323.35 0 288 0h-32c-24.63 0-45.77 14.07-56.47 34.47C140.63 45.94 96 97.8 96 160H83.78a32 32 0 0 0-28.62 17.69l-48.4 96.8A63.874 63.874 0 0 0 0 303.11V352c0 17.67 14.33 32 32 32h200v80h-88c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h224c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16h-88v-80h200c17.67 0 32-14.33 32-32v-48.89c0-9.94-2.31-19.74-6.76-28.62zM256 48h32c8.82 0 16 7.18 16 16s-7.18 16-16 16h-32c-8.82 0-16-7.18-16-16s7.18-16 16-16zm208 288H48v-32.89c0-2.47.58-4.95 1.69-7.15L93.67 208h324.67l43.98 87.95c1.11 2.21 1.69 4.69 1.69 7.16V336z"
  ]
};
export const faKhanda = {
  prefix: "far",
  iconName: "khanda",
  icon: [
    512,
    512,
    [],
    "f66d",
    "M415.81 66a16.095 16.095 0 0 0-7.76-1.99c-4.28 0-8.51 1.71-11.6 5.01a15.974 15.974 0 0 0-1.91 19.52c16.49 26.16 25.2 56.39 25.2 87.41-.19 53.25-26.77 102.69-71.27 132.41l-76.63 53.35v-20.1l44.05-36.09c3.92-4.2 5-10.09 2.81-15.28L310.85 273c33.84-19.26 56.94-55.25 56.94-96.99 0-40.79-22.02-76.13-54.59-95.71l5.22-11.44c2.34-5.53.93-11.83-3.57-16.04L255.86 0l-58.99 52.81c-4.5 4.21-5.9 10.51-3.57 16.04l5.22 11.44c-32.57 19.58-54.59 54.93-54.59 95.72 0 41.75 23.09 77.73 56.94 96.99l-7.85 17.24c-2.19 5.18-1.1 11.07 2.81 15.28l44.05 36.09v19.9l-76.59-53.33C119.02 278.62 92.44 229.19 92.25 176c0-31.08 8.71-61.31 25.2-87.47 3.87-6.16 2.4-13.77-2.59-19.08-3-3.21-7.34-4.8-11.69-4.8-2.89 0-5.8.7-8.33 2.1C16.32 109.6-22.3 205.3 13.36 295.99c7.07 17.99 17.89 34.38 30.46 49.06l55.97 65.36c3.12 3.65 7.6 5.59 12.15 5.59 2.55 0 5.13-.61 7.5-1.88l79.35-42.23L228 392.23l-47.08 32.78c-1.67-.37-3.23-1.01-5.01-1.01-13.25 0-23.99 10.74-23.99 24 0 13.25 10.74 24 23.99 24 12.1 0 21.69-9.11 23.33-20.76l40.63-28.28v29.95c-9.39 5.57-15.99 15.38-15.99 27.1 0 17.67 14.32 32 31.98 32s31.98-14.33 31.98-32c0-11.71-6.61-21.52-15.99-27.1v-30.15l40.91 28.48C314.41 462.89 324 472 336.09 472c13.25 0 23.99-10.75 23.99-24 0-13.26-10.74-24-23.99-24-1.78 0-3.34.64-5.01 1.01L284 392.23l29.21-20.34 79.35 42.23c2.38 1.26 4.95 1.88 7.5 1.88 4.55 0 9.03-1.94 12.15-5.59l52.51-61.31c18.86-22.02 34-47.5 41.25-75.59 21.62-83.66-16.45-167.27-90.16-207.51zM119.53 359.7l-39.29-45.88c-10.22-11.93-17.7-23.84-22.25-35.4-8.06-20.5-11.11-41.58-9.63-61.89 10.7 53.27 41.94 100.63 87.51 131.05l2.79 1.95-19.13 10.17zM327.81 176c0 25.53-13.44 47.86-33.52 60.65l-8.96-19.67c-8.75-24.52-8.75-51.04 0-75.56l11.25-24.68c18.83 13 31.23 34.69 31.23 59.26zm-143.91 0c0-24.57 12.4-46.26 31.23-59.26l11.25 24.68c8.75 24.52 8.75 51.03 0 75.56l-8.96 19.67c-20.08-12.79-33.52-35.12-33.52-60.65zm275.64 85.5c-4.88 18.91-15.39 37.87-31.23 56.37l-35.84 41.84-19.15-10.19 1.78-1.24c46.36-30.96 77.82-78.56 88.55-132.04 1.12 14.77-.18 30.03-4.11 45.26z"
  ]
};
export const faKidneys = {
  prefix: "far",
  iconName: "kidneys",
  icon: [
    640,
    512,
    [],
    "f5fb",
    "M273.01 217.61l-38.77-20.36c2.87-3.38 5.84-6.25 8.42-8.47 39.91-34.35 55.32-103 8.94-153.13-40.67-43.95-110.76-47.78-156.24-8.6C14.53 96.69-18.2 199.6 9.9 295.58c24.29 83.83 92.05 88.38 109.62 88.38 22.23 0 70.65-8.2 97.65-56.45 13.83-24.74 17.11-53.24 9.41-80.25l24.94 13.3c2.72 1.38 4.44 4.09 4.44 7.16l.03 228.28c0 8.84 7.17 16 16 16H288c8.84 0 16-7.17 16-16l-.02-228.28c0-21.33-11.84-40.52-30.97-50.11zm-61.68-65.22c-11.34 9.76-49.83 42.31-31.01 107.46 11.53 39.19-18.57 66.98-43.39 73.73-33.6 9.13-68.93-10.38-78.08-41.54-27.18-93.78 3.57-173.24 67.83-228.63 27.3-23.5 67.34-19.29 89.65 4.83 22.73 24.54 20.71 61.97-5 84.15zM544.64 27.05c-45.48-39.18-115.56-35.35-156.23 8.6-46.38 50.12-30.97 118.78 8.94 153.13a79.29 79.29 0 0 1 8.42 8.47L367 217.61c-19.13 9.6-30.98 28.79-30.98 50.11L336 496c0 8.84 7.17 16 16 16h16.01c8.84 0 16-7.17 16-16l.02-228.28c0-3.06 1.72-5.78 4.44-7.16l24.94-13.3c-7.7 27.01-4.42 55.51 9.41 80.25 27 48.25 75.42 56.45 97.65 56.45 17.58 0 85.33-4.55 109.62-88.38 28.11-95.98-4.62-198.89-85.45-268.53zm36.51 265c-9.16 31.16-44.48 50.67-78.08 41.54-24.82-6.75-54.92-34.54-43.39-73.73 18.82-65.15-19.67-97.7-31.01-107.46-25.71-22.18-27.73-59.61-5-84.14 22.31-24.12 62.35-28.33 89.65-4.83 64.26 55.38 95.01 134.83 67.83 228.62z"
  ]
};
export const faKiss = {
  prefix: "far",
  iconName: "kiss",
  icon: [
    496,
    512,
    [],
    "f596",
    "M168 176c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm136 132c0-19.2-28.8-41.5-71.5-44-3.8-.4-7.4 2.4-8.2 6.2-.9 3.8 1.1 7.7 4.7 9.2l16.9 7.2c13 5.5 20.8 13.5 20.8 21.5s-7.8 16-20.7 21.5l-17 7.2c-5.7 2.4-6 12.2 0 14.8l16.9 7.2c13 5.5 20.8 13.5 20.8 21.5s-7.8 16-20.7 21.5l-17 7.2c-3.6 1.5-5.6 5.4-4.7 9.2.8 3.6 4.1 6.2 7.8 6.2h.5c42.8-2.5 71.5-24.8 71.5-44 0-13-13.4-27.3-35.2-36C290.6 335.3 304 321 304 308zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm80-280c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"
  ]
};
export const faKissBeam = {
  prefix: "far",
  iconName: "kiss-beam",
  icon: [
    496,
    512,
    [],
    "f597",
    "M168 152c-23.8 0-52.7 29.3-56 71.4-.3 3.7 2 7.2 5.6 8.3 3.5 1 7.5-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 5.9-4.5 5.6-8.3-3.1-42.1-32-71.4-55.8-71.4zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm56-148c0-19.2-28.8-41.5-71.5-44-3.8-.4-7.4 2.4-8.2 6.2-.9 3.8 1.1 7.7 4.7 9.2l16.9 7.2c13 5.5 20.8 13.5 20.8 21.5s-7.8 16-20.7 21.5l-17 7.2c-5.7 2.4-6 12.2 0 14.8l16.9 7.2c13 5.5 20.8 13.5 20.8 21.5s-7.8 16-20.7 21.5l-17 7.2c-3.6 1.5-5.6 5.4-4.7 9.2.8 3.6 4.1 6.2 7.8 6.2h.5c42.8-2.5 71.5-24.8 71.5-44 0-13-13.4-27.3-35.2-36C290.6 335.3 304 321 304 308zm24-156c-23.8 0-52.7 29.3-56 71.4-.3 3.7 2 7.2 5.6 8.3 3.5 1 7.5-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 5.9-4.5 5.6-8.3-3.1-42.1-32-71.4-55.8-71.4z"
  ]
};
export const faKissWinkHeart = {
  prefix: "far",
  iconName: "kiss-wink-heart",
  icon: [
    504,
    512,
    [],
    "f598",
    "M304 308.5c0-19.2-28.8-41.5-71.5-44-3.8-.4-7.4 2.4-8.2 6.2-.9 3.8 1.1 7.7 4.7 9.2l16.9 7.2c13 5.5 20.8 13.5 20.8 21.5s-7.8 16-20.7 21.5l-17 7.2c-5.7 2.4-6 12.2 0 14.8l16.9 7.2c13 5.5 20.8 13.5 20.8 21.5s-7.8 16-20.7 21.5l-17 7.2c-3.6 1.5-5.6 5.4-4.7 9.2.8 3.6 4.1 6.2 7.8 6.2h.5c42.8-2.5 71.5-24.8 71.5-44 0-13-13.4-27.3-35.2-36 21.7-9.1 35.1-23.4 35.1-36.4zm70.5-83.5l9.5 8.5c3.8 3.3 9.3 4 13.7 1.6 4.4-2.4 6.9-7.4 6.1-12.4-4-25.2-34.2-42.1-59.8-42.1s-55.9 16.9-59.8 42.1c-.8 5 1.7 10 6.1 12.4 5.8 3.1 11.2.7 13.7-1.6l9.5-8.5c14.8-13.2 46.2-13.2 61 0zM136 208.5c0 17.7 14.3 32 32 32s32-14.3 32-32-14.3-32-32-32-32 14.3-32 32zm365.1 194c-8-20.8-31.5-31.5-53.1-25.9l-8.4 2.2-2.3-8.4c-5.9-21.4-27-36.5-49-33-25.2 4-40.6 28.6-34 52.6l22.9 82.6c1.5 5.3 7 8.5 12.4 7.1l83-21.5c24.1-6.3 37.7-31.8 28.5-55.7zM334 436.3c-26.1 12.5-55.2 19.7-86 19.7-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200c0 22.1-3.7 43.3-10.4 63.2 9 6.4 17 14.2 22.6 23.9 6.4.1 12.6 1.4 18.6 2.9 10.9-27.9 17.1-58.2 17.1-90C496 119 385 8 248 8S0 119 0 256s111 248 248 248c35.4 0 68.9-7.5 99.4-20.9-2.5-7.3 4.3 17.2-13.4-46.8z"
  ]
};
export const faKite = {
  prefix: "far",
  iconName: "kite",
  icon: [
    640,
    512,
    [],
    "f6f4",
    "M608 0H345.5c-14.9 0-27.8 10.3-31.2 24.8 0 0-79.2 344.6-79.3 346.3l-88.3 88.3c-9.8 9.8-26.6 2.9-26.6-11V319.3l47.1 30.1c10.6 6.8 24.9-.5 24.9-12.8v-65.3c0-12.2-14.2-19.5-24.9-12.8L120 288.7V224c0-48.6-39.4-88-88-88H16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h16c22.1 0 40 17.9 40 40v64.7l-47.1-30.1c-10.7-6.8-24.9.5-24.9 12.7v65.3c0 12.2 14.2 19.5 24.9 12.8L72 319.3v124c0 16.5 5 33 15.7 45.7 26.5 31.5 69 28.3 92.9 4.3l88.3-88.3c1.7-.1 346.3-79.3 346.3-79.3 14.5-3.3 24.8-16.3 24.8-31.2V32c0-17.7-14.3-32-32-32zm-16 281.8L288 352l187-187L358.2 48H592L475.1 164.9z"
  ]
};
export const faKiwiBird = {
  prefix: "far",
  iconName: "kiwi-bird",
  icon: [
    576,
    512,
    [],
    "f535",
    "M575.83 217.98C572.66 157.41 518.3 112 457.65 112h-9.37c-52.83 0-104.26-16.25-147.74-46.24C269.69 44.48 232.32 32 191.99 32 80.36 32-.05 121.84 0 224c.04 70.95 38.68 132.8 95.99 166.01V464c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-54.26c15.37 3.96 31.4 6.26 48 6.26 5.44 0 10.68-.73 16-1.18V464c0 8.84 7.16 16 16 16h16c8.83 0 16-7.16 16-16v-59.46c14.24-5.06 27.89-11.37 40.34-19.48C342.08 355.25 393.88 336 448.48 336h15.51c2.59 0 5-.61 7.55-.79l74.42 136.44c2.84 5.23 8.28 8.34 14.03 8.34 8.41 0 16-6.77 16-16 0-255.95.07-241.71-.16-246.01zM96.33 390.21c.01 0 .01.01.02.01-.01.05-.01.04-.02-.01zM463.99 288h-15.51c-60.45 0-120.46 19.12-178.35 56.84-23.25 15.15-50.27 23.16-78.14 23.16-77.75 0-144.18-62.88-144.03-144 .15-83.71 66.68-144 144.03-144 29.21 0 57.32 8.74 81.29 25.27 51.92 35.8 112.43 54.73 175 54.73h9.37c36.99 0 68.5 27.13 70.25 60.49 1.95 37.26-27.61 67.51-63.91 67.51zm80 113.25l-39.87-73.08c15.12-5.83 28.74-14.6 39.87-25.98v99.06zm-80-201.25c-13.25 0-24 10.74-24 24 0 13.25 10.75 24 24 24s24-10.75 24-24c0-13.26-10.75-24-24-24z"
  ]
};
export const faKnifeKitchen = {
  prefix: "far",
  iconName: "knife-kitchen",
  icon: [
    576,
    512,
    [],
    "f6f5",
    "M566.28 88.57c12.96-12.5 12.96-32.76 0-45.25L531.07 9.37c-12.96-12.5-33.98-12.5-46.94 0L319.99 160 4.76 464.14c-8.25 7.96-5.38 22.16 5.53 25.69C53.72 503.86 102.37 512 150.51 512c75.83 0 150.42-20.19 201.49-69.35l104.4-100.04c12.95-12.41 13.17-33.05.49-45.73L448 288v-80L566.28 88.57zM496 64c8.84 0 16 7.16 16 16s-7.16 16-16 16-16-7.16-16-16 7.16-16 16-16zM318.71 408.07C281.24 444.14 221.5 464 150.51 464c-23.16 0-46.79-2.1-70.07-6.17L319.4 227.28l91.99 91.99-92.68 88.8zM432 160c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.17 16-16 16z"
  ]
};
export const faLambda = {
  prefix: "far",
  iconName: "lambda",
  icon: [
    448,
    512,
    [],
    "f66e",
    "M440 432h-72.91L183.81 50.15A32.01 32.01 0 0 0 154.96 32H8c-4.42 0-8 3.58-8 8v32c0 4.42 3.58 8 8 8h136.91l9.08 18.92L1.31 457.7C-3.21 468.25 4.53 480 16.02 480h17.41c6.4 0 12.18-3.81 14.71-9.7l134.01-312.7 146.04 304.25A31.998 31.998 0 0 0 357.04 480H440c4.42 0 8-3.58 8-8v-32c0-4.42-3.58-8-8-8z"
  ]
};
export const faLamp = {
  prefix: "far",
  iconName: "lamp",
  icon: [
    448,
    512,
    [],
    "f4ca",
    "M445.5 237.8L368 21.8C363.3 8.6 352.4 0 340.4 0H120.6c-11.4 0-21.8 7.7-27 19.9l-90.4 216c-10 23.9 4.6 52.1 27 52.1h89.2C94.7 323.1 80 366.5 80 401.6c0 32.7 12.8 64.2 36 88.7 13 13.8 31.8 21.7 51.5 21.7h113c19.7 0 38.5-7.9 51.5-21.7 23.2-24.5 36-56.1 36-88.7 0-35.1-14.7-78.5-39.4-113.6h89.2c21.7 0 36.3-26.4 27.7-50.2zM320 401.6c0 21.3-8.7 40.7-22.9 55.7-4.3 4.5-10.4 6.7-16.6 6.7h-113c-6.2 0-12.4-2.2-16.6-6.7-14.2-15-22.9-34.4-22.9-55.7 0-34.7 22.8-87.4 55.6-113.6h80.7c32.9 26.2 55.7 78.9 55.7 113.6zM53.5 240l80.4-192h192.6l68.9 192H53.5z"
  ]
};
export const faLampDesk = {
  prefix: "far",
  iconName: "lamp-desk",
  icon: [
    512,
    512,
    [],
    "e014",
    "M392.65,278.4a56,56,0,0,0,77.75-77.76ZM509.3,85.76A35.08,35.08,0,0,0,476.76,64h-85L355.88,28.12A95.68,95.68,0,0,0,202.76,139.3L103,239a24,24,0,0,0-6.09,23.56L154.48,464H48C26.69,464,6.78,477.89.52,497.12-1.89,504.53,4.41,512,12.19,512H371.81c7.79,0,14.08-7.47,11.67-14.88C377.22,477.89,357.32,464,336,464H204.38L147,263l86.13-86.13L256,199.76v85a35.23,35.23,0,0,0,60.14,24.9L501.63,124.15A35.06,35.06,0,0,0,509.3,85.76ZM304,253.92v-74l-49.93-49.94a48,48,0,0,1,67.87-67.88L371.88,112h74Z"
  ]
};
export const faLampFloor = {
  prefix: "far",
  iconName: "lamp-floor",
  icon: [
    384,
    512,
    [],
    "e015",
    "M382,212.76l-71.13-192A31.63,31.63,0,0,0,281.23,0H102.77a31.64,31.64,0,0,0-29.6,20.76L2,212.76C-5.71,233.68,9.57,256,31.64,256H168.29V464H113c-21.06,0-40.72,13.89-46.91,33.12C63.68,504.53,69.9,512,77.59,512H306.4c7.7,0,13.92-7.47,11.54-14.88C311.75,477.89,292.09,464,271,464H215.71V256H352.36C374.43,256,389.71,233.68,382,212.76ZM54.45,208,113.73,48H270.27l59.28,160Z"
  ]
};
export const faLandmark = {
  prefix: "far",
  iconName: "landmark",
  icon: [
    576,
    512,
    [],
    "f66f",
    "M48 160h480c8.84 0 16-7.16 16-16v-36.91c0-6.67-4.14-12.64-10.38-14.98L299.24 2.04C295.62.68 291.81 0 288 0s-7.62.68-11.24 2.04L42.38 92.11A16.001 16.001 0 0 0 32 107.09V144c0 8.84 7.16 16 16 16zM288 49.14L451.58 112H124.42L288 49.14zM560 464h-16v-64c0-17.67-16.37-32-36.57-32H480V192h-48v176h-64V192h-48v176h-64V192h-48v176h-64V192H96v176H68.57C48.37 368 32 382.33 32 400v64H16c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h544c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16zm-64 0H80v-48h416v48z"
  ]
};
export const faLandmarkAlt = {
  prefix: "far",
  iconName: "landmark-alt",
  icon: [
    512,
    512,
    [],
    "f752",
    "M496 464h-16v-80c0-8.8-7.2-16-16-16h-16V256h16c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16h-16.8C439.7 117.6 369.3 44.9 280 33.7V16c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16v17.7C142.7 44.9 72.3 117.6 64.8 208H48c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h16v112H48c-8.8 0-16 7.2-16 16v80H16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zM256 80c73.9 0 134.3 56.2 142.4 128H113.6c8.1-71.8 68.5-128 142.4-128zm144 176v112h-64V256h64zm-112 0v112h-64V256h64zm-176 0h64v112h-64V256zm320 208H80v-48h352v48z"
  ]
};
export const faLanguage = {
  prefix: "far",
  iconName: "language",
  icon: [
    640,
    512,
    [],
    "f1ab",
    "M160.3 203.8h-.5s-4.3 20.9-7.8 33l-11 37.3h37.9l-10.7-37.3c-3.6-12.1-7.9-33-7.9-33zM616 96H24c-13.3 0-24 10.7-24 24v272c0 13.3 10.7 24 24 24h592c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24zM233.2 352h-22.6a12 12 0 0 1-11.5-8.6l-9.3-31.7h-59.9l-9.1 31.6c-1.5 5.1-6.2 8.7-11.5 8.7H86.8c-8.2 0-14-8.1-11.4-15.9l57.1-168c1.7-4.9 6.2-8.1 11.4-8.1h32.2c5.1 0 9.7 3.3 11.4 8.1l57.1 168c2.6 7.8-3.2 15.9-11.4 15.9zM600 376H320V136h280zM372 228h110.8c-6.3 12.8-15.1 25.9-25.9 38.5-6.6-7.8-12.8-15.8-18.3-24-3.5-5.3-10.6-6.9-16.1-3.6l-13.7 8.2c-5.9 3.5-7.6 11.3-3.8 17 6.5 9.7 14.4 20.1 23.5 30.6-9 7.7-18.6 14.8-28.7 21.2-5.4 3.4-7.1 10.5-3.9 16l7.9 13.9c3.4 5.9 11 7.9 16.8 4.2 12.5-7.9 24.6-17 36-26.8 10.7 9.6 22.3 18.6 34.6 26.6 5.8 3.7 13.6 1.9 17-4.1l8-13.9c3.1-5.5 1.5-12.5-3.8-16-9.2-6-18.4-13.1-27.2-20.9 1.5-1.7 2.9-3.3 4.3-5 17.1-20.6 29.6-41.7 36.8-62H540c6.6 0 12-5.4 12-12v-16c0-6.6-5.4-12-12-12h-64v-16c0-6.6-5.4-12-12-12h-16c-6.6 0-12 5.4-12 12v16h-64c-6.6 0-12 5.4-12 12v16c0 6.7 5.4 12.1 12 12.1z"
  ]
};
export const faLaptop = {
  prefix: "far",
  iconName: "laptop",
  icon: [
    640,
    512,
    [],
    "f109",
    "M624 352h-48V64c0-35.2-28.8-64-64-64H128C92.8 0 64 28.8 64 64v288H16c-8.8 0-16 7.2-16 16v48c0 52.8 43.2 96 96 96h448c52.8 0 96-43.2 96-96v-48c0-8.8-7.2-16-16-16zM112 64c0-8.67 7.33-16 16-16h384c8.67 0 16 7.33 16 16v288H112V64zm480 352c0 26.47-21.53 48-48 48H96c-26.47 0-48-21.53-48-48v-16h180.9c5.57 9.39 15.38 16 27.1 16h128c11.72 0 21.52-6.61 27.1-16H592v16z"
  ]
};
export const faLaptopCode = {
  prefix: "far",
  iconName: "laptop-code",
  icon: [
    640,
    512,
    [],
    "f5fc",
    "M624 352h-48V64c0-35.2-28.8-64-64-64H128C92.8 0 64 28.8 64 64v288H16c-8.8 0-16 7.2-16 16v48c0 52.8 43.2 96 96 96h448c52.8 0 96-43.2 96-96v-48c0-8.8-7.2-16-16-16zM112 64c0-8.67 7.33-16 16-16h384c8.67 0 16 7.33 16 16v288H112V64zm480 352c0 26.47-21.53 48-48 48H96c-26.47 0-48-21.53-48-48v-16h180.9c5.57 9.39 15.38 16 27.1 16h128c11.72 0 21.52-6.61 27.1-16H592v16zM277.66 261.65l11.31-11.31c6.25-6.25 6.25-16.38 0-22.63L253.25 192l35.71-35.72c6.25-6.25 6.25-16.38 0-22.63l-11.31-11.31c-6.25-6.25-16.38-6.25-22.63 0l-58.34 58.34c-6.25 6.25-6.25 16.38 0 22.63l58.34 58.34c6.25 6.25 16.39 6.25 22.64 0zm73.38-11.3l11.31 11.31c6.25 6.25 16.38 6.25 22.63 0l58.34-58.34c6.25-6.25 6.25-16.38 0-22.63l-58.34-58.34c-6.25-6.25-16.38-6.25-22.63 0l-11.31 11.31c-6.25 6.25-6.25 16.38 0 22.63L386.75 192l-35.71 35.72c-6.25 6.25-6.25 16.38 0 22.63z"
  ]
};
export const faLaptopHouse = {
  prefix: "far",
  iconName: "laptop-house",
  icon: [
    640,
    512,
    [],
    "e066",
    "M629.33,448H592V288c0-17.67-12.9-32-28.8-32H332.79c-15.9,0-28.8,14.33-28.8,32V448H266.66A10.67,10.67,0,0,0,256,458.67v10.66A42.83,42.83,0,0,0,298.6,512H597.4A42.82,42.82,0,0,0,640,469.33V458.67A10.67,10.67,0,0,0,629.33,448ZM544,448H352V304H544ZM272,368H112V168.06L240,52,368,168.06V224H474.7l1.28-1.45a18.58,18.58,0,0,0,4-10.61A18.21,18.21,0,0,0,474.65,200L416,146.84V48a16,16,0,0,0-16-16H384a16,16,0,0,0-16,16v55.34L264.08,9.12C258.4,4.09,247.6,0,240,0s-18.38,4.09-24.08,9.12L5.39,200A18.21,18.21,0,0,0,0,212a18.47,18.47,0,0,0,4,10.61l10.62,12a18.19,18.19,0,0,0,12,5.37,18.48,18.48,0,0,0,10.63-4L64,211.61V376a40,40,0,0,0,40,40H272ZM208,192a16.07,16.07,0,0,0-16,16v64a16,16,0,0,0,16,16h64a65.38,65.38,0,0,1,16-42.94V208a16.07,16.07,0,0,0-16-16Z"
  ]
};
export const faLaptopMedical = {
  prefix: "far",
  iconName: "laptop-medical",
  icon: [
    640,
    512,
    [],
    "f812",
    "M624 352h-48V64a64.19 64.19 0 0 0-64-64H128a64.19 64.19 0 0 0-64 64v288H16a16 16 0 0 0-16 16v48c0 52.8 43.2 96 96 96h448c52.8 0 96-43.2 96-96v-48a16 16 0 0 0-16-16zM112 64a16.22 16.22 0 0 1 16-16h384a16.22 16.22 0 0 1 16 16v288H112zm480 352a48.05 48.05 0 0 1-48 48H96a48.05 48.05 0 0 1-48-48v-16h180.9c5.57 9.39 15.38 16 27.1 16h128c11.72 0 21.52-6.61 27.1-16H592zM408 160h-56v-56a8 8 0 0 0-8-8h-48a8 8 0 0 0-8 8v56h-56a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8h56v56a8 8 0 0 0 8 8h48a8 8 0 0 0 8-8v-56h56a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8z"
  ]
};
export const faLasso = {
  prefix: "far",
  iconName: "lasso",
  icon: [
    576,
    512,
    [],
    "f8c8",
    "M288 0C126.5 0 0 78.48 0 178.67c0 48.33 29.62 93.24 83.44 126.6 4.17 2.59 8.69 5.12 13.44 7.65-5.61 40.89 35.55 73.75 85.65 70.45a82.41 82.41 0 0 1 3.79 27.11c-.63 29.94-26.22 53.52-56.16 53.52H48a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h82.06c57 0 104-46 104.28-103.07a125.05 125.05 0 0 0-6.71-40.52 71.77 71.77 0 0 0 15.22-13.48c14.88 1.42 29.9 2.4 45.15 2.4 161.5 0 288-78.47 288-178.66S449.5 0 288 0zm0 309.33c-11.35 0-22.46-.88-33.55-1.76-7.19-29.44-39.54-51.67-78.45-51.67-20.38 0-38.77 6.28-52.9 16.32-4.9-2.56-10.12-5.11-14.35-7.74C69.56 240.19 48 209.72 48 178.67 48 107.84 157.91 48 288 48s240 59.84 240 130.67-109.91 130.66-240 130.66z"
  ]
};
export const faLaugh = {
  prefix: "far",
  iconName: "laugh",
  icon: [
    496,
    512,
    [],
    "f599",
    "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm141.4 389.4c-37.8 37.8-88 58.6-141.4 58.6s-103.6-20.8-141.4-58.6S48 309.4 48 256s20.8-103.6 58.6-141.4S194.6 56 248 56s103.6 20.8 141.4 58.6S448 202.6 448 256s-20.8 103.6-58.6 141.4zM328 224c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm-160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm194.4 64H133.6c-8.2 0-14.5 7-13.5 15 7.5 59.2 58.9 105 121.1 105h13.6c62.2 0 113.6-45.8 121.1-105 1-8-5.3-15-13.5-15z"
  ]
};
export const faLaughBeam = {
  prefix: "far",
  iconName: "laugh-beam",
  icon: [
    496,
    512,
    [],
    "f59a",
    "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm141.4 389.4c-37.8 37.8-88 58.6-141.4 58.6s-103.6-20.8-141.4-58.6S48 309.4 48 256s20.8-103.6 58.6-141.4S194.6 56 248 56s103.6 20.8 141.4 58.6S448 202.6 448 256s-20.8 103.6-58.6 141.4zM328 152c-23.8 0-52.7 29.3-56 71.4-.7 8.6 10.8 11.9 14.9 4.5l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c4.1 7.4 15.6 4 14.9-4.5-3.1-42.1-32-71.4-55.8-71.4zm-201 75.9l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c4.1 7.4 15.6 4 14.9-4.5-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.6 8.5 10.9 11.9 15.1 4.5zM362.4 288H133.6c-8.2 0-14.5 7-13.5 15 7.5 59.2 58.9 105 121.1 105h13.6c62.2 0 113.6-45.8 121.1-105 1-8-5.3-15-13.5-15z"
  ]
};
export const faLaughSquint = {
  prefix: "far",
  iconName: "laugh-squint",
  icon: [
    496,
    512,
    [],
    "f59b",
    "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm141.4 389.4c-37.8 37.8-88 58.6-141.4 58.6s-103.6-20.8-141.4-58.6S48 309.4 48 256s20.8-103.6 58.6-141.4S194.6 56 248 56s103.6 20.8 141.4 58.6S448 202.6 448 256s-20.8 103.6-58.6 141.4zM343.6 196l33.6-40.3c8.6-10.3-3.8-24.8-15.4-18l-80 48c-7.8 4.7-7.8 15.9 0 20.6l80 48c11.5 6.8 24-7.6 15.4-18L343.6 196zm-209.4 58.3l80-48c7.8-4.7 7.8-15.9 0-20.6l-80-48c-11.6-6.9-24 7.7-15.4 18l33.6 40.3-33.6 40.3c-8.7 10.4 3.8 24.8 15.4 18zM362.4 288H133.6c-8.2 0-14.5 7-13.5 15 7.5 59.2 58.9 105 121.1 105h13.6c62.2 0 113.6-45.8 121.1-105 1-8-5.3-15-13.5-15z"
  ]
};
export const faLaughWink = {
  prefix: "far",
  iconName: "laugh-wink",
  icon: [
    496,
    512,
    [],
    "f59c",
    "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm141.4 389.4c-37.8 37.8-88 58.6-141.4 58.6s-103.6-20.8-141.4-58.6C68.8 359.6 48 309.4 48 256s20.8-103.6 58.6-141.4C144.4 76.8 194.6 56 248 56s103.6 20.8 141.4 58.6c37.8 37.8 58.6 88 58.6 141.4s-20.8 103.6-58.6 141.4zM328 164c-25.7 0-55.9 16.9-59.9 42.1-1.7 11.2 11.5 18.2 19.8 10.8l9.5-8.5c14.8-13.2 46.2-13.2 61 0l9.5 8.5c8.5 7.4 21.6.3 19.8-10.8-3.8-25.2-34-42.1-59.7-42.1zm-160 60c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm194.4 64H133.6c-8.2 0-14.5 7-13.5 15 7.5 59.2 58.9 105 121.1 105h13.6c62.2 0 113.6-45.8 121.1-105 1-8-5.3-15-13.5-15z"
  ]
};
export const faLayerGroup = {
  prefix: "far",
  iconName: "layer-group",
  icon: [
    512,
    512,
    [],
    "f5fd",
    "M512 256.01c0-12.86-7.53-24.42-19.12-29.44l-79.69-34.58 79.66-34.57c11.62-5.03 19.16-16.59 19.16-29.44s-7.53-24.41-19.12-29.42L274.66 3.89c-11.84-5.17-25.44-5.19-37.28-.02L19.16 98.55C7.53 103.58 0 115.14 0 127.99s7.53 24.41 19.12 29.42l79.7 34.58-79.67 34.57C7.53 231.58 0 243.15 0 256.01c0 12.84 7.53 24.41 19.12 29.42L98.81 320l-79.65 34.56C7.53 359.59 0 371.15 0 384.01c0 12.84 7.53 24.41 19.12 29.42l218.28 94.69a46.488 46.488 0 0 0 18.59 3.88c6.34-.02 12.69-1.3 18.59-3.86l218.25-94.69c11.62-5.03 19.16-16.59 19.16-29.44 0-12.86-7.53-24.42-19.12-29.44L413.19 320l79.65-34.56c11.63-5.03 19.16-16.59 19.16-29.43zM255.47 47.89l.03.02h-.06l.03-.02zm.53.23l184.16 79.89-183.63 80.09-184.62-80.11L256 48.12zm184.19 335.92l-183.66 80.07L71.91 384l87.21-37.84 78.29 33.96A46.488 46.488 0 0 0 256 384c6.34-.02 12.69-1.3 18.59-3.86l78.29-33.97 87.31 37.87zM256.53 336.1L71.91 255.99l87.22-37.84 78.28 33.96a46.488 46.488 0 0 0 18.59 3.88c6.34-.02 12.69-1.3 18.59-3.86l78.29-33.97 87.31 37.88-183.66 80.06z"
  ]
};
export const faLayerMinus = {
  prefix: "far",
  iconName: "layer-minus",
  icon: [
    512,
    512,
    [],
    "f5fe",
    "M496 32H304c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h192c8.84 0 16-7.16 16-16V48c0-8.84-7.16-16-16-16zm16 224c0-12.84-7.53-24.41-19.12-29.42l-218.28-94.7c-11.81-5.16-25.38-5.16-37.19 0L19.16 226.56C7.53 231.59 0 243.16 0 256s7.53 24.41 19.12 29.42L98.82 320l-79.67 34.56C7.53 359.59 0 371.16 0 384.02c0 12.84 7.53 24.41 19.12 29.42l218.28 94.69a46.488 46.488 0 0 0 18.59 3.88c6.34-.02 12.69-1.3 18.59-3.86l218.25-94.69c11.62-5.03 19.16-16.59 19.16-29.44 0-12.86-7.53-24.42-19.12-29.44L413.19 320l79.65-34.56C504.47 280.41 512 268.84 512 256zm-71.81 128.05l-183.66 80.06L71.91 384l87.22-37.84 78.28 33.96A46.488 46.488 0 0 0 256 384c6.34-.02 12.69-1.3 18.59-3.86l78.3-33.98 87.3 37.89zm-183.66-47.94L71.91 256 256 176.12l184.16 79.91-183.63 80.08z"
  ]
};
export const faLayerPlus = {
  prefix: "far",
  iconName: "layer-plus",
  icon: [
    512,
    512,
    [],
    "f5ff",
    "M492.88 354.58L413.19 320l79.68-34.58c12.16-5.28 17.72-19.41 12.47-31.56-5.28-12.17-19.38-17.67-31.59-12.47l-217.22 94.72L71.91 256l170.5-73.98c12.16-5.28 17.72-19.41 12.47-31.56-5.28-12.19-19.38-17.67-31.59-12.47L19.16 226.56C7.53 231.59 0 243.16 0 256s7.53 24.41 19.12 29.42L98.82 320l-79.67 34.56C7.53 359.59 0 371.16 0 384.02c0 12.84 7.53 24.41 19.12 29.42l218.28 94.69a46.488 46.488 0 0 0 18.59 3.88c6.34-.02 12.69-1.3 18.59-3.86l218.25-94.69c11.62-5.03 19.16-16.59 19.16-29.44.01-12.86-7.52-24.43-19.11-29.44zM256.53 464.11L71.91 384l87.22-37.84 78.28 33.96c5.91 2.58 12.25 3.86 18.59 3.86s12.69-1.28 18.59-3.84l78.3-33.98 87.29 37.88-183.65 80.07zM496 88h-72V16c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v72h-72c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h72v72c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-72h72c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16z"
  ]
};
export const faLeaf = {
  prefix: "far",
  iconName: "leaf",
  icon: [
    576,
    512,
    [],
    "f06c",
    "M546.2 9.7c-2.9-6.5-8.6-9.7-14.3-9.7-5.3 0-10.7 2.8-14 8.5C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 17.8 2.6 34.9 7.1 51.2C29 403.7 1.8 478.8 1.3 480.2c-4.3 12.5 2.3 26.2 14.8 30.5 14 4.8 26.7-3.8 30.5-14.8.4-1.1 21-57.5 76.3-110.1C160.5 449 231.5 487 308.4 478.9 465.5 467.5 576 326.7 576 154.3c0-50.2-10.8-102.2-29.8-144.6zM303.4 431.2c-86.1 9.1-130.6-54.5-142.2-76.5 47.4-32.9 112-58.7 198.9-58.7 13.2 0 24-10.8 24-24s-10.8-24-24-24c-91.3 0-161.1 25.5-214 59.4-.9-6.4-2-12.8-2-19.4 0-79.4 64.6-144 144-144h80c57.9 0 111.6-22 152-60.9 5.2 23.2 8 47.5 8 71.2-.1 151-93.9 267.4-224.7 276.9z"
  ]
};
export const faLeafHeart = {
  prefix: "far",
  iconName: "leaf-heart",
  icon: [
    576,
    512,
    [],
    "f4cb",
    "M397.4 219c-23.5-19.1-54.3-10.6-70 4.8l-7.4 7.3-7.4-7.3c-15.3-15.1-46.2-24.1-70-4.8-23.6 19.1-24.8 53.5-3.7 74.2l72.6 71.3c4.7 4.6 12.3 4.6 17 0l72.6-71.3c21-20.7 19.8-55.1-3.7-74.2zM546.2 9.7c-2.9-6.5-8.6-9.7-14.3-9.7-5.3 0-10.7 2.8-14 8.5C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 17.5 2.5 34.4 6.9 50.5C29 402.5 2.5 476.9 1.3 480.2c-4.3 12.5 2.3 26.1 14.8 30.5 2.6.9 5.2 1.3 7.9 1.3 9.9 0 19.2-6.2 22.7-16.1.2-.6 21.1-57.8 76.1-110.4C160.3 449 231.5 487 308.4 478.9 465.5 467.6 576 326.8 576 154.3c0-50.2-10.8-102.2-29.8-144.6zM303.4 431.2C215.4 440.5 144 370.8 144 288c0-79.4 64.6-144 144-144h80c57.9 0 111.6-22 152-60.9 5.2 23.2 8 47.5 8 71.2 0 151-93.8 267.4-224.6 276.9z"
  ]
};
export const faLeafMaple = {
  prefix: "far",
  iconName: "leaf-maple",
  icon: [
    512,
    512,
    [],
    "f6f6",
    "M457.73 301.13c2.24-10.52 1.74-21.21-1.31-31.2L483.01 253c18.43-11.73 29.27-31.77 28.98-53.62-.29-21.85-11.64-41.6-30.38-52.85l-4.92-2.95 4.9-44.08a62.684 62.684 0 0 0-15.56-48.64C454.17 37.6 437.18 30 419.42 30c-2.29 0-38.23 4.4-51.03 5.28l-2.95-4.92C354.05 11.36 333.99 0 311.79 0c-21.51 0-41.25 10.83-52.8 28.98l-16.93 26.6a62.405 62.405 0 0 0-18.18-2.69c-4.36 0-8.72.46-13.02 1.37l-13.83-15.67c-11.92-14.18-29.29-22.28-47.88-22.28-18.6 0-35.96 8.1-47.88 22.29L87.44 54.26c-4.29-.91-8.66-1.37-13.02-1.37-19.04 0-36.82 8.55-48.78 23.46-11.93 14.87-16.39 34.08-12.26 52.71l19.78 95.89A62.54 62.54 0 0 0 0 280.2c0 25.07 14.89 47.65 37.93 57.52l71.69 30.73L7.03 471.03c-9.37 9.38-9.37 24.56 0 33.94C11.72 509.66 17.84 512 24 512s12.28-2.34 16.97-7.03l102.59-102.59 30.72 71.69A62.529 62.529 0 0 0 231.81 512c23.29 0 44.44-12.85 55.24-33.16l96.6 19.93c42.17 9.43 83.8-28.54 74.09-74.21 18.82-16.61 37.95-30.18 37.95-61.71 0-32.23-20.53-46.34-37.96-61.72zm-15.51 73.1l-43.18 38.11 11.62 21.64c2.36 9.43-4.92 18.13-14.09 18.13-2.21 0 8.38 2.03-137.99-28.16l-13.37 31.2c-2.53 5.89-7.96 8.84-13.4 8.84s-10.88-2.95-13.41-8.84l-38.29-89.33 124.86-124.86c9.37-9.38 9.37-24.56 0-33.94s-24.56-9.38-33.94 0L146.18 331.89 56.84 293.6c-11.78-5.05-11.78-21.76 0-26.81l31.2-13.37-27.8-134.76c-2.49-11.22 7.85-19.8 17.77-17.31l21.64 11.62 38.11-43.18c2.92-3.65 7.15-5.47 11.39-5.47s8.47 1.82 11.39 5.47l38.11 43.18 21.64-11.62c10.16-2.54 20.2 6.38 17.77 17.31l-13.95 54.54 75.37-118.45c2.87-4.51 7.59-6.75 12.3-6.75 4.84 0 9.68 2.37 12.51 7.08l18.8 31.33 74.69-8.3c14.07-1.59 16.52 12.34 16.1 16.11l-8.3 74.69 31.33 18.8c9.3 5.58 9.47 18.99.33 24.81L338.8 287.88c59.17-15.13 55.26-14.31 57.77-14.31 9.16 0 16.44 8.7 14.08 18.13l-11.62 21.64 43.18 38.11c7.3 5.85 7.3 16.94.01 22.78z"
  ]
};
export const faLeafOak = {
  prefix: "far",
  iconName: "leaf-oak",
  icon: [
    512,
    512,
    [],
    "f6f7",
    "M511.56 208.08c-2.31-21.37-14.25-40.99-32.74-53.79-2.9-2.01-5.86-3.97-8.92-5.75 11.79-47.63-7.42-74.79-19.43-86.06-12.19-12.91-39.35-32.1-87.03-20.39-1.75-3.04-3.71-6-5.71-8.9C344.88 14.7 325.27 2.76 303.91.44c-20.99-2.32-41.35 4.58-57.25 19.33-8.36 7.76-13.94 16.88-20.02 26.77-3.03 4.87-5.92 9.81-8.82 14.86-17.59-11.82-36.95-16.28-55.26-12.69-20.14 3.99-37.76 17.6-49.55 38.29-16.53 28.84-14.31 58.55-10.95 84.12-10.32-.94-20.64.48-30.19 4.44-17.9 7.47-31.24 23.2-36.58 43.14-4.08 15.21-4.4 32.64-.94 47.81 2.53 10.88 6.42 20.64 10.23 30.09 2.62 6.56 5.3 13.11 7.17 19.86 2.12 7.64 1.81 12.85 1.34 14.2-12.31 34.06-11.61 66.68 1.03 91.89L7.31 469.39c-9.75 9.75-9.75 25.56 0 35.31 4.87 4.86 11.28 7.3 17.66 7.3s12.78-2.44 17.66-7.3l46.63-46.63c24.9 12.83 57.12 13.43 92.02.79 1.34-.5 6.58-.83 14.22 1.34 6.77 1.88 13.31 4.57 19.89 7.2 9.45 3.77 19.21 7.69 30.09 10.2 6.95 1.61 14.41 2.4 21.86 2.4 8.82 0 17.71-1.12 25.94-3.32 19.99-5.36 35.73-18.72 43.19-36.65 3.93-9.51 5.39-19.78 4.4-30.12 25.72 3.43 55.35 5.58 84.13-10.93 20.74-11.83 34.33-29.45 38.29-49.59 3.62-18.27-.87-37.67-12.66-55.21 5.27-3.05 10.73-6.27 16.68-9.95 8.08-4.97 17.21-10.59 24.95-18.96 14.75-15.89 21.61-36.2 19.3-57.19zm-54.44 24.66c-3.27 3.55-8.92 7.02-16.84 11.9-8.14 5.04-16.53 9.76-25.32 14.72l-36.95 21.14 23.14 28.17c2.84 3.41 5.3 6.38 7.7 9.43 4.3 5.53 9.07 13.83 7.48 22-1.62 8.09-9.11 13.89-15.09 17.32-14.44 8.25-30.75 8.09-54.16 5.01-8.51-1.12-17.03-1.96-26.66-2.92l-66.7-6.98 33.77 48.66c1.09 1.51 1.84 2.46 2.4 3.45 3.46 6.05 4.33 12.25 2.34 17.04-2.21 5.32-7.39 7.69-11.35 8.76-7.64 2.06-17.12 2.28-24.67.5-7.23-1.67-14.9-4.74-22.98-7.98-8.2-3.29-16.43-6.53-24.85-8.87-5.55-1.56-14.19-3.43-23.73-3.43-6.36 0-13.13.84-19.61 3.16-14.01 5.08-26.74 6.99-37.57 6.06L336.5 210.84c9.75-9.75 9.75-25.56 0-35.31-9.75-9.72-25.56-9.72-35.31 0L92.4 384.31c-1-10.96.83-23.71 5.75-37.35 5.52-15.25 2.93-31.97-.22-43.31-2.34-8.45-5.58-16.66-8.89-24.87-3.24-8.11-6.3-15.75-7.98-22.99-1.71-7.56-1.53-17.03.53-24.7 1.06-3.94 3.43-9.1 8.73-11.3 4.83-2.03 11.01-1.15 16.99 2.28 1.03.61 2 1.37 3.55 2.48l48.61 33.97-7.02-67.18c-.94-9.51-1.78-17.96-2.9-26.41-3.09-23.37-3.24-39.72 5.02-54.16 3.43-6 9.2-13.48 17.28-15.07 8.26-1.67 16.5 3.16 22.05 7.48 3.21 2.49 6.36 5.11 9.98 8.15l27.6 22.76 21.02-36.78c5.02-8.9 9.79-17.35 16.06-27.53 3.68-5.97 7.14-11.62 10.7-14.92 7.17-6.63 14.69-7.44 19.46-6.81 7.7.83 14.69 5.25 19.64 12.41 1.81 2.6 3.68 5.24 4.89 8.01 7.77 17.77 28.19 26.89 47.52 21.23 14.13-4.13 33.4-6.5 45.87 6.64 12.16 11.47 9.76 30.73 5.64 44.87-5.64 19.35 3.49 39.79 21.23 47.53 2.84 1.25 5.43 3.09 7.98 4.88 7.2 4.99 11.63 11.96 12.44 19.64.58 4.96-.17 12.33-6.81 19.48z"
  ]
};
export const faLemon = {
  prefix: "far",
  iconName: "lemon",
  icon: [
    512,
    512,
    [],
    "f094",
    "M484.112 27.889C455.989-.233 416.108-8.057 387.059 8.865 347.604 31.848 223.504-41.111 91.196 91.197-41.277 223.672 31.923 347.472 8.866 387.058c-16.922 29.051-9.1 68.932 19.022 97.054 28.135 28.135 68.011 35.938 97.057 19.021 39.423-22.97 163.557 49.969 295.858-82.329 132.474-132.477 59.273-256.277 82.331-295.861 16.922-29.05 9.1-68.931-19.022-97.054zm-22.405 72.894c-38.8 66.609 45.6 165.635-74.845 286.08-120.44 120.443-219.475 36.048-286.076 74.843-22.679 13.207-64.035-27.241-50.493-50.488 38.8-66.609-45.6-165.635 74.845-286.08C245.573 4.702 344.616 89.086 411.219 50.292c22.73-13.24 64.005 27.288 50.488 50.491zm-169.861 8.736c1.37 10.96-6.404 20.957-17.365 22.327-54.846 6.855-135.779 87.787-142.635 142.635-1.373 10.989-11.399 18.734-22.326 17.365-10.961-1.37-18.735-11.366-17.365-22.326 9.162-73.286 104.167-168.215 177.365-177.365 10.953-1.368 20.956 6.403 22.326 17.364z"
  ]
};
export const faLessThan = {
  prefix: "far",
  iconName: "less-than",
  icon: [
    320,
    512,
    [],
    "f536",
    "M311.15 373.06L77.04 256l234.11-117.06c7.9-3.95 11.11-13.56 7.16-21.46L304 88.85c-3.95-7.9-13.56-11.11-21.47-7.16L8.84 218.53A16 16 0 0 0 0 232.85v46.31c0 6.06 3.42 11.6 8.84 14.31l273.68 136.84c7.9 3.95 17.52.75 21.47-7.16l14.31-28.63c3.96-7.9.75-17.51-7.15-21.46z"
  ]
};
export const faLessThanEqual = {
  prefix: "far",
  iconName: "less-than-equal",
  icon: [
    384,
    512,
    [],
    "f537",
    "M368 416H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h352c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM42.06 235.24L318.18 350.8c8.21 3.44 17.52-.74 20.8-9.33l11.88-31.1c3.28-8.58-.71-18.32-8.92-21.76L111.09 192l230.85-96.62c8.2-3.43 12.19-13.17 8.92-21.76l-11.88-31.1c-3.28-8.59-12.59-12.76-20.8-9.33L42.06 148.76C35.98 151.3 32 157.46 32 164.3v55.39c0 6.85 3.98 13.01 10.06 15.55z"
  ]
};
export const faLevelDown = {
  prefix: "far",
  iconName: "level-down",
  icon: [
    320,
    512,
    [],
    "f149",
    "M316.485 392l-116 116.485c-4.686 4.686-12.284 4.686-16.971 0L67.515 392c-4.686-4.686-4.686-12.284 0-16.971l22.312-22.312c4.808-4.808 12.646-4.665 17.275.315L164 414.996V56H44.024a11.996 11.996 0 0 1-8.485-3.515l-32-32C-4.021 12.926 1.333 0 12.024 0H196c13.255 0 24 10.745 24 24v390.996l56.899-61.963c4.629-4.98 12.467-5.123 17.275-.315l22.312 22.312c4.686 4.686 4.686 12.284-.001 16.97z"
  ]
};
export const faLevelDownAlt = {
  prefix: "far",
  iconName: "level-down-alt",
  icon: [
    320,
    512,
    [],
    "f3be",
    "M296.64 412.326l-96.16 96.16c-4.686 4.687-12.285 4.686-16.97 0L87.354 412.33c-7.536-7.536-2.198-20.484 8.485-20.485l68.161-.002V56H64a11.996 11.996 0 0 1-8.485-3.515l-32-32C15.955 12.926 21.309 0 32 0h164c13.255 0 24 10.745 24 24v367.842l68.154-.001c10.626-.001 16.066 12.905 8.486 20.485z"
  ]
};
export const faLevelUp = {
  prefix: "far",
  iconName: "level-up",
  icon: [
    320,
    512,
    [],
    "f148",
    "M316.485 120l-116-116.485c-4.686-4.686-12.284-4.686-16.971 0L67.515 120c-4.686 4.686-4.686 12.284 0 16.971l22.312 22.312c4.808 4.808 12.646 4.665 17.275-.315L164 97.004V456H44.024a11.996 11.996 0 0 0-8.485 3.515l-32 32C-4.021 499.074 1.333 512 12.024 512H196c13.255 0 24-10.745 24-24V97.004l56.899 61.963c4.629 4.98 12.467 5.123 17.275.315l22.312-22.312c4.686-4.686 4.686-12.284-.001-16.97z"
  ]
};
export const faLevelUpAlt = {
  prefix: "far",
  iconName: "level-up-alt",
  icon: [
    320,
    512,
    [],
    "f3bf",
    "M296.64 99.674l-96.16-96.16c-4.686-4.687-12.285-4.686-16.97 0L87.353 99.671c-7.536 7.536-2.198 20.484 8.485 20.485l68.162.002V456H64a11.996 11.996 0 0 0-8.485 3.515l-32 32C15.955 499.074 21.309 512 32 512h164c13.255 0 24-10.745 24-24V120.159l68.154.001c10.626 0 16.066-12.906 8.486-20.486z"
  ]
};
export const faLifeRing = {
  prefix: "far",
  iconName: "life-ring",
  icon: [
    512,
    512,
    [],
    "f1cd",
    "M256 504c136.967 0 248-111.033 248-248S392.967 8 256 8 8 119.033 8 256s111.033 248 248 248zm-103.398-76.72l53.411-53.411c31.806 13.506 68.128 13.522 99.974 0l53.411 53.411c-63.217 38.319-143.579 38.319-206.796 0zM336 256c0 44.112-35.888 80-80 80s-80-35.888-80-80 35.888-80 80-80 80 35.888 80 80zm91.28 103.398l-53.411-53.411c13.505-31.806 13.522-68.128 0-99.974l53.411-53.411c38.319 63.217 38.319 143.579 0 206.796zM359.397 84.72l-53.411 53.411c-31.806-13.505-68.128-13.522-99.973 0L152.602 84.72c63.217-38.319 143.579-38.319 206.795 0zM84.72 152.602l53.411 53.411c-13.506 31.806-13.522 68.128 0 99.974L84.72 359.398c-38.319-63.217-38.319-143.579 0-206.796z"
  ]
};
export const faLightCeiling = {
  prefix: "far",
  iconName: "light-ceiling",
  icon: [
    512,
    512,
    [],
    "e016",
    "M256,512a64,64,0,0,0,64-64H192A64,64,0,0,0,256,512Zm24-350.9V0H232V161.1C112.78,172,17,263.19.32,379.62-2.43,398.81,13,416,32.56,416H479.44c19.56,0,35-17.19,32.24-36.38C495,263.19,399.22,172,280,161.1ZM51.35,368c22.13-92.42,107-160,204.65-160s182.52,67.58,204.65,160Z"
  ]
};
export const faLightSwitch = {
  prefix: "far",
  iconName: "light-switch",
  icon: [
    384,
    512,
    [],
    "e017",
    "M320,0H64A64,64,0,0,0,0,64V448a64,64,0,0,0,64,64H320a64,64,0,0,0,64-64V64A64,64,0,0,0,320,0Zm16,448a16,16,0,0,1-16,16H214.37a23.66,23.66,0,0,0-44.77,0H64a16,16,0,0,1-16-16V64A16,16,0,0,1,64,48H169.6a23.66,23.66,0,0,0,44.77,0H320a16,16,0,0,1,16,16ZM256,96H128a32,32,0,0,0-32,32V384a32,32,0,0,0,32,32H256a32,32,0,0,0,32-32V128A32,32,0,0,0,256,96ZM240,368H144V280h96Zm0-136H144V144h96Z"
  ]
};
export const faLightSwitchOff = {
  prefix: "far",
  iconName: "light-switch-off",
  icon: [
    384,
    512,
    [],
    "e018",
    "M320,0H64A64,64,0,0,0,0,64V448a64,64,0,0,0,64,64H320a64,64,0,0,0,64-64V64A64,64,0,0,0,320,0Zm16,448a16,16,0,0,1-16,16H214.38a23.65,23.65,0,0,0-44.76,0H64a16,16,0,0,1-16-16V64A16,16,0,0,1,64,48H169.62a23.65,23.65,0,0,0,44.76,0H320a16,16,0,0,1,16,16ZM256,96H128a32,32,0,0,0-32,32V384a32,32,0,0,0,32,32H256a32,32,0,0,0,32-32V128A32,32,0,0,0,256,96ZM240,256H144V144h96Z"
  ]
};
export const faLightSwitchOn = {
  prefix: "far",
  iconName: "light-switch-on",
  icon: [
    384,
    512,
    [],
    "e019",
    "M320,0H64A64,64,0,0,0,0,64V448a64,64,0,0,0,64,64H320a64,64,0,0,0,64-64V64A64,64,0,0,0,320,0Zm16,448a16,16,0,0,1-16,16H214.4a23.66,23.66,0,0,0-44.77,0H64a16,16,0,0,1-16-16V64A16,16,0,0,1,64,48H169.63a23.66,23.66,0,0,0,44.77,0H320a16,16,0,0,1,16,16ZM256,96H128a32,32,0,0,0-32,32V384a32,32,0,0,0,32,32H256a32,32,0,0,0,32-32V128A32,32,0,0,0,256,96ZM240,368H144V272h96Z"
  ]
};
export const faLightbulb = {
  prefix: "far",
  iconName: "lightbulb",
  icon: [
    352,
    512,
    [],
    "f0eb",
    "M176 80c-52.94 0-96 43.06-96 96 0 8.84 7.16 16 16 16s16-7.16 16-16c0-35.3 28.72-64 64-64 8.84 0 16-7.16 16-16s-7.16-16-16-16zM96.06 459.17c0 3.15.93 6.22 2.68 8.84l24.51 36.84c2.97 4.46 7.97 7.14 13.32 7.14h78.85c5.36 0 10.36-2.68 13.32-7.14l24.51-36.84c1.74-2.62 2.67-5.7 2.68-8.84l.05-43.18H96.02l.04 43.18zM176 0C73.72 0 0 82.97 0 176c0 44.37 16.45 84.85 43.56 115.78 16.64 18.99 42.74 58.8 52.42 92.16v.06h48v-.12c-.01-4.77-.72-9.51-2.15-14.07-5.59-17.81-22.82-64.77-62.17-109.67-20.54-23.43-31.52-53.15-31.61-84.14-.2-73.64 59.67-128 127.95-128 70.58 0 128 57.42 128 128 0 30.97-11.24 60.85-31.65 84.14-39.11 44.61-56.42 91.47-62.1 109.46a47.507 47.507 0 0 0-2.22 14.3v.1h48v-.05c9.68-33.37 35.78-73.18 52.42-92.16C335.55 260.85 352 220.37 352 176 352 78.8 273.2 0 176 0z"
  ]
};
export const faLightbulbDollar = {
  prefix: "far",
  iconName: "lightbulb-dollar",
  icon: [
    352,
    512,
    [],
    "f670",
    "M168 296h16c4.42 0 8-3.58 8-8v-16.12c23.62-.63 42.67-20.54 42.67-45.07 0-19.97-12.98-37.81-31.58-43.39l-45-13.5c-5.16-1.55-8.77-6.78-8.77-12.73 0-7.27 5.3-13.19 11.8-13.19h28.11c4.56 0 8.96 1.29 12.82 3.72 3.24 2.03 7.36 1.91 10.13-.73l11.75-11.21c3.53-3.37 3.33-9.21-.57-12.14-9.1-6.83-20.08-10.77-31.37-11.35V96c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v16.12c-23.62.63-42.67 20.55-42.67 45.07 0 19.97 12.98 37.81 31.58 43.39l45 13.5c5.16 1.55 8.77 6.78 8.77 12.73 0 7.27-5.3 13.19-11.8 13.19h-28.11c-4.56 0-8.96-1.29-12.82-3.72-3.24-2.03-7.36-1.91-10.13.73l-11.75 11.21c-3.53 3.37-3.33 9.21.57 12.14 9.1 6.83 20.08 10.77 31.37 11.35V288c0 4.42 3.58 8 8 8zM96.06 459.17c0 3.15.93 6.22 2.68 8.84l24.51 36.84c2.97 4.46 7.97 7.14 13.32 7.14h78.85c5.36 0 10.36-2.68 13.32-7.14l24.51-36.84c1.74-2.62 2.67-5.7 2.68-8.84l.05-43.18H96.02l.04 43.18zM176 0C73.72 0 0 82.97 0 176c0 44.37 16.45 84.85 43.56 115.78 16.64 18.99 42.74 58.8 52.42 92.16v.06h48v-.12c-.01-4.77-.72-9.51-2.15-14.07-5.59-17.81-22.82-64.77-62.17-109.67-20.54-23.43-31.52-53.15-31.61-84.14-.2-73.64 59.67-128 127.95-128 70.58 0 128 57.42 128 128 0 30.97-11.24 60.85-31.65 84.14-39.11 44.61-56.42 91.47-62.1 109.46a47.507 47.507 0 0 0-2.22 14.3v.1h48v-.05c9.68-33.37 35.78-73.18 52.42-92.16C335.55 260.85 352 220.37 352 176 352 78.8 273.2 0 176 0z"
  ]
};
export const faLightbulbExclamation = {
  prefix: "far",
  iconName: "lightbulb-exclamation",
  icon: [
    352,
    512,
    [],
    "f671",
    "M96.06 459.17c0 3.15.93 6.22 2.68 8.84l24.51 36.84c2.97 4.46 7.97 7.14 13.32 7.14h78.85c5.36 0 10.36-2.68 13.32-7.14l24.51-36.84c1.74-2.62 2.67-5.7 2.68-8.84l.05-43.18H96.02l.04 43.18zM176 320c17.67 0 32-14.33 32-32s-14.33-32-32-32-32 14.33-32 32 14.33 32 32 32zm0-320C73.72 0 0 82.97 0 176c0 44.37 16.45 84.85 43.56 115.78 16.64 18.99 42.74 58.8 52.42 92.16v.06h48v-.12c-.01-4.77-.72-9.51-2.15-14.07-5.59-17.81-22.82-64.77-62.17-109.67-20.54-23.43-31.52-53.15-31.61-84.14-.2-73.64 59.67-128 127.95-128 70.58 0 128 57.42 128 128 0 30.97-11.24 60.85-31.65 84.14-39.11 44.61-56.42 91.47-62.1 109.46a47.507 47.507 0 0 0-2.22 14.3v.1h48v-.05c9.68-33.37 35.78-73.18 52.42-92.16C335.55 260.85 352 220.37 352 176 352 78.8 273.2 0 176 0zm-9.52 224h19.04c8.22 0 15.1-6.23 15.92-14.41l12.8-96c.94-9.42-6.45-17.59-15.92-17.59h-44.64c-9.47 0-16.86 8.17-15.92 17.59l12.8 96c.82 8.18 7.7 14.41 15.92 14.41z"
  ]
};
export const faLightbulbOn = {
  prefix: "far",
  iconName: "lightbulb-on",
  icon: [
    640,
    512,
    [],
    "f672",
    "M112,192a24,24,0,0,0-24-24H24a24,24,0,0,0,0,48H88A24,24,0,0,0,112,192Zm-4.92,95.22-55.42,32a24,24,0,1,0,24,41.56l55.42-32a24,24,0,0,0-24-41.56Zm24-232-55.42-32a24,24,0,1,0-24,41.56l55.42,32a24,24,0,1,0,24-41.56ZM520.94,100a23.8,23.8,0,0,0,12-3.22l55.42-32a24,24,0,0,0-24-41.56l-55.42,32a24,24,0,0,0,12,44.78ZM616,168H552a24,24,0,0,0,0,48h64a24,24,0,0,0,0-48ZM588.34,319.23l-55.42-32a24,24,0,1,0-24,41.56l55.42,32a24,24,0,0,0,24-41.56ZM320,0C217.72,0,144,83,144,176a175,175,0,0,0,43.56,115.78c16.63,19,42.75,58.8,52.41,92.16V384h48v-.12a47.67,47.67,0,0,0-2.13-14.07C280.25,352,263,305.06,223.66,260.15A127.48,127.48,0,0,1,192.06,176C191.84,102.36,251.72,48,320,48a127.91,127.91,0,0,1,96.34,212.15c-39.09,44.61-56.4,91.47-62.09,109.46A56.78,56.78,0,0,0,352,383.92V384h48V384c9.69-33.37,35.78-73.18,52.41-92.15A175.93,175.93,0,0,0,320,0Zm0,80a96.11,96.11,0,0,0-96,96,16,16,0,0,0,32,0,64.08,64.08,0,0,1,64-64,16,16,0,0,0,0-32ZM240.06,459.19a16,16,0,0,0,2.69,8.84l24.5,36.83A16,16,0,0,0,280.56,512h78.85a16,16,0,0,0,13.34-7.14L397.25,468a16.2,16.2,0,0,0,2.69-8.84L400,416H240Z"
  ]
};
export const faLightbulbSlash = {
  prefix: "far",
  iconName: "lightbulb-slash",
  icon: [
    640,
    512,
    [],
    "f673",
    "M250.43 110.23l25.28 19.76C287.22 118.9 302.8 112 320 112c8.84 0 16-7.16 16-16s-7.16-16-16-16c-27.44 0-52.06 11.71-69.57 30.23zM320 48c70.58 0 128 57.42 128 128 0 25.62-8.07 50.25-22.28 71.27l37.73 29.49C483.62 248.16 496 213.67 496 176 496 78.8 417.2 0 320 0c-17.59 0-81.33 1.58-132.77 60.82l37.84 29.58C262.63 48.81 307.46 48 320 48zm-79.94 411.17c0 3.15.94 6.22 2.68 8.84l24.51 36.84c2.97 4.46 7.97 7.14 13.32 7.14h78.85c5.36 0 10.36-2.68 13.32-7.14l24.51-36.84c1.74-2.62 2.67-5.7 2.68-8.84l.05-43.18H240.02l.04 43.18zM287.98 384v-.11c-.01-4.8-.74-9.56-2.21-14.13-4.46-13.93-16.1-45.55-39.55-80.05l-98.02-76.63c6.4 29.68 20.04 56.66 39.35 78.7 16.64 18.99 42.74 58.8 52.42 92.16v.06h48.01zm346.01 87.02L36 3.51C29.1-2.01 19.03-.9 13.51 6l-10 12.49C-2.02 25.39-.9 35.46 6 40.98l598 467.51c6.9 5.52 16.96 4.4 22.49-2.49l10-12.49c5.52-6.9 4.41-16.97-2.5-22.49z"
  ]
};
export const faLightsHoliday = {
  prefix: "far",
  iconName: "lights-holiday",
  icon: [
    640,
    512,
    [],
    "f7b2",
    "M637.8 85.7l-8.1-13.9c-4.4-7.6-14.1-10-21.8-5.9-80.8 43.7-182.3 67.7-287.9 67.7S112.9 109.8 32.1 66c-7.7-4.2-17.3-1.7-21.8 5.9L2.2 85.7c-4.7 7.9-1.7 18 6.4 22.4 45.8 24.9 97.7 43.7 153 56.2l-17.9 39.3c-5.4.6-10.5 3.7-12.9 9l-9.2 20.2c-25.6-.7-49.6 12.6-65.2 46.8-21.9 48.3 4.3 129.8 17.4 135.7 13.1 6 91.8-27.9 113.7-76.1 15.6-34.2 9.8-61.1-7.7-79.8l9.2-20.2c2.4-5.3 1.4-11.2-1.7-15.6l22.8-50.1c28.1 4.3 56.8 6.9 85.8 7.8v45.2c-4.7 2.8-8 7.7-8 13.5v22.2c-23.6 9.8-40 31.8-40 69.5 0 53 57.6 116.4 72 116.4s72-63.3 72-116.4c0-37.6-16.4-59.7-40-69.5V240c0-5.9-3.3-10.8-8-13.5v-45.2c29.1-.9 57.8-3.6 85.8-7.8l22.8 50.1c-3.1 4.5-4.1 10.3-1.7 15.6l9.2 20.2c-17.5 18.7-23.2 45.5-7.7 79.8 21.9 48.3 100.6 82.1 113.7 76.1 13.1-6 39.3-87.5 17.4-135.7-15.6-34.2-39.6-47.5-65.2-46.7l-9.2-20.2c-2.4-5.3-7.5-8.4-12.9-9l-17.9-39.3c55.2-12.5 107.1-31.3 153-56.2 8.3-4.4 11.2-14.5 6.6-22.5zm-494 233.6c-6.5 14.2-26.5 29-43.9 38.6-4.3-19.4-6.3-44.2.2-58.4 9.7-21.4 18.5-22 33.3-15.2 14.8 6.7 20.2 13.6 10.4 35zm362.8-35.1c14.8-6.7 23.6-6.2 33.3 15.2 6.5 14.2 4.4 39 .2 58.4-17.4-9.6-37.4-24.4-43.9-38.6-9.8-21.3-4.4-28.2 10.4-35zM320 384.9c-11.9-15.9-24-37.7-24-53.3 0-23.5 7.7-27.6 24-27.6s24 4.1 24 27.6c0 15.6-12.1 37.4-24 53.3z"
  ]
};
export const faLineColumns = {
  prefix: "far",
  iconName: "line-columns",
  icon: [
    512,
    512,
    [],
    "f870",
    "M496 424H304a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm0-128H304a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm0-128H304a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm0-128H304a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16V56a16 16 0 0 0-16-16zM208 296H16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm0 128H16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm0-384H16A16 16 0 0 0 0 56v16a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16V56a16 16 0 0 0-16-16zm0 128H16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16z"
  ]
};
export const faLineHeight = {
  prefix: "far",
  iconName: "line-height",
  icon: [
    640,
    512,
    [],
    "f871",
    "M626.29 392H269.71c-7.57 0-13.71 7.16-13.71 16v16c0 8.84 6.14 16 13.71 16h356.58c7.57 0 13.71-7.16 13.71-16v-16c0-8.84-6.14-16-13.71-16zM176 144c14.31 0 21.33-17.31 11.31-27.31l-80-80a16 16 0 0 0-22.62 0l-80 80C-4.64 126 .36 144 16 144h56v224H16c-14.29 0-21.31 17.31-11.29 27.31l80 80a16 16 0 0 0 22.62 0l80-80C196.64 386 191.64 368 176 368h-56V144zm450.31 88h-356.6c-7.57 0-13.71 7.16-13.71 16v16c0 8.84 6.14 16 13.71 16h356.58c7.57 0 13.71-7.16 13.71-16v-16c0-8.84-6.14-16-13.71-16zm0-160h-356.6C262.14 72 256 79.16 256 88v16c0 8.84 6.14 16 13.71 16h356.58c7.57 0 13.71-7.16 13.71-16V88c0-8.84-6.14-16-13.71-16z"
  ]
};
export const faLink = {
  prefix: "far",
  iconName: "link",
  icon: [
    512,
    512,
    [],
    "f0c1",
    "M314.222 197.78c51.091 51.091 54.377 132.287 9.75 187.16-6.242 7.73-2.784 3.865-84.94 86.02-54.696 54.696-143.266 54.745-197.99 0-54.711-54.69-54.734-143.255 0-197.99 32.773-32.773 51.835-51.899 63.409-63.457 7.463-7.452 20.331-2.354 20.486 8.192a173.31 173.31 0 0 0 4.746 37.828c.966 4.029-.272 8.269-3.202 11.198L80.632 312.57c-32.755 32.775-32.887 85.892 0 118.8 32.775 32.755 85.892 32.887 118.8 0l75.19-75.2c32.718-32.725 32.777-86.013 0-118.79a83.722 83.722 0 0 0-22.814-16.229c-4.623-2.233-7.182-7.25-6.561-12.346 1.356-11.122 6.296-21.885 14.815-30.405l4.375-4.375c3.625-3.626 9.177-4.594 13.76-2.294 12.999 6.524 25.187 15.211 36.025 26.049zM470.958 41.04c-54.724-54.745-143.294-54.696-197.99 0-82.156 82.156-78.698 78.29-84.94 86.02-44.627 54.873-41.341 136.069 9.75 187.16 10.838 10.838 23.026 19.525 36.025 26.049 4.582 2.3 10.134 1.331 13.76-2.294l4.375-4.375c8.52-8.519 13.459-19.283 14.815-30.405.621-5.096-1.938-10.113-6.561-12.346a83.706 83.706 0 0 1-22.814-16.229c-32.777-32.777-32.718-86.065 0-118.79l75.19-75.2c32.908-32.887 86.025-32.755 118.8 0 32.887 32.908 32.755 86.025 0 118.8l-45.848 45.84c-2.93 2.929-4.168 7.169-3.202 11.198a173.31 173.31 0 0 1 4.746 37.828c.155 10.546 13.023 15.644 20.486 8.192 11.574-11.558 30.636-30.684 63.409-63.457 54.733-54.735 54.71-143.3-.001-197.991z"
  ]
};
export const faLips = {
  prefix: "far",
  iconName: "lips",
  icon: [
    640,
    512,
    [],
    "f600",
    "M631.14 195.68C579.47 109.99 466.31 32 417.72 32c0 0-32.57 0-97.72 50-65.15-50-97.72-50-97.72-50-48.59 0-161.75 77.99-213.42 163.68-10.32 17.11-11.63 37.99-3.89 56.38C32.95 318.51 117.59 480 279.28 480h81.43c161.69 0 246.33-161.49 274.32-227.95 7.74-18.38 6.43-39.26-3.89-56.37zm-40.34 37.74C565.65 293.13 492.91 432 360.72 432h-81.43C147.09 432 74.35 293.13 49.2 233.42c-1.84-4.38-1.57-9.1.76-12.96C96.28 143.65 191.9 83.43 220.33 80.14 250 87.12 290.29 119.71 320 142.5c33.12-25.41 70.35-55.46 99.67-62.36 28.47 3.31 124.06 63.53 170.37 140.32 2.32 3.86 2.6 8.59.76 12.96zm-57.83-2.18C512.72 223.25 465.99 208 404 208c-33.36 8.34-51.13 14-84 14-32.53 0-49.47-5.37-84-14-61.99 0-108.72 15.25-128.96 23.24-5.51 2.17-6.8 9.23-2.41 13.2C128.18 265.73 199.97 320 320 320s191.82-54.27 215.37-75.56c4.39-3.97 3.1-11.03-2.4-13.2z"
  ]
};
export const faLiraSign = {
  prefix: "far",
  iconName: "lira-sign",
  icon: [
    384,
    512,
    [],
    "f195",
    "M371.994 256H336c-6.415 0-11.7 5.049-11.982 11.457C319.492 370.307 253.298 424 156.041 424H128V252.141l150.603-33.467A12 12 0 0 0 288 206.96v-24.585c0-7.677-7.109-13.38-14.603-11.714L128 202.97v-46.829l150.603-33.467A12 12 0 0 0 288 110.96V86.374c0-7.677-7.109-13.38-14.603-11.714L128 106.97V44c0-6.627-5.373-12-12-12H76c-6.627 0-12 5.373-12 12v77.192L9.397 133.326A12 12 0 0 0 0 145.041v24.585c0 7.677 7.109 13.38 14.603 11.714L64 170.363v46.829L9.397 229.326A12 12 0 0 0 0 241.041v24.585c0 7.677 7.109 13.38 14.603 11.714L64 266.363V468c0 6.627 5.373 12 12 12h81.026c132.906 0 221.849-77.22 226.965-211.595.259-6.78-5.212-12.405-11.997-12.405z"
  ]
};
export const faList = {
  prefix: "far",
  iconName: "list",
  icon: [
    512,
    512,
    [],
    "f03a",
    "M80 48H16A16 16 0 0 0 0 64v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16V64a16 16 0 0 0-16-16zm0 160H16a16 16 0 0 0-16 16v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-64a16 16 0 0 0-16-16zm0 160H16a16 16 0 0 0-16 16v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-64a16 16 0 0 0-16-16zm416-136H176a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm0 160H176a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm0-320H176a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16V88a16 16 0 0 0-16-16z"
  ]
};
export const faListAlt = {
  prefix: "far",
  iconName: "list-alt",
  icon: [
    512,
    512,
    [],
    "f022",
    "M464 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zm-6 400H54a6 6 0 0 1-6-6V86a6 6 0 0 1 6-6h404a6 6 0 0 1 6 6v340a6 6 0 0 1-6 6zm-42-92v24c0 6.627-5.373 12-12 12H204c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h200c6.627 0 12 5.373 12 12zm0-96v24c0 6.627-5.373 12-12 12H204c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h200c6.627 0 12 5.373 12 12zm0-96v24c0 6.627-5.373 12-12 12H204c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h200c6.627 0 12 5.373 12 12zm-252 12c0 19.882-16.118 36-36 36s-36-16.118-36-36 16.118-36 36-36 36 16.118 36 36zm0 96c0 19.882-16.118 36-36 36s-36-16.118-36-36 16.118-36 36-36 36 16.118 36 36zm0 96c0 19.882-16.118 36-36 36s-36-16.118-36-36 16.118-36 36-36 36 16.118 36 36z"
  ]
};
export const faListMusic = {
  prefix: "far",
  iconName: "list-music",
  icon: [
    512,
    512,
    [],
    "f8c9",
    "M470.36 1.51l-112 35.38A32 32 0 0 0 336 67.36v299.12c-18.16-9.07-40.16-14.48-64-14.48-61.86 0-112 35.82-112 80s50.14 80 112 80 112-35.82 112-80V195.36L489.64 162A32 32 0 0 0 512 131.48V32a32 32 0 0 0-41.64-30.49zM272 464c-39.7 0-64-20.72-64-32s24.3-32 64-32 64 20.72 64 32-24.3 32-64 32zm192-344.25L384 145V79.12l80-25.26zM16 104h256a16 16 0 0 0 16-16V72a16 16 0 0 0-16-16H16A16 16 0 0 0 0 72v16a16 16 0 0 0 16 16zm0 128h256a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16zm144 96a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16z"
  ]
};
export const faListOl = {
  prefix: "far",
  iconName: "list-ol",
  icon: [
    512,
    512,
    [],
    "f0cb",
    "M61.77 401l17.5-20.15a19.92 19.92 0 0 0 5.07-14.19v-3.31C84.34 356 80.5 352 73 352H16a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h22.84a154.82 154.82 0 0 0-11 12.31l-5.61 7c-4 5.07-5.25 10.13-2.8 14.88l1.05 1.93c3 5.76 6.3 7.88 12.25 7.88h4.73c10.33 0 15.94 2.44 15.94 9.09 0 4.72-4.2 8.22-14.36 8.22a41.54 41.54 0 0 1-15.47-3.12c-6.49-3.88-11.74-3.5-15.6 3.12l-5.59 9.31c-3.73 6.13-3.2 11.72 2.62 15.94 7.71 4.69 20.39 9.44 37 9.44 34.16 0 48.5-22.75 48.5-44.12-.03-14.38-9.12-29.76-28.73-34.88zM496 392H176a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm0-320H176a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16V88a16 16 0 0 0-16-16zm0 160H176a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zM16 160h64a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8H64V40a8 8 0 0 0-8-8H32a8 8 0 0 0-7.14 4.42l-8 16A8 8 0 0 0 24 64h8v64H16a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8zm-3.9 160H80a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8H41.33c3.28-10.29 48.33-18.68 48.33-56.44 0-29.06-25-39.56-44.47-39.56-21.36 0-33.8 10-40.45 18.75-4.38 5.59-3 10.84 2.79 15.37l8.58 6.88c5.61 4.56 11 2.47 16.13-2.44a13.4 13.4 0 0 1 9.45-3.84c3.33 0 9.28 1.56 9.28 8.75C51 248.19 0 257.31 0 304.59v4C0 316 5.08 320 12.1 320z"
  ]
};
export const faListUl = {
  prefix: "far",
  iconName: "list-ul",
  icon: [
    512,
    512,
    [],
    "f0ca",
    "M48 368a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm0-160a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm0-160a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm448 24H176a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16V88a16 16 0 0 0-16-16zm0 160H176a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm0 160H176a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16z"
  ]
};
export const faLocation = {
  prefix: "far",
  iconName: "location",
  icon: [
    512,
    512,
    [],
    "f601",
    "M256 168c-48.6 0-88 39.4-88 88s39.4 88 88 88 88-39.4 88-88-39.4-88-88-88zm0 128c-22.06 0-40-17.94-40-40s17.94-40 40-40 40 17.94 40 40-17.94 40-40 40zm240-64h-49.66C435.49 145.19 366.81 76.51 280 65.66V16c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v49.66C145.19 76.51 76.51 145.19 65.66 232H16c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h49.66C76.51 366.81 145.19 435.49 232 446.34V496c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-49.66C366.81 435.49 435.49 366.8 446.34 280H496c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16zM256 400c-79.4 0-144-64.6-144-144s64.6-144 144-144 144 64.6 144 144-64.6 144-144 144z"
  ]
};
export const faLocationArrow = {
  prefix: "far",
  iconName: "location-arrow",
  icon: [
    512,
    512,
    [],
    "f124",
    "M461.9 0c-5.73 0-11.59 1.1-17.39 3.52L28.74 195.41c-47.97 22.39-31.98 92.75 19.19 92.75h175.91v175.91c0 30.01 24.21 47.93 48.74 47.93 17.3 0 34.75-8.9 44.01-28.74l191.9-415.78C522.06 34.89 494.14 0 461.9 0zM271.81 464.07V240.19h-47.97l-175.48.71c-.27-.37-.47-1.35.48-1.93L462.05 48.26c.61.41 1.28 1.07 1.69 1.68L271.81 464.07z"
  ]
};
export const faLocationCircle = {
  prefix: "far",
  iconName: "location-circle",
  icon: [
    496,
    512,
    [],
    "f602",
    "M304.51 140.2l-182.06 83.66c-19.85 9.23-30.01 29.64-25.32 50.81 4.63 20.69 22.67 35.15 43.89 35.15h52.99v52.73c0 21.14 14.54 39.1 35.32 43.69 3.44.76 6.88 1.14 10.25 1.14 17.38 0 33.01-9.82 40.8-26.45l84-181.13.38-.83c6.94-16.57 2.94-35.75-10.22-48.87-13.23-13.15-32.49-17.15-50.03-9.9zm-62.49 209.41v-87.58h-88.06l163.53-75.15-75.47 162.73zM248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 448c-110.28 0-200-89.72-200-200S137.72 56 248 56s200 89.72 200 200-89.72 200-200 200z"
  ]
};
export const faLocationSlash = {
  prefix: "far",
  iconName: "location-slash",
  icon: [
    640,
    512,
    [],
    "f603",
    "M633.99 471.02L36 3.51C29.1-2.01 19.03-.9 13.51 6l-10 12.49C-2.02 25.39-.9 35.46 6 40.98l598 467.51c6.9 5.52 16.96 4.4 22.49-2.49l10-12.49c5.52-6.9 4.41-16.97-2.5-22.49zM320 112c79.4 0 144 64.6 144 144 0 6.72-1.09 13.15-1.99 19.64l42.25 33.03c2.66-9.31 4.84-18.83 6.07-28.67H560c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16h-49.66C499.49 145.19 430.81 76.51 344 65.66V16c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v49.66c-25.81 3.23-49.69 12.07-71.26 24.48l41.55 32.48C282.92 115.9 300.99 112 320 112zm0 288c-79.4 0-144-64.6-144-144 0-6.72 1.09-13.16 1.99-19.64l-42.25-33.03c-2.66 9.31-4.85 18.83-6.08 28.67H80c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h49.66C140.51 366.81 209.2 435.49 296 446.34V496c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-49.66c25.81-3.23 49.69-12.07 71.26-24.48l-41.55-32.48C357.08 396.1 339.01 400 320 400z"
  ]
};
export const faLock = {
  prefix: "far",
  iconName: "lock",
  icon: [
    448,
    512,
    [],
    "f023",
    "M400 192h-32v-46.6C368 65.8 304 .2 224.4 0 144.8-.2 80 64.5 80 144v48H48c-26.5 0-48 21.5-48 48v224c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V240c0-26.5-21.5-48-48-48zm-272-48c0-52.9 43.1-96 96-96s96 43.1 96 96v48H128v-48zm272 320H48V240h352v224z"
  ]
};
export const faLockAlt = {
  prefix: "far",
  iconName: "lock-alt",
  icon: [
    448,
    512,
    [],
    "f30d",
    "M224 412c-15.5 0-28-12.5-28-28v-64c0-15.5 12.5-28 28-28s28 12.5 28 28v64c0 15.5-12.5 28-28 28zm224-172v224c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V240c0-26.5 21.5-48 48-48h32v-48C80 64.5 144.8-.2 224.4 0 304 .2 368 65.8 368 145.4V192h32c26.5 0 48 21.5 48 48zm-320-48h192v-48c0-52.9-43.1-96-96-96s-96 43.1-96 96v48zm272 48H48v224h352V240z"
  ]
};
export const faLockOpen = {
  prefix: "far",
  iconName: "lock-open",
  icon: [
    576,
    512,
    [],
    "f3c1",
    "M432.3 0C352.8-.2 288 64.5 288 144v48H48c-26.5 0-48 21.5-48 48v224c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V240c0-26.5-21.5-48-48-48h-64v-46.8c0-52.8 42.1-96.7 95-97.2 53.4-.6 97 42.7 97 96v56c0 13.3 10.7 24 24 24s24-10.7 24-24v-54.6C576 65.8 512 .2 432.3 0zM400 240v224H48V240h352z"
  ]
};
export const faLockOpenAlt = {
  prefix: "far",
  iconName: "lock-open-alt",
  icon: [
    576,
    512,
    [],
    "f3c2",
    "M432.3 0C352.8-.2 288 64.5 288 144v48H48c-26.5 0-48 21.5-48 48v224c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V240c0-26.5-21.5-48-48-48h-64v-46.8c0-52.8 42.1-96.7 95-97.2 53.4-.6 97 42.7 97 96v56c0 13.3 10.7 24 24 24s24-10.7 24-24v-54.6C576 65.8 512 .2 432.3 0zM400 240v224H48V240h352zM225 412c-15.5 0-28-12.5-28-28v-64c0-15.5 12.5-28 28-28s28 12.5 28 28v64c0 15.5-12.5 28-28 28z"
  ]
};
export const faLongArrowAltDown = {
  prefix: "far",
  iconName: "long-arrow-alt-down",
  icon: [
    256,
    512,
    [],
    "f309",
    "M20.485 372.485l99.029 99.03c4.686 4.686 12.284 4.686 16.971 0l99.029-99.03c7.56-7.56 2.206-20.485-8.485-20.485H156V44c0-6.627-5.373-12-12-12h-32c-6.627 0-12 5.373-12 12v308H28.97c-10.69 0-16.044 12.926-8.485 20.485z"
  ]
};
export const faLongArrowAltLeft = {
  prefix: "far",
  iconName: "long-arrow-alt-left",
  icon: [
    448,
    512,
    [],
    "f30a",
    "M107.515 150.971L8.485 250c-4.686 4.686-4.686 12.284 0 16.971L107.515 366c7.56 7.56 20.485 2.206 20.485-8.485v-71.03h308c6.627 0 12-5.373 12-12v-32c0-6.627-5.373-12-12-12H128v-71.03c0-10.69-12.926-16.044-20.485-8.484z"
  ]
};
export const faLongArrowAltRight = {
  prefix: "far",
  iconName: "long-arrow-alt-right",
  icon: [
    448,
    512,
    [],
    "f30b",
    "M340.485 366l99.03-99.029c4.686-4.686 4.686-12.284 0-16.971l-99.03-99.029c-7.56-7.56-20.485-2.206-20.485 8.485v71.03H12c-6.627 0-12 5.373-12 12v32c0 6.627 5.373 12 12 12h308v71.03c0 10.689 12.926 16.043 20.485 8.484z"
  ]
};
export const faLongArrowAltUp = {
  prefix: "far",
  iconName: "long-arrow-alt-up",
  icon: [
    256,
    512,
    [],
    "f30c",
    "M235.515 139.515l-99.029-99.03c-4.686-4.686-12.284-4.686-16.971 0l-99.029 99.03C12.926 147.074 18.28 160 28.97 160H100v308c0 6.627 5.373 12 12 12h32c6.627 0 12-5.373 12-12V160h71.03c10.69 0 16.044-12.926 8.485-20.485z"
  ]
};
export const faLongArrowDown = {
  prefix: "far",
  iconName: "long-arrow-down",
  icon: [
    320,
    512,
    [],
    "f175",
    "M300.3 327.5l-19.6-19.6c-4.8-4.8-12.5-4.7-17.1.2L186 388.8V44c0-6.6-5.4-12-12-12h-28c-6.6 0-12 5.4-12 12v344.8l-77.5-80.7c-4.7-4.8-12.4-4.9-17.1-.2l-19.6 19.6c-4.7 4.7-4.7 12.3 0 17l131.8 131.8c4.7 4.7 12.3 4.7 17 0l131.8-131.8c4.6-4.7 4.6-12.3-.1-17z"
  ]
};
export const faLongArrowLeft = {
  prefix: "far",
  iconName: "long-arrow-left",
  icon: [
    448,
    512,
    [],
    "f177",
    "M152.485 396.284l19.626-19.626c4.753-4.753 4.675-12.484-.173-17.14L91.22 282H436c6.627 0 12-5.373 12-12v-28c0-6.627-5.373-12-12-12H91.22l80.717-77.518c4.849-4.656 4.927-12.387.173-17.14l-19.626-19.626c-4.686-4.686-12.284-4.686-16.971 0L3.716 247.515c-4.686 4.686-4.686 12.284 0 16.971l131.799 131.799c4.686 4.685 12.284 4.685 16.97-.001z"
  ]
};
export const faLongArrowRight = {
  prefix: "far",
  iconName: "long-arrow-right",
  icon: [
    448,
    512,
    [],
    "f178",
    "M295.515 115.716l-19.626 19.626c-4.753 4.753-4.675 12.484.173 17.14L356.78 230H12c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h344.78l-80.717 77.518c-4.849 4.656-4.927 12.387-.173 17.14l19.626 19.626c4.686 4.686 12.284 4.686 16.971 0l131.799-131.799c4.686-4.686 4.686-12.284 0-16.971L312.485 115.716c-4.686-4.686-12.284-4.686-16.97 0z"
  ]
};
export const faLongArrowUp = {
  prefix: "far",
  iconName: "long-arrow-up",
  icon: [
    320,
    512,
    [],
    "f176",
    "M19.716 184.485l19.626 19.626c4.753 4.753 12.484 4.675 17.14-.173L134 123.22V468c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12V123.22l77.518 80.717c4.656 4.849 12.387 4.927 17.14.173l19.626-19.626c4.686-4.686 4.686-12.284 0-16.971L168.485 35.716c-4.686-4.686-12.284-4.686-16.971 0L19.716 167.515c-4.686 4.686-4.686 12.284 0 16.97z"
  ]
};
export const faLoveseat = {
  prefix: "far",
  iconName: "loveseat",
  icon: [
    512,
    512,
    [],
    "f4cc",
    "M448 196.6V128c0-53-43-96-96-96H160c-53 0-96 43-96 96v68.6C29.4 207.3 3.1 236.9.3 273-2 302 9.9 329.5 32 347.6V440c0 22.1 17.9 40 40 40h88c4 0 30.2-.9 31.9-32h128.3c1.4 30.8 28 32 31.9 32h88c22.1 0 40-17.9 40-40v-92.4c22-18.1 34-45.5 31.7-74.6-2.9-36.1-29.2-65.7-63.8-76.4zM144 432H80V321.3l-11.9-7C54.6 306.5 47 292 48.2 276.7 49.7 256.5 69.4 240 92 240h12c22.1 0 40 17.9 40 40v152zm176-128v96H192v-96h128zm3.7-48H188.2c-9.8-34.3-39.7-59.8-76.2-63.2V128c0-26.5 21.5-48 48-48h192c26.5 0 48 21.5 48 48v64.8c-36.6 3.4-66.5 28.9-76.3 63.2zm120.2 58.4l-11.9 7V432h-64V280c0-22.1 17.9-40 40-40h12c22.6 0 42.3 16.5 43.9 36.8 1.1 15.3-6.5 29.7-20 37.6z"
  ]
};
export const faLowVision = {
  prefix: "far",
  iconName: "low-vision",
  icon: [
    576,
    512,
    [],
    "f2a8",
    "M569.348 231.63C512.968 135.95 407.81 72 288 72c-31.44 0-61.87 4.4-90.67 12.63L144 5.12c-3.8-5.429-11.282-6.75-16.712-2.95l-19.657 13.758c-5.43 3.8-6.751 11.284-2.95 16.713L150.8 101.84c-58.851 27-110.003 71.82-144.147 129.79a47.963 47.963 0 0 0 0 48.74c36.15 61.35 92.357 109.66 159.637 136.42L50.65 251.6a273.208 273.208 0 0 1 38.609-49.099L254.32 438.3c19.795 2.055 40.851 2.183 59.09.73L126.009 171.311a277.521 277.521 0 0 1 52.851-29.381l.34.49L432 506.881c3.8 5.429 11.282 6.75 16.712 2.95l19.657-13.758c5.43-3.8 6.751-11.283 2.95-16.713l-46.119-69.2c60.42-27.72 110.818-73.22 144.148-129.79a47.963 47.963 0 0 0 0-48.74zM397.15 370.08l-26.59-37.99c54.022-41.348 68.205-114.637 37.44-172.13v.04c0 30.93-25.07 56-56 56s-56-25.07-56-56c0-15.17 6.04-28.92 15.84-39.01 92.48 7.74 172 60.08 216.16 135.01-29.8 50.57-75.71 90.86-130.85 114.08z"
  ]
};
export const faLuchador = {
  prefix: "far",
  iconName: "luchador",
  icon: [
    448,
    512,
    [],
    "f455",
    "M224 0C100.3 0 0 100.3 0 224v128c0 88.4 71.6 160 160 160h128c88.4 0 160-71.6 160-160V224C448 100.3 347.7 0 224 0zm176 352c0 61.8-50.2 112-112 112H160c-61.8 0-112-50.2-112-112V224c0-97 79-176 176-176s176 79 176 176v128zM226.5 226.2c-.9-.7-4.2-.7-5.1 0C213.3 188.3 182 160 144 160H76c-6.6 0-12 5.4-12 12v30.7c0 47.1 35.8 85.3 80 85.3h22.4c-7.4 12.2-12.5 23.5-15.8 32.9-30.9 4.6-54.6 31-54.6 63.1 0 35.5 29.4 64 64.9 64H287c35.5 0 64.9-28.5 64.9-64 0-32.1-23.7-58.5-54.6-63.1-3.3-9.5-8.4-20.7-15.8-32.9H304c44.2 0 80-38.2 80-85.3V172c0-6.6-5.4-12-12-12h-68c-37.9 0-69.3 28.3-77.5 66.2zm-2.5 40.5c20.2 19.9 31.9 38.6 38.7 53.3h-77.4c6.8-14.8 18.5-33.4 38.7-53.3zM144 256c-26.5 0-48-23.9-48-53.3V192h48c26.5 0 48 23.9 48 53.3v8.7c-.6.7-1.2 1.3-1.8 2H144zm144 96c17.6 0 32 14.4 32 32s-14.4 32-32 32H160c-17.6 0-32-14.4-32-32s14.4-32 32-32h128zm64-149.3c0 29.4-21.5 53.3-48 53.3h-46.2c-.6-.7-1.2-1.3-1.8-2v-8.7c0-29.4 21.5-53.3 48-53.3h48v10.7z"
  ]
};
export const faLuggageCart = {
  prefix: "far",
  iconName: "luggage-cart",
  icon: [
    640,
    512,
    [],
    "f59d",
    "M624 400H144V16c0-8.84-7.16-16-16-16H16C7.16 0 0 7.16 0 16v16c0 8.84 7.16 16 16 16h80v384c0 8.84 7.16 16 16 16h50.94c-1.79 5.03-2.94 10.36-2.94 16 0 26.51 21.49 48 48 48s48-21.49 48-48c0-5.64-1.15-10.97-2.94-16h197.88c-1.79 5.03-2.94 10.36-2.94 16 0 26.51 21.49 48 48 48s48-21.49 48-48c0-5.64-1.15-10.97-2.94-16H624c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16zm-400-48h320c17.67 0 32-14.33 32-32V128c0-17.67-14.33-32-32-32h-64V48c0-26.51-21.49-48-48-48h-96c-26.51 0-48 21.49-48 48v48h-64c-17.67 0-32 14.33-32 32v192c0 17.67 14.33 32 32 32zm256-208h48v160h-48V144zM336 48h96v48h-96V48zm0 96h96v160h-96V144zm-96 0h48v160h-48V144z"
  ]
};
export const faLungs = {
  prefix: "far",
  iconName: "lungs",
  icon: [
    640,
    512,
    [],
    "f604",
    "M636.11 390.15C614.44 308.85 580.07 231 534.1 159.13 511.98 124.56 498.03 96 454.05 96 415.36 96 384 125.42 384 161.71v60.11l-32.88-21.92a15.996 15.996 0 0 1-7.12-13.31V16c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v170.59c0 5.35-2.67 10.34-7.12 13.31L256 221.82v-60.11C256 125.42 224.64 96 185.95 96c-43.98 0-57.93 28.56-80.05 63.13C59.93 231 25.56 308.85 3.89 390.15 1.3 399.84 0 409.79 0 419.78 0 472.11 45.63 512 98.07 512c18.09 0 24.45-2.87 86.68-19.55 42.18-11.3 71.26-47.47 71.26-88.62v-87.49l-48 32v55.49c0 19.25-14.67 36.62-35.68 42.25C107.71 463.4 107.88 464 98.07 464c-30.31 0-57.91-23.57-47.79-61.49C70.68 325.93 103 252.74 146.33 185c23.04-36.41 25.34-41 39.62-41 11.95 0 22.05 8.11 22.05 17.71v92.11l-80 53.33c-7.35 4.9-9.34 14.83-4.44 22.19l8.88 13.31c4.9 7.35 14.84 9.34 22.19 4.44L320 236.84l165.38 110.25c7.35 4.9 17.29 2.91 22.19-4.44l8.88-13.31c4.9-7.35 2.91-17.29-4.44-22.19l-80-53.33v-92.11c0-9.6 10.1-17.71 22.05-17.71 14.28 0 16.57 4.59 39.62 41 43.33 67.74 75.65 140.93 96.06 217.51 10.12 37.92-17.48 61.49-47.79 61.49-9.81 0-9.64-.6-74.25-17.91-21.01-5.63-35.68-23.01-35.68-42.25v-55.49l-48-32v87.49c0 41.15 29.08 77.31 71.26 88.62 62.22 16.68 68.59 19.55 86.68 19.55 52.44 0 98.07-39.89 98.07-92.22-.03-10-1.33-19.95-3.92-29.64z"
  ]
};
export const faLungsVirus = {
  prefix: "far",
  iconName: "lungs-virus",
  icon: [
    640,
    512,
    [],
    "e067",
    "M636.08,390.14a821.47,821.47,0,0,0-102-231C512,124.56,498,96,454,96c-38.69,0-70,29.42-70,65.7v27.77a47.2,47.2,0,0,1,48-2.69V161.7c0-9.6,10.1-17.7,22.05-17.7,14.28,0,16.56,4.59,39.62,41A772.73,772.73,0,0,1,589.71,402.5C599.83,440.42,572.24,464,541.93,464c-9.81,0-9.64-.6-74.25-17.91a51.21,51.21,0,0,1-18.08-9.42c-1.73,2.6-2.87,5.49-5.17,7.78A47.65,47.65,0,0,1,410.5,458.5a48.69,48.69,0,0,1-7.76-.75,98,98,0,0,0,52.52,34.69C517.47,509.13,523.85,512,541.93,512c52.45,0,98.07-39.89,98.07-92.22A116,116,0,0,0,636.08,390.14Zm-440.54,54.3c-2.3-2.29-3.43-5.17-5.16-7.77a51,51,0,0,1-18.06,9.39C107.7,463.39,107.87,464,98.06,464c-30.3,0-57.91-23.57-47.78-61.49a772.42,772.42,0,0,1,96-217.51c23.05-36.4,25.34-41,39.62-41,12,0,22.05,8.1,22.05,17.7v25.07a47.22,47.22,0,0,1,48,2.7V161.7c0-36.28-31.36-65.7-70.05-65.7-44,0-57.93,28.56-80,63.12a821.47,821.47,0,0,0-102,231A114.68,114.68,0,0,0,0,419.77C0,472.09,45.62,512,98.06,512c18.09,0,24.45-2.87,86.68-19.54a98.06,98.06,0,0,0,52.52-34.7,46.51,46.51,0,0,1-41.72-13.3ZM344,150.68V16A16,16,0,0,0,328,0H312a16,16,0,0,0-16,16V150.68a46.44,46.44,0,0,1,48,0Zm77.85,271.14a16,16,0,0,0,0-22.63l-8.58-8.57C393.09,370.46,407.37,336,435.88,336H448a16,16,0,0,0,0-32H435.88c-28.51,0-42.79-34.47-22.63-54.62l8.58-8.58a16,16,0,0,0-22.63-22.62l-8.57,8.57C370.47,246.9,336,232.62,336,204.11V192a16,16,0,0,0-32,0v12.11c0,28.51-34.47,42.79-54.63,22.63l-8.57-8.57a16,16,0,0,0-22.63,22.62l8.58,8.58c20.16,20.15,5.88,54.62-22.63,54.62H192a16,16,0,0,0,0,32h12.12c28.51,0,42.79,34.47,22.63,54.63l-8.58,8.57a16,16,0,0,0,22.63,22.63l8.57-8.58c20.16-20.16,54.63-5.88,54.63,22.63V448a16,16,0,0,0,32,0V435.87c0-28.51,34.47-42.79,54.63-22.63l8.57,8.58a16,16,0,0,0,22.63,0ZM288,304a16,16,0,1,1,16-16A16,16,0,0,1,288,304Zm64,64a16,16,0,1,1,16-16A16,16,0,0,1,352,368Z"
  ]
};
export const faMace = {
  prefix: "far",
  iconName: "mace",
  icon: [
    512,
    512,
    [],
    "f6f8",
    "M304 176c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm196.98 18.97l-56.5-17.91c-12.21-55.61-56.4-99.15-112.42-110.23L313.05 10.8c-4.92-14.5-17.46-14.37-22.08.22l-17.91 56.5c-55.61 12.21-99.15 56.4-110.23 112.42l-56.03 19.01c-14.5 4.92-14.37 17.46.22 22.08l56.5 17.91c4.21 19.18 12.29 36.81 23.31 52.29L3.51 474.54c-4.69 4.69-4.69 12.29 0 16.97l16.97 16.97c4.69 4.69 12.29 4.69 16.97 0l183.32-183.32c16.26 11.57 34.87 19.99 55.16 24l19.01 56.03c4.92 14.5 17.46 14.37 22.08-.22l17.91-56.5c55.61-12.21 99.15-56.4 110.23-112.42l56.03-19.01c14.51-4.91 14.38-17.45-.21-22.07zM304 304c-52.94 0-96-43.07-96-96 0-52.94 43.06-96 96-96s96 43.06 96 96c0 52.93-43.06 96-96 96z"
  ]
};
export const faMagic = {
  prefix: "far",
  iconName: "magic",
  icon: [
    512,
    512,
    [],
    "f0d0",
    "M497.94 76.28l-62.22-62.22C426.34 4.69 414.06 0 401.78 0c-12.29 0-24.57 4.69-33.94 14.06L14.06 367.84c-18.75 18.75-18.75 49.14 0 67.88l62.22 62.22c9.37 9.37 21.66 14.06 33.94 14.06 12.28 0 24.57-4.69 33.94-14.06l353.77-353.78c18.76-18.74 18.76-49.13.01-67.88zM110.23 464L48 401.78l223.9-223.93 62.24 62.24L110.23 464zm257.85-257.86l-62.24-62.24L401.73 48h.05L464 110.22l-95.92 95.92zM432 288l-26.66 53.33L352 368l53.34 26.67L432 448l26.66-53.33L512 368l-53.34-26.67L432 288zM224 96l16-32 32-16-32-16-16-32-16 32-32 16 32 16 16 32zM80 160l26.66-53.33L160 80l-53.34-26.67L80 0 53.34 53.33 0 80l53.34 26.67L80 160z"
  ]
};
export const faMagnet = {
  prefix: "far",
  iconName: "magnet",
  icon: [
    512,
    512,
    [],
    "f076",
    "M509.8 55.6c-1.2-3.3-2.9-6.4-5-9.2-6.6-8.8-17-14.5-28.8-14.5H372c-12.4 0-23.4 6.3-29.9 15.9-1 1.4-1.8 2.9-2.6 4.5-2.3 4.7-3.5 10-3.5 15.6v172c0 64-40 96-79.9 96-40 0-80.1-32-80.1-96V68c0-4.3-.8-8.5-2.2-12.4-1.2-3.3-2.9-6.4-5-9.2-6.6-8.8-17-14.5-28.8-14.5H36c-11.8 0-22.3 5.7-28.8 14.5-2.1 2.8-3.8 5.9-5 9.2C.8 59.5 0 63.7 0 68v189.3C0 408 136.2 504 256.8 504 377.5 504 512 408 512 257.3V68c0-4.3-.8-8.5-2.2-12.4zM464 257.3c0 28.9-6.1 56.2-18.2 81.3-11.2 23.4-27.3 44.4-47.9 62.5-19.5 17.2-42.9 31.2-67.6 40.7-24.1 9.3-49.6 14.2-73.6 14.2-49.5 0-102.6-20.6-142.1-55-20.7-18.1-37-39.1-48.4-62.5-12-25.1-18.2-52.4-18.2-81.2V176h80v64c0 53.1 20.7 86.3 38 104.8 11.9 12.7 26 22.6 41.8 29.3 15.3 6.5 31.6 9.9 48.2 9.9 16.7 0 32.9-3.3 48.2-9.8 15.8-6.8 29.9-16.6 41.8-29.3 17.3-18.5 38-51.7 38-104.8v-64h80v81.2z"
  ]
};
export const faMailBulk = {
  prefix: "far",
  iconName: "mail-bulk",
  icon: [
    576,
    512,
    [],
    "f674",
    "M112 48h288v48h48V48c0-26.51-21.49-48-48-48H112C85.49 0 64 21.49 64 48v144h48V48zm224 176H48c-26.51 0-48 21.49-48 48v192c0 26.51 21.49 48 48 48h288c26.51 0 48-21.49 48-48V272c0-26.51-21.49-48-48-48zm0 240H48V343.96c14.49 11.01 80 58.12 80 58.12 14.44 11.2 38.62 29.92 64 29.92s49.56-18.72 64-29.92c0 0 65.5-47.1 80-58.12V464zm0-178.61c-2.37 1.85-111.81 81.94-117.09 85.55-8.5 5.83-19.1 13.06-26.91 13.06-9.41 0-22.69-10.55-31.5-17.53-3.41-2.72-110.13-82.43-112.5-84.28V272h288v13.39zM528 128H240c-26.51 0-48 21.49-48 48v16h48v-16h288v192H416v48h112c26.51 0 48-21.49 48-48V176c0-26.51-21.49-48-48-48zm-96 80v64h64v-64h-64z"
  ]
};
export const faMailbox = {
  prefix: "far",
  iconName: "mailbox",
  icon: [
    576,
    512,
    [],
    "f813",
    "M432 64H144A144 144 0 0 0 0 208v208a32 32 0 0 0 32 32h512a32 32 0 0 0 32-32V208A144 144 0 0 0 432 64zM240 400H48V208a96 96 0 0 1 192 0zm288 0H288V208c0-37.05-14.38-70.48-37.37-96H432a96.1 96.1 0 0 1 96 96zm-64-208H344a8 8 0 0 0-8 8v32a8 8 0 0 0 8 8h72v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-64a16 16 0 0 0-16-16zm-280 0h-80a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8h80a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8z"
  ]
};
export const faMale = {
  prefix: "far",
  iconName: "male",
  icon: [
    256,
    512,
    [],
    "f183",
    "M211.421 155.079C221.892 139.273 228 120.338 228 100 228 44.86 183.14 0 128 0S28 44.86 28 100c0 20.338 6.108 39.273 16.579 55.079C18.005 169.985 0 198.424 0 231v89c0 26.039 15.629 48.494 38 58.479V448c0 35.29 28.71 64 64 64h52c35.29 0 64-28.71 64-64v-69.521c22.371-9.984 38-32.44 38-58.479v-89c0-32.576-18.005-61.015-44.579-75.921zM128 48c28.719 0 52 23.281 52 52s-23.281 52-52 52-52-23.281-52-52 23.281-52 52-52zm80 272c0 8.8-7.2 16-16 16h-22v112c0 8.837-7.163 16-16 16h-52c-8.837 0-16-7.163-16-16V336H64c-8.837 0-16-7.163-16-16v-89c0-19.793 15.074-39 40.818-39 24.961 10.671 53.4 10.672 78.364 0 25.37 0 40.818 18.885 40.818 39v89z"
  ]
};
export const faMandolin = {
  prefix: "far",
  iconName: "mandolin",
  icon: [
    512,
    512,
    [],
    "f6f9",
    "M507.31 50.67l-46-46a16 16 0 0 0-19.81-2.25l-64 40.07a32 32 0 0 0-14 19.11L345.07 133l-59.23 59.23c-189.15-3.61-236.21 45.17-255.1 64.06-46.81 46.78-39.52 150.35 17.53 207.44C80.22 495.65 126.73 512 169.69 512c33.81 0 65.42-10.12 86-30.74 15.59-15.59 67.83-61.13 64-255.09L379 166.93l71.37-18.46a32 32 0 0 0 19.11-14l40.07-64a16 16 0 0 0-2.24-19.8zM221.77 447.33C211.34 457.77 191.86 464 169.69 464c-32.84 0-66.36-13.11-87.46-34.21-39.72-39.73-43.63-113.5-17.55-139.57 47.87-48.31 156.5-49 172.76-49.6l-49.16 49.16a48.81 48.81 0 1 0 33.94 33.94l49.18-49.19c-.5 14.98-1.14 124.64-49.63 172.8z"
  ]
};
export const faMap = {
  prefix: "far",
  iconName: "map",
  icon: [
    576,
    512,
    [],
    "f279",
    "M560.02 32c-1.96 0-3.98.37-5.96 1.16L384.01 96H384L212 35.28A64.252 64.252 0 0 0 191.76 32c-6.69 0-13.37 1.05-19.81 3.14L20.12 87.95A32.006 32.006 0 0 0 0 117.66v346.32C0 473.17 7.53 480 15.99 480c1.96 0 3.97-.37 5.96-1.16L192 416l172 60.71a63.98 63.98 0 0 0 40.05.15l151.83-52.81A31.996 31.996 0 0 0 576 394.34V48.02c0-9.19-7.53-16.02-15.98-16.02zM224 90.42l128 45.19v285.97l-128-45.19V90.42zM48 418.05V129.07l128-44.53v286.2l-.64.23L48 418.05zm480-35.13l-128 44.53V141.26l.64-.24L528 93.95v288.97z"
  ]
};
export const faMapMarked = {
  prefix: "far",
  iconName: "map-marked",
  icon: [
    576,
    512,
    [],
    "f59f",
    "M560 160c-2 0-4 .4-6 1.2l-73.5 27.2c-8.2 20.4-20.2 42-34.2 63.8L528 222v193l-128 44.5V316.3c-13.7 17.3-27.9 34.3-42.5 50.8-1.7 1.9-3.6 3.5-5.5 5.1v81.4l-128-45.2v-113c-18.1-24.1-34.8-48.8-48-72.8v180.2l-.6.2L48 450V257l123.6-43c-8-15.4-14.1-30.3-18.3-44.5L20.1 216C8 220.8 0 232.6 0 245.7V496c0 9.2 7.5 16 16 16 2 0 4-.4 6-1.2L192 448l172 60.7c13 4.3 27 4.4 40 .2L555.9 456c12.2-4.9 20.1-16.6 20.1-29.7V176c0-9.2-7.5-16-16-16zM320 352c5 0 10-2 13.5-6.1 35.3-40 127.3-150.1 127.3-210.6C460.8 60.6 397.8 0 320 0S179.2 60.6 179.2 135.3c0 60.4 92 170.6 127.3 210.6C310 350 315 352 320 352zm0-304c51.2 0 92.8 39.2 92.8 87.3 0 21.4-31.8 79.1-92.8 152.6-61-73.5-92.8-131.2-92.8-152.6 0-48.1 41.6-87.3 92.8-87.3z"
  ]
};
export const faMapMarkedAlt = {
  prefix: "far",
  iconName: "map-marked-alt",
  icon: [
    576,
    512,
    [],
    "f5a0",
    "M344 126c0-13.3-10.7-24-24-24s-24 10.7-24 24c0 13.2 10.7 24 24 24s24-10.8 24-24zm-24 226c5 0 10-2 13.5-6.1 35.3-40 127.3-150.1 127.3-210.6C460.8 60.6 397.8 0 320 0S179.2 60.6 179.2 135.3c0 60.4 92 170.6 127.3 210.6C310 350 315 352 320 352zm0-304c51.2 0 92.8 39.2 92.8 87.3 0 21.4-31.8 79.1-92.8 152.6-61-73.5-92.8-131.2-92.8-152.6 0-48.1 41.6-87.3 92.8-87.3zm240 112c-2 0-4 .4-6 1.2l-73.5 27.2c-8.2 20.4-20.2 42-34.2 63.8L528 222v193l-128 44.5V316.3c-13.7 17.3-27.9 34.3-42.5 50.8-1.7 1.9-3.6 3.5-5.5 5.1v81.4l-128-45.2v-113c-18.1-24.1-34.8-48.8-48-72.8v180.2l-.6.2L48 450V257l123.6-43c-8-15.4-14.1-30.3-18.3-44.5L20.1 216C8 220.8 0 232.6 0 245.7V496c0 9.2 7.5 16 16 16 2 0 4-.4 6-1.2L192 448l172 60.7c13 4.3 27 4.4 40 .2L555.9 456c12.2-4.9 20.1-16.6 20.1-29.7V176c0-9.2-7.5-16-16-16z"
  ]
};
export const faMapMarker = {
  prefix: "far",
  iconName: "map-marker",
  icon: [
    384,
    512,
    [],
    "f041",
    "M192 0C85.903 0 0 86.014 0 192c0 71.117 23.991 93.341 151.271 297.424 18.785 30.119 62.694 30.083 81.457 0C360.075 285.234 384 263.103 384 192 384 85.903 297.986 0 192 0zm0 464C64.576 259.686 48 246.788 48 192c0-79.529 64.471-144 144-144s144 64.471 144 144c0 54.553-15.166 65.425-144 272z"
  ]
};
export const faMapMarkerAlt = {
  prefix: "far",
  iconName: "map-marker-alt",
  icon: [
    384,
    512,
    [],
    "f3c5",
    "M192 0C85.903 0 0 86.014 0 192c0 71.117 23.991 93.341 151.271 297.424 18.785 30.119 62.694 30.083 81.457 0C360.075 285.234 384 263.103 384 192 384 85.903 297.986 0 192 0zm0 464C64.576 259.686 48 246.788 48 192c0-79.529 64.471-144 144-144s144 64.471 144 144c0 54.553-15.166 65.425-144 272zm-80-272c0-44.183 35.817-80 80-80s80 35.817 80 80-35.817 80-80 80-80-35.817-80-80z"
  ]
};
export const faMapMarkerAltSlash = {
  prefix: "far",
  iconName: "map-marker-alt-slash",
  icon: [
    640,
    512,
    [],
    "f605",
    "M633.99 471.02L36 3.51C29.1-2.01 19.03-.9 13.51 6l-10 12.49C-2.02 25.39-.9 35.46 6 40.98l598 467.51c6.9 5.52 16.96 4.4 22.49-2.49l10-12.49c5.52-6.9 4.41-16.97-2.5-22.49zM320 48c79.4 0 144 64.6 144 144 0 25.07-2.93 41.62-18.88 70.43l38.23 29.89C505.9 253.46 512 228.95 512 192 512 86.4 425.6 0 320 0c-53.42 0-101.88 22.16-136.77 57.69l38.22 29.88C247.25 63.21 281.8 48 320 48zm-34.23 89.85l94.83 74.14c2.03-6.31 3.4-12.93 3.4-19.99 0-35.84-28.16-64-64-64-12.71 0-24.37 3.68-34.23 9.85zm73.64 252.24c-11.9 16.87-25 35.44-39.41 55.99-14.41-20.56-27.51-39.12-39.41-55.99-58.27-82.6-84.42-120.33-95.93-148.51l-56.53-44.2c1.27 72.49 29.05 98.96 172.67 305.02 4.8 6.4 12 9.6 19.2 9.6 7.2 0 14.4-3.2 19.2-9.6 24.46-35.1 45.29-64.59 63.47-90.38l-37.86-29.6c-1.84 2.61-3.5 4.97-5.4 7.67z"
  ]
};
export const faMapMarkerCheck = {
  prefix: "far",
  iconName: "map-marker-check",
  icon: [
    384,
    512,
    [],
    "f606",
    "M192 0C86.4 0 0 86.4 0 192c0 76.8 25.6 99.2 172.8 310.4 4.8 6.4 12 9.6 19.2 9.6s14.4-3.2 19.2-9.6C358.4 291.2 384 268.8 384 192 384 86.4 297.6 0 192 0zm0 446.09c-14.41-20.56-27.51-39.12-39.41-55.99C58.35 256.48 48 240.2 48 192c0-79.4 64.6-144 144-144s144 64.6 144 144c0 48.2-10.35 64.48-104.59 198.09-11.9 16.87-25 35.44-39.41 56zm99.93-292.32l-23.21-23.4c-3.85-3.88-10.11-3.9-13.98-.06l-87.36 86.66-37.88-38.19c-3.84-3.88-10.11-3.9-13.98-.06l-23.4 23.21c-3.88 3.85-3.9 10.11-.06 13.98l68.05 68.6c3.85 3.88 10.11 3.9 13.98.06l117.78-116.83c3.88-3.84 3.91-10.1.06-13.97z"
  ]
};
export const faMapMarkerEdit = {
  prefix: "far",
  iconName: "map-marker-edit",
  icon: [
    384,
    512,
    [],
    "f607",
    "M192 0C86.4 0 0 86.4 0 192c0 76.8 25.6 99.2 172.8 310.4 4.8 6.4 12 9.6 19.2 9.6s14.4-3.2 19.2-9.6C358.4 291.2 384 268.8 384 192 384 86.4 297.6 0 192 0zm0 446.09c-14.41-20.56-27.51-39.12-39.41-55.99C58.35 256.48 48 240.2 48 192c0-79.4 64.6-144 144-144s144 64.6 144 144c0 48.2-10.35 64.48-104.59 198.09-11.9 16.87-25 35.44-39.41 56zm-78.41-231.66l-4.8 42.83c-.62 5.68 4.18 10.57 9.95 9.95l42.83-4.8 67.11-67.11-47.98-47.98-67.11 67.11zM247.43 106c-7.02-7.02-18.39-7.02-25.41 0l-18.7 18.7 47.98 47.98 18.7-18.7c7.02-7.02 7.02-18.39 0-25.41L247.43 106z"
  ]
};
export const faMapMarkerExclamation = {
  prefix: "far",
  iconName: "map-marker-exclamation",
  icon: [
    384,
    512,
    [],
    "f608",
    "M192 0C86.4 0 0 86.4 0 192c0 76.8 25.6 99.2 172.8 310.4 4.8 6.4 12 9.6 19.2 9.6s14.4-3.2 19.2-9.6C358.4 291.2 384 268.8 384 192 384 86.4 297.6 0 192 0zm0 446.09c-14.41-20.56-27.51-39.12-39.41-55.99C58.35 256.48 48 240.2 48 192c0-79.4 64.6-144 144-144s144 64.6 144 144c0 48.2-10.35 64.48-104.59 198.09-11.9 16.87-25 35.44-39.41 56zM192 256c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm28.72-160h-57.44c-10.02 0-17.57 9.1-15.73 18.95l18 96A16.001 16.001 0 0 0 181.28 224h21.44c7.7 0 14.31-5.48 15.73-13.05l18-96c1.84-9.85-5.71-18.95-15.73-18.95z"
  ]
};
export const faMapMarkerMinus = {
  prefix: "far",
  iconName: "map-marker-minus",
  icon: [
    384,
    512,
    [],
    "f609",
    "M192 0C86.4 0 0 86.4 0 192c0 76.8 25.6 99.2 172.8 310.4 4.8 6.4 12 9.6 19.2 9.6 7.2 0 14.4-3.2 19.2-9.6C358.4 291.2 384 268.8 384 192 384 86.4 297.6 0 192 0zm0 446.09c-14.41-20.56-27.51-39.13-39.41-56C58.35 256.48 48 240.2 48 192c0-79.4 64.6-144 144-144s144 64.6 144 144c0 48.2-10.35 64.48-104.59 198.09-11.9 16.87-25 35.44-39.41 56zM272 168H112c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16z"
  ]
};
export const faMapMarkerPlus = {
  prefix: "far",
  iconName: "map-marker-plus",
  icon: [
    384,
    512,
    [],
    "f60a",
    "M192 0C86.4 0 0 86.4 0 192c0 76.8 25.6 99.2 172.8 310.4 4.8 6.4 12 9.6 19.2 9.6 7.2 0 14.4-3.2 19.2-9.6C358.4 291.2 384 268.8 384 192 384 86.4 297.6 0 192 0zm0 446.09c-14.41-20.56-27.51-39.13-39.41-56C58.35 256.48 48 240.2 48 192c0-79.4 64.6-144 144-144s144 64.6 144 144c0 48.2-10.35 64.48-104.59 198.09-11.9 16.87-25 35.44-39.41 56zM272 168h-56v-56c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v56h-56c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h56v56c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-56h56c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16z"
  ]
};
export const faMapMarkerQuestion = {
  prefix: "far",
  iconName: "map-marker-question",
  icon: [
    384,
    512,
    [],
    "f60b",
    "M192 0C86.4 0 0 86.4 0 192c0 76.8 25.6 99.2 172.8 310.4 4.8 6.4 12 9.6 19.2 9.6s14.4-3.2 19.2-9.6C358.4 291.2 384 268.8 384 192 384 86.4 297.6 0 192 0zm0 446.09c-14.41-20.56-27.51-39.12-39.41-55.99C58.35 256.48 48 240.2 48 192c0-79.4 64.6-144 144-144s144 64.6 144 144c0 48.2-10.35 64.48-104.59 198.09-11.9 16.87-25 35.44-39.41 56zM194.67 88c-41.81 0-76.9 29.3-85.81 68.45-2.28 9.99 5.2 19.55 15.44 19.55h16.84c7.22 0 13.19-4.99 15.33-11.88 5.07-16.27 20.27-28.12 38.2-28.12 25.98 0 40 20.61 40 40 0 15.96-20.07 27.19-50.67 42.5-8.14 4.07-13.33 12.4-13.33 21.5v16.16c0 8.75 7.09 15.84 15.84 15.84h16.32c8.75 0 15.84-7.09 15.84-15.84v-1.43c31.25-16.27 64-37.78 64-78.73 0-43.25-32.92-88-88-88zM192 288c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32z"
  ]
};
export const faMapMarkerSlash = {
  prefix: "far",
  iconName: "map-marker-slash",
  icon: [
    640,
    512,
    [],
    "f60c",
    "M633.99 471.02L36 3.51C29.1-2.01 19.03-.9 13.51 6l-10 12.49C-2.02 25.39-.9 35.46 6 40.98l598 467.51c6.9 5.52 16.96 4.4 22.49-2.49l10-12.49c5.52-6.9 4.41-16.97-2.5-22.49zM320 48c79.4 0 144 64.6 144 144 0 25.07-2.93 41.62-18.88 70.43l38.23 29.89C505.9 253.46 512 228.95 512 192 512 86.4 425.6 0 320 0c-53.42 0-101.88 22.16-136.77 57.69l38.22 29.88C247.25 63.21 281.8 48 320 48zm39.41 342.09c-11.9 16.87-25 35.44-39.41 55.99-14.41-20.56-27.51-39.12-39.41-55.99-58.27-82.6-84.42-120.33-95.93-148.51l-56.53-44.2c1.27 72.49 29.05 98.96 172.67 305.02 4.8 6.4 12 9.6 19.2 9.6s14.4-3.2 19.2-9.6c24.46-35.1 45.29-64.59 63.48-90.38l-37.87-29.6c-1.84 2.61-3.5 4.97-5.4 7.67z"
  ]
};
export const faMapMarkerSmile = {
  prefix: "far",
  iconName: "map-marker-smile",
  icon: [
    384,
    512,
    [],
    "f60d",
    "M192 0C86.4 0 0 86.4 0 192c0 76.8 25.6 99.2 172.8 310.4 4.8 6.4 12 9.6 19.2 9.6s14.4-3.2 19.2-9.6C358.4 291.2 384 268.8 384 192 384 86.4 297.6 0 192 0zm0 446.09c-14.41-20.56-27.51-39.12-39.41-55.99C58.35 256.48 48 240.2 48 192c0-79.4 64.6-144 144-144s144 64.6 144 144c0 48.2-10.35 64.48-104.59 198.09-11.9 16.87-25 35.44-39.41 56zM136 176c13.25 0 24-10.75 24-24 0-13.26-10.75-24-24-24s-24 10.74-24 24c0 13.25 10.75 24 24 24zm112 0c13.25 0 24-10.75 24-24 0-13.26-10.75-24-24-24s-24 10.74-24 24c0 13.25 10.75 24 24 24zm-10 51.23c-23.25 26.38-68.69 26.39-92-.02-8.81-9.98-23.94-10.84-33.91-2.09-9.91 8.78-10.84 23.94-2.09 33.88 20.78 23.52 50.69 37 82 37 31.38 0 61.25-13.5 82-37.02 8.78-9.94 7.81-25.11-2.12-33.88-9.91-8.74-25.07-7.83-33.88 2.13z"
  ]
};
export const faMapMarkerTimes = {
  prefix: "far",
  iconName: "map-marker-times",
  icon: [
    384,
    512,
    [],
    "f60e",
    "M192 0C86.4 0 0 86.4 0 192c0 76.8 25.6 99.2 172.8 310.4 4.8 6.4 12 9.6 19.2 9.6 7.2 0 14.4-3.2 19.2-9.6C358.4 291.2 384 268.8 384 192 384 86.4 297.6 0 192 0zm0 446.09c-14.41-20.56-27.51-39.13-39.41-56C58.35 256.48 48 240.2 48 192c0-79.4 64.6-144 144-144s144 64.6 144 144c0 48.2-10.35 64.48-104.59 198.09-11.9 16.87-25 35.44-39.41 56zm73.54-316.32l-11.31-11.31c-6.25-6.25-16.38-6.25-22.63 0l-39.6 39.6-39.6-39.6c-6.25-6.25-16.38-6.25-22.63 0l-11.31 11.31c-6.25 6.25-6.25 16.38 0 22.63l39.6 39.6-39.6 39.6c-6.25 6.25-6.25 16.38 0 22.63l11.31 11.31c6.25 6.25 16.38 6.25 22.63 0l39.6-39.6 39.6 39.6c6.25 6.25 16.38 6.25 22.63 0l11.31-11.31c6.25-6.25 6.25-16.38 0-22.63l-39.6-39.6 39.6-39.6c6.25-6.25 6.25-16.38 0-22.63z"
  ]
};
export const faMapPin = {
  prefix: "far",
  iconName: "map-pin",
  icon: [
    288,
    512,
    [],
    "f276",
    "M144 0C64.47 0 0 64.47 0 144c0 71.31 51.96 130.1 120 141.58v197.64l16.51 24.77c3.56 5.34 11.41 5.34 14.98 0L168 483.22V285.58C236.04 274.1 288 215.31 288 144 288 64.47 223.53 0 144 0zm0 240c-52.94 0-96-43.07-96-96 0-52.94 43.06-96 96-96s96 43.06 96 96c0 52.93-43.06 96-96 96zm0-160c-35.28 0-64 28.7-64 64 0 8.84 7.16 16 16 16s16-7.16 16-16c0-17.64 14.34-32 32-32 8.84 0 16-7.16 16-16s-7.16-16-16-16z"
  ]
};
export const faMapSigns = {
  prefix: "far",
  iconName: "map-signs",
  icon: [
    512,
    512,
    [],
    "f277",
    "M441.37 192c8.49 0 16.62-4.21 22.63-11.72l43.31-54.14c6.25-7.81 6.25-20.47 0-28.29L464 43.71C458 36.21 449.86 32 441.37 32H280V16c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v16H56c-13.25 0-24 13.43-24 30v100c0 16.57 10.75 30 24 30h176v32H70.63C62.14 224 54 228.21 48 235.71L4.69 289.86c-6.25 7.81-6.25 20.47 0 28.29L48 372.28c6 7.5 14.14 11.72 22.63 11.72H232v112c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V384h176c13.25 0 24-13.43 24-30V254c0-16.57-10.75-30-24-30H280v-32h161.37zM432 336H80.44l-25.6-32 25.6-32H432v64zM80 80h351.56l25.6 32-25.6 32H80V80z"
  ]
};
export const faMarker = {
  prefix: "far",
  iconName: "map-marker",
  icon: [
    512,
    512,
    [],
    "f5a1",
    "M485.48 26.51C467.81 8.84 444.64 0 421.47 0s-46.33 8.84-64.01 26.51L335.7 48.27l-36.55-36.55c-15.62-15.62-40.95-15.62-56.56 0L123.8 130.5c-6.25 6.25-6.25 16.38 0 22.63l11.31 11.31c6.25 6.25 16.38 6.25 22.63 0L270.87 51.31l30.9 30.9L93.95 290.02A327.038 327.038 0 0 0 .17 485.11l-.03.23C-1.45 499.72 9.88 512 23.95 512c5.73 0 111.06-6.99 198.03-93.95l263.51-263.51c35.35-35.36 35.35-92.67-.01-128.03zm-297.45 357.6c-37.02 37.02-83.99 62.88-134.74 74.6 11.72-50.74 37.59-97.73 74.6-134.74l73.07-73.07 60.14 60.14-73.07 73.07zm263.52-263.52L295.04 277.1l-60.14-60.14 156.51-156.5C399.44 52.42 410.12 48 421.47 48c11.36 0 22.04 4.42 30.07 12.46C459.58 68.49 464 79.17 464 90.52c0 11.36-4.42 22.04-12.45 30.07z"
  ]
};
export const faMars = {
  prefix: "far",
  iconName: "mars",
  icon: [
    384,
    512,
    [],
    "f222",
    "M372 64h-63c-10.7 0-16 12.9-8.5 20.5L315 99l-87.6 87.6C203.9 169.9 175.1 160 144 160 64.5 160 0 224.5 0 304s64.5 144 144 144 144-64.5 144-144c0-31.1-9.9-59.9-26.6-83.4L349 133l14.5 14.5c7.6 7.6 20.5 2.2 20.5-8.5V76c0-6.6-5.4-12-12-12zM144 400c-52.9 0-96-43.1-96-96s43.1-96 96-96 96 43.1 96 96-43.1 96-96 96z"
  ]
};
export const faMarsDouble = {
  prefix: "far",
  iconName: "mars-double",
  icon: [
    512,
    512,
    [],
    "f227",
    "M288 208c0-31.1-9.9-59.9-26.6-83.4L317 69l14.5 14.5c7.6 7.6 20.5 2.2 20.5-8.5V12c0-6.6-5.4-12-12-12h-63c-10.7 0-16 12.9-8.5 20.5L283 35l-55.6 55.6C203.9 73.9 175.1 64 144 64 64.5 64 0 128.5 0 208s64.5 144 144 144 144-64.5 144-144zm-144 96c-52.9 0-96-43.1-96-96s43.1-96 96-96 96 43.1 96 96-43.1 96-96 96zm368-132v63c0 10.7-12.9 16-20.5 8.5L477 229l-55.6 55.6c16.8 23.5 26.6 52.3 26.6 83.4 0 79.5-64.5 144-144 144-74.4 0-135.6-56.4-143.2-128.8 16.1-1.5 32-5.3 47.3-11.2 2.1 51.1 44.3 92 95.9 92 52.9 0 96-43.1 96-96 0-51.6-40.9-93.8-92-95.9 6-15.3 9.7-31.2 11.2-47.3 25.3 2.7 48.6 11.8 68.2 25.8L443 195l-14.5-14.5c-7.6-7.6-2.2-20.5 8.5-20.5h63c6.6 0 12 5.4 12 12z"
  ]
};
export const faMarsStroke = {
  prefix: "far",
  iconName: "mars-stroke",
  icon: [
    384,
    512,
    [],
    "f229",
    "M372 64h-63c-10.7 0-16 12.9-8.5 20.5L315 99l-23.4 23.4-14.1-14.1c-4.7-4.7-12.3-4.7-17 0l-17 17c-4.7 4.7-4.7 12.3 0 17l14.1 14.1-30.2 30.2C203.9 169.9 175.1 160 144 160 64.5 160 0 224.5 0 304s64.5 144 144 144 144-64.5 144-144c0-31.1-9.9-59.9-26.6-83.4l30.2-30.2 14.1 14.1c4.7 4.7 12.3 4.7 17 0l17-17c4.7-4.7 4.7-12.3 0-17l-14.1-14.1L349 133l14.5 14.5c7.6 7.6 20.5 2.2 20.5-8.5V76c0-6.6-5.4-12-12-12zM144 400c-52.9 0-96-43.1-96-96s43.1-96 96-96 96 43.1 96 96-43.1 96-96 96z"
  ]
};
export const faMarsStrokeH = {
  prefix: "far",
  iconName: "mars-stroke-h",
  icon: [
    480,
    512,
    [],
    "f22b",
    "M476.5 247.5l-44.6-44.6c-7.6-7.6-20.5-2.2-20.5 8.5V232H376v-20c0-6.6-5.4-12-12-12h-24c-6.6 0-12 5.4-12 12v20h-42c-4.8-28.5-18.2-55.8-40.2-77.8C189.6 98 98.4 98 42.2 154.2c-56.2 56.2-56.2 147.4 0 203.6 56.2 56.2 147.4 56.2 203.6 0 22-22 35.4-49.3 40.2-77.8h42v20c0 6.6 5.4 12 12 12h24c6.6 0 12-5.4 12-12v-20h35.4v20.6c0 10.7 12.9 16 20.5 8.5l44.6-44.6c4.7-4.7 4.7-12.3 0-17zm-264.6 76.4c-37.4 37.4-98.3 37.4-135.8 0-37.4-37.4-37.4-98.3 0-135.8 37.4-37.4 98.3-37.4 135.8 0 37.4 37.4 37.4 98.4 0 135.8z"
  ]
};
export const faMarsStrokeV = {
  prefix: "far",
  iconName: "mars-stroke-v",
  icon: [
    288,
    512,
    [],
    "f22a",
    "M245.8 234.2c-22-22-49.3-35.4-77.8-40.2v-42.7h20c6.6 0 12-5.4 12-12v-24c0-6.6-5.4-12-12-12h-20V70.1h20.6c10.7 0 16-12.9 8.5-20.5L152.5 5.1c-4.7-4.7-12.3-4.7-17 0L90.9 49.6c-7.6 7.6-2.2 20.5 8.5 20.5H120v33.1h-20c-6.6 0-12 5.4-12 12v24c0 6.6 5.4 12 12 12h20V194c-28.5 4.8-55.8 18.2-77.8 40.2-56.2 56.2-56.2 147.4 0 203.6 56.2 56.2 147.4 56.2 203.6 0 56.3-56.2 56.3-147.4 0-203.6zm-33.9 169.7c-37.4 37.4-98.3 37.4-135.8 0-37.4-37.4-37.4-98.3 0-135.8 37.4-37.4 98.3-37.4 135.8 0 37.4 37.4 37.4 98.4 0 135.8z"
  ]
};
export const faMask = {
  prefix: "far",
  iconName: "mask",
  icon: [
    640,
    512,
    [],
    "f6fa",
    "M320.67 64c-442.6 0-357.57 384-158.46 384 39.9 0 77.47-20.69 101.42-55.86l25.73-37.79c7.83-11.5 19.57-17.25 31.31-17.25 11.74 0 23.49 5.75 31.31 17.25l25.73 37.79C401.66 427.31 439.23 448 479.13 448c189.86 0 290.63-384-158.46-384zm158.46 331.64c-24.57 0-48.08-12.98-62.88-34.72l-25.73-37.79c-16.61-24.39-42.07-38.38-69.85-38.38-27.78 0-53.24 13.99-69.85 38.38l-25.73 37.79c-14.8 21.74-38.31 34.72-62.88 34.72C93.89 395.64 48 332.11 48 272.77c0-38.62 18.1-73.1 52.35-99.7 33.3-25.87 98.55-56.71 220.32-56.71 122.22 0 187.15 30.17 220.1 55.48 33.52 25.75 51.23 59.42 51.23 97.37 0 59.8-46.35 126.43-112.87 126.43zM192 186.18c-39.11 0-64.53 25.66-76.27 41.05-4.98 6.53-4.98 16.1 0 22.63 11.73 15.4 37.16 41.05 76.27 41.05s64.53-25.66 76.27-41.05c4.98-6.53 4.98-16.09 0-22.63-11.74-15.39-37.16-41.05-76.27-41.05zm256 0c-39.11 0-64.53 25.66-76.27 41.05-4.98 6.53-4.98 16.1 0 22.63 11.73 15.4 37.16 41.05 76.27 41.05s64.53-25.66 76.27-41.05c4.98-6.53 4.98-16.09 0-22.63-11.74-15.39-37.16-41.05-76.27-41.05z"
  ]
};
export const faMeat = {
  prefix: "far",
  iconName: "meat",
  icon: [
    512,
    512,
    [],
    "f814",
    "M444 68.52C399.45 24.05 345.11 0 299.18 0c-38.65 0-62 19.06-68.77 25.85-38.72 38.68-102.26 113.78-102.26 183.6v72.67L116.3 294c-1.93 1.88-5.76 1-7.75.17A79.19 79.19 0 0 0 23.22 423.7a76.41 76.41 0 0 0 43.57 21.59 76.39 76.39 0 0 0 21.57 43.55 79.19 79.19 0 0 0 129.58-85.33c-1-2.5-1.56-6 .16-7.75L229.87 384h73c81.9 0 181.09-94.54 190.46-111.16 37.43-49.42 17.38-137.65-49.33-204.32zM302.88 336H210l-25.85 25.82c-15.24 15.24-19.37 38.05-10.78 59.52A31.07 31.07 0 0 1 144.43 464c-12 0-27.64-7.82-30.11-25.38l-5-35.81-35.8-5.05C56 395.28 48 379.7 48 367.65a31.13 31.13 0 0 1 42.5-29 60.4 60.4 0 0 0 22.5 4.42 52.76 52.76 0 0 0 37.27-15.17l25.9-25.9v-92.55c0-22.79 11.76-51.7 32.33-82.69 8.62 39.31 31.34 79.12 64.7 112.45s73.54 56.08 112.19 64.6C354.34 324.38 325.57 336 302.88 336zm149.82-88.09c-23.44 23.42-89.77 13.12-145.61-42.67-53.75-53.69-67.28-120.9-42.71-145.45 23.44-23.42 89.76-13.11 145.62 42.67 53.88 53.83 67 121.19 42.7 145.45zM331.89 127.23c-9.81 9.8-5.84 29.67 8.88 44.37s34.61 18.68 44.42 8.87 5.84-29.66-8.88-44.37-34.61-18.67-44.42-8.87z"
  ]
};
export const faMedal = {
  prefix: "far",
  iconName: "medal",
  icon: [
    512,
    512,
    [],
    "f5a2",
    "M342.17 281.67l-52.43-7.64-23.43-47.52c-2.11-4.25-6.22-6.39-10.33-6.39-4.08 0-8.16 2.12-10.28 6.39l-23.43 47.52-52.43 7.64c-9.4 1.36-13.17 12.96-6.35 19.59l37.93 36.96-8.97 52.22c-1.28 7.46 4.67 13.44 11.32 13.44 1.77 0 3.58-.42 5.33-1.35l46.9-24.65 46.9 24.65c1.74.92 3.55 1.33 5.31 1.33 6.66 0 12.62-5.96 11.34-13.43l-8.97-52.22 37.93-36.96c6.83-6.63 3.06-18.22-6.34-19.58zM495.97 0H338.12c-11.24 0-21.66 5.9-27.44 15.54L256 106.67l-54.68-91.13A31.997 31.997 0 0 0 173.88 0H16.03C3.08 0-4.5 14.57 2.92 25.18l113.99 162.85C84.21 222.47 64 268.87 64 320c0 105.87 86.13 192 192 192s192-86.13 192-192c0-51.13-20.21-97.53-52.91-131.98L509.08 25.18C516.5 14.57 508.92 0 495.97 0zM77.49 48h87.33l50.64 84.4c-22.11 4.78-42.73 13.45-61.3 25.13L77.49 48zM400 320c0 79.53-64.47 144-144 144s-144-64.47-144-144 64.47-144 144-144 144 64.47 144 144zm-42.16-162.47c-18.57-11.68-39.19-20.36-61.3-25.13L347.18 48h87.33l-76.67 109.53z"
  ]
};
export const faMedkit = {
  prefix: "far",
  iconName: "medkit",
  icon: [
    512,
    512,
    [],
    "f0fa",
    "M464 96H352V80c0-26.51-21.49-48-48-48h-96c-26.51 0-48 21.49-48 48v16H48c-26.51 0-48 21.49-48 48v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V144c0-26.51-21.49-48-48-48zM208 80h96v16h-96V80zM54 432a6 6 0 0 1-6-6V150a6 6 0 0 1 6-6h404a6 6 0 0 1 6 6v276a6 6 0 0 1-6 6H54zm298-160v32c0 6.627-5.373 12-12 12h-56v56c0 6.627-5.373 12-12 12h-32c-6.627 0-12-5.373-12-12v-56h-56c-6.627 0-12-5.373-12-12v-32c0-6.627 5.373-12 12-12h56v-56c0-6.627 5.373-12 12-12h32c6.627 0 12 5.373 12 12v56h56c6.627 0 12 5.373 12 12z"
  ]
};
export const faMegaphone = {
  prefix: "far",
  iconName: "megaphone",
  icon: [
    576,
    512,
    [],
    "f675",
    "M560 32h-16c-8.84 0-16 7.16-16 16v12.94L47.28 172.41C45.61 165.36 39.56 160 32 160H16c-8.84 0-16 7.16-16 16v160c0 8.84 7.16 16 16 16h16c7.56 0 13.61-5.36 15.28-12.41l115.01 26.67c-1.17 5.78-2.28 11.6-2.28 17.74 0 53.02 42.98 96 96 96 44.19 0 80.99-29.99 92.08-70.66L528 451.06V464c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V48c0-8.84-7.16-16-16-16zM256 432c-26.47 0-48-21.53-48-48 0-2.42.9-4.54 1.25-6.85l92.25 21.39C295.3 417.87 277.37 432 256 432zM48 290.5v-69l480-111.31V401.8L48 290.5z"
  ]
};
export const faMeh = {
  prefix: "far",
  iconName: "meh",
  icon: [
    496,
    512,
    [],
    "f11a",
    "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-80-216c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160-64c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm8 144H160c-13.2 0-24 10.8-24 24s10.8 24 24 24h176c13.2 0 24-10.8 24-24s-10.8-24-24-24z"
  ]
};
export const faMehBlank = {
  prefix: "far",
  iconName: "meh-blank",
  icon: [
    496,
    512,
    [],
    "f5a4",
    "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-80-280c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm160 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"
  ]
};
export const faMehRollingEyes = {
  prefix: "far",
  iconName: "meh-rolling-eyes",
  icon: [
    496,
    512,
    [],
    "f5a5",
    "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm88-304c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72zm0 112c-22.1 0-40-17.9-40-40 0-13.6 7.3-25.1 17.7-32.3-1 2.6-1.7 5.3-1.7 8.3 0 13.3 10.7 24 24 24s24-10.7 24-24c0-2.9-.7-5.7-1.7-8.3 10.4 7.2 17.7 18.7 17.7 32.3 0 22.1-17.9 40-40 40zm-104-40c0-39.8-32.2-72-72-72s-72 32.2-72 72 32.2 72 72 72 72-32.2 72-72zm-112 0c0-13.6 7.3-25.1 17.7-32.3-1 2.6-1.7 5.3-1.7 8.3 0 13.3 10.7 24 24 24s24-10.7 24-24c0-2.9-.7-5.7-1.7-8.3 10.4 7.2 17.7 18.7 17.7 32.3 0 22.1-17.9 40-40 40s-40-17.9-40-40zm192 128H184c-13.2 0-24 10.8-24 24s10.8 24 24 24h128c13.2 0 24-10.8 24-24s-10.8-24-24-24z"
  ]
};
export const faMemory = {
  prefix: "far",
  iconName: "memory",
  icon: [
    640,
    512,
    [],
    "f538",
    "M480 160h-64v128h64V160zm-128 0h-64v128h64V160zm-128 0h-64v128h64V160zm408 0h8V96c0-17.67-14.33-32-32-32H32C14.33 64 0 78.33 0 96v64h8c13.26 0 24 10.74 24 24 0 13.25-10.74 24-24 24H0v240h640V208h-8c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24zm-40 240h-64c0-8.84-7.16-16-16-16s-16 7.16-16 16h-96c0-8.84-7.16-16-16-16s-16 7.16-16 16h-96c0-8.84-7.16-16-16-16s-16 7.16-16 16h-96c0-8.84-7.16-16-16-16s-16 7.16-16 16H48v-48h544v48zm0-275.84c-19.29 12.93-32 34.93-32 59.84s12.71 46.91 32 59.84V320H48v-76.16c19.29-12.93 32-34.93 32-59.84s-12.71-46.91-32-59.84V112h544v12.16z"
  ]
};
export const faMenorah = {
  prefix: "far",
  iconName: "menorah",
  icon: [
    640,
    512,
    [],
    "f676",
    "M416 96c17.67 0 32-14.33 32-32S416 0 416 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S320 0 320 0s-32 46.33-32 64 14.33 32 32 32zm200 32h-16c-8.84 0-16 7.16-16 16v144h48V144c0-8.84-7.16-16-16-16zm-8-32c17.67 0 32-14.33 32-32S512 0 512 0s-32 46.33-32 64 14.33 32 32 32zm96 0c17.67 0 32-14.33 32-32S608 0 608 0s-32 46.33-32 64 14.33 32 32 32zm-184 32h-16c-8.84 0-16 7.16-16 16v144h48V144c0-8.84-7.16-16-16-16zM32 96c17.67 0 32-14.33 32-32S32 0 32 0 0 46.33 0 64s14.33 32 32 32zm104 32h-16c-8.84 0-16 7.16-16 16v144h48V144c0-8.84-7.16-16-16-16zm88-32c17.67 0 32-14.33 32-32S224 0 224 0s-32 46.33-32 64 14.33 32 32 32zm400 32h-16c-8.84 0-16 7.16-16 16v136c0 22.09-17.91 40-40 40H344V144c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v176H88c-22.09 0-40-17.91-40-40V144c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v136c0 48.6 39.4 88 88 88h208v96H112c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16H344v-96h208c48.6 0 88-39.4 88-88V144c0-8.84-7.16-16-16-16zM128 96c17.67 0 32-14.33 32-32S128 0 128 0 96 46.33 96 64s14.33 32 32 32zm104 32h-16c-8.84 0-16 7.16-16 16v144h48V144c0-8.84-7.16-16-16-16z"
  ]
};
export const faMercury = {
  prefix: "far",
  iconName: "mercury",
  icon: [
    288,
    512,
    [],
    "f223",
    "M288 208c0-50.3-25.8-94.6-65-120.4 3.2-2.2 6.2-4.6 9.2-7.2 21.1-18.1 34.1-41.4 37.5-66.8 1-7.2-4.6-13.6-11.9-13.6h-24.3c-5.7 0-10.7 4-11.8 9.7C216 40.4 183.3 64 144 64S72 40.4 66.2 9.7C65.2 4 60.2 0 54.5 0H30.1c-7.3 0-12.9 6.4-11.9 13.6C21.7 39 34.7 62.4 55.8 80.4c3 2.5 6 4.9 9.2 7.2C25.8 113.4 0 157.7 0 208c0 71.6 52.2 130.9 120.6 142.1-.4 1.2-.6 2.4-.6 3.7V408H76c-6.6 0-12 5.4-12 12v24c0 6.6 5.4 12 12 12h44v44c0 6.6 5.4 12 12 12h24c6.6 0 12-5.4 12-12v-44h44c6.6 0 12-5.4 12-12v-24c0-6.6-5.4-12-12-12h-44v-54.2c0-1.3-.2-2.6-.6-3.7C235.8 338.9 288 279.6 288 208zm-144 96c-52.9 0-96-43.1-96-96s43.1-96 96-96 96 43.1 96 96-43.1 96-96 96z"
  ]
};
export const faMeteor = {
  prefix: "far",
  iconName: "meteor",
  icon: [
    512,
    512,
    [],
    "f753",
    "M510.47232,42.84577C501.974,71.1397,481.35291,137.539,458.16986,196.03293a38.52839,38.52839,0,0,1,20.40233,53.90063C456.57641,292.02293,399.27491,396.30893,342.19212,453.303a200.55515,200.55515,0,0,1-283.53932,0c-78.20373-78.195-78.20373-205.36922,0-283.56419,57.17653-57.10343,161.2503-114.285,203.46094-136.28267a38.607,38.607,0,0,1,53.89591,20.29476c58.27006-23.107,124.851-43.79231,153.25183-52.29143a33.03375,33.03375,0,0,1,41.21084,41.38631ZM393.3698,226.73286l10.71669-24.90366c20.49607-47.88563,40.17979-107.48879,52.39619-146.28163-38.89878,12.20186-98.6998,31.99667-146.28442,52.40079l-24.90147,10.68639L277.7045,92.63746c-1.18727-3.99958-2.312-7.79606-3.40559-11.38944-39.8986,21.29466-132.56831,73.28924-181.65263,122.37787-59.39485,59.4938-59.39485,156.18685,0,215.68065a152.3963,152.3963,0,0,0,215.6461,0c48.49069-48.38559,98.57483-136.78262,122.47649-181.57483-3.59306-.99989-7.40483-2.10915-11.40406-3.29653Zm-81.35938,85.288A111.97851,111.97851,0,1,1,200.03191,200.03252,111.999,111.999,0,0,1,312.01042,312.02084Zm-111.97851-23.9975a23.99539,23.99539,0,1,0-23.99539,23.9975A23.95276,23.95276,0,0,0,200.03191,288.02334Zm31.99386,71.9925a15.99693,15.99693,0,1,0-15.99693,15.99833A16.05882,16.05882,0,0,0,232.02577,360.01584Z"
  ]
};
export const faMicrochip = {
  prefix: "far",
  iconName: "microchip",
  icon: [
    512,
    512,
    [],
    "f2db",
    "M368.5 0H144c-26.5 0-48 21.5-48 48v416c0 26.5 21.5 48 48 48h224.5c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zm0 457c0 3.3-2.7 7-6 7H150c-3.3 0-6-3.7-6-7V54c0-3.3 2.7-6 6-6h212.5c3.3 0 6 2.7 6 6v403zM512 106v12c0 3.3-2.7 6-6 6h-18v6c0 3.3-2.7 6-6 6h-42V88h42c3.3 0 6 2.7 6 6v6h18c3.3 0 6 2.7 6 6zm0 96v12c0 3.3-2.7 6-6 6h-18v6c0 3.3-2.7 6-6 6h-42v-48h42c3.3 0 6 2.7 6 6v6h18c3.3 0 6 2.7 6 6zm0 96v12c0 3.3-2.7 6-6 6h-18v6c0 3.3-2.7 6-6 6h-42v-48h42c3.3 0 6 2.7 6 6v6h18c3.3 0 6 2.7 6 6zm0 96v12c0 3.3-2.7 6-6 6h-18v6c0 3.3-2.7 6-6 6h-42v-48h42c3.3 0 6 2.7 6 6v6h18c3.3 0 6 2.7 6 6zM30 376h42v48H30c-3.3 0-6-2.7-6-6v-6H6c-3.3 0-6-2.7-6-6v-12c0-3.3 2.7-6 6-6h18v-6c0-3.3 2.7-6 6-6zm0-96h42v48H30c-3.3 0-6-2.7-6-6v-6H6c-3.3 0-6-2.7-6-6v-12c0-3.3 2.7-6 6-6h18v-6c0-3.3 2.7-6 6-6zm0-96h42v48H30c-3.3 0-6-2.7-6-6v-6H6c-3.3 0-6-2.7-6-6v-12c0-3.3 2.7-6 6-6h18v-6c0-3.3 2.7-6 6-6zm0-96h42v48H30c-3.3 0-6-2.7-6-6v-6H6c-3.3 0-6-2.7-6-6v-12c0-3.3 2.7-6 6-6h18v-6c0-3.3 2.7-6 6-6z"
  ]
};
export const faMicrophone = {
  prefix: "far",
  iconName: "microphone",
  icon: [
    352,
    512,
    [],
    "f130",
    "M336 192h-16c-8.84 0-16 7.16-16 16v48c0 74.8-64.49 134.82-140.79 127.38C96.71 376.89 48 317.11 48 250.3V208c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v40.16c0 89.64 63.97 169.55 152 181.69V464H96c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16h-56v-33.77C285.71 418.47 352 344.9 352 256v-48c0-8.84-7.16-16-16-16zM176 352c53.02 0 96-42.98 96-96V96c0-53.02-42.98-96-96-96S80 42.98 80 96v160c0 53.02 42.98 96 96 96zM128 96c0-26.47 21.53-48 48-48s48 21.53 48 48v160c0 26.47-21.53 48-48 48s-48-21.53-48-48V96z"
  ]
};
export const faMicrophoneAlt = {
  prefix: "far",
  iconName: "microphone-alt",
  icon: [
    352,
    512,
    [],
    "f3c9",
    "M336 192h-16c-8.84 0-16 7.16-16 16v48c0 74.8-64.49 134.82-140.79 127.38C96.71 376.89 48 317.11 48 250.3V208c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v40.16c0 89.64 63.97 169.55 152 181.69V464H96c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16h-56v-33.77C285.71 418.47 352 344.9 352 256v-48c0-8.84-7.16-16-16-16zM176 352c53.02 0 96-42.98 96-96V96c0-53.02-42.98-96-96-96S80 42.98 80 96v160c0 53.02 42.98 96 96 96zM128 96c0-26.47 21.53-48 48-48s48 21.53 48 48h-40c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h40v32h-40c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h40v32h-40c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h40c0 26.47-21.53 48-48 48s-48-21.53-48-48V96z"
  ]
};
export const faMicrophoneAltSlash = {
  prefix: "far",
  iconName: "microphone-alt-slash",
  icon: [
    640,
    512,
    [],
    "f539",
    "M633.99 471.02L36 3.51C29.1-2.01 19.03-.9 13.51 6l-10 12.49C-2.02 25.39-.9 35.46 6 40.98l598 467.51c6.9 5.52 16.96 4.4 22.49-2.49l10-12.49c5.52-6.9 4.41-16.97-2.5-22.49zM496 256v-48c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v48c0 2.75-.69 5.3-.86 8.01l43.21 33.78c3.32-13.47 5.65-27.31 5.65-41.79zm-96 208h-56v-33.77c20.68-2.84 40.14-9.43 57.9-18.81l-43.1-33.69c-16.09 5.14-33.46 7.42-51.59 5.65C240.72 376.89 192 317.11 192 250.3v-2.98l-48-37.53v38.37c0 89.64 63.97 169.55 152 181.69V464h-56c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16zM272 96c0-26.47 21.53-48 48-48s48 21.53 48 48h-40c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h40v32h-40c-3.42 0-5.79 2.42-6.94 5.44L355.03 192H368v10.14l48 37.53V96c0-53.02-42.98-96-96-96-50.97 0-92.26 39.85-95.4 90.03l47.4 37.06V96z"
  ]
};
export const faMicrophoneSlash = {
  prefix: "far",
  iconName: "microphone-slash",
  icon: [
    640,
    512,
    [],
    "f131",
    "M633.99 471.02L36 3.51C29.1-2.01 19.03-.9 13.51 6l-10 12.49C-2.02 25.39-.9 35.46 6 40.98l598 467.51c6.9 5.52 16.96 4.4 22.49-2.49l10-12.49c5.52-6.9 4.41-16.97-2.5-22.49zM496 256v-48c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v48c0 2.75-.69 5.31-.86 8.01l43.21 33.78c3.32-13.47 5.65-27.31 5.65-41.79zm-96 208h-56v-33.77c20.68-2.84 40.14-9.43 57.9-18.81l-43.1-33.69c-16.09 5.14-33.46 7.42-51.59 5.65C240.72 376.89 192 317.11 192 250.3v-2.98l-48-37.53v38.37c0 89.64 63.97 169.55 152 181.69V464h-56c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16zM272 96c0-26.47 21.53-48 48-48s48 21.53 48 48v106.14l48 37.53V96c0-53.02-42.98-96-96-96-50.97 0-92.26 39.85-95.4 90.03l47.4 37.05V96z"
  ]
};
export const faMicrophoneStand = {
  prefix: "far",
  iconName: "microphone-stand",
  icon: [
    512,
    512,
    [],
    "f8cb",
    "M476.37 35.63a121.69 121.69 0 0 0-172.07 0l-28.67 28.68a121.18 121.18 0 0 0-35.55 85.08L12 406.85a48 48 0 0 0 2 65.71l25.37 25.38a48 48 0 0 0 65.72 2L232 387.21V496a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16V344.83l82.6-72.92a121.23 121.23 0 0 0 85.09-35.54l28.68-28.68a121.67 121.67 0 0 0 0-172.06zM73.38 464L48 438.62l213.15-240.56 52.79 52.78zm288.28-240a72.88 72.88 0 0 1-7.41-.72l-65.51-65.51a73.2 73.2 0 0 1 18.46-56.62L410.86 204.8a73 73 0 0 1-49.2 19.2zm83.13-53.15L341.14 67.2a73.16 73.16 0 0 1 101.28 2.37c27.83 27.82 28.44 72.43 2.37 101.28z"
  ]
};
export const faMicroscope = {
  prefix: "far",
  iconName: "microscope",
  icon: [
    512,
    512,
    [],
    "f610",
    "M476 464h-40.5c37.06-33.68 60.5-82.1 60.5-136 0-98.75-78.26-179.36-176-183.6V97.14c0-18.39-10.16-34.45-25.16-42.88V36.58c0-20.17-16.4-36.58-36.56-36.58H157.72c-20.16 0-36.56 16.41-36.56 36.58v17.69C106.16 62.69 96 78.75 96 97.14v197.72c0 22.02 14.56 40.7 34.56 46.94v37.62c0 20.17 16.41 36.58 36.59 36.58h81.69c20.19 0 36.59-16.41 36.59-36.58V341.8c20-6.23 34.56-24.92 34.56-46.94V192.81c71.21 4.23 128 62.95 128 135.19 0 74.98-61 136-136 136H36c-19.88 0-36 16.12-36 36 0 6.63 5.37 12 12 12h488c6.63 0 12-5.37 12-12 0-19.88-16.12-36-36-36zm-297.44-96v-40h58.88v40h-58.88zm92.28-72H145.16l-1.16-1.14L145.16 96h24V48h77.69L248 96h24l-1.16 200z"
  ]
};
export const faMicrowave = {
  prefix: "far",
  iconName: "microwave",
  icon: [
    512,
    512,
    [],
    "e01b",
    "M464,64H48A48,48,0,0,0,0,112V400a48,48,0,0,0,48,48h0l24,32h48l24-32H368l24,32h48l24-32h0a48,48,0,0,0,48-48V112A48,48,0,0,0,464,64Zm0,336H48V112H464ZM416,272a24,24,0,1,0-24-24A24,24,0,0,0,416,272Zm0-80a24,24,0,1,0-24-24A24,24,0,0,0,416,192ZM96,368H352a16,16,0,0,0,16-16V160a16,16,0,0,0-16-16H96a16,16,0,0,0-16,16V352A16,16,0,0,0,96,368Z"
  ]
};
export const faMindShare = {
  prefix: "far",
  iconName: "mind-share",
  icon: [
    640,
    512,
    [],
    "f677",
    "M635 339.8l-96-95.2c-10.1-10-27-2.6-27 12.2V304h-79.9c-5.6 0-11.2-.1-17 .8-47.1 6.9-85.6 44.5-93.4 91.5-7.8 46.7 13.3 89.5 48.3 112.9 9.8 6.5 21.6-3.2 17.8-14.4-9-26.6-5.6-94.7 60.3-94.7h64v47.2c0 14.8 16.9 22.2 27 12.2l96-95.2c6.6-6.7 6.6-17.9-.1-24.5zM290 391c1.3-8 3.4-15.7 6.1-23.2V82c0-18.8 15.3-34 34.2-34 15.5 0 29.1 10.5 32.9 25.6l4.8 18.9 22.9-1.2c16.5.1 31.9 15.4 31.9 34.1 0 4.4-.4 5.3-5.5 27.2l18.9 7.7c13.7 5.6 42.7 30.2 25.1 65.9l-9.9 20.1 19.5 11.2c3.5 2 6.2 4.5 8.9 6.9v-7.8c0-22 14.5-40.4 34.2-46.5.1-1.7.7-3.4.7-5.1 0-33-16.7-63-43.7-80.6-.4-39.7-29.4-72.8-67.5-79.8C389.9 17.8 361.8 0 330.3 0c-22.8 0-43.4 9.2-58.3 24.1A82.316 82.316 0 0 0 213.7 0c-31.4 0-59.6 17.8-73.3 44.9-38.1 7-67.1 40.1-67.5 79.8-27.1 17.6-43.7 47.6-43.7 80.6 0 7.7 1 15.4 2.9 23C11.9 246.3 0 272.2 0 299.5c0 33 16.7 63 43.7 80.6.5 47.5 38.5 86.2 85.8 88.3 15.9 26.7 44.9 43.6 76.8 43.6 26 0 49.2-11.2 65.6-28.8 13.4 14.4 31.5 24.1 51.9 27.3-28-32.2-41-75.9-33.8-119.5zm-42.1 31.8c0 22.8-18.6 41.2-41.5 41.2-32.9 0-39.5-29.5-45.6-47.6l-20.3 3.4c-24 4-48.5-15.3-48.5-40.5 0-2.8 4.7-27.4 4.7-27.4l-18.2-7.5c-36.9-15.2-41.3-66.1-5.5-86.6l19.5-11.2-9.9-20.1C65 190.7 94 166 107.7 160.4l18.9-7.7c-5-21.9-5.5-22.8-5.5-27.2 0-18.8 15.3-34 31.9-34.1l22.9 1.2 4.8-18.9c3.9-15.1 17.4-25.6 32.9-25.6 18.9 0 34.2 15.2 34.2 34v340.7z"
  ]
};
export const faMinus = {
  prefix: "far",
  iconName: "minus",
  icon: [
    384,
    512,
    [],
    "f068",
    "M368 224H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h352c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
  ]
};
export const faMinusCircle = {
  prefix: "far",
  iconName: "minus-circle",
  icon: [
    512,
    512,
    [],
    "f056",
    "M140 284c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h232c6.6 0 12 5.4 12 12v32c0 6.6-5.4 12-12 12H140zm364-28c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-48 0c0-110.5-89.5-200-200-200S56 145.5 56 256s89.5 200 200 200 200-89.5 200-200z"
  ]
};
export const faMinusHexagon = {
  prefix: "far",
  iconName: "minus-hexagon",
  icon: [
    576,
    512,
    [],
    "f307",
    "M441.5 39.8C432.9 25.1 417.1 16 400 16H176c-17.1 0-32.9 9.1-41.5 23.8l-112 192c-8.7 14.9-8.7 33.4 0 48.4l112 192c8.6 14.7 24.4 23.8 41.5 23.8h224c17.1 0 32.9-9.1 41.5-23.8l112-192c8.7-14.9 8.7-33.4 0-48.4l-112-192zM400 448H176L64 256 176 64h224l112 192-112 192zM172 284c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h232c6.6 0 12 5.4 12 12v32c0 6.6-5.4 12-12 12H172z"
  ]
};
export const faMinusOctagon = {
  prefix: "far",
  iconName: "minus-octagon",
  icon: [
    512,
    512,
    [],
    "f308",
    "M497.9 150.5L361.5 14.1c-9-9-21.2-14.1-33.9-14.1H184.5c-12.7 0-24.9 5.1-33.9 14.1L14.1 150.5c-9 9-14.1 21.2-14.1 33.9v143.1c0 12.7 5.1 24.9 14.1 33.9l136.5 136.5c9 9 21.2 14.1 33.9 14.1h143.1c12.7 0 24.9-5.1 33.9-14.1L498 361.4c9-9 14.1-21.2 14.1-33.9v-143c-.1-12.8-5.2-25-14.2-34zm-33.9 177L327.5 464h-143L48 327.5v-143L184.5 48h143.1L464 184.5v143zM140 284c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h232c6.6 0 12 5.4 12 12v32c0 6.6-5.4 12-12 12H140z"
  ]
};
export const faMinusSquare = {
  prefix: "far",
  iconName: "minus-square",
  icon: [
    448,
    512,
    [],
    "f146",
    "M108 284c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h232c6.6 0 12 5.4 12 12v32c0 6.6-5.4 12-12 12H108zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
  ]
};
export const faMistletoe = {
  prefix: "far",
  iconName: "mistletoe",
  icon: [
    576,
    512,
    [],
    "f7b4",
    "M542.1 213.4c-26-26-89.6-38.6-130.9-44.2L312 70.1V16c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16v54.1l-99.1 99.1C123.6 174.8 60 187.4 34 213.4c-40 40-45.4 99.4-12.1 132.7C36.5 360.8 56.3 368 77.2 368c26.6 0 55-11.5 77.4-33.9 14.9-14.9 25.3-42 32.6-70.2 5.6 4.9 12.7 8.1 20.8 8.1 17.7 0 32-14.3 32-32s-14.3-32-32-32c-3.6 0-6.9 1-10.2 2.1.4-2.4.7-4.6 1-6.9L264 138v144.3c-28.4 32.8-72 89.2-72 127.3 0 56.6 43 102.4 96 102.4s96-45.8 96-102.4c0-38.1-43.6-94.6-72-127.3V137.9l65.2 65.2c5.6 41.3 18.2 104.9 44.2 130.9 22.4 22.4 50.8 33.9 77.4 33.9 20.9 0 40.7-7.2 55.4-21.8 33.3-33.3 27.9-92.7-12.1-132.7zm-421.4 86.7C108.2 312.6 92 320 77.2 320c-6.2 0-15-1.4-21.4-7.8-14.1-14.1-8.4-44.4 12.1-64.9 10.4-10.4 43.4-20.3 79.8-26.9-6.7 36.3-16.6 69.3-27 79.7zM336 409.6c0 30-21.5 54.4-48 54.4s-48-24.4-48-54.4c0-13.8 20.4-47.5 48-81.5 27.3 33.9 48 67.9 48 81.5zm184.2-97.4c-6.4 6.4-15.2 7.8-21.4 7.8-14.8 0-31-7.4-43.4-19.9-10.4-10.4-20.3-43.4-26.9-79.7 36.3 6.6 69.4 16.6 79.7 26.9 20.4 20.5 26.1 50.8 12 64.9zM384 64c17.7 0 32-14.3 32-32S401.7 0 384 0s-32 14.3-32 32 14.3 32 32 32z"
  ]
};
export const faMitten = {
  prefix: "far",
  iconName: "mitten",
  icon: [
    448,
    512,
    [],
    "f7b5",
    "M416.8 184.7c-15.6-13-35.3-20.1-55.6-20.1-14.8 0-29.1 3.7-41.7 10.6l-12.6-54.7C290.5 49.6 228.3 0 155.5 0c-11.7 0-23.5 1.4-35.1 4C37 23.3-15.3 106.9 4 190.4L54.6 384h49.6L50.8 179.6C37.5 121.9 73.6 64.1 131.3 50.8c8-1.8 16.1-2.8 24.2-2.8 50.3 0 93.3 34.3 104.6 83.3l32.7 141.5 38.5-46.2c7.4-8.9 18.3-14 29.9-14 9 0 17.9 3.2 24.8 9 16.5 13.7 18.7 38.3 5 54.7L301.3 384h62.5l64.1-76.9c30.7-36.8 25.7-91.7-11.1-122.4zM368.1 416H48c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16v-64c.1-8.8-7.1-16-15.9-16z"
  ]
};
export const faMobile = {
  prefix: "far",
  iconName: "mobile",
  icon: [
    320,
    512,
    [],
    "f10b",
    "M192 416c0 17.7-14.3 32-32 32s-32-14.3-32-32 14.3-32 32-32 32 14.3 32 32zM320 48v416c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V48C0 21.5 21.5 0 48 0h224c26.5 0 48 21.5 48 48zm-48 410V54c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v404c0 3.3 2.7 6 6 6h212c3.3 0 6-2.7 6-6z"
  ]
};
export const faMobileAlt = {
  prefix: "far",
  iconName: "mobile-alt",
  icon: [
    320,
    512,
    [],
    "f3cd",
    "M192 416c0 17.7-14.3 32-32 32s-32-14.3-32-32 14.3-32 32-32 32 14.3 32 32zm48-60V92c0-6.6-5.4-12-12-12H92c-6.6 0-12 5.4-12 12v264c0 6.6 5.4 12 12 12h136c6.6 0 12-5.4 12-12zm80-308v416c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V48C0 21.5 21.5 0 48 0h224c26.5 0 48 21.5 48 48zm-48 410V54c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v404c0 3.3 2.7 6 6 6h212c3.3 0 6-2.7 6-6z"
  ]
};
export const faMobileAndroid = {
  prefix: "far",
  iconName: "mobile-android",
  icon: [
    320,
    512,
    [],
    "f3ce",
    "M272 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zm-6 464H54c-3.3 0-6-2.7-6-6V54c0-3.3 2.7-6 6-6h212c3.3 0 6 2.7 6 6v404c0 3.3-2.7 6-6 6zm-70-32h-72c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h72c6.6 0 12 5.4 12 12v8c0 6.6-5.4 12-12 12z"
  ]
};
export const faMobileAndroidAlt = {
  prefix: "far",
  iconName: "mobile-android-alt",
  icon: [
    320,
    512,
    [],
    "f3cf",
    "M228 368H92c-6.6 0-12-5.4-12-12V92c0-6.6 5.4-12 12-12h136c6.6 0 12 5.4 12 12v264c0 6.6-5.4 12-12 12zm92-320v416c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V48C0 21.5 21.5 0 48 0h224c26.5 0 48 21.5 48 48zm-48 410V54c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v404c0 3.3 2.7 6 6 6h212c3.3 0 6-2.7 6-6zm-64-38v-8c0-6.6-5.4-12-12-12h-72c-6.6 0-12 5.4-12 12v8c0 6.6 5.4 12 12 12h72c6.6 0 12-5.4 12-12z"
  ]
};
export const faMoneyBill = {
  prefix: "far",
  iconName: "money-bill",
  icon: [
    640,
    512,
    [],
    "f0d6",
    "M608 64H32C14.33 64 0 78.33 0 96v320c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V96c0-17.67-14.33-32-32-32zm-16 272c-35.35 0-64 28.65-64 64H112c0-35.35-28.65-64-64-64V176c35.35 0 64-28.65 64-64h416c0 35.35 28.65 64 64 64v160zM320 160c-44.18 0-80 42.98-80 96 0 53.01 35.81 96 80 96 44.17 0 80-42.97 80-96 0-53.02-35.82-96-80-96z"
  ]
};
export const faMoneyBillAlt = {
  prefix: "far",
  iconName: "money-bill-alt",
  icon: [
    640,
    512,
    [],
    "f3d1",
    "M320 144c-53.02 0-96 50.14-96 112 0 61.85 42.98 112 96 112 53 0 96-50.13 96-112 0-61.86-42.98-112-96-112zm40 168c0 4.42-3.58 8-8 8h-64c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h16v-55.44l-.47.31a7.992 7.992 0 0 1-11.09-2.22l-8.88-13.31a7.992 7.992 0 0 1 2.22-11.09l15.33-10.22a23.99 23.99 0 0 1 13.31-4.03H328c4.42 0 8 3.58 8 8v88h16c4.42 0 8 3.58 8 8v16zM608 64H32C14.33 64 0 78.33 0 96v320c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V96c0-17.67-14.33-32-32-32zm-16 272c-35.35 0-64 28.65-64 64H112c0-35.35-28.65-64-64-64V176c35.35 0 64-28.65 64-64h416c0 35.35 28.65 64 64 64v160z"
  ]
};
export const faMoneyBillWave = {
  prefix: "far",
  iconName: "money-bill-wave",
  icon: [
    640,
    512,
    [],
    "f53a",
    "M320 160.55c-44.18 0-80 43.16-80 96.41 0 53.24 35.81 96.41 80 96.41 44.17 0 80-43.15 80-96.41 0-53.25-35.82-96.41-80-96.41zM621.16 54.46C582.37 38.19 543.55 32 504.75 32c-123.17-.01-246.33 62.34-369.5 62.34-30.89 0-61.76-3.92-92.65-13.72-3.47-1.1-6.95-1.62-10.35-1.62C15.04 79 0 92.32 0 110.81v317.26c0 12.63 7.23 24.6 18.84 29.46C57.63 473.81 96.45 480 135.25 480c123.17 0 246.34-62.35 369.51-62.35 30.89 0 61.76 3.92 92.65 13.72 3.47 1.1 6.95 1.62 10.35 1.62 17.21 0 32.25-13.32 32.25-31.81V83.93c-.01-12.64-7.24-24.6-18.85-29.47zM592 322.05c-26.89 3.4-48.58 23.31-54.38 49.48-10.8-.92-21.56-1.88-32.87-1.88-67.56 0-133.13 16.59-196.53 32.64C247.86 417.57 190.85 432 135.25 432c-8.02 0-15.85-.32-23.51-.94-1.42-34.23-29.29-61.61-63.73-61.61V192.69c31.07 0 56.93-22.25 62.74-51.75 8.14.51 16.08 1.4 24.51 1.4 67.56 0 133.12-16.59 196.52-32.64C392.13 94.43 449.14 80 504.75 80c10.84 0 21.22.78 31.42 1.91.85 31.96 24.87 57.84 55.83 61.76v178.38z"
  ]
};
export const faMoneyBillWaveAlt = {
  prefix: "far",
  iconName: "money-bill-wave-alt",
  icon: [
    640,
    512,
    [],
    "f53b",
    "M320 160.55c-44.18 0-80 43.16-80 96.41 0 53.24 35.81 96.41 80 96.41 44.17 0 80-43.15 80-96.41 0-53.25-35.82-96.41-80-96.41zM621.16 54.46C582.37 38.19 543.55 32 504.75 32c-123.17-.01-246.33 62.34-369.5 62.34-30.89 0-61.76-3.92-92.65-13.72-3.47-1.1-6.95-1.62-10.35-1.62C15.04 79 0 92.32 0 110.81v317.26c0 12.63 7.23 24.6 18.84 29.46C57.63 473.81 96.45 480 135.25 480c123.17 0 246.34-62.35 369.51-62.35 30.89 0 61.76 3.92 92.65 13.72 3.47 1.1 6.95 1.62 10.35 1.62 17.21 0 32.25-13.32 32.25-31.81V83.93c-.01-12.64-7.24-24.6-18.85-29.47zM592 379.98c-27.7-6.93-56.44-10.32-87.25-10.32-67.56 0-133.13 16.59-196.53 32.64-60.36 15.27-117.37 29.7-172.97 29.7-31.62 0-60.28-4.78-87.25-14.58v-285.4c27.7 6.93 56.44 10.32 87.25 10.32 67.56 0 133.12-16.59 196.52-32.64C392.13 94.43 449.14 80 504.75 80c31.63 0 60.29 4.78 87.25 14.58v285.4z"
  ]
};
export const faMoneyCheck = {
  prefix: "far",
  iconName: "money-check",
  icon: [
    640,
    512,
    [],
    "f53c",
    "M624 32H16C7.16 32 0 39.16 0 48v400c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V48c0-8.84-7.16-16-16-16zm-32 400H48V176h544v256zm0-304H48V80h544v48zM104 384h144c4.42 0 8-3.58 8-8v-32c0-4.42-3.58-8-8-8H104c-4.42 0-8 3.58-8 8v32c0 4.42 3.58 8 8 8zm352 0h80c4.42 0 8-3.58 8-8v-32c0-4.42-3.58-8-8-8h-80c-4.42 0-8 3.58-8 8v32c0 4.42 3.58 8 8 8zm-352-96h272c4.42 0 8-3.58 8-8v-32c0-4.42-3.58-8-8-8H104c-4.42 0-8 3.58-8 8v32c0 4.42 3.58 8 8 8zm360 0h64c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16h-64c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16z"
  ]
};
export const faMoneyCheckAlt = {
  prefix: "far",
  iconName: "money-check-alt",
  icon: [
    640,
    512,
    [],
    "f53d",
    "M608 32H32C14.33 32 0 46.33 0 64v384c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zm-16 400H48V80h544v352zM296 320h80c4.42 0 8-3.58 8-8v-32c0-4.42-3.58-8-8-8h-80c-4.42 0-8 3.58-8 8v32c0 4.42 3.58 8 8 8zm240-48h-80c-4.42 0-8 3.58-8 8v32c0 4.42 3.58 8 8 8h80c4.42 0 8-3.58 8-8v-32c0-4.42-3.58-8-8-8zm-240-32h240c4.42 0 8-3.58 8-8v-32c0-4.42-3.58-8-8-8H296c-4.42 0-8 3.58-8 8v32c0 4.42 3.58 8 8 8zm-161.28 17.72l42.19 11.44c4.19 1.14 7.09 4.55 7.09 8.3 0 4.8-4.5 8.7-10.06 8.7H147.6c-4.15 0-8.23-1.04-11.77-2.95-3.08-1.67-6.84-1.37-9.24 1.18l-12.07 12.73c-3.11 3.28-2.6 8.64 1.13 11.19 8.3 5.65 18.06 8.88 28.35 9.52V328c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-10.25c22.18-1.1 40-18.57 40-40.3 0-18.17-12.62-34.28-30.72-39.17l-42.19-11.44c-4.19-1.14-7.09-4.55-7.09-8.3 0-4.8 4.5-8.7 10.06-8.7h26.34c4.15 0 8.23 1.04 11.77 2.95 3.08 1.66 6.84 1.37 9.24-1.18l12.07-12.73c3.11-3.28 2.6-8.64-1.13-11.19-8.3-5.65-18.06-8.88-28.35-9.52V168c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v10.25c-22.18 1.1-40 18.57-40 40.3 0 18.17 12.62 34.28 30.72 39.17z"
  ]
};
export const faMoneyCheckEdit = {
  prefix: "far",
  iconName: "money-check-edit",
  icon: [
    640,
    512,
    [],
    "f872",
    "M485.52 384H528a16 16 0 0 0 16-16v-42.46a32 32 0 0 0-9.37-22.63L303.2 71.47l-71.7 71.7 231.39 231.45a32 32 0 0 0 22.63 9.38zM208.9 120.57l71.7-71.8L238.8 7a24.1 24.1 0 0 0-33.9 0L167 44.87a24 24 0 0 0 0 33.8zM128 368a16 16 0 0 0 16 16h283l-48-48H144a16 16 0 0 0-16 16zm480-240H405l48 48h139v288H48V176h171.07l-10.2-10.2-22.6-22.6-15.2-15.2H32a32 32 0 0 0-32 32v320a32 32 0 0 0 32 32h576a32 32 0 0 0 32-32V160a32 32 0 0 0-32-32zM144 304h203l-48-48H144a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16z"
  ]
};
export const faMoneyCheckEditAlt = {
  prefix: "far",
  iconName: "money-check-edit-alt",
  icon: [
    640,
    512,
    [],
    "f873",
    "M485.51 384H528a16 16 0 0 0 16-16v-42.46a32 32 0 0 0-9.37-22.63L303.18 71.47l-71.7 71.7 231.39 231.45a32 32 0 0 0 22.64 9.38zM208.88 120.57l71.7-71.8L238.78 7a24.1 24.1 0 0 0-33.9 0L167 44.87a24 24 0 0 0 0 33.8zM136 424h16a8 8 0 0 0 8-8v-16.12c23.62-.63 42.67-20.54 42.67-45.07 0-20-13-37.81-31.58-43.39l-45-13.5c-5.16-1.54-8.77-6.78-8.77-12.73 0-7.27 5.3-13.19 11.8-13.19h28.11a24 24 0 0 1 12.82 3.72 9 9 0 0 0 4.75 1.4 7.72 7.72 0 0 0 5.38-2.13l11.75-11.21a8 8 0 0 0-.57-12.14A57.18 57.18 0 0 0 160 240.29V224a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v16.12c-23.62.63-42.67 20.55-42.67 45.07 0 20 13 37.81 31.58 43.39l45 13.5c5.16 1.54 8.77 6.78 8.77 12.73 0 7.27-5.3 13.19-11.8 13.19h-28.11a24.08 24.08 0 0 1-12.77-3.72 9 9 0 0 0-4.75-1.4 7.7 7.7 0 0 0-5.38 2.13l-11.8 11.21a8 8 0 0 0 .57 12.14A57.26 57.26 0 0 0 128 399.71V416a8 8 0 0 0 8 8zm120-120h91l-48-48h-43a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16zm-16 64a16 16 0 0 0 16 16h171l-48-48H256a16 16 0 0 0-16 16zm368-240H405l48 48h139v288H48V176h171.05l-10.2-10.2-22.6-22.6-15.2-15.2H32a32 32 0 0 0-32 32v320a32 32 0 0 0 32 32h576a32 32 0 0 0 32-32V160a32 32 0 0 0-32-32z"
  ]
};
export const faMonitorHeartRate = {
  prefix: "far",
  iconName: "monitor-heart-rate",
  icon: [
    576,
    512,
    [],
    "f611",
    "M544 0H32C14.33 0 0 14.33 0 32v448c0 17.67 14.33 32 32 32h512c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32zm-16 464H48V288h158.69l26.53 79.59A24.044 24.044 0 0 0 255.69 384h.31c10.09 0 19.09-6.3 22.56-15.8l42.5-116.91 8.67 21.63A23.993 23.993 0 0 0 352 287.99h112c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16h-95.75l-25.97-64.91c-3.69-9.23-13.41-15.42-22.66-15.09-9.97.16-18.78 6.44-22.19 15.8L257 287.06l-10.22-30.66c-3.27-9.8-12.44-16.41-22.76-16.41H48V48h480v416z"
  ]
};
export const faMonkey = {
  prefix: "far",
  iconName: "monkey",
  icon: [
    640,
    512,
    [],
    "f6fb",
    "M640 120c0-39.77-32.24-72-72-72h-12.27C535.49 19.04 502.02 0 464 0s-71.49 19.04-91.73 48H360c-39.76 0-72 32.23-72 72 0 38.77 30.72 70.16 69.11 71.71.78 2.63 1.47 5.29 2.43 7.84C263.21 224.58 192 311.83 192 416v48h-8c-22.06 0-40-17.94-40-40V168c0-39.7-32.31-72-72-72S0 128.3 0 168v64c0 13.25 10.75 24 24 24s24-10.75 24-24v-64c0-13.23 10.78-24 24-24s24 10.77 24 24v256c0 48.53 39.47 88 88 88h248c8.84 0 16-7.16 16-16 0-17.67-14.33-32-32-32h-32l83.4-62.55 12.6 49.91V480c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-16.24c0-10.47-1.28-20.89-3.82-31.05l-51.31-205.24c8.08-10.62 14.13-22.66 18.02-35.76C609.28 190.16 640 158.77 640 120zm-48 0c0 10.4-6.73 19.05-16 22.38V112c0-5.03-.84-9.83-1.48-14.68 10 2.89 17.48 11.76 17.48 22.68zm-240-8v30.38c-9.27-3.33-16-11.98-16-22.38 0-10.92 7.48-19.79 17.48-22.68-.64 4.85-1.48 9.65-1.48 14.68zm48 0c0-35.29 28.71-64 64-64s64 28.71 64 64v48c0 35.29-28.71 64-64 64s-64-28.71-64-64v-48zm157.61 332.36a79.834 79.834 0 0 1 2.39 19.4v.24h-32v-18.6l-1.46-5.78-30.24-119.85L304 464h-64v-48c0-87.74 64.62-160.41 148.71-173.58C408.63 260.62 434.89 272 464 272c17.15 0 33.22-4.17 47.76-11.06l45.85 183.42zM496 136c8.84 0 16-7.16 16-16s-7.16-16-16-16-16 7.16-16 16 7.16 16 16 16zm-64 0c8.84 0 16-7.16 16-16s-7.16-16-16-16-16 7.16-16 16 7.16 16 16 16z"
  ]
};
export const faMonument = {
  prefix: "far",
  iconName: "monument",
  icon: [
    384,
    512,
    [],
    "f5a6",
    "M368 464h-33.98l-44.89-363.26a31.97 31.97 0 0 0-9.21-19.44L203.31 4.69A15.905 15.905 0 0 0 192 0c-4.09 0-8.19 1.56-11.31 4.69L104.08 81.3a31.97 31.97 0 0 0-9.21 19.44L49.98 464H16c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h352c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16zm-269.66 0l43.56-352.65 50.1-50.1 50.08 50.08L285.66 464H98.34zM227.2 272h-70.4c-6.4 0-12.8 6.4-12.8 12.8v22.4c0 6.4 6.4 12.8 12.8 12.8h70.4c6.4 0 12.8-6.4 12.8-12.8v-22.4c0-6.4-6.4-12.8-12.8-12.8z"
  ]
};
export const faMoon = {
  prefix: "far",
  iconName: "moon",
  icon: [
    512,
    512,
    [],
    "f186",
    "M279.135 512c78.756 0 150.982-35.804 198.844-94.775 28.27-34.831-2.558-85.722-46.249-77.401-82.348 15.683-158.272-47.268-158.272-130.792 0-48.424 26.06-92.292 67.434-115.836 38.745-22.05 28.999-80.788-15.022-88.919A257.936 257.936 0 0 0 279.135 0c-141.36 0-256 114.575-256 256 0 141.36 114.576 256 256 256zm0-464c12.985 0 25.689 1.201 38.016 3.478-54.76 31.163-91.693 90.042-91.693 157.554 0 113.848 103.641 199.2 215.252 177.944C402.574 433.964 344.366 464 279.135 464c-114.875 0-208-93.125-208-208s93.125-208 208-208z"
  ]
};
export const faMoonCloud = {
  prefix: "far",
  iconName: "moon-cloud",
  icon: [
    640,
    512,
    [],
    "f754",
    "M283.6 176.1C259.7 146.3 223.2 128 184 128c-40.4 0-77.7 19-101.6 50.3C35.4 188.2 0 230.1 0 280c0 57.3 46.7 104 104 104h176c57.3 0 104-46.7 104-104 0-56.1-44.7-102-100.4-103.9zM280 336H104c-30.9 0-56-25.1-56-56s25.1-56 56-56h6.8c12.4-28.2 40.5-48 73.2-48 34.4 0 63.4 21.8 74.8 52.2 6.6-2.7 13.7-4.2 21.2-4.2 30.9 0 56 25.1 56 56s-25.1 56-56 56zm357.6 15.2c-4.1-8.6-12.4-13.9-21.8-13.9-5.5 0-11.9 2.6-27.8 2.6-67 0-121.5-54.7-121.5-121.9 0-43.7 23.6-84.3 61.6-106 8.9-5.1 13.6-15 11.9-25.1-1.7-10.2-9.4-17.9-19.5-19.8-11.5-2.1-23.3-3.2-35-3.2-67.3 0-126 35.2-160.1 87.9 15.4 5.4 29.5 13.5 41.7 23.7 19.8-29.6 50-51.5 85.7-59.9-21.9 29.1-34.4 64.9-34.4 102.4 0 81.1 57 149.1 132.9 165.9-20.1 10.4-42.6 16-65.9 16-37.7 0-71.7-14.8-97.2-38.7-9.7 12.8-21.3 24-34.8 32.8 34.3 33.2 80.6 53.9 132 53.9 58.1 0 112.4-25.9 149-71.1 6.1-7.2 7.3-17.1 3.2-25.6z"
  ]
};
export const faMoonStars = {
  prefix: "far",
  iconName: "moon-stars",
  icon: [
    512,
    512,
    [],
    "f755",
    "M405.8 373.8c-1.4 0-2.8.3-4.3.9-23.2 10.5-47.3 15.4-70.8 15.4-75.9 0-146.6-50.8-166-129.3-14.6-59.2 4-121.4 48.7-163.3 6.7-6.3 2.1-17.5-7-17.5h-.6c-13.3.8-26.6 2.7-39.5 5.8C49.4 114.1-22.3 231 6.3 347c24.3 98.7 113.4 165 211.6 165 17.1 0 34.5-2 51.8-6.2C335 490 387.4 446.1 415 388.3c3.4-7.1-2.3-14.5-9.2-14.5zm-147.4 85.3c-13.3 3.2-27 4.9-40.5 4.9-78.5 0-146.4-52.8-165-128.5-10.7-43.3-3.8-88.2 19.4-126.4 12.7-20.9 29.4-38.4 49.1-51.8-11.3 36.8-12.8 76.5-3.3 115 22.4 91 99.8 156.3 192.1 164.8-15.7 10.1-33.1 17.5-51.8 22zm200.3-277.8L432 128l-26.7 53.3L352 208l53.3 26.7L432 288l26.7-53.3L512 208l-53.3-26.7zM304 96l16-32 32-16-32-16-16-32-16 32-32 16 32 16 16 32z"
  ]
};
export const faMortarPestle = {
  prefix: "far",
  iconName: "mortar-pestle",
  icon: [
    512,
    512,
    [],
    "f5a7",
    "M496 192H395.7L496.3 91.4c25.8-25.8 18.8-69.4-13.9-85.7-18.1-9.1-39.8-7.1-56 5.1L184.6 192H16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h16v16c0 81.4 50.8 150.8 122.3 178.8-12.8 16.8-21.7 36.6-24.9 58.4-1.4 9.8 6 18.8 15.9 18.8h221.4c9.9 0 17.4-9 15.9-18.8-3.2-21.8-12.2-41.7-24.9-58.4C429.2 406.8 480 337.4 480 256v-16h16c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zM455.2 49.1c1-.7 2.1-1.1 3.3-1.1.9 0 1.7.2 2.5.6.6.3 2.5 1.3 3 4s-1 4.3-1.5 4.8L327.8 192h-63.2zM432 256c0 59.7-36 112.3-91.7 134L281 413.2l38.5 50.6c0 .1.1.1.1.2H192.4c0-.1.1-.1.1-.2l38.5-50.6-59.3-23.2C116 368.3 80 315.7 80 256v-16h352z"
  ]
};
export const faMosque = {
  prefix: "far",
  iconName: "mosque",
  icon: [
    640,
    512,
    [],
    "f678",
    "M288 384c-17.67 0-32 14.33-32 32v80c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-80c0-17.67-14.33-32-32-32zm112-32s-48 24-48 72v72c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16v-72c0-48-48-72-48-72zm112 32c-17.67 0-32 14.33-32 32v80c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-80c0-17.67-14.33-32-32-32zm110.29-108.25C633.38 260.79 640 243.1 640 224c0-52.86-48.22-88.7-101.45-117.81C453.15 59.48 416.69 17.75 400 0c-16.68 17.74-53.14 59.48-138.55 106.19-19.17 10.48-37.59 21.89-53.45 34.6V120C208 40 104 0 104 0S0 40 0 120v376c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V192h112v304c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V320h384v176c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V304c0-12.46-7.32-22.97-17.71-28.25zM160 144H48v-24c0-29.2 32.46-53.73 56.01-66.84C126.81 65.88 160 90.4 160 120v24zm369.23 128H270.77c-34.02 0-62.77-21.98-62.77-48 0-23.11 24.3-47.16 76.48-75.7 45.39-24.82 83.47-51.29 115.52-80.35 32.05 29.06 70.13 55.52 115.52 80.35C567.7 176.84 592 200.89 592 224c0 26.02-28.74 48-62.77 48z"
  ]
};
export const faMotorcycle = {
  prefix: "far",
  iconName: "motorcycle",
  icon: [
    640,
    512,
    [],
    "f21c",
    "M512 192c-15.601 0-30.548 2.795-44.374 7.905L434.633 144H520c13.255 0 24-10.745 24-24V88c0-13.255-10.745-24-24-24h-45.312a24 24 0 0 0-17.839 7.945l-39.101 43.445-24.524-41.555A20 20 0 0 0 376 64h-76c-6.627 0-12 5.373-12 12v16c0 6.627 5.373 12 12 12h64.58l30.688 52h-175.86c-4.01-4.393-8.542-8.531-13.783-12.275C186.784 130.268 162.118 124 128 124H72c-11.046 0-20 8.954-20 20s8.954 20 20 20h56c22.885 0 37.946 8.448 48.662 20.205l-7.936 14.43A127.765 127.765 0 0 0 128 192C57.308 192 0 249.308 0 320s57.308 128 128 128c58.192 0 107.311-38.834 122.863-92h81.327c11.396 0 20.491-9.517 19.979-20.897-2.456-54.98 23.782-106.017 68.372-136.28l12.198 20.668C403.054 242.932 384 279.24 384 320c0 70.692 57.308 128 128 128s128-57.308 128-128-57.308-128-128-128zM128 408c-48.523 0-88-39.477-88-88s39.477-88 88-88c7.229 0 14.256.878 20.983 2.53l-50.507 91.831C91.156 339.672 100.802 356 116 356h92.27c-13.787 30.62-44.569 52-80.27 52zm184.367-92H149.825l66-120h147.308c-30.834 33.811-48.088 76.226-50.766 120zM512 408c-48.523 0-88-39.477-88-88 0-26.019 11.354-49.434 29.365-65.559l53.477 90.614c3.369 5.708 10.726 7.604 16.434 4.236l13.78-8.132c5.708-3.368 7.604-10.726 4.236-16.434l-52.833-89.522A87.769 87.769 0 0 1 512 232c48.523 0 88 39.477 88 88s-39.477 88-88 88z"
  ]
};
export const faMountain = {
  prefix: "far",
  iconName: "mountain",
  icon: [
    640,
    512,
    [],
    "f6fc",
    "M634.92 462.7l-288-448C341.03 5.54 330.89 0 320 0s-21.03 5.54-26.92 14.7l-288 448a32.001 32.001 0 0 0-1.17 32.64A32.004 32.004 0 0 0 32 512h576c11.71 0 22.48-6.39 28.09-16.67a31.983 31.983 0 0 0-1.17-32.63zM61.31 464l131.77-204.98L256 321.94 329.94 248h109.9L578.7 464H61.31zM320 61.59L408.98 200h-98.92L256 254.06l-36.36-36.36L320 61.59z"
  ]
};
export const faMountains = {
  prefix: "far",
  iconName: "mountains",
  icon: [
    640,
    512,
    [],
    "f6fd",
    "M635.73 406.91l-194.04-297.6C435.9 100.44 425.95 96 416 96c-9.95 0-19.9 4.44-25.69 13.31l-52 79.76-70.79-110.55C261.32 68.84 250.66 64 240 64s-21.32 4.84-27.52 14.52L4.58 403.18C-7.99 422.81 6.81 448 30.92 448h580.22c22.5 0 36.32-23.09 24.59-41.09zM63.61 400L240 124.55 416.39 400H63.61zm409.78 0L366.71 233.4 416 157.8 573.92 400H473.39z"
  ]
};
export const faMouse = {
  prefix: "far",
  iconName: "mouse",
  icon: [
    384,
    512,
    [],
    "f8cc",
    "M224 0h-64A160 160 0 0 0 0 160v192a160 160 0 0 0 160 160h64a160 160 0 0 0 160-160V160A160 160 0 0 0 224 0zm112 160v16H216V48h8a112.12 112.12 0 0 1 112 112zM160 48h8v128H48v-16A112.12 112.12 0 0 1 160 48zm64 416h-64A112.12 112.12 0 0 1 48 352V224h288v128a112.12 112.12 0 0 1-112 112z"
  ]
};
export const faMouseAlt = {
  prefix: "far",
  iconName: "mouse-alt",
  icon: [
    384,
    512,
    [],
    "f8cd",
    "M224 0h-64A160 160 0 0 0 0 160v192a160 160 0 0 0 160 160h64a160 160 0 0 0 160-160V160A160 160 0 0 0 224 0zm112 352a112.12 112.12 0 0 1-112 112h-64A112.12 112.12 0 0 1 48 352V160A112.12 112.12 0 0 1 160 48h64a112.12 112.12 0 0 1 112 112zM192 96a32 32 0 0 0-32 32v32a32 32 0 0 0 64 0v-32a32 32 0 0 0-32-32z"
  ]
};
export const faMousePointer = {
  prefix: "far",
  iconName: "mouse-pointer",
  icon: [
    384,
    512,
    [],
    "f245",
    "M356.683 255.576L115.915 18.636C77.055-21.086 8 6.909 8 62.87v349.112c0 55.241 67.457 83.887 107.414 44.727l23.927-23.449 17.535 40.669.121.281.125.274c13.903 31.145 50.295 45.894 82.155 32.648l41.903-17.395.254-.106.253-.109c15.618-6.697 27.662-19.038 33.912-34.749 6.184-15.545 5.927-32.568-.724-47.933l-18.71-43.423h16.527c55.848.002 85.165-68.485 43.991-107.841zm-43.872 59.843h-89.594l47.607 110.491c3.316 7.661-.474 16.249-8.053 19.499l-41.922 17.409c-7.816 3.25-16.58-.465-19.895-7.892l-45.238-104.92-73.898 72.423C72.038 432.012 56 424.734 56 411.982V62.868c0-13.309 16.978-19.829 25.817-10.445L323.47 290.117c9.79 9.091 2.553 25.302-10.659 25.302z"
  ]
};
export const faMp3Player = {
  prefix: "far",
  iconName: "mp3-player",
  icon: [
    384,
    512,
    [],
    "f8ce",
    "M305 80H81v112h224zm32-80H49A48 48 0 0 0 1 48v416a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V48a48 48 0 0 0-48-48zm0 464H49V48h288zM193 240a96 96 0 1 0 96 96 96 96 0 0 0-96-96zm0 128a32 32 0 1 1 32-32 32 32 0 0 1-32 32z"
  ]
};
export const faMug = {
  prefix: "far",
  iconName: "mug",
  icon: [
    576,
    512,
    [],
    "f874",
    "M464 64H64a32 32 0 0 0-32 32v256a96 96 0 0 0 96 96h192a96 96 0 0 0 96-96v-64h48a112 112 0 0 0 0-224zm-96 288a48 48 0 0 1-48 48H128a48 48 0 0 1-48-48V112h288zm96-112h-48V112h48a64 64 0 0 1 0 128z"
  ]
};
export const faMugHot = {
  prefix: "far",
  iconName: "mug-hot",
  icon: [
    512,
    512,
    [],
    "f7b6",
    "M400 192H32c-17.7 0-32 14.3-32 32v192c0 53 43 96 96 96h192c53 0 96-43 96-96h16c61.8 0 112-50.2 112-112s-50.2-112-112-112zm-64 224c0 26.5-21.5 48-48 48H96c-26.5 0-48-21.5-48-48V240h288v176zm64-48h-16V240h16c35.3 0 64 28.7 64 64s-28.7 64-64 64zM239.1 146.5c1.3 7.7 8 13.5 16 13.5h16.5c9.8 0 17.6-8.5 16.3-18-3.8-28.2-16.4-54.2-36.6-74.7-14.4-14.7-23.6-33.3-26.4-53.5C223.8 5.9 217 0 208.8 0h-16.4c-9.8 0-17.5 8.5-16.3 18 3.9 31.9 18 61.3 40.6 84.4 12 12.2 19.7 27.5 22.4 44.1zm-112 0c1.3 7.7 8 13.5 16 13.5h16.5c9.8 0 17.6-8.5 16.3-18-3.8-28.2-16.4-54.2-36.6-74.7-14.4-14.7-23.6-33.3-26.4-53.5C111.8 5.9 105 0 96.8 0H80.4C70.6 0 63 8.5 64.1 18c3.9 31.9 18 61.3 40.6 84.4 12 12.2 19.7 27.5 22.4 44.1z"
  ]
};
export const faMugMarshmallows = {
  prefix: "far",
  iconName: "mug-marshmallows",
  icon: [
    512,
    512,
    [],
    "f7b7",
    "M400 160h-20.9c7.2-12.4 6-28.3-4.6-39L295 41.5c-6.3-6.3-14.7-9.5-23-9.5s-16.6 3.2-23 9.5l-27.4 27.4C217 57 205.6 48.5 192 48.5H64c-17.7 0-32 14.3-32 32V160c-17.7 0-32 14.3-32 32v192c0 53 43 96 96 96h192c53 0 96-43 96-96h16c61.8 0 112-50.2 112-112s-50.2-112-112-112zM272 86.4l57.6 57.6-16 16h-83.1l-16-16L272 86.4zM80 96.5h96v18.1l-6.5 6.5c-10.6 10.6-11.8 26.5-4.6 39H80V96.5zM336 384c0 26.5-21.5 48-48 48H96c-26.5 0-48-21.5-48-48V208h48v56c0 13.3 10.7 24 24 24s24-10.7 24-24v-56h192v176zm64-48h-16V208h16c35.3 0 64 28.7 64 64s-28.7 64-64 64z"
  ]
};
export const faMugTea = {
  prefix: "far",
  iconName: "mug-tea",
  icon: [
    640,
    512,
    [],
    "f875",
    "M599.87 432H8.16c-18.19 0-5.29 48 32 48h527.62c37.28 0 50.22-48 32.09-48zM176 384h224a80 80 0 0 0 80-80v-16h32c70.59 0 128-57.41 128-128S582.56 32 512 32H112a16 16 0 0 0-16 16v256a80 80 0 0 0 80 80zM480 80h32a80 80 0 0 1 0 160h-32zm-256 99.88l16-16 16 16V224h-32zM144 80h72v40l-30.63 30.63a32 32 0 0 0-9.37 22.62V240a32 32 0 0 0 32 32h64a32 32 0 0 0 32-32v-66.75a32 32 0 0 0-9.38-22.62L264 120V80h168v224a32.11 32.11 0 0 1-32 32H176a32.1 32.1 0 0 1-32-32z"
  ]
};
export const faMusic = {
  prefix: "far",
  iconName: "music",
  icon: [
    512,
    512,
    [],
    "f001",
    "M480.06 0a31.94 31.94 0 0 0-9.68 1.5l-304 96A32 32 0 0 0 144 128v235.09A109.68 109.68 0 0 0 96 352c-53 0-96 35.81-96 80s43 80 96 80c49.38 0 89.56-31.16 94.91-71.09a38.74 38.74 0 0 0 1.06-8.66V256l272-85.91v129A109.78 109.78 0 0 0 416 288c-53 0-96 35.81-96 80s43 80 96 80c49.38 0 89.56-31.19 94.94-71.12a38.94 38.94 0 0 0 1-8.22c0-.22.06-.44.06-.66V32a32 32 0 0 0-31.94-32zM96 464c-28.28 0-48-16.88-48-32s19.72-32 48-32 48 16.84 48 32-19.72 32-48 32zm368-96c0 15.12-19.72 32-48 32s-48-16.88-48-32 19.72-32 48-32 48 16.84 48 32zm0-248.25l-272 85.91v-65.91l272-85.87z"
  ]
};
export const faMusicAlt = {
  prefix: "far",
  iconName: "music-alt",
  icon: [
    384,
    512,
    [],
    "f8cf",
    "M342.36 1.51l-144 35.38A32 32 0 0 0 176 67.36v299.12c-18.16-9.07-40.16-14.48-64-14.48-61.86 0-112 35.82-112 80s50.14 80 112 80 112-35.82 112-80V195.36L361.64 162A32 32 0 0 0 384 131.48V32a32 32 0 0 0-41.64-30.49zM112 464c-39.7 0-64-20.72-64-32s24.3-32 64-32 64 20.72 64 32-24.3 32-64 32zm224-344.25L224 145V79.12l112-25.26z"
  ]
};
export const faMusicAltSlash = {
  prefix: "far",
  iconName: "music-alt-slash",
  icon: [
    640,
    512,
    [],
    "f8d0",
    "M240 352c-61.86 0-112 35.82-112 80s50.14 80 112 80 112-35.82 112-80-50.15-80-112-80zm0 112c-39.7 0-64-20.72-64-32s24.3-32 64-32 64 20.72 64 32-24.3 32-64 32zm394 7L36 3.52A16 16 0 0 0 13.48 6l-10 12.49A16 16 0 0 0 6 41l598 467.5a16 16 0 0 0 22.5-2.5l10-12.5A16 16 0 0 0 634 471zM489.64 162A32 32 0 0 0 512 131.48V32a32 32 0 0 0-41.64-30.49l-144 35.38A32 32 0 0 0 304 67.36v84.76L357.58 194zM352 79.13l112-25.27v65.89L352 145z"
  ]
};
export const faMusicSlash = {
  prefix: "far",
  iconName: "music-slash",
  icon: [
    640,
    512,
    [],
    "f8d1",
    "M528 53.88v65.9l-189 59.68 45.86 35.85L528 170.1v157.15l48 37.52V32a31.95 31.95 0 0 0-41.62-30.5L233.05 96.66l45.87 35.86zM634 471L36 3.52A16 16 0 0 0 13.48 6l-10 12.49A16 16 0 0 0 6 41l598 467.5a16 16 0 0 0 22.5-2.5l10-12.5A16 16 0 0 0 634 471zM208 363.09A109.68 109.68 0 0 0 160 352c-53 0-96 35.81-96 80s43 80 96 80c49.37 0 89.56-31.16 94.91-71.09a38.69 38.69 0 0 0 1.06-8.63V297.37l-48-37.53zM160 464c-28.28 0-48-16.87-48-32s19.72-32 48-32 48 16.88 48 32-19.72 32-48 32z"
  ]
};
export const faNarwhal = {
  prefix: "far",
  iconName: "narwhal",
  icon: [
    640,
    512,
    [],
    "f6fe",
    "M591.21 220.16l48.52-207.28c1.04-4.46-.94-9.25-5.14-11.57-5.07-2.8-11.45-.96-14.25 4.11L517.06 192.51c-1.71-.07-3.32-.51-5.06-.51-141.14 0-207.15 83.47-308.69 182.31-3.26 3.26-7.27 4.72-11.2 4.72-8.23 0-16.12-6.39-16.12-16.03v-62.87l31.38-16.49C217.76 277.7 224 267.7 224 257V144.03c0-9.41-9.01-16.03-18.72-16.03h-.01c-3.47 0-7.02.85-10.29 2.71L112 178.13l-82.98-47.42c-3.27-1.87-6.83-2.71-10.3-2.71C9.01 128 0 134.61 0 144.03V257c0 10.7 6.24 20.69 16.62 26.62L48 300.12v80C48 452.96 107.04 512 179.88 512H544c53.02 0 96-42.98 96-96v-96c0-40.62-19.29-76.39-48.79-99.84zM592 416c0 26.47-21.53 48-48 48H179.88C133.63 464 96 426.37 96 380.13v-109l-25.67-13.49L48 245.89v-49.05l40.19 22.96L112 233.42l23.82-13.61L176 196.84v49.05l-22.33 11.74-25.67 13.5V363c0 35.31 28.76 64.03 64.12 64.03 17 0 33.03-6.67 44.68-18.32 11.53-11.22 22.6-22.24 33.38-32.97C352.28 294 406.52 240 512 240c44.11 0 80 35.89 80 80v96zm-160-72c-13.25 0-24 10.74-24 24 0 13.25 10.75 24 24 24s24-10.75 24-24c0-13.26-10.75-24-24-24z"
  ]
};
export const faNetworkWired = {
  prefix: "far",
  iconName: "network-wired",
  icon: [
    640,
    512,
    [],
    "f6ff",
    "M640 264v-16c0-8.84-7.16-16-16-16H344v-72h72c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32H224c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h72v72H16c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h104v72H64c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h160c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32h-56v-72h304v72h-56c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h160c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32h-56v-72h104c8.84 0 16-7.16 16-16zM240 48h160v64H240V48zm-32 352v64H80v-64h128zm352 0v64H432v-64h128z"
  ]
};
export const faNeuter = {
  prefix: "far",
  iconName: "neuter",
  icon: [
    288,
    512,
    [],
    "f22c",
    "M288 176c0-79.5-64.5-144-144-144S0 96.5 0 176c0 71.4 51.9 130.6 120 142v150c0 6.6 5.4 12 12 12h24c6.6 0 12-5.4 12-12V318c68.1-11.4 120-70.6 120-142zm-144 96c-52.9 0-96-43.1-96-96s43.1-96 96-96 96 43.1 96 96-43.1 96-96 96z"
  ]
};
export const faNewspaper = {
  prefix: "far",
  iconName: "newspaper",
  icon: [
    576,
    512,
    [],
    "f1ea",
    "M552 64H112c-20.858 0-38.643 13.377-45.248 32H24c-13.255 0-24 10.745-24 24v272c0 30.928 25.072 56 56 56h496c13.255 0 24-10.745 24-24V88c0-13.255-10.745-24-24-24zM48 392V144h16v248c0 4.411-3.589 8-8 8s-8-3.589-8-8zm480 8H111.422c.374-2.614.578-5.283.578-8V112h416v288zM172 280h136c6.627 0 12-5.373 12-12v-96c0-6.627-5.373-12-12-12H172c-6.627 0-12 5.373-12 12v96c0 6.627 5.373 12 12 12zm28-80h80v40h-80v-40zm-40 140v-24c0-6.627 5.373-12 12-12h136c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12H172c-6.627 0-12-5.373-12-12zm192 0v-24c0-6.627 5.373-12 12-12h104c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12H364c-6.627 0-12-5.373-12-12zm0-144v-24c0-6.627 5.373-12 12-12h104c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12H364c-6.627 0-12-5.373-12-12zm0 72v-24c0-6.627 5.373-12 12-12h104c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12H364c-6.627 0-12-5.373-12-12z"
  ]
};
export const faNotEqual = {
  prefix: "far",
  iconName: "not-equal",
  icon: [
    384,
    512,
    [],
    "f53e",
    "M368 208c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16h-42.32l55.03-66.81c5.37-7.02 4.04-17.06-2.97-22.43L352.32 35.3c-7.02-5.37-17.06-4.04-22.43 2.97L242.81 144H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h174.1l-79.07 96H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h42.32L3.3 434.81c-5.37 7.01-4.04 17.05 2.97 22.43l25.41 19.46c7.02 5.38 17.06 4.04 22.43-2.97L141.19 368H368c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16H193.9l79.07-96H368z"
  ]
};
export const faNotesMedical = {
  prefix: "far",
  iconName: "notes-medical",
  icon: [
    384,
    512,
    [],
    "f481",
    "M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM192 40c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm144 418c0 3.3-2.7 6-6 6H54c-3.3 0-6-2.7-6-6V118c0-3.3 2.7-6 6-6h42v36c0 6.6 5.4 12 12 12h168c6.6 0 12-5.4 12-12v-36h42c3.3 0 6 2.7 6 6v340zm-56-170h-56v-56c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v56h-56c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h56v56c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-56h56c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z"
  ]
};
export const faObjectGroup = {
  prefix: "far",
  iconName: "object-group",
  icon: [
    512,
    512,
    [],
    "f247",
    "M500 128c6.627 0 12-5.373 12-12V44c0-6.627-5.373-12-12-12h-72c-6.627 0-12 5.373-12 12v12H96V44c0-6.627-5.373-12-12-12H12C5.373 32 0 37.373 0 44v72c0 6.627 5.373 12 12 12h12v256H12c-6.627 0-12 5.373-12 12v72c0 6.627 5.373 12 12 12h72c6.627 0 12-5.373 12-12v-12h320v12c0 6.627 5.373 12 12 12h72c6.627 0 12-5.373 12-12v-72c0-6.627-5.373-12-12-12h-12V128h12zm-52-64h32v32h-32V64zM32 64h32v32H32V64zm32 384H32v-32h32v32zm416 0h-32v-32h32v32zm-40-64h-12c-6.627 0-12 5.373-12 12v12H96v-12c0-6.627-5.373-12-12-12H72V128h12c6.627 0 12-5.373 12-12v-12h320v12c0 6.627 5.373 12 12 12h12v256zm-36-192h-84v-52c0-6.628-5.373-12-12-12H108c-6.627 0-12 5.372-12 12v168c0 6.628 5.373 12 12 12h84v52c0 6.628 5.373 12 12 12h200c6.627 0 12-5.372 12-12V204c0-6.628-5.373-12-12-12zm-268-24h144v112H136V168zm240 176H232v-24h76c6.627 0 12-5.372 12-12v-76h56v112z"
  ]
};
export const faObjectUngroup = {
  prefix: "far",
  iconName: "object-ungroup",
  icon: [
    576,
    512,
    [],
    "f248",
    "M564 224c6.627 0 12-5.373 12-12v-72c0-6.627-5.373-12-12-12h-72c-6.627 0-12 5.373-12 12v12h-88v-24h12c6.627 0 12-5.373 12-12V44c0-6.627-5.373-12-12-12h-72c-6.627 0-12 5.373-12 12v12H96V44c0-6.627-5.373-12-12-12H12C5.373 32 0 37.373 0 44v72c0 6.627 5.373 12 12 12h12v160H12c-6.627 0-12 5.373-12 12v72c0 6.627 5.373 12 12 12h72c6.627 0 12-5.373 12-12v-12h88v24h-12c-6.627 0-12 5.373-12 12v72c0 6.627 5.373 12 12 12h72c6.627 0 12-5.373 12-12v-12h224v12c0 6.627 5.373 12 12 12h72c6.627 0 12-5.373 12-12v-72c0-6.627-5.373-12-12-12h-12V224h12zM352 64h32v32h-32V64zm0 256h32v32h-32v-32zM64 352H32v-32h32v32zm0-256H32V64h32v32zm32 216v-12c0-6.627-5.373-12-12-12H72V128h12c6.627 0 12-5.373 12-12v-12h224v12c0 6.627 5.373 12 12 12h12v160h-12c-6.627 0-12 5.373-12 12v12H96zm128 136h-32v-32h32v32zm280-64h-12c-6.627 0-12 5.373-12 12v12H256v-12c0-6.627-5.373-12-12-12h-12v-24h88v12c0 6.627 5.373 12 12 12h72c6.627 0 12-5.373 12-12v-72c0-6.627-5.373-12-12-12h-12v-88h88v12c0 6.627 5.373 12 12 12h12v160zm40 64h-32v-32h32v32zm0-256h-32v-32h32v32z"
  ]
};
export const faOctagon = {
  prefix: "far",
  iconName: "octagon",
  icon: [
    512,
    512,
    [],
    "f306",
    "M497.9 150.5L361.5 14.1c-9-9-21.2-14.1-33.9-14.1H184.5c-12.7 0-24.9 5.1-33.9 14.1L14.1 150.5c-9 9-14.1 21.2-14.1 33.9v143.1c0 12.7 5.1 24.9 14.1 33.9l136.5 136.5c9 9 21.2 14.1 33.9 14.1h143.1c12.7 0 24.9-5.1 33.9-14.1L498 361.4c9-9 14.1-21.2 14.1-33.9v-143c-.1-12.8-5.2-25-14.2-34zm-33.9 177L327.5 464h-143L48 327.5v-143L184.5 48h143.1L464 184.5v143z"
  ]
};
export const faOilCan = {
  prefix: "far",
  iconName: "oil-can",
  icon: [
    640,
    512,
    [],
    "f613",
    "M629.8 160.31L416 224l-50.49-25.24a64.07 64.07 0 0 0-28.62-6.76H280v-48h56c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16H176c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h56v48h-56C26.86 164.88 36.11 166.33 31.93 166.33 14.67 166.33 0 180.36 0 198.34v94.95c0 15.46 11.06 28.72 26.28 31.48L96 337.46V384c0 17.67 14.33 32 32 32h274.64c8.55 0 16.75-3.42 22.76-9.51l212.26-214.75c1.5-1.5 2.34-3.54 2.34-5.66V168c0-5.75-5.51-9.03-10.2-7.69zM96 288.67l-48-8.73v-62.43l48 8.73v62.43zM395.95 368H144V240h192.89c2.47 0 4.95.58 7.15 1.69 61.22 30.61 46.03 23.01 67.46 33.73 25.47-7.59 13.03-3.88 107.64-32.07L395.95 368zm153.38 5.33c0 23.56 19.1 42.67 42.67 42.67s42.67-19.1 42.67-42.67S592 288 592 288s-42.67 61.77-42.67 85.33z"
  ]
};
export const faOilTemp = {
  prefix: "far",
  iconName: "oil-temp",
  icon: [
    640,
    512,
    [],
    "f614",
    "M16 400h16c38.62 0 72.72-12.19 96-31.84 23.21 19.6 57.18 31.74 95.66 31.82-14.61-14.67-25.34-32.9-32.07-52.98-10.15-3.33-18.29-7.92-23.68-12.89-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C77.8 343.58 58.04 352 32 352H16c-8.84 0-16 7.16-16 16v16c0 8.83 7.16 16 16 16zm608-48h-16c-26.04 0-45.8-8.42-56.09-17.9-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1-5.39 4.97-13.53 9.57-23.68 12.89-6.73 20.08-17.46 38.31-32.07 52.98 38.48-.07 72.45-12.22 95.66-31.82 23.28 19.66 57.38 31.84 96 31.84h16c8.84 0 16-7.16 16-16v-16C640 359.16 632.84 352 624 352zm0 112h-16c-26.04 0-45.8-8.42-56.09-17.9-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C461.8 455.58 442.04 464 416 464s-45.8-8.42-56.09-17.9a60.051 60.051 0 0 0-12.49-8.85c-8.86 1.81-18.03 2.77-27.42 2.77s-18.57-.95-27.42-2.77c-4.46 2.39-8.68 5.34-12.49 8.85C269.8 455.58 250.04 464 224 464s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C77.8 455.58 58.04 464 32 464H16c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h16c38.62 0 72.72-12.19 96-31.84 23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84h16c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16zm-304-63.99c52.94 0 96-43.06 96-96 0-44.6-30.71-81.86-72-92.59V144h56c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16h-56V48h56c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16h-88c-8.84 0-16 7.16-16 16v195.41c-41.29 10.73-72 47.99-72 92.59 0 52.95 43.06 96.01 96 96.01zm0-144c26.47 0 48 21.53 48 48s-21.53 48-48 48-48-21.53-48-48 21.53-48 48-48z"
  ]
};
export const faOm = {
  prefix: "far",
  iconName: "om",
  icon: [
    512,
    512,
    [],
    "f679",
    "M420.11 200c-24.19 0-47.88 9.81-64.98 26.91l-24.25 24.25c-8.16 8.16-19.47 12.84-31.04 12.84h-65.29c14.12-21.81 20.79-48.87 14.9-77.74-8.48-41.62-43.08-74.54-85.07-80.97-33.07-5.06-64.78 5.06-87.8 26.73-7.05 6.64-5.93 18.23 1.81 24.05l13.15 9.87c6.08 4.56 14.34 3.98 20.16-.91 12.34-10.38 28.72-15.03 45.68-12.21 21.57 3.58 39.67 20.39 44.69 41.67 8.66 36.71-19.12 69.53-54.42 69.53l-39.64.17c-8.97 0-14.81 9.44-10.79 17.46l12.07 24.13c1.9 3.79 5.7 6.07 9.88 6.41l36.77-.17c41.91 0 76.01 34.09 76.01 76s-34.1 76-76.01 76c-82.77 0-104.76-20.73-142.62-76.81C9.24 381.17.01 384.34 0 391.39-.05 421.11 20.44 512 155.94 512c68.39 0 124.02-55.62 124.02-124 0-28.77-10.25-54.94-26.75-76h46.63c24.19 0 47.88-9.81 64.98-26.91l24.25-24.25c8.16-8.16 19.47-12.84 31.04-12.84 24.19 0 43.88 19.69 43.88 43.88V400c0 17.64-14.35 32-32.01 32-26.49 0-48.68-5.11-69.37-29.82-3.58-4.27-10.65-1.85-10.65 3.66v27.57c0 13.8 9.78 46.6 80.01 46.6 44.13 0 80.01-32 80.01-80V291.88C512 241.22 470.77 200 420.11 200zM360.59 60.94c4.08 4.07 10.68 4.07 14.76 0l21.57-21.56a10.43 10.43 0 0 0 0-14.76L375.35 3.06a10.43 10.43 0 0 0-14.76 0l-21.57 21.56a10.43 10.43 0 0 0 0 14.76l21.57 21.56zm16.16 89.79c76.24 0 96.12-19.92 100.4-26.03 1.89-2.69 2.9-5.89 2.9-9.18V80c0-12.7-14.83-21.01-25.7-12.73-25.67 19.56-53.62 29.47-83.07 29.47-50.84 0-89.09-29.11-89.47-29.4-13.99-10.82-32.97 6.07-23.28 21.26 1.6 2.54 40.51 62.13 118.22 62.13z"
  ]
};
export const faOmega = {
  prefix: "far",
  iconName: "omega",
  icon: [
    447,
    512,
    [],
    "f67a",
    "M360.62 432c63.3-49.55 99.85-131.8 81.75-222.07-17.42-86.85-87.35-156.72-174.13-173.58C125.19 8.56 0 117.63 0 256c0 71.72 34.05 135.04 86.38 176H15.96C7.15 432 0 439.16 0 448v16c0 8.84 7.15 16 15.96 16h127.71c8.82 0 15.96-7.16 15.96-16v-22.99c0-11.82-5.98-23.28-16.45-28.7-66.69-34.53-108.68-110.48-91.4-193.8 13.81-66.57 67.39-120.48 133.77-134.49C298.88 60.09 399.11 146.53 399.11 256c0 68.22-38.99 127.37-95.76 156.54-10.16 5.22-15.99 16.28-15.99 27.72V464c0 8.84 7.15 16 15.96 16h127.71c8.82 0 15.96-7.16 15.96-16v-16c0-8.84-7.15-16-15.96-16h-70.41z"
  ]
};
export const faOrnament = {
  prefix: "far",
  iconName: "ornament",
  icon: [
    384,
    512,
    [],
    "f7b8",
    "M288 153.9V112c0-8.8-7.2-16-16-16h-24.9c5.5-9.4 8.9-20.3 8.9-32 0-35.3-28.7-64-64-64s-64 28.7-64 64c0 11.7 3.4 22.6 8.9 32H112c-8.8 0-16 7.2-16 16v41.9C38.7 187.1 0 249 0 320c0 106 86 192 192 192s192-86 192-192c0-71-38.7-132.9-96-166.1zM192 48c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16 7.2-16 16-16zm0 128c42.4 0 80.2 18.8 106.5 48h-213c26.3-29.2 64.1-48 106.5-48zm144 144c0 16.9-3.5 32.9-8.8 48H56.8c-5.4-15.1-8.8-31.1-8.8-48s3.5-32.9 8.8-48h270.3c5.4 15.1 8.9 31.1 8.9 48zM192 464c-42.4 0-80.2-18.8-106.5-48h213.1c-26.4 29.2-64.2 48-106.6 48z"
  ]
};
export const faOtter = {
  prefix: "far",
  iconName: "otter",
  icon: [
    640,
    512,
    [],
    "f700",
    "M496 72c-8.84 0-16 7.16-16 16s7.17 16 16 16c8.84 0 16-7.16 16-16s-7.16-16-16-16zm79.96-40h-9.47l-8.63-8.61C542.74 8.31 522.65 0 501.27 0h-20.54c-13.89 0-27.62 3.63-39.68 10.51L291.09 96h-18.71C157.48 96 64 189.31 64 304l.08 64.8C28.15 372.81 0 403.01 0 440c0 39.7 32.31 72 72 72h160c13.25 0 24-10.75 24-24s-10.75-24-24-24H72c-13.22 0-24-10.77-24-24s10.78-24 24-24h232.46c26.51 0 48-21.49 48-48 0-19.45-6.98-37.29-18.57-51.17l13.94-7.39 40.13 80.07A48 48 0 0 0 430.87 416H529c26.51 0 48-21.49 48-48 0-44.11-35.92-80-80.08-80h-16.59l-19.35-38.6 31.12-16.51c10.96-5.82 23.32-8.89 35.75-8.89C589.69 224 640 173.76 640 112V96c0-35.29-28.73-64-64.04-64zm-48.11 144c-20.31 0-40.31 4.97-58.24 14.49l-3.68 1.95 16.7-21.71c9-11.73 23.22-18.73 38.03-18.73h56.9c-11.76 14.52-29.54 24-49.71 24zM592 112c0 2.74-.47 5.35-.81 8h-70.53c-24.69 0-48.38 11.67-63.41 31.23l-59.32 75.78 1.01.96-1.89 1L450.7 336h46.22c17.7 0 32.08 14.36 32.08 32h-98.13l-62.14-123.99L195.33 336h77.05c17.7 0 32.08 14.36 32.08 32H112v-64c0-88.37 71.81-160 160.38-160h31.43l161.01-91.79A32.16 32.16 0 0 1 480.73 48h20.54c8.57 0 16.63 3.33 22.68 9.37l13.29 13.26 9.4 9.38h29.32c8.86 0 16.04 7.16 16.04 16V112z"
  ]
};
export const faOutdent = {
  prefix: "far",
  iconName: "outdent",
  icon: [
    448,
    512,
    [],
    "f03b",
    "M100.69 363.29c10 10 27.31 2.93 27.31-11.31V160c0-14.32-17.33-21.31-27.31-11.31l-96 96a16 16 0 0 0 0 22.62zM432 424H16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm3.17-128H204.83A12.82 12.82 0 0 0 192 308.83v22.34A12.82 12.82 0 0 0 204.83 344h230.34A12.82 12.82 0 0 0 448 331.17v-22.34A12.82 12.82 0 0 0 435.17 296zM432 40H16A16 16 0 0 0 0 56v16a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V56a16 16 0 0 0-16-16zm3.17 128H204.83A12.82 12.82 0 0 0 192 180.83v22.34A12.82 12.82 0 0 0 204.83 216h230.34A12.82 12.82 0 0 0 448 203.17v-22.34A12.82 12.82 0 0 0 435.17 168z"
  ]
};
export const faOutlet = {
  prefix: "far",
  iconName: "outlet",
  icon: [
    512,
    512,
    [],
    "e01c",
    "M448,0H64A64,64,0,0,0,0,64V448a64,64,0,0,0,64,64H448a64,64,0,0,0,64-64V64A64,64,0,0,0,448,0Zm16,448a16,16,0,0,1-16,16H64a16,16,0,0,1-16-16V64A16,16,0,0,1,64,48H448a16,16,0,0,1,16,16ZM353.85,96H158.15a22.86,22.86,0,0,0-16.41,6.7C103.71,141.71,80,195.9,80,256s23.71,114.28,61.74,153.29A22.87,22.87,0,0,0,158.15,416h195.7a22.87,22.87,0,0,0,16.41-6.71c38-39,61.74-93.19,61.74-153.29s-23.71-114.29-61.74-153.3A22.86,22.86,0,0,0,353.85,96ZM208,272a16,16,0,0,1-16,16H176a16,16,0,0,1-16-16V192a16,16,0,0,1,16-16h16a16,16,0,0,1,16,16Zm80,80H224V336a32,32,0,0,1,64,0Zm64-80a16,16,0,0,1-16,16H320a16,16,0,0,1-16-16V192a16,16,0,0,1,16-16h16a16,16,0,0,1,16,16Z"
  ]
};
export const faOven = {
  prefix: "far",
  iconName: "oven",
  icon: [
    448,
    512,
    [],
    "e01d",
    "M96,432H352a16,16,0,0,0,16-16V256a16,16,0,0,0-16-16H96a16,16,0,0,0-16,16V416A16,16,0,0,0,96,432Zm32-144H320v32H128ZM104,80a24,24,0,1,0,24,24A24,24,0,0,0,104,80Zm240,0a24,24,0,1,0,24,24A24,24,0,0,0,344,80ZM184,80a24,24,0,1,0,24,24A24,24,0,0,0,184,80ZM384,0H64A64,64,0,0,0,0,64V480a32,32,0,0,0,32,32H416a32,32,0,0,0,32-32V64A64,64,0,0,0,384,0Zm16,464H48V208H400Zm0-304H48V64A16,16,0,0,1,64,48H384a16,16,0,0,1,16,16ZM264,80a24,24,0,1,0,24,24A24,24,0,0,0,264,80Z"
  ]
};
export const faOverline = {
  prefix: "far",
  iconName: "overline",
  icon: [
    448,
    512,
    [],
    "f876",
    "M432 0H16A16 16 0 0 0 0 16v16a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V16a16 16 0 0 0-16-16zM224 96A176 176 0 0 0 48 272v64a176 176 0 0 0 352 0v-64A176 176 0 0 0 224 96zm112 240a112 112 0 0 1-224 0v-64a112 112 0 0 1 224 0z"
  ]
};
export const faPageBreak = {
  prefix: "far",
  iconName: "page-break",
  icon: [
    576,
    512,
    [],
    "f877",
    "M144 48.06L304 48v112a16 16 0 0 0 16 16h112v40h48v-84a48.09 48.09 0 0 0-14.09-34L382 14.07A48.09 48.09 0 0 0 348 0L128 .08a32 32 0 0 0-32 32V216h48zM352 52l76.07 76H352zM240 264a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm192 200H144V360H96v120a32 32 0 0 0 32 32h320a32 32 0 0 0 32-32V360h-48zm128-200H432a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm-400 32v-16a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16z"
  ]
};
export const faPager = {
  prefix: "far",
  iconName: "pager",
  icon: [
    512,
    512,
    [],
    "f815",
    "M304 304h-80v48h80a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zM96 320v16a16 16 0 0 0 16 16h80v-48h-80a16 16 0 0 0-16 16zm296-160H120a24 24 0 0 0-24 24v48a24 24 0 0 0 24 24h272a24 24 0 0 0 24-24v-48a24 24 0 0 0-24-24zm56-96H64a64 64 0 0 0-64 64v256a64 64 0 0 0 64 64h384a64 64 0 0 0 64-64V128a64 64 0 0 0-64-64zm16 320a16 16 0 0 1-16 16H64a16 16 0 0 1-16-16V128a16 16 0 0 1 16-16h384a16 16 0 0 1 16 16z"
  ]
};
export const faPaintBrush = {
  prefix: "far",
  iconName: "paint-brush",
  icon: [
    512,
    512,
    [],
    "f1fc",
    "M455.59 0c-15.81 0-30.62 6.99-41.93 17.15C195.73 211.82 169.77 216.5 179.98 281.99c-41.52 4.96-78.59 24.05-100.32 81.32-2.68 7.08-9.12 11.38-16.64 11.38-12.67 0-51.85-31.56-63.02-39.19C0 429.45 43.26 512 146 512c117.18 0 152.72-87.75 145.06-145.89 56.9-7.01 97.15-62.51 206.45-266.49C505.2 84.65 512 68.48 512 51.66 512 21.52 484.89 0 455.59 0zM222.08 432.89c-16.24 18.52-41.84 27.91-76.08 27.91-35.97 0-58.6-14.93-72.68-35.65 24.56-3.6 45.23-19.96 54.21-43.67 13.79-36.33 32.61-45.55 58.52-48.65l16.43-1.96 36.06 28.51 1.77 13.41c2.07 15.77-1.46 40.97-18.23 60.1zm62.72-117.6l-16.87 2.08L233 289.75l-2.44-15.64C224.3 233.92 444.24 44.8 456.12 54.57c12.12 9.98-121.27 254.56-171.32 260.72z"
  ]
};
export const faPaintBrushAlt = {
  prefix: "far",
  iconName: "paint-brush-alt",
  icon: [
    512,
    512,
    [],
    "f5a9",
    "M489.17 144.05C547.44 80.02 483.28 0 418.52 0c-23.39 0-46.87 10.44-64.68 35.85L187.9 284.01c-45.13 2.9-86.1 20.09-109.34 81.34-2.65 6.99-9 11.22-16.41 11.22-12.49 0-51.14-31.13-62.15-38.65C0 430.58 42.67 512 144 512c141.21 0 145.89-117.04 142.91-145.49l.02-.02 202.24-222.44zM393.15 63.4c9.68-13.8 19.11-15.4 25.37-15.4 16.4 0 35.57 13.17 42.72 29.35 5.36 12.13 3.03 22.74-7.6 34.41L266.16 317.98l-27.76-23.13L393.15 63.4zM144 464c-38.6 0-62.03-16.87-76.06-39.67 25.07-2.14 46.49-18.14 55.51-41.95 10.03-26.44 18.24-47.29 83.23-51.48l30.94 25.79C239.85 376.62 251.75 464 144 464z"
  ]
};
export const faPaintRoller = {
  prefix: "far",
  iconName: "paint-roller",
  icon: [
    512,
    512,
    [],
    "f5aa",
    "M456 72h-40V48c0-26.51-21.49-48-48-48H48C21.49 0 0 21.49 0 48v96c0 26.51 21.49 48 48 48h320c26.51 0 48-21.49 48-48v-24h40c4.41 0 8 3.59 8 8v96c0 4.41-3.59 8-8 8H256c-30.88 0-56 25.12-56 56v32h-8c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32h-8v-32c0-4.41 3.59-8 8-8h200c30.88 0 56-25.12 56-56v-96c0-30.88-25.12-56-56-56zm-88 72H48V48h320v96zM240 464h-32v-96h32v96z"
  ]
};
export const faPalette = {
  prefix: "far",
  iconName: "palette",
  icon: [
    512,
    512,
    [],
    "f53f",
    "M128 224c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.4-32-32-32zM418.6 58.1C359.2 9.3 281.3-10 204.6 5 104.9 24.4 24.7 104.2 5.1 203.7c-16.7 84.2 8.1 168.3 67.8 230.6 47.3 49.4 109.7 77.8 167.9 77.8 8.8 0 17.5-.6 26.1-2 24.2-3.7 44.6-18.7 56.1-41.1 12.3-24 12.3-52.7.2-76.6-6.1-12-5.5-26.2 1.8-38 7-11.8 18.7-18.4 32-18.4h72.2c46.4 0 82.8-35.7 82.8-81.3-.2-76.4-34.3-148.1-93.4-196.6zM429.2 288H357c-29.9 0-57.2 15.4-73 41.3-16 26.1-17.3 57.8-3.6 84.9 5.1 10.1 5.1 22.7-.2 32.9-2.6 5-8.7 13.7-20.6 15.6-49.3 7.7-108.9-16.6-152-61.6-48.8-50.9-69-119.4-55.4-188 15.9-80.6 80.8-145.3 161.6-161 62.6-12.3 126.1 3.5 174.3 43.1 48.1 39.5 75.7 97.6 75.9 159.6 0 18.6-15.3 33.2-34.8 33.2zM160 128c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.4-32-32-32zm96-32.1c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32c0-17.6-14.3-32-32-32zm96 32.1c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"
  ]
};
export const faPallet = {
  prefix: "far",
  iconName: "pallet",
  icon: [
    640,
    512,
    [],
    "f482",
    "M144 288h352c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16H144c-8.8 0-16 7.2-16 16v256c0 8.8 7.2 16 16 16zm32-240h80v80l64-32 64 32V48h80v192H176V48zm448 320c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16H16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h48v96H16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16h-48v-96h48zm-448 96h-64v-96h64v96zm240 0H224v-96h192v96zm112 0h-64v-96h64v96z"
  ]
};
export const faPalletAlt = {
  prefix: "far",
  iconName: "pallet-alt",
  icon: [
    640,
    512,
    [],
    "f483",
    "M112 288h416c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H384V16c0-8.8-7.2-16-16-16H112c-8.8 0-16 7.2-16 16v256c0 8.8 7.2 16 16 16zm272-176h112v128H384V112zM144 48h192v192H144V48zm480 320c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16H16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h48v96H16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16h-48v-96h48zm-448 96h-64v-96h64v96zm240 0H224v-96h192v96zm112 0h-64v-96h64v96z"
  ]
};
export const faPaperPlane = {
  prefix: "far",
  iconName: "paper-plane",
  icon: [
    512,
    512,
    [],
    "f1d8",
    "M440 6.5L24 246.4c-34.4 19.9-31.1 70.8 5.7 85.9L144 379.6V464c0 46.4 59.2 65.5 86.6 28.6l43.8-59.1 111.9 46.2c5.9 2.4 12.1 3.6 18.3 3.6 8.2 0 16.3-2.1 23.6-6.2 12.8-7.2 21.6-20 23.9-34.5l59.4-387.2c6.1-40.1-36.9-68.8-71.5-48.9zM192 464v-64.6l36.6 15.1L192 464zm212.6-28.7l-153.8-63.5L391 169.5c10.7-15.5-9.5-33.5-23.7-21.2L155.8 332.6 48 288 464 48l-59.4 387.3z"
  ]
};
export const faPaperclip = {
  prefix: "far",
  iconName: "paperclip",
  icon: [
    512,
    512,
    [],
    "f0c6",
    "M67.508 468.467c-58.005-58.013-58.016-151.92 0-209.943l225.011-225.04c44.643-44.645 117.279-44.645 161.92 0 44.743 44.749 44.753 117.186 0 161.944l-189.465 189.49c-31.41 31.413-82.518 31.412-113.926.001-31.479-31.482-31.49-82.453 0-113.944L311.51 110.491c4.687-4.687 12.286-4.687 16.972 0l16.967 16.971c4.685 4.686 4.685 12.283 0 16.969L184.983 304.917c-12.724 12.724-12.73 33.328 0 46.058 12.696 12.697 33.356 12.699 46.054-.001l189.465-189.489c25.987-25.989 25.994-68.06.001-94.056-25.931-25.934-68.119-25.932-94.049 0l-225.01 225.039c-39.249 39.252-39.258 102.795-.001 142.057 39.285 39.29 102.885 39.287 142.162-.028A739446.174 739446.174 0 0 1 439.497 238.49c4.686-4.687 12.282-4.684 16.969.004l16.967 16.971c4.685 4.686 4.689 12.279.004 16.965a755654.128 755654.128 0 0 0-195.881 195.996c-58.034 58.092-152.004 58.093-210.048.041z"
  ]
};
export const faParachuteBox = {
  prefix: "far",
  iconName: "parachute-box",
  icon: [
    512,
    512,
    [],
    "f4cd",
    "M511.9 175c-9.1-75.6-78.4-132.4-158.3-158.7 36.3 39.2 62.2 100.1 62.4 174.8L314.6 320H280V192h104C384 76.8 315.1 0 256 0S128 76.8 128 192h104v128h-34.6L96 191.1c.2-74.7 26.1-135.6 62.4-174.8C78.5 42.7 9.2 99.5.1 175c-1.1 9.1 6.8 17 16 17h19.5l124.7 158.5c0 .5-.3 1-.3 1.5v128c0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32V352c0-.5-.3-1-.3-1.5L476.4 192h19.5c9.2 0 17.1-7.8 16-17zM304 456c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8v-80c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v80z"
  ]
};
export const faParagraph = {
  prefix: "far",
  iconName: "paragraph",
  icon: [
    448,
    512,
    [],
    "f1dd",
    "M415 32H191a160 160 0 0 0 0 320h48v112a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16V80h48v384a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16V80h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM239 304h-48a112 112 0 0 1 0-224h48z"
  ]
};
export const faParagraphRtl = {
  prefix: "far",
  iconName: "paragraph-rtl",
  icon: [
    384,
    512,
    [],
    "f878",
    "M368 392H112v-56a16 16 0 0 0-16.12-16 15.65 15.65 0 0 0-11.19 4.72l-80 80a16 16 0 0 0 0 22.62l80 80A16.12 16.12 0 0 0 96.17 512c8 0 15.83-5.69 15.83-16v-56h256a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zM144 224h32v80a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16V48h32v256a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16V48h32a16 16 0 0 0 16-16V16a16 16 0 0 0-16-16H144C80 0 32 48 32 112s48 112 112 112zm0-176h32v128h-32c-37.68 0-64-26.32-64-64s26.32-64 64-64z"
  ]
};
export const faParking = {
  prefix: "far",
  iconName: "parking",
  icon: [
    448,
    512,
    [],
    "f540",
    "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm0 394c0 3.3-2.7 6-6 6H54c-3.3 0-6-2.7-6-6V86c0-3.3 2.7-6 6-6h340c3.3 0 6 2.7 6 6v340zM232 135.9h-80c-8.8 0-16 7.2-16 16v216c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-56h48c48.5 0 88-39.5 88-88 .1-48.5-39.4-88-88-88zm0 128.1h-48v-80h48c22.1 0 40 17.9 40 40s-17.9 40-40 40z"
  ]
};
export const faParkingCircle = {
  prefix: "far",
  iconName: "parking-circle",
  icon: [
    496,
    512,
    [],
    "f615",
    "M256.09 135.91h-80c-8.84 0-16 7.16-16 16v216c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-56h48c48.53 0 88-39.47 88-88s-39.47-88-88-88zm0 128h-48v-80h48c22.06 0 40 17.94 40 40s-17.94 40-40 40zM248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 448c-110.28 0-200-89.72-200-200S137.72 56 248 56s200 89.72 200 200-89.72 200-200 200z"
  ]
};
export const faParkingCircleSlash = {
  prefix: "far",
  iconName: "parking-circle-slash",
  icon: [
    496,
    512,
    [],
    "f616",
    "M160.09 367.91c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-51.73l-48-37.53v89.26zM248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 448c-110.28 0-200-89.72-200-200 0-37.79 10.73-73.04 29.02-103.21l312.54 244.35C353.33 433.47 303.25 456 248 456zm-39.91-261.67v-10.42h48c22.06 0 40 17.94 40 40 0 11.56-5.08 21.79-12.95 29.1l-75.05-58.68zm210.9 164.88l-97.96-76.59c14.19-15.56 23.06-36.01 23.06-58.71 0-48.53-39.47-88-88-88h-80c-8.84 0-16 7.16-16 16v4.9l-53.65-41.94C142.67 78.53 192.75 56 248 56c110.28 0 200 89.72 200 200 0 37.79-10.73 73.04-29.01 103.21z"
  ]
};
export const faParkingSlash = {
  prefix: "far",
  iconName: "parking-slash",
  icon: [
    640,
    512,
    [],
    "f617",
    "M633.99 471.02L36 3.51C29.1-2.01 19.03-.9 13.51 6l-10 12.49C-2.02 25.39-.9 35.46 6 40.98l598 467.51c6.9 5.52 16.96 4.4 22.49-2.49l10-12.49c5.52-6.9 4.41-16.97-2.5-22.49zM283.31 135.93l131.27 102.63c.8-4.78 1.48-9.61 1.48-14.61 0-48.54-39.48-88.02-88.02-88.02h-44.73zM490 80c3.3 0 6 2.7 6 6v216.21l48 37.53V80c0-26.5-21.5-48-48-48H150.37l61.4 48H490zM150 432c-3.3 0-6-2.7-6-6V209.79l-48-37.53V432c0 26.5 21.5 48 48 48h345.63l-61.4-48H150zm114.03-48.02c8.84 0 16-7.17 16-16v-51.83l-48.01-37.53v89.37c0 8.84 7.16 16 16 16h16.01z"
  ]
};
export const faPassport = {
  prefix: "far",
  iconName: "passport",
  icon: [
    448,
    512,
    [],
    "f5ab",
    "M416 0H64C28.65 0 0 28.65 0 64v384c0 35.35 28.65 64 64 64h352c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32zm-16 464H64c-8.82 0-16-7.18-16-16V64c0-8.82 7.18-16 16-16h336v416zm-288-48h224c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-8.8 0-16 7.2-16 16s7.2 16 16 16zm112-88c66.28 0 120-53.73 120-120 0-66.28-53.72-120-120-120-66.27 0-120 53.72-120 120 0 66.27 53.73 120 120 120zm86.38-136h-34.59c-1.39-23.68-5.75-44.99-12.27-62.19 24.05 12.21 41.81 34.87 46.86 62.19zm-34.59 32h34.59c-5.05 27.32-22.82 49.98-46.86 62.19 6.53-17.21 10.88-38.51 12.27-62.19zM224 122.24c6.91 8.37 17.51 32.39 19.96 69.76h-39.93c2.46-37.37 13.06-61.39 19.97-69.76zM243.96 224c-2.45 37.37-13.05 61.39-19.96 69.76-6.91-8.37-17.51-32.39-19.96-69.76h39.92zm-59.49-94.19c-6.52 17.2-10.87 38.51-12.27 62.19h-34.59c5.06-27.32 22.82-49.98 46.86-62.19zM172.21 224c1.4 23.68 5.75 44.98 12.27 62.19-24.04-12.21-41.8-34.87-46.86-62.19h34.59z"
  ]
};
export const faPastafarianism = {
  prefix: "far",
  iconName: "pastafarianism",
  icon: [
    640,
    512,
    [],
    "f67b",
    "M624.52 347.67c-32.62-12.47-57.34 4.27-75.37 16.45-17.09 11.53-23.19 14.42-31.4 11.36-8.09-3.09-10.81-9.38-15.87-29.38-3.33-13.15-7.44-29.31-17.96-42.64 2.25-2.92 4.43-5.79 6.38-8.58 10.17 9.56 23.41 17.11 41.7 17.11 33.97 0 50.87-25.78 62.06-42.83 10.59-16.14 15-21.17 21.94-21.17 13.25 0 24-10.75 24-24s-10.75-24-24-24c-33.97 0-50.87 25.78-62.06 42.83-10.59 16.14-15 21.17-21.94 21.17-17.83 0-39.62-66.72-103.93-106.46l15.02-30.03c1.65.13 3.23.5 4.92.5 35.35 0 64-28.65 64-64s-28.65-64-64-64c-35.34 0-64 28.65-64 64 0 16.19 6.21 30.81 16.12 42.08l-15.85 31.71C365.31 131.81 344.11 128 320 128s-45.31 3.81-64.27 9.79l-15.85-31.71C249.79 94.8 256 80.19 256 64c0-35.35-28.65-64-64-64-35.34 0-64 28.65-64 64s28.65 64 64 64c1.68 0 3.26-.37 4.92-.5l15.02 30.03C148.35 196.84 125.44 264 108.01 264c-6.94 0-11.34-5.03-21.94-21.17C74.89 225.78 57.98 200 24.01 200c-13.25 0-24 10.75-24 24s10.75 24 24 24c6.94 0 11.34 5.03 21.94 21.17C57.14 286.22 74.04 312 108.01 312c18.29 0 31.53-7.54 41.7-17.11 1.95 2.79 4.14 5.66 6.38 8.58-10.52 13.33-14.63 29.49-17.96 42.64-5.06 20-7.78 26.28-15.87 29.38-8.19 3.06-14.34.17-31.4-11.36-18-12.19-42.72-28.91-75.37-16.45-12.41 4.72-18.62 18.58-13.91 30.97 4.75 12.39 18.66 18.64 30.97 13.88 8.22-3.09 14.34-.19 31.4 11.36 13.53 9.16 30.84 20.86 52.43 20.84 7.16 0 14.81-1.28 22.94-4.39 32.65-12.44 40-41.33 45.34-62.44 2.21-8.72 3.99-14.49 5.95-18.86 16.62 13.61 36.94 25.88 61.63 34.16-9.95 37-32.17 90.81-60.23 90.81-13.25 0-24 10.75-24 24s10.75 24 24 24c66.74 0 97.04-88.63 107.42-129.14 6.69.6 13.42 1.14 20.58 1.14s13.89-.54 20.58-1.14C350.95 423.37 381.25 512 447.99 512c13.25 0 24-10.75 24-24s-10.75-24-24-24c-27.93 0-50.19-53.81-60.2-90.82 24.67-8.29 44.98-20.55 61.6-34.15 1.95 4.38 3.74 10.14 5.95 18.86 5.34 21.11 12.69 50 45.34 62.44 8.12 3.11 15.78 4.39 22.94 4.39 21.59 0 38.9-11.69 52.43-20.84 17.06-11.55 23.19-14.45 31.4-11.36 12.37 4.73 26.22-1.48 30.97-13.88 4.72-12.39-1.5-26.25-13.9-30.97zM447.99 48c8.82 0 16 7.18 16 16s-7.18 16-16 16-16-7.18-16-16 7.18-16 16-16zM192.01 80c-8.82 0-16-7.18-16-16s7.18-16 16-16 16 7.18 16 16-7.18 16-16 16zM320 336c-80.59 0-122.1-52.17-138.49-79.97C197.99 228.05 239.49 176 320 176c80.59 0 122.1 52.17 138.49 79.97C442.01 283.95 400.51 336 320 336z"
  ]
};
export const faPaste = {
  prefix: "far",
  iconName: "paste",
  icon: [
    448,
    512,
    [],
    "f0ea",
    "M433.941 193.941l-51.882-51.882A48 48 0 0 0 348.118 128H320V80c0-26.51-21.49-48-48-48h-61.414C201.582 13.098 182.294 0 160 0s-41.582 13.098-50.586 32H48C21.49 32 0 53.49 0 80v288c0 26.51 21.49 48 48 48h80v48c0 26.51 21.49 48 48 48h224c26.51 0 48-21.49 48-48V227.882a48 48 0 0 0-14.059-33.941zm-84.066-16.184l48.368 48.368a6 6 0 0 1 1.757 4.243V240h-64v-64h9.632a6 6 0 0 1 4.243 1.757zM160 38c9.941 0 18 8.059 18 18s-8.059 18-18 18-18-8.059-18-18 8.059-18 18-18zm-32 138v192H54a6 6 0 0 1-6-6V86a6 6 0 0 1 6-6h55.414c9.004 18.902 28.292 32 50.586 32s41.582-13.098 50.586-32H266a6 6 0 0 1 6 6v42h-96c-26.51 0-48 21.49-48 48zm266 288H182a6 6 0 0 1-6-6V182a6 6 0 0 1 6-6h106v88c0 13.255 10.745 24 24 24h88v170a6 6 0 0 1-6 6z"
  ]
};
export const faPause = {
  prefix: "far",
  iconName: "pause",
  icon: [
    448,
    512,
    [],
    "f04c",
    "M192 79v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V79c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48zm-48 346V85c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h84c3.3 0 6-2.7 6-6zM448 79v352c0 26.5-21.5 48-48 48h-96c-26.5 0-48-21.5-48-48V79c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48zm-48 346V85c0-3.3-2.7-6-6-6h-84c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h84c3.3 0 6-2.7 6-6z"
  ]
};
export const faPauseCircle = {
  prefix: "far",
  iconName: "pause-circle",
  icon: [
    512,
    512,
    [],
    "f28b",
    "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm96-280v160c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16zm-112 0v160c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16z"
  ]
};
export const faPaw = {
  prefix: "far",
  iconName: "paw",
  icon: [
    512,
    512,
    [],
    "f1b0",
    "M74.84 286.73c29.12-6.96 44.29-40.69 33.88-75.34C99.6 181 73.83 160 47.98 160c-3.62 0-7.24.41-10.81 1.27-29.12 6.96-44.29 40.69-33.89 75.34C12.41 267 38.18 288 64.02 288c3.62 0 7.24-.41 10.82-1.27zM41.59 225.1c-2.88-9.59-1.38-17.37.97-21.47 1.69-2.93 3.3-3.32 3.91-3.46.48-.11.97-.17 1.51-.17 6.52 0 17.95 7.96 22.43 22.89 2.88 9.59 1.38 17.38-.97 21.47-1.69 2.93-3.3 3.32-5.42 3.63-6.52.01-17.94-7.95-22.43-22.89zm276.97-34.49c3.55.93 7.15 1.38 10.76 1.38 27.84 0 56.22-26.82 66.7-65.25 11.84-43.42-3.64-85.21-34.58-93.36a41.92 41.92 0 0 0-10.76-1.39c-27.84 0-56.22 26.82-66.7 65.26-11.84 43.42 3.64 85.22 34.58 93.36zm4.01-82.83C328.98 84.29 344.28 72 350.68 72l.58.07c.88.23 2.46 1.67 4.01 4.35 4.08 7.06 7.09 21.73 2.16 39.8-6.39 23.43-21.62 35.71-28.63 35.71h-.06c-.88-.23-2.46-1.66-4.01-4.35-4.08-7.06-7.09-21.72-2.16-39.8zm152.26 53.49c-3.57-.86-7.2-1.27-10.81-1.27-25.85 0-51.62 21-60.74 51.39-10.4 34.65 4.77 68.38 33.89 75.34 3.58.86 7.2 1.27 10.81 1.27 25.85 0 51.62-21 60.74-51.39 10.4-34.65-4.77-68.38-33.89-75.34zm-4.42 63.83c-4.44 14.78-15.67 22.73-23.69 22.73h-.25c-.61-.14-2.22-.53-3.91-3.46-2.36-4.1-3.85-11.89-.97-21.47 4.49-14.94 15.91-22.9 22.43-22.9l1.51.17c.61.14 2.22.53 3.91 3.46 2.36 4.1 3.85 11.89.97 21.47zM182.68 192c3.61 0 7.21-.45 10.76-1.38 30.94-8.14 46.42-49.94 34.58-93.36C217.54 58.82 189.16 32 161.32 32c-3.61 0-7.21.45-10.76 1.39-30.94 8.14-46.42 49.94-34.58 93.36 10.48 38.43 38.87 65.25 66.7 65.25zM156.73 76.42c1.55-2.68 3.13-4.12 4.01-4.35.12-.03.29-.07.58-.07 6.4 0 21.7 12.29 28.11 35.78 4.93 18.08 1.92 32.74-2.16 39.8-1.55 2.68-3.13 4.12-4.59 4.41-6.4 0-21.71-12.29-28.11-35.78-4.93-18.07-1.92-32.73 2.16-39.79zM256 224c-79.41 0-192 122.76-192 200.25 0 34.9 26.81 55.75 71.74 55.75 48.84 0 81.09-25.08 120.26-25.08 39.51 0 71.85 25.08 120.26 25.08 44.93 0 71.74-20.85 71.74-55.75C448 346.76 335.41 224 256 224zm143.81 203.07c-.95 1.05-7.7 4.93-23.54 4.93-17.73 0-33.3-5.13-51.34-11.08-19.9-6.56-42.46-14-68.92-14-26.22 0-48.63 7.4-68.4 13.92-18.14 5.99-33.8 11.16-51.86 11.16-15.85 0-22.6-3.89-23.38-4.67-.1-.23-.36-1.23-.36-3.08C112 370.18 204.86 272 256 272s144 98.18 144 152.25c0 1.82-.25 2.82-.19 2.82z"
  ]
};
export const faPawAlt = {
  prefix: "far",
  iconName: "paw-alt",
  icon: [
    448,
    512,
    [],
    "f701",
    "M400 144c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm-256-16c26.51 0 48-21.49 48-48s-21.49-48-48-48-48 21.49-48 48 21.49 48 48 48zm160 0c26.51 0 48-21.49 48-48s-21.49-48-48-48-48 21.49-48 48 21.49 48 48 48zm63.31 172.78c-26.29-14.84-47.14-61.41-67.17-97.83C284.41 174.31 254.21 160 224 160s-60.41 14.31-76.15 42.95c-20.29 36.96-40.12 82.56-67.17 97.83C51.63 317.18 32 348.18 32 383.95c0 53.01 42.98 95.98 96 95.98 1.31.04 2.6.07 3.87.07 48.88 0 68.92-32.06 92.13-32.06S267.25 480 316.13 480c1.27 0 2.56-.02 3.87-.07 53.02 0 96-42.97 96-95.98 0-35.77-19.63-66.77-48.69-83.17zM320 431.93h-.81l-.81.03-2.25.04c-15.7 0-25.28-5.71-38.54-13.63-13.76-8.21-30.89-18.43-53.59-18.43-22.7 0-39.83 10.22-53.59 18.44-13.25 7.91-22.83 13.62-38.54 13.62l-2.24-.04-.81-.03H128c-26.47 0-48-21.52-48-47.98 0-17.32 9.08-32.79 24.29-41.38 34.56-19.52 55.25-58.92 75.25-97.02 3.48-6.62 6.92-13.2 10.38-19.48C199.13 209.3 218.33 208 224 208s24.87 1.3 34.08 18.07c3.27 5.95 6.56 12.17 9.89 18.48 20.47 38.73 41.65 78.78 75.74 98.03 15.21 8.59 24.29 24.06 24.29 41.38 0 26.45-21.53 47.97-48 47.97zM96 192c0-26.51-21.49-48-48-48S0 165.49 0 192s21.49 48 48 48 48-21.49 48-48z"
  ]
};
export const faPawClaws = {
  prefix: "far",
  iconName: "paw-claws",
  icon: [
    512,
    512,
    [],
    "f702",
    "M256 256c-80.75 0-192 108.19-192 186.7 0 42.09 34.06 69.3 86.78 69.3 46.78 0 76.4-20.38 105.22-20.38 28.99 0 58.94 20.38 105.22 20.38 52.72 0 86.78-27.2 86.78-69.3C448 364.19 336.75 256 256 256zm105.22 208c-37.73 0-65.78-20.38-105.22-20.38-39.23 0-67.06 20.38-105.22 20.38-14.47 0-38.78-2.77-38.78-21.3 0-47.77 86.09-138.7 144-138.7s144 90.94 144 138.7c0 18.53-24.31 21.3-38.78 21.3zM493.5 190.37L448 128v66.94c-19.83 6.55-37.51 24.43-44.72 48.46-10.4 34.65 4.77 68.38 33.89 75.34 30.19 7.22 61.56-16.82 71.56-50.13 8.84-29.5-1.54-59.48-15.23-78.24zm-47.1 89.25c-16.45-4.94-.2-53.07 19.22-47.25 16.49 4.98-.13 53.38-19.22 47.25zm-127.85-57.01c40.37 10.63 69.81-35.82 77.46-63.87 8.44-30.94 3.01-61.05-12.01-78.75L320 0v74.96c-15.95 11.26-29.49 30.37-36.02 54.29-11.85 43.42 3.64 85.22 34.57 93.36zm4.01-82.83c15.7-57.62 47.93-39.38 34.84 8.44-15.62 57.31-47.91 39.57-34.84-8.44zM108.73 243.39c-7.21-24.03-24.89-41.91-44.72-48.46V128L18.5 190.37C4.81 209.13-5.57 239.11 3.29 268.61c10 33.3 41.36 57.35 71.56 50.13 29.11-6.97 44.28-40.7 33.88-75.35zM65.6 279.62c-19.09 6.12-35.72-42.28-19.22-47.25 19.42-5.81 35.67 42.32 19.22 47.25zm127.85-57.01c30.94-8.14 46.42-49.94 34.58-93.36-6.53-23.92-20.07-43.04-36.02-54.29V0L128 79.99c-15.02 17.7-20.45 47.82-12.01 78.75 7.65 28.05 37.09 74.5 77.46 63.87zm-4.01-82.83c13.07 48.01-19.22 65.75-34.84 8.44-13.09-47.82 19.15-66.06 34.84-8.44z"
  ]
};
export const faPeace = {
  prefix: "far",
  iconName: "peace",
  icon: [
    496,
    512,
    [],
    "f67c",
    "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm-24 446.42c-44.87-5.4-85.21-25.63-115.91-55.75L224 305.93v148.49zm48-148.49l115.91 92.73c-30.71 30.12-71.04 50.35-115.91 55.75V305.93zM48 256c0-102.14 77.02-186.51 176-198.42v186.88L78.18 361.12C59.17 330.54 48 294.59 48 256zm369.82 105.12L272 244.46V57.58C370.98 69.49 448 153.86 448 256c0 38.59-11.17 74.54-30.18 105.12z"
  ]
};
export const faPegasus = {
  prefix: "far",
  iconName: "pegasus",
  icon: [
    576,
    512,
    [],
    "f703",
    "M464 112c8.84 0 16-7.16 16-16s-7.16-16-16-16-16 7.16-16 16 7.16 16 16 16zm111.95-9.75a47.943 47.943 0 0 0-10.94-30.46L543.28 45.3c16.02-5.4 29.13-18.84 32.56-35.66C576.85 4.68 572.96 0 567.9 0H432c-68.4 0-125.82 47.95-140.42 112h-25.81c-38.88 0-78.63-12.31-104.4-41.44-4.02-4.54-9.17-6.56-14.21-6.56-9.78 0-19.16 7.6-19.16 19.06 0 86.09 59.76 162.72 140.01 183.21 10.11 2.58 19.99-5.19 19.99-15.63v-16.36c0-6.96-4.44-13.34-11.15-15.21-37.34-10.46-68.92-37.67-86.32-73.34 23.38 9.37 48.83 14.27 75.24 14.27H336v-16c0-53.02 42.98-96 96-96h51.33L528 102.28l.05 65.35c0 4.77-3.03 9.01-7.54 10.55l-31.02 10.59c-1.51.52-9.71 2.95-16.48-3.83L448.05 160h-32v80H416c0 26.09-12.68 49.03-32 63.64V464h-48V320l-139.82-31.07-28.73 80.02L191.53 464H150l-21.13-87.86a31.698 31.698 0 0 1 .37-16.18l22.7-76.72C128.54 273.72 112 250.83 112 224c0-14.97 5.17-28.67 13.8-39.51-8.95-14.24-15.65-29.79-20.68-46.07-7.93 6.43-15.28 13.54-21.13 21.98C37.36 162.55 0 200.84 0 248v56c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-56c0-13.22 6.87-24.39 16.78-31.68-.18 2.59-.78 5.05-.78 7.68 0 30.13 11.91 58.09 32.16 78.58l-12.94 43.76a78.948 78.948 0 0 0-1.05 40.85l24.11 100.29c3.46 14.38 16.32 24.52 31.11 24.52h74.7c20.86 0 36.14-19.64 31.02-39.86l-25.53-100.76 9.48-26.41L288 358.5V480c0 17.67 14.33 32 32 32h80c17.67 0 32-14.33 32-32V324.35c19.96-22.47 31.31-51.04 31.97-81.55.05-.93.08-8.43.08-8.43 20.95 6.96 38.31.72 40.94-.17l31.02-10.59c23.96-8.18 40.01-30.7 39.99-56.02l-.05-65.34z"
  ]
};
export const faPen = {
  prefix: "far",
  iconName: "pen",
  icon: [
    512,
    512,
    [],
    "f304",
    "M493.26 56.26l-37.51-37.51C443.25 6.25 426.87 0 410.49 0s-32.76 6.25-45.25 18.74l-74.49 74.49L256 127.98 12.85 371.12.15 485.34C-1.45 499.72 9.88 512 23.95 512c.89 0 1.79-.05 2.69-.15l114.14-12.61L384.02 256l34.74-34.74 74.49-74.49c25-25 25-65.52.01-90.51zM118.75 453.39l-67.58 7.46 7.53-67.69 231.24-231.24 31.02-31.02 60.14 60.14-31.02 31.02-231.33 231.33zm340.56-340.57l-44.28 44.28-60.13-60.14 44.28-44.28c4.08-4.08 8.84-4.69 11.31-4.69s7.24.61 11.31 4.69l37.51 37.51c6.24 6.25 6.24 16.4 0 22.63z"
  ]
};
export const faPenAlt = {
  prefix: "far",
  iconName: "pen-alt",
  icon: [
    512,
    512,
    [],
    "f305",
    "M493.25 56.26l-37.51-37.51C443.25 6.25 426.87 0 410.49 0s-32.76 6.25-45.26 18.74l-67.87 67.88-39.59-39.59c-15.62-15.62-40.95-15.62-56.56 0L82.42 165.81c-6.25 6.25-6.25 16.38 0 22.62l11.31 11.31c6.25 6.25 16.38 6.25 22.62 0L229.49 86.62l33.94 33.94-7.42 7.42L93.95 290.03A327.038 327.038 0 0 0 .17 485.12l-.03.23C-1.45 499.72 9.88 512 23.95 512c.89 0 1.78-.05 2.69-.15a327.077 327.077 0 0 0 195.34-93.8L384.02 256l34.74-34.74 74.49-74.49c25-25 25-65.52 0-90.51zM188.03 384.11c-37.02 37.02-83.99 62.88-134.74 74.6 11.72-50.74 37.59-97.73 74.6-134.74l162.05-162.05 7.42-7.42 60.14 60.14-7.42 7.42-162.05 162.05zm271.28-271.29l-67.88 67.88-48.82-48.83-11.31-11.31 67.87-67.87c4.08-4.08 8.84-4.69 11.31-4.69 2.47 0 7.24.61 11.31 4.69L459.3 90.2c4.08 4.08 4.69 8.84 4.69 11.31s-.6 7.24-4.68 11.31z"
  ]
};
export const faPenFancy = {
  prefix: "far",
  iconName: "pen-fancy",
  icon: [
    512,
    512,
    [],
    "f5ac",
    "M424.86 0c-23.45 0-46.85 9.64-63.71 28.72L169.93 240 84.1 268.62a34.005 34.005 0 0 0-21.5 21.5L0 478l33.99 34 187.79-62.62a33.967 33.967 0 0 0 21.49-21.5L271.88 342l211.19-191.3C544.5 96.38 500.08 0 424.86 0zM199.97 406.05L92.79 441.79l50-50.02c.4.02.74.23 1.14.23 13.25 0 23.99-10.75 23.99-24 0-13.26-10.74-24-23.99-24-13.25 0-23.99 10.74-23.99 24 0 .41.21.74.23 1.14l-50 50.02 35.72-107.22 79.2-26.41 1.81-.61 40.06 40.07-.61 1.81-26.38 79.25zm250.9-290.93l-192 173.92-36-36.02L397.1 60.51C404.23 52.44 414.09 48 424.86 48c20.23 0 39.6 18.13 38.92 40.12-.31 10.32-4.75 19.77-12.91 27z"
  ]
};
export const faPenNib = {
  prefix: "far",
  iconName: "pen-nib",
  icon: [
    512,
    512,
    [],
    "f5ad",
    "M493.87 95.6L416.4 18.13C404.32 6.04 388.48 0 372.64 0c-15.84 0-31.68 6.04-43.76 18.13l-92.45 92.45-99.83 28.21a64.003 64.003 0 0 0-43.31 41.35L0 460l52 52 279.86-93.29a64.003 64.003 0 0 0 41.35-43.31l28.21-99.83 92.45-92.45c24.17-24.17 24.17-63.35 0-87.52zM327.02 362.35c-1.44 5.1-5.31 9.15-10.34 10.83L83.83 450.79 187.42 347.2c6.26 2.99 13.18 4.8 20.58 4.8 26.51 0 48-21.49 48-48s-21.49-48-48-48-48 21.49-48 48c0 7.4 1.81 14.32 4.8 20.58L61.21 428.17l77.62-232.85c1.68-5.03 5.72-8.89 10.83-10.34l99.83-28.21 1.05-.3 105 105-.29 1.04-28.23 99.84zm132.91-213.17l-74.41 74.41-97.11-97.11 74.41-74.41c2.29-2.29 11.67-7.97 19.64 0l77.47 77.47c5.42 5.41 5.42 14.22 0 19.64z"
  ]
};
export const faPenSquare = {
  prefix: "far",
  iconName: "pen-square",
  icon: [
    448,
    512,
    [],
    "f14b",
    "M246.6 177.9l55.5 55.5c2.3 2.3 2.3 6.1 0 8.5L166.4 377.6l-57.1 6.3c-7.6.8-14.1-5.6-13.3-13.3l6.3-57.1L238 177.8c2.4-2.2 6.2-2.2 8.6.1zm98.4-12.8L314.9 135c-9.4-9.4-24.6-9.4-33.9 0l-23.1 23.1c-2.3 2.3-2.3 6.1 0 8.5l55.5 55.5c2.3 2.3 6.1 2.3 8.5 0L345 199c9.3-9.3 9.3-24.5 0-33.9zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
  ]
};
export const faPencil = {
  prefix: "far",
  iconName: "pencil",
  icon: [
    512,
    512,
    [],
    "f040",
    "M491.609 73.625l-53.861-53.839c-26.378-26.379-69.076-26.383-95.46-.001L24.91 335.089.329 484.085c-2.675 16.215 11.368 30.261 27.587 27.587l148.995-24.582 315.326-317.378c26.33-26.331 26.581-68.879-.628-96.087zM120.644 302l170.259-169.155 88.251 88.251L210 391.355V350h-48v-48h-41.356zM82.132 458.132l-28.263-28.263 12.14-73.587L84.409 338H126v48h48v41.59l-18.282 18.401-73.586 12.141zm378.985-319.533l-.051.051-.051.051-48.03 48.344-88.03-88.03 48.344-48.03.05-.05.05-.05c9.147-9.146 23.978-9.259 33.236-.001l53.854 53.854c9.878 9.877 9.939 24.549.628 33.861z"
  ]
};
export const faPencilAlt = {
  prefix: "far",
  iconName: "pencil-alt",
  icon: [
    512,
    512,
    [],
    "f303",
    "M491.609 73.625l-53.861-53.839c-26.378-26.379-69.075-26.383-95.46-.001L24.91 335.089.329 484.085c-2.675 16.215 11.368 30.261 27.587 27.587l148.995-24.582 315.326-317.378c26.33-26.331 26.581-68.879-.628-96.087zM200.443 311.557C204.739 315.853 210.37 318 216 318s11.261-2.147 15.557-6.443l119.029-119.03 28.569 28.569L210 391.355V350h-48v-48h-41.356l170.259-169.155 28.569 28.569-119.03 119.029c-8.589 8.592-8.589 22.522.001 31.114zM82.132 458.132l-28.263-28.263 12.14-73.587L84.409 338H126v48h48v41.59l-18.282 18.401-73.586 12.141zm378.985-319.533l-.051.051-.051.051-48.03 48.344-88.03-88.03 48.344-48.03.05-.05.05-.05c9.147-9.146 23.978-9.259 33.236-.001l53.854 53.854c9.878 9.877 9.939 24.549.628 33.861z"
  ]
};
export const faPencilPaintbrush = {
  prefix: "far",
  iconName: "pencil-paintbrush",
  icon: [
    512,
    512,
    [],
    "f618",
    "M433.43 365.35c-20.56-54.19-55.01-73.83-93.93-79.66l153.76-153.76c24.99-24.99 24.99-65.52-.01-90.51l-22.68-22.68C458.07 6.25 441.69 0 425.32 0c-16.38 0-32.76 6.25-45.25 18.74L240.21 158.57 158.15 35.86C140.34 10.45 116.87.01 93.48.01 28.72.01-35.44 80.03 22.84 144.06l110.42 121.45L19.08 379.66.33 487.1C-1.98 500.33 8.34 512 21.18 512c1.23 0 2.47-.11 3.74-.33l107.45-18.84 93.72-93.72C232.09 444.02 260.26 512 368 512c101.33 0 144-81.42 144-174.07-11.01 7.52-49.66 38.65-62.15 38.65-7.42 0-13.77-4.24-16.42-11.23zM414 52.68c5.82-5.82 15.98-6.64 22.63 0l22.68 22.68c5.81 5.8 6.66 15.97 0 22.63l-51.69 51.69-45.31-45.31L414 52.68zM58.33 111.75c-10.61-11.65-12.94-22.26-7.58-34.39 7.15-16.18 26.32-29.35 42.72-29.35 6.26 0 15.7 1.6 24.78 14.53l87.35 130.63-38.37 38.36-108.9-119.78zm50.81 336.42l-54.97 9.64 9.59-54.94 264.62-264.56 45.31 45.31-264.55 264.55zM368 464c-34.54 0-59.8-8.58-75.06-25.51-19.93-22.11-21.29-55.88-20.13-67.03l2.21-21.3 19.93-19.93 26.06 1.68c31.41 2.02 52.54 10.93 67.53 50.44 9.03 23.84 30.45 39.83 55.52 41.98C430.03 447.13 406.6 464 368 464z"
  ]
};
export const faPencilRuler = {
  prefix: "far",
  iconName: "pencil-ruler",
  icon: [
    512,
    512,
    [],
    "f5ae",
    "M502.71 368.14L379.88 245.31l56.01-56.01 57.36-57.37c24.99-24.99 24.99-65.52-.01-90.51l-22.68-22.68C458.07 6.25 441.69 0 425.31 0s-32.76 6.25-45.25 18.74L322.69 76.1l-.01-.01-56.02 56.01L230.57 96 143.86 9.29C137.66 3.1 129.55 0 121.43 0S105.2 3.1 99 9.29L9.29 99.01c-12.38 12.39-12.39 32.47 0 44.86l100.18 100.17 22.62 22.62-113.02 113L.32 487.1c-2.3 13.24 8.01 24.9 20.86 24.9 1.23 0 2.47-.11 3.74-.33l107.44-18.84 112.95-112.96L368.14 502.7c6.19 6.19 14.31 9.29 22.43 9.29s16.24-3.1 22.43-9.29l89.71-89.7c12.39-12.39 12.39-32.47 0-44.86zM414 52.68c4.08-4.08 8.84-4.69 11.31-4.69 2.47 0 7.23.61 11.31 4.69l22.68 22.68c4.08 4.08 4.69 8.84 4.69 11.31s-.61 7.24-4.69 11.31l-51.69 51.69-45.31-45.31L414 52.68zM143.41 210.1l-88.66-88.66 66.69-66.69 38.95 38.94-22.03 22.03c-6.25 6.25-6.25 16.38 0 22.63l11.31 11.31c6.25 6.25 16.38 6.25 22.63 0l22.03-22.03 2.32 2.32 36.1 36.1-66.69 66.68-22.65-22.63zm-34.27 238.07l-54.97 9.64 9.59-54.94 264.62-264.56 45.31 45.31-264.55 264.55zm281.43 9.08L279.25 345.94l66.69-66.69 38.44 38.44-22.03 22.03c-6.25 6.25-6.25 16.38 0 22.63l11.31 11.31c6.25 6.25 16.38 6.25 22.63 0l22.03-22.03 38.94 38.94-66.69 66.68z"
  ]
};
export const faPennant = {
  prefix: "far",
  iconName: "pennant",
  icon: [
    576,
    512,
    [],
    "f456",
    "M542.3 183.5c-21.9 4.8-104.7 14.1-246.4-62.8-74.6-40.4-137.5-50.4-186.7-48C121.5 33.7 90.9 0 56 0 25.1 0 0 25.1 0 56c0 22.3 13.2 41.4 32 50.4V504c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8v-75.6c80.8-54.3 156.4-55.7 165.8-56.2 28.2-1.4 74.5-5.9 135.1-19 4.4-1 109-24.5 188.9-124.7 16.1-20.2-1.5-50.3-27.5-45zM370.8 306.3c-57.5 12.4-101 16.6-127.4 18-69.6 3.5-125.6 26.3-163.4 47.9V124c44.1-8.6 109.6-6.3 193 38.9 101.4 54.9 177 69.8 225.9 71.5-61.8 56.6-127.4 71.7-128.1 71.9z"
  ]
};
export const faPeopleArrows = {
  prefix: "far",
  iconName: "people-arrows",
  icon: [
    576,
    512,
    [],
    "e068",
    "M512,165H416a66,66,0,0,0-43.35,15.93,44.91,44.91,0,0,1,21.59,10.33l21.29,18.83c.16,0,.3-.09.47-.09h96c8.82,0,16,6.73,16,15v90H496V435H432V345.48l-1.7,1.5-36.08,31.93a43.68,43.68,0,0,1-10.22,6.7V450c0,16.57,14.33,30,32,30h96c17.67,0,32-13.43,32-30V360c17.67,0,32-13.43,32-30V225C576,191.86,547.35,165,512,165Zm-48-15c44.22,0,80-33.54,80-75S508.22,0,464,0s-80,33.54-80,75S419.78,150,464,150Zm0-105c17.64,0,32,13.46,32,30s-14.36,30-32,30-32-13.46-32-30S446.36,45,464,45ZM145.7,347l-1.7-1.5V435H80V315H48V225c0-8.27,7.18-15,16-15h96c.17,0,.31.08.47.09l21.3-18.84a44.9,44.9,0,0,1,21.58-10.32A66,66,0,0,0,160,165H64c-35.35,0-64,26.86-64,60V330c0,16.57,14.33,30,32,30v90c0,16.57,14.33,30,32,30h96c17.67,0,32-13.43,32-30V385.62a44.33,44.33,0,0,1-10.24-6.73ZM112,150c44.22,0,80-33.54,80-75S156.22,0,112,0,32,33.54,32,75,67.78,150,112,150Zm0-105c17.64,0,32,13.46,32,30s-14.36,30-32,30S80,91.54,80,75,94.36,45,112,45ZM444.4,276.88l-72.12-63.81a12.67,12.67,0,0,0-13-2.15A11.28,11.28,0,0,0,352,221.26V255H224V221.26a11.28,11.28,0,0,0-7.26-10.34,12.67,12.67,0,0,0-13,2.15L131.6,276.88a11.12,11.12,0,0,0,0,16.38l72.12,63.81a12.67,12.67,0,0,0,13,2.16A11.28,11.28,0,0,0,224,348.88V315H352v33.88a11.28,11.28,0,0,0,7.26,10.35,12.67,12.67,0,0,0,13-2.16l72.12-63.81A11.12,11.12,0,0,0,444.4,276.88Z"
  ]
};
export const faPeopleCarry = {
  prefix: "far",
  iconName: "people-carry",
  icon: [
    640,
    512,
    [],
    "f4ce",
    "M128 96c26.5 0 48-21.5 48-48S154.5 0 128 0 80 21.5 80 48s21.5 48 48 48zm384 0c26.5 0 48-21.5 48-48S538.5 0 512 0s-48 21.5-48 48 21.5 48 48 48zm88 154.6l-19-78.4c-4.2-17.3-16.7-32-33.5-39.3-16.9-7.4-35.7-6.5-51.4 2.3-25.6 14.4-40.3 47.6-46.8 66.2l-12.2 34.7c-.6 1.7-1.7 3.2-3.4 4.3L416 250.5V128c0-8.8-7.2-16-16-16H240c-8.8 0-16 7.2-16 16v122.5l-17.8-10.1c-1.6-1.1-2.8-2.6-3.4-4.3l-12.2-34.7c-6.5-18.6-21.2-51.8-46.8-66.2-15.7-8.8-34.5-9.7-51.4-2.3-16.7 7.3-29.2 22-33.5 39.3L40 250.7c-5.1 21.1 2 43.2 18.3 57.5l68.7 60c6.3 5.5 10.2 13.2 10.9 21.5l8 100.2c.8 9.1 8.9 23.3 25.8 22 13.2-1.1 23.1-12.6 22-25.8L185 376.9c-1.2-15.1-8.3-29.1-19.7-39.1l-52.2-45.6 24.8-92.1c2.7 5.3 19.6 51.8 19.6 51.8 3.9 11.2 11.2 20.7 23 28.9l36.9 19.4c4.6 2.4 9.7 3.7 14.9 3.7h175.5c5.2 0 10.3-1.3 14.9-3.7l36.9-19.4c11.8-8.2 19.1-17.7 23-28.9 0 0 16.9-46.6 19.6-51.8l24.8 92.1-52.2 45.6c-11.4 10-18.5 24-19.7 39.1L446.3 486c-1 13.2 8.8 24.8 22 25.8 16.9 1.3 25.1-12.7 25.8-22l8-100.2c.7-8.3 4.6-16.1 10.9-21.5l68.7-59.9c16.3-14.3 23.3-36.5 18.3-57.6zM368 256h-96v-96h96v96zm270.2 222.9l-53.7-130.8-38.2 33.4 47.4 115.6c5 12.2 18.9 18.1 31.3 13.1 12.4-5 18.2-19 13.2-31.3zm-636.4 0c-5 12.3.8 26.3 13.1 31.3 12.4 5 26.3-.9 31.3-13.1l47.4-115.6-38.2-33.4L1.8 478.9z"
  ]
};
export const faPepperHot = {
  prefix: "far",
  iconName: "pepper-hot",
  icon: [
    512,
    512,
    [],
    "f816",
    "M456.54 143c38.38-63.64 21.46-115.6 2-140.1a7.94 7.94 0 0 0-11.81-.51l-23 23a7.91 7.91 0 0 0-1 10c7.3 10.9 18.86 38.19-5.06 79.78A166.42 166.42 0 0 0 340.34 96c-54.74 0-92.37 28.33-98.4 32.12a17.16 17.16 0 0 0 .12 29.13C222.23 182 211.15 213 200.84 242.22c-40.4 114.55-104.37 122.66-132.3 125.86A72 72 0 0 0 72 512c197.58-3 336.64-99 396.24-180.62l10.62 8a14.94 14.94 0 0 0 23.44-8.2c2.73-10.59 9.7-33.74 9.7-58.45A178.43 178.43 0 0 0 456.54 143zm-116.2 1c66.69 0 121.22 55.22 123.57 124l-39-29.31a32 32 0 0 0-22.77-6.23l-39 4.33 4.13-37.13a32 32 0 0 0-15-30.77l-36.15-22.29a114.26 114.26 0 0 1 24.22-2.6zM72 464a24 24 0 0 1 0-48c30.46-3.51 122.66-11.95 174.12-157.81 11.21-31.8 20.68-57.68 37.54-75.23l34.81 21.49-5.21 47a32 32 0 0 0 35.34 35.34l52.59-5.85 28.72 21.61C382.09 368.39 259.26 461.12 72 464z"
  ]
};
export const faPercent = {
  prefix: "far",
  iconName: "percent",
  icon: [
    384,
    512,
    [],
    "f295",
    "M96 224c53 0 96-43 96-96s-43-96-96-96S0 75 0 128s43 96 96 96zm0-144c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zm192 208c-53 0-96 43-96 96s43 96 96 96 96-43 96-96-43-96-96-96zm0 144c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm93.9-381.2L57.2 475c-2.3 3.1-5.9 5-9.7 5H12c-9.6 0-15.3-10.7-10-18.7L327.2 37c2.3-3.1 5.9-5 9.7-5H372c9.6 0 15.3 10.8 9.9 18.8z"
  ]
};
export const faPercentage = {
  prefix: "far",
  iconName: "percentage",
  icon: [
    320,
    512,
    [],
    "f541",
    "M81.94 177.94c18.74-18.75 18.74-49.14 0-67.88-18.75-18.75-49.14-18.75-67.88 0-18.74 18.74-18.74 49.14 0 67.88 18.75 18.75 49.14 18.75 67.88 0zm156.12 156.12c-18.74 18.74-18.74 49.14 0 67.88 18.75 18.74 49.14 18.74 67.88 0 18.74-18.75 18.74-49.14 0-67.88-18.75-18.75-49.14-18.75-67.88 0zm77.25-210.75l-22.63-22.63c-6.25-6.25-16.38-6.25-22.63 0L4.69 366.06c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l265.37-265.37c6.24-6.26 6.24-16.39-.01-22.64z"
  ]
};
export const faPersonBooth = {
  prefix: "far",
  iconName: "person-booth",
  icon: [
    576,
    512,
    [],
    "f756",
    "M192 496c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V320h-48v176zM63.6 128c26.5 0 48-21.5 48-48s-21.5-48-48-48-48 21.5-48 48 21.5 48 48 48zm160.6 104h-54.3l-47.6-47.6C111.8 173.8 97.7 168 82.8 168H56.1c-31 0-56.1 25.1-56 56.1L.2 320 0 488c0 13.2 10.7 24 24 24 13.2 0 24-10.7 24-24l.2-117.9c.2.2.5.3.8.5.2.2.3.4.5.5l51.4 38.4c2 1.5 3.2 3.9 3.2 6.4v72c0 13.2 10.8 24 24 24s24-10.8 24-24v-72c0-17.6-8.4-34.4-22.5-44.8l-17.9-13.4V241.5l26.7 26.8c7.4 7.5 17.8 11.7 28.3 11.7h57.6c13.2 0 24-10.8 24-24s-10.8-24-24.1-24zM544 0H224c-17.7 0-32 14.3-32 32v160h48V48.1l84.7 204.7C301.8 285.1 264 342.7 264 372c0 41.9 34.1 76 76 76 14.3 0 28.1-4.1 40-11.5 23.8 15 56.2 15 80 0 11.9 7.5 25.7 11.5 40 11.5 9.9 0 19.3-2 28-5.5V496c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V32c0-17.7-14.3-32-32-32zm-16 372c0 15.4-12.6 28-28 28-8.2 0-16-3.8-21.5-10.4-4.6-5.5-11.3-8.8-18.5-8.8s-14 3.2-18.5 8.8c-10.9 13.2-32.1 13.2-42.9 0-9.1-11.1-27.9-11.1-37.1 0-5.5 6.6-13.3 10.4-21.5 10.4-15.4 0-28-12.6-28-27.8.8-12.2 28.5-59.9 59.3-102 5-6.8 6-15.6 2.8-23.4L291.9 48H528v324z"
  ]
};
export const faPersonCarry = {
  prefix: "far",
  iconName: "person-carry",
  icon: [
    384,
    512,
    [],
    "f4cf",
    "M80 96c26.5 0 48-21.5 48-48S106.5 0 80 0 32 21.5 32 48s21.5 48 48 48zm288 0H208c-8.8 0-16 7.2-16 16v128h-33.6l-32.1-77.5c-8.7-20.9-29-34.5-51.7-34.5H56c-30.9 0-56 25.1-56 56v102.3c0 7.7 3 29.5 21.3 44l76.4 60.4c5.7 4.5 9.7 10.8 11.3 17.9l19.6 84.8c2.6 11.5 14.4 21.2 28.8 18 12.9-3 21-15.9 18-28.8l-21.4-93c-2.9-12.4-9.9-23.5-19.9-31.4L96 328.1V214.7l22.2 53.5c5 12 16.6 19.8 29.6 19.8H368c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16zm-32 144h-96v-96h96v96zM0 488c0 13.2 10.8 24 24 24s24-10.7 24-24v-95.9C36 382.6.5 354.3 0 353.9V488z"
  ]
};
export const faPersonDolly = {
  prefix: "far",
  iconName: "person-dolly",
  icon: [
    512,
    512,
    [],
    "f4d0",
    "M80 96c26.5 0 48-21.5 48-48S106.5 0 80 0 32 21.5 32 48s21.5 48 48 48zm423.4 280.4c-1.1-4.3-5.5-6.8-9.8-5.7l-20.3 5.4L432 222c-2.1-7.8-10.3-13.8-19.6-11.3L262.1 251l-22.8-85.1c-1.1-4.3-5.5-6.8-9.8-5.7l-30.9 8.3c-4.3 1.1-6.8 5.5-5.7 9.8l16.5 61.6h-51.1l-32.1-77.5c-8.7-20.9-29-34.5-51.7-34.5H56c-30.9 0-56 25.1-56 56v102.3c0 7.7 3 29.5 21.3 44l76.4 60.4c5.7 4.5 9.7 10.8 11.3 17.9l19.6 84.8c2.6 11.5 14.4 21.2 28.8 18 12.9-3 21-15.9 18-28.8l-21.4-93c-2.9-12.4-9.9-23.5-19.9-31.4l-38.1-30V214.7l22.2 53.5c5 12 16.6 19.8 29.6 19.8h74.6l28.9 107.7C234.8 407.3 224 426.4 224 448c0 35.3 28.7 64 64 64 31.7 0 57.8-23.1 62.9-53.3l155.2-41.6c4.3-1.1 6.8-5.5 5.7-9.8l-8.4-30.9zM288 464c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm52.9-52c-9.7-14.2-25.1-24.1-42.8-27l-23.5-87.8L394 265.5l33 123.2-86.1 23.3zM0 488c0 13.2 10.8 24 24 24s24-10.7 24-24v-95.9C36 382.6.5 354.3 0 353.9V488z"
  ]
};
export const faPersonDollyEmpty = {
  prefix: "far",
  iconName: "person-dolly-empty",
  icon: [
    512,
    512,
    [],
    "f4d1",
    "M32 48C32 21.5 53.5 0 80 0s48 21.5 48 48-21.5 48-48 48-48-21.5-48-48zM0 488c0 13.2 10.8 24 24 24s24-10.7 24-24v-95.9C36 382.6.5 354.3 0 353.9V488zm503.4-111.6l8.3 30.9c1.1 4.3-1.4 8.7-5.7 9.8l-155.2 41.6c-5.1 30.2-31.2 53.3-62.9 53.3-35.3 0-64-28.7-64-64 0-21.6 10.8-40.7 27.2-52.3L222.4 288h-74.6c-12.9 0-24.6-7.8-29.6-19.8L96 214.7v113.4l38.1 30.1c10 7.9 17 19 19.9 31.4l21.4 93c3 12.9-5.1 25.8-18 28.8-14.4 3.2-26.1-6.5-28.8-18L109 408.6c-1.6-7.1-5.6-13.4-11.3-17.9l-76.4-60.4C3 315.8 0 294 0 286.3V184c0-30.9 25.1-56 56-56h18.7c22.6 0 43 13.6 51.7 34.5l32.1 77.5h51.1L193 178.4c-1.1-4.3 1.4-8.7 5.7-9.8l30.9-8.3c4.3-1.1 8.7 1.4 9.8 5.7l58.7 219c17.7 2.8 33.1 12.7 42.8 27l152.8-41.2c4.2-1.2 8.6 1.4 9.7 5.6zM304 448c0-8.8-7.2-16-16-16s-16 7.2-16 16 7.2 16 16 16 16-7.2 16-16z"
  ]
};
export const faPersonSign = {
  prefix: "far",
  iconName: "person-sign",
  icon: [
    512,
    512,
    [],
    "f757",
    "M501.5 66.7l-67.6-24.6 5.5-15c3-8.3-1.3-17.5-9.6-20.5l-15-5.5c-8.3-3-17.5 1.3-20.5 9.6l-5.5 15-67.7-24.6C310-3 302.5 5.6 300.6 10.6l-43.8 120.3c-3 8.3 1.3 17.5 9.6 20.5L334 176l-15.8 43.5s-49.9-17.1-49.5-16.5l-50.5-58.6C207.8 134 193.4 128 178.6 128h-62.9c-21.4 0-40.5 11.9-50.1 30.9L2.5 285.3c-5.9 11.9-1.1 26.3 10.7 32.2 14.1 7 27.4-1.3 32.2-10.7L96 205.7v96.7L72.2 484.9c-1.7 13.2 7.6 25.2 20.7 26.9 1 .1 2.1.2 3.1.2 11.9 0 22.2-8.8 23.8-20.9L141 328h14l51.2 78.2c1.1 1.4 1.7 3.2 1.7 5V488c0 13.2 10.7 24 24 24 13.2 0 24-10.7 24-24v-76.8c0-12.7-4.3-25.1-10.9-33.1l-53.1-81.2V187.3l41.6 48.3c6.1 6.1 13.6 10.8 21.9 13.6l46.3 15.4-13.9 38.3c-3 8.3 1.3 17.5 9.6 20.5l15 5.5c8.3 3 17.5-1.3 20.5-9.6l46.2-126.9 67.6 24.6c11.3 4.1 18.7-4.7 20.5-9.6L511 87.2c3.1-8.3-1.2-17.5-9.5-20.5zM433.1 161l-120.2-43.8 21.9-60.1L455 100.9 433.1 161zM144 96.1c26.5 0 48-21.5 48-48s-21.5-48-48-48-48 21.5-48 48 21.5 48 48 48z"
  ]
};
export const faPhone = {
  prefix: "far",
  iconName: "phone",
  icon: [
    512,
    512,
    [],
    "f095",
    "M476.5 22.9L382.3 1.2c-21.6-5-43.6 6.2-52.3 26.6l-43.5 101.5c-8 18.6-2.6 40.6 13.1 53.4l40 32.7C311 267.8 267.8 311 215.4 339.5l-32.7-40c-12.8-15.7-34.8-21.1-53.4-13.1L27.7 329.9c-20.4 8.7-31.5 30.7-26.6 52.3l21.7 94.2c4.8 20.9 23.2 35.5 44.6 35.5C312.3 512 512 313.7 512 67.5c0-21.4-14.6-39.8-35.5-44.6zM69.3 464l-20.9-90.7 98.2-42.1 55.7 68.1c98.8-46.4 150.6-98 197-197l-68.1-55.7 42.1-98.2L464 69.3C463 286.9 286.9 463 69.3 464z"
  ]
};
export const faPhoneAlt = {
  prefix: "far",
  iconName: "phone-alt",
  icon: [
    512,
    512,
    [],
    "f879",
    "M484.25 330l-101.59-43.55a45.86 45.86 0 0 0-53.39 13.1l-32.7 40a311.08 311.08 0 0 1-124.19-124.12l40-32.7a45.91 45.91 0 0 0 13.1-53.42L182 27.79a45.63 45.63 0 0 0-52.31-26.61L35.5 22.89A45.59 45.59 0 0 0 0 67.5C0 313.76 199.68 512.1 444.56 512a45.58 45.58 0 0 0 44.59-35.51l21.7-94.22a45.75 45.75 0 0 0-26.6-52.27zm-41.59 134.09C225.08 463.09 49 287 48 69.3l90.69-20.9 42.09 98.22-68.09 55.71c46.39 99 98.19 150.63 197 197l55.69-68.11 98.19 42.11z"
  ]
};
export const faPhoneLaptop = {
  prefix: "far",
  iconName: "phone-laptop",
  icon: [
    640,
    512,
    [],
    "f87a",
    "M112 48h352v48h48V32a32.09 32.09 0 0 0-32-32H96a32.09 32.09 0 0 0-32 32v256H16a16 16 0 0 0-16 16v16a64.14 64.14 0 0 0 63.91 64H352v-96H112zm492 80H420a36 36 0 0 0-36 36v312a36 36 0 0 0 36 36h184a36 36 0 0 0 36-36V164a36 36 0 0 0-36-36zm-12 336H432V176h160z"
  ]
};
export const faPhoneOffice = {
  prefix: "far",
  iconName: "phone-office",
  icon: [
    576,
    512,
    [],
    "f67d",
    "M368 336h-32c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-48-80v32c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16zm112 144h32c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16zm0-96h32c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16zm80-272H269.06C262.45 13.4 244.87 0 224 0h-80c-20.87 0-38.45 13.4-45.06 32H64C28.65 32 0 60.65 0 96v352c0 35.35 28.65 64 64 64h448c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM144 48h80v320h-80V48zm384 400c0 8.82-7.18 16-16 16H64c-8.82 0-16-7.18-16-16V96c0-8.82 7.18-16 16-16h32v288c0 26.51 21.49 48 48 48h80c26.51 0 48-21.49 48-48V80h48v72c0 22.06 17.94 40 40 40h168v256zm0-304H368V80h144c8.82 0 16 7.18 16 16v48z"
  ]
};
export const faPhonePlus = {
  prefix: "far",
  iconName: "phone-plus",
  icon: [
    512,
    512,
    [],
    "f4d2",
    "M476.5 22.9L382.3 1.2C378.8.4 375.4 0 372 0c-18 0-34.7 10.6-42 27.7l-43.5 101.5c-8 18.6-2.6 40.6 13.1 53.4l40 32.7C311 267.8 267.8 311 215.4 339.5l-32.7-40c-8.9-10.8-22.1-16.7-35.5-16.7-6 0-12.1 1.2-17.9 3.7L27.7 329.9c-20.4 8.7-31.5 30.7-26.6 52.3l21.7 94.2c4.8 20.9 23.2 35.5 44.6 35.5C312.3 512 512 313.7 512 67.5c0-21.4-14.6-39.8-35.5-44.6zM69.3 464l-20.9-90.7 98.2-42.1 55.7 68.1c98.8-46.4 150.6-98 197-197l-68.1-55.7 42.1-98.2L464 69.3C463 286.9 286.9 463 69.3 464zM88 208c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-72h72c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16h-72V16c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16v72H16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h72v72z"
  ]
};
export const faPhoneRotary = {
  prefix: "far",
  iconName: "phone-rotary",
  icon: [
    512,
    512,
    [],
    "f8d3",
    "M370.43 192.25A64 64 0 0 0 314.86 160H197.14a64 64 0 0 0-55.57 32.25L36.22 376.62A32 32 0 0 0 32 392.5V448a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32v-55.5a32 32 0 0 0-4.22-15.88zM432 432H80v-35.25l103.25-180.69a16 16 0 0 1 13.89-8.06h117.72a16 16 0 0 1 13.89 8.06L432 396.75zM256 256a64 64 0 1 0 64 64 64 64 0 0 0-64-64zm250.18-133C436.76 65 347.38 32 256 32S75.24 65 5.82 123A16.45 16.45 0 0 0 0 135.64V192a16 16 0 0 0 16 16h70.11a16 16 0 0 0 14.31-8.85L128 128c39.9-17.28 83.2-24 128-24 44.77 0 88.07 6.72 128 24l27.58 71.15a16 16 0 0 0 14.31 8.85H496a16 16 0 0 0 16-16v-56.36a16.45 16.45 0 0 0-5.82-12.64z"
  ]
};
export const faPhoneSlash = {
  prefix: "far",
  iconName: "phone-slash",
  icon: [
    640,
    512,
    [],
    "f3dd",
    "M634 471L36 3.5C29.1-2 19-.9 13.5 6l-10 12.5C-2 25.4-.9 35.5 6 41l598 467.5c6.9 5.5 17 4.4 22.5-2.5l10-12.5c5.5-6.9 4.4-17-2.5-22.5zM403.5 215.4c-1.8 3.4-4.2 6.4-6.2 9.7l37.8 29.5c9.8-16 19.2-33 28.2-52.3l-68.1-55.7 42.1-98.2L528 69.3c-.3 77.2-23.1 149-61.6 209.8l38 29.7c45-69.5 71.5-152.2 71.5-241.3 0-21.4-14.6-39.8-35.5-44.6L446.3 1.2c-21.6-5-43.6 6.2-52.3 26.6l-43.5 101.5c-8 18.6-2.6 40.6 13.1 53.4l39.9 32.7zM133.3 464l-20.9-90.7 98.2-42.1 55.7 68.1c26.5-12.4 49.4-25.3 69.9-39.3l-40-31.3c-5.6 3.6-10.9 7.6-16.8 10.8l-32.7-40c-12.8-15.7-34.8-21.1-53.4-13.1L91.7 329.9c-20.4 8.7-31.5 30.7-26.6 52.3l21.7 94.2c4.8 20.9 23.2 35.5 44.6 35.5 104.2 0 199.9-36.1 275.9-96.3L368.2 385c-65.6 49.1-146.7 78.6-234.9 79z"
  ]
};
export const faPhoneSquare = {
  prefix: "far",
  iconName: "phone-square",
  icon: [
    448,
    512,
    [],
    "f098",
    "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zm-6 400H54a6 6 0 0 1-6-6V86a6 6 0 0 1 6-6h340a6 6 0 0 1 6 6v340a6 6 0 0 1-6 6zm-42-280c0 128.234-103.956 232-232 232a12.004 12.004 0 0 1-11.693-9.302l-11.999-52a12 12 0 0 1 6.966-13.728l55.999-23.999a12 12 0 0 1 14.015 3.431l24.798 30.308c39.155-18.37 70.638-50.287 88.624-88.624l-30.309-24.798a12 12 0 0 1-3.431-14.015l24-55.999a12 12 0 0 1 13.728-6.966l52 11.999A12 12 0 0 1 352 152z"
  ]
};
export const faPhoneSquareAlt = {
  prefix: "far",
  iconName: "phone-square-alt",
  icon: [
    448,
    512,
    [],
    "f87b",
    "M344.73 309l-56-24a14.46 14.46 0 0 0-4.73-1 13.61 13.61 0 0 0-9.29 4.4l-24.8 30.31a185.51 185.51 0 0 1-88.62-88.62l30.31-24.8A13.61 13.61 0 0 0 196 196a14.2 14.2 0 0 0-1-4.73l-24-56a13 13 0 0 0-11-7.27 14.51 14.51 0 0 0-2.7.31l-52 12A12.57 12.57 0 0 0 96 152c0 128.23 104 232 232 232a12.57 12.57 0 0 0 11.69-9.3l12-52a14.51 14.51 0 0 0 .31-2.7 13 13 0 0 0-7.27-11zM400 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h352a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48zm0 394a6 6 0 0 1-6 6H54a6 6 0 0 1-6-6V86a6 6 0 0 1 6-6h340a6 6 0 0 1 6 6z"
  ]
};
export const faPhoneVolume = {
  prefix: "far",
  iconName: "phone-volume",
  icon: [
    448,
    512,
    [],
    "f2a0",
    "M226.615 412.576l-28.086-70.218c-7.914-19.785-27.631-31.304-48.207-29.247l-21.97 2.197c-6.25-27.912-6.442-57.872-.002-86.618l21.97 2.197c20.541 2.055 40.282-9.433 48.208-29.246l28.087-70.218c8.438-21.094.579-45.143-18.686-57.184l-56.175-35.107c-18.097-11.311-42.199-9.21-58.016 6.606-124.622 124.622-125.347 327.175 0 452.523 15.816 15.814 39.913 17.922 58.017 6.606l56.174-35.107c19.265-12.041 27.124-36.091 18.686-57.184zm-99.556 51.125C21.661 357.639 21.517 186.505 127.06 80.297l54.646 34.156-27.437 68.589-59.946-5.993c-25.22 69.795-25.241 120.05 0 189.901l59.947-5.995 27.436 68.591-54.647 34.155zm155.728-362.488l-11.476 11.476c-4.117 4.117-4.671 10.584-1.341 15.36A55.7 55.7 0 0 1 280 160a55.688 55.688 0 0 1-10.031 31.95c-3.329 4.776-2.775 11.244 1.341 15.36l11.476 11.476c5.191 5.191 13.751 4.52 18.149-1.359C312.913 201.414 320 181.535 320 160s-7.087-41.414-19.064-57.428c-4.398-5.88-12.958-6.55-18.149-1.359zm90.875-90.875l-11.323 11.323c-4.461 4.461-4.746 11.651-.559 16.37C391.666 71.708 408 114.595 408 160s-16.334 88.292-46.22 121.969c-4.188 4.719-3.902 11.909.559 16.37l11.323 11.323c4.871 4.871 12.843 4.658 17.434-.479C426.488 269.575 448 217.302 448 160S426.488 50.425 391.096 10.817c-4.591-5.137-12.563-5.35-17.434-.479zm-45.355 45.355l-11.355 11.355c-4.406 4.406-4.679 11.429-.685 16.213C334.227 104.771 344 131.638 344 160s-9.773 55.229-27.733 76.74c-3.994 4.783-3.721 11.807.685 16.213l11.355 11.355c4.935 4.935 13.059 4.665 17.582-.65C369.655 235.731 384 199.54 384 160s-14.345-75.731-38.111-103.657c-4.523-5.315-12.647-5.584-17.582-.65z"
  ]
};
export const faPhotoVideo = {
  prefix: "far",
  iconName: "photo-video",
  icon: [
    640,
    512,
    [],
    "f87c",
    "M608 0H160c-17.67 0-32 13.13-32 29.33V112h48V48h48v64h48V48h224v304h112c17.67 0 32-13.13 32-29.33V29.33C640 13.13 625.67 0 608 0zm-16 304h-48v-56h48zm0-104h-48v-48h48zm0-96h-48V48h48zM128 320a32 32 0 1 0-32-32 32 32 0 0 0 32 32zm288-160H32a32 32 0 0 0-32 32v288a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32V192a32 32 0 0 0-32-32zm-16 240L299.31 299.31a16 16 0 0 0-22.62 0L176 400l-36.69-36.69a16 16 0 0 0-22.62 0L48 432V208h352z"
  ]
};
export const faPi = {
  prefix: "far",
  iconName: "pi",
  icon: [
    448,
    512,
    [],
    "f67e",
    "M436 96H49.96c-8.49 0-16.63 3.37-22.63 9.37L2.36 130.34C-2.68 135.38.89 144 8.02 144H144v137.79c0 48.12-17.34 93.57-49.1 129.21-4.26 4.78-4.31 11.89.21 16.42l16.99 16.99c4.83 4.83 12.94 4.82 17.52-.25C169.95 399.53 192 342.35 192 281.79V144h96v235.9c0 28.48 16.96 55.51 43.97 64.53 29.62 9.89 60.23-1.42 76.37-25.68l23.63-35.45c3.68-5.52 2.19-12.96-3.33-16.64l-19.97-13.31c-5.52-3.68-12.97-2.19-16.64 3.33l-23.62 35.46a17.644 17.644 0 0 1-14.72 7.86c-9.75 0-17.69-7.94-17.69-17.69V144h100c6.63 0 12-5.37 12-12v-24c0-6.63-5.37-12-12-12z"
  ]
};
export const faPiano = {
  prefix: "far",
  iconName: "piano",
  icon: [
    512,
    512,
    [],
    "f8d4",
    "M476.62,270.31l-57.24-28.62A64,64,0,0,1,384,184.44C384,82.58,301.42,0,199.55,0h-15.1C82.58,0,0,82.58,0,184.44V480a32,32,0,0,0,32,32H480a32,32,0,0,0,32-32V327.55A64,64,0,0,0,476.62,270.31ZM464,464H48V384H80v40a8,8,0,0,0,8,8h16a8,8,0,0,0,8-8V384h32v40a8,8,0,0,0,8,8h16a8,8,0,0,0,8-8V384h32v40a8,8,0,0,0,8,8h16a8,8,0,0,0,8-8V384h96v40a8,8,0,0,0,8,8h16a8,8,0,0,0,8-8V384h32v40a8,8,0,0,0,8,8h16a8,8,0,0,0,8-8V384h32Zm0-128H48V184.44C48,109.21,109.21,48,184.45,48h15.1C274.79,48,336,109.21,336,184.44a111.38,111.38,0,0,0,61.91,100.18l57.24,28.62A15.9,15.9,0,0,1,464,327.55Z"
  ]
};
export const faPianoKeyboard = {
  prefix: "far",
  iconName: "piano-keyboard",
  icon: [
    576,
    512,
    [],
    "f8d5",
    "M544 64H32A32 32 0 0 0 0 96v320a32 32 0 0 0 32 32h512a32 32 0 0 0 32-32V96a32 32 0 0 0-32-32zM144 400H48V224h80v80a16 16 0 0 0 16 16zm128 0h-96v-80a16 16 0 0 0 16-16v-80h64v80a16 16 0 0 0 16 16zm128 0h-96v-80a16 16 0 0 0 16-16v-80h64v80a16 16 0 0 0 16 16zm128 0h-96v-80a16 16 0 0 0 16-16v-80h80zm0-224H48v-64h480z"
  ]
};
export const faPie = {
  prefix: "far",
  iconName: "pie",
  icon: [
    576,
    512,
    [],
    "f705",
    "M544 240c-6.44 0-10.37-1.2-14.47-3.52C494.93 136.17 400.07 64 288 64S81 136.21 46.45 236.55c-4.07 2.28-8 3.45-14.45 3.45a32 32 0 0 0 0 64c32 0 50-13.47 61.92-22.39 9.08-6.8 12.83-9.61 23.53-9.61s14.47 2.81 23.55 9.61c11.91 8.92 29.89 22.39 61.91 22.39s50-13.48 61.88-22.41c9-6.78 12.8-9.59 23.45-9.59s14.39 2.81 23.44 9.59c11.89 8.92 29.86 22.41 61.86 22.41s49.95-13.48 61.84-22.41c9.05-6.78 12.8-9.59 23.44-9.59s14.34 2.81 23.38 9.58C494.06 290.52 512 304 544 304a32 32 0 0 0 0-64zm-337.69-88.84l-16 32A16 16 0 0 1 176 192a16 16 0 0 1-14.32-23.16l16-32a16 16 0 1 1 28.63 14.32zM304 176a16 16 0 0 1-32 0v-32a16 16 0 0 1 32 0zm103.16 14.31a16 16 0 0 1-21.47-7.15l-16-32a16 16 0 1 1 28.63-14.31l16 32a16 16 0 0 1-7.16 21.46zM445.4 400H130.6l-28.36-85.08a122.1 122.1 0 0 1-44.49 18.32l31 92.88A32 32 0 0 0 119.07 448h337.87a32 32 0 0 0 30.36-21.88l31-92.88a121.62 121.62 0 0 1-44.47-18.38z"
  ]
};
export const faPig = {
  prefix: "far",
  iconName: "pig",
  icon: [
    576,
    512,
    [],
    "f706",
    "M447.99 240c0 8.8-7.2 16-16 16s-16-7.2-16-16 7.2-16 16-16 16 7.2 16 16zM576 208v128c0 8.8-7.2 16-16 16h-48.7c-8.9 11.8-19.6 22.1-31.3 31.1V448c0 17.6-14.4 32-32 32h-80c-17.6 0-32-14.4-32-32v-32h-64v32c0 17.6-14.4 32-32 32h-80c-17.6 0-32-14.4-32-32v-64.7C89.4 354.1 64 308.2 64 256h-8C22.7 256-3.9 226.8.5 192.6 4.1 164.4 29.5 144 58 144c3.3 0 6 2.7 6 6v20c0 3.3-2.7 6-6 6h-1c-11.6 0-22.3 7.8-24.5 19.2-3 15.3 8.7 28.8 23.5 28.8h11.2c9.46-46.34 38.95-85.3 78.99-107.63l.03.07c23-12.98 49.5-20.44 77.79-20.44H374.5c1.3-1 40.55-32 89.52-32h16v64.6c21.8 16.5 39.4 38.1 50.5 63.4H560c8.8 0 16 7.2 16 16zm-48 32h-28.9c-22.9-52.3-21.7-53.1-67.1-87.5v-34.7c-18.4 6.9-31.1 18.6-40.6 26.2H223.99c-61.8 0-112 50.2-112 112 0 63.6 49.4 92.4 64 103.4V432h48v-64H384v64h48v-72.6c36-27.5 31.9-24.3 55.4-55.4H528v-64z"
  ]
};
export const faPiggyBank = {
  prefix: "far",
  iconName: "piggy-bank",
  icon: [
    576,
    512,
    [],
    "f4d3",
    "M560 224h-29.5c-11.1-25.3-28.7-46.9-50.5-63.4V96h-16c-30.3 0-57.8 10.1-81 26.2.4-3.4 1-6.7 1-10.2C384 50.1 333.9 0 272 0S160 50.1 160 112c0 9.7 1.5 19 3.8 27.9C114.9 159.8 78 203.1 67.2 256H56c-14.8 0-26.5-13.5-23.5-28.8C34.7 215.8 45.4 208 57 208h1c3.3 0 6-2.7 6-6v-20c0-3.3-2.7-6-6-6-28.5 0-53.9 20.4-57.5 48.6C-3.9 258.8 22.7 288 56 288h8c0 52.2 25.4 98.1 64 127.3V496c0 8.8 7.2 16 16 16h112c8.8 0 16-7.2 16-16v-48h64v48c0 8.8 7.2 16 16 16h112c8.8 0 16-7.2 16-16v-80.9c11.7-9 22.4-19.3 31.3-31.1H560c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16zM272 48c35.3 0 64 28.7 64 64 0 5.6-.9 10.9-2.3 16H224c-4.5 0-8.8 1-13.3 1.3-1.6-5.5-2.7-11.3-2.7-17.3 0-35.3 28.7-64 64-64zm256 288h-40.6c-23.5 31.1-19.4 27.9-55.4 55.4V464h-48v-64H224v64h-48v-72.6c-14.6-11-64-39.8-64-103.4 0-61.8 50.2-112 112-112h167.4c9.5-7.6 22.2-19.3 40.6-26.2v34.7c45.4 34.4 44.2 35.2 67.1 87.5H528v64zm-96-80c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16z"
  ]
};
export const faPills = {
  prefix: "far",
  iconName: "pills",
  icon: [
    576,
    512,
    [],
    "f484",
    "M112 32C50.1 32 0 82.1 0 144v224c0 61.9 50.1 112 112 112s112-50.1 112-112V144c0-61.9-50.1-112-112-112zm64 224H48V144c0-84.7 128-84.7 128 0v112zm353.1-49.1c-62.4-62.4-163.8-62.5-226.3 0s-62.5 163.8 0 226.3c62.4 62.4 163.8 62.5 226.3 0s62.5-163.9 0-226.3zm-207.3 52.8l154.5 154.5C375.7 478.8 257 360.5 321.8 259.7zm188.4 120.6L355.7 225.8c100.6-64.7 219.3 53.7 154.5 154.5z"
  ]
};
export const faPizza = {
  prefix: "far",
  iconName: "pizza",
  icon: [
    576,
    512,
    [],
    "f817",
    "M523.2 100.13a15.43 15.43 0 0 0-12.36-6 16.42 16.42 0 0 0-11.61 4.78L342.17 256l157.06 157.06a16.42 16.42 0 0 0 11.61 4.78 15.4 15.4 0 0 0 12.36-6 256.47 256.47 0 0 0 0-311.71zm-67.32 201.7L410.05 256l45.66-45.66c4.91 14.44 8.29 29.58 8.29 45.66a137.62 137.62 0 0 1-8.12 45.83zm49.23 49.23l-24.27-24.27a172.11 172.11 0 0 0-.1-141.48l24.37-24.37a208.65 208.65 0 0 1 0 190.12zM256.45 256L425.6 86.85c6.46-6.46 6.45-17.36-.42-23.39A255.13 255.13 0 0 0 256.46 0C175.37 0 94.29 38.28 42.65 114.84c-56.87 84.3-56.87 198 0 282.34C94.3 473.72 175.38 512 256.45 512a255.14 255.14 0 0 0 168.73-63.46c6.87-6 6.88-16.93.42-23.39zm-67.88 0L318 385.38A140.58 140.58 0 0 1 256 400c-79.4 0-144-64.6-144-144s64.6-144 144-144a140.71 140.71 0 0 1 62 14.62zm67.88 208c-70.42 0-133.84-34.14-174-93.67-46.14-68.38-46.14-160.26 0-228.64C122.6 82.15 186 48 256.46 48a207.9 207.9 0 0 1 109.19 30.92l-23.8 23.8A174.09 174.09 0 0 0 256 80a176 176 0 0 0 0 352 174.09 174.09 0 0 0 85.85-22.72l23.8 23.8A207.91 207.91 0 0 1 256.45 464zM216 144a24 24 0 1 0 24 24 24 24 0 0 0-24-24zm-40 184a24 24 0 1 0 24-24 24 24 0 0 0-24 24z"
  ]
};
export const faPizzaSlice = {
  prefix: "far",
  iconName: "pizza-slice",
  icon: [
    512,
    512,
    [],
    "f818",
    "M158.87.15c-1.09-.1-2.18-.15-3.26-.15a32.85 32.85 0 0 0-32.07 24.27L.55 491.63A16.24 16.24 0 0 0 16.15 512a16.54 16.54 0 0 0 4.4-.61l467.6-129.66c15.72-4.35 25.49-19.67 23.62-35.89C490.89 165.08 340.78 17.32 158.87.15zm-97.82 450.2l81.7-310.48c122.13 20.54 206.16 103.39 228.39 224.5zm356.39-98.82C390.5 215 292.6 118.47 155 93.45l11.61-44.12C315.39 69.09 439.5 190.64 462.43 339.06zM192 192a32 32 0 1 0 32 32 32 32 0 0 0-32-32zm-32 128a32 32 0 1 0 32 32 32 32 0 0 0-32-32zm96 0a32 32 0 1 0 32-32 32 32 0 0 0-32 32z"
  ]
};
export const faPlaceOfWorship = {
  prefix: "far",
  iconName: "place-of-worship",
  icon: [
    576,
    512,
    [],
    "f67f",
    "M558.57 339.99L448 292.58v-18.46c0-11.24-5.9-21.65-15.53-27.44L384 217.6V102.63c0-8.49-3.37-16.63-9.38-22.63L299.31 4.69C296.19 1.56 292.09 0 288 0s-8.19 1.56-11.31 4.69L201.37 80c-6 6-9.37 14.14-9.37 22.62V217.6l-48.46 29.08A32.002 32.002 0 0 0 128 274.13v18.46l-110.57 47.4C6.96 344.99 0 357.89 0 372.32v122.45C0 504.28 5.97 512 13.33 512H32c8.84 0 16-7.16 16-16V379.11l80-34.3V496c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V283.18l64-38.4V109.26l48-48 48 48v135.52l64 38.4V496c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V344.81l80 34.3V496c0 8.84 7.16 16 16 16h18.67c7.37 0 13.33-7.71 13.33-17.23V372.32c0-14.43-6.96-27.33-17.43-32.33zM281.71 320.3c-33.27 3.17-57.71 33.02-57.71 66.45V496c0 8.84 7.16 16 16 16h96c8.84 0 16-7.16 16-16V384c0-37.42-32.12-67.34-70.29-63.7z"
  ]
};
export const faPlane = {
  prefix: "far",
  iconName: "plane",
  icon: [
    576,
    512,
    [],
    "f072",
    "M239.57 48l100.57 176H456c26.03 0 62.87 19.73 71.1 32-8.23 12.27-45.07 32-71.1 32H340.14L239.57 464h-37.14l50.29-176H136l-36 48H58.68L82 256l-23.32-80H100l36 48h116.72L202.43 48h37.14m18.57-48h-98.13c-10.63 0-18.3 10.17-15.38 20.39L189.08 176H160l-31.2-41.6c-3.02-4.03-7.77-6.4-12.8-6.4H16.01C5.6 128-2.04 137.78.49 147.88L32 256 .49 364.12C-2.04 374.22 5.6 384 16.01 384H116c5.04 0 9.78-2.37 12.8-6.4L160 336h29.08l-44.46 155.6C141.7 501.82 149.37 512 160 512h98.13c5.74 0 11.04-3.08 13.89-8.06L368 336h88c44.18 0 120-35.82 120-80 0-44.19-75.82-80-120-80h-88L272.03 8.06A15.998 15.998 0 0 0 258.14 0z"
  ]
};
export const faPlaneAlt = {
  prefix: "far",
  iconName: "plane-alt",
  icon: [
    576,
    512,
    [],
    "f3de",
    "M457.75 176.563H356.417L329.66 128H340c6.627 0 12-5.373 12-12V76c0-6.627-5.373-12-12-12h-45.602l-25.569-46.406-.581-.998C261.947 6.359 250.566 0 238.547 0h-52.369c-22.472 0-38.951 20.866-34.015 42.578l25.086 135.738a624.765 624.765 0 0 0-37.477 3.772l-27.581-42.387c-6.326-10.162-17.62-16.451-29.61-16.451H44.004c-22.029 0-38.509 20.155-34.198 41.714l11.961 59.805C7.821 234.229 0 244.818 0 256.001s7.821 21.772 21.766 31.231l-11.96 59.803c-4.319 21.601 12.212 41.718 34.199 41.714l38.582-.001c11.988-.003 23.278-6.292 29.604-16.45l27.58-42.386a624.11 624.11 0 0 0 37.477 3.772L152.163 469.42c-4.941 21.739 11.568 42.58 34.015 42.58h52.369c12.021 0 23.401-6.36 29.702-16.598l.302-.491L294.397 448H340c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-10.341l26.758-48.565 101.333.001C510.814 335.436 576 306.854 576 256c0-50.872-65.216-79.437-118.25-79.437zm0 110.873l-129.69-.001L230.778 464h-28.801l32.542-176.087c-53.455-1.594-62.567-1.471-118.194-9.978l-40.872 62.812-15.439.001L76.964 256l-16.95-84.751h15.44l40.872 62.814c55.671-8.515 64.832-8.386 118.194-9.979L201.979 48h28.8l97.281 176.563h129.69C496.424 224.563 528 240 528 256s-31.58 31.436-70.25 31.436z"
  ]
};
export const faPlaneArrival = {
  prefix: "far",
  iconName: "plane-arrival",
  icon: [
    640,
    512,
    [],
    "f5af",
    "M624 464H16c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16zM113.43 312.32c9.06 7.82 20.41 13.78 32.47 16.93l306.36 80c22.63 5.9 56.94 11.05 93.25 1.37 34.2-9.13 54.62-24.95 60.71-47 6.19-22.57-3.55-46.66-28.92-71.66-20.91-20.59-49.21-35.98-81.86-44.51l-97.89-25.56L294.89 33.8a48.016 48.016 0 0 0-30.01-23.45C228.67.89 227.1 0 219.1 0c-12.89 0-25.45 5.2-34.62 14.75a47.985 47.985 0 0 0-11.3 47.23l33.51 110.06L129.95 152 106.4 94.84c-5.74-13.93-17.68-21.36-32.26-25.16C60 65.98 55.78 64.46 48 64.46c-35.4 0-48 28.62-48 45V194c0 14.11 6.21 27.51 16.98 36.63l96.45 81.69zM48 109.46l14.02 3.66 32.65 79.28 182.93 47.77L219.1 48l33.66 8.79 112.59 206.29 117.96 30.8c24.52 6.4 45.37 17.56 60.29 32.26 15.12 14.89 16.74 23.24 16.34 24.7-.39 1.42-6.09 7.86-26.81 13.39-6.76 1.8-31.65 8.25-68.75-1.43l-306.37-80c-5-1.3-9.69-3.77-13.57-7.11L48 194v-84.54z"
  ]
};
export const faPlaneDeparture = {
  prefix: "far",
  iconName: "plane-departure",
  icon: [
    640,
    512,
    [],
    "f5b0",
    "M624 464H16c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16zM74.64 367.77A48.002 48.002 0 0 0 110.62 384h.21l124.25-.54c12.03-.02 24.23-3.07 35.13-8.82L550.46 226.7c30.06-15.87 54.47-38.04 70.58-64.11 19.42-31.42 23.95-58.48 13.46-80.44-10.38-21.78-33.53-34.06-68.79-36.44-3.23-.22-6.46-.32-9.68-.32-26.8 0-54.1 7.23-81.12 21.5l-88.68 46.82-.36.19-.39-.15-201-78.46a47.99 47.99 0 0 0-39.86 2.26L108.7 56.52a48.002 48.002 0 0 0-3.84 82.64l103.92 67.88.29.19-.35.18-66.79 35.26-.42.22-.42-.22-54.64-28.65a47.96 47.96 0 0 0-22.29-5.49c-7.7 0-15.4 1.85-22.41 5.55l-16.16 8.53A47.987 47.987 0 0 0 .78 256.42a47.981 47.981 0 0 0 11.23 40.4l62.63 70.95zM64.16 256.52l77.43 40.6 161.98-85.51L131.11 98.97 167.03 80l221.83 86.59 108.46-57.25c20.05-10.59 39.81-15.95 58.72-15.95 2.14 0 4.29.07 6.44.21 15.03 1.02 26.56 4.71 28.71 9.24 2.08 4.36.46 16.01-10.98 34.51-11.62 18.8-29.66 35.02-52.16 46.9L247.81 332.19c-4.04 2.13-8.52 3.26-12.94 3.27l-124.25.54L48 265.05l16.16-8.53z"
  ]
};
export const faPlaneSlash = {
  prefix: "far",
  iconName: "plane-slash",
  icon: [
    640,
    512,
    [],
    "e069",
    "M271.57,464H234.44L277.3,314l-33.25-26H168l-36,48H90.69L114,256,90.69,176,41.38,129.56a15.89,15.89,0,0,0-8.89,18.32L64,256,32.49,364.13A16,16,0,0,0,48,384H148a16,16,0,0,0,12.8-6.4L192,336h29.08L176.63,491.59A16,16,0,0,0,192,512h98.13A16,16,0,0,0,304,503.94L370.8,387.1l-38.21-29.88ZM188.45,61.77,252.73,112,234.44,48h37.13l81.34,142.33L396,224h92c26,0,62.88,19.74,71.1,32-8.22,12.27-45.06,32-71.1,32H477.83l51.5,40.26C568.11,315.5,608,288.06,608,256c0-44.18-75.81-80-120-80H400L304,8.07C301.49,3.62,295.27,0,290.14,0H192A16,16,0,0,0,176.63,20.4ZM634,471,36,3.52A16,16,0,0,0,13.51,6l-10,12.49A16,16,0,0,0,6,41L604,508.48A16,16,0,0,0,626.48,506l10-12.49A16,16,0,0,0,634,471Z"
  ]
};
export const faPlanetMoon = {
  prefix: "far",
  iconName: "planet-moon",
  icon: [
    576,
    512,
    [],
    "e01f",
    "M512,0a64,64,0,1,0,64,64A63.99942,63.99942,0,0,0,512,0ZM224,64C100.28711,64,0,164.28516,0,288,0,411.71289,100.28711,512,224,512S448,411.71289,448,288C448,164.28516,347.71289,64,224,64Zm0,400c-97.04688,0-176-78.95312-176-176a174.63792,174.63792,0,0,1,17.93555-76.90625,28.23035,28.23035,0,0,0,23.78515,12.9043L114.74609,224a32.00483,32.00483,0,0,1,22.627,9.37109L192,288v32a32.00033,32.00033,0,0,0,32,32c-.00586,0-.00391,39.58984-.00195,63.06836a16.03421,16.03421,0,0,0,17.60742,15.98437q5.25587-.5625,10.41992-1.43359A28.68332,28.68332,0,0,0,272.918,414.166l40.32422-80.64844A64.02377,64.02377,0,0,0,320,304.89062V288a31.99908,31.99908,0,0,0-32-32H223.45312a37.31367,37.31367,0,0,1-26.38085-10.92773,32.00106,32.00106,0,0,1-1.55079-43.58985L245.25,144.125c5.82031-8.73047,8.77539-18.832,9.81836-29.209C337.32422,129.65039,400,201.57031,400,288,400,385.04688,321.04688,464,224,464Z"
  ]
};
export const faPlanetRinged = {
  prefix: "far",
  iconName: "planet-ringed",
  icon: [
    512,
    512,
    [],
    "e020",
    "M502.93136,9.03939c-23.47-23.46814-88.251.13477-167.07181,54.86839A207.27823,207.27823,0,0,0,255.986,47.96155c-114.88922,0-208.02332,93.1362-208.02332,208.02366a207.28775,207.28775,0,0,0,15.94425,79.87567C9.17336,414.68181-14.42952,479.46288,9.04054,502.931c23.49155,23.49158,88.31157-.01172,167.2144-54.81369a207.3182,207.3182,0,0,0,79.731,15.89153c114.88727,0,208.02137-93.13425,208.02137-208.02365A207.30937,207.30937,0,0,0,448.11581,176.256C502.91769,97.3511,526.42291,32.531,502.93136,9.03939ZM63.96353,448.00794c-7.96334-7.96334,2.46107-32.88469,25.7612-67.375A208.80918,208.80918,0,0,0,131.397,422.28967C96.83645,445.64257,71.94053,455.983,63.96353,448.00794ZM172.57505,391.8973c-45.76036-28.19107-76.60779-78.33262-76.60779-135.91209,0-88.23358,71.7833-160.017,160.01869-160.017,57.57939,0,107.7189,30.84552,135.90993,76.60791-27.48787,34.72074-63.109,74.61366-103.90814,115.41288C247.18663,328.79017,207.29574,364.4094,172.57505,391.8973Zm83.4109,24.10686a160.07735,160.07735,0,0,1-32.30258-3.28535,1197.437,1197.437,0,0,0,99.65009-89.386,1196.72461,1196.72461,0,0,0,89.38389-99.6483,160.0442,160.0442,0,0,1,3.28534,32.30069C416.00269,344.22074,344.21939,416.00416,255.986,416.00416ZM380.63353,89.72566c34.4902-23.29821,59.40956-33.72459,67.3729-25.76124,7.975,7.97507-2.36342,32.86907-25.71823,67.4316A208.84145,208.84145,0,0,0,380.63353,89.72566Z"
  ]
};
export const faPlay = {
  prefix: "far",
  iconName: "play",
  icon: [
    448,
    512,
    [],
    "f04b",
    "M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6zM48 453.5v-395c0-4.6 5.1-7.5 9.1-5.2l334.2 197.5c3.9 2.3 3.9 8 0 10.3L57.1 458.7c-4 2.3-9.1-.6-9.1-5.2z"
  ]
};
export const faPlayCircle = {
  prefix: "far",
  iconName: "play-circle",
  icon: [
    512,
    512,
    [],
    "f144",
    "M371.7 238l-176-107c-15.8-8.8-35.7 2.5-35.7 21v208c0 18.4 19.8 29.8 35.7 21l176-101c16.4-9.1 16.4-32.8 0-42zM504 256C504 119 393 8 256 8S8 119 8 256s111 248 248 248 248-111 248-248zm-448 0c0-110.5 89.5-200 200-200s200 89.5 200 200-89.5 200-200 200S56 366.5 56 256z"
  ]
};
export const faPlug = {
  prefix: "far",
  iconName: "plug",
  icon: [
    384,
    512,
    [],
    "f1e6",
    "M312,24a24,24,0,0,0-48,0v88h48ZM120,24a24,24,0,0,0-48,0v88h48ZM368,144H16A16,16,0,0,0,0,160v16a16,16,0,0,0,16,16H32v64c0,80.14,59.11,145.92,136,157.58V512h48V413.58C292.89,401.92,352,336.14,352,256V192h16a16,16,0,0,0,16-16V160A16,16,0,0,0,368,144ZM304,256a112,112,0,0,1-224,0V192H304Z"
  ]
};
export const faPlus = {
  prefix: "far",
  iconName: "plus",
  icon: [
    384,
    512,
    [],
    "f067",
    "M368 224H224V80c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v144H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h144v144c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V288h144c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
  ]
};
export const faPlusCircle = {
  prefix: "far",
  iconName: "plus-circle",
  icon: [
    512,
    512,
    [],
    "f055",
    "M384 240v32c0 6.6-5.4 12-12 12h-88v88c0 6.6-5.4 12-12 12h-32c-6.6 0-12-5.4-12-12v-88h-88c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h88v-88c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v88h88c6.6 0 12 5.4 12 12zm120 16c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-48 0c0-110.5-89.5-200-200-200S56 145.5 56 256s89.5 200 200 200 200-89.5 200-200z"
  ]
};
export const faPlusHexagon = {
  prefix: "far",
  iconName: "plus-hexagon",
  icon: [
    576,
    512,
    [],
    "f300",
    "M441.5 39.8C432.9 25.1 417.1 16 400 16H176c-17.1 0-32.9 9.1-41.5 23.8l-112 192c-8.7 14.9-8.7 33.4 0 48.4l112 192c8.6 14.7 24.4 23.8 41.5 23.8h224c17.1 0 32.9-9.1 41.5-23.8l112-192c8.7-14.9 8.7-33.4 0-48.4l-112-192zM400 448H176L64 256 176 64h224l112 192-112 192zm16-208v32c0 6.6-5.4 12-12 12h-88v88c0 6.6-5.4 12-12 12h-32c-6.6 0-12-5.4-12-12v-88h-88c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h88v-88c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v88h88c6.6 0 12 5.4 12 12z"
  ]
};
export const faPlusOctagon = {
  prefix: "far",
  iconName: "plus-octagon",
  icon: [
    512,
    512,
    [],
    "f301",
    "M497.9 150.5L361.5 14.1c-9-9-21.2-14.1-33.9-14.1H184.5c-12.7 0-24.9 5.1-33.9 14.1L14.1 150.5c-9 9-14.1 21.2-14.1 33.9v143.1c0 12.7 5.1 24.9 14.1 33.9l136.5 136.5c9 9 21.2 14.1 33.9 14.1h143.1c12.7 0 24.9-5.1 33.9-14.1L498 361.4c9-9 14.1-21.2 14.1-33.9v-143c-.1-12.8-5.2-25-14.2-34zm-33.9 177L327.5 464h-143L48 327.5v-143L184.5 48h143.1L464 184.5v143zM384 240v32c0 6.6-5.4 12-12 12h-88v88c0 6.6-5.4 12-12 12h-32c-6.6 0-12-5.4-12-12v-88h-88c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h88v-88c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v88h88c6.6 0 12 5.4 12 12z"
  ]
};
export const faPlusSquare = {
  prefix: "far",
  iconName: "plus-square",
  icon: [
    448,
    512,
    [],
    "f0fe",
    "M352 240v32c0 6.6-5.4 12-12 12h-88v88c0 6.6-5.4 12-12 12h-32c-6.6 0-12-5.4-12-12v-88h-88c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h88v-88c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v88h88c6.6 0 12 5.4 12 12zm96-160v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
  ]
};
export const faPodcast = {
  prefix: "far",
  iconName: "podcast",
  icon: [
    512,
    512,
    [],
    "f2ce",
    "M299.429 488.563C294.286 507.573 274.858 512 256 512c-18.857 0-38.286-4.427-43.428-23.437C204.927 460.134 192 388.898 192 355.75c0-35.156 31.142-43.75 64-43.75s64 8.594 64 43.75c0 32.949-12.871 104.179-20.571 132.813zM144 232c0-61.19 48.953-110.852 109.88-111.98 61.961-1.147 114.04 49.862 114.12 111.833.035 27.659-9.892 53.792-28.077 74.313-1.843 2.08-2.077 5.144-.48 7.418 5.296 7.541 8.981 16.176 10.931 25.69.947 4.623 6.573 6.453 10.003 3.211 29.469-27.847 47.806-67.348 47.623-111.136-.352-84.131-69.885-152.428-154.01-151.337C170.968 81.09 104 148.724 104 232c0 43.523 18.297 82.768 47.614 110.476 3.434 3.246 9.064 1.427 10.013-3.203 1.949-9.514 5.635-18.149 10.931-25.69 1.596-2.272 1.365-5.335-.477-7.413C153.926 285.685 144 259.607 144 232zM256.503.001C126.406-.271 21.207 103.688 20.01 233.78c-.902 98.093 58.054 182.512 142.555 218.984 4.388 1.894 9.108-1.9 8.253-6.602a985.559 985.559 0 0 1-5.517-33.559 6.014 6.014 0 0 0-3.088-4.407C102.605 375.626 60 311.84 60 236c0-108.321 87.662-196 196-196 108.321 0 196 87.661 196 196 0 74.634-41.538 139.051-102.213 172.196a6.01 6.01 0 0 0-3.088 4.406 986.377 986.377 0 0 1-5.517 33.559c-.855 4.703 3.866 8.496 8.255 6.602C433.298 416.566 492 333.145 492 236 492 105.828 386.611.272 256.503.001zM256 160c-35.346 0-64 28.654-64 64s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64z"
  ]
};
export const faPodium = {
  prefix: "far",
  iconName: "podium",
  icon: [
    448,
    512,
    [],
    "f680",
    "M432 160H112c0-33.85 21.22-62.69 52.02-74.35C172.92 110.29 196.29 128 224 128h32c35.35 0 64-28.65 64-64S291.35 0 256 0h-32c-24.63 0-45.77 14.07-56.47 34.47C108.63 45.94 64 97.8 64 160H16c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h51.02l23.71 256H48c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h352c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16h-42.73l23.71-256H432c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16zM224 48h32c8.82 0 16 7.18 16 16s-7.18 16-16 16h-32c-8.82 0-16-7.18-16-16s7.18-16 16-16zm85.04 416H138.96l-23.71-256h217.5l-23.71 256z"
  ]
};
export const faPodiumStar = {
  prefix: "far",
  iconName: "podium-star",
  icon: [
    448,
    512,
    [],
    "f758",
    "M186 338.3l-6.2 36.4c-1.1 6.6 5.8 11.5 11.6 8.4l32.6-17.2 32.6 17.2c5.8 3 12.7-1.8 11.6-8.4l-6.2-36.4 26.4-25.7c4.7-4.6 2.1-12.7-4.4-13.6l-36.5-5.3-16.3-33.1c-2.9-5.9-11.4-6-14.3 0l-16.3 33.1-36.5 5.3c-6.5.9-9.2 9-4.4 13.6l26.3 25.7zM432 160H112c0-33.8 21.2-62.7 52-74.3 8.9 24.6 32.3 42.3 60 42.3h32c35.3 0 64-28.7 64-64S291.3 0 256 0h-32c-24.6 0-45.8 14.1-56.5 34.5C108.6 45.9 64 97.8 64 160H16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h51l23.7 256H48c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h352c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16h-42.7L381 208h51c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zM224 48h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16s7.2-16 16-16zm85 416H139l-23.7-256h217.5L309 464z"
  ]
};
export const faPoliceBox = {
  prefix: "far",
  iconName: "police-box",
  icon: [
    384,
    512,
    [],
    "e021",
    "M184,208V180H148v36h28A8.00039,8.00039,0,0,0,184,208Zm-44-72H112a8.00039,8.00039,0,0,0-8,8v28h36Zm-28,80h28V180H104v28A8.00039,8.00039,0,0,0,112,216Zm72-72a8.00039,8.00039,0,0,0-8-8H148v36h36ZM112,320h64a8.00039,8.00039,0,0,0,8-8V248a8.00039,8.00039,0,0,0-8-8H112a8.00039,8.00039,0,0,0-8,8v64A8.00039,8.00039,0,0,0,112,320ZM280,208V180H244v36h28A8.00039,8.00039,0,0,0,280,208Zm0-64a8.00039,8.00039,0,0,0-8-8H244v36h36Zm-72,72h28V180H200v28A8.00039,8.00039,0,0,0,208,216Zm28-80H208a8.00039,8.00039,0,0,0-8,8v28h36ZM368,464H352V88a23.99869,23.99869,0,0,0-24-24h-8.02148V48a15.99829,15.99829,0,0,0-16-16H216V16A15.99954,15.99954,0,0,0,200,0H184a15.99954,15.99954,0,0,0-16,16V32H80A15.99954,15.99954,0,0,0,64,48V64H56A23.99993,23.99993,0,0,0,32,88V464H16A15.99954,15.99954,0,0,0,0,480v16a16.00079,16.00079,0,0,0,16,16H368a16.00079,16.00079,0,0,0,16-16V480A15.99954,15.99954,0,0,0,368,464Zm-64,0H80V112H304Z"
  ]
};
export const faPoll = {
  prefix: "far",
  iconName: "poll",
  icon: [
    448,
    512,
    [],
    "f681",
    "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm0 400H48V80h352v352zm-280-48h16c8.84 0 16-7.16 16-16V240c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v128c0 8.84 7.16 16 16 16zm96 0h16c8.84 0 16-7.16 16-16V144c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v224c0 8.84 7.16 16 16 16zm96 0h16c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16z"
  ]
};
export const faPollH = {
  prefix: "far",
  iconName: "poll-h",
  icon: [
    448,
    512,
    [],
    "f682",
    "M448 432V80c0-26.5-21.5-48-48-48H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48zm-400 0V80h352v352H48zm48-280v16c0 8.84 7.16 16 16 16h128c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16H112c-8.84 0-16 7.16-16 16zm0 96v16c0 8.84 7.16 16 16 16h224c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16H112c-8.84 0-16 7.16-16 16zm0 96v16c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16h-64c-8.84 0-16 7.16-16 16z"
  ]
};
export const faPollPeople = {
  prefix: "far",
  iconName: "poll-people",
  icon: [
    640,
    512,
    [],
    "f759",
    "M154.2 390.6c6.1-10.2 9.8-21.9 9.8-34.6 0-37.5-30.5-68-68-68s-68 30.5-68 68c0 12.7 3.7 24.4 9.8 34.6C15.1 405.1 0 430.4 0 459.2v14.4C0 494.8 17.2 512 38.4 512h115.2c21.2 0 38.4-17.2 38.4-38.4v-14.4c0-28.8-15.1-54.1-37.8-68.6zM96 336c11 0 20 9 20 20s-9 20-20 20-20-9-20-20 9-20 20-20zm48 128H48v-4.8c0-18.5 15.1-33.6 33.6-33.6h28.8c18.5 0 33.6 15.1 33.6 33.6v4.8zm10.2-361.4c6.1-10.2 9.8-21.9 9.8-34.6 0-37.5-30.5-68-68-68S28 30.5 28 68c0 12.7 3.7 24.4 9.8 34.6C15.1 117.1 0 142.4 0 171.2v14.4C0 206.8 17.2 224 38.4 224h115.2c21.2 0 38.4-17.2 38.4-38.4v-14.4c0-28.8-15.1-54.1-37.8-68.6zM96 48c11 0 20 9 20 20s-9 20-20 20-20-9-20-20 9-20 20-20zm48 128H48v-4.8c0-18.5 15.1-33.6 33.6-33.6h28.8c18.5 0 33.6 15.1 33.6 33.6v4.8zM616 32H248c-13.3 0-24 10.7-24 24v112c0 13.3 10.7 24 24 24h368c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24zm-24 112h-80V80h80v64zm24 176H248c-13.3 0-24 10.7-24 24v112c0 13.3 10.7 24 24 24h368c13.3 0 24-10.7 24-24V344c0-13.3-10.7-24-24-24zm-24 112H352v-64h240v64z"
  ]
};
export const faPoo = {
  prefix: "far",
  iconName: "poo",
  icon: [
    512,
    512,
    [],
    "f2fe",
    "M343.7 352H168.3c-5.8 0-9.8 5.7-7.8 11 10.5 27.9 58.4 53 95.5 53s85-25.1 95.5-53c2-5.3-2-11-7.8-11zM192 320c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm128-64c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm161.8 75.1c2.8-9.5 4.2-19.5 4.2-29.6 0-38.9-21-73-52.2-91.6.1-2 .2-3.9.2-5.9 0-37.9-21.2-71-52.4-87.9C376.5 51.2 322.1 0 256 0c-7.6 0-14.2.9-19.8 1.8-16.4 2.6-30.4 13.6-36.8 28.9-6.4 15.4-4.4 33 5.3 46.5 2.2 3 3.3 6.3 3.3 9.8 0 9.4-7.6 17-17 17h-13c-55.1 0-100 44.9-100 100 0 2 .1 4 .2 5.9C47 228.5 26 262.6 26 301.5c0 10.2 1.4 20.2 4.2 29.6C11.4 350.4 0 376.7 0 405.5 0 464.2 47.8 512 106.5 512h299c58.7 0 106.5-47.8 106.5-106.5 0-28.8-11.4-55.1-30.2-74.4zM405.5 464h-299C74.2 464 48 437.8 48 405.5c0-29.1 21.4-53.1 49.3-57.6C83.2 337.2 74 320.5 74 301.5c0-32.3 26.2-58.5 58.5-58.5h11.4c-10.9-9.5-17.9-23.4-17.9-39 0-28.7 23.3-52 52-52h13c35.9 0 65-29.1 65-65 0-14.1-4.6-27.1-12.3-37.8 4-.6 8.1-1.2 12.3-1.2 43.1 0 78 34.9 78 78 0 9.2-1.9 17.8-4.8 26h4.8c28.7 0 52 23.3 52 52 0 15.6-7 29.5-17.9 39h11.4c32.3 0 58.5 26.2 58.5 58.5 0 19-9.2 35.7-23.3 46.4 27.9 4.5 49.3 28.4 49.3 57.6 0 32.3-26.2 58.5-58.5 58.5z"
  ]
};
export const faPooStorm = {
  prefix: "far",
  iconName: "poo-storm",
  icon: [
    448,
    512,
    [],
    "f75a",
    "M400 192.4v-.4c0-38.2-22.5-71.3-54.9-86.8C337.8 46 287.2 0 226 0c-7.8 0-14.7 1.1-18.8 1.7-16.5 2.6-30.4 13.5-36.8 28.9-6.4 15.4-4.4 33 5.3 46.5 1.5 2.1 2.3 4.5 2.3 6.9 0 6.6-5.4 12-12 12h-22c-52.9 0-96 43.1-96 96v.4C19.2 210.9 0 243.3 0 280c0 57.3 46.7 104 104 104h24.3c.1-.6 0-1.2 0-1.8l6.2-46.2H104c-30.9 0-56-25.1-56-56s25.1-56 56-56h4.5c-7.7-8.5-12.5-19.7-12.5-32 0-26.5 21.5-48 48-48h22c33.1 0 60-26.9 60-60 0-13-4.3-25-11.3-34.9 3.7-.6 7.5-1.1 11.3-1.1 39.8 0 72 32.2 72 72 0 8.5-1.7 16.5-4.4 24H304c26.5 0 48 21.5 48 48 0 12.3-4.8 23.5-12.5 32h4.5c30.9 0 56 25.1 56 56 0 28.9-22 52.4-50 55.4 3.4 11.5 2.2 24.1-3.9 34.6l-8.1 14h6c57.3 0 104-46.7 104-104 0-36.7-19.2-69.1-48-87.6zM308 336h-57.7l17.3-64.9c2-7.6-3.7-15.1-11.6-15.1h-68c-6 0-11.1 4.5-11.9 10.4l-16 120c-1 7.2 4.6 13.6 11.9 13.6h59.3l-23 97.2c-1.8 7.6 4 14.8 11.7 14.8 4.2 0 8.2-2.2 10.4-6l88-152c4.6-8-1.2-18-10.4-18z"
  ]
};
export const faPoop = {
  prefix: "far",
  iconName: "poop",
  icon: [
    512,
    512,
    [],
    "f619",
    "M481.81 331.15c2.76-9.5 4.19-19.46 4.19-29.65 0-38.9-20.96-72.99-52.18-91.58.12-1.97.18-3.94.18-5.92 0-37.92-21.21-70.97-52.39-87.92C376.54 51.22 322.14 0 256 0c-7.63 0-14.23.95-19.81 1.83a47.993 47.993 0 0 0-36.76 28.92 48.01 48.01 0 0 0 5.3 46.47C206.9 80.25 208 83.54 208 87c0 9.37-7.63 17-17 17h-13c-55.14 0-100 44.86-100 100 0 1.98.06 3.96.18 5.92C46.96 228.51 26 262.6 26 301.5c0 10.19 1.44 20.15 4.19 29.65C11.36 350.38 0 376.68 0 405.5 0 464.22 47.78 512 106.5 512h299c58.72 0 106.5-47.78 106.5-106.5 0-28.82-11.36-55.12-30.19-74.35zM405.5 464h-299C74.19 464 48 437.81 48 405.5c0-29.15 21.38-53.12 49.27-57.57C83.22 337.24 74 320.52 74 301.5c0-32.31 26.19-58.5 58.5-58.5h11.44c-10.9-9.53-17.94-23.38-17.94-39 0-28.72 23.28-52 52-52h13c35.9 0 65-29.1 65-65 0-14.12-4.62-27.1-12.27-37.76C247.75 48.6 251.8 48 256 48c43.08 0 78 34.92 78 78 0 9.17-1.87 17.83-4.78 26H334c28.72 0 52 23.28 52 52 0 15.62-7.03 29.47-17.94 39h11.44c32.31 0 58.5 26.19 58.5 58.5 0 19.02-9.22 35.74-23.27 46.43 27.89 4.45 49.27 28.42 49.27 57.57 0 32.31-26.19 58.5-58.5 58.5z"
  ]
};
export const faPopcorn = {
  prefix: "far",
  iconName: "popcorn",
  icon: [
    512,
    512,
    [],
    "f819",
    "M422.06 113.61c-5.57-34.13-30.33-53.78-50-61.32-11.16-16.85-34.37-36.17-67.58-35.77A80.37 80.37 0 0 0 255.57 0a78.42 78.42 0 0 0-48.39 16.52c-20.08-.33-49.35 7.9-67.7 35.78a80.15 80.15 0 0 0-50.21 61.36C60.35 140 60.84 173.53 68.34 195.94v.38l39.36 288A32.05 32.05 0 0 0 139.45 512h232.69a32 32 0 0 0 31.78-27.68L443 198.46c13.56-37.63-2.83-68.46-20.94-84.85zM153.45 464l-35-256h50.39l21.38 256zm119.65 0h-34.6l-21.39-256h77.37zm85 0h-36.74l21.38-256h50.39zM114.42 160c7.38-16.75 21.92-18.55 25.59-18.91a30.59 30.59 0 0 1 .25-29.51c10.3-19 29.91-16.79 34.14-15.9a31.58 31.58 0 0 1 21.73-29.5 30.59 30.59 0 0 1 29.08 5c1-3.55 8.08-23.23 30.36-23.23 21.49 0 30.57 18.91 30.57 23.23a31.15 31.15 0 0 1 29.3-5 31.56 31.56 0 0 1 21.75 29.5c4.23-.89 23.86-3.09 34.12 15.9a32 32 0 0 1 .27 29.51c7.69.77 19.37 4.79 25.58 18.91z"
  ]
};
export const faPortalEnter = {
  prefix: "far",
  iconName: "portal-enter",
  icon: [
    512,
    512,
    [],
    "e022",
    "M416,0c-38.68751,0-83.877,34.86808-93.9043,188.8126l-.002-.00586a88.19428,88.19428,0,0,0-64.8125-60.23254l-78.25-17.70258a87.4657,87.4657,0,0,0-73.25,16.21825l-48.375,37.35824a24.00841,24.00841,0,1,0,29.375,37.98321l48.375-37.37386a40.34188,40.34188,0,0,1,33.3125-7.37477l14.875,3.37489-35.3125,87.34109a55.77113,55.77113,0,0,0,23,68.90415l83.78124,50.5922a8.84284,8.84284,0,0,1,3.84376,6.84354,8.72041,8.72041,0,0,1-.3125,2.20306L225.06249,481.40718a23.97436,23.97436,0,0,0,16.46876,29.671,24.99565,24.99565,0,0,0,6.625.92185,23.98662,23.98662,0,0,0,23.0625-17.42134l33.3125-104.46557A56.10341,56.10341,0,0,0,279.625,326.7869L227.78125,295.491l41.9375-104.79367a39.09378,39.09378,0,0,1,6.40625,12.06213l13.96875,45.9361c7.21874,23.67115,28.6875,39.04568,53.40625,39.13943l48.40625.15624H392a23.986,23.986,0,0,0,24-23.90552c.06249-13.26522-10.65625-23.48366-23.93751-23.53053l-23.88085-.084C370.01953,132.87485,390.69922,47.99854,416,47.99854c26.50977,0,48,93.12215,48,207.99365s-21.49023,207.99365-48,207.99365c-21.35352,0-39.42773-60.45909-45.66016-143.99561h-48.4375C328.01367,418.1845,350.87305,511.98438,416,511.98438c43.79492,0,96-44.41271,96-255.99219C512,139.20864,495.3457,0,416,0ZM272.15625,95.99707A47.99855,47.99855,0,1,0,224.125,47.99854,48.02832,48.02832,0,0,0,272.15625,95.99707Zm-146,220.85264L106.3125,363.12954a8.0132,8.0132,0,0,1-7.34375,4.85923H24a23.99927,23.99927,0,1,0,0,47.99854H98.96875a55.99645,55.99645,0,0,0,51.5-33.93647L164,350.44243l-9.5625-5.76545A87.55881,87.55881,0,0,1,126.15625,316.84971Z"
  ]
};
export const faPortalExit = {
  prefix: "far",
  iconName: "portal-exit",
  icon: [
    512,
    512,
    [],
    "e023",
    "M368.156,95.99707a47.99855,47.99855,0,1,0-48.03125-47.999A48.02823,48.02823,0,0,0,368.156,95.99707ZM488.06226,239.99219l-48.40625-.17188a7.91188,7.91188,0,0,1-7.59375-5.65527l-13.96875-45.3584a88.19461,88.19461,0,0,0-64.8125-60.23242l-78.24988-17.70313a87.467,87.467,0,0,0-73.25,16.21875L184.996,140.05273C174.35925,63.17188,149.42383,0,96,0,52.20508,0,0,44.41113,0,255.99219,0,372.77344,16.65625,511.98438,96,511.98438c24.63281,0,51.92773-14.05274,71.0957-63.998H114.46484c-5.68554,10.27929-11.91992,16-18.46484,16-26.50977,0-48-93.12305-48-207.99414S69.49023,47.99805,96,47.99805s48,93.123,48,207.99414c0,41.44629-2.94531,79.58984-7.77539,111.99609H120a23.99951,23.99951,0,1,0,0,47.999h74.96863a55.997,55.997,0,0,0,51.5-33.93652l13.53125-31.6084-9.5625-5.76562a87.55746,87.55746,0,0,1-28.28125-27.82715l-19.84375,46.28027a8.01229,8.01229,0,0,1-7.34375,4.8584h-9.459c4.0586-30.835,6.49024-67.499,6.49024-111.99609,0-19.43067-.52344-39.47559-1.65821-59.40235l40.81446-31.53222a40.3409,40.3409,0,0,1,33.3125-7.375l14.875,3.375-35.3125,87.34082a55.77154,55.77154,0,0,0,23,68.90429l83.78113,50.5918a8.84316,8.84316,0,0,1,3.84375,6.84375,8.721,8.721,0,0,1-.3125,2.20313L321.06226,481.40723A23.97414,23.97414,0,0,0,337.531,511.07812,24.99489,24.99489,0,0,0,344.156,512a23.98672,23.98672,0,0,0,23.0625-17.42188L400.531,390.11328a56.1032,56.1032,0,0,0-24.90625-63.32617L323.781,295.49121l41.9375-104.79394a39.09522,39.09522,0,0,1,6.40625,12.0625l13.96875,45.373A55.77866,55.77866,0,0,0,439.49976,287.835l48.40625.15625h.09375a23.99955,23.99955,0,0,0,.0625-47.999Z"
  ]
};
export const faPortrait = {
  prefix: "far",
  iconName: "portrait",
  icon: [
    384,
    512,
    [],
    "f3e0",
    "M336 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zm0 464H48V48h288v416zM192 256c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm-89.6 128h179.2c12.4 0 22.4-8.6 22.4-19.2v-19.2c0-31.8-30.1-57.6-67.2-57.6h-5c-12.3 5.1-25.7 8-39.8 8s-27.6-2.9-39.8-8h-5c-37.1 0-67.2 25.8-67.2 57.6v19.2c0 10.6 10 19.2 22.4 19.2z"
  ]
};
export const faPoundSign = {
  prefix: "far",
  iconName: "pound-sign",
  icon: [
    320,
    512,
    [],
    "f154",
    "M308 360h-30.284c-6.627 0-12 5.373-12 12v56.835H112V280h100c6.627 0 12-5.373 12-12v-24c0-6.627-5.373-12-12-12H112v-77.081c0-37.438 26.786-67.388 72.958-67.388 25.94 0 48.692 11.882 60.552 19.451 5.141 3.28 11.923 2.156 15.758-2.586l19.658-24.305c4.35-5.378 3.262-13.296-2.365-17.32C262.736 51.456 229.027 32 184.334 32 105.716 32 48 83.164 48 152.423V232H20c-6.627 0-12 5.373-12 12v24c0 6.627 5.373 12 12 12h28v148.835H12c-6.627 0-12 5.373-12 12V468c0 6.627 5.373 12 12 12h296c6.627 0 12-5.373 12-12v-96c0-6.627-5.373-12-12-12z"
  ]
};
export const faPowerOff = {
  prefix: "far",
  iconName: "power-off",
  icon: [
    512,
    512,
    [],
    "f011",
    "M388.5 46.3C457.9 90.3 504 167.8 504 256c0 136.8-110.8 247.7-247.5 248C120 504.3 8.2 393 8 256.4 7.9 168 54 90.3 123.5 46.3c5.8-3.7 13.5-1.8 16.9 4.2l11.8 20.9c3.1 5.5 1.4 12.5-3.9 15.9C92.8 122.9 56 185.1 56 256c0 110.5 89.5 200 200 200s200-89.5 200-200c0-70.9-36.8-133.1-92.3-168.6-5.3-3.4-7-10.4-3.9-15.9l11.8-20.9c3.3-6.1 11.1-7.9 16.9-4.3zM280 276V12c0-6.6-5.4-12-12-12h-24c-6.6 0-12 5.4-12 12v264c0 6.6 5.4 12 12 12h24c6.6 0 12-5.4 12-12z"
  ]
};
export const faPray = {
  prefix: "far",
  iconName: "pray",
  icon: [
    384,
    512,
    [],
    "f683",
    "M256 128c35.35 0 64-28.65 64-64S291.35 0 256 0s-64 28.65-64 64 28.65 64 64 64zm-22.28 159.48a28.1 28.1 0 0 0 19.31 10.89c7.59.83 15.31-1.55 21.16-6.56l100-82.54c11.75-10.05 13.16-27.73 3.09-39.48-10.06-11.75-27.81-13.11-39.47-3.08l-77.47 63.27-46.69-61.38c-12.5-17.14-32.44-26.14-53.47-24.38-21.03 1.89-39.19 14.47-49.06 34.86l-47 109.41c-20.47 41.95-7.09 93.28 31.06 119.41L165.5 456H28c-15.47 0-28 12.53-28 28s12.53 28 28 28h228c5.57 0 32-4.93 32-32 0-8.51-3.37-17-10.06-23.3L158.53 344.33l44.03-97.82 31.16 40.97z"
  ]
};
export const faPrayingHands = {
  prefix: "far",
  iconName: "praying-hands",
  icon: [
    640,
    512,
    [],
    "f684",
    "M620.1 364.4c10.1 2.5 19.9-5.1 19.9-15.5v-16.5c0-7.4-5-13.8-12.1-15.5l-67.9-17v-66.3c0-21.2-6-42-17.3-59.9L452.9 33.6C439.7 12.7 416.7 0 392 0c-13.6 0-26.8 3.8-38.4 11.1-18.9 11.9-31.1 31.6-33.3 54.3-.2 1.8-.3 3.5-.3 5.2 0-1.7-.1-3.4-.3-5.2-2.2-22.8-14.4-42.4-33.3-54.3C274.9 3.9 261.6 0 248 0c-24.7 0-47.7 12.7-60.9 33.6L97.3 173.7C86 191.6 80 212.4 80 233.6v66.3l-67.9 17C5 318.6 0 325 0 332.4v16.5c0 10.4 9.8 18.1 19.9 15.5l108.1-27V233.6c0-12.1 3.4-24 9.9-34.2l89.8-140.1c7.6-12.1 24.2-15 35.5-5.8 9.6 7.8 10.9 22.2 4.2 32.8l-57.6 89c-6.5 10.2-9.9 22.1-9.9 34.2V286c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-56c0-13.3 10.8-24 24-24s24 10.8 24 24v69.1c0 55.1-37.5 103.2-90.9 116.6L12 464c-7 1.7-12 8.1-12 15.5V496c0 10.4 9.8 18.1 19.9 15.5l196.9-49.3c44.6-11.2 80.9-39.8 103.3-77.3 22.3 37.5 58.7 66.1 103.3 77.3l196.9 49.3c10.1 2.5 19.9-5.1 19.9-15.5v-16.5c0-7.4-5-13.8-12.1-15.5l-193-48.3c-53.4-13.4-90.9-61.4-90.9-116.5V230c0-13.3 10.8-24 24-24s24 10.8 24 24v56c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-76.6c0-12.1-3.4-24-9.9-34.2l-57.6-89c-6.6-10.5-5.4-24.9 4.2-32.8 11.3-9.2 27.9-6.3 35.5 5.8l89.8 140.1c6.5 10.2 9.9 22.1 9.9 34.2v103.8zM320 176.7c-11.5-10.4-26.2-17.4-42.6-18.6l29.9-47.4c7.6-12.1 12.4-24.4 12.6-38.1.2 13.7 5 26 12.6 38.1l29.9 47.4c-16.2 1.2-30.9 8.2-42.4 18.6z"
  ]
};
export const faPrescription = {
  prefix: "far",
  iconName: "prescription",
  icon: [
    384,
    512,
    [],
    "f5b1",
    "M289.94 352l89.37-89.37c6.25-6.25 6.25-16.38 0-22.63L368 228.69c-6.25-6.25-16.38-6.25-22.63 0L256 318.06l-94.24-94.24c52.19-.96 94.24-43.4 94.24-95.82 0-53.02-42.98-96-96-96H16C7.16 32 0 39.16 0 48v256c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-80h46.06l128 128-89.37 89.37c-6.25 6.25-6.25 16.38 0 22.63L144 475.31c6.25 6.25 16.38 6.25 22.63 0L256 385.94l89.37 89.37c6.25 6.25 16.38 6.25 22.63 0L379.31 464c6.25-6.25 6.25-16.38 0-22.63L289.94 352zM48 176V80h112c26.47 0 48 21.53 48 48s-21.53 48-48 48H48z"
  ]
};
export const faPrescriptionBottle = {
  prefix: "far",
  iconName: "prescription-bottle",
  icon: [
    448,
    512,
    [],
    "f485",
    "M416 0H32C14.3 0 0 14.3 0 32v96c0 8.8 7.2 16 16 16h16v336c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V144h16c8.8 0 16-7.2 16-16V32c0-17.7-14.3-32-32-32zM48 48h352v48H48V48zm320 416H80v-40h88c4.4 0 8-3.6 8-8v-32c0-4.4-3.6-8-8-8H80v-48h88c4.4 0 8-3.6 8-8v-32c0-4.4-3.6-8-8-8H80v-48h88c4.4 0 8-3.6 8-8v-32c0-4.4-3.6-8-8-8H80v-40h288v320z"
  ]
};
export const faPrescriptionBottleAlt = {
  prefix: "far",
  iconName: "prescription-bottle-alt",
  icon: [
    448,
    512,
    [],
    "f486",
    "M136 320h56v56c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-56h56c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8h-56v-56c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v56h-56c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zM416 0H32C14.3 0 0 14.3 0 32v96c0 8.8 7.2 16 16 16h16v336c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V144h16c8.8 0 16-7.2 16-16V32c0-17.7-14.3-32-32-32zm-48 464H80V144h288v320zm32-368H48V48h352v48z"
  ]
};
export const faPresentation = {
  prefix: "far",
  iconName: "presentation",
  icon: [
    576,
    512,
    [],
    "f685",
    "M560 0H16C7.16 0 0 7.16 0 16v16c0 8.84 7.16 16 16 16h16v272c0 17.67 14.33 32 32 32h200v43.72l-77.65 77.65c-6.25 6.25-6.25 16.38 0 22.63l11.31 11.31c6.25 6.25 16.38 6.25 22.63 0L288 439.6l67.72 67.72c6.25 6.25 16.38 6.25 22.63 0l11.3-11.32c6.25-6.25 6.25-16.38 0-22.63L312 395.72V352h200c17.67 0 32-14.33 32-32V48h16c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16zm-64 304H80V48h416v256z"
  ]
};
export const faPrint = {
  prefix: "far",
  iconName: "print",
  icon: [
    512,
    512,
    [],
    "f02f",
    "M400 264c-13.25 0-24 10.74-24 24 0 13.25 10.75 24 24 24s24-10.75 24-24c0-13.26-10.75-24-24-24zm32-88V99.88c0-12.73-5.06-24.94-14.06-33.94l-51.88-51.88c-9-9-21.21-14.06-33.94-14.06H110.48C93.64 0 80 14.33 80 32v144c-44.18 0-80 35.82-80 80v128c0 8.84 7.16 16 16 16h64v96c0 8.84 7.16 16 16 16h320c8.84 0 16-7.16 16-16v-96h64c8.84 0 16-7.16 16-16V256c0-44.18-35.82-80-80-80zM128 48h192v48c0 8.84 7.16 16 16 16h48v64H128V48zm256 416H128v-64h256v64zm80-112H48v-96c0-17.64 14.36-32 32-32h352c17.64 0 32 14.36 32 32v96z"
  ]
};
export const faPrintSearch = {
  prefix: "far",
  iconName: "print-search",
  icon: [
    640,
    512,
    [],
    "f81a",
    "M128 464v-64h163.43a174.58 174.58 0 0 1-16.37-48H48v-96a32 32 0 0 1 32-32h220.68a177.28 177.28 0 0 1 46.45-48H128V48h192v48a16 16 0 0 0 16 16h48v44.22a174.63 174.63 0 0 1 48-11.41V99.88a48 48 0 0 0-14.06-33.94l-51.88-51.88A48 48 0 0 0 332.12 0H110.48C93.64 0 80 14.33 80 32v144a80 80 0 0 0-80 80v128a16 16 0 0 0 16 16h64v96a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-.81A174.82 174.82 0 0 1 347.13 464zm507.31 9.38l-81.46-81.46a128.12 128.12 0 1 0-33.94 33.93l81.47 81.46a16 16 0 0 0 22.62 0L635.31 496a16 16 0 0 0 0-22.62zM448 400a80 80 0 1 1 80-80 80 80 0 0 1-80 80z"
  ]
};
export const faPrintSlash = {
  prefix: "far",
  iconName: "print-slash",
  icon: [
    640,
    512,
    [],
    "f686",
    "M451.91 267.74l34.7 27.13c.68-2.21 1.39-4.43 1.39-6.87 0-13.26-10.75-24-24-24-4.51 0-8.49 1.58-12.09 3.74zM192 48h192v48c0 8.84 7.16 16 16 16h48v64H334.57l61.4 48H496c17.64 0 32 14.36 32 32v71.23l48 37.53V256c0-44.18-35.82-80-80-80V99.88c0-12.73-5.06-24.94-14.06-33.94l-51.88-51.88c-9-9-21.21-14.06-33.94-14.06H174.48c-15.37 0-27.55 12.14-29.64 27.67L192 64.54V48zm441.99 423.02L36 3.51C29.1-2.01 19.03-.9 13.51 6l-10 12.49C-2.02 25.39-.9 35.46 6 40.98l598 467.51c6.9 5.52 16.96 4.4 22.49-2.49l10-12.49c5.52-6.9 4.41-16.97-2.5-22.49zM448 464H192v-64h195.3l-61.4-48H112v-96c0-17.64 14.36-32 32-32h18.18l-51.7-40.42C83.1 196.29 64 223.83 64 256v128c0 8.84 7.16 16 16 16h64v96c0 8.84 7.16 16 16 16h320c8.84 0 16-7.16 16-16v-11.02l-48-37.53V464z"
  ]
};
export const faProcedures = {
  prefix: "far",
  iconName: "procedures",
  icon: [
    640,
    512,
    [],
    "f487",
    "M520 240H312c-22.1 0-40 17.9-40 40v136H48V136c0-4.4-3.6-8-8-8H8c-4.4 0-8 3.6-8 8v368c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8v-40h544v40c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V360c0-66.2-53.8-120-120-120zm72 176H320V288h200c39.7 0 72 32.3 72 72v56zm-432-32c44.1 0 80-35.9 80-80s-35.9-80-80-80-80 35.9-80 80 35.9 80 80 80zm0-112c17.7 0 32 14.4 32 32s-14.3 32-32 32-32-14.4-32-32 14.3-32 32-32zm-16-144h114.3l36.9 73.9c4.1 8.2 15.7 8.2 19.8 0l54.1-108.2 17.2 34.3H504c13.2 0 24-10.7 24-24s-10.8-24-24-24h-88L379.1 6.1C375-2 363.3-2 359.3 6.1l-54.1 108.2L288 80H144c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16z"
  ]
};
export const faProjectDiagram = {
  prefix: "far",
  iconName: "project-diagram",
  icon: [
    640,
    512,
    [],
    "f542",
    "M608 0H480c-17.67 0-32 14.33-32 32v32H192V32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v128c0 17.67 14.33 32 32 32h95.72L224 360.12V480c0 17.67 14.33 32 32 32h128c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32H274.76L192 175.5V128h256v32c0 17.67 14.33 32 32 32h128c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32zM144 144H48V48h96v96zm128 224h96v96h-96v-96zm320-224h-96V48h96v96z"
  ]
};
export const faProjector = {
  prefix: "far",
  iconName: "projector",
  icon: [
    640,
    512,
    [],
    "f8d6",
    "M307.72 133.65a16 16 0 0 0 22.63 0l11.31-11.31a16 16 0 0 0 0-22.62l-67.88-67.89a16 16 0 0 0-22.63 0l-11.31 11.31a16 16 0 0 0 0 22.63zM408 128h16a16 16 0 0 0 16-16V16a16 16 0 0 0-16-16h-16a16 16 0 0 0-16 16v96a16 16 0 0 0 16 16zm93.65 5.65a16 16 0 0 0 22.63 0l67.88-67.88a16 16 0 0 0 0-22.63l-11.31-11.31a16 16 0 0 0-22.63 0l-67.88 67.89a16 16 0 0 0 0 22.62zM112 296a24 24 0 1 0 24 24 24 24 0 0 0-24-24zm480-104H480.58c-19.51-9.89-41.25-16-64.58-16s-45.07 6.11-64.58 16H48a48 48 0 0 0-48 48v160a48 48 0 0 0 48 48h16l13 51.88A16 16 0 0 0 92.49 512h23A16 16 0 0 0 131 499.88L144 448h207.42c19.51 9.89 41.25 16 64.58 16s45.07-6.11 64.58-16H496l13 51.88A16 16 0 0 0 524.49 512h23A16 16 0 0 0 563 499.88L576 448h16a48 48 0 0 0 48-48V240a48 48 0 0 0-48-48zM296.38 400H48V240h248.38a143.45 143.45 0 0 0 0 160zM416 416a96 96 0 1 1 96-96 96.14 96.14 0 0 1-96 96zm176-16h-56.38a143.45 143.45 0 0 0 0-160H592zM176 296a24 24 0 1 0 24 24 24 24 0 0 0-24-24z"
  ]
};
export const faPumpMedical = {
  prefix: "far",
  iconName: "pump-medical",
  icon: [
    384,
    512,
    [],
    "e06a",
    "M186.67,293.33v-40A13.33,13.33,0,0,0,173.33,240H146.67a13.33,13.33,0,0,0-13.34,13.33v40h-40A13.33,13.33,0,0,0,80,306.67v26.66a13.33,13.33,0,0,0,13.33,13.34h40v40A13.33,13.33,0,0,0,146.67,400h26.66a13.33,13.33,0,0,0,13.34-13.33v-40h40A13.33,13.33,0,0,0,240,333.33V306.67a13.33,13.33,0,0,0-13.33-13.34ZM379.31,107.72,336,64.4A56,56,0,0,0,296.41,48H240V32A32,32,0,0,0,208,0H112A32,32,0,0,0,80,32v96.41a63.83,63.83,0,0,0-59.37,57.8L.27,442.21A64,64,0,0,0,64,512H256a64,64,0,0,0,63.74-69.79l-20.36-256A63.83,63.83,0,0,0,240,128.41V96h56.41a8,8,0,0,1,5.65,2.34l43.32,43.31a16,16,0,0,0,22.62,0l11.31-11.31A16,16,0,0,0,379.31,107.72ZM128,48h64v80H128ZM251.52,190l20.41,256.54A16,16,0,0,1,256,464H64a15.87,15.87,0,0,1-11.82-5.21A16.26,16.26,0,0,1,48.12,446L68.44,190.55A15.92,15.92,0,0,1,84.37,176H235.63A15.81,15.81,0,0,1,251.52,190Z"
  ]
};
export const faPumpSoap = {
  prefix: "far",
  iconName: "pump-soap",
  icon: [
    384,
    512,
    [],
    "e06b",
    "M152,244c-16.33,21.8-52,72.27-52,97.27,0,32.42,26.88,58.75,60,58.75s60-26.33,60-58.75c0-25-35.7-75.47-52-97.27A10,10,0,0,0,152,244ZM379.31,107.72,336,64.4A56,56,0,0,0,296.41,48H240V32A32,32,0,0,0,208,0H112A32,32,0,0,0,80,32v96.41a63.83,63.83,0,0,0-59.37,57.8L.27,442.21A64,64,0,0,0,64,512H256a64,64,0,0,0,63.74-69.79l-20.36-256A63.83,63.83,0,0,0,240,128.41V96h56.41a8,8,0,0,1,5.65,2.34l43.32,43.31a16,16,0,0,0,22.62,0l11.31-11.31A16,16,0,0,0,379.31,107.72ZM128,48h64v80H128ZM251.52,190l20.41,256.54A16,16,0,0,1,256,464H64a15.87,15.87,0,0,1-11.82-5.21A16.26,16.26,0,0,1,48.12,446L68.44,190.55A15.92,15.92,0,0,1,84.37,176H235.63A15.81,15.81,0,0,1,251.52,190Z"
  ]
};
export const faPumpkin = {
  prefix: "far",
  iconName: "pumpkin",
  icon: [
    576,
    512,
    [],
    "f707",
    "M494.59 104.28C455.6 67.15 396.8 62.07 352 89V35.81c0-6.06-3.42-11.6-8.84-14.31l-39.6-19.8c-8.37-4.19-18.54-.32-22.01 8.37l-26.7 66.74c-10.24 2.99-20.02 7.37-28.85 13.23-45.03-28.27-105.03-23.42-144.59 14.25C28.91 154.28 0 220.94 0 292s28.91 137.72 81.41 187.73c37.66 35.8 95.62 42.53 141.09 16.3 2.16-1.23 4.91-1.08 7.41.39C247.06 506.75 266.62 512 288 512s40.94-5.25 58.09-15.58c2.53-1.47 5.28-1.62 7.41-.39 45.44 26.23 103.41 19.52 141.09-16.31C547.09 429.72 576 363.06 576 292s-28.91-137.72-81.41-187.72zM288 468c-121.24 0-124.2-352 0-352 121.24 0 124.2 352 0 352zM48 292c0-78.07 65.15-207.18 148.15-163.44-53.33 80.86-53.27 246.17.07 326.98C113.56 499.3 48 371.25 48 292zm331.78 163.55c45.71-69.19 53.2-201.73 17.75-293.3-.95-1.66-5.01-14.45-17.67-33.68C463.09 84.82 528 213.66 528 292c0 78.38-65.67 207.34-148.22 163.55z"
  ]
};
export const faPuzzlePiece = {
  prefix: "far",
  iconName: "puzzle-piece",
  icon: [
    576,
    512,
    [],
    "f12e",
    "M437.983 261.352c-4.321 2.778-10.839 6.969-13.122 7.279-24.067-.092.757-103.841 5.813-124.714-29.614 5.697-134.448 26.337-159.932 7.046C271.197 132.585 304 116.55 304 73.588 304 28.222 261.986 0 216.994 0 171.147 0 112 25.756 112 75.063c0 40.881 28.702 64.642 31.994 74.559-.739 28.838-115.981 1.752-143.994-5.469v351.556C10.464 498.412 56.682 512 104 512c45.3-.001 88-15.737 88-60.854 0-31.773-32-45.657-32-73.834 0-16.521 29.235-27.063 49.361-27.063 21.125 0 46.639 11.414 46.639 25.588 0 24.02-32 36.882-32 77.924 0 66.838 81.555 58.073 134.44 51.225 37.039-4.797 33.159-3.906 73.069-3.906-2.799-8.954-28.061-81.125-13.892-100.4 10.021-13.639 39.371 31.32 84.037 31.32C548.715 432 576 380.487 576 336c0-57.793-45.975-133.814-138.017-74.648zM501.654 384c-24.507 0-37.496-32.763-79.116-32.763-35.286 0-67.12 27.143-53.431 104.031-19.03 2.234-84.249 12.922-96.329 2.29C261.633 447.771 304 419.385 304 375.837c0-46.326-49.475-73.588-94.639-73.588-46.686 0-97.361 27.417-97.361 75.063 0 50.809 41.414 70.396 29.601 79.554-16.851 13.064-71.854 5.122-93.601.935V204.584c63.934 10.948 144 9.33 144-55.435 0-31.802-32-45.775-32-74.086C160 58.488 199.338 48 216.994 48 233.19 48 256 55.938 256 73.588c0 23.524-33.264 36.842-33.264 77.924 0 60.396 86.897 58.813 146.508 51.68-6.592 53.714 1.669 113.439 55.691 113.439 31.223 0 45.141-28.631 75.22-28.631C517.407 288 528 315.957 528 336c0 21.606-12.157 48-26.346 48z"
  ]
};
export const faQrcode = {
  prefix: "far",
  iconName: "qrcode",
  icon: [
    448,
    512,
    [],
    "f029",
    "M0 224h192V32H0v192zM40 72h112v112H40V72zm216-40v192h192V32H256zm152 152H296V72h112v112zM0 480h192V288H0v192zm40-152h112v112H40V328zm32 32h48v48H72v-48zm0-256h48v48H72v-48zm304 48h-48v-48h48v48zm40 136h32v128H320v-32h-32v96h-32V288h96v32h64v-32zm0 160h32v32h-32v-32zm-64 0h32v32h-32v-32z"
  ]
};
export const faQuestion = {
  prefix: "far",
  iconName: "question",
  icon: [
    384,
    512,
    [],
    "f128",
    "M199.65 0C125.625 0 69.665 30.187 27.21 92.51c-19.17 28.15-12.94 66.3 14.17 86.86l36.73 27.85c10.81 8.2 24.19 12.79 37.74 12.96-11.84 19-17.82 40.61-17.82 64.55v11.43c0 16.38 6.2 31.34 16.38 42.65C97.99 357.2 88 381.45 88 408c0 57.35 46.65 104 104 104s104-46.65 104-104c0-26.55-9.99-50.8-26.41-69.19 8.66-9.62 14.43-21.87 15.97-35.38 28.287-16.853 96-48.895 96-138.21C381.56 71.151 290.539 0 199.65 0zM192 464c-30.88 0-56-25.12-56-56 0-30.873 25.118-56 56-56 30.887 0 56 25.132 56 56 0 30.88-25.12 56-56 56zm45.97-176.21v8.37c0 8.788-7.131 15.84-15.84 15.84h-60.26c-8.708 0-15.84-7.051-15.84-15.84v-11.43c0-47.18 35.77-66.04 62.81-81.2 23.18-13 37.39-21.83 37.39-39.04 0-22.77-29.04-37.88-52.52-37.88-30.61 0-44.74 14.49-64.6 39.56-5.365 6.771-15.157 8.01-22 2.8l-36.73-27.85c-6.74-5.11-8.25-14.6-3.49-21.59C98.08 73.73 137.8 48 199.65 48c64.77 0 133.91 50.56 133.91 117.22 0 88.51-95.59 89.87-95.59 122.57z"
  ]
};
export const faQuestionCircle = {
  prefix: "far",
  iconName: "question-circle",
  icon: [
    512,
    512,
    [],
    "f059",
    "M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 448c-110.532 0-200-89.431-200-200 0-110.495 89.472-200 200-200 110.491 0 200 89.471 200 200 0 110.53-89.431 200-200 200zm107.244-255.2c0 67.052-72.421 68.084-72.421 92.863V300c0 6.627-5.373 12-12 12h-45.647c-6.627 0-12-5.373-12-12v-8.659c0-35.745 27.1-50.034 47.579-61.516 17.561-9.845 28.324-16.541 28.324-29.579 0-17.246-21.999-28.693-39.784-28.693-23.189 0-33.894 10.977-48.942 29.969-4.057 5.12-11.46 6.071-16.666 2.124l-27.824-21.098c-5.107-3.872-6.251-11.066-2.644-16.363C184.846 131.491 214.94 112 261.794 112c49.071 0 101.45 38.304 101.45 88.8zM298 368c0 23.159-18.841 42-42 42s-42-18.841-42-42 18.841-42 42-42 42 18.841 42 42z"
  ]
};
export const faQuestionSquare = {
  prefix: "far",
  iconName: "question-square",
  icon: [
    448,
    512,
    [],
    "f2fd",
    "M448 80v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48zm-48 346V86a6 6 0 0 0-6-6H54a6 6 0 0 0-6 6v340a6 6 0 0 0 6 6h340a6 6 0 0 0 6-6zm-68.756-225.2c0 67.052-72.421 68.084-72.421 92.863V300c0 6.627-5.373 12-12 12h-45.647c-6.627 0-12-5.373-12-12v-8.659c0-35.745 27.1-50.034 47.579-61.516 17.561-9.845 28.324-16.541 28.324-29.579 0-17.246-21.999-28.693-39.784-28.693-23.189 0-33.894 10.977-48.942 29.969-4.057 5.12-11.46 6.071-16.666 2.124l-27.824-21.098c-5.107-3.872-6.251-11.066-2.644-16.363C152.846 131.491 182.94 112 229.794 112c49.071 0 101.45 38.304 101.45 88.8zM266 368c0 23.159-18.841 42-42 42s-42-18.841-42-42 18.841-42 42-42 42 18.841 42 42z"
  ]
};
export const faQuidditch = {
  prefix: "far",
  iconName: "quidditch",
  icon: [
    640,
    512,
    [],
    "f458",
    "M636.5 31L616.6 6c-5.5-6.9-15.6-8-22.5-2.6l-230.7 178-34.7-43.6c-4.8-6.1-14-6-18.8.1L252.2 211c-31.1.7-104 6.6-151.9 44.7C38.3 305 0 511.3 0 511.3c15.1.7 212.4 7.4 272.2-40.1 47.7-37.9 70-107.4 77.8-137.6l84.3-39.5c7-3.3 9.1-12.3 4.3-18.3l-35.3-44.3L634 53.5c6.9-5.5 8-15.6 2.5-22.5zM242.3 433.7c-16.6 13.2-74.3 28.5-182.8 30.2 4.8-19.1 10.1-38.2 15.8-56.4l45.3-36c5-3.9 1.2-11.9-5-10.6l-26.1 5.5c13.4-35.3 27.7-63 40.7-73.4 27-21.5 71.3-31 109.7-33.5l59.8 75c-9.3 31.2-28 75.9-57.4 99.2zm88-143.9l-39.8-49.9 24.2-30.8c2.4-3 7-3.1 9.4 0l43.8 54.9c2.4 3 1.4 7.5-2.1 9.2l-35.5 16.6zm181.8 29.9c-52.9 0-96 43-96 95.8s43.1 95.8 96 95.8 96-43 96-95.8-43.1-95.8-96-95.8zm0 143.8c-26.5 0-48-21.5-48-47.9s21.5-47.9 48-47.9 48 21.5 48 47.9-21.6 47.9-48 47.9z"
  ]
};
export const faQuoteLeft = {
  prefix: "far",
  iconName: "quote-left",
  icon: [
    576,
    512,
    [],
    "f10d",
    "M504 224h-56v-8c0-22.1 17.9-40 40-40h8c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48h-8c-101.5 0-184 82.5-184 184v192c0 39.7 32.3 72 72 72h128c39.7 0 72-32.3 72-72V296c0-39.7-32.3-72-72-72zm24 184c0 13.2-10.8 24-24 24H376c-13.2 0-24-10.8-24-24V216c0-75 61-136 136-136h8v48h-8c-48.5 0-88 39.5-88 88v56h104c13.2 0 24 10.8 24 24v112zM200 224h-56v-8c0-22.1 17.9-40 40-40h8c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48h-8C82.5 32 0 114.5 0 216v192c0 39.7 32.3 72 72 72h128c39.7 0 72-32.3 72-72V296c0-39.7-32.3-72-72-72zm24 184c0 13.2-10.8 24-24 24H72c-13.2 0-24-10.8-24-24V216c0-75 61-136 136-136h8v48h-8c-48.5 0-88 39.5-88 88v56h104c13.2 0 24 10.8 24 24v112z"
  ]
};
export const faQuoteRight = {
  prefix: "far",
  iconName: "quote-right",
  icon: [
    576,
    512,
    [],
    "f10e",
    "M200 32H72C32.3 32 0 64.3 0 104v112c0 39.7 32.3 72 72 72h56v8c0 22.1-17.9 40-40 40h-8c-26.5 0-48 21.5-48 48v48c0 26.5 21.5 48 48 48h8c101.5 0 184-82.5 184-184V104c0-39.7-32.3-72-72-72zm24 264c0 75-61 136-136 136h-8v-48h8c48.5 0 88-39.5 88-88v-56H72c-13.2 0-24-10.8-24-24V104c0-13.2 10.8-24 24-24h128c13.2 0 24 10.8 24 24v192zM504 32H376c-39.7 0-72 32.3-72 72v112c0 39.7 32.3 72 72 72h56v8c0 22.1-17.9 40-40 40h-8c-26.5 0-48 21.5-48 48v48c0 26.5 21.5 48 48 48h8c101.5 0 184-82.5 184-184V104c0-39.7-32.3-72-72-72zm24 264c0 75-61 136-136 136h-8v-48h8c48.5 0 88-39.5 88-88v-56H376c-13.2 0-24-10.8-24-24V104c0-13.2 10.8-24 24-24h128c13.2 0 24 10.8 24 24v192z"
  ]
};
export const faQuran = {
  prefix: "far",
  iconName: "quran",
  icon: [
    448,
    512,
    [],
    "f687",
    "M257.13 182.57l20.72 20.2-4.89 28.52c-.52 3.02 2.65 5.39 5.42 3.94L304 221.76l25.62 13.47c2.75 1.45 5.94-.9 5.42-3.94l-4.89-28.52 20.72-20.2c2.21-2.16.99-5.93-2.07-6.37l-28.64-4.16-12.81-25.95c-1.37-2.77-5.33-2.77-6.7 0l-12.81 25.95-28.64 4.16c-3.06.44-4.28 4.2-2.07 6.37zM232.66 304c12.31 0 24.53-2.23 36.03-6.53 5.59-1.88 9.34-7.06 9.34-12.94 0-7.52-6.12-13.64-13.69-13.64l-3.44.17c-39.19 0-71.06-31.88-71.06-71.06s31.88-71.06 71.06-71.06l3.44.17c6.47 0 12.09-4.59 13.38-10.89 1.34-6.59-2.25-13.12-8.59-15.55C257.28 98.25 245 96 232.66 96c-57.34 0-104 46.66-104 104s46.65 104 104 104zM448 384V16c0-8.8-7.2-16-16-16H80C35.8 0 0 35.8 0 80v352c0 44.2 35.8 80 80 80h352c8.8 0 16-7.2 16-16v-16c0-7.8-5.6-14.3-12.9-15.7-4.2-13-4.2-51.6 0-64.6 7.4-1.5 12.9-7.9 12.9-15.7zm-54 80H80c-17.7 0-32-14.3-32-32 0-17.6 14.4-32 32-32h314c-2.7 17.3-2.7 46.7 0 64zm6-112H80c-11.4 0-22.2 2.4-32 6.7V80c0-17.7 14.3-32 32-32h320v304z"
  ]
};
export const faRabbit = {
  prefix: "far",
  iconName: "rabbit",
  icon: [
    512,
    512,
    [],
    "f708",
    "M500.36 421.88l-95.95-120.66c43.34-10.47 75.61-49.35 75.61-95.58 0-47.99-32.82-74.41-42.89-81.02C458.33 17.1 401.03 0 378.86 0c-16.92 0-31.09 6.91-42.84 17.36C324.27 6.91 310.11.01 293.2 0h-.02c-25.92 0-86.21 22.9-53.74 144.05.99 3.7 2.08 7.42 3.28 11.18-2.19 9.16-2.7 17.54-2.7 23.43v34.93c-63.14 14.97-114.6 59.14-140.89 117.07C92.93 329.08 86.58 328 80 328c-44.19 0-80 35.76-80 80 0 44.19 35.76 80 80 80 7.07 0 13.9-1.2 20.52-3.02C115.18 501.42 136.29 512 160 512h160.01c21.04 0 38.92-13.54 45.4-32.37l7.76 9.55c10.53 14.36 27.1 22.82 45.12 22.82h37.72c20.35 0 39.12-11.06 48.98-28.86 11.26-20.32 8.4-44.87-4.63-61.26zM80.8 439.85c-.28.01-.53.15-.8.15-8.19 0-16.38-3.12-22.63-9.37-12.5-12.5-12.5-32.76 0-45.25 12.4-12.4 25.91-8.71 26.6-8.61-.6 3.16-6.35 31.02-3.17 63.08zM456.01 464h-37.72c-2.76 0-5.32-1.42-6.79-3.76l-70.46-86.76L224.01 432h64c17.66 0 32 14.36 32 32h-160c-17.67 0-32-14.33-32-32v-16c0-88.37 71.64-160 160.01-160v-77.34c0-9.78 2.36-17.04 5.53-23.66-2.84-7.29-5.5-15.03-7.74-23.37-11.32-42.25-9.08-79.55 5-83.32 13.81-3.7 33.78 26.27 45.21 67.09 11.46-40.89 31.43-70.79 45.21-67.09 14.08 3.77 16.32 41.08 5 83.32-1.43 5.32-3 10.46-4.69 15.39l29.13 17.65c13.4 9.45 21.35 24.71 21.35 40.97 0 27.81-22.83 50.36-50.99 50.36h-29.02v56.46l110.78 139.3c3.33 5.33-.5 12.24-6.78 12.24zm-87.99-272c0-8.84-7.16-16-16-16s-16 7.16-16 16 7.16 16 16 16 16-7.16 16-16z"
  ]
};
export const faRabbitFast = {
  prefix: "far",
  iconName: "rabbit-fast",
  icon: [
    640,
    512,
    [],
    "f709",
    "M598.33 189.44c-1.98-1.4.26.02-41.42-25.23-1.44-8.79-3.37-17.75-5.76-26.67C542.64 105.8 516.85 32 461.17 32c-5.01 0-9.99.65-14.8 1.95-18.5 4.96-31.84 17.01-39.68 34.91-8.84-3.03-17.89-4.86-26.88-4.86-16.51 0-31.68 6.07-42.71 17.1-5.7 5.7-14.96 17.64-16.74 36.22C292.78 103.85 266.77 96 239.89 96c-40.75 0-77.54 18.47-112.37 55.99-13.71-10.22-30.11-16-47.53-16-44.19 0-80 35.75-80 79.99 0 44.19 35.76 79.99 80 79.99 10.98 0 21.54-2.34 31.33-6.55 7.3 11.89 8.74 12.68 51.15 59.01l-9.54 5.16c-15.62 10.4-24.94 27.82-24.94 46.59v23.73c0 20.19 10.44 38.29 27.88 48.42 8.78 5.11 18.44 7.66 28.12 7.66 9.53 0 19.06-2.48 27.78-7.45l42.21-24.12 14.6 15.95a48.01 48.01 0 0 0 35.41 15.59h160c26.51 0 48-21.49 48-48 0-26.14-12.6-49.39-32.05-64h61.07c54.58 0 98.98-44.12 98.98-98.35.01-31.78-15.57-61.76-41.66-80.17zM95.87 243.1c-19.31 11.27-34.01.01-38.5-4.48-12.5-12.5-12.5-32.76 0-45.25 6.69-6.7 26.57-16.99 44.22-.69-5.94 16.23-7.56 33.47-5.72 50.42zm92.1 187.76c-3.5 2.02-6.5.81-8-.02-1.47-.88-3.97-2.92-3.97-6.92v-23.73c0-2.69 1.34-5.17 1.62-5.5l18.2-9.81 24.94 27.24-32.79 18.74zm353.05-110.88H448l-48.06 20.03c-.35-48.13-31.81-90.94-76.81-104.27l-36.31-10.77c-12.81-3.75-26.06 3.5-29.81 16.19-3.78 12.72 3.47 26.08 16.19 29.84l36.31 10.76c25.03 7.41 42.5 31.69 42.5 59.03v59.18h80c17.66 0 32 14.36 32 32H304L159.86 274.5c-22.36-24.22-22.66-61.37-.81-86.05C186.71 157.21 212.34 144 239.9 144c52.91 0 112.95 48.69 208.11 111.99 0-18.85-.38-22.24 3.75-33.12-13.16-6.88-28.53-18.32-43.38-33.17-30.93-30.92-47.64-64.35-37.33-74.65 10.74-10.74 45.13 7.8 74.66 37.32 2.58 2.58 4.9 5.18 7.28 7.78-10.27-40.77-7.88-76.17 5.81-79.84 14.11-3.8 34.71 27.54 45.99 69.65 4.37 16.3 6.67 31.8 7.1 44.98 2.6.84 5.2 1.56 7.79 2.82l50.98 30.89c13.4 9.45 21.35 24.71 21.35 40.97-.01 27.82-22.84 50.36-50.99 50.36zM512 239.99c-8.84 0-16 7.16-16 16s7.16 16 16 16 16-7.16 16-16-7.16-16-16-16z"
  ]
};
export const faRacquet = {
  prefix: "far",
  iconName: "racquet",
  icon: [
    640,
    512,
    [],
    "f45a",
    "M616.3 61.3C562-17.2 434.4-19.7 333 50.4c-57.7 40-95.6 95.3-108.4 149.9-10 42.6-30.1 81.5-56.6 115.8-.4-.2-15.1-8.1-30.7 2.8L13.6 405.6c-14.5 10.1-18 30.1-7.9 44.6l33.8 48.2c10.5 15 30.5 17.7 44.6 7.9l123.7-86.6c9.8-6.8 14-18.1 13-29.2 30.3-9.2 61.7-14.3 93.4-14 28.7.3 34.9 3.8 58.3 4.1 49.7.5 104.6-16.1 154.1-50.3 103-71.4 143.2-191.8 89.7-269zM69.7 457.7l-15.4-22 97.5-68.3 15.4 22-97.5 68.3zM207.9 344c9.9-12.9 18.4-26.5 26.4-40.4 8.4 16.8 12.6 20.5 20.9 29.6-15.8 2.6-31.6 6.1-47.3 10.8zm291.4-53.3c-39.7 27.5-84.7 42.4-126.6 41.9-139.4-1.5-135.7-157.3-12.4-242.7C416.9 50.8 466.3 48 486.9 48c10 0 10 0 0 0 138.2 1.5 137.2 156.4 12.4 242.7z"
  ]
};
export const faRadar = {
  prefix: "far",
  iconName: "radar",
  icon: [
    512,
    512,
    [],
    "e024",
    "M504,256c0,136.9668-111.0332,248-248,248S8,392.9668,8,256,119.0332,8,256,8A246.36335,246.36335,0,0,1,395.14648,50.916L425.377,20.68555a16.00006,16.00006,0,0,1,22.627,0l11.31054,11.31054a16.00006,16.00006,0,0,1,0,22.627l-201.373,201.373L257.93555,256H320a64.00026,64.00026,0,1,1-66.1543-63.7832l34.543-34.543A100.011,100.011,0,0,0,256,152,104,104,0,1,0,360,256h48c0,73.94727-52.85156,135.42773-122.81055,149.05664a39.15632,39.15632,0,0,0-58.3789,0A151.96039,151.96039,0,0,1,106.94336,285.18945a39.15632,39.15632,0,0,0,0-58.3789C120.57227,156.85156,182.05273,104,256,104c24.918,0,47.99219,6.67773,68.66016,17.40234l35.64062-35.64062A197.97306,197.97306,0,0,0,256,56C157.05078,56,74.87305,128.30664,58.98828,222.81055,47.82812,229.9082,40,241.79492,40,256s7.82812,26.0918,18.98828,33.18945A200.18858,200.18858,0,0,0,222.81055,453.01172C229.9082,464.17188,241.79492,472,256,472s26.0918-7.82812,33.18945-18.98828C383.69336,437.127,456,354.94922,456,256Z"
  ]
};
export const faRadiation = {
  prefix: "far",
  iconName: "radiation",
  icon: [
    496,
    512,
    [],
    "f7b9",
    "M290.7 323.6c-12.4 7.7-27 12.4-42.7 12.4s-30.3-4.6-42.7-12.4l-71.5 113.3c-10.2 16.2-4.2 38.2 13.5 45.9C178.1 496.4 212.1 504 248 504s69.9-7.6 100.7-21.1c17.6-7.7 23.7-29.7 13.5-45.9l-71.5-113.4zM248 456c-21.5 0-42.5-3.4-62.7-10l40.4-64c7.4 1.3 14.8 2 22.4 2 7.5 0 15-.7 22.4-2l40.4 64c-20.4 6.6-41.4 10-62.9 10zM32.6 256h134.6c0-28.6 15.3-53.5 38.1-67.6L133.9 75.2c-6.2-9.8-17-15.3-27.8-15.3-7.1 0-14.2 2.3-20.1 7.3-45.2 38-76.7 91.7-85.7 152.5C-2.5 238.9 13 256 32.6 256zm70.6-139l40.3 63.9c-6.2 8.4-11.3 17.5-15.3 27.1H52c8.5-34.2 26.2-65.6 51.2-91zM248 304c26.5 0 48-21.5 48-48s-21.5-48-48-48-48 21.5-48 48 21.5 48 48 48zm80.8-48h134.6c19.6 0 35.1-17.1 32.3-36.3-9-60.9-40.5-114.5-85.7-152.5-5.9-4.9-13-7.3-20.1-7.3-10.8 0-21.6 5.4-27.8 15.3l-71.4 113.2c22.8 14.1 38.1 39 38.1 67.6zm64-139c25 25.4 42.6 56.8 51.2 91h-76.2c-3.9-9.6-9.1-18.7-15.3-27.1l40.3-63.9z"
  ]
};
export const faRadiationAlt = {
  prefix: "far",
  iconName: "radiation-alt",
  icon: [
    496,
    512,
    [],
    "f7ba",
    "M314.1 256h81.7c9.5 0 17.5-8 16.5-17.4-4.8-45-27.8-84.4-61.5-111.3-7.9-6.3-19.5-4.7-24.8 3.9l-43.1 68.9c18.6 11.7 31.2 32.3 31.2 55.9zm-101 55.9L169.9 381c-5 8-2.5 19 5.9 23.2 21.8 10.8 46.2 17 72.1 17s50.3-6.3 72.1-17c8.5-4.2 11-15.2 5.9-23.2l-43.2-69.1c-10.2 6.4-22.1 10.2-34.9 10.2s-24.6-3.9-34.7-10.2zM100.3 256H182c0-23.6 12.5-44.2 31.2-55.9l-43.1-68.9c-5.3-8.6-16.9-10.2-24.8-3.9-33.6 26.8-56.7 66.3-61.5 111.3-1 9.4 7 17.4 16.5 17.4zM248 289c18.2 0 33-14.8 33-33s-14.8-33-33-33-33 14.8-33 33 14.8 33 33 33zm0 215c137 0 248-111 248-248S385 8 248 8 0 119 0 256s111 248 248 248zm0-448c110.3 0 200 89.7 200 200s-89.7 200-200 200S48 366.3 48 256 137.7 56 248 56z"
  ]
};
export const faRadio = {
  prefix: "far",
  iconName: "radio",
  icon: [
    512,
    512,
    [],
    "f8d7",
    "M208 336h-96a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm16-80H96a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm128-16a80 80 0 1 0 80 80 80 80 0 0 0-80-80zm96-112H211.5l288.83-81.21a16 16 0 0 0 11.07-19.74l-4.33-15.38A16 16 0 0 0 487.33.6L46.68 124.5A64 64 0 0 0 0 186.11V448a64 64 0 0 0 64 64h384a64 64 0 0 0 64-64V192a64 64 0 0 0-64-64zm16 320a16 16 0 0 1-16 16H64a16 16 0 0 1-16-16V192a16 16 0 0 1 16-16h384a16 16 0 0 1 16 16z"
  ]
};
export const faRadioAlt = {
  prefix: "far",
  iconName: "radio-alt",
  icon: [
    512,
    512,
    [],
    "f8d8",
    "M209 368h-64a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm144 56a72 72 0 1 0-72-72 72.09 72.09 0 0 0 72 72zm96-296H212.5l288.83-81.21a16 16 0 0 0 11.07-19.74l-4.33-15.38A16 16 0 0 0 488.33.6L47.68 124.5A64 64 0 0 0 1 186.11V448a64 64 0 0 0 64 64h384a64 64 0 0 0 64-64V192a64 64 0 0 0-64-64zm16 320a16 16 0 0 1-16 16H65a16 16 0 0 1-16-16V256h416zM113 336h128a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16H113a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16z"
  ]
};
export const faRainbow = {
  prefix: "far",
  iconName: "rainbow",
  icon: [
    576,
    512,
    [],
    "f75b",
    "M268.3 32.7C115.4 42.9 0 176.9 0 330.2V464c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V320C48 177.3 173.2 63.3 319.6 82 440.6 97.5 528 206.4 528 328.3V464c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V320c0-165.3-140-298.6-307.7-287.3zm-5.6 97.4C166 142.5 96 229.6 96 327.2V464c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V320.5c0-84.2 72.5-151.7 158.4-143.3 74.8 7.3 129.6 74.5 129.6 149.7V464c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V320.5c0-114.2-100.2-205.4-217.3-190.4zm6.2 95.8c-45.6 8.9-76.9 51.5-76.9 97.9V464c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V320c0-26.5 21.5-48 48-48s48 21.5 48 48v144c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V320c0-59.2-53.8-106-115.1-94.1z"
  ]
};
export const faRaindrops = {
  prefix: "far",
  iconName: "raindrops",
  icon: [
    448,
    512,
    [],
    "f75c",
    "M320 216.7c14.8 28.3 31.2 50.4 45.4 69.6 23.3 31.5 34.6 47.7 34.6 71.2 0 41-35.9 74.4-80 74.4s-80-33.4-80-74.4c0-23.3 11.3-39.6 34.7-71.3 14.2-19.2 30.5-41.3 45.3-69.5M160 32c-3.9 0-7.9 2.3-9.3 6.9-14.9 49.3-46.7 62.7-46.7 97.4 0 30.8 25 55.7 56 55.7s56-24.9 56-55.7c0-34.9-31.8-47.9-46.7-97.4C168 34.4 164 32 160 32zm160 96c-9 0-18 5-21.2 15.2C264.7 251.6 192 281.1 192 357.6c0 67.7 57.2 122.4 128 122.4s128-54.8 128-122.4c0-76.8-72.6-105.4-106.8-214.4-2.9-10-12-15.2-21.2-15.2zM56 224c-3.9 0-7.9 2.3-9.3 6.9C31.8 280.2 0 293.6 0 328.3 0 359.1 25 384 56 384s56-24.9 56-55.7c0-34.9-31.8-47.9-46.7-97.4C64 226.4 60 224 56 224z"
  ]
};
export const faRam = {
  prefix: "far",
  iconName: "ram",
  icon: [
    640,
    512,
    [],
    "f70a",
    "M609.81 100.92l-27.22-16.2C575.84 50.16 545.31 24 508.81 24H445.9C424.49 8.91 398.84 0 371.69 0c-55.97 0-101.7 42.61-107.73 97.02-12.82-1.47-26.04.24-37.55 5.97-18.84-9.47-42.91-9.08-61.47 1-12.94-5.89-27.53-7.52-42.31-4.37-17.88 4.02-33.12 15.11-42.69 30.34-17.59 2.08-34.06 11.16-45.66 25.83-11.25 14.57-16.22 32.94-14.28 50.88-12.62 12.78-20 30.34-20 49.02s7.25 36.19 19.69 48.92c-2.06 18.17 2.94 36.62 14.28 50.94 11.28 14.67 27.66 23.81 45.25 25.91 4.77 7.71 10.96 14.36 18.17 19.57l20.79 86.46c3.46 14.38 16.32 24.52 31.11 24.52h74.7c20.86 0 36.14-19.64 31.02-39.86l-14.67-57.91a66.566 66.566 0 0 0 15.23 1.77c10.5 0 20.72-2.45 29.94-7.09 5.69 2.77 11.96 4.46 18.52 5.59V480c0 17.67 14.33 32 32 32h80c17.67 0 32-14.33 32-32V377.86c11.36-4.34 21.72-11.56 29.7-21.64 11.25-14.58 16.22-32.95 14.28-50.89 12.62-12.78 20-30.34 20-49.02 0-8.48-1.68-16.65-4.47-24.31h68.13c17.75 0 34.31-9.56 43.22-25.05 18.94-33.2 21.12-48.14 21.12-56.48-.01-21.06-11.54-39.94-30.2-49.55zM161.89 464l-12.41-51.61c5.02-.98 9.97-2.33 14.7-4.46 8.18 4.46 17.47 6.72 26.91 7.4L203.42 464h-41.53zm238.13 0h-48v-54.2c11.7 4.23 24.42 5.38 37.35 2.59 3.7-.83 7.2-2.14 10.65-3.55V464zm175.64-280H452.64l-17.23 43.39 18.34 10.27c13.42 7.56 13.97 29.28-.31 37.31l-18.34 10.27 7.75 19.53c6.19 15.52-6.22 32.05-21.78 29.47l-21.19-3.77-6.03 20.67c-3.81 13.07-20.02 20.48-31.88 9.92l-17.16-15.22-16 16.44c-6.56 6.78-18.41 8.29-26.88.23l-16.59-15.78-16.53 15.84c-7.41 7.02-19.03 7.06-26 .23l-16.59-16.37-16.84 16.14c-8.56 8.23-22.38 4.28-26.69-.25L167 346.09l-17.16 14.64c-12.02 10.18-28.26 3.88-32.19-10.05l-5.94-20.91-21.41 3.83c-14.59 2.64-27.87-13.37-21.47-29.48l7.75-19.52-18.34-10.27c-13.42-7.56-13.97-29.28.31-37.31l18.34-10.27-7.75-19.53c-6.23-15.61 6.46-32.22 21.78-29.47l21.19 3.77 6.03-20.67c3.86-13.24 20.2-20.35 31.88-9.92l17.16 15.2 15.97-16.42c4.44-4.5 18.28-8.44 26.22-.58l16.59 16.45 16.91-16.16c7.28-6.98 19.19-7.08 26.59.03 11.63 11.08 31.4 50.64 84.44 50.64 42.41 0 76.91-34.5 76.91-76.92 0-30.37-21.5-57.25-51-63.91C369.28 55.33 361 62.05 361 70.22V86.5c0 4.47 2.47 8.48 6.22 10.48 11.7 4.12 23.59 9.07 23.59 26.2 0 20.36-16.56 36.92-36.91 36.92-28.22 0-51.16-22.95-51.16-51.16 0-38.02 30.94-68.95 68.94-68.95 26.76 0 51.68 12.38 68.72 32h68.41c15 0 27.19 12.2 27.19 27.22v13.66c70.12 41.71 60.88 27.24 39.66 71.13zM496 112c-8.84 0-16 7.16-16 16s7.16 16 16 16 16-7.16 16-16-7.16-16-16-16z"
  ]
};
export const faRampLoading = {
  prefix: "far",
  iconName: "ramp-loading",
  icon: [
    384,
    512,
    [],
    "f4d4",
    "M384 352V32c0-17.7-14.3-32-32-32H32C14.3 0 0 14.3 0 32v320c0 17.7 14.3 32 32 32h6.9L3.2 467.4C-5.9 488.5 9.6 512 32.6 512h318.9c23 0 38.5-23.5 29.4-44.6L345.1 384h6.9c17.7 0 32-14.3 32-32zM56.8 464l54.9-128h160.6l54.9 128H56.8zm255.5-156.6c-5-11.8-16.6-19.4-29.4-19.4H101.1c-12.8 0-24.4 7.6-29.4 19.4L59.5 336H48V48h288v288h-11.5l-12.2-28.6z"
  ]
};
export const faRandom = {
  prefix: "far",
  iconName: "random",
  icon: [
    512,
    512,
    [],
    "f074",
    "M505 400l-79.2 72.9c-15.1 15.1-41.8 4.4-41.8-17v-40h-31c-3.3 0-6.5-1.4-8.8-3.9l-89.8-97.2 38.1-41.3 79.8 86.3H384v-48c0-21.4 26.7-32.1 41.8-17l79.2 71c9.3 9.6 9.3 24.8 0 34.2zM12 152h91.8l79.8 86.3 38.1-41.3-89.8-97.2c-2.3-2.5-5.5-3.9-8.8-3.9H12c-6.6 0-12 5.4-12 12v32c0 6.7 5.4 12.1 12 12.1zm493-41.9l-79.2-71C410.7 24 384 34.7 384 56v40h-31c-3.3 0-6.5 1.4-8.8 3.9L103.8 360H12c-6.6 0-12 5.4-12 12v32c0 6.6 5.4 12 12 12h111c3.3 0 6.5-1.4 8.8-3.9L372.2 152H384v48c0 21.4 26.7 32.1 41.8 17l79.2-73c9.3-9.4 9.3-24.6 0-33.9z"
  ]
};
export const faRaygun = {
  prefix: "far",
  iconName: "raygun",
  icon: [
    576,
    512,
    [],
    "e025",
    "M111.95117,151.98283a23.997,23.997,0,1,0,24.002,23.99607A23.99826,23.99826,0,0,0,111.95117,151.98283Zm96.00977,0a23.997,23.997,0,1,0,24.00195,23.99607A23.99827,23.99827,0,0,0,207.96094,151.98283ZM320.0332,31.99664h-16.002a15.99912,15.99912,0,0,0-16,15.998V75.25441A110.46265,110.46265,0,0,0,239.96484,63.9927H191.959L87.16016,1.70957a15.99888,15.99888,0,0,0-23.1543,14.30858l-.04492,59.18938C26.24805,93.231,0,131.40083,0,175.9789c0,55.27923,40.14844,100.92176,92.82812,110.05456L22.4082,407.95129a47.93739,47.93739,0,0,0,17.59571,65.58586L95.416,505.53321a47.92475,47.92475,0,0,0,65.60156-17.59178L281.10547,279.93c2.45117-.9707,4.56445-2.51562,6.92578-3.65429v27.68747a15.99911,15.99911,0,0,0,16,15.998h16.002a15.99828,15.99828,0,0,0,16.002-15.998V47.99467A15.99829,15.99829,0,0,0,320.0332,31.99664ZM119.42578,463.97271,63.98047,431.95322l70.41992-121.91979,12.74609-22.06833h73.89258ZM288.03125,217.78354A63.61105,63.61105,0,0,1,239.96484,239.971H111.95117a63.99211,63.99211,0,1,1,0-127.98422H239.96484a63.61105,63.61105,0,0,1,48.06641,22.18747ZM554.9375,119.01217,480.002,143.98284H416.043V79.99073a15.99787,15.99787,0,0,0-16-15.998H384.041a15.99953,15.99953,0,0,0-16.002,15.998V271.96707a15.99953,15.99953,0,0,0,16.002,15.998h16.002a15.99787,15.99787,0,0,0,16-15.998V207.975h64.07617l74.8125,24.97067A16.00209,16.00209,0,0,0,576,217.76987V134.18793A16.0008,16.0008,0,0,0,554.9375,119.01217Z"
  ]
};
export const faReceipt = {
  prefix: "far",
  iconName: "receipt",
  icon: [
    448,
    512,
    [],
    "f543",
    "M344 288H104c-4.4 0-8 3.6-8 8v32c0 4.4 3.6 8 8 8h240c4.4 0 8-3.6 8-8v-32c0-4.4-3.6-8-8-8zM400.8 5.7L357.3 37 318.7 9.2c-16.8-12.1-39.2-12.1-56.1 0L224 37 185.4 9.2a47.888 47.888 0 0 0-56.1 0L90.7 37 47.2 5.7C27.4-8.5 0 5.6 0 29.9v452.3c0 23.8 27.1 38.6 47.2 24.2L90.7 475l38.6 27.8c16.8 12.1 39.2 12.1 56.1 0L224 475l38.6 27.8c16.8 12.1 39.3 12.1 56.1 0l38.6-27.8 43.5 31.3c19.8 14.2 47.2.1 47.2-24.1V29.9C448 6 420.9-8.7 400.8 5.7zm-.8 440.8l-42.7-30.7-66.7 48-66.7-48-66.7 48-66.7-48L48 446.5v-381l42.7 30.7 66.7-48 66.7 48 66.7-48 66.7 48L400 65.5v381zM344 176H104c-4.4 0-8 3.6-8 8v32c0 4.4 3.6 8 8 8h240c4.4 0 8-3.6 8-8v-32c0-4.4-3.6-8-8-8z"
  ]
};
export const faRecordVinyl = {
  prefix: "far",
  iconName: "record-vinyl",
  icon: [
    512,
    512,
    [],
    "f8d9",
    "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.28 0-200-89.72-200-200S145.72 56 256 56s200 89.72 200 200-89.72 200-200 200zm0-304a104 104 0 1 0 104 104 104 104 0 0 0-104-104zm0 128a24 24 0 1 1 24-24 24 24 0 0 1-24 24z"
  ]
};
export const faRectangleLandscape = {
  prefix: "far",
  iconName: "rectangle-landscape",
  icon: [
    510,
    512,
    [],
    "f2fa",
    "M462 64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h414c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zm-6 336H54c-3.3 0-6-2.7-6-6V118c0-3.3 2.7-6 6-6h402c3.3 0 6 2.7 6 6v276c0 3.3-2.7 6-6 6z"
  ]
};
export const faRectanglePortrait = {
  prefix: "far",
  iconName: "rectangle-portrait",
  icon: [
    385,
    512,
    [],
    "f2fb",
    "M385 464V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h289c26.5 0 48-21.5 48-48zm-337-6V54c0-3.3 2.7-6 6-6h277c3.3 0 6 2.7 6 6v404c0 3.3-2.7 6-6 6H54c-3.3 0-6-2.7-6-6z"
  ]
};
export const faRectangleWide = {
  prefix: "far",
  iconName: "rectangle-wide",
  icon: [
    640,
    512,
    [],
    "f2fc",
    "M592 96.5H48c-26.5 0-48 21.5-48 48v223c0 26.5 21.5 48 48 48h544c26.5 0 48-21.5 48-48v-223c0-26.5-21.5-48-48-48zm-6 271H54c-3.3 0-6-2.7-6-6v-211c0-3.3 2.7-6 6-6h532c3.3 0 6 2.7 6 6v211c0 3.3-2.7 6-6 6z"
  ]
};
export const faRecycle = {
  prefix: "far",
  iconName: "recycle",
  icon: [
    512,
    512,
    [],
    "f1b8",
    "M214.951 71.068l-29.543 48.77c-3.425 5.654-10.778 7.473-16.444 4.069l-20.562-12.355c-5.694-3.422-7.525-10.819-4.085-16.501l29.585-48.861c37.33-61.594 126.877-61.579 164.198 0l44.115 72.856 34.93-20.988c12.268-7.371 27.19 3.858 23.765 17.585l-21.886 87.815c-2.137 8.574-10.821 13.792-19.395 11.654l-87.804-21.906c-13.822-3.446-16.55-21.921-4.37-29.239l33.631-20.208-44.045-72.707c-18.636-30.747-63.456-30.73-82.09.016zM55.006 335.104l49.596-81.873 34.03 20.447c12.18 7.318 27.211-3.763 23.765-17.585l-21.88-87.811c-2.137-8.574-10.821-13.792-19.395-11.654l-87.81 21.902c-13.729 3.421-16.638 21.868-4.37 29.239l34.554 20.762-49.475 81.711C-24.729 374.181 21.448 456 96.12 456H164c6.627 0 12-5.373 12-12v-24c0-6.627-5.373-12-12-12H96.045c-37.259 0-60.426-40.907-41.039-72.896zm442.98-24.861l-34.991-57.788c-3.424-5.655-10.778-7.476-16.445-4.071l-20.53 12.336c-5.695 3.422-7.526 10.821-4.083 16.504l35.074 57.897C476.323 366.988 453.337 408 415.96 408H320v-39.98c0-14.21-17.24-21.386-27.313-11.313l-64 63.98c-6.249 6.248-6.249 16.379 0 22.627l64 63.989C302.689 517.308 320 510.3 320 495.989V456h95.887c74.764 0 120.802-81.898 82.099-145.757z"
  ]
};
export const faRedo = {
  prefix: "far",
  iconName: "redo",
  icon: [
    512,
    512,
    [],
    "f01e",
    "M500 8h-27.711c-6.739 0-12.157 5.548-11.997 12.286l2.347 98.568C418.075 51.834 341.788 7.73 255.207 8.001 118.82 8.428 7.787 120.009 8 256.396 8.214 393.181 119.165 504 256 504c63.926 0 122.202-24.187 166.178-63.908 5.113-4.618 5.354-12.561.482-17.433l-19.738-19.738c-4.498-4.498-11.753-4.785-16.501-.552C351.787 433.246 306.105 452 256 452c-108.322 0-196-87.662-196-196 0-108.322 87.662-196 196-196 79.545 0 147.941 47.282 178.675 115.302l-126.389-3.009c-6.737-.16-12.286 5.257-12.286 11.997V212c0 6.627 5.373 12 12 12h192c6.627 0 12-5.373 12-12V20c0-6.627-5.373-12-12-12z"
  ]
};
export const faRedoAlt = {
  prefix: "far",
  iconName: "redo-alt",
  icon: [
    512,
    512,
    [],
    "f2f9",
    "M483.515 28.485L431.35 80.65C386.475 35.767 324.485 8 256.001 8 119.34 8 7.9 119.525 8 256.185 8.1 393.067 119.095 504 256 504c63.926 0 122.202-24.187 166.178-63.908 5.113-4.618 5.353-12.561.482-17.433l-19.738-19.738c-4.498-4.498-11.753-4.785-16.501-.552C351.787 433.246 306.105 452 256 452c-108.321 0-196-87.662-196-196 0-108.321 87.662-196 196-196 54.163 0 103.157 21.923 138.614 57.386l-54.128 54.129c-7.56 7.56-2.206 20.485 8.485 20.485H492c6.627 0 12-5.373 12-12V36.971c0-10.691-12.926-16.045-20.485-8.486z"
  ]
};
export const faRefrigerator = {
  prefix: "far",
  iconName: "refrigerator",
  icon: [
    384,
    512,
    [],
    "e026",
    "M336,0H48A48,48,0,0,0,0,48V464a48,48,0,0,0,48,48H336a48,48,0,0,0,48-48V48A48,48,0,0,0,336,0Zm0,48V176H288V112a16,16,0,0,0-16-16H256a16,16,0,0,0-16,16v64H48V48ZM48,464V224H240V368a16,16,0,0,0,16,16h16a16,16,0,0,0,16-16V224h48V464Z"
  ]
};
export const faRegistered = {
  prefix: "far",
  iconName: "registered",
  icon: [
    512,
    512,
    [],
    "f25d",
    "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 448c-110.532 0-200-89.451-200-200 0-110.531 89.451-200 200-200 110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200zm110.442-81.791c-53.046-96.284-50.25-91.468-53.271-96.085 24.267-13.879 39.482-41.563 39.482-73.176 0-52.503-30.247-85.252-101.498-85.252h-78.667c-6.617 0-12 5.383-12 12V380c0 6.617 5.383 12 12 12h38.568c6.617 0 12-5.383 12-12v-83.663h31.958l47.515 89.303a11.98 11.98 0 0 0 10.593 6.36h42.81c9.14 0 14.914-9.799 10.51-17.791zM256.933 239.906h-33.875v-64.14h27.377c32.417 0 38.929 12.133 38.929 31.709-.001 20.913-11.518 32.431-32.431 32.431z"
  ]
};
export const faRemoveFormat = {
  prefix: "far",
  iconName: "remove-format",
  icon: [
    640,
    512,
    [],
    "f87d",
    "M634 471L36 3.5A16 16 0 0 0 13.49 6l-10 12.5A16 16 0 0 0 6 41l598 467.5a16 16 0 0 0 22.5-2.5l10-12.5A16 16 0 0 0 634 471zM352 96l-24.76 74.27L378 210l38-114h144v32a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16H176a15.86 15.86 0 0 0-14.18 8.94L232.24 96zm-16 336h-32l25.68-77-50.77-39.7L240 432h-32a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16z"
  ]
};
export const faRepeat = {
  prefix: "far",
  iconName: "repeat",
  icon: [
    512,
    512,
    [],
    "f363",
    "M512 256c0 83.813-68.187 152-152 152H136.535l55.762 54.545c4.775 4.67 4.817 12.341.094 17.064l-16.877 16.877c-4.686 4.686-12.284 4.686-16.971 0l-104-104c-4.686-4.686-4.686-12.284 0-16.971l104-104c4.686-4.686 12.284-4.686 16.971 0l16.877 16.877c4.723 4.723 4.681 12.393-.094 17.064L136.535 360H360c57.346 0 104-46.654 104-104 0-19.452-5.372-37.671-14.706-53.258a11.991 11.991 0 0 1 1.804-14.644l17.392-17.392c5.362-5.362 14.316-4.484 18.491 1.847C502.788 196.521 512 225.203 512 256zM62.706 309.258C53.372 293.671 48 275.452 48 256c0-57.346 46.654-104 104-104h223.465l-55.762 54.545c-4.775 4.67-4.817 12.341-.094 17.064l16.877 16.877c4.686 4.686 12.284 4.686 16.971 0l104-104c4.686-4.686 4.686-12.284 0-16.971l-104-104c-4.686-4.686-12.284-4.686-16.971 0l-16.877 16.877c-4.723 4.723-4.681 12.393.094 17.064L375.465 104H152C68.187 104 0 172.187 0 256c0 30.797 9.212 59.479 25.019 83.447 4.175 6.331 13.129 7.209 18.491 1.847l17.392-17.392a11.991 11.991 0 0 0 1.804-14.644z"
  ]
};
export const faRepeat1 = {
  prefix: "far",
  iconName: "repeat-1",
  icon: [
    512,
    512,
    [],
    "f365",
    "M512 256c0 83.813-68.187 152-152 152H136.535l55.762 54.545c4.775 4.67 4.817 12.341.094 17.064l-16.877 16.877c-4.686 4.686-12.284 4.686-16.971 0l-104-104c-4.686-4.686-4.686-12.284 0-16.971L154.59 275.468c4.686-4.686 12.284-4.686 16.971 0l16.877 16.877c4.723 4.723 4.681 12.393-.094 17.064L136.535 360H360c57.346 0 104-46.654 104-104 0-19.452-5.372-37.671-14.706-53.258a11.991 11.991 0 0 1 1.804-14.644l17.392-17.392c5.362-5.362 14.316-4.484 18.491 1.847C502.788 196.521 512 225.203 512 256zM62.706 309.258C53.372 293.671 48 275.452 48 256c0-57.346 46.654-104 104-104h223.465l-51.809 50.592c-4.775 4.67-4.817 12.341-.094 17.064l16.877 16.877c4.686 4.686 12.284 4.686 16.971 0l100.047-100.047c4.686-4.686 4.686-12.284 0-16.971l-104-104c-4.686-4.686-12.284-4.686-16.971 0l-16.877 16.877c-4.723 4.723-4.681 12.393.094 17.064L375.465 104H152C68.187 104 0 172.187 0 256c0 30.797 9.212 59.479 25.019 83.447 4.175 6.331 13.129 7.209 18.491 1.847l17.392-17.392a11.991 11.991 0 0 0 1.804-14.644zm164.557-9.731c0-7.477 3.917-11.572 11.573-11.572h15.131v-39.878c0-5.163.534-10.503.534-10.503h-.356s-1.779 2.67-2.848 3.738c-4.451 4.273-10.504 4.451-15.666-1.068l-5.518-6.231c-5.342-5.341-4.984-11.216.534-16.379l21.72-19.939c4.449-4.095 8.366-5.697 14.42-5.697h12.105c7.656 0 11.749 3.916 11.749 11.572v84.384h15.488c7.655 0 11.572 4.094 11.572 11.572v8.901c0 7.477-3.917 11.572-11.572 11.572h-67.293c-7.656 0-11.573-4.095-11.573-11.572v-8.9z"
  ]
};
export const faRepeat1Alt = {
  prefix: "far",
  iconName: "repeat-1-alt",
  icon: [
    512,
    512,
    [],
    "f366",
    "M481.162 164.326c19.478 25.678 30.997 57.709 30.836 92.388C511.61 340.638 442.361 408 358.436 408H176v64c-.001 10.683-12.949 16.021-20.485 8.485l-88-87.995c-4.686-4.686-4.687-12.284 0-16.971l88-88.005c7.58-7.58 20.485-2.14 20.485 8.485v64h182.668C415.933 360 464.06 313.154 464 255.889c-.023-22.372-7.149-43.111-19.237-60.082-3.431-4.817-2.962-11.387 1.223-15.564 8.269-8.255 13.592-13.545 17.137-17.104 5.131-5.152 13.645-4.605 18.039 1.187zM48 256.111C47.94 198.846 96.067 152 153.332 152H336v64c0 10.625 12.905 16.066 20.485 8.485l88-88.005c4.687-4.686 4.686-12.285 0-16.971l-88-87.995C348.949 23.979 336.001 29.317 336 40v64H153.564C69.639 104 .389 171.362.002 255.286c-.16 34.679 11.358 66.71 30.836 92.388 4.394 5.792 12.908 6.339 18.039 1.188 3.545-3.559 8.867-8.849 17.137-17.105 4.185-4.178 4.653-10.748 1.223-15.564-12.088-16.971-19.213-37.71-19.237-60.082zm179.263 43.416c0-7.477 3.917-11.572 11.573-11.572h15.131v-39.878c0-5.163.534-10.503.534-10.503h-.356s-1.779 2.67-2.848 3.738c-4.451 4.273-10.504 4.451-15.666-1.068l-5.518-6.231c-5.342-5.341-4.984-11.216.534-16.379l21.72-19.939c4.449-4.095 8.366-5.697 14.42-5.697h12.105c7.656 0 11.749 3.916 11.749 11.572v84.384h15.488c7.655 0 11.572 4.094 11.572 11.572v8.901c0 7.477-3.917 11.572-11.572 11.572h-67.293c-7.656 0-11.573-4.095-11.573-11.572v-8.9z"
  ]
};
export const faRepeatAlt = {
  prefix: "far",
  iconName: "repeat-alt",
  icon: [
    512,
    512,
    [],
    "f364",
    "M481.162 164.326c19.478 25.678 30.997 57.709 30.836 92.388C511.61 340.638 442.361 408 358.436 408H176v64c-.001 10.683-12.949 16.021-20.485 8.485l-88-87.995c-4.686-4.686-4.687-12.284 0-16.971l88-88.005c7.58-7.58 20.485-2.14 20.485 8.485v64h182.668C415.933 360 464.06 313.154 464 255.889c-.023-22.372-7.149-43.111-19.237-60.082-3.431-4.817-2.962-11.387 1.223-15.564 8.269-8.255 13.592-13.545 17.137-17.104 5.131-5.152 13.645-4.605 18.039 1.187zM48 256.111C47.94 198.846 96.067 152 153.332 152H336v64c0 10.625 12.905 16.066 20.485 8.485l88-88.005c4.687-4.686 4.686-12.285 0-16.971l-88-87.995C348.949 23.979 336.001 29.317 336 40v64H153.564C69.639 104 .389 171.362.002 255.286c-.16 34.679 11.358 66.71 30.836 92.388 4.394 5.792 12.908 6.339 18.039 1.188 3.545-3.559 8.867-8.849 17.137-17.105 4.185-4.178 4.653-10.748 1.223-15.564-12.088-16.971-19.213-37.71-19.237-60.082z"
  ]
};
export const faReply = {
  prefix: "far",
  iconName: "reply",
  icon: [
    576,
    512,
    [],
    "f3e5",
    "M14.062 257.94L190.06 433.88c30.21 30.21 81.94 8.7 81.94-33.94v-78.28c146.59 8.54 158.53 50.199 134.18 127.879-13.65 43.56 35.07 78.89 72.19 54.46C537.98 464.768 576 403.8 576 330.05c0-170.37-166.04-197.15-304-201.3V48.047c0-42.72-51.79-64.09-81.94-33.94L14.062 190.06c-18.75 18.74-18.75 49.14 0 67.88zM48 224L224 48v128.03c143.181.63 304 11.778 304 154.02 0 66.96-40 109.95-76.02 133.65C501.44 305.911 388.521 273.88 224 272.09V400L48 224z"
  ]
};
export const faReplyAll = {
  prefix: "far",
  iconName: "reply-all",
  icon: [
    640,
    512,
    [],
    "f122",
    "M142.06 273.94l160 159.97c30.02 30.02 81.94 8.98 81.94-33.94v-71.08c118.18 4.94 121.95 30.99 104.44 89.17-13.17 43.75 36.21 78.71 73.1 53.43 50.61-34.7 78.46-79.33 78.46-143.11 0-142.4-127.16-171.02-256-175.61V80.04c0-42.88-51.89-64-81.94-33.94l-160 159.96c-18.75 18.74-18.75 49.14 0 67.88zM176 240L336 80v120c120.616 0 256 6.513 256 128.38 0 55.8-28.79 83.87-57.6 103.62 41.002-136.247-60.829-152-198.4-152v120L176 240zM14.059 206.059l160-159.962c20.389-20.389 50.822-17.22 68.29.31L48 240l194.35 193.603c-17.474 17.531-47.921 20.675-68.291.306l-160-159.967c-18.745-18.746-18.745-49.138 0-67.883z"
  ]
};
export const faRepublican = {
  prefix: "far",
  iconName: "republican",
  icon: [
    640,
    512,
    [],
    "f75e",
    "M189 144.2l-27.4-4-12.2-24.8c-2.2-4.4-8.5-4.5-10.7 0l-12.2 24.8-27.4 4c-4.9.7-6.9 6.8-3.3 10.2l19.8 19.3-4.7 27.3c-.8 4.9 4.3 8.6 8.7 6.3l24.5-12.9 24.5 12.9c4.3 2.3 9.5-1.4 8.7-6.3l-4.7-27.3 19.8-19.3c3.4-3.5 1.5-9.5-3.4-10.2zm128 0l-27.4-4-12.2-24.8c-2.2-4.4-8.5-4.5-10.7 0l-12.2 24.8-27.4 4c-4.9.7-6.9 6.8-3.3 10.2l19.8 19.3-4.7 27.3c-.8 4.9 4.3 8.6 8.7 6.3l24.5-12.9 24.5 12.9c4.3 2.3 9.5-1.4 8.7-6.3l-4.7-27.3 19.8-19.3c3.4-3.5 1.5-9.5-3.4-10.2zm128 0l-27.4-4-12.2-24.8c-2.2-4.4-8.5-4.5-10.7 0l-12.2 24.8-27.4 4c-4.9.7-6.9 6.8-3.3 10.2l19.8 19.3-4.7 27.3c-.8 4.9 4.3 8.6 8.7 6.3l24.5-12.9 24.5 12.9c4.3 2.3 9.5-1.4 8.7-6.3l-4.7-27.3 19.8-19.3c3.4-3.5 1.5-9.5-3.4-10.2zM624 320h-16c-8.8 0-16 7.2-16 16v72c0 13.2-10.8 24-24 24s-24-10.8-24-24V192c0-88.4-71.6-160-160-160H160C71.6 32 0 103.6 0 192v256c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32v-64h128v64c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32v-64h48v19.7c0 37.6 27 72 64.4 75.9 2.5.3 5.1.4 7.6.4 39.7 0 72-32.3 72-72v-72c0-8.8-7.2-16-16-16zm-128 16h-64c-17.7 0-32 14.3-32 32v64h-64v-64c0-17.7-14.3-32-32-32H144c-17.7 0-32 14.3-32 32v64H48V288h448v48zm0-96H48v-48c0-61.9 50.1-112 112-112h224c61.8 0 112 50.2 112 112v48z"
  ]
};
export const faRestroom = {
  prefix: "far",
  iconName: "restroom",
  icon: [
    640,
    512,
    [],
    "f7bd",
    "M328 0h-16c-8.8 0-16 7.2-16 16v480c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16zM200.8 137.4c9.6-14.1 15.2-31.1 15.2-49.4 0-48.6-39.4-88-88-88S40 39.4 40 88c0 18.3 5.6 35.3 15.2 49.4C22.7 152.8 0 185.6 0 224v112c0 17.7 14.3 32 32 32h16v112c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32V368h16c17.7 0 32-14.3 32-32V224c0-38.4-22.7-71.2-55.2-86.6zM128 48c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zm80 272h-48v144H96V320H48v-96c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v96zm430.8 10.3l-37.7-134.7c-4.9-17.7-15.1-32.7-28.2-44.3 16.7-16 27.1-38.4 27.1-63.3 0-48.6-39.4-88-88-88s-88 39.4-88 88c0 24.9 10.5 47.3 27.1 63.3-13.2 11.6-23.3 26.6-28.2 44.3l-37.7 134.7c-3.1 12.8-.2 26.2 8 36.6 8.5 10.8 21.4 17 35.3 17h3.5v88c0 22.1 17.9 40 40 40h80c22.1 0 40-17.9 40-40v-88h3.5c13.9 0 26.8-6.2 35.3-17 8.2-10.4 11.1-23.7 8-36.6zM512 48c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zm32 288v128h-64V336l-46.9 1.2 36-128.7c5.3-19.2 23-32.5 42.9-32.5s37.5 13.4 42.9 32.5L590.5 336H544z"
  ]
};
export const faRetweet = {
  prefix: "far",
  iconName: "retweet",
  icon: [
    640,
    512,
    [],
    "f079",
    "M624.485 353.456l-104 104c-4.686 4.686-12.284 4.686-16.971 0l-104-104c-4.686-4.686-4.686-12.284 0-16.971l16.877-16.877c4.723-4.723 12.393-4.681 17.064.094L488 375.465V152H284.024a11.996 11.996 0 0 1-8.485-3.515l-24-24c-7.56-7.56-2.206-20.485 8.485-20.485H512c13.255 0 24 10.745 24 24v247.465l54.545-55.762c4.671-4.775 12.341-4.817 17.064-.094l16.877 16.877c4.686 4.686 4.686 12.284-.001 16.97zm-260.024 10.059a12.002 12.002 0 0 0-8.485-3.515H152V136.535l54.545 55.762c4.671 4.775 12.341 4.817 17.064.094l16.877-16.877c4.686-4.686 4.686-12.284 0-16.971l-104-104c-4.686-4.686-12.284-4.686-16.971 0l-104 104c-4.686 4.686-4.686 12.284 0 16.971l16.877 16.877c4.723 4.723 12.393 4.681 17.064-.094L104 136.535V384c0 13.255 10.745 24 24 24h251.976c10.691 0 16.045-12.926 8.485-20.485l-24-24z"
  ]
};
export const faRetweetAlt = {
  prefix: "far",
  iconName: "retweet-alt",
  icon: [
    640,
    512,
    [],
    "f361",
    "M388.461 387.515c7.56 7.56 2.206 20.485-8.485 20.485H128c-13.255 0-24-10.745-24-24V171.187l-72.162-.001c-10.683-.001-16.022-12.949-8.485-20.485l96.156-96.156c4.686-4.686 12.284-4.687 16.971 0l96.16 96.16c7.58 7.58 2.14 20.485-8.485 20.485L152 171.188V360h203.976c3.183 0 6.235 1.264 8.485 3.515l24 24zm219.701-46.7L536 340.813V128c0-13.255-10.745-24-24-24H260.024c-10.691 0-16.045 12.926-8.485 20.485l24 24a12.002 12.002 0 0 0 8.485 3.515H488v188.812l-72.154-.001c-10.625 0-16.066 12.905-8.485 20.485l96.16 96.16c4.686 4.687 12.285 4.686 16.971 0l96.156-96.156c7.535-7.536 2.197-20.485-8.486-20.485z"
  ]
};
export const faRibbon = {
  prefix: "far",
  iconName: "ribbon",
  icon: [
    448,
    512,
    [],
    "f4d6",
    "M437.7 404.6L329.5 287l37.5-40.3c34.8-37.4 39-91.3 10.8-137.3L347 59.1c-15-24.5-37.2-42.4-62.4-50.5-36-11.5-85.1-11.5-121 0-25.3 8.1-47.5 26-62.4 50.5l-33.3 54.3c-25.9 42.2-20.4 97 13.3 133.2l37.5 40.4L10.4 404.7c-16.5 17.9-12.8 45.9 7.5 59.2l63.3 41.3c24 15.7 45.5.1 51.4-6.2l91.5-98.5 91.4 98.4c5.8 6.3 27.6 21.9 51.4 6.3l63.3-41.3c20.1-13.1 24-41.3 7.5-59.3zM328.2 120.2l8.7 14.2c16.9 27.5 14.9 58-5.1 79.5l-34.9 37.6-40.3-43.8 45.5-49.5c11.7-11.4 19.9-24.9 26.1-38zm-150-65.9c26.5-8.5 65.2-8.5 91.7 0 9.1 2.9 17.5 8.5 24.8 15.8-2.7 12.9-9.8 37.9-27 54.8L224 172.3 179.6 124C163 107.7 156 82.7 153.4 69.9c7.2-7.3 15.7-12.7 24.8-15.6zm-76.3 407.2l-49.1-32.1 98.5-107.2 40 43-89.4 96.3zm244.3 0L116.3 214c-19.1-20.6-22.2-51.6-7.5-75.5l10.9-17.9c6 12.8 14.2 25.8 25.4 36.8l250.2 272.1-49.1 32z"
  ]
};
export const faRing = {
  prefix: "far",
  iconName: "ring",
  icon: [
    512,
    512,
    [],
    "f70b",
    "M256 64C110.06 64 0 125.91 0 208v98.13C0 384.48 114.62 448 256 448s256-63.52 256-141.87V208c0-82.09-110.06-144-256-144zm0 48c110.46 0 200 35.82 200 80 0 9.09-3.97 17.79-10.95 25.93C398.24 192.23 331 176 256 176s-142.24 16.23-189.05 41.93C59.97 209.79 56 201.09 56 192c0-44.18 89.54-80 200-80zm141.7 136.45C361.48 262.99 311.38 272 256 272s-105.48-9.01-141.7-23.55C150 234.3 198.38 224 256 224s106 10.3 141.7 24.45zm66.3 57.68C464 344.4 382.97 400 256 400S48 344.41 48 306.13v-39.78C94.43 298.78 170.15 320 256 320s161.57-21.22 208-53.64v39.77z"
  ]
};
export const faRingsWedding = {
  prefix: "far",
  iconName: "rings-wedding",
  icon: [
    512,
    512,
    [],
    "f81b",
    "M371.94 163.7a222.3 222.3 0 0 1 22.43 59C435.52 244.05 464 286.55 464 336a128 128 0 0 1-256 0c0-54.66 34.52-101.17 82.85-119.44A126.49 126.49 0 0 1 304 272c0 37.37-16.38 70.73-42 94.15a80.3 80.3 0 0 0 31 37 175.71 175.71 0 0 0-46.33-292.3L288 44.66 232.53 0H119.47L64 44.66l41.29 66.23A176 176 0 0 0 176 448a164 164 0 0 0 22.86-1.82A176 176 0 1 0 371.94 163.7zM128 55.34l8.53-7.34h78.94l8.53 7.34-25.47 42.26a160 160 0 0 0-45.06 0zM48 272a128.14 128.14 0 0 1 128-128c33 0 62.87 12.91 85.6 33.51-59.88 28-101.6 88-101.6 158.49a175.18 175.18 0 0 0 12 63.6C103.33 397.45 48 341.22 48 272z"
  ]
};
export const faRoad = {
  prefix: "far",
  iconName: "road",
  icon: [
    576,
    512,
    [],
    "f018",
    "M267.73 192h40.54c7.13 0 12.68-6.17 11.93-13.26l-4.6-43.58a8 8 0 0 0-7.96-7.16h-39.29c-4.09 0-7.53 3.09-7.96 7.16l-4.6 43.58c-.74 7.09 4.82 13.26 11.94 13.26zm-7.37 112h55.29c9.5 0 16.91-8.23 15.91-17.68l-5.07-48c-.86-8.14-7.72-14.32-15.91-14.32h-45.15c-8.19 0-15.05 6.18-15.91 14.32l-5.07 48c-1 9.45 6.41 17.68 15.91 17.68zm13.06-208h29.16c4.75 0 8.45-4.12 7.96-8.84l-1.69-16a8 8 0 0 0-7.96-7.16h-25.78c-4.09 0-7.53 3.09-7.96 7.16l-1.69 16c-.49 4.72 3.21 8.84 7.96 8.84zm48.98 240h-68.8c-8.19 0-15.05 6.18-15.91 14.32l-8.45 80c-1 9.45 6.41 17.68 15.91 17.68h85.69c9.5 0 16.91-8.23 15.91-17.68l-8.45-80c-.85-8.14-7.71-14.32-15.9-14.32zM173.35 64h-16a7.99 7.99 0 0 0-7.38 4.92L1.25 425.85C-3.14 436.38 4.6 448 16.02 448h44c7.11 0 13.37-4.69 15.36-11.52L181.03 74.24c1.49-5.12-2.35-10.24-7.68-10.24zm401.4 361.85L426.04 68.92a8 8 0 0 0-7.38-4.92h-16c-5.33 0-9.17 5.12-7.68 10.24l105.65 362.24A15.996 15.996 0 0 0 515.99 448h44c11.41 0 19.15-11.62 14.76-22.15z"
  ]
};
export const faRobot = {
  prefix: "far",
  iconName: "robot",
  icon: [
    640,
    512,
    [],
    "f544",
    "M192,408h64V360H192ZM576,192H544a95.99975,95.99975,0,0,0-96-96H344V24a24,24,0,0,0-48,0V96H192a95.99975,95.99975,0,0,0-96,96H64a47.99987,47.99987,0,0,0-48,48V368a47.99987,47.99987,0,0,0,48,48H96a95.99975,95.99975,0,0,0,96,96H448a95.99975,95.99975,0,0,0,96-96h32a47.99987,47.99987,0,0,0,48-48V240A47.99987,47.99987,0,0,0,576,192ZM96,368H64V240H96Zm400,48a48.14061,48.14061,0,0,1-48,48H192a48.14061,48.14061,0,0,1-48-48V192a47.99987,47.99987,0,0,1,48-48H448a47.99987,47.99987,0,0,1,48,48Zm80-48H544V240h32ZM240,208a48,48,0,1,0,48,48A47.99612,47.99612,0,0,0,240,208Zm160,0a48,48,0,1,0,48,48A47.99612,47.99612,0,0,0,400,208ZM384,408h64V360H384Zm-96,0h64V360H288Z"
  ]
};
export const faRocket = {
  prefix: "far",
  iconName: "rocket",
  icon: [
    512,
    512,
    [],
    "f135",
    "M367.96813,103.99609a39.999,39.999,0,1,0,40.00384,40A40.02908,40.02908,0,0,0,367.96813,103.99609ZM505.07337,19.3418c-1.21875-5.60742-6.75-11.13868-12.34373-12.3418-32.62885-7-58.162-7-83.57017-7C305.39988,0,242.95858,55.0918,196.236,127.99609H94.82015c-16.34567.01563-35.53314,11.875-42.87883,26.48243L2.53125,253.28906A28.12512,28.12512,0,0,0,0,263.99219a24.00617,24.00617,0,0,0,24.00191,23.998h92.63266l-10.59373,21.42188c-9.33592,18.91016,4.27733,34.77344,6.15624,36.62305l53.75381,53.71875c15.56443,15.54492,33.81635,7.52929,36.6601,6.13867l21.34567-10.57617V488a24.00659,24.00659,0,0,0,24.00191,24,28.618,28.618,0,0,0,10.71873-2.51562l98.6971-49.4043c14.625-7.29688,26.50191-26.5,26.50191-42.85938V315.69336c72.72449-46.76367,128.10525-109.44922,128.10525-212.69727C512.07531,77.4668,512.07531,51.99805,505.07337,19.3418ZM358.53065,274.99023c-36.94135,18.48438-121.10527,60.14063-166.7966,82.73243l-37.50189-37.49805c22.59567-45.6875,64.25575-129.99609,82.72447-166.88672C284.33741,79.5293,335.96623,47.99805,409.15947,47.99805c18.00192,0,34.2851,0,52.56632,2.34375,2.375,18.71875,2.31249,35.27929,2.25,52.63867C463.97578,175.75977,432.41138,227.30469,358.53065,274.99023Z"
  ]
};
export const faRocketLaunch = {
  prefix: "far",
  iconName: "rocket-launch",
  icon: [
    512,
    512,
    [],
    "e027",
    "M35.68523,352.06641C9.82784,377.91992-2.94948,442.59375.5759,511.41016c69.11514,3.55859,133.61115-9.35157,159.365-35.10547,40.289-40.2793,42.8769-93.98633,6.31054-130.54883C129.68706,309.19727,75.97033,311.78516,35.68523,352.06641Zm81.6327,84.03125c-8.58592,8.584-30.08394,12.88672-53.11907,11.69922-1.17382-22.93555,3.084-44.49219,11.70311-53.10938,13.42772-13.42578,31.33-14.28906,43.51752-2.10352C131.607,404.77148,130.74565,422.67188,117.31793,436.09766ZM505.16311,19.29688c-1.17578-5.4629-6.98827-11.26563-12.45115-12.4336C460.6163,0,435.464,0,410.4191,0,307.20049,0,245.30018,55.20312,199.09126,128H94.88827c-16.29685,0-35.59956,11.92383-42.88861,26.49805L2.57785,253.29688A28.4,28.4,0,0,0,.06223,264,24.00826,24.00826,0,0,0,24.0661,288h103.953a96.00635,96.00635,0,0,1,96.01354,96V488a24.00826,24.00826,0,0,0,24.00388,24,28.53983,28.53983,0,0,0,10.70311-2.51562l98.74791-49.40626c14.56053-7.28515,26.47457-26.56445,26.47457-42.84374V312.79688c72.5878-46.3125,128.01936-108.40626,128.01936-211.09376C512.07521,76.55273,512.07521,51.40234,505.16311,19.29688ZM358.13792,272.332c-25.332,16.16211-7.50585,6.74024-99.31627,52.209a144.4818,144.4818,0,0,0-71.41006-71.36719c45.373-91.6836,35.89643-73.75,52.21282-99.45313C286.66341,79.61719,337.74146,48,410.4191,48c17.64841,0,33.541,0,51.373,2.248,2.30468,18.26367,2.24413,34.46875,2.18163,51.45507C463.97371,173.97266,432.32141,225.002,358.13792,272.332ZM368.05587,104a40,40,0,1,0,40.00581,40A40.01947,40.01947,0,0,0,368.05587,104Z"
  ]
};
export const faRoute = {
  prefix: "far",
  iconName: "route",
  icon: [
    512,
    512,
    [],
    "f4d7",
    "M424 336h-96c-22.1 0-40-17.9-40-40s17.9-40 40-40h88s96-107 96-160-43-96-96-96-96 43-96 96c0 29.8 30.3 76.7 56.9 112H328c-48.5 0-88 39.5-88 88s39.5 88 88 88h96c22.1 0 40 17.9 40 40s-17.9 40-40 40H135.1c26.6-35.3 56.9-82.2 56.9-112 0-53-43-96-96-96S0 299 0 352s96 160 96 160h328c48.5 0 88-39.5 88-88s-39.5-88-88-88zM368 96c0-26.5 21.5-48 48-48s48 21.5 48 47.9c-.5 13.4-20.8 48.2-48 84.4-27.2-36.2-47.5-70.9-48-84.3zM96 436.3c-27.2-36.2-47.5-70.9-48-84.3 0-26.5 21.5-48 48-48s48 21.5 48 47.9c-.5 13.4-20.8 48.2-48 84.4zM96 336c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zM432 96c0-8.8-7.2-16-16-16s-16 7.2-16 16 7.2 16 16 16 16-7.2 16-16z"
  ]
};
export const faRouteHighway = {
  prefix: "far",
  iconName: "route-highway",
  icon: [
    448,
    512,
    [],
    "f61a",
    "M428.4 269.21c-30.48-45.42-11.8-104.47 13-155.4 3.96-8.13 3.34-17.75-1.87-25.13l-41.17-58.36c-4.56-6.47-11.8-10.14-19.28-10.14-2.74 0-5.52.49-8.21 1.52-15.37 5.88-32.67 8.89-50.26 8.89-29.51 0-59.81-8.47-83.16-26.11C233.48 1.5 228.74 0 224 0s-9.48 1.5-13.44 4.49C187.21 22.13 156.9 30.6 127.39 30.6c-17.59 0-34.89-3.01-50.25-8.89a22.929 22.929 0 0 0-8.21-1.52c-7.48 0-14.72 3.67-19.28 10.13L8.47 88.69c-5.21 7.38-5.83 16.99-1.87 25.13 24.8 50.92 43.47 109.97 13 155.4-37.94 56.52-18.55 139.43 38.81 166.03L223.97 512l165.62-76.76c57.37-26.6 76.75-109.51 38.81-166.03zM78.65 72.48c15.57 4.03 32.12 6.12 48.75 6.12 34.98 0 68.63-8.94 96.61-25.45 27.98 16.5 61.62 25.45 96.61 25.45 16.63 0 33.18-2.09 48.75-6.12l23.01 32.62c-7.13 15.4-16.3 37.56-22.08 62.9H77.72c-5.79-25.33-14.95-47.49-22.08-62.9l23.01-32.62zM397.2 355.63c-4.73 16.92-14.87 30.07-27.79 36.06l-145.43 67.4-145.38-67.4c-12.93-6-23.06-19.14-27.8-36.06-5.78-20.67-2.55-42.98 8.66-59.67 17.23-25.68 23.58-53.33 23.83-79.96h281.42c.26 26.62 6.6 54.29 23.83 79.97 11.21 16.68 14.44 38.98 8.66 59.66z"
  ]
};
export const faRouteInterstate = {
  prefix: "far",
  iconName: "route-interstate",
  icon: [
    480,
    512,
    [],
    "f61b",
    "M464.83 55.14c-3.07-9.95-11.66-16.67-20.94-16.67-1.73 0-3.49.23-5.24.72-18.23 5.12-37.74 7.96-58.1 7.96-49.12 0-93.61-16.07-126.17-42.11C250.18 1.68 245.09 0 240 0s-10.18 1.68-14.38 5.03c-32.56 26.04-77.05 42.11-126.17 42.11-20.36 0-39.87-2.84-58.1-7.96-1.75-.49-3.51-.72-5.24-.72-9.28 0-17.87 6.73-20.94 16.67C-21.83 175.11-6.68 410.34 240 512 486.68 410.34 501.83 175.11 464.83 55.14zM55.32 91.44c14.52 2.46 29.28 3.7 44.14 3.7C150.82 95.14 200 80.62 240 53.93c40 26.69 89.18 41.22 140.55 41.22 14.85 0 29.62-1.24 44.14-3.7 4.72 22.11 7.43 48.36 6.99 76.56H48.32c-.44-28.21 2.28-54.46 7-76.57zM240 459.61C153.46 419.33 95.16 357.2 66.55 274.71c-6.81-19.64-11.27-39.36-14.21-58.71h375.31c-2.94 19.35-7.4 39.07-14.21 58.71-28.6 82.49-86.9 144.62-173.44 184.9z"
  ]
};
export const faRouter = {
  prefix: "far",
  iconName: "router",
  icon: [
    576,
    512,
    [],
    "f8da",
    "M528 288H376v-80a16 16 0 0 0-16-16h-16a16 16 0 0 0-16 16v80H48a48 48 0 0 0-48 48v128a48 48 0 0 0 48 48h480a48 48 0 0 0 48-48V336a48 48 0 0 0-48-48zm0 176H48V336h480zm-416-32a32 32 0 1 0-32-32 32 32 0 0 0 32 32zm96 0a32 32 0 1 0-32-32 32 32 0 0 0 32 32zm35.44-296.47a16.44 16.44 0 0 0-1.3 24l11.11 11.37a15.15 15.15 0 0 0 20.53 1.29 122.72 122.72 0 0 1 156.44 0 15.15 15.15 0 0 0 20.53-1.29l11.11-11.37a16.44 16.44 0 0 0-1.3-24 168.83 168.83 0 0 0-217.12 0zm-67.84-28.2c6 6.11 15.39 6.06 21.71.36a230.29 230.29 0 0 1 309.38 0c6.32 5.7 15.75 5.75 21.71-.36L539.47 96a16.41 16.41 0 0 0-1-23.56C487 25.59 421.42 0 352 0S217 25.59 165.48 72.44a16.41 16.41 0 0 0-.95 23.56z"
  ]
};
export const faRss = {
  prefix: "far",
  iconName: "rss",
  icon: [
    448,
    512,
    [],
    "f09e",
    "M80 368c17.645 0 32 14.355 32 32s-14.355 32-32 32-32-14.355-32-32 14.355-32 32-32m0-48c-44.183 0-80 35.817-80 80s35.817 80 80 80 80-35.817 80-80-35.817-80-80-80zm367.996 147.615c-6.449-237.834-198.057-429.163-435.61-435.61C5.609 31.821 0 37.229 0 44.007v24.02c0 6.482 5.147 11.808 11.626 11.992 211.976 6.04 382.316 176.735 388.354 388.354.185 6.479 5.51 11.626 11.992 11.626h24.02c6.78.001 12.187-5.608 12.004-12.384zm-136.239-.05C305.401 305.01 174.966 174.599 12.435 168.243 5.643 167.977 0 173.444 0 180.242v24.024c0 6.431 5.072 11.705 11.497 11.98 136.768 5.847 246.411 115.511 252.258 252.258.275 6.425 5.549 11.497 11.98 11.497h24.024c6.797-.001 12.264-5.644 11.998-12.436z"
  ]
};
export const faRssSquare = {
  prefix: "far",
  iconName: "rss-square",
  icon: [
    448,
    512,
    [],
    "f143",
    "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zm-6 400H54a6 6 0 0 1-6-6V86a6 6 0 0 1 6-6h340a6 6 0 0 1 6 6v340a6 6 0 0 1-6 6zm-218-88c0 22.091-17.909 40-40 40s-40-17.909-40-40 17.909-40 40-40 40 17.909 40 40zm93.566 30.405c-4.774-88.343-75.534-159.193-163.971-163.971-5.22-.282-9.595 3.912-9.595 9.14v27.468c0 4.808 3.709 8.841 8.507 9.153 63.904 4.162 115.127 55.258 119.298 119.298.313 4.798 4.345 8.507 9.153 8.507h27.468c5.228 0 9.422-4.375 9.14-9.595zm82.428.165c-4.796-133.612-112.3-241.744-246.564-246.564-5.159-.185-9.43 3.983-9.43 9.146v27.467c0 4.929 3.906 8.94 8.83 9.142 109.245 4.479 196.93 92.181 201.408 201.408.202 4.925 4.213 8.83 9.142 8.83h27.467c5.164.001 9.332-4.27 9.147-9.429z"
  ]
};
export const faRubleSign = {
  prefix: "far",
  iconName: "ruble-sign",
  icon: [
    384,
    512,
    [],
    "f158",
    "M243.128 314.38C324.987 314.38 384 257.269 384 172.238S324.987 32 243.128 32H76c-6.627 0-12 5.373-12 12v215.807H12c-6.627 0-12 5.373-12 12v30.572c0 6.627 5.373 12 12 12h52V352H12c-6.627 0-12 5.373-12 12v24c0 6.627 5.373 12 12 12h52v68c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-68h180c6.627 0 12-5.373 12-12v-24c0-6.627-5.373-12-12-12H128v-37.62h115.128zM128 86.572h105.61c53.303 0 86.301 31.728 86.301 85.666 0 53.938-32.998 87.569-86.935 87.569H128V86.572z"
  ]
};
export const faRuler = {
  prefix: "far",
  iconName: "ruler",
  icon: [
    640,
    512,
    [],
    "f545",
    "M635.7 179.2L543.2 16.3c-7.6-13.5-26.5-22-43.7-11.9L16 288.3c-15.3 9-20.6 28.9-11.7 44.5l92.5 162.9c7.6 13.4 26.5 22 43.7 11.9L624 223.7c15.3-9 20.5-28.9 11.7-44.5zm-505.4 278L53.9 322.5l46-27 34.2 60.3c2.2 3.9 7.1 5.2 10.9 3l26.6-15.6c3.8-2.2 5.1-7.2 2.9-11.1l-34.2-60.3 40.4-23.7 18.7 32.9c2.2 3.9 7.1 5.2 10.9 3l26.6-15.6c3.8-2.2 5.1-7.2 2.9-11.1l-18.7-32.9 40.4-23.7 34.2 60.3c2.2 3.9 7.1 5.2 10.9 3l26.6-15.6c3.8-2.2 5.1-7.2 2.9-11.1L302 176.8l40.4-23.7 18.7 32.9c2.2 3.9 7.1 5.2 10.9 3l26.6-15.6c3.8-2.2 5.1-7.2 2.9-11.1l-18.7-32.9 40.4-23.7 34.2 60.3c2.2 3.9 7.1 5.2 10.9 3l26.6-15.6c3.8-2.2 5.1-7.2 2.9-11.1L463.6 82l46-27 76.5 134.7-455.8 267.5z"
  ]
};
export const faRulerCombined = {
  prefix: "far",
  iconName: "ruler-combined",
  icon: [
    512,
    512,
    [],
    "f546",
    "M480 288H224V32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v448c0 17.67 14.33 32 32 32h448c17.67 0 32-14.33 32-32V320c0-17.67-14.33-32-32-32zM48 48h128v48h-72c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h72v48h-72c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h72v48h-72c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h72v25.38l-128 128V48zm416 416H70.62l128-128H224v72c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-72h48v72c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-72h48v72c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-72h48v128z"
  ]
};
export const faRulerHorizontal = {
  prefix: "far",
  iconName: "ruler-horizontal",
  icon: [
    640,
    512,
    [],
    "f547",
    "M608 128H32c-17.67 0-32 14.33-32 32v192c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V160c0-17.67-14.33-32-32-32zm-16 208H48V176h64v56c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-56h64v56c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-56h64v56c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-56h64v56c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-56h64v56c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-56h64v160z"
  ]
};
export const faRulerTriangle = {
  prefix: "far",
  iconName: "ruler-triangle",
  icon: [
    512,
    512,
    [],
    "f61c",
    "M501.65 452.08L59.91 10.35C52.76 3.2 43.97 0 35.35 0 17.31 0 0 14.01 0 35.17V476.9C0 496.29 15.71 512 35.1 512h441.73c31.27 0 46.93-37.8 24.82-59.92zM48 464V66.32l63.08 63.08-11.31 11.31c-6.25 6.25-6.25 16.38 0 22.63l11.31 11.31c6.25 6.25 16.38 6.25 22.63 0l11.31-11.31 45.26 45.25-11.31 11.31c-6.25 6.25-6.25 16.38 0 22.63l11.31 11.31c6.25 6.25 16.38 6.25 22.63 0l11.31-11.31 45.25 45.25-11.31 11.31c-6.25 6.25-6.25 16.38 0 22.63l11.31 11.31c6.25 6.25 16.38 6.25 22.63 0l11.31-11.31 45.25 45.26-11.31 11.31c-6.25 6.25-6.25 16.38 0 22.63l11.31 11.31c6.25 6.25 16.38 6.25 22.63 0l11.31-11.31L445.68 464H48zm80-80h124.54L128 259.46V384z"
  ]
};
export const faRulerVertical = {
  prefix: "far",
  iconName: "ruler-vertical",
  icon: [
    256,
    512,
    [],
    "f548",
    "M224 0H32C14.33 0 0 14.33 0 32v448c0 17.67 14.33 32 32 32h192c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32zM48 464V48h160v48h-56c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h56v64h-56c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h56v64h-56c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h56v64h-56c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h56v48H48z"
  ]
};
export const faRunning = {
  prefix: "far",
  iconName: "running",
  icon: [
    416,
    512,
    [],
    "f70c",
    "M126.16 316.86l-19.85 46.28c-1.27 2.95-4.14 4.86-7.35 4.86H24.01C10.76 368 0 378.75 0 392s10.76 24 24.01 24h74.95c22.43 0 42.65-13.31 51.5-33.94l13.55-31.6-9.56-5.77c-11.88-7.18-21.22-16.87-28.29-27.83zM272.15 96c26.52 0 48.03-21.49 48.03-48s-21.5-48-48.03-48-48.03 21.49-48.03 48 21.51 48 48.03 48zm119.91 144.56l-48.4-.17c-3.53-.02-6.6-2.3-7.61-5.66l-13.95-45.92c-9.19-30.19-34.02-53.27-64.82-60.23l-78.25-17.7c-25.73-5.86-52.45.08-73.26 16.22L57.4 164.46c-10.49 8.09-12.43 23.17-4.31 33.66 8.08 10.5 23.23 12.41 33.68 4.31l48.39-37.36c9.46-7.33 21.68-9.92 33.3-7.38l14.88 3.37-35.3 87.35c-10.35 25.62-.69 54.59 22.98 68.91l83.78 50.58a8.004 8.004 0 0 1 3.55 9.05l-33.3 104.47c-3.64 12.75 3.74 26.03 16.49 29.67 2.2.62 4.42.92 6.61.92 10.44 0 20.06-6.86 23.08-17.41l33.3-104.47c6.93-24.25-3.31-50.28-24.9-63.33l-51.85-31.3 41.94-104.8c2.72 3.64 5.06 7.59 6.42 12.07l13.96 45.94c7.21 23.66 28.67 39.61 53.41 39.69l48.4.17h.08c13.23 0 23.97-10.69 24.01-23.92.05-13.26-10.66-24.04-23.94-24.09z"
  ]
};
export const faRupeeSign = {
  prefix: "far",
  iconName: "rupee-sign",
  icon: [
    320,
    512,
    [],
    "f156",
    "M308 80c6.627 0 12-5.373 12-12V44c0-6.627-5.373-12-12-12H12C5.373 32 0 37.373 0 44v31.659c0 6.627 5.373 12 12 12h93.61c39.065 0 67.203 17.4 79.458 48.341H12c-6.627 0-12 5.373-12 12v24c0 6.627 5.373 12 12 12h179.59c-3.43 49.738-35.677 80.341-86.615 80.341H12c-6.627 0-12 5.373-12 12v34.974c0 3.495 1.524 6.816 4.173 9.096l182.094 156.685a11.996 11.996 0 0 0 7.827 2.904h61.326c11.13 0 16.263-13.837 7.827-21.096L101.818 320h13.31c79.002 0 136.718-54.257 140.65-136H308c6.627 0 12-5.373 12-12v-24c0-6.627-5.373-12-12-12h-56.354c-5.067-21.636-14.409-40.497-27.202-56H308z"
  ]
};
export const faRv = {
  prefix: "far",
  iconName: "rv",
  icon: [
    640,
    512,
    [],
    "f7be",
    "M592.1 208h3.9c24.3 0 44-19.7 44-44 0-72.9-59.1-132-132-132H384V16c0-8.8-7.2-16-16-16H240c-8.8 0-16 7.2-16 16v16H64C28.7 32 0 60.7 0 96v197.5c0 17 6.7 33.3 18.7 45.3L96 416v16c0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.6-10.8-1.6-16h163.2c-1.1 5.2-1.6 10.5-1.6 16 0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.6-10.8-1.6-16H608c17.6 0 32-14.4 32-32V282.4c0-17-6.7-33.2-18.7-45.2L592.1 208zM176 464c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm192-96H223.6c-13.3-9.9-29.7-16-47.6-16s-34.2 6.1-47.6 16h-12.6l-63.2-63.2c-3-3-4.7-7-4.7-11.3V96c0-8.8 7.2-16 16-16h444c45 0 81.8 35.5 83.9 80H368v208zm204.2-112H416v-48h101.5c4.3 0 8.4 1.7 11.5 4.8l43.2 43.2zM496 464c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm96-96h-48.4c-13.3-9.9-29.7-16-47.6-16s-34.2 6.1-47.6 16H416v-64h176v64zM304 128H112c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h192c8.8 0 16-7.2 16-16v-96c0-8.8-7.2-16-16-16zm-32 80H144v-32h128v32z"
  ]
};
export const faSack = {
  prefix: "far",
  iconName: "sack",
  icon: [
    512,
    512,
    [],
    "f81c",
    "M326 115.91l55.4-81.18A24 24 0 0 0 360 0H152a24 24 0 0 0-21.47 34.73L186 115.92C-9.82 235.66.08 392.05.08 412c0 55.23 49.11 100 109.69 100h292.49c60.57 0 109.68-44.77 109.68-100 0-19.59 8.8-177-185.94-296.09zM314.28 48l-38.22 56h-40.12l-38.22-56zm149.66 364c0 28.67-27.67 52-61.68 52H109.77c-34 0-61.68-23.33-61.68-52-.82-81 32.63-175.45 170.91-260h74.08c137.58 84.18 171.53 178.93 170.86 260z"
  ]
};
export const faSackDollar = {
  prefix: "far",
  iconName: "sack-dollar",
  icon: [
    512,
    512,
    [],
    "f81d",
    "M326 115.91l55.4-81.18A24 24 0 0 0 360 0H152a24 24 0 0 0-21.47 34.73L186 115.92C-9.82 235.66.08 392.05.08 412c0 55.23 49.11 100 109.69 100h292.49c60.57 0 109.68-44.77 109.68-100 0-19.59 8.8-177-185.94-296.09zM314.28 48l-38.22 56h-40.12l-38.22-56zm149.66 364c0 28.67-27.67 52-61.68 52H109.77c-34 0-61.68-23.33-61.68-52-.82-81 32.63-175.45 170.91-260h74.08c137.58 84.18 171.53 178.93 170.86 260zM285.61 310.74l-49-14.54c-5.65-1.62-9.57-7.22-9.57-13.68 0-7.86 5.77-14.21 12.84-14.21h30.59a26.81 26.81 0 0 1 13.93 4 8.92 8.92 0 0 0 11-.75l12.74-12.17a8.54 8.54 0 0 0-.66-13 63.12 63.12 0 0 0-34.17-12.17v-17.6a8.69 8.69 0 0 0-8.71-8.62h-17.42a8.68 8.68 0 0 0-8.7 8.62v17.44c-25.8.75-46.48 22.19-46.48 48.57 0 21.54 14.15 40.71 34.39 46.74l49 14.54c5.65 1.61 9.57 7.21 9.57 13.67 0 7.87-5.77 14.22-12.84 14.22h-30.6a26.72 26.72 0 0 1-13.93-4 8.92 8.92 0 0 0-11 .76l-12.85 12.06a8.54 8.54 0 0 0 .66 13 63.2 63.2 0 0 0 34.18 12.17v17.55a8.68 8.68 0 0 0 8.7 8.62h17.42a8.68 8.68 0 0 0 8.7-8.62V406c25.69-.64 46.48-22.18 46.59-48.56.01-21.5-14.14-40.67-34.38-46.7z"
  ]
};
export const faSadCry = {
  prefix: "far",
  iconName: "sad-cry",
  icon: [
    496,
    512,
    [],
    "f5b3",
    "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm144 386.4V280c0-13.2-10.8-24-24-24s-24 10.8-24 24v151.4C315.5 447 282.8 456 248 456s-67.5-9-96-24.6V280c0-13.2-10.8-24-24-24s-24 10.8-24 24v114.4c-34.6-36-56-84.7-56-138.4 0-110.3 89.7-200 200-200s200 89.7 200 200c0 53.7-21.4 102.5-56 138.4zM205.8 234.5c4.4-2.4 6.9-7.4 6.1-12.4-4-25.2-34.2-42.1-59.8-42.1s-55.9 16.9-59.8 42.1c-.8 5 1.7 10 6.1 12.4 4.4 2.4 9.9 1.8 13.7-1.6l9.5-8.5c14.8-13.2 46.2-13.2 61 0l9.5 8.5c2.5 2.3 7.9 4.8 13.7 1.6zM344 180c-25.7 0-55.9 16.9-59.8 42.1-.8 5 1.7 10 6.1 12.4 4.5 2.4 9.9 1.8 13.7-1.6l9.5-8.5c14.8-13.2 46.2-13.2 61 0l9.5 8.5c2.5 2.2 8 4.7 13.7 1.6 4.4-2.4 6.9-7.4 6.1-12.4-3.9-25.2-34.1-42.1-59.8-42.1zm-96 92c-30.9 0-56 28.7-56 64s25.1 64 56 64 56-28.7 56-64-25.1-64-56-64z"
  ]
};
export const faSadTear = {
  prefix: "far",
  iconName: "sad-tear",
  icon: [
    496,
    512,
    [],
    "f5b4",
    "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm8-152c-13.2 0-24 10.8-24 24s10.8 24 24 24c23.8 0 46.3 10.5 61.6 28.8 8.1 9.8 23.2 11.9 33.8 3.1 10.2-8.5 11.6-23.6 3.1-33.8C330 320.8 294.1 304 256 304zm-88-64c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160-64c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm-165.6 98.8C151 290.1 126 325.4 126 342.9c0 22.7 18.8 41.1 42 41.1s42-18.4 42-41.1c0-17.5-25-52.8-36.4-68.1-2.8-3.7-8.4-3.7-11.2 0z"
  ]
};
export const faSalad = {
  prefix: "far",
  iconName: "salad",
  icon: [
    512,
    512,
    [],
    "f81e",
    "M512 240c0-49.93-29-92.82-70.87-113.9a95.42 95.42 0 0 0-77.72-60.94c-12.78-2.07-24.33-.78-36.69 2.59a112 112 0 0 0-205.84 0C103 62.88 91.19 64 84.21 65.16a95.49 95.49 0 0 0-84.08 90c-1 16 4.11 37 10.56 49.14 9 17 15.94 34.9 19.09 53.57-7.39 1.81-14.4 5-19.64 10.71a38.29 38.29 0 0 0-10 29.08c6.18 72.9 51.31 136.51 116.6 166.34 2.84 26.92 25.44 48 52.78 48H343.1c27.44 0 50.1-21.17 52.82-48.22 64.94-30 109.79-93.51 115.94-166.11.67-7.76-1.84-15.15-5.69-21.86 3.41-11.43 5.83-23.28 5.83-35.81zm-128.09-80C430 160 464 198.84 464 240c0 5.57-1.14 10.79-2.28 16H306.13c-1.14-5.21-2.27-10.43-2.27-16a80 80 0 0 1 80.05-80zM215.8 96h16a8 8 0 0 1 8 8v152h-32V104a8 8 0 0 1 8-8zM74 165.66l11.32-11.32a8 8 0 0 1 11.32 0L198.41 256h-45.28L74 177a8 8 0 0 1 0-11.34zm290 259.39l-15.81 5.73v27.5c0 3.16-2.29 5.72-5.1 5.72H169.52c-2.81 0-5.09-2.56-5.09-5.72v-27.4l-15.91-5.69C95.8 406.31 57.7 359.42 49.2 304h413.6c-8.47 55.2-46.35 102.05-98.8 121.05z"
  ]
};
export const faSandwich = {
  prefix: "far",
  iconName: "sandwich",
  icon: [
    512,
    512,
    [],
    "f81f",
    "M497.61 247.3c-16.86-1.78-26.82-6.77-38.8-12.77-12.94-6.47-71.67-38.85-149.37 0-52.66 26.38-90.19 8.19-106.56 0-12.8-6.39-71.25-39.14-149.54 0-12 6-22 11-38.95 12.77A16 16 0 0 0 0 263.13v16.08c0 9.59 8.51 16.88 18.06 16 26.4-2.55 42.36-10.52 56.72-17.7 52.79-26.4 90.35-8.15 106.66 0 77.7 38.85 136.54 6.47 149.5 0 55.93-28 95.44-5.46 106.37 0 14.36 7.18 30.3 15.15 56.62 17.7 9.55.92 18.07-6.37 18.07-16v-16.08a16 16 0 0 0-14.39-15.83zM480 32H32A32 32 0 0 0 0 64v96a32 32 0 0 0 32 32h448a32 32 0 0 0 32-32V64a32 32 0 0 0-32-32zm-16 112H48V80h416zm16 176H32a32 32 0 0 0-32 32v96a32 32 0 0 0 32 32h448a32 32 0 0 0 32-32v-96a32 32 0 0 0-32-32zm-16 112H48v-64h232l72 48 72-48h40z"
  ]
};
export const faSatellite = {
  prefix: "far",
  iconName: "satellite",
  icon: [
    512,
    512,
    [],
    "f7bf",
    "M502.62516,264.79688a31.98911,31.98911,0,0,1,0,45.10937l-96.6858,96.6875a31.8365,31.8365,0,0,1-44.99921,0l-45.99919-46c9.99982,48.20313,3.68743,99-20.12465,143.3125A15.39834,15.39834,0,0,1,280.94156,512a16.79636,16.79636,0,0,1-11.906-4.90625L148.22514,386.40625l-21.90587,21.89063c.71874,2.60937,1.625,5,1.625,7.79687a31.99944,31.99944,0,1,1-31.99944-32c2.78121,0,5.18741.90625,7.78112,1.60937l21.90586-21.90624L4.9464,243.09375C-2.67846,235.5-1.366,222.40625,8.0401,217.29688a211.415,211.415,0,0,1,142.59124-20.89063l-45.3117-45.3125a32.02746,32.02746,0,0,1,0-45.09375l96.717-96.70312A31.56644,31.56644,0,0,1,224.5363,0a32.04621,32.04621,0,0,1,22.59335,9.29688l70.81126,70.90624,70.78-70.79687a31.87473,31.87473,0,0,1,45.218,0L502.62516,78a32.04531,32.04531,0,0,1,0,45.29688l-70.81125,70.79687ZM224.13005,287.90625A164.01085,164.01085,0,0,0,73.6327,243.70312L268.223,438.40625C279.62908,385,263.81686,327.70312,224.13005,287.90625ZM150.72509,128.5l59.40521,59.40625,73.8112-73.8125L224.5363,54.70312Zm82.31106,104.40625A214.85983,214.85983,0,0,1,258.03571,254a217.48794,217.48794,0,0,1,21.09338,24.90625L457.43846,100.70312,411.31427,54.59375ZM457.31346,287.5l-59.374-59.40625-73.8112,73.8125,59.40521,59.39063Z"
  ]
};
export const faSatelliteDish = {
  prefix: "far",
  iconName: "satellite-dish",
  icon: [
    512,
    512,
    [],
    "f7c0",
    "M315.02363,461.00155c7.59223,7.59352,6.31124,20.7025-3.09314,25.79609A211.82864,211.82864,0,0,1,61.98024,450.00188C-5.725,382.30081-17.91011,280.30391,25.17507,200.10322a15.47642,15.47642,0,0,1,13.90348-8.0935,16.89827,16.89827,0,0,1,11.90388,4.9061L171.64591,317.709l21.90189-21.90559c-.68736-2.59367-1.59343-4.99985-1.59343-7.79664a31.99364,31.99364,0,1,1,31.99363,31.999c-2.81194,0-5.21771-.90622-7.81094-1.5937l-21.90189,21.89Zm-68.5801-.7031-194.68-194.69722C40.39079,319.00586,56.1689,376.301,95.97348,416.09666A162.48809,162.48809,0,0,0,211.638,464.00146,169.49813,169.49813,0,0,0,246.44353,460.29845ZM511.98442,303.30321a16.25209,16.25209,0,0,1-16.30925,16.70262H479.67835a15.96553,15.96553,0,0,1-15.77811-15.49953C457.0891,166.41675,345.51756,55.81073,207.35756,48.10784c-8.62329-.5-15.40319-7.18728-15.40319-15.7964V16.31193A16.25444,16.25444,0,0,1,208.63855.01555C372.01228,8.51529,503.39238,139.91755,511.98442,303.30321Zm-96.07462-.20312c.59363,9.1091-7.09234,16.812-16.21553,16.812H383.51c-8.4983,0-15.09074-6.70292-15.80935-15.20266-7.18607-85.40366-75.07881-154.79217-160.34308-160.69824-8.62329-.5-15.40319-7.20291-15.40319-15.7964V112.21527c0-9.20285,7.686-16.90574,16.77791-16.20264C319.21029,104.21551,407.599,192.71282,415.9098,303.10009Z"
  ]
};
export const faSausage = {
  prefix: "far",
  iconName: "sausage",
  icon: [
    512,
    512,
    [],
    "f820",
    "M447.83 69.83L463 24.18A18.36 18.36 0 0 0 445.62 0h-59.24A18.36 18.36 0 0 0 369 24.18l15.21 45.65C346.88 83 320 118.2 320 160c0 88.22-71.78 160-160 160-41.8 0-77 26.88-90.17 64.17L24.18 369A18.36 18.36 0 0 0 0 386.38v59.24A18.37 18.37 0 0 0 24.18 463l45.65-15.21C83 485.12 118.2 512 160 512c194.09 0 352-157.91 352-352 0-41.8-26.88-77-64.17-90.17zM160 464a48 48 0 0 1 0-96c114.69 0 208-93.31 208-208a48 48 0 0 1 96 0c0 167.63-136.37 304-304 304z"
  ]
};
export const faSave = {
  prefix: "far",
  iconName: "save",
  icon: [
    448,
    512,
    [],
    "f0c7",
    "M433.941 129.941l-83.882-83.882A48 48 0 0 0 316.118 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V163.882a48 48 0 0 0-14.059-33.941zM272 80v80H144V80h128zm122 352H54a6 6 0 0 1-6-6V86a6 6 0 0 1 6-6h42v104c0 13.255 10.745 24 24 24h176c13.255 0 24-10.745 24-24V83.882l78.243 78.243a6 6 0 0 1 1.757 4.243V426a6 6 0 0 1-6 6zM224 232c-48.523 0-88 39.477-88 88s39.477 88 88 88 88-39.477 88-88-39.477-88-88-88zm0 128c-22.056 0-40-17.944-40-40s17.944-40 40-40 40 17.944 40 40-17.944 40-40 40z"
  ]
};
export const faSaxHot = {
  prefix: "far",
  iconName: "sax-hot",
  icon: [
    640,
    512,
    [],
    "f8db",
    "M120 288a24 24 0 1 0 24 24 24 24 0 0 0-24-24zm505.82-183.73l-24.58-23.41A61.24 61.24 0 0 0 558.81 64h-42.15a90.59 90.59 0 0 0-62.8 24.89l-5.5 5.53-9.73-9.73a16 16 0 0 0-22.63 0L404.69 96a16 16 0 0 0 0 22.63l9.82 9.82-14 14.1-9.86-9.86a16 16 0 0 0-22.63 0L356.69 144a16 16 0 0 0 0 22.63l9.95 10-14 14.1-10-10a16 16 0 0 0-22.63 0L308.69 192a16 16 0 0 0 0 22.63l10.08 10.08L224 320l22.86-64H256a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v16a15.82 15.82 0 0 0 14 15.59c-7.3 30.08-14 63.75-14 87.27 0 62.7 36.31 119.94 94.77 149.36C119 505.22 146.59 512 176 512c78.65 0 122-47 136.24-62.49 4.63-5-17.73 21.45 224.27-266.65h57.06a46.14 46.14 0 0 0 43.17-29 45.08 45.08 0 0 0-10.92-49.59zm-89.31 30.59A48 48 0 0 0 499.76 152C258.42 439.31 280.7 413 276.94 417c-11.85 12.86-43.33 47-100.94 47a123.87 123.87 0 0 1-59.65-14.65C74.19 428.13 48 387.32 48 342.86c0-24.46 8.16-58.66 15.43-86.86h132.46l-17.09 47.86a48 48 0 0 0 79.23 50L487 123.66A42.77 42.77 0 0 1 516.66 112h42.15a13.24 13.24 0 0 1 9.33 3.62l20.2 19.24zM74.07 176l-7-16.45A66.15 66.15 0 0 1 64 140.8c0-10.43 11.25-38.67 36.33-70.61 3.7 4.52 7.21 9.07 10.49 13.59l36.57 50.39 28.1-34.34C186 118 191.72 134.51 192 140.8a66.15 66.15 0 0 1-3.06 18.75l-7 16.45h52.18a117 117 0 0 0 5.88-35.2c0-26.63-26-81.57-62.23-115.2a301.94 301.94 0 0 0-28.1 30A387.31 387.31 0 0 0 100 0C50.88 45.58 16 105 16 140.8a117 117 0 0 0 5.89 35.2z"
  ]
};
export const faSaxophone = {
  prefix: "far",
  iconName: "saxophone",
  icon: [
    640,
    512,
    [],
    "f8dc",
    "M112 280a24 24 0 1 0 24 24 24 24 0 0 0-24-24zM625.83 72.27l-24.58-23.41A61.24 61.24 0 0 0 558.81 32h-42.15a90.59 90.59 0 0 0-62.8 24.89l-5.5 5.53-9.73-9.73a16 16 0 0 0-22.63 0L404.69 64a16 16 0 0 0 0 22.63l9.82 9.82-14 14.1-9.86-9.86a16 16 0 0 0-22.63 0L356.69 112a16 16 0 0 0 0 22.63l9.95 10-14 14.1-10-10a16 16 0 0 0-22.63 0L308.69 160a16 16 0 0 0 0 22.63l10.08 10.08L224 288l40-112h8a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h10.59C17.09 209 0 273.14 0 310.86c0 62.7 36.31 119.94 94.77 149.36C119 473.22 146.59 480 176 480c78.65 0 122-47 136.24-62.49 4.63-5-17.73 21.45 224.27-266.65h57.07a46.16 46.16 0 0 0 43.17-29 45.12 45.12 0 0 0-10.92-49.59zm-89.32 30.59A48 48 0 0 0 499.76 120C258.42 407.31 280.7 381 276.94 385c-11.85 12.86-43.33 47-100.94 47a123.87 123.87 0 0 1-59.65-14.65C74.19 396.13 48 355.32 48 310.86 48 267 74.59 190.62 74.59 176H213l-34.2 95.86a48 48 0 0 0 79.23 50L487 91.66A42.78 42.78 0 0 1 516.66 80h42.15a13.22 13.22 0 0 1 9.33 3.62l20.2 19.24zM128 200a24 24 0 1 0 24 24 24 24 0 0 0-24-24z"
  ]
};
export const faScalpel = {
  prefix: "far",
  iconName: "scalpel",
  icon: [
    544,
    512,
    [],
    "f61d",
    "M509.82 13.82C496.61 4.4 481.33 0 465.99 0c-24.22 0-48.59 10.96-65.24 30.42l-235.08 274.7c-6.79 7.94-4.94 18.28 1.27 24.77L0 512h.38c101.37 0 198.38-34.12 272.97-94.68.23-.19.46-.38.69-.56 25.93-21.25 42.01-49.96 49.46-80.75h10.32c10.93 0 21.32-4.78 28.43-13.09L524.43 133.4c30.77-35.94 24.78-91.48-14.61-119.58zM243.09 380.05c-33.88 27.51-72.81 48.74-114.74 62.97L226.45 336h47.49c-6.22 17.28-16.71 32.46-30.85 44.05zm244.87-277.86L328.94 288H243.5L437.22 61.63C444.41 53.22 455.43 48 465.99 48c6.03 0 11.4 1.65 15.96 4.9 10.45 7.45 13.13 17.75 13.8 23.22 1.17 9.58-1.6 18.84-7.79 26.07z"
  ]
};
export const faScalpelPath = {
  prefix: "far",
  iconName: "scalpel-path",
  icon: [
    640,
    512,
    [],
    "f61e",
    "M509.82 13.82C496.61 4.4 481.33 0 465.99 0c-24.22 0-48.59 10.96-65.24 30.42l-235.08 274.7c-6.79 7.94-4.94 18.28 1.27 24.77L0 512h.38c101.37 0 198.38-34.12 272.97-94.68.23-.19.46-.38.69-.56 25.93-21.25 42.01-49.96 49.46-80.75h10.32c10.93 0 21.32-4.78 28.43-13.09L524.43 133.4c30.77-35.94 24.78-91.48-14.61-119.58zM243.09 380.05c-33.88 27.51-72.81 48.74-114.74 62.97L226.45 336h47.49c-6.22 17.28-16.71 32.46-30.85 44.05zm244.87-277.86L328.94 288H243.5L437.22 61.63C444.41 53.22 455.43 48 465.99 48c6.03 0 11.4 1.65 15.96 4.9 10.45 7.45 13.13 17.75 13.8 23.22 1.17 9.58-1.6 18.84-7.79 26.07zM488 464h-80c-4.42 0-8 3.58-8 8v32c0 4.42 3.58 8 8 8h80c4.42 0 8-3.58 8-8v-32c0-4.42-3.58-8-8-8zm-144 0h-80c-4.42 0-8 3.58-8 8v32c0 4.42 3.58 8 8 8h80c4.42 0 8-3.58 8-8v-32c0-4.42-3.58-8-8-8zm288 0h-80c-4.42 0-8 3.58-8 8v32c0 4.42 3.58 8 8 8h80c4.42 0 8-3.58 8-8v-32c0-4.42-3.58-8-8-8z"
  ]
};
export const faScanner = {
  prefix: "far",
  iconName: "scanner",
  icon: [
    640,
    512,
    [],
    "f488",
    "M632 64H456c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h176c4.4 0 8-3.6 8-8V72c0-4.4-3.6-8-8-8zm0-64H456c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h176c4.4 0 8-3.6 8-8V8c0-4.4-3.6-8-8-8zm0 160H456c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h176c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm0 192H456c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h176c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zm0-64H456c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h176c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zM368 64H112C50.1 64 0 114.1 0 176c0 50.3 33.3 92.3 78.9 106.5L6.4 408C-6.9 431 1 460.3 24 473.6l55.4 32c7.6 4.4 15.8 6.4 24 6.4 16.6 0 32.7-8.6 41.6-24l60-104h67c26.5 0 48-21.5 48-48v-48h48c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16zM103.4 464L48 432l83.1-144H205L103.4 464zM288 336c0 8.8-7.2 16-16 16h-48.5l36.9-64H288v48zm48-96H112c-35.3 0-64-28.7-64-64s28.7-64 64-64h224v128zm296 208H456c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h176c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z"
  ]
};
export const faScannerImage = {
  prefix: "far",
  iconName: "scanner-image",
  icon: [
    640,
    512,
    [],
    "f8f3",
    "M168 408h32a8 8 0 0 0 8-8v-32a8 8 0 0 0-8-8h-32a8 8 0 0 0-8 8v32a8 8 0 0 0 8 8zm-80 0h32a8 8 0 0 0 8-8v-32a8 8 0 0 0-8-8H88a8 8 0 0 0-8 8v32a8 8 0 0 0 8 8zm550.89-120c-2.69-21-16.51-39.19-37-46.11L26.25 32.85a15.75 15.75 0 0 0-5.12-.85A16 16 0 0 0 6 42.88L.85 58.07a16 16 0 0 0 10 20.28l575.7 209.06c.34.11.5.44.81.59H48a48 48 0 0 0-48 48v96a48 48 0 0 0 48 48h544a48 48 0 0 0 48-48V288zM592 432H48v-96h544z"
  ]
};
export const faScannerKeyboard = {
  prefix: "far",
  iconName: "scanner-keyboard",
  icon: [
    576,
    512,
    [],
    "f489",
    "M400 64H16C7.2 64 0 71.2 0 80v182.6c0 8.5 3.4 16.6 9.4 22.6L32 307.9V464c0 26.5 21.5 48 48 48h256c26.5 0 48-21.5 48-48V307.9l22.6-22.6c6-6 9.4-14.1 9.4-22.6V80c0-8.8-7.2-16-16-16zm-32 192l-32 32v176H80V288l-32-32V112h320v144zM184 368h-64c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm112 0h-64c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm-112-96h-64c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm112 0h-64c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm-184-48h192c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16H112c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16zM256 8c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v24h64V8zm64 0c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v24h32V8zm248-8h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V8c0-4.4-3.6-8-8-8zM408 0h-48c-4.4 0-8 3.6-8 8v24h64V8c0-4.4-3.6-8-8-8zm64 0h-16c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V8c0-4.4-3.6-8-8-8z"
  ]
};
export const faScannerTouchscreen = {
  prefix: "far",
  iconName: "scanner-touchscreen",
  icon: [
    576,
    512,
    [],
    "f48a",
    "M400 64H16C7.2 64 0 71.2 0 80v182.6c0 8.5 3.4 16.6 9.4 22.6L32 307.9V464c0 26.5 21.5 48 48 48h256c26.5 0 48-21.5 48-48V307.9l22.6-22.6c6-6 9.4-14.1 9.4-22.6V80c0-8.8-7.2-16-16-16zm-32 192l-32 32v176H80V288l-32-32V112h320v144zM144 416h128c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H144c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16zM256 8c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v24h64V8zm64 0c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v24h32V8zm248-8h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V8c0-4.4-3.6-8-8-8zm-96 0h-16c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V8c0-4.4-3.6-8-8-8zm-64 0h-48c-4.4 0-8 3.6-8 8v24h64V8c0-4.4-3.6-8-8-8z"
  ]
};
export const faScarecrow = {
  prefix: "far",
  iconName: "scarecrow",
  icon: [
    448,
    512,
    [],
    "f70d",
    "M445.7 186.3L419.3 160l18.3-18.3c5-5 1.5-13.7-5.7-13.7H320V96c0-53-43-96-96-96-1.7 0-3.4 0-5.2.1C166.9 2.8 128 49.5 128 101.4V128H16c-7.1 0-10.7 8.6-5.7 13.7L28.7 160 2.3 186.3c-3.1 3.1-3.1 8.2 0 11.3L28.7 224l-18.3 18.3c-5 5-1.5 13.7 5.7 13.7h106.1l-26 141.3c-1.7 10.3 6.5 18.7 15.8 18.7 2.4 0 4.8-.5 7.2-1.7l32.7-24.2c2.8-2 6.1-3.2 9.5-3.1 2.6 0 5.2.6 7.5 1.9l31.1 16.6V496c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-90.7l31.1-16.6c2.4-1.3 5-1.9 7.5-1.9 3.4 0 6.7 1.1 9.5 3.1l32.7 24.2c2.4 1.2 4.8 1.7 7.2 1.7 9.3 0 17.5-8.4 15.8-18.7L325.9 256H432c7.1 0 10.7-8.6 5.7-13.7L419.3 224l26.3-26.3c3.2-3.2 3.2-8.2.1-11.4zM176 101.4c0-.6.1-1.2.2-1.7 3.3 2.5 7.3 4.3 11.8 4.3 11 0 20-9 20-20 0-10.5-8.1-18.8-18.3-19.7 8.2-9.4 19.4-15.6 31.7-16.3h2.6c22 0 40.3 14.9 46 35.1-3-1.8-6.3-3.1-10-3.1-11 0-20 9-20 20s9 20 20 20c4.6 0 8.6-1.8 12-4.4V128c0 8.8-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16zM367.4 208h-99.2l10.4 56.6 13.7 74.5c-12.4-1.1-24.8 1.4-35.8 7.3L224 363.7l-32.5-17.3c-9.3-4.9-19.6-7.5-30.1-7.5-1.9 0-3.8.1-5.7.2l13.6-74.5 10.4-56.7H80.6l-16-16 16-16h69.5c11.2 9.8 25.8 16 41.9 16h64c16.1 0 30.7-6.2 41.9-16h69.5l16 16z"
  ]
};
export const faScarf = {
  prefix: "far",
  iconName: "scarf",
  icon: [
    512,
    512,
    [],
    "f7c1",
    "M509.7 395.7l-68.8-68.6-74.3-74.2 24.1-24.7c48.6-53.7 13-113.3 11.5-115.8l-43.6-73.1c-4.3-7.2-9.9-13.3-16.8-18-45.8-30.6-132.4-26.2-171.5.2-6.9 4.7-12.5 10.8-16.8 18l-43.6 73.1c-1.5 2.5-37.1 62.1 11.5 115.8l24.1 24.7-74.3 74.2-68.9 68.4c-3.1 3.1-3.1 8.2 0 11.3l11.3 11.3c3.1 3.1 8.2 3.1 11.3 0l68.8-68.6 22.6 22.6-68.8 68.6c-3.1 3.1-3.1 8.2 0 11.3l11.3 11.3c3.1 3.1 8.2 3.1 11.3 0l68.8-68.6 22.5 22.5-68.7 69.7c-3.1 3.1-3.1 8.2 0 11.3l11.3 11.3c3.1 3.1 8.2 3.1 11.3 0L256 365.9l140.5 143.7c3.1 3.1 8.2 3.1 11.3 0l11.3-11.3c3.1-3.1 3.1-8.2 0-11.3l-68.7-69.7 22.5-22.5 68.8 68.6c3.1 3.1 8.2 3.1 11.3 0l11.3-11.3c3.1-3.1 3.1-8.2 0-11.3l-68.8-68.6 22.6-22.6 68.8 68.6c3.1 3.1 8.2 3.1 11.3 0l11.3-11.3c3.3-3 3.3-8 .2-11.2zM361 137.1c4.3 7.4 16.6 33.4-5.4 58.3L332.5 219l-42.7-42.8L349 117l12 20.1zm-166.3-73c12.6-21 110.2-21 122.7-.1l6.3 10.5-67.7 67.8-67.6-67.8 6.3-10.4zm27 268.3l-38.2 39.1-44.4-44.3 40-39.9 43.4 44.3-.8.8zm106.8 39l-172.1-176c-22-24.9-9.7-50.9-5.3-58.4l12-20.1L372.9 327l-44.4 44.4z"
  ]
};
export const faSchool = {
  prefix: "far",
  iconName: "school",
  icon: [
    640,
    512,
    [],
    "f549",
    "M368 352h-96c-8.84 0-16 7.16-16 16v128c0 8.84 7.16 16 16 16h96c8.84 0 16-7.16 16-16V368c0-8.84-7.16-16-16-16zm-48-232c-48.6 0-88 39.4-88 88s39.4 88 88 88 88-39.4 88-88-39.4-88-88-88zm48 112c0 4.42-3.58 8-8 8h-48c-4.42 0-8-3.58-8-8v-64c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v40h24c4.42 0 8 3.58 8 8v16zm240-40h-96v-53.33c0-10.7-5.35-20.69-14.25-26.62l-160-106.67A31.9 31.9 0 0 0 320 0a31.97 31.97 0 0 0-17.75 5.37l-160 106.67A32.015 32.015 0 0 0 128 138.66V192H32c-17.67 0-32 14.33-32 32v272c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V240h80v272h48V147.23l144-96 144 96V512h48V240h80v256c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V224c0-17.67-14.33-32-32-32z"
  ]
};
export const faScrewdriver = {
  prefix: "far",
  iconName: "screwdriver",
  icon: [
    512,
    512,
    [],
    "f54a",
    "M400 224L512 74.67 437.33 0 288 112v78.06l-75.85 75.85c-44.88-23.79-82.68.42-96.41 14.16L12.03 383.77c-16.04 16.05-16.04 42.06 0 58.11l58.09 58.09C78.15 507.99 88.66 512 99.18 512c10.51 0 21.03-4.01 29.05-12.03l103.71-103.71c26.14-26.14 30.61-65.37 14.16-96.41L321.94 224H400zm-64-88l96.83-72.62 15.79 15.79L376 176h-40v-40zM197.99 362.32l-98.82 98.82-48.31-48.31 98.82-98.82c13.34-13.34 34.95-13.36 48.31 0 13.32 13.32 13.32 34.99 0 48.31z"
  ]
};
export const faScroll = {
  prefix: "far",
  iconName: "scroll",
  icon: [
    640,
    512,
    [],
    "f70e",
    "M608 336h-64V88c0-48.52-39.47-88-88-88H80C35.88 0 0 35.89 0 80v64c0 17.64 14.34 32 32 32h80v227.44c0 55.44 41.69 105.46 98.66 108.3v.26h312C587.38 512 640 459.36 640 394.67V368c0-17.64-14.34-32-32-32zM48 128V80c0-17.64 14.34-32 32-32s32 14.36 32 32v48H48zm112 275.44V80c0-11.38-2.38-22.2-6.69-32H456c22.06 0 40 17.94 40 40v248H304c-17.66 0-32 14.36-32 32v40c0 71.98-112 78.07-112-4.56zm432-8.77c0 38.23-31.09 69.33-69.34 69.33H303.11c10.67-16.62 16.89-35.92 16.89-56v-24h272v10.67z"
  ]
};
export const faScrollOld = {
  prefix: "far",
  iconName: "scroll-old",
  icon: [
    640,
    512,
    [],
    "f70f",
    "M608 336h-64v-65.94L529.94 256 544 241.94v-99.88L529.94 128 544 113.94V88c0-48.52-39.47-88-88-88H80C35.88 0 0 35.89 0 80v64c0 17.64 14.34 32 32 32h80v65.94L126.06 256 112 270.06v133.38c0 55.44 41.69 105.46 98.66 108.3l312 .26C587.38 512 640 459.36 640 394.67V368c0-17.64-14.34-32-32-32zM48 128V80c0-17.64 14.34-32 32-32s32 14.36 32 32v48H48zm112 275.44v-113.5L193.94 256 160 222.06V80c0-11.38-2.38-22.2-6.69-32H456c22.06 0 40 17.94 40 40v6.06L462.06 128 496 161.94v60.12L462.06 256 496 289.94V336h-65.94L416 350.06 401.94 336H304c-17.66 0-32 14.36-32 32v40c0 15.78-6.72 30.92-18.44 41.53-11.88 10.73-27.25 15.67-43.41 14.19-28.12-2.83-50.15-29.3-50.15-60.28zm432-8.77c0 38.23-31.09 69.33-69.34 69.33H303.11c10.67-16.62 16.89-35.92 16.89-56v-24h62.06L416 417.94 449.94 384H592v10.67z"
  ]
};
export const faScrubber = {
  prefix: "far",
  iconName: "scrubber",
  icon: [
    496,
    512,
    [],
    "f2f8",
    "M248 56c110.5 0 200 89.5 200 200s-89.5 200-200 200S48 366.5 48 256 137.5 56 248 56m0-48C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 184c-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64-28.7-64-64-64z"
  ]
};
export const faScythe = {
  prefix: "far",
  iconName: "scythe",
  icon: [
    640,
    512,
    [],
    "f710",
    "M608 0H338.84C192 0 64 64 0 224h552.09l-13.28 64H400a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h128.86l-32.58 157.05A16 16 0 0 0 512 512h15.45a16 16 0 0 0 15.72-13l96.27-461A32 32 0 0 0 608 0zM78.62 176C134.84 91 222.06 48 338.84 48h249.75L562 176z"
  ]
};
export const faSdCard = {
  prefix: "far",
  iconName: "sd-card",
  icon: [
    448,
    512,
    [],
    "f7c2",
    "M384 0H128L0 128v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zm16 448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V147.9L147.9 48H384c8.8 0 16 7.2 16 16v384zm-80-272h48V80h-48v96zm-80 0h48V80h-48v96zm-80 0h48V80h-48v96z"
  ]
};
export const faSearch = {
  prefix: "far",
  iconName: "search",
  icon: [
    512,
    512,
    [],
    "f002",
    "M508.5 468.9L387.1 347.5c-2.3-2.3-5.3-3.5-8.5-3.5h-13.2c31.5-36.5 50.6-84 50.6-136C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c52 0 99.5-19.1 136-50.6v13.2c0 3.2 1.3 6.2 3.5 8.5l121.4 121.4c4.7 4.7 12.3 4.7 17 0l22.6-22.6c4.7-4.7 4.7-12.3 0-17zM208 368c-88.4 0-160-71.6-160-160S119.6 48 208 48s160 71.6 160 160-71.6 160-160 160z"
  ]
};
export const faSearchDollar = {
  prefix: "far",
  iconName: "search-dollar",
  icon: [
    512,
    512,
    [],
    "f688",
    "M235.09 199.42l-45-13.5c-5.16-1.55-8.77-6.78-8.77-12.73 0-7.27 5.3-13.19 11.8-13.19h28.11c4.56 0 8.96 1.29 12.82 3.72 3.24 2.03 7.36 1.91 10.13-.73l11.75-11.21c3.53-3.37 3.33-9.21-.57-12.14-9.1-6.83-20.08-10.77-31.37-11.35V112c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v16.12c-23.62.63-42.67 20.55-42.67 45.07 0 19.97 12.98 37.81 31.58 43.39l45 13.5c5.16 1.55 8.77 6.78 8.77 12.73 0 7.27-5.3 13.19-11.8 13.19h-28.11c-4.56 0-8.96-1.29-12.82-3.72-3.24-2.03-7.36-1.91-10.13.73l-11.75 11.21c-3.53 3.37-3.33 9.21.57 12.14 9.1 6.83 20.08 10.77 31.37 11.35V304c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-16.12c23.62-.63 42.67-20.54 42.67-45.07 0-19.97-12.98-37.81-31.58-43.39zm273.38 269.46l-121.39-121.4c-2.3-2.3-5.3-3.5-8.5-3.5h-13.2c31.5-36.5 50.6-84 50.6-135.99C415.98 93.1 322.88 0 207.99 0S0 93.1 0 207.99c0 114.89 93.1 207.99 207.99 207.99 52 0 99.49-19.1 135.99-50.6v13.2c0 3.2 1.3 6.2 3.5 8.5l121.39 121.39c4.7 4.7 12.3 4.7 17 0l22.6-22.6c4.71-4.69 4.71-12.29 0-16.99zm-300.48-100.9c-88.4 0-159.99-71.6-159.99-159.99C48 119.59 119.59 48 207.99 48c88.39 0 159.99 71.6 159.99 159.99 0 88.4-71.6 159.99-159.99 159.99z"
  ]
};
export const faSearchLocation = {
  prefix: "far",
  iconName: "search-location",
  icon: [
    512,
    512,
    [],
    "f689",
    "M208 112c-40.78 0-73.83 33.05-73.83 73.83 0 32.96 48.25 93.05 66.74 114.86a9.24 9.24 0 0 0 14.18 0c18.49-21.81 66.74-81.89 66.74-114.86 0-40.78-33.05-73.83-73.83-73.83zm0 96c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm300.47 260.88l-121.39-121.4c-2.3-2.3-5.3-3.5-8.5-3.5h-13.2c31.5-36.5 50.6-84 50.6-135.99C415.98 93.1 322.88 0 207.99 0S0 93.1 0 207.99c0 114.89 93.1 207.99 207.99 207.99 52 0 99.49-19.1 135.99-50.6v13.2c0 3.2 1.3 6.2 3.5 8.5l121.39 121.39c4.7 4.7 12.3 4.7 17 0l22.6-22.6c4.71-4.69 4.71-12.29 0-16.99zm-300.48-100.9c-88.4 0-159.99-71.6-159.99-159.99C48 119.59 119.59 48 207.99 48c88.39 0 159.99 71.6 159.99 159.99 0 88.4-71.6 159.99-159.99 159.99z"
  ]
};
export const faSearchMinus = {
  prefix: "far",
  iconName: "search-minus",
  icon: [
    512,
    512,
    [],
    "f010",
    "M312 196v24c0 6.6-5.4 12-12 12H116c-6.6 0-12-5.4-12-12v-24c0-6.6 5.4-12 12-12h184c6.6 0 12 5.4 12 12zm196.5 289.9l-22.6 22.6c-4.7 4.7-12.3 4.7-17 0L347.5 387.1c-2.3-2.3-3.5-5.3-3.5-8.5v-13.2c-36.5 31.5-84 50.6-136 50.6C93.1 416 0 322.9 0 208S93.1 0 208 0s208 93.1 208 208c0 52-19.1 99.5-50.6 136h13.2c3.2 0 6.2 1.3 8.5 3.5l121.4 121.4c4.7 4.7 4.7 12.3 0 17zM368 208c0-88.4-71.6-160-160-160S48 119.6 48 208s71.6 160 160 160 160-71.6 160-160z"
  ]
};
export const faSearchPlus = {
  prefix: "far",
  iconName: "search-plus",
  icon: [
    512,
    512,
    [],
    "f00e",
    "M312 196v24c0 6.6-5.4 12-12 12h-68v68c0 6.6-5.4 12-12 12h-24c-6.6 0-12-5.4-12-12v-68h-68c-6.6 0-12-5.4-12-12v-24c0-6.6 5.4-12 12-12h68v-68c0-6.6 5.4-12 12-12h24c6.6 0 12 5.4 12 12v68h68c6.6 0 12 5.4 12 12zm196.5 289.9l-22.6 22.6c-4.7 4.7-12.3 4.7-17 0L347.5 387.1c-2.3-2.3-3.5-5.3-3.5-8.5v-13.2c-36.5 31.5-84 50.6-136 50.6C93.1 416 0 322.9 0 208S93.1 0 208 0s208 93.1 208 208c0 52-19.1 99.5-50.6 136h13.2c3.2 0 6.2 1.3 8.5 3.5l121.4 121.4c4.7 4.7 4.7 12.3 0 17zM368 208c0-88.4-71.6-160-160-160S48 119.6 48 208s71.6 160 160 160 160-71.6 160-160z"
  ]
};
export const faSeedling = {
  prefix: "far",
  iconName: "seedling",
  icon: [
    512,
    512,
    [],
    "f4d8",
    "M436.4 32c-91 0-168.3 67.9-194.7 161.4C204.6 134.6 144 96 75.6 96H0v24c0 127.9 91.7 232 204.4 232H232v112c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V288h27.6C420.3 288 512 183.9 512 56V32h-75.6zm-232 272c-79.3 0-145.1-69.8-155.1-160h26.2c79.3 0 145.1 69.8 155.1 160h-26.2zm103.2-64h-26.2c10-90.2 75.8-160 155.1-160h26.2c-10 90.2-75.8 160-155.1 160z"
  ]
};
export const faSendBack = {
  prefix: "far",
  iconName: "send-back",
  icon: [
    640,
    512,
    [],
    "f87e",
    "M256 208V48a48 48 0 0 0-48-48H48A48 48 0 0 0 0 48v160a48 48 0 0 0 48 48h160a48 48 0 0 0 48-48zM48 48h160v160H48zm384 176h48v-80a48 48 0 0 0-48-48H288v48h144zM96 160h64V96H96zm496 96H432a48 48 0 0 0-48 48v160a48 48 0 0 0 48 48h160a48 48 0 0 0 48-48V304a48 48 0 0 0-48-48zm0 208H432V304h160zM208 288h-48v80a48 48 0 0 0 48 48h144v-48H208zm336 64h-64v64h64z"
  ]
};
export const faSendBackward = {
  prefix: "far",
  iconName: "send-backward",
  icon: [
    512,
    512,
    [],
    "f87f",
    "M48,48H304v80h48V48A48,48,0,0,0,304,0H48A48,48,0,0,0,0,48V304a48,48,0,0,0,48,48h80V304H48ZM256,432H416a16,16,0,0,0,16-16V256a16,16,0,0,0-16-16H256a16,16,0,0,0-16,16V416A16,16,0,0,0,256,432Zm32-144h96v96H288ZM464,160H208a48,48,0,0,0-48,48V464a48,48,0,0,0,48,48H464a48,48,0,0,0,48-48V208A48,48,0,0,0,464,160Zm0,304H208V208H464Z"
  ]
};
export const faSensor = {
  prefix: "far",
  iconName: "sensor",
  icon: [
    448,
    512,
    [],
    "e028",
    "M200,128a24,24,0,0,0-24,24V264a24,24,0,0,0,48,0V152A24,24,0,0,0,200,128Zm-80,0a24,24,0,0,0-24,24V264a24,24,0,0,0,48,0V152A24,24,0,0,0,120,128ZM384,32H64A64,64,0,0,0,0,96V416a64,64,0,0,0,64,64H384a64,64,0,0,0,64-64V96A64,64,0,0,0,384,32Zm16,384a16,16,0,0,1-16,16H64a16,16,0,0,1-16-16V96A16,16,0,0,1,64,80H384a16,16,0,0,1,16,16Z"
  ]
};
export const faSensorAlert = {
  prefix: "far",
  iconName: "sensor-alert",
  icon: [
    640,
    512,
    [],
    "e029",
    "M633.09,403.37,492.27,159.22c-19.66-34.1-68.87-34.1-88.53,0L262.91,403.36C243.26,437.43,267.85,480,307.18,480H588.82C628.15,480,652.74,437.43,633.09,403.37ZM448,432a24,24,0,1,1,24-24A24,24,0,0,1,448,432Zm19.08-82.8A12,12,0,0,1,455.14,360H440.87a12,12,0,0,1-11.95-10.8l-9.59-96A12,12,0,0,1,431.27,240h33.47a12,12,0,0,1,11.94,13.2ZM176,152V264a24,24,0,0,0,48,0V152a24,24,0,0,0-48,0Zm48.35,280H64a16,16,0,0,1-16-16V96A16,16,0,0,1,64,80H384a16,16,0,0,1,16,16v21.57c13.8-9.9,30.16-15.92,48-15.92V96a64,64,0,0,0-64-64H64A64,64,0,0,0,0,96V416a64,64,0,0,0,64,64H242.51c-2.47-3.15-5.24-6-7.29-9.54A82.69,82.69,0,0,1,224.35,432ZM96,152V264a24,24,0,0,0,48,0V152a24,24,0,0,0-48,0Z"
  ]
};
export const faSensorFire = {
  prefix: "far",
  iconName: "sensor-fire",
  icon: [
    640,
    512,
    [],
    "e02a",
    "M325.8,432H64a16,16,0,0,1-16-16V96A16,16,0,0,1,64,80H384a16,16,0,0,1,16,16v13.11c6-6.16,12-12.39,18.32-18.29l23-22.7A63.82,63.82,0,0,0,384,32H64A64,64,0,0,0,0,96V416a64,64,0,0,0,64,64H375.35A195.52,195.52,0,0,1,325.8,432ZM176,152V264a24,24,0,1,0,48,0V152a24,24,0,1,0-48,0Zm-80,0V264a24,24,0,1,0,48,0V152a24,24,0,1,0-48,0Zm455.14-1.14A427.29,427.29,0,0,0,511,193.7,552.55,552.55,0,0,0,440,114.29c-70.18,65.11-120,150-120,201.14C320,406.33,391.66,480,480,480s160-73.67,160-164.57C640,277.38,602.88,198.89,551.13,150.86ZM530.07,400.92A84.1,84.1,0,0,1,481.8,416C436.71,416,400,386.16,400,337.73c0-24.14,15.19-45.41,45.49-81.73,4.33,5,61.75,78.32,61.75,78.32l36.65-41.78c2.59,4.27,4.94,8.46,7,12.49C568.05,337.65,560.85,379.38,530.07,400.92Z"
  ]
};
export const faSensorOn = {
  prefix: "far",
  iconName: "sensor-on",
  icon: [
    640,
    512,
    [],
    "e02b",
    "M616,232H536a24,24,0,0,0,0,48h80a24,24,0,0,0,0-48Zm-80-88a23.87,23.87,0,0,0,13.29-4l48-32a24,24,0,1,0-26.62-39.92l-48,32A24,24,0,0,0,536,144Zm13.29,228A24,24,0,1,0,522.69,412l48,32A24,24,0,1,0,597.31,404ZM120,128a24,24,0,0,0-24,24V264a24,24,0,0,0,48,0V152A24,24,0,0,0,120,128Zm80,0a24,24,0,0,0-24,24V264a24,24,0,0,0,48,0V152A24,24,0,0,0,200,128ZM384,32H64A64,64,0,0,0,0,96V416a64,64,0,0,0,64,64H384a64,64,0,0,0,64-64V96A64,64,0,0,0,384,32Zm16,384a16,16,0,0,1-16,16H64a16,16,0,0,1-16-16V96A16,16,0,0,1,64,80H384a16,16,0,0,1,16,16Z"
  ]
};
export const faSensorSmoke = {
  prefix: "far",
  iconName: "sensor-smoke",
  icon: [
    640,
    512,
    [],
    "e02c",
    "M572.67,321.28a47.81,47.81,0,0,0-82.4-46.63,79.94,79.94,0,0,0-152.63,45.52c-.56,0-1.08-.17-1.64-.17a80,80,0,0,0,0,160H560a79.85,79.85,0,0,0,12.67-158.72ZM176,152V264a24,24,0,0,0,48,0V152a24,24,0,0,0-48,0ZM64,432a16,16,0,0,1-16-16V96A16,16,0,0,1,64,80H384a16,16,0,0,1,16,16v97.52A111,111,0,0,1,416,192c11.14,0,21.74,2.15,32,5.22V96a64,64,0,0,0-64-64H64A64,64,0,0,0,0,96V416a64,64,0,0,0,64,64H257.86a111.79,111.79,0,0,1-28.64-48ZM96,152V264a24,24,0,0,0,48,0V152a24,24,0,0,0-48,0Z"
  ]
};
export const faServer = {
  prefix: "far",
  iconName: "server",
  icon: [
    512,
    512,
    [],
    "f233",
    "M424 400c0 13.255-10.745 24-24 24s-24-10.745-24-24 10.745-24 24-24 24 10.745 24 24zm-88-24c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm64-144c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm-64 0c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm176-72a47.758 47.758 0 0 1-6.438 24A47.758 47.758 0 0 1 512 208v96a47.758 47.758 0 0 1-6.438 24A47.758 47.758 0 0 1 512 352v96c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48v-96a47.758 47.758 0 0 1 6.438-24A47.758 47.758 0 0 1 0 304v-96a47.758 47.758 0 0 1 6.438-24A47.758 47.758 0 0 1 0 160V64c0-26.51 21.49-48 48-48h416c26.51 0 48 21.49 48 48v96zm-464 0h416V64H48v96zm416 48H48v96h416v-96zm0 144H48v96h416v-96zm-64-216c13.255 0 24-10.745 24-24s-10.745-24-24-24-24 10.745-24 24 10.745 24 24 24zm-64 0c13.255 0 24-10.745 24-24s-10.745-24-24-24-24 10.745-24 24 10.745 24 24 24z"
  ]
};
export const faShapes = {
  prefix: "far",
  iconName: "shapes",
  icon: [
    512,
    512,
    [],
    "f61f",
    "M480 288H320c-17.67 0-32 14.33-32 32v160c0 17.67 14.33 32 32 32h160c17.67 0 32-14.33 32-32V320c0-17.67-14.33-32-32-32zm-16 176H336V336h128v128zM128 256C57.31 256 0 313.31 0 384s57.31 128 128 128 128-57.31 128-128-57.31-128-128-128zm0 208c-44.11 0-80-35.89-80-80s35.89-80 80-80 80 35.89 80 80-35.89 80-80 80zm378.98-262.86L400.07 18.29C392.95 6.1 380.47 0 368 0s-24.95 6.1-32.07 18.29L229.02 201.14c-14.26 24.38 3.56 54.86 32.07 54.86h213.82c28.51 0 46.33-30.48 32.07-54.86zM280.61 208L368 58.53 455.39 208H280.61z"
  ]
};
export const faShare = {
  prefix: "far",
  iconName: "share",
  icon: [
    576,
    512,
    [],
    "f064",
    "M561.938 190.06L385.94 14.107C355.79-16.043 304 5.327 304 48.047v80.703C166.04 132.9 0 159.68 0 330.05c0 73.75 38.02 134.719 97.63 173.949 37.12 24.43 85.84-10.9 72.19-54.46C145.47 371.859 157.41 330.2 304 321.66v78.28c0 42.64 51.73 64.15 81.94 33.94l175.997-175.94c18.751-18.74 18.751-49.14.001-67.88zM352 400V272.09c-164.521 1.79-277.44 33.821-227.98 191.61C88 440 48 397.01 48 330.05c0-142.242 160.819-153.39 304-154.02V48l176 176-176 176z"
  ]
};
export const faShareAll = {
  prefix: "far",
  iconName: "share-all",
  icon: [
    640,
    512,
    [],
    "f367",
    "M497.94 206.06l-160-159.96C307.89 16.04 256 37.16 256 80.04v72.73C127.16 157.36 0 185.98 0 328.38c0 63.78 27.85 108.41 78.46 143.11 36.89 25.28 86.27-9.68 73.1-53.43-17.51-58.18-13.74-84.23 104.44-89.17v71.08c0 42.92 51.92 63.96 81.94 33.94l160-159.97c18.75-18.74 18.75-49.14 0-67.88zM304 400V280c-137.571 0-239.402 15.753-198.4 152C76.79 412.25 48 384.18 48 328.38 48 206.513 183.384 200 304 200V80l160 160-160 160zm321.941-126.059l-160 159.967c-20.37 20.37-50.817 17.225-68.291-.306L592 240 397.652 46.407c17.468-17.53 47.9-20.699 68.29-.31l160 159.962c18.744 18.745 18.744 49.137-.001 67.882z"
  ]
};
export const faShareAlt = {
  prefix: "far",
  iconName: "share-alt",
  icon: [
    448,
    512,
    [],
    "f1e0",
    "M352 320c-25.6 0-48.9 10-66.1 26.4l-98.3-61.5c5.9-18.8 5.9-39.1 0-57.8l98.3-61.5C303.1 182 326.4 192 352 192c53 0 96-43 96-96S405 0 352 0s-96 43-96 96c0 9.8 1.5 19.6 4.4 28.9l-98.3 61.5C144.9 170 121.6 160 96 160c-53 0-96 43-96 96s43 96 96 96c25.6 0 48.9-10 66.1-26.4l98.3 61.5c-2.9 9.4-4.4 19.1-4.4 28.9 0 53 43 96 96 96s96-43 96-96-43-96-96-96zm0-272c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zM96 304c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm256 160c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"
  ]
};
export const faShareAltSquare = {
  prefix: "far",
  iconName: "share-alt-square",
  icon: [
    448,
    512,
    [],
    "f1e1",
    "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zm-6 400H54a6 6 0 0 1-6-6V86a6 6 0 0 1 6-6h340a6 6 0 0 1 6 6v340a6 6 0 0 1-6 6zm-58-96c0 26.51-21.49 48-48 48s-48-21.49-48-48c0-2.007.138-3.981.377-5.923l-69.131-34.565A47.768 47.768 0 0 1 144 304c-26.51 0-48-21.49-48-48s21.49-48 48-48a47.762 47.762 0 0 1 27.246 8.489l69.131-34.565A48.461 48.461 0 0 1 240 176c0-26.51 21.49-48 48-48s48 21.49 48 48-21.49 48-48 48c-12.941 0-24.677-5.131-33.31-13.457l-64.54 32.27a47.935 47.935 0 0 1 0 26.374l64.54 32.27C263.323 293.13 275.059 288 288 288c26.51 0 48 21.49 48 48z"
  ]
};
export const faShareSquare = {
  prefix: "far",
  iconName: "share-square",
  icon: [
    576,
    512,
    [],
    "f14d",
    "M561.938 158.06L417.94 14.092C387.926-15.922 336 5.097 336 48.032v57.198c-42.45 1.88-84.03 6.55-120.76 17.99-35.17 10.95-63.07 27.58-82.91 49.42C108.22 199.2 96 232.6 96 271.94c0 61.697 33.178 112.455 84.87 144.76 37.546 23.508 85.248-12.651 71.02-55.74-15.515-47.119-17.156-70.923 84.11-78.76V336c0 42.993 51.968 63.913 81.94 33.94l143.998-144c18.75-18.74 18.75-49.14 0-67.88zM384 336V232.16C255.309 234.082 166.492 255.35 206.31 376 176.79 357.55 144 324.08 144 271.94c0-109.334 129.14-118.947 240-119.85V48l144 144-144 144zm24.74 84.493a82.658 82.658 0 0 0 20.974-9.303c7.976-4.952 18.286.826 18.286 10.214V464c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h132c6.627 0 12 5.373 12 12v4.486c0 4.917-2.987 9.369-7.569 11.152-13.702 5.331-26.396 11.537-38.05 18.585a12.138 12.138 0 0 1-6.28 1.777H54a6 6 0 0 0-6 6v340a6 6 0 0 0 6 6h340a6 6 0 0 0 6-6v-25.966c0-5.37 3.579-10.059 8.74-11.541z"
  ]
};
export const faSheep = {
  prefix: "far",
  iconName: "sheep",
  icon: [
    640,
    512,
    [],
    "f711",
    "M496 96c-8.84 0-16 7.16-16 16s7.16 16 16 16 16-7.16 16-16-7.16-16-16-16zm113.81 4.92L584 85.56V80c0-30.87-25.12-56-56-56h-81.62C442.76 10.3 430.84 0 416 0c-17.67 0-32 14.33-32 32v67.04c-12.39-1.71-24.83-.09-36.19 5.01-17.11-9.45-40.77-11.56-61.81-1-18.41-9.2-41.19-9.2-59.59-.06-18.84-9.47-42.91-9.08-61.47 1-12.94-5.89-27.56-7.52-42.31-4.37-17.88 4.02-33.12 15.11-42.69 30.34-17.59 2.08-34.06 11.16-45.66 25.83-11.25 14.57-16.22 32.94-14.28 50.88-12.62 12.78-20 30.34-20 49.02s7.25 36.19 19.69 48.92c-2.06 18.17 2.94 36.62 14.28 50.94 11.28 14.67 27.66 23.81 45.25 25.91 4.77 7.71 10.96 14.36 18.17 19.57l20.79 86.46c3.46 14.38 16.32 24.52 31.11 24.52h74.7c20.86 0 36.14-19.64 31.02-39.86l-14.67-57.91a66.566 66.566 0 0 0 15.23 1.77c10.5 0 20.72-2.45 29.94-7.09 5.64 2.75 11.96 4.45 18.52 5.57V480c0 17.67 14.33 32 32 32h80c17.67 0 32-14.33 32-32V377.86c11.36-4.34 21.72-11.56 29.7-21.64 11.25-14.58 16.22-32.95 14.28-50.89 12.62-12.78 20-30.34 20-49.02 0-8.48-1.68-16.65-4.47-24.31h68.13c17.75 0 34.31-9.56 43.22-25.05 18.94-33.2 21.12-48.14 21.12-56.48-.01-21.06-11.54-39.94-30.2-49.55zM161.89 464l-12.41-51.61c5.02-.98 9.97-2.33 14.7-4.46 8.19 4.46 17.48 6.72 26.91 7.4L203.42 464h-41.53zm238.13 0h-48v-54.2c11.7 4.23 24.4 5.38 37.35 2.59 3.7-.83 7.2-2.14 10.65-3.55V464zm53.42-189.03l-18.34 10.27 7.75 19.53c6.2 15.52-6.22 32.05-21.78 29.47l-21.19-3.77-6.03 20.67c-3.83 13.14-20.14 20.45-31.88 9.92l-17.16-15.22-16 16.44c-6.56 6.78-18.41 8.29-26.88.23l-16.59-15.78-16.53 15.84c-7.41 7.02-19.06 7.06-26 .23l-16.59-16.37-16.84 16.14c-8.56 8.23-22.38 4.28-26.69-.25L167 346.09l-17.16 14.64c-11.21 9.5-27.98 4.87-32.19-10.05l-5.94-20.91-21.41 3.83c-14.59 2.64-27.87-13.37-21.47-29.48l7.75-19.52-18.34-10.27c-13.42-7.56-13.97-29.28.31-37.31l18.34-10.27-7.75-19.53c-6.23-15.61 6.46-32.22 21.78-29.47l21.19 3.77 6.03-20.67c3.87-13.27 20.22-20.33 31.88-9.92l17.16 15.2 15.97-16.42c4.44-4.5 18.28-8.44 26.22-.58l16.59 16.45 16.91-16.16c7.28-6.98 19.19-7.08 26.59.03l16.62 15.84 16.56-15.91c10.04-9.7 21.87-4.71 26.69.28l15.66 16.2 17.16-14.62c12.15-10.3 28.3-3.72 32.19 10.05l5.94 20.91 21.41-3.83c14.63-2.69 27.84 13.44 21.47 29.48l-7.75 19.52 18.34 10.27c13.42 7.57 13.97 29.29-.31 37.33zM575.66 184h-84.83c-2.22-9.96-6.37-19.44-12.79-27.55-11.28-14.67-27.66-23.81-45.25-25.91-.23-.37-.55-.66-.78-1.03V72h96c4.41 0 8 3.59 8 8v32.87l49.97 29.72c9.66 5.28 8.6 10.49-10.32 41.41z"
  ]
};
export const faShekelSign = {
  prefix: "far",
  iconName: "shekel-sign",
  icon: [
    384,
    512,
    [],
    "f20b",
    "M216 160v192c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V160c0-70.69-57.31-128-128-128H24C10.75 32 0 42.74 0 56v408c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V96h88c35.35 0 64 28.65 64 64zM368 32h-32c-8.84 0-16 7.16-16 16v304c0 35.35-28.65 64-64 64h-88V160c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v296c0 13.25 10.75 24 24 24h128c70.69 0 128-57.31 128-128V48c0-8.84-7.16-16-16-16z"
  ]
};
export const faShield = {
  prefix: "far",
  iconName: "shield",
  icon: [
    512,
    512,
    [],
    "f132",
    "M237.5 508.3c11.8 4.9 25.1 4.9 36.9 0C360.1 472.6 496 349.3 496 128c0-19.4-11.7-36.9-29.5-44.3l-192-80a48.15 48.15 0 0 0-36.9 0l-192 80C27.7 91.1 16 108.6 16 128c0 198.5 114.5 335.7 221.5 380.3zM256 48l192 80c0 173.8-98.4 297-192 336-97.5-40.6-192-166.7-192-336l192-80z"
  ]
};
export const faShieldAlt = {
  prefix: "far",
  iconName: "shield-alt",
  icon: [
    512,
    512,
    [],
    "f3ed",
    "M256 409.6V100l-142.9 59.5c8.4 116.2 65.2 202.6 142.9 250.1zM466.5 83.7l-192-80a48.15 48.15 0 0 0-36.9 0l-192 80C27.7 91.1 16 108.6 16 128c0 198.5 114.5 335.7 221.5 380.3 11.8 4.9 25.1 4.9 36.9 0C360.1 472.6 496 349.3 496 128c0-19.4-11.7-36.9-29.5-44.3zM256 464C158.5 423.4 64 297.3 64 128l192-80 192 80c0 173.8-98.4 297-192 336z"
  ]
};
export const faShieldCheck = {
  prefix: "far",
  iconName: "shield-check",
  icon: [
    512,
    512,
    [],
    "f2f7",
    "M163.2 230.5c-4.7-4.7-12.3-4.7-17-.1l-22.7 22.5c-4.7 4.7-4.7 12.3-.1 17l90.8 91.5c4.7 4.7 12.3 4.7 17 .1l172.6-171.2c4.7-4.7 4.7-12.3.1-17l-22.5-22.7c-4.7-4.7-12.3-4.7-17-.1L223 290.7zM466.5 83.7l-192-80a48.15 48.15 0 0 0-36.9 0l-192 80C27.7 91.1 16 108.6 16 128c0 198.5 114.5 335.7 221.5 380.3 11.8 4.9 25.1 4.9 36.9 0C360.1 472.6 496 349.3 496 128c0-19.4-11.7-36.9-29.5-44.3zM256 464C158.5 423.4 64 297.3 64 128l192-80 192 80c0 173.8-98.4 297-192 336z"
  ]
};
export const faShieldCross = {
  prefix: "far",
  iconName: "shield-cross",
  icon: [
    448,
    512,
    [],
    "f712",
    "M420.43 83.69l-179.2-80C235.72 1.23 229.86 0 224 0s-11.72 1.23-17.23 3.69l-179.2 80C10.88 91.14 0 108.62 0 128c0 198.49 106.86 335.71 206.77 380.31 5.51 2.46 11.37 3.69 17.23 3.69s11.72-1.23 17.23-3.69C321.13 472.64 448 349.28 448 128c0-19.38-10.88-36.86-27.57-44.31zM398.33 168H248V59.41L400 128c0 13.81-.64 27.08-1.67 40zM200 59.28V168H49.17c-1.15-13.19-1.96-26.6-2.03-40.48L200 59.28zM55.76 216H200v233.96C137.82 410.28 77.53 328.89 55.76 216zM248 449.75V216h143.84C368.77 339.71 300.17 415.42 248 449.75z"
  ]
};
export const faShieldVirus = {
  prefix: "far",
  iconName: "shield-virus",
  icon: [
    512,
    512,
    [],
    "e06c",
    "M240,112v12.12c0,28.51-34.47,42.79-54.63,22.63l-8.57-8.58a16,16,0,0,0-22.63,22.63l8.58,8.57c20.16,20.16,5.88,54.63-22.63,54.63H128a16,16,0,0,0,0,32h12.12c28.51,0,42.79,34.47,22.63,54.63l-8.58,8.57a16,16,0,1,0,22.63,22.63l8.57-8.58c20.16-20.16,54.63-5.88,54.63,22.63V368a16,16,0,0,0,32,0V355.88c0-28.51,34.47-42.79,54.63-22.63l8.57,8.58a16,16,0,0,0,22.63-22.63l-8.58-8.57C329.09,290.47,343.37,256,371.88,256H384a16,16,0,0,0,0-32H371.88c-28.51,0-42.79-34.47-22.63-54.63l8.58-8.57a16,16,0,0,0-22.63-22.63l-8.57,8.58C306.47,166.91,272,152.63,272,124.12V112a16,16,0,0,0-32,0ZM224,224a16,16,0,1,1,16-16A16,16,0,0,1,224,224Zm64,32a16,16,0,1,1-16,16A16,16,0,0,1,288,256ZM466.5,83.68l-192-80A57.4,57.4,0,0,0,256.05,0a57.4,57.4,0,0,0-18.46,3.67l-192,80A47.93,47.93,0,0,0,16,128C16,326.5,130.5,463.72,237.5,508.32a48.12,48.12,0,0,0,36.91,0C360.09,472.61,496,349.3,496,128A48,48,0,0,0,466.5,83.68ZM256.08,48h0l0,0ZM256,464C163.51,425.48,64,303.88,64.06,128L254.88,48.42c.33-.1.91-.22,1.44-.32L448,128C448,330.48,322.37,436.33,256,464Z"
  ]
};
export const faShip = {
  prefix: "far",
  iconName: "ship",
  icon: [
    640,
    512,
    [],
    "f21a",
    "M484.843 379.396l74.163-62.753c28.358-23.994 19.811-69.847-15.304-82.002L488 215.359V88c0-13.255-10.745-24-24-24h-48V24c0-13.255-10.745-24-24-24H248c-13.255 0-24 10.745-24 24v40h-48c-13.255 0-24 10.745-24 24v127.359L96.299 234.64c-35.103 12.151-43.671 58-15.304 82.002l74.163 62.753C131.794 430.787 84.576 464 12 464c-6.627 0-12 5.373-12 12v24c0 6.627 5.373 12 12 12 61.682 0 114.334-17.015 157.164-66.492C175.604 483.207 208.493 512 248 512h144c39.507 0 72.396-28.793 78.836-66.492C513.949 495.312 566.824 512 628 512c6.627 0 12-5.373 12-12v-24c0-6.627-5.373-12-12-12-71.98 0-119.548-32.672-143.157-84.604zM264 40h112v24H264V40zm-64 72h240v86.744l-104.299-36.103a48 48 0 0 0-31.403 0L200 198.744V112zm224 320c0 17.673-14.327 32-32 32H248c-17.673 0-32-14.327-32-32v-64l-104-88 208-72 208 72-104 88v64z"
  ]
};
export const faShippingFast = {
  prefix: "far",
  iconName: "shipping-fast",
  icon: [
    640,
    512,
    [],
    "f48b",
    "M624 368h-16V251.9c0-19-7.7-37.5-21.1-50.9L503 117.1C489.6 103.7 471 96 452.1 96H416V56c0-30.9-25.1-56-56-56H120C89.1 0 64 25.1 64 56v40H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h240c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H112V56c0-4.4 3.6-8 8-8h240c4.4 0 8 3.6 8 8v312H242.7c-16.6-28.6-47.2-48-82.7-48-17.6 0-33.8 5.1-48 13.3V288H64v128c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zm-464 96c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm256-320h36.1c6.3 0 12.5 2.6 17 7l73 73H416v-80zm64 320c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-100.9c-17.2-25.9-46.6-43.1-80-43.1-24.7 0-47 9.6-64 24.9V272h144v91.1zM256 248v-16c0-4.4-3.6-8-8-8H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h240c4.4 0 8-3.6 8-8zm24-56c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H40c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h240z"
  ]
};
export const faShippingTimed = {
  prefix: "far",
  iconName: "shipping-timed",
  icon: [
    640,
    512,
    [],
    "f48c",
    "M208 88c-57.4 0-104 46.6-104 104s46.6 104 104 104 104-46.6 104-104S265.4 88 208 88zm48 128c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-80c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v56h24c4.4 0 8 3.6 8 8v16zm368 152h-16V251.9c0-19-7.7-37.5-21.1-50.9L503 117.1C489.6 103.7 471 96 452.1 96H416V56c0-30.9-25.1-56-56-56H56C25.1 0 0 25.1 0 56v304c0 30.9 25.1 56 56 56h8c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zm-464 96c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm208-96H242.7c-16.6-28.6-47.2-48-82.7-48s-66.1 19.4-82.7 48H56c-4.4 0-8-3.6-8-8V56c0-4.4 3.6-8 8-8h304c4.4 0 8 3.6 8 8v312zm48-224h36.1c6.3 0 12.5 2.6 17 7l73 73H416v-80zm64 320c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-100.9c-17.2-25.9-46.6-43.1-80-43.1-24.7 0-47 9.6-64 24.9V256h144v107.1z"
  ]
};
export const faShishKebab = {
  prefix: "far",
  iconName: "shish-kebab",
  icon: [
    512,
    512,
    [],
    "f821",
    "M511.21 84.07c-3.78-29.71-21.06-55.68-47.42-71.21a95.17 95.17 0 0 0-97.93 1.43C323.2 41 307.71 94 330 138.88c1.44 2.93 2.28 7.16 0 9.49l-24.3 24.21-31.8-31.8a70.94 70.94 0 0 0-100.32 0l-31.7 31.71a70.15 70.15 0 0 0-20.28 45.11 70.28 70.28 0 0 0-45.12 20.28l-31.7 31.71a70.93 70.93 0 0 0 0 100.32l31.71 31.72-71.94 71.89a15.49 15.49 0 0 0 0 21.94l12 12a15.49 15.49 0 0 0 21.94 0l72-71.89 31.67 31.66a70.93 70.93 0 0 0 100.32 0l31.7-31.7a70.22 70.22 0 0 0 20.29-45.11 70.24 70.24 0 0 0 45.11-20.29l31.7-31.7a70.93 70.93 0 0 0 0-100.32l-31.58-31.59 24.23-24.22c16.72-16.73 20.28-42.14 9.09-64.72-9.62-19.43-6-48.25 19.61-63.36a45.55 45.55 0 0 1 45.92-.53c14.22 8 23.15 21 25.13 36.45a47.88 47.88 0 0 1-6 30.09c-3.71 6.39-3.31 14.32 1.91 19.55l12.29 12.29c6.72 6.72 18.17 6.09 23.54-1.75a95.31 95.31 0 0 0 15.79-66.25zm-271 317.51l-31.7 31.7a22.94 22.94 0 0 1-32.44 0L78.72 336a22.94 22.94 0 0 1 0-32.44l31.7-31.7a22.94 22.94 0 0 1 32.44 0l97.32 97.32a22.94 22.94 0 0 1 0 32.4zm97.1-97.1l-31.7 31.7a22.94 22.94 0 0 1-32.44 0l-97.32-97.32a22.94 22.94 0 0 1 0-32.44l31.7-31.7a22.94 22.94 0 0 1 32.44 0L337.28 272a22.94 22.94 0 0 1 0 32.48z"
  ]
};
export const faShoePrints = {
  prefix: "far",
  iconName: "shoe-prints",
  icon: [
    640,
    512,
    [],
    "f54b",
    "M491.42 7.7C468.38 2.4 444.87 0 421.3 0c-9.15 0-18.31.36-27.46 1.05-27.3 2.07-54.1 8.33-80.31 16.12L256 32h-64c-35.35 0-64 32.98-64 70.86 0 37.87 28.65 68.57 64 68.57h64c60.2 0 79.94 16.73 104.73 34.29C389.3 225.94 430.54 240 465.46 240 555.82 240 640 205.71 640 137.14 640 88.69 600.9 32.89 491.42 7.7zM240 123.43h-48c-8.67 0-16-9.42-16-20.57C176 90.2 184.75 80 192 80h48v43.43zM465.46 192c-24.16 0-55.82-10.47-76.99-25.46l-4.08-2.91c-20.96-14.97-46.54-32.83-96.38-38.35V73.32l37.51-9.66.86-.22.85-.25c27.53-8.19 49.85-12.72 70.26-14.27 7.94-.6 15.88-.92 23.83-.92 20.71 0 40.69 2.18 59.36 6.48C562.75 73.37 592 109.57 592 137.14c0 34.34-64.34 54.86-126.54 54.86zm-128 80c-34.91 0-76.16 14.06-104.73 34.29-24.79 17.55-44.52 34.29-104.73 34.29H64c-35.35 0-64 30.7-64 68.57S28.65 480 64 480h64l57.53 14.82c26.21 7.79 53.01 14.05 80.31 16.12 9.14.69 18.31 1.05 27.46 1.05 23.57 0 47.09-2.4 70.12-7.7C472.9 479.11 512 423.3 512 374.86 512 306.29 427.82 272 337.46 272zM112 432H64c-7.25 0-16-10.2-16-22.86 0-11.15 7.33-20.57 16-20.57h48V432zm240.66 25.52c-18.68 4.3-38.65 6.48-59.36 6.48-7.94 0-15.89-.32-23.83-.92-20.4-1.55-42.73-6.08-70.26-14.27l-.85-.25-.86-.22-37.5-9.66v-51.97c49.84-5.52 75.43-23.37 96.38-38.34l4.08-2.91c21.18-14.99 52.84-25.46 77-25.46 62.2 0 126.54 20.52 126.54 54.86 0 27.57-29.25 63.77-111.34 82.66z"
  ]
};
export const faShoppingBag = {
  prefix: "far",
  iconName: "shopping-bag",
  icon: [
    448,
    512,
    [],
    "f290",
    "M352 128C352 57.42 294.579 0 224 0 153.42 0 96 57.42 96 128H0v304c0 44.183 35.817 80 80 80h288c44.183 0 80-35.817 80-80V128h-96zM224 48c44.112 0 80 35.888 80 80H144c0-44.112 35.888-80 80-80zm176 384c0 17.645-14.355 32-32 32H80c-17.645 0-32-14.355-32-32V176h48v40c0 13.255 10.745 24 24 24s24-10.745 24-24v-40h160v40c0 13.255 10.745 24 24 24s24-10.745 24-24v-40h48v256z"
  ]
};
export const faShoppingBasket = {
  prefix: "far",
  iconName: "shopping-basket",
  icon: [
    576,
    512,
    [],
    "f291",
    "M564 192h-72.902L362.286 40.457c-8.583-10.099-23.729-11.327-33.83-2.743-10.099 8.584-11.327 23.731-2.742 33.83L428.102 192H147.899L250.287 71.543c8.584-10.099 7.356-25.246-2.743-33.83s-25.246-7.355-33.83 2.743L84.901 192H12c-6.627 0-12 5.373-12 12v24c0 6.627 5.373 12 12 12h18.667l27.584 198.603C61.546 462.334 81.836 480 105.794 480h364.412c23.958 0 44.248-17.666 47.544-41.397L545.333 240H564c6.627 0 12-5.373 12-12v-24c0-6.627-5.373-12-12-12zm-93.794 240H105.794L79.127 240h417.745l-26.666 192zM312 296v80c0 13.255-10.745 24-24 24s-24-10.745-24-24v-80c0-13.255 10.745-24 24-24s24 10.745 24 24zm112 0v80c0 13.255-10.745 24-24 24s-24-10.745-24-24v-80c0-13.255 10.745-24 24-24s24 10.745 24 24zm-224 0v80c0 13.255-10.745 24-24 24s-24-10.745-24-24v-80c0-13.255 10.745-24 24-24s24 10.745 24 24z"
  ]
};
export const faShoppingCart = {
  prefix: "far",
  iconName: "shopping-cart",
  icon: [
    576,
    512,
    [],
    "f07a",
    "M551.991 64H144.28l-8.726-44.608C133.35 8.128 123.478 0 112 0H12C5.373 0 0 5.373 0 12v24c0 6.627 5.373 12 12 12h80.24l69.594 355.701C150.796 415.201 144 430.802 144 448c0 35.346 28.654 64 64 64s64-28.654 64-64a63.681 63.681 0 0 0-8.583-32h145.167a63.681 63.681 0 0 0-8.583 32c0 35.346 28.654 64 64 64 35.346 0 64-28.654 64-64 0-18.136-7.556-34.496-19.676-46.142l1.035-4.757c3.254-14.96-8.142-29.101-23.452-29.101H203.76l-9.39-48h312.405c11.29 0 21.054-7.869 23.452-18.902l45.216-208C578.695 78.139 567.299 64 551.991 64zM208 472c-13.234 0-24-10.766-24-24s10.766-24 24-24 24 10.766 24 24-10.766 24-24 24zm256 0c-13.234 0-24-10.766-24-24s10.766-24 24-24 24 10.766 24 24-10.766 24-24 24zm23.438-200H184.98l-31.31-160h368.548l-34.78 160z"
  ]
};
export const faShovel = {
  prefix: "far",
  iconName: "shovel",
  icon: [
    512,
    512,
    [],
    "f713",
    "M502.71 89.55L422.45 9.29C416.26 3.1 408.14 0 400.02 0s-16.24 3.1-22.43 9.29l-31.56 31.56c-16.77 16.77-25.91 39.25-25.91 62.49 0 20.49 6.93 35.24 11.39 43.23L207.22 270.86l-52.66-52.66c-6.24-6.25-14.43-9.37-22.61-9.37s-16.37 3.12-22.61 9.37l-69.62 69.62C-11.22 338.76-6.4 472.29 16.66 495.35 26.71 505.41 57.81 512 93.89 512c46.62 0 101.57-11 130.29-39.71l69.62-69.62c12.49-12.49 12.49-32.74 0-45.23l-52.66-52.66 124.32-124.32c17.83 9.95 34.2 11.45 43.26 11.45 24.7 0 48.16-11.67 65.7-29.2l28.29-28.3c12.39-12.39 12.39-32.47 0-44.86zM190.26 438.37c-15.35 15.35-54.08 25.66-96.37 25.66-19.48 0-33.9-2.27-41.9-4.31-7.87-29.31-5.31-111.05 21.63-137.99l58.31-58.32 116.63 116.63-58.3 58.33zm250.23-309.59c-9.61 9.61-21.17 15.13-32.76 15.13-35 0-53.14-43.78-27.78-69.15l20.07-20.07 57.28 57.28-16.81 16.81z"
  ]
};
export const faShovelSnow = {
  prefix: "far",
  iconName: "shovel-snow",
  icon: [
    512,
    512,
    [],
    "f7c3",
    "M503.2 72.3L439.7 8.8C428-2.9 409-2.9 397.3 8.8l-24.5 24.5c-14.2 14.2-21.9 33.2-21.9 52.9 0 4.9.5 9.8 1.5 14.8 1.3 6.5 3.6 12.6 6.4 18.4L262 216.2l-41.5-41.5c-9.7-9.7-22.5-14.6-35.3-14.6-10.7 0-21.5 3.4-30.5 10.4L19.4 274.9c-23.8 18.4-26.1 53.5-4.8 74.8l147.7 147.7c9.8 9.8 22.6 14.6 35.3 14.6 14.8 0 29.6-6.6 39.5-19.4l104.5-135.2c15.4-19.9 13.6-48.1-4.2-65.8l-41.5-41.5 96.8-96.8c5.8 2.8 11.9 5.1 18.4 6.4 24.6 4.9 49.9-2.7 67.6-20.5l24.5-24.5c11.7-11.7 11.7-30.7 0-42.4zM303.4 325.5c.7.7.8 1.8.2 2.5L199.1 463.2c-.1.2-.3.4-1.2.4-.4 0-1-.1-1.7-.3L48.6 315.8l.2-2.9L184 208.4c.2-.2.6-.4 1.2-.4l1.4.6 116.8 116.9zm141.4-220.2c-6.4 6.4-15.5 9.1-24.3 7.3-10.7-2.1-19-10.4-21.1-21.1-1.7-8.9 1-17.9 7.3-24.3l11.8-11.8 38.1 38.1-11.8 11.8zM153.7 265.7l-32 32c-9.4 9.4-9.4 24.6 0 33.9 4.7 4.7 10.8 7 17 7s12.3-2.3 17-7l32-32c9.4-9.4 9.4-24.6 0-33.9-9.5-9.4-24.6-9.4-34 0zm26.7 124.6c4.7 4.7 10.8 7 17 7s12.3-2.3 17-7l32-32c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-32 32c-9.5 9.3-9.5 24.5-.1 33.9z"
  ]
};
export const faShower = {
  prefix: "far",
  iconName: "shower",
  icon: [
    512,
    512,
    [],
    "f2cc",
    "M304,320a16,16,0,1,0,16,16A16,16,0,0,0,304,320Zm32-96a16,16,0,1,0,16,16A16,16,0,0,0,336,224Zm32,64a16,16,0,1,0-16-16A16,16,0,0,0,368,288Zm-32,32a16,16,0,1,0-16-16A16,16,0,0,0,336,320Zm-32-64a16,16,0,1,0,16,16A16,16,0,0,0,304,256Zm128-32a16,16,0,1,0-16-16A16,16,0,0,0,432,224Zm-48,16a16,16,0,1,0,16-16A16,16,0,0,0,384,240Zm-16-48a16,16,0,1,0,16,16A16,16,0,0,0,368,192Zm96,32a16,16,0,1,0,16,16A16,16,0,0,0,464,224Zm32-32a16,16,0,1,0,16,16A16,16,0,0,0,496,192Zm-64,64a16,16,0,1,0,16,16A16,16,0,0,0,432,256Zm-32,32a16,16,0,1,0,16,16A16,16,0,0,0,400,288Zm-64,64a16,16,0,1,0,16,16A16,16,0,0,0,336,352Zm-32,32a16,16,0,1,0,16,16A16,16,0,0,0,304,384Zm64-64a16,16,0,1,0,16,16A16,16,0,0,0,368,320Zm21.65-218.35-11.3-11.31a16,16,0,0,0-22.63,0L350.05,96A110.94,110.94,0,0,0,211.76,81.84L195.47,65.55a114.07,114.07,0,0,0-95-32.72C42,39.73,0,93.07,0,151.94V464a16,16,0,0,0,16,16H32a16,16,0,0,0,16-16V146.52a66.5,66.5,0,0,1,113.53-47l16.3,16.3A110.93,110.93,0,0,0,192,254.05l-5.66,5.67a16,16,0,0,0,0,22.62l11.3,11.31a16,16,0,0,0,22.63,0L389.65,124.28A16,16,0,0,0,389.65,101.65ZM226.28,219.78C215.24,208.31,208,193.15,208,176a64.07,64.07,0,0,1,64-64c17.15,0,32.31,7.24,43.78,18.28Z"
  ]
};
export const faShredder = {
  prefix: "far",
  iconName: "shredder",
  icon: [
    512,
    512,
    [],
    "f68a",
    "M432 176V99.88c0-12.73-5.06-24.94-14.06-33.94l-51.88-51.88c-9-9-21.21-14.06-33.94-14.06H110.48C93.64 0 80 14.33 80 32v144c-44.18 0-80 35.82-80 80v128c0 8.84 7.16 16 16 16h24v96c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-96h48v96c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-96h48v96c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-96h48v96c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-96h48v96c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-96h24c8.84 0 16-7.16 16-16V256c0-44.18-35.82-80-80-80zM128 48h192v48c0 8.84 7.16 16 16 16h48v64H128V48zm336 304H48v-96c0-17.64 14.36-32 32-32h352c17.64 0 32 14.36 32 32v96zm-64-88c-13.25 0-24 10.74-24 24 0 13.25 10.75 24 24 24s24-10.75 24-24c0-13.26-10.75-24-24-24z"
  ]
};
export const faShuttleVan = {
  prefix: "far",
  iconName: "shuttle-van",
  icon: [
    640,
    512,
    [],
    "f5b6",
    "M628.88 210.65L499.19 55.03A64.006 64.006 0 0 0 450.02 32H32C14.33 32 0 46.33 0 64v288c0 17.67 14.33 32 32 32h32c0 52.93 43.06 96 96 96s96-43.07 96-96h128c0 52.93 43.06 96 96 96s96-43.07 96-96h32c17.67 0 32-14.33 32-32V241.38a48.03 48.03 0 0 0-11.12-30.73zM376 80h74.02c4.76 0 9.24 2.1 12.29 5.76L550.85 192H376V80zm-160 0h112v112H216V80zM48 80h120v112H48V80zm112 352c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm320 0c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm112-96h-29.36c-16.65-28.55-47.27-48-82.64-48s-65.99 19.45-82.64 48H242.64c-16.65-28.55-47.27-48-82.64-48s-65.99 19.45-82.64 48H48v-96h542.85l1.15 1.38V336z"
  ]
};
export const faShuttlecock = {
  prefix: "far",
  iconName: "shuttlecock",
  icon: [
    512,
    512,
    [],
    "f45b",
    "M472 192h-40v-72c0-22.1-17.9-40-40-40h-72V40c0-22.1-17.9-40-40-40h-34.9c-15.5 0-29.8 9.1-36.3 23.1L95.5 266.5 31.1 331c-41.4 41.4-41.4 108.6 0 150 41.3 41.3 108.4 41.5 150 0l64.5-64.5 243.3-113.3c14.1-6.5 23.2-20.8 23.2-36.3V232c-.1-22.1-18-40-40.1-40zm-88-64v62.4l-91.2 28.8 28.8-91.2H384zM85.1 344.8l20.9-20.9 82.1 82.1-20.9 20.9-82.1-82.1zM250.2 48H272v50.2l-62 36L250.2 48zm10.9 112l-26.3 83.1L164 314l-25.7-25.7 36.3-77.9 86.5-50.4zM65 447c-21.8-21.8-22.4-56.6-2.2-79.4l81.6 81.6c-23.8 21.1-58.2 19-79.4-2.2zm158.7-73.3L198 347.9l70.8-70.8 83.1-26.3-50.3 86.5-77.9 36.4zM464 261.8l-86.2 40.1 36-61.9H464v21.8z"
  ]
};
export const faSickle = {
  prefix: "far",
  iconName: "sickle",
  icon: [
    512,
    512,
    [],
    "f822",
    "M511.54 159.85C500.76 104.56 445.67 0 314.48 0c-91.79 0-169.8 64.06-189.75 155.79-5 22.84-6.45 50.38-4 77.41l-67.38 67.36a16 16 0 0 0 0 22.63l22.59 22.6-66.6 66.6a31.93 31.93 0 0 0 0 45.13l45.13 45.13a31.92 31.92 0 0 0 45.14 0l66.6-66.6 22.6 22.6a16 16 0 0 0 22.57 0l67.7-67.7a16 16 0 0 0 0-22.57l-14.46-14.46 13.73-13.71c6-6 5.75-15.69.32-22.28-20.12-24.4-28.54-55.28-23.66-87.09 7.51-49.26 45.45-90.64 98.56-100.74a103.34 103.34 0 0 1 19.31-1.8 113.08 113.08 0 0 1 45.73 9.82c21 9.37 38.28 23 51 40.36a23.24 23.24 0 0 0 18.76 9.6 23.64 23.64 0 0 0 23.13-28.23zM200.05 402.29l-33.88-33.88-89.11 89.1-22.57-22.57 89.2-89-34.16-34.16 22.63-22.63 90.51 90.51-22.62 22.64zM372.89 80.43a151.56 151.56 0 0 0-28.24 2.64c-71.16 13.52-126.2 70-136.95 140.52a157.39 157.39 0 0 0 9.56 83l-44-44.49-2.9-16.75c-4.46-25.8-4-55.46 1.17-79.33 15.12-69.53 73.91-118.08 143-118.09 47.72 0 80.84 17.48 103.57 39.16a160.12 160.12 0 0 0-45.17-6.61z"
  ]
};
export const faSigma = {
  prefix: "far",
  iconName: "sigma",
  icon: [
    320,
    512,
    [],
    "f68b",
    "M287.96 448H42.36a42.314 42.314 0 0 1-38.92-25.62C-3.26 406.8 0 388.8 11.7 376.52L126.63 256 11.7 135.48C0 123.2-3.26 105.2 3.44 89.62A42.325 42.325 0 0 1 42.36 64h245.6C305.65 64 320 78.33 320 96v48c0 8.84-7.17 16-16.02 16h-16.02c-8.85 0-16.02-7.16-16.02-16v-32H55.66l116.27 121.94c11.79 12.36 11.79 31.78 0 44.14L55.66 400h216.28v-32c0-8.84 7.17-16 16.02-16h16.02c8.85 0 16.02 7.16 16.02 16v48c0 17.67-14.35 32-32.04 32z"
  ]
};
export const faSign = {
  prefix: "far",
  iconName: "sign",
  icon: [
    512,
    512,
    [],
    "f4d9",
    "M496 64H112V16c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16v48H16C7.2 64 0 71.2 0 80v16c0 8.8 7.2 16 16 16h48v384c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V112h80v48c-17.7 0-32 14.3-32 32v160c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32v-48h48c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16zm-64 272H208V208h224v128zm-16-176H224v-48h192v48z"
  ]
};
export const faSignIn = {
  prefix: "far",
  iconName: "sign-in",
  icon: [
    512,
    512,
    [],
    "f090",
    "M416 448h-84c-6.6 0-12-5.4-12-12v-24c0-6.6 5.4-12 12-12h84c26.5 0 48-21.5 48-48V160c0-26.5-21.5-48-48-48h-84c-6.6 0-12-5.4-12-12V76c0-6.6 5.4-12 12-12h84c53 0 96 43 96 96v192c0 53-43 96-96 96zM167.1 83.5l-19.6 19.6c-4.8 4.8-4.7 12.5.2 17.1L260.8 230H12c-6.6 0-12 5.4-12 12v28c0 6.6 5.4 12 12 12h248.8L147.7 391.7c-4.8 4.7-4.9 12.4-.2 17.1l19.6 19.6c4.7 4.7 12.3 4.7 17 0l164.4-164c4.7-4.7 4.7-12.3 0-17l-164.4-164c-4.7-4.6-12.3-4.6-17 .1z"
  ]
};
export const faSignInAlt = {
  prefix: "far",
  iconName: "sign-in-alt",
  icon: [
    512,
    512,
    [],
    "f2f6",
    "M144 112v51.6H48c-26.5 0-48 21.5-48 48v88.6c0 26.5 21.5 48 48 48h96v51.6c0 42.6 51.7 64.2 81.9 33.9l144-143.9c18.7-18.7 18.7-49.1 0-67.9l-144-144C195.8 48 144 69.3 144 112zm192 144L192 400v-99.7H48v-88.6h144V112l144 144zm80 192h-84c-6.6 0-12-5.4-12-12v-24c0-6.6 5.4-12 12-12h84c26.5 0 48-21.5 48-48V160c0-26.5-21.5-48-48-48h-84c-6.6 0-12-5.4-12-12V76c0-6.6 5.4-12 12-12h84c53 0 96 43 96 96v192c0 53-43 96-96 96z"
  ]
};
export const faSignLanguage = {
  prefix: "far",
  iconName: "sign-language",
  icon: [
    448,
    512,
    [],
    "f2a7",
    "M448 255.1l-4.3-133.4c-1.6-49.9-61.8-73.6-96.5-38.3l-46.7-61.2C289.7 8.1 273.4 0 255.7 0c-15.7 0-29.9 6.5-40.1 16.8-16.2-5.3-35.7-3.3-51.6 8.8-15.4 11.9-23.2 30.4-22 49.2-29.5 17.4-36.5 56.4-17 83.3-22.2 18.8-26.4 51.1-11 74.9H81c-34.5 0-60.5 30.7-56 64.7C10.1 307.8.4 324.7 0 344c-.4 19.9 9.5 37.4 24.5 47.8-4.9 34.3 21.2 63.8 53.9 65.2 1 30.5 25.8 55.1 56.5 55.1H227c11.6 0 23.1-1.4 34.4-4.1l69-16.6c27.8-6.7 47.2-31.8 47.2-60.3v-87.7l47.1-37.4c15.2-12.3 23.9-31.2 23.3-50.9zM182.5 114.2L248 200l-11-8.1c-11.1-8.3-25.8-10.1-38.5-5l-40-52.5c-13.4-17.6 11.6-36.5 24-20.2zm-8.7 78.1l6.7 8.8c-10.2 14.4-10 33.8 0 47.9h-2.9l-28.5-37.3c-12.9-17 11.9-36.2 24.7-19.4zM336.5 431c0 9.8-6.5 18.2-15.8 20.5l-69 16.6c-8.1 2-16.5 2.9-24.8 2.9h-92.1c-20.9 0-20.2-32 .5-32h53.4c5 0 9-4 9-9v-5c0-5-4-9-9-9H80.9c-20.7 0-21.4-32-.5-32h108.4c5 0 9-4 9-9v-5c0-5-4-9-9-9H57c-20.7 0-21.4-32-.5-32h132.2c5 0 9-4 9-9v-5c0-5-4-9-9-9H81.5c-20.7 0-21.4-32-.5-32h144.5c5 0 9-4 9-9 0-2.8-1.3-5.5-3.6-7.2L204.2 238c-16.9-12.6 1.7-38.1 18.1-26L328 290.5c5.3 3.9 8.5 10.3 8.5 17zm62.6-157.2l-37.9 30.1c-1.1-13.3-7.8-25.6-18.4-33.5l-88.3-65.6c2.6.5 5.3-.1 7.4-1.8l3.9-3.1c3.8-3 4.5-8.6 1.6-12.5l-81-106.1c-13.4-17.6 11.6-36.4 24-20.2l81.2 106.5c1.5 1.9 3.6 3.2 6 3.5s4.8-.4 6.7-1.9l3.9-3.1c3.8-3 4.5-8.6 1.6-12.5l-65.9-86.4c-13.4-17.6 11.6-36.4 24-20.2l88.8 116.4c5.3 7 16.4 3 16.2-5.7l-1.1-33.6c-.7-21.7 30.3-21.8 31-1.1l4.3 133.4c.1 6.8-2.9 13.3-8 17.4z"
  ]
};
export const faSignOut = {
  prefix: "far",
  iconName: "sign-out",
  icon: [
    512,
    512,
    [],
    "f08b",
    "M96 64h84c6.6 0 12 5.4 12 12v24c0 6.6-5.4 12-12 12H96c-26.5 0-48 21.5-48 48v192c0 26.5 21.5 48 48 48h84c6.6 0 12 5.4 12 12v24c0 6.6-5.4 12-12 12H96c-53 0-96-43-96-96V160c0-53 43-96 96-96zm231.1 19.5l-19.6 19.6c-4.8 4.8-4.7 12.5.2 17.1L420.8 230H172c-6.6 0-12 5.4-12 12v28c0 6.6 5.4 12 12 12h248.8L307.7 391.7c-4.8 4.7-4.9 12.4-.2 17.1l19.6 19.6c4.7 4.7 12.3 4.7 17 0l164.4-164c4.7-4.7 4.7-12.3 0-17l-164.4-164c-4.7-4.6-12.3-4.6-17 .1z"
  ]
};
export const faSignOutAlt = {
  prefix: "far",
  iconName: "sign-out-alt",
  icon: [
    512,
    512,
    [],
    "f2f5",
    "M272 112v51.6h-96c-26.5 0-48 21.5-48 48v88.6c0 26.5 21.5 48 48 48h96v51.6c0 42.6 51.7 64.2 81.9 33.9l144-143.9c18.7-18.7 18.7-49.1 0-67.9l-144-144C323.8 48 272 69.3 272 112zm192 144L320 400v-99.7H176v-88.6h144V112l144 144zM96 64h84c6.6 0 12 5.4 12 12v24c0 6.6-5.4 12-12 12H96c-26.5 0-48 21.5-48 48v192c0 26.5 21.5 48 48 48h84c6.6 0 12 5.4 12 12v24c0 6.6-5.4 12-12 12H96c-53 0-96-43-96-96V160c0-53 43-96 96-96z"
  ]
};
export const faSignal = {
  prefix: "far",
  iconName: "signal",
  icon: [
    640,
    512,
    [],
    "f012",
    "M208 288h-32c-8.84 0-16 7.16-16 16v192c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V304c0-8.84-7.16-16-16-16zM80 384H48c-8.84 0-16 7.16-16 16v96c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-96c0-8.84-7.16-16-16-16zm256-192h-32c-8.84 0-16 7.16-16 16v288c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V208c0-8.84-7.16-16-16-16zm128-96h-32c-8.84 0-16 7.16-16 16v384c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V112c0-8.84-7.16-16-16-16zM592 0h-32c-8.84 0-16 7.16-16 16v480c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16z"
  ]
};
export const faSignal1 = {
  prefix: "far",
  iconName: "signal-1",
  icon: [
    640,
    512,
    [],
    "f68c",
    "M80 384H48c-8.84 0-16 7.16-16 16v96c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-96c0-8.84-7.16-16-16-16z"
  ]
};
export const faSignal2 = {
  prefix: "far",
  iconName: "signal-2",
  icon: [
    640,
    512,
    [],
    "f68d",
    "M208 288h-32c-8.84 0-16 7.16-16 16v192c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V304c0-8.84-7.16-16-16-16zM80 384H48c-8.84 0-16 7.16-16 16v96c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-96c0-8.84-7.16-16-16-16z"
  ]
};
export const faSignal3 = {
  prefix: "far",
  iconName: "signal-3",
  icon: [
    640,
    512,
    [],
    "f68e",
    "M208 288h-32c-8.84 0-16 7.16-16 16v192c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V304c0-8.84-7.16-16-16-16zM80 384H48c-8.84 0-16 7.16-16 16v96c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-96c0-8.84-7.16-16-16-16zm256-192h-32c-8.84 0-16 7.16-16 16v288c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V208c0-8.84-7.16-16-16-16z"
  ]
};
export const faSignal4 = {
  prefix: "far",
  iconName: "signal-4",
  icon: [
    640,
    512,
    [],
    "f68f",
    "M208 288h-32c-4.42 0-8 3.58-8 8v208c0 4.42 3.58 8 8 8h32c4.42 0 8-3.58 8-8V296c0-4.42-3.58-8-8-8zM80 384H48c-4.42 0-8 3.58-8 8v112c0 4.42 3.58 8 8 8h32c4.42 0 8-3.58 8-8V392c0-4.42-3.58-8-8-8zm256-192h-32c-4.42 0-8 3.58-8 8v304c0 4.42 3.58 8 8 8h32c4.42 0 8-3.58 8-8V200c0-4.42-3.58-8-8-8zm128-96h-32c-4.42 0-8 3.58-8 8v400c0 4.42 3.58 8 8 8h32c4.42 0 8-3.58 8-8V104c0-4.42-3.58-8-8-8z"
  ]
};
export const faSignalAlt = {
  prefix: "far",
  iconName: "signal-alt",
  icon: [
    640,
    512,
    [],
    "f690",
    "M576 48v416h-32V48h32M416 176v288h-32V176h32M256 304v160h-32V304h32M96 400v64H64v-64h32M592 0h-64c-17.67 0-32 14.33-32 32v448c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32zM432 128h-64c-17.67 0-32 14.33-32 32v320c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V160c0-17.67-14.33-32-32-32zM272 256h-64c-17.67 0-32 14.33-32 32v192c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V288c0-17.67-14.33-32-32-32zm-160 96H48c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32z"
  ]
};
export const faSignalAlt1 = {
  prefix: "far",
  iconName: "signal-alt-1",
  icon: [
    640,
    512,
    [],
    "f691",
    "M96 400v64H64v-64h32m16-48H48c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32z"
  ]
};
export const faSignalAlt2 = {
  prefix: "far",
  iconName: "signal-alt-2",
  icon: [
    640,
    512,
    [],
    "f692",
    "M256 304v160h-32V304h32M96 400v64H64v-64h32m176-144h-64c-17.67 0-32 14.33-32 32v192c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V288c0-17.67-14.33-32-32-32zm-160 96H48c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32z"
  ]
};
export const faSignalAlt3 = {
  prefix: "far",
  iconName: "signal-alt-3",
  icon: [
    640,
    512,
    [],
    "f693",
    "M416 176v288h-32V176h32M256 304v160h-32V304h32M96 400v64H64v-64h32m336-272h-64c-17.67 0-32 14.33-32 32v320c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V160c0-17.67-14.33-32-32-32zM272 256h-64c-17.67 0-32 14.33-32 32v192c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V288c0-17.67-14.33-32-32-32zm-160 96H48c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32z"
  ]
};
export const faSignalAltSlash = {
  prefix: "far",
  iconName: "signal-alt-slash",
  icon: [
    640,
    512,
    [],
    "f694",
    "M633.99 471.02L36 3.51C29.1-2.01 19.03-.9 13.51 6l-10 12.49C-2.02 25.39-.9 35.46 6 40.98l598 467.51c6.9 5.52 16.96 4.4 22.49-2.49l10-12.49c5.52-6.9 4.41-16.97-2.5-22.49zM544 48h32v316.75l48 37.53V32c0-17.67-14.33-32-32-32h-64c-17.67 0-32 14.33-32 32v270.21l48 37.53V48zM384 176h32v63.66l48 37.53V160c0-17.67-14.33-32-32-32h-64c-17.67 0-32 14.33-32 32v17.12l48 37.53V176zM112 352H48c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32zM96 464H64v-64h32v64zm320 0h-32v-66.58l-48-37.53V480c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-20.03l-48-37.53V464zM176 288v192c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V334.88l-99.89-78.09c-15.75 2-28.11 14.92-28.11 31.21zm48 16h32v160h-32V304z"
  ]
};
export const faSignalSlash = {
  prefix: "far",
  iconName: "signal-slash",
  icon: [
    640,
    512,
    [],
    "f695",
    "M633.99 471.02L36 3.51C29.1-2.01 19.03-.9 13.51 6l-10 12.49C-2.02 25.39-.9 35.46 6 40.98l598 467.51c6.9 5.52 16.96 4.4 22.49-2.49l10-12.49c5.52-6.9 4.41-16.97-2.5-22.49zM80 384H48c-8.84 0-16 7.16-16 16v96c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-96c0-8.84-7.16-16-16-16zm400-272c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v127.66l64 50.04V112zm128-96c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v323.73l64 50.04V16zM416 496c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-23.52l-64-50.04V496zm-128 0c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V372.41l-64-50.04V496zm-80-208h-32c-8.84 0-16 7.16-16 16v192c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V304c0-8.84-7.16-16-16-16z"
  ]
};
export const faSignalStream = {
  prefix: "far",
  iconName: "signal-stream",
  icon: [
    576,
    512,
    [],
    "f8dd",
    "M186.87 157.25l-11.37-11.11a16.44 16.44 0 0 0-24 1.3 168.83 168.83 0 0 0 0 217.12 16.44 16.44 0 0 0 24 1.3l11.37-11.11a15.14 15.14 0 0 0 1.29-20.53 122.72 122.72 0 0 1 0-156.44 15.15 15.15 0 0 0-1.29-20.53zM107.33 79.6L96 68.53a16.41 16.41 0 0 0-23.56 1C25.59 121 0 186.58 0 256s25.59 135 72.44 186.52a16.41 16.41 0 0 0 23.56 1l11.33-11.07c6.11-6 6.06-15.39.36-21.71a230.28 230.28 0 0 1 0-309.37c5.7-6.37 5.75-15.81-.36-21.77zm396.23-10.12a16.41 16.41 0 0 0-23.56-1L468.67 79.6c-6.11 6-6.06 15.39-.36 21.72a230.28 230.28 0 0 1 0 309.37c-5.7 6.32-5.75 15.75.36 21.71L480 443.47a16.41 16.41 0 0 0 23.56-1C550.41 391 576 325.42 576 256s-25.59-135-72.44-186.52zM288 200a56 56 0 1 0 56 56 56 56 0 0 0-56-56zm112.5-53.86l-11.37 11.11a15.15 15.15 0 0 0-1.29 20.53 122.72 122.72 0 0 1 0 156.44 15.15 15.15 0 0 0 1.29 20.53l11.37 11.11a16.44 16.44 0 0 0 24-1.3 168.83 168.83 0 0 0 0-217.12 16.44 16.44 0 0 0-24-1.3z"
  ]
};
export const faSignature = {
  prefix: "far",
  iconName: "signature",
  icon: [
    640,
    512,
    [],
    "f5b7",
    "M637.2 199.8c-.9-.9-3-2.5-5.7-2.2-36.2 2.4-84.6 29.9-123.4 51.9-16 9.1-29.8 16.9-41.1 22-30.7 14-57.1 26.2-81.4 26.2-10.6 0-18.5-3-23.8-9.3-9.5-11-9.3-29.7-6.1-54.3 3.7-28.4.1-50.5-9.7-61.3-6-6.5-14.5-9.3-25.5-8.6-27.8 1.6-76.6 39-168.7 129.1l-27.4 26.9L181 175.9c13.2-33.5 4-70.1-23.3-93.1-21.8-18.4-58.8-29.2-97.7-4L4 117.1c-4 2.6-5.1 7.8-2.7 11.6L18.9 157c1.2 1.9 3 3.2 5.2 3.7 2.1.4 4.3.1 6.2-1.1L89.6 119c5.4-3.4 11.2-5.1 17-5.1 7 0 13.9 2.5 19.7 7.4 10.6 9 14.2 23.1 9.1 36.1L34.6 413.6c-2.9 7.3-1.7 17.3 3 24.3 3.1 4.6 9 10.1 19.9 10.1 6.6 0 12.8-2.6 17.4-7.3 43.5-44.2 158.5-157.2 217.3-205l14.8-12-1.5 19.2c-2.1 27.9-2.5 57.2 19 81.2 14.1 15.7 34.7 23.7 61.2 23.7 34.8 0 67.2-14.9 101.6-30.6 10.5-4.8 25-13.4 40.3-22.5 35.2-20.9 75.1-44.5 104.4-47 4.7-.4 8.1-3.8 8.1-8.2V206c-.1-2.3-1.1-4.6-2.9-6.2z"
  ]
};
export const faSimCard = {
  prefix: "far",
  iconName: "sim-card",
  icon: [
    448,
    512,
    [],
    "f7c4",
    "M0 64v384c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V128L320 0H64C28.7 0 0 28.7 0 64zm48 0c0-8.8 7.2-16 16-16h236.1l99.9 99.9V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V64zm304 288h-64v64h32c17.7 0 32-14.3 32-32v-32zM192 224h64v-64h-64v64zm64 128h-64v64h64v-64zm32-128h64v-32c0-17.7-14.3-32-32-32h-32v64zM160 352H96v32c0 17.7 14.3 32 32 32h32v-64zM96 192v32h64v-64h-32c-17.7 0-32 14.3-32 32zm256 64H96v64h256v-64z"
  ]
};
export const faSink = {
  prefix: "far",
  iconName: "sink",
  icon: [
    512,
    512,
    [],
    "e06d",
    "M496,288H400V256h64a16,16,0,0,0,16-16V224a16,16,0,0,0-16-16H384a32,32,0,0,0-32,32v48H280V88a40,40,0,0,1,44.17-39.79C345,50.33,360,69.43,360,90.35V112a16,16,0,0,0,16,16h16a16,16,0,0,0,16-16V88A88.09,88.09,0,0,0,311.22.43C265.5,4.88,232,46,232,91.9V288H160V240a32,32,0,0,0-32-32H48a16,16,0,0,0-16,16v16a16,16,0,0,0,16,16h64v32H16A16,16,0,0,0,0,304v16a16,16,0,0,0,16,16H32v80a96,96,0,0,0,96,96H384a96,96,0,0,0,96-96V336h16a16,16,0,0,0,16-16V304A16,16,0,0,0,496,288ZM432,416a48.05,48.05,0,0,1-48,48H128a48.05,48.05,0,0,1-48-48V336H432Z"
  ]
};
export const faSiren = {
  prefix: "far",
  iconName: "siren",
  icon: [
    448,
    512,
    [],
    "e02d",
    "M416,336,393.88,127.07A72,72,0,0,0,322.44,64H125.56a72,72,0,0,0-71.44,63.07L32,336h0A32,32,0,0,0,0,368v80a32,32,0,0,0,32,32H416a32,32,0,0,0,32-32V368A32,32,0,0,0,416,336ZM101.75,133a24,24,0,0,1,23.81-21H322.44a24,24,0,0,1,23.82,21l21.37,203H156.09l19.84-180.82a8,8,0,0,0-6.87-9l-15.86-2.13a7.79,7.79,0,0,0-1.07-.07,8,8,0,0,0-7.92,6.94L123.8,336H80.37ZM400,432H48V384H400Z"
  ]
};
export const faSirenOn = {
  prefix: "far",
  iconName: "siren-on",
  icon: [
    640,
    512,
    [],
    "e02e",
    "M90.69,76a24,24,0,1,0,26.62-39.92l-48-32A24,24,0,1,0,42.69,44ZM536,80a23.87,23.87,0,0,0,13.29-4l48-32A24,24,0,1,0,570.69,4.06l-48,32A24,24,0,0,0,536,80ZM112,192a24,24,0,0,0-24-24H24a24,24,0,0,0,0,48H88A24,24,0,0,0,112,192Zm504-24H552a24,24,0,0,0,0,48h64a24,24,0,0,0,0-48ZM512,336,489.88,127.07A72,72,0,0,0,418.44,64H221.56a72,72,0,0,0-71.44,63.07L128,336a32,32,0,0,0-32,32v80a32,32,0,0,0,32,32H512a32,32,0,0,0,32-32V368A32,32,0,0,0,512,336ZM197.75,133a24,24,0,0,1,23.81-21H418.44a24,24,0,0,1,23.82,21l21.37,203H252.09l19.84-180.82a8,8,0,0,0-6.87-9l-15.86-2.13a7.79,7.79,0,0,0-1.07-.07,8,8,0,0,0-7.92,6.94L219.8,336H176.37ZM496,432H144V384H496Z"
  ]
};
export const faSitemap = {
  prefix: "far",
  iconName: "sitemap",
  icon: [
    640,
    512,
    [],
    "f0e8",
    "M104 272h192v48h48v-48h192v48h48v-57.59c0-21.17-17.22-38.41-38.41-38.41H344v-64h40c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32H256c-17.67 0-32 14.33-32 32v96c0 8.84 3.58 16.84 9.37 22.63S247.16 160 256 160h40v64H94.41C73.22 224 56 241.23 56 262.41V320h48v-48zm168-160V48h96v64h-96zm336 240h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32zm-16 112h-64v-64h64v64zM368 352h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32zm-16 112h-64v-64h64v64zM128 352H32c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32zm-16 112H48v-64h64v64z"
  ]
};
export const faSkating = {
  prefix: "far",
  iconName: "skating",
  icon: [
    448,
    512,
    [],
    "f7c5",
    "M400 0c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48zM152 144h103.1l-36.5 31.3c-11.8 10.1-18.9 24.8-19.5 40.4-.6 15.5 5.4 30.8 17.2 42.5l87.7 80V424c0 13.2 10.7 24 24 24s24-10.8 24-24v-89.4c0-10.5-4.3-20.8-12.5-29l-72.8-66.3 88.6-88.6c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.7-29.6-19.7H152c-13.2 0-24 10.8-24 24s10.7 23.9 24 23.9zm35.5 129.4L85.9 375c-9.4 9.4-9.4 24.6 0 33.9 4.7 4.7 10.8 7 17 7s12.3-2.3 17-7L222 306.7l-28.4-25.9c-2.3-2.3-4-4.9-6.1-7.4zM400 448c-8.8 0-16 7.2-16 16s-7.2 16-16 16h-96c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c26.5 0 48-21.5 48-48 0-8.8-7.2-16-16-16zm-282.2 8.6c-6.2 6.2-16.4 6.2-22.6 0l-67.9-67.9c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l67.9 67.9c9.3 9.4 21.7 14 33.9 14s24.6-4.7 33.9-14c6.2-6.2 6.2-16.4 0-22.6s-16.3-6.3-22.6 0z"
  ]
};
export const faSkeleton = {
  prefix: "far",
  iconName: "skeleton",
  icon: [
    512,
    512,
    [],
    "f620",
    "M496 160H280v-48h152c8.84 0 16-7.16 16-16V80c0-8.84-7.16-16-16-16H280V16c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v48H80c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h152v48H16c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h216v48H80c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h152v48H112c-44.18 0-80 35.82-80 80s35.82 80 80 80 80-35.82 80-80c0-11.39-2.46-22.19-6.75-32h141.51c-4.29 9.81-6.75 20.61-6.75 32 0 44.18 35.82 80 80 80s80-35.82 80-80-35.82-80-80-80H280v-48h152c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16H280v-48h216c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16zM144 432c0 17.64-14.36 32-32 32s-32-14.36-32-32 14.36-32 32-32 32 14.36 32 32zm288 0c0 17.64-14.36 32-32 32s-32-14.36-32-32 14.36-32 32-32 32 14.36 32 32z"
  ]
};
export const faSkiJump = {
  prefix: "far",
  iconName: "ski-jump",
  icon: [
    512,
    512,
    [],
    "f7c7",
    "M400 96c26.5 0 48-21.5 48-48S426.5 0 400 0s-48 21.5-48 48 21.5 48 48 48zm110.7 94.1c-2.2-13.1-14.8-22-27.7-19.7-13.1 2.2-21.9 14.6-19.7 27.7 3.3 19.3-6 38.9-22.1 48.1L169 386.4l50.5-122.6c.4-1.1 1.2-2.1 2-2.9l121.2-110.3c9.2-9.2 11.9-22.9 6.9-34.9S333 96 320 96H136c-13.3 0-24 10.8-24 24s10.8 24 24 24h113.7L181 233.4c-1.3 1.6-1.7 2-5.9 12.1l-53.3 129.4c-4.8 11.5.4 24.3 11.2 30.1L13 466.7c-11.8 6-16.4 20.5-10.3 32.3 4.3 8.3 12.7 13 21.4 13 3.7 0 7.4-.9 10.9-2.7l429.2-220.9c34.4-19.7 53.1-59.2 46.5-98.3z"
  ]
};
export const faSkiLift = {
  prefix: "far",
  iconName: "ski-lift",
  icon: [
    512,
    512,
    [],
    "f7c8",
    "M112 128c26.5 0 48-21.5 48-48s-21.5-48-48-48-48 21.5-48 48 21.5 48 48 48zM256 0h-32v216l32-8V0zm-64.4 381.4c12.6-4.2 19.4-17.8 15.2-30.4-4.2-12.6-17.7-19.5-30.4-15.2L158 342c-19 6.4-40-2.5-48.7-20.7l-63.6-133c-5.7-11.9-20-17-32-11.3-12 5.7-17 20-11.3 32L66 342c15 31.2 46.4 50 79.5 50 12.6 0 17-.9 46.1-10.6zM488 288c-13.2 0-24 10.8-24 24 0 13.9-8.8 26.5-21.8 31.3L312 391.5V256c0-15.8-15-27-29.8-23.3l-93.5 23.4-39.7-85.5c-7.4-16-26.3-23.1-42.5-15.6-12.6 5.8-24.1 24.2-15.7 42.5l47.3 100.6c4.8 10.5 16.5 16.1 27.6 13.2l98.2-24.5v122.5l-152.3 56.3c-12.4 4.6-18.8 18.4-14.2 30.8 3.6 9.7 12.8 15.7 22.5 15.7 2.8 0 5.6-.5 8.3-1.5l330.5-122.1c31.8-11.8 53.2-42.5 53.2-76.4.1-13.3-10.7-24.1-23.9-24.1z"
  ]
};
export const faSkiing = {
  prefix: "far",
  iconName: "skiing",
  icon: [
    512,
    512,
    [],
    "f7c9",
    "M432 96c26.5 0 48-21.5 48-48S458.5 0 432 0s-48 21.5-48 48 21.5 48 48 48zm-312-4.4l-11.5 22.5c14.4 7.3 31.1 4.9 42.8-4.8L284 175.5l61.1-24.4 14.1 42.3c3.4 10.1 10.5 18.3 20.1 23.1l58.1 29c11.9 6 26.3 1.1 32.2-10.7 5.9-11.9 1.1-26.3-10.8-32.2L403.6 175l-18.1-54.4c-4.9-14.6-15.6-26.6-29.6-33.1-14-6.5-30.1-6.9-44.3-1.2l-74.5 29.8-72.2-35.8c.3-14.5-7.2-28.5-20.9-35.6l-11.1 21.7h-.3l-34.4-7c-1.8-.4-3.7.2-5 1.7-1.9 2.2-1.7 5.5.5 7.4L120 91.6zM505 452c-9.4-9.4-24.6-9.3-33.9 0-12.1 12.1-30.7 15.3-45.1 8.7l-143-73.9 49.7-74.6c10.6-15.8 8.5-37.1-5-50.5l-57.2-57.2-76.9-38.1c-1.6 16.6 3.8 33 15.7 44.9l79.8 79.8-49.1 73.6-205-106c-11.9-6.1-26.3-1.5-32.3 10.3-6.1 11.8-1.5 26.3 10.3 32.3l391.9 202.5c11.9 5.5 24.5 8.1 37.1 8.1 23.2 0 46.1-9 63-26 9.3-9.3 9.3-24.5 0-33.9z"
  ]
};
export const faSkiingNordic = {
  prefix: "far",
  iconName: "skiing-nordic",
  icon: [
    576,
    512,
    [],
    "f7ca",
    "M336 96c26.5 0 48-21.5 48-48S362.5 0 336 0s-48 21.5-48 48 21.5 48 48 48zm216 320c-13.2 0-24 10.7-24 24 0 13.2-10.8 24-24 24h-69.5l28.2-197.4c5.5-4.4 9.3-10.9 9.3-18.5 0-13.2-10.8-24-24-24h-49l-28.2-57.7c-11.3-23.1-32.4-40.6-56.6-46.7l-71.4-21.2c-25.6-6.2-52.6-.4-73.7 15.8l-39.7 30.4c-5.1 3.9-8.4 9.5-9.2 15.9-.8 5.8.8 11.5 4.1 16.4L66.9 464H24c-13.2 0-24 10.7-24 24s10.8 24 24 24h480c39.7 0 72-32.3 72-72 0-13.2-10.8-24-24-24zm-254.6 48H185.7l51.4-108.5-17.4-10.3c-8.6-5.1-15.8-11.5-22-18.8L132.6 464H99.5l56-279.8c1-.6 2.2-.8 3.1-1.5l39.7-30.4c7.1-5.5 15.9-8.5 24.4-8.5 2.6 0 5.2.3 7.6.9l23.8 7-41 95.7c-11 25.8-1.2 56 23 70.3l90.5 53.4-29.2 92.9zm104.7 0h-54.4l26.9-85.8c4.8-17.1-2.6-35.8-18.2-45.2l-67.1-39.6L329.8 192l28.2 57.6c6.7 13.6 20.8 22.4 35.9 22.4h35.5l-27.3 192z"
  ]
};
export const faSkull = {
  prefix: "far",
  iconName: "skull",
  icon: [
    512,
    512,
    [],
    "f54c",
    "M344 200c-30.9 0-56 25.1-56 56s25.1 56 56 56 56-25.1 56-56-25.1-56-56-56zm-176 0c-30.9 0-56 25.1-56 56s25.1 56 56 56 56-25.1 56-56-25.1-56-56-56zM256 0C114.6 0 0 100.3 0 224c0 70.1 36.9 132.6 94.5 173.7 9.7 6.9 15.2 18.1 13.5 29.9l-6.8 47.9c-2.7 19.3 12.2 36.5 31.7 36.5h246.3c19.5 0 34.4-17.2 31.7-36.5l-6.8-47.9c-1.7-11.7 3.8-23 13.5-29.9C475.1 356.6 512 294.1 512 224 512 100.3 397.4 0 256 0zm133.7 358.6c-24.6 17.5-37.3 46.5-33.2 75.7l4.2 29.7H320v-40c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v40h-64v-40c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v40h-40.7l4.2-29.7c4.1-29.2-8.6-58.2-33.2-75.7C75.1 324.9 48 275.9 48 224c0-97 93.3-176 208-176s208 79 208 176c0 51.9-27.1 100.9-74.3 134.6z"
  ]
};
export const faSkullCow = {
  prefix: "far",
  iconName: "skull-cow",
  icon: [
    640,
    512,
    [],
    "f8de",
    "M256,224.09a32,32,0,1,0,32,32A32,32,0,0,0,256,224.09Zm128,0a32,32,0,1,0,32,32A32,32,0,0,0,384,224.09ZM603.26,4.57a16,16,0,0,0-26.21,17c6.07,16.11,19.6,67.57,2.88,91.67C573.13,123,561.4,128,544,128l-73.1-.12a63.75,63.75,0,0,0-55-31.71H224a63.74,63.74,0,0,0-55,31.83H96C78.63,128,66.9,123,60.1,113.26,43.35,89.2,56.49,38.91,63,21.56a16,16,0,0,0-26.19-17C13.05,27.8,0,60.15,0,95.67c0,70.46,57.43,128.26,128,128.26H160v80.13a63.82,63.82,0,0,0,54.6,63l34.73,121.69A32,32,0,0,0,280.07,512h79.72a32,32,0,0,0,30.77-23.19l34.83-121.72a63.81,63.81,0,0,0,54.57-63V224l32-.08c70.59,0,128-57.81,128-128.26C640,60.16,627,27.81,603.26,4.57ZM432,304.06a15.78,15.78,0,0,1-13.64,15.57l-30.58,4.55-8.5,29.71L347.73,464H292.14L260.72,353.93l-8.5-29.76-30.61-4.54A15.79,15.79,0,0,1,208,304.06V160.11a16,16,0,0,1,16-16H416a16,16,0,0,1,16,16Z"
  ]
};
export const faSkullCrossbones = {
  prefix: "far",
  iconName: "skull-crossbones",
  icon: [
    448,
    512,
    [],
    "f714",
    "M184 160c13.24 0 24-10.76 24-24s-10.76-24-24-24-24 10.76-24 24 10.76 24 24 24zm80 0c13.24 0 24-10.76 24-24s-10.76-24-24-24-24 10.76-24 24 10.76 24 24 24zm-128.15 68.54l-7.33 34.61c-2.67 12.62 5.42 24.85 16.45 24.85h158.08c11.03 0 19.12-12.23 16.45-24.85l-7.33-34.61C345.91 205.11 368 169.01 368 128 368 57.31 303.53 0 224 0S80 57.31 80 128c0 41.01 22.09 77.11 55.85 100.54zM224 48c52.94 0 96 35.89 96 80 0 23.3-12.84 45.57-35.21 61.1l-26.2 18.18 6.61 31.2.32 1.52h-83.03l.32-1.52 6.61-31.2-26.2-18.18C140.84 173.57 128 151.3 128 128c0-44.11 43.07-80 96-80zm214.7 418.95L284.31 400l154.39-66.95c8.03-3.71 11.53-13.21 7.82-21.24l-6.71-14.52c-3.71-8.02-13.21-11.52-21.23-7.82L224 373.85 29.42 289.48c-8.02-3.7-17.53-.2-21.23 7.82l-6.71 14.52c-3.71 8.02-.21 17.53 7.82 21.24L163.69 400 9.3 466.95c-8.03 3.7-11.53 13.21-7.82 21.24l6.71 14.52c3.71 8.02 13.21 11.52 21.23 7.82L224 426.15l194.58 84.37c8.02 3.7 17.53.2 21.23-7.82l6.71-14.52c3.71-8.02.21-17.53-7.82-21.23z"
  ]
};
export const faSlash = {
  prefix: "far",
  iconName: "slash",
  icon: [
    640,
    512,
    [],
    "f715",
    "M604 508.49L6.01 40.98c-6.9-5.52-8.02-15.59-2.49-22.49L13.51 6C19.03-.9 29.1-2.01 36 3.51l598 467.51c6.9 5.52 8.02 15.59 2.49 22.49l-10 12.49c-5.52 6.9-15.59 8.01-22.49 2.49z"
  ]
};
export const faSledding = {
  prefix: "far",
  iconName: "sledding",
  icon: [
    512,
    512,
    [],
    "f7cb",
    "M505 420c-9.4-9.4-24.6-9.3-33.9 0-12.1 12.1-30.7 15.3-45.1 8.7l-51-26.4c5.4-4.4 9.1-10.8 9.1-18.3v-80c0-22.1-17.9-40-40-40h-71.5l67.7-67.7c11.5-11.5 14.9-28.6 8.7-43.6-6.2-15-20.7-24.7-37-24.7H152c-13.3 0-24 10.8-24 24s10.8 24 24 24h107l-100 85.8c-6.2 5.3-9.3 13.4-8.2 21.5.2 1.5 1.2 2.6 1.7 4L35 226.7c-11.9-6.1-26.3-1.5-32.3 10.3-6.1 11.8-1.5 26.3 10.3 32.3l391.9 202.5c11.9 5.5 24.5 8.1 37.1 8.1 23.2 0 46.1-9 63-26 9.3-9.3 9.3-24.5 0-33.9zm-169-37.7L200.1 312H336v70.3zM400 128c26.5 0 48-21.5 48-48s-21.5-48-48-48-48 21.5-48 48 21.5 48 48 48z"
  ]
};
export const faSleigh = {
  prefix: "far",
  iconName: "sleigh",
  icon: [
    640,
    512,
    [],
    "f7cc",
    "M612.7 350.7l-9.3-7.4c-6.9-5.5-17-4.4-22.5 2.5l-10 12.5c-5.5 6.9-4.4 17 2.5 22.5l9.3 7.4c5.9 4.7 9.2 11.7 9.2 19.2 0 13.6-11 24.6-24.6 24.6H440v-48c66.2 0 120-53.8 120-120V144h32c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16H432c-8.8 0-16 7.2-16 16v72c0 65.3-134.4 52.3-181.2-42.6C201.5 73.9 134.6 32 60.2 32H16C7.2 32 0 39.2 0 48v16c0 8.8 7.2 16 16 16h16v152c0 66.9 43.8 123.3 104 143.5V432H48c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h516c39 0 73.7-29.3 75.9-68.3 1.4-23.8-8.7-46.3-27.2-61zM80 232V81.4c47.9 6.5 89.6 36.4 111.7 81.2C260.3 301.6 464 308.4 464 184v-40h48v120c0 39.7-32.3 72-72 72H184c-57.3 0-104-46.7-104-104zm312 200H184v-48h208v48z"
  ]
};
export const faSlidersH = {
  prefix: "far",
  iconName: "sliders-h",
  icon: [
    512,
    512,
    [],
    "f1de",
    "M496 72H288V48c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v24H16C7.2 72 0 79.2 0 88v16c0 8.8 7.2 16 16 16h208v24c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-24h208c8.8 0 16-7.2 16-16V88c0-8.8-7.2-16-16-16zm0 320H160v-24c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v24H16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h80v24c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-24h336c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zm0-160h-80v-24c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v24H16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h336v24c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-24h80c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16z"
  ]
};
export const faSlidersHSquare = {
  prefix: "far",
  iconName: "sliders-h-square",
  icon: [
    448,
    512,
    [],
    "f3f0",
    "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-6 400H54c-3.3 0-6-2.7-6-6V86c0-3.3 2.7-6 6-6h340c3.3 0 6 2.7 6 6v340c0 3.3-2.7 6-6 6zm-42-244v8c0 6.6-5.4 12-12 12H192v24c0 13.3-10.7 24-24 24h-16c-13.3 0-24-10.7-24-24v-24h-20c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h20v-24c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24v24h148c6.6 0 12 5.4 12 12zm0 128v8c0 6.6-5.4 12-12 12h-20v24c0 13.3-10.7 24-24 24h-16c-13.3 0-24-10.7-24-24v-24H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h148v-24c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24v24h20c6.6 0 12 5.4 12 12z"
  ]
};
export const faSlidersV = {
  prefix: "far",
  iconName: "sliders-v",
  icon: [
    448,
    512,
    [],
    "f3f1",
    "M272 352h-24V16c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16v336h-24c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h24v80c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-80h24c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM112 96H88V16c0-8.8-7.2-16-16-16H56c-8.8 0-16 7.2-16 16v80H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h24v336c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V160h24c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm320 128h-24V16c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16v208h-24c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h24v208c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V288h24c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"
  ]
};
export const faSlidersVSquare = {
  prefix: "far",
  iconName: "sliders-v-square",
  icon: [
    448,
    512,
    [],
    "f3f2",
    "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-6 400H54c-3.3 0-6-2.7-6-6V86c0-3.3 2.7-6 6-6h340c3.3 0 6 2.7 6 6v340c0 3.3-2.7 6-6 6zM224 184v16c0 13.3-10.7 24-24 24h-24v148c0 6.6-5.4 12-12 12h-8c-6.6 0-12-5.4-12-12V224h-24c-13.3 0-24-10.7-24-24v-16c0-13.3 10.7-24 24-24h24v-20c0-6.6 5.4-12 12-12h8c6.6 0 12 5.4 12 12v20h24c13.3 0 24 10.7 24 24zm128 128v16c0 13.3-10.7 24-24 24h-24v20c0 6.6-5.4 12-12 12h-8c-6.6 0-12-5.4-12-12v-20h-24c-13.3 0-24-10.7-24-24v-16c0-13.3 10.7-24 24-24h24V140c0-6.6 5.4-12 12-12h8c6.6 0 12 5.4 12 12v148h24c13.3 0 24 10.7 24 24z"
  ]
};
export const faSmile = {
  prefix: "far",
  iconName: "smile",
  icon: [
    496,
    512,
    [],
    "f118",
    "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-80-216c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm4 72.6c-20.8 25-51.5 39.4-84 39.4s-63.2-14.3-84-39.4c-8.5-10.2-23.7-11.5-33.8-3.1-10.2 8.5-11.5 23.6-3.1 33.8 30 36 74.1 56.6 120.9 56.6s90.9-20.6 120.9-56.6c8.5-10.2 7.1-25.3-3.1-33.8-10.1-8.4-25.3-7.1-33.8 3.1z"
  ]
};
export const faSmileBeam = {
  prefix: "far",
  iconName: "smile-beam",
  icon: [
    496,
    512,
    [],
    "f5b8",
    "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm84-143.4c-20.8 25-51.5 39.4-84 39.4s-63.2-14.3-84-39.4c-8.5-10.2-23.6-11.5-33.8-3.1-10.2 8.5-11.5 23.6-3.1 33.8 30 36 74.1 56.6 120.9 56.6s90.9-20.6 120.9-56.6c8.5-10.2 7.1-25.3-3.1-33.8-10.2-8.4-25.3-7.1-33.8 3.1zM136.5 211c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3 3.4 1.1 7.4-.5 9.3-3.7l9.5-17zM328 152c-23.8 0-52.7 29.3-56 71.4-.3 3.7 2.1 7.2 5.7 8.3 3.5 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4z"
  ]
};
export const faSmilePlus = {
  prefix: "far",
  iconName: "smile-plus",
  icon: [
    640,
    512,
    [],
    "f5b9",
    "M208 96C93.1 96 0 189.1 0 304s93.1 208 208 208 208-93.1 208-208S322.9 96 208 96zm0 368c-88.2 0-160-71.8-160-160s71.8-160 160-160 160 71.8 160 160-71.8 160-160 160zm61.8-124.2c-30.6 35.8-92.9 35.8-123.5 0-8.7-10.1-23.8-11.2-33.8-2.7-10.1 8.6-11.2 23.8-2.7 33.8 24.4 28.6 60.2 45 98.2 45s73.8-16.4 98.2-45c8.6-10.1 7.4-25.2-2.7-33.8-10-8.5-25.1-7.4-33.7 2.7zM144 288c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm128 0c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zM624 88h-72V16c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16v72h-72c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h72v72c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-72h72c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16z"
  ]
};
export const faSmileWink = {
  prefix: "far",
  iconName: "smile-wink",
  icon: [
    496,
    512,
    [],
    "f4da",
    "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm117.8-146.4c-10.2-8.5-25.3-7.1-33.8 3.1-20.8 25-51.5 39.4-84 39.4s-63.2-14.3-84-39.4c-8.5-10.2-23.7-11.5-33.8-3.1-10.2 8.5-11.5 23.6-3.1 33.8 30 36 74.1 56.6 120.9 56.6s90.9-20.6 120.9-56.6c8.5-10.2 7.1-25.3-3.1-33.8zM168 240c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160-60c-25.7 0-55.9 16.9-59.9 42.1-1.7 11.2 11.5 18.2 19.8 10.8l9.5-8.5c14.8-13.2 46.2-13.2 61 0l9.5 8.5c8.5 7.4 21.6.3 19.8-10.8-3.8-25.2-34-42.1-59.7-42.1z"
  ]
};
export const faSmog = {
  prefix: "far",
  iconName: "smog",
  icon: [
    640,
    512,
    [],
    "f75f",
    "M624 368H80c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h544c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zm-480 96H16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zm416 0H224c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h336c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zM144 288h113c28 21 60.7 32 95 32s67.1-11 95-32h65c70.6 0 128-57.4 128-128S582.6 32 512 32c-17.8 0-35.4 3.8-51.7 11C430.8 15.5 392.2 0 352 0c-40.1 0-77.7 14.9-106.9 41.5C218.4 15.2 182.3 0 144 0 64.6 0 0 64.6 0 144s64.6 144 144 144zm0-240c25.4 0 49.3 9.8 67.3 27.7l32.4 32L277.4 77c20.5-18.7 47-29 74.6-29 27.9 0 54.7 10.7 75.6 30.1l23.2 21.7 29-12.9c10.3-4.6 21.1-6.9 32.2-6.9 44.1 0 80 35.9 80 80s-35.9 80-80 80h-81l-12.8 9.6C398.4 264.5 376.1 272 352 272s-46.4-7.5-66.2-22.4L273 240H144c-52.9 0-96-43.1-96-96s43.1-96 96-96z"
  ]
};
export const faSmoke = {
  prefix: "far",
  iconName: "smoke",
  icon: [
    640,
    512,
    [],
    "f760",
    "M640 248c0-83.8-68.2-152-152-152-14.4 0-28.4 2.7-42 6.7C418.2 60.3 370.5 32 316 32c-19.8 0-39.3 3.9-58.1 11.7C229.6 15.7 191.9 0 152 0 68.2 0 0 68.2 0 152c0 37.8 14.3 72 37.4 98.5C14.4 278.2 0 313.3 0 352c0 88.2 71.8 160 160 160h352c70.6 0 128-57.4 128-128 0-23.8-7-45.9-18.4-65.1 11.5-21.1 18.4-45.1 18.4-70.9zm-48 0c0 11.3-2.1 22.1-5.5 32.3-21-15.2-46.6-24.3-74.5-24.3-21.6 0-42.4 5.4-61.1 15.9C423.8 241.5 385.3 224 344 224c-24.1 0-47.3 6.1-68.4 17.7-6.9-7.3-14.6-13.6-22.7-19.4C268.7 194.8 298 176 332 176c15.6 0 30.8 4.2 45.2 12.5l17.7 10.1 12.9-15.8c20.1-24.6 49.3-38.8 80.2-38.8 57.3 0 104 46.7 104 104zM152 48c31.6 0 61.2 14.6 81.3 40l12.7 16.1 17.9-10C280.6 84.8 298.2 80 316 80c35.3 0 66.4 17.3 86.1 43.6-6.4 4.5-12.8 9.2-18.5 14.7C367 131.4 349.7 128 332 128c-52.8 0-98.3 29.6-122.1 72.9-16-5.4-32.7-8.9-49.9-8.9-32.3 0-62.3 9.8-87.5 26.3-15.2-18-24.5-41-24.5-66.3C48 94.7 94.7 48 152 48zm360 416H160c-61.8 0-112-50.2-112-112s50.2-112 112-112c36 0 70.1 17.7 91.2 47.4l14.5 20.4 19.8-15.4C302.8 279.1 323 272 344 272c33.1 0 63.4 17 81.2 45.4l14.6 23.4 21.1-17.7c10.4-8.7 27.6-19 51.1-19 44.1 0 80 35.9 80 80S556.1 464 512 464z"
  ]
};
export const faSmoking = {
  prefix: "far",
  iconName: "smoking",
  icon: [
    640,
    512,
    [],
    "f48d",
    "M503.7 141.6C479.8 125 464 99.3 464 70.3V8c0-4.4-3.6-8-8-8h-32c-4.4 0-8 3.6-8 8v66.4c0 43.7 24.6 81.6 60.3 106.7 22.4 15.7 35.7 41.2 35.7 68.6V280c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8v-30.3c0-43.3-21-83.4-56.3-108.1zm49.6-54.5c-5.7-3.8-9.3-10-9.3-16.8V8c0-4.4-3.6-8-8-8h-32c-4.4 0-8 3.6-8 8v62.3c0 22 10.2 43.4 28.6 55.4 42.2 27.3 67.4 73.8 67.4 124V280c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8v-30.3c0-65.5-32.4-126.2-86.7-162.6zM632 352h-32c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8zm-80 0h-32c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8zm-96 0H48c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h408c13.2 0 24-10.8 24-24V376c0-13.2-10.8-24-24-24zm-24 112H224v-64h208v64z"
  ]
};
export const faSmokingBan = {
  prefix: "far",
  iconName: "smoking-ban",
  icon: [
    512,
    512,
    [],
    "f54d",
    "M112 320h106.2l-96-96H112c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16zm208.6-192c-15.6 0-28.6-11.2-31.4-25.9-.7-3.6-4-6.1-7.7-6.1h-16.2c-5 0-8.7 4.5-8 9.4 4.6 30.9 31.2 54.6 63.3 54.6 15.6 0 28.6 11.2 31.4 25.9.7 3.6 4 6.1 7.7 6.1h16.2c5 0 8.7-4.5 8-9.4-4.6-30.9-31.2-54.6-63.3-54.6zM256 0C114.6 0 0 114.6 0 256s114.6 256 256 256 256-114.6 256-256S397.4 0 256 0zm0 464c-114.7 0-208-93.3-208-208 0-48.7 17-93.5 45.1-129L385 418.9C349.5 447 304.7 464 256 464zm33.9-208H384v32h-62.1l-32-32zm129 129l-65-65H400c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16H257.9L127 93.1C162.5 65 207.3 48 256 48c114.7 0 208 93.3 208 208 0 48.7-17 93.5-45.1 129z"
  ]
};
export const faSms = {
  prefix: "far",
  iconName: "sms",
  icon: [
    512,
    512,
    [],
    "f7cd",
    "M135.4 218.5c-1.4-1.2-2.1-2.5-2.1-3.8 0-3.1 4.5-6.6 10.4-6.6H156c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8h-12.2c-23.4 0-42.4 17.3-42.4 38.6 0 10.7 4.9 20.9 13.3 28.1l21.9 18.8c1.4 1.2 2.1 2.5 2.1 3.8 0 3.1-4.5 6.6-10.4 6.6H116c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h12.3c23.4 0 42.4-17.3 42.4-38.6 0-10.7-4.9-20.9-13.3-28.1l-22-18.8zM304 176h-16c-6.1 0-11.6 3.4-14.3 8.8L256 220.2l-17.7-35.4c-2.7-5.4-8.2-8.8-14.3-8.8h-16c-8.8 0-16 7.2-16 16v104c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-68.2l24.8 55.8c2.9 5.9 11.4 5.9 14.3 0l24.8-55.8V296c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V192c.1-8.8-7.1-16-15.9-16zm71.4 42.5c-1.4-1.2-2.1-2.5-2.1-3.8 0-3.1 4.5-6.6 10.4-6.6H396c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8h-12.3c-23.4 0-42.4 17.3-42.4 38.6 0 10.7 4.9 20.9 13.3 28.1l21.9 18.8c1.4 1.2 2.1 2.5 2.1 3.8 0 3.1-4.5 6.6-10.4 6.6H356c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h12.3c23.4 0 42.4-17.3 42.4-38.6 0-10.7-4.9-20.9-13.3-28.1l-22-18.8zM256 32C114.6 32 0 125.1 0 240c0 47.6 19.9 91.2 52.9 126.3C38 405.7 7 439.1 6.5 439.5c-6.6 7-8.4 17.2-4.6 26C5.7 474.3 14.4 480 24 480c61.5 0 110-25.7 139.1-46.3C192 442.8 223.2 448 256 448c141.4 0 256-93.1 256-208S397.4 32 256 32zm0 368c-26.7 0-53.1-4.1-78.4-12.1l-22.7-7.2-19.5 13.8c-14.3 10.1-33.9 21.4-57.5 29 7.3-12.1 14.4-25.7 19.9-40.2l10.6-28.1-20.6-21.8C69.7 314.1 48 282.2 48 240c0-88.2 93.3-160 208-160s208 71.8 208 160-93.3 160-208 160z"
  ]
};
export const faSnake = {
  prefix: "far",
  iconName: "snake",
  icon: [
    640,
    512,
    [],
    "f716",
    "M512 248c-8.84 0-16 7.16-16 16s7.16 16 16 16 16-7.16 16-16-7.16-16-16-16zm99.76-83.09c-96.8-34.97-97.74-36.89-115.74-36.89-34.38 0-65.09 22.74-75.71 55.49C362.35 202.13 320 255.93 320 320v48c0 8.82-7.18 16-16 16s-16-7.18-16-16V149.7C288 94.31 246.48 0 144 0 64.56 0 0 64.47 0 144v159.53C0 367.85 11.45 431 34.04 491.23 38.77 503.85 50.53 512 64 512c13.47 0 25.23-8.15 29.96-20.76C116.55 431.01 128 367.85 128 303.53V144c0-8.82 7.18-16 16-16s16 7.18 16 16v218.3c0 55.4 41.52 149.7 144 149.7 79.4 0 144-64.6 144-144v-31.14c13.53 10.16 30.24 16.09 47.87 16.09 18.2 0 21.44-2.86 115.47-35.52 16.99-5.03 28.65-20.66 28.65-38.4v-75.85c.01-17.58-11.45-33.1-28.23-38.27zM592 270.98c-93.37 34.05-88.56 33.04-95.98 33.04-13.44 0-25.79-9.17-30.05-22.29l-5.66-17.47c-33.51 1.38-60.3 28.77-60.3 62.61V368c0 125.3-192 131.89-192-5.7V147.6c0-31.89-21.71-61.53-53.18-66.71C114.77 74.29 80 105.16 80 144v159.53c0 42.02-5.37 83.49-16 123.82-10.63-40.33-16-81.8-16-123.82V147.46C48 73.11 109.92 48 144 48c55.06 0 96 47.89 96 101.7v214.7c0 90.85 128 87.15 128 3.6v-48c0-60.1 47.88-84.66 67-90.8l23.39-7.52 7.58-23.38c4.26-13.12 16.61-22.29 30.05-22.29 7.44 0 2.62-1.01 95.98 33.04v61.93zM496 216c0 8.84 7.16 16 16 16s16-7.16 16-16-7.16-16-16-16-16 7.16-16 16z"
  ]
};
export const faSnooze = {
  prefix: "far",
  iconName: "snooze",
  icon: [
    448,
    512,
    [],
    "f880",
    "M288 29V16a16 16 0 0 0-16-16H160a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h58.12l-82.2 93.94A32 32 0 0 0 128 163v13a16 16 0 0 0 16 16h112a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16h-58.13l82.21-93.94A32 32 0 0 0 288 29zm-88 227H32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h99.34L9.53 440.06A32.09 32.09 0 0 0 0 462.86V488a24 24 0 0 0 24 24h184a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H92.66l121.81-120.06a32.09 32.09 0 0 0 9.53-22.8V280a24 24 0 0 0-24-24zm232-32H320a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h58.12l-82.2 93.94A32 32 0 0 0 288 387v13a16 16 0 0 0 16 16h112a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16h-58.13l82.21-93.94A32 32 0 0 0 448 253v-13a16 16 0 0 0-16-16z"
  ]
};
export const faSnowBlowing = {
  prefix: "far",
  iconName: "snow-blowing",
  icon: [
    640,
    512,
    [],
    "f761",
    "M350.4 105.4l-12.1-21c-3.4-5.8-10.8-7.8-16.6-4.4l-26.6 15.3 5.5-20.4c1.7-6.5-2.1-13.1-8.6-14.9l-11.7-3.1c-6.5-1.7-13.1 2.1-14.9 8.6l-15 55.5-50.4 29.1V93.2L240.2 53c4.7-4.7 4.7-12.3 0-17l-8.5-8.5c-4.7-4.7-12.3-4.7-17 0L200 42.3V12c0-6.6-5.4-12-12-12h-24c-6.6 0-12 5.4-12 12v30.3l-14.8-14.8c-4.7-4.7-12.3-4.7-17 0l-8.5 8.5c-4.7 4.7-4.7 12.3 0 17L152 93.2v56.9L101.6 121l-15-55.7c-1.7-6.5-8.4-10.3-14.9-8.6L60 59.9c-6.5 1.7-10.3 8.4-8.6 14.9l5.5 20.4-26.5-15.3c-5.8-3.4-13.2-1.4-16.6 4.4l-12.1 21c-3.4 5.8-1.4 13.2 4.4 16.6l26.6 15.3-20.4 5.5c-6.5 1.7-10.3 8.4-8.6 14.9l3.1 11.7c1.7 6.5 8.4 10.3 14.9 8.6L77.3 163l50.2 29-50.2 29-55.7-15c-6.5-1.7-13.1 2.1-14.9 8.6l-3.1 11.7c-1.7 6.5 2.1 13.1 8.6 14.9l20.4 5.5-26.5 15.4c-5.8 3.4-7.8 10.8-4.4 16.6l12.1 21c3.4 5.8 10.8 7.8 16.6 4.4L57 288.8l-5.5 20.4c-1.7 6.5 2.1 13.1 8.6 14.9l11.7 3.1c6.5 1.7 13.1-2.1 14.9-8.6l14.9-55.6 50.4-29.1v56.9L111.8 331c-4.7 4.7-4.7 12.3 0 17l8.5 8.5c4.7 4.7 12.3 4.7 17 0l14.8-14.8V372c0 6.6 5.4 12 12 12h24c6.6 0 12-5.4 12-12v-30.3l14.8 14.8c4.7 4.7 12.3 4.7 17 0l8.5-8.5c4.7-4.7 4.7-12.3 0-17L200 290.8v-56.9l50.4 29.1 14.9 55.6c1.7 6.5 8.4 10.3 14.9 8.6l11.7-3.1c6.5-1.7 10.3-8.4 8.6-14.9l-5.5-20.4 26.6 15.3c5.8 3.4 13.2 1.4 16.6-4.4l12.1-21c3.4-5.8 1.4-13.2-4.4-16.6l-26.6-15.3 20.4-5.5c6.5-1.7 10.3-8.4 8.6-14.9l-3.1-11.7c-1.7-6.5-8.4-10.3-14.9-8.6L274.7 221l-50.2-29 50.2-29 55.6 14.9c6.5 1.7 13.1-2.1 14.9-8.6l3.1-11.7c1.7-6.5-2.1-13.1-8.6-14.9l-20.4-5.5 26.6-15.3c5.8-3.3 7.8-10.7 4.5-16.5zM544 320H368c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h176c31.4 0 55.9 30.3 45.6 63.3-4.4 14.3-16.1 25.9-30.4 30.4-28.5 8.9-55.1-8.3-61.7-33.5-1.8-6.9-7.5-12.1-14.7-12.1h-18.4c-9.2 0-16.6 8.2-14.9 17.2 9.3 51.2 59.2 88.3 115.1 76.6 36.3-7.6 65.6-36.9 73.2-73.2 13-62.1-34-116.7-93.8-116.7zm-144-32h144c59.8 0 106.8-54.6 93.8-116.6-7.6-36.3-36.9-65.6-73.2-73.2-55.9-11.7-105.8 25.4-115.1 76.6-1.6 9 5.8 17.2 14.9 17.2h18.4c7.2 0 12.9-5.2 14.7-12.1 6.6-25.2 33.2-42.4 61.7-33.5 14.3 4.5 25.9 16.1 30.4 30.4 10.2 32.9-14.2 63.3-45.6 63.3H400c-8.8 0-16 7.2-16 16v16c0 8.7 7.2 15.9 16 15.9z"
  ]
};
export const faSnowboarding = {
  prefix: "far",
  iconName: "snowboarding",
  icon: [
    512,
    512,
    [],
    "f7ce",
    "M432 96c26.5 0 48-21.5 48-48S458.5 0 432 0s-48 21.5-48 48 21.5 48 48 48zm41.4 155c4.3 3.3 9.5 5 14.6 5 7.2 0 14.3-3.2 19.1-9.4 8.1-10.5 6.1-25.6-4.4-33.7L383 121.3c-13.1-9.8-27.6-17.4-43.2-22.6l-67-22.4-35.9-64C230.4.8 215.7-3.4 204.2 3.1c-11.6 6.5-15.7 21.1-9.2 32.7l36.5 65.1c4.8 9.5 13 16.6 23.1 20l34.8 11.6-58.4 29.2c-19.1 9.5-31 28.7-31 50.1v54.9c0 3.2-1.9 6.1-4.9 7.4l-76.3 31.8c-12.2 5.1-18 19.2-12.9 31.4 1.2 3 3.1 5.4 5.3 7.5l-43.6-15.9c-9.7-3.5-17.4-10.6-21.8-20-5.6-12-19.9-17.3-31.9-11.6-12 5.6-17.2 19.9-11.6 31.9 9.8 21 27.1 36.8 48.8 44.8l364.8 132.8c9.7 3.5 19.7 5.3 29.7 5.3 12.5 0 24.9-2.7 36.5-8.2 12-5.6 17.2-19.9 11.6-31.9s-19.9-17.2-31.9-11.6c-9.3 4.3-19.8 4.8-29.5 1.3l-103.8-37.8c10.8-.3 20.5-7.8 22.9-18.9l21.8-102c3.2-15.2-2.7-31.1-15.1-40.4l-62.7-47 82.2-37.9 95.8 73.3zm-148.1 47l-20.8 97c-1.9 9 1.7 17.7 8.2 23.2l-182.8-66.5c2.5-.2 4.9-.5 7.3-1.5l76.3-31.8c20.9-8.7 34.4-29 34.4-51.7V240l77.4 58z"
  ]
};
export const faSnowflake = {
  prefix: "far",
  iconName: "snowflake",
  icon: [
    448,
    512,
    [],
    "f2dc",
    "M440.1 355.2l-39.2-23 34.1-9.3c8.4-2.3 13.4-11.1 11.1-19.6l-4.1-15.5c-2.2-8.5-10.9-13.6-19.3-11.3L343 298.2 271.2 256l71.9-42.2 79.7 21.7c8.4 2.3 17-2.8 19.3-11.3l4.1-15.5c2.2-8.5-2.7-17.3-11.1-19.6l-34.1-9.3 39.2-23c7.5-4.4 10.1-14.2 5.8-21.9l-7.9-13.9c-4.3-7.7-14-10.3-21.5-5.9l-39.2 23 9.1-34.7c2.2-8.5-2.7-17.3-11.1-19.6l-15.2-4.1c-8.4-2.3-17 2.8-19.3 11.3l-21.3 81-71.9 42.2v-84.5L306 70.4c6.1-6.2 6.1-16.4 0-22.6l-11.1-11.3c-6.1-6.2-16.1-6.2-22.2 0l-24.9 25.4V16c0-8.8-7-16-15.7-16h-15.7c-8.7 0-15.7 7.2-15.7 16v46.1l-24.9-25.4c-6.1-6.2-16.1-6.2-22.2 0L142.1 48c-6.1 6.2-6.1 16.4 0 22.6l58.3 59.3v84.5l-71.9-42.2-21.3-81c-2.2-8.5-10.9-13.6-19.3-11.3L72.7 84c-8.4 2.3-13.4 11.1-11.1 19.6l9.1 34.7-39.2-23c-7.5-4.4-17.1-1.8-21.5 5.9l-7.9 13.9c-4.3 7.7-1.8 17.4 5.8 21.9l39.2 23-34.1 9.1c-8.4 2.3-13.4 11.1-11.1 19.6L6 224.2c2.2 8.5 10.9 13.6 19.3 11.3l79.7-21.7 71.9 42.2-71.9 42.2-79.7-21.7c-8.4-2.3-17 2.8-19.3 11.3l-4.1 15.5c-2.2 8.5 2.7 17.3 11.1 19.6l34.1 9.3-39.2 23c-7.5 4.4-10.1 14.2-5.8 21.9L10 391c4.3 7.7 14 10.3 21.5 5.9l39.2-23-9.1 34.7c-2.2 8.5 2.7 17.3 11.1 19.6l15.2 4.1c8.4 2.3 17-2.8 19.3-11.3l21.3-81 71.9-42.2v84.5l-58.3 59.3c-6.1 6.2-6.1 16.4 0 22.6l11.1 11.3c6.1 6.2 16.1 6.2 22.2 0l24.9-25.4V496c0 8.8 7 16 15.7 16h15.7c8.7 0 15.7-7.2 15.7-16v-46.1l24.9 25.4c6.1 6.2 16.1 6.2 22.2 0l11.1-11.3c6.1-6.2 6.1-16.4 0-22.6l-58.3-59.3v-84.5l71.9 42.2 21.3 81c2.2 8.5 10.9 13.6 19.3 11.3L375 428c8.4-2.3 13.4-11.1 11.1-19.6l-9.1-34.7 39.2 23c7.5 4.4 17.1 1.8 21.5-5.9l7.9-13.9c4.6-7.5 2.1-17.3-5.5-21.7z"
  ]
};
export const faSnowflakes = {
  prefix: "far",
  iconName: "snowflakes",
  icon: [
    640,
    512,
    [],
    "f7cf",
    "M527.9 120c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V91.6l28 16.1c3.8 2.2 8.7.9 10.9-2.9l8-13.9c2.2-3.8.9-8.7-2.9-10.9L576 64l27.9-16c3.8-2.2 5.1-7.1 2.9-10.9l-8-13.9c-2.2-3.8-7.1-5.1-10.9-2.9l-28 16.1V8c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v28.4l-28-16.1c-3.8-2.2-8.7-.9-10.9 2.9l-8 13.9c-2.2 3.8-.9 8.7 2.9 10.9l27.9 16-27.9 16c-3.8 2.2-5.1 7.1-2.9 10.9l8 13.9c2.2 3.8 7.1 5.1 10.9 2.9l28-16.1V120zm80.2 136l27.9-16c3.8-2.2 5.1-7.1 2.9-10.9l-8-13.9c-2.2-3.8-7.1-5.1-10.9-2.9l-28 16.1V200c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v28.4l-28-16.1c-3.8-2.2-8.7-.9-10.9 2.9l-8 13.9c-2.2 3.8-.9 8.7 2.9 10.9l27.9 16-27.9 16c-3.8 2.2-5.1 7.1-2.9 10.9l8 13.9c2.2 3.8 7.1 5.1 10.9 2.9l28-16.1V312c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-28.4l28 16.1c3.8 2.2 8.7.9 10.9-2.9l8-13.9c2.2-3.8.9-8.7-2.9-10.9l-27.9-16zM445.9 134.9L438 121c-4.3-7.7-14-10.3-21.5-5.9l-39.2 23 9.1-34.7c2.2-8.5-2.7-17.3-11.1-19.6l-15.2-4.1c-8.4-2.3-17 2.8-19.3 11.3l-21.3 81-71.9 42.2v-84.5l58.3-59.3c6.1-6.2 6.1-16.4 0-22.6l-11.1-11.3c-6.1-6.2-16.1-6.2-22.2 0l-24.9 25.4V16c0-8.8-7-16-15.7-16h-15.7c-8.7 0-15.7 7.2-15.7 16v46.1l-24.9-25.4c-6.1-6.2-16.1-6.2-22.2 0L142.1 48c-6.1 6.2-6.1 16.4 0 22.6l58.3 59.3v84.5l-71.9-42.2-21.3-81c-2.2-8.5-10.9-13.6-19.3-11.3L72.7 84c-8.4 2.3-13.4 11.1-11.1 19.6l9.1 34.7-39.2-23c-7.5-4.4-17.1-1.8-21.5 5.9l-7.9 13.9c-4.3 7.7-1.8 17.4 5.8 21.9l39.2 23-34.1 9.1c-8.4 2.3-13.4 11.1-11.1 19.6L6 224.2c2.2 8.5 10.9 13.6 19.3 11.3l79.7-21.7 71.9 42.2-71.9 42.2-79.7-21.7c-8.4-2.3-17 2.8-19.3 11.3l-4.1 15.5c-2.2 8.5 2.7 17.3 11.1 19.6l34.1 9.3-39.2 23c-7.5 4.4-10.1 14.2-5.8 21.9L10 391c4.3 7.7 14 10.3 21.5 5.9l39.2-23-9.1 34.7c-2.2 8.5 2.7 17.3 11.1 19.6l15.2 4.1c8.4 2.3 17-2.8 19.3-11.3l21.3-81 71.9-42.2v84.5l-58.3 59.3c-6.1 6.2-6.1 16.4 0 22.6l11.1 11.3c6.1 6.2 16.1 6.2 22.2 0l24.9-25.4V496c0 8.8 7 16 15.7 16h15.7c8.7 0 15.7-7.2 15.7-16v-46.1l24.9 25.4c6.1 6.2 16.1 6.2 22.2 0l11.1-11.3c6.1-6.2 6.1-16.4 0-22.6l-58.3-59.3v-84.5l71.9 42.2 21.3 81c2.2 8.5 10.9 13.6 19.3 11.3L375 428c8.4-2.3 13.4-11.1 11.1-19.6l-9.1-34.7 39.2 23c7.5 4.4 17.1 1.8 21.5-5.9l7.9-13.9c4.6-7.5 2.1-17.3-5.5-21.7l-39.2-23 34.1-9.3c8.4-2.3 13.4-11.1 11.1-19.6l-4.1-15.5c-2.2-8.5-10.9-13.6-19.3-11.3L343 298.2 271.2 256l71.9-42.2 79.7 21.7c8.4 2.3 17-2.8 19.3-11.3l4.1-15.5c2.2-8.5-2.7-17.3-11.1-19.6l-34.1-9.3 39.2-23c7.4-4.4 10-14.2 5.7-21.9z"
  ]
};
export const faSnowman = {
  prefix: "far",
  iconName: "snowman",
  icon: [
    512,
    512,
    [],
    "f7d0",
    "M256 288c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm0-64c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zM224 88c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm32 264c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm254.9-167.7l-5.9-14.5c-3.3-8-12.6-11.9-20.8-8.7L456 172.6v-29c0-8.6-7.2-15.6-16-15.6h-16c-8.8 0-16 7-16 15.6v46.9c0 .5.3 1 .3 1.5l-26.2 10.7c-3.7-9.2-8.1-18.3-13.7-26.6C376 159.8 380 142 380 124 380 55.6 324.4 0 256 0S132 55.6 132 124c0 18 4 35.8 11.6 52.1-5.7 8.4-10.1 17.4-13.7 26.6L103.7 192c.1-.5.3-1 .3-1.5v-46.9c0-8.6-7.2-15.6-16-15.6H72c-8.8 0-16 7-16 15.6v29l-28.1-11.5c-8.2-3.2-17.5.7-20.8 8.7l-5.9 14.5c-3.3 8 .7 17.1 8.9 20.3l110.1 44.9c0 .8-.2 1.6-.2 2.4 0 7.1.7 14.3 2.1 22-18.2 26.8-27.8 57.9-27.8 90.7 0 55.4 28.2 106.2 75.3 136.1 11.5 7.3 25.7 11.1 41.2 11.1h89.9c17 0 33.4-5.1 47.4-14.9 52.8-36.6 78.5-98.8 67-162.3-3.9-21.3-12.5-42-25.1-60.6 1.4-7.7 2.1-15.1 2.1-22.2 0-.8-.2-1.6-.2-2.4L502 204.5c8.1-3 12.1-12.1 8.9-20.2zM320.7 457.7c-5.9 4.1-12.9 6.3-20.1 6.3h-89.9c-4.4 0-10.7-.6-15.5-3.7-33.2-21-53-56.8-53-95.6 0-25.8 8.4-50.2 24.4-70.4l7.3-9.3-2.9-11.5c-2.1-8.2-3.1-15.1-3.1-21.6 0-26.9 12.1-46.3 22.2-57.8l12-13.7-9.9-15.2c-8.1-12.5-12.3-26.7-12.3-41.3 0-41.9 34.1-76 76-76s76 34.1 76 76c0 14.5-4.3 28.8-12.3 41.3l-9.9 15.2 12 13.7c10.2 11.5 22.2 31 22.2 57.8 0 6.6-1 13.5-3.1 21.7l-2.9 11.5 7.3 9.3c11.6 14.7 19.4 31.6 22.5 48.9 8.2 44.8-9.8 88.6-47 114.4zM288 88c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm-32 40c-8.8 0-16 7.2-16 16s16 32 16 32 16-23.2 16-32-7.2-16-16-16z"
  ]
};
export const faSnowmobile = {
  prefix: "far",
  iconName: "snowmobile",
  icon: [
    640,
    512,
    [],
    "f7d1",
    "M636.8 446.4l-9.6-12.8c-5.3-7.1-15.3-8.5-22.4-3.2L570.7 456c-6.9 5.2-15.3 8-24 8h-.7l-54-72 76.9-51.3c4.5-3 7.1-8 7.1-13.3v-77.5c0-6.1-3.4-11.6-8.8-14.3l-152.7-76.4-41-82c-5.9-11.8-20.3-16.7-32.2-10.7-11.9 5.9-16.7 20.3-10.8 32.2l35 69.9L342 200h-41c-2.1 0-4.1-.8-5.6-2.2l-55-53.4c-12.8-12.7-31.1-18.5-48.6-15.7-17.7 2.9-33.1 14.2-41.1 30.2l-29.8 59.7c-6.7 13.4-7.8 28.6-3 42.8 1.3 3.9 3.5 7.2 5.5 10.6H112c-12.1 0-23.2 6.8-28.6 17.7l-32 64c-.7 1.4-1 2.9-1.5 4.3C20.7 369.9 0 398.5 0 432c0 44.1 35.9 80 80 80h160c44.1 0 80-35.9 80-80 0-11.4-2.5-22.2-6.8-32H438l48 64h-54c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h114.7c19 0 37.6-6.2 52.8-17.6l34.1-25.6c7.1-5.3 8.5-15.3 3.2-22.4zM220 191.6l42 40.7c10.5 10.2 24.3 15.8 39 15.8h5l-18 24h-78.3l-23.9-11.9 34.2-68.6zM240 464H80c-17.7 0-32-14.3-32-32s14.3-32 32-32h160c17.7 0 32 14.3 32 32s-14.3 32-32 32zm225.5-112H105.9l16-32H312l86.4-115.2L528 269.7v40.6L465.5 352zM240 96c26.5 0 48-21.5 48-48S266.5 0 240 0s-48 21.5-48 48 21.5 48 48 48z"
  ]
};
export const faSnowplow = {
  prefix: "far",
  iconName: "snowplow",
  icon: [
    640,
    512,
    [],
    "f7d2",
    "M120 376c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm459.7 41.8c-7.5-7.5-11.7-17.7-11.7-28.3v-139c0-10.6 4.2-20.8 11.7-28.3l55.6-55.6c6.2-6.2 6.2-16.4 0-22.6L624 132.7c-6.2-6.2-16.4-6.2-22.6 0l-55.6 55.6c-16.5 16.5-25.8 38.9-25.8 62.2V296h-88v-58.9c0-8.7-1.8-17.2-5.2-25.2L348.5 29.1C340.9 11.4 323.6 0 304.3 0H160c-26.5 0-48 21.5-48 48v80H96c-26.5 0-48 21.5-48 48v132.3C19 328.5 0 362 0 400c0 61.9 50.1 112 112 112h256c61.9 0 112-50.1 112-112 0-20.5-5.9-39.5-15.5-56H520v45.5c0 23.3 9.3 45.7 25.8 62.2l55.6 55.6c6.2 6.2 16.4 6.2 22.6 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6l-55.6-55.6zM160 48h144.4l65.1 152H220.6L160 112.5V48zM96 176h49.6l42.7 61.7c4.5 6.5 11.8 10.3 19.7 10.3h176v41.6c-5.3-.8-10.5-1.6-16-1.6H112c-5.5 0-10.7.9-16 1.6V176zm272 288H112c-35.3 0-64-28.7-64-64s28.7-64 64-64h256c35.3 0 64 28.7 64 64s-28.7 64-64 64zm-168-88c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm160 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm-80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24z"
  ]
};
export const faSoap = {
  prefix: "far",
  iconName: "soap",
  icon: [
    512,
    512,
    [],
    "e06e",
    "M384,64a32,32,0,1,0-32-32A32,32,0,0,0,384,64ZM208,96a48,48,0,1,0-48-48A48,48,0,0,0,208,96Zm208,96H398.39a80,80,0,1,0-156.78,0H96A96,96,0,0,0,0,288V416a96,96,0,0,0,96,96H416a96,96,0,0,0,96-96V288A96,96,0,0,0,416,192Zm-96-48a32,32,0,1,1-32,32A32,32,0,0,1,320,144ZM464,416a48.05,48.05,0,0,1-48,48H96a48.05,48.05,0,0,1-48-48V288a48.05,48.05,0,0,1,48-48H272.94c13.27,9.77,29.32,16,47.06,16s33.79-6.23,47.06-16H416a48.05,48.05,0,0,1,48,48ZM352,288H160a64,64,0,0,0,0,128H352a64,64,0,0,0,0-128Zm0,96H160a32,32,0,0,1,0-64H352a32,32,0,0,1,0,64Z"
  ]
};
export const faSocks = {
  prefix: "far",
  iconName: "socks",
  icon: [
    512,
    512,
    [],
    "f696",
    "M448 0h-95.83c-11.89 0-22.88 3.44-32.42 9.06C310.34 3.6 299.68 0 288 0h-95.83c-35.32 0-63.96 28.46-64 63.78C128.1 137.27 128 248 128 248l-79.77 59.39c-45.97 34.49-62.82 98.49-34.06 148.25C35.46 492.47 73.2 512 111.49 512c23.38 0 47.57-7.3 67.7-22.41l13.76-10.32c21.47 21.46 50.13 32.72 79.15 32.72 23.38 0 46.97-7.3 67.09-22.41l121.61-91.2a128.006 128.006 0 0 0 51.21-102.4V64C512 28.65 483.35 0 448 0zm-95.83 48H448c8.82 0 16 7.18 16 16v32H336.14l.03-32.17c.01-8.73 7.19-15.83 16-15.83zm-160 0H288c.8 0 1.5.29 2.26.43-1.23 4.94-2.08 10.03-2.08 15.36l-.03 32.22h-112l.03-32.17c0-8.74 7.18-15.84 15.99-15.84zm-80.68 416c-23.2 0-44.04-12.11-55.76-32.38-15.79-27.32-6.43-65.02 21.31-85.83l98.94-73.77.12-128.02h112c-.05 54.65-.1 104-.1 104l-79.16 59.39c-40.9 30.68-58.54 84.68-41.72 131.26l-16.74 12.55c-11.16 8.38-25 12.8-38.89 12.8zM432 360l-121.63 91.21c-11.15 8.37-24.38 12.79-38.28 12.79-23.2 0-44.04-12.11-55.76-32.38-15.79-27.32-6.43-65.02 21.31-85.83l98.34-73.77.12-128.02H464v151.99c0 25.05-11.96 48.98-32 64.01z"
  ]
};
export const faSolarPanel = {
  prefix: "far",
  iconName: "solar-panel",
  icon: [
    640,
    512,
    [],
    "f5ba",
    "M585.24 26.74C582.62 11.31 569.02 0 553.09 0H86.91C70.98 0 57.38 11.31 54.76 26.74l-54.31 320C-2.86 366.24 12.46 384 32.6 384H224v80.24l-31.98.03c-8.82.01-15.97 7.16-15.98 15.98l-.04 15.73c-.01 8.85 7.17 16.03 16.02 16.02l255.94-.26c8.82-.01 15.97-7.16 15.98-15.98l.04-15.72c.01-8.85-7.17-16.03-16.02-16.02l-31.96.03V384h191.4c20.14 0 35.46-17.76 32.14-37.26l-54.3-320zM558.3 160H436.91l-11.2-112h113.58l19.01 112zm-306.99 0l11.2-112h114.97l11.2 112H251.31zm142.18 48l12.8 128H233.71l12.8-128h146.98zM100.71 48h113.58l-11.2 112H81.7l19.01-112zM73.55 208h124.73l-12.8 128H51.83l21.72-128zM368 464.1l-96 .1V384h96v80.1zM454.51 336l-12.8-128h124.73l21.72 128H454.51z"
  ]
};
export const faSolarSystem = {
  prefix: "far",
  iconName: "solar-system",
  icon: [
    512,
    512,
    [],
    "e02f",
    "M391.77844,120.23438c-16.64243-16.64063-42.05926-17.63672-60.76247-4.73047C307.55639,102.98633,281.92079,96,256,96A160,160,0,1,0,369.149,369.13672c51.02312-51.01758,59.65883-127.62891,27.36235-188.14453C409.421,162.291,408.42283,136.877,391.77844,120.23438ZM346.51961,346.50977a128.50726,128.50726,0,1,1-34.23614-204.94141c-4.41455,16.09375-1.03918,33.90625,11.60673,46.54883,12.644,12.64453,30.45839,16.01953,46.55389,11.60547a126.334,126.334,0,0,1-23.92448,146.78711ZM256,176a80,80,0,1,0,80.0087,80A80.08848,80.08848,0,0,0,256,176Zm0,112a32,32,0,1,1,32.00348-32A32.03339,32.03339,0,0,1,256,288Zm80.90528,159.67773a208.24661,208.24661,0,0,1-227.9994-44.59961C39.328,333.50781,29.62381,226.59766,79.41829,146.38672a56.05613,56.05613,0,1,0-37.799-30.34375c-64.97,99.2832-53.88672,233.75781,33.34152,320.97656A255.17414,255.17414,0,0,0,364.422,487.65039c-2.19165-1.80273-4.5376-3.32812-6.58665-5.377A86.91321,86.91321,0,0,1,336.90528,447.67773ZM437.03922,74.98047A255.17108,255.17108,0,0,0,147.58,24.34961c2.19165,1.80273,4.53761,3.32812,6.5847,5.375a86.87534,86.87534,0,0,1,20.93,34.59766,208.24661,208.24661,0,0,1,227.9994,44.59961c69.57593,69.56835,79.28011,176.47851,29.48759,256.68945a56.05819,56.05819,0,1,0,37.799,30.3457C535.3507,296.67383,524.26746,162.19922,437.03922,74.98047Z"
  ]
};
export const faSort = {
  prefix: "far",
  iconName: "sort",
  icon: [
    320,
    512,
    [],
    "f0dc",
    "M272 288H48.1c-42.6 0-64.2 51.7-33.9 81.9l111.9 112c18.7 18.7 49.1 18.7 67.9 0l112-112c30-30.1 8.7-81.9-34-81.9zM160 448L48 336h224L160 448zM48 224h223.9c42.6 0 64.2-51.7 33.9-81.9l-111.9-112c-18.7-18.7-49.1-18.7-67.9 0l-112 112C-16 172.2 5.3 224 48 224zM160 64l112 112H48L160 64z"
  ]
};
export const faSortAlphaDown = {
  prefix: "far",
  iconName: "sort-alpha-down",
  icon: [
    448,
    512,
    [],
    "f15d",
    "M447.17 202.94l-61.05-160A16 16 0 0 0 371 32h-38a15.92 15.92 0 0 0-15.1 10.94l-61.06 160a16 16 0 0 0 15.1 21.06h16.78a15.93 15.93 0 0 0 15.11-10.94L314.35 184h75.3l10.52 29.06A15.93 15.93 0 0 0 415.28 224h16.78a16 16 0 0 0 15.11-21.06zM331.73 136L352 80l20.27 56zM416 288H288a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h77.11L281 422.69a32 32 0 0 0-9 22.31v19a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16h-77.11L423 345.29a32 32 0 0 0 9-22.29v-19a16 16 0 0 0-16-16zm-252 96h-44V48a16 16 0 0 0-16-16H88a16 16 0 0 0-16 16v336H28a12 12 0 0 0-8.73 20.24l68 72a12 12 0 0 0 17.44 0l68-72A12 12 0 0 0 164 384z"
  ]
};
export const faSortAlphaDownAlt = {
  prefix: "far",
  iconName: "sort-alpha-down-alt",
  icon: [
    448,
    512,
    [],
    "f881",
    "M447.17 458.94l-61.09-160A16 16 0 0 0 371 288h-38a16 16 0 0 0-15.12 10.94l-61.09 160A16 16 0 0 0 271.83 480h16.79a16 16 0 0 0 15.12-10.94L314.27 440h75.34l10.53 29.06A16 16 0 0 0 415.25 480h16.8a16 16 0 0 0 15.12-21.06zM331.65 392l20.29-56 20.28 56zM287.9 224H416a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16h-77.18L423 89.29A32 32 0 0 0 432 67V48a16 16 0 0 0-16-16H287.9a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h77.16l-84.14 86.69a32 32 0 0 0-9 22.28v19A16 16 0 0 0 287.9 224zM164.09 384h-44V48a16 16 0 0 0-16-16h-16A16 16 0 0 0 72 48v336H28a12 12 0 0 0-8.73 20.24l68 72a12 12 0 0 0 17.46 0l68-72a12 12 0 0 0-8.64-20.24z"
  ]
};
export const faSortAlphaUp = {
  prefix: "far",
  iconName: "sort-alpha-up",
  icon: [
    448,
    512,
    [],
    "f15e",
    "M447.17 202.94l-61.05-160A16 16 0 0 0 371 32h-38a15.92 15.92 0 0 0-15.1 10.94l-61.06 160a16 16 0 0 0 15.1 21.06h16.78a15.93 15.93 0 0 0 15.11-10.94L314.35 184h75.3l10.52 29.06A15.93 15.93 0 0 0 415.28 224h16.78a16 16 0 0 0 15.11-21.06zM331.73 136L352 80l20.27 56zM416 288H288a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h77.11L281 422.69a32 32 0 0 0-9 22.31v19a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16h-77.11L423 345.29a32 32 0 0 0 9-22.29v-19a16 16 0 0 0-16-16zM28 128h44v336a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16V128h44a12 12 0 0 0 8.73-20.24l-68-72a12 12 0 0 0-17.44 0l-68 72A12 12 0 0 0 28 128z"
  ]
};
export const faSortAlphaUpAlt = {
  prefix: "far",
  iconName: "sort-alpha-up-alt",
  icon: [
    448,
    512,
    [],
    "f882",
    "M288 224h128a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16h-77.11L423 89.29A32 32 0 0 0 432 67V48a16 16 0 0 0-16-16H288a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h77.11L281 166.69a32 32 0 0 0-9 22.31v19a16 16 0 0 0 16 16zm159.17 234.94l-61.05-160A16 16 0 0 0 371 288h-38a15.92 15.92 0 0 0-15.1 10.94l-61.06 160a16 16 0 0 0 15.1 21.06h16.78a15.93 15.93 0 0 0 15.11-10.94L314.35 440h75.3l10.52 29.06A15.93 15.93 0 0 0 415.28 480h16.78a16 16 0 0 0 15.11-21.06zM331.73 392L352 336l20.27 56zm-227-356.24a12 12 0 0 0-17.44 0l-68 72A12 12 0 0 0 28 128h44v336a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16V128h44a12 12 0 0 0 8.73-20.24z"
  ]
};
export const faSortAlt = {
  prefix: "far",
  iconName: "sort-alt",
  icon: [
    384,
    512,
    [],
    "f883",
    "M164 384h-44V48a16 16 0 0 0-16-16H88a16 16 0 0 0-16 16v336H28a12 12 0 0 0-8.73 20.24l68 72a12 12 0 0 0 17.44 0l68-72A12 12 0 0 0 164 384zm200.72-276.24l-68-72a12 12 0 0 0-17.44 0l-68 72A12 12 0 0 0 220 128h44v336a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16V128h44a12 12 0 0 0 8.72-20.24z"
  ]
};
export const faSortAmountDown = {
  prefix: "far",
  iconName: "sort-amount-down",
  icon: [
    512,
    512,
    [],
    "f160",
    "M304 376h-64a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm-140 8h-44V48a16 16 0 0 0-16-16H88a16 16 0 0 0-16 16v336H28a12 12 0 0 0-8.73 20.24l68 72a12 12 0 0 0 17.44 0l68-72A12 12 0 0 0 164 384zm268-200H240a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm64-96H240a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h256a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zM368 280H240a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16z"
  ]
};
export const faSortAmountDownAlt = {
  prefix: "far",
  iconName: "sort-amount-down-alt",
  icon: [
    512,
    512,
    [],
    "f884",
    "M320 120v-16a16 16 0 0 0-16-16h-64a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16zM164 384h-44V48a16 16 0 0 0-16-16H88a16 16 0 0 0-16 16v336H28a12 12 0 0 0-8.73 20.24l68 72a12 12 0 0 0 17 .48l.48-.48 68-72A12 12 0 0 0 164 384zm284-72v-16a16 16 0 0 0-16-16H240a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16zm64 96v-16a16 16 0 0 0-16-16H240a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h256a16 16 0 0 0 16-16zM384 216v-16a16 16 0 0 0-16-16H240a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16z"
  ]
};
export const faSortAmountUp = {
  prefix: "far",
  iconName: "sort-amount-up",
  icon: [
    512,
    512,
    [],
    "f161",
    "M304 376h-64a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zM28 128h44v336a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16V128h44a12 12 0 0 0 8.73-20.24l-68-72a12 12 0 0 0-17.44 0l-68 72A12 12 0 0 0 28 128zm404 56H240a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm64-96H240a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h256a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zM368 280H240a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16z"
  ]
};
export const faSortAmountUpAlt = {
  prefix: "far",
  iconName: "sort-amount-up-alt",
  icon: [
    512,
    512,
    [],
    "f885",
    "M240 328h192a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16H240a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16zm0-192h64a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16h-64a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16zm0 96h128a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16H240a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16zm256 144H240a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h256a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zM28 128h44v336a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16V128h44a12 12 0 0 0 8.73-20.24l-68-72a12 12 0 0 0-17.44 0l-68 72A12 12 0 0 0 28 128z"
  ]
};
export const faSortCircle = {
  prefix: "far",
  iconName: "sort-circle",
  icon: [
    512,
    512,
    [],
    "e030",
    "M350.88,26.94A247.21,247.21,0,0,0,256.1,8C158.8,8,66.49,65.64,26.94,161.12c-52.4,126.51,7.67,271.54,134.18,323.94A247.21,247.21,0,0,0,255.9,504c97.3,0,189.61-57.64,229.16-153.12C537.46,224.37,477.39,79.34,350.88,26.94Zm89.84,305.57A199.74,199.74,0,0,1,179.49,440.72C77.64,398.53,29.09,281.34,71.28,179.49A199.74,199.74,0,0,1,332.51,71.28C434.37,113.47,482.9,230.66,440.72,332.51ZM164.75,224H347.11c16.4,0,24.59-19.85,13-31.41L269,101.41a18.31,18.31,0,0,0-26,0l-91.25,91.18C140.16,204.15,148.35,224,164.75,224Zm182.36,64H164.75c-16.4,0-24.59,19.85-13,31.41L243,410.59a18.31,18.31,0,0,0,26,0l91.18-91.18C371.7,307.85,363.52,288,347.11,288Z"
  ]
};
export const faSortCircleDown = {
  prefix: "far",
  iconName: "sort-circle-down",
  icon: [
    512,
    512,
    [],
    "e031",
    "M350.88,26.94A247.21,247.21,0,0,0,256.1,8C158.8,8,66.49,65.64,26.94,161.12c-52.4,126.51,7.67,271.54,134.18,323.94A247.21,247.21,0,0,0,255.9,504c97.3,0,189.61-57.64,229.16-153.12C537.46,224.37,477.39,79.34,350.88,26.94Zm89.84,305.57A199.74,199.74,0,0,1,179.49,440.72C77.63,398.53,29.1,281.34,71.28,179.49A199.74,199.74,0,0,1,332.51,71.28C434.36,113.47,482.91,230.66,440.72,332.51ZM347.25,288H164.89c-16.4,0-24.59,19.85-13,31.41L243,410.59a18.31,18.31,0,0,0,26,0l91.25-91.18C371.84,307.85,363.65,288,347.25,288ZM269,101.41a18.31,18.31,0,0,0-26,0l-91.18,91.18c-11.56,11.56-3.38,31.41,13,31.41H347.25c16.4,0,24.59-19.85,13-31.41ZM197.7,192,256,133.67,314.41,192Z"
  ]
};
export const faSortCircleUp = {
  prefix: "far",
  iconName: "sort-circle-up",
  icon: [
    512,
    512,
    [],
    "e032",
    "M350.88,26.94A247.21,247.21,0,0,0,256.1,8C158.8,8,66.49,65.64,26.94,161.12c-52.4,126.51,7.67,271.54,134.18,323.94A247.21,247.21,0,0,0,255.9,504c97.3,0,189.61-57.64,229.16-153.12C537.46,224.37,477.39,79.34,350.88,26.94Zm89.84,305.57A199.74,199.74,0,0,1,179.49,440.72C77.64,398.53,29.09,281.34,71.28,179.49A199.74,199.74,0,0,1,332.51,71.28C434.37,113.47,482.9,230.66,440.72,332.51ZM164.75,224H347.11c16.4,0,24.59-19.85,13-31.41L269,101.41a18.31,18.31,0,0,0-26,0l-91.25,91.18C140.16,204.15,148.35,224,164.75,224Zm182.36,64H164.75c-16.4,0-24.59,19.85-13,31.41L243,410.59a18.31,18.31,0,0,0,26,0l91.18-91.18C371.7,307.85,363.52,288,347.11,288ZM256,378.33,197.59,320H314.3Z"
  ]
};
export const faSortDown = {
  prefix: "far",
  iconName: "sort-down",
  icon: [
    320,
    512,
    [],
    "f0dd",
    "M272 288H48.1c-42.6 0-64.2 51.7-33.9 81.9l111.9 112c18.7 18.7 49.1 18.7 67.9 0l112-112c30-30.1 8.7-81.9-34-81.9zM160 448L48 336h224L160 448z"
  ]
};
export const faSortNumericDown = {
  prefix: "far",
  iconName: "sort-numeric-down",
  icon: [
    448,
    512,
    [],
    "f162",
    "M400 176h-24V48a16 16 0 0 0-16-16h-36a16 16 0 0 0-13.57 7.52l-20 32A16 16 0 0 0 304 96h24v80h-24a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm-56 80a72 72 0 0 0 0 144 71.1 71.1 0 0 0 18.84-2.82 59.56 59.56 0 0 1-42.32 34.42A15.84 15.84 0 0 0 308 447.16v16.77a16 16 0 0 0 18.71 15.83A108.19 108.19 0 0 0 416 373.38V328a72.08 72.08 0 0 0-72-72zm0 96a24 24 0 1 1 24-24 24 24 0 0 1-24 24zm-180 32h-44V48a16 16 0 0 0-16-16H88a16 16 0 0 0-16 16v336H28a12 12 0 0 0-8.73 20.24l68 72a12 12 0 0 0 17.44 0l68-72A12 12 0 0 0 164 384z"
  ]
};
export const faSortNumericDownAlt = {
  prefix: "far",
  iconName: "sort-numeric-down-alt",
  icon: [
    448,
    512,
    [],
    "f886",
    "M400 432h-24V304a16 16 0 0 0-16-16h-36a16 16 0 0 0-13.57 7.52l-20 32A16 16 0 0 0 304 352h24v80h-24a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zM344 32a72 72 0 0 0 0 144 71.1 71.1 0 0 0 18.84-2.82 59.56 59.56 0 0 1-42.32 34.42A15.84 15.84 0 0 0 308 223.16v16.77a16 16 0 0 0 18.71 15.83A108.19 108.19 0 0 0 416 149.38V104a72.08 72.08 0 0 0-72-72zm0 96a24 24 0 1 1 24-24 24 24 0 0 1-24 24zM164 384h-44V48a16 16 0 0 0-16-16H88a16 16 0 0 0-16 16v336H28a12 12 0 0 0-8.73 20.24l68 72a12 12 0 0 0 17.44 0l68-72A12 12 0 0 0 164 384z"
  ]
};
export const faSortNumericUp = {
  prefix: "far",
  iconName: "sort-numeric-up",
  icon: [
    448,
    512,
    [],
    "f163",
    "M400 176h-24V48a16 16 0 0 0-16-16h-36a16 16 0 0 0-13.57 7.52l-20 32A16 16 0 0 0 304 96h24v80h-24a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm-56 80a72 72 0 0 0 0 144 71.1 71.1 0 0 0 18.84-2.82 59.56 59.56 0 0 1-42.32 34.42A15.84 15.84 0 0 0 308 447.16v16.77a16 16 0 0 0 18.71 15.83A108.19 108.19 0 0 0 416 373.38V328a72.08 72.08 0 0 0-72-72zm0 96a24 24 0 1 1 24-24 24 24 0 0 1-24 24zM28 128h44v336a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16V128h44a12 12 0 0 0 8.73-20.24l-68-72a12 12 0 0 0-17.44 0l-68 72A12 12 0 0 0 28 128z"
  ]
};
export const faSortNumericUpAlt = {
  prefix: "far",
  iconName: "sort-numeric-up-alt",
  icon: [
    448,
    512,
    [],
    "f887",
    "M400 432h-24V304a16 16 0 0 0-16-16h-36a16 16 0 0 0-13.57 7.52l-20 32A16 16 0 0 0 304 352h24v80h-24a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zM344 32a72 72 0 0 0 0 144 71.1 71.1 0 0 0 18.84-2.82 59.56 59.56 0 0 1-42.32 34.42A15.84 15.84 0 0 0 308 223.16v16.77a16 16 0 0 0 18.71 15.83A108.19 108.19 0 0 0 416 149.38V104a72.08 72.08 0 0 0-72-72zm0 96a24 24 0 1 1 24-24 24 24 0 0 1-24 24zm-316 0h44v336a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16V128h44a12 12 0 0 0 8.73-20.24l-68-72a12 12 0 0 0-17.44 0l-68 72A12 12 0 0 0 28 128z"
  ]
};
export const faSortShapesDown = {
  prefix: "far",
  iconName: "sort-shapes-down",
  icon: [
    448,
    512,
    [],
    "f888",
    "M164 384h-44V48a16 16 0 0 0-16-16H88a16 16 0 0 0-16 16v336H28a12 12 0 0 0-8.73 20.24l68 72a12 12 0 0 0 17.44 0l68-72A12 12 0 0 0 164 384zm280.1-201.14L361 45.71a29.56 29.56 0 0 0-49.9 0l-83.2 137.15c-11.08 18.28 2.77 41.14 24.95 41.14h166.3c22.18 0 36.03-22.86 24.95-41.14zM288.19 176L336 97.14 383.81 176zM408 288H264a24 24 0 0 0-24 24v144a24 24 0 0 0 24 24h144a24 24 0 0 0 24-24V312a24 24 0 0 0-24-24zm-24 144h-96v-96h96z"
  ]
};
export const faSortShapesDownAlt = {
  prefix: "far",
  iconName: "sort-shapes-down-alt",
  icon: [
    448,
    512,
    [],
    "f889",
    "M164 384h-44V48a16 16 0 0 0-16-16H88a16 16 0 0 0-16 16v336H28a12 12 0 0 0-8.73 20.24l68 72a12 12 0 0 0 17.45 0l68-72A12 12 0 0 0 164 384zm100-160h144a24 24 0 0 0 24-24V56a24 24 0 0 0-24-24H264a24 24 0 0 0-24 24v144a24 24 0 0 0 24 24zm24-144h96v96h-96zm156.1 358.86L361 301.71a29.56 29.56 0 0 0-49.9 0l-83.2 137.15c-11.08 18.28 2.77 41.14 24.95 41.14h166.3c22.18 0 36.03-22.86 24.95-41.14zM288.19 432L336 353.14 383.81 432z"
  ]
};
export const faSortShapesUp = {
  prefix: "far",
  iconName: "sort-shapes-up",
  icon: [
    448,
    512,
    [],
    "f88a",
    "M104.72 35.76a12 12 0 0 0-17.45 0l-68 72A12 12 0 0 0 28 128h44v336a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16V128h44a12 12 0 0 0 8.73-20.24zm339.38 147.1L361 45.71a29.56 29.56 0 0 0-49.9 0l-83.2 137.15c-11.08 18.28 2.77 41.14 24.95 41.14h166.3c22.18 0 36.03-22.86 24.95-41.14zM288.19 176L336 97.14 383.81 176zM408 288H264a24 24 0 0 0-24 24v144a24 24 0 0 0 24 24h144a24 24 0 0 0 24-24V312a24 24 0 0 0-24-24zm-24 144h-96v-96h96z"
  ]
};
export const faSortShapesUpAlt = {
  prefix: "far",
  iconName: "sort-shapes-up-alt",
  icon: [
    448,
    512,
    [],
    "f88b",
    "M104.72 35.76a12 12 0 0 0-17.45 0l-68 72A12 12 0 0 0 28 128h44v336a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16V128h44a12 12 0 0 0 8.73-20.24zM264 224h144a24 24 0 0 0 24-24V56a24 24 0 0 0-24-24H264a24 24 0 0 0-24 24v144a24 24 0 0 0 24 24zm24-144h96v96h-96zm156.1 358.86L361 301.71a29.56 29.56 0 0 0-49.9 0l-83.2 137.15c-11.08 18.28 2.77 41.14 24.95 41.14h166.3c22.18 0 36.03-22.86 24.95-41.14zM288.19 432L336 353.14 383.81 432z"
  ]
};
export const faSortSizeDown = {
  prefix: "far",
  iconName: "sort-size-down",
  icon: [
    512,
    512,
    [],
    "f88c",
    "M484 32H251a28 28 0 0 0-28 28v168a28 28 0 0 0 28 28h233a28 28 0 0 0 28-28V60a28 28 0 0 0-28-28zm-20 176H271V80h193zm-35 112H244a20 20 0 0 0-20 20v120a20 20 0 0 0 20 20h185a20 20 0 0 0 20-20V340a20 20 0 0 0-20-20zm-28 112H272v-64h129zm-237-48h-44V48a16 16 0 0 0-16-16H88a16 16 0 0 0-16 16v336H28a12 12 0 0 0-8.73 20.24l68 72a12 12 0 0 0 17.44 0l68-72A12 12 0 0 0 164 384z"
  ]
};
export const faSortSizeDownAlt = {
  prefix: "far",
  iconName: "sort-size-down-alt",
  icon: [
    512,
    512,
    [],
    "f88d",
    "M244 192h184a20 20 0 0 0 20-20V52a20 20 0 0 0-20-20H244a20 20 0 0 0-20 20v120a20 20 0 0 0 20 20zm28-112h128v64H272zm212 176H252a28 28 0 0 0-28 28v168a28 28 0 0 0 28 28h232a28 28 0 0 0 28-28V284a28 28 0 0 0-28-28zm-20 176H272V304h192zm-300-48h-44V48a16 16 0 0 0-16-16H88a16 16 0 0 0-16 16v336H28a12 12 0 0 0-8.73 20.24l68 72a12 12 0 0 0 17.44 0l68-72A12 12 0 0 0 164 384z"
  ]
};
export const faSortSizeUp = {
  prefix: "far",
  iconName: "sort-size-up",
  icon: [
    512,
    512,
    [],
    "f88e",
    "M428 320H244a20 20 0 0 0-20 20v120a20 20 0 0 0 20 20h184a20 20 0 0 0 20-20V340a20 20 0 0 0-20-20zm-28 112H272v-64h128zm84-400H252a28 28 0 0 0-28 28v168a28 28 0 0 0 28 28h232a28 28 0 0 0 28-28V60a28 28 0 0 0-28-28zm-20 176H272V80h192zM104.72 35.76a12 12 0 0 0-17.44 0l-68 72A12 12 0 0 0 28 128h44v336a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16V128h44a12 12 0 0 0 8.73-20.24z"
  ]
};
export const faSortSizeUpAlt = {
  prefix: "far",
  iconName: "sort-size-up-alt",
  icon: [
    512,
    512,
    [],
    "f88f",
    "M484 256H252a28 28 0 0 0-28 28v168a28 28 0 0 0 28 28h232a28 28 0 0 0 28-28V284a28 28 0 0 0-28-28zm-20 176H272V304h192zM244 192h184a20 20 0 0 0 20-20V52a20 20 0 0 0-20-20H244a20 20 0 0 0-20 20v120a20 20 0 0 0 20 20zm28-112h128v64H272zM104.72 35.76a12 12 0 0 0-17.44 0l-68 72A12 12 0 0 0 28 128h44v336a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16V128h44a12 12 0 0 0 8.73-20.24z"
  ]
};
export const faSortUp = {
  prefix: "far",
  iconName: "sort-up",
  icon: [
    320,
    512,
    [],
    "f0de",
    "M48 224h223.9c42.6 0 64.2-51.7 33.9-81.9l-111.9-112c-18.7-18.7-49.1-18.7-67.9 0l-112 112C-16 172.2 5.3 224 48 224zM160 64l112 112H48L160 64z"
  ]
};
export const faSoup = {
  prefix: "far",
  iconName: "soup",
  icon: [
    512,
    512,
    [],
    "f823",
    "M303.06 146.5a16.23 16.23 0 0 0 16 13.5h16.5c9.8 0 17.6-8.5 16.3-18a130.72 130.72 0 0 0-36.6-74.7 94.83 94.83 0 0 1-26.4-53.5A16.11 16.11 0 0 0 272.76 0h-16.4c-9.8 0-17.5 8.5-16.3 18a145.36 145.36 0 0 0 40.6 84.4 81.22 81.22 0 0 1 22.4 44.1zM480 192H32a32 32 0 0 0-32 32c0 94.7 51.56 177.16 128 221.45V480a32 32 0 0 0 32 32h192a32 32 0 0 0 32-32v-34.55C460.44 401.16 512 318.7 512 224a32 32 0 0 0-32-32zM336 417.78V464H176v-46.22C108.46 378.65 55.73 330.7 48.62 240h414.76c-6.97 88.93-57.97 137.57-127.38 177.78zM191.11 146.5a16.23 16.23 0 0 0 16 13.5h16.5c9.8 0 17.6-8.5 16.3-18a130.72 130.72 0 0 0-36.6-74.7 94.83 94.83 0 0 1-26.4-53.5A16.11 16.11 0 0 0 160.81 0h-16.4a16.31 16.31 0 0 0-16.3 18 145.36 145.36 0 0 0 40.6 84.4 81.22 81.22 0 0 1 22.4 44.1z"
  ]
};
export const faSpa = {
  prefix: "far",
  iconName: "spa",
  icon: [
    576,
    512,
    [],
    "f5bb",
    "M568.28 192h-.04c-21.38.1-84.49 3.63-147.75 36.03-26.59-78.31-69.27-146.58-121.73-192.22-2.92-2.54-6.83-3.81-10.74-3.81s-7.82 1.27-10.74 3.81c-52.47 45.64-95.16 113.91-121.78 192.23C92.25 195.63 29.14 192.1 7.75 192h-.04c-4.39 0-7.76 3.41-7.72 7.82.23 27.92 7.14 126.14 88.77 199.3C170.99 479.18 252.43 480 285.87 480h4.48c33.57 0 114.83-.98 196.88-80.88 81.64-73.17 88.54-171.38 88.77-199.3.04-4.41-3.32-7.82-7.72-7.82zM122.26 364.73l-.71-.69-.74-.66c-42.39-37.99-60.22-84.4-67.64-119.21 38.78 6.58 91.94 23.31 134.92 65.21l.73.72.76.68c23.54 21.06 41.22 46.39 54.05 77.43l17.79 43.04c-33.77-2.65-85.61-14.37-139.16-66.52zM288 369.86c-13.05-31.56-33.29-65.23-66.41-94.86-7.93-7.73-16.27-14.26-24.65-20.62 20.08-63.83 51.85-120.74 91.08-162.36 39.22 41.62 70.96 98.54 91.03 162.36-8.37 6.36-16.71 12.89-24.64 20.61-33.12 29.64-53.36 63.31-66.41 94.87zm167.19-6.48l-.74.66-.71.69c-53.64 52.23-105.47 63.91-139.18 66.52l17.8-43.05c12.83-31.04 30.51-56.36 54.05-77.43l.76-.68.73-.72c43.01-41.92 96.2-58.65 134.93-65.22-7.41 34.81-25.25 81.23-67.64 119.23z"
  ]
};
export const faSpaceShuttle = {
  prefix: "far",
  iconName: "space-shuttle",
  icon: [
    640,
    512,
    [],
    "f197",
    "M456 168C248 168 266.989 32 96 32c-44.665 0-66.4 24.39-66.4 64v56C9.056 152 0 162.568 0 176v48c0 12.834 8.412 24 29.6 24v16C9.056 264 0 274.568 0 288v48c0 12.834 8.412 24 29.6 24v56c0 39.602 21.727 64 66.4 64 171.029 0 152-136 360-136 96 0 184-33.5 184-88 0-51-88-88-184-88zM115.417 80C181.277 80 240 144 288 168H144c-13.999-9.503-31.155-16-48-16V80h19.417zm0 352H96v-72c16.845 0 34.001-6.497 48-16h144c-48 24-97.487 88-172.583 88zM456 304H168.786c9.396-29.293 9.843-65.315 0-96H456c39.888 0 76.728 3.778 103.734 16 .09.041.09 63.959 0 64-27.006 12.222-63.846 16-103.734 16zm24.242-11.429a8 8 0 0 1-8-8v-57.143a8 8 0 0 1 8-8c42.384.001 42.303 73.143 0 73.143z"
  ]
};
export const faSpaceStationMoon = {
  prefix: "far",
  iconName: "space-station-moon",
  icon: [
    512,
    512,
    [],
    "e033",
    "M256,8C119.0332,8,8,119.0332,8,256S119.0332,504,256,504,504,392.9668,504,256,392.9668,8,256,8ZM176,112a32,32,0,1,1-32,32A32.03667,32.03667,0,0,1,176,112ZM96.87305,135.3418A78.62147,78.62147,0,0,0,96,144a80.0001,80.0001,0,1,0,97.62891-77.9082A198.97376,198.97376,0,0,1,256,56c110.28125,0,200,89.71875,200,200a199.64027,199.64027,0,0,1-2.77734,31.80078A504.546,504.546,0,0,1,256,328,502.908,502.908,0,0,1,58.7207,287.4375,195.37013,195.37013,0,0,1,96.87305,135.3418ZM256,456c-77.77148,0-145.14844-44.71484-178.21484-109.69727A551.90154,551.90154,0,0,0,256,376a556.10146,556.10146,0,0,0,178.08594-29.43359C400.97266,411.4082,333.666,456,256,456Z"
  ]
};
export const faSpaceStationMoonAlt = {
  prefix: "far",
  iconName: "space-station-moon-alt",
  icon: [
    512,
    512,
    [],
    "e034",
    "M456,208h-3.85156V196.74023a47.99988,47.99988,0,0,0-48-48h-4.47461a47.96923,47.96923,0,0,0,22.8457-40.88867V95.02734A48.00137,48.00137,0,0,0,403,56.38867,249.5078,249.5078,0,0,0,256,8C119.0332,8,8,119.0332,8,256S119.0332,504,256,504a247.17156,247.17156,0,0,0,166.60938-64.332,47.61685,47.61685,0,0,0-25.51954-82.60938c19.71289-5.19921,64.707-19.97265,68.21485-20.91015a47.99912,47.99912,0,0,0,34.877-37.9961A242.4554,242.4554,0,0,0,504,256,47.99987,47.99987,0,0,0,456,208ZM176,112a32,32,0,1,1-32,32A32.03667,32.03667,0,0,1,176,112ZM96.87305,135.3418A78.62147,78.62147,0,0,0,96,144a80.0001,80.0001,0,1,0,97.62891-77.9082A198.91848,198.91848,0,0,1,374.51953,95.02734v12.82422H322.668a7.40649,7.40649,0,0,0-7.4082,7.40821v14.81445a7.40732,7.40732,0,0,0,7.4082,7.40625h22.22265V189.332a7.40733,7.40733,0,0,0,7.40626,7.4082h51.85156v29.62891H381.92578a7.40733,7.40733,0,0,0-7.40625,7.4082V248.5918A7.40733,7.40733,0,0,0,381.92578,256H456a193.097,193.097,0,0,1-2.875,31.50391A502.89283,502.89283,0,0,1,256,328,502.908,502.908,0,0,1,58.7207,287.4375,195.37013,195.37013,0,0,1,96.87305,135.3418Zm262.832,268.80664h30.61914A199.14878,199.14878,0,0,1,256,456c-77.77148,0-145.14844-44.71484-178.21484-109.69727A551.90154,551.90154,0,0,0,256,376c30.45117,0,59.96094-3.20312,88.89062-7.90039V389.332A14.81508,14.81508,0,0,0,359.70508,404.14844Z"
  ]
};
export const faSpade = {
  prefix: "far",
  iconName: "spade",
  icon: [
    512,
    512,
    [],
    "f2f4",
    "M256 48s174.6 167.3 192.2 192c10 14.1 15.9 31.4 15.8 50.1-.3 47.1-39.5 84.8-86.6 84.8h-.8c-38.1-.3-48.9-6-78.4-36.2-1.2-1.3-2.7-1.8-4.2-1.8-3.1 0-6 2.4-6 6V360c0 37.7-2.3 48.8 24.7 82.9 6.8 8.5.7 21.1-10.2 21.1h-93.2c-10.9 0-16.9-12.6-10.2-21.1 27-34 24.7-45.2 24.7-82.9v-17.1c0-3.6-3-6-6-6-1.5 0-3 .6-4.2 1.8-29.2 29.9-40.1 35.8-78.3 36.2h-.8c-47.2 0-86.4-37.8-86.6-85.1-.1-18.7 5.9-36 16-50.1C81.6 215.2 256 48 256 48m0-48c-12 0-23.9 4.5-33.2 13.4-.4.4-44.3 42.5-89.8 87C38.5 193 29.4 205.6 25 211.7c-16.5 22.9-25.1 50-25 78.2.3 73.3 60.6 132.9 134.6 132.9h1.2c7-.1 13.6-.3 20-.8-3.9 7.2-6.3 15.2-7.1 23.5-1 11 1 22.1 5.9 32 4.8 10 12.2 18.4 21.4 24.5 9.9 6.5 21.5 10 33.5 10h93.2c12 0 23.6-3.5 33.5-10 9.2-6.1 16.6-14.5 21.4-24.5 4.8-10 6.8-21 5.9-32-.7-8.3-3.2-16.2-7.1-23.5 6.4.5 13 .8 20 .8h1.2c35.4 0 68.9-13.6 94.3-38.3 25.7-25 40-58.5 40.3-94.1.2-28.2-8.3-55.3-24.7-78.3-4.4-6.1-13.5-18.9-108.2-111.7-45.5-44.6-89.4-86.7-89.9-87.1C279.9 4.4 268 0 256 0z"
  ]
};
export const faSparkles = {
  prefix: "far",
  iconName: "sparkles",
  icon: [
    512,
    512,
    [],
    "f890",
    "M324.42 103.16L384 128l24.84 59.58a8 8 0 0 0 14.32 0L448 128l59.58-24.84a8 8 0 0 0 0-14.32L448 64 423.16 4.42a8 8 0 0 0-14.32 0L384 64l-59.58 24.84a8 8 0 0 0 0 14.32zm183.16 305.68L448 384l-24.84-59.58a8 8 0 0 0-14.32 0L384 384l-59.58 24.84a8 8 0 0 0 0 14.32L384 448l24.84 59.58a8 8 0 0 0 14.32 0L448 448l59.58-24.84a8 8 0 0 0 0-14.32zM384 256a24 24 0 0 0-13.28-21.47l-104.85-52.42-52.4-104.84c-8.13-16.25-34.81-16.25-42.94 0l-52.41 104.84-104.84 52.42a24 24 0 0 0 0 42.94l104.84 52.42 52.41 104.85a24 24 0 0 0 42.94 0l52.4-104.85 104.85-52.42A24 24 0 0 0 384 256zm-146.72 34.53a24 24 0 0 0-10.75 10.74L192 370.33l-34.53-69.06a24 24 0 0 0-10.75-10.74L77.66 256l69.06-34.53a24 24 0 0 0 10.75-10.73L192 141.67l34.53 69.07a24 24 0 0 0 10.75 10.73L306.34 256z"
  ]
};
export const faSpeaker = {
  prefix: "far",
  iconName: "speaker",
  icon: [
    384,
    512,
    [],
    "f8df",
    "M193 176a48 48 0 1 0-48-48 48 48 0 0 0 48 48zm0 256A112 112 0 1 0 81 320a112 112 0 0 0 112 112zm0-176a64 64 0 1 1-64 64 64 64 0 0 1 64-64zM337 0H49A48 48 0 0 0 1 48v416a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V48a48 48 0 0 0-48-48zm0 464H49V48h288z"
  ]
};
export const faSpeakers = {
  prefix: "far",
  iconName: "speakers",
  icon: [
    640,
    512,
    [],
    "f8e0",
    "M448 176a48 48 0 1 0-48-48 48 48 0 0 0 48 48zm0 256a112 112 0 1 0-112-112 112 112 0 0 0 112 112zm0-176a64 64 0 1 1-64 64 64 64 0 0 1 64-64zM592 0H304a48 48 0 0 0-48 48v416a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V48a48 48 0 0 0-48-48zm0 464H304V48h288zM224 92.46a48 48 0 1 0 0 71.08zM192 256a63.33 63.33 0 0 1 32 8.88V213.2c-10.2-3.06-20.8-5.2-32-5.2a112 112 0 0 0 0 224c11.2 0 21.8-2.14 32-5.2v-51.68a63.33 63.33 0 0 1-32 8.88 64 64 0 0 1 0-128zM240.41 0H48A48 48 0 0 0 0 48v416a48 48 0 0 0 48 48h192.41A79.24 79.24 0 0 1 224 464H48V48h176a79.24 79.24 0 0 1 16.41-48z"
  ]
};
export const faSpellCheck = {
  prefix: "far",
  iconName: "spell-check",
  icon: [
    576,
    512,
    [],
    "f891",
    "M572.48 279.8l-28.28-28.28a12 12 0 0 0-17 0l-175.18 175-79.28-80.66a12 12 0 0 0-17 0l-28.28 28.28a12 12 0 0 0 0 17l116 117.42a12 12 0 0 0 17 0l212-211.71a12 12 0 0 0 .02-17.05zM145.3 11a16 16 0 0 0-15.18-11H90.4a16 16 0 0 0-15.19 11L.83 235A16 16 0 0 0 16 256h16.87a16 16 0 0 0 15.19-11l12.3-37h103.28l12.3 37a16 16 0 0 0 15.18 11H208a16 16 0 0 0 15.18-21zm-69 149L112 58.84 145.59 160zM280 256h92a76 76 0 0 0 46.16-136.33A76 76 0 0 0 356 0h-76a24 24 0 0 0-24 24v208a24 24 0 0 0 24 24zm24-208h52a28 28 0 0 1 0 56h-52zm0 104h68a28 28 0 0 1 0 56h-68z"
  ]
};
export const faSpider = {
  prefix: "far",
  iconName: "spider",
  icon: [
    576,
    512,
    [],
    "f717",
    "M151.17 167.35l30.6 8.65 5.22-26.12c.72-3.58 1.8-7.58 3.21-11.79l-20.29-40.58 23.8-71.39c2.79-8.38-1.73-17.44-10.12-20.24L168.42.82c-8.38-2.8-17.45 1.73-20.24 10.12l-25.89 77.68a32.04 32.04 0 0 0 1.73 24.43l27.15 54.3zm254.92-69.84l-20.29 40.58c1.41 4.21 2.49 8.21 3.21 11.79l5.22 26.12 30.6-8.65 27.15-54.3a31.992 31.992 0 0 0 1.73-24.43l-25.89-77.68C425.03 2.56 415.96-1.98 407.58.82l-15.17 5.06c-8.38 2.8-12.91 11.86-10.12 20.24l23.8 71.39zm167.22 251.87l-52.75-79.12a32.002 32.002 0 0 0-26.62-14.25H416l68.99-24.36a32.03 32.03 0 0 0 16.51-12.61l53.6-80.41c4.9-7.35 2.91-17.29-4.44-22.19l-13.31-8.88c-7.35-4.9-17.29-2.91-22.19 4.44l-50.56 75.83L404.1 208H368l-10.37-51.85C355.44 145.18 340.26 96 288 96c-52.26 0-67.44 49.18-69.63 60.15L208 208h-36.1l-60.49-20.17L60.84 112c-4.9-7.35-14.83-9.34-22.19-4.44l-13.31 8.88c-7.35 4.9-9.34 14.83-4.44 22.19l53.6 80.41a32.03 32.03 0 0 0 16.51 12.61L160 256H82.06c-10.7 0-20.69 5.35-26.62 14.25L2.69 349.38c-4.9 7.35-2.92 17.29 4.44 22.19l13.31 8.88c7.35 4.9 17.29 2.91 22.19-4.44l48-72h47.06l-60.83 97.33A31.988 31.988 0 0 0 72 418.3V496c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-73.11l74.08-118.53c-1.01 14.05-2.08 28.11-2.08 42.21C192 399.64 232.76 448 288 448s96-48.36 96-101.43c0-14.1-1.08-28.16-2.08-42.21L456 422.89V496c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-77.71c0-6-1.69-11.87-4.86-16.96L438.31 304h47.06l48 72c4.9 7.35 14.84 9.34 22.19 4.44l13.31-8.88c7.36-4.9 9.34-14.83 4.44-22.18zM288 400c-28.71 0-48-27.63-48-53.43 0-35.71 3.55-71.57 10.55-106.59l14.86-74.29C266.55 160.6 271.53 144 288 144c16.46 0 21.45 16.61 22.56 21.56l14.88 74.42c7 35.02 10.55 70.87 10.55 106.58C336 372.37 316.71 400 288 400z"
  ]
};
export const faSpiderBlackWidow = {
  prefix: "far",
  iconName: "spider-black-widow",
  icon: [
    576,
    512,
    [],
    "f718",
    "M313.59 288h-51.18c-5.27 0-8.28 5.02-5.12 8.53L278.4 320l-21.11 23.46c-3.16 3.52-.15 8.54 5.12 8.54h51.18c5.27 0 8.28-5.02 5.12-8.54L297.6 320l21.11-23.47c3.16-3.51.15-8.53-5.12-8.53zM151.17 167.35l30.6 8.65 5.22-26.12c.72-3.58 1.8-7.58 3.21-11.79l-20.29-40.58 23.8-71.39c2.79-8.38-1.73-17.44-10.12-20.24L168.42.82c-8.38-2.8-17.45 1.73-20.24 10.12l-25.89 77.68a32.04 32.04 0 0 0 1.73 24.43l27.15 54.3zm254.92-69.84l-20.29 40.58c1.41 4.21 2.49 8.21 3.21 11.79l5.22 26.12 30.6-8.65 27.15-54.3a31.992 31.992 0 0 0 1.73-24.43l-25.89-77.68C425.03 2.56 415.96-1.98 407.58.82l-15.17 5.06c-8.38 2.8-12.91 11.86-10.12 20.24l23.8 71.39zm167.22 251.87l-52.75-79.12a32.002 32.002 0 0 0-26.62-14.25H416l68.99-24.36a32.03 32.03 0 0 0 16.51-12.61l53.6-80.41c4.9-7.35 2.91-17.29-4.44-22.19l-13.31-8.88c-7.35-4.9-17.29-2.91-22.19 4.44l-50.56 75.83L404.1 208H368l-10.37-51.85C355.44 145.18 340.26 96 288 96c-52.26 0-67.44 49.18-69.63 60.15L208 208h-36.1l-60.49-20.17L60.84 112c-4.9-7.35-14.83-9.34-22.19-4.44l-13.31 8.88c-7.35 4.9-9.34 14.83-4.44 22.19l53.6 80.41a32.03 32.03 0 0 0 16.51 12.61L160 256H82.06c-10.7 0-20.69 5.35-26.62 14.25L2.69 349.38c-4.9 7.35-2.92 17.29 4.44 22.19l13.31 8.88c7.35 4.9 17.29 2.91 22.19-4.44l48-72h47.06l-60.83 97.33A31.988 31.988 0 0 0 72 418.3V496c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-73.11l74.08-118.53c-1.01 14.05-2.08 28.11-2.08 42.21C192 399.64 232.76 448 288 448s96-48.36 96-101.43c0-14.1-1.08-28.16-2.08-42.21L456 422.89V496c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-77.71c0-6-1.69-11.87-4.86-16.96L438.31 304h47.06l48 72c4.9 7.35 14.84 9.34 22.19 4.44l13.31-8.88c7.36-4.9 9.34-14.83 4.44-22.18zM288 400c-28.71 0-48-27.63-48-53.43 0-35.71 3.55-71.57 10.55-106.59l14.86-74.29C266.55 160.6 271.53 144 288 144c16.46 0 21.45 16.61 22.56 21.56l14.88 74.42c7 35.02 10.55 70.87 10.55 106.58C336 372.37 316.71 400 288 400z"
  ]
};
export const faSpiderWeb = {
  prefix: "far",
  iconName: "spider-web",
  icon: [
    576,
    512,
    [],
    "f719",
    "M569.41 239.5c-59-62.2-102.69-138.98-126.32-222.03C439.56 5.02 426.9-2.47 414.15.75c-82.56 20.72-169.75 20.72-252.32 0-12.81-3.17-25.38 4.27-28.94 16.72-23.61 83.05-67.3 159.83-126.3 222.03-8.78 9.27-8.78 23.76 0 33.03 59 62.2 102.69 138.98 126.32 222.03 3.53 12.44 16.06 19.83 28.94 16.72 82.56-20.72 169.75-20.72 252.32 0 1.97.48 3.94.72 5.84.72 10.5 0 20.09-6.91 23.09-17.44 23.63-83.06 67.31-159.83 126.32-222.03 8.78-9.27 8.78-23.77-.01-33.03zm-68.84-7.48h-45.99c-27.73-31.88-48.83-69.55-61.87-110.25l22.49-39.2c20.99 53.84 49.78 104.23 85.37 149.45zm-254 0h-64.04a362.548 362.548 0 0 0 31.78-56.22l32.26 56.22zm7.54-83.27c22.54 2.27 45.25 2.27 67.79 0L288 207.81l-33.89-59.06zm-7.54 131.26l-32.25 56.2a362.814 362.814 0 0 0-31.8-56.2h64.05zM288 304.22l33.9 59.07c-11.27-1.13-22.58-1.83-33.9-1.83s-22.63.69-33.9 1.83l33.9-59.07zm41.43-24.21h64.05a365.399 365.399 0 0 0-31.8 56.2l-32.25-56.2zm0-47.99l32.26-56.22a363.01 363.01 0 0 0 31.78 56.22h-64.04zM374.6 56.9l-21.79 37.97a289.7 289.7 0 0 1-129.62 0L201.4 56.9a568.257 568.257 0 0 0 173.2 0zM160.81 82.57l22.49 39.2c-13.04 40.7-34.15 78.37-61.87 110.25h-46c35.59-45.22 64.38-95.61 85.38-149.45zM75.43 280.01h45.98c27.73 31.85 48.84 69.53 61.89 110.24l-22.49 39.2c-21-53.83-49.79-104.22-85.38-149.44zM201.4 455.12l21.79-37.97a289.7 289.7 0 0 1 129.62 0l21.79 37.97c-28.69-4.43-57.59-7.39-86.6-7.39s-57.91 2.97-86.6 7.39zm213.79-25.67l-22.49-39.2c13.05-40.72 34.15-78.39 61.89-110.24h45.98c-35.59 45.22-64.38 95.61-85.38 149.44z"
  ]
};
export const faSpinner = {
  prefix: "far",
  iconName: "spinner",
  icon: [
    512,
    512,
    [],
    "f110",
    "M296 48c0 22.091-17.909 40-40 40s-40-17.909-40-40 17.909-40 40-40 40 17.909 40 40zm-40 376c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zm248-168c0-22.091-17.909-40-40-40s-40 17.909-40 40 17.909 40 40 40 40-17.909 40-40zm-416 0c0-22.091-17.909-40-40-40S8 233.909 8 256s17.909 40 40 40 40-17.909 40-40zm20.922-187.078c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40c0-22.092-17.909-40-40-40zm294.156 294.156c-22.091 0-40 17.909-40 40s17.909 40 40 40c22.092 0 40-17.909 40-40s-17.908-40-40-40zm-294.156 0c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40z"
  ]
};
export const faSpinnerThird = {
  prefix: "far",
  iconName: "spinner-third",
  icon: [
    512,
    512,
    [],
    "f3f4",
    "M460.116 373.846l-20.823-12.022c-5.541-3.199-7.54-10.159-4.663-15.874 30.137-59.886 28.343-131.652-5.386-189.946-33.641-58.394-94.896-95.833-161.827-99.676C261.028 55.961 256 50.751 256 44.352V20.309c0-6.904 5.808-12.337 12.703-11.982 83.556 4.306 160.163 50.864 202.11 123.677 42.063 72.696 44.079 162.316 6.031 236.832-3.14 6.148-10.75 8.461-16.728 5.01z"
  ]
};
export const faSplotch = {
  prefix: "far",
  iconName: "splotch",
  icon: [
    512,
    512,
    [],
    "f5bc",
    "M459.67 179.63l-60.75-20.49c-9.69-3.28-17-10.05-19.03-17.7l-14.5-53.97c-6.84-25.44-27.69-45.05-55.75-52.42-30.87-8.06-63.09.17-84.22 21.66l-41.81 42.55c-7 7.16-18.62 11.02-30.16 10.14l-65.15-5.02c-33.56-2.42-65.03 13.2-79.9 40.21-12.87 23.38-10.87 50.32 5.34 72.05l34.9 46.78c4.62 6.19 5.34 13.16 2.03 19.67l-25.75 50.88c-11.84 23.36-9.25 49.85 6.97 70.85 19.25 24.99 53 36.47 86.09 29.38l63.4-13.64c11.34-2.5 23.78-.05 32.37 6.28L263 463.28c14.87 11.03 33.28 16.72 51.87 16.72 12.69 0 25.44-2.64 37.25-8.03 25.41-11.59 41.75-33.77 43.75-59.35l4.25-55.24c.56-7.44 6.03-14.47 14.66-18.8l56.19-28.35c27.22-13.74 42.87-39.63 40.87-67.55-2.04-28.72-22.04-52.9-52.17-63.05zm-10.34 87.75l-56.19 28.35c-23.75 11.98-39.03 33.66-40.9 57.97l-4.25 55.24c-.87 11.38-11.34 17.33-15.81 19.36-10.19 4.63-27 6.5-40.62-3.58l-49.22-36.45c-14.66-10.86-33.19-16.67-52.03-16.67-6.34 0-12.75.67-19.03 2.02l-63.4 13.64c-17 3.75-31.4-3.23-37.97-11.75-4.87-6.33-5.62-13.02-2.16-19.84L93.5 304.8c11.47-22.58 9.03-49.44-6.37-70.1l-34.9-46.78c-4.94-6.59-5.53-13.39-1.78-20.19 4.44-8.02 16.03-16.75 34.19-15.52l65.15 5.02c25.25 2.08 51.12-7.09 68.09-24.35l41.81-42.56c8.87-9.05 23.69-12.53 37.75-8.86 11.22 2.95 19.28 9.84 21.59 18.47l14.5 53.94c6.25 23.31 24.97 42.27 50.09 50.74l60.75 20.49c11.62 3.92 18.94 11.78 19.59 21 .62 8.53-4.72 16.29-14.63 21.28z"
  ]
};
export const faSprayCan = {
  prefix: "far",
  iconName: "spray-can",
  icon: [
    512,
    512,
    [],
    "f5bd",
    "M480 128c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm0 96c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm0-128c17.67 0 32-14.33 32-32s-14.33-32-32-32-32 14.33-32 32 14.33 32 32 32zm-96 32c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm0-96c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm-96 0c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm-64 96V32c0-17.67-14.33-32-32-32h-64c-17.67 0-32 14.33-32 32v96c-53.02 0-96 42.98-96 96v256c0 17.67 14.33 32 32 32h256c17.67 0 32-14.33 32-32V224c0-53.02-42.98-96-96-96zm-80-80h32v80h-32V48zm128 416H48V224c0-26.47 21.53-48 48-48h128c26.47 0 48 21.53 48 48v240zM160 256c-35.35 0-64 28.65-64 64s28.65 64 64 64 64-28.65 64-64-28.65-64-64-64z"
  ]
};
export const faSprinkler = {
  prefix: "far",
  iconName: "sprinkler",
  icon: [
    512,
    512,
    [],
    "e035",
    "M24,104a24,24,0,1,0,24,24A24,24,0,0,0,24,104Zm0,104a24,24,0,1,0,24,24A24,24,0,0,0,24,208ZM88,96A24,24,0,1,0,64,72,24,24,0,0,0,88,96ZM488,48a24,24,0,1,0-24-24A24,24,0,0,0,488,48ZM360,152a24,24,0,1,0-24-24A24,24,0,0,0,360,152Zm-208,0a24,24,0,1,0-24-24A24,24,0,0,0,152,152Zm336,56a24,24,0,1,0,24,24A24,24,0,0,0,488,208ZM424,64a24,24,0,1,0,24,24A24,24,0,0,0,424,64Zm64,40a24,24,0,1,0,24,24A24,24,0,0,0,488,104ZM24,0A24,24,0,1,0,48,24,24,24,0,0,0,24,0ZM424,160a24,24,0,1,0,24,24A24,24,0,0,0,424,160Zm-25.81,96H288V80a16,16,0,0,0-16-16H240a16,16,0,0,0-16,16V256H113.81a17.77,17.77,0,0,0-14.22,28.44l67.52,78.23L192,387.56V496a16,16,0,0,0,16,16h96a16,16,0,0,0,16-16V387.56l24.89-24.89,67.52-78.23A17.77,17.77,0,0,0,398.19,256ZM272,367.68V464H240V367.68L179.88,304H332.12ZM112,168a24,24,0,1,0-24,24A24,24,0,0,0,112,168Z"
  ]
};
export const faSquare = {
  prefix: "far",
  iconName: "square",
  icon: [
    448,
    512,
    [],
    "f0c8",
    "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-6 400H54c-3.3 0-6-2.7-6-6V86c0-3.3 2.7-6 6-6h340c3.3 0 6 2.7 6 6v340c0 3.3-2.7 6-6 6z"
  ]
};
export const faSquareFull = {
  prefix: "far",
  iconName: "square-full",
  icon: [512, 512, [], "f45c", "M0 0v512h512V0H0zm464 464H48V48h416v416z"]
};
export const faSquareRoot = {
  prefix: "far",
  iconName: "square-root",
  icon: [
    512,
    512,
    [],
    "f697",
    "M174.06 480c-17.84 0-33.88-9.92-41.81-25.89L49.19 288H16c-8.84 0-16-7.16-16-16v-16c0-8.84 7.16-16 16-16h38.12c15.16 0 29.03 8.57 35.81 22.13l75.65 151.33c3.31 6.63 13.08 5.58 14.91-1.6l97.19-349.24C282.09 44.58 298.09 32 316.59 32H496c8.84 0 16 7.16 16 16v16c0 8.84-7.16 16-16 16H322.88L219.56 444.2c-5.09 21.08-23.81 35.8-45.5 35.8z"
  ]
};
export const faSquareRootAlt = {
  prefix: "far",
  iconName: "square-root-alt",
  icon: [
    512,
    512,
    [],
    "f698",
    "M507.45 239.54l-10.99-10.99c-6.07-6.07-15.91-6.07-21.98 0L432 271.03l-42.47-42.47c-6.07-6.07-15.91-6.07-21.98 0l-10.99 10.99c-6.07 6.07-6.07 15.91 0 21.98L399.03 304l-42.47 42.47c-6.07 6.07-6.07 15.91 0 21.98l10.99 10.99c6.07 6.07 15.91 6.07 21.98 0L432 336.97l42.47 42.47c6.07 6.07 15.91 6.07 21.98 0l10.99-10.99c6.07-6.07 6.07-15.91 0-21.98L464.97 304l42.47-42.47c6.08-6.07 6.08-15.92.01-21.99zM496 32H316.59c-18.5 0-34.5 12.58-38.91 30.62l-97.2 349.24c-1.83 7.18-11.59 8.23-14.91 1.6L89.93 262.13A40.034 40.034 0 0 0 54.12 240H16c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h33.19l83.06 166.11c7.94 15.97 23.97 25.89 41.81 25.89 21.69 0 40.41-14.72 45.5-35.8L322.88 80H496c8.84 0 16-7.16 16-16V48c0-8.84-7.16-16-16-16z"
  ]
};
export const faSquirrel = {
  prefix: "far",
  iconName: "squirrel",
  icon: [
    512,
    512,
    [],
    "f71a",
    "M480 256c17.67 0 32-14.33 32-32v-32c0-58.44-37.09-105.88-88-117.34V48c0-13.25-10.75-24-24-24-55.42 0-88.73 42.76-106.56 73.23C265.04 42.96 206.07 0 147.72 0 66.28 0 0 66.27 0 147.73c0 69.03 47.59 127.16 111.69 143.3l-8.81 18.3c-18.64 48.91-11.55 100.12 22.63 142.81 31.38 39.2 80.54 59.86 130.75 59.86H496c8.22 0 15.57-6.22 15.96-14.43.88-18.39-13.77-33.57-31.96-33.57h-29.85c12.72-18.38 21.85-40.48 21.85-64 0-51.33-30.06-89.67-75.84-100.75l7.88-43.25H480zm-126.7 88c20.5 0 40.83 7.13 55.31 21.63 41.83 41.89-13.4 93.04-26.97 98.37h-139.2c-56.03 0-101.62-45.59-101.62-101.64 0-11.78 2.34-23.88 6.12-34.05l39.03-80.84h-34.78c-50.68 0-95.9-36.34-102.34-86.62C41.05 100.03 88.4 48 147.72 48c54.91 0 115.22 60.3 115.22 115.2h.44l-54.33 130.68c-3.39 8.16.47 17.52 8.63 20.92l14.76 6.14c8.16 3.4 17.53-.47 20.92-8.63l72.11-173.58c16-31.98 32.44-51.95 50.53-61.02V120h24c35.88 0 64 31.62 64 72v16H363.97l-24.72 136h14.05zM400 176c8.84 0 16-7.16 16-16s-7.16-16-16-16-16 7.16-16 16 7.16 16 16 16z"
  ]
};
export const faStaff = {
  prefix: "far",
  iconName: "staff",
  icon: [
    512,
    512,
    [],
    "f71b",
    "M448 0h-76.23a64 64 0 0 0-57.24 35.38l-16 32c-3.95 7.9-.75 17.51 7.15 21.46l28.63 14.31c7.9 3.95 17.51.75 21.47-7.15l16-32H448v103.86l-168.92 48.28a159.974 159.974 0 0 0-69.15 40.69L146.75 320H112c-8.84 0-16 7.16-16 16v34.75L4.69 462.06c-6.25 6.25-6.25 16.38 0 22.63l22.62 22.62c6.25 6.25 16.38 6.25 22.63 0L255.15 302.1a96.027 96.027 0 0 1 41.54-24.44l70.31-20.1 35.14 20.29c7.65 4.42 17.44 1.8 21.86-5.86l21.24-36.79 20.35-5.82c27.47-7.85 46.41-32.96 46.41-61.53V64c0-35.35-28.65-64-64-64z"
  ]
};
export const faStamp = {
  prefix: "far",
  iconName: "stamp",
  icon: [
    512,
    512,
    [],
    "f5bf",
    "M416 256h-66.56c-16.26 0-29.44-13.18-29.44-29.44v-9.46c0-27.37 8.88-53.42 21.46-77.73 9.11-17.61 12.9-38.38 9.05-60.42-6.77-38.78-38.47-70.7-77.26-77.45C267.41.49 261.65 0 256 0c-53.02 0-96 42.98-96 96 0 14.16 3.12 27.54 8.68 39.57C182.02 164.43 192 194.71 192 226.5v.06c0 16.26-13.18 29.44-29.44 29.44H96c-53.02 0-96 42.98-96 96v48c0 8.84 7.16 16 16 16h16v64c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-64h16c8.84 0 16-7.16 16-16v-48c0-53.02-42.98-96-96-96zM48 352c0-26.47 21.53-48 48-48h66.56c42.7 0 77.44-34.74 77.44-77.5 0-34.82-8.82-70.11-27.74-111.06-2.83-6.12-4.26-12.66-4.26-19.44 0-26.47 21.53-48 48-48 2.96 0 6 .27 9.02.79 18.82 3.28 34.89 19.43 38.2 38.42 1.87 10.71.39 20.85-4.4 30.11C280.78 152.21 272 184.85 272 217.1v9.46c0 42.7 34.74 77.44 77.44 77.44H416c26.47 0 48 21.53 48 48v16H48v-16zm384 112H80v-48h352v48z"
  ]
};
export const faStar = {
  prefix: "far",
  iconName: "star",
  icon: [
    576,
    512,
    [],
    "f005",
    "M528.1 171.5L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6zM388.6 312.3l23.7 138.4L288 385.4l-124.3 65.3 23.7-138.4-100.6-98 139-20.2 62.2-126 62.2 126 139 20.2-100.6 98z"
  ]
};
export const faStarAndCrescent = {
  prefix: "far",
  iconName: "star-and-crescent",
  icon: [
    512,
    512,
    [],
    "f699",
    "M340.47 466.36c-1.45 0-6.89.46-9.18.46-116.25 0-210.82-94.57-210.82-210.82S215.04 45.18 331.29 45.18c2.32 0 7.7.46 9.18.46 7.13 0 13.33-5.03 14.75-12.07 1.46-7.25-2.55-14.49-9.47-17.09C316.58 5.54 286.39 0 256 0 114.84 0 0 114.84 0 256s114.84 256 256 256c30.23 0 60.28-5.49 89.32-16.32 5.96-2.02 10.28-7.64 10.28-14.26 0-8.09-6.39-15.06-15.13-15.06zM48 256c0-70.16 34.92-132.33 88.3-170.02-39.73 45.51-63.83 105-63.83 170.02 0 65.02 24.1 124.51 63.83 170.02C82.93 388.33 48 326.16 48 256zm455.46-42.14l-76.38-11.1-34.16-69.21c-1.83-3.7-5.38-5.55-8.93-5.55s-7.1 1.85-8.93 5.55l-34.16 69.21-76.38 11.1c-8.17 1.18-11.43 11.22-5.52 16.99l55.27 53.87-13.05 76.07c-1.11 6.44 4.01 11.66 9.81 11.66 1.53 0 3.11-.36 4.64-1.17L384 335.37l68.31 35.91c1.53.8 3.11 1.17 4.64 1.17 5.8 0 10.92-5.23 9.81-11.66l-13.05-76.07 55.27-53.87c5.91-5.77 2.65-15.81-5.52-16.99zm-83.25 36.48l-18.07 17.61 4.27 24.87.02.1-.09-.05L384 281.14l-22.34 11.74-.09.04.02-.1 4.27-24.87-18.07-17.61-.07-.07.1-.01 24.97-3.63L383.96 224l.04-.09.04.09 11.17 22.63 24.97 3.63.1.01-.07.07z"
  ]
};
export const faStarChristmas = {
  prefix: "far",
  iconName: "star-christmas",
  icon: [
    512,
    512,
    [],
    "f7d4",
    "M487.7 224.9l-121.8-30.5 60.7-75.4c7.8-9.8 7.1-23.2-1.7-32-8.8-8.8-22.2-9.4-32-1.7l-75.5 60.4-30.3-121.4C283.5 10 270.7 0 256 0h-.1c-14.8 0-27.5 10-31 24.3l-30.5 121.9L119 85.5c-9.8-7.8-23.2-7.1-32 1.7-8.8 8.8-9.5 22.2-1.7 32l60.4 75.5-121.4 30.2C10 228.5 0 241.3 0 256c0 14.7 10 27.5 24.3 31.1l121.8 30.5L85.4 393c-7.8 9.8-7.1 23.2 1.7 32 4.7 4.7 10.8 7.1 16.8 7.1 5.3 0 10.6-1.8 15.1-5.4l75.5-60.4 30.4 121.5c3.5 14.3 16.3 24.3 31 24.3h.1c14.7 0 27.5-10 31.1-24.3L317.6 366l75.4 60.7c4.5 3.6 9.8 5.4 15.1 5.4 6.1 0 12.1-2.4 16.8-7.1 8.8-8.8 9.5-22.2 1.7-32l-60.4-75.5 121.5-30.4C502 283.5 512 270.7 512 256c0-14.7-10-27.5-24.3-31.1zm-200.1 62.7L256 414.1l-31.6-126.5L97.9 256l126.5-31.6L256 97.9l31.6 126.5L414.1 256l-126.5 31.6z"
  ]
};
export const faStarExclamation = {
  prefix: "far",
  iconName: "star-exclamation",
  icon: [
    576,
    512,
    [],
    "f2f3",
    "M252.5 184.6c-.4-4.6 3.3-8.6 8-8.6h55.1c4.7 0 8.3 4 8 8.6l-6.8 88c-.3 4.2-3.8 7.4-8 7.4h-41.5c-4.2 0-7.7-3.2-8-7.4l-6.8-88zM288 296c-22.1 0-40 17.9-40 40s17.9 40 40 40 40-17.9 40-40-17.9-40-40-40zm257.9-70L440.1 329l25 145.5c4.5 26.2-23.1 46-46.4 33.7L288 439.6l-130.7 68.7c-23.4 12.3-50.9-7.6-46.4-33.7l25-145.5L30.1 226c-19-18.5-8.5-50.8 17.7-54.6L194 150.2l65.3-132.4c11.8-23.8 45.7-23.7 57.4 0L382 150.2l146.1 21.2c26.2 3.8 36.7 36.1 17.8 54.6zm-56.8-11.7l-139-20.2-62.1-126L225.8 194l-139 20.2 100.6 98-23.7 138.4L288 385.3l124.3 65.4-23.7-138.4 100.5-98z"
  ]
};
export const faStarHalf = {
  prefix: "far",
  iconName: "star-half",
  icon: [
    576,
    512,
    [],
    "f089",
    "M288 385.3l-124.3 65.4 23.7-138.4-100.6-98 139-20.2 62.2-126V0c-11.4 0-22.8 5.9-28.7 17.8L194 150.2 47.9 171.4c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.1 23 46 46.4 33.7L288 439.6v-54.3z"
  ]
};
export const faStarHalfAlt = {
  prefix: "far",
  iconName: "star-half-alt",
  icon: [
    536,
    512,
    [],
    "f5c0",
    "M390.6 439.61l-7.94 5.88-22.39 42.5 38.67 20.28c4.7 2.45 9.68 3.7 14.83 3.7 9.41 0 18.68-4.38 24.74-11.59 4.84-5.75 7.41-12.73 7.41-20.2l-7.91-48.69-47.41 8.12zM278.98 391.6c-6.77-3.54-14.92-4.21-22.18-.4l-113.32 59.44 23.83-138.31-100.8-98.02 139.28-20.28 62.2-125.88 10.02 20.29 43.15-21.22-24.41-49.41C291.29 6.83 280.24 0 267.92 0c-12.46 0-23.19 6.67-28.68 17.81l-65.41 132.38-146.4 21.3c-12.21 1.8-22.11 10.19-25.8 21.73-3.84 11.69-.74 24.28 8.09 32.86l105.9 103-25.05 145.5c-1.61 9.45.86 18.64 6.94 25.83 6.12 7.27 15.34 11.59 24.69 11.59 5.2 0 10.25-1.3 14.86-3.75l130.95-68.68 45.58 23.91 22.39-42.5-56.77-29.78-.23.4zm51.23-197.57l75.95 11.06 6.95-47.5-50.96-7.41-22.77-46.09-43.15 21.22 33.98 68.72zm204.22-.62c-3.76-11.73-13.67-20.12-25.89-21.92l-43.32-6.31-6.95 47.5 3.21 9.42 33.57 34.38L526.38 226c6.22-6.09 9.63-14.14 9.63-22.66l-1.58-9.93zM368.68 312.33l13.01 75.52 47.41-8.12-8.72-50.64 36.86-35.86-33.57-34.38-54.99 53.48z"
  ]
};
export const faStarOfDavid = {
  prefix: "far",
  iconName: "star-of-david",
  icon: [
    464,
    512,
    [],
    "f69a",
    "M405.68 256l53.21-89.39C473.3 142.4 455.48 112 426.88 112H319.96l-55.95-93.98C256.86 6.01 244.43 0 232 0s-24.86 6.01-32.01 18.02L144.04 112H37.11c-28.6 0-46.42 30.4-32.01 54.61L58.32 256 5.11 345.39C-9.31 369.6 8.51 400 37.11 400h106.93l55.95 93.98C207.14 505.99 219.57 512 232 512s24.86-6.01 32.01-18.02L319.96 400h106.93c28.6 0 46.42-30.4 32.01-54.61L405.68 256zm1.29-96l-29.22 49.08L348.53 160h58.44zm-57.15 96l-57.15 96H171.33l-57.15-96 57.15-96h121.34l57.15 96zM232 58.08L264.1 112h-64.2L232 58.08zM57.03 160h58.44l-29.22 49.08L57.03 160zm0 192l29.22-49.08L115.47 352H57.03zM232 453.92L199.9 400h64.2L232 453.92zM348.53 352l29.22-49.08L406.97 352h-58.44z"
  ]
};
export const faStarOfLife = {
  prefix: "far",
  iconName: "star-of-life",
  icon: [
    512,
    512,
    [],
    "f621",
    "M288 512h-64c-22.06 0-40-17.94-40-40v-92.36l-90.93 46.83c-19.06 10.8-43.65 4.27-54.81-14.5L5.55 356.48c-5.5-9.31-6.97-20.14-4.16-30.53 2.81-10.44 9.59-19.11 19.06-24.44L101.04 256l-80.65-45.55c-9.41-5.3-16.19-13.97-19-24.41-2.81-10.39-1.34-21.22 4.12-30.5l32.75-55.47c11.16-18.81 35.72-25.31 54.81-14.53L184 132.35V40c0-22.06 17.94-40 40-40h64c22.06 0 40 17.94 40 40v92.36l90.93-46.83c19.09-10.78 43.65-4.28 54.81 14.5l32.72 55.48c5.5 9.31 6.97 20.14 4.16 30.53-2.81 10.44-9.59 19.11-19.06 24.44L410.96 256l80.59 45.52c9.47 5.33 16.25 14 19.06 24.44 2.81 10.39 1.34 21.22-4.12 30.5l-32.75 55.47c-11.12 18.81-35.68 25.34-54.81 14.53L328 379.65V472c-.01 22.06-17.94 40-40 40zm-56-48h48V297.42l156.21 83.67 24.65-41.78L305.34 256l155.52-83.31-24.65-41.78L280 214.58V48h-48v166.58L75.8 130.91l-24.65 41.78L206.66 256 51.14 339.31l24.65 41.78L232 297.42V464z"
  ]
};
export const faStarShooting = {
  prefix: "far",
  iconName: "star-shooting",
  icon: [
    512,
    512,
    [],
    "e036",
    "M308.68131,192.00421l11.31076,11.30858a15.997,15.997,0,0,0,22.62737,0L507.31388,38.6235a15.99983,15.99983,0,0,0,0-22.62693L496.00312,4.686a16.00057,16.00057,0,0,0-22.62737,0L308.68131,169.37533A16.00218,16.00218,0,0,0,308.68131,192.00421ZM239.99059,91.3129a15.997,15.997,0,0,0,22.62737,0l52.69238-52.6894a15.99983,15.99983,0,0,0,0-22.62693L303.99958,4.686a16.00057,16.00057,0,0,0-22.62737,0l-52.69237,52.6894a16.00217,16.00217,0,0,0,0,22.62889Zm256.01253,105.373a16.00057,16.00057,0,0,0-22.62737,0l-52.69237,52.6894a16.00217,16.00217,0,0,0,0,22.62889l11.31075,11.30858a15.997,15.997,0,0,0,22.62737,0l52.69238-52.6894a15.99984,15.99984,0,0,0,0-22.62694ZM364.29366,267.27562l-104.7988-15.29686-46.90712-95.203a22.94639,22.94639,0,0,0-41.18826,0l-46.90711,95.203L19.69356,267.27562C.89634,269.97875-6.71318,293.18185,6.9902,306.47871l75.90765,73.99993L64.89752,485.07229A23.05366,23.05366,0,0,0,87.52489,512,22.45856,22.45856,0,0,0,98.195,509.27539l93.7986-49.39057,93.79861,49.39057a22.76456,22.76456,0,0,0,10.66426,2.68164,22.9945,22.9945,0,0,0,22.63323-26.88474l-17.891-104.59365,75.892-73.99993C390.7004,293.18185,383.09089,269.97875,364.29366,267.27562ZM249.63335,363.71694l13.58618,79.42375-71.22592-37.50387-71.16733,37.47457,13.66041-79.37687L76.75516,307.45527l79.64209-11.625,35.59636-72.246,35.59636,72.246L307.32,307.469Z"
  ]
};
export const faStarfighter = {
  prefix: "far",
  iconName: "starfighter",
  icon: [
    640,
    512,
    [],
    "e037",
    "M288,256v48a16.00079,16.00079,0,0,0,16,16h32a16.00079,16.00079,0,0,0,16-16V256a32,32,0,0,0-64,0ZM624,128v-8a24,24,0,0,0-48,0v8H560v32h16V352H528V304a64.07207,64.07207,0,0,0-64-64H432a63.18953,63.18953,0,0,0-20.36133,3.62891L385.5625,35.03125A40.06534,40.06534,0,0,0,345.875,0h-51.75a40.06457,40.06457,0,0,0-39.6875,35.03125L228.51367,243.67578A63.19136,63.19136,0,0,0,208,240H176a64.07207,64.07207,0,0,0-64,64v48H64V160H80V128H64v-8a24,24,0,0,0-48,0v8H0v32H16V424a23.88263,23.88263,0,0,0,45.52734,10.21094L168,476.80078V496a16.00079,16.00079,0,0,0,16,16h16a16.00079,16.00079,0,0,0,16-16V479.19141a63.1753,63.1753,0,0,0,23.95117-8.06836C246.71484,476.35938,254.80078,480,264,480H376c9.19922,0,17.28516-3.64258,24.04883-8.877A63.1753,63.1753,0,0,0,424,479.19141V496a16.00079,16.00079,0,0,0,16,16h16a16.00079,16.00079,0,0,0,16-16V476.80078l106.47266-42.58984A23.88263,23.88263,0,0,0,624,424V160h16V128ZM224,416a16.00079,16.00079,0,0,1-16,16H176a16.00079,16.00079,0,0,1-16-16V304a15.99954,15.99954,0,0,1,16-16h32a15.99954,15.99954,0,0,1,16,16Zm144,0a16.00079,16.00079,0,0,1-16,16H287.98047a15.99913,15.99913,0,0,1-16-15.98047l-.168-133.03515L301.1875,48h37.625L368,280Zm112,0a16.00079,16.00079,0,0,1-16,16H432a16.00079,16.00079,0,0,1-16-16V304a15.99954,15.99954,0,0,1,16-16h32a15.99954,15.99954,0,0,1,16,16Z"
  ]
};
export const faStarfighterAlt = {
  prefix: "far",
  iconName: "starfighter-alt",
  icon: [
    576,
    512,
    [],
    "e038",
    "M560,32H544a15.99954,15.99954,0,0,0-16,16V195.26562L421.86133,168.73047C393.30078,125.01172,344.11719,96,288,96s-105.30078,29.01172-133.86133,72.73047L48,195.26562V48A15.99954,15.99954,0,0,0,32,32H16A15.99954,15.99954,0,0,0,0,48V464a16.00079,16.00079,0,0,0,16,16H32a16.00079,16.00079,0,0,0,16-16V316.73438l106.13867,26.53515C182.69922,386.98828,231.88281,416,288,416s105.30078-29.01172,133.86133-72.73047L528,316.73438V464a16.00079,16.00079,0,0,0,16,16h16a16.00079,16.00079,0,0,0,16-16V48A15.99954,15.99954,0,0,0,560,32ZM131.23242,288.07422,56,269.26562V242.73438l75.23242-18.8086a160.74708,160.74708,0,0,0,0,64.14844ZM304,145.61719a110.85425,110.85425,0,0,1,50.76562,20.99219l-28.57031,28.57031A71.32957,71.32957,0,0,0,304,185.92578Zm-32,0v40.30859a71.32957,71.32957,0,0,0-22.19531,9.25391l-28.57031-28.57031A110.85425,110.85425,0,0,1,272,145.61719Zm-73.39062,43.61719,28.57031,28.57031A71.30232,71.30232,0,0,0,217.92578,240H177.61719A110.85425,110.85425,0,0,1,198.60938,189.23438ZM177.61719,272h40.30859a71.32957,71.32957,0,0,0,9.25391,22.19531l-28.56836,28.56836A110.82866,110.82866,0,0,1,177.61719,272ZM272,366.38281a110.82866,110.82866,0,0,1-50.76367-20.99414l28.56836-28.56836A71.32957,71.32957,0,0,0,272,326.07422ZM264,256a24,24,0,1,1,24,24A24.02624,24.02624,0,0,1,264,256Zm40,110.38281V326.07422a71.32957,71.32957,0,0,0,22.19531-9.25391l28.57031,28.57031A110.83317,110.83317,0,0,1,304,366.38281Zm73.38867-43.61914-28.56836-28.56836A71.32957,71.32957,0,0,0,358.07422,272h40.30859A110.82866,110.82866,0,0,1,377.38867,322.76367ZM358.07422,240a71.30232,71.30232,0,0,0-9.25391-22.19531l28.57031-28.57031A110.85425,110.85425,0,0,1,398.38281,240ZM520,269.26562l-75.23242,18.8086a160.74708,160.74708,0,0,0,0-64.14844L520,242.73438Z"
  ]
};
export const faStars = {
  prefix: "far",
  iconName: "stars",
  icon: [
    512,
    512,
    [],
    "f762",
    "M259.68734,85.96808l49.6461,20.70054,20.70378,49.645a6.65746,6.65746,0,0,0,11.92616,0l20.70182-49.645,49.6461-20.70054a6.6661,6.6661,0,0,0,0-11.92542L362.6652,53.34017l-20.70182-49.643a6.65746,6.65746,0,0,0-11.92616,0l-20.70378,49.643-49.6461,20.70249a6.6661,6.6661,0,0,0,0,11.92542Zm249.3653,133.26937L469.3385,202.67936l-16.55912-39.71168a5.32691,5.32691,0,0,0-9.54132,0L426.677,202.67936,386.9648,219.23745a5.33414,5.33414,0,0,0,0,9.54072L426.677,245.33822l16.56107,39.70972a5.32534,5.32534,0,0,0,9.54132,0l16.55912-39.70972,39.71414-16.56005a5.33414,5.33414,0,0,0,0-9.54072ZM364.30783,267.30434,259.492,252.00793l-46.90773-95.20022a22.76642,22.76642,0,0,0-20.68816-12.79648,22.40194,22.40194,0,0,0-20.50065,12.79648l-46.90773,95.20022L19.67194,267.30434C.89009,270.00739-6.7039,293.2098,6.984,306.50627L82.89269,380.504,64.89212,485.09457C62.29829,500.00037,74.17366,512,87.48658,512a22.24712,22.24712,0,0,0,10.68784-2.703l93.81546-49.38912L285.80535,509.297a22.859,22.859,0,0,0,33.2823-24.20239L301.18084,380.504l75.90865-73.99774C390.68367,293.2098,383.08968,270.00739,364.30783,267.30434ZM249.4917,363.8014l13.68794,79.40382-71.18976-37.49885-71.31475,37.49885,13.71918-79.40382L76.58,307.50624l79.815-11.5934,35.59487-72.20092,35.59488,72.20092,79.815,11.5934Z"
  ]
};
export const faStarship = {
  prefix: "far",
  iconName: "starship",
  icon: [
    640,
    512,
    [],
    "e039",
    "M448,64c-78.54688,0-145.97461,47.22266-175.71289,114.77734l-71.15039,6.46875L163.26562,160H192a64,64,0,0,0,0-128H32A31.99908,31.99908,0,0,0,0,64v64a31.99908,31.99908,0,0,0,32,32H76.73438l48.25585,32.17188C86.27336,195.68455,64,224.521,64,256c0,30.88879,21.50605,60.23325,60.98828,63.832L76.73438,352H32A31.99908,31.99908,0,0,0,0,384v64a31.99908,31.99908,0,0,0,32,32H192a64,64,0,0,0,0-128H163.26562l37.86915-25.24609,71.15234,6.46875C302.02344,400.77734,369.45312,448,448,448c106.03906,0,192-85.96094,192-192S554.03906,64,448,64ZM48,112V80H192a16,16,0,0,1,0,32ZM192,400a16,16,0,0,1,0,32H48V400Zm66.22852-116.26367L126.375,271.75a15.81421,15.81421,0,0,1,.03125-31.5l131.82227-11.98438A192.33608,192.33608,0,0,0,256,256,192.36313,192.36313,0,0,0,258.22852,283.73633ZM448,400c-79.40234,0-144-64.59766-144-144s64.59766-144,144-144,144,64.59766,144,144S527.40234,400,448,400Zm0-224a80,80,0,1,0,80,80A79.999,79.999,0,0,0,448,176Zm0,112a32,32,0,1,1,32-32A32.00033,32.00033,0,0,1,448,288Z"
  ]
};
export const faStarshipFreighter = {
  prefix: "far",
  iconName: "starship-freighter",
  icon: [
    576,
    512,
    [],
    "e03a",
    "M127.99741,336A16,16,0,1,0,143.997,352,16.00059,16.00059,0,0,0,127.99741,336Zm-31.9992-96a16,16,0,1,0,15.9996,16A16.0006,16.0006,0,0,0,95.99821,240Zm31.9992-96A16,16,0,1,0,143.997,160,16.00059,16.00059,0,0,0,127.99741,144Zm426.95819-7.668L311.32686,47.5625A257.73035,257.73035,0,0,0,224.43448,32c-29.15162,0-58.1177,5.41211-85.21469,17.15039C-4.095,111.22266.01425,256,.01425,256S-4.34111,400.666,139.21979,462.84961c27.09308,11.73437,56.067,17.14844,85.21469,17.14844,25.39195,0,50.8503-4.32813,75.38095-11.94532l9.08376,13.05665A71.93338,71.93338,0,0,0,367.99148,512h71.99821a71.67038,71.67038,0,0,0,57.19976-115.28516L554.9556,375.668A31.998,31.998,0,0,0,576,345.60156V166.39844A31.998,31.998,0,0,0,554.9556,136.332Zm-330.52112,295.666c-103.46619,0-177.84521-89.92188-176.41946-175.96875C46.79239,163.28711,126.48378,80.09375,224.28409,80.01367,256.48252,79.98633,399.99068,106.793,399.99068,256A173.67687,173.67687,0,0,1,381.497,333.33594l-53.5436-76.95508c0-.13086.03907-.25.03907-.38086a87.99783,87.99783,0,1,0-175.99565,0c0,37.76562,24.03456,69.77539,57.5142,82.23633l60.98091,87.66211C255.09974,429.50977,239.69582,431.99805,224.43448,431.99805ZM279.99365,256a39.999,39.999,0,1,1-39.999-40A39.999,39.999,0,0,1,279.99365,256Zm159.996,208H367.99148a23.959,23.959,0,0,1-19.687-10.29688L268.42558,338.875a87.70726,87.70726,0,0,0,39.35059-27.44531L380.52242,416h59.46727a24,24,0,0,1,0,48Zm88.0115-129.59766L435.79058,368H417.27932a221.81734,221.81734,0,0,0,28.32156-80h82.38664l.01367-.002Zm0-110.40039L527.98752,224h-82.3964a221.319,221.319,0,0,0-33.4816-88.62891l115.89167,42.22657Z"
  ]
};
export const faSteak = {
  prefix: "far",
  iconName: "steak",
  icon: [
    576,
    512,
    [],
    "f824",
    "M368.85 96c-27.31 0-51.89 23.7-62.62 60.36-6.24 21.36-26.75 106.21-173.16 170-82.13 35.76-9.65 88.57 95.81 88.57 72.76 0 161.21-25.12 225.45-98.31 38.21-43.53 32.8-126-11.57-176.59C417.86 111.58 391.61 96 368.85 96zM384 255.9a32 32 0 1 1 32-32 32 32 0 0 1-32 32zM514.92 76.65C467.92 23.11 416.28 0 368.85 0 298.27 0 237 51.17 214.1 129.39 165 269.32 1.37 212.32 0 351.63-1.13 467.49 126.32 512 239.31 512q8.41 0 16.69-.32c87.78-3.41 187.32-37.1 270.49-131.85C596.78 299.75 591.6 164 514.92 76.65zm-24.5 271.51c-79.89 91-172.59 113.08-236.28 115.55q-7.37.29-14.83.29c-71.69 0-135.83-19.8-167.39-51.66C55.59 395.85 47.77 376.15 48 352.1c.38-39.52 15.05-47.66 65.88-69.79 48.52-21.13 115-50.06 145.5-137l.42-1.2.35-1.22C277 85.24 319.69 48 368.85 48c37.32 0 75.36 20.86 110 60.32 60.15 68.58 65.49 178.41 11.57 239.84z"
  ]
};
export const faSteeringWheel = {
  prefix: "far",
  iconName: "steering-wheel",
  icon: [
    496,
    512,
    [],
    "f622",
    "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 48c102.14 0 186.51 77.02 198.42 176h-84.65c-12.85-32.71-44.55-56-81.77-56h-64c-37.22 0-68.92 23.29-81.77 56H49.58C61.5 133.02 145.86 56 248 56zm0 270.05l-71-70.98c4.06-17.77 20-31.06 39-31.06h64c19 0 34.94 13.3 39 31.06l-71 70.98zM49.58 280h84.48L224 369.93v84.49C132.9 443.45 60.55 371.1 49.58 280zM272 454.42v-84.49L361.94 280h84.48C435.46 371.1 363.1 443.45 272 454.42z"
  ]
};
export const faStepBackward = {
  prefix: "far",
  iconName: "step-backward",
  icon: [
    448,
    512,
    [],
    "f048",
    "M76 480h24c6.6 0 12-5.4 12-12V285l219.5 187.6c20.6 17.2 52.5 2.8 52.5-24.6V64c0-27.4-31.9-41.8-52.5-24.6L112 228.1V44c0-6.6-5.4-12-12-12H76c-6.6 0-12 5.4-12 12v424c0 6.6 5.4 12 12 12zM336 98.5v315.1L149.3 256.5 336 98.5z"
  ]
};
export const faStepForward = {
  prefix: "far",
  iconName: "step-forward",
  icon: [
    448,
    512,
    [],
    "f051",
    "M372 32h-24c-6.6 0-12 5.4-12 12v183L116.5 39.4C95.9 22.3 64 36.6 64 64v384c0 27.4 31.9 41.8 52.5 24.6L336 283.9V468c0 6.6 5.4 12 12 12h24c6.6 0 12-5.4 12-12V44c0-6.6-5.4-12-12-12zM112 413.5V98.4l186.7 157.1-186.7 158z"
  ]
};
export const faStethoscope = {
  prefix: "far",
  iconName: "stethoscope",
  icon: [
    512,
    512,
    [],
    "f0f1",
    "M120 334v18c0 88.2 75.4 160 168 160s168-71.8 168-160v-99.7c32.3-10.1 55.7-40.2 56-75.7.3-43.4-34.6-79.6-78.1-80.6-45-1-81.9 35.2-81.9 80 0 35.8 23.5 66.1 56 76.3V352c0 61.8-53.8 112-120 112s-120-50.2-120-112v-18c68-11.5 120-70.8 120-142V27.5c0-5.6-3.9-10.5-9.4-11.7L208.9.3c-6.5-1.4-12.9 2.6-14.3 9.1l-5.2 23.4c-1.4 6.5 2.6 12.9 9.1 14.3l41.5 9.2v134.4c0 52.9-42.2 96.7-95.1 97.2-53.3.6-96.9-42.6-96.9-95.9V56.4l41.5-9.2c6.5-1.4 10.5-7.8 9.1-14.3L93.4 9.4C92 2.9 85.5-1.1 79.1.3L9.4 15.8C3.9 17 0 21.9 0 27.5V192c0 71.2 52 130.5 120 142zm312-190c17.6 0 32 14.4 32 32s-14.4 32-32 32-32-14.4-32-32 14.4-32 32-32z"
  ]
};
export const faStickyNote = {
  prefix: "far",
  iconName: "sticky-note",
  icon: [
    448,
    512,
    [],
    "f249",
    "M448 348.106V80c0-26.51-21.49-48-48-48H48C21.49 32 0 53.49 0 80v351.988c0 26.51 21.49 48 48 48h268.118a48 48 0 0 0 33.941-14.059l83.882-83.882A48 48 0 0 0 448 348.106zm-128 80v-76.118h76.118L320 428.106zM400 80v223.988H296c-13.255 0-24 10.745-24 24v104H48V80h352z"
  ]
};
export const faStocking = {
  prefix: "far",
  iconName: "stocking",
  icon: [
    384,
    512,
    [],
    "f7d5",
    "M368 0H80c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h16v155.5l-39 26C-1.8 316.7-17.7 396.2 21.5 455c24.7 37 65.2 57 106.6 57 24.4 0 49.1-7 70.9-21.5l81.7-54.5c44.6-29.7 71.2-79.5 71.2-133.1V96h16c8.8 0 16-7.2 16-16V16c.1-8.8-7.1-16-15.9-16zm-64 302.9c0 37.5-18.6 72.4-49.9 93.2l-81.8 54.5c-53.7 35.8-99.8-5.6-110.9-22.2-24.5-36.8-14.6-86.4 22.2-111l60.4-40.2V96h160v206.9z"
  ]
};
export const faStomach = {
  prefix: "far",
  iconName: "stomach",
  icon: [
    512,
    512,
    [],
    "f623",
    "M397.91 96.75C341.63 90.74 292.2 121.69 269.45 168H256c-39.76 0-72-32.24-72-72V16c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v80c0 66.27 53.73 120 120 120h.81c-.17 2.7-.81 5.26-.81 8v64c0 39.76-32.24 72-72 72h-64C53.73 360 0 413.73 0 480v16c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-16c0-.4 0-.79.01-1.18.83-51.38 64.09-76.8 103.98-44.4l37.24 30.25c28.26 22.96 61.66 39.72 97.68 45.09C407.75 527.79 512 434.23 512 316.78V229.6c0-66.37-48.09-125.81-114.09-132.85zM316.78 464c-33.69 0-66.66-11.7-92.84-32.95l-28.97-23.55c46.6-4.24 85.39-35.3 101.24-77.5l.26.69c24.31-9.12 54.38-5.64 73.06 8.47 20.09 15.17 46.69 23.14 73.53 23.14 4.47 0 8.91-.71 13.36-1.16C437.47 420.55 382.41 464 316.78 464zM464 311.11c-22.74 6.03-48.69 2.49-65.53-10.27-25.36-19.15-61-26.61-94.47-21.28V224c0-44.11 35.88-80 80-80s80 35.89 80 80v87.11z"
  ]
};
export const faStop = {
  prefix: "far",
  iconName: "stop",
  icon: [
    448,
    512,
    [],
    "f04d",
    "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-6 400H54c-3.3 0-6-2.7-6-6V86c0-3.3 2.7-6 6-6h340c3.3 0 6 2.7 6 6v340c0 3.3-2.7 6-6 6z"
  ]
};
export const faStopCircle = {
  prefix: "far",
  iconName: "stop-circle",
  icon: [
    512,
    512,
    [],
    "f28d",
    "M504 256C504 119 393 8 256 8S8 119 8 256s111 248 248 248 248-111 248-248zm-448 0c0-110.5 89.5-200 200-200s200 89.5 200 200-89.5 200-200 200S56 366.5 56 256zm296-80v160c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h160c8.8 0 16 7.2 16 16z"
  ]
};
export const faStopwatch = {
  prefix: "far",
  iconName: "stopwatch",
  icon: [
    448,
    512,
    [],
    "f2f2",
    "M393.9 184l22.6-22.6c4.7-4.7 4.7-12.3 0-17l-17-17c-4.7-4.7-12.3-4.7-17 0l-20.7 20.7c-31.1-27.5-70.4-45.9-113.8-50.8V48h28c6.6 0 12-5.4 12-12V12c0-6.6-5.4-12-12-12H172c-6.6 0-12 5.4-12 12v24c0 6.6 5.4 12 12 12h28v49.4C96.4 109.3 16 197.2 16 304c0 114.9 93.1 208 208 208s208-93.1 208-208c0-44.7-14.1-86.1-38.1-120zM224 464c-88.4 0-160-71.6-160-160s71.6-160 160-160 160 71.6 160 160-71.6 160-160 160zm12-112h-24c-6.6 0-12-5.4-12-12V204c0-6.6 5.4-12 12-12h24c6.6 0 12 5.4 12 12v136c0 6.6-5.4 12-12 12z"
  ]
};
export const faStopwatch20 = {
  prefix: "far",
  iconName: "stopwatch-20",
  icon: [
    448,
    512,
    [],
    "e06f",
    "M275.35,207.2c-29.29,0-45,18-45,50.58V342c0,27.15,8.95,50.76,43.81,50.76C310.15,392.8,320,370,320,341.85V256.24C320,225.31,304.79,207.2,275.35,207.2Zm10.16,138.4c0,10.59-2.71,17-10.41,17s-10.59-6-10.59-16.48V253.39c0-10,3.05-16,10.59-16,8,0,10.41,6.46,10.41,15.47ZM217.6,256c0-28.15-10.07-48.83-44.46-48.83-38.36,0-45.14,26.35-45.14,48.19v3.26a6.56,6.56,0,0,0,6.66,6.46h19.92a6.57,6.57,0,0,0,6.67-6.46v-4.19c0-12.22,2.64-18.14,10.14-18.14,8.35,0,9.78,5.88,9.78,19.42,0,20-5.35,26.52-21.68,49.87-19,27.17-28.54,44.92-30.76,73.1A13.16,13.16,0,0,0,142,392.8h66.28a6.56,6.56,0,0,0,6.66-6.45V368.49a6.56,6.56,0,0,0-6.66-6.45H169c1.44-12.5,11.88-28.92,21.13-41C207.64,297,217.6,284.49,217.6,256Zm176.31-72,22.59-22.59a12,12,0,0,0,0-17l-17-17a12,12,0,0,0-17,0l-20.7,20.68A206.56,206.56,0,0,0,248,97.3V48h28a12,12,0,0,0,12-12V12A12,12,0,0,0,276,0H172a12,12,0,0,0-12,12V36a12,12,0,0,0,12,12h28V97.41C96.41,109.3,16,197.2,16,304c0,114.91,93.09,208,208,208s208-93.09,208-208A207,207,0,0,0,393.91,184ZM224,464A160,160,0,1,1,384,304,159.94,159.94,0,0,1,224,464Z"
  ]
};
export const faStore = {
  prefix: "far",
  iconName: "store",
  icon: [
    616,
    512,
    [],
    "f54e",
    "M602 118.6L537.1 15C531.3 5.7 521 0 510 0H106C95 0 84.7 5.7 78.9 15L14 118.6c-29.6 47.2-10 110.6 38 130.8v227.4c0 19.4 14.3 35.2 32 35.2h448c17.7 0 32-15.8 32-35.2V249.4c48-20.2 67.6-83.6 38-130.8zM516 464H100v-96h416zm-.2-144.2H100v-64.7c24-3.3 45.1-15.2 60.3-32.2 18 20.1 44.3 33.1 73.8 33.1 29.6 0 55.8-13 73.8-33.1 18 20.1 44.3 33.1 73.8 33.1 29.6 0 55.8-13 73.8-33.1 15.3 17 36.3 28.9 60.3 32.2zm47.9-133c-3.2 6.8-10.9 18.6-27 20.8-2.4.3-4.8.5-7.2.5-14.7 0-28.2-6.1-38.1-17.2L455.7 151 420 190.8c-9.9 11.1-23.5 17.2-38.1 17.2s-28.2-6.1-38.1-17.2L308 151l-35.7 39.8c-9.9 11.1-23.5 17.2-38.1 17.2-14.7 0-28.2-6.1-38.1-17.2L160.3 151l-35.7 39.8c-9.9 11.1-23.5 17.2-38.1 17.2-2.5 0-4.9-.2-7.2-.5-16-2.2-23.8-13.9-27-20.8-5-10.8-7.1-27.6 2.3-42.6L114.8 48h386.3l60.2 96.1c9.5 15.1 7.5 31.9 2.4 42.7z"
  ]
};
export const faStoreAlt = {
  prefix: "far",
  iconName: "store-alt",
  icon: [
    640,
    512,
    [],
    "f54f",
    "M635.7 176.1l-91.4-160C538.6 6.2 528 0 516.5 0h-393C112 0 101.4 6.2 95.7 16.1l-91.4 160C-7.9 197.5 7.4 224 32 224h32v252.8c0 19.4 14.3 35.2 32 35.2h256c17.7 0 32-15.8 32-35.2V224h144v272c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V224h32c24.6 0 39.9-26.5 27.7-47.9zM336 464H112v-95.8h224V464zm0-143.8H112V224h224v96.2zM59.6 176l73.1-128h374.5l73.1 128H59.6z"
  ]
};
export const faStoreAltSlash = {
  prefix: "far",
  iconName: "store-alt-slash",
  icon: [
    640,
    512,
    [],
    "e070",
    "M507.21,48l73.1,128H334.57L396,224H528V327.23l48,37.53V224h32c24.6,0,39.91-26.5,27.71-47.9l-91.41-160A32.16,32.16,0,0,0,516.51,0h-393a31.59,31.59,0,0,0-11.14,2.27L170.84,48ZM112,320.21V224h50.2l-61.4-48H59.58l12.73-22.26L34.12,123.88,4.28,176.1C-7.92,197.5,7.39,224,32,224H64V476.8c0,19.4,14.3,35.2,32,35.2H352c17.71,0,32-15.8,32-35.2V397.42l-98.76-77.21ZM336,464H112V368.21H336ZM36,3.52A16,16,0,0,0,13.51,6l-10,12.49A16,16,0,0,0,6,41L604,508.48A16,16,0,0,0,626.48,506l10-12.49A16,16,0,0,0,634,471Z"
  ]
};
export const faStoreSlash = {
  prefix: "far",
  iconName: "store-slash",
  icon: [
    640,
    512,
    [],
    "e071",
    "M634,471,36,3.52A16,16,0,0,0,13.51,6l-10,12.49A16,16,0,0,0,6,41L604,508.48A16,16,0,0,0,626.48,506l10-12.49A16,16,0,0,0,634,471ZM513.09,48,573.3,144.1c9.5,15.11,7.5,31.9,2.4,42.7-3.2,6.8-10.9,18.61-27,20.8a56.2,56.2,0,0,1-7.2.5,50.43,50.43,0,0,1-38.09-17.19L467.7,151,432,190.8A50.57,50.57,0,0,1,393.91,208c-22.43,0-25.91-11.16-25.91-5.86l60.26,47.11a99.41,99.41,0,0,0,39.24-26.34,99.26,99.26,0,0,0,60.3,32.19v.9h.2v71.23l48,37.52V249.41c48-20.2,67.59-83.61,38-130.81L549.09,15A32,32,0,0,0,522,0H118a31.63,31.63,0,0,0-7.35.94L170.84,48ZM112,464V368H346.38l-61.66-48.2H112V255.1a98.44,98.44,0,0,0,55.08-27.27l-38.27-29.92A50.24,50.24,0,0,1,98.5,208a55.37,55.37,0,0,1-7.2-.5c-16-2.2-23.8-13.9-27-20.79A45.75,45.75,0,0,1,64.91,148L26.45,117.88l-.45.72C-3.59,165.8,16,229.21,64,249.41V476.8C64,496.2,78.3,512,96,512H530.57l-61.4-48Z"
  ]
};
export const faStream = {
  prefix: "far",
  iconName: "stream",
  icon: [
    512,
    512,
    [],
    "f550",
    "M16 128h416c8.84 0 16-7.16 16-16V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v32c0 8.84 7.16 16 16 16zm480 96H80c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-64 160H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
  ]
};
export const faStreetView = {
  prefix: "far",
  iconName: "street-view",
  icon: [
    512,
    512,
    [],
    "f21d",
    "M168 338.59V384c0 30.88 25.12 56 56 56h64c30.88 0 56-25.12 56-56v-45.41c18.91-9 32-28.3 32-50.59v-72c0-28.78-17.09-53.48-41.54-65C345.43 135.4 352 116.49 352 96c0-52.94-43.06-96-96-96s-96 43.06-96 96c0 20.49 6.57 39.4 17.55 55-24.46 11.52-41.55 36.22-41.55 65v72c0 22.3 13.09 41.59 32 50.59zM256 48c26.51 0 48 21.49 48 48s-21.49 48-48 48-48-21.49-48-48 21.49-48 48-48zm-72 168c0-13.23 10.78-24 24-24h96c13.22 0 24 10.77 24 24v72c0 4.41-3.59 8-8 8h-24v88c0 4.41-3.59 8-8 8h-64c-4.41 0-8-3.59-8-8v-88h-24c-4.41 0-8-3.59-8-8v-72zm209.61 119.14c-4.9 7.65-10.55 14.83-17.61 20.69v14.49c53.18 10.14 88 26.81 88 45.69 0 30.93-93.12 56-208 56S48 446.93 48 416c0-18.88 34.82-35.54 88-45.69v-14.49c-7.06-5.86-12.71-13.03-17.61-20.69C47.28 352.19 0 382 0 416c0 53.02 114.62 96 256 96s256-42.98 256-96c0-34-47.28-63.81-118.39-80.86z"
  ]
};
export const faStretcher = {
  prefix: "far",
  iconName: "stretcher",
  icon: [
    640,
    512,
    [],
    "f825",
    "M600 112H203l-86.25-99.6a39.86 39.86 0 0 0-55.47-2.25L13.44 52.66C-3.75 68-4.06 94.39 10.28 109.31l101.56 117.16A88.09 88.09 0 0 0 177.63 256h46.48l107.43 94-46.91 41.05A63.31 63.31 0 0 0 256 384a64 64 0 1 0 64 64 63.26 63.26 0 0 0-3.76-20.81L368 381.9l51.76 45.29A63.26 63.26 0 0 0 416 448a64 64 0 1 0 64-64 63.31 63.31 0 0 0-28.63 7.05L404.45 350l107.43-94H600a40 40 0 0 0 40-40v-64a40 40 0 0 0-40-40zM256 464a16 16 0 1 1 16-16 16 16 0 0 1-16 16zm224-32a16 16 0 1 1-16 16 16 16 0 0 1 16-16zM368 318.1L297 256h142zM592 208H177.63a40 40 0 0 1-29.72-13.2L51.22 83.31l35.87-31.88L181 160h411z"
  ]
};
export const faStrikethrough = {
  prefix: "far",
  iconName: "strikethrough",
  icon: [
    512,
    512,
    [],
    "f0cc",
    "M150.39 208h113.17l-46.31-23.16a45.65 45.65 0 0 1 0-81.68A67.93 67.93 0 0 1 247.56 96H310a45.59 45.59 0 0 1 36.49 18.25l15.09 20.13a16 16 0 0 0 22.4 3.21l25.62-19.19a16 16 0 0 0 3.21-22.4L397.7 75.84A109.44 109.44 0 0 0 310.1 32h-62.54a132.49 132.49 0 0 0-58.94 13.91c-40.35 20.17-64.19 62.31-60.18 108 1.76 20.09 10.02 38.37 21.95 54.09zM496 240H16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h480a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm-92.5 80h-91.07l14.32 7.16a45.65 45.65 0 0 1 0 81.68 67.93 67.93 0 0 1-30.31 7.16H234a45.59 45.59 0 0 1-36.49-18.25l-15.09-20.13a16 16 0 0 0-22.4-3.21L134.4 393.6a16 16 0 0 0-3.21 22.4l15.11 20.17A109.44 109.44 0 0 0 233.9 480h62.54a132.42 132.42 0 0 0 58.93-13.91c40.36-20.17 64.2-62.31 60.19-108-1.19-13.69-5.89-26.27-12.06-38.09z"
  ]
};
export const faStroopwafel = {
  prefix: "far",
  iconName: "stroopwafel",
  icon: [
    512,
    512,
    [],
    "f551",
    "M256 0C114.62 0 0 114.62 0 256s114.62 256 256 256 256-114.62 256-256S397.38 0 256 0zm0 464c-114.69 0-208-93.31-208-208S141.31 48 256 48s208 93.31 208 208-93.31 208-208 208zm158.39-208l28.28-28.28c3.12-3.12 3.12-8.19 0-11.31l-11.31-11.31c-3.12-3.12-8.19-3.12-11.31 0l-28.28 28.28-45.26-45.25 22.63-22.63 16.97 16.97c3.12 3.12 8.19 3.12 11.31 0l11.31-11.31c3.12-3.12 3.12-8.19 0-11.31l-16.97-16.97 5.66-5.66c3.12-3.12 3.12-8.19 0-11.31l-11.31-11.31c-3.12-3.12-8.19-3.12-11.31 0l-5.66 5.66-16.97-16.97c-3.12-3.12-8.19-3.12-11.31 0l-11.31 11.31c-3.12 3.12-3.12 8.19 0 11.31l16.97 16.97-22.63 22.63-45.26-45.25 28.29-28.28c3.12-3.12 3.12-8.19 0-11.31L295.6 69.32c-3.12-3.12-8.19-3.12-11.31 0L256 97.61l-28.29-28.29c-3.12-3.12-8.19-3.12-11.31 0l-11.31 11.31c-3.12 3.12-3.12 8.19 0 11.31l28.29 28.28-45.25 45.25-22.63-22.63 16.97-16.97c3.12-3.12 3.12-8.19 0-11.31l-11.31-11.31c-3.12-3.12-8.19-3.12-11.31 0l-16.97 16.97-5.66-5.66c-3.12-3.12-8.19-3.12-11.31 0l-11.31 11.31c-3.12 3.12-3.12 8.19 0 11.31l5.66 5.66-16.97 16.97c-3.12 3.12-3.12 8.19 0 11.31l11.31 11.31c3.12 3.12 8.19 3.12 11.31 0l16.97-16.97 22.63 22.63-45.25 45.25-28.29-28.28c-3.12-3.12-8.19-3.12-11.31 0L69.32 216.4c-3.12 3.12-3.12 8.19 0 11.31L97.61 256l-28.29 28.29c-3.12 3.12-3.12 8.19 0 11.31l11.31 11.31c3.12 3.12 8.19 3.12 11.31 0l28.29-28.28 45.25 45.25-22.63 22.63-16.97-16.97c-3.12-3.12-8.19-3.12-11.31 0l-11.31 11.31c-3.12 3.12-3.12 8.19 0 11.31l16.97 16.97-5.66 5.66c-3.12 3.12-3.12 8.19 0 11.31l11.31 11.31c3.12 3.12 8.19 3.12 11.31 0l5.66-5.66 16.97 16.97c3.12 3.12 8.19 3.12 11.31 0l11.31-11.31c3.12-3.12 3.12-8.19 0-11.31l-16.97-16.97 22.63-22.63 45.26 45.26-28.29 28.29c-3.12 3.12-3.12 8.19 0 11.31l11.31 11.31c3.12 3.12 8.19 3.12 11.31 0L256 414.39l28.29 28.29c3.12 3.12 8.19 3.12 11.31 0l11.31-11.31c3.12-3.12 3.12-8.19 0-11.31l-28.29-28.29 45.26-45.26 22.63 22.63-16.97 16.97c-3.12 3.12-3.12 8.19 0 11.31l11.31 11.31c3.12 3.12 8.19 3.12 11.31 0l16.97-16.97 5.66 5.66c3.12 3.12 8.19 3.12 11.31 0l11.31-11.31c3.12-3.12 3.12-8.19 0-11.31l-5.66-5.66 16.97-16.97c3.12-3.12 3.12-8.19 0-11.31l-11.31-11.31c-3.12-3.12-8.19-3.12-11.31 0l-16.97 16.97-22.63-22.63 45.25-45.25 28.29 28.28c3.12 3.12 8.19 3.12 11.31 0l11.31-11.31c3.12-3.12 3.12-8.19 0-11.31L414.39 256zM256 142.86l45.25 45.25L256 233.37l-45.25-45.25L256 142.86zM142.86 256l45.25-45.26L233.37 256l-45.26 45.26L142.86 256zM256 369.14l-45.26-45.26L256 278.62l45.26 45.26L256 369.14zm67.88-67.89L278.63 256l45.26-45.25L369.14 256l-45.26 45.25z"
  ]
};
export const faSubscript = {
  prefix: "far",
  iconName: "subscript",
  icon: [
    512,
    512,
    [],
    "f12c",
    "M336 64h-52.28a16 16 0 0 0-13.31 7.12L176 212.73 81.59 71.12A16 16 0 0 0 68.28 64H16A16 16 0 0 0 0 80v16a16 16 0 0 0 16 16h35.16l96 144-96 144H16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h52.28a16 16 0 0 0 13.31-7.12L176 299.27l94.41 141.61a16 16 0 0 0 13.31 7.12H336a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16h-35.16l-96-144 96-144H336a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm160 400h-24V304a16 16 0 0 0-16-16h-32a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 408 352h16v112h-24a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16z"
  ]
};
export const faSubway = {
  prefix: "far",
  iconName: "subway",
  icon: [
    448,
    512,
    [],
    "f239",
    "M280 328c0-22.091 17.909-40 40-40s40 17.909 40 40-17.909 40-40 40-40-17.909-40-40zm-152 40c22.091 0 40-17.909 40-40s-17.909-40-40-40-40 17.909-40 40 17.909 40 40 40zm320-258.286v228.572c0 49.194-43.706 90.629-99.059 104.713l58.758 58.758c3.78 3.78 1.103 10.243-4.243 10.243h-48.427a11.996 11.996 0 0 1-8.485-3.515L286.059 448H161.941l-60.485 60.485A12.002 12.002 0 0 1 92.971 512H44.544c-5.345 0-8.022-6.463-4.243-10.243l58.758-58.758C43.886 428.961 0 387.656 0 338.286V109.714C0 45.928 71.001 0 138.286 0h171.428C377.889 0 448 45.922 448 109.714zM50.774 96h346.534c-10.2-26.136-47.971-48-87.595-48H138.286c-38.862 0-77.011 21.67-87.512 48zM48 224h152v-80H48v80zm352 48H48v66.286C48 374.495 99.975 400 138.286 400h171.428C347.479 400 400 374.816 400 338.286V272zm0-128H248v80h152v-80z"
  ]
};
export const faSuitcase = {
  prefix: "far",
  iconName: "suitcase",
  icon: [
    512,
    512,
    [],
    "f0f2",
    "M464 128h-80V80c0-26.5-21.5-48-48-48H176c-26.5 0-48 21.5-48 48v48H48c-26.5 0-48 21.5-48 48v256c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48zM176 80h160v48H176V80zM48 432V176h80v256H48zm128 0V176h160v256H176zm288 0h-80V176h80v256z"
  ]
};
export const faSuitcaseRolling = {
  prefix: "far",
  iconName: "suitcase-rolling",
  icon: [
    384,
    512,
    [],
    "f5c1",
    "M336 128h-48V48c0-26.51-21.49-48-48-48h-96c-26.51 0-48 21.49-48 48v80H48c-26.51 0-48 21.49-48 48v256c0 26.51 21.49 48 48 48h16v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16h128v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16h16c26.51 0 48-21.49 48-48V176c0-26.51-21.49-48-48-48zM144 48h96v80h-96V48zm192 384H48V176h288v256zm-232-48h176c4.42 0 8-3.58 8-8v-32c0-4.42-3.58-8-8-8H104c-4.42 0-8 3.58-8 8v32c0 4.42 3.58 8 8 8zm0-112h176c4.42 0 8-3.58 8-8v-32c0-4.42-3.58-8-8-8H104c-4.42 0-8 3.58-8 8v32c0 4.42 3.58 8 8 8z"
  ]
};
export const faSun = {
  prefix: "far",
  iconName: "sun",
  icon: [
    512,
    512,
    [],
    "f185",
    "M494.2 221.9l-59.8-40.5 13.7-71c2.6-13.2-1.6-26.8-11.1-36.4-9.6-9.5-23.2-13.7-36.2-11.1l-70.9 13.7-40.4-59.9c-15.1-22.3-51.9-22.3-67 0l-40.4 59.9-70.8-13.7C98 60.4 84.5 64.5 75 74.1c-9.5 9.6-13.7 23.1-11.1 36.3l13.7 71-59.8 40.5C6.6 229.5 0 242 0 255.5s6.7 26 17.8 33.5l59.8 40.5-13.7 71c-2.6 13.2 1.6 26.8 11.1 36.3 9.5 9.5 22.9 13.7 36.3 11.1l70.8-13.7 40.4 59.9C230 505.3 242.6 512 256 512s26-6.7 33.5-17.8l40.4-59.9 70.9 13.7c13.4 2.7 26.8-1.6 36.3-11.1 9.5-9.5 13.6-23.1 11.1-36.3l-13.7-71 59.8-40.5c11.1-7.5 17.8-20.1 17.8-33.5-.1-13.6-6.7-26.1-17.9-33.7zm-112.9 85.6l17.6 91.2-91-17.6L256 458l-51.9-77-90.9 17.6 17.6-91.2-76.8-52 76.8-52-17.6-91.2 91 17.6L256 53l51.9 76.9 91-17.6-17.6 91.1 76.8 52-76.8 52.1zM256 152c-57.3 0-104 46.7-104 104s46.7 104 104 104 104-46.7 104-104-46.7-104-104-104zm0 160c-30.9 0-56-25.1-56-56s25.1-56 56-56 56 25.1 56 56-25.1 56-56 56z"
  ]
};
export const faSunCloud = {
  prefix: "far",
  iconName: "sun-cloud",
  icon: [
    640,
    512,
    [],
    "f763",
    "M580.5 226c-18.7-39.6-58.6-66-104.5-66-42.4 0-80 23.4-100.2 58.2-49.4 5.7-87.8 47.7-87.8 98.6 0 54.7 44.5 99.2 99.2 99.2h153.6c54.7 0 99.2-44.5 99.2-99.2 0-40.6-24.3-75.5-59.5-90.8zm-39.7 142H387.2c-28.3 0-51.2-22.9-51.2-51.2s22.9-51.2 51.2-51.2c7.7 0 14.8 2.2 21.3 5.3 2.7-35.1 31.7-62.9 67.5-62.9 34.1 0 62 25.1 67 57.8 27.2 1.2 49 23.4 49 51 0 28.3-22.9 51.2-51.2 51.2zM256 458l-51.9-77-90.9 17.6 17.6-91.2-76.8-52 76.8-52-17.6-91.2 91 17.6L256 53l51.9 76.9 91-17.6-8.4 43.5c16-11.5 34.2-19.8 53.5-24.1l4.1-21.3c2.6-13.2-1.6-26.8-11.1-36.4-9.6-9.5-23.2-13.7-36.2-11.1l-70.9 13.7-40.4-59.9c-15.1-22.3-51.9-22.3-67 0l-40.4 59.9-70.8-13.7C98 60.4 84.5 64.5 75 74.1c-9.5 9.6-13.7 23.1-11.1 36.3l13.7 71-59.8 40.5C6.6 229.5 0 242 0 255.5s6.7 26 17.8 33.5l59.8 40.5-13.7 71c-2.6 13.2 1.6 26.8 11.1 36.3 9.5 9.5 22.9 13.7 36.3 11.1l70.8-13.7 40.4 59.9C230 505.3 242.6 512 256 512s26-6.7 33.5-17.8l40.4-59.9c-14.6-7.2-27.7-16.8-38.7-28.6L256 458zm0-258c17.1 0 32.3 7.9 42.6 20.1 11.8-10.8 25.8-19.3 41.1-25.3-19-25.8-49.3-42.8-83.7-42.8-57.3 0-104 46.7-104 104s46.7 104 104 104c2.6 0 5.1-.6 7.7-.8-4.6-13.4-7.7-27.5-7.7-42.4 0-1.6.4-3.2.4-4.8h-.4c-30.9 0-56-25.1-56-56s25.1-56 56-56z"
  ]
};
export const faSunDust = {
  prefix: "far",
  iconName: "sun-dust",
  icon: [
    512,
    512,
    [],
    "f764",
    "M160 448c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm320-256c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm-96 96c0-17.7-14.3-32-32-32s-32 14.3-32 32 14.3 32 32 32 32-14.3 32-32zm-144 64c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm160 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm80 96c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm0-192c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zM320 448c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm-64-248c15.4 0 29.4 6.3 39.6 16.4l33.9-33.9C310.7 163.7 284.7 152 256 152c-57.3 0-104 46.7-104 104 0 28.7 11.7 54.7 30.5 73.5l33.9-33.9C206.3 285.4 200 271.4 200 256c0-30.9 25.1-56 56-56zM400.8 62.9l-70.9 13.7-40.4-59.9c-15.1-22.3-51.9-22.3-67 0l-40.4 59.9-70.8-13.7C98 60.4 84.5 64.5 75 74.1c-9.5 9.6-13.7 23.1-11.1 36.3l13.7 71-59.8 40.5C6.6 229.5 0 242 0 255.5s6.7 26 17.8 33.5l59.8 40.5-13.7 71c-2.6 13.2 1.6 26.8 11.1 36.3l.1.1 38.3-38.3-.3.1 17.6-91.2-76.8-52 76.8-52-17.6-91.2 91 17.6L256 53l51.9 76.9 91-17.6-.2 1 38.8-38.8c-.2-.2-.2-.4-.4-.5-9.6-9.5-23.3-13.6-36.3-11.1z"
  ]
};
export const faSunHaze = {
  prefix: "far",
  iconName: "sun-haze",
  icon: [
    640,
    512,
    [],
    "f765",
    "M80 336h336c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16zm544-48H496c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zM208 464H80c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zm416 0H288c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h336c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zm-48-56v-16c0-8.8-7.2-16-16-16H16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h544c8.8 0 16-7.2 16-16zM194.7 203.5l-17.6-91.2 91 17.6L320 53l51.9 76.9 91-17.6-17.6 91.1 54 36.6h73.4c-3-7.2-7.8-13.6-14.4-18.1l-59.8-40.5 13.7-71c2.6-13.2-1.6-26.8-11.1-36.4-9.6-9.5-23.2-13.7-36.2-11.1L394 76.6l-40.4-59.9c-15.1-22.3-51.9-22.3-67 0l-40.4 59.9-70.8-13.7c-13.3-2.6-26.8 1.6-36.3 11.1-9.5 9.6-13.7 23.1-11.1 36.3l13.7 71-59.8 40.5c-6.6 4.5-11.4 10.9-14.4 18.1h73.4l53.8-36.4zm22.9 36.5h49c6.9-23 28.1-40 53.4-40s46.5 17 53.4 40h49c-7.8-49.7-50.5-88-102.4-88s-94.6 38.3-102.4 88z"
  ]
};
export const faSunglasses = {
  prefix: "far",
  iconName: "sunglasses",
  icon: [
    576,
    512,
    [],
    "f892",
    "M574.09 280.38L528.75 98.66a87.94 87.94 0 0 0-113.19-62.14l-15.25 5.08a16 16 0 0 0-10.12 20.25L395.25 77a16 16 0 0 0 20.22 10.13l13.19-4.39c10.87-3.63 23-3.57 33.15 1.73a39.59 39.59 0 0 1 20.38 25.81l38.47 153.83a276.7 276.7 0 0 0-81.22-12.47c-39.88 0-85.63 9.2-133 36.34h-36.85c-47.4-27.15-93.12-36.34-133-36.34a276.75 276.75 0 0 0-81.22 12.45l38.44-153.8a39.61 39.61 0 0 1 20.38-25.82c10.15-5.29 22.28-5.34 33.15-1.73l13.16 4.39A16 16 0 0 0 180.75 77l5.06-15.19a16 16 0 0 0-10.12-20.21l-15.25-5.08A87.95 87.95 0 0 0 47.25 98.65L1.91 280.38A75.35 75.35 0 0 0 0 295.86v70.25C0 429 51.59 480 115.19 480h37.12c60.28 0 110.38-45.94 114.88-105.37l2.93-38.63h35.76l2.93 38.63c4.5 59.43 54.6 105.37 114.88 105.37h37.12C524.41 480 576 429 576 366.13v-70.25a62.67 62.67 0 0 0-1.91-15.5zM48 366.11v-48.47c19.78-8.18 51.22-18 88.59-18zM356.66 371l-4-52.81a213.46 213.46 0 0 1 86.78-18.53z"
  ]
};
export const faSunrise = {
  prefix: "far",
  iconName: "sunrise",
  icon: [
    576,
    512,
    [],
    "f766",
    "M560 464h-68.5l29.4-44.7c7.4-11.2 8.7-25.3 3.6-37.8-5.2-12.4-16.1-21.5-29.3-24.2l-70.7-14.5L410 272c-2.7-13.2-11.7-24.2-24.2-29.4-12.5-5.2-26.7-3.7-37.7 3.6L287.8 286l-60.2-39.9c-22.5-14.9-56.5-.8-61.9 25.7l-14.4 70.8L80.6 357c-13.3 2.7-24.1 11.7-29.3 24.2-5.1 12.5-3.8 26.6 3.7 37.8l29.7 45H16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h544c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zm-325.4 0c4.7-15.6 16-29 32.2-35.7 28.5-11.8 61.4 1.8 73.2 30.3.7 1.8 1.1 3.6 1.6 5.4h-107zm199.4 0h-43.3c-1.2-8-3.1-16-6.3-23.8-21.9-53-82.9-78.2-135.9-56.3-34.7 14.4-57.4 45.5-62.8 80.1h-43.4l-40.9-62.1 90.8-18.6 18.5-90.9 77.4 51.2 77.3-51.1 18.7 90.9 90.8 18.7L434 464zM190.2 135.6c6.2 6.3 16.4 6.3 22.6.1L264 84.9V192c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V84.9l51.1 50.8c6.3 6.2 16.4 6.2 22.6-.1l11.3-11.4c6.2-6.3 6.2-16.4-.1-22.6l-97.7-97c-6.2-6.2-16.3-6.2-22.5 0l-97.7 97c-6.3 6.2-6.3 16.4-.1 22.6l11.3 11.4z"
  ]
};
export const faSunset = {
  prefix: "far",
  iconName: "sunset",
  icon: [
    576,
    512,
    [],
    "f767",
    "M560 464h-68.5l29.4-44.7c7.4-11.2 8.7-25.3 3.6-37.8-5.2-12.4-16.1-21.5-29.3-24.2l-70.7-14.5L410 272c-2.7-13.2-11.7-24.2-24.2-29.4-12.5-5.2-26.7-3.7-37.7 3.6L287.8 286l-60.2-39.9c-22.5-14.9-56.5-.8-61.9 25.7l-14.4 70.8L80.6 357c-13.3 2.7-24.1 11.7-29.3 24.2-5.1 12.5-3.8 26.6 3.7 37.8l29.7 45H16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h544c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zm-325.4 0c4.7-15.6 16-29 32.2-35.7 28.5-11.8 61.4 1.8 73.2 30.3.7 1.8 1.1 3.6 1.6 5.4h-107zm199.4 0h-43.3c-1.2-8-3.1-16-6.3-23.8-21.9-53-82.9-78.2-135.9-56.3-34.7 14.4-57.4 45.5-62.8 80.1h-43.4l-40.9-62.1 90.8-18.6 18.5-90.9 77.4 51.2 77.3-51.1 18.7 90.9 90.8 18.7L434 464zM276.7 203.4c6.2 6.2 16.3 6.2 22.5 0l97.7-97c6.3-6.2 6.3-16.4.1-22.6l-11.3-11.4c-6.2-6.3-16.4-6.3-22.6-.1L312 123.1V16c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16v107.1l-51.1-50.8c-6.3-6.2-16.4-6.2-22.6.1L179 83.8c-6.2 6.3-6.2 16.4.1 22.6l97.6 97z"
  ]
};
export const faSuperscript = {
  prefix: "far",
  iconName: "superscript",
  icon: [
    512,
    512,
    [],
    "f12b",
    "M336 64h-52.28a16 16 0 0 0-13.31 7.12L176 212.73 81.59 71.12A16 16 0 0 0 68.28 64H16A16 16 0 0 0 0 80v16a16 16 0 0 0 16 16h35.16l96 144-96 144H16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h52.28a16 16 0 0 0 13.31-7.12L176 299.27l94.41 141.61a16 16 0 0 0 13.31 7.12H336a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16h-35.16l-96-144 96-144H336a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm160 112h-24V16a16 16 0 0 0-16-16h-32a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 408 64h16v112h-24a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16z"
  ]
};
export const faSurprise = {
  prefix: "far",
  iconName: "surprise",
  icon: [
    496,
    512,
    [],
    "f5c2",
    "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm0-176c-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64-28.7-64-64-64zm-48-72c0-17.7-14.3-32-32-32s-32 14.3-32 32 14.3 32 32 32 32-14.3 32-32zm128-32c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"
  ]
};
export const faSwatchbook = {
  prefix: "far",
  iconName: "swatchbook",
  icon: [
    512,
    512,
    [],
    "f5c3",
    "M112 424c13.25 0 24-10.75 24-24 0-13.26-10.75-24-24-24s-24 10.74-24 24c0 13.25 10.75 24 24 24zm368-136h-97.61l69.02-69.02c12.5-12.5 12.5-32.76 0-45.25L338.27 60.59c-6.25-6.25-14.44-9.37-22.63-9.37s-16.38 3.12-22.63 9.37L224 129.61V32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v368c0 61.86 50.14 112 112 112h368c17.67 0 32-14.33 32-32V320c0-17.67-14.33-32-32-32zM176 400c0 17.88-7.41 34.03-19.27 45.65-3.65 3.57-7.7 6.53-11.99 9.05-.86.51-1.76.96-2.64 1.43-4.47 2.34-9.12 4.31-14.02 5.57-5.16 1.35-10.48 2.29-16.06 2.29H112c-35.29 0-64-28.71-64-64v-96h128V400zm0-144H48v-80h128v80zm0-128H48V48h128v80zm48 69.49l91.65-91.65 90.51 90.51L224 378.51V197.49zM464 464H206.39l128-128H464v128z"
  ]
};
export const faSwimmer = {
  prefix: "far",
  iconName: "swimmer",
  icon: [
    640,
    512,
    [],
    "f5c4",
    "M185.53 323.38c1.34 1.12 2.77 1.99 4.08 3.2 3.53 3.26 15.27 9.42 34.39 9.42 4.81 0 9.14-.39 13.01-1.03l25.79-36.11c14.89-20.87 31.42-40.34 48.71-59.11L442.1 331.2c3.89-1.63 6.91-3.34 8.3-4.62 11.97-11.04 25.32-18.17 39.21-21.08L346.12 205.02c20.66-19.12 42.3-37.27 65.59-53.58 9.31-6.52 21.1-8.89 33.09-6.41l102.38 18.08c13.32 2.28 26.04-6.33 28.43-19.37 2.39-13.05-6.44-25.52-19.76-27.87L454.26 97.94c-24.67-5.16-50.55.08-70.98 14.44-92.89 65.05-147.56 140.71-160.58 158.95l-37.17 52.05zM624 368h-16c-26.04 0-45.8-8.42-56.09-17.9-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C461.8 359.58 442.04 368 416 368s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C269.8 359.58 250.04 368 224 368s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C77.8 359.58 58.04 368 32 368H16c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h16c38.62 0 72.72-12.19 96-31.84 23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84h16c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16zm-496-80c53.02 0 96-42.98 96-96s-42.98-96-96-96-96 42.98-96 96 42.98 96 96 96zm0-144c26.47 0 48 21.53 48 48s-21.53 48-48 48-48-21.53-48-48 21.53-48 48-48z"
  ]
};
export const faSwimmingPool = {
  prefix: "far",
  iconName: "swimming-pool",
  icon: [
    640,
    512,
    [],
    "f5c5",
    "M624 432h-16c-26.04 0-45.8-8.42-56.09-17.9-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C461.8 423.58 442.04 432 416 432s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C269.8 423.58 250.04 432 224 432s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C77.8 423.58 58.04 432 32 432H16c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h16c38.62 0 72.72-12.19 96-31.84 23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84h16c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16zm-408-32.63V288h208v111.37c14.22-1.43 23.4-6.04 26.39-8.79 6.79-6.26 14.09-10.98 21.61-14.67V120c0-22.06 17.94-40 40-40s40 17.94 40 40v24c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-24c0-48.53-39.47-88-88-88s-88 39.47-88 88v120H216V120c0-22.06 17.94-40 40-40s40 17.94 40 40v24c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-24c0-48.53-39.47-88-88-88s-88 39.47-88 88v255.9c7.52 3.69 14.82 8.41 21.61 14.67 2.98 2.76 12.17 7.38 26.39 8.8z"
  ]
};
export const faSword = {
  prefix: "far",
  iconName: "sword",
  icon: [
    512,
    512,
    [],
    "f71c",
    "M511.84 18.27C513.23 8.49 505.57 0 496.04 0c-.76 0-1.53.05-2.31.16L400 16 148.51 267.49l-38.82-38.82c-6.22-6.22-16.31-6.23-22.54 0L68.43 247.4c-5.37 5.37-6.21 13.79-1.99 20.11l53.19 79.79-53.23 53.22-29.15-14.57c-1.21-.61-9.25-4.14-15.97 2.59L4.05 405.76c-5.4 5.41-5.4 14.17 0 19.57l82.62 82.62c2.7 2.7 6.24 4.05 9.78 4.05s7.08-1.35 9.79-4.05l17.23-17.23a13.84 13.84 0 0 0 2.59-15.97l-14.57-29.15 53.22-53.23 79.79 53.19c6.32 4.21 14.74 3.38 20.11-1.99l18.73-18.72c6.22-6.22 6.22-16.32 0-22.54l-38.82-38.82L496 112l15.84-93.73zm-60.62 70.62L210.57 329.55l-28.12-28.12L423.11 60.77l33.83-5.72-5.72 33.84z"
  ]
};
export const faSwordLaser = {
  prefix: "far",
  iconName: "sword-laser",
  icon: [
    512,
    512,
    [],
    "e03b",
    "M176.53532,223.49668a8.003,8.003,0,0,0-11.31445,0l-11.31249,11.31446a7.99945,7.99945,0,0,0,0,11.31446l4.48047,4.47851L15.99828,393.00458a54.62106,54.62106,0,0,0,0,77.24613l25.75,25.752a54.61858,54.61858,0,0,0,77.24411-.002L261.3849,353.60026l5.66015,5.66211a8.003,8.003,0,0,0,11.31445,0L289.672,347.94791a7.99708,7.99708,0,0,0,0-11.3125ZM85.051,462.06125a6.62791,6.62791,0,0,1-9.35937.00391L49.93968,436.31124a6.632,6.632,0,0,1,0-9.36719l63.19723-63.19925,35.11327,35.1133Zm74.51168-74.51566-35.11326-35.11525,11.31445-11.31251,35.11326,35.1133Zm22.6289-22.62892-35.11327-35.1133,11.31055-11.31446,35.11522,35.1133Zm22.625-22.62892-35.11327-35.1133,11.31445-11.3125,35.11327,35.1133ZM503.28323,8.71532a29.769,29.769,0,0,0-41.26561-.79492l-237.58779,218.215,61.43552,61.43558,218.2128-237.588A29.76768,29.76768,0,0,0,503.28323,8.71532Z"
  ]
};
export const faSwordLaserAlt = {
  prefix: "far",
  iconName: "sword-laser-alt",
  icon: [
    512,
    512,
    [],
    "e03c",
    "M118.99181,496.002,330.47444,283.28146c10.03322-10.09374,2.88477-27.28122-11.34571-27.28122h-159.508a16.00015,16.00015,0,0,0-11.31251,4.68554L15.99757,393.004a54.625,54.625,0,0,0,0,77.248l25.74807,25.75a54.62171,54.62171,0,0,0,77.24617,0Zm53.88287-192.00178h70.22663l-70.2403,70.246L137.74769,339.131ZM49.9351,436.30867a6.61787,6.61787,0,0,1,.002-9.36328L115.12462,361.756l10.45509,10.457-69.86726,69.871Zm25.752,25.75193-5.7754-5.77734,69.86726-69.871,10.459,10.459L85.05037,462.0606a6.62024,6.62024,0,0,1-9.36329,0ZM503.28321,8.7153a29.76908,29.76908,0,0,0-41.26567-.79492L226.75559,224.00026H344.24985L504.07813,49.98284A29.76757,29.76757,0,0,0,503.28321,8.7153Z"
  ]
};
export const faSwords = {
  prefix: "far",
  iconName: "swords",
  icon: [
    512,
    512,
    [],
    "f71d",
    "M507.31 462.06L448 402.75l31.64-59.03c3.33-6.22 2.2-13.88-2.79-18.87l-17.54-17.53c-6.25-6.25-16.38-6.25-22.63 0L420 324 112 16 18.27.16C8.27-1.27-1.42 7.17.17 18.26l15.84 93.73 308 308-16.69 16.69c-6.25 6.25-6.25 16.38 0 22.62l17.53 17.54a16 16 0 0 0 18.87 2.79L402.75 448l59.31 59.31c6.25 6.25 16.38 6.25 22.63 0l22.62-22.62c6.25-6.25 6.25-16.38 0-22.63zm-149.36-76.01L60.78 88.89l-5.72-33.83 33.84 5.72 297.17 297.16-28.12 28.11zm65.17-325.27l33.83-5.72-5.72 33.84L340.7 199.43l33.94 33.94L496.01 112l15.84-93.73c1.43-10-7.01-19.69-18.1-18.1l-93.73 15.84-121.38 121.36 33.94 33.94L423.12 60.78zM199.45 340.69l-45.38 45.38-28.12-28.12 45.38-45.38-33.94-33.94-45.38 45.38-16.69-16.69c-6.25-6.25-16.38-6.25-22.62 0l-17.54 17.53a16 16 0 0 0-2.79 18.87L64 402.75 4.69 462.06c-6.25 6.25-6.25 16.38 0 22.63l22.62 22.62c6.25 6.25 16.38 6.25 22.63 0L109.25 448l59.03 31.64c6.22 3.33 13.88 2.2 18.87-2.79l17.53-17.54c6.25-6.25 6.25-16.38 0-22.63L188 420l45.38-45.38-33.93-33.93z"
  ]
};
export const faSwordsLaser = {
  prefix: "far",
  iconName: "swords-laser",
  icon: [
    640,
    512,
    [],
    "e03d",
    "M136.77186,8.71727a29.77142,29.77142,0,0,0-.79483,41.26562l216.0556,235.26173V167.75048L178.03476,7.92234A29.76184,29.76184,0,0,0,136.77186,8.71727Zm487.23191,384.291L411.30716,181.52587a15.99854,15.99854,0,0,0-27.27816,11.3457V352.37939a16.00105,16.00105,0,0,0,4.685,11.3125L521.01739,496.00244a54.61454,54.61454,0,0,0,77.23929,0l25.74709-25.748a54.626,54.626,0,0,0,0-77.24609ZM432.02356,339.12548V268.89892l70.23814,70.24023-35.11126,35.11329ZM564.31717,462.06494a6.6166,6.6166,0,0,1-9.36222-.00195l-65.18207-65.18751,10.45585-10.45507L570.0919,456.2876Zm25.749-25.75195-5.77669,5.77539-69.86317-69.86719,10.4578-10.459,65.18206,65.1875a6.62075,6.62075,0,0,1,0,9.36329ZM414.60757,147.31493l89.4137-97.332a29.76239,29.76239,0,0,0-42.05579-42.0625L343.66834,116.61766l30.00832,27.56446,5.79426,5.32226a47.89343,47.89343,0,0,1,20.67149-4.66406A47.27194,47.27194,0,0,1,414.60757,147.31493Zm-173.951,63.957-39.79822,36.57032-24.343-24.34571a8.00142,8.00142,0,0,0-11.31317,0L153.891,234.811a8.00009,8.00009,0,0,0,0,11.31445l4.48,4.47851L15.99648,393.00439a54.62537,54.62537,0,0,0,0,77.2461l25.74708,25.75195a54.60807,54.60807,0,0,0,77.23539-.00195L261.3554,353.60009l5.65951,5.66211a8.00143,8.00143,0,0,0,11.31318,0l11.31121-11.31445a7.99772,7.99772,0,0,0,0-11.3125l-25.51078-25.51368,34.11723-37.13867ZM85.04139,462.061a6.62663,6.62663,0,0,1-9.35831.00391L49.934,436.311a6.63257,6.63257,0,0,1,0-9.36719l63.19011-63.19922,35.1093,35.11329Zm74.50328-74.51562-35.10931-35.11524,11.31318-11.3125,35.1093,35.11328ZM182.171,364.9165l-35.1093-35.11328L158.371,318.48876l35.11126,35.11329Zm22.62244-22.62891-35.10931-35.11328,11.31318-11.3125,35.1093,35.11328Z"
  ]
};
export const faSynagogue = {
  prefix: "far",
  iconName: "synagogue",
  icon: [
    640,
    512,
    [],
    "f69b",
    "M320 320c-45.52 0-64 41.61-64 66.75V496c0 8.84 7.16 16 16 16h96c8.84 0 16-7.16 16-16V384c0-35.35-28.65-64-64-64zm311.99-51.71l-76-71.78c-3.19-3.01-7.59-4.51-12-4.51s-8.81 1.5-12 4.51l-36 34v-82.68a35.21 35.21 0 0 0-13.21-27.49L341.99 7.71A35.157 35.157 0 0 0 320 0c-7.78 0-15.56 2.57-21.99 7.71l-140.8 112.64A35.196 35.196 0 0 0 144 147.84v82.67l-36-34c-3.19-3.01-7.59-4.51-12-4.51s-8.81 1.5-12 4.51L8 268.29c-5.15 4.87-8 11.14-8 17.64V496c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V296.54l48-45.33 48 45.33V496c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V153.99l128-102.4 128 102.4V496c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V296.54l48-45.33 48 45.33V496c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V285.93c0-6.5-2.85-12.77-8.01-17.64zM388.06 154.2h-38.95L324 114.21c-1.85-2.95-6.15-2.95-8 0l-25.12 39.98h-38.94c-3.72 0-5.98 4.09-4 7.24l19.2 30.56-19.2 30.56c-1.98 3.15.29 7.24 4 7.24h38.94l25.12 40c1.85 2.95 6.15 2.95 8 0l25.12-39.98h38.94c3.72 0 5.98-4.09 4-7.24L372.87 192l19.2-30.56c1.97-3.15-.29-7.24-4.01-7.24z"
  ]
};
export const faSync = {
  prefix: "far",
  iconName: "sync",
  icon: [
    512,
    512,
    [],
    "f021",
    "M500 8h-27.711c-6.739 0-12.157 5.548-11.997 12.286l2.347 98.575C418.212 52.043 342.256 8 256 8 134.813 8 33.933 94.924 12.296 209.824 10.908 217.193 16.604 224 24.103 224h28.576c5.674 0 10.542-3.982 11.737-9.529C83.441 126.128 161.917 60 256 60c79.545 0 147.942 47.282 178.676 115.302l-126.39-3.009c-6.737-.16-12.286 5.257-12.286 11.997V212c0 6.627 5.373 12 12 12h192c6.627 0 12-5.373 12-12V20c0-6.627-5.373-12-12-12zm-12.103 280h-28.576c-5.674 0-10.542 3.982-11.737 9.529C428.559 385.872 350.083 452 256 452c-79.546 0-147.942-47.282-178.676-115.302l126.39 3.009c6.737.16 12.286-5.257 12.286-11.997V300c0-6.627-5.373-12-12-12H12c-6.627 0-12 5.373-12 12v192c0 6.627 5.373 12 12 12h27.711c6.739 0 12.157-5.548 11.997-12.286l-2.347-98.575C93.788 459.957 169.744 504 256 504c121.187 0 222.067-86.924 243.704-201.824 1.388-7.369-4.308-14.176-11.807-14.176z"
  ]
};
export const faSyncAlt = {
  prefix: "far",
  iconName: "sync-alt",
  icon: [
    512,
    512,
    [],
    "f2f1",
    "M483.515 28.485L431.35 80.65C386.475 35.767 324.485 8 256 8 123.228 8 14.824 112.338 8.31 243.493 7.971 250.311 13.475 256 20.301 256h28.045c6.353 0 11.613-4.952 11.973-11.294C66.161 141.649 151.453 60 256 60c54.163 0 103.157 21.923 138.614 57.386l-54.128 54.129c-7.56 7.56-2.206 20.485 8.485 20.485H492c6.627 0 12-5.373 12-12V36.971c0-10.691-12.926-16.045-20.485-8.486zM491.699 256h-28.045c-6.353 0-11.613 4.952-11.973 11.294C445.839 370.351 360.547 452 256 452c-54.163 0-103.157-21.923-138.614-57.386l54.128-54.129c7.56-7.56 2.206-20.485-8.485-20.485H20c-6.627 0-12 5.373-12 12v143.029c0 10.691 12.926 16.045 20.485 8.485L80.65 431.35C125.525 476.233 187.516 504 256 504c132.773 0 241.176-104.338 247.69-235.493.339-6.818-5.165-12.507-11.991-12.507z"
  ]
};
export const faSyringe = {
  prefix: "far",
  iconName: "syringe",
  icon: [
    512,
    512,
    [],
    "f48e",
    "M475.7 115.5c3.1 3.1 8.2 3.1 11.3 0l22.6-22.6c3.1-3.1 3.1-8.2 0-11.3L430.5 2.3c-3.1-3.1-8.2-3.1-11.3 0L396.5 25c-3.1 3.1-3.1 8.2 0 11.3l22.6 22.6-33.9 33.9L317.3 25c-3.1-3.1-8.2-3.1-11.3 0l-22.6 22.6c-3.1 3.1-3.1 8.2 0 11.3l11.3 11.3L78.9 286.1c-19 19-28.2 45.2-25.2 72l7.8 69.9-59.2 59c-3.1 3.1-3.1 8.2 0 11.3l11.3 11.3c3.1 3.1 8.2 3.1 11.3 0l59.1-59c74.8 8.3 73 8.3 79.8 8.3 23.2 0 45.4-9.1 62.1-25.8l215.8-215.8 11.3 11.3c3.1 3.1 8.2 3.1 11.3 0L487 206c3.1-3.1 3.1-8.2 0-11.3l-67.9-67.9L453 92.9l22.7 22.6zM192 399.2c-8.6 8.7-20.6 12.9-32.7 11.5l-52.2-5.8-5.8-52.1c-1.3-12.2 2.9-24.1 11.5-32.7l12.2-12.2 28.3 28.3c6.2 6.2 16.4 6.2 22.6 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6L158.9 274l33.9-33.9 28.3 28.3c6.2 6.2 16.4 6.2 22.6 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6L226.8 206l33.9-33.9 28.3 28.3c6.2 6.2 16.4 6.2 22.6 0L323 189c6.2-6.2 6.2-16.4 0-22.6l-28.3-28.3 33.9-33.9 79.2 79.2L192 399.2z"
  ]
};
export const faTable = {
  prefix: "far",
  iconName: "table",
  icon: [
    512,
    512,
    [],
    "f0ce",
    "M464 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM232 432H54a6 6 0 0 1-6-6V296h184v136zm0-184H48V112h184v136zm226 184H280V296h184v130a6 6 0 0 1-6 6zm6-184H280V112h184v136z"
  ]
};
export const faTableTennis = {
  prefix: "far",
  iconName: "table-tennis",
  icon: [
    512,
    512,
    [],
    "f45d",
    "M483.2 325.8c46.5-83.4 35.4-190.7-35.2-261.5C406.6 22.8 351.7 0 293.2 0c-105.4 0-152.7 62.3-218 127.7-50.9 51-50.9 134 0 185.1l13.1 13.1-73.9 64.2c-18.3 15.9-19.3 44-2.2 61.1l48.4 48.5c17.7 17.8 45.8 15.6 61.2-2.2l63.9-73.9c10.1 10.1 53.4 64.5 130.6 50.1C336.8 497 366.6 512 400 512c61.8 0 112-50.2 112-112 0-28.6-11.1-54.4-28.8-74.2zM293.2 48c45.6 0 88.5 17.8 120.7 50.1 53.8 53.9 63.4 134.7 30.3 199.1-58.1-25.1-105 5.9-122.3 22.8L136.3 134.4C167.6 103.1 209.2 48 293.2 48zm-110 305.1l-93.3 108-39-39.1 107.7-93.6-49.5-49.5c-29.9-30-31.7-77.3-6-109.8l192.2 192.2c-10.5 28.3-7.7 49.4-3.7 65.4-43-.1-56.5-21.6-108.4-73.6zM400 464c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64z"
  ]
};
export const faTablet = {
  prefix: "far",
  iconName: "tablet",
  icon: [
    448,
    512,
    [],
    "f10a",
    "M256 416c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-21.3 14.3-32 32-32s32 14.3 32 32zM448 48v416c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V48C0 21.5 21.5 0 48 0h352c26.5 0 48 21.5 48 48zm-48 410V54c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v404c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
  ]
};
export const faTabletAlt = {
  prefix: "far",
  iconName: "tablet-alt",
  icon: [
    448,
    512,
    [],
    "f3fa",
    "M356 368H92c-6.6 0-12-5.4-12-12V92c0-6.6 5.4-12 12-12h264c6.6 0 12 5.4 12 12v264c0 6.6-5.4 12-12 12zm92-320v416c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V48C0 21.5 21.5 0 48 0h352c26.5 0 48 21.5 48 48zm-48 410V54c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v404c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6zm-176-74c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"
  ]
};
export const faTabletAndroid = {
  prefix: "far",
  iconName: "tablet-android",
  icon: [
    448,
    512,
    [],
    "f3fb",
    "M400 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zm-6 464H54c-3.3 0-6-2.7-6-6V54c0-3.3 2.7-6 6-6h340c3.3 0 6 2.7 6 6v404c0 3.3-2.7 6-6 6zm-118-32H172c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h104c6.6 0 12 5.4 12 12v8c0 6.6-5.4 12-12 12z"
  ]
};
export const faTabletAndroidAlt = {
  prefix: "far",
  iconName: "tablet-android-alt",
  icon: [
    448,
    512,
    [],
    "f3fc",
    "M356 368H92c-6.6 0-12-5.4-12-12V92c0-6.6 5.4-12 12-12h264c6.6 0 12 5.4 12 12v264c0 6.6-5.4 12-12 12zm92-320v416c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V48C0 21.5 21.5 0 48 0h352c26.5 0 48 21.5 48 48zm-48 410V54c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v404c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6zm-112-38v-8c0-6.6-5.4-12-12-12H172c-6.6 0-12 5.4-12 12v8c0 6.6 5.4 12 12 12h104c6.6 0 12-5.4 12-12z"
  ]
};
export const faTabletRugged = {
  prefix: "far",
  iconName: "tablet-rugged",
  icon: [
    448,
    512,
    [],
    "f48f",
    "M439.2 164.4c5.4-2.7 8.8-8.2 8.8-14.3V73.9c0-6.1-3.4-11.6-8.8-14.3L416 48c0-26.5-21.5-48-48-48H80C53.5 0 32 21.5 32 48L8.8 59.6C3.4 62.3 0 67.8 0 73.9v76.2c0 6.1 3.4 11.6 8.8 14.3L32 176v16L8.8 203.6c-5.4 2.7-8.8 8.2-8.8 14.3v76.2c0 6.1 3.4 11.6 8.8 14.3L32 320v16L8.8 347.6c-5.4 2.7-8.8 8.2-8.8 14.3v76.2c0 6.1 3.4 11.6 8.8 14.3L32 464c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48l23.2-11.6c5.4-2.7 8.8-8.2 8.8-14.3v-76.2c0-6.1-3.4-11.6-8.8-14.3L416 336v-16l23.2-11.6c5.4-2.7 8.8-8.2 8.8-14.3v-76.2c0-6.1-3.4-11.6-8.8-14.3L416 192v-16l23.2-11.6zM368 448c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h256c8.8 0 16 7.2 16 16v384z"
  ]
};
export const faTablets = {
  prefix: "far",
  iconName: "tablets",
  icon: [
    640,
    512,
    [],
    "f490",
    "M160 192C71.6 192 0 263.6 0 352s71.6 160 160 160 160-71.6 160-160-71.6-160-160-160zM50.7 376h218.5c-25.6 117-192.8 116.7-218.5 0zm0-48c25.7-116.9 192.9-116.9 218.5 0H50.7zM593.1 46.9c-62.4-62.4-163.8-62.5-226.3 0s-62.5 163.8 0 226.3c62.4 62.4 163.8 62.5 226.3 0s62.5-163.9 0-226.3zM385.8 99.7l154.5 154.5C439.7 318.8 321 200.5 385.8 99.7zm188.4 120.6L419.7 65.8C520.3 1.1 639 119.5 574.2 220.3z"
  ]
};
export const faTachometer = {
  prefix: "far",
  iconName: "tachometer",
  icon: [
    576,
    512,
    [],
    "f0e4",
    "M288 32C128.94 32 0 160.94 0 320c0 52.8 14.25 102.26 39.06 144.8 5.61 9.62 16.3 15.2 27.44 15.2h443c11.14 0 21.83-5.58 27.44-15.2C561.75 422.26 576 372.8 576 320c0-159.06-128.94-288-288-288zm212.27 400H75.73C57.56 397.63 48 359.12 48 320 48 187.66 155.66 80 288 80s240 107.66 240 240c0 39.12-9.56 77.63-27.73 112zM359.59 137.23c-12.72-4.23-26.16 2.62-30.38 15.17l-45.34 136.01C250.49 290.58 224 318.06 224 352c0 11.72 3.38 22.55 8.88 32h110.25c5.5-9.45 8.88-20.28 8.88-32 0-19.45-8.86-36.66-22.55-48.4l45.34-136.01c4.17-12.57-2.64-26.17-15.21-30.36z"
  ]
};
export const faTachometerAlt = {
  prefix: "far",
  iconName: "tachometer-alt",
  icon: [
    576,
    512,
    [],
    "f3fd",
    "M128 288c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm154.65-97.08l16.24-48.71c1.16-3.45 3.18-6.35 4.92-9.43-4.73-2.76-9.94-4.78-15.81-4.78-17.67 0-32 14.33-32 32 0 15.78 11.63 28.29 26.65 30.92zM176 176c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zM288 32C128.94 32 0 160.94 0 320c0 52.8 14.25 102.26 39.06 144.8 5.61 9.62 16.3 15.2 27.44 15.2h443c11.14 0 21.83-5.58 27.44-15.2C561.75 422.26 576 372.8 576 320c0-159.06-128.94-288-288-288zm212.27 400H75.73C57.56 397.63 48 359.12 48 320 48 187.66 155.66 80 288 80s240 107.66 240 240c0 39.12-9.56 77.63-27.73 112zM416 320c0 17.67 14.33 32 32 32s32-14.33 32-32-14.33-32-32-32-32 14.33-32 32zm-56.41-182.77c-12.72-4.23-26.16 2.62-30.38 15.17l-45.34 136.01C250.49 290.58 224 318.06 224 352c0 11.72 3.38 22.55 8.88 32h110.25c5.5-9.45 8.88-20.28 8.88-32 0-19.45-8.86-36.66-22.55-48.4l45.34-136.01c4.17-12.57-2.64-26.17-15.21-30.36zM432 208c0-15.8-11.66-28.33-26.72-30.93-.07.21-.07.43-.14.65l-19.5 58.49c4.37 2.24 9.11 3.8 14.36 3.8 17.67-.01 32-14.34 32-32.01z"
  ]
};
export const faTachometerAltAverage = {
  prefix: "far",
  iconName: "tachometer-alt-average",
  icon: [
    576,
    512,
    [],
    "f624",
    "M176 176c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm-48 112c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm304-80c0-17.67-14.33-32-32-32s-32 14.33-32 32 14.33 32 32 32 32-14.33 32-32zm-16 112c0 17.67 14.33 32 32 32s32-14.33 32-32-14.33-32-32-32-32 14.33-32 32zM288 32C128.94 32 0 160.94 0 320c0 52.8 14.25 102.26 39.06 144.8 5.61 9.62 16.3 15.2 27.44 15.2h443c11.14 0 21.83-5.58 27.44-15.2C561.75 422.26 576 372.8 576 320c0-159.06-128.94-288-288-288zm212.27 400H75.73C57.56 397.63 48 359.12 48 320 48 187.66 155.66 80 288 80s240 107.66 240 240c0 39.12-9.56 77.63-27.73 112zM312 292.75V160c0-13.25-10.75-24-24-24s-24 10.75-24 24v132.75c-23.44 9.5-40 32.41-40 59.25 0 11.72 3.38 22.55 8.88 32h110.25c5.5-9.45 8.88-20.28 8.88-32-.01-26.85-16.57-49.75-40.01-59.25z"
  ]
};
export const faTachometerAltFast = {
  prefix: "far",
  iconName: "tachometer-alt-fast",
  icon: [
    576,
    512,
    [],
    "f625",
    "M416 320c0 17.67 14.33 32 32 32s32-14.33 32-32-14.33-32-32-32-32 14.33-32 32zm-192 32c0 11.72 3.38 22.55 8.88 32h110.25c5.5-9.45 8.88-20.28 8.88-32 0-11.67-3.36-22.46-8.81-31.88l75.75-97.39c8.16-10.47 6.25-25.55-4.19-33.67-10.56-8.17-25.56-6.25-33.69 4.2l-75.76 97.4c-5.54-1.56-11.27-2.67-17.3-2.67C252.65 288 224 316.65 224 352zm96-192c0-17.67-14.33-32-32-32s-32 14.33-32 32 14.33 32 32 32 32-14.33 32-32zM128 288c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm48-48c17.67 0 32-14.33 32-32s-14.33-32-32-32-32 14.33-32 32 14.33 32 32 32zM0 320c0 52.8 14.25 102.26 39.06 144.8 5.61 9.62 16.3 15.2 27.44 15.2h443c11.14 0 21.83-5.58 27.44-15.2C561.75 422.26 576 372.8 576 320c0-159.06-128.94-288-288-288S0 160.94 0 320zm48 0C48 187.66 155.66 80 288 80s240 107.66 240 240c0 39.12-9.56 77.63-27.73 112H75.73C57.56 397.63 48 359.12 48 320z"
  ]
};
export const faTachometerAltFastest = {
  prefix: "far",
  iconName: "tachometer-alt-fastest",
  icon: [
    576,
    512,
    [],
    "f626",
    "M400 240c17.67 0 32-14.33 32-32s-14.33-32-32-32-32 14.33-32 32 14.33 32 32 32zm-272 48c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm160-96c17.67 0 32-14.33 32-32s-14.33-32-32-32-32 14.33-32 32 14.33 32 32 32zm155.28 104.47l-101.87 20.38C329.96 299.49 310.35 288 288 288c-35.35 0-64 28.65-64 64 0 11.72 3.38 22.55 8.88 32h110.25c3.54-6.08 5.73-12.89 7.18-19.99l102.41-20.48c13-2.59 21.41-15.23 18.81-28.23s-15.31-21.61-28.25-18.83zM176 176c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zM288 32C128.94 32 0 160.94 0 320c0 52.8 14.25 102.26 39.06 144.8 5.61 9.62 16.3 15.2 27.44 15.2h443c11.14 0 21.83-5.58 27.44-15.2C561.75 422.26 576 372.8 576 320c0-159.06-128.94-288-288-288zm212.27 400H75.73C57.56 397.63 48 359.12 48 320 48 187.66 155.66 80 288 80s240 107.66 240 240c0 39.12-9.56 77.63-27.73 112z"
  ]
};
export const faTachometerAltSlow = {
  prefix: "far",
  iconName: "tachometer-alt-slow",
  icon: [
    576,
    512,
    [],
    "f627",
    "M128 288c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm160 0c-6.04 0-11.77 1.11-17.3 2.67l-75.76-97.4c-8.12-10.45-23.12-12.38-33.69-4.2-10.44 8.12-12.34 23.2-4.19 33.67l75.75 97.39c-5.45 9.42-8.81 20.21-8.81 31.88 0 11.72 3.38 22.55 8.88 32h110.25c5.5-9.45 8.88-20.28 8.88-32C352 316.65 323.35 288 288 288zm0-96c17.67 0 32-14.33 32-32s-14.33-32-32-32-32 14.33-32 32 14.33 32 32 32zm128 128c0 17.67 14.33 32 32 32s32-14.33 32-32-14.33-32-32-32-32 14.33-32 32zm16-112c0-17.67-14.33-32-32-32s-32 14.33-32 32 14.33 32 32 32 32-14.33 32-32zM288 32C128.94 32 0 160.94 0 320c0 52.8 14.25 102.26 39.06 144.8 5.61 9.62 16.3 15.2 27.44 15.2h443c11.14 0 21.83-5.58 27.44-15.2C561.75 422.26 576 372.8 576 320c0-159.06-128.94-288-288-288zm212.27 400H75.73C57.56 397.63 48 359.12 48 320 48 187.66 155.66 80 288 80s240 107.66 240 240c0 39.12-9.56 77.63-27.73 112z"
  ]
};
export const faTachometerAltSlowest = {
  prefix: "far",
  iconName: "tachometer-alt-slowest",
  icon: [
    576,
    512,
    [],
    "f628",
    "M288 288c-22.35 0-41.96 11.49-53.41 28.84l-101.87-20.38c-13.06-2.77-25.66 5.83-28.25 18.83s5.81 25.64 18.81 28.23L225.69 364c1.45 7.1 3.64 13.91 7.18 19.99h110.25c5.5-9.45 8.88-20.28 8.88-32 0-35.34-28.65-63.99-64-63.99zm-112-48c17.67 0 32-14.33 32-32s-14.33-32-32-32-32 14.33-32 32 14.33 32 32 32zm240 80c0 17.67 14.33 32 32 32s32-14.33 32-32-14.33-32-32-32-32 14.33-32 32zM288 192c17.67 0 32-14.33 32-32s-14.33-32-32-32-32 14.33-32 32 14.33 32 32 32zm144 16c0-17.67-14.33-32-32-32s-32 14.33-32 32 14.33 32 32 32 32-14.33 32-32zM288 32C128.94 32 0 160.94 0 320c0 52.8 14.25 102.26 39.06 144.8 5.61 9.62 16.3 15.2 27.44 15.2h443c11.14 0 21.83-5.58 27.44-15.2C561.75 422.26 576 372.8 576 320c0-159.06-128.94-288-288-288zm212.27 400H75.73C57.56 397.63 48 359.12 48 320 48 187.66 155.66 80 288 80s240 107.66 240 240c0 39.12-9.56 77.63-27.73 112z"
  ]
};
export const faTachometerAverage = {
  prefix: "far",
  iconName: "tachometer-average",
  icon: [
    576,
    512,
    [],
    "f629",
    "M312 292.75V160c0-13.25-10.75-24-24-24s-24 10.75-24 24v132.75c-23.44 9.5-40 32.41-40 59.25 0 11.72 3.38 22.55 8.88 32h110.25c5.5-9.45 8.88-20.28 8.88-32-.01-26.85-16.57-49.75-40.01-59.25zM288 32C128.94 32 0 160.94 0 320c0 52.8 14.25 102.26 39.06 144.8 5.61 9.62 16.3 15.2 27.44 15.2h443c11.14 0 21.83-5.58 27.44-15.2C561.75 422.26 576 372.8 576 320c0-159.06-128.94-288-288-288zm212.27 400H75.73C57.56 397.63 48 359.12 48 320 48 187.66 155.66 80 288 80s240 107.66 240 240c0 39.12-9.56 77.63-27.73 112z"
  ]
};
export const faTachometerFast = {
  prefix: "far",
  iconName: "tachometer-fast",
  icon: [
    576,
    512,
    [],
    "f62a",
    "M381.06 193.27l-75.76 97.4c-5.54-1.56-11.27-2.67-17.3-2.67-35.35 0-64 28.65-64 64 0 11.72 3.38 22.55 8.88 32h110.25c5.5-9.45 8.88-20.28 8.88-32 0-11.67-3.36-22.46-8.81-31.88l75.75-97.39c8.16-10.47 6.25-25.55-4.19-33.67-10.57-8.15-25.6-6.23-33.7 4.21zM288 32C128.94 32 0 160.94 0 320c0 52.8 14.25 102.26 39.06 144.8 5.61 9.62 16.3 15.2 27.44 15.2h443c11.14 0 21.83-5.58 27.44-15.2C561.75 422.26 576 372.8 576 320c0-159.06-128.94-288-288-288zm212.27 400H75.73C57.56 397.63 48 359.12 48 320 48 187.66 155.66 80 288 80s240 107.66 240 240c0 39.12-9.56 77.63-27.73 112z"
  ]
};
export const faTachometerFastest = {
  prefix: "far",
  iconName: "tachometer-fastest",
  icon: [
    576,
    512,
    [],
    "f62b",
    "M443.28 296.47l-101.87 20.38C329.96 299.49 310.35 288 288 288c-35.35 0-64 28.65-64 64 0 11.72 3.38 22.55 8.88 32h110.25c3.54-6.08 5.73-12.89 7.18-19.99l102.41-20.48c13-2.59 21.41-15.23 18.81-28.23s-15.31-21.61-28.25-18.83zM288 32C128.94 32 0 160.94 0 320c0 52.8 14.25 102.26 39.06 144.8 5.61 9.62 16.3 15.2 27.44 15.2h443c11.14 0 21.83-5.58 27.44-15.2C561.75 422.26 576 372.8 576 320c0-159.06-128.94-288-288-288zm212.27 400H75.73C57.56 397.63 48 359.12 48 320 48 187.66 155.66 80 288 80s240 107.66 240 240c0 39.12-9.56 77.63-27.73 112z"
  ]
};
export const faTachometerSlow = {
  prefix: "far",
  iconName: "tachometer-slow",
  icon: [
    576,
    512,
    [],
    "f62c",
    "M288 288c-6.04 0-11.77 1.11-17.3 2.67l-75.76-97.4c-8.12-10.45-23.12-12.38-33.69-4.2-10.44 8.12-12.34 23.2-4.19 33.67l75.75 97.39c-5.45 9.42-8.81 20.21-8.81 31.88 0 11.72 3.38 22.55 8.88 32h110.25c5.5-9.45 8.88-20.28 8.88-32C352 316.65 323.35 288 288 288zm0-256C128.94 32 0 160.94 0 320c0 52.8 14.25 102.26 39.06 144.8 5.61 9.62 16.3 15.2 27.44 15.2h443c11.14 0 21.83-5.58 27.44-15.2C561.75 422.26 576 372.8 576 320c0-159.06-128.94-288-288-288zm212.27 400H75.73C57.56 397.63 48 359.12 48 320 48 187.66 155.66 80 288 80s240 107.66 240 240c0 39.12-9.56 77.63-27.73 112z"
  ]
};
export const faTachometerSlowest = {
  prefix: "far",
  iconName: "tachometer-slowest",
  icon: [
    576,
    512,
    [],
    "f62d",
    "M288 288c-22.35 0-41.96 11.49-53.41 28.84l-101.87-20.38c-13.06-2.77-25.66 5.83-28.25 18.83s5.81 25.64 18.81 28.23L225.69 364c1.45 7.1 3.64 13.91 7.18 19.99h110.25c5.5-9.45 8.88-20.28 8.88-32 0-35.34-28.65-63.99-64-63.99zm0-256C128.94 32 0 160.94 0 320c0 52.8 14.25 102.26 39.06 144.8 5.61 9.62 16.3 15.2 27.44 15.2h443c11.14 0 21.83-5.58 27.44-15.2C561.75 422.26 576 372.8 576 320c0-159.06-128.94-288-288-288zm212.27 400H75.73C57.56 397.63 48 359.12 48 320 48 187.66 155.66 80 288 80s240 107.66 240 240c0 39.12-9.56 77.63-27.73 112z"
  ]
};
export const faTaco = {
  prefix: "far",
  iconName: "taco",
  icon: [
    512,
    512,
    [],
    "f826",
    "M208 288a16 16 0 1 0 16 16 16 16 0 0 0-16-16zm-64 64a16 16 0 1 0 16 16 16 16 0 0 0-16-16zm367.45 55.64a309.9 309.9 0 0 0-14.63-62.14 62.39 62.39 0 0 0 4.18-22.3c0-9.39.62-18.25 3.3-27.59 5.32-18.45 12.55-43.48 3-69.58-13-35.67-47.92-48.78-59.91-58.14-5.26-16.34-6.42-55.1-35.2-78.59-27.05-22.08-56.11-15.17-81.75-15.4C316.57 62.73 293.75 32 257.42 32c-37.66 0-64.67 32.84-75.88 41.86-16.77.15-52.72-8.3-81.75 15.4S70 151.77 64.37 168c-12.55 9.54-46.82 22.64-59.71 58-9.54 26.06-2.32 51.08 3 69.35 2.7 9.4 3.35 18.22 3.35 27.77a62.13 62.13 0 0 0 4.22 22.33A309.26 309.26 0 0 0 .55 407.64C-3.84 442.59 21 480 60.5 480h391c39.5 0 64.36-37.34 59.96-72.36zM451.51 432H60.5c-8.57 0-13.32-10.45-12.33-18.38C62.89 296.4 152.24 208 256 208s193.12 88.4 207.84 205.62c1 8-3.91 18.38-12.33 18.38z"
  ]
};
export const faTag = {
  prefix: "far",
  iconName: "tag",
  icon: [
    512,
    512,
    [],
    "f02b",
    "M497.941 225.941L286.059 14.059A48 48 0 0 0 252.118 0H48C21.49 0 0 21.49 0 48v204.118a47.998 47.998 0 0 0 14.059 33.941l211.882 211.882c18.745 18.745 49.137 18.746 67.882 0l204.118-204.118c18.745-18.745 18.745-49.137 0-67.882zM259.886 463.996L48 252.118V48h204.118L464 259.882 259.886 463.996zM192 144c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48z"
  ]
};
export const faTags = {
  prefix: "far",
  iconName: "tags",
  icon: [
    640,
    512,
    [],
    "f02c",
    "M625.941 293.823L421.823 497.941c-18.746 18.746-49.138 18.745-67.882 0l-.36-.36L592 259.882 331.397 0h48.721a48 48 0 0 1 33.941 14.059l211.882 211.882c18.745 18.745 18.745 49.137 0 67.882zm-128 0L293.823 497.941C284.451 507.314 272.166 512 259.882 512c-12.284 0-24.569-4.686-33.941-14.059L14.059 286.059A48 48 0 0 1 0 252.118V48C0 21.49 21.49 0 48 0h204.118a47.998 47.998 0 0 1 33.941 14.059l211.882 211.882c18.745 18.745 18.745 49.137 0 67.882zM464 259.882L252.118 48H48v204.118l211.886 211.878L464 259.882zM144 96c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48z"
  ]
};
export const faTally = {
  prefix: "far",
  iconName: "tally",
  icon: [
    640,
    512,
    [],
    "f69c",
    "M639.25 171.91l-4.84-15.25c-2.67-8.42-11.66-13.09-20.09-10.42L536 171.08V48c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v138.3l-80 25.37V48c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v178.89l-80 25.37V48c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v219.47l-80 25.37V48c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v260.06L11.17 337.5C2.75 340.17-1.92 349.16.75 357.59l4.84 15.25c2.67 8.42 11.67 13.09 20.09 10.41L104 358.41V464c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V343.19l80-25.37V464c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V302.61l80-25.37V464c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V262.02l80-25.37V464c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V221.44L628.83 192c8.43-2.67 13.09-11.66 10.42-20.09z"
  ]
};
export const faTanakh = {
  prefix: "far",
  iconName: "tanakh",
  icon: [
    448,
    512,
    [],
    "f827",
    "M368 0H16A16 16 0 0 0 0 16v368a16 16 0 0 0 12.9 15.7c4.2 13 4.2 51.6 0 64.6A16 16 0 0 0 0 480v16a16 16 0 0 0 16 16h352a80 80 0 0 0 80-80V80a80 80 0 0 0-80-80zm0 464H54c2.7-17.3 2.7-46.7 0-64h314a32 32 0 0 1 0 64zm32-105.3a79.37 79.37 0 0 0-32-6.7H48V48h320a32 32 0 0 1 32 32zM314.58 200l27.7-46.32a20 20 0 0 0-17.19-30.26h-56.35L241 77.16a19.64 19.64 0 0 0-16.94-9.68 20 20 0 0 0-17.28 9.8l-27.6 46.16h-56.3a20.14 20.14 0 0 0-17.5 10.15 19.68 19.68 0 0 0 .21 20L133.42 200l-27.7 46.32a20 20 0 0 0 17.19 30.26h56.35L207 322.84a19.64 19.64 0 0 0 16.94 9.68h.06a20 20 0 0 0 17.22-9.8l27.6-46.16h56.3a20.14 20.14 0 0 0 17.5-10.15 19.68 19.68 0 0 0-.21-20zm3.48-52.58l-17.47 29.21-17.49-29.19zM224 95.38l16.8 28.06h-33.62zm-94 52.06h34.91l-17.51 29.17zm0 105.12l17.47-29.21 17.49 29.21zm94 52.06l-16.8-28.06h33.59zm31.15-52.06h-62.28L161.39 200l31.43-52.54h62.31L286.61 200zm28 0l17.45-29.17 17.46 29.17z"
  ]
};
export const faTape = {
  prefix: "far",
  iconName: "tape",
  icon: [
    640,
    512,
    [],
    "f4db",
    "M624 432H362.3c52.1-41 85.7-104.5 85.7-176 0-123.7-100.3-224-224-224S0 132.3 0 256s100.3 224 224 224h400c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zm-400 0c-97 0-176-79-176-176S127 80 224 80s176 79 176 176-79 176-176 176zm0-272c-53 0-96 43-96 96s43 96 96 96 96-43 96-96-43-96-96-96zm0 144c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"
  ]
};
export const faTasks = {
  prefix: "far",
  iconName: "tasks",
  icon: [
    512,
    512,
    [],
    "f0ae",
    "M496 232H208a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm0 160H208a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm0-320H208a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16V88a16 16 0 0 0-16-16zM64.3 368C38 368 16 389.5 16 416s22 48 48.3 48a48 48 0 0 0 0-96zm75.26-172.51a12.09 12.09 0 0 0-17 0l-63.66 63.3-22.68-21.94a12 12 0 0 0-17 0L3.53 252.43a11.86 11.86 0 0 0 0 16.89L51 316.51a12.82 12.82 0 0 0 17.58 0l15.7-15.59 72.17-71.74a11.86 11.86 0 0 0 .1-16.8zm0-160a12 12 0 0 0-17 0L58.91 98.65 36.22 76.58a12.07 12.07 0 0 0-17 0L3.53 92.26a11.93 11.93 0 0 0 0 16.95l47.57 47.28a12.79 12.79 0 0 0 17.6 0l15.59-15.58 72.17-72a12.05 12.05 0 0 0 .1-17z"
  ]
};
export const faTasksAlt = {
  prefix: "far",
  iconName: "tasks-alt",
  icon: [
    512,
    512,
    [],
    "f828",
    "M488 31H24C10.7 31 0 43 0 58v74c0 15 10.7 27 24 27h464c13.3 0 24-12 24-27V58c0-15-10.7-27-24-27zm-184 80H48V79h256v32zm160 0H352V79h112v32zm24 240H24c-13.3 0-24 12-24 27v74c0 15 10.7 27 24 27h464c13.3 0 24-12 24-27v-74c0-15-10.7-27-24-27zm-248 80H48v-32h192v32zm224 0H288v-32h176v32zm24-240H24c-13.3 0-24 12-24 27v74c0 15 10.7 27 24 27h464c13.3 0 24-12 24-27v-74c0-15-10.7-27-24-27zm-376 80H48v-32h64v32zm352 0H160v-32h304v32z"
  ]
};
export const faTaxi = {
  prefix: "far",
  iconName: "taxi",
  icon: [
    512,
    512,
    [],
    "f1ba",
    "M112 280c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm288 0c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm-72 24H184c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h144c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8zm126.15-88.03l-15.03-77.66C432.56 104.52 402.84 80 368.44 80H352V64c0-17.67-14.33-32-32-32H192c-17.67 0-32 14.33-32 32v16h-16.44c-34.41 0-64.12 24.52-70.69 58.31l-15.03 77.66C23.83 230.74 0 264.55 0 304v48c0 23.63 12.95 44.04 32 55.12V456c0 13.25 10.75 24 24 24h32c13.25 0 24-10.75 24-24v-40h288v40c0 13.25 10.75 24 24 24h32c13.25 0 24-10.75 24-24v-48.88c19.05-11.09 32-31.49 32-55.12v-48c0-39.45-23.83-73.26-57.85-88.03zM120 147.44c2.19-11.27 12.09-19.44 23.56-19.44h224.88c11.47 0 21.38 8.17 23.56 19.44L403.72 208H108.28L120 147.44zM464 352c0 8.82-7.18 16-16 16H64c-8.82 0-16-7.18-16-16v-48c0-26.47 21.53-48 48-48h320c26.47 0 48 21.53 48 48v48z"
  ]
};
export const faTeeth = {
  prefix: "far",
  iconName: "teeth",
  icon: [
    640,
    512,
    [],
    "f62e",
    "M544 0H96C42.98 0 0 42.98 0 96v320c0 53.02 42.98 96 96 96h448c53.02 0 96-42.98 96-96V96c0-53.02-42.98-96-96-96zm48 416c0 26.47-21.53 48-48 48H96c-26.47 0-48-21.53-48-48v-29.68C63.93 409.04 90.21 424 120 424c26.38 0 50.09-11.67 66.23-30.12C203.75 412.42 228.55 424 256 424c24.56 0 47-9.27 64-24.5 17 15.23 39.44 24.5 64 24.5 27.45 0 52.25-11.58 69.77-30.12C469.91 412.33 493.62 424 520 424c29.79 0 56.07-14.96 72-37.68V416zM93.33 288h53.33c7.36 0 13.33 5.97 13.33 13.33V336c0 22.09-17.91 40-40 40s-40-17.91-40-40v-34.67C80 293.97 85.97 288 93.33 288zM80 242.67V208c0-22.09 17.91-40 40-40s40 17.91 40 40v34.67c0 7.36-5.97 13.33-13.33 13.33H93.33C85.97 256 80 250.03 80 242.67zM221.71 288h68.57c7.57 0 13.71 6.14 13.71 13.71V328c0 26.51-21.49 48-48 48s-48-21.49-48-48v-26.29c.01-7.57 6.15-13.71 13.72-13.71zM208 242.29V184c0-26.51 21.49-48 48-48s48 21.49 48 48v58.29c0 7.57-6.14 13.71-13.71 13.71h-68.57c-7.58 0-13.72-6.14-13.72-13.71zM349.71 288h68.57c7.57 0 13.71 6.14 13.71 13.71V328c0 26.51-21.49 48-48 48s-48-21.49-48-48v-26.29c.01-7.57 6.15-13.71 13.72-13.71zM336 242.29V184c0-26.51 21.49-48 48-48s48 21.49 48 48v58.29c0 7.57-6.14 13.71-13.71 13.71h-68.57c-7.58 0-13.72-6.14-13.72-13.71zM493.33 288h53.33c7.36 0 13.33 5.97 13.33 13.33V336c0 22.09-17.91 40-40 40s-40-17.91-40-40v-34.67c.01-7.36 5.98-13.33 13.34-13.33zM480 242.67V208c0-22.09 17.91-40 40-40s40 17.91 40 40v34.67c0 7.36-5.97 13.33-13.33 13.33h-53.33c-7.37 0-13.34-5.97-13.34-13.33zm112-84.99C576.07 134.96 549.79 120 520 120c-19.53 0-37.59 6.39-52.2 17.2C451.35 107.86 419.95 88 384 88c-24.56 0-47 9.27-64 24.5C303 97.27 280.56 88 256 88c-35.95 0-67.35 19.86-83.8 49.2-14.61-10.8-32.68-17.2-52.2-17.2-29.79 0-56.07 14.96-72 37.68V96c0-26.47 21.53-48 48-48h448c26.47 0 48 21.53 48 48v61.68z"
  ]
};
export const faTeethOpen = {
  prefix: "far",
  iconName: "teeth-open",
  icon: [
    640,
    512,
    [],
    "f62f",
    "M544 0H96C42.98 0 0 42.98 0 96v96c0 35.35 28.66 64 64 64h512c35.34 0 64-28.65 64-64V96c0-53.02-42.98-96-96-96zM160 212.57c0 6.31-5.12 11.43-11.43 11.43H91.43C85.12 224 80 218.88 80 212.57V200c0-22.09 17.91-40 40-40s40 17.91 40 40v12.57zm144-2.28c0 7.57-6.14 13.71-13.71 13.71h-68.57c-7.57 0-13.71-6.14-13.71-13.71V176c0-26.51 21.49-48 48-48s48 21.49 48 48v34.29zm128 0c0 7.57-6.14 13.71-13.71 13.71h-68.57c-7.57 0-13.71-6.14-13.71-13.71V176c0-26.51 21.49-48 48-48s48 21.49 48 48v34.29zm128 2.28c0 6.31-5.12 11.43-11.43 11.43h-57.14c-6.31 0-11.43-5.12-11.43-11.43V200c0-22.09 17.91-40 40-40s40 17.91 40 40v12.57zm32-62.51C575.96 127.13 549.53 112 520 112c-19.35 0-37.44 6.43-52.13 17.31C451.44 99.92 420 80 384 80c-24.56 0-47 9.27-64 24.5C303 89.27 280.56 80 256 80c-36 0-67.44 19.92-83.87 49.31C157.44 118.43 139.35 112 120 112c-29.53 0-55.96 15.13-72 38.06V96c0-26.47 21.53-48 48-48h448c26.47 0 48 21.53 48 48v54.06zM576 288H64c-35.34 0-64 28.65-64 64v64c0 53.02 42.98 96 96 96h448c53.02 0 96-42.98 96-96v-64c0-35.35-28.66-64-64-64zm-96 43.43c0-6.31 5.12-11.43 11.43-11.43h57.14c6.31 0 11.43 5.12 11.43 11.43V344c0 22.09-17.91 40-40 40s-40-17.91-40-40v-12.57zm-144 2.28c0-7.57 6.14-13.71 13.71-13.71h68.57c7.57 0 13.71 6.14 13.71 13.71V336c0 26.51-21.49 48-48 48s-48-21.49-48-48v-2.29zm-128 0c0-7.57 6.14-13.71 13.71-13.71h68.57c7.57 0 13.71 6.14 13.71 13.71V336c0 26.51-21.49 48-48 48s-48-21.49-48-48v-2.29zm-128-2.28c0-6.31 5.12-11.43 11.43-11.43h57.14c6.31 0 11.43 5.12 11.43 11.43V344c0 22.09-17.91 40-40 40s-40-17.91-40-40v-12.57zM592 416c0 26.47-21.53 48-48 48H96c-26.47 0-48-21.53-48-48v-21.68C63.93 417.04 90.21 432 120 432c26.38 0 50.09-11.67 66.23-30.12C203.75 420.42 228.55 432 256 432c24.56 0 47-9.27 64-24.5 17 15.23 39.44 24.5 64 24.5 27.45 0 52.25-11.58 69.77-30.12C469.91 420.33 493.62 432 520 432c29.79 0 56.07-14.96 72-37.68V416z"
  ]
};
export const faTelescope = {
  prefix: "far",
  iconName: "telescope",
  icon: [
    640,
    512,
    [],
    "e03e",
    "M638.7773,216.83088,553.06276,9.88222A15.99571,15.99571,0,0,0,532.16,1.22208L414.84419,49.81961a15.9993,15.9993,0,0,0-8.65758,20.90424l3.22047,7.77537L74.29836,241.74292c-8.31776,4.06444-12.27646,13.25582-9.056,21.02924l8.74351,21.10932L9.88112,310.43609a16.00022,16.00022,0,0,0-8.65954,20.90424l20.0552,48.42175a16.00118,16.00118,0,0,0,20.90475,8.66013l64.10476-26.55462,8.74352,21.10737c3.18531,7.69138,12.42684,11.50387,21.2719,8.46677l126.87565-43.77918c.2285.29492.47848.57031.71088.86133L216.419,490.93951A16.00126,16.00126,0,0,0,231.5976,512h16.86207a15.99882,15.99882,0,0,0,15.17664-10.94138l42.163-126.49575a71.11486,71.11486,0,0,0,28.44718,0l42.163,126.49575A16.00127,16.00127,0,0,0,391.58805,512h16.86011a16.00043,16.00043,0,0,0,15.1786-21.06049L376.15752,348.52388a71.27587,71.27587,0,0,0,15.86018-44.52332c0-.26367-.07616-.50586-.07812-.76757l96.72547-33.37491,3.2361,7.81443a16.00164,16.00164,0,0,0,20.90279,8.66013l117.31578-48.59752A15.99767,15.99767,0,0,0,638.7773,216.83088ZM320.02288,328.0005a23.99994,23.99994,0,1,1,23.99827-23.99994A24.0354,24.0354,0,0,1,320.02288,328.0005Zm55.123-69.74786a71.55078,71.55078,0,0,0-126.92056,43.79285L147.81065,336.69383l-26.6641-64.38068L427.8081,122.92683,470.264,225.43046ZM524.00235,229.739l-61.228-147.81991,58.18918-24.1054,61.22607,147.82186Z"
  ]
};
export const faTemperatureDown = {
  prefix: "far",
  iconName: "temperature-down",
  icon: [
    512,
    512,
    [],
    "e03f",
    "M160,322.91V304a16,16,0,0,0-32,0v18.91a48,48,0,1,0,32,0ZM256,112a112,112,0,0,0-224,0V278.5C12.31,303.09,0,334,0,368a144,144,0,0,0,288,0c0-34-12.31-64.91-32-89.5ZM144,464a96.14,96.14,0,0,1-96-96c0-27,11.69-47.3,21.5-59.5L80,295.41V112a64,64,0,0,1,128,0V295.3l10.5,13.11C228.31,320.7,240,341,240,368A96.14,96.14,0,0,1,144,464Zm340-80H440V48a16,16,0,0,0-16-16H408a16,16,0,0,0-16,16V384H348a12,12,0,0,0-12,12,13.75,13.75,0,0,0,3.28,8.23l68,72A13.61,13.61,0,0,0,416,480a13.77,13.77,0,0,0,8.72-3.77l68-72A13.75,13.75,0,0,0,496,396,12,12,0,0,0,484,384Z"
  ]
};
export const faTemperatureFrigid = {
  prefix: "far",
  iconName: "temperature-frigid",
  icon: [
    576,
    512,
    [],
    "f768",
    "M200 125.2L240.2 85c4.7-4.7 4.7-12.3 0-17l-8.5-8.5c-4.7-4.7-12.3-4.7-17 0L200 74.3V44c0-6.6-5.4-12-12-12h-24c-6.6 0-12 5.4-12 12v30.3l-14.8-14.8c-4.7-4.7-12.3-4.7-17 0l-8.5 8.5c-4.7 4.7-4.7 12.3 0 17l40.2 40.2v56.9L101.6 153l-15-55.7c-1.7-6.5-8.4-10.3-14.9-8.6L60 91.9c-6.5 1.7-10.3 8.4-8.6 14.9l5.5 20.4-26.6-15.3c-5.8-3.4-13.2-1.4-16.6 4.4l-12.1 21c-3.4 5.8-1.4 13.2 4.4 16.6l26.6 15.3-20.4 5.5c-6.5 1.7-10.3 8.4-8.6 14.9l3.1 11.7c1.7 6.5 8.4 10.3 14.9 8.6L77.3 195l50.2 29-50.2 29-55.7-15c-6.5-1.7-13.1 2.1-14.9 8.6l-3.1 11.7c-1.7 6.5 2.1 13.1 8.6 14.9l20.4 5.5-26.5 15.4c-5.8 3.4-7.8 10.8-4.4 16.6l12.1 21c3.4 5.8 10.8 7.8 16.6 4.4L57 320.8l-5.5 20.4c-1.7 6.5 2.1 13.1 8.6 14.9l11.7 3.1c6.5 1.7 13.1-2.1 14.9-8.6l14.9-55.6 50.4-29.1v56.9L111.8 363c-4.7 4.7-4.7 12.3 0 17l8.5 8.5c4.7 4.7 12.3 4.7 17 0l14.8-14.8V404c0 6.6 5.4 12 12 12h24c6.6 0 12-5.4 12-12v-30.3l14.8 14.8c4.7 4.7 12.3 4.7 17 0l8.5-8.5c4.7-4.7 4.7-12.3 0-17L200 322.8v-56.9l68.3 39.4c5.1-13 11.4-25.7 19.7-37.5v-7.2L224.6 224l63.4-36.6v-56.1l-88 50.8v-56.9zm344 153.3V112C544 50.1 493.9 0 432 0S320 50.1 320 112v166.5c-19.7 24.6-32 55.5-32 89.5 0 79.5 64.5 144 144 144s144-64.5 144-144c0-34-12.3-64.9-32-89.5zM432 464c-52.9 0-96-43.1-96-96 0-27 11.7-47.3 21.5-59.5l10.5-13.1V112c0-35.3 28.7-64 64-64s64 28.7 64 64v183.3l10.5 13.1C516.3 320.7 528 341 528 368c0 52.9-43.1 96-96 96zm16-141.1V304c0-8.8-7.2-16-16-16s-16 7.2-16 16v18.9c-18.6 6.6-32 24.2-32 45.1 0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.5-32-45.1z"
  ]
};
export const faTemperatureHigh = {
  prefix: "far",
  iconName: "temperature-high",
  icon: [
    448,
    512,
    [],
    "f769",
    "M368 0c-44.1 0-80 35.9-80 80s35.9 80 80 80 80-35.9 80-80-35.9-80-80-80zm0 112c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm-112 0C256 50.1 205.9 0 144 0S32 50.1 32 112v166.5C12.3 303.1 0 334 0 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-34-12.3-64.9-32-89.5V112zM144 464c-52.9 0-96-43.1-96-96 0-27 11.7-47.3 21.5-59.5L80 295.4V112c0-35.3 28.7-64 64-64s64 28.7 64 64v183.3l10.5 13.1C228.3 320.7 240 341 240 368c0 52.9-43.1 96-96 96zm16-141.1V112c0-8.8-7.2-16-16-16s-16 7.2-16 16v210.9c-18.6 6.6-32 24.2-32 45.1 0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.5-32-45.1z"
  ]
};
export const faTemperatureHot = {
  prefix: "far",
  iconName: "temperature-hot",
  icon: [
    576,
    512,
    [],
    "f76a",
    "M448 322.9V112c0-8.8-7.2-16-16-16s-16 7.2-16 16v210.9c-18.6 6.6-32 24.2-32 45.1 0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.5-32-45.1zm-189.3 15.6l-9.8 14.6L224 390l-24.9-36.9-17.8-26.3-31.2 6-43.6 8.5 8.5-43.9 6-31.1-26.2-17.8-37-25.1 37-25.1 26.2-17.8-6-31.1-8.5-43.9 43.7 8.5 31.2 6 17.8-26.3L224 57l24.9 36.9 17.7 26.3 21.4-4.1V112c0-16.3 3.3-31.8 8.4-46.4l-7.7 1.5-35.4-52.4C246.7 4.9 235.4 0 224 0s-22.7 4.9-29.3 14.7l-35.4 52.4-62-12c-2.3-.4-4.5-.7-6.8-.7-9.3 0-18.3 3.7-25 10.4-8.3 8.4-11.9 20.2-9.7 31.8l12 62.1-52.3 35.5C5.8 200.8 0 211.8 0 223.5c0 11.8 5.8 22.7 15.6 29.3l52.3 35.4-12 62.1c-2.2 11.6 1.4 23.5 9.7 31.8 6.7 6.7 15.6 10.4 25 10.4 2.2 0 4.5-.2 6.8-.6l62-12 35.4 52.4a35.318 35.318 0 0 0 58.6 0l9.9-14.7c-4.7-15.8-7.3-32.4-7.3-49.7 0-9.9 1-19.7 2.7-29.4zm285.3-60V112C544 50.1 493.9 0 432 0S320 50.1 320 112v166.5c-19.7 24.6-32 55.5-32 89.5 0 79.5 64.5 144 144 144s144-64.5 144-144c0-34-12.3-64.9-32-89.5zM432 464c-52.9 0-96-43.1-96-96 0-27 11.7-47.3 21.5-59.5l10.5-13.1V112c0-35.3 28.7-64 64-64s64 28.7 64 64v183.3l10.5 13.1C516.3 320.7 528 341 528 368c0 52.9-43.1 96-96 96zM288 164c-16.1-17.1-38.7-28-64-28-48.5 0-88 39.5-88 88s39.5 88 88 88c17.5 0 33.6-5.3 47.3-14.1 4.6-10.4 9.9-20.5 16.7-30.1V164zm-64 100c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40z"
  ]
};
export const faTemperatureLow = {
  prefix: "far",
  iconName: "temperature-low",
  icon: [
    448,
    512,
    [],
    "f76b",
    "M160 322.9V304c0-8.8-7.2-16-16-16s-16 7.2-16 16v18.9c-18.6 6.6-32 24.2-32 45.1 0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.5-32-45.1zM256 112C256 50.1 205.9 0 144 0S32 50.1 32 112v166.5C12.3 303.1 0 334 0 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-34-12.3-64.9-32-89.5V112zM144 464c-52.9 0-96-43.1-96-96 0-27 11.7-47.3 21.5-59.5L80 295.4V112c0-35.3 28.7-64 64-64s64 28.7 64 64v183.3l10.5 13.1C228.3 320.7 240 341 240 368c0 52.9-43.1 96-96 96zM368 0c-44.1 0-80 35.9-80 80s35.9 80 80 80 80-35.9 80-80-35.9-80-80-80zm0 112c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
  ]
};
export const faTemperatureUp = {
  prefix: "far",
  iconName: "temperature-up",
  icon: [
    512,
    512,
    [],
    "e040",
    "M160,322.91V112a16,16,0,0,0-32,0V322.91a48,48,0,1,0,32,0ZM256,112a112,112,0,0,0-224,0V278.5C12.31,303.09,0,334,0,368a144,144,0,0,0,288,0c0-34-12.31-64.91-32-89.5ZM144,464a96.14,96.14,0,0,1-96-96c0-27,11.69-47.3,21.5-59.5L80,295.41V112a64,64,0,0,1,128,0V295.3l10.5,13.11C228.31,320.7,240,341,240,368A96.14,96.14,0,0,1,144,464ZM492.72,107.77l-68-72A13.61,13.61,0,0,0,416,32a13.77,13.77,0,0,0-8.72,3.77l-68,72A13.75,13.75,0,0,0,336,116a12,12,0,0,0,12,12h44V464a16,16,0,0,0,16,16h16a16,16,0,0,0,16-16V128h44a12,12,0,0,0,12-12A13.75,13.75,0,0,0,492.72,107.77Z"
  ]
};
export const faTenge = {
  prefix: "far",
  iconName: "tenge",
  icon: [
    384,
    512,
    [],
    "f7d7",
    "M372 144H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h148v260c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12V208h148c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12zm0-112H12C5.4 32 0 37.4 0 44v40c0 6.6 5.4 12 12 12h360c6.6 0 12-5.4 12-12V44c0-6.6-5.4-12-12-12z"
  ]
};
export const faTennisBall = {
  prefix: "far",
  iconName: "tennis-ball",
  icon: [
    496,
    512,
    [],
    "f45e",
    "M495 236.2c0-.1.1-.2.1-.3h-.1C485.2 115.2 388.8 18.8 268.1 9v-.1c-.1 0-.2.1-.3.1-6.5-.5-13.1-1-19.8-1C111.2 8 0 119.2 0 256c0 6.7.5 13.3 1 19.9v.1c9.7 120.8 106.2 217.3 227 227h.1c6.6.5 13.2 1 19.9 1 136.8 0 248-111.2 248-248 0-6.7-.5-13.2-1-19.8zM219.3 58.3c-1.7 6.2-2.8 12.6-2.8 19.3 0 37.7-16.9 79.9-41.9 104.9-25.1 25-67.2 41.9-104.9 41.9-6.7 0-13.1 1.1-19.3 2.8C63 140 132 71 219.3 58.3zM50 282.9c4.2-6.4 11.4-10.5 19.6-10.5 50.3 0 104.8-22 138.8-56 34-34 55.9-88.5 56-138.8 0-8.2 4-15.4 10.4-19.6C363.6 70 434 140.4 446 229.2c-4.2 6.4-11.4 10.4-19.6 10.4-50.4 0-104.8 22-138.8 56-34 34-55.9 88.4-56 138.8 0 8.3-4.1 15.5-10.5 19.7C132.4 442 62 371.6 50 282.9zm226.8 170.8c1.7-6.2 2.8-12.6 2.8-19.3 0-37.7 16.9-79.9 41.9-104.9 25.1-25.1 67.2-41.9 104.9-41.9 6.7 0 13.1-1.1 19.3-2.8C433 372 364 441 276.8 453.7z"
  ]
};
export const faTerminal = {
  prefix: "far",
  iconName: "terminal",
  icon: [
    640,
    512,
    [],
    "f120",
    "M41.678 38.101l209.414 209.414c4.686 4.686 4.686 12.284 0 16.971L41.678 473.899c-4.686 4.686-12.284 4.686-16.971 0L4.908 454.101c-4.686-4.686-4.686-12.284 0-16.971L185.607 256 4.908 74.87c-4.686-4.686-4.686-12.284 0-16.971L24.707 38.1c4.686-4.686 12.284-4.686 16.971.001zM640 468v-28c0-6.627-5.373-12-12-12H300c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h328c6.627 0 12-5.373 12-12z"
  ]
};
export const faText = {
  prefix: "far",
  iconName: "text",
  icon: [
    448,
    512,
    [],
    "f893",
    "M432 32a16 16 0 0 1 16 16v80a16 16 0 0 1-16 16h-16a16 16 0 0 1-16-16V96H256v336h48a16 16 0 0 1 16 16v16a16 16 0 0 1-16 16H144a16 16 0 0 1-16-16v-16a16 16 0 0 1 16-16h48V96H48v32a16 16 0 0 1-16 16H16a16 16 0 0 1-16-16V48a16 16 0 0 1 16-16z"
  ]
};
export const faTextHeight = {
  prefix: "far",
  iconName: "text-height",
  icon: [
    576,
    512,
    [],
    "f034",
    "M560 368h-56V144h56c14.31 0 21.33-17.31 11.31-27.31l-80-80a16 16 0 0 0-22.62 0l-80 80C379.36 126 384.36 144 400 144h56v224h-56c-14.31 0-21.32 17.31-11.31 27.31l80 80a16 16 0 0 0 22.62 0l80-80C580.64 386 575.64 368 560 368zM304 32H16A16 16 0 0 0 0 48v80a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16V96h80v336H80a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h160a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16h-48V96h80v32a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
  ]
};
export const faTextSize = {
  prefix: "far",
  iconName: "text-size",
  icon: [
    640,
    512,
    [],
    "f894",
    "M624 32H272a16 16 0 0 0-16 16v80a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16V96h112v336h-48a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h160a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16h-48V96h112v32a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM304 224H16a16 16 0 0 0-16 16v64a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-32h80v160H96a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16h-32V272h80v32a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-64a16 16 0 0 0-16-16z"
  ]
};
export const faTextWidth = {
  prefix: "far",
  iconName: "text-width",
  icon: [
    448,
    512,
    [],
    "f035",
    "M363.31 292.68C354 283.36 336 288.36 336 304v56H112v-56c0-14.31-17.31-21.33-27.31-11.31l-80 80a16 16 0 0 0 0 22.63l80 80C94 484.64 112 479.64 112 464v-56h224v56c0 14.31 17.31 21.33 27.31 11.31l80-80a16 16 0 0 0 0-22.63zM432 32H16A16 16 0 0 0 0 48v80a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16V96h144v144h-32a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16h-32V96h144v32a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
  ]
};
export const faTh = {
  prefix: "far",
  iconName: "th",
  icon: [
    512,
    512,
    [],
    "f00a",
    "M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM197.3 72h117.3v96H197.3zm0 136h117.3v96H197.3zm-40 232H52c-6.6 0-12-5.4-12-12v-84h117.3zm0-136H40v-96h117.3zm0-136H40V84c0-6.6 5.4-12 12-12h105.3zm157.4 272H197.3v-96h117.3v96zm157.3 0H354.7v-96H472zm0-136H354.7v-96H472zm0-136H354.7V72H472z"
  ]
};
export const faThLarge = {
  prefix: "far",
  iconName: "th-large",
  icon: [
    512,
    512,
    [],
    "f009",
    "M0 80v352c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48H48C21.49 32 0 53.49 0 80zm232 0v152H48V86a6 6 0 0 1 6-6h178zM48 280h184v152H54a6 6 0 0 1-6-6V280zm232 152V280h184v146a6 6 0 0 1-6 6H280zm184-200H280V80h178a6 6 0 0 1 6 6v146z"
  ]
};
export const faThList = {
  prefix: "far",
  iconName: "th-list",
  icon: [
    512,
    512,
    [],
    "f00b",
    "M0 80v352c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48H48C21.49 32 0 53.49 0 80zm472 224H197.333v-96H472v96zm0 40v84c0 6.627-5.373 12-12 12H197.333v-96H472zM40 208h117.333v96H40v-96zm157.333-40V72H460c6.627 0 12 5.373 12 12v84H197.333zm-40-96v96H40V84c0-6.627 5.373-12 12-12h105.333zM40 344h117.333v96H52c-6.627 0-12-5.373-12-12v-84z"
  ]
};
export const faTheaterMasks = {
  prefix: "far",
  iconName: "theater-masks",
  icon: [
    640,
    512,
    [],
    "f630",
    "M206.86 244.47c-35.88 10.48-59.95 41.3-57.53 74.29 11.4-12.76 28.81-23.76 49.9-31l7.63-43.29zM606.8 119.91c-44.49-24.76-92.35-41.65-141.65-50.34-49.3-8.69-100.05-9.19-150.32-1.14-27.31 4.37-49.08 26.32-54.04 54.49l-31.73 179.96c-15.39 87.27 95.28 196.76 158.31 207.88 63.03 11.11 204.47-53.93 219.86-141.2l31.73-179.96c4.96-28.17-7.99-56.24-32.16-69.69zm-46.86 241.32c-10.22 57.95-124.2 109.32-164.25 102.26-40.06-7.06-129.59-94.32-119.38-152.27l31.73-179.96c1.4-7.96 7.31-14.3 14.36-15.43 44.75-7.16 89.96-6.82 134.4 1.02 44.44 7.83 87.05 22.98 126.64 45.01 6.24 3.47 9.62 11.46 8.22 19.42l-31.72 179.95zM80.05 297.66L48.32 118.22c-1.4-7.93 1.97-15.89 8.22-19.36 60.13-33.37 128.18-51 196.79-51 8.45 0 16.94.48 25.42 1.01 9.52-5.26 19.91-9.08 31.03-10.86 18.89-3.01 38.04-4.54 57.18-5.32-9.99-13.95-24.47-24.22-41.77-26.99C301.27 1.89 277.24 0 253.32 0 176.66 0 101.02 19.41 33.2 57.04 9.03 70.45-3.92 98.44 1.05 126.53l31.73 179.45C47.02 386.46 169.11 448 237.23 448c3.69 0 6.95-.46 10.29-.82-12.21-15.56-23.11-32.14-31.6-49.38-52.88-10.5-127.86-54.85-135.87-100.14zm113.31-141.01c-.73-4.13-2.23-7.89-4.07-11.42-8.25 8.94-20.67 15.79-35.32 18.37-14.65 2.58-28.67.4-39.48-5.18-.52 3.95-.64 8 .09 12.13 3.84 21.76 24.58 36.28 46.34 32.45s36.28-24.6 32.44-46.35zm312.59 50.09c-21.75-3.84-42.5 10.69-46.34 32.45-.73 4.13-.61 8.18-.09 12.13 10.81-5.58 24.83-7.77 39.48-5.18 14.65 2.58 27.08 9.43 35.33 18.37 1.84-3.53 3.34-7.29 4.07-11.43 3.83-21.76-10.69-42.51-32.45-46.34zm-133 17.16c14.65 2.58 27.08 9.43 35.32 18.37 1.84-3.53 3.34-7.29 4.07-11.43 3.84-21.76-10.69-42.5-32.45-46.34-21.75-3.84-42.5 10.69-46.34 32.45-.73 4.13-.61 8.18-.09 12.13 10.82-5.57 24.84-7.76 39.49-5.18zm44.31 117.3c-43.28-7.63-78.89-28.32-99.49-53.92-4.48 53.77 33.37 103.36 89.04 113.18 55.68 9.82 108.21-23.84 122.38-75.9-28.11 17.01-68.65 24.27-111.93 16.64z"
  ]
};
export const faThermometer = {
  prefix: "far",
  iconName: "thermometer",
  icon: [
    512,
    512,
    [],
    "f491",
    "M476.8 20.4c-37.5-30.7-95.5-26.3-131.9 10.2L96 281.1V382L7 471c-9.4 9.4-9.4 24.6 0 33.9 9.4 9.4 24.6 9.4 33.9 0l89-89h99.9L484 162.6c34.9-34.9 42.2-101.5-7.2-142.2zm-26.7 108.2L210 368h-66v-67.1l33.1-33.3 27.6 27.6c6.2 6.2 16.4 6.2 22.6 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6L211 233.5l33.8-34.1 27.8 27.8c6.2 6.2 16.4 6.2 22.6 0l11.3-11.3c6.3-6.2 6.3-16.4 0-22.6l-28-28 33.8-34.1 28.1 28.1c6.2 6.2 16.4 6.2 22.6 0l11.3-11.3c6.2-6.3 6.2-16.4 0-22.6l-28.2-28.2 32.6-32.8c19.2-19.1 48.8-22.2 67.4-7 25.5 21 21.1 54.1 4 71.2z"
  ]
};
export const faThermometerEmpty = {
  prefix: "far",
  iconName: "thermometer-empty",
  icon: [
    256,
    512,
    [],
    "f2cb",
    "M184 384c0 30.928-25.072 56-56 56s-56-25.072-56-56 25.072-56 56-56 56 25.072 56 56zm40-84.653c19.912 22.563 32 52.194 32 84.653 0 70.696-57.302 128-128 128-.299 0-.61-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.756 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM216 384c0-37.167-21.152-57.235-32-69.527V96c0-30.878-25.122-56-56-56-30.879 0-56 25.122-56 56v218.473c-10.977 12.439-31.811 32.281-31.999 69.064-.247 48.291 39.091 88.125 87.367 88.461L128 472c48.524 0 88-39.477 88-88z"
  ]
};
export const faThermometerFull = {
  prefix: "far",
  iconName: "thermometer-full",
  icon: [
    256,
    512,
    [],
    "f2c7",
    "M224 96c0-53.019-42.981-96-96-96S32 42.981 32 96v203.347C12.225 321.756.166 351.136.002 383.333c-.359 70.303 56.787 128.176 127.089 128.664.299.002.61.003.909.003 70.698 0 128-57.304 128-128 0-32.459-12.088-62.09-32-84.653V96zm-96 376l-.631-.002c-48.276-.335-87.614-40.17-87.367-88.461.188-36.783 21.022-56.625 31.999-69.064V96c0-30.878 25.121-56 56-56 30.878 0 56 25.122 56 56v218.473c10.848 12.292 32 32.361 32 69.527-.001 48.523-39.477 88-88.001 88zm56-88c0 30.928-25.072 56-56 56s-56-25.072-56-56c0-22.338 13.082-41.615 32-50.604V96c0-13.255 10.745-24 24-24s24 10.745 24 24v237.396c18.918 8.989 32 28.266 32 50.604z"
  ]
};
export const faThermometerHalf = {
  prefix: "far",
  iconName: "thermometer-half",
  icon: [
    256,
    512,
    [],
    "f2c9",
    "M184 384c0 30.928-25.072 56-56 56s-56-25.072-56-56c0-22.338 13.082-41.615 32-50.604V216c0-13.255 10.745-24 24-24s24 10.745 24 24v117.396c18.918 8.989 32 28.266 32 50.604zm40-84.653c19.912 22.563 32 52.194 32 84.653 0 70.696-57.302 128-128 128-.299 0-.61-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.756 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM216 384c0-37.167-21.152-57.235-32-69.527V96c0-30.878-25.122-56-56-56-30.879 0-56 25.122-56 56v218.473c-10.977 12.439-31.811 32.281-31.999 69.064-.247 48.291 39.091 88.125 87.367 88.461L128 472c48.524 0 88-39.477 88-88z"
  ]
};
export const faThermometerQuarter = {
  prefix: "far",
  iconName: "thermometer-quarter",
  icon: [
    256,
    512,
    [],
    "f2ca",
    "M184 384c0 30.928-25.072 56-56 56s-56-25.072-56-56c0-22.338 13.082-41.615 32-50.604V280c0-13.255 10.745-24 24-24s24 10.745 24 24v53.396c18.918 8.989 32 28.266 32 50.604zm40-84.653c19.912 22.563 32 52.194 32 84.653 0 70.696-57.302 128-128 128-.299 0-.61-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.756 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM216 384c0-37.167-21.152-57.235-32-69.527V96c0-30.878-25.122-56-56-56-30.879 0-56 25.122-56 56v218.473c-10.977 12.439-31.811 32.281-31.999 69.064-.247 48.291 39.091 88.125 87.367 88.461L128 472c48.524 0 88-39.477 88-88z"
  ]
};
export const faThermometerThreeQuarters = {
  prefix: "far",
  iconName: "thermometer-three-quarters",
  icon: [
    256,
    512,
    [],
    "f2c8",
    "M184 384c0 30.928-25.072 56-56 56s-56-25.072-56-56c0-22.338 13.082-41.615 32-50.604V152c0-13.255 10.745-24 24-24s24 10.745 24 24v181.396c18.918 8.989 32 28.266 32 50.604zm40-84.653c19.912 22.563 32 52.194 32 84.653 0 70.696-57.302 128-128 128-.299 0-.61-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.756 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM216 384c0-37.167-21.152-57.235-32-69.527V96c0-30.878-25.122-56-56-56-30.879 0-56 25.122-56 56v218.473c-10.977 12.439-31.811 32.281-31.999 69.064-.247 48.291 39.091 88.125 87.367 88.461L128 472c48.524 0 88-39.477 88-88z"
  ]
};
export const faTheta = {
  prefix: "far",
  iconName: "theta",
  icon: [
    352,
    512,
    [],
    "f69e",
    "M176 32C78.8 32 0 132.29 0 256s78.8 224 176 224 176-100.29 176-224S273.2 32 176 32zm0 48c63.46 0 117.77 67.49 126.6 152H49.4C58.23 147.49 112.54 80 176 80zm0 352c-63.46 0-117.77-67.49-126.6-152h253.2c-8.83 84.51-63.14 152-126.6 152z"
  ]
};
export const faThumbsDown = {
  prefix: "far",
  iconName: "thumbs-down",
  icon: [
    512,
    512,
    [],
    "f165",
    "M466.27 225.31c4.674-22.647.864-44.538-8.99-62.99 2.958-23.868-4.021-48.565-17.34-66.99C438.986 39.423 404.117 0 327 0c-7 0-15 .01-22.22.01C201.195.01 168.997 40 128 40h-10.845c-5.64-4.975-13.042-8-21.155-8H32C14.327 32 0 46.327 0 64v240c0 17.673 14.327 32 32 32h64c11.842 0 22.175-6.438 27.708-16h7.052c19.146 16.953 46.013 60.653 68.76 83.4 13.667 13.667 10.153 108.6 71.76 108.6 57.58 0 95.27-31.936 95.27-104.73 0-18.41-3.93-33.73-8.85-46.54h36.48c48.602 0 85.82-41.565 85.82-85.58 0-19.15-4.96-34.99-13.73-49.84zM64 296c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24zm330.18 16.73H290.19c0 37.82 28.36 55.37 28.36 94.54 0 23.75 0 56.73-47.27 56.73-18.91-18.91-9.46-66.18-37.82-94.54C206.9 342.89 167.28 272 138.92 272H128V85.83c53.611 0 100.001-37.82 171.64-37.82h37.82c35.512 0 60.82 17.12 53.12 65.9 15.2 8.16 26.5 36.44 13.94 57.57 21.581 20.384 18.699 51.065 5.21 65.62 9.45 0 22.36 18.91 22.27 37.81-.09 18.91-16.71 37.82-37.82 37.82z"
  ]
};
export const faThumbsUp = {
  prefix: "far",
  iconName: "thumbs-up",
  icon: [
    512,
    512,
    [],
    "f164",
    "M466.27 286.69C475.04 271.84 480 256 480 236.85c0-44.015-37.218-85.58-85.82-85.58H357.7c4.92-12.81 8.85-28.13 8.85-46.54C366.55 31.936 328.86 0 271.28 0c-61.607 0-58.093 94.933-71.76 108.6-22.747 22.747-49.615 66.447-68.76 83.4H32c-17.673 0-32 14.327-32 32v240c0 17.673 14.327 32 32 32h64c14.893 0 27.408-10.174 30.978-23.95 44.509 1.001 75.06 39.94 177.802 39.94 7.22 0 15.22.01 22.22.01 77.117 0 111.986-39.423 112.94-95.33 13.319-18.425 20.299-43.122 17.34-66.99 9.854-18.452 13.664-40.343 8.99-62.99zm-61.75 53.83c12.56 21.13 1.26 49.41-13.94 57.57 7.7 48.78-17.608 65.9-53.12 65.9h-37.82c-71.639 0-118.029-37.82-171.64-37.82V240h10.92c28.36 0 67.98-70.89 94.54-97.46 28.36-28.36 18.91-75.63 37.82-94.54 47.27 0 47.27 32.98 47.27 56.73 0 39.17-28.36 56.72-28.36 94.54h103.99c21.11 0 37.73 18.91 37.82 37.82.09 18.9-12.82 37.81-22.27 37.81 13.489 14.555 16.371 45.236-5.21 65.62zM88 432c0 13.255-10.745 24-24 24s-24-10.745-24-24 10.745-24 24-24 24 10.745 24 24z"
  ]
};
export const faThumbtack = {
  prefix: "far",
  iconName: "thumbtack",
  icon: [
    384,
    512,
    [],
    "f08d",
    "M306.5 186.6l-5.7-42.6H328c13.2 0 24-10.8 24-24V24c0-13.2-10.8-24-24-24H56C42.8 0 32 10.8 32 24v96c0 13.2 10.8 24 24 24h27.2l-5.7 42.6C29.6 219.4 0 270.7 0 328c0 13.2 10.8 24 24 24h144v104c0 .9.1 1.7.4 2.5l16 48c2.4 7.3 12.8 7.3 15.2 0l16-48c.3-.8.4-1.7.4-2.5V352h144c13.2 0 24-10.8 24-24 0-57.3-29.6-108.6-77.5-141.4zM50.5 304c8.3-38.5 35.6-70 71.5-87.8L138 96H80V48h224v48h-58l16 120.2c35.8 17.8 63.2 49.4 71.5 87.8z"
  ]
};
export const faThunderstorm = {
  prefix: "far",
  iconName: "thunderstorm",
  icon: [
    512,
    512,
    [],
    "f76c",
    "M337 288h-72.1l22.6-77.1c2.5-9.5-4.6-18.9-14.5-18.9h-82c-7.5 0-13.9 5.6-14.9 13l-16 130c-1.2 9 5.8 17 14.9 17h81l-31.6 141.5c-2.2 9.5 5 18.5 14.6 18.5 5.2 0 10.2-2.7 13-7.5l98-194c5.7-10-1.5-22.5-13-22.5zm73.7-183.8C397.2 61.8 358 32 312 32c-13.5 0-26.8 2.6-39.2 7.7C250.3 14.5 218.4 0 184 0 120 0 67.6 50.3 64.2 113.4 25.6 130.4 0 168.5 0 212c0 59.5 48.4 108 108 108h21.7l5.9-48H108c-33.1 0-60-26.9-60-60 0-28 19.1-52 46.4-58.3l20.8-4.8-2.8-24.9c-.2-1.3-.4-2.6-.4-4 0-39.7 32.3-72 72-72 25.2 0 48.2 13.1 61.4 35.1l13.3 22.1 21.1-14.9C289.4 83.6 300.5 80 312 80c28.6 0 52.4 21.7 55.3 50.4l2.2 21.6H404c33.1 0 60 26.9 60 60s-26.9 60-60 60h-32.1c2.1 2.4 4.2 4.7 5.8 7.5 7.2 12.4 7.8 27.3 2.7 40.5H404c59.6 0 108-48.5 108-108 0-57.3-44.9-104.3-101.3-107.8z"
  ]
};
export const faThunderstormMoon = {
  prefix: "far",
  iconName: "thunderstorm-moon",
  icon: [
    640,
    512,
    [],
    "f76d",
    "M277.6 335.3h-57.7l17.3-65.2c2-7.6-3.7-15.2-11.6-15.2h-68c-6 0-11.1 4.5-11.9 10.5l-16 120.5c-1 7.2 4.6 13.6 11.9 13.6H201l-23 97.6c-1.8 7.6 4 14.8 11.7 14.8 4.2 0 8.2-2.2 10.4-6l88-152.6c4.5-7.9-1.2-18-10.5-18zm85.8-151.2c-12.1-36.9-46.7-63.6-87.4-63.6-3.1 0-6.1.2-9.1.5-21.6-15.9-47.6-24.6-74.9-24.6-52.4 0-97.6 31.4-117.2 77.5C31.4 188 0 228.9 0 277.1c0 56.3 43.2 102.2 97.9 107.4.1-.9-.1-1.9.1-2.8l5.9-44.8c-31.2-2.1-56-27.9-56-59.8 0-33.3 26.9-60.2 60-60.2 1.6 0 3.2.4 4.8.5 3.8-40.8 37.6-72.8 79.2-72.8 25.2 0 47.4 11.9 62.1 30.2 6.5-3.8 13.9-6.1 21.9-6.1 24.3 0 44 19.8 44 44.2 0 1.8-.3 3.5-.5 5.2 27.6 5.4 48.5 29.8 48.5 59.1 0 29.1-20.5 53.4-47.9 59 2.9 11.1 1.4 23.2-4.4 33.4l-9.2 16h1.5c59.6 0 108-48.6 108-108.4.1-39-20.7-74-52.5-93.1zm274.4 53.5c-3.8-7.9-11.8-13.1-20.5-13.1h-1.5l-2.8.5c-6.1 1.2-12.3 1.8-18.4 1.8-53.2 0-96.5-43.6-96.5-97.2 0-34.9 18.8-67.3 49-84.5 8.4-4.8 12.8-14.1 11.2-23.7-1.6-9.6-8.8-16.9-18.3-18.6C530.3.9 520.5 0 510.7 0c-73.6 0-135.1 50.5-153.6 118.7 13.8 11.9 25 26.9 32.6 44.3.6.4 1 .9 1.6 1.3 0-1.2-.4-2.4-.4-3.6 0-59.1 42.6-108.4 98.6-118.6-19.9 24.3-31.3 55.1-31.3 87.5 0 67.6 48.8 124 112.9 135.3-18 10.6-38.7 16.3-60.2 16.3-23.4 0-45.1-7-63.6-18.8.5 4.9.9 9.8.9 14.7 0 10.1-1.3 19.9-3.3 29.4 20.2 9.3 42.4 14.8 66.1 14.8 48.4 0 93.6-21.7 124.2-59.5 5.3-6.9 6.4-16.2 2.6-24.2z"
  ]
};
export const faThunderstormSun = {
  prefix: "far",
  iconName: "thunderstorm-sun",
  icon: [
    640,
    512,
    [],
    "f76e",
    "M500 336h-57.7l17.3-64.9c2-7.6-3.7-15.1-11.6-15.1h-68c-6 0-11.1 4.5-11.9 10.4l-16 120c-1 7.2 4.6 13.6 11.9 13.6h59.3l-23 97.2c-1.8 7.6 4 14.8 11.7 14.8 4.2 0 8.2-2.2 10.4-6l88-152c4.6-8-1.2-18-10.4-18zm-307.1-72.3l-5.9 8.7-10.8 16-11.2-16.7-17.8-26.3-31.2 6-19.4 3.8 3.8-19.6 6-31.1-26.2-17.8-16.5-11.2 16.5-11.2 26.2-17.8-6-31.1-3.8-19.5 19.4 3.8 31.2 6L165 79.5l10.8-16L187 80.3l17.8 26.3 31.2-6 19.4-3.7-3.8 19.6-6 31.1 13.5 9.2c5.3-3.2 10.7-6.2 16.4-8.7 7-13 15.7-24.8 25.7-35.2l7-36.1c1.8-9.1-1.1-18.4-7.6-25-5.2-5.3-12.3-8.2-19.6-8.2-1.8 0-3.6.2-5.3.5L227 53.5l-28-41.3C193.9 4.6 185.2 0 176 0c-8.9 0-17.9 3.8-23 11.5l-27.8 41.2-48.7-9.4c-1.8-.3-3.6-.5-5.3-.5-7.3 0-14.3 2.9-19.6 8.2-6.5 6.6-9.4 15.9-7.6 25l9.4 48.8-41.1 27.9C4.6 157.8 0 166.4 0 175.6s4.6 17.9 12.2 23.1l41.1 27.8-9.4 48.8c-1.8 9.1 1.1 18.4 7.6 25 5.2 5.3 12.3 8.2 19.6 8.2 1.8 0 3.6-.2 5.3-.5l48.7-9.4 27.8 41.2c5.2 7.7 13.8 12.3 23 12.3 8.9 0 17.9-3.8 23-11.5l5.2-7.8c-7.8-17.4-12.3-36.5-12.3-56.7.2-4.3.7-8.3 1.1-12.4zm394.5-80.3c-12-36.8-46.7-63.4-87.4-63.4-3.1 0-6.1.2-9.1.5C469.3 104.7 443.2 96 416 96c-52.4 0-97.6 31.3-117.2 77.2C255.4 187.3 224 228 224 276c0 55.6 42.3 100.9 96.4 106.8v-.6l6.2-46.7C296 332.7 272 307.3 272 276c0-33.1 26.9-60 60-60 1.6 0 3.2.4 4.8.5 3.8-40.6 37.6-72.5 79.2-72.5 25.2 0 47.4 11.9 62.1 30.1 6.5-3.8 13.9-6.1 21.9-6.1 24.3 0 44 19.7 44 44 0 1.8-.3 3.4-.5 5.2 27.6 5.4 48.5 29.6 48.5 58.8 0 29.8-21.8 54.3-50.2 59 3.6 11.6 2.5 24.3-3.7 35l-8.1 14h2c59.6 0 108-48.4 108-108 0-38.8-20.8-73.6-52.6-92.6zM176 136c-22.1 0-40 17.9-40 40s17.9 40 40 40 40-17.9 40-40-17.9-40-40-40z"
  ]
};
export const faTicket = {
  prefix: "far",
  iconName: "ticket",
  icon: [
    576,
    512,
    [],
    "f145",
    "M568 216h8V112c0-26.51-21.49-48-48-48H48C21.49 64 0 85.49 0 112v104h8c22.091 0 40 17.909 40 40s-17.909 40-40 40H0v104c0 26.51 21.49 48 48 48h480c26.51 0 48-21.49 48-48V296h-8c-22.091 0-40-17.909-40-40s17.909-40 40-40zm-40-38.372c-28.47 14.59-48 44.243-48 78.372s19.53 63.782 48 78.372V400H48v-65.628c28.471-14.59 48-44.243 48-78.372s-19.529-63.782-48-78.372V112h480v65.628z"
  ]
};
export const faTicketAlt = {
  prefix: "far",
  iconName: "ticket-alt",
  icon: [
    576,
    512,
    [],
    "f3ff",
    "M400 208v96H176v-96h224m24-48H152c-13.255 0-24 10.745-24 24v144c0 13.255 10.745 24 24 24h272c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24zm144 56h8V112c0-26.51-21.49-48-48-48H48C21.49 64 0 85.49 0 112v104h8c22.091 0 40 17.909 40 40s-17.909 40-40 40H0v104c0 26.51 21.49 48 48 48h480c26.51 0 48-21.49 48-48V296h-8c-22.091 0-40-17.909-40-40s17.909-40 40-40zm-40-38.372c-28.47 14.59-48 44.243-48 78.372s19.53 63.782 48 78.372V400H48v-65.628c28.471-14.59 48-44.243 48-78.372s-19.529-63.782-48-78.372V112h480v65.628z"
  ]
};
export const faTilde = {
  prefix: "far",
  iconName: "tilde",
  icon: [
    448,
    512,
    [],
    "f69f",
    "M316.25 350.67c-31.48-4.74-58.98-24.08-77.7-49.83l-70.96-97.62c-19.2-26.36-56.6-36.33-87.97-17.5C59.2 197.99 48 221.37 48 245.19V304c0 8.84-7.16 16-16 16H16c-8.84 0-16-7.16-16-16v-56.21c0-46.29 25.01-90.77 67.26-109.69 51.3-22.97 108.58-5.14 139.15 36.88l74 101.8c19.2 26.36 56.6 36.33 87.97 17.5C388.8 282.02 400 258.63 400 234.81V176c0-8.84 7.16-16 16-16h16c8.84 0 16 7.16 16 16v61.89c0 68.71-61.03 123.42-131.75 112.78z"
  ]
};
export const faTimes = {
  prefix: "far",
  iconName: "times",
  icon: [
    320,
    512,
    [],
    "f00d",
    "M207.6 256l107.72-107.72c6.23-6.23 6.23-16.34 0-22.58l-25.03-25.03c-6.23-6.23-16.34-6.23-22.58 0L160 208.4 52.28 100.68c-6.23-6.23-16.34-6.23-22.58 0L4.68 125.7c-6.23 6.23-6.23 16.34 0 22.58L112.4 256 4.68 363.72c-6.23 6.23-6.23 16.34 0 22.58l25.03 25.03c6.23 6.23 16.34 6.23 22.58 0L160 303.6l107.72 107.72c6.23 6.23 16.34 6.23 22.58 0l25.03-25.03c6.23-6.23 6.23-16.34 0-22.58L207.6 256z"
  ]
};
export const faTimesCircle = {
  prefix: "far",
  iconName: "times-circle",
  icon: [
    512,
    512,
    [],
    "f057",
    "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm101.8-262.2L295.6 256l62.2 62.2c4.7 4.7 4.7 12.3 0 17l-22.6 22.6c-4.7 4.7-12.3 4.7-17 0L256 295.6l-62.2 62.2c-4.7 4.7-12.3 4.7-17 0l-22.6-22.6c-4.7-4.7-4.7-12.3 0-17l62.2-62.2-62.2-62.2c-4.7-4.7-4.7-12.3 0-17l22.6-22.6c4.7-4.7 12.3-4.7 17 0l62.2 62.2 62.2-62.2c4.7-4.7 12.3-4.7 17 0l22.6 22.6c4.7 4.7 4.7 12.3 0 17z"
  ]
};
export const faTimesHexagon = {
  prefix: "far",
  iconName: "times-hexagon",
  icon: [
    576,
    512,
    [],
    "f2ee",
    "M441.5 39.8C432.9 25.1 417.1 16 400 16H176c-17.1 0-32.9 9.1-41.5 23.8l-112 192c-8.7 14.9-8.7 33.4 0 48.4l112 192c8.6 14.7 24.4 23.8 41.5 23.8h224c17.1 0 32.9-9.1 41.5-23.8l112-192c8.7-14.9 8.7-33.4 0-48.4l-112-192zM400 448H176L64 256 176 64h224l112 192-112 192zm-10.2-112.8l-22.6 22.6c-4.7 4.7-12.3 4.7-17 0L288 295.6l-62.2 62.2c-4.7 4.7-12.3 4.7-17 0l-22.6-22.6c-4.7-4.7-4.7-12.3 0-17l62.2-62.2-62.2-62.2c-4.7-4.7-4.7-12.3 0-17l22.6-22.6c4.7-4.7 12.3-4.7 17 0l62.2 62.2 62.2-62.2c4.7-4.7 12.3-4.7 17 0l22.6 22.6c4.7 4.7 4.7 12.3 0 17L327.6 256l62.2 62.2c4.7 4.7 4.7 12.3 0 17z"
  ]
};
export const faTimesOctagon = {
  prefix: "far",
  iconName: "times-octagon",
  icon: [
    512,
    512,
    [],
    "f2f0",
    "M497.9 150.5L361.5 14.1c-9-9-21.2-14.1-33.9-14.1H184.5c-12.7 0-24.9 5.1-33.9 14.1L14.1 150.5c-9 9-14.1 21.2-14.1 33.9v143.1c0 12.7 5.1 24.9 14.1 33.9l136.5 136.5c9 9 21.2 14.1 33.9 14.1h143.1c12.7 0 24.9-5.1 33.9-14.1L498 361.4c9-9 14.1-21.2 14.1-33.9v-143c-.1-12.8-5.2-25-14.2-34zm-33.9 177L327.5 464h-143L48 327.5v-143L184.5 48h143.1L464 184.5v143zm-106.2 7.7l-22.6 22.6c-4.7 4.7-12.3 4.7-17 0L256 295.6l-62.2 62.2c-4.7 4.7-12.3 4.7-17 0l-22.6-22.6c-4.7-4.7-4.7-12.3 0-17l62.2-62.2-62.2-62.2c-4.7-4.7-4.7-12.3 0-17l22.6-22.6c4.7-4.7 12.3-4.7 17 0l62.2 62.2 62.2-62.2c4.7-4.7 12.3-4.7 17 0l22.6 22.6c4.7 4.7 4.7 12.3 0 17L295.6 256l62.2 62.2c4.7 4.7 4.7 12.3 0 17z"
  ]
};
export const faTimesSquare = {
  prefix: "far",
  iconName: "times-square",
  icon: [
    448,
    512,
    [],
    "f2d3",
    "M325.8 193.8L263.6 256l62.2 62.2c4.7 4.7 4.7 12.3 0 17l-22.6 22.6c-4.7 4.7-12.3 4.7-17 0L224 295.6l-62.2 62.2c-4.7 4.7-12.3 4.7-17 0l-22.6-22.6c-4.7-4.7-4.7-12.3 0-17l62.2-62.2-62.2-62.2c-4.7-4.7-4.7-12.3 0-17l22.6-22.6c4.7-4.7 12.3-4.7 17 0l62.2 62.2 62.2-62.2c4.7-4.7 12.3-4.7 17 0l22.6 22.6c4.7 4.7 4.7 12.3 0 17zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
  ]
};
export const faTint = {
  prefix: "far",
  iconName: "tint",
  icon: [
    352,
    512,
    [],
    "f043",
    "M205.22 22.09C201.21 7.53 188.61 0 175.97 0c-12.35 0-24.74 7.2-29.19 22.09C100.01 179.85 0 222.72 0 333.91 0 432.35 78.72 512 176 512s176-79.65 176-178.09c0-111.75-99.79-153.34-146.78-311.82zM176 464c-70.58 0-128-58.36-128-130.09 0-43.33 20.67-72.95 51.96-117.79 24.15-34.61 52.98-75.92 76.04-132.46 23.15 56.83 52.02 98.1 76.2 132.66 31.19 44.58 51.8 74.03 51.8 117.6C304 405.64 246.58 464 176 464zm16-64c-44.12 0-80-35.89-80-80 0-8.84-7.16-16-16-16s-16 7.16-16 16c0 61.75 50.25 112 112 112 8.84 0 16-7.16 16-16s-7.16-16-16-16z"
  ]
};
export const faTintSlash = {
  prefix: "far",
  iconName: "tint-slash",
  icon: [
    640,
    512,
    [],
    "f5c7",
    "M633.99 471.01L36 3.51C29.1-2.01 19.03-.9 13.51 6l-10 12.49C-2.02 25.39-.9 35.46 6 40.98l598 467.51c6.9 5.52 16.96 4.4 22.49-2.49l10-12.49c5.52-6.9 4.41-16.97-2.5-22.5zM320 83.66c23.15 56.83 52.02 98.1 76.2 132.66 4.2 6 8.16 11.69 11.95 17.21l84.24 65.86c-17.92-87.7-101.36-136.27-143.17-277.3C345.21 7.54 332.61 0 319.97 0c-12.35 0-24.74 7.2-29.19 22.09-10.44 35.2-23.58 64.47-37.62 90.27l38.12 29.8c10.01-17.75 19.83-36.71 28.72-58.5zM320 464c-70.58 0-128-58.36-128-130.09 0-26.35 7.73-47.65 20.76-70.37l-38.06-29.76c-18.15 30.24-30.7 60.94-30.7 100.13C144 432.35 222.72 512 320 512c52.93 0 100.23-23.69 132.48-61.04l-38.17-29.84C390.88 447.27 357.46 464 320 464z"
  ]
};
export const faTire = {
  prefix: "far",
  iconName: "tire",
  icon: [
    512,
    512,
    [],
    "f631",
    "M256 84c-94.99 0-172 77.01-172 172s77.01 172 172 172 172-77.01 172-172S350.99 84 256 84zm0 48c18.58 0 36.05 4.4 51.89 11.75l-26.66 36.7c-7.97-2.66-16.35-4.45-25.22-4.45s-17.25 1.79-25.22 4.45l-26.66-36.7C219.95 136.4 237.42 132 256 132zM133.47 270.56c-.58-4.84-1.47-9.58-1.47-14.56 0-32.48 12.83-61.85 33.34-83.98l26.55 36.55C182.03 221.87 176 238.17 176 256c0 .25.07.47.07.72l-42.6 13.84zM232 377.57c-36.13-7.12-66.23-30.21-83.72-61.35l42.71-13.88c9.96 13.94 24.31 24.31 41.01 29.59v45.64zM256 288c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm24 89.57v-45.64c16.7-5.28 31.04-15.64 41.01-29.59l42.71 13.88c-17.49 31.15-47.59 54.23-83.72 61.35zm55.93-120.85c0-.25.07-.47.07-.72 0-17.83-6.03-34.13-15.89-47.43l26.55-36.55C367.17 194.15 380 223.52 380 256c0 4.99-.9 9.73-1.47 14.56l-42.6-13.84zM256 0C114.62 0 0 114.62 0 256s114.62 256 256 256 256-114.62 256-256S397.38 0 256 0zm0 464c-114.69 0-208-93.31-208-208S141.31 48 256 48s208 93.31 208 208-93.31 208-208 208z"
  ]
};
export const faTireFlat = {
  prefix: "far",
  iconName: "tire-flat",
  icon: [
    512,
    512,
    [],
    "f632",
    "M0 488.02c0 13.23 10.71 23.94 23.92 23.98h464.16c13.22-.04 23.92-10.76 23.92-23.98 0-13.26-10.74-24-24-24h-20.38C495.6 422.98 512 373.42 512 320c0-141.38-114.62-256-256-256S0 178.62 0 320c0 53.42 16.4 102.98 44.38 144.02H24c-13.26 0-24 10.74-24 24zm232-46.45c-36.13-7.12-66.23-30.21-83.72-61.35l42.71-13.88c9.96 13.94 24.31 24.31 41.01 29.59v45.64zm-55.93-120.85l-42.6 13.84c-.58-4.84-1.47-9.58-1.47-14.56 0-32.48 12.83-61.85 33.34-83.98l26.55 36.55C182.03 285.87 176 302.17 176 320c0 .25.07.47.07.72zM256 352c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm-51.89-144.25c24.13-11.21 61.58-19.6 103.77 0l-26.66 36.7c-22.06-7.37-37.63-4.28-50.45 0l-26.66-36.7zM280 441.57v-45.64c16.7-5.28 31.04-15.64 41.01-29.59l42.71 13.88c-17.49 31.15-47.59 54.23-83.72 61.35zm40.11-169l26.55-36.55C367.17 258.15 380 287.52 380 320c0 4.99-.9 9.73-1.47 14.56l-42.6-13.84c0-.25.07-.47.07-.72 0-17.83-6.03-34.13-15.89-47.43zM256 112c114.69 0 208 93.31 208 208 0 55.89-22.27 106.6-58.27 144.02h-56.12C396.71 433.33 428 380.41 428 320c0-94.99-77.01-172-172-172S84 225.01 84 320c0 60.41 31.29 113.33 78.4 144.02h-56.13C70.27 426.6 48 375.89 48 320c0-114.69 93.31-208 208-208z"
  ]
};
export const faTirePressureWarning = {
  prefix: "far",
  iconName: "tire-pressure-warning",
  icon: [
    512,
    512,
    [],
    "f633",
    "M246.48 256.02h19.04c8.22 0 15.1-6.23 15.92-14.41l12.8-128c.94-9.42-6.45-17.59-15.92-17.59h-44.64c-9.47 0-16.86 8.17-15.92 17.59l12.8 128c.82 8.18 7.7 14.41 15.92 14.41zm257.67-40.31c-6.02-28.55-19.49-54.79-34.23-79.98C455.57 111.21 448 84.89 448 59.47V16c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v43.47c0 89.04 55.66 112.48 63.19 206.2 4.73 58.94-11.05 105.22-53.22 153.27-7.44 8.47-18.48 13.06-29.75 13.06H131.78c-11.29 0-22.34-4.59-29.78-13.08-42.16-48.06-57.93-94.35-53.19-153.29C56.21 173.78 112 147.1 112 59.47V16c0-8.84-7.16-16-16-16H80c-8.84 0-16 7.16-16 16v43.47c0 25.42-7.56 51.73-21.91 76.23-14.74 25.16-28.2 51.38-34.22 79.92-19.71 93.35-3.04 165.08 57.71 234.54 4.32 4.93 9.19 9.25 14.43 13.04V496c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16h32v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16h32v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16h32v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-32.8c5.22-3.78 10.08-8.09 14.39-13.01 60.75-69.44 77.44-141.16 57.75-234.48zM256 288.02c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32c0-17.68-14.33-32-32-32z"
  ]
};
export const faTireRugged = {
  prefix: "far",
  iconName: "tire-rugged",
  icon: [
    512,
    512,
    [],
    "f634",
    "M474.35 165.55c6.89-24.88.57-52.67-18.94-72.19L418.63 56.6c-13.98-13.98-32.56-21.68-52.33-21.68-6.82 0-13.49.92-19.89 2.69C333.69 15.17 309.58 0 282 0h-52c-27.58 0-51.69 15.17-64.42 37.61a74.512 74.512 0 0 0-19.89-2.69c-19.77 0-38.35 7.7-52.33 21.68L56.6 93.36c-19.52 19.52-25.83 47.32-18.94 72.19C15.19 178.27 0 202.39 0 230v52c0 27.6 15.19 51.72 37.65 64.44-6.89 24.88-.57 52.67 18.94 72.19l36.77 36.77c13.98 13.98 32.56 21.67 52.33 21.67 6.82 0 13.49-.92 19.89-2.69C178.3 496.83 202.41 512 230 512h52c27.59 0 51.7-15.17 64.42-37.61a74.457 74.457 0 0 0 19.89 2.69c19.77 0 38.35-7.7 52.32-21.67l36.77-36.77c19.52-19.52 25.83-47.32 18.94-72.19C496.81 333.72 512 309.6 512 282v-52c0-27.61-15.19-51.73-37.65-64.45zM464 282c0 14.36-11.64 26-26 26h-7.64c-3.6 12.09-8.34 23.69-14.25 34.58l5.35 5.35c10.15 10.15 10.15 26.62 0 36.77l-36.77 36.77c-5.08 5.08-11.73 7.62-18.38 7.62s-13.31-2.54-18.38-7.62l-5.35-5.35c-10.89 5.9-22.49 10.64-34.58 14.25V438c0 14.36-11.64 26-26 26h-52c-14.36 0-26-11.64-26-26v-7.64c-12.09-3.6-23.69-8.34-34.58-14.25l-5.35 5.35c-5.08 5.08-11.73 7.62-18.38 7.62s-13.31-2.54-18.38-7.62l-36.77-36.77c-10.15-10.15-10.15-26.62 0-36.77l5.35-5.35c-5.9-10.89-10.64-22.49-14.25-34.58H74c-14.36 0-26-11.64-26-26v-52c0-14.36 11.64-26 26-26h7.64c3.6-12.09 8.34-23.69 14.25-34.58l-5.35-5.34c-10.15-10.15-10.15-26.62 0-36.77l36.77-36.77c5.08-5.08 11.73-7.62 18.38-7.62s13.31 2.54 18.38 7.62l5.35 5.34c10.89-5.9 22.49-10.64 34.58-14.24V74c0-14.36 11.64-26 26-26h52c14.36 0 26 11.64 26 26v7.64c12.09 3.6 23.69 8.34 34.58 14.24l5.35-5.34c5.08-5.08 11.73-7.62 18.38-7.62s13.31 2.54 18.38 7.62l36.77 36.77c10.15 10.15 10.15 26.62 0 36.77l-5.35 5.34c5.9 10.89 10.64 22.49 14.25 34.58H438c14.36 0 26 11.64 26 26v52zM256 111.98c-79.53 0-144 64.47-144 144s64.47 144 144 144 144-64.47 144-144-64.47-144-144-144zm0 256c-61.76 0-112-50.24-112-112s50.24-112 112-112 112 50.24 112 112-50.24 112-112 112zM256 176c-13.25 0-24 10.74-24 24 0 13.25 10.75 24 24 24s24-10.75 24-24c0-13.26-10.75-24-24-24zm0 111.98c-13.25 0-24 10.74-24 24 0 13.25 10.75 24 24 24s24-10.75 24-24-10.75-24-24-24zM312 232c-13.25 0-24 10.74-24 24 0 13.25 10.75 24 24 24s24-10.75 24-24c0-13.26-10.75-24-24-24zm-112 0c-13.25 0-24 10.74-24 24 0 13.25 10.75 24 24 24s24-10.75 24-24c0-13.26-10.75-24-24-24z"
  ]
};
export const faTired = {
  prefix: "far",
  iconName: "tired",
  icon: [
    496,
    512,
    [],
    "f5c8",
    "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm129.1-303.8c-3.8-4.4-10.3-5.4-15.3-2.5l-80 48c-3.6 2.2-5.8 6.1-5.8 10.3s2.2 8.1 5.8 10.3l80 48c5.4 3.2 11.8 1.6 15.3-2.5 3.8-4.5 3.9-11 .1-15.5L343.6 208l33.6-40.3c3.8-4.5 3.7-11.1-.1-15.5zM220 208c0-4.2-2.2-8.1-5.8-10.3l-80-48c-5-3-11.5-1.9-15.3 2.5-3.8 4.5-3.9 11-.1 15.5l33.6 40.3-33.6 40.3c-3.8 4.5-3.7 11 .1 15.5 3.5 4.1 9.9 5.7 15.3 2.5l80-48c3.6-2.2 5.8-6.1 5.8-10.3zm28 64c-45.4 0-100.9 38.3-107.8 93.3-1.5 11.8 6.9 21.6 15.5 17.9C178.4 373.5 212 368 248 368s69.6 5.5 92.3 15.2c8.5 3.7 17-6 15.5-17.9-6.9-55-62.4-93.3-107.8-93.3z"
  ]
};
export const faToggleOff = {
  prefix: "far",
  iconName: "toggle-off",
  icon: [
    576,
    512,
    [],
    "f204",
    "M384 64H192C85.961 64 0 149.961 0 256s85.961 192 192 192h192c106.039 0 192-85.961 192-192S490.039 64 384 64zM48 256c0-79.583 64.404-144 144-144 79.582 0 144 64.404 144 144 0 79.582-64.404 144-144 144-79.582 0-144-64.404-144-144zm336 144h-65.02c86.704-76.515 86.683-211.504 0-288H384c79.582 0 144 64.404 144 144 0 79.582-64.404 144-144 144z"
  ]
};
export const faToggleOn = {
  prefix: "far",
  iconName: "toggle-on",
  icon: [
    576,
    512,
    [],
    "f205",
    "M384 64H192C86 64 0 150 0 256s86 192 192 192h192c106 0 192-86 192-192S490 64 384 64zm0 336c-79.6 0-144-64.4-144-144s64.4-144 144-144 144 64.4 144 144-64.4 144-144 144z"
  ]
};
export const faToilet = {
  prefix: "far",
  iconName: "toilet",
  icon: [
    384,
    512,
    [],
    "f7d8",
    "M152 64h-48c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V72c0-4.4-3.6-8-8-8zm216-16c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16H16C7.2 0 0 7.2 0 16v16c0 8.8 7.2 16 16 16h16v156.7C11.8 214.8 0 226.9 0 240c0 61.4 28.9 115.9 73.7 151l-24.3 79.7C43.1 491.2 58.5 512 80 512h224c21.5 0 36.9-20.8 30.6-41.3L310.3 391c44.8-35.1 73.7-89.7 73.7-151 0-13.1-11.8-25.2-32-35.3V48h16zM80 48h224v140.1c-31.5-7.6-70.2-12.1-112-12.1s-80.5 4.5-112 12.1V48zm21.6 416l14.5-47.6c23.3 10 48.9 15.6 75.9 15.6s52.6-5.6 75.9-15.6l14.5 47.6H101.6zm90.4-80c-63.6 0-117.3-41.6-136.3-98.9 34.8 11.7 83 18.9 136.3 18.9s101.5-7.2 136.3-18.9c-19 57.3-72.7 98.9-136.3 98.9zm0-116c-77.1 0-139.6-12.5-139.6-28s62.5-28 139.6-28 139.6 12.5 139.6 28-62.5 28-139.6 28z"
  ]
};
export const faToiletPaper = {
  prefix: "far",
  iconName: "toilet-paper",
  icon: [
    576,
    512,
    [],
    "f71e",
    "M216 232c13.25 0 24-10.75 24-24 0-13.26-10.75-24-24-24s-24 10.74-24 24c0 13.25 10.75 24 24 24zm80 0c13.25 0 24-10.75 24-24 0-13.26-10.75-24-24-24s-24 10.74-24 24c0 13.25 10.75 24 24 24zm-184-24c0 13.25 10.75 24 24 24s24-10.75 24-24c0-13.26-10.75-24-24-24s-24 10.74-24 24zm352-64c-13.25 0-24 21.49-24 48s10.75 48 24 48c13.26 0 24-21.49 24-48s-10.74-48-24-48zm0-144H144C82.14 0 32 85.96 32 192v172.07c0 41.12-9.8 62.77-31.17 126.87C-2.62 501.3 5.09 512 16.01 512h328.92c13.77 0 26-8.81 30.36-21.88 11.16-33.48 21.59-63.54 24.11-106.12H464c61.86 0 112-85.96 112-192S525.86 0 464 0zM352 192v172.07c0 41.07-8.02 68.04-18.6 99.93H60.6C73.16 426.48 80 401.78 80 364.07V192c0-86.57 38.52-144 64-144h246.09C366.78 83.19 352 134.58 352 192zm112 144c-25.48 0-64-57.43-64-144s38.52-144 64-144c25.48 0 64 57.43 64 144s-38.52 144-64 144z"
  ]
};
export const faToiletPaperAlt = {
  prefix: "far",
  iconName: "toilet-paper-alt",
  icon: [
    576,
    512,
    [],
    "f71f",
    "M464 144c-13.25 0-24 21.49-24 48s10.75 48 24 48c13.26 0 24-21.49 24-48s-10.74-48-24-48zm0-144H144C82.14 0 32 85.96 32 192v172.07c0 41.12-9.8 62.77-31.17 126.87C-2.62 501.3 5.09 512 16.01 512h328.92c13.77 0 26-8.81 30.36-21.88 11.16-33.48 21.59-63.54 24.11-106.12H464c61.86 0 112-85.96 112-192S525.86 0 464 0zM352 192v172.07c0 41.07-8.02 68.04-18.6 99.93H60.6C73.16 426.48 80 401.78 80 364.07V192c0-86.57 38.52-144 64-144h246.09C366.78 83.19 352 134.58 352 192zm112 144c-25.48 0-64-57.43-64-144s38.52-144 64-144c25.48 0 64 57.43 64 144s-38.52 144-64 144z"
  ]
};
export const faToiletPaperSlash = {
  prefix: "far",
  iconName: "toilet-paper-slash",
  icon: [
    640,
    512,
    [],
    "e072",
    "M496,144c-13.25,0-24,21.48-24,48s10.75,48,24,48,24-21.49,24-48S509.26,144,496,144ZM176,48H422.09C398.78,83.19,384,134.58,384,192v22.65L440.73,259A257.37,257.37,0,0,1,432,192c0-86.56,38.51-144,64-144s64,57.44,64,144c0,61.15-19.25,107.25-39.52,129.35l38.16,29.83C588.42,316.68,608,258.26,608,192,608,86,557.86,0,496,0H176c-16.17,0-31.5,6-45.38,16.56L172.13,49C173.41,48.75,174.77,48,176,48ZM365.41,464H92.59C105.16,426.48,112,401.78,112,364.06V192c0-2.42.32-4.56.38-6.93l-45.53-35.6A324.36,324.36,0,0,0,64,192V364.06c0,41.12-9.8,62.78-31.17,126.87A16,16,0,0,0,48,512H376.94a32,32,0,0,0,30.36-21.87c6.73-20.22,13-39.49,17.6-60.73l-42.85-33.5C379.11,420.68,373,441.16,365.41,464ZM634,471,36,3.52A16,16,0,0,0,13.51,6l-10,12.49A16,16,0,0,0,6,41L604,508.48A16,16,0,0,0,626.48,506l10-12.49A16,16,0,0,0,634,471Z"
  ]
};
export const faTombstone = {
  prefix: "far",
  iconName: "tombstone",
  icon: [
    512,
    512,
    [],
    "f720",
    "M336 160h-56v-48c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v48h-56c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h56v128c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V208h56c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16zm160 304h-48V192C448 85.96 362.04 0 256 0S64 85.96 64 192v272H16c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16zm-96 0H112V192c0-79.4 64.6-144 144-144s144 64.6 144 144v272z"
  ]
};
export const faTombstoneAlt = {
  prefix: "far",
  iconName: "tombstone-alt",
  icon: [
    512,
    512,
    [],
    "f721",
    "M496 464h-48V192C448 85.96 362.04 0 256 0S64 85.96 64 192v272H16c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16zm-96 0H112V192c0-79.4 64.6-144 144-144s144 64.6 144 144v272z"
  ]
};
export const faToolbox = {
  prefix: "far",
  iconName: "toolbox",
  icon: [
    512,
    512,
    [],
    "f552",
    "M512 237.25c0-8.49-3.37-16.62-9.37-22.63l-45.26-45.26c-6-6-14.14-9.37-22.63-9.37H384V80c0-26.51-21.49-48-48-48H176c-26.51 0-48 21.49-48 48v80H77.26c-8.49 0-16.63 3.37-22.63 9.37L9.37 214.63c-6 6-9.37 14.14-9.37 22.63L.01 304 0 448c0 17.67 14.33 32 32 32h448c17.67 0 32-14.33 32-32V237.25zM176 80h160v80H176V80zM48 243.88L83.88 208h344.23L464 243.88l.01 60.12H376v-16c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v16H184v-16c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v16H48.01L48 243.88zM464 432H48v-80h88v16c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-16h144v16c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-16h88v80z"
  ]
};
export const faTools = {
  prefix: "far",
  iconName: "tools",
  icon: [
    512,
    512,
    [],
    "f7d9",
    "M224 96.1v48.8l29.7 29.7c-6.8-34.8 3.5-70.3 28.5-95.3 20.3-20.3 47.2-31.2 75-31.2h1.2L301 105.3l15.1 90.6 90.6 15.1 57.3-57.3c.3 28.3-10.6 55.5-31.2 76.1-9.3 9.3-20.2 16.4-31.8 21.6 1.8 1.6 3.9 2.9 5.6 4.6l30.7 30.7c10.5-6.3 20.5-13.9 29.4-22.9 38.1-38.1 53.7-94.3 40.7-146.6C504.4 105 495 95.4 483 92c-12.2-3.4-25.2.1-34 9l-58.7 58.6-32.4-5.4-5.4-32.4 58.6-58.6c8.9-8.9 12.3-21.9 8.9-34-3.3-12.1-13-21.5-25.2-24.5-53.2-13.2-107.9 2-146.6 40.6C238 55.5 229.7 67 222.9 79.2l1.1.8v16.1zM106 454c-12.8 12.8-35.3 12.8-48.1 0-6.4-6.4-10-15-10-24 0-9.1 3.5-17.6 10-24l134.4-134.4-33.9-33.9L24 372C8.5 387.5 0 408.1 0 430s8.5 42.5 24 58 36.1 24 58 24 42.5-8.5 58-24l100.9-100.9c-9.7-15.8-15.2-33.8-15.7-52.1L106 454zm395.1-58.3L384 278.6c-23.1-23.1-57.6-27.6-85.4-13.9L192 158.1V96L64 0 0 64l96 128h62.1l106.6 106.6c-13.6 27.8-9.2 62.3 13.9 85.4l117.1 117.1c14.6 14.6 38.2 14.6 52.7 0l52.7-52.7c14.5-14.6 14.5-38.2 0-52.7z"
  ]
};
export const faTooth = {
  prefix: "far",
  iconName: "tooth",
  icon: [
    448,
    512,
    [],
    "f5c9",
    "M443.96 96.2c-11.03-45.29-47.13-82.07-91.97-93.7-27.48-7.16-57.49 1.03-89.16 24.31-11.45 8.42-25.2 13.02-38.81 13.3-6.28-.12-17.12.13-40.43-14.36-.1-.06-.21-.05-.3-.11C152.33 3.4 122.92-4.46 96.04 2.49c-44.85 11.64-80.96 48.43-92 93.73-9.59 39.52-1.95 78.74 21.51 110.45 20.51 27.71 32.04 61.82 36.29 107.35 3.61 38.69 9.26 89.62 20.93 140.32l7.8 33.99c3.22 13.94 15.42 23.67 29.67 23.67 13.97 0 26.12-9.5 29.54-23.16l34.48-138.43c4.56-18.35 20.9-31.16 39.74-31.16 18.84 0 35.2 12.81 39.76 31.16l34.46 138.48C301.65 502.5 313.8 512 327.77 512c14.25 0 26.45-9.74 29.67-23.69l7.8-33.97c11.67-50.71 17.33-101.63 20.93-140.32 4.25-45.54 15.78-79.65 36.28-107.35 23.47-31.71 31.11-70.93 21.51-110.47zm-60.09 81.9c-25.93 35.05-40.38 76.82-45.48 131.45-2.52 26.85-6.03 59.74-11.94 94.01l-16.12-64.75c-9.92-39.77-45.42-67.55-86.33-67.55-40.93 0-76.43 27.78-86.32 67.57l-16.14 64.75c-5.9-34.25-9.42-67.18-11.94-94.02-5.09-54.63-19.54-96.4-45.49-131.45-14.84-20.06-19.62-45.11-13.45-70.52 6.9-28.35 29.45-51.36 57.44-58.63 2.53-.66 5.14-.98 7.75-.98 15.92 0 17.9 3.35 135.48 76.4 3.94 2.45 8.31 3.61 12.64 3.61 8.01 0 15.86-4.02 20.4-11.34 6.98-11.25 3.53-26.05-7.73-33.05l-8.46-5.26c8.08-3.47 15.9-7.55 23.08-12.82 19.22-14.16 35.12-20.13 48.63-16.53 27.98 7.25 50.52 30.27 57.41 58.6 6.21 25.39 1.43 50.44-13.43 70.51z"
  ]
};
export const faToothbrush = {
  prefix: "far",
  iconName: "toothbrush",
  icon: [
    640,
    512,
    [],
    "f635",
    "M624 464H16c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16zM48 224c-8.84 0-16 7.16-16 16v192h48V240c0-8.84-7.16-16-16-16H48zm368 0c-8.84 0-16 7.16-16 16v192h48V240c0-8.84-7.16-16-16-16h-16zm-272 0c-8.84 0-16 7.16-16 16v192h48V240c0-8.84-7.16-16-16-16h-16zm176 0c-8.84 0-16 7.16-16 16v192h48V240c0-8.84-7.16-16-16-16h-16zm-88 0c-8.84 0-16 7.16-16 16v192h48V240c0-8.84-7.16-16-16-16h-16zM64 192h352c35.35 0 64-28.65 64-64C480 57.31 422.69 0 352 0c23.62 23.62 6.89 64-26.51 64H64C28.65 64 0 92.65 0 128s28.65 64 64 64zm0-80h261.49c32.45 0 61.66-18.11 76.18-46.68C420.13 79.99 432 102.64 432 128c0 8.82-7.18 16-16 16H64c-8.82 0-16-7.18-16-16s7.18-16 16-16z"
  ]
};
export const faTorah = {
  prefix: "far",
  iconName: "torah",
  icon: [
    640,
    512,
    [],
    "f6a0",
    "M224.36 256l-29.21 48.86a21.11 21.11 0 0 0 18.1 32h59.54L302 385.71a20.78 20.78 0 0 0 18 10.23 21.13 21.13 0 0 0 18.16-10.37l29.13-48.7h59.45a21.25 21.25 0 0 0 18.48-10.72A20.69 20.69 0 0 0 445 305l-29.35-49 29.24-48.86a21.12 21.12 0 0 0-18.1-32h-59.54L338 126.29a20.76 20.76 0 0 0-17.95-10.23 21.13 21.13 0 0 0-18.22 10.37l-29.13 48.7h-59.45a21.23 21.23 0 0 0-18.48 10.72A20.7 20.7 0 0 0 195 207zm-3.62 55.5l18.39-30.82 18.46 30.82zm99.31 55l-17.74-29.64h35.46zm99.26-55h-36.86l18.41-30.8zm-.05-111l-18.4 30.82-18.46-30.82zm-99.26-55l17.68 29.62h-35.46zm-32.93 54.95h65.79L386.09 256l-33.17 55.5h-65.79L253.9 256zm-29.52 0l-18.37 30.8-18.44-30.8zM560 0c-36.17 0-65.67 20-75.88 48H155.88C145.67 20 116.17 0 80 0 35.14 0 0 30.46 0 69.33v373.34C0 481.54 35.14 512 80 512c36.17 0 65.67-19.95 75.88-48h328.24c10.21 28.05 39.71 48 75.88 48 44.86 0 80-30.46 80-69.33V69.33C640 30.46 604.86 0 560 0zM112 442.67C112 454.45 97.67 464 80 464s-32-9.55-32-21.33V69.33C48 57.55 62.33 48 80 48s32 9.55 32 21.33zM480 416H160V96h320zm112 26.67c0 11.78-14.33 21.33-32 21.33s-32-9.55-32-21.33V69.33C528 57.55 542.33 48 560 48s32 9.55 32 21.33z"
  ]
};
export const faToriiGate = {
  prefix: "far",
  iconName: "torii-gate",
  icon: [
    512,
    512,
    [],
    "f6a1",
    "M480 176c17.7 0 32-14.3 32-32V0c-42.1 21-88.5 32-135.5 32H135.6C88.5 32 42.1 21 0 0v144c0 17.7 14.3 32 32 32h32v64H16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h48v208c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V288h288v208c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V288h48c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16h-48v-64zm-248 64H112v-64h120zm168 0H280v-64h120zM48 128V68.9C76.6 76.2 106.1 80 135.5 80h240.9c29.5 0 59-3.8 87.5-11.1V128z"
  ]
};
export const faTornado = {
  prefix: "far",
  iconName: "tornado",
  icon: [
    512,
    512,
    [],
    "f76f",
    "M429.1 25.2c7.4-10.6 0-25.2-12.9-25.2h-400C7.1 0-.3 7.6 0 16.5c13.3 352.7 452 219.8 331.7 472.6-5 10.6 2.6 22.9 14.3 22.9h27.4c7.9 0 15.8-3 21.7-8.3 320.6-286.7-138.9-229.8 34-478.5zM360.4 48c-13.8 29.8-19.3 56.3-19.3 80H76.4c-12.3-22-21.2-48.1-25.6-80h309.6zM114.6 176h234.7c11.8 33.3 34.3 59.3 55.1 80H257.1c-4.3-1.9-8.5-3.8-12.8-5.7-47.6-20.9-93.9-41.4-129.7-74.3zm284.6 257.6c3.2-24.3.9-46.6-6.8-67.2-9.8-26.3-26.9-46-48.1-62.5h107.3c8 10.2 12.5 19.4 12.3 29.1-.2 14.3-9.7 44.9-64.7 100.6z"
  ]
};
export const faTractor = {
  prefix: "far",
  iconName: "tractor",
  icon: [
    640,
    512,
    [],
    "f722",
    "M608 160h-80v-48c0-10.59 3.52-20.82 9.86-29.13 3.32-4.35 2.66-10.54-.99-14.62l-16.22-18.12c-5-5.58-13.74-5.19-18.53.58C487.93 67.83 480 89.51 480 112v48H364.4L306.22 24.23C299.88 9.52 285.44 0 269.44 0H136c-22.06 0-40 17.94-40 40v144.53c-11.97.87-23.15 5.72-31.72 14.29l-25.45 25.45c-9.44 9.45-14.64 22-14.64 35.36 0 4.94.71 9.77 2.08 14.37C10.63 282.47 0 299.02 0 318v36c0 18.98 10.63 35.53 26.26 44-1.37 4.6-2.08 9.43-2.08 14.37 0 13.36 5.2 25.91 14.65 35.35l25.46 25.46c9.44 9.44 22 14.64 35.35 14.65 4.94 0 9.77-.71 14.37-2.09 8.46 15.63 25.01 26.26 44 26.26h36.01c18.98 0 35.52-10.64 43.99-26.26a50.3 50.3 0 0 0 14.37 2.09c13.36 0 25.92-5.2 35.36-14.65l25.45-25.45c9.44-9.45 14.64-22 14.64-35.36 0-4.94-.71-9.77-2.08-14.37 6.27-3.4 11.42-8.36 15.72-14h80.42c-3.57 10.05-5.88 20.72-5.88 32 0 53.02 42.98 96 96 96s96-42.98 96-96c0-26.51-10.74-50.51-28.12-67.88l50.74-50.74c6-6 9.37-14.14 9.37-22.63V192c0-17.67-14.33-32-32-32zM144 48h120.19l47.98 112H157.99c-4.86 0-9.55.74-13.99 2.04V48zm160 306c0 1.1-.9 2-2 2h-17.77c-6.73 22.57-6.25 21.41-17.55 42.39l12.56 12.56c.67.67.66 2.16 0 2.82l-25.46 25.46h-2.83l-12.55-12.56c-21.02 11.32-19.88 10.84-42.4 17.55V462a2 2 0 0 1-2 2h-36c-1.1 0-2-.9-2-2v-17.77c-22.49-6.71-21.38-6.23-42.4-17.55l-12.56 12.56h-2.83l-25.46-25.46c-.67-.67-.67-2.16 0-2.83l12.55-12.56C74 377.41 74.47 378.53 67.76 356H50c-1.1 0-2-.9-2-2v-36c0-1.1.9-2 2-2h17.77c6.73-22.57 6.25-21.41 17.55-42.39l-12.56-12.56c-.67-.67-.66-2.16 0-2.82l25.46-25.46h2.83l12.55 12.56c21.02-11.32 19.88-10.84 42.4-17.55V210a2 2 0 0 1 2-2h36c1.1 0 2 .9 2 2v17.77c22.49 6.7 21.38 6.22 42.4 17.55l12.56-12.56h2.83l25.46 25.46c.67.67.67 2.16 0 2.83l-12.55 12.56c11.3 20.98 10.83 19.86 17.54 42.39H302c1.1 0 2 .9 2 2v36zm208 110c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48zm80-195.88l-55.45 55.45c-7.88-2.09-16.01-3.57-24.55-3.57-19.59 0-37.76 5.93-52.95 16H352v-18c0-18.98-10.63-35.53-26.26-44 1.37-4.6 2.08-9.43 2.08-14.37 0-13.36-5.2-25.91-14.65-35.35L296.9 208H592v60.12zm-380.22 14.81C201.57 276.03 189.25 272 176 272s-25.57 4.03-35.78 10.93a64.352 64.352 0 0 0-17.29 17.29C116.03 310.43 112 322.74 112 336c0 35.35 28.65 64 64 64s64-28.65 64-64c0-13.26-4.03-25.57-10.93-35.78a64.352 64.352 0 0 0-17.29-17.29zM176 352c-8.82 0-16-7.18-16-16s7.18-16 16-16 16 7.18 16 16-7.18 16-16 16z"
  ]
};
export const faTrademark = {
  prefix: "far",
  iconName: "trademark",
  icon: [
    640,
    512,
    [],
    "f25c",
    "M640 403l-23.8-296c-.5-6.2-5.7-11-12-11h-43c-4.9 0-9.3 3-11.2 7.6l-59.6 150.6c-7.2 18.9-15.8 46.9-15.8 46.9h-.9s-9-27.9-16.2-46.9l-59.6-150.6c-1.8-4.6-6.2-7.6-11.2-7.6h-43c-6.2 0-11.5 4.8-12 11l-24.2 296c-.6 7 4.9 13 12 13h34c6.3 0 11.5-4.8 12-11.1l12.7-167.8c1.4-21.2.5-50 .5-50h.9s9.9 31.5 17.6 50l48.3 116.5c1.9 4.5 6.2 7.4 11.1 7.4h34.9c4.8 0 9.2-2.9 11.1-7.4L551.3 237c7.7-18.5 17.1-49.6 17.1-49.6h.9s-.9 28.4.5 49.6l12.7 167.8c.5 6.3 5.7 11.1 12 11.1H628c7 .1 12.5-5.9 12-12.9zM256.2 96H12c-6.6 0-12 5.4-12 12v26c0 6.6 5.4 12 12 12h93v258c0 6.6 5.4 12 12 12h34.1c6.6 0 12-5.4 12-12V146h93c6.6 0 12-5.4 12-12v-26c.1-6.6-5.3-12-11.9-12z"
  ]
};
export const faTrafficCone = {
  prefix: "far",
  iconName: "traffic-cone",
  icon: [
    512,
    512,
    [],
    "f636",
    "M496 464h-21.39L294.54 11.52A18.284 18.284 0 0 0 277.55 0h-43.11c-7.49 0-14.22 4.57-16.99 11.52L37.39 464H16c-8.84 0-16 7.16-16 16v24c0 4.42 3.58 8 8 8h496c4.42 0 8-3.58 8-8v-24c0-8.84-7.16-16-16-16zM365.64 320H146.36l44.57-112h130.15l44.56 112zM254.6 48h2.8l44.57 112h-91.94L254.6 48zM127.25 368h257.49l38.2 96H89.05l38.2-96z"
  ]
};
export const faTrafficLight = {
  prefix: "far",
  iconName: "traffic-light",
  icon: [
    384,
    512,
    [],
    "f637",
    "M384 192h-48v-45.31c28.57-16.63 48-47.24 48-82.69h-48V32c0-17.67-14.33-32-32-32H80C62.33 0 48 14.33 48 32v32H0c0 35.44 19.43 66.05 48 82.69V192H0c0 35.44 19.43 66.05 48 82.69V320H0c0 37.73 21.97 70.05 53.63 85.74C70.3 466.84 125.62 512 192 512s121.7-45.16 138.37-106.26C362.03 390.05 384 357.73 384 320h-48v-45.31c28.57-16.64 48-47.25 48-82.69zm-96 176c0 52.93-43.06 96-96 96-52.93 0-96-43.07-96-96V48h192v320zm-96-192c26.51 0 48-21.49 48-48s-21.49-48-48-48-48 21.49-48 48 21.49 48 48 48zm0 128c26.51 0 48-21.49 48-48s-21.49-48-48-48-48 21.49-48 48 21.49 48 48 48zm0 128c26.51 0 48-21.49 48-48s-21.49-48-48-48-48 21.49-48 48 21.49 48 48 48z"
  ]
};
export const faTrafficLightGo = {
  prefix: "far",
  iconName: "traffic-light-go",
  icon: [
    384,
    512,
    [],
    "f638",
    "M384 192h-48v-45.31c28.57-16.63 48-47.24 48-82.69h-48V32c0-17.67-14.33-32-32-32H80C62.33 0 48 14.33 48 32v32H0c0 35.44 19.43 66.05 48 82.69V192H0c0 35.44 19.43 66.05 48 82.69V320H0c0 37.73 21.97 70.05 53.63 85.74C70.3 466.84 125.62 512 192 512s121.7-45.16 138.37-106.26C362.03 390.05 384 357.73 384 320h-48v-45.31c28.57-16.64 48-47.25 48-82.69zm-96 176c0 52.93-43.06 96-96 96s-96-43.07-96-96V48h192v320zm-96-192c26.51 0 48-21.49 48-48s-21.49-48-48-48-48 21.49-48 48 21.49 48 48 48zm0-72c13.23 0 24 10.77 24 24s-10.77 24-24 24-24-10.77-24-24 10.77-24 24-24zm0 200c26.51 0 48-21.49 48-48s-21.49-48-48-48-48 21.49-48 48 21.49 48 48 48zm0-72c13.23 0 24 10.77 24 24s-10.77 24-24 24-24-10.77-24-24 10.77-24 24-24zm0 200c26.51 0 48-21.49 48-48s-21.49-48-48-48-48 21.49-48 48 21.49 48 48 48z"
  ]
};
export const faTrafficLightSlow = {
  prefix: "far",
  iconName: "traffic-light-slow",
  icon: [
    384,
    512,
    [],
    "f639",
    "M384 192h-48v-45.31c28.57-16.63 48-47.24 48-82.69h-48V32c0-17.67-14.33-32-32-32H80C62.33 0 48 14.33 48 32v32H0c0 35.44 19.43 66.05 48 82.69V192H0c0 35.44 19.43 66.05 48 82.69V320H0c0 37.73 21.97 70.05 53.63 85.74C70.3 466.84 125.62 512 192 512s121.7-45.16 138.37-106.26C362.03 390.05 384 357.73 384 320h-48v-45.31c28.57-16.64 48-47.25 48-82.69zm-96 176c0 52.93-43.06 96-96 96-52.93 0-96-43.07-96-96V48h192v320zm-96-192c26.51 0 48-21.49 48-48s-21.49-48-48-48-48 21.49-48 48 21.49 48 48 48zm0-72c13.23 0 24 10.77 24 24s-10.77 24-24 24-24-10.77-24-24 10.77-24 24-24zm0 328c26.51 0 48-21.49 48-48s-21.49-48-48-48-48 21.49-48 48 21.49 48 48 48zm0-72c13.23 0 24 10.77 24 24s-10.77 24-24 24-24-10.77-24-24 10.77-24 24-24zm0-56c26.51 0 48-21.49 48-48s-21.49-48-48-48-48 21.49-48 48 21.49 48 48 48z"
  ]
};
export const faTrafficLightStop = {
  prefix: "far",
  iconName: "traffic-light-stop",
  icon: [
    384,
    512,
    [],
    "f63a",
    "M384 192h-48v-45.31c28.57-16.63 48-47.24 48-82.69h-48V32c0-17.67-14.33-32-32-32H80C62.33 0 48 14.33 48 32v32H0c0 35.44 19.43 66.05 48 82.69V192H0c0 35.44 19.43 66.05 48 82.69V320H0c0 37.73 21.97 70.05 53.63 85.74C70.3 466.84 125.62 512 192 512s121.7-45.16 138.37-106.26C362.03 390.05 384 357.73 384 320h-48v-45.31c28.57-16.64 48-47.25 48-82.69zm-96 176c0 52.93-43.06 96-96 96-52.93 0-96-43.07-96-96V48h192v320zm-96-192c26.51 0 48-21.49 48-48s-21.49-48-48-48-48 21.49-48 48 21.49 48 48 48zm0 128c26.51 0 48-21.49 48-48s-21.49-48-48-48-48 21.49-48 48 21.49 48 48 48zm0-72c13.23 0 24 10.77 24 24s-10.77 24-24 24-24-10.77-24-24 10.77-24 24-24zm0 200c26.51 0 48-21.49 48-48s-21.49-48-48-48-48 21.49-48 48 21.49 48 48 48zm0-72c13.23 0 24 10.77 24 24s-10.77 24-24 24-24-10.77-24-24 10.77-24 24-24z"
  ]
};
export const faTrailer = {
  prefix: "far",
  iconName: "trailer",
  icon: [
    640,
    512,
    [],
    "e041",
    "M176,320a80,80,0,1,0,80,80A80,80,0,0,0,176,320Zm0,112a32,32,0,1,1,32-32A32,32,0,0,1,176,432Zm448-96H544V96a32,32,0,0,0-32-32H32A32,32,0,0,0,0,96V368a16,16,0,0,0,16,16H52.58c7.59,0,13.69-5.44,15.64-12.78C80.91,323.36,124.14,288,176,288s95.09,35.36,107.78,83.22c2,7.34,8.05,12.78,15.64,12.78H624a16,16,0,0,0,16-16V352A16,16,0,0,0,624,336Zm-128,0H440V160a16,16,0,0,0-16-16H408a16,16,0,0,0-16,16V336H344V160a16,16,0,0,0-16-16H312a16,16,0,0,0-16,16V295.79a158.8,158.8,0,0,0-48-38.09V160a16,16,0,0,0-16-16H216a16,16,0,0,0-16,16v81.81a151.35,151.35,0,0,0-48,.21V160a16,16,0,0,0-16-16H120a16,16,0,0,0-16,16v97.4a160.31,160.31,0,0,0-56,47.87V112H496Z"
  ]
};
export const faTrain = {
  prefix: "far",
  iconName: "train",
  icon: [
    448,
    512,
    [],
    "f238",
    "M264 336c0 22.091-17.909 40-40 40s-40-17.909-40-40 17.909-40 40-40 40 17.909 40 40zm184-226.286v228.572c0 49.194-43.705 90.629-99.059 104.713l58.758 58.758c3.78 3.78 1.103 10.243-4.243 10.243h-48.427a11.996 11.996 0 0 1-8.485-3.515L286.059 448H161.941l-60.485 60.485A12.002 12.002 0 0 1 92.971 512H44.544c-5.345 0-8.022-6.463-4.243-10.243l58.758-58.758C43.886 428.961 0 387.656 0 338.286V109.714C0 45.928 71.001 0 138.286 0h171.428C377.889 0 448 45.922 448 109.714zM48 224h352v-80H48v80zm2.774-128h346.534c-10.2-26.136-47.971-48-87.595-48H138.286c-38.862 0-77.011 21.67-87.512 48zM400 338.286V272H48v66.286C48 374.495 99.974 400 138.286 400h171.428C347.479 400 400 374.816 400 338.286z"
  ]
};
export const faTram = {
  prefix: "far",
  iconName: "tram",
  icon: [
    512,
    512,
    [],
    "f7da",
    "M511.1 49.6c-3.5-12.8-16.7-20.2-29.5-16.8l-464 128C4.8 164.3-2.7 177.6.8 190.3 3.8 201 13.5 208 24 208c2.1 0 4.3-.3 6.4-.9L232 151.5V224H64c-17.7 0-32 14.3-32 32v224c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32H280v-85.7l214.4-59.1c12.8-3.6 20.3-16.8 16.7-29.6zM432 272v192H80V272h352zM144 384h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16zm96 0h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16zm96 0h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16zM192 96c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm96-32c17.7 0 32-14.3 32-32S305.7 0 288 0s-32 14.3-32 32 14.3 32 32 32z"
  ]
};
export const faTransgender = {
  prefix: "far",
  iconName: "transgender",
  icon: [
    384,
    512,
    [],
    "f224",
    "M372 0h-63c-10.7 0-16 12.9-8.5 20.5L315 35l-87.6 87.6C203.9 105.9 175.1 96 144 96 64.5 96 0 160.5 0 240c0 71.4 51.9 130.6 120 142v34H76c-6.6 0-12 5.4-12 12v24c0 6.6 5.4 12 12 12h44v36c0 6.6 5.4 12 12 12h24c6.6 0 12-5.4 12-12v-36h44c6.6 0 12-5.4 12-12v-24c0-6.6-5.4-12-12-12h-44v-34c68.1-11.4 120-70.6 120-142 0-31.1-9.9-59.9-26.6-83.4L349 69l14.5 14.5c7.6 7.6 20.5 2.2 20.5-8.5V12c0-6.6-5.4-12-12-12zM144 336c-52.9 0-96-43.1-96-96s43.1-96 96-96 96 43.1 96 96-43.1 96-96 96z"
  ]
};
export const faTransgenderAlt = {
  prefix: "far",
  iconName: "transgender-alt",
  icon: [
    480,
    512,
    [],
    "f225",
    "M468 0h-63c-10.7 0-16 12.9-8.5 20.5L411 35l-87.6 87.6C299.9 105.9 271.1 96 240 96s-59.9 9.9-83.4 26.6l-26-26L150 77.1c4.7-4.7 4.7-12.3 0-17l-17-17c-4.7-4.7-12.3-4.7-17 0L96.6 62.6 69 35l14.5-14.5C91.1 12.9 85.7 0 75 0H12C5.4 0 0 5.4 0 12v63c0 10.7 12.9 16 20.5 8.5L35 69l27.6 27.6L43.2 116c-4.7 4.7-4.7 12.3 0 17l17 17c4.7 4.7 12.3 4.7 17 0l19.5-19.5 26 26C105.9 180.1 96 208.9 96 240c0 71.4 51.9 130.6 120 142v34h-44c-6.6 0-12 5.4-12 12v24c0 6.6 5.4 12 12 12h44v36c0 6.6 5.4 12 12 12h24c6.6 0 12-5.4 12-12v-36h44c6.6 0 12-5.4 12-12v-24c0-6.6-5.4-12-12-12h-44v-34c68.1-11.4 120-70.6 120-142 0-31.1-9.9-59.9-26.6-83.4L445 69l14.5 14.5c7.6 7.6 20.5 2.2 20.5-8.5V12c0-6.6-5.4-12-12-12zM240 336c-52.9 0-96-43.1-96-96s43.1-96 96-96 96 43.1 96 96-43.1 96-96 96z"
  ]
};
export const faTransporter = {
  prefix: "far",
  iconName: "transporter",
  icon: [
    512,
    512,
    [],
    "e042",
    "M255.958,96l.01953-.00195L255.99707,96a48,48,0,1,0,0-96l-.01953.002L255.958,0a48,48,0,1,0,0,96ZM63.99194,96,51.57169,66.21484a3.99313,3.99313,0,0,0-7.15449,0L31.997,96,2.211,108.41992a3.99921,3.99921,0,0,0,0,7.1543l29.786,12.41992L44.4172,157.7793a3.9947,3.9947,0,0,0,7.15449,0l12.42025-29.78516,29.786-12.41992a4.00079,4.00079,0,0,0,0-7.1543ZM384.00049,464H319.99487V211.20312l53.12642,67.625a24.00329,24.00329,0,0,0,37.751-29.65624L332.464,149.35938A55.81142,55.81142,0,0,0,288.43153,128H223.5548a55.672,55.672,0,0,0-44.03243,21.40625L101.114,249.17188a24.00329,24.00329,0,0,0,37.751,29.65624l53.12641-67.59765V464h-63.9978A31.99951,31.99951,0,0,0,95.9928,496v16H416.00134V496A31.99951,31.99951,0,0,0,384.00049,464Zm-120.00321,0H247.99686V320h16.00042ZM509.789,44.43164,480.005,32.01172,467.58475,2.22656a3.99471,3.99471,0,0,0-7.15644,0L448.00806,32.01172l-29.784,12.41992a3.99921,3.99921,0,0,0,0,7.1543l29.784,12.41992L460.42831,93.791a3.99628,3.99628,0,0,0,7.15644,0L480.005,64.00586l29.784-12.41992a3.99921,3.99921,0,0,0,0-7.1543Z"
  ]
};
export const faTransporter1 = {
  prefix: "far",
  iconName: "transporter-1",
  icon: [
    512,
    512,
    [],
    "e043",
    "M191.99145,416h56.00541V384H191.99145Zm72.00583,0h55.99759V384H263.99728Zm-144.039-128a23.98036,23.98036,0,0,0,18.90676-9.17188l53.12641-67.59765V352h56.00541V320h16.00042v32h55.99759V211.20312l53.12642,67.625a24.00329,24.00329,0,0,0,37.751-29.65624L332.464,149.35938A55.81142,55.81142,0,0,0,288.43153,128H223.5548a55.672,55.672,0,0,0-44.03243,21.40625L101.114,249.17188A23.99035,23.99035,0,0,0,119.95828,288ZM255.958,96l.01953-.00195L255.99707,96a48,48,0,1,0,0-96l-.01953.002L255.958,0a48,48,0,1,0,0,96ZM384.00049,464H319.99487V448H263.99728v16H247.99686V448H191.99145v16h-63.9978A31.99951,31.99951,0,0,0,95.9928,496v16H416.00134V496A31.99951,31.99951,0,0,0,384.00049,464ZM509.789,364.41992,480.005,352l-12.42026-29.78516a3.99471,3.99471,0,0,0-7.15644,0L448.00806,352l-29.784,12.41992a3.99921,3.99921,0,0,0,0,7.1543l29.784,12.41992,12.42025,29.78516a3.99628,3.99628,0,0,0,7.15644,0L480.005,383.99414l29.784-12.41992a3.99921,3.99921,0,0,0,0-7.1543ZM63.99194,128.002,51.57169,98.21875a3.99313,3.99313,0,0,0-7.15449,0L31.997,128.002,2.211,140.42188a4.00078,4.00078,0,0,0,0,7.15624l29.786,12.41993,12.42025,29.7832a3.99313,3.99313,0,0,0,7.15449,0l12.42025-29.7832,29.786-12.41993a4.00236,4.00236,0,0,0,0-7.15624Z"
  ]
};
export const faTransporter2 = {
  prefix: "far",
  iconName: "transporter-2",
  icon: [
    512,
    512,
    [],
    "e044",
    "M264.0061,416h55.99781V384H264.0061Zm55.99781-96H264.0061v32h55.99781Zm0-64H192v32H320.00391Zm53.12662,22.82812a23.99776,23.99776,0,0,0,33.68853,4.04688A23.74886,23.74886,0,0,0,414.32124,256H355.19639ZM255.9668,96l.01953-.00195L256.00586,96a48,48,0,1,0,0-96l-.01953.002L255.9668,0a48,48,0,1,0,0,96ZM192,211.23047V224H320.00391V211.20312L330.05695,224h61.05069L332.473,149.35938A55.81171,55.81171,0,0,0,288.44044,128h-64.877a55.67227,55.67227,0,0,0-44.03259,21.40625L120.906,224h61.05851ZM248.00562,320H192v32h56.00562ZM119.96655,288a23.98048,23.98048,0,0,0,18.90683-9.17188L156.81533,256H97.68267a23.69223,23.69223,0,0,0,22.28388,32ZM192,416h56.00562V384H192Zm192.00977,48H320.00391V448H264.0061v16H248.00562V448H192v16H128.002a31.99957,31.99957,0,0,0-32.001,32v16H416.01074V496A31.99957,31.99957,0,0,0,384.00977,464ZM509.791,140.416l-29.78607-12.41993-12.4203-29.7832a3.99315,3.99315,0,0,0-7.15451,0l-12.4203,29.7832L418.2237,140.416a4.00079,4.00079,0,0,0,0,7.15625l29.78607,12.41992,12.4203,29.7832a3.99315,3.99315,0,0,0,7.15451,0l12.4203-29.7832L509.791,147.57227a4.00237,4.00237,0,0,0,0-7.15625ZM63.99023,32.002,51.56993,2.21875a3.99315,3.99315,0,0,0-7.15451,0L31.99512,32.002,2.20905,44.42188a4.00078,4.00078,0,0,0,0,7.15429L31.99512,63.99609l12.4203,29.78516a3.99315,3.99315,0,0,0,7.15451,0l12.4203-29.78516L93.7763,51.57617a3.99921,3.99921,0,0,0,0-7.15429Z"
  ]
};
export const faTransporter3 = {
  prefix: "far",
  iconName: "transporter-3",
  icon: [
    512,
    512,
    [],
    "e045",
    "M509.791,44.43164,480.00488,32.01172,467.58458,2.22656a3.99315,3.99315,0,0,0-7.15451,0l-12.4203,29.78516L418.2237,44.43164a3.99921,3.99921,0,0,0,0,7.1543l29.78607,12.41992L460.43007,93.791a3.99472,3.99472,0,0,0,7.15451,0l12.4203-29.78516L509.791,51.58594a4.00079,4.00079,0,0,0,0-7.1543ZM63.99023,352.00391,51.56993,322.2207a3.99315,3.99315,0,0,0-7.15451,0l-12.4203,29.78321L2.20905,364.42383a4.00237,4.00237,0,0,0,0,7.15625L31.99512,384l12.4203,29.7832a3.99315,3.99315,0,0,0,7.15451,0L63.99023,384,93.7763,371.58008a4.00079,4.00079,0,0,0,0-7.15625Zm309.13248-73.17579a23.99776,23.99776,0,0,0,33.68853,4.04688A23.74885,23.74885,0,0,0,414.31343,256H355.18857ZM319.99609,320h-55.9978v32h55.9978ZM191.99219,211.23047V224h128.0039V211.20312L330.04913,224h61.0507l-25.13749-32H146.04743l-25.14921,32h61.0585ZM255.99805,0l-.01954.002L255.959,0a47.95186,47.95186,0,0,0-45.0502,32h90.13947A47.95186,47.95186,0,0,0,255.99805,0ZM255.959,96l.01953-.00195L255.99805,96a47.87741,47.87741,0,0,0,45.06-32H210.899A47.87741,47.87741,0,0,0,255.959,96Zm76.50624,53.35938A55.81167,55.81167,0,0,0,288.43263,128h-64.877a55.67224,55.67224,0,0,0-44.03259,21.40625L171.19663,160H340.82485ZM263.99829,416h55.9978V384h-55.9978ZM384.002,464H319.99609V448h-55.9978v16H247.9978V448H191.99219v16h-63.998a31.99957,31.99957,0,0,0-32.001,32v16H416.00293V496A31.99957,31.99957,0,0,0,384.002,464ZM191.99219,416H247.9978V384H191.99219ZM119.95874,288a23.98048,23.98048,0,0,0,18.90683-9.17188L156.80752,256H97.67486a23.69223,23.69223,0,0,0,22.28388,32ZM247.9978,320H191.99219v32H247.9978Zm71.99829-64H191.99219v32h128.0039Z"
  ]
};
export const faTransporterEmpty = {
  prefix: "far",
  iconName: "transporter-empty",
  icon: [
    512,
    512,
    [],
    "e046",
    "M509.791,268.419l-29.78607-12.42-12.4203-29.78527a3.99315,3.99315,0,0,0-7.15451,0L448.00977,255.999l-29.78607,12.42a3.99924,3.99924,0,0,0,0,7.15433l29.78607,12.42,12.4203,29.78527a3.99471,3.99471,0,0,0,7.15451,0l12.4203-29.78527,29.78607-12.42a4.00082,4.00082,0,0,0,0-7.15433ZM63.99023,32.00208,51.56993,2.21876a3.99314,3.99314,0,0,0-7.15451,0L31.99512,32.00208,2.20905,44.422a4.0024,4.0024,0,0,0,0,7.15628l29.78607,12.42,12.4203,29.78332a3.99314,3.99314,0,0,0,7.15451,0l12.4203-29.78332,29.78607-12.42a4.00082,4.00082,0,0,0,0-7.15628ZM384.00977,463.99982H128.002a31.99963,31.99963,0,0,0-32.001,32.00012V512H416.01074V495.99994A31.99963,31.99963,0,0,0,384.00977,463.99982Z"
  ]
};
export const faTrash = {
  prefix: "far",
  iconName: "trash",
  icon: [
    448,
    512,
    [],
    "f1f8",
    "M432 80h-82.4l-34-56.7A48 48 0 0 0 274.4 0H173.6a48 48 0 0 0-41.2 23.3L98.4 80H16A16 16 0 0 0 0 96v16a16 16 0 0 0 16 16h16l21.2 339a48 48 0 0 0 47.9 45h245.8a48 48 0 0 0 47.9-45L416 128h16a16 16 0 0 0 16-16V96a16 16 0 0 0-16-16zM173.6 48h100.8l19.2 32H154.4zm173.3 416H101.11l-21-336h287.8z"
  ]
};
export const faTrashAlt = {
  prefix: "far",
  iconName: "trash-alt",
  icon: [
    448,
    512,
    [],
    "f2ed",
    "M268 416h24a12 12 0 0 0 12-12V188a12 12 0 0 0-12-12h-24a12 12 0 0 0-12 12v216a12 12 0 0 0 12 12zM432 80h-82.41l-34-56.7A48 48 0 0 0 274.41 0H173.59a48 48 0 0 0-41.16 23.3L98.41 80H16A16 16 0 0 0 0 96v16a16 16 0 0 0 16 16h16v336a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128h16a16 16 0 0 0 16-16V96a16 16 0 0 0-16-16zM171.84 50.91A6 6 0 0 1 177 48h94a6 6 0 0 1 5.15 2.91L293.61 80H154.39zM368 464H80V128h288zm-212-48h24a12 12 0 0 0 12-12V188a12 12 0 0 0-12-12h-24a12 12 0 0 0-12 12v216a12 12 0 0 0 12 12z"
  ]
};
export const faTrashRestore = {
  prefix: "far",
  iconName: "trash-restore",
  icon: [
    448,
    512,
    [],
    "f829",
    "M432 80h-82.4l-34-56.7A48 48 0 0 0 274.4 0H173.6a48 48 0 0 0-41.2 23.3L98.4 80H16A16 16 0 0 0 0 96v16a16 16 0 0 0 16 16h16l21.2 339a48 48 0 0 0 47.9 45h245.8a48 48 0 0 0 47.9-45L416 128h16a16 16 0 0 0 16-16V96a16 16 0 0 0-16-16zM173.6 48h100.8l19.2 32H154.4zm173.3 416H101.11l-21-336h287.8zM235.61 181.05a15.88 15.88 0 0 0-23.22 0l-80.26 81.75c-8.82 9.3-2.58 25.2 9.9 25.2h50v96a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-96h50c12.48 0 18.72-15.9 9.9-25.2z"
  ]
};
export const faTrashRestoreAlt = {
  prefix: "far",
  iconName: "trash-restore-alt",
  icon: [
    448,
    512,
    [],
    "f82a",
    "M432 80h-82.41l-34-56.7A48 48 0 0 0 274.41 0H173.59a48 48 0 0 0-41.16 23.3L98.41 80H16A16 16 0 0 0 0 96v16a16 16 0 0 0 16 16h16v336a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128h16a16 16 0 0 0 16-16V96a16 16 0 0 0-16-16zM171.84 50.91A6 6 0 0 1 177 48h94a6 6 0 0 1 5.15 2.91L293.61 80H154.39zM368 464H80V128h288zM142 288h50v96a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-96h50c12.48 0 18.72-15.9 9.9-25.2l-80.26-81.75a15.88 15.88 0 0 0-23.22 0l-80.29 81.75c-8.82 9.3-2.58 25.2 9.87 25.2z"
  ]
};
export const faTrashUndo = {
  prefix: "far",
  iconName: "trash-undo",
  icon: [
    448,
    512,
    [],
    "f895",
    "M203.76 348.71A12 12 0 0 0 224 340v-35.16c48.68 5.1 65.21 26 48.45 84.78-2.15 7.53 6.15 13.37 12 8.72C303.11 383.45 320 355 320 326.19c0-62.88-39.64-82-96-86.17V204a12 12 0 0 0-20.24-8.73l-72 68a12 12 0 0 0 0 17.44zM432 80h-82.41l-34-56.7C307.88 10.44 289.44 0 274.44 0H173.56c-15 0-33.44 10.44-41.15 23.3l-34 56.7H16A16 16 0 0 0 0 96v16a16 16 0 0 0 16 16h16l21.19 339c1.56 24.84 23 45 47.9 45h245.82c24.87 0 46.34-20.16 47.9-45L416 128h16a16 16 0 0 0 16-16V96a16 16 0 0 0-16-16zM173.59 48h100.82l19.18 32H154.41zm173.32 416H101.12l-21-336h287.79z"
  ]
};
export const faTrashUndoAlt = {
  prefix: "far",
  iconName: "trash-undo-alt",
  icon: [
    448,
    512,
    [],
    "f896",
    "M432 80h-82.41l-34-56.7C307.88 10.44 289.44 0 274.44 0H173.59c-15 0-33.43 10.44-41.15 23.3L98.41 80H16A16 16 0 0 0 0 96v16a16 16 0 0 0 16 16h16v336a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128h16a16 16 0 0 0 16-16V96a16 16 0 0 0-16-16zM171.84 50.91A6.66 6.66 0 0 1 177 48h94a6.67 6.67 0 0 1 5.16 2.91L293.62 80H154.38zM368 464H80V128h288zM203.76 348.71A12 12 0 0 0 224 340v-35.16c48.68 5.1 65.21 26 48.45 84.78-2.15 7.53 6.15 13.37 12 8.72C303.11 383.45 320 355 320 326.19c0-62.88-39.64-82-96-86.17V204a12 12 0 0 0-20.24-8.73l-72 68a12 12 0 0 0 0 17.44z"
  ]
};
export const faTreasureChest = {
  prefix: "far",
  iconName: "treasure-chest",
  icon: [
    576,
    512,
    [],
    "f723",
    "M448 32H128C57.31 32 0 89.31 0 160v288c0 17.67 14.33 32 32 32h512c17.67 0 32-14.33 32-32V160c0-70.69-57.31-128-128-128zM96 432H48V288h48v144zm0-192H48v-80c0-32.72 19.8-60.84 48-73.22V240zm336 192H144V288h80v48c0 8.84 7.16 16 16 16h96c8.84 0 16-7.16 16-16v-48h80v144zM272 288v-32c0-8.84 7.16-16 16-16s16 7.16 16 16v32c0 8.84-7.16 16-16 16s-16-7.16-16-16zm160-48h-80v-32c0-8.84-7.16-16-16-16h-96c-8.84 0-16 7.16-16 16v32h-80V80h288v160zm96 192h-48V288h48v144zm0-192h-48V86.78c28.2 12.38 48 40.5 48 73.22v80z"
  ]
};
export const faTree = {
  prefix: "far",
  iconName: "tree",
  icon: [
    448,
    512,
    [],
    "f1bb",
    "M442.2 376.2l-55.5-64.4h5.3c9.3 0 17.8-5.4 21.8-13.9 3.9-8.5 2.6-18.5-3.5-25.6l-54.6-64.5H368c9.5 0 18.1-5.6 21.9-14.2 3.8-8.7 2.2-18.8-4.1-25.8L241.9 7.6c-9.1-10.1-26.6-10.1-35.7 0l-144 160.1c-6.3 7.1-7.9 17.2-4.1 25.8 3.9 8.7 12.5 14.2 21.9 14.2h12.2l-54.6 64.5c-6 7.1-7.4 17.1-3.5 25.6s12.4 13.9 21.8 13.9h5.3L5.8 376.2c-6.1 7.1-7.5 17.2-3.6 25.7s12.4 14 21.8 14h168v24.5l-30.3 48.4c-5.3 10.6 2.4 23.2 14.3 23.2h96c11.9 0 19.6-12.5 14.3-23.2L256 440.4v-24.5h168c9.4 0 17.9-5.5 21.8-14s2.5-18.6-3.6-25.7zm-365.8-8.3L166 263.8h-58.3l88-104.1h-61.9L224 59.5l90.1 100.2h-61.9l88 104.1H282l89.7 104.1z"
  ]
};
export const faTreeAlt = {
  prefix: "far",
  iconName: "tree-alt",
  icon: [
    512,
    512,
    [],
    "f400",
    "M463.16 198.09a94.96 94.96 0 0 0 2.44-21.36c0-58.56-51.97-105.42-111.06-99.91C343.81 32.81 303.69 0 256 0s-87.81 32.81-98.53 76.83c-59.09-5.52-111.06 41.34-111.06 99.91 0 7.19.81 14.33 2.44 21.36C18.88 215.89 0 247.86 0 283.64 0 338.98 45.47 384 101.34 384H224v56.45l-30.29 48.4c-5.32 10.64 2.42 23.16 14.31 23.16h95.96c11.89 0 19.63-12.52 14.31-23.16L288 440.45V384h122.66C466.53 384 512 338.98 512 283.64c0-35.78-18.88-67.75-48.84-85.55zM410.66 336H101.34C71.94 336 48 312.52 48 283.64c0-22.95 15.22-42.95 37.84-49.75l27.59-8.28-13.12-25.64c-3.94-7.64-5.91-15.45-5.91-23.23 0-28.88 23.91-52.38 53.31-52.38 7.41 0 14.78 1.61 21.94 4.77l37.53 16.66-4.53-45.42C202.66 71.48 226.59 48 256 48s53.34 23.48 53.19 53.38l-4.38 44.41 37.53-16.66c35.59-15.72 75.25 11.45 75.25 47.61 0 7.78-1.97 15.59-5.91 23.23l-13.12 25.64 27.59 8.28c22.62 6.8 37.84 26.8 37.84 49.75.01 28.88-23.93 52.36-53.33 52.36z"
  ]
};
export const faTreeChristmas = {
  prefix: "far",
  iconName: "tree-christmas",
  icon: [
    512,
    512,
    [],
    "f7db",
    "M232 256c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm80 96c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm190.1 82.8l-66.5-87c10.6-4.8 19.4-13.3 24.3-24.4 7.7-17.4 4.4-37.6-8.4-51.7L338 146.8l12.4-6.2c10.8-5.4 17.7-16.5 17.7-28.6s-6.8-23.2-17.7-28.6l-43.8-21.9-21.9-43.8C279.2 6.8 268.1 0 256 0s-23.2 6.8-28.6 17.7l-21.9 43.8-43.8 21.9C150.8 88.8 144 99.9 144 112s6.8 23.2 17.7 28.6l12.4 6.2L60.5 271.7c-12.8 14.1-16.1 34.3-8.4 51.7 4.9 11.1 13.7 19.6 24.3 24.4l-66.5 87c-11.1 14.5-13 34.1-4.9 50.4 8.1 16.4 24.8 26.7 43 26.7h416c18.3 0 34.9-10.4 43-26.7 8.1-16.3 6.2-35.9-4.9-50.4zM236.5 99.6c3.1-1.5 5.6-4.1 7.2-7.2L256 67.8l12.4 24.7c1.5 3.1 4.1 5.6 7.2 7.2l24.7 12.4-24.7 12.4c-3.1 1.5-5.6 4.1-7.2 7.2L256 156.2l-12.4-24.7c-1.5-3.1-4.1-5.6-7.2-7.2L211.8 112l24.7-12.4zM48 464l122.4-160H96l116.3-127.9 15.1 30.2c5.4 10.8 16.5 17.7 28.6 17.7s23.2-6.8 28.6-17.7l15.1-30.2L416 304h-74.4L464 464H48z"
  ]
};
export const faTreeDecorated = {
  prefix: "far",
  iconName: "tree-decorated",
  icon: [
    512,
    512,
    [],
    "f7dc",
    "M500.3 432.6l-46.6-53.7c9.2-4.7 16.8-12.2 21.5-21.8 8-16.5 5.9-36.2-5.4-50.6L413.6 235c9.9-5 17.9-13.3 22.5-23.9 7.6-17.6 4-38-9.2-52l-136-144C281.8 5.4 269.2 0 256 0s-25.8 5.4-34.9 15l-136 144c-13.2 13.9-16.8 34.4-9.2 52 4.6 10.6 12.6 18.9 22.5 23.9l-56.2 71.5c-11.4 14.4-13.5 34.1-5.4 50.6 4.7 9.6 12.3 17.2 21.5 21.8l-46.6 53.7c-12.3 14.2-15.2 34.3-7.4 51.4C12.1 501 29.2 512 48 512h416c18.8 0 35.9-11 43.7-28.1 7.8-17.1 4.9-37.1-7.4-51.3zM48 464l110.9-128H80l113.1-144H120L256 48l136 144h-73.1L432 336h-78.9L464 464H48zm256-88c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zM192 264c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm104-88c0-13.3-10.7-24-24-24s-24 10.7-24 24 10.7 24 24 24 24-10.7 24-24z"
  ]
};
export const faTreeLarge = {
  prefix: "far",
  iconName: "tree-large",
  icon: [
    512,
    512,
    [],
    "f7dd",
    "M500.3 432.6l-46.6-53.7c9.2-4.7 16.8-12.2 21.5-21.8 8-16.5 5.9-36.2-5.4-50.6L413.6 235c9.9-5 17.9-13.3 22.5-23.9 7.6-17.6 4-38-9.2-52l-136-144C281.8 5.4 269.2 0 256 0s-25.8 5.4-34.9 15l-136 144c-13.2 13.9-16.8 34.4-9.2 52 4.6 10.6 12.6 18.9 22.5 23.9l-56.2 71.5c-11.4 14.4-13.5 34.1-5.4 50.6 4.7 9.6 12.3 17.2 21.5 21.8l-46.6 53.7c-12.3 14.2-15.2 34.3-7.4 51.4C12.1 501 29.2 512 48 512h416c18.8 0 35.9-11 43.7-28.1 7.8-17.1 4.9-37.1-7.4-51.3zM48 464l110.9-128H80l113.1-144H120L256 48l136 144h-73.1L432 336h-78.9L464 464H48z"
  ]
};
export const faTreePalm = {
  prefix: "far",
  iconName: "tree-palm",
  icon: [
    640,
    512,
    [],
    "f82b",
    "M448.76 64c-39.43 0-75.06 11.74-103 30.5C327.14 40.17 265.37 0 191.24 0c-80.61 0-147.37 47.24-159 108.86C30.39 118.79 38.75 128 50 128h46l32-48 33.46 66.92c-3.53 3.07-7.28 5.69-10.66 9.07C93.8 213 80 293.6 115.37 345.38c5.7 8.34 18.12 8.94 26.07 1l124.92-124.92c2.17 99.11-20.8 196.29-32.92 240-6.91 25.18 11.66 50.54 38.19 50.54h90.43a39.63 39.63 0 0 0 39.28-33.48c16.94-104.88-1.7-218-17.46-286.52H448l32-48 32 48h78c11.25 0 19.61-9.21 17.74-19.14C596.13 111.24 529.38 64 448.76 64zM355 464h-72.53c14.42-54.48 37.74-163.81 30.32-272h21.68c14.81 61.61 35.01 171.89 20.53 272z"
  ]
};
export const faTrees = {
  prefix: "far",
  iconName: "trees",
  icon: [
    640,
    512,
    [],
    "f724",
    "M634.19 376.23l-55.47-64.37H584c9.34 0 17.84-5.43 21.78-13.92 3.94-8.47 2.56-18.48-3.47-25.61l-54.56-64.55H560c9.47 0 18.06-5.58 21.94-14.24a24.088 24.088 0 0 0-4.09-25.85l-144-160.11c-9.13-10.1-26.56-10.1-35.69 0L320 94.48l-78.16-86.9c-9.13-10.1-26.56-10.1-35.69 0l-144 160.11a24.063 24.063 0 0 0-4.09 25.85c3.88 8.66 12.47 14.24 21.94 14.24h12.25l-54.56 64.55c-6.03 7.13-7.41 17.14-3.47 25.61A24.021 24.021 0 0 0 56 311.86h5.28L5.81 376.23c-6.13 7.11-7.53 17.15-3.63 25.69a23.998 23.998 0 0 0 21.81 14.01h168v24.46l-30.29 48.43c-5.32 10.65 2.42 23.17 14.31 23.17h95.96c11.89 0 19.63-12.53 14.31-23.17L256 440.39v-24.46h128v24.46l-30.29 48.43c-5.32 10.65 2.42 23.17 14.31 23.17h95.96c11.89 0 19.63-12.53 14.31-23.17L448 440.39v-24.46h168c9.38 0 17.91-5.47 21.81-14.01 3.91-8.54 2.51-18.57-3.62-25.69zM304 367.9H76.37l89.66-104.07h-58.28l88-104.07h-61.88L224 59.55l90.13 100.2h-61.88l88 104.07h-58.28l89.66 104.07H304zm131 0l-48.29-56.04H392c9.34 0 17.84-5.43 21.78-13.92 3.94-8.47 2.56-18.48-3.47-25.61l-54.56-64.55H368c9.47 0 18.06-5.58 21.94-14.24a24.088 24.088 0 0 0-4.09-25.85l-33.55-37.31L416 59.55l90.13 100.2h-61.88l88 104.07h-58.28l89.66 104.07H435z"
  ]
};
export const faTriangle = {
  prefix: "far",
  iconName: "triangle",
  icon: [
    576,
    512,
    [],
    "f2ec",
    "M329.6 24c-18.4-32-64.7-32-83.2 0L6.5 440c-18.4 31.9 4.6 72 41.6 72H528c36.9 0 60-40 41.6-72l-240-416zM48 464L288 48l240 416H48z"
  ]
};
export const faTriangleMusic = {
  prefix: "far",
  iconName: "triangle-music",
  icon: [
    512,
    512,
    [],
    "f8e2",
    "M256.06 263.89a56.77 56.77 0 1 0 52.55 37.34l198.66-198.65a16 16 0 0 0 0-22.62L496 68.66a16 16 0 0 0-22.62 0L274.69 267.31a55.41 55.41 0 0 0-18.63-3.42zM497.79 368.1l-80.46-130.34-34.87 34.87L457 393.32c9 14.55 9.42 31.33 1.07 46.22A48.13 48.13 0 0 1 415.83 464H96.15A48 48 0 0 1 54 439.6c-8.34-14.86-8-31.71 1-46.27l159.86-258.94A47.93 47.93 0 0 1 256 111.74c17.24 0 32.24 8.27 41.13 22.66L322 174.73l34.87-34.87L338 109.2a95.21 95.21 0 0 0-58-42.42V16a16 16 0 0 0-16-16h-16a16 16 0 0 0-16 16v50.78a95.14 95.14 0 0 0-58 42.38l-159.86 259a92.38 92.38 0 0 0-2 94.94c16.72 30.08 49 48.92 84 48.92h319.69A96.14 96.14 0 0 0 500 462.84c16.73-29.84 16-65.35-2.21-94.74z"
  ]
};
export const faTrophy = {
  prefix: "far",
  iconName: "trophy",
  icon: [
    576,
    512,
    [],
    "f091",
    "M448 64V16c0-8.8-7.2-16-16-16H144c-8.8 0-16 7.2-16 16v48H16C7.2 64 0 71.2 0 80v60.8C0 201.1 68.3 266 159.6 283.4c27.4 57.9 68.1 88.2 104.4 97.4V464h-64c-22.1 0-40 17.9-40 40 0 4.4 3.6 8 8 8h240c4.4 0 8-3.6 8-8 0-22.1-17.9-40-40-40h-64v-83.2c36.3-9.3 77-39.5 104.4-97.4C507.5 266.1 576 201.2 576 140.8V80c0-8.8-7.2-16-16-16H448zM48 140.8V112h80c0 39.2 2.1 76.2 12.3 116.8-55.1-18.9-92.3-58.9-92.3-88zM288 336c-53 0-112-78.4-112-216V48h224v72c0 140.5-60.8 216-112 216zm240-195.2c0 29.1-37.2 69.1-92.3 88C445.9 188.2 448 151.1 448 112h80v28.8z"
  ]
};
export const faTrophyAlt = {
  prefix: "far",
  iconName: "trophy-alt",
  icon: [
    576,
    512,
    [],
    "f2eb",
    "M359.3 138.9l-43.4-6.3-19.4-39.3c-3.5-7-13.5-7.1-17 0l-19.4 39.3-43.4 6.3c-7.8 1.1-10.9 10.7-5.3 16.2l31.4 30.6-7.4 43.2c-1.3 7.7 6.8 13.7 13.8 10l38.8-20.4 38.8 20.4c6.9 3.6 15.1-2.2 13.8-10l-7.4-43.2 31.4-30.6c5.6-5.5 2.5-15.1-5.3-16.2zM448 64V16c0-8.8-7.2-16-16-16H144c-8.8 0-16 7.2-16 16v48H16C7.2 64 0 71.2 0 80v60.8C0 201.1 68.3 266 159.6 283.4c27.4 57.9 68.1 88.2 104.4 97.4V464h-64c-22.1 0-40 17.9-40 40 0 4.4 3.6 8 8 8h240c4.4 0 8-3.6 8-8 0-22.1-17.9-40-40-40h-64v-83.2c36.3-9.3 77-39.5 104.4-97.4C507.5 266.1 576 201.2 576 140.8V80c0-8.8-7.2-16-16-16H448zM48 140.8V112h80c0 39.2 2.1 76.2 12.3 116.8-55.1-18.9-92.3-58.9-92.3-88zM288 336c-53 0-112-78.4-112-216V48h224v72c0 140.5-60.8 216-112 216zm240-195.2c0 29.1-37.2 69.1-92.3 88C445.9 188.2 448 151.1 448 112h80v28.8z"
  ]
};
export const faTruck = {
  prefix: "far",
  iconName: "truck",
  icon: [
    640,
    512,
    [],
    "f0d1",
    "M624 368h-16V251.9c0-19-7.7-37.5-21.1-50.9L503 117.1C489.6 103.7 471 96 452.1 96H416V56c0-30.9-25.1-56-56-56H56C25.1 0 0 25.1 0 56v304c0 30.9 25.1 56 56 56h8c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zm-464 96c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm208-96H242.7c-16.6-28.6-47.2-48-82.7-48s-66.1 19.4-82.7 48H56c-4.4 0-8-3.6-8-8V56c0-4.4 3.6-8 8-8h304c4.4 0 8 3.6 8 8v312zm48-224h36.1c6.3 0 12.5 2.6 17 7l73 73H416v-80zm64 320c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-100.9c-17.2-25.9-46.6-43.1-80-43.1-24.7 0-47 9.6-64 24.9V272h144v91.1z"
  ]
};
export const faTruckContainer = {
  prefix: "far",
  iconName: "truck-container",
  icon: [
    640,
    512,
    [],
    "f4dc",
    "M32 304h336c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64v208c0 17.7 14.3 32 32 32zM48 80h304v176H48V80zm573.3 125.3l-58.5-58.5c-12-12-28.3-18.7-45.3-18.7H464c-17.7 0-32 14.3-32 32v176H32c-17.7 0-32 14.3-32 32v27.8c0 40.8 28.7 78.1 69.1 83.5 30.7 4.1 58.3-9.5 74.9-31.7 18.4 24.7 50.4 38.7 85.3 29.7 25.2-6.5 46.1-26.2 54.4-50.8 4.9-14.8 5.4-29.2 2.8-42.4h163.2c-2.7 13.2-2.2 27.6 2.8 42.4 8.4 25.1 29.9 44.9 55.6 51.1 52.8 12.8 100-26.9 100-77.6 0-5.5-.6-10.8-1.6-16H624c8.8 0 16-7.2 16-16V250.5c0-17-6.7-33.2-18.7-45.2zM80 432c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm128 0c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm272-256h37.5c4.3 0 8.3 1.7 11.3 4.7l43.3 43.3H480v-48zm48 256c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm64-96h-16.4c-13.3-9.9-29.7-16-47.6-16s-34.2 6.1-47.6 16h-.4v-80h112v80zM136 112h-32c-4.4 0-8 3.6-8 8v96c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8v-96c0-4.4-3.6-8-8-8zm160 0h-32c-4.4 0-8 3.6-8 8v96c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8v-96c0-4.4-3.6-8-8-8zm-80 0h-32c-4.4 0-8 3.6-8 8v96c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8v-96c0-4.4-3.6-8-8-8z"
  ]
};
export const faTruckCouch = {
  prefix: "far",
  iconName: "truck-couch",
  icon: [
    640,
    512,
    [],
    "f4dd",
    "M13.8 237.9c2.5-1 4.9-2.1 7.5-2.8 6.1-1.6 12.4-2.5 18.7-2.5 29.8 0 56.1 18.5 66.8 45.8l125-33.5c-2.5-16.1.3-32.4 8.5-46.7 9.6-16.7 25.1-28.6 43.7-33.5 2.6-.7 5.3-.7 8-1.1l-.3-1c-9.1-34.1-44.2-54.4-78.4-45.3L58.9 158.8c-34.1 9.1-54.4 44.2-45.3 78.4l.2.7zM7.6 338.2L24.1 400l77.3-20.7 185.5-49.7 14.8-4 18.3-4.9v-122c-8.3-4-18-5.6-27.6-3.1-21.3 5.7-34 27.7-28.3 49l6.2 23.2-143.2 38.4-11.4 3-30.9 8.3-6.2-23.2c-5.7-21.3-27.7-34-49-28.3-21.3 5.7-34 27.7-28.3 49l6.3 23.2zM640 48V0H384c-17.7 0-32 14.3-32 32v340.6L5.9 465.4c-4.3 1.1-6.8 5.5-5.7 9.8l8.3 30.9c1.1 4.3 5.5 6.8 9.8 5.7L416.5 405c2.7 59.5 51.4 107 111.5 107 61.9 0 112-50.1 112-112s-50.1-112-112-112c-44.6 0-82.8 26.3-100.8 64H400V48h240zM528 336c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64z"
  ]
};
export const faTruckLoading = {
  prefix: "far",
  iconName: "truck-loading",
  icon: [
    640,
    512,
    [],
    "f4de",
    "M640 48V0H384c-17.7 0-32 14.3-32 32v340.6L5.9 465.4c-4.3 1.1-6.8 5.5-5.7 9.8l8.3 30.9c1.1 4.3 5.5 6.8 9.8 5.7L416.5 405c2.7 59.5 51.4 107 111.5 107 61.9 0 112-50.1 112-112s-50.1-112-112-112c-44.6 0-82.8 26.3-100.8 64H400V48h240zM528 336c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zM50.2 375.6c2.3 8.5 11.1 13.6 19.6 11.3l216.4-58c8.5-2.3 13.6-11.1 11.3-19.6l-49.7-185.5c-2.3-8.5-11.1-13.6-19.6-11.3L151 133.3l24.8 92.7-61.8 16.5-24.8-92.7-77.3 20.7C3.4 172.8-1.7 181.6.6 190.1l49.6 185.5z"
  ]
};
export const faTruckMonster = {
  prefix: "far",
  iconName: "truck-monster",
  icon: [
    640,
    512,
    [],
    "f63b",
    "M272 352h-5.2c-2.2-7.33-5.07-14.28-8.65-20.89l3.67-3.67c6.25-6.25 6.25-16.38 0-22.63l-22.63-22.63c-6.25-6.25-16.38-6.25-22.63 0l-3.67 3.67A110.85 110.85 0 0 0 192 277.2V272c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v5.2c-7.33 2.2-14.28 5.07-20.89 8.65l-3.67-3.67c-6.25-6.25-16.38-6.25-22.63 0L58.18 304.8c-6.25 6.25-6.25 16.38 0 22.63l3.67 3.67a110.85 110.85 0 0 0-8.65 20.89H48c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h5.2c2.2 7.33 5.07 14.28 8.65 20.89l-3.67 3.67c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l3.67-3.67c6.61 3.57 13.57 6.45 20.9 8.65v5.2c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-5.2c7.33-2.2 14.28-5.07 20.9-8.65l3.67 3.67c6.25 6.25 16.38 6.25 22.63 0l22.63-22.63c6.25-6.25 6.25-16.38 0-22.63l-3.67-3.67a110.85 110.85 0 0 0 8.65-20.89h5.2c8.84 0 16-7.16 16-16v-32C288 359.16 280.84 352 272 352zm-112 96c-35.35 0-64-28.65-64-64s28.65-64 64-64 64 28.65 64 64-28.65 64-64 64zm432-96h-5.2c-2.2-7.33-5.07-14.28-8.65-20.89l3.67-3.67c6.25-6.25 6.25-16.38 0-22.63l-22.63-22.63c-6.25-6.25-16.38-6.25-22.63 0l-3.67 3.67A110.85 110.85 0 0 0 512 277.2V272c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v5.2c-7.33 2.2-14.28 5.07-20.89 8.65l-3.67-3.67c-6.25-6.25-16.38-6.25-22.63 0l-22.63 22.63c-6.25 6.25-6.25 16.38 0 22.63l3.67 3.67A110.85 110.85 0 0 0 373.2 352H368c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h5.2c2.2 7.33 5.07 14.28 8.65 20.89l-3.67 3.67c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l3.67-3.67c6.61 3.57 13.57 6.45 20.9 8.65v5.2c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-5.2c7.33-2.2 14.28-5.07 20.9-8.65l3.67 3.67c6.25 6.25 16.38 6.25 22.63 0l22.63-22.63c6.25-6.25 6.25-16.38 0-22.63l-3.67-3.67a110.85 110.85 0 0 0 8.65-20.89h5.2c8.84 0 16-7.16 16-16v-32c-.02-8.84-7.18-16-16.02-16zm-112 96c-35.35 0-64-28.65-64-64s28.65-64 64-64 64 28.65 64 64-28.65 64-64 64zm144-208h-16v-80c0-17.67-14.33-32-32-32h-73.6L419.21 24.02A63.99 63.99 0 0 0 369.24 0H256c-17.67 0-32 14.33-32 32v96H64c-17.67 0-32 14.33-32 32v80H16c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h16v.88c12.92-17.35 29.22-31.76 48-42.69V176h480v70.19c18.78 10.93 35.08 25.34 48 42.69V288h16c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16zM272 128V48h97.24c4.89 0 9.44 2.19 12.49 6l59.2 74H272z"
  ]
};
export const faTruckMoving = {
  prefix: "far",
  iconName: "truck-moving",
  icon: [
    640,
    512,
    [],
    "f4df",
    "M621.3 205.3l-58.5-58.5c-12-12-28.3-18.7-45.3-18.7H480V64c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64v336c0 44.2 35.8 80 80 80 26.3 0 49.4-12.9 64-32.4 14.6 19.6 37.7 32.4 64 32.4 44.2 0 80-35.8 80-80 0-5.5-.6-10.8-1.6-16h163.2c-1.1 5.2-1.6 10.5-1.6 16 0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.6-10.8-1.6-16H624c8.8 0 16-7.2 16-16V250.5c0-17-6.7-33.2-18.7-45.2zM80 432c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm128 0c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm47.6-96c-13.3-9.9-29.7-16-47.6-16s-34.2 6.1-47.6 16h-32.9c-13.3-9.9-29.7-16-47.6-16-11.4 0-22.2 2.5-32 6.8V80h384v256zM480 176h37.5c4.3 0 8.3 1.7 11.3 4.7l43.3 43.3H480zm48 256c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm64-96h-16.4c-13.4-9.9-29.7-16-47.6-16s-34.2 6.1-47.6 16h-.4v-80h112z"
  ]
};
export const faTruckPickup = {
  prefix: "far",
  iconName: "truck-pickup",
  icon: [
    640,
    512,
    [],
    "f63c",
    "M624 336h-16V208c0-17.67-14.33-32-32-32h-60.8L419.21 56.02A63.99 63.99 0 0 0 369.24 32H256c-17.67 0-32 14.33-32 32v112H64c-17.67 0-32 14.33-32 32v128H16c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h49.61c7.82 54.21 54.01 96 110.39 96s102.56-41.79 110.39-96h67.23c7.82 54.21 54.01 96 110.39 96s102.56-41.79 110.39-96H624c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16zM272 80h97.24c4.89 0 9.44 2.19 12.49 6l72 90H272V80zm-96 352c-35.35 0-64-28.65-64-64s28.65-64 64-64 64 28.65 64 64-28.65 64-64 64zm288 0c-35.29 0-64-28.71-64-64s28.71-64 64-64 64 28.71 64 64-28.71 64-64 64zm96-120.86C540.48 278.27 505 256 464 256c-50.66 0-92.96 33.85-106.8 80h-74.4c-13.84-46.15-56.14-80-106.8-80-41 0-76.48 22.27-96 55.14V224h480v87.14z"
  ]
};
export const faTruckPlow = {
  prefix: "far",
  iconName: "truck-plow",
  icon: [
    640,
    512,
    [],
    "f7de",
    "M579.7 385.8c-7.5-7.5-11.7-17.7-11.7-28.3v-139c0-10.6 4.2-20.8 11.7-28.3l55.6-55.6c6.2-6.2 6.2-16.4 0-22.6L624 100.7c-6.2-6.2-16.4-6.2-22.6 0l-55.6 55.6c-16.5 16.5-25.8 38.9-25.8 62.2V264h-40v-40c0-17.7-14.3-32-32-32h-42.4L321.2 51.5C314 39.5 300.9 32 286.9 32H160c-17.7 0-32 14.4-32 32v128H32c-17.7 0-32 14.3-32 32v128c0 17.7 14.3 32 32 32 0 53 43 96 96 96s96-43 96-96h64c0 53 43 96 96 96s96-43 96-96v-72h40v45.5c0 23.3 9.3 45.7 25.8 62.2l55.6 55.6c6.2 6.2 16.4 6.2 22.6 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6l-55.6-55.6zM176 80h106.4l67.2 112H176V80zm-48 352c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm82.7-96c-16.6-28.6-47.2-48-82.7-48-33.4 0-62.8 17.1-80 43.1V240h384v61.3c-14.2-8.2-30.4-13.3-48-13.3-35.4 0-66.1 19.4-82.7 48h-90.6zM384 432c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"
  ]
};
export const faTruckRamp = {
  prefix: "far",
  iconName: "truck-ramp",
  icon: [
    640,
    512,
    [],
    "f4e0",
    "M544 48h96V0H384c-17.7 0-32 14.3-32 32v340.6L5.9 465.4c-4.3 1.1-6.8 5.5-5.7 9.8l8.3 30.9c1.1 4.3 5.5 6.8 9.8 5.7L416.5 405c2.7 59.5 51.4 107 111.5 107 61.9 0 112-50.1 112-112s-50.1-112-112-112c-44.6 0-82.8 26.3-100.8 64H400V48h144zm-16 288c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64z"
  ]
};
export const faTrumpet = {
  prefix: "far",
  iconName: "trumpet",
  icon: [
    640,
    512,
    [],
    "f8e3",
    "M608 32a31.91 31.91 0 0 0-26.65 14.22c-.46.68-45.08 66.36-112.58 102-14.58 7.71-32 11.78-50.35 11.78H400v-16a16 16 0 0 0-16-16h-16a16 16 0 0 0-16 16v16h-40v-16a16 16 0 0 0-16-16h-16a16 16 0 0 0-16 16v16h-40v-16a16 16 0 0 0-16-16h-16a16 16 0 0 0-16 16v16H48a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v128a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16h32.6A103.72 103.72 0 0 0 168 448h240a102.13 102.13 0 0 0 102.31-120.71c43.58 34.39 70.7 73.94 71.05 74.45A32 32 0 0 0 608 416c10.31 0 32-7.76 32-32V64c0-10.17-7.71-32-32-32zM176 400h-8a56 56 0 0 1 0-112h8zm88 0h-40V288h40zm88 0h-40V288h40zm56 0h-8V288h8a56 56 0 0 1 0 112zm184-61.44c-22.78-25.38-57.62-58.45-100.78-81.24C469.74 246 444.58 240 418.45 240H48v-32h370.45c26.13 0 51.29-6 72.77-17.33 43.57-23 78.23-55.83 100.78-81z"
  ]
};
export const faTshirt = {
  prefix: "far",
  iconName: "tshirt",
  icon: [
    640,
    512,
    [],
    "f553",
    "M638 121c-3.3-9.8-10.2-17.8-19.5-22.4L420.2 0c-9.5 13.2-28.4 50.3-100.2 50.3-72.4 0-91.1-37.7-100.2-50.3L21.6 98.6C12.3 103.2 5.3 111.2 2 121c-3.3 9.9-2.6 20.4 2.1 29.7l53 106.2c9.6 19.2 33 27 51.6 17.7l24-11.3c5.3-2.5 11.4 1.4 11.4 7.2v185.3c0 31 25.1 56.2 56 56.2h240c30.9 0 56-25.2 56-56.2V270.6c0-5.9 6.1-9.7 11.4-7.2l23.5 11.1c19.1 9.7 42.5 1.8 52.1-17.4l53-106.2c4.4-9.5 5.2-20 1.9-29.9zm-94 106.4l-73.2-34.6c-10.6-5-22.8 2.7-22.8 14.5v248.6c0 4.4-3.6 8-8 8H200c-4.4 0-8-3.6-8-8V207.3c0-11.7-12.2-19.5-22.8-14.5L96 227.4l-44.8-89.9 155.5-77.3c26.4 24 67.8 38.3 113.3 38.3s86.9-14.3 113.2-38.2l155.5 77.3-44.7 89.8z"
  ]
};
export const faTty = {
  prefix: "far",
  iconName: "tty",
  icon: [
    512,
    512,
    [],
    "f1e4",
    "M256.015.004zm248.687 159.27l-37.058 59.291c-12.314 19.701-36.965 27.752-58.53 19.125l-74.42-29.769c-19.855-7.943-32.062-28.062-29.935-49.341l2.606-26.073c-36.57-9.118-67.361-8.82-102.729 0l2.607 26.072c2.128 21.28-10.079 41.401-29.936 49.344l-74.422 29.768c-21.579 8.631-46.225.56-58.53-19.127L7.297 159.272c-11.876-19.002-9.025-43.693 6.869-59.488 133.558-132.722 349.459-133.369 483.668.001 15.894 15.795 18.745 40.487 6.868 59.489zm-40.701-25.441c-115.216-114.495-300.899-114.381-416-.001l37.059 59.292 74.422-29.768-6.505-65.044c75.782-27.384 130.31-27.367 206.046 0l-6.502 65.043 74.42 29.769 37.06-59.291zM126 430H98c-6.627 0-12-5.373-12-12v-28c0-6.627 5.373-12 12-12h28c6.627 0 12 5.373 12 12v28c0 6.627-5.373 12-12 12zm96 0h-28c-6.627 0-12-5.373-12-12v-28c0-6.627 5.373-12 12-12h28c6.627 0 12 5.373 12 12v28c0 6.627-5.373 12-12 12zm96 0h-28c-6.627 0-12-5.373-12-12v-28c0-6.627 5.373-12 12-12h28c6.627 0 12 5.373 12 12v28c0 6.627-5.373 12-12 12zm96 0h-28c-6.627 0-12-5.373-12-12v-28c0-6.627 5.373-12 12-12h28c6.627 0 12 5.373 12 12v28c0 6.627-5.373 12-12 12zM78 512H50c-6.627 0-12-5.373-12-12v-28c0-6.627 5.373-12 12-12h28c6.627 0 12 5.373 12 12v28c0 6.627-5.373 12-12 12zm384 0h-28c-6.627 0-12-5.373-12-12v-28c0-6.627 5.373-12 12-12h28c6.627 0 12 5.373 12 12v28c0 6.627-5.373 12-12 12zM78 348H50c-6.627 0-12-5.373-12-12v-28c0-6.627 5.373-12 12-12h28c6.627 0 12 5.373 12 12v28c0 6.627-5.373 12-12 12zm96 0h-28c-6.627 0-12-5.373-12-12v-28c0-6.627 5.373-12 12-12h28c6.627 0 12 5.373 12 12v28c0 6.627-5.373 12-12 12zm96 0h-28c-6.627 0-12-5.373-12-12v-28c0-6.627 5.373-12 12-12h28c6.627 0 12 5.373 12 12v28c0 6.627-5.373 12-12 12zm96 0h-28c-6.627 0-12-5.373-12-12v-28c0-6.627 5.373-12 12-12h28c6.627 0 12 5.373 12 12v28c0 6.627-5.373 12-12 12zm96 0h-28c-6.627 0-12-5.373-12-12v-28c0-6.627 5.373-12 12-12h28c6.627 0 12 5.373 12 12v28c0 6.627-5.373 12-12 12zm-98 158H148c-6.627 0-12-5.373-12-12v-16c0-6.627 5.373-12 12-12h216c6.627 0 12 5.373 12 12v16c0 6.627-5.373 12-12 12z"
  ]
};
export const faTurkey = {
  prefix: "far",
  iconName: "turkey",
  icon: [
    640,
    512,
    [],
    "f725",
    "M534 207.93a72.05 72.05 0 0 0 26.69 7.73c27.78 2.49 74.43-14.46 79-65.95a72.9 72.9 0 0 0-58.82-77.89C580.55 44 558.34 0 508 0a72.34 72.34 0 0 0-72.45 66.25A71.24 71.24 0 0 0 438 92.4c3.77 13.11-2.89 16.09-12.16 23.83a165.52 165.52 0 0 1-18.4 13C371 108.72 330.67 96 288 96 128.94 96 0 269.13 0 384s128.94 128 288 128 288-13.12 288-128c0-51.4-25.94-114.38-68.71-168.37 1.77-1.59 3.23-3.44 5.07-5 2.82-2.33 8.64-9.43 21.64-2.7zM528 384c0 50.67-39.27 80-240 80S48 434.67 48 384c0-92.58 109.84-240 240-240a182.57 182.57 0 0 1 54.21 8.72c-4.95.71-9.86 1.72-14.87 2-18.11.91-107.67 8.32-130.92 96.89-10.46 39.84-2.18 81.19 22.72 113.47 47.14 61.11 114.93 51.34 130.15 48.45 49.53-9.4 89.36-49.34 101.49-101.75a187.94 187.94 0 0 1 24.94-59.22C508.22 296 528 344.86 528 384zm-46.39-210.21c-38.49 32.11-66 77.26-77.58 127.14-7.84 33.88-32.84 59.56-63.68 65.41-48.9 9.27-75.82-21.06-83.19-30.61a82.57 82.57 0 0 1-14.3-72c3.54-13.49 20.27-57.79 86.89-61.14 73.34-3.68 118.81-42.52 133.76-55.29 23.1-19.62 26.14-38.34 20.95-68.07s19.89-31.2 23.2-31.2c10.35 0 26.95 6.6 25.15 26.87-.14 1.6-2 6.75-4.47 13.25-6.67 17.3 8 35.25 26.35 32.31 17.65-2.84 23.34-2 30.66 6a24.93 24.93 0 0 1 6.55 19c-.47 5.33-7.73 30.79-38 18.83-8.23-3.25-18.47-7.3-30.75-7.3-14.38.01-27.96 5.5-41.54 16.8z"
  ]
};
export const faTurntable = {
  prefix: "far",
  iconName: "turntable",
  icon: [
    576,
    512,
    [],
    "f8e4",
    "M224 112a144 144 0 1 0 144 144 144 144 0 0 0-144-144zm0 168a24 24 0 1 1 24-24 24 24 0 0 1-24 24zm248-152h-16a16 16 0 0 0-16 16v99.71a31.88 31.88 0 0 1-2.95 13.41L416 302.8a15.69 15.69 0 0 0-11.75 8.35l-25.69 51.38a16 16 0 0 0 7.13 21.47l28.62 14.32a16 16 0 0 0 21.47-7.16l25.69-51.38a15.89 15.89 0 0 0-1.85-17l25.43-55.1a32 32 0 0 0 2.95-13.44V144a16 16 0 0 0-16-16zm40-96H64A64 64 0 0 0 0 96v320a64 64 0 0 0 64 64h448a64 64 0 0 0 64-64V96a64 64 0 0 0-64-64zm16 384a16 16 0 0 1-16 16H64a16 16 0 0 1-16-16V96a16 16 0 0 1 16-16h448a16 16 0 0 1 16 16z"
  ]
};
export const faTurtle = {
  prefix: "far",
  iconName: "turtle",
  icon: [
    640,
    512,
    [],
    "f726",
    "M637.12 160.46c-5.2-20.65-18.86-38.27-36.18-50.64C556.31 77.94 545.09 64 507.68 64c-39.63 0-73.59 23.57-86.26 57.9C380.78 71.45 317.81 32 248.39 32 232.27 32 84.6 43.86 35.54 191.49c-5.37 16.14-4.57 33.14 1.91 48.51H32c-17.67 0-32 14.33-32 32v16c0 11.89 6.59 22.8 17.11 28.33l81.53 42.85L70.46 408c-8.55 14.8-8.55 33.2 0 48s24.47 24 41.57 24h36.95c17.15 0 33-9.15 41.57-24l27.64-47.88c40.34 10.42 97.54 10.88 139.63 0L385.46 456c8.57 14.85 24.42 24 41.57 24h36.95c17.09 0 33.02-9.2 41.57-24s8.55-33.2 0-48l-30.68-53.13c30.65-20.78 51.2-50.03 61.5-82.87h14.98c56.34 0 100.56-52.82 85.77-111.54zM81.1 206.63C100.2 149.14 167.51 80 247.61 80h.79c80.1 0 147.41 69.14 166.51 126.63 3.27 9.83-6.69 32.32-30.74 33.12-.94.06-269.57.25-269.57.25-22.47 0-39.11-16.5-33.5-33.37zM551.34 224H504c-11.29 90.33-74.88 101.62-96.5 110.19L463.97 432H427l-46.75-81.05c-66.9 21.93-108.77 24.83-184.5 0L148.97 432H112l53.19-92.08L66.38 288h316.68c32.03 0 80.8-21.8 80.94-79.78V153c0-19.84 11.64-30.56 21.78-35.75 31.46-16.13 47.11 2.97 89.19 33.02 10.66 7.62 17.03 20 17.03 33.08 0 22.42-18.25 40.65-40.66 40.65zM512 144c-8.84 0-16 7.16-16 16s7.16 16 16 16 16-7.16 16-16-7.16-16-16-16z"
  ]
};
export const faTv = {
  prefix: "far",
  iconName: "tv",
  icon: [
    640,
    512,
    [],
    "f26c",
    "M592 0H48A48 48 0 0 0 0 48v320a48 48 0 0 0 48 48h248v48H112a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16H344v-48h248a48 48 0 0 0 48-48V48a48 48 0 0 0-48-48zm0 368H48V48h544z"
  ]
};
export const faTvAlt = {
  prefix: "far",
  iconName: "tv-alt",
  icon: [
    640,
    512,
    [],
    "f8e5",
    "M528 464H112a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zM592 0H48A48 48 0 0 0 0 48v320a48 48 0 0 0 48 48h544a48 48 0 0 0 48-48V48a48 48 0 0 0-48-48zm0 368H48V48h544z"
  ]
};
export const faTvMusic = {
  prefix: "far",
  iconName: "tv-music",
  icon: [
    640,
    512,
    [],
    "f8e6",
    "M240 320c26.5 0 48-14.33 48-32v-84.84l96-37.52V226a69.82 69.82 0 0 0-16-2c-26.5 0-48 14.33-48 32s21.5 32 48 32 48-14.33 48-32V112a16 16 0 0 0-20.81-15.25l-128 47.25A16 16 0 0 0 256 159.25V258a69.82 69.82 0 0 0-16-2c-26.5 0-48 14.33-48 32s21.5 32 48 32zM592 0H48A48 48 0 0 0 0 48v320a48 48 0 0 0 48 48h544a48 48 0 0 0 48-48V48a48 48 0 0 0-48-48zm0 368H48V48h544zm-64 96H112a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16z"
  ]
};
export const faTvRetro = {
  prefix: "far",
  iconName: "tv-retro",
  icon: [
    512,
    512,
    [],
    "f401",
    "M400 244v-8c0-6.6 5.4-12 12-12h8c6.6 0 12 5.4 12 12v8c0 6.6-5.4 12-12 12h-8c-6.6 0-12-5.4-12-12zm12 76h8c6.6 0 12-5.4 12-12v-8c0-6.6-5.4-12-12-12h-8c-6.6 0-12 5.4-12 12v8c0 6.6 5.4 12 12 12zm-36-136.5s-1.5-7.5-144-7.5-144.5 7.5-144.5 7.5S80 184 80 288s7.5 104.5 7.5 104.5S88 400 232 400s144-7.5 144-7.5 7.5-.5 7.5-104.5-7.5-104.5-7.5-104.5zM512 144v288c0 26.5-21.5 48-48 48h-16v32h-48l-10.7-32H122.7L112 512H64v-32H48c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48h140.9l-54-55.2c-9.3-9.5-9.1-24.7.3-33.9 9.5-9.3 24.7-9.1 33.9.3L256 96l86.9-88.8c9.3-9.5 24.5-9.6 33.9-.3 9.5 9.3 9.6 24.5.3 33.9l-54 55.2H464c26.5 0 48 21.5 48 48zm-48 0H48v288h416V144z"
  ]
};
export const faTypewriter = {
  prefix: "far",
  iconName: "typewriter",
  icon: [
    512,
    512,
    [],
    "f8e7",
    "M480 192h-32V77.25a32 32 0 0 0-9.38-22.63L393.38 9.38A32 32 0 0 0 370.75 0H96a32 32 0 0 0-32 32v160H32a32 32 0 0 0-32 32v32a32 32 0 0 0 32 32v160a64 64 0 0 0 64 64h320a64 64 0 0 0 64-64V288a32 32 0 0 0 32-32v-32a32 32 0 0 0-32-32zM112 48h240v32a16 16 0 0 0 16 16h32v96h-34.75a32 32 0 0 0-22.62 9.37l-13.26 13.26a32 32 0 0 1-22.62 9.37h-101.5a32 32 0 0 1-22.62-9.37l-13.26-13.26a32 32 0 0 0-22.62-9.37H112zm320 400a16 16 0 0 1-16 16H96a16 16 0 0 1-16-16V288h352zm-288-16h224a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16H144a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16zm-8-76h24a8 8 0 0 0 8-8v-24a8 8 0 0 0-8-8h-24a8 8 0 0 0-8 8v24a8 8 0 0 0 8 8zm216 0h24a8 8 0 0 0 8-8v-24a8 8 0 0 0-8-8h-24a8 8 0 0 0-8 8v24a8 8 0 0 0 8 8zm-144 0h24a8 8 0 0 0 8-8v-24a8 8 0 0 0-8-8h-24a8 8 0 0 0-8 8v24a8 8 0 0 0 8 8zm72 0h24a8 8 0 0 0 8-8v-24a8 8 0 0 0-8-8h-24a8 8 0 0 0-8 8v24a8 8 0 0 0 8 8z"
  ]
};
export const faUfo = {
  prefix: "far",
  iconName: "ufo",
  icon: [
    640,
    512,
    [],
    "e047",
    "M128,296a24,24,0,1,0,24,24A23.99993,23.99993,0,0,0,128,296Zm192,40a24,24,0,1,0,24,24A23.99993,23.99993,0,0,0,320,336ZM483.47656,210.10938C474.207,128.15039,404.87891,64,320,64c-84.87695,0-154.20312,64.15039-163.47461,146.10742C62.91016,232.44141,0,273.23047,0,320c0,70.69141,143.26953,128,320,128,176.73242,0,320-57.30859,320-128C640,273.23047,577.09375,232.44336,483.47656,210.10938ZM320,112c64.80273,0,117.334,52.0957,117.334,116.36328,0,5.22461-.877,10.21289-1.55078,15.25586a250.36631,250.36631,0,0,1-231.5664,0c-.67188-5.043-1.54883-10.03125-1.54883-15.25586C202.668,164.0957,255.19727,112,320,112Zm0,288c-178.47656,0-272-59.44141-272-80,0-13.05078,37.81445-41.72656,110.98438-60.96289a47.81277,47.81277,0,0,0,23.043,27.14648,298.37591,298.37591,0,0,0,275.94532,0,47.80892,47.80892,0,0,0,23.04492-27.14648C554.18555,278.27344,592,306.94922,592,320,592,340.55859,498.47852,400,320,400ZM512,296a24,24,0,1,0,24,24A23.99993,23.99993,0,0,0,512,296Z"
  ]
};
export const faUfoBeam = {
  prefix: "far",
  iconName: "ufo-beam",
  icon: [
    640,
    512,
    [],
    "e048",
    "M320,232.00045a24,24,0,1,0,24,24A24,24,0,0,0,320,232.00045ZM144,200.00038a24.00005,24.00005,0,1,0,24,24A24,24,0,0,0,144,200.00038Zm322.36719-90.88494C447.2793,45.94345,388.45117,0,320,0S192.7207,45.94345,173.63281,109.11544C75.24219,127.86939,0,166.56282,0,224.00043c0,84.03141,160.96875,128.00025,320,128.00025s320-43.96884,320-128.00025C640,166.56282,564.75781,127.86939,466.36719,109.11544ZM320,48.00009a104.91293,104.91293,0,0,1,104.82422,97.08808C393.53711,154.57842,357.89062,160.00031,320,160.00031s-73.53711-5.42189-104.82422-14.91214A104.91293,104.91293,0,0,1,320,48.00009Zm0,256.00049c-166.03125,0-272-47.37509-272-80.00015,0-21.1602,44.78516-48.45126,121.4082-65.07044a47.86653,47.86653,0,0,0,31.834,32.09186C238.38477,202.2875,278.33984,208.0004,320,208.0004s81.61523-5.7129,118.75781-16.97855A47.86653,47.86653,0,0,0,470.5918,158.93C547.21484,175.54917,592,202.84023,592,224.00043,592,256.62549,486.03125,304.00058,320,304.00058ZM33.68164,481.68452a15.99652,15.99652,0,0,0,7.1543,21.46488l14.3164,7.15822a16.00262,16.00262,0,0,0,21.4668-7.15431l68.75-137.50222c-16.45117-3.77344-32.23633-8.10743-47.12109-13.10158ZM541.74219,352.55341c-14.88477,4.9922-30.66992,9.32619-47.1211,13.10159l68.74805,137.49831a16.00206,16.00206,0,0,0,21.4668,7.15431l14.3164-7.15822a15.99819,15.99819,0,0,0,7.1543-21.46488ZM496,200.00038a24.00005,24.00005,0,1,0,24,24A24,24,0,0,0,496,200.00038Z"
  ]
};
export const faUmbrella = {
  prefix: "far",
  iconName: "umbrella",
  icon: [
    576,
    512,
    [],
    "f0e9",
    "M575.2 253.8C546.3 132.5 434.3 57.7 312 48.9V24c0-13.3-10.7-24-24-24s-24 10.7-24 24v24.9C142.1 57.6 30.5 131.8.8 253.7c-5.9 23.6 22.3 43.8 43.6 25.5l.5-.4c49.2-45.8 89.5-28.1 125.3 27.7 11.3 17.8 34.8 16.9 45.6 0 13.5-20.9 27.6-40.2 48.2-48.8V440c0 13.2-10.8 24-24 24-10.2 0-19.3-6.4-22.7-16-4.4-12.5-18.1-19-30.6-14.6s-19 18.1-14.6 30.6c10.2 28.7 37.4 48 67.9 48 39.7 0 72-32.3 72-72V258c25.9 10.8 38 32.6 48.2 48.5 10.8 16.9 34.2 17.8 45.6 0 36.2-56 76.6-73.1 125.4-27.7l.5.4c21.1 18.2 49.3-1.7 43.5-25.4zm-191.4 1.5c-24-30-56.8-50.3-95.8-50.3-39.4 0-69.7 18.7-94.6 49.9-35.7-44.3-82.8-57.1-122.7-46.8C115 134.8 202 96 288 96c85.6 0 173.8 39 217.8 112.8-47.9-13.8-89.8 8.1-122 46.5z"
  ]
};
export const faUmbrellaBeach = {
  prefix: "far",
  iconName: "umbrella-beach",
  icon: [
    640,
    512,
    [],
    "f5ca",
    "M443.48 18.08C409.77 5.81 375.31 0 341.41 0c-90.47 0-176.84 41.45-233.44 112.33-6.7 8.39-2.67 21.04 7.42 24.71l229.18 83.41L254.84 464H16c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h544c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16H306.01l83.67-227.12 228.66 83.22c1.83.67 3.7.98 5.53.98 8.27 0 15.83-6.35 16.04-15.14 3.03-124.66-72.77-242.85-196.43-287.86zm9.1 190.61L307.4 155.85c14.25-25.26 30.54-47.29 48.16-63.97 25.34-24.03 50.03-34.16 67.41-27.77 17.53 6.38 29.84 29.92 33.84 64.62 2.77 24.11 1.09 51.45-4.23 79.96zm-274.63-99.95c42.89-36.66 97.81-58.24 154.55-60.33-4.47 3.76-36.86 28.45-70.29 91l-84.26-30.67zm319.82 116.4c7.38-35.07 12.06-77.07 4.11-118.28 45.77 38.28 77.14 91.67 86.87 151.39l-90.98-33.11z"
  ]
};
export const faUnderline = {
  prefix: "far",
  iconName: "underline",
  icon: [
    448,
    512,
    [],
    "f0cd",
    "M32 48h32v208c0 88.22 71.78 160 160 160s160-71.78 160-160V48h32a16 16 0 0 0 16-16V16a16 16 0 0 0-16-16H288a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h32v208a96 96 0 0 1-192 0V48h32a16 16 0 0 0 16-16V16a16 16 0 0 0-16-16H32a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16zm400 416H16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16z"
  ]
};
export const faUndo = {
  prefix: "far",
  iconName: "undo",
  icon: [
    512,
    512,
    [],
    "f0e2",
    "M12 8h27.711c6.739 0 12.157 5.548 11.997 12.286l-2.347 98.568C93.925 51.834 170.212 7.73 256.793 8.001 393.18 8.428 504.213 120.009 504 256.396 503.786 393.181 392.835 504 256 504c-63.926 0-122.202-24.187-166.178-63.908-5.113-4.618-5.354-12.561-.482-17.433l19.738-19.738c4.498-4.498 11.753-4.785 16.501-.552C160.213 433.246 205.895 452 256 452c108.322 0 196-87.662 196-196 0-108.322-87.662-196-196-196-79.545 0-147.941 47.282-178.675 115.302l126.389-3.009c6.737-.16 12.286 5.257 12.286 11.997V212c0 6.627-5.373 12-12 12H12c-6.627 0-12-5.373-12-12V20C0 13.373 5.373 8 12 8z"
  ]
};
export const faUndoAlt = {
  prefix: "far",
  iconName: "undo-alt",
  icon: [
    512,
    512,
    [],
    "f2ea",
    "M28.485 28.485L80.65 80.65C125.525 35.767 187.515 8 255.999 8 392.66 8 504.1 119.525 504 256.185 503.9 393.067 392.905 504 256 504c-63.926 0-122.202-24.187-166.178-63.908-5.113-4.618-5.353-12.561-.482-17.433l19.738-19.738c4.498-4.498 11.753-4.785 16.501-.552C160.213 433.246 205.895 452 256 452c108.321 0 196-87.662 196-196 0-108.321-87.662-196-196-196-54.163 0-103.157 21.923-138.614 57.386l54.128 54.129c7.56 7.56 2.206 20.485-8.485 20.485H20c-6.627 0-12-5.373-12-12V36.971c0-10.691 12.926-16.045 20.485-8.486z"
  ]
};
export const faUnicorn = {
  prefix: "far",
  iconName: "unicorn",
  icon: [
    640,
    512,
    [],
    "f727",
    "M631.98 64H526.61l-15.28-18.57c16.37-5.23 29.03-18.72 32.51-35.79C544.85 4.68 540.96 0 535.9 0H399.95c-68.41 0-125.83 47.95-140.42 112H176c-38.13 0-71.77 19.22-92.01 48.4C37.36 162.55 0 200.84 0 248v56c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-56c0-13.22 6.87-24.39 16.78-31.68-.18 2.59-.78 5.05-.78 7.68 0 30.13 11.9 58.09 32.16 78.58l-12.95 43.76a78.913 78.913 0 0 0-1.05 40.84l24.12 100.29c3.46 14.38 16.32 24.52 31.11 24.52h74.7c20.86 0 36.14-19.64 31.02-39.86l-25.53-100.76 8.51-23.71L256 356.2V480c0 17.67 14.33 32 32 32h80c17.67 0 32-14.33 32-32V324.35c20.57-23.15 32-52.8 32-84.35v-5.62c20.95 6.97 38.32.72 40.93-.17l31.03-10.59c23.96-8.18 40.06-30.7 40.04-56.01l-.04-52.27 92.46-36.67c6.59-4.4 3.48-14.67-4.44-14.67zM488.46 178.19l-31.02 10.59c-1.51.52-9.71 2.95-16.48-3.83L416 160h-32v80c0 26.09-12.68 49.03-32 63.64V464h-48V320l-107.91-30.83-28.65 79.78L191.53 464H150l-21.13-87.86a31.698 31.698 0 0 1 .37-16.18l22.7-76.72C128.54 273.72 112 250.83 112 224c0-35.35 28.65-64 64-64h127.95v-16c0-53.02 42.98-96 96-96h51.33l44.67 54.28.05 65.35c0 4.77-3.03 9.02-7.54 10.56zM432 80c-8.84 0-16 7.16-16 16s7.16 16 16 16 16-7.16 16-16-7.16-16-16-16z"
  ]
};
export const faUnion = {
  prefix: "far",
  iconName: "union",
  icon: [
    320,
    512,
    [],
    "f6a2",
    "M272 80v204.78c0 53.45-36.12 102.08-88.48 112.81C111.54 412.33 48 357.44 48 288V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v200.86c0 83.51 60.89 158.24 144.01 166.35C239.38 456.53 320 381.5 320 288V80c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16z"
  ]
};
export const faUniversalAccess = {
  prefix: "far",
  iconName: "universal-access",
  icon: [
    512,
    512,
    [],
    "f29a",
    "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 456c-114.953 0-208-93.029-208-208 0-114.953 93.029-208 208-208 114.953 0 208 93.029 208 208 0 114.953-93.029 208-208 208zm143.594-286.66c2.538 10.75-4.119 21.522-14.869 24.061-29.865 7.051-57.839 13.286-85.597 16.751.679 111.33 12.654 128.456 26.969 165.116 4.823 12.346-1.275 26.265-13.622 31.087-12.34 4.823-26.263-1.27-31.087-13.622-9.559-24.467-18.089-42.949-23.805-85.12h-3.164c-5.721 42.206-14.269 60.706-23.805 85.12-4.816 12.329-18.721 18.451-31.087 13.623-12.346-4.823-18.445-18.741-13.623-31.088 14.33-36.686 26.29-53.837 26.969-165.116-27.758-3.465-55.732-9.699-85.597-16.751-10.75-2.538-17.407-13.311-14.869-24.061 2.539-10.75 13.312-17.405 24.061-14.869 104.768 24.736 134.447 24.701 239.066 0 10.749-2.538 21.522 4.118 24.06 14.869zm-181.788-43.146C217.806 113.1 234.906 96 256 96s38.194 17.1 38.194 38.194-17.1 38.194-38.194 38.194-38.194-17.101-38.194-38.194z"
  ]
};
export const faUniversity = {
  prefix: "far",
  iconName: "university",
  icon: [
    512,
    512,
    [],
    "f19c",
    "M472 440h-8v-56c0-13.255-10.745-24-24-24h-16V208h-48v152h-48V208h-48v152h-48V208h-48v152h-48V208H88v152H72c-13.255 0-24 10.745-24 24v56h-8c-13.255 0-24 10.745-24 24v16a8 8 0 0 0 8 8h464a8 8 0 0 0 8-8v-16c0-13.255-10.745-24-24-24zm-56 0H96v-32h320v32zm72.267-322.942L271.179 26.463a48.004 48.004 0 0 0-30.358 0L23.733 117.058A11.999 11.999 0 0 0 16 128.274V156c0 6.627 5.373 12 12 12h20v12c0 6.627 5.373 12 12 12h392c6.627 0 12-5.373 12-12v-12h20c6.627 0 12-5.373 12-12v-27.726c0-4.982-3.077-9.445-7.733-11.216zM64 144l192-72 192 72H64z"
  ]
};
export const faUnlink = {
  prefix: "far",
  iconName: "unlink",
  icon: [
    512,
    512,
    [],
    "f127",
    "M304.083 388.936c4.686 4.686 4.686 12.284 0 16.971l-65.057 65.056c-54.709 54.711-143.27 54.721-197.989 0-54.713-54.713-54.719-143.27 0-197.989l65.056-65.057c4.686-4.686 12.284-4.686 16.971 0l22.627 22.627c4.686 4.686 4.686 12.284 0 16.971L81.386 311.82c-34.341 34.341-33.451 88.269.597 120.866 32.577 31.187 84.788 31.337 117.445-1.32l65.057-65.056c4.686-4.686 12.284-4.686 16.971 0l22.627 22.626zm-56.568-243.245l64.304-64.304c34.346-34.346 88.286-33.453 120.882.612 31.18 32.586 31.309 84.785-1.335 117.43l-65.056 65.057c-4.686 4.686-4.686 12.284 0 16.971l22.627 22.627c4.686 4.686 12.284 4.686 16.971 0l65.056-65.057c54.711-54.709 54.721-143.271 0-197.99-54.71-54.711-143.27-54.72-197.989 0l-65.057 65.057c-4.686 4.686-4.686 12.284 0 16.971l22.627 22.627c4.685 4.685 12.283 4.685 16.97-.001zm238.343 362.794l22.627-22.627c4.686-4.686 4.686-12.284 0-16.971L43.112 3.515c-4.686-4.686-12.284-4.686-16.971 0L3.515 26.142c-4.686 4.686-4.686 12.284 0 16.971l465.373 465.373c4.686 4.686 12.284 4.686 16.97-.001z"
  ]
};
export const faUnlock = {
  prefix: "far",
  iconName: "unlock",
  icon: [
    448,
    512,
    [],
    "f09c",
    "M400 240H128v-94.8c0-52.8 42.1-96.7 95-97.2 53.4-.6 97 42.7 97 96v24c0 13.3 10.7 24 24 24s24-10.7 24-24v-22.6C368 65.8 304 .2 224.3 0 144.8-.2 80 64.5 80 144v96H48c-26.5 0-48 21.5-48 48v176c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V288c0-26.5-21.5-48-48-48zm0 224H48V288h352v176z"
  ]
};
export const faUnlockAlt = {
  prefix: "far",
  iconName: "unlock-alt",
  icon: [
    448,
    512,
    [],
    "f13e",
    "M400 240H128v-94.8c0-52.8 42.1-96.7 95-97.2 53.4-.6 97 42.7 97 96v24c0 13.3 10.7 24 24 24s24-10.7 24-24v-22.6C368 65.8 304 .2 224.3 0 144.8-.2 80 64.5 80 144v96H48c-26.5 0-48 21.5-48 48v176c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V288c0-26.5-21.5-48-48-48zm0 224H48V288h352v176zm-176-32c-15.5 0-28-12.5-28-28v-56c0-15.5 12.5-28 28-28s28 12.5 28 28v56c0 15.5-12.5 28-28 28z"
  ]
};
export const faUpload = {
  prefix: "far",
  iconName: "upload",
  icon: [
    576,
    512,
    [],
    "f093",
    "M528 288H384v-32h64c42.6 0 64.2-51.7 33.9-81.9l-160-160c-18.8-18.8-49.1-18.7-67.9 0l-160 160c-30.1 30.1-8.7 81.9 34 81.9h64v32H48c-26.5 0-48 21.5-48 48v128c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V336c0-26.5-21.5-48-48-48zm-400-80L288 48l160 160H336v160h-96V208H128zm400 256H48V336h144v32c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48v-32h144v128zm-40-64c0 13.3-10.7 24-24 24s-24-10.7-24-24 10.7-24 24-24 24 10.7 24 24z"
  ]
};
export const faUsbDrive = {
  prefix: "far",
  iconName: "usb-drive",
  icon: [
    640,
    512,
    [],
    "f8e9",
    "M624 128H480v-16a16 16 0 0 0-16-16H64a64 64 0 0 0-64 64v192a64 64 0 0 0 64 64h400a16 16 0 0 0 16-16v-16h144a16 16 0 0 0 16-16V144a16 16 0 0 0-16-16zM432 368H64a16 16 0 0 1-16-16V160a16 16 0 0 1 16-16h368zm152-56a16 16 0 0 1-16 16h-16a16 16 0 0 1-16-16v-16a16 16 0 0 1 16-16h16a16 16 0 0 1 16 16zm0-96a16 16 0 0 1-16 16h-16a16 16 0 0 1-16-16v-16a16 16 0 0 1 16-16h16a16 16 0 0 1 16 16z"
  ]
};
export const faUsdCircle = {
  prefix: "far",
  iconName: "usd-circle",
  icon: [
    496,
    512,
    [],
    "f2e8",
    "M291 244l-72-21.9c-9-2.8-15.2-12.1-15.2-22.7 0-12.9 9.2-23.4 20.5-23.4h45c7 0 13.8 1.9 19.9 5.4 6.4 3.7 14.3 3.4 19.7-1.6l12-11.3c7.6-7.2 6.3-19.4-2.3-25.2-13.8-9.3-29.9-14.5-46.4-15.1V112c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16v16c-37.6.1-68.2 32.1-68.2 71.4 0 31.5 20.2 59.7 49.2 68.6l72 21.9c9 2.8 15.2 12.1 15.2 22.7 0 12.9-9.2 23.4-20.5 23.4h-45c-7 0-13.8-1.9-19.9-5.4-6.4-3.7-14.3-3.4-19.7 1.6l-12 11.3c-7.6 7.2-6.3 19.4 2.3 25.2 13.8 9.3 29.9 14.5 46.4 15.1V400c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-16c37.6-.1 68.2-32.1 68.2-71.4 0-31.5-20.2-59.7-49.2-68.6zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200z"
  ]
};
export const faUsdSquare = {
  prefix: "far",
  iconName: "usd-square",
  icon: [
    448,
    512,
    [],
    "f2e9",
    "M261.8 242.3L200 223.7c-6.2-1.9-10.6-8.3-10.6-15.6 0-8.9 6.4-16.1 14.2-16.1h38.6c6.6 0 13 2.1 18.4 6.1 3 2.2 7.2 1.7 9.8-.9l23.4-22.3c3.3-3.2 3.5-8.7 0-11.6-12.9-10.9-29.1-17.4-45.9-18.6V120c0-4.4-3.6-8-8-8h-32c-4.4 0-8 3.6-8 8v24.4c-32.6 1.9-58.7 29.7-58.7 63.8 0 28.3 18.4 53.7 44.8 61.6l61.9 18.6c6.2 1.9 10.6 8.3 10.6 15.6 0 8.9-6.4 16.1-14.2 16.1h-38.6c-6.6 0-13-2.1-18.4-6.1-3-2.2-7.2-1.7-9.8.9l-23.4 22.3c-3.3 3.2-3.5 8.7 0 11.6 12.9 10.9 29.1 17.4 45.9 18.6V392c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8v-24.4c32.6-1.9 58.7-29.7 58.7-63.8 0-28.3-18.5-53.6-44.9-61.5zM392 32H56C25.1 32 0 57.1 0 88v336c0 30.9 25.1 56 56 56h336c30.9 0 56-25.1 56-56V88c0-30.9-25.1-56-56-56zm8 392c0 4.4-3.6 8-8 8H56c-4.4 0-8-3.6-8-8V88c0-4.4 3.6-8 8-8h336c4.4 0 8 3.6 8 8v336z"
  ]
};
export const faUser = {
  prefix: "far",
  iconName: "user",
  icon: [
    448,
    512,
    [],
    "f007",
    "M313.6 304c-28.7 0-42.5 16-89.6 16-47.1 0-60.8-16-89.6-16C60.2 304 0 364.2 0 438.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-25.6c0-74.2-60.2-134.4-134.4-134.4zM400 464H48v-25.6c0-47.6 38.8-86.4 86.4-86.4 14.6 0 38.3 16 89.6 16 51.7 0 74.9-16 89.6-16 47.6 0 86.4 38.8 86.4 86.4V464zM224 288c79.5 0 144-64.5 144-144S303.5 0 224 0 80 64.5 80 144s64.5 144 144 144zm0-240c52.9 0 96 43.1 96 96s-43.1 96-96 96-96-43.1-96-96 43.1-96 96-96z"
  ]
};
export const faUserAlien = {
  prefix: "far",
  iconName: "user-alien",
  icon: [
    448,
    512,
    [],
    "e04a",
    "M252,272h24a60.00047,60.00047,0,0,0,60-60v-8a12.0006,12.0006,0,0,0-12-12H300a60.00047,60.00047,0,0,0-60,60v8A12.0006,12.0006,0,0,0,252,272Zm-56,0a12.0006,12.0006,0,0,0,12-12v-8a60.00047,60.00047,0,0,0-60-60H124a12.0006,12.0006,0,0,0-12,12v8a60.00047,60.00047,0,0,0,60,60Zm156,80h-8.81251c39.14845-43.77734,72.87892-96.6582,72.87892-149.36719C416.06641,76.73633,330.05273,0,224,0,117.91992,0,31.93555,76.73633,31.93555,202.63281c0,52.709,33.73047,105.58985,72.8789,149.36719H96A95.99975,95.99975,0,0,0,0,448v32a32.00158,32.00158,0,0,0,32,32H416a32.00033,32.00033,0,0,0,32-32V448A95.99975,95.99975,0,0,0,352,352ZM79.93555,202.63281C79.93555,110.14258,137.83008,48,224,48s144.06641,62.14258,144.06641,154.63281c0,61.3711-72.96289,139.19336-144.06641,193.9375C152.89648,341.82617,79.93555,264.00391,79.93555,202.63281ZM400,464H48V448a48.055,48.055,0,0,1,48-48h57.05664c19.35156,17.27734,37.27344,31.41992,50.24219,41.11133a34.55191,34.55191,0,0,0,41.40429,0c12.96876-9.69141,30.88868-23.834,50.24024-41.11133H352a48.055,48.055,0,0,1,48,48Z"
  ]
};
export const faUserAlt = {
  prefix: "far",
  iconName: "user-alt",
  icon: [
    512,
    512,
    [],
    "f406",
    "M384 336c-40.6 0-47.6-1.5-72.2 6.8-17.5 5.9-36.3 9.2-55.8 9.2s-38.3-3.3-55.8-9.2c-24.6-8.3-31.5-6.8-72.2-6.8C57.3 336 0 393.3 0 464v16c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32v-16c0-70.7-57.3-128-128-128zm80 128H48c0-21.4 8.3-41.5 23.4-56.6C86.5 392.3 106.6 384 128 384c41.1 0 41-1.1 56.8 4.2 23 7.8 47 11.8 71.2 11.8 24.2 0 48.2-4 71.2-11.8 15.8-5.4 15.7-4.2 56.8-4.2 44.1 0 80 35.9 80 80zM256 320c88.4 0 160-71.6 160-160S344.4 0 256 0 96 71.6 96 160s71.6 160 160 160zm0-272c61.8 0 112 50.2 112 112s-50.2 112-112 112-112-50.2-112-112S194.2 48 256 48z"
  ]
};
export const faUserAltSlash = {
  prefix: "far",
  iconName: "user-alt-slash",
  icon: [
    640,
    512,
    [],
    "f4fa",
    "M320 48c61.8 0 112 50.2 112 112 0 27.3-10.2 52-26.5 71.5l24.1 18.8 13.6 10.7c22.7-27.7 36.8-62.5 36.8-101C480 71.6 408.4 0 320 0c-52.5 0-98.7 25.6-127.8 64.7l37.7 29.5C250.3 66.3 282.9 48 320 48zm314 423L479.5 350.2 400 288.1 115.6 65.7l-2.2-1.7L36 3.5C29.1-2 19-.9 13.5 6l-10 12.5C-2 25.4-.9 35.5 6 41l44.3 34.6 39 30.5L604 508.5c6.9 5.5 17 4.4 22.5-2.5l10-12.5c5.5-6.9 4.4-17-2.5-22.5zm-522-7.1c0-21.4 8.3-41.4 23.4-56.5S170.6 384 192 384h36.8c5.1 0 11.5 1.3 20 4.2 23 7.8 47 11.8 71.2 11.8 19.3 0 38.2-3.2 56.9-8.2l-51.5-40.3c-1.8.1-3.5.4-5.3.4-19.5 0-38.3-3.3-55.8-9.2-11.5-3.9-23.3-6.8-35.4-6.8H192c-70.7 0-128 57.3-128 128v16c0 17.7 14.3 32 32 32h434.6l-61.4-48z"
  ]
};
export const faUserAstronaut = {
  prefix: "far",
  iconName: "user-astronaut",
  icon: [
    448,
    512,
    [],
    "f4fb",
    "M358.6 328.8c20.5-20.2 36.4-45.1 46.2-72.8H416c8.8 0 16-7.2 16-16v-96c0-8.8-7.2-16-16-16h-11.2C378.5 53.5 307.6 0 224 0S69.5 53.5 43.2 128H32c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h11.2c9.8 27.7 25.7 52.6 46.2 72.8C37.4 347.3 0 396.1 0 454.4V488c0 13.3 10.7 24 24 24s24-10.7 24-24v-33.6c0-47.6 38.8-86.4 86.4-86.4h13c23.5 10.2 49.4 16 76.6 16s53.1-5.8 76.6-16h13c47.6 0 86.4 38.8 86.4 86.4V488c0 13.3 10.7 24 24 24s24-10.7 24-24v-33.6c0-58.3-37.4-107.1-89.4-125.6zM224 336c-79.4 0-144-64.6-144-144S144.6 48 224 48s144 64.6 144 144-64.6 144-144 144zm80 80H144c-17.7 0-32 14.3-32 32v64h48v-48c0-8.8 7.2-16 16-16s16 7.2 16 16v48h144v-64c0-17.7-14.3-32-32-32zm-32 64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm16-352H160c-26.5 0-48 21.5-48 48v16c0 53 43 96 96 96h32c53 0 96-43 96-96v-16c0-26.5-21.5-48-48-48zm-84 92l-12 36-12-36-36-12 36-12 12-36 12 36 36 12-36 12z"
  ]
};
export const faUserChart = {
  prefix: "far",
  iconName: "user-chart",
  icon: [
    640,
    512,
    [],
    "f6a3",
    "M160 320c53 0 96-43 96-96s-43-96-96-96-96 43-96 96 43 96 96 96zm0-144c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zm257 81l72-72 24.3 24.3c11.3 11.3 30.7 3.3 30.7-12.7V108c0-6.6-5.4-12-12-12h-88.5c-16 0-24.1 19.4-12.7 30.7L455 151l-55 55-55-55c-9.4-9.4-24.6-9.4-33.9 0l-30.7 30.7C285 195 288 209.1 288 224c0 6.8-1 13.4-2 20l42-42 55 55c9.4 9.3 24.6 9.3 34 0zM592 0H208c-26.5 0-48 22.2-48 49.6V96c6.4 0 11.4.6 15.8 1.6 5.4.7 10.7 1.5 15.9 2.9 4.2 1 8.2 2.3 12.2 3.8 1.3.5 2.8.7 4.1 1.3V48h384v320H352v48h240c26.5 0 48-22.2 48-49.6V49.6C640 22.2 618.5 0 592 0zM226.8 342c-9.9 0-19.9 1.5-29.6 4.4C185.4 350 173 352 160 352s-25.4-2-37.2-5.6c-9.7-2.9-19.7-4.4-29.6-4.4-30.2 0-59.7 13.5-76.9 39.1C6 396.4 0 414.8 0 434.7V472c0 22.1 17.9 40 40 40h240c22.1 0 40-17.9 40-40v-37.3c0-19.8-6-38.2-16.3-53.5-17.3-25.7-46.7-39.2-76.9-39.2zM272 464H48v-29.3c0-9.6 2.8-18.8 8.1-26.7 7.5-11.2 21.4-17.9 37.1-17.9 5.3 0 10.6.8 15.6 2.3 16.8 5.1 34 7.7 51.2 7.7s34.4-2.6 51.2-7.7c5.1-1.5 10.3-2.3 15.6-2.3 15.7 0 29.5 6.7 37.1 17.9 5.3 7.9 8.1 17.1 8.1 26.7z"
  ]
};
export const faUserCheck = {
  prefix: "far",
  iconName: "user-check",
  icon: [
    640,
    512,
    [],
    "f4fc",
    "M637 161.1l-19.1-19.2c-4-4.1-10.6-4.1-14.6 0L500.2 245.6l-47.4-47.7c-4-4.1-10.6-4.1-14.6 0L419 217.1c-4 4.1-4 10.6 0 14.7l73.8 74.3c4 4.1 10.6 4.1 14.6 0L637 175.8c4-4 4-10.6 0-14.7zM224 288c79.5 0 144-64.5 144-144S303.5 0 224 0 80 64.5 80 144s64.5 144 144 144zm0-240c52.9 0 96 43.1 96 96s-43.1 96-96 96-96-43.1-96-96 43.1-96 96-96zm89.6 256c-28.8 0-42.4 16-89.6 16-47.1 0-60.8-16-89.6-16C60.2 304 0 364.2 0 438.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-25.6c0-74.2-60.2-134.4-134.4-134.4zM400 464H48v-25.6c0-47.6 38.8-86.4 86.4-86.4 14.6 0 38.3 16 89.6 16 51.7 0 74.9-16 89.6-16 47.6 0 86.4 38.8 86.4 86.4V464z"
  ]
};
export const faUserCircle = {
  prefix: "far",
  iconName: "user-circle",
  icon: [
    496,
    512,
    [],
    "f2bd",
    "M248 104c-53 0-96 43-96 96s43 96 96 96 96-43 96-96-43-96-96-96zm0 144c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm0-240C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-49.7 0-95.1-18.3-130.1-48.4 14.9-23 40.4-38.6 69.6-39.5 20.8 6.4 40.6 9.6 60.5 9.6s39.7-3.1 60.5-9.6c29.2 1 54.7 16.5 69.6 39.5-35 30.1-80.4 48.4-130.1 48.4zm162.7-84.1c-24.4-31.4-62.1-51.9-105.1-51.9-10.2 0-26 9.6-57.6 9.6-31.5 0-47.4-9.6-57.6-9.6-42.9 0-80.6 20.5-105.1 51.9C61.9 339.2 48 299.2 48 256c0-110.3 89.7-200 200-200s200 89.7 200 200c0 43.2-13.9 83.2-37.3 115.9z"
  ]
};
export const faUserClock = {
  prefix: "far",
  iconName: "user-clock",
  icon: [
    640,
    512,
    [],
    "f4fd",
    "M224 288c79.5 0 144-64.5 144-144S303.5 0 224 0 80 64.5 80 144s64.5 144 144 144zm0-240c52.9 0 96 43.1 96 96s-43.1 96-96 96-96-43.1-96-96 43.1-96 96-96zM48 464v-25.6c0-47.6 38.8-86.4 86.4-86.4 14.6 0 38.3 16 89.6 16 43 0 70.4-12.1 80.7-14.6 1.3-17.1 4.9-33.6 10.4-49.2-31.4-.4-43.1 15.8-91.1 15.8-47.1 0-60.8-16-89.6-16C60.2 304 0 364.2 0 438.4V464c0 26.5 21.5 48 48 48h321.4c-15.6-13.7-29-29.9-39.5-48H48zm448-240c-79.6 0-144 64.4-144 144s64.4 144 144 144 144-64.4 144-144-64.4-144-144-144zm64 150.3c0 5.3-4.4 9.7-9.7 9.7h-60.6c-5.3 0-9.7-4.4-9.7-9.7v-76.6c0-5.3 4.4-9.7 9.7-9.7h12.6c5.3 0 9.7 4.4 9.7 9.7V352h38.3c5.3 0 9.7 4.4 9.7 9.7v12.6z"
  ]
};
export const faUserCog = {
  prefix: "far",
  iconName: "user-cog",
  icon: [
    640,
    512,
    [],
    "f4fe",
    "M340.3 464H48v-25.6c0-47.6 38.8-86.4 86.4-86.4 14.6 0 38.3 16 89.6 16 42.6 0 70-11.9 80.1-14.4-.1-7.5-.1-24.8 6.1-49.2-28.6 1.4-40.9 15.6-86.2 15.6-47.1 0-60.8-16-89.6-16C60.2 304 0 364.2 0 438.4V464c0 26.5 21.5 48 48 48h342c-19.4-12.9-36.2-29.2-49.7-48zM224 288c79.5 0 144-64.5 144-144S303.5 0 224 0 80 64.5 80 144s64.5 144 144 144zm0-240c52.9 0 96 43.1 96 96s-43.1 96-96 96-96-43.1-96-96 43.1-96 96-96zm386.5 325.3c2.6-14.1 2.6-28.5 0-42.6l25.8-14.9c3-1.7 4.3-5.2 3.3-8.5-6.7-21.6-18.2-41.2-33.2-57.4-2.3-2.5-6-3.1-9-1.4l-25.8 14.9c-10.9-9.3-23.4-16.5-36.9-21.3v-29.8c0-3.4-2.4-6.4-5.7-7.1-22.3-5-45-4.8-66.2 0-3.3.7-5.7 3.7-5.7 7.1v29.8c-13.5 4.8-26 12-36.9 21.3l-25.8-14.9c-2.9-1.7-6.7-1.1-9 1.4-15 16.2-26.5 35.8-33.2 57.4-1 3.3.4 6.8 3.3 8.5l25.8 14.9c-2.6 14.1-2.6 28.5 0 42.6l-25.8 14.9c-3 1.7-4.3 5.2-3.3 8.5 6.7 21.6 18.2 41.1 33.2 57.4 2.3 2.5 6 3.1 9 1.4l25.8-14.9c10.9 9.3 23.4 16.5 36.9 21.3v29.8c0 3.4 2.4 6.4 5.7 7.1 22.3 5 45 4.8 66.2 0 3.3-.7 5.7-3.7 5.7-7.1v-29.8c13.5-4.8 26-12 36.9-21.3l25.8 14.9c2.9 1.7 6.7 1.1 9-1.4 15-16.2 26.5-35.8 33.2-57.4 1-3.3-.4-6.8-3.3-8.5l-25.8-14.9zM496 400.5c-26.8 0-48.5-21.8-48.5-48.5s21.8-48.5 48.5-48.5 48.5 21.8 48.5 48.5-21.7 48.5-48.5 48.5z"
  ]
};
export const faUserCowboy = {
  prefix: "far",
  iconName: "user-cowboy",
  icon: [
    448,
    512,
    [],
    "f8ea",
    "M313.59 352c-28.72 0-42.43 16-89.59 16s-60.88-16-89.56-16A134.46 134.46 0 0 0 0 486.41 25.61 25.61 0 0 0 25.59 512H422.4a25.61 25.61 0 0 0 25.6-25.59A134.46 134.46 0 0 0 313.59 352zM50.94 464c9.53-35.3 46.93-64 83.5-64 14.43 0 38.28 16 89.56 16 51.47 0 75.09-16 89.59-16 36.56.05 73.94 28.72 83.47 64zm45.9-280.53c-.22 2.86-.84 5.61-.84 8.53a128 128 0 0 0 256 0c0-2.77-.6-5.36-.79-8.08 69.17-30.06 93.7-77.93 95.13-80.86a16 16 0 0 0-26.44-17.53c-1.92 1.87-22.55 20.59-76.16 33.61C333 69 312.09 0 278.1 0c-10.33 0-19.55 4.45-27.3 10.47a42.41 42.41 0 0 1-52.07 0C191 4.45 181.76 0 171.43 0c-34.08 0-55 69.38-65.73 119.54-55.17-13-75.62-31.87-76-31.87a16 16 0 0 0-27.89 15.71c1.49 2.89 26.85 50.09 95.03 80.09zM224 208a352.41 352.41 0 0 0 79.25-8.57C299.43 240 265.57 272 224 272s-75.52-32.06-79.26-72.72A347.29 347.29 0 0 0 224 208z"
  ]
};
export const faUserCrown = {
  prefix: "far",
  iconName: "user-crown",
  icon: [
    448,
    512,
    [],
    "f6a4",
    "M224 288c70.7 0 128-57.31 128-128V0l-64 32-64-32-64 32L96 0v160c0 70.69 57.31 128 128 128zm-80-160h160v32c0 44.11-35.89 80-80 80s-80-35.89-80-80v-32zm169.6 176c-11.04 0-21.78 2.6-32.2 6.24-18 6.28-37.28 9.76-57.4 9.76-20.11 0-39.4-3.48-57.39-9.76-10.42-3.64-21.17-6.24-32.21-6.24C60.17 304 0 364.17 0 438.4V464c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48v-25.6c0-74.23-60.17-134.4-134.4-134.4zM400 464H48v-25.6c0-47.64 38.76-86.4 86.4-86.4 4.18 0 9.53 1.16 16.38 3.55C174.44 363.81 199.07 368 224 368s49.56-4.19 73.22-12.45c6.85-2.39 12.21-3.55 16.38-3.55 47.64 0 86.4 38.76 86.4 86.4V464z"
  ]
};
export const faUserEdit = {
  prefix: "far",
  iconName: "user-edit",
  icon: [
    640,
    512,
    [],
    "f4ff",
    "M358.9 433.3l-6.8 61c-1.1 10.2 7.5 18.8 17.6 17.6l60.9-6.8 137.9-137.9-71.7-71.7-137.9 137.8zM633 268.9L595.1 231c-9.3-9.3-24.5-9.3-33.8 0l-41.8 41.8 71.8 71.7 41.8-41.8c9.2-9.3 9.2-24.4-.1-33.8zM223.9 288c79.6.1 144.2-64.5 144.1-144.1C367.9 65.6 302.4.1 224.1 0 144.5-.1 79.9 64.5 80 144.1c.1 78.3 65.6 143.8 143.9 143.9zm-4.4-239.9c56.5-2.6 103 43.9 100.4 100.4-2.3 49.2-42.1 89.1-91.4 91.4-56.5 2.6-103-43.9-100.4-100.4 2.3-49.3 42.2-89.1 91.4-91.4zM134.4 352c14.6 0 38.3 16 89.6 16 51.7 0 74.9-16 89.6-16 16.7 0 32.2 5 45.5 13.3l34.4-34.4c-22.4-16.7-49.8-26.9-79.9-26.9-28.7 0-42.5 16-89.6 16-47.1 0-60.8-16-89.6-16C60.2 304 0 364.2 0 438.4V464c0 26.5 21.5 48 48 48h258.3c-3.8-14.6-2.2-20.3.9-48H48v-25.6c0-47.6 38.8-86.4 86.4-86.4z"
  ]
};
export const faUserFriends = {
  prefix: "far",
  iconName: "user-friends",
  icon: [
    640,
    512,
    [],
    "f500",
    "M480 256c53 0 96-43 96-96s-43-96-96-96-96 43-96 96 43 96 96 96zm0-144c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zM272.1 276c-11.9 0-23.9 1.7-35.5 5.3-14.2 4.3-29.1 6.7-44.7 6.7s-30.5-2.4-44.7-6.7c-11.6-3.5-23.6-5.3-35.5-5.3-36.3 0-71.6 16.2-92.3 46.9C7.2 341.3 0 363.4 0 387.2V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-44.8c0-23.8-7.2-45.9-19.6-64.3-20.7-30.7-56-46.9-92.3-46.9zM336 432H48v-44.8c0-28.9 18.4-53.6 44.1-63.1 10.3-3.8 21.6-3.7 31.9 0 22.1 7.9 45 11.9 68 11.9s45.8-4 68.1-11.9c10.3-3.7 21.6-3.8 31.9 0 25.7 9.4 44.1 34.2 44.1 63.1V432zM192 256c61.9 0 112-50.1 112-112S253.9 32 192 32 80 82.1 80 144s50.1 112 112 112zm0-176c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm431.7 237.1C606.4 291.5 577 278 546.8 278c-27.8 0-34.8 10-66.8 10s-39-10-66.8-10c-13.3 0-26.2 3-38.2 8.1 5.8 5.9 11.3 12 16 18.9 4.7 7 8.6 14.4 12 22 3.3-.7 6.7-1.1 10.2-1.1 17.2 0 29.6 10 66.8 10 37.4 0 49.5-10 66.8-10 15.7 0 29.5 6.7 37.1 17.9 5.3 7.9 8.1 17.1 8.1 26.7V400H416v32c0 5.5-.6 10.8-1.6 16H600c22.1 0 40-17.9 40-40v-37.3c0-19.9-6-38.3-16.3-53.6z"
  ]
};
export const faUserGraduate = {
  prefix: "far",
  iconName: "user-graduate",
  icon: [
    448,
    512,
    [],
    "f501",
    "M13.2 100l6.8 2v37.6c-7 4.2-12 11.5-12 20.3 0 8.4 4.6 15.4 11.1 19.7L3.5 242c-1.7 6.9 2.1 14 7.6 14h41.8c5.5 0 9.3-7.1 7.6-14l-15.6-62.3C51.4 175.4 56 168.4 56 160c0-8.8-5-16.1-12-20.3v-30.5L90.6 123C84 139.4 80 157.2 80 176c0 79.5 64.5 144 144 144s144-64.5 144-144c0-18.8-4-36.6-10.6-53l77.4-23c17.6-5.2 17.6-34.8 0-40L240.9 2.5C235.3.8 229.7 0 224 0s-11.3.8-16.9 2.5L13.2 60c-17.6 5.2-17.6 34.8 0 40zM224 272c-52.9 0-96-43.1-96-96 0-14.1 3.3-27.3 8.8-39.3l70.4 20.9c14.8 4.4 27.2 2 33.8 0l70.4-20.9c5.5 12 8.8 25.3 8.8 39.3-.2 52.9-43.3 96-96.2 96zm-3.2-223.5c1-.3 3.3-.9 6.5 0L333.5 80l-106.3 31.5c-2.1.6-4.2.7-6.5 0L114.5 80l106.3-31.5zm98.6 272.1L224 400l-95.4-79.4C57.1 323.7 0 382.2 0 454.4v9.6c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-9.6c0-72.2-57.1-130.7-128.6-133.8zM200 464H48v-9.6c0-40.4 27.9-74.4 66-83.5l86 71.6V464zm200 0H248v-21.5l86-71.6c38.1 9.1 66 43.1 66 83.5v9.6z"
  ]
};
export const faUserHardHat = {
  prefix: "far",
  iconName: "user-hard-hat",
  icon: [
    448,
    512,
    [],
    "f82c",
    "M224 272a80.13 80.13 0 0 1-78.38-64h-48c8 63.06 61.17 112 126.39 112s118.44-48.94 126.39-112h-48a80.13 80.13 0 0 1-78.4 64zm89.6 80c-28.72 0-42.45 16-89.6 16s-60.88-16-89.56-16A134.4 134.4 0 0 0 0 486.4 25.6 25.6 0 0 0 25.6 512h396.8a25.6 25.6 0 0 0 25.6-25.6A134.4 134.4 0 0 0 313.6 352zM50.94 464a86.58 86.58 0 0 1 83.5-64c14.44 0 38.28 16 89.56 16 51.47 0 75.1-16 89.6-16a86.55 86.55 0 0 1 83.46 64zM88 176h272a8 8 0 0 0 8-8v-32a8 8 0 0 0-8-8h-8c0-46.41-28.53-85.54-68.79-102.42L256 80V16a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v64l-27.21-54.42C124.53 42.46 96 81.59 96 128h-8a8 8 0 0 0-8 8v32a8 8 0 0 0 8 8z"
  ]
};
export const faUserHeadset = {
  prefix: "far",
  iconName: "user-headset",
  icon: [
    448,
    512,
    [],
    "f82d",
    "M320 352h-4.7c-12.15 0-24 2.9-35.5 6.8a173.73 173.73 0 0 1-111.63 0c-11.49-3.9-23.3-6.78-35.43-6.78H128A128 128 0 0 0 0 480a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32 128 128 0 0 0-128-128zM49.61 464A80.14 80.14 0 0 1 128 400h4.74c5.12 0 11.49 1.35 20 4.24a221.75 221.75 0 0 0 142.42 0c8.6-2.91 15-4.27 20.11-4.27H320a80.14 80.14 0 0 1 78.39 64zm5.72-240a23.36 23.36 0 0 0 23.34-23.33V192c0-80.14 65.19-145.33 145.33-145.33S369.33 111.86 369.33 192v12.67a68.74 68.74 0 0 1-68.66 68.66h-23.5a38.74 38.74 0 0 0-37.84-30.66h-30.66a38.67 38.67 0 1 0 0 77.33h92A115.46 115.46 0 0 0 416 204.67V192C416 86.13 329.87 0 224 0S32 86.13 32 192v8.67A23.36 23.36 0 0 0 55.33 224zM224 128a64.07 64.07 0 0 1 64 64 63.21 63.21 0 0 1-8.76 31.73c7 4.86 13.41 10.55 18.29 17.6h3.14c12.69 0 23.35-6.88 29.94-16.71 3.18-10.39 5.39-21.19 5.39-32.62a112 112 0 0 0-224 0c0 28.2 10.78 53.66 28 73.35a70.73 70.73 0 0 1 28.54-42.05A63.22 63.22 0 0 1 160 192a64.07 64.07 0 0 1 64-64z"
  ]
};
export const faUserInjured = {
  prefix: "far",
  iconName: "user-injured",
  icon: [
    448,
    512,
    [],
    "f728",
    "M224 288c79.53 0 144-64.47 144-144S303.53 0 224 0 80 64.47 80 144s64.47 144 144 144zm82.64-192h-66.65l39.77-29.83c10.99 7.9 20.04 18.1 26.88 29.83zM224 48c7.85 0 15.37 1.21 22.68 3l-60 45h-45.32c16.65-28.55 47.27-48 82.64-48zm-94.38 80h188.77c.89 5.23 1.62 10.52 1.62 16 0 52.93-43.06 96-96 96-52.93 0-96-43.07-96-96-.01-5.48.72-10.77 1.61-16zM313.6 304c-11.04 0-21.78 2.6-32.2 6.24-18 6.28-37.28 9.76-57.4 9.76-20.11 0-39.4-3.48-57.39-9.76-10.42-3.64-21.17-6.24-32.21-6.24C60.17 304 0 364.17 0 438.4V464c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48v-25.6c0-74.23-60.17-134.4-134.4-134.4zM80 464H48v-25.6c0-26.92 12.63-50.71 32-66.57V464zm32 0V355.32c7.19-1.95 14.61-3.32 22.4-3.32 4.18 0 9.53 1.16 16.38 3.55 1.46.51 2.99.67 4.46 1.15L202.93 464H112zm171.08 0h-45.12l-21.33-48H256c17.66 0 32 14.36 32 32 0 5.95-2.07 11.22-4.92 16zM400 464h-82.27c1.34-5.14 2.27-10.44 2.27-16 0-35.3-28.72-64-64-64h-53.6l-8.23-18.52c9.88 1.35 19.8 2.52 29.83 2.52 24.93 0 49.56-4.19 73.22-12.45 6.85-2.39 12.21-3.55 16.38-3.55 47.64 0 86.4 38.76 86.4 86.4V464z"
  ]
};
export const faUserLock = {
  prefix: "far",
  iconName: "user-lock",
  icon: [
    640,
    512,
    [],
    "f502",
    "M496 432a32 32 0 1 0-32-32 32 32 0 0 0 32 32zm-192 32H48v-25.6a86.55 86.55 0 0 1 86.4-86.4c14.6 0 38.3 16 89.6 16 42.3 0 69.5-11.7 80-14.4V320a83.12 83.12 0 0 1 1.5-15.1c-26.2 2.9-40 15.1-81.5 15.1-47.1 0-60.8-16-89.6-16A134.43 134.43 0 0 0 0 438.4V464a48 48 0 0 0 48 48h262.8c-7.9-18-6.8-30.7-6.8-48zm304-176h-32v-48a80 80 0 0 0-160 0v48h-32a32 32 0 0 0-32 32v160a32 32 0 0 0 32 32h224a32 32 0 0 0 32-32V320a32 32 0 0 0-32-32zm-144-48a32 32 0 0 1 64 0v48h-64zm128 224H400V336h192zM224 0a144 144 0 1 0 144 144A144 144 0 0 0 224 0zm0 240a96 96 0 1 1 96-96 96.15 96.15 0 0 1-96 96z"
  ]
};
export const faUserMd = {
  prefix: "far",
  iconName: "user-md",
  icon: [
    448,
    512,
    [],
    "f0f0",
    "M224 288c79.5 0 144-64.5 144-144S303.5 0 224 0 80 64.5 80 144s64.5 144 144 144zm0-240c52.9 0 96 43.1 96 96s-43.1 96-96 96-96-43.1-96-96 43.1-96 96-96zm89.6 256c-11 0-21.8 2.6-32.2 6.2-18 6.3-37.3 9.8-57.4 9.8s-39.4-3.5-57.4-9.8c-10.4-3.6-21.2-6.2-32.2-6.2C60.2 304 0 364.2 0 438.4V488c0 13.3 10.7 24 24 24s24-10.7 24-24v-49.6c0-45.5 35.4-82.4 80-85.8v50c-23.1 6.9-40 28.1-40 53.4 0 30.9 25.1 56 56 56s56-25.1 56-56c0-25.3-16.9-46.5-40-53.4v-44.7c20.8 6.3 42.3 10.1 64 10.1 21.8 0 43.2-3.8 64-10.1v36.3c-28.2 7.5-48 34.5-48 64.6V488c0 4.2 1.7 8.3 4.7 11.3l10.3 10.3c3.1 3.1 8.2 3.1 11.3 0l11.3-11.3c3.1-3.1 3.1-8.2 0-11.3l-5.7-5.7V456c0-19.4 17.4-34.8 37.4-31.6 15.7 2.6 26.6 17.4 26.6 33.3v23.6l-5.7 5.7c-3.1 3.1-3.1 8.2 0 11.3l11.3 11.3c3.1 3.1 8.2 3.1 11.3 0l10.3-10.3c3-3 4.7-7.1 4.7-11.3v-32c0-29.7-20.5-54.5-48-61.6v-41.7c44.6 3.3 80 40.3 80 85.8V488c0 13.3 10.7 24 24 24s24-10.7 24-24v-49.6c.2-74.2-60-134.4-134.2-134.4zM168 456c0 13.3-10.7 24-24 24s-24-10.7-24-24 10.7-24 24-24 24 10.7 24 24z"
  ]
};
export const faUserMdChat = {
  prefix: "far",
  iconName: "user-md-chat",
  icon: [
    640,
    512,
    [],
    "f82e",
    "M512 0c-70.69 0-128 50.14-128 112 0 28.76 12.75 54.72 33.11 74.55a312.08 312.08 0 0 1-31.29 55.37 9.86 9.86 0 0 0-1.25 9.07c1.09 3.13 3.43 5 6.11 5 39.84 0 72.35-17.14 95.22-34.36A146 146 0 0 0 512 224c70.69 0 128-50.14 128-112S582.69 0 512 0zM224 288A144 144 0 1 0 80 144a144 144 0 0 0 144 144zm0-240a96 96 0 1 1-96 96 96.15 96.15 0 0 1 96-96zm89.6 256c-11 0-21.8 2.6-32.2 6.2a173 173 0 0 1-114.8 0c-10.4-3.6-21.2-6.2-32.2-6.2A134.43 134.43 0 0 0 0 438.4V488a24 24 0 0 0 48 0v-49.6c0-45.5 35.4-82.4 80-85.8v50a56 56 0 1 0 32 0v-44.7c20.8 6.3 42.3 10.1 64 10.1s43.2-3.8 64-10.1v36.3c-28.2 7.5-48 34.5-48 64.6V488a16.06 16.06 0 0 0 4.7 11.3l10.3 10.3a8 8 0 0 0 11.3 0l11.3-11.3a8 8 0 0 0 0-11.3l-5.7-5.7V456a32.14 32.14 0 0 1 37.4-31.6c15.7 2.6 26.6 17.4 26.6 33.3v23.6l-5.7 5.7a8 8 0 0 0 0 11.3l11.3 11.3a8 8 0 0 0 11.3 0l10.3-10.3a16.06 16.06 0 0 0 4.7-11.3v-32a63.8 63.8 0 0 0-48-61.6v-41.7c44.6 3.3 80 40.3 80 85.8V488a24 24 0 0 0 48 0v-49.6c.2-74.2-60-134.4-134.2-134.4zM168 456a24 24 0 1 1-24-24 23.94 23.94 0 0 1 24 24z"
  ]
};
export const faUserMinus = {
  prefix: "far",
  iconName: "user-minus",
  icon: [
    640,
    512,
    [],
    "f503",
    "M624 216H432c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h192c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zm-310.4 88c-28.8 0-42.4 16-89.6 16-47.1 0-60.8-16-89.6-16C60.2 304 0 364.2 0 438.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-25.6c0-74.2-60.2-134.4-134.4-134.4zM400 464H48v-25.6c0-47.6 38.8-86.4 86.4-86.4 14.6 0 38.3 16 89.6 16 51.7 0 74.9-16 89.6-16 47.6 0 86.4 38.8 86.4 86.4V464zM224 288c79.5 0 144-64.5 144-144S303.5 0 224 0 80 64.5 80 144s64.5 144 144 144zm0-240c52.9 0 96 43.1 96 96s-43.1 96-96 96-96-43.1-96-96 43.1-96 96-96z"
  ]
};
export const faUserMusic = {
  prefix: "far",
  iconName: "user-music",
  icon: [
    640,
    512,
    [],
    "f8eb",
    "M598.36 97.51l-112 35.38A32 32 0 0 0 464 163.36v203.12c-18.16-9.07-40.16-14.48-64-14.48-61.86 0-112 35.82-112 80s50.14 80 112 80 112-35.82 112-80V291.36L617.64 258A32 32 0 0 0 640 227.48V128a32 32 0 0 0-41.64-30.49zM400 464c-39.7 0-64-20.72-64-32s24.3-32 64-32 64 20.72 64 32-24.3 32-64 32zm192-248.25L512 241v-65.88l80-25.26zM262.46 464H48v-25.59A86.56 86.56 0 0 1 134.41 352c14.59 0 38.28 16 89.59 16 32.8 0 54.08-6.42 69.05-11.13 21.76-18.79 51.57-31.47 85.83-35.26-19.41-10.88-41.46-17.61-65.29-17.61-28.68 0-42.5 16-89.59 16s-60.81-16-89.59-16A134.43 134.43 0 0 0 0 438.41V464a48 48 0 0 0 48 48h250.42a107.94 107.94 0 0 1-35.96-48zM224 288A144 144 0 1 0 80 144a144 144 0 0 0 144 144zm0-240a96 96 0 1 1-96 96 96.14 96.14 0 0 1 96-96z"
  ]
};
export const faUserNinja = {
  prefix: "far",
  iconName: "user-ninja",
  icon: [
    448,
    512,
    [],
    "f504",
    "M32 208c21 0 40.3-6.9 56.1-18.4 19.1 57 72.4 98.4 135.9 98.4 79.5 0 144-64.5 144-144S303.5 0 224 0C169.5 0 122.6 30.7 98.1 75.4 80.9 58.7 57.9 48 32 48c0 33.4 17.1 62.8 43.1 80-26 17.2-43.1 46.6-43.1 80zM224 48c35.4 0 66 19.4 82.6 48H141.4C158 67.4 188.6 48 224 48zm96 96c0 52.9-43.1 96-96 96s-96-43.1-96-96h192zm5.4 145.2L224 368l-101.4-78.8C54 295.3 0 352.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-70.2-54-127.1-122.6-133.2zM200 464H48v-41.6c0-38.9 25.7-71.8 61.9-82.2l90.1 70V464zm200 0H248v-53.9l90.1-70c36.3 10.5 61.9 43.3 61.9 82.2V464z"
  ]
};
export const faUserNurse = {
  prefix: "far",
  iconName: "user-nurse",
  icon: [
    448,
    512,
    [],
    "f82f",
    "M224,303A128,128,0,0,0,352,175V64.82a32,32,0,0,0-20.76-30L246.47,3.07a64,64,0,0,0-44.94,0L116.76,34.86A32,32,0,0,0,96,64.82V175A128,128,0,0,0,224,303ZM184,70.67a5,5,0,0,1,5-5h21.67V44a5,5,0,0,1,5-5h16.66a5,5,0,0,1,5,5V65.67H259a5,5,0,0,1,5,5V87.33a5,5,0,0,1-5,5H237.33V114a5,5,0,0,1-5,5H215.67a5,5,0,0,1-5-5V92.33H189a5,5,0,0,1-5-5ZM144,159H304v16a80,80,0,0,1-160,0ZM319.41,319,224,414.39,128.59,319C57.09,322.09,0,380.59,0,452.8A58.23,58.23,0,0,0,58.2,511H389.8A58.23,58.23,0,0,0,448,452.8C448,380.59,390.91,322.09,319.41,319ZM58.2,463A10.22,10.22,0,0,1,48,452.8c0-36.36,28.5-73.5,63.61-82.91L204.72,463Zm331.6,0H243.28l93.11-93.11C371.5,379.3,400,416.44,400,452.8A10.22,10.22,0,0,1,389.8,463Z"
  ]
};
export const faUserPlus = {
  prefix: "far",
  iconName: "user-plus",
  icon: [
    640,
    512,
    [],
    "f234",
    "M224 288c79.5 0 144-64.5 144-144S303.5 0 224 0 80 64.5 80 144s64.5 144 144 144zm0-240c52.9 0 96 43.1 96 96s-43.1 96-96 96-96-43.1-96-96 43.1-96 96-96zm89.6 256c-28.7 0-42.5 16-89.6 16-47.1 0-60.8-16-89.6-16C60.2 304 0 364.2 0 438.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-25.6c0-74.2-60.2-134.4-134.4-134.4zM400 464H48v-25.6c0-47.6 38.8-86.4 86.4-86.4 14.6 0 38.3 16 89.6 16 51.7 0 74.9-16 89.6-16 47.6 0 86.4 38.8 86.4 86.4V464zm224-248h-72v-72c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16v72h-72c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h72v72c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-72h72c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16z"
  ]
};
export const faUserRobot = {
  prefix: "far",
  iconName: "user-robot",
  icon: [
    448,
    512,
    [],
    "e04b",
    "M272,208a32,32,0,1,0-32-32A31.99783,31.99783,0,0,0,272,208Zm-64,64h32V240H208Zm64,0h32V240H272Zm103.48828,35.23633A79.15715,79.15715,0,0,0,384,272V256h29.99955A17.97977,17.97977,0,0,0,432,238V178a17.97853,17.97853,0,0,0-18.00045-18H384V144a79.999,79.999,0,0,0-80-80H248V24a24,24,0,0,0-48,0V64H144a79.999,79.999,0,0,0-80,80v16H33.99956A17.97834,17.97834,0,0,0,16,178v60a17.97958,17.97958,0,0,0,17.99956,18H64v16a79.15715,79.15715,0,0,0,8.51172,35.23633C30.91406,317.75977,0,355.13086,0,400v48a64.00067,64.00067,0,0,0,64,64H384a64.00067,64.00067,0,0,0,64-64V400C448,355.13086,417.08594,317.75977,375.48828,307.23633ZM112,144a32.03667,32.03667,0,0,1,32-32H304a32.03667,32.03667,0,0,1,32,32V272a32.03667,32.03667,0,0,1-32,32H144a32.03667,32.03667,0,0,1-32-32Zm96,320H176V432a16,16,0,0,1,32,0Zm64-16a16,16,0,1,1,16-16A16.00079,16.00079,0,0,1,272,448Zm128,0a16.01833,16.01833,0,0,1-16,16H320V416a31.99908,31.99908,0,0,0-32-32H160a31.99908,31.99908,0,0,0-32,32v48H64a16.01833,16.01833,0,0,1-16-16V400a48.055,48.055,0,0,1,48-48H352a48.055,48.055,0,0,1,48,48ZM176,208a32,32,0,1,0-32-32A31.99783,31.99783,0,0,0,176,208Zm0,32H144v32h32Z"
  ]
};
export const faUserSecret = {
  prefix: "far",
  iconName: "user-secret",
  icon: [
    448,
    512,
    [],
    "f21b",
    "M383.9 308.3l23.9-62.6c4-10.5-3.7-21.7-15-21.7h-33.6c5.4-15.1 8.8-31.1 8.8-48 0-6.6-.7-13.1-1.6-19.4C397.1 149 416 139 416 128c0-13.3-27.3-25.1-70.1-33-9.2-32.8-27-65.8-40.6-82.8C299.1 4.3 289.7 0 280.1 0c-4.8 0-9.7 1.1-14.3 3.4C236 18.3 233.5 20.5 224 20.5s-12.3-2.4-41.9-17.2c-4.6-2.3-9.4-3.4-14.3-3.4-9.6 0-18.9 4.3-25.2 12.2-13.5 17-31.4 50-40.6 82.8-42.7 8-70 19.8-70 33.1 0 11 18.9 21 49.6 28.6-1 6.4-1.6 12.8-1.6 19.4 0 16.9 3.5 32.9 8.8 48H56.3c-11.5 0-19.2 11.7-14.7 22.3l25.8 60.2C27.3 329.8 0 372.7 0 422.4v44.8C0 491.9 20.1 512 44.8 512h358.4c24.7 0 44.8-20.1 44.8-44.8v-44.8c0-48.4-25.8-90.4-64.1-114.1zM173 52.5c16.2 8.1 29 16 51 16 21.8 0 34.8-7.9 51-16 19 30.4 25.7 59.2 27.7 66.2-21.8 2.4-48.1 3.9-78.7 3.9s-56.8-1.6-78.7-3.9c2-7.1 8.7-35.8 27.7-66.2zM183.5 464H48v-41.6c0-30.8 16.2-58.6 43.5-74.3l36.8-21.3-23.5-54.8h12.6c17 18.9 38.8 32.9 63.6 40.7l27 47.3zm-55.6-287.9c.1-.2.1-.3.1-.4.1.1 5.5 3.2 6.3 5.8 3.9 11.9 7 24.6 16.5 33.4 8 7.4 47 25.1 64-25 2.8-8.4 15.4-8.4 18.3 0 16 47.4 53.9 34.4 64 25 9.5-8.8 12.7-21.5 16.5-33.4.8-2.5 6.2-5.6 6.3-5.7v.3c0 52.9-43.1 96-96 96s-96-43.1-96-96zM264.5 464L240 360l27-47.3c24.8-7.8 46.6-21.9 63.6-40.7h15.7l-21.5 56.3 33.8 20.8c25.9 16 41.3 43.4 41.3 73.2V464z"
  ]
};
export const faUserShield = {
  prefix: "far",
  iconName: "user-shield",
  icon: [
    640,
    512,
    [],
    "f505",
    "M622.3 271.1l-115.2-45c-4.1-1.6-12.6-3.7-22.2 0l-115.2 45c-10.7 4.2-17.7 14-17.7 24.9 0 111.6 68.7 188.8 132.9 213.9 9.6 3.7 18 1.6 22.2 0C558.4 489.9 640 420.5 640 296c0-10.9-7-20.7-17.7-24.9zM496 462.4V273.3l95.5 37.3c-5.6 87.1-60.9 135.4-95.5 151.8zM356.2 464H48v-25.6c0-47.6 38.8-86.4 86.4-86.4 14.6 0 38.3 16 89.6 16 47.1 0 70.9-13.5 85.4-15.5-2.9-15.2-4.6-31-5.1-47.5-25.6 3.2-39.5 15-80.4 15-47.1 0-60.8-16-89.6-16C60.2 304 0 364.2 0 438.4V464c0 26.5 21.5 48 48 48h351.3c-15.5-13.7-30.2-29.7-43.1-48zM224 288c79.5 0 144-64.5 144-144S303.5 0 224 0 80 64.5 80 144s64.5 144 144 144zm0-240c52.9 0 96 43.1 96 96s-43.1 96-96 96-96-43.1-96-96 43.1-96 96-96z"
  ]
};
export const faUserSlash = {
  prefix: "far",
  iconName: "user-slash",
  icon: [
    640,
    512,
    [],
    "f506",
    "M634 471L36 3.5C29.1-2 19-.9 13.5 6l-10 12.5C-2 25.4-.9 35.5 6 41l598 467.5c6.9 5.5 17 4.4 22.5-2.5l10-12.5c5.5-6.9 4.4-17-2.5-22.5zM320 48c52.9 0 96 43.1 96 96 0 28.1-12.4 53.3-31.8 70.8l38.4 30c25.5-26 41.4-61.5 41.4-100.8C464 64.5 399.5 0 320 0c-51.9 0-97 27.7-122.4 68.9l38.2 29.9C252.1 68.7 283.5 48 320 48zM144 464v-25.6c0-47.6 38.8-86.4 86.4-86.4 4.2 0 9.5 1.2 16.4 3.6 23.7 8.3 48.3 12.4 73.2 12.4 8 0 15.9-1.1 23.8-2l-66.4-51.9c-4.9-1.3-10-2.2-14.8-3.8-10.4-3.6-21.2-6.2-32.2-6.2C156.2 304 96 364.2 96 438.4V464c0 26.5 21.5 48 48 48h352c9.3 0 17.9-2.8 25.2-7.3l-52-40.7H144z"
  ]
};
export const faUserTag = {
  prefix: "far",
  iconName: "user-tag",
  icon: [
    640,
    512,
    [],
    "f507",
    "M630.6 364.9l-90.3-90.2c-12-12-28.3-18.7-45.3-18.7h-79.3c-17.7 0-32 14.3-32 32v79.2c0 17 6.7 33.2 18.7 45.2l90.3 90.2c12.5 12.5 32.8 12.5 45.3 0l92.5-92.5c12.6-12.5 12.6-32.7.1-45.2zm-182.8-21c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24c0 13.2-10.7 24-24 24zM48 463.8v-25.6c0-47.6 38.8-86.4 86.4-86.4 14.6 0 38.3 16 89.6 16 51.7 0 74.9-16 89.6-16 7.7 0 15.1 1.3 22.2 3.3v-49c-7.3-1.2-14.6-2.2-22.2-2.2-28.7 0-42.5 16-89.6 16-47.1 0-60.8-16-89.6-16C60.2 303.9 0 364 0 438.3v25.6c0 26.5 21.5 48 48 48h352c9.7 0 18.7-2.9 26.3-7.9l-40.1-40.1H48zm176-175.9c79.5 0 144-64.5 144-144S303.5 0 224 0 80 64.4 80 144c0 79.5 64.5 143.9 144 143.9zM224 48c52.9 0 96 43 96 96 0 52.9-43.1 96-96 96s-96-43.1-96-96c0-53 43.1-96 96-96z"
  ]
};
export const faUserTie = {
  prefix: "far",
  iconName: "user-tie",
  icon: [
    448,
    512,
    [],
    "f508",
    "M224 288c79.5 0 144-64.5 144-144S303.5 0 224 0 80 64.5 80 144s64.5 144 144 144zm0-240c52.9 0 96 43.1 96 96s-43.1 96-96 96-96-43.1-96-96 43.1-96 96-96zm91.9 256.2l-56.5 154.5L240 376l32-56h-96l32 56-19.5 82.7L132 304.2C58.9 305.5 0 365 0 438.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-25.6c0-73.4-58.9-132.9-132.1-134.2zM96 464H48v-25.6c0-35.4 21.9-66.2 53-79.4l38.4 105H96zm304 0h-91.3L347 359c31 13.2 53 44 53 79.4V464z"
  ]
};
export const faUserTimes = {
  prefix: "far",
  iconName: "user-times",
  icon: [
    640,
    512,
    [],
    "f235",
    "M593.9 240l41.4-41.4c6.2-6.2 6.2-16.4 0-22.6L624 164.7c-6.2-6.2-16.4-6.2-22.6 0L560 206.1l-41.4-41.4c-6.2-6.2-16.4-6.2-22.6 0L484.7 176c-6.2 6.2-6.2 16.4 0 22.6l41.4 41.4-41.4 41.4c-6.2 6.2-6.2 16.4 0 22.6l11.3 11.3c6.2 6.2 16.4 6.2 22.6 0l41.4-41.4 41.4 41.4c6.2 6.2 16.4 6.2 22.6 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6L593.9 240zM224 288c79.5 0 144-64.5 144-144S303.5 0 224 0 80 64.5 80 144s64.5 144 144 144zm0-240c52.9 0 96 43.1 96 96s-43.1 96-96 96-96-43.1-96-96 43.1-96 96-96zm89.6 256c-28.8 0-42.4 16-89.6 16-47.1 0-60.8-16-89.6-16C60.2 304 0 364.2 0 438.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-25.6c0-74.2-60.2-134.4-134.4-134.4zM400 464H48v-25.6c0-47.6 38.8-86.4 86.4-86.4 14.6 0 38.3 16 89.6 16 51.7 0 74.9-16 89.6-16 47.6 0 86.4 38.8 86.4 86.4V464z"
  ]
};
export const faUserUnlock = {
  prefix: "far",
  iconName: "user-unlock",
  icon: [
    640,
    512,
    [],
    "e058",
    "M224,0A144,144,0,1,0,368,144,144,144,0,0,0,224,0Zm0,240a96,96,0,1,1,96-96A96,96,0,0,1,224,240Zm80,224H48V438.4A86.55,86.55,0,0,1,134.4,352c14.6,0,38.3,16,89.6,16,42.3,0,69.5-11.7,80-14.4V320a83.2,83.2,0,0,1,1.5-15.1c-26.2,2.9-40,15.1-81.5,15.1-47.1,0-60.8-16-89.6-16A134.43,134.43,0,0,0,0,438.4V464a48,48,0,0,0,48,48H310.8C302.9,494,304,481.3,304,464ZM608,288H464V208.67c0-17.44,13.67-32.18,31.1-32.66A32,32,0,0,1,528,208a16,16,0,0,0,16,16h17a15,15,0,0,0,15-15h0c0-43.28-34-79.51-77.26-80.95A80,80,0,0,0,416,208v80H384a32,32,0,0,0-32,32V480a32,32,0,0,0,32,32H608a32,32,0,0,0,32-32V320A32,32,0,0,0,608,288ZM592,464H400V336H592Zm-96-32a32,32,0,1,0-32-32A32,32,0,0,0,496,432Z"
  ]
};
export const faUserVisor = {
  prefix: "far",
  iconName: "user-visor",
  icon: [
    448,
    512,
    [],
    "e04c",
    "M313.59375,304c-28.6875,0-42.5,16-89.59375,16s-60.8125-16-89.59375-16A134.43133,134.43133,0,0,0,0,438.40625V464a48.01238,48.01238,0,0,0,48,48H400a48.01238,48.01238,0,0,0,48-48V438.40625A134.43133,134.43133,0,0,0,313.59375,304ZM400,464H48V438.40625A86.55945,86.55945,0,0,1,134.40625,352C149,352,172.6875,368,224,368c51.6875,0,74.90625-16,89.59375-16A86.55945,86.55945,0,0,1,400,438.40625ZM322.44141,362.66406a3.53,3.53,0,0,0-2.69532,1.23633c-17.61132,20.42969-28.27734,47.19531-31.72265,79.55664a3.55509,3.55509,0,0,0,5.72265,3.18164c22.084-17.18164,30-21.168,32.918-22.05664a5.98,5.98,0,0,1,1.22266-.334c2.332,2.07031,7.27734,7.627,17.666,22.252a3.51185,3.51185,0,0,0,2.88868,1.5,3.63354,3.63354,0,0,0,1.14062-.18164,3.56782,3.56782,0,0,0,2.416-3.48633c-1.02735-31.40234-10.02735-58.4043-26.72266-80.26562A4.00227,4.00227,0,0,0,322.44141,362.66406ZM88.33789,190.45312C107.73828,247.05078,160.82422,288,224,288s116.26172-40.94922,135.66211-97.54688C373.52734,186.94336,384,174.95508,384,160V96a31.99908,31.99908,0,0,0-32-32h-8.31641a143.90751,143.90751,0,0,0-239.36718,0H96A31.99908,31.99908,0,0,0,64,96v64C64,174.95508,74.47266,186.94336,88.33789,190.45312ZM224,240c-35.37305,0-65.99023-19.44531-82.64453-48H306.64453C289.99023,220.55469,259.37305,240,224,240Zm0-192a95.35439,95.35439,0,0,1,52.86719,16H171.13281A95.35439,95.35439,0,0,1,224,48ZM112,112H336v32H112Z"
  ]
};
export const faUsers = {
  prefix: "far",
  iconName: "users",
  icon: [
    640,
    512,
    [],
    "f0c0",
    "M544 224c44.2 0 80-35.8 80-80s-35.8-80-80-80-80 35.8-80 80 35.8 80 80 80zm0-112c17.6 0 32 14.4 32 32s-14.4 32-32 32-32-14.4-32-32 14.4-32 32-32zM96 224c44.2 0 80-35.8 80-80s-35.8-80-80-80-80 35.8-80 80 35.8 80 80 80zm0-112c17.6 0 32 14.4 32 32s-14.4 32-32 32-32-14.4-32-32 14.4-32 32-32zm396.4 210.9c-27.5-40.8-80.7-56-127.8-41.7-14.2 4.3-29.1 6.7-44.7 6.7s-30.5-2.4-44.7-6.7c-47.1-14.3-100.3.8-127.8 41.7-12.4 18.4-19.6 40.5-19.6 64.3V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-44.8c.2-23.8-7-45.9-19.4-64.3zM464 432H176v-44.8c0-36.4 29.2-66.2 65.4-67.2 25.5 10.6 51.9 16 78.6 16 26.7 0 53.1-5.4 78.6-16 36.2 1 65.4 30.7 65.4 67.2V432zm92-176h-24c-17.3 0-33.4 5.3-46.8 14.3 13.4 10.1 25.2 22.2 34.4 36.2 3.9-1.4 8-2.5 12.3-2.5h24c19.8 0 36 16.2 36 36 0 13.2 10.8 24 24 24s24-10.8 24-24c.1-46.3-37.6-84-83.9-84zm-236 0c61.9 0 112-50.1 112-112S381.9 32 320 32 208 82.1 208 144s50.1 112 112 112zm0-176c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zM154.8 270.3c-13.4-9-29.5-14.3-46.8-14.3H84c-46.3 0-84 37.7-84 84 0 13.2 10.8 24 24 24s24-10.8 24-24c0-19.8 16.2-36 36-36h24c4.4 0 8.5 1.1 12.3 2.5 9.3-14 21.1-26.1 34.5-36.2z"
  ]
};
export const faUsersClass = {
  prefix: "far",
  iconName: "users-class",
  icon: [
    640,
    512,
    [],
    "f63d",
    "M80 48h480v133.62c17.64 2.56 34.01 8.91 48 18.71V49.59C608 22.25 586.47 0 560 0H80C53.53 0 32 22.25 32 49.59v150.73c13.99-9.8 30.36-16.15 48-18.71V48zm28 356H84c-46.31 0-84 37.69-84 84 0 13.25 10.75 24 24 24s24-10.75 24-24c0-19.84 16.16-36 36-36h24c19.84 0 36 16.16 36 36 0 13.25 10.75 24 24 24s24-10.75 24-24c0-46.31-37.69-84-84-84zm436-192c-44.18 0-80 35.82-80 80s35.82 80 80 80 80-35.82 80-80-35.82-80-80-80zm0 112c-17.64 0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32zm12 80h-24c-46.31 0-84 37.69-84 84 0 13.25 10.75 24 24 24s24-10.75 24-24c0-19.84 16.16-36 36-36h24c19.84 0 36 16.16 36 36 0 13.25 10.75 24 24 24s24-10.75 24-24c0-46.31-37.69-84-84-84zM96 372c44.18 0 80-35.82 80-80s-35.82-80-80-80-80 35.82-80 80 35.82 80 80 80zm0-112c17.64 0 32 14.36 32 32s-14.36 32-32 32-32-14.36-32-32 14.36-32 32-32zm144 32c0 44.18 35.82 80 80 80s80-35.82 80-80-35.82-80-80-80-80 35.82-80 80zm112 0c0 17.64-14.36 32-32 32s-32-14.36-32-32 14.36-32 32-32 32 14.36 32 32zm-20 112h-24c-46.31 0-84 37.69-84 84 0 13.25 10.75 24 24 24s24-10.75 24-24c0-19.84 16.16-36 36-36h24c19.84 0 36 16.16 36 36 0 13.25 10.75 24 24 24s24-10.75 24-24c0-46.31-37.69-84-84-84z"
  ]
};
export const faUsersCog = {
  prefix: "far",
  iconName: "users-cog",
  icon: [
    640,
    512,
    [],
    "f509",
    "M315.3 255.5c6.8-19 16.4-36.5 28.4-52.2-7.4 3-15.4 4.7-23.8 4.7-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64c0 8.4-1.7 16.4-4.7 23.8 15.7-12 33.2-21.7 52.2-28.4C429 79.7 380.3 32 320 32c-61.9 0-112 50.1-112 112 0 60.3 47.7 109 107.3 111.5zM96 224c44.2 0 80-35.8 80-80s-35.8-80-80-80-80 35.8-80 80 35.8 80 80 80zm0-112c17.6 0 32 14.4 32 32s-14.4 32-32 32-32-14.4-32-32 14.4-32 32-32zm244.3 320H176v-44.8c0-36.4 29.2-66.2 65.4-67.2 20.6 8.6 41.9 13.6 63.4 15.2-.7-9.3-2-24 2.3-48.6-16.8-1.5-33.1-4.9-48-11.2-5.1-2.1-10.4-3.4-15.9-3.4-63.6 0-115.2 51.6-115.2 115.2V432c0 26.5 21.5 48 48 48h214c-19.4-12.9-36.2-29.2-49.7-48zM154.8 270.3c-13.4-9-29.5-14.3-46.8-14.3H84c-46.3 0-84 37.7-84 84 0 13.2 10.8 24 24 24s24-10.8 24-24c0-19.8 16.2-36 36-36h24c4.4 0 8.5 1.1 12.3 2.5 9.3-14 21.1-26.1 34.5-36.2zm455.7 71c2.6-14.1 2.6-28.5 0-42.6l25.8-14.9c3-1.7 4.3-5.2 3.3-8.5-6.7-21.6-18.2-41.2-33.2-57.4-2.3-2.5-6-3.1-9-1.4l-25.8 14.9c-10.9-9.3-23.4-16.5-36.9-21.3v-29.8c0-3.4-2.4-6.4-5.7-7.1-22.3-5-45-4.8-66.2 0-3.3.7-5.7 3.7-5.7 7.1v29.8c-13.5 4.8-26 12-36.9 21.3l-25.8-14.9c-2.9-1.7-6.7-1.1-9 1.4-15 16.2-26.5 35.8-33.2 57.4-1 3.3.4 6.8 3.3 8.5l25.8 14.9c-2.6 14.1-2.6 28.5 0 42.6l-25.8 14.9c-3 1.7-4.3 5.2-3.3 8.5 6.7 21.6 18.2 41.1 33.2 57.4 2.3 2.5 6 3.1 9 1.4l25.8-14.9c10.9 9.3 23.4 16.5 36.9 21.3v29.8c0 3.4 2.4 6.4 5.7 7.1 22.3 5 45 4.8 66.2 0 3.3-.7 5.7-3.7 5.7-7.1v-29.8c13.5-4.8 26-12 36.9-21.3l25.8 14.9c2.9 1.7 6.7 1.1 9-1.4 15-16.2 26.5-35.8 33.2-57.4 1-3.3-.4-6.8-3.3-8.5l-25.8-14.9zM496 368.5c-26.8 0-48.5-21.8-48.5-48.5s21.8-48.5 48.5-48.5 48.5 21.8 48.5 48.5-21.7 48.5-48.5 48.5z"
  ]
};
export const faUsersCrown = {
  prefix: "far",
  iconName: "users-crown",
  icon: [
    640,
    512,
    [],
    "f6a5",
    "M556 256h-24c-17.3 0-33.39 5.27-46.77 14.28 13.37 10.14 25.18 22.18 34.43 36.22 3.88-1.44 7.96-2.5 12.34-2.5h24c19.84 0 36 16.16 36 36 0 13.25 10.75 24 24 24s24-10.75 24-24c0-46.31-37.69-84-84-84zm-12-32c44.18 0 80-35.82 80-80s-35.82-80-80-80-80 35.82-80 80 35.82 80 80 80zm0-112c17.64 0 32 14.36 32 32s-14.36 32-32 32-32-14.36-32-32 14.36-32 32-32zM154.77 270.28C141.39 261.27 125.3 256 108 256H84c-46.31 0-84 37.69-84 84 0 13.25 10.75 24 24 24s24-10.75 24-24c0-19.84 16.16-36 36-36h24c4.37 0 8.46 1.06 12.34 2.5 9.25-14.04 21.06-26.08 34.43-36.22zM96 224c44.18 0 80-35.82 80-80s-35.82-80-80-80-80 35.82-80 80 35.82 80 80 80zm0-112c17.64 0 32 14.36 32 32s-14.36 32-32 32-32-14.36-32-32 14.36-32 32-32zm268.66 169.28c-14.16 4.3-29.1 6.72-44.66 6.72s-30.5-2.42-44.66-6.72c-47.08-14.3-100.29.84-127.77 41.66C135.21 341.3 128 363.41 128 387.2V432c0 26.51 21.49 48 48 48h288c26.51 0 48-21.49 48-48v-44.8c0-23.79-7.21-45.9-19.57-64.25-27.48-40.82-80.69-55.97-127.77-41.67zM464 432H176v-44.8c0-36.44 29.16-66.2 65.38-67.18C266.88 330.63 293.32 336 320 336c26.67 0 53.11-5.37 78.62-15.98C434.84 321 464 350.76 464 387.2V432zM320 256c61.86 0 112-50.14 112-112V32l-56 28-56-28-56 28-56-28v112c0 61.86 50.14 112 112 112zm-64-128h128v16c0 35.29-28.71 64-64 64s-64-28.71-64-64v-16z"
  ]
};
export const faUsersMedical = {
  prefix: "far",
  iconName: "users-medical",
  icon: [
    640,
    512,
    [],
    "f830",
    "M512 224a128 128 0 1 0 128 128 128 128 0 0 0-128-128zm64 144a5.33 5.33 0 0 1-5.33 5.33h-37.34v37.34A5.33 5.33 0 0 1 528 416h-32a5.33 5.33 0 0 1-5.33-5.33v-37.34h-37.34A5.33 5.33 0 0 1 448 368v-32a5.33 5.33 0 0 1 5.33-5.33h37.34v-37.34A5.33 5.33 0 0 1 496 288h32a5.33 5.33 0 0 1 5.33 5.33v37.34h37.34A5.33 5.33 0 0 1 576 336zM320 256a112 112 0 1 0-112-112 111.94 111.94 0 0 0 112 112zm0-176a64 64 0 1 1-64 64 64.06 64.06 0 0 1 64-64zM96 224a80 80 0 1 0-80-80 80 80 0 0 0 80 80zm0-112a32 32 0 1 1-32 32 32.09 32.09 0 0 1 32-32zm278.26 320H176v-44.8a67.38 67.38 0 0 1 65.4-67.2 203.8 203.8 0 0 0 78.6 16 198.4 198.4 0 0 0 33.94-3.14 157.56 157.56 0 0 1 16-52.84c-1.76.45-3.56.65-5.3 1.18a152.46 152.46 0 0 1-89.4 0c-47.1-14.3-100.3.8-127.8 41.7a114.59 114.59 0 0 0-19.6 64.3V432a48 48 0 0 0 48 48H417a160.27 160.27 0 0 1-42.74-48zM154.8 270.3A83.7 83.7 0 0 0 108 256H84a84.12 84.12 0 0 0-84 84 24 24 0 0 0 48 0 36.11 36.11 0 0 1 36-36h24a35.48 35.48 0 0 1 12.3 2.5 148.37 148.37 0 0 1 34.5-36.2z"
  ]
};
export const faUsersSlash = {
  prefix: "far",
  iconName: "users-slash",
  icon: [
    640,
    512,
    [],
    "e073",
    "M556.09,256h-24a83.66,83.66,0,0,0-46.79,14.29,146.29,146.29,0,0,1,34.39,36.21A36.21,36.21,0,0,1,532,304h24a36.11,36.11,0,0,1,36,36,24,24,0,0,0,48,0A84,84,0,0,0,556.09,256Zm-236-176A63.78,63.78,0,0,1,358.6,194.79L397.19,225a111.81,111.81,0,0,0-77.1-193c-41.75,0-77.7,23.06-97,56.88l38.21,29.87A64,64,0,0,1,320.09,80Zm224,144a80,80,0,1,0-80-80A80,80,0,0,0,544.09,224Zm0-112a32,32,0,1,1-32,32A32.1,32.1,0,0,1,544.09,112Zm-368,320V387.2A67.38,67.38,0,0,1,241.5,320a206.08,206.08,0,0,0,62.92,15.2l-74.84-58.51C197,279.44,166.26,295,147.5,322.9a114.5,114.5,0,0,0-19.61,64.3V432a48,48,0,0,0,48,48h288a47.59,47.59,0,0,0,20-4.49L428.23,432Zm-21.2-161.71A83.67,83.67,0,0,0,108.09,256h-24a84.12,84.12,0,0,0-84,84,24,24,0,0,0,48,0,36.11,36.11,0,0,1,36-36h24a35.2,35.2,0,0,1,12.3,2.5A148.78,148.78,0,0,1,154.89,270.29ZM96.09,224a79.47,79.47,0,0,0,46.63-15.21L99.81,175.24c-1.28.16-2.4.76-3.72.76-16.19,0-29.15-12.39-31.19-28.06l-43-33.6A79.75,79.75,0,0,0,96.09,224ZM36,3.52A16,16,0,0,0,13.51,6l-10,12.49A16,16,0,0,0,6,41L604,508.48A16,16,0,0,0,626.48,506l10-12.49A16,16,0,0,0,634,471Z"
  ]
};
export const faUtensilFork = {
  prefix: "far",
  iconName: "utensil-fork",
  icon: [
    512,
    512,
    [],
    "f2e3",
    "M457.4 107.3c-6.3-24.8-28.9-46.7-52.7-52.8-10.2-39.8-60-70.8-97.6-45.2C294 18.1 230.8 60.9 207 84.8c-41.3 41.3-51.2 96.4-34.6 145.5L18.2 368.2c-23.5 21-24.3 57.5-1.9 79.9l47.6 47.6c22.6 22.6 59.1 21.4 79.9-1.9l137.9-154.3c51.5 17.4 105.9 5 145.5-34.6 23.8-23.8 66.5-86.9 75.3-100.1 26.4-38.4-6.6-87.7-45.1-97.5zm5.5 70.6s-47.8 71.3-69.7 93.1c-34.3 34.3-82.6 37-123.2 9.5L108 461.9c-2.5 2.9-7.2 2.9-10.2-.1l-47.6-47.6c-2.9-2.9-3-7.6-.1-10.2l181.4-162c-27.2-40.1-25.2-88.5 9.5-123.2 21.9-21.9 93.1-69.7 93.1-69.7 8.5-6 29.6 15.3 23.2 23.6l-90.1 90.1c-7.7 9.2 13.8 31 23.2 23.6l96.4-84.7c8.4-5.9 29.3 15 23.4 23.4l-84.7 96.4c-7.4 9.4 14.4 31 23.6 23.2l90.1-90.1c8.4-6.3 29.8 14.7 23.7 23.3z"
  ]
};
export const faUtensilKnife = {
  prefix: "far",
  iconName: "utensil-knife",
  icon: [
    512,
    512,
    [],
    "f2e4",
    "M463.3 16.6c-22.1-21.1-57-22.7-79-1.7L16.7 365.1c-23.2 22.1-21.9 59.1 1.8 81.7l51 48.6c23.9 22.8 61.4 22.2 82.4-1.9l122.6-140.7c66.4 8.2 128.1-.7 176.4-46.6C492 266.9 512 210.7 512 152.6c0-47.5-14.2-103.1-48.7-136zm-45.6 254.7c-43.7 41.6-103 40.6-162.1 30L115.7 461.9c-2.9 3.4-9.1 2.5-13.1-1.3l-51-48.5c-3.9-3.8-4.8-9.3-1.8-12.2L417.4 49.7c3-2.8 8.8-2.1 12.8 1.7 40.6 38.7 53.7 157-12.5 219.9z"
  ]
};
export const faUtensilSpoon = {
  prefix: "far",
  iconName: "utensil-spoon",
  icon: [
    512,
    512,
    [],
    "f2e5",
    "M474.4 37.5c-64-64-180.7-39.7-245.2 24.8-45 45.1-57.9 98.1-40.5 153.4L18.8 368.2c-24.2 21.7-25.3 59.4-2.2 82.5l44.7 44.7c23.3 23.3 61 21.7 82.5-2.2l152.4-169.9c53.8 16.9 107.1 5.8 153.4-40.5 63.4-63.5 89.7-180.4 24.8-245.3zm-58.7 211.2c-40.3 40.3-82.9 43-132.5 17.1L108 461.1c-3.3 3.7-9.2 4-12.8.3l-44.7-44.7c-3.6-3.6-3.4-9.4.3-12.8L246 228.7c-24.2-46.5-25.3-90.1 17.1-132.5 48.3-48.3 135.1-67 177.3-24.8 44 43.9 21.1 131.5-24.7 177.3z"
  ]
};
export const faUtensils = {
  prefix: "far",
  iconName: "utensils",
  icon: [
    544,
    512,
    [],
    "f2e7",
    "M288 157.5c0-30.5-12.9-97.8-15.6-111.7C267.5 20.1 244.1 0 210.6 0c-11.4 0-23.1 2.4-33.3 7.8C167.3 2.5 155.5 0 144 0c-11.5 0-23.3 2.5-33.3 7.8C100.6 2.4 88.8 0 77.4 0 44.1 0 20.5 19.9 15.6 45.8 12.9 59.6 0 126.9 0 157.5c0 52.7 28.2 94.8 69.8 116.7L59.6 454.9c-1.8 31 23.1 57.1 54.4 57.1h60c31.3 0 56.2-26.1 54.4-57.1l-10.2-180.8c41.4-21.7 69.8-63.8 69.8-116.6zm-119.7 83.6l12.2 216.5c.2 3.4-2.7 6.4-6.5 6.4h-60c-3.7 0-6.7-2.9-6.5-6.4l12.2-216.5C77.3 233 48 201.3 48 157.5c0-27.6 14.8-102.7 14.8-102.7 1.6-9.2 28.3-9 29.5.2v113.7c.9 10.6 28.2 10.8 29.5.2l7.4-114.1c1.6-9 27.9-9 29.5 0l7.4 114.1c1.3 10.6 28.6 10.4 29.5-.2V55c1.2-9.2 27.9-9.4 29.5-.2 0 0 14.8 75.1 14.8 102.7.1 43.6-29 75.4-71.6 83.6zm221.2 69.5l-13.3 142.5c-2.9 31.6 22.7 58.9 55.8 58.9h56c30.9 0 56-24.2 56-54V54c0-29.8-25.1-54-56-54-71.8 0-168 83-168 181.7 0 60.4 35 101.2 69.5 128.9zM368 181.7C368 109.1 443.4 48 488 48c4.3 0 8 2.8 8 6v404c0 3.3-3.7 6-8 6h-56c-4.6 0-8.3-3-8-6.4l15.8-169.5c-39.6-27-71.8-59-71.8-106.4z"
  ]
};
export const faUtensilsAlt = {
  prefix: "far",
  iconName: "utensils-alt",
  icon: [
    576,
    512,
    [],
    "f2e6",
    "M0 74.1c0 114.2 47.3 199 156.1 223L88 356.6c-31.9 28.2-33.4 77.6-3.3 107.7l26.9 26c30.3 30.3 79.6 28.5 107.7-3.3l70.1-79.1c74 87.3 67.1 79.2 68.5 80.7 28.2 30.1 76.4 31.6 106.3 1.7l26-26c29.7-29.7 28.7-78.1-2-106.6l-59.4-55.2c25.5-3.9 50.3-16.2 71.3-37.2 20.7-20.7 58.4-74.8 66.1-85.9 23.5-33.6 1.2-78.9-35.8-91.9-6.4-18.5-22.8-35.3-42-42.1-12.8-36.3-58-59.6-91.9-35.8-11.2 7.8-65.2 45.4-85.9 66.1-23 23-36.3 51.4-38.3 81.4L124.4 19.9C76.9-24.2 0 9.9 0 74.1zm348.3 153.6c-33.6-33.6-40.1-81.6-3.7-118C363.4 90.9 424 49 424 49c7.3-5.3 24.1 11.8 18.6 18.9L365 145.5c-6.7 7.8 10.5 25.3 18.6 18.9l82.6-73.3c7.2-5.1 23.9 11.5 18.7 18.7l-73.3 82.6c-6.4 8.1 11 25.3 18.9 18.6l77.6-77.6c7.1-5.5 24.1 11.3 18.9 18.6 0 0-41.9 60.6-60.7 79.5-35.8 35.8-83.8 30.5-118-3.8zm-138.7 86.1l48.5 57.1-74.6 84.3c-9.9 11.2-27.3 11.7-37.8 1.1l-26-26c-10.6-10.6-10.1-27.9 1.1-37.8l88.8-78.7zM48 74c0-22.6 27-34.5 43.7-19l364 338c10.8 10 11.1 27 .7 37.4l-26 26c-10.4 10.4-27.3 10.1-37.4-.6L223.5 256C93.5 256 48 182.8 48 74z"
  ]
};
export const faVacuum = {
  prefix: "far",
  iconName: "vacuum",
  icon: [
    640,
    512,
    [],
    "e04d",
    "M640,120A120.14,120.14,0,0,0,520,0H309.59C253.38,0,204,39.91,192.28,94.86L130.31,384H96A96,96,0,0,0,0,480v16a16,16,0,0,0,16,16H224a32,32,0,0,0,32-32V416a32,32,0,0,0-32-32H179.41l59.81-279.09A72.35,72.35,0,0,1,309.59,48H520a71.8,71.8,0,0,1,31.79,136.27A191.34,191.34,0,0,0,416,128H384a32,32,0,0,0-32,32V331.19A110.94,110.94,0,0,1,400,320V176h16c79.4,0,144,64.6,144,144V448a16,16,0,0,1-16,16H506.8a111.62,111.62,0,0,1-28.58,48H544a64,64,0,0,0,64-64V320a190.79,190.79,0,0,0-27-97.9C616.1,201.35,640,163.75,640,120ZM208,432v32H50.74A48.1,48.1,0,0,1,96,432Zm192-80a80,80,0,1,0,80,80A80,80,0,0,0,400,352Zm0,96a16,16,0,1,1,16-16A16,16,0,0,1,400,448Z"
  ]
};
export const faVacuumRobot = {
  prefix: "far",
  iconName: "vacuum-robot",
  icon: [
    512,
    512,
    [],
    "e04e",
    "M431.36,80.64a248,248,0,0,0-350.72,0c-96.85,96.85-96.85,253.87,0,350.72a248,248,0,0,0,350.72,0C528.21,334.51,528.21,177.49,431.36,80.64ZM397.42,397.42A200,200,0,1,1,114.58,114.58,200,200,0,1,1,397.42,397.42ZM369,143C306.66,80.75,205.34,80.75,143,143A24,24,0,0,0,177,177,111.77,111.77,0,1,1,335,335,24,24,0,1,0,369,369,159.72,159.72,0,0,0,369,143ZM139.55,304.57a16,16,0,0,0-22.63,22.63l67.88,67.88a16,16,0,0,0,22.63-22.63Zm90.51-90.51a16,16,0,0,0-22.63,22.63l67.88,67.88a16,16,0,0,0,22.63-22.63Zm-67.88,22.63a16,16,0,0,0-22.63,22.62L252.69,372.45a16,16,0,0,0,22.62-22.63Z"
  ]
};
export const faValueAbsolute = {
  prefix: "far",
  iconName: "value-absolute",
  icon: [
    448,
    512,
    [],
    "f6a6",
    "M32 32H16C7.16 32 0 39.16 0 48v416c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V48c0-8.84-7.16-16-16-16zm315.31 112L336 132.69c-6.25-6.25-16.38-6.25-22.63 0L224 222.06l-89.38-89.38c-6.25-6.25-16.38-6.25-22.63 0L100.69 144c-6.25 6.25-6.25 16.38 0 22.63L190.06 256l-89.38 89.38c-6.25 6.25-6.25 16.38 0 22.63l11.32 11.3c6.25 6.25 16.38 6.25 22.63 0L224 289.94l89.38 89.38c6.25 6.25 16.38 6.25 22.63 0l11.3-11.32c6.25-6.25 6.25-16.38 0-22.63L257.94 256l89.38-89.38c6.24-6.24 6.24-16.38-.01-22.62zM432 32h-16c-8.84 0-16 7.16-16 16v416c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V48c0-8.84-7.16-16-16-16z"
  ]
};
export const faVectorSquare = {
  prefix: "far",
  iconName: "vector-square",
  icon: [
    512,
    512,
    [],
    "f5cb",
    "M480 160c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32h-96c-17.67 0-32 14.33-32 32v16H160V32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v96c0 17.67 14.33 32 32 32h16v192H32c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-16h192v16c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32h-16V160h16zM400 48h64v64h-64V48zM48 48h64v64H48V48zm64 416H48v-64h64v64zm352 0h-64v-64h64v64zm-48-112h-32c-17.67 0-32 14.33-32 32v32H160v-32c0-17.67-14.33-32-32-32H96V160h32c17.67 0 32-14.33 32-32V96h192v32c0 17.67 14.33 32 32 32h32v192z"
  ]
};
export const faVenus = {
  prefix: "far",
  iconName: "venus",
  icon: [
    288,
    512,
    [],
    "f221",
    "M288 176c0-79.5-64.5-144-144-144S0 96.5 0 176c0 71.4 51.9 130.6 120 142v58H76c-6.6 0-12 5.4-12 12v24c0 6.6 5.4 12 12 12h44v44c0 6.6 5.4 12 12 12h24c6.6 0 12-5.4 12-12v-44h44c6.6 0 12-5.4 12-12v-24c0-6.6-5.4-12-12-12h-44v-58c68.1-11.4 120-70.6 120-142zm-240 0c0-52.9 43.1-96 96-96s96 43.1 96 96-43.1 96-96 96-96-43.1-96-96z"
  ]
};
export const faVenusDouble = {
  prefix: "far",
  iconName: "venus-double",
  icon: [
    512,
    512,
    [],
    "f226",
    "M288 176c0-79.5-64.5-144-144-144S0 96.5 0 176c0 71.4 51.9 130.6 120 142v58H76c-6.6 0-12 5.4-12 12v24c0 6.6 5.4 12 12 12h44v44c0 6.6 5.4 12 12 12h24c6.6 0 12-5.4 12-12v-44h44c6.6 0 12-5.4 12-12v-24c0-6.6-5.4-12-12-12h-44v-58c68.1-11.4 120-70.6 120-142zm-240 0c0-52.9 43.1-96 96-96s96 43.1 96 96-43.1 96-96 96-96-43.1-96-96zm344 142v58h44c6.6 0 12 5.4 12 12v24c0 6.6-5.4 12-12 12h-44v44c0 6.6-5.4 12-12 12h-24c-6.6 0-12-5.4-12-12v-44h-44c-6.6 0-12-5.4-12-12v-24c0-6.6 5.4-12 12-12h44v-58c-24.3-4.1-46.6-14.3-65.2-28.9 10.4-12.4 19.1-26.1 25.8-41 16.9 14.9 39.1 24 63.4 24 52.9 0 96-43.1 96-96s-43.1-96-96-96c-24.3 0-46.5 9.1-63.4 24-6.7-14.9-15.4-28.7-25.8-41C303.4 43.6 334.3 32 368 32c79.5 0 144 64.5 144 144 0 71.4-51.9 130.6-120 142z"
  ]
};
export const faVenusMars = {
  prefix: "far",
  iconName: "venus-mars",
  icon: [
    576,
    512,
    [],
    "f228",
    "M288 208c0-79.5-64.5-144-144-144S0 128.5 0 208c0 71.4 51.9 130.6 120 142v58H76c-6.6 0-12 5.4-12 12v24c0 6.6 5.4 12 12 12h44v44c0 6.6 5.4 12 12 12h24c6.6 0 12-5.4 12-12v-44h44c6.6 0 12-5.4 12-12v-24c0-6.6-5.4-12-12-12h-44v-58c68.1-11.4 120-70.6 120-142zm-240 0c0-52.9 43.1-96 96-96s96 43.1 96 96-43.1 96-96 96-96-43.1-96-96zM576 12v63c0 10.7-12.9 16-20.5 8.5L541 69l-55.6 55.6c16.8 23.5 26.6 52.3 26.6 83.4 0 79.5-64.5 144-144 144-33.7 0-64.6-11.6-89.2-30.9 10.4-12.4 19.1-26.1 25.8-41 16.9 14.9 39.1 24 63.4 24 52.9 0 96-43.1 96-96s-43.1-96-96-96c-24.3 0-46.5 9.1-63.4 24-6.7-14.9-15.4-28.7-25.8-41C303.4 75.6 334.3 64 368 64c31.1 0 59.9 9.9 83.4 26.6L507 35l-14.5-14.5C484.9 12.9 490.3 0 501 0h63c6.6 0 12 5.4 12 12z"
  ]
};
export const faVest = {
  prefix: "far",
  iconName: "vest",
  icon: [
    448,
    512,
    [],
    "e085",
    "M433.219,226.562,384,152.734V56A56.068,56.068,0,0,0,328,0h-8a23.924,23.924,0,0,0-13.289,4.066l-.023-.035-25,16.672a103.794,103.794,0,0,1-115.376,0l-25-16.672-.023.035A23.924,23.924,0,0,0,128,0h-8A56.068,56.068,0,0,0,64,56v96.734L14.781,226.562A87.638,87.638,0,0,0,0,275.375V456a56.068,56.068,0,0,0,56,56H392a56.068,56.068,0,0,0,56-56V275.375A87.638,87.638,0,0,0,433.219,226.562ZM194.094,246.188A24.06,24.06,0,0,0,192,256V464H56a8.016,8.016,0,0,1-8-8V275.375a39.907,39.907,0,0,1,6.719-22.187l53.25-79.876A24.021,24.021,0,0,0,112,160V56a7.992,7.992,0,0,1,1.781-5.031L197.7,238.154ZM400,456a8.016,8.016,0,0,1-8,8H240V261.141L334.219,50.969A7.992,7.992,0,0,1,336,56V160a24.021,24.021,0,0,0,4.031,13.312l53.25,79.876A39.907,39.907,0,0,1,400,275.375ZM76.688,419.312a15.992,15.992,0,0,0,22.624,0l48-48a16,16,0,0,0-22.624-22.624l-48,48A15.993,15.993,0,0,0,76.688,419.312Zm246.624-70.624a16,16,0,0,0-22.624,22.624l48,48a16,16,0,0,0,22.624-22.624Z"
  ]
};
export const faVestPatches = {
  prefix: "far",
  iconName: "vest-patches",
  icon: [
    448,
    512,
    [],
    "e086",
    "M433.219,226.562,384,152.734V56A56.068,56.068,0,0,0,328,0h-8a23.924,23.924,0,0,0-13.289,4.066l-.023-.035-25,16.672a103.794,103.794,0,0,1-115.376,0l-25-16.672-.023.035A23.924,23.924,0,0,0,128,0h-8A56.068,56.068,0,0,0,64,56v96.734L14.781,226.562A87.638,87.638,0,0,0,0,275.375V456a56.068,56.068,0,0,0,56,56H392a56.068,56.068,0,0,0,56-56V275.375A87.638,87.638,0,0,0,433.219,226.562ZM194.094,246.188A24.06,24.06,0,0,0,192,256V464H56a8.016,8.016,0,0,1-8-8V275.375a39.907,39.907,0,0,1,6.719-22.187l53.25-79.876A24.021,24.021,0,0,0,112,160V56a7.992,7.992,0,0,1,1.781-5.031L197.7,238.154ZM400,456a8.016,8.016,0,0,1-8,8H240V261.141L334.219,50.969A7.992,7.992,0,0,1,336,56V160a24.021,24.021,0,0,0,4.031,13.312l53.25,79.876A39.907,39.907,0,0,1,400,275.375ZM342.5,302.541l-5.051.037.037-5.057c.073-12.8-9.267-24.257-22.056-25.419a24.987,24.987,0,0,0-27.215,24.621L288,345.3a6.671,6.671,0,0,0,6.7,6.7l48.53-.215A24.948,24.948,0,0,0,367.9,324.617C366.736,311.816,355.326,302.506,342.5,302.541ZM112,360a40,40,0,1,0,40,40A40,40,0,0,0,112,360ZM95.5,255.516a12.052,12.052,0,0,0,0,16.968L111.016,288,95.5,303.516a12.01,12.01,0,0,0,17,16.968l15.5-15.5,15.5,15.5a12.01,12.01,0,0,0,17-16.968L144.984,288,160.5,272.484a12.01,12.01,0,0,0-17-16.968l-15.5,15.5-15.5-15.5A12.032,12.032,0,0,0,95.5,255.516Z"
  ]
};
export const faVhs = {
  prefix: "far",
  iconName: "vhs",
  icon: [
    512,
    512,
    [],
    "f8ec",
    "M464 400H48V192H0v208a48 48 0 0 0 48 48h416a48 48 0 0 0 48-48V192h-48zm32-336H16A16 16 0 0 0 0 80v80h512V80a16 16 0 0 0-16-16zM344 368a88 88 0 0 0 0-176H168a88 88 0 0 0 0 176zm8-120a32 32 0 0 1 0 64zm-144-8h96v80h-96zm-48 72a32 32 0 0 1 0-64z"
  ]
};
export const faVial = {
  prefix: "far",
  iconName: "vial",
  icon: [
    480,
    512,
    [],
    "f492",
    "M477.7 186.1L309.9 18.3c-1.6-1.6-3.6-2.3-5.7-2.3-2 0-4.1.8-5.7 2.3l-22.3 22.3c-3.1 3.1-3.1 8.2 0 11.3L287.5 63 30.1 320.4c-40.1 40.1-40.1 105.4 0 145.5 40.1 40 105.3 40.1 145.5 0L433 208.5l11.1 11.1c1.6 1.6 3.6 2.3 5.7 2.3s4.1-.8 5.7-2.3l22.3-22.3c3-3 3-8.1-.1-11.2zM141.6 432c-21.3 21.3-56.1 21.5-77.6 0-21.4-21.4-21.4-56.2 0-77.6l50.4-50.4h155.2l-128 128zm176-176H162.4L321 97.4l77.6 77.6-81 81z"
  ]
};
export const faVials = {
  prefix: "far",
  iconName: "vials",
  icon: [
    640,
    512,
    [],
    "f493",
    "M72 48h24v288c0 44.1 35.9 80 80 80s80-35.9 80-80V48h24c4.4 0 8-3.6 8-8V8c0-4.4-3.6-8-8-8H72c-4.4 0-8 3.6-8 8v32c0 4.4 3.6 8 8 8zm72 0h64v112h-64V48zm0 160h64v128c0 42.3-64 42.3-64 0V208zm488 256H8c-4.4 0-8 3.6-8 8v32c0 4.4 3.6 8 8 8h624c4.4 0 8-3.6 8-8v-32c0-4.4-3.6-8-8-8zM360 48h24v288c0 44.1 35.9 80 80 80s80-35.9 80-80V48h24c4.4 0 8-3.6 8-8V8c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v32c0 4.4 3.6 8 8 8zm72 0h64v112h-64V48zm0 160h64v128c0 42.3-64 42.3-64 0V208z"
  ]
};
export const faVideo = {
  prefix: "far",
  iconName: "video",
  icon: [
    576,
    512,
    [],
    "f03d",
    "M543.9 96c-6.2 0-12.5 1.8-18.2 5.7L416 170.1v-58.3c0-26.4-23.2-47.8-51.8-47.8H51.8C23.2 64 0 85.4 0 111.8v288.4C0 426.6 23.2 448 51.8 448h312.4c28.6 0 51.8-21.4 51.8-47.8v-58.3l109.7 68.3c5.7 4 12.1 5.7 18.2 5.7 16.6 0 32.1-13 32.1-31.5V127.5C576 109 560.5 96 543.9 96zM368 200v198.9c-.6.4-1.8 1.1-3.8 1.1H51.8c-2 0-3.2-.6-3.8-1.1V113.1c.6-.4 1.8-1.1 3.8-1.1h312.4c2 0 3.2.6 3.8 1.1V200zm160 155.2l-112-69.8v-58.7l112-69.8v198.3z"
  ]
};
export const faVideoPlus = {
  prefix: "far",
  iconName: "video-plus",
  icon: [
    576,
    512,
    [],
    "f4e1",
    "M543.9 96c-6.2 0-12.5 1.8-18.2 5.7L416 170.1v-58.3c0-26.4-23.2-47.8-51.8-47.8H51.8C23.2 64 0 85.4 0 111.8v288.4C0 426.6 23.2 448 51.8 448h312.4c28.6 0 51.8-21.4 51.8-47.8v-58.3l109.7 68.3c5.7 4 12.1 5.7 18.2 5.7 16.6 0 32.1-13 32.1-31.5V127.5C576 109 560.5 96 543.9 96zM368 398.9c-.6.4-1.8 1.1-3.8 1.1H51.8c-2 0-3.2-.6-3.8-1.1V113.1c.6-.4 1.8-1.1 3.8-1.1h312.4c2 0 3.2.6 3.8 1.1v285.8zm160-43.7l-112-69.8v-58.7l112-69.8v198.3zM288 232h-56v-56c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16v56h-56c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h56v56c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-56h56c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16z"
  ]
};
export const faVideoSlash = {
  prefix: "far",
  iconName: "video-slash",
  icon: [
    640,
    512,
    [],
    "f4e2",
    "M396.2 112c2 0 3.2.6 3.8 1.1v114.1l48 37.5v-38l112-69.8v195.4l47 36.8c.2-1.6 1-2.9 1-4.6v-257C608 109 592.5 96 575.9 96c-6.2 0-12.5 1.8-18.2 5.7L448 170.1v-58.3c0-26.4-23.2-47.8-51.8-47.8H191.3l61.4 48h143.5zM634 471L479.5 350.2 400 288.1 115.6 65.7l-2.2-1.7L36 3.5C29.1-2 19-.9 13.5 6l-10 12.5C-2 25.4-.9 35.5 6 41l44.3 34.6 39 30.5L604 508.5c6.9 5.5 17 4.4 22.5-2.5l10-12.5c5.5-6.9 4.4-17-2.5-22.5zM83.8 400c-2 0-3.2-.6-3.8-1.1V159.8l-48-37.5v277.9c0 26.4 23.2 47.8 51.8 47.8h312.4c13.8 0 26.3-5.1 35.6-13.2L387.3 400H83.8z"
  ]
};
export const faVihara = {
  prefix: "far",
  iconName: "vihara",
  icon: [
    640,
    512,
    [],
    "f6a7",
    "M632.88 384.94L544 320v-32l55.16-23.59c11.79-7.86 11.79-30.3 0-38.16L480 160v-32l27.31-16.3c7.72-7.72 5.61-20.74-4.16-25.62L320 0 136.85 86.07c-9.77 4.88-11.88 17.9-4.16 25.62L160 128v32L40.84 226.25c-11.79 7.86-11.79 30.3 0 38.16L96 288v32L7.12 384.94c-10.22 9.09-9.27 29.51 1.72 36.83L64 448v48c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-48h184v48c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-48h184v48c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-48l55.15-26.23c10.99-7.32 11.95-27.74 1.73-36.83zM320 53.04L377.39 80H262.62L320 53.04zM208 128h224v32H208v-32zm-35.55 80h295.11l57.55 32H114.89l57.56-32zM144 288h352v32H144v-32zm-32.33 80h416.66L576 400H64l47.67-32z"
  ]
};
export const faViolin = {
  prefix: "far",
  iconName: "violin",
  icon: [
    640,
    512,
    [],
    "f8ed",
    "M481.14 192.8L635.31 38.62a16 16 0 0 0 0-22.62L624 4.69a16 16 0 0 0-22.62 0l-154.2 154.19c-15.44-12.84-33.06-23-52.59-27.53-18.76-4.37-64-10-98 24-3.68 3.69-6.5 7.9-9.4 12.05 6.65 48.81-40.82 85.5-85.95 68.2-15.23 5.15-29.31 13.11-41 24.86-42.52 42.4-41.86 113.62-3.24 171.24l-21.87 14.59a16 16 0 0 0-2.44 24.62l36.4 36.4a16 16 0 0 0 24.62-2.44l14.46-21.69c28.23 18.92 59.72 28.74 89.51 28.74 31 0 60.18-10.53 81.8-32.16 11.75-11.68 19.71-25.77 24.87-41-17.17-45 19.28-92.33 68-85.87 4.21-2.94 8.48-5.8 12.23-9.54 24.94-25 32.43-61.48 24-97.91-4.49-19.56-14.58-37.19-27.44-52.64zm-26.21 111.58c-61.44 4.94-113.41 62.7-101.22 130.69-5 8.85-20.61 28.85-56 28.85-21.29 0-43.21-7.47-62.86-20.71l4.79-7.18a16 16 0 0 0-2-20.19l-13.45-13.45a16 16 0 0 0-20.19-2l-7.2 4.8c-13.3-19.7-20.79-41.67-20.77-63 0-26.13 11.64-46.1 28.84-55.91 68.45 12.32 126-39.66 130.83-101.37 10.07-7.25 21.8-8.92 30.45-8.92a78 78 0 0 1 17.59 2.1c11.06 2.57 21 8.55 29.29 15l-88.31 88.32a16 16 0 0 0 0 22.62L336 315.31a16 16 0 0 0 22.62 0L447 227c6.4 8.33 12.34 18.21 14.89 29.23 4.33 18.92 1.76 36.1-6.96 48.15zM347.31 16L336 4.69a16 16 0 0 0-22.62 0L4.69 313.38a16 16 0 0 0 0 22.62L16 347.31a16 16 0 0 0 22.62 0L347.31 38.62a16 16 0 0 0 0-22.62zM520 48a24 24 0 1 0-24-24 24 24 0 0 0 24 24zm-48 48a24 24 0 1 0-24-24 24 24 0 0 0 24 24zm144 0a24 24 0 1 0 24 24 24 24 0 0 0-24-24zm-48 48a24 24 0 1 0 24 24 24 24 0 0 0-24-24z"
  ]
};
export const faVirus = {
  prefix: "far",
  iconName: "virus",
  icon: [
    512,
    512,
    [],
    "e074",
    "M224,176a48,48,0,1,0,48,48A48,48,0,0,0,224,176Zm80,104a24,24,0,1,0,24,24A24,24,0,0,0,304,280Zm179.55-52.45H462c-50.68,0-76.07-61.27-40.23-97.11L437,115.19A28.44,28.44,0,0,0,396.8,75L381.56,90.22A55.74,55.74,0,0,1,341.74,107c-29.24,0-57.29-22.7-57.29-57V28.44a28.45,28.45,0,0,0-56.9,0V50c0,34.29-28.05,57-57.29,57a55.7,55.7,0,0,1-39.82-16.77L115.2,75A28.44,28.44,0,0,0,75,115.19l15.25,15.25c35.84,35.84,10.45,97.11-40.23,97.11H28.45a28.45,28.45,0,1,0,0,56.89H50c50.68,0,76.07,61.28,40.23,97.12L75,396.8A28.45,28.45,0,0,0,115.2,437l15.24-15.25A55.7,55.7,0,0,1,170.25,405c29.25,0,57.3,22.7,57.3,57v21.54a28.45,28.45,0,0,0,56.9,0V462c0-34.29,28.05-57,57.3-57a55.7,55.7,0,0,1,39.81,16.77L396.8,437A28.45,28.45,0,0,0,437,396.8l-15.25-15.24c-35.84-35.84-10.45-97.12,40.23-97.12h21.54a28.45,28.45,0,1,0,0-56.89ZM365.1,301.19a104.81,104.81,0,0,0-6.65,57.16,104.13,104.13,0,0,0-16.7-1.34A105.35,105.35,0,0,0,256,401.12,105.35,105.35,0,0,0,170.25,357a104.13,104.13,0,0,0-16.7,1.34A105.26,105.26,0,0,0,111.09,256a105.29,105.29,0,0,0,42.46-102.36A103,103,0,0,0,170.26,155,105.34,105.34,0,0,0,256,110.88,105.34,105.34,0,0,0,341.74,155a103,103,0,0,0,16.71-1.35A105.29,105.29,0,0,0,400.91,256,104.69,104.69,0,0,0,365.1,301.19Z"
  ]
};
export const faVirusSlash = {
  prefix: "far",
  iconName: "virus-slash",
  icon: [
    640,
    512,
    [],
    "e075",
    "M320,110.88A105.34,105.34,0,0,0,405.74,155a103,103,0,0,0,16.71-1.35A105.29,105.29,0,0,0,464.91,256a105.15,105.15,0,0,0-13.27,11.53l38.47,30.07A55.22,55.22,0,0,1,526,284.44h21.55a28.45,28.45,0,0,0,0-56.89H526c-50.68,0-76.07-61.27-40.23-97.11L501,115.19A28.44,28.44,0,1,0,460.81,75L445.56,90.22A55.74,55.74,0,0,1,405.74,107c-29.24,0-57.29-22.7-57.29-57V28.44a28.45,28.45,0,0,0-56.89,0V50c0,30.06-21.56,51.21-46.58,56L288,139.63C300.49,132.17,311.58,122.63,320,110.88Zm0,290.24A105.33,105.33,0,0,0,234.25,357a103.92,103.92,0,0,0-16.69,1.35A105.3,105.3,0,0,0,175.09,256a105.23,105.23,0,0,0,13.27-11.54l-38.47-30.07A55.17,55.17,0,0,1,114,227.55H92.45a28.45,28.45,0,1,0,0,56.89H114c50.68,0,76.07,61.28,40.23,97.12L139,396.8A28.44,28.44,0,1,0,179.2,437l15.24-15.24A55.71,55.71,0,0,1,234.25,405c29.25,0,57.31,22.71,57.31,57v21.55a28.45,28.45,0,0,0,56.89,0V462c0-30.05,21.55-51.2,46.57-56L352,372.37C339.51,379.83,328.42,389.37,320,401.12ZM634,471,36,3.52A16,16,0,0,0,13.51,6l-10,12.49A16,16,0,0,0,6,41L604,508.48A16,16,0,0,0,626.48,506l10-12.49A16,16,0,0,0,634,471Z"
  ]
};
export const faViruses = {
  prefix: "far",
  iconName: "viruses",
  icon: [
    640,
    512,
    [],
    "e076",
    "M224,192a16,16,0,1,0,16,16A16,16,0,0,0,224,192Zm-48-40a24,24,0,1,0,24,24A24,24,0,0,0,176,152ZM624,352H611.88c-28.51,0-42.79-34.47-22.63-54.63l8.58-8.57a16,16,0,1,0-22.63-22.63l-8.57,8.58a31.34,31.34,0,0,1-22.4,9.43c-16.45,0-32.23-12.77-32.23-32.06V240a16,16,0,0,0-32,0v12.12c0,19.29-15.78,32.06-32.23,32.06a31.34,31.34,0,0,1-22.4-9.43l-8.57-8.58a16,16,0,0,0-22.63,22.63l8.58,8.57c20.16,20.16,5.88,54.63-22.63,54.63H368a16,16,0,0,0,0,32h12.12c28.51,0,42.79,34.47,22.63,54.63l-8.58,8.57a16,16,0,1,0,22.63,22.63l8.57-8.58a31.34,31.34,0,0,1,22.4-9.43c16.45,0,32.23,12.77,32.23,32.06V496a16,16,0,0,0,32,0V483.88c0-19.29,15.78-32.06,32.23-32.06a31.32,31.32,0,0,1,22.4,9.43l8.57,8.58a16,16,0,1,0,22.63-22.63l-8.58-8.57C569.09,418.47,583.37,384,611.88,384H624a16,16,0,0,0,0-32ZM464,392a24,24,0,1,1,24-24A24,24,0,0,1,464,392ZM346.51,213.33h16.16a21.33,21.33,0,0,0,0-42.66H346.51c-38,0-57.05-46-30.17-72.84L327.77,86.4A21.33,21.33,0,1,0,297.6,56.23L286.17,67.66a41.75,41.75,0,0,1-29.86,12.59c-21.94,0-43-17-43-42.76V21.33a21.33,21.33,0,0,0-42.66,0V37.49c0,25.72-21,42.76-43,42.76A41.75,41.75,0,0,1,97.83,67.66L86.4,56.23A21.33,21.33,0,0,0,56.23,86.4L67.66,97.83c26.88,26.88,7.85,72.84-30.17,72.84H21.33a21.33,21.33,0,0,0,0,42.66H37.49c38,0,57.05,46,30.17,72.84L56.23,297.6A21.33,21.33,0,1,0,86.4,327.77l11.43-11.43a41.75,41.75,0,0,1,29.86-12.59c21.94,0,43,17,43,42.76v16.16a21.33,21.33,0,0,0,42.66,0V346.51c0-25.72,21-42.76,43-42.76a41.75,41.75,0,0,1,29.86,12.59l11.43,11.43a21.33,21.33,0,0,0,30.17-30.17l-11.43-11.43C289.46,259.29,308.49,213.33,346.51,213.33Zm-83.77,8a91,91,0,0,0-7,34.46A90.75,90.75,0,0,0,192,282.38a90.75,90.75,0,0,0-63.79-26.62A91.28,91.28,0,0,0,101.78,192a91.28,91.28,0,0,0,26.43-63.76A90.75,90.75,0,0,0,192,101.62a90.75,90.75,0,0,0,63.79,26.62A91.28,91.28,0,0,0,282.22,192,90.82,90.82,0,0,0,262.74,221.3Z"
  ]
};
export const faVoicemail = {
  prefix: "far",
  iconName: "voicemail",
  icon: [
    640,
    512,
    [],
    "f897",
    "M496 128a144 144 0 0 0-144 144c0 37.05 14.38 70.48 37.37 96H250.63c23-25.52 37.37-58.95 37.37-96a144 144 0 1 0-144 144h352a144 144 0 0 0 0-288zM48 272a96 96 0 1 1 96 96 96.11 96.11 0 0 1-96-96zm448 96a96 96 0 1 1 96-96 96.11 96.11 0 0 1-96 96z"
  ]
};
export const faVolcano = {
  prefix: "far",
  iconName: "volcano",
  icon: [
    512,
    512,
    [],
    "f770",
    "M500.9 426.5L341.6 228.3c-10.1-12.9-25.3-20.3-41.8-20.3H212c-16.4 0-31.6 7.4-41.6 20.1L10.7 427.2c-12.2 16.2-14.1 37.4-5.1 55.5S32.8 512 53 512h406c20.2 0 38.4-11.2 47.4-29.3s7.1-39.4-5.5-56.2zM208.2 257.9c.9-1.2 2.4-1.9 3.9-1.9h87.8c1.5 0 3 .7 4.1 2.2l49.4 61.5-28.9 35.6c-3.6 4.2-8.1 4.8-10.5 4.8-2.4 0-6.9-.6-10.5-4.8l-28.6-33.4c-12-14-29.7-20.9-47.9-21.6-18.4.3-35.7 8.8-47.2 23.2-3.6 4.5-8.3 5.2-10.8 5.2s-7.2-.7-9.2-2.9l-2.7-4.3 51.1-63.6zM459 464H53.1c-2.1 0-3.6-.9-4.5-2.8-.9-1.8-.8-3.6 0-4.7l78.2-97.3c25.2 23.1 68.6 21.4 90.5-5.8 3.5-4.4 8.1-5.1 10.5-5.2 3-.4 7 .6 10.7 4.8l28.6 33.4C278.9 400.2 296 408 314 408c18.1 0 35.2-7.8 47.3-22.1l22.8-28.1L463 456c1.3 1.7 1.4 3.4.5 5.3-1 1.8-2.5 2.7-4.5 2.7zM160 144c12.9 0 24.8-3.9 34.8-10.4L224 176h64l29.2-42.4c10 6.5 21.9 10.4 34.8 10.4 35.3 0 64-28.7 64-64s-28.7-64-64-64c-15.8 0-30 5.9-41.2 15.4C299.6 12.7 279.4 0 256 0s-43.6 12.7-54.8 31.4C190.1 21.9 175.8 16 160 16c-35.3 0-64 28.7-64 64s28.7 64 64 64z"
  ]
};
export const faVolleyballBall = {
  prefix: "far",
  iconName: "volleyball-ball",
  icon: [
    496,
    512,
    [],
    "f45f",
    "M248 8C111.2 8 0 119.2 0 256s111.2 248 248 248 248-111.2 248-248S384.8 8 248 8zm146.6 383.6c-75.3 12.7-152.6-4.5-215.7-47.8 19.8-23.6 43.5-43.9 70.3-60.3 95 51.4 177.4 40.1 187.1 39.3-9.2 25.8-23.5 49.1-41.7 68.8zm52.5-118.1c-18.9 2.6-37.9 3.5-56.8 2.3 5.6-68.4-10.3-136.3-45-194.4 28.8 16.2 111.9 76.6 101.8 192.1zM291.9 61c48.8 58.9 72.6 134.6 66.7 211-30.2-5.3-59.6-15.6-87.1-30.5-1.8-65.7-22.6-128.5-59.9-182 12-2.2 41.1-7.3 80.3 1.5zM163.7 74.9C175.4 90 185.6 106 194 122.8c-62 29.3-112.9 77-145.9 136.2-1.3-87.3 52-154.4 115.6-184.1zM57.1 315.7c26.6-71.8 80.2-130.4 149.4-163.5 10.5 28.8 16.3 59.4 17.1 90.7-56 34.4-100 83.8-127.6 142.8-17.3-20.3-30.7-44-38.9-70zm76.2 103.9c7.1-17.6 15.9-34.2 26.1-49.9 33.7 23.3 98.9 59.2 190.8 57.9-30 17.9-64.8 28.4-102.2 28.4-42.7 0-82.2-13.6-114.7-36.4z"
  ]
};
export const faVolume = {
  prefix: "far",
  iconName: "volume",
  icon: [
    480,
    512,
    [],
    "f6a8",
    "M394.23 100.85c-11.19-7.09-26.03-3.8-33.12 7.41s-3.78 26.03 7.41 33.12C408.27 166.6 432 209.44 432 256s-23.73 89.41-63.48 114.62c-11.19 7.09-14.5 21.92-7.41 33.12 6.51 10.28 21.12 15.03 33.12 7.41C447.94 377.09 480 319.09 480 256s-32.06-121.09-85.77-155.15zm-56 78.28c-11.58-6.33-26.19-2.16-32.61 9.45-6.39 11.61-2.16 26.2 9.45 32.61C327.98 228.28 336 241.63 336 256c0 14.37-8.02 27.72-20.92 34.81-11.61 6.41-15.84 21-9.45 32.61 6.43 11.66 21.05 15.8 32.61 9.45 28.23-15.55 45.77-45 45.77-76.87s-17.54-61.33-45.78-76.87zM231.81 64c-5.91 0-11.92 2.18-16.78 7.05L126.06 160H24c-13.26 0-24 10.74-24 24v144c0 13.25 10.74 24 24 24h102.06l88.97 88.95c4.87 4.87 10.88 7.05 16.78 7.05 12.33 0 24.19-9.52 24.19-24.02V88.02C256 73.51 244.13 64 231.81 64zM208 366.05L145.94 304H48v-96h97.94L208 145.95v220.1z"
  ]
};
export const faVolumeDown = {
  prefix: "far",
  iconName: "volume-down",
  icon: [
    384,
    512,
    [],
    "f027",
    "M338.23 179.13c-11.58-6.33-26.19-2.16-32.61 9.45-6.39 11.61-2.16 26.2 9.45 32.61C327.98 228.28 336 241.63 336 256s-8.02 27.72-20.92 34.81c-11.61 6.41-15.84 21-9.45 32.61 6.43 11.66 21.05 15.8 32.61 9.45 28.23-15.55 45.77-45 45.77-76.87s-17.54-61.33-45.78-76.87zM231.81 64c-5.91 0-11.92 2.18-16.78 7.05L126.06 160H24c-13.26 0-24 10.74-24 24v144c0 13.25 10.74 24 24 24h102.06l88.97 88.95c4.87 4.87 10.88 7.05 16.78 7.05 12.33 0 24.19-9.52 24.19-24.02V88.02C256 73.51 244.13 64 231.81 64zM208 366.05L145.94 304H48v-96h97.94L208 145.95v220.1z"
  ]
};
export const faVolumeMute = {
  prefix: "far",
  iconName: "volume-mute",
  icon: [
    512,
    512,
    [],
    "f6a9",
    "M231.81 64c-5.91 0-11.92 2.18-16.78 7.05L126.06 160H24c-13.26 0-24 10.74-24 24v144c0 13.25 10.74 24 24 24h102.06l88.97 88.95c4.87 4.87 10.88 7.05 16.78 7.05 12.33 0 24.19-9.52 24.19-24.02V88.02C256 73.51 244.13 64 231.81 64zM208 366.05l-48-47.99L145.94 304H48v-96h97.94L160 193.94l48-47.99v220.1zM465.94 256l41.37-41.37c6.25-6.25 6.25-16.38 0-22.63L496 180.69c-6.25-6.25-16.38-6.25-22.63 0L432 222.06l-41.37-41.37c-6.25-6.25-16.38-6.25-22.63 0L356.69 192c-6.25 6.25-6.25 16.38 0 22.63L398.06 256l-41.37 41.37c-6.25 6.25-6.25 16.38 0 22.63L368 331.32c6.25 6.25 16.38 6.25 22.63 0L432 289.94l41.37 41.37c6.25 6.25 16.38 6.25 22.63 0L507.31 320c6.25-6.25 6.25-16.38 0-22.63L465.94 256z"
  ]
};
export const faVolumeOff = {
  prefix: "far",
  iconName: "volume-off",
  icon: [
    256,
    512,
    [],
    "f026",
    "M231.81 64c-5.91 0-11.92 2.18-16.78 7.05L126.06 160H24c-13.26 0-24 10.74-24 24v144c0 13.25 10.74 24 24 24h102.06l88.97 88.95c4.87 4.87 10.88 7.05 16.78 7.05 12.33 0 24.19-9.52 24.19-24.02V88.02C256 73.51 244.13 64 231.81 64zM208 366.05L145.94 304H48v-96h97.94L208 145.95v220.1z"
  ]
};
export const faVolumeSlash = {
  prefix: "far",
  iconName: "volume-slash",
  icon: [
    640,
    512,
    [],
    "f2e2",
    "M633.99 471.02L36 3.51C29.1-2.01 19.03-.9 13.51 6l-10 12.49C-2.02 25.39-.9 35.46 6 40.98l598 467.51c6.9 5.52 16.96 4.4 22.49-2.49l10-12.49c5.52-6.9 4.41-16.97-2.5-22.49zM370.23 179.13c-9.14-5-20.01-3.25-27.41 3.33l70.67 55.25c-5.31-24.49-20.57-46.09-43.26-58.58zm30.29-37.75C440.27 166.6 464 209.44 464 256c0 6.75-.64 13.38-1.61 19.93l41.66 32.57c5.03-16.82 7.95-34.39 7.95-52.5 0-63.09-32.06-121.09-85.77-155.16-11.19-7.09-26.03-3.8-33.12 7.41-7.09 11.21-3.78 26.03 7.41 33.13zm53.27-80.96c66.27 43.49 105.82 116.6 105.82 195.58 0 29.13-5.46 57.42-15.57 83.76l39.23 30.67C599.07 334.91 608 296.19 608 256c0-95.33-47.73-183.58-127.65-236.03-11.17-7.33-26.18-4.24-33.51 6.95-7.34 11.17-4.22 26.18 6.95 33.5zM288 88.02C288 73.51 276.13 64 263.81 64c-5.91 0-11.92 2.18-16.78 7.05l-20.5 20.49L288 139.59V88.02zm-48 278.03L177.94 304H80v-96h61.71l-61.4-48H56c-13.26 0-24 10.74-24 24v144c0 13.25 10.74 24 24 24h102.06l88.97 88.95c4.87 4.87 10.88 7.05 16.78 7.05 12.33 0 24.19-9.52 24.19-24.02V322.37l-48-37.53v81.21z"
  ]
};
export const faVolumeUp = {
  prefix: "far",
  iconName: "volume-up",
  icon: [
    576,
    512,
    [],
    "f028",
    "M338.23 179.12c-11.58-6.33-26.19-2.16-32.61 9.45-6.39 11.61-2.16 26.2 9.45 32.61C327.98 228.28 336 241.62 336 256c0 14.37-8.02 27.72-20.92 34.81-11.61 6.41-15.84 21-9.45 32.61 6.43 11.66 21.05 15.8 32.61 9.45 28.23-15.55 45.77-45 45.77-76.87s-17.54-61.33-45.78-76.88zM480 256c0-63.09-32.06-121.09-85.77-155.15-11.19-7.09-26.03-3.8-33.12 7.41s-3.78 26.03 7.41 33.12C408.27 166.59 432 209.44 432 256s-23.73 89.4-63.48 114.62c-11.19 7.09-14.5 21.92-7.41 33.12 6.51 10.28 21.12 15.03 33.12 7.41C447.94 377.09 480 319.09 480 256zM448.35 19.97c-11.17-7.33-26.18-4.24-33.51 6.95-7.34 11.17-4.22 26.18 6.95 33.51C488.06 103.91 527.61 177.02 527.61 256c0 78.98-39.55 152.08-105.82 195.57-11.17 7.32-14.29 22.34-6.95 33.5 7.04 10.71 21.93 14.56 33.51 6.95C528.27 439.57 576 351.33 576 256S528.27 72.42 448.35 19.97zM231.81 64c-5.91 0-11.92 2.18-16.78 7.05L126.06 160H24c-13.26 0-24 10.74-24 24v144c0 13.25 10.74 24 24 24h102.06l88.97 88.95c4.87 4.86 10.88 7.05 16.78 7.05 12.33 0 24.19-9.52 24.19-24.02V88.02C256 73.51 244.13 64 231.81 64zM208 366.04L145.94 304H48v-96h97.94L208 145.95v220.09z"
  ]
};
export const faVoteNay = {
  prefix: "far",
  iconName: "vote-nay",
  icon: [
    640,
    512,
    [],
    "f771",
    "M246.5 268.4l11.3 11.3c6.2 6.2 16.4 6.2 22.6 0l39.6-39.6 39.6 39.6c6.2 6.2 16.4 6.2 22.6 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6l-39.6-39.6 39.6-39.6c6.2-6.2 6.2-16.4 0-22.6l-11.3-11.3c-6.2-6.2-16.4-6.2-22.6 0L320 172.3l-39.6-39.6c-6.2-6.2-16.4-6.2-22.6 0L246.5 144c-6.2 6.2-6.2 16.4 0 22.6l39.6 39.6-39.6 39.6c-6.3 6.3-6.3 16.4 0 22.6zM592 272h-80V38.2C512 17.1 497.5 0 479.7 0H160.3C142.5 0 128 17.1 128 38.2V272H48c-26.5 0-48 21.5-48 48v144c0 26.5 21.5 48 48 48h544c26.5 0 48-21.5 48-48V320c0-26.5-21.5-48-48-48zM464 48v320H176V48h288zm128 416H48V320h80v48h-22.4c-5.3 0-9.6 3.6-9.6 8v32c0 4.4 4.3 8 9.6 8h428.8c5.3 0 9.6-3.6 9.6-8v-32c0-4.4-4.3-8-9.6-8H512v-48h80v144z"
  ]
};
export const faVoteYea = {
  prefix: "far",
  iconName: "vote-yea",
  icon: [
    640,
    512,
    [],
    "f772",
    "M288.1 285.1c3.8 3.9 10.1 3.9 14 .1l117.8-116.8c3.9-3.8 3.9-10.1.1-14L396.8 131c-3.8-3.9-10.1-3.9-14-.1l-87.4 86.7-37.9-38.2c-3.8-3.9-10.1-3.9-14-.1l-23.4 23.2c-3.9 3.8-3.9 10.1-.1 14l68.1 68.6zM592 272h-80V38.2C512 17.1 497.5 0 479.7 0H160.3C142.5 0 128 17.1 128 38.2V272H48c-26.5 0-48 21.5-48 48v144c0 26.5 21.5 48 48 48h544c26.5 0 48-21.5 48-48V320c0-26.5-21.5-48-48-48zM464 48v320H176V48h288zm128 416H48V320h80v48h-22.4c-5.3 0-9.6 3.6-9.6 8v32c0 4.4 4.3 8 9.6 8h428.8c5.3 0 9.6-3.6 9.6-8v-32c0-4.4-4.3-8-9.6-8H512v-48h80v144z"
  ]
};
export const faVrCardboard = {
  prefix: "far",
  iconName: "vr-cardboard",
  icon: [
    640,
    512,
    [],
    "f729",
    "M576 64H64C28.65 64 0 92.65 0 128v256c0 35.35 28.65 64 64 64h129.13c37.78 0 72.04-22.16 87.54-56.61l8.07-17.93C294.66 360.31 306.76 352 320 352s25.34 8.31 31.26 21.46l8.07 17.93c15.5 34.45 49.77 56.61 87.54 56.61H576c35.35 0 64-28.65 64-64V128c0-35.35-28.65-64-64-64zm16 320c0 8.82-7.18 16-16 16H446.87c-18.85 0-36.04-11.11-43.77-28.3l-8.07-17.93C381.43 323.54 351.98 304 320 304s-61.43 19.54-75.03 49.77l-8.07 17.93c-7.74 17.19-24.92 28.3-43.77 28.3H64c-8.82 0-16-7.18-16-16V128c0-8.82 7.18-16 16-16h512c8.82 0 16 7.18 16 16v256zM176 176c-35.35 0-64 28.65-64 64s28.65 64 64 64 64-28.65 64-64-28.65-64-64-64zm288 0c-35.35 0-64 28.65-64 64s28.65 64 64 64 64-28.65 64-64-28.65-64-64-64z"
  ]
};
export const faWagonCovered = {
  prefix: "far",
  iconName: "wagon-covered",
  icon: [
    640,
    512,
    [],
    "f8ee",
    "M624.23,26.47A71.08,71.08,0,0,0,555.75,1.21l-149,27.94h-8.22A63.44,63.44,0,0,0,360,16H280A63.42,63.42,0,0,0,241.5,29.15h-8.22L84.31,1.21a71.12,71.12,0,0,0-78.89,97L69,260.42A15.86,15.86,0,0,0,64,272v32a16,16,0,0,0,16,16H97.79c-.31.31-.68.5-1,.81A112,112,0,1,0,286.49,416h67.08a111.85,111.85,0,1,0,189.69-95.2c-.31-.31-.68-.5-1-.81h17.79a16,16,0,0,0,16-16V272a15.85,15.85,0,0,0-5-11.56L634.4,98.71A71,71,0,0,0,624.23,26.47ZM160,461.73A62.4,62.4,0,0,1,114.27,416H160ZM160,384H114.27A62.4,62.4,0,0,1,160,338.25ZM118.87,256l-69-175.89A23.12,23.12,0,0,1,75.46,48.4L216.53,74.85c-.14,1.72-.51,3.36-.51,5.11V256Zm102.4,189.27A63.4,63.4,0,0,1,192,461.73V416h45.74A63.36,63.36,0,0,1,221.27,445.25ZM192,384V338.25A62.4,62.4,0,0,1,237.75,384ZM376,256H264V80a16,16,0,0,1,16-16h80a16,16,0,0,1,16,16Zm72,205.75A62.43,62.43,0,0,1,402.3,416h45.75Zm0-77.74H402.3a62.43,62.43,0,0,1,45.75-45.74Zm61.26,61.26a63.4,63.4,0,0,1-29.26,16.48V416h45.74A63.36,63.36,0,0,1,509.31,445.25ZM480.05,384V338.25A62.4,62.4,0,0,1,525.79,384ZM589.94,80.63,521.18,256H424V80c0-1.88-.39-3.65-.55-5.49L564.59,48.4a22.59,22.59,0,0,1,22.27,8.2C589.47,59.84,595,68.6,589.94,80.63Z"
  ]
};
export const faWalker = {
  prefix: "far",
  iconName: "walker",
  icon: [
    448,
    512,
    [],
    "f831",
    "M408 388.75V88a88 88 0 0 0-88-88H186a88 88 0 0 0-85.37 66.66L.48 488.23a16 16 0 0 0 11.64 19.4l15.52 3.89a16 16 0 0 0 19.41-11.64L101.16 272H360v116.75a64 64 0 1 0 48 0zM112.56 224l34.6-145.7A40 40 0 0 1 186 48h134a40 40 0 0 1 40 40v136zM384 464a16 16 0 1 1 16-16 16 16 0 0 1-16 16z"
  ]
};
export const faWalkieTalkie = {
  prefix: "far",
  iconName: "walkie-talkie",
  icon: [
    384,
    512,
    [],
    "f8ef",
    "M352 96h-32V80a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v16h-32V80a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v16h-48V16A16 16 0 0 0 96 0H80a16 16 0 0 0-16 16v80H32a32.09 32.09 0 0 0-32 32v178.74a32 32 0 0 0 9.37 22.63L32 352v112a48 48 0 0 0 48 48h224a48 48 0 0 0 48-48V352l22.63-22.63a32 32 0 0 0 9.37-22.63V128a32.09 32.09 0 0 0-32-32zm-16 204.12l-17.94 17.94L304 332.12V464H80V332.12l-14.06-14.06L48 300.12V144h288zM128 240h128a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16H128a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16zm0 80h128a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16H128a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16z"
  ]
};
export const faWalking = {
  prefix: "far",
  iconName: "walking",
  icon: [
    320,
    512,
    [],
    "f554",
    "M94.8 347.8s-.1-.1-.1-.2l-20.4 51c-2 5-5 9.6-8.9 13.4L7 470.5c-9.4 9.4-9.4 24.6 0 33.9 4.7 4.7 10.8 7 16.9 7s12.3-2.3 16.9-7l58.4-58.5c8.5-8.5 15-18.5 19.4-29.5l13.5-33.7-36.2-33.5-1.1-1.4zM207.8 96c26.5 0 47.9-21.5 47.9-48S234.2 0 207.8 0c-26.5 0-47.9 21.5-47.9 48s21.4 48 47.9 48zm104.7 174.9L283.2 242c-.9-.9-1.6-2-2-3.2L268.3 200c-14.4-43.1-54.4-72-99.8-72-34.8 0-53 8.8-95.7 26-20.9 8.4-37.9 24.1-48.2 44.8l-14.4 31.1c-13.3 28.7 30.1 49.1 43.5 20.2l14-30.4c4.8-9.6 12.9-17 22.8-21 21.7-8.7 33.1-13.5 44.3-17.1L115 260.8c-4.7 18.9.3 38.8 14.9 54.6l79 73c5.9 5.5 10 12.5 11.8 20.4l19.5 84.8c2.6 11.5 14.4 21.2 28.7 18 12.9-3 20.9-15.9 17.9-28.8l-19.5-84.7c-4-17.3-13-32.8-26-44.9l-53.8-49.6 26.2-104.8c7.4 9.7 7.5 12.6 21.8 55.4 2.8 8.3 7.5 15.9 13.8 22.2l29.3 29c22.3 21.5 56.7-11.9 33.9-34.5z"
  ]
};
export const faWallet = {
  prefix: "far",
  iconName: "wallet",
  icon: [
    512,
    512,
    [],
    "f555",
    "M448 112V96c0-35.35-28.65-64-64-64H96C42.98 32 0 74.98 0 128v256c0 53.02 42.98 96 96 96h352c35.35 0 64-28.65 64-64V176c0-35.35-28.65-64-64-64zm16 304c0 8.82-7.18 16-16 16H96c-26.47 0-48-21.53-48-48V128c0-26.47 21.53-48 48-48h288c8.82 0 16 7.18 16 16v32H112c-8.84 0-16 7.16-16 16s7.16 16 16 16h336c8.82 0 16 7.18 16 16v240zm-80-160c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32z"
  ]
};
export const faWand = {
  prefix: "far",
  iconName: "wand",
  icon: [
    512,
    512,
    [],
    "f72a",
    "M432 192a16 16 0 0 0 16-16v-34.11L502 82a38.48 38.48 0 0 0-1.31-53.09L483 11.28a38.47 38.47 0 0 0-53-1.36L157.26 256H112a16 16 0 0 0-16 16v39.28l-78.55 70.84-.06.05a53 53 0 0 0-1.87 76.76l37.53 37.52a52.94 52.94 0 0 0 76.78-1.92L402.77 192zM94.2 462.36c-.82.91-4.23 3.24-7.22.17L49.45 425c-3-3-.73-6.44.16-7.27L455.48 51.61l4.91 4.88z"
  ]
};
export const faWandMagic = {
  prefix: "far",
  iconName: "wand-magic",
  icon: [
    512,
    512,
    [],
    "f72b",
    "M80 160l26.66-53.33L160 80l-53.33-26.67L80 0 53.33 53.33 0 80l53.33 26.67L80 160zm351.99 128l-26.66 53.33L351.99 368l53.33 26.67L431.99 448l26.66-53.33L511.98 368l-53.33-26.67L431.99 288zm-208-192l16-32 32-16-32-16-16-32-16 32-32 16 32 16 16 32zm208 96c8.84 0 16-7.16 16-16v-34.11L502.02 82c13.81-15.22 13.22-38.53-1.31-53.09l-17.66-17.63c-14.5-14.52-37.84-15.08-53-1.36L157.28 256H112c-8.84 0-16 7.16-16 16v39.28l-78.53 70.84-.06.05C6.72 391.86.38 405.69.04 420.12c-.37 14.44 5.28 28.58 15.5 38.81l37.53 37.52c9.87 9.92 23.5 15.55 37.5 15.55 22.17 0 35.57-13.37 39.28-17.47L402.78 192h29.21zM94.22 462.36c-.82.91-4.23 3.24-7.22.17l-37.53-37.52c-2.97-3.01-.73-6.44.16-7.27L455.49 51.61l4.91 4.88L94.22 462.36z"
  ]
};
export const faWarehouse = {
  prefix: "far",
  iconName: "warehouse",
  icon: [
    640,
    512,
    [],
    "f494",
    "M504 208H136c-22.1 0-40 17.9-40 40v248c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-48h352v48c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V248c0-22.1-17.9-40-40-40zm-8 208H144v-64h352v64zm0-96H144v-64h352v64zm101.9-209.9L346.3 5.3c-17-7-35.7-7.1-52.6 0L42.1 110.1C16.5 120.7 0 145.5 0 173.2V496c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V173.2c0-8.3 4.9-15.7 12.5-18.8L312.2 49.6c5.1-2.1 10.6-2.1 15.7 0l251.6 104.8c7.6 3.2 12.5 10.6 12.5 18.8V496c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V173.2c0-27.7-16.5-52.5-42.1-63.1z"
  ]
};
export const faWarehouseAlt = {
  prefix: "far",
  iconName: "warehouse-alt",
  icon: [
    640,
    512,
    [],
    "f495",
    "M528 352H352V240c0-8.8-7.2-16-16-16H112c-8.8 0-16 7.2-16 16v256c0 8.8 7.2 16 16 16h416c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16zM304 464H144v-64h160v64zm0-128H144v-64h160v64zm192 128H352v-64h144v64zm101.9-353.9L346.3 5.3c-17-7-35.7-7.1-52.6 0L42.1 110.1C16.5 120.7 0 145.5 0 173.2V496c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V173.2c0-8.3 4.9-15.7 12.5-18.8L312.2 49.6c5.1-2.1 10.6-2.1 15.7 0l251.6 104.8c7.6 3.2 12.5 10.6 12.5 18.8V496c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V173.2c0-27.7-16.5-52.5-42.1-63.1z"
  ]
};
export const faWasher = {
  prefix: "far",
  iconName: "washer",
  icon: [
    446,
    512,
    [],
    "f898",
    "M383 0H63A64 64 0 0 0-1 64v416a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32V64a64 64 0 0 0-64-64zm16 464H47V64a16 16 0 0 1 16-16h320a16 16 0 0 1 16 16zM127 104a24 24 0 1 0-24 24 24 24 0 0 0 24-24zm56 24a24 24 0 1 0-24-24 24 24 0 0 0 24 24zm40 32a136 136 0 1 0 136 136 136 136 0 0 0-136-136zm0 226.67A90.78 90.78 0 0 1 132.33 296c0-2.89.59-5.62.86-8.44a45.71 45.71 0 0 0 19.92 4.66 48.93 48.93 0 0 0 35.07-14.79 48.38 48.38 0 0 0 69.64 0 48.93 48.93 0 0 0 35.07 14.79 45.71 45.71 0 0 0 19.92-4.66c.27 2.82.86 5.55.86 8.44A90.78 90.78 0 0 1 223 386.67z"
  ]
};
export const faWatch = {
  prefix: "far",
  iconName: "watch",
  icon: [
    384,
    512,
    [],
    "f2e1",
    "M320 112.9V24c0-13.2-10.8-24-24-24H88C74.8 0 64 10.8 64 24v88.9C24.7 148 0 199.1 0 256s24.7 108 64 143.1V488c0 13.2 10.8 24 24 24h208c13.2 0 24-10.8 24-24v-88.9c39.3-35.1 64-86.2 64-143.1s-24.7-108-64-143.1zM104 40h176v45.3C253.6 71.7 223.7 64 192 64s-61.6 7.7-88 21.3V40zm176 432H104v-45.3c26.4 13.6 56.3 21.3 88 21.3s61.6-7.7 88-21.3V472zm-88-72c-78.9 0-144-63.8-144-144 0-78.6 63.5-144 144-144 78.9 0 144 63.8 144 144 0 78.6-63.5 144-144 144zm38.3-71.6l-61.1-41.6c-3.3-2.2-5.2-5.9-5.2-9.9V164c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v89.6l41.9 28.5c5.5 3.7 6.9 11.2 3.2 16.7l-18 26.4c-3.8 5.5-11.3 6.9-16.8 3.2z"
  ]
};
export const faWatchCalculator = {
  prefix: "far",
  iconName: "watch-calculator",
  icon: [
    384,
    512,
    [],
    "f8f0",
    "M128 232H96a8 8 0 0 0-8 8v32a8 8 0 0 0 8 8h32a8 8 0 0 0 8-8v-32a8 8 0 0 0-8-8zm80 72h-32a8 8 0 0 0-8 8v32a8 8 0 0 0 8 8h32a8 8 0 0 0 8-8v-32a8 8 0 0 0-8-8zm-80 0H96a8 8 0 0 0-8 8v32a8 8 0 0 0 8 8h32a8 8 0 0 0 8-8v-32a8 8 0 0 0-8-8zm160 0h-32a8 8 0 0 0-8 8v32a8 8 0 0 0 8 8h32a8 8 0 0 0 8-8v-32a8 8 0 0 0-8-8zm-80-72h-32a8 8 0 0 0-8 8v32a8 8 0 0 0 8 8h32a8 8 0 0 0 8-8v-32a8 8 0 0 0-8-8zm80-72H96a8 8 0 0 0-8 8v32a8 8 0 0 0 8 8h192a8 8 0 0 0 8-8v-32a8 8 0 0 0-8-8zm32-78.39V32a32 32 0 0 0-32-32H96a32 32 0 0 0-32 32v49.61A80 80 0 0 0 0 160v192a80 80 0 0 0 64 78.39V480a32 32 0 0 0 32 32h192a32 32 0 0 0 32-32v-49.61A80 80 0 0 0 384 352V160a80 80 0 0 0-64-78.39zM112 48h160v32H112zm160 416H112v-32h160zm64-112a32.06 32.06 0 0 1-32 32H80a32.06 32.06 0 0 1-32-32V160a32.06 32.06 0 0 1 32-32h224a32.06 32.06 0 0 1 32 32zm-48-120h-32a8 8 0 0 0-8 8v32a8 8 0 0 0 8 8h32a8 8 0 0 0 8-8v-32a8 8 0 0 0-8-8z"
  ]
};
export const faWatchFitness = {
  prefix: "far",
  iconName: "watch-fitness",
  icon: [
    384,
    512,
    [],
    "f63e",
    "M320 81.61V32c0-17.67-14.33-32-32-32H96C78.33 0 64 14.33 64 32v49.61C27.49 89.03 0 121.3 0 160v192c0 38.7 27.49 70.97 64 78.39V480c0 17.67 14.33 32 32 32h192c17.67 0 32-14.33 32-32v-49.61c36.52-7.41 64-39.69 64-78.39V160c0-38.7-27.48-70.97-64-78.39zM112 48h160v32H112V48zm160 416H112v-32h160v32zm64-112c0 17.64-14.36 32-32 32H80c-17.64 0-32-14.36-32-32V160c0-17.64 14.36-32 32-32h224c17.64 0 32 14.36 32 32v192zm-71.49-150.1c-22.05-17.19-50.86-9.54-65.59 4.36l-6.93 6.54-6.93-6.54c-14.36-13.55-43.29-21.73-65.59-4.36-22.09 17.21-23.25 48.13-3.48 66.79l68.04 64.2c4.39 4.14 11.52 4.15 15.91 0l68.04-64.2c19.78-18.66 18.62-49.58-3.47-66.79z"
  ]
};
export const faWater = {
  prefix: "far",
  iconName: "water",
  icon: [
    576,
    512,
    [],
    "f773",
    "M561.5 399.9c-25.1-2.6-49.2-11.9-66.4-25.9-8.7-7.1-21.6-7-30.3.1-20.5 16.9-50 26.6-80.8 26.6-30.1 0-60.3-10-80.9-26.7-8.7-7.1-21.6-7-30.3.1-20.5 16.9-50 26.6-80.8 26.6-30.1 0-60.3-10-80.9-26.7-8.7-7.1-21.6-7-30.3.1-17.2 14.2-40.7 23.3-66.1 25.8-8.2.9-14.7 7.3-14.7 15.5v16.5c0 9.1 7.6 16.8 16.7 16 28.9-2.5 56.5-11.5 79.3-25.8 54.9 34.2 137.9 33.9 192 0 54.9 34.2 137.9 33.9 192 0 22.9 14.3 50.5 23.3 79.2 25.8 9.1.8 16.7-6.9 16.7-16v-16.7c.1-8.1-6.3-14.4-14.4-15.3zm0-304.7c-25.1-2.6-49.2-11.9-66.4-25.9-8.7-7.1-21.6-7-30.3.1C444.3 86.3 414.8 96 384 96c-30.1 0-60.3-10-80.9-26.7-8.7-7.1-21.6-7-30.3.1C252.3 86.3 222.8 96 192 96c-30.1 0-60.3-10-80.9-26.7-8.7-7.1-21.6-7-30.3.1-17.2 14.1-40.7 23.2-66.1 25.8C6.5 96 0 102.4 0 110.7v16.5c0 9.1 7.6 16.8 16.7 16 28.9-2.5 56.5-11.5 79.3-25.8 54.9 34.2 137.9 33.9 192 0 54.9 34.2 137.9 33.9 192 0 22.9 14.3 50.5 23.3 79.2 25.8 9.1.8 16.7-6.9 16.7-16v-16.7c.1-8.2-6.3-14.5-14.4-15.3zm0 152c-25.1-2.6-49.2-11.9-66.4-25.9-8.7-7.1-21.6-7-30.3.1-20.5 16.9-50 26.6-80.8 26.6-30.1 0-60.3-10-80.9-26.7-8.7-7.1-21.6-7-30.3.1-20.5 16.9-50 26.6-80.8 26.6-30.1 0-60.3-10-80.9-26.7-8.7-7.1-21.6-7-30.3.1-17.2 14.2-40.7 23.3-66.1 25.8C6.5 248 0 254.4 0 262.7v16.5c0 9.1 7.6 16.8 16.7 16 28.9-2.5 56.5-11.5 79.3-25.8 54.9 34.2 137.9 33.9 192 0 54.9 34.2 137.9 33.9 192 0 22.9 14.3 50.5 23.3 79.2 25.8 9.1.8 16.7-6.9 16.7-16v-16.7c.1-8.2-6.3-14.5-14.4-15.3z"
  ]
};
export const faWaterLower = {
  prefix: "far",
  iconName: "water-lower",
  icon: [
    576,
    512,
    [],
    "f774",
    "M276.7 219.4c6.2 6.2 16.3 6.2 22.5 0l97.7-97c6.3-6.2 6.3-16.4.1-22.6l-11.3-11.4c-6.2-6.3-16.4-6.3-22.6-.1L312 139.1V16c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16v123.1l-51.1-50.8c-6.3-6.2-16.4-6.2-22.6.1L179 99.8c-6.2 6.3-6.2 16.4.1 22.6l97.6 97zm284.8 244.5c-25.1-2.6-49.2-11.9-66.4-25.9-8.7-7.1-21.6-7-30.3.1-20.5 16.9-50 26.6-80.8 26.6-30.1 0-60.3-10-80.9-26.7-8.7-7.1-21.6-7-30.3.1-20.5 16.9-50 26.6-80.8 26.6-30.1 0-60.3-10-80.9-26.7-8.7-7.1-21.6-7-30.3.1-17.2 14.2-40.7 23.3-66.1 25.8-8.2.9-14.7 7.3-14.7 15.5v16.5c0 9.1 7.6 16.8 16.7 16 28.9-2.5 56.5-11.5 79.3-25.8 54.9 34.2 137.9 33.9 192 0 54.9 34.2 137.9 33.9 192 0 22.9 14.3 50.5 23.3 79.2 25.8 9.1.8 16.7-6.9 16.7-16v-16.7c.1-8.1-6.3-14.4-14.4-15.3zm0-144.7c-25.1-2.6-49.2-11.9-66.4-25.9-8.7-7.1-21.6-7-30.3.1-20.5 16.9-50 26.6-80.8 26.6-30.1 0-60.3-10-80.9-26.7-8.7-7.1-21.6-7-30.3.1-20.5 16.9-50 26.6-80.8 26.6-30.1 0-60.3-10-80.9-26.7-8.7-7.1-21.6-7-30.3.1-17.2 14.2-40.7 23.3-66.1 25.8C6.5 320 0 326.4 0 334.7v16.5c0 9.1 7.6 16.8 16.7 16 28.9-2.5 56.5-11.5 79.3-25.8 54.9 34.2 137.9 33.9 192 0 54.9 34.2 137.9 33.9 192 0 22.9 14.3 50.5 23.3 79.2 25.8 9.1.8 16.7-6.9 16.7-16v-16.7c.1-8.2-6.3-14.5-14.4-15.3z"
  ]
};
export const faWaterRise = {
  prefix: "far",
  iconName: "water-rise",
  icon: [
    576,
    512,
    [],
    "f775",
    "M190.2 135.6c6.2 6.3 16.4 6.3 22.6.1L264 84.9V208c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V84.9l51.1 50.8c6.3 6.2 16.4 6.2 22.6-.1l11.3-11.4c6.2-6.3 6.2-16.4-.1-22.6l-97.7-97c-6.2-6.2-16.3-6.2-22.5 0l-97.7 97c-6.3 6.2-6.3 16.4-.1 22.6l11.3 11.4zm371.3 328.3c-25.1-2.6-49.2-11.9-66.4-25.9-8.7-7.1-21.6-7-30.3.1-20.5 16.9-50 26.6-80.8 26.6-30.1 0-60.3-10-80.9-26.7-8.7-7.1-21.6-7-30.3.1-20.5 16.9-50 26.6-80.8 26.6-30.1 0-60.3-10-80.9-26.7-8.7-7.1-21.6-7-30.3.1-17.2 14.2-40.7 23.3-66.1 25.8-8.2.9-14.7 7.3-14.7 15.5v16.5c0 9.1 7.6 16.8 16.7 16 28.9-2.5 56.5-11.5 79.3-25.8 54.9 34.2 137.9 33.9 192 0 54.9 34.2 137.9 33.9 192 0 22.9 14.3 50.5 23.3 79.2 25.8 9.1.8 16.7-6.9 16.7-16v-16.7c.1-8.1-6.3-14.4-14.4-15.3zm0-144.7c-25.1-2.6-49.2-11.9-66.4-25.9-8.7-7.1-21.6-7-30.3.1-20.5 16.9-50 26.6-80.8 26.6-30.1 0-60.3-10-80.9-26.7-8.7-7.1-21.6-7-30.3.1-20.5 16.9-50 26.6-80.8 26.6-30.1 0-60.3-10-80.9-26.7-8.7-7.1-21.6-7-30.3.1-17.2 14.2-40.7 23.3-66.1 25.8C6.5 320 0 326.4 0 334.7v16.5c0 9.1 7.6 16.8 16.7 16 28.9-2.5 56.5-11.5 79.3-25.8 54.9 34.2 137.9 33.9 192 0 54.9 34.2 137.9 33.9 192 0 22.9 14.3 50.5 23.3 79.2 25.8 9.1.8 16.7-6.9 16.7-16v-16.7c.1-8.2-6.3-14.5-14.4-15.3z"
  ]
};
export const faWaveSine = {
  prefix: "far",
  iconName: "wave-sine",
  icon: [
    640,
    512,
    [],
    "f899",
    "M628.41 261.07L613 256.63a15.88 15.88 0 0 0-19.55 10.16C572.85 329.76 511.64 432 464 432c-52.09 0-87.41-93.77-121.53-184.45C302.56 141.58 261.31 32 176 32 87.15 32 17.77 178.46.78 230.69a16 16 0 0 0 10.81 20.23L27 255.36a15.87 15.87 0 0 0 19.55-10.15C67.15 182.24 128.36 80 176 80c52.09 0 87.41 93.77 121.53 184.45C337.44 370.42 378.69 480 464 480c88.85 0 158.23-146.46 175.22-198.7a16 16 0 0 0-10.81-20.23z"
  ]
};
export const faWaveSquare = {
  prefix: "far",
  iconName: "wave-square",
  icon: [
    640,
    512,
    [],
    "f83e",
    "M472 480H328a32 32 0 0 1-32-32V80H184v168a32 32 0 0 1-32 32H8a8 8 0 0 1-8-8v-32a8 8 0 0 1 8-8h128V64a32 32 0 0 1 32-32h144a32 32 0 0 1 32 32v368h112V264a32 32 0 0 1 32-32h144a8 8 0 0 1 8 8v32a8 8 0 0 1-8 8H504v168a32 32 0 0 1-32 32z"
  ]
};
export const faWaveTriangle = {
  prefix: "far",
  iconName: "wave-triangle",
  icon: [
    640,
    512,
    [],
    "f89a",
    "M464 480h-.31a24 24 0 0 1-19.16-10L175.5 96.38l-134 185.29a16 16 0 0 1-22.42 3.08l-12.75-9.67a16 16 0 0 1-3.08-22.42L156.88 41.5A24 24 0 0 1 176 32h.31a24 24 0 0 1 19.16 10l269 373.64 134-185.29a16 16 0 0 1 22.42-3.08l12.75 9.67a16 16 0 0 1 3.08 22.42L483.13 470.5A24 24 0 0 1 464 480z"
  ]
};
export const faWaveform = {
  prefix: "far",
  iconName: "waveform",
  icon: [
    640,
    512,
    [],
    "f8f1",
    "M328 0h-16a16 16 0 0 0-16 16v480a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16V16a16 16 0 0 0-16-16zm-96 96h-16a16 16 0 0 0-16 16v288a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16V112a16 16 0 0 0-16-16zm192 32h-16a16 16 0 0 0-16 16v224a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16V144a16 16 0 0 0-16-16zm96-64h-16a16 16 0 0 0-16 16v352a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zM136 192h-16a16 16 0 0 0-16 16v96a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-96a16 16 0 0 0-16-16zm-96 32H24a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm576 0h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
  ]
};
export const faWaveformPath = {
  prefix: "far",
  iconName: "waveform-path",
  icon: [
    640,
    512,
    [],
    "f8f2",
    "M628 268h-52.09l-20.44-92.48a20 20 0 0 0-38.94-.07L484.75 315.7l-33-234.53a20 20 0 0 0-39.65.45l-29.5 250-42.79-314.35a20 20 0 0 0-39.62 0l-42.81 314.37-29.5-250a20 20 0 0 0-39.66-.44l-33 234.53-31.75-140.28a20 20 0 0 0-38.94.05L64.09 268H12a12 12 0 0 0-12 12v16a12 12 0 0 0 12 12h68a19.87 19.87 0 0 0 19.47-15.5l4.66-19.94 36.4 160c2.22 9.69 9.78 15.44 20.25 15.44h.22a19.94 19.94 0 0 0 18.75-17.16l26.5-189.36 29.85 252.91a20 20 0 0 0 39.68.34L320 170.36l44.19 324.37a20 20 0 0 0 39.69-.34l29.84-252.91 26.5 189.33A20 20 0 0 0 479.13 448c9.93.53 18.06-5.63 20.34-15.44l36.41-160 4.65 19.92A19.88 19.88 0 0 0 560 308h68a12 12 0 0 0 12-12v-16a12 12 0 0 0-12-12z"
  ]
};
export const faWebcam = {
  prefix: "far",
  iconName: "webcam",
  icon: [
    448,
    512,
    [],
    "f832",
    "M401 438.6l-49.19-30.75C409.88 367.39 448 300.19 448 224 448 100.29 347.71 0 224 0S0 100.29 0 224c0 76.19 38.12 143.39 96.23 183.85L47 438.6a32 32 0 0 0-15 27.14V480a32 32 0 0 0 32 32h320a32 32 0 0 0 32-32v-14.26a32 32 0 0 0-15-27.14zM224 400a176 176 0 1 1 176-176 176 176 0 0 1-176 176zm0-320c-79.41 0-144 64.59-144 144s64.59 144 144 144 144-64.59 144-144S303.41 80 224 80zm0 240a96 96 0 1 1 96-96 96.1 96.1 0 0 1-96 96zm0-160a64.07 64.07 0 0 0-64 64 16 16 0 0 0 32 0 32 32 0 0 1 32-32 16 16 0 0 0 0-32z"
  ]
};
export const faWebcamSlash = {
  prefix: "far",
  iconName: "webcam-slash",
  icon: [
    640,
    512,
    [],
    "f833",
    "M634 471L36 3.51A16 16 0 0 0 13.51 6l-10 12.49A16 16 0 0 0 6 41l598 467.49a16 16 0 0 0 22.49-2.49l10-12.49A16 16 0 0 0 634 471zM455.58 270.61c5.08-14.7 8.42-30.21 8.42-46.61 0-79.41-64.59-144-144-144a142.89 142.89 0 0 0-78.26 23.43l41 32.09a94.54 94.54 0 0 1 131.75 103zM320 48a176 176 0 0 1 162.48 243.64l38.63 30.2A222.06 222.06 0 0 0 544 224C544 100.29 443.71 0 320 0a223 223 0 0 0-143.71 52.26l39 30.5A175 175 0 0 1 320 48zm0 320a142.8 142.8 0 0 0 23.35-2.36L177.18 235.73C183.27 309.58 244.61 368 320 368zm0 32a176 176 0 0 1-176-176c0-4.62.34-9.15.69-13.67l-43.49-34A224.17 224.17 0 0 0 96 224c0 76.19 38.11 143.39 96.23 183.85L143 438.6a32 32 0 0 0-15 27.14V480a32 32 0 0 0 32 32h320c12.39 0 22.81-7.25 28.14-17.54L375.63 390.88A175.61 175.61 0 0 1 320 400z"
  ]
};
export const faWeight = {
  prefix: "far",
  iconName: "weight",
  icon: [
    512,
    512,
    [],
    "f496",
    "M448 64h-64.81C353.95 25.38 308.07 0 256 0s-97.95 25.38-127.19 64H64C28.71 64 0 92.71 0 128v320c0 35.29 28.71 64 64 64h384c35.29 0 64-28.71 64-64V128c0-35.29-28.71-64-64-64zM256 48c61.86 0 112 50.14 112 112s-50.14 112-112 112-112-50.14-112-112S194.14 48 256 48zm208 400c0 8.84-7.16 16-16 16H64c-8.84 0-16-7.16-16-16V128c0-8.84 7.16-16 16-16h40.17C99.33 127.25 96 143.17 96 160c0 88.22 71.78 160 160 160s160-71.78 160-160c0-16.83-3.33-32.75-8.17-48H448c8.84 0 16 7.16 16 16v320zM256 240c17.67 0 32-14.33 32-32 0-8.06-3.25-15.22-8.18-20.85l23.36-70.09c6.66-20.08-23.63-30.2-30.38-10.12l-23.47 70.41C234.97 180.49 224 192.69 224 208c0 17.67 14.33 32 32 32z"
  ]
};
export const faWeightHanging = {
  prefix: "far",
  iconName: "weight-hanging",
  icon: [
    512,
    512,
    [],
    "f5cd",
    "M510.28 445.86l-73.03-292.13c-3.8-15.19-16.44-25.72-30.87-25.72h-72.41c6.2-12.05 10.04-25.51 10.04-40 0-48.6-39.4-88-88-88s-88 39.4-88 88c0 14.49 3.83 27.95 10.04 40h-72.41c-14.43 0-27.08 10.54-30.87 25.72L1.72 445.86C-6.61 479.17 16.38 512 48.03 512h415.95c31.64 0 54.63-32.83 46.3-66.14zM216 88c0-22.06 17.94-40 40-40s40 17.94 40 40c0 22.05-17.94 40-40 40s-40-17.95-40-40zm246.72 376H49.28c-.7-.96-1.81-3.23-1-6.5L118.66 176h274.68l70.38 281.5c.81 3.27-.3 5.54-1 6.5z"
  ]
};
export const faWhale = {
  prefix: "far",
  iconName: "whale",
  icon: [
    640,
    512,
    [],
    "f72c",
    "M512 128c-141.14 0-207.15 83.47-308.69 182.31-3.26 3.26-7.27 4.72-11.2 4.72-8.23 0-16.12-6.39-16.12-16.03v-62.87l31.38-16.49C217.76 213.7 224 203.7 224 193V80.03c0-9.41-9.01-16.03-18.72-16.03h-.01c-3.47 0-7.02.85-10.29 2.71L112 114.13 29.02 66.71A20.781 20.781 0 0 0 18.72 64C9.01 64 0 70.61 0 80.03V193c0 10.7 6.24 20.69 16.62 26.62L48 236.12v80C48 388.96 107.04 448 179.88 448H544c53.02 0 96-42.98 96-96v-96c0-70.69-57.31-128-128-128zm80 224c0 26.47-21.53 48-48 48H179.88C133.63 400 96 362.37 96 316.12v-109l-25.67-13.49L48 181.89v-49.05l40.19 22.96L112 169.42l23.82-13.61L176 132.84v49.05l-22.33 11.74L128 207.12v91.87c0 35.31 28.76 64.03 64.12 64.03 17 0 33.03-6.67 44.68-18.32 11.53-11.22 22.6-22.24 33.38-32.97C352.28 230 406.52 176 512 176c44.11 0 80 35.89 80 80v96zm-160-72c-13.25 0-24 10.74-24 24 0 13.25 10.75 24 24 24s24-10.75 24-24c0-13.26-10.75-24-24-24z"
  ]
};
export const faWheat = {
  prefix: "far",
  iconName: "wheat",
  icon: [
    512,
    512,
    [],
    "f72d",
    "M460.88 152.46c-3.16-3.16 2.2-.13 18.18-14.98 26.56-28.87 34.75-75.08 32.62-120.15C510.75-2.33 487.66.1 481.05.1c-34.29 0-76.94 6.42-105.69 33.16-18.54 18.64-11.73 21.82-16.26 17.29l-39.56-39.59c-6.26-6.26-16.37-6.24-22.6 0l-34.08 34.1c-12.59 12.6-20.57 27.91-24.71 44.01-11.18-8.16-20.36 1.13-20.57 1.35l-33.69 33.71c-12.58 12.59-20.57 27.9-24.7 43.99-11.19-8.16-20.35 1.14-20.57 1.36l-33.87 33.89c-37.49 37.51-37.49 98.35 0 135.87l16.95 16.96L7.03 471.01c-9.37 9.38-9.37 24.58 0 33.95 4.69 4.69 10.8 7.04 16.96 7.04s12.27-2.35 16.96-7.04l114.68-114.8 16.93 16.96c37.46 37.52 98.22 37.54 135.7 0L342.31 373c5.64-5.65 5.9-14.34 1.35-20.6 16.08-4.14 31.37-12.13 43.96-24.74l33.67-33.73c5.64-5.65 5.9-14.34 1.35-20.59 16.07-4.14 31.35-12.13 43.93-24.73l33.85-33.91c6.24-6.25 6.24-16.38 0-22.63l-39.54-39.61zM166.9 310.93l-11.29 11.31-16.95-16.97c-18.74-18.76-18.77-49.15 0-67.93l11.27-11.28 16.95 16.97c9.07 9.07 14.06 21.13 14.06 33.97 0 12.82-4.99 24.87-14.04 33.93zm129.87-231.9l11.47-11.48 16.95 16.96c18.74 18.75 18.77 49.15 0 67.93l-11.47 11.48-16.95-16.96c-18.74-18.74-18.78-49.14 0-67.93zM217.8 158.1l11.08-11.09 16.95 16.96c18.74 18.75 18.78 49.13.01 67.93L234.75 243l-16.95-16.96c-18.74-18.76-18.77-49.15 0-67.94zm56.53 215.07c-18.74 18.78-49.1 18.79-67.85 0l-16.94-16.97 11.54-11.55c18.8-18.76 49.09-18.65 67.77.06l16.94 16.97-11.46 11.49zm79.36-79.45c-18.74 18.78-49.1 18.79-67.85 0l-16.94-16.97 11.08-11.1c18.75-18.78 49.1-18.79 67.85 0l16.94 16.97-11.08 11.1zm78.95-79.06c-18.75 18.78-49.1 18.79-67.85 0l-16.94-16.97 11.26-11.28c18.75-18.78 49.1-18.79 67.85 0l16.94 16.97-11.26 11.28zm-42.65-92.63c1.6-20.03 6.74-41.62 18.71-54.22 11.53-10.28 30.54-16.82 54.59-18.93-2.06 23.83-8.38 42.97-18.28 54.68-11.83 10.14-30.97 16.52-55.02 18.47z"
  ]
};
export const faWheelchair = {
  prefix: "far",
  iconName: "wheelchair",
  icon: [
    512,
    512,
    [],
    "f193",
    "M500.1 399.78l10.65 21.494c2.937 5.928.522 13.116-5.399 16.067l-63.278 32.164c-12.134 6.014-26.981.801-32.571-11.723L344.431 312H184.003c-12.03 0-22.203-8.908-23.792-20.833C125.74 32.641 128.263 52.443 128 48c0-27.152 22.544-49.038 49.935-47.962 24.787.974 44.979 21.107 46.021 45.892 1.06 25.208-17.335 46.326-41.405 49.614L192.212 168H340c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12H198.613l6.4 48H360a23.999 23.999 0 0 1 21.916 14.218l61.233 137.185 40.834-21.029c5.943-2.971 13.168-.547 16.117 5.406zM313.291 360h-11.558C290.467 419.146 238.377 464 176 464c-70.579 0-128-57.421-128-128 0-43.765 22.083-82.463 55.686-105.556l-6.884-51.587C39.428 207.89 0 267.423 0 336c0 97.047 78.953 176 176 176 70.605 0 131.621-41.797 159.636-101.941L313.291 360z"
  ]
};
export const faWhistle = {
  prefix: "far",
  iconName: "whistle",
  icon: [
    640,
    512,
    [],
    "f460",
    "M250.6 254c0 22.3-18.1 40.4-40.4 40.4s-40.4-18.1-40.4-40.4c0-22.3 18.1-40.4 40.4-40.4s40.4 18.1 40.4 40.4zm231.9-50.2L633.9 325c6.8 5.5 8.1 15.3 2.8 22.3l-79 105.3c-4.9 6.5-13.9 8.4-20.9 4.3l-151.7-86.8c-7.6 11.4-16.4 22.3-26.5 32.4-41 41-94.7 61.5-148.5 61.5-157 0-258.4-166.6-186.8-306A64.714 64.714 0 0 1 .2 108.4c0-35.6 29-64.6 64.6-64.6 19.2 0 36.9 8.8 49.1 23.4C144 51.7 177 44.1 210 44.1c86.7 0 126.5 42.9 194.5 97.3 5.3 4.3 7.4 11.4 5.2 17.9L399.5 189c-1.1 3.2-.1 6.8 2.6 8.9l25.5 20.4c2.6 2.1 6.3 2.4 9.2.6l27.5-16.4c5.7-3.4 13-2.9 18.2 1.3zM41 129.8c6.3-8.5 13-16.8 20.7-24.5 7.8-7.8 16.1-14.6 24.7-20.9-5.9-5.3-13.5-8.3-21.6-8.3-17.8 0-32.3 14.5-32.3 32.3 0 8.1 3.3 15.6 8.5 21.4zm533.5 219.7c2.6-3.5 2-8.4-1.4-11.2l-103.4-82.7-32.3 19.2c-5.8 3.4-13.1 2.9-18.3-1.3L349.6 218c-5.3-4.3-7.4-11.4-5.2-17.9l12.1-35.2s-52-41.5-60.6-47.8C262.1 95.9 170.5 65 96 139.5 33 202.5 33 305 96 368c30.5 30.5 71.1 47.5 114.2 47.5 102.1 0 142.2-83.7 159.7-109.9L530 397.2c3.5 2 8 1.1 10.5-2.2l34-45.5z"
  ]
};
export const faWifi = {
  prefix: "far",
  iconName: "wifi",
  icon: [
    640,
    512,
    [],
    "f1eb",
    "M320 368c17.64 0 32 14.36 32 32s-14.36 32-32 32-32-14.36-32-32 14.35-32 32-32m0-48c-44.18 0-80 35.82-80 80s35.82 80 80 80 80-35.82 80-80-35.82-80-80-80zm204.69-31.83c4.62-4.87 4.38-12.64-.59-17.15-115.74-105.32-292.41-105.38-408.22 0-4.96 4.51-5.2 12.28-.59 17.15l16.47 17.37c4.46 4.71 11.81 4.95 16.62.6 97.44-88.13 245.68-88.21 343.22 0 4.81 4.35 12.16 4.1 16.62-.6l16.47-17.37zm111.42-133.98C457.86-8.86 181.84-8.59 3.89 154.19c-4.94 4.52-5.22 12.14-.57 16.95l16.6 17.18c4.52 4.68 12.01 4.93 16.81.54 159.59-145.79 406.82-145.91 566.54 0 4.81 4.39 12.29 4.13 16.81-.54l16.6-17.18c4.65-4.81 4.37-12.44-.57-16.95z"
  ]
};
export const faWifi1 = {
  prefix: "far",
  iconName: "wifi-1",
  icon: [
    640,
    512,
    [],
    "f6aa",
    "M320 368c17.64 0 32 14.36 32 32s-14.36 32-32 32-32-14.36-32-32 14.35-32 32-32m0-48c-44.18 0-80 35.82-80 80s35.82 80 80 80 80-35.82 80-80-35.82-80-80-80z"
  ]
};
export const faWifi2 = {
  prefix: "far",
  iconName: "wifi-2",
  icon: [
    640,
    512,
    [],
    "f6ab",
    "M320 368c17.64 0 32 14.36 32 32s-14.36 32-32 32-32-14.36-32-32 14.35-32 32-32m0-48c-44.18 0-80 35.82-80 80s35.82 80 80 80 80-35.82 80-80-35.82-80-80-80zm204.69-31.83c4.62-4.87 4.38-12.64-.59-17.15-115.74-105.32-292.41-105.38-408.22 0-4.96 4.51-5.2 12.28-.59 17.15l16.47 17.37c4.46 4.71 11.81 4.95 16.62.6 97.44-88.13 245.68-88.21 343.22 0 4.81 4.35 12.16 4.1 16.62-.6l16.47-17.37z"
  ]
};
export const faWifiSlash = {
  prefix: "far",
  iconName: "wifi-slash",
  icon: [
    640,
    512,
    [],
    "f6ac",
    "M36 3.51C29.1-2.01 19.03-.9 13.51 6l-10 12.49C-2.02 25.39-.9 35.46 6 40.98l598 467.51c6.9 5.52 16.96 4.4 22.49-2.49l10-12.49c5.53-6.9 4.41-16.97-2.49-22.49L36 3.51zm467.18 304.31c1.77-.6 3.67-.83 5.05-2.29l16.46-17.37c4.62-4.87 4.38-12.64-.58-17.15-47.67-43.38-105.71-68.61-165.55-76.26l144.62 113.07zm100.09-118.96c4.8 4.39 12.29 4.13 16.81-.54l16.6-17.19c4.65-4.81 4.37-12.43-.57-16.95C509.51 38.38 333.7 5.4 178.62 54.08l46.71 36.52c130.7-29.93 273.12 2.51 377.94 98.26zM3.89 154.18c-4.94 4.52-5.22 12.14-.57 16.95l16.6 17.19c4.52 4.68 12.01 4.93 16.81.54 12.72-11.62 26.16-21.97 39.9-31.74L37.34 126.4c-11.47 8.69-22.66 17.91-33.45 27.78zm112 116.83c-4.96 4.52-5.2 12.28-.58 17.15l16.46 17.37c4.46 4.71 11.81 4.95 16.62.6 19.7-17.81 41.53-31.84 64.54-42.46l-41.51-32.45c-19.55 11.03-38.28 24.09-55.53 39.79zM240 400c0 44.18 35.82 80 80 80 41.03 0 74.45-31 79.07-70.79l-107.24-83.84C261.6 336.79 240 365.77 240 400zm80-32c17.64 0 32 14.36 32 32s-14.36 32-32 32-32-14.36-32-32 14.36-32 32-32z"
  ]
};
export const faWind = {
  prefix: "far",
  iconName: "wind",
  icon: [
    512,
    512,
    [],
    "f72e",
    "M16 224h336c59.8 0 106.8-54.6 93.8-116.7-7.6-36.3-36.9-65.6-73.2-73.2-55.9-11.7-105.8 25.4-115.1 76.6-1.6 9 5.8 17.2 14.9 17.2h18.4c7.2 0 12.9-5.2 14.7-12.1 6.6-25.2 33.2-42.4 61.7-33.5 14.3 4.4 25.9 16.1 30.4 30.4 10.3 32.9-14.2 63.3-45.6 63.3H16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16zm144 32H16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h144c31.4 0 55.9 30.3 45.6 63.3-4.4 14.3-16.1 25.9-30.4 30.4-28.5 8.9-55.1-8.3-61.7-33.5-1.8-6.9-7.5-12.1-14.7-12.1H80.5c-9.2 0-16.6 8.2-14.9 17.2 9.3 51.2 59.2 88.3 115.1 76.6 36.3-7.6 65.6-36.9 73.2-73.2C266.8 310.6 219.8 256 160 256zm235.3 0H243.8c5.4 4.8 10.9 9.6 15.5 15.3 8.1 9.9 13.9 21.1 18.6 32.7h119.2c33.4 0 63.3 24.4 66.5 57.6 3.7 38.1-26.3 70.4-63.7 70.4-27.7 0-51.1-17.7-60-42.4-1.2-3.3-4.1-5.6-7.6-5.6h-33.1c-5 0-9 4.6-7.9 9.5C302.9 443 347 480 400 480c63 0 113.8-52 111.9-115.4-1.8-61.3-55.3-108.6-116.6-108.6z"
  ]
};
export const faWindTurbine = {
  prefix: "far",
  iconName: "wind-turbine",
  icon: [
    514,
    512,
    [],
    "f89b",
    "M350.1 480h-24.27l-3-46-52.03-61.3 7 107.3h-43.56l9.06-139.69-26.9-31.68a24 24 0 0 0-16-8.78l-2.52-.27L186.17 480H161.9a36.94 36.94 0 0 0-33 20.42A8 8 0 0 0 136 512h240a8 8 0 0 0 7.15-11.58A36.93 36.93 0 0 0 350.1 480zm48.59-54.21l-88.35-182.32a55.73 55.73 0 0 1-.73-42.79l73.28-179.07a15.8 15.8 0 0 0-27.5-15.07L241.27 163.21a55.74 55.74 0 0 1-36.47 22.4L13.32 215.94A15.81 15.81 0 0 0 0 231.89v.23a15.8 15.8 0 0 0 14.1 15.35L203.83 268a55.78 55.78 0 0 1 37.54 20.58l130.31 153.5a15.81 15.81 0 0 0 20.53 3.63l.19-.12a15.79 15.79 0 0 0 6.29-19.8zM256 248a24 24 0 1 1 24-24 24 24 0 0 1-24 24z"
  ]
};
export const faWindWarning = {
  prefix: "far",
  iconName: "wind-warning",
  icon: [
    640,
    512,
    [],
    "f776",
    "M544 320H420.1c-9.2 17.4-20.7 33.4-33.7 48H544c31.4 0 55.9 30.3 45.6 63.3-4.4 14.3-16.1 25.9-30.4 30.4-28.5 8.9-55.1-8.3-61.7-33.5-1.8-6.9-7.5-12.1-14.7-12.1h-18.4c-9.2 0-16.6 8.2-14.9 17.2 9.3 51.2 59.2 88.3 115.1 76.6 36.3-7.6 65.6-36.9 73.2-73.2 13-62.1-34-116.7-93.8-116.7zm93.8-148.7c-7.6-36.3-36.9-65.6-73.2-73.2-55.9-11.7-105.8 25.4-115.1 76.6-1.6 9 5.8 17.2 14.9 17.2h18.4c7.2 0 12.9-5.2 14.7-12.1 6.6-25.2 33.2-42.4 61.7-33.5 14.3 4.5 25.9 16.1 30.4 30.4 10.2 32.9-14.2 63.3-45.6 63.3h-98.4c-2.2 16.6-6.2 32.6-11.6 48h110c59.8 0 106.8-54.6 93.8-116.7zM208 256c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm28.7-160h-57.4c-10 0-17.6 9.1-15.7 18.9l18 96c1.4 7.6 8 13.1 15.7 13.1h21.4c7.7 0 14.3-5.5 15.7-13.1l18-96c1.9-9.8-5.7-18.9-15.7-18.9zM208 0C93.1 0 0 93.1 0 208s93.1 208 208 208 208-93.1 208-208S322.9 0 208 0zm0 368c-88.2 0-160-71.8-160-160S119.8 48 208 48s160 71.8 160 160-71.8 160-160 160z"
  ]
};
export const faWindow = {
  prefix: "far",
  iconName: "window",
  icon: [
    512,
    512,
    [],
    "f40e",
    "M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-208 80c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm-96 0c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm-96 0c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm400 314c0 3.3-2.7 6-6 6H54c-3.3 0-6-2.7-6-6V192h416v234z"
  ]
};
export const faWindowAlt = {
  prefix: "far",
  iconName: "window-alt",
  icon: [
    512,
    512,
    [],
    "f40f",
    "M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-80 80c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm-96 0c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm-96 0c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm272 314c0 3.3-2.7 6-6 6H54c-3.3 0-6-2.7-6-6V192h416v234z"
  ]
};
export const faWindowClose = {
  prefix: "far",
  iconName: "window-close",
  icon: [
    512,
    512,
    [],
    "f410",
    "M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm0 394c0 3.3-2.7 6-6 6H54c-3.3 0-6-2.7-6-6V86c0-3.3 2.7-6 6-6h404c3.3 0 6 2.7 6 6v340zM356.5 194.6L295.1 256l61.4 61.4c4.6 4.6 4.6 12.1 0 16.8l-22.3 22.3c-4.6 4.6-12.1 4.6-16.8 0L256 295.1l-61.4 61.4c-4.6 4.6-12.1 4.6-16.8 0l-22.3-22.3c-4.6-4.6-4.6-12.1 0-16.8l61.4-61.4-61.4-61.4c-4.6-4.6-4.6-12.1 0-16.8l22.3-22.3c4.6-4.6 12.1-4.6 16.8 0l61.4 61.4 61.4-61.4c4.6-4.6 12.1-4.6 16.8 0l22.3 22.3c4.7 4.6 4.7 12.1 0 16.8z"
  ]
};
export const faWindowFrame = {
  prefix: "far",
  iconName: "window-frame",
  icon: [
    512,
    512,
    [],
    "e04f",
    "M496,464H480V32A32,32,0,0,0,448,0H64A32,32,0,0,0,32,32V464H16A16,16,0,0,0,0,480v16a16,16,0,0,0,16,16H496a16,16,0,0,0,16-16V480A16,16,0,0,0,496,464Zm-264,0H80V272H232Zm0-240H80V48H232ZM432,464H280V272H432Zm0-240H280V48H432Z"
  ]
};
export const faWindowFrameOpen = {
  prefix: "far",
  iconName: "window-frame-open",
  icon: [
    512,
    512,
    [],
    "e050",
    "M496,464H480V304H432V464H80V304H32V464H16A16,16,0,0,0,0,480v16a16,16,0,0,0,16,16H496a16,16,0,0,0,16-16V480A16,16,0,0,0,496,464ZM480,32A32,32,0,0,0,448,0H64A32,32,0,0,0,32,32V272H480ZM232,224H80V48H232Zm200,0H280V48H432Z"
  ]
};
export const faWindowMaximize = {
  prefix: "far",
  iconName: "window-maximize",
  icon: [
    512,
    512,
    [],
    "f2d0",
    "M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm0 394c0 3.3-2.7 6-6 6H54c-3.3 0-6-2.7-6-6V192h416v234z"
  ]
};
export const faWindowMinimize = {
  prefix: "far",
  iconName: "window-minimize",
  icon: [
    512,
    512,
    [],
    "f2d1",
    "M480 480H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h448c17.7 0 32 14.3 32 32s-14.3 32-32 32z"
  ]
};
export const faWindowRestore = {
  prefix: "far",
  iconName: "window-restore",
  icon: [
    512,
    512,
    [],
    "f2d2",
    "M464 0H144c-26.5 0-48 21.5-48 48v48H48c-26.5 0-48 21.5-48 48v320c0 26.5 21.5 48 48 48h320c26.5 0 48-21.5 48-48v-48h48c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zm-96 464H48V256h320v208zm96-96h-48V144c0-26.5-21.5-48-48-48H144V48h320v320z"
  ]
};
export const faWindsock = {
  prefix: "far",
  iconName: "windsock",
  icon: [
    512,
    512,
    [],
    "f777",
    "M484.2 148.3l-389.9-52C105.1 86.2 112 72 112 56c0-30.9-25.1-56-56-56S0 25.1 0 56c0 22.3 13.1 41.4 32 50.4V496c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V369.6l404.2-53.9C500.1 313.6 512 300 512 284V180c0-16-11.9-29.6-27.8-31.7zM320 174.8v114.3L224 302V162l96 12.8zm-240-32l80 10.7v157l-80 10.7V142.8zM464 270l-80 10.7v-97.3l80 10.7V270z"
  ]
};
export const faWineBottle = {
  prefix: "far",
  iconName: "wine-bottle",
  icon: [
    512,
    512,
    [],
    "f72f",
    "M500.75 72.77l-61.54-61.56c-15.03-14.97-39.47-14.94-54.44.03l-43.16 43.15c-8.56 8.6-12.22 20.28-10.97 31.51l-25.16 25.16c-48.85-14.3-101.44-1.13-137.91 35.38L24.03 290.01C8.53 305.48 0 326.08 0 347.99c0 21.93 8.53 42.52 24.03 57.99l82.01 82.06c16 15.97 36.97 23.96 57.97 23.96s42-7.99 58-23.97l143.57-143.57c36.5-36.54 49.6-89.2 35.38-137.93l25.13-25.14c11.34 1.2 22.94-2.41 31.53-11.02l43.13-43.15c15-15.01 15-39.43 0-54.45zM309.76 332.4l-73.38 73.38-130.11-130.13 73.37-73.39L309.76 332.4zM139.98 454.08l-82.01-82.05c-6.44-6.42-9.97-14.96-9.97-24.05 0-9.08 3.53-17.61 9.97-24.04l25.67-25.68L213.76 428.4l-25.68 25.68c-13.19 13.26-34.79 13.29-48.1 0zM430.4 129.7l-10.25-10.25-75.29 75.28 6.31 14.89c14.55 34.38 7.11 73.52-18.84 100.09L202.34 179.7c44.99-43.96 98.43-19.55 100.08-18.85l14.88 6.3 75.22-75.26-10.22-10.27 29.69-29.72 48.1 48.1-29.69 29.7z"
  ]
};
export const faWineGlass = {
  prefix: "far",
  iconName: "wine-glass",
  icon: [
    288,
    512,
    [],
    "f4e3",
    "M216 464h-48V348.54c72.6-12.52 126.31-78.75 119.4-155.88L271.45 14.55C270.71 6.31 263.9 0 255.74 0H32.26c-8.15 0-14.97 6.31-15.7 14.55L.6 192.66C-6.31 269.79 47.4 336.03 120 348.54V464H72c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h208c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40zm-85.01-161.73c-51.16-7.1-87.28-52.88-82.58-105.33L61.75 48h164.5l13.34 148.94c4.7 52.45-31.42 98.23-82.58 105.33h-26.02z"
  ]
};
export const faWineGlassAlt = {
  prefix: "far",
  iconName: "wine-glass-alt",
  icon: [
    288,
    512,
    [],
    "f5ce",
    "M216 464h-48V348.54c72.6-12.52 126.31-78.75 119.4-155.88L271.45 14.55C270.71 6.31 263.9 0 255.74 0H32.26c-8.15 0-14.97 6.31-15.7 14.55L.6 192.66C-6.31 269.79 47.4 336.03 120 348.54V464H72c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h208c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40zm10.25-416l7.17 80H54.58l7.17-80h164.5zM48.41 196.94L50.28 176h187.43l1.88 20.94c4.7 52.45-31.42 98.23-82.58 105.33h-26.03c-51.15-7.1-87.27-52.89-82.57-105.33z"
  ]
};
export const faWonSign = {
  prefix: "far",
  iconName: "won-sign",
  icon: [
    576,
    512,
    [],
    "f159",
    "M564 168c6.6 0 12-5.4 12-12v-24c0-6.6-5.4-12-12-12h-46.1l17.3-72.8c1.8-7.5-3.9-14.8-11.7-14.8h-30.8c-5.6 0-10.5 3.9-11.7 9.3L463.2 120h-130l-18.9-78.4c-1.3-5.4-6.1-9.2-11.7-9.2H271c-5.5 0-10.4 3.8-11.7 9.2L240.5 120H112.6L95.5 41.8c-1.2-5.5-6.1-9.4-11.7-9.4H55c-7.7 0-13.4 7.2-11.7 14.7L60.1 120H12c-6.6 0-12 5.4-12 12v24c0 6.6 5.4 12 12 12h59.2l11.1 48H12c-6.6 0-12 5.4-12 12v24c0 6.6 5.4 12 12 12h81.4l47.7 206.7c1.3 5.4 6.1 9.3 11.7 9.3h42c5.5 0 10.4-3.8 11.7-9.2L256.3 264h61.1l49.9 206.8c1.3 5.4 6.1 9.2 11.7 9.2h44c5.6 0 10.4-3.8 11.7-9.2l49-206.8H564c6.6 0 12-5.4 12-12v-24c0-6.6-5.4-12-12-12h-68.9l11.4-48zM182.4 360.8c-5.7 24.7-8.6 47.5-8.6 47.5h-1.1s-2.3-23.5-7.5-47.5L144.1 264h61.7zM217.3 216h-83.8L123 168h105.8zm50.6 0l6.4-26.4c1.7-7 3.3-14.4 4.7-21.6h15.8c1.4 7.2 3 14.6 4.7 21.6l6.4 26.4zm140.6 144.8c-5.7 24.1-7.5 47.5-7.5 47.5h-1.1s-2.9-22.8-8.6-47.5L367.9 264h62.5zM441.4 216h-85l-11.6-48h107.5z"
  ]
};
export const faWreath = {
  prefix: "far",
  iconName: "wreath",
  icon: [
    448,
    512,
    [],
    "f7e2",
    "M298.9 384.8L224 416l-74.9-31.2c-10.4-3.5-21.1 4.3-21.1 15.2v96c0 10.9 10.7 18.6 21.1 15.2L224 480l74.9 31.2c10.4 3.5 21.1-4.3 21.1-15.2v-96c0-10.9-10.7-18.6-21.1-15.2zm10.9-193.9c-.7-6.4-1.7-16-7.8-24.7-6.3-9-15-13.1-20.7-15.8-4.1-1.9-2.9-.9-6.1-4.7-4.2-4.9-10.7-12.3-21.1-15.8-10.4-3.5-19.8-1.5-26-.1-4.5 1-3.1 1-7.9 0-6.2-1.3-15.6-3.4-25.9.1-10.5 3.5-16.9 10.9-21.2 15.8-3 3.5-1.8 2.6-6.2 4.7-5.8 2.7-14.4 6.7-20.7 15.7-6.2 8.8-7.2 18.4-7.8 24.8-.5 5.1 0 3.5-2.4 8-3.1 5.6-7.8 14.1-7.8 25.1 0 11 4.7 19.5 7.8 25.1 2.3 4.2 1.9 2.5 2.4 8 .7 6.4 1.7 16 7.8 24.7 6.3 9 15 13.1 20.7 15.8 4.1 1.9 2.9.9 6.1 4.7 4.2 4.9 10.7 12.3 21.1 15.8 10.4 3.5 19.8 1.5 26 .1 4.5-1 3.1-1 7.9 0 4.1.9 14.8 3.6 25.9-.1 10.5-3.5 16.9-10.9 21.2-15.8 3-3.5 1.8-2.6 6.2-4.7 5.8-2.7 14.4-6.7 20.7-15.7 6.2-8.8 7.2-18.4 7.8-24.8.5-5.1 0-3.5 2.4-8 3.1-5.6 7.8-14.1 7.8-25.1 0-11-4.7-19.5-7.8-25.1-2.4-4.3-1.9-2.8-2.4-8zm-48 62.7c-9 4.1-17.3 9.1-23.5 17.7-15.5-2.6-13.2-2.6-28.7 0-8.7-11.9-22.2-17-23.5-17.7-1.5-12.6-1.7-15.9-9.4-29.6 8.2-14.5 8-18 9.4-29.6 4.1-1.8 15.6-6.8 23.5-17.7 10.5 1.7 18.2 1.7 28.7 0 3 4.2 7.3 9.6 23.5 17.7 1.3 11 1.1 14.9 9.4 29.6-8.1 14.4-8 18-9.4 29.6zm175-71.9c1.8-14.5-.1-29.4-5.9-43.4-5.9-14.2-15.2-26.2-27-35.2-3.8-14-11.1-27-21.6-37.5A81.794 81.794 0 0 0 344.9 44c-9-11.7-21-21.1-35.2-26.9-10.5-4.3-21.5-6.5-32.7-6.5-3.6 0-7.1.2-10.6.7C253.7 4 239.1 0 224 0s-29.7 4-42.4 11.2c-3.5-.4-7.1-.7-10.7-.7-11.3 0-22.3 2.2-32.7 6.5-14.2 5.9-26.2 15.2-35.1 26.9C89 47.7 76.1 55 65.6 65.5 55.1 76.1 47.8 89 44 103.1c-11.7 9-21.1 21-27 35.2-5.8 14-7.7 28.9-5.9 43.4C3.9 194.4 0 208.9 0 224c0 15.1 3.9 29.6 11.2 42.3-1.8 14.5.1 29.4 5.9 43.4 5.8 14.1 15.2 26 26.9 34.9 3.7 14.1 11.1 27.2 21.7 37.7 8.7 8.7 19.2 14.7 30.4 18.9V400c0-13 5.1-25.2 14.4-34.3 3-2.9 6.5-5.3 10-7.3-24.7-3.8-34.7-25-30.4-44.6-12.4-2.1-23.5-9.9-28.7-22.4-5.1-12.2-3.2-25.6 3.8-35.8C54.9 248.9 48 237.3 48 224s6.9-24.9 17.2-31.6c-7-10.2-8.9-23.5-3.8-35.8 5.2-12.5 16.2-20.6 28.6-22.7-2.6-12.1.2-25.1 9.5-34.4C113.1 86 130.2 89.2 134 90c2.1-12.4 10.2-23.5 22.7-28.6 12.9-5.3 26.2-2.7 35.8 3.8C199.1 54.9 210.7 48 224 48s24.9 6.9 31.6 17.2c9.6-6.6 22.9-9.1 35.8-3.8 12.5 5.2 20.6 16.2 22.7 28.6 3.7-.8 20.9-4 34.4 9.5 9.4 9.4 12.1 22.3 9.5 34.4 12.4 2.1 23.5 10.2 28.6 22.7 5.1 12.3 3.2 25.6-3.8 35.8 10.3 6.7 17.2 18.3 17.2 31.6s-6.9 24.9-17.2 31.6c7 10.2 8.9 23.5 3.8 35.8-5.2 12.5-16.3 20.3-28.7 22.4 4.4 19.7-5.9 40.9-30.5 44.6C342 366.6 352 382.1 352 400v1.3c11.2-4.2 21.7-10.2 30.4-18.9 10.6-10.6 17.9-23.6 21.7-37.7 11.7-8.9 21.1-20.9 26.9-34.9 5.8-14 7.7-28.9 5.9-43.4 7.2-12.7 11.2-27.2 11.2-42.3-.1-15.2-4-29.7-11.3-42.4z"
  ]
};
export const faWrench = {
  prefix: "far",
  iconName: "wrench",
  icon: [
    512,
    512,
    [],
    "f0ad",
    "M507.48 117.18c-3-12.17-12.41-21.79-24.5-25.15-12.1-3.34-25.16.11-33.97 8.97l-58.66 58.63-32.44-5.4-5.38-32.41 58.67-58.64c8.84-8.89 12.28-21.92 8.91-33.99-3.38-12.11-13.06-21.5-25.29-24.53-53.09-13.19-107.91 2.07-146.54 40.69-37.63 37.62-52.6 91.37-40.72 143.27L24.04 372.06C8.53 387.53 0 408.12 0 430.02s8.53 42.49 24.04 57.97C39.51 503.47 60.1 512 82.01 512c21.88 0 42.47-8.53 57.98-24.01l183.34-183.26c51.79 11.87 105.64-3.14 143.49-40.93 38.09-38.1 53.69-94.27 40.66-146.62zm-74.61 112.69c-28.47 28.46-70.2 38.1-109.01 25.21l-14.06-4.69-203.75 203.67c-12.85 12.84-35.29 12.81-48.07 0-6.44-6.42-9.97-14.96-9.97-24.04 0-9.08 3.53-17.61 9.97-24.03l203.84-203.78-4.63-14.03c-12.81-38.9-3.22-80.62 25.04-108.9 20.35-20.32 47.19-31.24 75.04-31.24h1.12l-57.32 57.3 15.13 90.59 90.57 15.09 57.35-57.29c.32 28.26-10.62 55.52-31.25 76.14zM88.01 408.02c-8.84 0-16 7.16-16 16s7.16 16 16 16 16-7.16 16-16-7.16-16-16-16z"
  ]
};
export const faXRay = {
  prefix: "far",
  iconName: "x-ray",
  icon: [
    640,
    512,
    [],
    "f497",
    "M168 224h128v32h-96c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h96v32h-56c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48h64c0 26.5 21.5 48 48 48s48-21.5 48-48-21.5-48-48-48h-56v-32h96c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8h-96v-32h128c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H344v-32h96c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8h-96V88c0-4.4-3.6-8-8-8h-32c-4.4 0-8 3.6-8 8v40h-96c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h96v32H168c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm56 144c0-21.2 32-21.2 32 0s-32 21.1-32 0zm192 0c0 21.2-32 21.1-32 0 0-21.2 32-21.2 32 0zM632 48c4.4 0 8-3.6 8-8V8c0-4.4-3.6-8-8-8H8C3.6 0 0 3.6 0 8v32c0 4.4 3.6 8 8 8h56v416H8c-4.4 0-8 3.6-8 8v32c0 4.4 3.6 8 8 8h624c4.4 0 8-3.6 8-8v-32c0-4.4-3.6-8-8-8h-56V48h56zM528 464H112V48h416v416z"
  ]
};
export const faYenSign = {
  prefix: "far",
  iconName: "yen-sign",
  icon: [
    384,
    512,
    [],
    "f157",
    "M347.983 32h-44.065a12.001 12.001 0 0 0-10.555 6.291l-73.76 133.313c-13.96 29.825-27.286 64.725-27.286 64.725h-1.269s-13.326-34.901-27.287-64.725L90.689 38.328A12 12 0 0 0 80.115 32H36.017c-9.157 0-14.94 9.844-10.481 17.843L119.746 216H68c-6.627 0-12 5.373-12 12v24c0 6.627 5.373 12 12 12h77.18l14.775 26.267V312H68c-6.627 0-12 5.373-12 12v24c0 6.627 5.373 12 12 12h91.955v108c0 6.627 5.373 12 12 12h39.456c6.627 0 12-5.373 12-12V360H316c6.627 0 12-5.373 12-12v-24c0-6.627-5.373-12-12-12h-92.589v-21.733L238.185 264H316c6.627 0 12-5.373 12-12v-24c0-6.627-5.373-12-12-12h-52.367L358.45 49.87c4.485-7.999-1.296-17.87-10.467-17.87z"
  ]
};
export const faYinYang = {
  prefix: "far",
  iconName: "yin-yang",
  icon: [
    496,
    512,
    [],
    "f6ad",
    "M263.9 332c-19.88 0-35.99 16.12-35.99 36s16.11 36 35.99 36 35.99-16.12 35.99-36-16.11-36-35.99-36zm-31.99-152c19.88 0 35.99-16.12 35.99-36s-16.11-36-35.99-36-35.99 16.12-35.99 36c.01 19.88 16.12 36 35.99 36zm16-172C110.99 8 0 119.03 0 256s110.99 248 247.91 248v-.02c.06 0 .12.02.19.02C384.79 504 496 392.75 496 256S384.6 8 247.91 8zM119.05 408.67C75.65 371.95 47.98 317.18 47.98 256c0-110.28 89.68-200 199.92-200 48.51 0 88.15 39.47 88.15 88s-39.45 88-87.97 88c-74.97 0-135.95 61.02-135.95 136 .02 14.26 2.83 27.75 6.92 40.67zM248.09 456c-48.51 0-87.97-39.47-87.97-88s39.45-88 87.97-88c74.97 0 135.95-61.02 135.95-136 0-13.84-2.09-27.22-5.94-39.83 42.77 36.72 69.91 91.16 69.91 151.83.01 110.28-89.68 200-199.92 200z"
  ]
};
